import type { Icon } from 'ngxi'

export const streamlineAdd1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13M.5 6.96h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAdd1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625 1a.625.625 0 1 0-1.25 0v5.335H1a.625.625 0 1 0 0 1.25h5.375V13a.625.625 0 1 0 1.25 0V7.585H13a.625.625 0 1 0 0-1.25H7.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAdd1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 1a1 1 0 0 0-2 0v5H1a1 1 0 0 0 0 2h5v5a1 1 0 1 0 2 0V8h5a1 1 0 1 0 0-2H8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddBellNotification: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 13.5h2M5.09 2.1A4 4 0 0 0 2 6v3.5A1.5 1.5 0 0 1 .5 11h11A1.5 1.5 0 0 1 10 9.5V9m.5-8.5v6m-3-3h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddBellNotificationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.25.75a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2zM5.125 12.5a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zm1-11.125A4.625 4.625 0 0 0 1.5 6v3.25a.875.875 0 0 1-.875.875a.625.625 0 1 0 0 1.25h11a.625.625 0 1 0 0-1.25a.875.875 0 0 1-.875-.875V8.5a.625.625 0 1 0-1.25 0v.75c0 .305.065.603.189.875H2.56c.124-.272.189-.57.189-.875V6a3.375 3.375 0 0 1 3.375-3.375a.625.625 0 1 0 0-1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddBellNotificationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.5.75a.75.75 0 0 0-1.5 0V2.5H8.25a.75.75 0 0 0 0 1.5H10v1.75a.75.75 0 0 0 1.5 0V4h1.75a.75.75 0 0 0 0-1.5H11.5zM6 1.5q.555 0 1.086.123A2 2 0 0 0 8.25 5.25h.5v.5a2 2 0 0 0 1.822 1.992v1.833c0 .234.1.466.289.642c.219.204.391.283.639.283a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1c.248 0 .42-.079.64-.283a.88.88 0 0 0 .288-.642V5.8c0-1.152.49-2.25 1.351-3.053A4.72 4.72 0 0 1 6 1.5M4.25 13.25A.75.75 0 0 1 5 12.5h2A.75.75 0 0 1 7 14H5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddCircle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13M7 4v6M4 7h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 3.25a.75.75 0 0 1 .75.75v2.25H10a.75.75 0 0 1 0 1.5H7.75V10a.75.75 0 0 1-1.5 0V7.75H4a.75.75 0 0 1 0-1.5h2.25V4A.75.75 0 0 1 7 3.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M7 3.25a.75.75 0 0 1 .75.75v2.25H10a.75.75 0 0 1 0 1.5H7.75V10a.75.75 0 0 1-1.5 0V7.75H4a.75.75 0 0 1 0-1.5h2.25V4A.75.75 0 0 1 7 3.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddLayer2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 3.5h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1\"/><path d=\"M3.5.5h9a1 1 0 0 1 1 1v9M5.5 6v5M8 8.5H3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddLayer2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 12c0 .898.728 1.625 1.625 1.625h7.5c.898 0 1.625-.727 1.625-1.625v-.875H12c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625H4.5c-.897 0-1.625.728-1.625 1.625v.875H2c-.897 0-1.625.728-1.625 1.625zM2 12.375A.375.375 0 0 1 1.625 12V4.5c0-.207.168-.375.375-.375h7.5c.207 0 .375.168.375.375V12a.375.375 0 0 1-.375.375zm.75-4.125a.75.75 0 0 1 .75-.75H5V6a.75.75 0 0 1 1.5 0v1.5H8A.75.75 0 0 1 8 9H6.5v1.5a.75.75 0 0 1-1.5 0V9H3.5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddLayer2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.25 0a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 0 1.5 0v-7.5A2.25 2.25 0 0 0 11.75 0zM9.5 3A1.5 1.5 0 0 1 11 4.5v8A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-8A1.5 1.5 0 0 1 1.5 3zM2.25 8.5A.75.75 0 0 1 3 7.75h1.75V6a.75.75 0 0 1 1.5 0v1.75H8a.75.75 0 0 1 0 1.5H6.25V11a.75.75 0 0 1-1.5 0V9.25H3a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddSquare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 4v6M4 7h6m.5-6.5h-7a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 1.625H2A.375.375 0 0 0 1.625 2v10c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375V2A.375.375 0 0 0 12 1.625M2 .375h10c.898 0 1.625.728 1.625 1.625v10c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12V2C.375 1.103 1.103.375 2 .375M7 3.25a.75.75 0 0 1 .75.75v2.25H10a.75.75 0 0 1 0 1.5H7.75V10a.75.75 0 0 1-1.5 0V7.75H4a.75.75 0 0 1 0-1.5h2.25V4A.75.75 0 0 1 7 3.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAddSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3.5A3.5 3.5 0 0 1 3.5 0h7A3.5 3.5 0 0 1 14 3.5v7a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 0 10.5zm7-.25a.75.75 0 0 1 .75.75v2.25H10a.75.75 0 0 1 0 1.5H7.75V10a.75.75 0 0 1-1.5 0V7.75H4a.75.75 0 0 1 0-1.5h2.25V4A.75.75 0 0 1 7 3.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAdobe: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.233.816L.816 13.183H7.75l-.884-2.65H5.157L7 4.965l2.975 8.218h3.208L8.766.816z\"/><path d=\"M.816.816h12.367v12.367H.816z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAdobeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .375A.625.625 0 0 0 .375 1v12c0 .345.28.625.625.625h12c.345 0 .625-.28.625-.625V1A.625.625 0 0 0 13 .375zm.625 10.875V1.624h3.437zm5.894 1.125h2.142L7 5.025l-1.788 5.403H6.87zm4.856-1.124V1.625H8.937z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAdobeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.316.816a.5.5 0 0 1 .5-.5h12.368a.5.5 0 0 1 .5.5v12.368a.5.5 0 0 1-.5.5H.816a.5.5 0 0 1-.5-.5zM1.37 12.63L5.391 1.37h3.217l4.022 11.26H9.71L7 5.147l-1.678 5.07h1.556l.805 2.413z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAffordableAndCleanEnergy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.862.858v.644m0 3.194v1.535m0 5.991v.644M.859 6.862h.643m10.721 0h.643M11.15 2.574l-.428.428m-7.72 7.719l-.428.428m0-8.575l.428.428m7.72 7.719l.428.428M3 6.862a3.861 3.861 0 1 0 7.722 0a3.861 3.861 0 1 0-7.722 0\"/><path d=\"M5.45 5.779a1.764 1.764 0 1 0 2.823 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAffordableAndCleanEnergyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.75a.625.625 0 0 1-.625-.625v-.5a.625.625 0 1 1 1.25 0v.5c0 .345-.28.625-.625.625m3.712 1.538a.625.625 0 0 1 0-.884l.354-.354a.625.625 0 0 1 .884.884l-.354.354a.625.625 0 0 1-.884 0M2.934 2.05a.625.625 0 1 0-.884.884l.354.354a.625.625 0 1 0 .884-.884zM7 3.625a3.375 3.375 0 1 0 0 6.75a3.375 3.375 0 0 0 0-6.75M2.375 7a4.625 4.625 0 1 1 9.25 0a4.625 4.625 0 0 1-9.25 0M5.48 5.748a.625.625 0 0 1 .36.808a1.242 1.242 0 1 0 2.32 0a.625.625 0 0 1 1.167-.448a2.492 2.492 0 1 1-4.654 0a.625.625 0 0 1 .807-.36m2.145-.881a.625.625 0 1 0-1.25 0v1.066a.625.625 0 0 0 1.25 0zM12.25 7c0-.345.28-.625.625-.625h.5a.625.625 0 1 1 0 1.25h-.5A.625.625 0 0 1 12.25 7M.625 6.375a.625.625 0 1 0 0 1.25h.5a.625.625 0 1 0 0-1.25zm10.087 4.337a.625.625 0 0 1 .884 0l.354.354a.625.625 0 1 1-.884.884l-.354-.354a.625.625 0 0 1 0-.884m-8.662.354a.625.625 0 0 0 .884.884l.354-.354a.625.625 0 0 0-.884-.884zm4.325 2.309a.625.625 0 1 0 1.25 0v-.5a.625.625 0 1 0-1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAffordableAndCleanEnergySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.862.014a.75.75 0 0 1 .75.75v.653a.75.75 0 1 1-1.5 0V.764a.75.75 0 0 1 .75-.75m4.288 6.848a4.289 4.289 0 1 1-8.578 0a4.289 4.289 0 0 1 8.578 0m-3.538 5.444a.75.75 0 0 0-1.5 0v.653a.75.75 0 0 0 1.5 0zM.015 6.862a.75.75 0 0 1 .75-.75h.652a.75.75 0 1 1 0 1.5H.765a.75.75 0 0 1-.75-.75m12.292-.75a.75.75 0 0 0 0 1.5h.652a.75.75 0 0 0 0-1.5zm-.56-4.136a.75.75 0 0 1 0 1.06l-.434.435a.75.75 0 1 1-1.061-1.06l.434-.435a.75.75 0 0 1 1.06 0M3.47 11.312a.75.75 0 1 0-1.06-1.06l-.434.433a.75.75 0 0 0 1.06 1.061zM1.977 1.976a.75.75 0 0 1 1.06 0l.434.434a.75.75 0 0 1-1.06 1.06l-.434-.433a.75.75 0 0 1 0-1.06m9.336 8.276a.75.75 0 1 0-1.061 1.06l.434.434a.75.75 0 0 0 1.06-1.06zm-4.45-6.706c.345 0 .625.28.625.625v1.766a.625.625 0 1 1-1.25 0V4.171c0-.345.28-.625.625-.625m-1.494 2.19a.625.625 0 1 0-1-.751a3.115 3.115 0 1 0 4.984 0a.625.625 0 0 0-1 .75a1.865 1.865 0 1 1-2.985 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiChipSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 8.833H.679m12.642 0H11.5m-9-3.666H.679m12.642 0H11.5M5.167 2.5V.679m0 12.642V11.5m3.666-9V.679m0 12.642V11.5m1.667-9h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1\"/><path d=\"M4.667 7.25c-.281-.048-.281-.452 0-.501a2.55 2.55 0 0 0 2.05-1.964l.018-.078c.06-.278.457-.28.52-.002l.02.09a2.56 2.56 0 0 0 2.057 1.953c.283.049.283.455 0 .504a2.56 2.56 0 0 0-2.057 1.952l-.02.09c-.063.278-.46.276-.52-.002l-.017-.077A2.55 2.55 0 0 0 4.667 7.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiChipSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.014 2.875h-1.68a.46.46 0 0 0-.459.458v7.334c0 .253.205.458.458.458h7.334a.46.46 0 0 0 .458-.458V3.333a.46.46 0 0 0-.458-.458zm4.597-1.25v-1a.625.625 0 1 0-1.25 0v1H5.64v-1a.625.625 0 0 0-1.25 0v1H3.333c-.943 0-1.708.765-1.708 1.708V4.39h-1a.625.625 0 1 0 0 1.25h1v2.72h-1a.625.625 0 0 0 0 1.25h1v1.056c0 .943.765 1.708 1.708 1.708H4.39v1a.625.625 0 1 0 1.25 0v-1h2.72v1a.625.625 0 1 0 1.25 0v-1h1.056c.943 0 1.708-.765 1.708-1.708V9.61h1a.625.625 0 1 0 0-1.25h-1V5.64h1a.625.625 0 1 0 0-1.25h-1V3.333c0-.943-.765-1.708-1.708-1.708zM7.738 4.598c-.18-.801-1.315-.795-1.487.006l-.017.077A2.02 2.02 0 0 1 4.62 6.257c-.827.146-.827 1.34 0 1.486a2.02 2.02 0 0 1 1.614 1.576l.017.077c.172.801 1.308.807 1.487.006l.02-.09a2.03 2.03 0 0 1 1.62-1.568c.83-.146.83-1.342 0-1.488a2.03 2.03 0 0 1-1.62-1.568z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiChipSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.714.04a.75.75 0 0 1 .75.75v1.188h1.035a1.5 1.5 0 0 1 1.5 1.5v1.036h1.219a.75.75 0 0 1 0 1.5h-1.22v1.93h1.22a.75.75 0 0 1 0 1.5h-1.22v1.033a1.5 1.5 0 0 1-1.5 1.5H9.465v1.233a.75.75 0 0 1-1.5 0v-1.233h-1.93v1.233a.75.75 0 0 1-1.5 0v-1.233H3.5a1.5 1.5 0 0 1-1.5-1.5V9.443H.782a.75.75 0 0 1 0-1.5H2v-1.93H.782a.75.75 0 1 1 0-1.5H2V3.479a1.5 1.5 0 0 1 1.5-1.5h1.035V.79a.75.75 0 0 1 1.5 0v1.188h1.93V.79a.75.75 0 0 1 .75-.75M6.243 4.568c.176-.804 1.32-.809 1.503-.006l.008.035l.016.07a2.1 2.1 0 0 0 1.68 1.585c.84.146.84 1.35 0 1.496a2.1 2.1 0 0 0-1.683 1.599l-.021.091c-.183.803-1.327.798-1.503-.006l-.018-.079a2.08 2.08 0 0 0-1.677-1.606c-.838-.146-.838-1.348 0-1.494a2.08 2.08 0 0 0 1.675-1.598l.013-.057z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiCloudSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 9.534a3 3 0 0 1-1.395-.692a3.193 3.193 0 0 1 1.887-5.59a.23.23 0 0 0 .21-.127a3.868 3.868 0 0 1 7.508.91a.25.25 0 0 0 .173.2a2.73 2.73 0 0 1-.173 5.35\"/><path d=\"M4.528 11.096c-.298-.052-.298-.48 0-.532A2.7 2.7 0 0 0 6.7 8.483l.02-.083c.065-.295.484-.297.551-.003l.022.096a2.71 2.71 0 0 0 2.18 2.069c.299.052.299.482 0 .534a2.71 2.71 0 0 0-2.18 2.069l-.022.096c-.067.294-.486.292-.55-.003l-.019-.082a2.7 2.7 0 0 0-2.173-2.081\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiCloudSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.734 1.273a3.18 3.18 0 0 0-2.067.46a3.17 3.17 0 0 0-1.318 1.652a.85.85 0 0 1-.772.546a2.52 2.52 0 0 0-1.707.85a2.502 2.502 0 0 0 .655 3.827a.625.625 0 1 1-.602 1.096a3.753 3.753 0 0 1 1.348-6.998a4.433 4.433 0 0 1 7.256-1.366a4.4 4.4 0 0 1 1.198 2.399a3.298 3.298 0 0 1 .7 5.95a.625.625 0 1 1-.654-1.066a2.06 2.06 0 0 0 .966-1.516a2.05 2.05 0 0 0-1.573-2.229l-.035-.01a.87.87 0 0 1-.408-.263l.472-.409l-.472.41a.87.87 0 0 1-.206-.476a3.17 3.17 0 0 0-.884-1.918a3.18 3.18 0 0 0-1.897-.939M7.8 7.4c-.195-.87-1.428-.864-1.616.007l-.02.097A2.65 2.65 0 0 1 4.047 9.57c-.896.159-.896 1.453 0 1.612a2.65 2.65 0 0 1 2.118 2.066l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.898-.159.898-1.455 0-1.614a2.67 2.67 0 0 1-2.126-2.056z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiCloudSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.883.165a4.37 4.37 0 0 0-4.582 2.717a3.693 3.693 0 0 0-1.194 7c.131-.787.692-1.501 1.683-1.674a1.43 1.43 0 0 0 1.147-1.092l.023-.105c.475-2.173 3.57-2.186 4.064-.017l.01.044l.018.077c.132.563.587.993 1.157 1.092c1.051.183 1.62.976 1.704 1.817a3.23 3.23 0 0 0-.227-6.11A4.37 4.37 0 0 0 7.883.165M6.181 7.28c.19-.869 1.427-.874 1.624-.007l.01.043l.02.086a2.69 2.69 0 0 0 2.16 2.037c.905.158.905 1.457 0 1.614a2.69 2.69 0 0 0-2.164 2.055l-.026.112c-.197.867-1.434.862-1.624-.007l-.021-.097a2.68 2.68 0 0 0-2.156-2.064c-.903-.157-.903-1.454 0-1.611a2.68 2.68 0 0 0 2.153-2.054l.016-.071z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiEditSpark: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m6.926 13.202l-3 .26l.26-3l6.24-6.2a1 1 0 0 1 1.43 0l1.27 1.28a1 1 0 0 1 0 1.42zM.842 3.972c-.351-.061-.351-.565 0-.626A3.18 3.18 0 0 0 3.4.896l.021-.097c.076-.346.57-.349.65-.002l.025.112A3.19 3.19 0 0 0 6.66 3.345c.353.06.353.567 0 .629a3.19 3.19 0 0 0-2.565 2.435l-.026.113c-.079.346-.573.344-.649-.003l-.02-.097a3.18 3.18 0 0 0-2.56-2.45\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiEditSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.81.656C2.998-.214 4.23-.22 4.426.65l.025.113a2.67 2.67 0 0 0 2.126 2.056c.897.159.897 1.455 0 1.614A2.67 2.67 0 0 0 4.45 6.488l-.025.113c-.195.87-1.428.863-1.616-.007l-.02-.097A2.65 2.65 0 0 0 .672 4.43c-.896-.159-.896-1.453 0-1.612A2.65 2.65 0 0 0 2.79.753l.488.105L2.79.753zm8.209 4.12a.35.35 0 0 1 .384.078l.003.003l1.237 1.246l.003.004a.35.35 0 0 1 0 .495l-.003.003l-5.875 5.913l-1.952.17l.17-1.953l5.912-5.875l.006-.006a.4.4 0 0 1 .114-.078m.135-1.277a1.6 1.6 0 0 0-1.14.477L3.942 10.01a.63.63 0 0 0-.182.39l-.253 2.92a.625.625 0 0 0 .676.677l2.921-.253a.63.63 0 0 0 .39-.182l6.034-6.074a1.6 1.6 0 0 0 0-2.266l-1.233-1.244a1.6 1.6 0 0 0-1.141-.479\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiEditSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.856.654c.19-.868 1.427-.874 1.625-.007l.01.044l.02.086a2.69 2.69 0 0 0 2.16 2.037c.905.157.905 1.457 0 1.614a2.69 2.69 0 0 0-2.164 2.054l-.026.113c-.198.867-1.434.861-1.625-.007l-.02-.097A2.68 2.68 0 0 0 .68 4.427c-.904-.158-.904-1.454 0-1.612A2.68 2.68 0 0 0 2.833.762l.016-.071zm7.78 2.962a1.5 1.5 0 0 1 1.652.333l.002.001l1.266 1.277a1.5 1.5 0 0 1 0 2.126l-.002.002l-6.197 6.237a.5.5 0 0 1-.312.146l-3 .26a.5.5 0 0 1-.541-.541l.26-3a.5.5 0 0 1 .146-.312l6.237-6.197a1.5 1.5 0 0 1 .488-.332\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiEmailGeneratorSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.076 9.546h-3.5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4.5\"/><path d=\"m.576 1.806l6 4.24l6-4.24m-5.236 8.84c-.351-.06-.351-.565 0-.626a3.18 3.18 0 0 0 2.558-2.45l.021-.096c.076-.347.57-.35.649-.003l.026.112a3.19 3.19 0 0 0 2.565 2.436c.353.061.353.568 0 .629a3.19 3.19 0 0 0-2.565 2.435l-.026.113c-.079.346-.573.344-.649-.003l-.021-.096a3.18 3.18 0 0 0-2.558-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiEmailGeneratorSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.537 1.26a.4.4 0 0 1 .088-.01h9.75q.045 0 .088.01L6.5 4.738zM.033 1.3A1.6 1.6 0 0 0 0 1.626v6.75A1.625 1.625 0 0 0 1.625 10H5a.625.625 0 1 0 0-1.25H1.625a.375.375 0 0 1-.375-.375V2.586l4.891 3.426a.63.63 0 0 0 .718 0l4.891-3.426v4.039a.625.625 0 1 0 1.25 0v-5A1.627 1.627 0 0 0 11.375 0h-9.75A1.625 1.625 0 0 0 .033 1.3m11.143 6.1c-.195-.87-1.428-.865-1.616.006l-.02.097A2.65 2.65 0 0 1 7.422 9.57c-.896.159-.896 1.453 0 1.612a2.65 2.65 0 0 1 2.118 2.066l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2 7.512z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiEmailGeneratorSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.62.051h9.312c.857 0 1.552.695 1.552 1.552v.077L6.276 4.784L.07 1.68v-.077A1.55 1.55 0 0 1 1.62.051M.07 3.078V7.81c0 .857.694 1.552 1.551 1.552h4.927c.257-.292.622-.51 1.094-.592c.516-.09.926-.481 1.04-.991l.022-.095c.431-1.97 3.237-1.983 3.686-.016l.009.04l.016.07q.024.1.061.193q.009-.08.009-.161V3.078L6.556 6.042a.63.63 0 0 1-.56 0zm9.696 4.84c.183-.837 1.373-.842 1.564-.007l.009.04l.018.077a2.39 2.39 0 0 0 1.921 1.812c.873.152.873 1.404 0 1.556a2.395 2.395 0 0 0-1.925 1.827l-.023.103c-.19.834-1.381.83-1.564-.007l-.02-.088a2.38 2.38 0 0 0-1.917-1.836c-.871-.152-.871-1.402 0-1.553a2.38 2.38 0 0 0 1.915-1.827l.014-.064z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGamingSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.312 7.003v2.311m1.155-1.155h-2.31m1.909-3.632H4.15a3 3 0 0 0-2.981 2.669l-.412 3.71a2.283 2.283 0 0 0 4.31 1.273l.36-.72h2.971l.36.72a2.283 2.283 0 0 0 4.31-1.274l-.412-3.71\"/><path d=\"M8.644 8.736a.248.248 0 1 1 .496 0m-.495 0a.248.248 0 1 0 .495 0M7.175 3.994c-.351-.062-.351-.565 0-.626A3.18 3.18 0 0 0 9.733.918L9.754.82c.076-.347.57-.35.649-.003l.026.113a3.19 3.19 0 0 0 2.565 2.435c.353.061.353.568 0 .63A3.19 3.19 0 0 0 10.43 6.43l-.026.112c-.079.346-.573.344-.649-.003l-.02-.096a3.18 3.18 0 0 0-2.56-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGamingSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.56.656c.188-.87 1.42-.877 1.616-.007l.025.113a2.67 2.67 0 0 0 2.126 2.056c.897.159.897 1.455 0 1.614A2.67 2.67 0 0 0 11.2 6.488l-.025.113c-.195.87-1.428.863-1.615-.007l-.021-.097A2.65 2.65 0 0 0 7.422 4.43c-.896-.159-.896-1.453 0-1.612A2.65 2.65 0 0 0 9.54.753l.489.105l-.49-.105zM4.07 6.438c.345 0 .625.28.625.625v.53h.53a.625.625 0 1 1 0 1.25h-.53v.53a.625.625 0 0 1-1.25 0v-.53h-.53a.625.625 0 1 1 0-1.25h.53v-.53c0-.346.28-.625.625-.625m-2.406.888a2.314 2.314 0 0 1 2.3-2.059H5.23a.625.625 0 1 0 0-1.25H3.964a3.564 3.564 0 0 0-3.542 3.17l-.404 3.635a2.862 2.862 0 0 0 5.404 1.596l.179-.359h2.138l.18.36a2.862 2.862 0 0 0 5.403-1.597l-.358-3.22a.625.625 0 1 0-1.242.138l.358 3.22a1.612 1.612 0 0 1-3.043.9l-.352-.705a.63.63 0 0 0-.56-.346h-2.91a.63.63 0 0 0-.56.346l-.352.704a1.612 1.612 0 0 1-3.043-.899z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGamingSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.29.77c.183-.837 1.375-.842 1.566-.006l.009.04l.018.077c.22.938.979 1.655 1.93 1.82c.873.152.873 1.406 0 1.558a2.41 2.41 0 0 0-1.934 1.835l-.023.102c-.19.836-1.383.831-1.567-.006l-.019-.088a2.39 2.39 0 0 0-1.926-1.845c-.871-.151-.871-1.403 0-1.554A2.39 2.39 0 0 0 9.268.868l.014-.064zM7.156 5.334a2 2 0 0 1-.697-.257H3.942A3 3 0 0 0 .96 7.745l-.4 3.608a2.247 2.247 0 0 0 4.24 1.253l.354-.707H8.08l.353.707a2.246 2.246 0 0 0 4.242-1.253l-.4-3.608a3 3 0 0 0-.387-1.175c-.542 1.842-3.242 1.786-3.665-.147l-.02-.088a1.3 1.3 0 0 0-1.045-1.001M4.684 7.513a.625.625 0 1 0-1.25 0v.512h-.512a.625.625 0 0 0 0 1.25h.512v.512a.625.625 0 0 0 1.25 0v-.512h.512a.625.625 0 1 0 0-1.25h-.512zm4.75 1.746a.61.61 0 1 1-1.218 0a.61.61 0 0 1 1.218 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateLandscapeImageSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.576 6.733a6.5 6.5 0 0 1 1.164-.104c1.58 0 3.027.563 4.154 1.5\"/><path d=\"M5.076 10.629h-3.5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3.5\"/><path d=\"M6.326 5.629a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5m1.014 4.934c-.351-.061-.351-.565 0-.626a3.18 3.18 0 0 0 2.558-2.45l.021-.097c.076-.347.57-.349.649-.003l.026.113a3.19 3.19 0 0 0 2.565 2.435c.353.062.353.568 0 .63A3.19 3.19 0 0 0 10.594 13l-.026.113c-.079.346-.573.344-.649-.003l-.021-.097a3.18 3.18 0 0 0-2.558-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateLandscapeImageSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.25a.375.375 0 0 0-.375.375v4.387Q1.455 6 1.664 6c2.106 0 3.994.93 5.277 2.4C5.74 8.76 5.29 9.99 5.59 11H1.5A1.5 1.5 0 0 1 0 9.5V1.625A1.625 1.625 0 0 1 1.625 0h7.75A1.625 1.625 0 0 1 11 1.625V5a.625.625 0 1 1-1.25 0V1.625a.375.375 0 0 0-.375-.375zm4.625 1a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3m4.926 5.15c-.195-.87-1.428-.865-1.616.006l-.02.097A2.65 2.65 0 0 1 7.422 9.57c-.896.159-.896 1.453 0 1.612a2.65 2.65 0 0 1 2.118 2.066l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2 7.512z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateLandscapeImageSparkSolid: Icon = {
  "body": "<g fill=\"none\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.391 10.677c-.35-.061-.35-.565 0-.626a3.18 3.18 0 0 0 2.556-2.437l.024-.11c.076-.347.57-.349.649-.003l.03.133a3.19 3.19 0 0 0 2.56 2.415c.353.062.353.568 0 .63a3.19 3.19 0 0 0-2.565 2.435l-.025.112c-.08.347-.573.344-.65-.002l-.02-.097a3.18 3.18 0 0 0-2.559-2.45\"/><path fill=\"currentColor\" d=\"M7.391 10.677c-.35-.061-.35-.565 0-.626a3.18 3.18 0 0 0 2.556-2.437l.024-.11c.076-.347.57-.349.649-.003l.03.133a3.19 3.19 0 0 0 2.56 2.415c.353.062.353.568 0 .63a3.19 3.19 0 0 0-2.565 2.435l-.025.112c-.08.347-.573.344-.65-.002l-.02-.097a3.18 3.18 0 0 0-2.559-2.45\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.025 8.798c0 .944.765 1.708 1.708 1.708h3.65a2.1 2.1 0 0 1 .479-1.5H1.775a.25.25 0 0 1-.25-.25V5.84l.203-.036a5.25 5.25 0 0 1 5.12 2.008l.368.487a1.42 1.42 0 0 0 1.022-1.065l.023-.104c.295-1.345 1.593-1.863 2.656-1.548V1.723c0-.943-.765-1.708-1.708-1.708H1.733C.79.015.025.78.025 1.723zm7.857-4.265a1.371 1.371 0 1 0 0-2.742a1.371 1.371 0 0 0 0 2.742\" clip-rule=\"evenodd\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateMusicSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.12 13.462a1.597 1.597 0 1 0 0-3.193a1.597 1.597 0 0 0 0 3.193m7.186-1.597a1.597 1.597 0 1 0 0-3.193a1.597 1.597 0 0 0 0 3.193\"/><path d=\"M3.717 11.865V5.383a.4.4 0 0 1 .295-.384l1.261-.361M3.717 7.474l4.06-1.128m3.125 3.923V8.86m-3.51-4.888c-.35-.061-.35-.565 0-.626A3.18 3.18 0 0 0 9.951.896l.021-.097c.076-.347.57-.349.649-.003l.026.113a3.19 3.19 0 0 0 2.565 2.435c.353.062.353.568 0 .63a3.19 3.19 0 0 0-2.565 2.435l-.026.112c-.08.347-.573.344-.649-.002l-.021-.097a3.18 3.18 0 0 0-2.559-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateMusicSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65c-.195-.87-1.428-.865-1.616.006l-.02.097l.489.105l-.49-.105A2.65 2.65 0 0 1 7.423 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2.762zm-5.73 4.813A.625.625 0 1 0 5.1 4.26l-1.23.353a1.016 1.016 0 0 0-.746.973v4.248a2.188 2.188 0 1 0 1.25 1.992V8.112l3.516-.976a.625.625 0 0 0-.335-1.204l-3.18.883V5.77zm3.773 3.85a.938.938 0 1 0 0 1.874a.938.938 0 0 0 0-1.875m-2.188.937a2.188 2.188 0 0 1 3.348-1.855a.625.625 0 0 1 1.028.478v1.393a2.188 2.188 0 0 1-4.376-.016m-4.843.625a.938.938 0 1 0 0 1.875a.938.938 0 0 0 0-1.875\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateMusicSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.812.633c.183-.836 1.374-.841 1.565-.006l.009.04l.018.077c.22.935.976 1.649 1.923 1.814c.872.152.872 1.404 0 1.556A2.4 2.4 0 0 0 11.4 5.943l-.023.102c-.19.835-1.382.83-1.565-.007l-.02-.088a2.38 2.38 0 0 0-1.918-1.838c-.871-.151-.871-1.401 0-1.553A2.38 2.38 0 0 0 9.79.731l.014-.065zM3.74 4.24l2.406-.668c.088.75.602 1.45 1.541 1.614c.518.09.93.484 1.043.998l.019.088l.013.057L4.395 7.54v4.268a2.188 2.188 0 1 1-1.5-2.078V5.34a1.15 1.15 0 0 1 .845-1.1m7.807 3.273a1.98 1.98 0 0 1-1.637.123a2.192 2.192 0 0 0-2.739 2.118a2.188 2.188 0 0 0 4.376.056z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGeneratePortraitImageSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.77 8.286A3.5 3.5 0 0 1 5.577 6.88c.818 0 1.57.28 2.166.75\"/><path d=\"M5.076 10.629h-3.5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3\"/><path d=\"M5.576 5.379a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m1.764 5.184c-.351-.061-.351-.565 0-.626a3.18 3.18 0 0 0 2.558-2.45l.021-.097c.076-.347.57-.349.649-.003l.026.113a3.19 3.19 0 0 0 2.565 2.435c.353.062.353.568 0 .63A3.19 3.19 0 0 0 10.594 13l-.026.113c-.079.346-.573.344-.649-.003l-.021-.097a3.18 3.18 0 0 0-2.558-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGeneratePortraitImageSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.25a.375.375 0 0 0-.375.375v7.75a.375.375 0 0 0 .375.375H5A.625.625 0 1 1 5 11H1.625A1.625 1.625 0 0 1 0 9.375v-7.75A1.625 1.625 0 0 1 1.625 0h7.75A1.625 1.625 0 0 1 11 1.625V4.5a.625.625 0 1 1-1.25 0V1.625a.375.375 0 0 0-.375-.375zM5.5 2.875a.875.875 0 1 0 0 1.75a.875.875 0 0 0 0-1.75m-2.125.875a2.125 2.125 0 1 1 4.25 0a2.125 2.125 0 0 1-4.25 0M9.56 7.406c.188-.87 1.42-.877 1.616-.007l.025.113a2.67 2.67 0 0 0 2.126 2.056c.897.159.897 1.456 0 1.614a2.67 2.67 0 0 0-2.126 2.056l-.025.113c-.195.87-1.428.863-1.616-.007l-.02-.097a2.65 2.65 0 0 0-2.118-2.066c-.896-.159-.896-1.453 0-1.612A2.65 2.65 0 0 0 9.54 7.503zm-2.27-.735c.365.183.7.42.992.704c-.161.51-.583.876-1.078.963a2.1 2.1 0 0 0-.805.312H2.7a.5.5 0 0 1-.4-.8a3.99 3.99 0 0 1 3.2-1.6a4 4 0 0 1 1.79.421M5.5 6.25v.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGeneratePortraitImageSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.532.004a1.5 1.5 0 0 0-1.5 1.5v8a1.5 1.5 0 0 0 1.5 1.5h3.93a2.16 2.16 0 0 1 .285-1.847H2.871a.296.296 0 0 1-.296-.296a2.956 2.956 0 0 1 5.577-1.37q.05-.117.08-.246l.022-.104c.306-1.397 1.694-1.901 2.778-1.507v-4.13a1.5 1.5 0 0 0-1.5-1.5zm4 5.019a1.774 1.774 0 1 0 0-3.548a1.774 1.774 0 0 0 0 3.548m3.943 2.385c.19-.868 1.427-.874 1.625-.007l.01.044l.02.086a2.69 2.69 0 0 0 2.16 2.037c.905.157.905 1.457 0 1.614a2.69 2.69 0 0 0-2.164 2.054l-.026.113c-.198.867-1.434.861-1.625-.007l-.02-.097a2.68 2.68 0 0 0-2.156-2.064c-.904-.158-.904-1.454 0-1.611a2.68 2.68 0 0 0 2.153-2.054l.016-.071z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateVariationSpark: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.28 8.231H1.132a.49.49 0 0 0-.488.488v4.15c0 .27.219.488.488.488h4.15c.27 0 .488-.219.488-.488v-4.15a.49.49 0 0 0-.488-.488m7.587 0h-4.15a.49.49 0 0 0-.488.488v4.15c0 .27.218.488.488.488h4.15c.27 0 .488-.219.488-.488v-4.15a.49.49 0 0 0-.488-.488M5.28.643H1.132a.49.49 0 0 0-.488.488v4.15c0 .27.219.488.488.488h4.15c.27 0 .488-.219.488-.488V1.13a.49.49 0 0 0-.488-.488m2.864 2.942c-.301-.052-.301-.483 0-.536A2.72 2.72 0 0 0 10.337.95l.018-.083c.065-.297.488-.3.556-.003l.022.097a2.735 2.735 0 0 0 2.197 2.086c.302.052.302.486 0 .539a2.735 2.735 0 0 0-2.197 2.086l-.022.096c-.068.297-.49.295-.556-.002l-.018-.083a2.72 2.72 0 0 0-2.191-2.099\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateVariationSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.188 1.045c-.182-.814-1.337-.808-1.513.007l-.017.081a2.15 2.15 0 0 1-1.715 1.674c-.84.149-.84 1.362 0 1.511a2.15 2.15 0 0 1 1.715 1.674l.017.081c.176.815 1.33.821 1.513.007l.022-.095a2.16 2.16 0 0 1 1.72-1.666c.843-.149.843-1.364 0-1.513a2.16 2.16 0 0 1-1.72-1.666zm-9.5.768v3.5h3.5v-3.5zm-1.25-.15a1.1 1.1 0 0 1 1.1-1.1h3.798a1.1 1.1 0 0 1 1.101 1.1v3.798a1.1 1.1 0 0 1-1.1 1.101H1.538a1.1 1.1 0 0 1-1.101-1.1zm1.25 7.15v3.5h3.5v-3.5zm-1.25-.15a1.1 1.1 0 0 1 1.1-1.1h3.798a1.1 1.1 0 0 1 1.101 1.1v3.798c0 .609-.493 1.102-1.1 1.102H1.538a1.1 1.1 0 0 1-1.1-1.103zm8.25 3.65v-3.5h3.5v3.5zm-.15-4.75a1.1 1.1 0 0 0-1.1 1.1v3.798a1.1 1.1 0 0 0 1.1 1.101h3.798a1.1 1.1 0 0 0 1.102-1.1V8.663c0-.608-.493-1.101-1.102-1.101z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiGenerateVariationSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.919.731c.178-.816 1.34-.821 1.527-.007l.008.038l.017.072a2.21 2.21 0 0 0 1.774 1.673c.852.149.852 1.372 0 1.52a2.21 2.21 0 0 0-1.778 1.687l-.021.096c-.186.815-1.349.81-1.527-.007L9.9 5.721a2.2 2.2 0 0 0-1.77-1.695c-.85-.148-.85-1.37 0-1.517A2.2 2.2 0 0 0 9.899.822l.013-.06zM1.105.171a.977.977 0 0 0-.978.977V5.3c0 .54.438.977.978.977h4.153c.54 0 .977-.437.977-.977V1.148A.977.977 0 0 0 5.258.17zm-.978 8.57c0-.54.438-.977.978-.977h4.153c.54 0 .977.437.977.977v4.153c0 .54-.437.978-.977.978H1.105a.977.977 0 0 1-.978-.978zm7.595 0c0-.54.437-.977.977-.977h4.153c.54 0 .978.437.978.977v4.153c0 .54-.438.978-.978.978H8.7a.977.977 0 0 1-.977-.978z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiNavigationSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.519 6.746a1.75 1.75 0 1 0 3.5 0a1.75 1.75 0 1 0-3.5 0\"/><path d=\"M9.629 8.74c-.948 2.542-3.366 4.756-4.36 4.756c-1.25 0-4.75-3.5-4.75-6.75a4.75 4.75 0 0 1 5.19-4.73M7.696 3.77c-.334-.059-.334-.538 0-.596a3.02 3.02 0 0 0 2.433-2.33l.02-.092c.072-.33.542-.331.617-.002l.024.107a3.04 3.04 0 0 0 2.44 2.316c.335.058.335.54 0 .598a3.04 3.04 0 0 0-2.44 2.316l-.024.107c-.075.329-.545.327-.617-.003l-.02-.092a3.02 3.02 0 0 0-2.433-2.33\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiNavigationSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65c-.195-.87-1.428-.865-1.616.006l-.02.097l.489.105l-.49-.105A2.65 2.65 0 0 1 7.423 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2.762zM0 7.482a4.77 4.77 0 0 1 5.228-4.75a.625.625 0 0 1-.118 1.244a3.52 3.52 0 0 0-3.86 3.506c0 1.214.667 2.551 1.526 3.618c.423.525.87.958 1.263 1.253c.197.148.37.254.51.32q.103.048.165.065c.037.01.056.011.058.012l.046-.009a1 1 0 0 0 .136-.049q.177-.075.43-.251A6.7 6.7 0 0 0 6.5 11.42c.78-.88 1.478-2.032 1.712-3.163a.625.625 0 0 1 1.224.253c-.292 1.415-1.132 2.759-2.001 3.74c-.439.493-.9.913-1.333 1.216c-.216.15-.434.28-.646.372c-.205.09-.441.163-.683.163c-.268 0-.532-.09-.76-.197a4.3 4.3 0 0 1-.724-.45a8.7 8.7 0 0 1-1.486-1.469C.861 10.715 0 9.105 0 7.483M4.75 5.75a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiNavigationSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.957.659c.18-.82 1.347-.825 1.534-.007l.008.038l.017.073a2.25 2.25 0 0 0 1.802 1.7c.856.148.856 1.377 0 1.526a2.25 2.25 0 0 0-1.805 1.713l-.022.097c-.187.818-1.354.813-1.534-.007l-.018-.083A2.23 2.23 0 0 0 8.14 3.987c-.854-.148-.854-1.375 0-1.523A2.23 2.23 0 0 0 9.937.75L9.95.69zM7.969 4.978c-1.65-.287-1.915-2.323-.793-3.17A5.25 5.25 0 0 0 .04 6.709c0 1.788.953 3.585 2.017 4.907a9.8 9.8 0 0 0 1.663 1.645c.271.203.54.373.793.493c.247.117.516.205.777.205c.262 0 .531-.088.778-.205c.253-.12.522-.29.792-.493a9.7 9.7 0 0 0 1.664-1.645c.927-1.152 1.769-2.663 1.97-4.215a1.74 1.74 0 0 1-1.519-1.394l-.018-.083a1.23 1.23 0 0 0-.988-.946M5.29 8.458a1.75 1.75 0 1 0 0-3.5a1.75 1.75 0 0 0 0 3.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiNetworkSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.512 7.463a6 6 0 1 1-6-6m-6 6h6.923\"/><path d=\"M6.512 1.463a10.36 10.36 0 0 0-2.308 6a10.36 10.36 0 0 0 2.308 6a10.36 10.36 0 0 0 2.142-4.615\"/><path d=\"M7.404 3.97c-.35-.06-.35-.564 0-.625A3.18 3.18 0 0 0 9.963.895l.02-.097c.077-.347.57-.35.65-.003l.025.113a3.19 3.19 0 0 0 2.566 2.435c.353.061.353.568 0 .63a3.19 3.19 0 0 0-2.566 2.435l-.025.112c-.08.346-.573.344-.65-.003l-.02-.096a3.18 3.18 0 0 0-2.559-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiNetworkSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65c-.195-.87-1.428-.865-1.616.006l-.02.097l.489.105l-.49-.105A2.65 2.65 0 0 1 7.423 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2.762zM6.985 2.02A.623.623 0 0 0 6.502 1H6.5A6.5 6.5 0 1 0 13 7.5a.625.625 0 1 0-1.25 0a5.25 5.25 0 0 1-3.923 5.081a10.8 10.8 0 0 0 1.385-3.61a.625.625 0 0 0-1.229-.231a9.5 9.5 0 0 1-1.477 3.584a8.6 8.6 0 0 1-1.499-4.199h2.886a.625.625 0 1 0 0-1.25H5.006c.128-1.707.787-3.39 1.979-4.856M3.753 6.874c.1-1.538.574-3.06 1.423-4.457a5.255 5.255 0 0 0-3.89 4.457zm-2.466 1.25a5.255 5.255 0 0 0 3.9 4.46a9.8 9.8 0 0 1-1.433-4.46z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiNetworkSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.814.666C9.997-.17 11.188-.175 11.38.66l.009.04l.017.077c.22.935.976 1.648 1.922 1.813c.872.152.872 1.404 0 1.556a2.4 2.4 0 0 0-1.925 1.827l-.023.102c-.19.835-1.382.83-1.565-.007l-.019-.087a2.38 2.38 0 0 0-1.918-1.837c-.87-.151-.87-1.401 0-1.553A2.38 2.38 0 0 0 9.793.764l.014-.065zM7.691 5.214c-1.876-.326-2.053-2.795-.532-3.527q-.204-.367-.431-.721a7 7 0 0 0-.475 0A13.3 13.3 0 0 0 4.22 6.838h4.543q-.045-.45-.12-.894a1.3 1.3 0 0 0-.95-.73M.02 6.838a6.51 6.51 0 0 1 4.63-5.612a14.6 14.6 0 0 0-1.686 5.612H.018m.009 1.25h2.936A14.6 14.6 0 0 0 4.65 13.7A6.51 6.51 0 0 1 .019 8.088zm4.191 0a13.3 13.3 0 0 0 2.034 5.872a7 7 0 0 0 .475 0a13.3 13.3 0 0 0 2.034-5.872zm8.743 0a6.51 6.51 0 0 1-4.63 5.612a14.6 14.6 0 0 0 1.685-5.612z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiPromptSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.02 3.485h-3.5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-4m-11-2.5h6.5\"/><path d=\"m3.02 10.985l1.5-1.5l-1.5-1.5m3 3h1.5m-.124-7.036c-.35-.061-.35-.565 0-.626A3.18 3.18 0 0 0 9.955.873l.02-.097c.077-.347.57-.35.65-.003l.025.113a3.19 3.19 0 0 0 2.566 2.435c.352.061.352.568 0 .63a3.19 3.19 0 0 0-2.566 2.435l-.026.112c-.079.346-.572.344-.648-.003L9.955 6.4a3.18 3.18 0 0 0-2.559-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiPromptSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.56.656c.188-.87 1.42-.877 1.616-.007l.025.113a2.67 2.67 0 0 0 2.126 2.056c.897.159.897 1.455 0 1.614A2.67 2.67 0 0 0 11.2 6.488l-.025.113c-.195.87-1.428.863-1.616-.007l-.02-.097A2.65 2.65 0 0 0 7.422 4.43c-.896-.159-.896-1.453 0-1.612A2.65 2.65 0 0 0 9.54.753l.489.105l-.49-.105zM6.26 2c-1.121.884-1.002 2.814.359 3.475H1.25v6.9a.375.375 0 0 0 .375.375h9.75a.375.375 0 0 0 .375-.375V8.25a.625.625 0 1 1 1.25 0v4.125c0 .898-.727 1.625-1.625 1.625h-9.75A1.625 1.625 0 0 1 0 12.375v-8.75A1.625 1.625 0 0 1 1.625 2zM3.072 7.519a.625.625 0 0 1 .884 0l1.5 1.5a.625.625 0 0 1 0 .884l-1.5 1.5a.625.625 0 1 1-.884-.884L4.13 9.46L3.072 8.403a.625.625 0 0 1 0-.884m3.442 2.817a.625.625 0 1 0 0 1.25h1.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiPromptSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.721.657c.186-.846 1.39-.851 1.582-.007l.01.04l.018.08a2.48 2.48 0 0 0 1.992 1.879c.881.153.881 1.42 0 1.573a2.48 2.48 0 0 0-1.996 1.894l-.024.105c-.192.844-1.396.839-1.582-.007l-.02-.09c-.214-.98-1-1.732-1.987-1.904c-.88-.153-.88-1.417 0-1.57A2.47 2.47 0 0 0 9.7.757l.015-.066zM1.766 2.48h4.39c-.57 1.05-.115 2.6 1.364 2.857c.486.085.882.43 1.036.893h-7.04v6c0 .138.112.25.25.25h9a.25.25 0 0 0 .25-.25V7.923c.644-.163 1.21-.646 1.394-1.45l.024-.106q.03-.13.082-.247v6.11a1.75 1.75 0 0 1-1.75 1.75h-9a1.75 1.75 0 0 1-1.75-1.75v-8c0-.967.784-1.75 1.75-1.75m.963 4.836a.625.625 0 0 1 .884 0l1.5 1.5a.625.625 0 0 1 0 .884l-1.5 1.5a.625.625 0 1 1-.884-.884L3.787 9.26L2.73 8.201a.625.625 0 0 1 0-.884m2.817 3.442c0-.345.28-.625.625-.625h1.5a.625.625 0 1 1 0 1.25h-1.5a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiRedoSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.04 13.448v-2.48h2.48\"/><path d=\"M13.339 5.815a6.449 6.449 0 0 1-11.3 5.308M.661 8.185a6.449 6.449 0 0 1 11.3-5.308\"/><path d=\"M11.96.552v2.48H9.48M4.09 7.334c-.351-.061-.351-.565 0-.626a3.18 3.18 0 0 0 2.558-2.45l.021-.097c.076-.347.57-.349.649-.003l.026.113a3.19 3.19 0 0 0 2.565 2.435c.353.061.353.568 0 .63A3.19 3.19 0 0 0 7.344 9.77l-.026.112c-.079.346-.573.344-.649-.003l-.02-.096a3.18 3.18 0 0 0-2.56-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiRedoSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.041.76l-.726.727A7.001 7.001 0 0 0 0 7a.625.625 0 1 0 1.25 0a5.751 5.751 0 0 1 9.175-4.621l-.835.834a.5.5 0 0 0 .353.854h2.453a.5.5 0 0 0 .5-.5V1.114a.5.5 0 0 0-.854-.353m.71 6.24A.625.625 0 1 1 14 7a7 7 0 0 1-11.317 5.513l-.726.726a.5.5 0 0 1-.853-.354v-2.452a.5.5 0 0 1 .5-.5h2.452a.5.5 0 0 1 .353.854l-.834.834A5.751 5.751 0 0 0 12.75 7M7.8 4.024c-.195-.87-1.428-.863-1.616.007l-.02.097a2.65 2.65 0 0 1-2.118 2.066c-.896.159-.896 1.453 0 1.612a2.65 2.65 0 0 1 2.117 2.066l.021.097c.188.87 1.42.877 1.616.007l.025-.113A2.67 2.67 0 0 1 9.95 7.807c.898-.159.898-1.455 0-1.614a2.67 2.67 0 0 1-2.125-2.056z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiRedoSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.213 2.538A5.499 5.499 0 0 0 1.595 8.01a.75.75 0 0 1-1.474.277a6.999 6.999 0 0 1 11.163-6.821l.612-.612a.5.5 0 0 1 .854.353V3.5a.5.5 0 0 1-.5.5H9.957a.5.5 0 0 1-.353-.853zm2.791 2.577a.75.75 0 0 1 .876.598a6.999 6.999 0 0 1-11.164 6.821l-.612.613a.5.5 0 0 1-.854-.354V10.5a.5.5 0 0 1 .5-.5h2.293a.5.5 0 0 1 .354.854l-.61.609a5.499 5.499 0 0 0 8.618-5.472a.75.75 0 0 1 .6-.876M6.181 4.034c.19-.87 1.427-.874 1.625-.008l.01.044q.008.044.02.086a2.69 2.69 0 0 0 2.159 2.037c.905.157.905 1.457 0 1.614a2.69 2.69 0 0 0-2.164 2.054l-.025.113c-.198.867-1.435.861-1.625-.007L6.16 9.87a2.68 2.68 0 0 0-2.156-2.064c-.903-.157-.903-1.454 0-1.611A2.68 2.68 0 0 0 6.157 4.14l.016-.071z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiScienceSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.022 4.347a18.5 18.5 0 0 0-1.93 1.686C1.248 8.877-.192 12.046.874 13.113c1.066 1.066 4.236-.375 7.079-3.218a18.5 18.5 0 0 0 1.686-1.931\"/><path d=\"M9.639 7.964c1.677 2.226 2.36 4.32 1.532 5.148c-1.067 1.067-4.236-.374-7.08-3.217C1.249 7.05-.191 3.882.875 2.815c.828-.827 2.922-.144 5.148 1.532\"/><path d=\"M5.522 7.964a.5.5 0 1 0 1 0a.5.5 0 0 0-1 0m2.51-4.354c-.315-.055-.315-.506 0-.56a2.84 2.84 0 0 0 2.29-2.193L10.34.77c.068-.31.51-.312.58-.003l.024.101a2.86 2.86 0 0 0 2.296 2.18c.316.055.316.509 0 .563a2.86 2.86 0 0 0-2.296 2.18l-.024.101c-.07.31-.512.308-.58-.002l-.02-.087A2.84 2.84 0 0 0 8.03 3.61\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiScienceSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65C10.98-.22 9.748-.216 9.56.655l-.02.097l.488.105L9.54.753A2.65 2.65 0 0 1 7.422 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.125-2.056c.898-.159.898-1.455 0-1.614A2.67 2.67 0 0 1 11.202.762zM5.494 3.347C4.536 2.728 3.596 2.286 2.77 2.1c-.797-.18-1.662-.155-2.244.428C.093 2.96-.03 3.554.005 4.137c.035.584.23 1.233.533 1.899c.283.623.673 1.288 1.153 1.965c-.48.677-.87 1.342-1.153 1.965c-.303.666-.498 1.315-.533 1.9c-.035.582.088 1.176.52 1.608l.443-.442l-.442.442c.432.433 1.026.556 1.609.521c.584-.035 1.233-.23 1.899-.533A12 12 0 0 0 6 12.308c.677.48 1.342.87 1.965 1.153c.666.303 1.315.498 1.899.533c.583.035 1.177-.088 1.61-.52c.605-.607.609-1.516.402-2.348c-.215-.866-.703-1.855-1.382-2.858a.625.625 0 1 0-1.036.7c.632.933 1.037 1.785 1.205 2.46c.176.707.052 1.035-.074 1.161c-.088.09-.272.18-.65.158c-.377-.023-.87-.158-1.457-.424c-.45-.205-.937-.48-1.442-.816a19 19 0 0 0 1.92-1.839a.625.625 0 1 0-.925-.842A18.4 18.4 0 0 1 6 10.743c-.48-.385-.966-.82-1.445-1.298A18 18 0 0 1 3.257 8a18 18 0 0 1 2.086-2.187a.625.625 0 0 0-.83-.935a19.6 19.6 0 0 0-2.02 2.082a10.4 10.4 0 0 1-.816-1.442c-.266-.586-.401-1.08-.424-1.457c-.022-.378.069-.562.157-.65c.12-.12.427-.241 1.085-.093c.631.143 1.432.505 2.319 1.08a.625.625 0 0 0 .68-1.05M2.493 9.04c-.337.505-.611.992-.816 1.442c-.266.586-.401 1.08-.424 1.457c-.022.378.069.562.157.65c.09.09.273.18.65.158c.378-.023.872-.158 1.458-.424c.45-.205.937-.479 1.442-.816A19.3 19.3 0 0 1 2.493 9.04M4.75 8a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiScienceSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.825.638c.183-.836 1.374-.841 1.565-.006l.008.039l.018.078c.22.934.975 1.647 1.922 1.812c.872.152.872 1.404 0 1.556a2.4 2.4 0 0 0-1.925 1.827l-.024.102c-.19.835-1.38.83-1.564-.006l-.019-.088a2.38 2.38 0 0 0-1.918-1.837c-.87-.151-.87-1.401 0-1.552A2.38 2.38 0 0 0 9.804.736L9.818.67zm.727 7.118a1.9 1.9 0 0 1-1.275-.529a.8.8 0 0 0-.194.186c-.45.596-.977 1.205-1.573 1.8c-.452.452-.91.863-1.362 1.23c-.452-.367-.91-.778-1.362-1.23a18 18 0 0 1-1.23-1.361c.367-.453.779-.91 1.23-1.362a17 17 0 0 1 1.8-1.573a.8.8 0 0 0 .172-.172a1.87 1.87 0 0 1-.61-1.365c-.981-.687-1.951-1.196-2.817-1.461c-.938-.287-2.038-.364-2.759.356c-.467.468-.594 1.104-.558 1.709c.036.606.239 1.272.546 1.948a12 12 0 0 0 1.117 1.92A12 12 0 0 0 .56 9.77c-.307.676-.51 1.342-.546 1.948s.09 1.241.558 1.708c.468.468 1.104.595 1.709.559c.605-.037 1.272-.239 1.948-.546c.61-.278 1.259-.655 1.92-1.117c.66.462 1.308.84 1.919 1.117c.675.307 1.342.51 1.948.546s1.24-.091 1.708-.559c.721-.72.644-1.82.357-2.758c-.274-.894-.807-1.9-1.529-2.913m-7.66-4.403c.576.176 1.263.51 2.007.994a19.5 19.5 0 0 0-2.256 2.256a10 10 0 0 1-.718-1.292c-.263-.58-.392-1.06-.414-1.417c-.021-.359.067-.503.122-.558c.09-.09.423-.238 1.26.017m-.967 7.039c.184-.405.425-.84.718-1.292A19.5 19.5 0 0 0 4.9 11.356a10 10 0 0 1-1.291.718c-.58.264-1.06.393-1.417.414c-.36.022-.503-.066-.558-.121s-.143-.2-.122-.558c.022-.357.15-.837.414-1.417m6.763 1.683a10 10 0 0 1-1.29-.719A19.5 19.5 0 0 0 9.652 9.1c.483.745.818 1.432.993 2.008c.256.836.108 1.169.018 1.259c-.055.055-.2.143-.558.122c-.358-.022-.838-.15-1.418-.414m-3.54-4.223a1 1 0 1 1 2 0a1 1 0 0 1-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiSettingsSpark: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.92 2.57h-.687a.84.84 0 0 0-.78.537l-.36.93l-1.24.703l-.988-.15a.84.84 0 0 0-.838.41l-.335.587a.84.84 0 0 0 .067.946l.628.78V8.72l-.611.78a.84.84 0 0 0-.067.946l.335.586a.84.84 0 0 0 .838.411l.988-.15l1.223.703l.36.93a.84.84 0 0 0 .78.536h.704a.84.84 0 0 0 .779-.536l.36-.93l1.223-.704l.989.151a.84.84 0 0 0 .838-.41l.335-.587a.84.84 0 0 0-.067-.947l-.629-.779v-.907m-5.864.203a1.676 1.676 0 1 0 3.351 0a1.676 1.676 0 0 0-3.351 0M8.1 3.542c-.306-.053-.306-.494 0-.547A2.78 2.78 0 0 0 10.34.85l.019-.085c.066-.303.498-.305.567-.002l.023.098a2.79 2.79 0 0 0 2.244 2.131c.309.054.309.497 0 .55a2.79 2.79 0 0 0-2.244 2.131l-.023.099c-.069.303-.501.3-.568-.003l-.018-.084a2.78 2.78 0 0 0-2.238-2.144\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiSettingsSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65c-.195-.87-1.428-.865-1.616.006l-.02.097l.489.105l-.49-.105A2.65 2.65 0 0 1 7.423 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2.762zM5.799 2.731a.625.625 0 0 1-.623.626a.19.19 0 0 0-.18.124v.001l-.352.908a.63.63 0 0 1-.275.318l-1.211.688a.63.63 0 0 1-.403.074l-.959-.146a.19.19 0 0 0-.19.094l-.325.57l-.004.008a.19.19 0 0 0 .014.217l.613.76c.09.11.138.25.138.392V8.74c0 .14-.047.276-.133.386l-.598.761l-.002.004a.19.19 0 0 0-.016.218l.004.007l.326.57a.19.19 0 0 0 .19.095l.959-.146a.63.63 0 0 1 .406.076l1.195.687a.63.63 0 0 1 .27.316l.353.909a.19.19 0 0 0 .18.124h.684a.19.19 0 0 0 .18-.123v-.001l.352-.909a.63.63 0 0 1 .27-.316l1.196-.687a.63.63 0 0 1 .406-.076l.959.146a.19.19 0 0 0 .19-.094v-.001l.326-.57l.003-.007a.19.19 0 0 0-.014-.217l-.001-.001l-.612-.759a.625.625 0 0 1 .973-.784l.614.76l.002.004a1.44 1.44 0 0 1 .118 1.627l-.326.57l-.001.003a1.44 1.44 0 0 1-1.444.707l-.01-.001l-.75-.115l-.813.469l-.272.702a1.44 1.44 0 0 1-1.343.923h-.691a1.44 1.44 0 0 1-1.342-.923l-.272-.702l-.814-.469l-.75.115l-.01.001a1.44 1.44 0 0 1-1.443-.707l-.002-.003l-.326-.57A1.44 1.44 0 0 1 .33 9.115l.463-.59v-.938l-.475-.59l-.002-.003a1.44 1.44 0 0 1-.118-1.627l.326-.57l.001-.003a1.44 1.44 0 0 1 1.444-.707l.01.001l.752.115l.829-.47l.27-.7v-.001a1.44 1.44 0 0 1 1.343-.924a.625.625 0 0 1 .627.624M5.51 6.04a2.013 2.013 0 1 0 0 4.027a2.013 2.013 0 0 0 0-4.027\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiSettingsSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.805.745c.18-.825 1.356-.83 1.544-.006l.009.038l.017.075c.21.895.935 1.58 1.843 1.738c.861.15.861 1.386 0 1.536c-.912.159-1.64.85-1.846 1.752l-.023.099c-.188.824-1.363.819-1.544-.007l-.018-.084a2.28 2.28 0 0 0-1.84-1.761c-.86-.15-.86-1.384 0-1.534A2.28 2.28 0 0 0 9.785.84l.014-.063zM7.771 5.142C6.429 4.91 5.987 3.541 6.444 2.56a.9.9 0 0 0-.622-.256h-.73a.89.89 0 0 0-.827.569l-.382.987l-1.316.747l-1.05-.16a.89.89 0 0 0-.889.435l-.355.623a.89.89 0 0 0 .07 1.005l.668.827V8.83l-.65.827a.89.89 0 0 0-.07 1.004l.355.623a.89.89 0 0 0 .89.435l1.049-.16l1.298.747l.382.988a.89.89 0 0 0 .827.569h.747a.89.89 0 0 0 .827-.57l.383-.987l1.298-.746l1.05.16a.89.89 0 0 0 .889-.436l.355-.623a.89.89 0 0 0-.07-1.004l-.668-.827V7.503c-.522-.198-.96-.636-1.107-1.312l-.019-.085a1.25 1.25 0 0 0-1.006-.964M5.457 9.94a1.858 1.858 0 1 0 0-3.715a1.858 1.858 0 0 0 0 3.715\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiTechnologySpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.406 7.97c-.386.44-.856.8-1.385 1.061v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1.5A4.5 4.5 0 0 1 6.875.9M3.021 13.5h4\"/><path d=\"M7.395 3.934c-.351-.061-.351-.565 0-.626A3.18 3.18 0 0 0 9.953.858L9.974.76c.076-.347.57-.349.649-.003l.026.113a3.19 3.19 0 0 0 2.565 2.435c.353.062.353.568 0 .63A3.19 3.19 0 0 0 10.65 6.37l-.026.113c-.079.346-.573.344-.649-.003l-.02-.097a3.18 3.18 0 0 0-2.56-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiTechnologySparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65c-.195-.87-1.428-.865-1.615.006L9.54.753l.489.105l-.49-.105A2.65 2.65 0 0 1 7.423 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.898-.159.898-1.455 0-1.614A2.67 2.67 0 0 1 11.2.762zM7.248.522a5.018 5.018 0 0 0-4.808 8.8v1.094a1.113 1.113 0 0 0 1.113 1.113h2.929a1.113 1.113 0 0 0 1.113-1.113V9.324c.436-.26.829-.584 1.166-.96a.625.625 0 0 0-.931-.834a3.8 3.8 0 0 1-1.136.862a.63.63 0 0 0-.35.56v1.328H3.69V8.953a.63.63 0 0 0-.347-.56a3.768 3.768 0 0 1 3.35-6.75a.625.625 0 0 0 .555-1.12M3.125 12.75a.625.625 0 1 0 0 1.25h3.75a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiTechnologySparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.527 9.331a5 5 0 0 0 1.49-1.319a2 2 0 0 1-.273-.661l-.019-.088a1.29 1.29 0 0 0-1.042-.998c-2.072-.36-2.072-3.334 0-3.695a1.29 1.29 0 0 0 1.03-.948a5 5 0 1 0-6.187 7.709V10.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1zm-5 3.919a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m7.28-11.533C9.99.881 11.18.876 11.37 1.71l.009.04l.018.078a2.4 2.4 0 0 0 1.921 1.812c.872.152.872 1.404 0 1.556a2.4 2.4 0 0 0-1.925 1.827l-.023.102c-.19.835-1.381.83-1.565-.007l-.019-.087A2.38 2.38 0 0 0 7.87 5.194c-.871-.151-.871-1.401 0-1.553a2.38 2.38 0 0 0 1.915-1.826L9.8 1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiUpscaleSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 12.5a6 6 0 1 0 0-12a6 6 0 0 0 0 12m4.24-1.76l2.76 2.76\"/><path d=\"M3.45 6.828c-.368-.064-.368-.592 0-.656a3.33 3.33 0 0 0 2.68-2.568l.022-.101c.08-.364.597-.366.68-.003l.027.118A3.35 3.35 0 0 0 9.55 6.17c.37.065.37.595 0 .66a3.35 3.35 0 0 0-2.69 2.552l-.027.118c-.083.363-.6.36-.68-.003l-.022-.1a3.33 3.33 0 0 0-2.681-2.57\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiUpscaleSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1.25a5.25 5.25 0 1 0 0 10.5a5.25 5.25 0 0 0 0-10.5M0 6.5a6.5 6.5 0 1 1 11.673 3.936l2.07 2.07a.875.875 0 0 1-1.237 1.238l-2.07-2.07A6.5 6.5 0 0 1 0 6.5m7.313-3.09c-.198-.884-1.45-.878-1.64.007l-.022.1a2.78 2.78 0 0 1-2.219 2.165c-.91.16-.91 1.475 0 1.636a2.78 2.78 0 0 1 2.219 2.165l.021.1c.19.885 1.443.891 1.641.007l.027-.117A2.79 2.79 0 0 1 9.566 7.32c.912-.161.912-1.479 0-1.64A2.79 2.79 0 0 1 7.34 3.527z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiUpscaleSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1.5a5 5 0 1 0 0 10a5 5 0 0 0 0-10M0 6.5a6.5 6.5 0 1 1 11.749 3.835l1.958 1.958a1 1 0 1 1-1.414 1.414l-1.958-1.958A6.5 6.5 0 0 1 0 6.5m5.74-2.63c.18-.824 1.352-.829 1.539-.007l.009.038A2.275 2.275 0 0 0 9.13 5.697c.859.149.859 1.382 0 1.531A2.275 2.275 0 0 0 7.3 8.964l-.022.098c-.187.821-1.36.816-1.54-.007l-.018-.084a2.26 2.26 0 0 0-1.822-1.744c-.857-.15-.857-1.38 0-1.53a2.26 2.26 0 0 0 1.82-1.734l.013-.062l.007-.031Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiVehicleSpark1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.513 4.963H4.77a1 1 0 0 0-1 .68L3 7.963H1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1H2m10-4h.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H12\"/><path d=\"M10.499 13.463a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002m-7 0a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002m5.499-1.5H5M7.416 3.97c-.351-.06-.351-.564 0-.625A3.18 3.18 0 0 0 9.974.895l.022-.097c.075-.347.57-.349.648-.003l.026.113a3.19 3.19 0 0 0 2.565 2.435c.353.062.353.568 0 .63a3.19 3.19 0 0 0-2.565 2.435l-.026.112c-.079.347-.573.344-.648-.002l-.022-.097a3.18 3.18 0 0 0-2.558-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiVehicleSpark1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.815.696C9.998-.14 11.19-.145 11.38.69l.009.04q.008.04.018.077a2.4 2.4 0 0 0 1.921 1.813c.872.152.872 1.404 0 1.556a2.4 2.4 0 0 0-1.925 1.827l-.023.102c-.19.835-1.382.83-1.565-.007l-.019-.087a2.38 2.38 0 0 0-1.918-1.837c-.87-.151-.87-1.401 0-1.553A2.38 2.38 0 0 0 9.794.794l.014-.065zM7.692 5.244C6.99 5.122 6.526 4.7 6.3 4.181H4.782a1.5 1.5 0 0 0-1.486 1.021v.002L2.638 7.18H1.5A1.5 1.5 0 0 0 0 8.68v2a1.5 1.5 0 0 0 1.02 1.421a2.502 2.502 0 0 1 4.968.08H8.01a2.501 2.501 0 0 1 4.968-.079A1.5 1.5 0 0 0 14 10.681v-2a1.5 1.5 0 0 0-1.5-1.5h-.473c-.926 1.07-2.916.783-3.274-.851l-.019-.088a1.29 1.29 0 0 0-1.042-.998M3.5 13.934a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002m7 0a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAiVehicleSpark2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65c-.195-.87-1.428-.865-1.616.006l-.02.097l.489.105l-.49-.105A2.65 2.65 0 0 1 7.423 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2.762zm-7.463 6.6a.875.875 0 0 0-.856.692L2.63 9h4.74l-.227-1.058a.875.875 0 0 0-.856-.692zm5.003 2.065l-.35-1.635A2.125 2.125 0 0 0 6.286 6H3.713c-1.002 0-1.868.7-2.078 1.68l-.35 1.635A2.5 2.5 0 0 0 0 11.5a1.5 1.5 0 0 0 1.375 1.495v.38a.625.625 0 1 0 1.25 0V13h4.75v.375a.625.625 0 1 0 1.25 0v-.38A1.5 1.5 0 0 0 10 11.5a2.5 2.5 0 0 0-1.284-2.185\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplane: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.25 2.75h1.61a.49.49 0 0 1 .48.38l.51 2l5-1a3.69 3.69 0 0 1 4.4 3.59a1 1 0 0 1-1 1h-4.4l-1 1.58a2 2 0 0 1-1.68.92h-1.1a.5.5 0 0 1-.44-.73l.88-1.74H1.75a1 1 0 0 1-1-1v-4.5a.5.5 0 0 1 .5-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneDisabled: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.146 13.275L7 12.343l-2.146.93a.99.99 0 0 1-1.035-1.665L5.72 10L5.5 7.97l-3.637.821a.989.989 0 0 1-.665-1.846l1.916-.972M13.5 13.5L.5.5M5.031 5l-.19-1.298a2.97 2.97 0 0 1 .607-2.268a1.977 1.977 0 0 1 3.104 0c.505.64.725 1.46.607 2.268L8.969 5l3.833 1.944a.989.989 0 0 1-.665 1.846L8.5 7.969l-.052.48\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneDisabledRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 1 .884 0l3.2 3.2A3.5 3.5 0 0 1 5.01.966a2.536 2.536 0 0 1 3.981 0a3.5 3.5 0 0 1 .717 2.651l-.143 1.552l3.85 1.952c.21.107.342.322.342.558V8.97a.625.625 0 0 1-.727.617L9.965 9.08l3.852 3.852a.625.625 0 1 1-.884.884L4.672 5.555a.6.6 0 0 1-.114-.113L.183 1.067a.625.625 0 0 1 0-.884m5.471 4.588l2.794 2.793l4.058.669V8.06L8.62 6.091a.625.625 0 0 1-.34-.615l.184-1.99l.004-.033a2.24 2.24 0 0 0-.459-1.714a1.286 1.286 0 0 0-2.019 0a2.24 2.24 0 0 0-.454 1.747zM4.118 6.03a.625.625 0 0 1-.275.84L1.494 8.06v.172l4.2-.692a.625.625 0 0 1 .724.556l.211 2.202a.63.63 0 0 1-.23.547L4.94 12.017v.462l1.843-.68a.62.62 0 0 1 .432 0l1.952.72a.624.624 0 0 1 1.141.352v.504a.625.625 0 0 1-.84.586L7 13.051l-2.468.91a.625.625 0 0 1-.841-.586v-1.657c0-.19.086-.37.233-.488l1.429-1.148l-.116-1.2l-4.266.704a.625.625 0 0 1-.727-.617V7.678c0-.236.132-.451.342-.558l2.692-1.365a.625.625 0 0 1 .84.275\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneDisabledSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.219 1.28A.75.75 0 0 1 1.279.219l3.43 3.43l-.028-.193a3.2 3.2 0 0 1 .652-2.435a2.123 2.123 0 0 1 3.333 0c.543.688.779 1.568.652 2.435L9.114 4.85l4.117 2.088a1.062 1.062 0 0 1-.714 1.982L9.24 8.18l4.54 4.54a.75.75 0 0 1-1.06 1.061zm5.19 6.953l5.169 5.168c-.282.37-.796.542-1.273.335l-2.305-1l-2.305 1a1.064 1.064 0 0 1-1.111-1.788l2.04-1.729zM2.99 5.812L5.247 8.07l-3.764.85a1.062 1.062 0 0 1-.714-1.982z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneEnabled: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.031 5l-.19-1.298a2.97 2.97 0 0 1 .607-2.267a1.977 1.977 0 0 1 3.104 0c.505.64.725 1.46.607 2.267L8.969 5l3.833 1.944a.989.989 0 0 1-.665 1.846L8.5 7.97L8.281 10l1.9 1.61a.991.991 0 0 1-1.035 1.664L7 12.344l-2.146.93a.99.99 0 0 1-1.035-1.665L5.72 10L5.5 7.969l-3.637.821a.989.989 0 0 1-.665-1.846z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneEnabledRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.01 1.74a1.286 1.286 0 0 0-2.02 0a2.24 2.24 0 0 0-.454 1.746l.184 1.99a.625.625 0 0 1-.34.615L1.494 8.06v.172l4.2-.692a.625.625 0 0 1 .724.556l.211 2.202a.63.63 0 0 1-.23.547L4.94 12.017v.462l1.843-.68a.62.62 0 0 1 .432 0l1.843.68v-.462l-1.457-1.171a.63.63 0 0 1-.231-.547l.211-2.202a.625.625 0 0 1 .724-.556l4.2.692V8.06L8.62 6.091a.625.625 0 0 1-.34-.615l.184-1.99l.004-.033a2.24 2.24 0 0 0-.459-1.714m-3-.775a2.536 2.536 0 0 1 3.98 0a3.5 3.5 0 0 1 .717 2.651l-.143 1.552l3.85 1.952c.21.107.342.322.342.558v1.291a.625.625 0 0 1-.727.617l-4.266-.703l-.115 1.2l1.428 1.147a.63.63 0 0 1 .234.488v1.657a.625.625 0 0 1-.842.586L7 13.051l-2.468.91a.625.625 0 0 1-.841-.586v-1.657c0-.19.086-.37.233-.488l1.429-1.147l-.116-1.2l-4.266.703a.625.625 0 0 1-.727-.617V7.678c0-.236.132-.451.342-.558l3.85-1.952l-.143-1.552A3.5 3.5 0 0 1 5.01.965\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneEnabledSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4.886 4.85l-.204-1.393a3.2 3.2 0 0 1 .651-2.435a2.123 2.123 0 0 1 3.334 0c.542.687.778 1.568.651 2.435L9.114 4.85l4.117 2.088a1.062 1.062 0 0 1-.714 1.982l-3.906-.882l-.235 2.181l2.04 1.729a1.064 1.064 0 0 1-1.111 1.788l-2.305-1l-2.305 1a1.064 1.064 0 0 1-1.111-1.788l2.04-1.729L5.39 8.04l-3.906.882A1.062 1.062 0 0 1 .77 6.94z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3.125V8c0 .207.168.375.375.375H4.5a.625.625 0 0 1 .488 1.015L3.8 10.875h2.22a.38.38 0 0 0 .292-.14l1.7-2.125a.63.63 0 0 1 .488-.235h3.875A.375.375 0 0 0 12.75 8v-.096a3.375 3.375 0 0 0-4.052-3.307h-.001L3.879 5.613a.625.625 0 0 1-.728-.432l-.616-2.055zM0 3c0-.621.504-1.125 1.125-1.125h1.503c.497 0 .935.326 1.078.802l.478 1.593l4.262-.897A4.625 4.625 0 0 1 14 7.903V8c0 .897-.727 1.625-1.625 1.625H8.8l-1.512 1.89c-.308.386-.775.61-1.269.61H3.54c-.943 0-1.467-1.091-.878-1.828l.538-.672H1.625A1.625 1.625 0 0 1 0 8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirplaneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.563 2.197a.775.775 0 0 1 .758.598v-.003l-.243.062l.244-.056v-.003l.486 1.91L8.934 3.68a4.204 4.204 0 0 1 5.013 4.09v.003a1.32 1.32 0 0 1-1.321 1.321H8.048l-.997 1.577l-.001.001a2.4 2.4 0 0 1-2.01 1.101H3.857a.786.786 0 0 1-.692-1.146l.223.114l-.222-.115l.758-1.5h-2.55A1.32 1.32 0 0 1 .052 7.805V2.983a.786.786 0 0 1 .786-.786z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportPlane: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.33 10.67H1.88a1.45 1.45 0 0 1 0-2.89h2.3L5.66 6.3L1.6 3.8a1.45 1.45 0 0 1-.52-1.91a1.47 1.47 0 0 1 2-.77l5.3 2.45L10.94.98a1.47 1.47 0 1 1 2.08 2.08l-2.59 2.56l2.45 5.35a1.46 1.46 0 0 1-.77 1.95a1.45 1.45 0 0 1-1.91-.52L7.7 8.34L6.22 9.82v2.3a1.45 1.45 0 0 1-2.89 0z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportPlaneRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M10.683 1.067L8.25 3.5L4.131 1.539a2 2 0 0 0-2.11.244l-.947.757a.5.5 0 0 0 .065.825L5.75 6L3.875 7.875l-1.438-.221A1.573 1.573 0 0 0 .625 9.209c0 .384.278.712.657.776l2.343.39l.39 2.343a.79.79 0 0 0 .776.657c.964 0 1.702-.86 1.555-1.812l-.221-1.438L8 8.25l2.635 4.611a.5.5 0 0 0 .825.064l.757-.947a2 2 0 0 0 .244-2.109L10.5 5.75l2.433-2.433a1.51 1.51 0 0 0 0-2.134l-.116-.116a1.51 1.51 0 0 0-2.134 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportPlaneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.98.3a1.72 1.72 0 0 0-1.217.504h-.001L8.325 3.27L3.186.894a1.72 1.72 0 0 0-2.333.89a1.7 1.7 0 0 0 .615 2.23l3.79 2.334L4.077 7.53H1.859a1.7 1.7 0 0 0 .02 3.39h1.2v1.2l.001.02a1.7 1.7 0 0 0 3.39-.02V9.924l1.182-1.183l2.335 3.79v.001a1.7 1.7 0 0 0 2.229.615a1.71 1.71 0 0 0 .891-2.28L10.73 5.675l2.465-2.437h.001A1.72 1.72 0 0 0 11.98.3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportPlaneTransit: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.246 6.417l.71-.365a.257.257 0 0 1 .349.086l.67.764l2.77-1.94a1.882 1.882 0 0 1 2.802.547a.515.515 0 0 1-.243.686l-1.677.775l-.185.089l-.38 2.07a.27.27 0 0 1-.153.214L6.89 9.9a.28.28 0 0 1-.406-.26l.249-1.67l-.122.057l-1.814.904a.506.506 0 0 1-.681-.213l-.98-1.971a.257.257 0 0 1 .11-.33m-1.241 7.076v-2.497h2.498\"/><path d=\"M13.383 5.807A6.494 6.494 0 0 1 2.005 11.15M.617 8.193a6.494 6.494 0 0 1 11.378-5.345\"/><path d=\"M11.995.507v2.497H9.497\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportPlaneTransitRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.594 4.25H10.5a.5.5 0 0 1-.353-.854l.764-.764a5.875 5.875 0 0 0-9.66 4.493a.625.625 0 0 1-1.25 0a7.125 7.125 0 0 1 11.796-5.38l.6-.599a.5.5 0 0 1 .853.354v2.25a.5.5 0 0 1-.5.5zm.781 2a.625.625 0 0 0-.625.625a5.875 5.875 0 0 1-9.66 4.493l.764-.764A.5.5 0 0 0 3.5 9.75H1.25a.5.5 0 0 0-.5.5v2.25a.5.5 0 0 0 .854.354l.599-.6A7.125 7.125 0 0 0 14 6.874a.625.625 0 0 0-.625-.624M8.792 4.763a2.12 2.12 0 0 1 2.175 1.362a.76.76 0 0 1-.504.951l-.003.001l-1.76.517l-.073.022l-.632 1.853a.52.52 0 0 1-.338.35l-1.08.397l-.008.003a.528.528 0 0 1-.679-.626l.35-1.15l-1.587.517a.753.753 0 0 1-.953-.462l-.002-.006l-.676-2.08l-.004-.011a.505.505 0 0 1 .313-.61l.006-.002l.745-.253a.505.505 0 0 1 .636.248l.418.647l2.799-1.4a2.1 2.1 0 0 1 .857-.268\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportPlaneTransitSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.213 2.538A5.499 5.499 0 0 0 1.595 8.01a.75.75 0 0 1-1.474.277a6.999 6.999 0 0 1 11.163-6.821l.612-.612a.5.5 0 0 1 .854.353V3.5a.5.5 0 0 1-.5.5H9.957a.5.5 0 0 1-.353-.853zm2.791 2.577a.75.75 0 0 1 .876.598a6.999 6.999 0 0 1-11.164 6.821l-.612.613a.5.5 0 0 1-.854-.354V10.5a.5.5 0 0 1 .5-.5h2.293a.5.5 0 0 1 .354.854l-.61.609a5.499 5.499 0 0 0 8.618-5.472a.75.75 0 0 1 .6-.876m-9.048.937l-.71.365a.257.257 0 0 0-.112.33l.98 1.971a.507.507 0 0 0 .682.213l1.606-.85l.122-.056l-.25 1.669a.28.28 0 0 0 .406.26l1.23-.611a.27.27 0 0 0 .151-.214l.38-2.07l.186-.089l1.677-.775a.514.514 0 0 0 .243-.686a1.882 1.882 0 0 0-2.802-.547l-2.77 1.94l-.67-.764a.257.257 0 0 0-.35-.086\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.36 13.433a1 1 0 0 1-.72 0A9.565 9.565 0 0 1 .505 4.498V1.499a1 1 0 0 1 1-.999h10.993a1 1 0 0 1 1 1v2.998a9.565 9.565 0 0 1-6.137 8.935\"/><path d=\"m3.059 4.55l.826-.282a.28.28 0 0 1 .364.149l.603.934l3.306-1.653A2.058 2.058 0 0 1 11.1 4.739a.563.563 0 0 1-.372.703L8.79 6.01l-.215.066l-.744 2.178a.3.3 0 0 1-.198.207L6.439 8.9a.306.306 0 0 1-.397-.347l.537-1.765l-.14.041l-2.107.686a.554.554 0 0 1-.703-.339l-.744-2.289a.28.28 0 0 1 .174-.339\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportSecurityRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v2.675a9.4 9.4 0 0 1-6.427 8.918a.62.62 0 0 1-.396 0A9.4 9.4 0 0 1 .375 4.675zM2 1.625A.375.375 0 0 0 1.625 2v2.675A8.15 8.15 0 0 0 7 12.338a8.15 8.15 0 0 0 5.375-7.663V2A.375.375 0 0 0 12 1.625zm6.792 1.884a2.12 2.12 0 0 1 2.174 1.362a.76.76 0 0 1-.503.951l-.003.001l-1.76.517l-.073.022l-.632 1.853a.52.52 0 0 1-.338.35l-1.08.397l-.008.003a.528.528 0 0 1-.679-.626l.35-1.15l-1.587.517a.753.753 0 0 1-.953-.462l-.002-.006l-.676-2.081l-.004-.01a.505.505 0 0 1 .313-.61l.006-.002l.745-.254a.505.505 0 0 1 .636.25l.418.646l2.799-1.4a2.1 2.1 0 0 1 .857-.268\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAirportSecuritySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.443.44A1.5 1.5 0 0 1 1.503 0h10.994a1.5 1.5 0 0 1 1.5 1.5v2.998A10.065 10.065 0 0 1 7.539 13.9a1.5 1.5 0 0 1-1.078 0A10.065 10.065 0 0 1 .004 4.498V1.499c0-.397.158-.779.44-1.06m9.509 3.368a2.3 2.3 0 0 0-1.912.17l-3.1 1.549l-.472-.731a.53.53 0 0 0-.669-.263l-.827.281a.53.53 0 0 0-.328.64l.003.011l.746 2.296a.804.804 0 0 0 1.018.492l1.791-.583l-.399 1.31l-.006.027a.556.556 0 0 0 .72.63l.008-.002l1.19-.437a.55.55 0 0 0 .355-.369l.7-2.05l.092-.029l1.94-.57a.813.813 0 0 0 .531-1.031a2.3 2.3 0 0 0-1.381-1.341\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlarmClock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11M.5 2.5A8.7 8.7 0 0 1 3 .5m10.5 2a8.7 8.7 0 0 0-2.5-2\"/><path d=\"M7 5v3h2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlarmClockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.181 1.43A.75.75 0 1 0 3.546.07A8.8 8.8 0 0 0 .14 2.899a.75.75 0 0 0 1.218.875A7.3 7.3 0 0 1 4.181 1.43M9.457.431a.75.75 0 0 1 .997-.361a8.8 8.8 0 0 1 3.405 2.827a.75.75 0 1 1-1.218.875A7.3 7.3 0 0 0 9.82 1.43a.75.75 0 0 1-.362-.997M2.248 8a4.752 4.752 0 1 1 9.504 0a4.752 4.752 0 0 1-9.504 0M7 1.997a6.002 6.002 0 1 0 0 12.005A6.002 6.002 0 0 0 7 1.997M7.75 5a.75.75 0 1 0-1.5 0v3c0 .415.336.75.75.75h2.5a.75.75 0 1 0 0-1.5H7.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlarmClockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.603 1.412A.75.75 0 1 0 2.897.088A9.4 9.4 0 0 0 .182 2.261a.75.75 0 1 0 1.136.978a7.9 7.9 0 0 1 2.285-1.827M7 14A6 6 0 1 0 7 2a6 6 0 0 0 0 12M10.088.398a.75.75 0 0 1 1.015-.31a9.4 9.4 0 0 1 2.715 2.173a.75.75 0 0 1-1.136.978a7.9 7.9 0 0 0-2.285-1.827a.75.75 0 0 1-.309-1.014M7.625 5a.625.625 0 1 0-1.25 0v3c0 .345.28.625.625.625h2.5a.625.625 0 1 0 0-1.25H7.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlien: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 5.5c0 3.59-2.95 8-6.5 8S.5 9.09.5 5.5S3.41.5 7 .5s6.5 1.41 6.5 5\"/><path d=\"M2.75 4.75a3.12 3.12 0 0 0 .49 2.44a3.12 3.12 0 0 0 2.44.49a3.12 3.12 0 0 0-.49-2.44a3.12 3.12 0 0 0-2.44-.49m8.5 0a3.12 3.12 0 0 1-.49 2.44a3.12 3.12 0 0 1-2.44.49a3.12 3.12 0 0 1 .49-2.44a3.12 3.12 0 0 1 2.44-.49\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlienRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 6c0-1.642.542-2.69 1.408-3.35C3.929 1.968 5.27 1.626 7 1.626s3.07.342 3.967 1.026c.866.66 1.408 1.707 1.408 3.349c0 3.37-2.333 6.375-5.375 6.375S1.625 9.369 1.625 6M7 .375c-1.86 0-3.52.363-4.725 1.282C1.038 2.599.375 4.052.375 6c0 3.81 2.667 7.625 6.625 7.625S13.625 9.811 13.625 6c0-1.948-.663-3.4-1.9-4.343C10.52.737 8.86.375 7 .375M3.016 4.824a3.3 3.3 0 0 1 2.58.518a.3.3 0 0 1 .062.062a3.3 3.3 0 0 1 .518 2.58a.25.25 0 0 1-.192.192a3.3 3.3 0 0 1-2.58-.518a.3.3 0 0 1-.062-.062a3.3 3.3 0 0 1-.518-2.58a.25.25 0 0 1 .192-.192m7.968 0a3.3 3.3 0 0 0-2.58.518a.3.3 0 0 0-.062.062a3.3 3.3 0 0 0-.518 2.58a.25.25 0 0 0 .192.192a3.3 3.3 0 0 0 2.58-.518a.3.3 0 0 0 .062-.062a3.3 3.3 0 0 0 .518-2.58a.25.25 0 0 0-.192-.192\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlienSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0C5.152 0 3.413.361 2.122 1.24C.803 2.14 0 3.548 0 5.5c0 1.92.783 4.023 2.021 5.65C3.256 12.77 5.011 14 7 14s3.744-1.23 4.979-2.85C13.217 9.522 14 7.42 14 5.5c0-1.953-.803-3.361-2.122-4.26C10.587.362 8.848 0 7 0M2.52 4.169a3.26 3.26 0 0 1 2.552.512a.3.3 0 0 1 .062.062a3.26 3.26 0 0 1 .512 2.551a.25.25 0 0 1-.192.192a3.26 3.26 0 0 1-2.55-.512a.3.3 0 0 1-.063-.063a3.26 3.26 0 0 1-.512-2.55a.25.25 0 0 1 .192-.192m7.63-.01a3.3 3.3 0 0 1 1.33.01a.25.25 0 0 1 .191.192a3.26 3.26 0 0 1-.512 2.55a.3.3 0 0 1-.062.063a3.26 3.26 0 0 1-2.551.512a.25.25 0 0 1-.192-.192a3.26 3.26 0 0 1 .512-2.55a.3.3 0 0 1 .062-.063a3.3 3.3 0 0 1 1.222-.521\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignBack1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 .5H1.5a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1\"/><path d=\"M13.5 3.5v9a1 1 0 0 1-1 1h-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignBack1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v7.5c0 .898.728 1.625 1.625 1.625h7.5c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625zM13.625 4a.625.625 0 1 0-1.25 0v8a.375.375 0 0 1-.375.375H4a.625.625 0 1 0 0 1.25h8A1.625 1.625 0 0 0 13.625 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignBack1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v8A1.5 1.5 0 0 0 1.5 11h8A1.5 1.5 0 0 0 11 9.5v-8A1.5 1.5 0 0 0 9.5 0zM14 4.25a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 0 0 1.5h7.5A2.25 2.25 0 0 0 14 11.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignCenter: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 1h13M2 4h10M3.5 7h7m-10 6h13M2 10h10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignCenterRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 1c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 1m1.5 3c0-.345.28-.625.625-.625h9a.625.625 0 1 1 0 1.25h-9A.625.625 0 0 1 1.875 4M4 6.375a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25zM.375 13c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 13M2.5 9.375a.625.625 0 1 0 0 1.25h9a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignCenterSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1A.75.75 0 0 1 .75.25h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 1m1.25 3A.75.75 0 0 1 2 3.25h10a.75.75 0 0 1 0 1.5H2A.75.75 0 0 1 1.25 4M3.5 6.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zM1.25 10A.75.75 0 0 1 2 9.25h10a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m-.5 2.25a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignFront1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 13.5h8.5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8.5a1 1 0 0 0 1 1\"/><path d=\"M.5 10.5v-9a1 1 0 0 1 1-1h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignFront1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 13.625c.898 0 1.625-.727 1.625-1.625V4.5c0-.897-.727-1.625-1.625-1.625H4.5c-.897 0-1.625.728-1.625 1.625V12c0 .898.728 1.625 1.625 1.625zM.375 10a.625.625 0 1 0 1.25 0V2A.375.375 0 0 1 2 1.625h8a.625.625 0 1 0 0-1.25H2A1.625 1.625 0 0 0 .375 2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignFront1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.25 0A2.25 2.25 0 0 0 0 2.25v7.5a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 0 0-1.5zM4.5 3A1.5 1.5 0 0 0 3 4.5v8A1.5 1.5 0 0 0 4.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 12.5 3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 1h13M.5 4h10M.5 7h7m-7 6h13m-13-3h10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignLeft1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 1c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 1m0 3c0-.345.28-.625.625-.625h9a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 4M1 6.375a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25zM.375 13c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 13M1 9.375a.625.625 0 1 0 0 1.25h9a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignLeftSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1A.75.75 0 0 1 .75.25h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 1m.75 2.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zM0 7a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 0 7m0 3a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 0 10m.75 2.25a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H.5m13 3h-10m10 3h-7m7 6H.5m13-3h-10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignRight1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 1c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 1m3 3c0-.345.28-.625.625-.625h9a.625.625 0 1 1 0 1.25H4A.625.625 0 0 1 3.375 4M7 6.375a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25zM.375 13c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 13M4 9.375a.625.625 0 1 0 0 1.25h9a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlignRightSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1A.75.75 0 0 1 .75.25h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 1m3.25 2.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zM5.5 7a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 5.5 7m-3 3a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2.5 10M.75 12.25a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAlt: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.207.793a1 1 0 0 1 .293.707v11a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 .707.293m-2.76 4.412v3.59M9.25 5.205h2.394\"/><path d=\"M6.747 5.205v3.59h2.095m-6.592 0l1.102-3.307a.415.415 0 0 1 .394-.283v0c.179 0 .337.114.394.283l1.102 3.307M2.649 7.598h2.194\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAltRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.923 1.625a.3.3 0 0 0-.298.298v10.154c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V1.923a.3.3 0 0 0-.298-.298zm-1.548.298c0-.855.693-1.548 1.548-1.548h10.154c.855 0 1.548.693 1.548 1.548v10.154c0 .855-.693 1.548-1.548 1.548H1.923a1.55 1.55 0 0 1-1.548-1.548zm9.75 2.657H9.053a.625.625 0 1 0 0 1.25H9.5v2.965a.625.625 0 1 0 1.25 0V5.83h.447a.625.625 0 1 0 0-1.25zm-3.2 0c.346 0 .626.28.626.625V8.17h.72a.625.625 0 1 1 0 1.25H6.925a.625.625 0 0 1-.625-.625v-3.59c0-.346.28-.625.625-.625M4.579 8.993l-.257-.77h-.793l-.257.77a.625.625 0 0 1-1.186-.395l.394-1.181l.01-.032l.778-2.331a.693.693 0 0 1 1.315 0l.778 2.333l.009.027l.394 1.184a.625.625 0 1 1-1.185.395\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAltSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.44.44A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11C0 1.102.158.72.44.44m11.855 5.219a.625.625 0 1 0 0-1.25H9.673a.625.625 0 1 0 0 1.25h.686v3.307a.625.625 0 1 0 1.25 0V5.66zm-5.572-1.25c.346 0 .625.28.625.625V8.34h1.67a.625.625 0 1 1 0 1.25H6.723a.625.625 0 0 1-.625-.625V5.034c0-.346.28-.625.625-.625m-2.355.738a1.08 1.08 0 0 0-2.049 0l-.765 2.297l-.01.028l-.432 1.297a.625.625 0 1 0 1.186.395l.294-.884h1.503l.294.884a.625.625 0 0 0 1.186-.395l-.432-1.297l-.01-.028zM3.009 7.03l.335-1.003l.334 1.003z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmazon: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.469 6.777c0 1.046-1.06 1.893-2.367 1.893c-1.308 0-2.368-.847-2.368-1.893s1.06-1.894 2.368-1.894h2.367\"/><path d=\"M3.734 2.988c0-1.046 1.06-1.894 2.368-1.894s2.367.848 2.367 1.894v4.018c.082.403.42 1.25 1.11 1.415M.84 10.061c1.135 1.03 3.57 1.996 6.6 1.848s5.179-1.338 5.874-1.914\"/><path d=\"M10.545 9.495c1.178-.423 2.78.33 2.78.33s-.08 1.769-1.005 2.613\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmazonRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.948 1.25c-1.146 0-1.826.721-1.826 1.336a.625.625 0 0 1-1.25 0C2.872 1.035 4.386 0 5.948 0s3.077 1.035 3.077 2.586v4.092c.037.148.116.365.24.558c.141.222.291.336.429.37a.625.625 0 1 1-.292 1.215c-.466-.112-.804-.401-1.04-.7c-.587.615-1.492.975-2.414.975c-1.562 0-3.076-1.035-3.076-2.586s1.514-2.586 3.076-2.586h1.827V2.586c0-.615-.68-1.336-1.827-1.336m0 3.924h1.827V6.51c0 .615-.68 1.336-1.827 1.336S4.122 7.125 4.122 6.51s.68-1.336 1.826-1.336m-4.922 5.12a.625.625 0 1 0-.802.958c1.366 1.144 3.985 2.104 7.141 1.95a13.4 13.4 0 0 0 3.997-.81l.598.991a.5.5 0 0 0 .765.111c.59-.538.88-1.333 1.027-1.93a7 7 0 0 0 .173-1.092l.001-.02v-.009l-.499-.023l.5.023a.5.5 0 0 0-.287-.475l-.213.452l.213-.452l-.003-.002l-.005-.002l-.018-.008a4 4 0 0 0-.287-.118a7 7 0 0 0-.761-.239c-.596-.147-1.434-.262-2.185.009a.5.5 0 0 0-.26.729l.582.963a12.2 12.2 0 0 1-3.399.654c-2.906.141-5.197-.756-6.278-1.66\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmazonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.444 2.961c0-.47.545-1.117 1.585-1.117s1.585.648 1.585 1.117v1.12H6.029c-1.539 0-3.085 1.024-3.085 2.617S4.49 9.316 6.03 9.316c.847 0 1.697-.31 2.289-.856c.232.255.548.49.964.59a.75.75 0 0 0 .35-1.46c-.076-.018-.19-.09-.314-.284a1.8 1.8 0 0 1-.204-.467V2.96C9.115 1.367 7.569.343 6.03.343S2.944 1.368 2.944 2.96a.75.75 0 1 0 1.5 0m3.17 2.62H6.029c-1.04 0-1.585.647-1.585 1.117S4.99 7.816 6.03 7.816s1.585-.648 1.585-1.118V5.58M.284 10.05a.75.75 0 0 1 1.06-.052c.94.853 3.13 1.767 5.968 1.629a11.1 11.1 0 0 0 4.141-.998c-.291-.026-.565-.008-.788.072a.75.75 0 0 1-.508-1.411c.793-.285 1.657-.16 2.24-.016a6.6 6.6 0 0 1 1.045.355l.02.009l.005.003h.003v.001l-.066.143l.067-.142a.75.75 0 0 1 .43.712h-.021h.021v.011l-.002.021q0 .026-.005.07l-.002.03a1 1 0 0 1-.015.151l-.007.06a7 7 0 0 1-.144.78c-.144.583-.436 1.405-1.059 1.973a.75.75 0 0 1-1.011-1.108q.118-.109.217-.257a12.7 12.7 0 0 1-4.488 1.04c-3.14.152-5.75-.839-7.05-2.017a.75.75 0 0 1-.05-1.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmbulance: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.159 10.773V4a1 1 0 0 0-1-1H1.702a1 1 0 0 0-1 1v6.626a1 1 0 0 0 1 1h.787m10.809-3.894H9.16\"/><path d=\"M11.638 11.626h.682a1 1 0 0 0 1-1.008l-.024-3.18l-1.392-2.85a1 1 0 0 0-.899-.562h-1.86m-6.643 7.63a1.396 1.396 0 1 0 2.792 0a1.396 1.396 0 1 0-2.792 0\"/><path d=\"M8.839 11.656a1.396 1.396 0 1 0 2.792 0a1.396 1.396 0 1 0-2.792 0M3.431 7H6.43m-1.5-1.499v2.998m3.909 3.127H5.294\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmbulanceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2.25a.375.375 0 0 0-.375.375v7.25c0 .207.168.375.375.375H2q.03 0 .059.003a1.751 1.751 0 0 1 3.024.247h3.333A1.76 1.76 0 0 1 9 9.81V2.626a.375.375 0 0 0-.375-.375zM10 7.625v1.873a1.75 1.75 0 0 1 1.437.752h.938a.375.375 0 0 0 .375-.375v-2.25zM3.499 13c.882 0 1.611-.652 1.733-1.5h3.034a1.751 1.751 0 0 0 3.466 0h.643c.898 0 1.625-.727 1.625-1.625v-2.9a.62.62 0 0 0-.135-.363l-1.141-2.283a1.5 1.5 0 0 0-1.342-.829H10.25v-.875C10.25 1.728 9.522 1 8.625 1h-7C.728 1 0 1.728 0 2.625v7.25c0 .898.728 1.625 1.625 1.625h.14c.123.848.852 1.5 1.734 1.5M2.75 5.537a.75.75 0 0 1 .75-.75h.75V4a.75.75 0 0 1 1.5 0v.787h.75a.75.75 0 1 1 0 1.5h-.75V7a.75.75 0 0 1-1.5 0v-.713H3.5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmbulanceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.353 4.368l1.338 2.74h-3.124V3.526h.438a1.5 1.5 0 0 1 1.348.842M8.16 2.5c.466 0 .883.213 1.158.548v4.685c0 .345.28.625.625.625h3.854v2.081a1.5 1.5 0 0 1-1.5 1.5h-.166v.06a1.896 1.896 0 0 1-3.787.127H5.79a1.896 1.896 0 0 1-3.784 0h-.304a1.5 1.5 0 0 1-1.5-1.5V4a1.5 1.5 0 0 1 1.5-1.5zM4.93 4.75c.345 0 .625.28.625.625v1h1a.625.625 0 1 1 0 1.25h-1v1a.625.625 0 1 1-1.25 0v-1h-1a.625.625 0 0 1 0-1.25h1v-1c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmpersand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.753 13.33c-.846-.725-2.299-1.89-3.837-3.21m0 0C7.467 8.873 5.942 7.49 4.774 6.201m4.142 3.917l-2.749 2.587A2.92 2.92 0 1 1 2.26 8.37l2.514-2.167m4.142 3.917l1.691-1.591M4.774 6.202C3.595 4.9 2.782 3.697 2.782 2.834C2.782.796 4.284.5 5.164.5c1.287 0 2.341.76 2.341 2.334c0 1.05-2.261 2.963-2.261 2.963z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmpersandRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m11.9 13.376l-3.188-3.188m0 0L4.927 6.403m3.785 3.785l-2.376 2.375c-.52.52-1.226.813-1.961.813h-.05a2.725 2.725 0 0 1-1.841-4.734l2.443-2.24m3.785 3.786l2.207-2.207M4.927 6.403L3.292 4.768A2.428 2.428 0 0 1 5.01.624h.09a2.384 2.384 0 0 1 1.611 4.142z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAmpersandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.192 1.758c-.233.158-.498.47-.498 1.236c0 .204.107.556.422 1.069c.21.34.486.715.819 1.114a13 13 0 0 0 .914-.89c.257-.277.497-.566.668-.83q.126-.196.18-.332c.035-.086.038-.127.039-.13q0-.002 0 0c0-.58-.188-.928-.417-1.136c-.24-.22-.608-.359-1.084-.359c-.363 0-.757.065-1.043.258M5.941 6.29a15 15 0 0 0 1.007-.983c.286-.308.59-.668.827-1.034c.219-.337.46-.797.46-1.279c0-.934-.318-1.709-.906-2.244C6.753.225 5.996 0 5.235 0C4.75 0 4 .077 3.35.516c-.7.475-1.157 1.285-1.157 2.478c0 .625.284 1.268.644 1.854c.26.422.588.863.961 1.31l-1.846 1.59a3.557 3.557 0 1 0 4.76 5.285l2.154-2.027a170 170 0 0 0 1.897 1.582c.508.42.945.781 1.28 1.068a.75.75 0 1 0 .976-1.138c-.346-.297-.796-.669-1.304-1.089l-.301-.249c-.45-.372-.94-.779-1.449-1.209l1.016-.956a.75.75 0 0 0-1.028-1.092L8.821 8.989c-1.01-.881-2.02-1.809-2.88-2.7m-1.137.981L2.932 8.884a2.057 2.057 0 1 0 2.753 3.057l2.039-1.919c-1.01-.885-2.036-1.83-2.92-2.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnchor: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 8H1.5a5.5 5.5 0 0 0 11 0H11M7 3.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 0v10m-1.5-7h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnchorRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.125 2.125a.875.875 0 1 1 1.75 0a.875.875 0 0 1-1.75 0m3 0c0 .956-.631 1.765-1.5 2.032V6H8.5a.625.625 0 1 1 0 1.25h-.875v5.46a4.875 4.875 0 0 0 4.21-4.21H11a.625.625 0 1 1 0-1.25h1.5a.625.625 0 0 1 .625.625a6.125 6.125 0 1 1-12.25 0A.625.625 0 0 1 1.5 7.25H3A.625.625 0 1 1 3 8.5h-.835a4.875 4.875 0 0 0 4.21 4.21V7.25H5.5A.625.625 0 1 1 5.5 6h.875V4.157a2.126 2.126 0 1 1 2.75-2.032\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnchorSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.25 2.284a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m3 0a2.25 2.25 0 0 1-1.5 2.122v.872h.75a.75.75 0 0 1 0 1.5h-.75v5.612a4.75 4.75 0 0 0 3.94-3.94H11a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 .75.75a6.25 6.25 0 0 1-12.5 0a.75.75 0 0 1 .75-.75H3a.75.75 0 1 1 0 1.5h-.69a4.75 4.75 0 0 0 3.94 3.94V6.778H5.5a.75.75 0 1 1 0-1.5h.75v-.872a2.25 2.25 0 1 1 3-2.122\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAndroid: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 13.5v-8a4 4 0 0 1 8 0v8M3 11h8\"/><path d=\"M.5 10V8a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v2M11 .5L9.28 2.22M3 .5l1.72 1.72\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAndroidRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.442.183a.625.625 0 0 1 0 .884l-1.23 1.23l.058.058a4.63 4.63 0 0 1 1.354 3.157A2.625 2.625 0 0 1 14 8.125v2a.625.625 0 1 1-1.25 0v-2a1.375 1.375 0 0 0-1.125-1.352v6.602a.625.625 0 1 1-1.25 0v-1.75h-6.75v1.75a.625.625 0 1 1-1.25 0V6.773A1.375 1.375 0 0 0 1.25 8.125v2a.625.625 0 1 1-1.25 0v-2a2.625 2.625 0 0 1 2.376-2.613a4.63 4.63 0 0 1 1.412-3.215l-1.23-1.23a.625.625 0 1 1 .884-.884L4.81 1.551a4.63 4.63 0 0 1 4.38 0L10.558.183a.625.625 0 0 1 .884 0M3.625 6.75v3.625h6.75V6.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAndroidSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.53.241a.75.75 0 1 0-1.06 1.06l1.29 1.292a4.33 4.33 0 0 0-1.07 2.491h8.62a4.33 4.33 0 0 0-1.07-2.49l1.29-1.292a.75.75 0 1 0-1.06-1.06L9.056 1.654a4.33 4.33 0 0 0-4.112 0zm.644 11.167h5.652v1.752a.75.75 0 0 0 1.5 0V7.608a1.15 1.15 0 0 1 1.101 1.15v.9a.75.75 0 1 0 1.5 0v-.9a2.65 2.65 0 0 0-2.65-2.65H2.723a2.65 2.65 0 0 0-2.651 2.65v.9a.75.75 0 1 0 1.5 0v-.9a1.15 1.15 0 0 1 1.1-1.15v5.552a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAngleBracketsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.567 2.942a.625.625 0 1 0-.884-.884l-4.5 4.5a.625.625 0 0 0 0 .884l4.5 4.5a.625.625 0 1 0 .884-.884L1.509 7zm3.75-.884a.625.625 0 1 0-.884.884L12.491 7l-4.058 4.058a.625.625 0 1 0 .884.884l4.5-4.5a.625.625 0 0 0 0-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnnoncementMegaphone: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.182 3.747l3.857 6.681m-.202-.351l-9.51 2.209L.72 11.23L7.386 4.1\"/><path d=\"m3.396 11.805l.524.906a1.421 1.421 0 1 0 2.455-1.432l-.084-.145m1.153-9.297V.583m4.802 6.057H13.5m-12.111 0h1.253m.519-4.283l.886.887m6.793 0l.886-.887\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnnouncementMegaphone: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.182 3.747l3.857 6.681m-.202-.351l-9.51 2.209L.72 11.23l6.667-7.132\"/><path d=\"m3.396 11.805l.524.907a1.421 1.421 0 1 0 2.455-1.433l-.084-.145m1.153-9.297V.583m4.803 6.057H13.5m-12.111 0h1.253m.519-4.283l.886.887m6.793 0l.886-.887\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnnouncementMegaphoneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.759a.75.75 0 0 0-1.5 0V2.05a.75.75 0 1 0 1.5 0zm-.205 2.84a.625.625 0 0 0-1.113.566L.217 10.813a.625.625 0 0 0-.085.74l.597 1.033a.625.625 0 0 0 .683.296l1.575-.366l.28.487l.002.003a2.017 2.017 0 0 0 3.719-1.419l3.289-.763a.625.625 0 0 0 1.046-.682l-.183-.316l-.032-.055l-3.348-5.8l-.032-.055zM3.127 11.2l.056-.013L9.62 9.693L7.083 5.299l-5.637 6.03l.134.23zm1.222 1.176l-.09-.156l1.51-.35a.767.767 0 0 1-1.42.506M11.2 7a.75.75 0 0 1 .75-.75h1.293a.75.75 0 0 1 0 1.5H11.95A.75.75 0 0 1 11.2 7M.76 6.25a.75.75 0 1 0 0 1.5h1.29a.75.75 0 0 0 0-1.5zm1.296-4.194a.75.75 0 0 1 1.06 0l.914.914a.75.75 0 0 1-1.06 1.06l-.914-.913a.75.75 0 0 1 0-1.06m9.889 1.061a.75.75 0 0 0-1.06-1.06l-.914.913a.75.75 0 1 0 1.06 1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnnouncementMegaphoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.933.767a.75.75 0 0 0-1.5 0v.754a.75.75 0 0 0 1.5 0zM6.595 2.928a.75.75 0 0 1 1.024.275l3.858 6.681a.75.75 0 0 1-1.299.75l-.055-.096l-3.092.718a2.171 2.171 0 0 1-3.97 1.664l-.002-.003l-.376-.651l-1.454.337a.5.5 0 0 1-.546-.237l-.609-1.055a.5.5 0 0 1 .068-.591l6.235-6.67l-.057-.097a.75.75 0 0 1 .275-1.025M4.21 11.911l1.357-.315a.671.671 0 0 1-1.21.57zm9.78-5.088a.75.75 0 0 1-.75.75h-.754a.75.75 0 0 1 0-1.5h.753a.75.75 0 0 1 .75.75Zm-12.108.75a.75.75 0 1 0 0-1.5h-.754a.75.75 0 1 0 0 1.5zm2.182-3.868a.75.75 0 0 1-1.06 0l-.634-.634a.75.75 0 1 1 1.06-1.06l.635.633a.75.75 0 0 1 0 1.061Zm7.932-.634a.75.75 0 0 0-1.06-1.06l-.642.64a.75.75 0 1 0 1.061 1.061z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAppStore: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.805 12.584a.977.977 0 0 0 1.791.247l.21-.36m3.112-3.035H5.566l1.444-2.49l1.938-3.342a.977.977 0 0 0-1.69-.98l-.248.427l-.247-.427a.977.977 0 1 0-1.69.98l.808 1.394l-2.574 4.438H1.602a.977.977 0 1 0 0 1.954H7.75\"/><path d=\"m8.939 6.324l1.775 3.113h1.556a.977.977 0 0 1 0 1.954h-.423l.268.462a.977.977 0 1 1-1.69.98L7.939 8.574\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAppStoreRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.002.95a1.806 1.806 0 0 1 2.935 2.078l-.542-.313l.542.313l-.85 1.472l1.627 2.82h1.484a1.806 1.806 0 0 1 .552 3.525l.073.127a1.805 1.805 0 1 1-3.127 1.806L8.629 10.93H5.374l-.645 1.116l-.421.73a1.806 1.806 0 1 1-3.128-1.805l.074-.127a1.806 1.806 0 0 1 .552-3.525h1.483L4.917 4.5l-.85-1.472A1.806 1.806 0 0 1 7.002.95m.721 5.911l.642-1.11l1.447 2.506a.63.63 0 0 0 .541.313h1.845a.556.556 0 1 1 0 1.11h-.481a.625.625 0 0 0-.542.938l.565.98a.556.556 0 0 1-.962.555zM6.376 8.57h.89l.642 1.11H1.806a.556.556 0 1 1 0-1.11H3.65c.223 0 .43-.12.541-.313L6.18 4.813a.63.63 0 0 0 0-.625L5.15 2.403a.556.556 0 1 1 .961-.556l.35.605a.625.625 0 0 0 1.082 0l.349-.605a.556.556 0 1 1 .962.556l-3.02 5.23a.625.625 0 0 0 .542.937m-2.445 2.36H2.648l-.385.667a.556.556 0 0 0 .962.556l.422-.73z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAppStoreSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.853 1.298a1.054 1.054 0 0 0-1.44.383l-.268.46l-.267-.46a1.054 1.054 0 1 0-1.825 1.058l.873 1.505l-2.778 4.79h-1.84a1.054 1.054 0 0 0 0 2.108h7.32l-1.22-2.108H5.586l1.559-2.689L9.236 2.74a1.054 1.054 0 0 0-.383-1.441M1.738 13.647a1.08 1.08 0 0 0 1.474-.397l.594-1.03h-2.49a1.08 1.08 0 0 0 .422 1.427m9.351-.397L7.751 7.452l1.243-2.138l2.159 3.72h1.669a1.054 1.054 0 1 1 0 2.11h-.455l.593 1.029a1.08 1.08 0 1 1-1.87 1.077\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineApple: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.182 7.49a2.49 2.49 0 0 1 1.737-2.366a2.906 2.906 0 0 0-4.214-.999a1 1 0 0 1-.999 0a3.086 3.086 0 0 0-4.404 1.208a5.12 5.12 0 0 0-.54 3.356A7.24 7.24 0 0 0 3.7 12.893a2.09 2.09 0 0 0 2.697.15a1.32 1.32 0 0 1 1.568 0a2.06 2.06 0 0 0 2.656-.06a6.57 6.57 0 0 0 1.698-2.996a2.476 2.476 0 0 1-2.137-2.497M8.184 1.998L9.682.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAppleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.8 1.494A.875.875 0 1 0 8.564.256L7.315 1.504a.875.875 0 0 0 1.238 1.238zm.306 2.092a3.34 3.34 0 0 0-2.65.49a.31.31 0 0 1-.286-.004a3.51 3.51 0 0 0-4.99 1.375a5.4 5.4 0 0 0-.57 3.517a7.4 7.4 0 0 0 2 4.295c.42.399.992.702 1.63.737s1.235-.202 1.695-.55a.61.61 0 0 1 .712-.004a2.55 2.55 0 0 0 3.307-.112a6.77 6.77 0 0 0 1.749-3.086a.625.625 0 0 0-.52-.774a1.69 1.69 0 0 1-1.459-1.704v-.01a1.7 1.7 0 0 1 1.188-1.618a.625.625 0 0 0 .36-.894a3.34 3.34 0 0 0-2.166-1.658m-1.16 1.197a2.1 2.1 0 0 1 1.825.533a2.95 2.95 0 0 0-1.297 2.433a2.94 2.94 0 0 0 1.833 2.77a5.5 5.5 0 0 1-1.226 1.915a1.3 1.3 0 0 1-1.683.01a1.86 1.86 0 0 0-2.209 0l-.006.003c-.276.21-.59.317-.874.302c-.28-.016-.579-.154-.827-.386a6.14 6.14 0 0 1-1.638-3.599a4.16 4.16 0 0 1 .438-2.728l.008-.015a2.26 2.26 0 0 1 3.248-.871a1.56 1.56 0 0 0 1.602-.03c.241-.168.516-.283.805-.338\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAppleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.147 1.337a.75.75 0 1 0-1.06-1.06l-1.5 1.5a.75.75 0 1 0 1.06 1.06zM8.609 3.761a3.21 3.21 0 0 1 3.423 1.623a.5.5 0 0 1-.289.716a1.82 1.82 0 0 0-1.273 1.733v.008a1.813 1.813 0 0 0 1.564 1.827a.5.5 0 0 1 .416.62a6.63 6.63 0 0 1-1.738 3.047a2.42 2.42 0 0 1-3.116.078a.73.73 0 0 0-.86.004a2.45 2.45 0 0 1-3.18-.197a7.26 7.26 0 0 1-1.94-4.198a5.28 5.28 0 0 1 .556-3.436a3.38 3.38 0 0 1 4.81-1.325a.43.43 0 0 0 .412.004a3.2 3.2 0 0 1 1.215-.504\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineApplicationAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 .5H1.5a1 1 0 0 0-1 1V5a1 1 0 0 0 1 1H5a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1M12.5 8H9a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1M5 8H1.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1H5a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1m5.75-2V.5M8 3.25h5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineApplicationAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 1.784c0-.157.127-.284.284-.284h3.182c.157 0 .284.127.284.284v3.182a.284.284 0 0 1-.284.284H1.784a.284.284 0 0 1-.284-.284zM1.784.25C.937.25.25.937.25 1.784v3.182C.25 5.813.937 6.5 1.784 6.5h3.182c.847 0 1.534-.687 1.534-1.534V1.784C6.5.937 5.813.25 4.966.25zM8.75 9.034c0-.157.127-.284.284-.284h3.182c.157 0 .284.127.284.284v3.182a.284.284 0 0 1-.284.284H9.034a.284.284 0 0 1-.284-.284zM9.034 7.5c-.847 0-1.534.687-1.534 1.534v3.182c0 .847.687 1.534 1.534 1.534h3.182c.847 0 1.534-.687 1.534-1.534V9.034c0-.847-.687-1.534-1.534-1.534zM.25 9.034C.25 8.187.937 7.5 1.784 7.5h3.182c.847 0 1.534.687 1.534 1.534v3.182c0 .847-.687 1.534-1.534 1.534H1.784A1.534 1.534 0 0 1 .25 12.216zM10.625.25a.75.75 0 0 1 .75.75v1.625H13a.75.75 0 0 1 0 1.5h-1.625V5.75a.75.75 0 0 1-1.5 0V4.125H8.25a.75.75 0 0 1 0-1.5h1.625V1a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineApplicationAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.077 0h3.77c.594 0 1.076.482 1.076 1.077v3.77c0 .594-.482 1.076-1.077 1.076h-3.77A1.077 1.077 0 0 1 0 4.846v-3.77C0 .483.482 0 1.077 0m8.077 8.077h3.77c.594 0 1.076.482 1.076 1.077v3.77c0 .594-.482 1.076-1.077 1.076h-3.77a1.077 1.077 0 0 1-1.076-1.077v-3.77c0-.594.482-1.076 1.077-1.076m-4.308 0h-3.77C.483 8.077 0 8.559 0 9.154v3.77C0 13.517.482 14 1.077 14h3.77c.594 0 1.076-.482 1.076-1.077v-3.77c0-.594-.482-1.076-1.077-1.076M10.761 0a.75.75 0 0 1 .75.75v1.733h1.732a.75.75 0 1 1 0 1.5h-1.732v1.732a.75.75 0 1 1-1.5 0V3.983H8.278a.75.75 0 0 1 0-1.5h1.733V.75a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArchiveBox: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 5h11v7a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1zm12-1V2a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1m-8 4h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArchiveBoxRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.125.875C.504.875 0 1.379 0 2v2c0 .58.438 1.056 1 1.118V11.5c0 .898.728 1.625 1.625 1.625h8.75c.898 0 1.625-.727 1.625-1.625V5.118c.563-.062 1-.539 1-1.118V2c0-.621-.504-1.125-1.125-1.125zM2.25 11.5V5.125h9.5V11.5a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375M5.5 6.875a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArchiveBoxSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 2A1.5 1.5 0 0 1 1.5.5h11A1.5 1.5 0 0 1 14 2v1.5A1.5 1.5 0 0 1 12.5 5h-11A1.5 1.5 0 0 1 0 3.5zm13 4.25H1V12a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 13 12zM5.5 7.875a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowBendLeftDown2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.5 10.5l3 3l3-3\"/><path d=\"M11.5.5h-2a4 4 0 0 0-4 4v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowBendLeftDown2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 4a2 2 0 0 1 2-2H11a1 1 0 1 0 0-2H8.5a4 4 0 0 0-4 4v6h-2a.5.5 0 0 0-.354.854l3 3a.5.5 0 0 0 .708 0l3-3A.5.5 0 0 0 8.5 10h-2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowBendRightDown2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5 10.5l-3 3l-3-3\"/><path d=\"M2.5.5h2a4 4 0 0 1 4 4v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowBendRightDown2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 0a1 1 0 0 0 0 2h2.5a2 2 0 0 1 2 2v6h-2a.5.5 0 0 0-.354.854l3 3a.5.5 0 0 0 .708 0l3-3A.5.5 0 0 0 11.5 10h-2V4a4 4 0 0 0-4-4z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverDown: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13m0-4v4h-4M5 9L.5 13.5m0-4v4h4M9 5L13.5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverDownSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.707.293A1 1 0 0 0 .293 1.707l10.146 10.147l-1.293 1.292A.5.5 0 0 0 9.5 14h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.854-.354l-1.292 1.293zM.31 9.038a.5.5 0 0 1 .545.108l1.292 1.293l1.647-1.646a1 1 0 0 1 1.414 1.414l-1.646 1.647l1.293 1.292A.5.5 0 0 1 4.5 14h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .309-.462m13.398-7.33A1 1 0 0 0 12.293.292l-3.5 3.5a1 1 0 0 0 1.414 1.414z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5.5l-13 13m4 0h-4v-4M5 5L.5.5m4 0h-4v4M9 9l4.5 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverLeftSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.707 1.707L3.561 11.854l1.293 1.292A.5.5 0 0 1 4.5 14h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .854-.354l1.292 1.293L12.293.293a1 1 0 1 1 1.414 1.414M8.793 8.793a1 1 0 0 1 1.414 0l3.5 3.5a1 1 0 0 1-1.414 1.414l-3.5-3.5a1 1 0 0 1 0-1.414M0 1v3.5a.5.5 0 0 0 .854.354L2.146 3.56l1.647 1.646a1 1 0 0 0 1.414-1.414L3.561 2.146L4.854.854A.5.5 0 0 0 4.5 0h-4a.5.5 0 0 0-.5.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13m-4 0h4v4M9 9l4.5 4.5m-4 0h4v-4M5 5L.5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverRightSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13 0H9.5a.5.5 0 0 0-.354.854l1.293 1.292L.293 12.293a1 1 0 1 0 1.414 1.414L11.854 3.561l1.292 1.293A.5.5 0 0 0 14 4.5v-4a.5.5 0 0 0-.5-.5zM.293.293a1 1 0 0 1 1.414 0l3.5 3.5a1 1 0 0 1-1.414 1.414l-3.5-3.5a1 1 0 0 1 0-1.414M14 9.5a.5.5 0 0 0-.854-.354l-1.292 1.293l-1.647-1.646a1 1 0 0 0-1.414 1.414l1.646 1.647l-1.293 1.292A.5.5 0 0 0 9.5 14h4a.5.5 0 0 0 .5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverUp: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5L.5.5m0 4v-4h4M9 5L13.5.5m0 4v-4h-4M5 9L.5 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCrossoverUpSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.5 0h-4a.5.5 0 0 0-.354.854l1.293 1.292l-1.646 1.647a1 1 0 0 0 1.414 1.414l1.647-1.646l1.292 1.293A.5.5 0 0 0 14 4.5v-4a.5.5 0 0 0-.5-.5M0 1V.5A.5.5 0 0 1 .5 0h4a.5.5 0 0 1 .354.854L3.56 2.146l10.146 10.147a1 1 0 0 1-1.414 1.414L2.146 3.561L.854 4.854A.5.5 0 0 1 0 4.5zm5.207 9.207a1 1 0 0 0-1.414-1.414l-3.5 3.5a1 1 0 1 0 1.414 1.414z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCursor1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 10.5l-4-4l2-2a1.001 1.001 0 0 0-.5-1.68L1.74.53A1 1 0 0 0 .53 1.74L2.82 11a1 1 0 0 0 1.68.46l2-2l4 4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCursor1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m13 10l-3 3l-4-4l-1.916 1.916a1 1 0 0 1-1.689-.52L.777 1.948a1 1 0 0 1 1.17-1.17l8.45 1.618a1 1 0 0 1 .519 1.69L9 6z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCursor1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.858.043A1.5 1.5 0 0 0 .043 1.858v.001l2.29 9.26l.001.002a1.5 1.5 0 0 0 2.52.69L6.5 10.166l3.646 3.646a.5.5 0 0 0 .705.003l3-2.96a.5.5 0 0 0 .003-.71L10.206 6.5l1.647-1.646l.002-.003a1.5 1.5 0 0 0-.742-2.518L1.859.044\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCursor2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.006 5.428c.156-.065.256-.094.35-.186a.494.494 0 0 0 0-.7c-.094-.092-.125-.147-.35-.214C12.78 4.262 1.809.554 1.809.554A.99.99 0 0 0 .553 1.809S4.35 12.856 4.396 13.006s.106.257.199.35a.495.495 0 0 0 .7 0c.092-.093.113-.146.183-.35l1.94-5.594s5.431-1.919 5.588-1.984\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCursor2Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M12.753 4.67L1.83 1.106a.564.564 0 0 0-.704.732l4.04 10.932a.35.35 0 0 0 .663-.015l1.53-4.81a1 1 0 0 1 .575-.623l4.845-1.982a.358.358 0 0 0-.025-.672\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCursor2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.972.08H1.97A1.49 1.49 0 0 0 .08 1.97l.473-.162l-.473.163l.001.002l.002.006l.008.024l.032.092l.12.35L.675 3.7l3.07 8.944l.128.373l.035.104l.01.03a.995.995 0 0 0 1.73.56a1 1 0 0 0 .193-.26c.045-.088.078-.187.11-.279l.001-.004l.995-2.87l.65-1.876l.213-.613l.002-.005l.007-.002l.617-.218l1.885-.667a323 323 0 0 0 2.878-1.027l.046-.018c.11-.043.307-.118.465-.276a.994.994 0 0 0 0-1.406l-.01-.01a1.3 1.3 0 0 0-.182-.164a1.2 1.2 0 0 0-.373-.169h-.002l-.035-.012L13 3.8l-.382-.127l-1.298-.436A5548 5548 0 0 1 3.687.66L2.441.24L2.093.12L2 .091l-.023-.01z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCurvyUpDown1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 11L3 13.5v-11a2 2 0 1 1 4 0v9a2 2 0 0 0 4 0V.5L13.5 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCurvyUpDown1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.058.227a.996.996 0 0 1 1.249-.016a1 1 0 0 1 .092.082L13.707 2.6A1 1 0 0 1 13 4.308h-1.308v6.846a2.847 2.847 0 0 1-5.692 0V2.846a.846.846 0 0 0-1.692 0V13a1 1 0 0 1-1.707.707L.293 11.4A1 1 0 0 1 1 9.692h1.308V2.846a2.846 2.846 0 0 1 5.692 0v8.308a.846.846 0 1 0 1.692 0V1a1 1 0 0 1 .366-.773\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCurvyUpDown2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.385 2.958v8.084a2.193 2.193 0 0 1-4.385 0V2.958a2.192 2.192 0 1 0-4.385 0v8.084\"/><path d=\"m9.385 4.868l2-2l2 2M4.615 9.07l-2 2l-2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowCurvyUpDown2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.808 1.515c-.797 0-1.443.646-1.443 1.443V8.57h1.25a.5.5 0 0 1 .354.854l-1.604 1.603v.015H3.35l-.381.382a.5.5 0 0 1-.708 0l-.38-.382h-.016v-.015L.261 9.424a.5.5 0 0 1 .354-.854h1.25V2.958a2.942 2.942 0 0 1 5.885 0v8.084a1.442 1.442 0 0 0 2.885 0V5.368h-1.25a.5.5 0 0 1-.354-.854l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.354.854h-1.25v5.674a2.942 2.942 0 1 1-5.885 0V2.958c0-.797-.646-1.443-1.442-1.443\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowDown2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4 6.5l3 3l3-3m-3-6v9m-3.5 4h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowDown2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 1a1 1 0 0 0-2 0v5H4a.5.5 0 0 0-.354.854l3 3a.5.5 0 0 0 .708 0l3-3A.5.5 0 0 0 10 6H8zM4 12a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowDownDashedSquare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.705 13.394a3 3 0 0 1-2.07-2m10.66 2a3 3 0 0 0 2.07-2M6 13.5h2m0-13H6M.5 6v2m13-2v2M2.705.606a3 3 0 0 0-2.07 2m10.66-2a3 3 0 0 1 2.07 2M7 4v6M5 8l2 2l2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowDownDashedSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.961 12.5H6.038a.75.75 0 0 0 0 1.5h1.923a.75.75 0 0 0 0-1.5M5.288.75c0 .414.336.75.75.75h1.923a.75.75 0 1 0 0-1.5H6.038a.75.75 0 0 0-.75.75m5.644 11.674a.75.75 0 0 0 .396 1.447a3.64 3.64 0 0 0 2.508-2.424a.75.75 0 1 0-1.432-.446a2.14 2.14 0 0 1-1.472 1.423m-7.863 0a.75.75 0 1 1-.397 1.447a3.64 3.64 0 0 1-2.508-2.424a.75.75 0 0 1 1.432-.446a2.14 2.14 0 0 0 1.473 1.423m-1.57-4.462a.75.75 0 0 1-1.5 0V6.038a.75.75 0 0 1 1.5 0zm11.751.75a.75.75 0 0 1-.75-.75V6.038a.75.75 0 0 1 1.5 0v1.924a.75.75 0 0 1-.75.75M1.596 2.999a.75.75 0 1 1-1.432-.446A3.64 3.64 0 0 1 2.672.129a.75.75 0 1 1 .397 1.447a2.14 2.14 0 0 0-1.473 1.423m11.747.493a.75.75 0 0 1-.939-.493a2.14 2.14 0 0 0-1.472-1.423a.75.75 0 1 1 .396-1.447a3.64 3.64 0 0 1 2.508 2.424a.75.75 0 0 1-.493.939M7.75 4a.75.75 0 0 0-1.5 0v3.5H5a.5.5 0 0 0-.354.854l2 2a.5.5 0 0 0 .708 0l2-2A.5.5 0 0 0 9 7.5H7.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowExpand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m8.5 5.5l5-5m-4 0h4v4m-8 1l-5-5m4 0h-4v4m8 4l5 5m-4 0h4v-4m-8-1l-5 5m4 0h-4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowExpandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1v3.5a.5.5 0 0 0 .854.354L2.146 3.56l2.147 2.146a1 1 0 0 0 1.414-1.414L3.561 2.146L4.854.854A.5.5 0 0 0 4.5 0h-4a.5.5 0 0 0-.5.5zm5.707 8.707a1 1 0 0 0-1.414-1.414l-2.147 2.146L.854 9.146A.5.5 0 0 0 0 9.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .354-.854L3.56 11.854l2.146-2.147Zm2.586-1.414a1 1 0 0 1 1.414 0l2.147 2.146l1.292-1.293A.5.5 0 0 1 14 9.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.354-.854l1.293-1.292l-2.146-2.147a1 1 0 0 1 0-1.414M9.5 0a.5.5 0 0 0-.354.854l1.293 1.292l-2.146 2.147a1 1 0 0 0 1.414 1.414l2.147-2.146l1.292 1.293A.5.5 0 0 0 14 4.5v-4a.5.5 0 0 0-.5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowInfiniteLoop: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 10.43a2.37 2.37 0 0 1-1.5.57A2.75 2.75 0 0 1 .65 9.192C.511 8.811.5 8 .5 8s.012-.81.15-1.192A2.75 2.75 0 0 1 3.5 5c2.75 0 4.25 6 7 6a2.75 2.75 0 0 0 2.85-1.808C13.489 8.811 13.5 8 13.5 8s-.012-.81-.15-1.192A2.75 2.75 0 0 0 10.5 5h-2l2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowInfiniteLoopSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.109 3.155a.75.75 0 0 0-1.28-.53L7.915 4.538a.75.75 0 0 0-.104.946a.75.75 0 0 0 .629.34h1.916l.017.001a6 6 0 0 1 .36.02c.243.02.438.05.517.079a1.89 1.89 0 0 1 1.241 1.958a1 1 0 0 0 0 .143a1.89 1.89 0 0 1-2.06 2.061l-.072-.003c-.37 0-.774-.2-1.265-.684S8.132 8.255 7.612 7.52l-.022-.032c-.494-.696-1.036-1.461-1.63-2.048c-.596-.587-1.35-1.102-2.282-1.115A3.39 3.39 0 0 0 .009 7.954a3.39 3.39 0 0 0 3.675 3.628a3.03 3.03 0 0 0 1.885-.727a.75.75 0 1 0-.976-1.139c-.27.23-.61.36-.965.367l-.058.003a1.89 1.89 0 0 1-2.061-2.06a1 1 0 0 0 0-.144a1.89 1.89 0 0 1 2.06-2.06l.072.003c.37 0 .774.199 1.265.683s.962 1.145 1.482 1.88l.022.03c.494.698 1.036 1.462 1.63 2.049c.596.587 1.35 1.102 2.282 1.115a3.39 3.39 0 0 0 3.669-3.628a3.39 3.39 0 0 0-2.234-3.442a3 3 0 0 0-.648-.137z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowMove: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5 2.5l2-2l2 2m-4 9l2 2l2-2M7 .5v13M11.5 5l2 2l-2 2m-9-4l-2 2l2 2m11-2H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowMoveSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.761 7.549a.75.75 0 0 0 0-1.057l-1.994-1.995a.75.75 0 0 0-.778-.16a.74.74 0 0 0-.499.689v.997a.25.25 0 0 1-.249.25H7.997a.25.25 0 0 1-.25-.25V3.779a.25.25 0 0 1 .25-.25h.997a.74.74 0 0 0 .689-.498a.75.75 0 0 0-.16-.818L7.529.22a.75.75 0 0 0-1.058 0L4.477 2.213a.75.75 0 0 0-.16.818a.74.74 0 0 0 .688.499h.998a.25.25 0 0 1 .249.25v2.243a.25.25 0 0 1-.25.25H3.76a.25.25 0 0 1-.25-.25v-.997a.748.748 0 0 0-1.276-.529L.24 6.492a.75.75 0 0 0 0 1.057l1.994 1.994c.141.139.33.217.529.22a.8.8 0 0 0 .249-.06a.74.74 0 0 0 .499-.688v-.998a.25.25 0 0 1 .249-.249h2.244a.25.25 0 0 1 .249.25v2.243a.25.25 0 0 1-.25.25h-.997a.74.74 0 0 0-.688.458a.75.75 0 0 0 .16.818l1.994 1.994a.75.75 0 0 0 1.058 0l1.994-1.994a.75.75 0 0 0 .16-.778a.74.74 0 0 0-.689-.498h-.997a.25.25 0 0 1-.25-.25V8.017a.25.25 0 0 1 .25-.249h2.244a.25.25 0 0 1 .25.25v.997a.74.74 0 0 0 .458.688q.138.06.29.06a.77.77 0 0 0 .528-.22z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadHorizontal1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 .5L11.5 3L9 5.5\"/><path d=\"M.5 6V4a1 1 0 0 1 1-1h10M5 13.5L2.5 11L5 8.5\"/><path d=\"M13.5 8v2a1 1 0 0 1-1 1h-10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadHorizontal1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.354.146A.5.5 0 0 0 8.5.5V2h-6A2.5 2.5 0 0 0 0 4.5V6a1 1 0 0 0 2 0V4.5a.5.5 0 0 1 .5-.5h6v1.5a.5.5 0 0 0 .854.354l2.5-2.5a.5.5 0 0 0 0-.708zM5.19 8.038a.5.5 0 0 1 .31.462V10h6a.5.5 0 0 0 .5-.5V8a1 1 0 1 1 2 0v1.5a2.5 2.5 0 0 1-2.5 2.5h-6v1.5a.5.5 0 0 1-.854.354l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .545-.108\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadHorizontal2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.25 8.5L7 10.75L9.25 13m-4.5-7.5L7 3.25L4.75 1\"/><path d=\"M7 10.75h4.5a2 2 0 0 0 2-2v-3.5a2 2 0 0 0-2-2H10m-3 0H2.5a2 2 0 0 0-2 2v3.5a2 2 0 0 0 2 2H4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadHorizontal2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 5.543V4.25H3a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h1a1 1 0 1 1 0 2H3a3 3 0 0 1-3-3v-3.5a3 3 0 0 1 3-3h1V.957a.5.5 0 0 1 .854-.353l2.292 2.292a.5.5 0 0 1 0 .708L4.854 5.896A.5.5 0 0 1 4 5.543m6 6.207v1.293a.5.5 0 0 1-.854.354l-2.292-2.293a.5.5 0 0 1 0-.708l2.292-2.292a.5.5 0 0 1 .854.353V9.75h1a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1h-1a1 1 0 1 1 0-2h1a3 3 0 0 1 3 3v3.5a3 3 0 0 1-3 3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadVertical1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 5L3 2.5L5.5 5\"/><path d=\"M6 13.5H4a1 1 0 0 1-1-1v-10M13.5 9L11 11.5L8.5 9\"/><path d=\"M8 .5h2a1 1 0 0 1 1 1v10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadVertical1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0a1 1 0 0 0 0 2h1.5a.5.5 0 0 1 .5.5v6H8.5a.5.5 0 0 0-.354.854l2.5 2.5a.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 13.5 8.5H12v-6A2.5 2.5 0 0 0 9.5 0zM3.354 2.146a.5.5 0 0 0-.708 0l-2.5 2.5A.5.5 0 0 0 .5 5.5H2v6A2.5 2.5 0 0 0 4.5 14H6a1 1 0 1 0 0-2H4.5a.5.5 0 0 1-.5-.5v-6h1.5a.5.5 0 0 0 .354-.854z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadVertical2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 9.25L3.25 7L1 9.25m7.5-4.5L10.75 7L13 4.75\"/><path d=\"M3.25 7v4.5a2 2 0 0 0 2 2h3.5a2 2 0 0 0 2-2V10m0-3V2.5a2 2 0 0 0-2-2h-3.5a2 2 0 0 0-2 2V4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowReloadVertical2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.457 4H9.75V3a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1v1a1 1 0 0 1-2 0V3a3 3 0 0 1 3-3h3.5a3 3 0 0 1 3 3v1h1.293a.5.5 0 0 1 .353.854l-2.293 2.292a.5.5 0 0 1-.707 0L8.104 4.854A.5.5 0 0 1 8.457 4M2.25 10H.957a.5.5 0 0 1-.353-.854l2.292-2.292a.5.5 0 0 1 .708 0l2.292 2.292a.5.5 0 0 1-.353.854H4.25v1a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-1a1 1 0 1 1 2 0v1a3 3 0 0 1-3 3h-3.5a3 3 0 0 1-3-3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowRoadmap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 11.643h6.5m-1.857-1.857l1.857 1.857l-1.857 1.857M3.286 1.893a1.393 1.393 0 1 0 2.786 0a1.393 1.393 0 1 0-2.786 0M7 6.536a1.393 1.393 0 1 0 2.786 0a1.393 1.393 0 1 0-2.786 0m-2.786 5.107a1.393 1.393 0 1 0 2.786 0a1.393 1.393 0 1 0-2.786 0\"/><path d=\"M7 6.536H3.054a2.554 2.554 0 0 0 0 5.107h1.16m5.572-5.107h1.393a2.321 2.321 0 0 0 0-4.643H6.07m-2.784 0H.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowRoadmapSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.233 3a2 2 0 0 1-3.465 0H1a1 1 0 0 1 0-2h1.768a2 2 0 0 1 3.465 0h4.517a3.25 3.25 0 0 1 0 6.5h-.517a2 2 0 0 1-3.466 0H3.5a1.5 1.5 0 1 0 0 3h.268a2 2 0 0 1 3.464 0H11v-1a.5.5 0 0 1 .854-.354l2 2a.5.5 0 0 1 0 .707l-2 2A.5.5 0 0 1 11 13.5v-1H7.233a2 2 0 0 1-3.466 0H3.5a3.5 3.5 0 1 1 0-7h3.268a2 2 0 0 1 3.464 0h.518a1.25 1.25 0 1 0 0-2.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowRoundLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.75.5L2.25 3l2.5 2.5\"/><path d=\"M1.75 8.25A5.25 5.25 0 1 0 7 3H2.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowRoundLeftSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.351 1.002a.75.75 0 0 0-1.28-.53l-2.4 2.4a.75.75 0 0 0 0 1.06l2.4 2.399a.75.75 0 0 0 1.28-.53V4.4H7a3.798 3.798 0 1 1-3.798 3.8a1 1 0 1 0-2 0A5.798 5.798 0 1 0 7 2.401H5.351z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowRoundRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9.25.5l2.5 2.5l-2.5 2.5\"/><path d=\"M12.25 8.25A5.25 5.25 0 1 1 7 3h4.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowRoundRightSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.65 1.002a.75.75 0 0 1 1.28-.53l2.398 2.4a.75.75 0 0 1 0 1.06L9.93 6.33a.75.75 0 0 1-1.28-.53V4.4H7a3.798 3.798 0 1 0 3.798 3.8a1 1 0 1 1 2 0A5.798 5.798 0 1 1 7 2.401h1.649z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowShrink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l4-4M1 9.5h3.5V13m9 .5l-4-4m3.5 0H9.5V13M.5.5l4 4M1 4.5h3.5V1m9-.5l-4 4m3.5 0H9.5V1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowShrinkDiagonal1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l5-5m-4 0h4v4m8-12l-5 5m4 0h-4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowShrinkDiagonal1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.707 1.707A1 1 0 0 0 12.293.293l-2.147 2.146l-1.292-1.293A.5.5 0 0 0 8 1.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .354-.854L11.56 3.854zm-8.56 11.147L3.853 11.56l-2.147 2.146a1 1 0 0 1-1.414-1.414l2.146-2.147l-1.293-1.292A.5.5 0 0 1 1.5 8h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.854.354\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowShrinkDiagonal2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 13.5l-5-5m4 0h-4v4M.5.5l5 5m-4 0h4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowShrinkDiagonal2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.707.293A1 1 0 0 0 .293 1.707l2.146 2.147l-1.293 1.292A.5.5 0 0 0 1.5 6h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.854-.354L3.854 2.44zm11.147 8.56l-1.293 1.293l2.146 2.147a1 1 0 0 1-1.414 1.414l-2.147-2.146l-1.292 1.293A.5.5 0 0 1 8 12.5v-4a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .354.854\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowShrinkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.293.293a1 1 0 0 1 1.414 0l1.397 1.396L4.146.646A.5.5 0 0 1 5 1v3.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.354-.854L1.69 3.104L.293 1.707a1 1 0 0 1 0-1.414m9.016.245a.5.5 0 0 1 .545.108l1.043 1.043L12.293.293a1 1 0 1 1 1.414 1.414l-1.396 1.397l1.043 1.042A.5.5 0 0 1 13 5H9.5a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 .309-.462M1 9a.5.5 0 0 0-.354.854l1.043 1.043l-1.396 1.396a1 1 0 1 0 1.414 1.414l1.397-1.396l1.042 1.043A.5.5 0 0 0 5 13V9.5a.5.5 0 0 0-.5-.5zm8 .5a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 .354.854l-1.043 1.043l1.396 1.396a1 1 0 0 1-1.414 1.414l-1.397-1.396l-1.042 1.043A.5.5 0 0 1 9 13z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowTransferDiagonal1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 10.5l10-10H6m7.5 3l-10 10H8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowTransferDiagonal1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.998 1.068a1 1 0 0 1-.29.64l-2 2l-7 7A1 1 0 0 1 .292 9.292L6.586 3L5.293 1.707A1 1 0 0 1 6 0h4a1 1 0 0 1 .674.261M7.414 11l6.293-6.293a1 1 0 0 0-1.414-1.414l-7 7l-2 2a.996.996 0 0 0-.05 1.36q.038.045.083.086A1 1 0 0 0 4 14h4a1 1 0 0 0 .707-1.707z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowTransferDiagonal2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 10.5L3.5.5H8m-7.5 3l10 10H6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowTransferDiagonal2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0a1 1 0 0 1 .707 1.707L7.406 3.008l6.3 6.284a1 1 0 0 1-1.412 1.416L3.278 1.716a1 1 0 0 1 .28-1.613A1 1 0 0 1 4 0zM6.586 11L.293 4.707a1 1 0 0 1 1.414-1.414l7 7l2 2a.996.996 0 0 1 .05 1.36A1 1 0 0 1 10 14H6.001a1 1 0 0 1-.707-1.707z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowTransferDiagonal3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.5 8.5l8-8m0 3.5V.5H6m6.5 5l-8 8m0-3.5v3.5H8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowTransferDiagonal3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 0h3.5a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.854.354L8.104 3.31L2.207 9.207A1 1 0 0 1 .793 7.793l5.896-5.897L5.646.854A.5.5 0 0 1 6 0m7.207 6.207a1 1 0 0 0-1.414-1.414l-5.897 5.896l-1.042-1.043A.5.5 0 0 0 4 10v3.5a.5.5 0 0 0 .5.5H8a.5.5 0 0 0 .354-.854L7.31 12.104z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowUp1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5V.5M10.5 4L7 .5L3.5 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowUp1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.646.146a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1-.354.854H8V13a1 1 0 1 1-2 0V4.5H3.5a.5.5 0 0 1-.354-.854z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowUpDashedSquare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.705.606a3 3 0 0 0-2.07 2m10.66-2a3 3 0 0 1 2.07 2M6 .5h2m0 13H6M.5 8V6m13 2V6M2.705 13.394a3 3 0 0 1-2.07-2m10.66 2a3 3 0 0 0 2.07-2M7 10V4M5 6l2-2l2 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArrowUpDashedSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.961 1.5H6.038a.75.75 0 1 1 0-1.5h1.923a.75.75 0 1 1 0 1.5M5.288 13.25a.75.75 0 0 1 .75-.75h1.923a.75.75 0 0 1 0 1.5H6.038a.75.75 0 0 1-.75-.75m5.643-11.674a.75.75 0 1 1 .397-1.447a3.64 3.64 0 0 1 2.508 2.424a.75.75 0 1 1-1.432.446a2.14 2.14 0 0 0-1.472-1.423m-7.862 0A.75.75 0 0 0 2.672.129A3.64 3.64 0 0 0 .164 2.553a.75.75 0 1 0 1.432.446a2.14 2.14 0 0 1 1.473-1.423m-1.57 4.462a.75.75 0 0 0-1.5 0v1.924a.75.75 0 0 0 1.5 0zm11.751-.75a.75.75 0 0 0-.75.75v1.924a.75.75 0 0 0 1.5 0V6.038a.75.75 0 0 0-.75-.75M1.596 11.001a.75.75 0 0 0-1.432.446a3.64 3.64 0 0 0 2.508 2.424a.75.75 0 1 0 .397-1.447a2.14 2.14 0 0 1-1.473-1.423m11.747-.493a.75.75 0 0 0-.939.493a2.14 2.14 0 0 1-1.472 1.423a.75.75 0 0 0 .396 1.447a3.64 3.64 0 0 0 2.508-2.424a.75.75 0 0 0-.493-.939M7.75 10a.75.75 0 0 1-1.5 0V6.5H5a.5.5 0 0 1-.354-.854l2-2a.5.5 0 0 1 .708 0l2 2A.5.5 0 0 1 9 6.5H7.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArtificialIntelligenceSpark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 6.433v3.97a2.724 2.724 0 1 1-5.439-.229C.994 9.565.636 8.374.636 7.38c0-1.354.665-2.671 1.617-3.19a2.38 2.38 0 0 1 3.902-2.076\"/><path d=\"M3.511 5.809c-.35-.08-1.141-.6-1.26-1.612m.039 4.549c-.356.281-.64.917-.731 1.427m5.441.23a2.724 2.724 0 1 0 5.439-.229c.567-.609.924-1.8.924-2.794c0-.434-.068-.864-.192-1.265\"/><path d=\"M11.71 8.746c.356.281.64.917.731 1.427M7.064 4.307c-.35-.062-.35-.565 0-.626a3.18 3.18 0 0 0 2.559-2.45l.021-.097c.076-.347.57-.35.649-.003l.025.113a3.19 3.19 0 0 0 2.566 2.435c.353.061.353.568 0 .63a3.19 3.19 0 0 0-2.566 2.435l-.025.112c-.08.346-.573.344-.649-.003l-.021-.096a3.18 3.18 0 0 0-2.559-2.45\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArtificialIntelligenceSparkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.176.65c-.195-.87-1.428-.865-1.616.006l-.02.097l.489.105l-.49-.105A2.65 2.65 0 0 1 7.423 2.82c-.896.159-.896 1.453 0 1.612A2.65 2.65 0 0 1 9.54 6.497l.02.097c.188.87 1.42.877 1.616.007l.025-.113a2.67 2.67 0 0 1 2.126-2.056c.897-.159.897-1.455 0-1.614A2.67 2.67 0 0 1 11.2.762zM4.525.986c-1.633 0-2.922 1.35-2.955 2.98C.582 4.726 0 6.158 0 7.535c0 .572.098 1.19.272 1.752c.144.463.35.924.624 1.297v.024C.896 12.459 2.348 14 4.188 14a3.25 3.25 0 0 0 2.667-1.404A3.25 3.25 0 0 0 9.522 14c1.84 0 3.292-1.541 3.292-3.393v-.024c.274-.373.48-.834.624-1.297c.174-.563.272-1.18.272-1.752c0-.459-.063-.912-.179-1.34a.625.625 0 1 0-1.206.327c.087.324.135.668.135 1.013c0 .422-.071.896-.202 1.333a2 2 0 0 0-.382-.428a.625.625 0 0 0-.791.967c.072.06.18.2.286.422c.08.17.144.355.184.525q0 .036.002.07q.007.09.007.183c0 1.207-.936 2.144-2.042 2.144c-1.08 0-1.996-.893-2.04-2.056l.006-.088V7.588a.625.625 0 1 0-1.25 0v2.92a1 1 0 0 0-.008.099c0 1.206-.936 2.143-2.042 2.143s-2.042-.937-2.042-2.143q0-.085.006-.167c.037-.193.109-.413.203-.612c.106-.223.214-.362.286-.422a.625.625 0 1 0-.791-.967c-.152.124-.283.28-.394.444a4.8 4.8 0 0 1-.206-1.349c0-.84.274-1.612.664-2.14c.109.194.236.362.369.505c.315.34.698.571 1.016.646a.625.625 0 1 0 .288-1.216l-.036-.014a1 1 0 0 1-.097-.053a1.3 1.3 0 0 1-.256-.214a1.4 1.4 0 0 1-.368-.82a2 2 0 0 1-.01-.197c0-1.013.785-1.794 1.705-1.794c.33 0 .638.098.9.27A.625.625 0 0 0 6.11 1.46A2.9 2.9 0 0 0 4.525.987\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineArtificialIntelligenceSparkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.739.85c.183-.835 1.374-.84 1.564-.005l.01.04l.017.077c.22.934.975 1.648 1.922 1.812c.872.152.872 1.404 0 1.556a2.4 2.4 0 0 0-1.925 1.827l-.024.103c-.19.834-1.38.83-1.564-.007l-.02-.088a2.38 2.38 0 0 0-1.917-1.836c-.87-.152-.87-1.402 0-1.553A2.38 2.38 0 0 0 9.718.948l.014-.064zM8.658 6.398A1.29 1.29 0 0 0 7.625 5.4v7.215a2.998 2.998 0 0 0 5.204-.85a3 3 0 0 1-.778-.183c-.595-.224-1.242-.665-1.773-1.436a.625.625 0 0 1 1.03-.709c.382.555.82.839 1.183.975c.184.07.348.1.476.11l.023.002C13.61 9.85 14 8.546 14 7.457c0-.734-.177-1.458-.483-2.072l-.079.015c-.52.09-.934.484-1.051.998l-.024.102c-.448 1.967-3.255 1.955-3.686-.016zM6.375 4.615a1.96 1.96 0 0 1 0-2.127v-.52a2.618 2.618 0 0 0-4.612 1.698v.002c.039.39.198.68.382.89c.229.261.47.368.527.38a.625.625 0 1 1-.277 1.22c-.36-.083-.82-.355-1.19-.775a2.8 2.8 0 0 1-.383-.562C.312 5.526 0 6.483 0 7.457c0 .735.178 1.568.483 2.238q.12-.136.26-.244a.625.625 0 1 1 .774.98c-.178.141-.364.444-.478.795a2.997 2.997 0 0 0 5.336 1.389v-3.67a2.7 2.7 0 0 1-1.405.585a.625.625 0 1 1-.139-1.243c.509-.056.879-.349 1.143-.734c.268-.39.384-.818.401-1.023z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAscendingNumberOrder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.167.5v5M9.5 1.75h.417c.69 0 1.25-.56 1.25-1.25v0m1.667 5H9.5m.922 5.593h.656a1.422 1.422 0 0 0 0-2.843h-.656a1.422 1.422 0 0 0 0 2.843\"/><path d=\"M12.5 9.562v2.625c0 .725-.588 1.313-1.312 1.313h-.875a1.31 1.31 0 0 1-1.238-.875M6 11l-2.5 2.5L1 11M3.5.5v13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAscendingNumberOrderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.532.753a.613.613 0 0 0-1.225 0a.613.613 0 0 1-.612.612h-.408a.612.612 0 1 0 0 1.225h.408q.323-.002.612-.105V5.04h-1.02a.612.612 0 1 0 0 1.225h3.266a.612.612 0 1 0 0-1.225h-1.02zm-.699 9.524h-.643a.781.781 0 0 1 0-1.562h.643a.78.78 0 0 1 .781.768v.026a.78.78 0 0 1-.78.768m0-2.787c1.028 0 1.875.773 1.992 1.769a.6.6 0 0 1 .014.13v2.572c0 1.048-.85 1.898-1.899 1.898h-.857a1.9 1.9 0 0 1-1.79-1.265a.612.612 0 1 1 1.154-.409c.093.263.344.45.636.45h.857a.674.674 0 0 0 .674-.674v-.617a2 2 0 0 1-.78.157h-.644a2.006 2.006 0 1 1 0-4.011zm-9.386 2.695a.613.613 0 0 0-.433 1.046l2.45 2.45a.613.613 0 0 0 .866 0l2.45-2.45a.612.612 0 0 0-.433-1.046H4.509V.753a.612.612 0 1 0-1.225 0v9.432z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAscendingNumberOrderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.75 0a1 1 0 0 1 1 1v9h1.5a.75.75 0 0 1 .53 1.28l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5A.75.75 0 0 1 1.25 10h1.5V1a1 1 0 0 1 1-1m8.167.75a.75.75 0 0 0-1.5 0a.5.5 0 0 1-.5.5H9.5a.75.75 0 0 0 0 1.5h.417q.259 0 .5-.063V5H9.5a.75.75 0 0 0 0 1.5h3.333a.75.75 0 0 0 0-1.5h-.916zm-.839 9.344h-.656a.672.672 0 0 1 0-1.344h.656c.37 0 .67.298.672.667v.01a.67.67 0 0 1-.672.667m0-2.844c1.11 0 2.027.833 2.156 1.909q.015.074.016.153v2.625c0 1.14-.923 2.063-2.062 2.063h-.875c-.9 0-1.662-.575-1.945-1.375a.75.75 0 1 1 1.414-.5c.078.22.287.375.53.375h.876c.31 0 .562-.252.562-.563v-.45a2.2 2.2 0 0 1-.672.107h-.656a2.172 2.172 0 0 1 0-4.344z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAsterisk1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13m-5.5-10l11 7m-11 0l11-7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAsterisk1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625v5.236l4.54-2.888a.625.625 0 0 1 .67 1.054L8.166 7l4.67 2.973a.625.625 0 1 1-.67 1.054L7.625 8.14v5.236a.625.625 0 1 1-1.25 0V8.139l-4.54 2.888a.625.625 0 1 1-.67-1.054L5.835 7l-4.67-2.973a.625.625 0 0 1 .67-1.054l4.54 2.888V.625C6.375.28 6.655 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAsterisk1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .09a1 1 0 0 1 1 1v4.088l3.463-2.204a1 1 0 0 1 1.074 1.688L8.863 7l3.674 2.338a1 1 0 0 1-1.074 1.688L8 8.822v4.087a1 1 0 1 1-2 0V8.822l-3.463 2.204a1 1 0 1 1-1.074-1.688L5.137 7L1.463 4.662a1 1 0 1 1 1.074-1.688L6 5.178V1.091a1 1 0 0 1 1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAttribution: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0\"/><path d=\"M5.467 4.073a1.524 1.524 0 1 0 3.048 0a1.524 1.524 0 1 0-3.048 0\"/><path d=\"m8.301 8.85l-.325 2.602H6.024L5.699 8.85h-.65a.325.325 0 0 1-.326-.326v-.65a2.277 2.277 0 1 1 4.554 0v.65c0 .18-.146.326-.326.326z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAttributionRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M5.497 5.502A2.5 2.5 0 0 0 4.5 7.5v1.25a.5.5 0 0 0 .5.5h.543l.21 2.295A.5.5 0 0 0 6.25 12h1.5a.5.5 0 0 0 .498-.455l.209-2.295H9a.5.5 0 0 0 .5-.5V7.5c0-.817-.391-1.542-.997-1.998a2.125 2.125 0 1 0-3.006 0M7 3.125a.875.875 0 1 0 0 1.75a.875.875 0 0 0 0-1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAttributionSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M8.5 3.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-.362 8.16l.307-2.451h.722c.2 0 .36-.162.36-.361v-.723a2.528 2.528 0 0 0-5.055 0v.723c0 .2.162.36.361.36h.722l.307 2.452a.5.5 0 0 0 .496.438h1.284a.5.5 0 0 0 .496-.438\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAutoFlash: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.115.59v4.115h2.88l-4.526 6.583V7.173h-2.88zm1.911 12.656l1.842-5.525a.69.69 0 0 1 .658-.475v0c.299 0 .564.191.658.475l1.842 5.525m-4.333-2h3.666\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAutoFlashRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.355.029A.5.5 0 0 1 6.688.5v3.875h3.437a.5.5 0 0 1 .388.815l-5.687 7a.5.5 0 0 1-.888-.315V8H.5a.5.5 0 0 1-.388-.815l5.687-7a.5.5 0 0 1 .556-.156m4.624 8.22a.04.04 0 0 0-.038.027l-.853 2.557h1.78l-.852-2.557a.04.04 0 0 0-.037-.027m-2.99 4.928l.634-1.902l.01-.03L9.755 7.88a1.29 1.29 0 0 1 2.447 0l1.123 3.367l.008.024l.635 1.905a.625.625 0 1 1-1.186.395l-.497-1.49H9.672l-.497 1.49a.625.625 0 1 1-1.186-.395\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAutoFlashSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.263.113a.5.5 0 0 1 .352.477v3.615h2.38a.5.5 0 0 1 .412.783L4.88 11.571a.5.5 0 0 1-.912-.283V7.673h-2.38a.5.5 0 0 1-.413-.783L5.703.307a.5.5 0 0 1 .56-.194m4.263 6.383c.621 0 1.173.398 1.37.988l1.17 3.51l.01.03l.661 1.985a.75.75 0 0 1-1.423.475l-.495-1.488H9.233l-.495 1.488a.75.75 0 0 1-1.424-.475l.661-1.982l.012-.036l1.17-3.507c.196-.59.748-.988 1.369-.988m0 1.622l.793 2.378H9.733z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBackCamera1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 3.5A.25.25 0 0 1 7 3m0 .5A.25.25 0 0 0 7 3\"/><path d=\"M10.5.5h-7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBackCamera1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.567 1.25a.356.356 0 0 0-.356.356v10.788c0 .197.16.356.356.356h6.866c.196 0 .355-.16.355-.356V1.606a.356.356 0 0 0-.355-.356zm-1.606.356C1.961.719 2.681 0 3.567 0h6.866c.886 0 1.605.719 1.605 1.606v10.788c0 .887-.719 1.606-1.605 1.606H3.567a1.606 1.606 0 0 1-1.606-1.606zm5.03 2.586a.87.87 0 1 1 .018-1.74a.87.87 0 0 1-.018 1.74\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBackCamera1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.684.432C2.954.147 3.326 0 3.731 0h6.538c.406 0 .778.147 1.047.432c.267.283.395.663.395 1.068v11c0 .405-.128.785-.395 1.068a1.4 1.4 0 0 1-1.047.432H3.731c-.405 0-.778-.146-1.047-.432c-.267-.283-.395-.663-.395-1.068v-11c0-.405.128-.785.395-1.068M7 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBackpack: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 3h4a2 2 0 0 1 2 2v8.5H3V5a2 2 0 0 1 2-2M3 13.5H.5v-4a1 1 0 0 1 1-1H3m8 0h1.5a1 1 0 0 1 1 1v4H11m-8-6h8m-4-1v2M5 3v-.5a2 2 0 1 1 4 0V3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBackpackRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.028 2.028a1.375 1.375 0 0 1 2.342.85l-.12-.003h-2.5q-.06 0-.12.003c.029-.32.169-.621.398-.85M4.375 3.264V3a2.625 2.625 0 0 1 5.25 0v.264a2.63 2.63 0 0 1 1.25 2.236v2H12A1.5 1.5 0 0 1 13.5 9v4a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V9A1.5 1.5 0 0 1 2 7.5h1.125v-2a2.63 2.63 0 0 1 1.25-2.236m1.375.861A1.375 1.375 0 0 0 4.375 5.5v1.125H6.25V6.25a.75.75 0 0 1 1.5 0v.375h1.875V5.5A1.375 1.375 0 0 0 8.25 4.125zm-1.375 3.75H6.25v.375a.75.75 0 0 0 1.5 0v-.375h1.875v4.375h-5.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBackpackSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.116 1.866a1.25 1.25 0 0 1 2.134.884v.202h-2.5V2.75c0-.332.132-.65.366-.884M4.25 3.101V2.75a2.75 2.75 0 1 1 5.5 0v.35c.246.102.473.254.664.45c.375.382.586.9.586 1.44v1.69H7.625v-.322a.625.625 0 1 0-1.25 0v.322H3V4.99c0-.54.21-1.058.586-1.44c.191-.196.418-.348.664-.45m2.125 4.83H3v6.022h8V7.93H7.625v.428a.625.625 0 1 1-1.25 0zM1.5 7.952h.25v6H.5a.5.5 0 0 1-.5-.5v-4a1.5 1.5 0 0 1 1.5-1.5m11 0h-.25v6h1.25a.5.5 0 0 0 .5-.5v-4a1.5 1.5 0 0 0-1.5-1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBacteriaVirusCellsBiology: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.874 11.57c-4.079-2.981-.453-8.944 1.36-9.796c1.45-.681 2.719 0 3.172.426c1.713 1.609-.16 3.36.747 4.638c2.788 3.29-1.338 7.612-5.279 4.732\"/><path d=\"M6.282 9.257a1.229 1.229 0 1 0 2.458 0a1.229 1.229 0 1 0-2.458 0m.002-4.75a1.005 1.005 0 1 0 2.01 0a1.005 1.005 0 1 0-2.01 0M5.152 7.235a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5M7.53 1.486V.542M5.945 1.944l-.528-.782m-.626 1.943l-.8-.5m-.184 2.103l-.853-.404m.239 2.136l-.926-.182m.747 1.854l-.943.027m1.312 1.636l-.868.369m1.829.988l-.657.677m2.133.316l-.434.838m2.144.495v-.944m1.797.588l-.408-.851m1.958-.239l-.665-.67m1.718-1.35l-.923-.2m.75-2.042l-.881.34m-.043-1.995l-.88.34m1.113-2.029l-.938-.107m.665-1.813l-.874.356M9.41 1.045l-.531.78\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBacteriaVirusCellsBiologyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.658.004a.625.625 0 0 1 .706.532l.055.396c.433-.031.826.02 1.188.146q.188.066.357.153L6.178.9a.625.625 0 0 1 1.05.678l-.276.428q.07.073.136.147c.127.142.254.295.371.436l.142.169c.162.192.31.36.465.502q.078.073.157.135l.165-.34a.625.625 0 0 1 1.124.546l-.075.155c.582.066 1.1.232 1.552.476l.344-.37a.625.625 0 0 1 .914.854l-.269.288q.11.12.21.249c.27.35.477.742.622 1.155l.477-.067a.625.625 0 0 1 .176 1.237l-.405.058a5 5 0 0 1-.188 1.715l.453.292a.625.625 0 1 1-.677 1.05l-.278-.178a4.85 4.85 0 0 1-1.463 1.555l.204.372a.625.625 0 1 1-1.095.601l-.224-.407a6 6 0 0 1-1.941.346l-.015.416a.625.625 0 1 1-1.25-.044l.017-.452a6 6 0 0 1-1.39-.388l-.203.38a.625.625 0 1 1-1.103-.589l.208-.388a6.3 6.3 0 0 1-1.072-.937l-.407.263a.625.625 0 0 1-.679-1.05l.325-.21a8 8 0 0 1-.746-1.51l-.421.118a.625.625 0 0 1-.334-1.205l.405-.112A8.6 8.6 0 0 1 .99 5.295L.534 5.23a.625.625 0 1 1 .177-1.238l.413.06q.024-.123.054-.24c.084-.345.2-.68.35-.99l-.395-.323a.625.625 0 0 1 .79-.97l.33.27c.267-.256.58-.46.942-.594L3.125.71a.625.625 0 0 1 .533-.706M5.196 2.26c-.334-.117-.809-.146-1.549.112c-.554.193-1.019.775-1.255 1.738c-.233.948-.207 2.147.118 3.323c.651 2.353 2.418 4.408 5.401 4.297c2.493-.093 3.75-1.784 3.893-3.454c.073-.845-.142-1.66-.606-2.259c-.453-.586-1.175-1.01-2.22-1.042l-.024-.001C8.2 4.92 7.65 4.578 7.216 4.176a7 7 0 0 1-.57-.613q-.086-.1-.164-.195a13 13 0 0 0-.326-.383c-.32-.358-.611-.605-.96-.726m.58 1.548a1.63 1.63 0 0 0-2.301 0a1.624 1.624 0 0 0 0 2.298a1.63 1.63 0 0 0 2.3 0a1.624 1.624 0 0 0 0-2.298m1.338 3.338a2 2 0 0 1 2.828 0c.781.78.781 2.045 0 2.825s-2.047.78-2.828 0a1.995 1.995 0 0 1 0-2.825M3.983 8.46a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBacteriaVirusCellsBiologySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.52.434a.75.75 0 0 0-1.36.632l.299.644c-.23.183-.461.408-.687.663l-.569-.53A.75.75 0 0 0 3.18 2.938l.696.65a10 10 0 0 0-.404.718l-.747-.319a.75.75 0 1 0-.589 1.38l.761.324l-.016.05q-.139.437-.228.893l-.803-.1a.75.75 0 0 0-.186 1.489l.866.107q.014.422.094.838l-.672.3a.75.75 0 0 0-.378.992c.17.378.613.547.991.378l.573-.256c.215.384.492.751.843 1.094l-.48.576a.75.75 0 0 0 1.152.96l.531-.637c.438.248.877.42 1.309.527v.348a.75.75 0 1 0 1.5-.002v-.239a4.1 4.1 0 0 0 1.566-.493l.617.664a.75.75 0 0 0 1.099-1.021l-.562-.605c.237-.288.431-.61.576-.952l.854.115a.75.75 0 0 0 .2-1.487l-.764-.102a3.7 3.7 0 0 0-.18-1.1l.586-.25a.75.75 0 0 0-.588-1.38l-.712.304q-.059-.075-.121-.15c-.13-.193-.174-.412-.157-.705q.011-.16.037-.323h.896a.75.75 0 0 0 0-1.5h-.668a3 3 0 0 0-.058-.718l.723-.482a.75.75 0 0 0-.832-1.248l-.611.408a2.7 2.7 0 0 0-.506-.419l.263-.413A.75.75 0 0 0 8.386.347l-.436.686a3.3 3.3 0 0 0-1.132.042L6.52.435Zm2.233 8.842a1.229 1.229 0 1 1-2.457 0a1.229 1.229 0 0 1 2.457 0M7.303 5.53a1.005 1.005 0 1 0 0-2.01a1.005 1.005 0 0 0 0 2.01M4.415 7.004a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBag: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5c3.5 0 6-1.24 6-4c0-3-1.5-4.52-4.5-6.02l1.298-2.028a.65.65 0 0 0-.56-.95h-4.24a.65.65 0 0 0-.56 1L5.5 3.48C2.5 5 1 6.52 1 9.52c0 2.74 2.5 3.98 6 3.98\"/><path d=\"M5.5 3.5a1.803 1.803 0 0 0 3 0v0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagDollar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5c3.5 0 6-1.238 6-3.994c0-2.995-1.5-4.992-4.5-6.49l1.18-1.518A.658.658 0 0 0 9.12.5H4.88a.66.66 0 0 0-.56.998L5.5 3.026C2.5 4.534 1 6.531 1 9.526C1 12.262 3.5 13.5 7 13.5\"/><path d=\"M8.383 6.806a1.08 1.08 0 0 0-1.022-.723h-.838a.967.967 0 0 0-.207 1.912l1.277.28a1.084 1.084 0 0 1-.232 2.142H6.64c-.472 0-.873-.302-1.022-.722M7 6.083V5m0 6.5v-1.083\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagDollarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.094-.001h-.006c-.226.002-.443.07-.63.19a1.25 1.25 0 0 0-.433.48a1.32 1.32 0 0 0 .055 1.296l.667.941c-1.124.699-2.019 1.514-2.655 2.497C1.342 6.561.98 7.908.98 9.478c0 1.547.663 2.718 1.795 3.475C3.873 13.687 5.36 14 7 14s3.128-.314 4.226-1.051c1.133-.76 1.794-1.937 1.794-3.492c0-1.57-.362-2.916-1.112-4.074c-.636-.98-1.53-1.794-2.652-2.488l.663-.93A1.32 1.32 0 0 0 9.975.67a1.25 1.25 0 0 0-.433-.48a1.2 1.2 0 0 0-.63-.19zM6.16 2.741L5.132 1.287a.1.1 0 0 1 .001-.038h3.734a.1.1 0 0 1 0 .038L7.84 2.729a.625.625 0 0 0 .21.912c1.286.7 2.207 1.494 2.809 2.423c.599.924.911 2.026.911 3.394c0 1.149-.462 1.931-1.24 2.454c-.813.545-2.022.839-3.53.839s-2.717-.293-3.53-.837c-.779-.521-1.24-1.3-1.24-2.436c0-1.368.312-2.47.911-3.396c.603-.93 1.524-1.727 2.81-2.432a.625.625 0 0 0 .21-.91m1.464 2.134v.479a1.71 1.71 0 0 1 1.347 1.118a.625.625 0 0 1-1.178.417a.46.46 0 0 0-.433-.306h-.838a.342.342 0 0 0-.073.677l1.276.279a1.709 1.709 0 0 1-.101 3.358v.478a.625.625 0 1 1-1.25 0v-.479a1.71 1.71 0 0 1-1.347-1.118a.625.625 0 1 1 1.178-.417a.46.46 0 0 0 .433.306h.722a.459.459 0 0 0 .098-.907l-1.277-.28a1.592 1.592 0 0 1 .193-3.14v-.465a.625.625 0 1 1 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagDollarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.463 9.692C13.463 12.664 10.77 14 7 14S.537 12.664.537 9.713c0-3.231 1.616-4.868 4.847-6.505L4.24 1.077A.7.7 0 0 1 4.843 0H9.41a.7.7 0 0 1 .603 1.023L8.616 3.208c3.23 1.615 4.847 3.252 4.847 6.484M7.625 4.887a.625.625 0 1 0-1.25 0v.627a1.74 1.74 0 0 0-.298 3.44l1.473.322a.625.625 0 0 1-.133 1.236h-.834a.625.625 0 0 1-.59-.416a.625.625 0 1 0-1.178.416a1.88 1.88 0 0 0 1.56 1.239v.636a.625.625 0 1 0 1.25 0v-.636a1.876 1.876 0 0 0 .192-3.696l-1.473-.322a.49.49 0 0 1 .105-.97h.968a.62.62 0 0 1 .59.416a.625.625 0 0 0 1.178-.417a1.87 1.87 0 0 0-1.56-1.238z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagPound: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.604 6.22s-1.312-.582-2.041.147c-.967.966.437 3.5-1.313 4.083c0 0 1.944.097 3.5 0m-.583-2.042H5.25\"/><path d=\"M7 13.5c3.5 0 6-1.238 6-3.994c0-2.995-1.5-4.992-4.5-6.49l1.18-1.518A.658.658 0 0 0 9.12.5H4.88a.66.66 0 0 0-.56.998L5.5 3.026C2.5 4.534 1 6.531 1 9.526C1 12.262 3.5 13.5 7 13.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagPoundRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.094-.001h-.006c-.226.002-.443.07-.63.19a1.25 1.25 0 0 0-.433.48a1.32 1.32 0 0 0 .055 1.296l.667.941c-1.124.699-2.019 1.514-2.655 2.497C1.342 6.561.98 7.908.98 9.478c0 1.547.663 2.718 1.795 3.475C3.873 13.687 5.36 14 7 14s3.128-.314 4.226-1.051c1.133-.76 1.794-1.937 1.794-3.492c0-1.57-.362-2.916-1.112-4.074c-.636-.98-1.53-1.794-2.652-2.488l.663-.93A1.32 1.32 0 0 0 9.975.67a1.25 1.25 0 0 0-.433-.48a1.2 1.2 0 0 0-.63-.19zM6.16 2.741L5.132 1.287a.1.1 0 0 1 .001-.038h3.734a.1.1 0 0 1 0 .038L7.84 2.729a.625.625 0 0 0 .21.912c1.286.7 2.207 1.494 2.809 2.423c.599.924.911 2.026.911 3.394c0 1.149-.462 1.931-1.24 2.454c-.813.545-2.022.839-3.53.839s-2.717-.293-3.53-.837c-.779-.521-1.24-1.3-1.24-2.436c0-1.368.312-2.47.911-3.396c.603-.93 1.524-1.727 2.81-2.432a.625.625 0 0 0 .21-.91m2.443 3.48l.254-.571l-.002-.001l-.002-.001l-.006-.003l-.018-.007a3 3 0 0 0-.25-.092a3.7 3.7 0 0 0-.642-.145c-.49-.064-1.247-.046-1.817.524c-.398.398-.512.918-.548 1.354a6 6 0 0 0-.016.504H5.25a.625.625 0 1 0 0 1.25h.313a1.6 1.6 0 0 1-.088.443c-.064.166-.166.293-.411.377a.62.62 0 0 0-.429.485a.62.62 0 0 0 .256.624a.62.62 0 0 0 .374.113H8.75a.625.625 0 1 0 0-1.25H6.677c.086-.26.124-.531.14-.792h1.35a.625.625 0 0 0 0-1.25h-1.36c-.002-.139 0-.27.012-.401c.027-.33.1-.488.185-.573c.16-.16.423-.214.772-.169a2.4 2.4 0 0 1 .572.151l.004.002a.625.625 0 0 0 .506-1.143z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagPoundSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.463 9.692C13.463 12.664 10.77 14 7 14S.537 12.664.537 9.713c0-3.231 1.616-4.868 4.847-6.505L4.24 1.077A.7.7 0 0 1 4.843 0H9.41a.7.7 0 0 1 .603 1.023L8.616 3.208c3.23 1.615 4.847 3.252 4.847 6.484M8.488 5.615c.152.053.326.13.438.223a.5.5 0 0 1-.64.77l-.004-.005l.005.004l.003.003l.007.006s-.003 0-.009-.004a1.8 1.8 0 0 0-.536-.142c-.316-.03-.615.03-.836.25c-.117.117-.194.312-.222.652a5 5 0 0 0-.01.536h1.483a.5.5 0 1 1 0 1h-1.47a3 3 0 0 1-.173.974l-.028.068H8.75a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.158-.974c.29-.097.421-.253.5-.455a2 2 0 0 0 .104-.613H5.25a.5.5 0 0 1 0-1h.433a6 6 0 0 1 .015-.619c.035-.425.144-.91.511-1.276c.509-.508 1.154-.585 1.64-.538c.245.024.466.08.64.14Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.21.001H4.79a1.263 1.263 0 0 0-1.06 1.894l.904 1.413c-1.213.657-2.199 1.365-2.904 2.25C.89 6.613.489 7.866.489 9.453c0 1.582.735 2.759 1.953 3.51c1.18.727 2.783 1.04 4.558 1.04s3.378-.313 4.558-1.04c1.218-.751 1.952-1.929 1.952-3.51c0-1.587-.4-2.84-1.239-3.893c-.705-.886-1.69-1.594-2.905-2.251l.905-1.413l.028-.048A1.264 1.264 0 0 0 9.21 0M2.708 6.337c.584-.734 1.454-1.365 2.67-2.01a2.4 2.4 0 0 0 3.246 0c1.216.645 2.086 1.276 2.67 2.01c.633.796.968 1.76.968 3.115c0 1.127-.492 1.911-1.359 2.446c-.904.557-2.244.853-3.902.853s-2.998-.296-3.902-.853c-.867-.535-1.359-1.32-1.359-2.446c0-1.355.335-2.32.968-3.115\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagRupee: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.958 6h4.084M4.958 7.604h4.084M6.708 6c.389.097 1.167.438 1.167 1.458c0 1.75-2.334 1.75-2.334 1.75s1.167 1.021 2.917 1.459\"/><path d=\"M7 13.5c3.5 0 6-1.238 6-3.994c0-2.995-1.5-4.992-4.5-6.49l1.18-1.518A.658.658 0 0 0 9.12.5H4.88a.66.66 0 0 0-.56.998L5.5 3.026C2.5 4.534 1 6.531 1 9.526C1 12.262 3.5 13.5 7 13.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagRupeeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.094-.001h-.006c-.226.002-.443.07-.63.19a1.25 1.25 0 0 0-.433.48a1.32 1.32 0 0 0 .055 1.296l.667.941c-1.124.699-2.019 1.514-2.655 2.497C1.342 6.561.98 7.908.98 9.478c0 1.547.663 2.718 1.795 3.475C3.873 13.687 5.36 14 7 14s3.128-.314 4.226-1.051c1.133-.76 1.794-1.937 1.794-3.492c0-1.57-.362-2.916-1.112-4.074c-.636-.98-1.53-1.794-2.652-2.488l.663-.93A1.32 1.32 0 0 0 9.975.67a1.25 1.25 0 0 0-.433-.48a1.2 1.2 0 0 0-.63-.19zM6.16 2.741L5.132 1.287a.1.1 0 0 1 .001-.038h3.734a.1.1 0 0 1 0 .038L7.84 2.729a.625.625 0 0 0 .21.912c1.286.7 2.207 1.494 2.809 2.423c.599.924.911 2.026.911 3.394c0 1.149-.462 1.931-1.24 2.454c-.813.545-2.022.839-3.53.839s-2.717-.293-3.53-.837c-.779-.521-1.24-1.3-1.24-2.436c0-1.368.312-2.47.911-3.396c.603-.93 1.524-1.727 2.81-2.432a.625.625 0 0 0 .21-.91M4.958 6.75h1.658a1 1 0 0 1 .526.48H4.958a.625.625 0 1 0 0 1.25h1.93a1.8 1.8 0 0 1-.426.248a3.1 3.1 0 0 1-.943.23l-.012.001h-.001a.625.625 0 0 0-.376 1.095l.411-.47l-.411.47l.003.002l.004.004l.014.012q.017.015.05.04q.061.052.175.138a8.4 8.4 0 0 0 2.93 1.398a.625.625 0 0 0 .304-1.213a7 7 0 0 1-1.557-.603c.507-.236 1.073-.656 1.32-1.353h.669a.625.625 0 0 0 0-1.25h-.587a2.2 2.2 0 0 0-.152-.479h.739a.625.625 0 0 0 0-1.25H4.958a.625.625 0 1 0 0 1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagRupeeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.463 9.692C13.463 12.664 10.77 14 7 14S.537 12.664.537 9.713c0-3.231 1.616-4.868 4.847-6.505L4.24 1.077A.7.7 0 0 1 4.843 0H9.41a.7.7 0 0 1 .603 1.023L8.616 3.208c3.23 1.615 4.847 3.252 4.847 6.484M4.957 6.5H6.64c.14.042.316.12.457.25a.8.8 0 0 1 .226.354H4.958a.5.5 0 1 0 0 1h2.207a1.5 1.5 0 0 1-.633.417a3.1 3.1 0 0 1-.977.187H5.54a.5.5 0 0 0-.328.877h.001l.001.002l.005.003l.013.012a4 4 0 0 0 .219.173a8.2 8.2 0 0 0 2.886 1.377a.5.5 0 1 0 .242-.97a7.2 7.2 0 0 1-1.75-.704l.054-.02c.338-.127.71-.329 1-.656c.175-.195.312-.428.397-.698h.762a.5.5 0 0 0 0-1h-.694A1.9 1.9 0 0 0 8.15 6.5h.892a.5.5 0 0 0 0-1H4.958a.5.5 0 0 0 0 1Zm.583 2.708l-.329.377z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.462 9.692C13.462 12.664 10.77 14 7 14S.537 12.664.537 9.713c0-2.825 1.235-4.432 3.705-5.885a4.59 4.59 0 0 0 5.52-.004c2.467 1.438 3.7 3.045 3.7 5.868M8.743 3.008l1.27-1.985A.7.7 0 0 0 9.41 0H4.843a.7.7 0 0 0-.603 1.077l1.047 1.95c1.061.635 2.4.629 3.456-.019\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagSuitcase1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 3.5h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1M5 .5h4a1 1 0 0 1 1 1v2H4v-2a1 1 0 0 1 1-1M3.5 7h7m-7 3h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagSuitcase1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5.375A1.875 1.875 0 0 0 3.625 2.25v1.125H2C1.103 3.375.375 4.103.375 5v7c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V5c0-.897-.727-1.625-1.625-1.625h-1.625V2.25A1.875 1.875 0 0 0 8.5.375zm3.125 3V2.25a.125.125 0 0 0-.125-.125h-3a.125.125 0 0 0-.125.125v1.125zM1.625 5c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v7a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12zM3.75 6.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM3 10a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 3 10\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagSuitcase1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.823 1.627A.25.25 0 0 1 5 1.553h4a.25.25 0 0 1 .25.25V3h-4.5V1.803a.25.25 0 0 1 .073-.176M3.25 3V1.803A1.75 1.75 0 0 1 5 .053h4a1.75 1.75 0 0 1 1.75 1.75V3h1.75A1.5 1.5 0 0 1 14 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8A1.5 1.5 0 0 1 1.5 3zm-.375 3.578c0-.345.28-.625.625-.625h7a.625.625 0 1 1 0 1.25h-7a.625.625 0 0 1-.625-.625M3.5 9.797a.625.625 0 1 0 0 1.25h7a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagSuitcase2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 3.5h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-2.5 0v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagSuitcase2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5.375A1.875 1.875 0 0 0 3.625 2.25v1.125H2C1.103 3.375.375 4.103.375 5v7c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V5c0-.897-.727-1.625-1.625-1.625h-1.625V2.25A1.875 1.875 0 0 0 8.5.375zm3.125 3V2.25a.125.125 0 0 0-.125-.125h-3a.125.125 0 0 0-.125.125v1.125zM1.625 5c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v7a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagSuitcase2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 .02a1.75 1.75 0 0 0-1.75 1.75V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 12.5 3h-1.75V1.77A1.75 1.75 0 0 0 9 .02zM9.25 3V1.77A.25.25 0 0 0 9 1.52H5a.25.25 0 0 0-.25.25V3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagYen: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.25 6L7 8.333L8.75 6M7 8.333v2.625M5.25 8.333h3.5m-3.5 1.459h3.5\"/><path d=\"M7 13.5c3.5 0 6-1.238 6-3.994c0-2.995-1.5-4.992-4.5-6.49l1.18-1.518A.658.658 0 0 0 9.12.5H4.88a.66.66 0 0 0-.56.998L5.5 3.026C2.5 4.534 1 6.531 1 9.526C1 12.262 3.5 13.5 7 13.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagYenRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.094-.001h-.006c-.226.002-.443.07-.63.19a1.25 1.25 0 0 0-.433.48a1.32 1.32 0 0 0 .055 1.296l.667.941c-1.124.699-2.019 1.514-2.655 2.497C1.342 6.561.98 7.908.98 9.478c0 1.547.663 2.718 1.795 3.475C3.873 13.687 5.36 14 7 14s3.128-.314 4.226-1.051c1.133-.76 1.794-1.937 1.794-3.492c0-1.57-.362-2.916-1.112-4.074c-.636-.98-1.53-1.794-2.652-2.488l.663-.93A1.32 1.32 0 0 0 9.975.67a1.25 1.25 0 0 0-.433-.48a1.2 1.2 0 0 0-.63-.19zM6.16 2.741L5.132 1.287a.1.1 0 0 1 .001-.038h3.734a.1.1 0 0 1 0 .038L7.84 2.729a.625.625 0 0 0 .21.912c1.286.7 2.207 1.494 2.809 2.423c.599.924.911 2.026.911 3.394c0 1.149-.462 1.931-1.24 2.454c-.813.545-2.022.839-3.53.839s-2.717-.293-3.53-.837c-.779-.521-1.24-1.3-1.24-2.436c0-1.368.312-2.47.911-3.396c.603-.93 1.524-1.727 2.81-2.432a.625.625 0 0 0 .21-.91M4.875 5.5a.625.625 0 0 1 .875.125L7 7.292l1.25-1.667a.625.625 0 1 1 1 .75L8.156 7.833h.594a.625.625 0 0 1 0 1.25H7.625v.584H8.75a.625.625 0 1 1 0 1.25H7.625v.291a.625.625 0 1 1-1.25 0v-.291H5.25a.625.625 0 1 1 0-1.25h1.125v-.584H5.25a.625.625 0 1 1 0-1.25h.594L4.75 6.375a.625.625 0 0 1 .125-.875\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBagYenSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.463 9.692C13.463 12.664 10.77 14 7 14S.537 12.664.537 9.713c0-3.231 1.616-4.868 4.847-6.505L4.24 1.078A.7.7 0 0 1 4.843 0H9.41a.7.7 0 0 1 .603 1.023L8.616 3.208c3.23 1.615 4.847 3.252 4.847 6.484M4.95 5.6a.5.5 0 0 1 .7.1L7 7.5l1.35-1.8a.5.5 0 1 1 .8.6L8 7.833h.75a.5.5 0 0 1 0 1H7.5v.459h1.25a.5.5 0 1 1 0 1H7.5v.666a.5.5 0 1 1-1 0v-.666H5.25a.5.5 0 1 1 0-1H6.5v-.459H5.25a.5.5 0 1 1 0-1H6L4.85 6.3a.5.5 0 0 1 .1-.7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBaggage: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 4h-9a2 2 0 0 0-2 2v5.5a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M4 13.5V4m6 9.5V4M4.5 4a2.5 2.5 0 1 1 5 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBaggageRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.625 3a1.375 1.375 0 0 1 2.75 0v.375h-2.75zm-1.25.375V3a2.625 2.625 0 1 1 5.25 0v.375H11A2.625 2.625 0 0 1 13.625 6v5A2.625 2.625 0 0 1 11 13.625H3A2.625 2.625 0 0 1 .375 11V6A2.625 2.625 0 0 1 3 3.375zm6 1.25v7.75H11c.76 0 1.375-.616 1.375-1.375V6c0-.76-.616-1.375-1.375-1.375zm-1.75 7.75v-7.75h-3.25v7.75zM3 4.625h.625v7.75H3c-.76 0-1.375-.616-1.375-1.375V6c0-.76.616-1.375 1.375-1.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBaggageSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 2.25A1.75 1.75 0 0 0 5.323 3.5h3.354A1.75 1.75 0 0 0 7 2.25m-2.298-.548a3.25 3.25 0 0 0-.91 1.777l.004.068v10.406L3.794 14h6.412l-.002-.047V3.547l.004-.068a3.25 3.25 0 0 0-5.506-1.777m6.75 1.798l.002.047v10.406l-.002.047h.048a2.5 2.5 0 0 0 2.5-2.5V6a2.5 2.5 0 0 0-2.5-2.5zM2.5 3.5h.048l-.002.047v10.406l.002.047H2.5A2.5 2.5 0 0 1 0 11.5V6a2.5 2.5 0 0 1 2.5-2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBall: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m0-13v13\"/><path d=\"M2.1 11.27a5 5 0 0 0 0-8.54m9.8 0a5 5 0 0 0 0 8.54\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBallRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 1.284a5.73 5.73 0 0 0-3.22 1.44A5.63 5.63 0 0 1 5.124 7a5.67 5.67 0 0 1-1.972 4.276a5.73 5.73 0 0 0 3.222 1.442zm1.25 11.434a5.73 5.73 0 0 0 3.222-1.442a5.625 5.625 0 0 1-.001-8.551a5.73 5.73 0 0 0-3.221-1.441zm4.054-9.061a4.375 4.375 0 0 0 .001 6.687A5.72 5.72 0 0 0 12.751 7a5.72 5.72 0 0 0-1.072-3.344m-9.36 6.687A4.42 4.42 0 0 0 3.876 7A4.37 4.37 0 0 0 2.32 3.657A5.73 5.73 0 0 0 1.249 7c0 1.247.397 2.4 1.07 3.343M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBallSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.333 2.89A6.97 6.97 0 0 0 0 7a6.97 6.97 0 0 0 1.333 4.11l.04-.03A4.55 4.55 0 0 0 2.87 9.356A5.2 5.2 0 0 0 3.423 7c0-.828-.191-1.64-.553-2.355A4.55 4.55 0 0 0 1.333 2.89m.826-.947a5.8 5.8 0 0 1 1.826 2.138c.453.895.688 1.9.688 2.919s-.235 2.024-.688 2.92a5.8 5.8 0 0 1-1.826 2.137a6.98 6.98 0 0 0 4.216 1.915V.028c-1.63.144-3.1.847-4.216 1.915m5.466 12.03a6.98 6.98 0 0 0 4.216-1.916a5.8 5.8 0 0 1-1.826-2.138c-.453-.895-.688-1.9-.688-2.919s.235-2.024.688-2.92a5.8 5.8 0 0 1 1.826-2.137A6.98 6.98 0 0 0 7.625.028zM14 7a6.97 6.97 0 0 1-1.333 4.11l-.04-.03a4.55 4.55 0 0 1-1.497-1.725A5.2 5.2 0 0 1 10.577 7c0-.828.191-1.64.553-2.355a4.55 4.55 0 0 1 1.537-1.755A6.97 6.97 0 0 1 14 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBalloon: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.021 11.27c.205 2.682 2.541 2.356 3.553 1.706c1.712-1.1 2.846-1.385 4.864-1.226M9.04 4.404c0-1.975-1.8-3.779-4.02-3.779S1.003 2.429 1.003 4.404s1.8 4.152 4.018 4.152c2.22 0 4.019-2.178 4.019-4.152\"/><path d=\"m5.048 8.556l-1.25 1.512a.5.5 0 0 0 .386.819h1.693a.5.5 0 0 0 .39-.813z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBalloonRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.23 4.468c0 .912.384 1.964 1.023 2.787c.642.826 1.463 1.327 2.293 1.327S7.198 8.08 7.84 7.255c.64-.823 1.023-1.875 1.023-2.787c0-.934-.301-1.73-.837-2.29c-.532-.554-1.346-.928-2.479-.928s-1.946.374-2.478.928c-.536.56-.838 1.356-.838 2.29m2.177 5.169c-.856-.297-1.589-.904-2.14-1.615C1.478 7.01.98 5.693.98 4.468c0-1.202.391-2.327 1.186-3.155C2.966.479 4.122 0 5.546 0s2.58.48 3.38 1.313c.795.828 1.186 1.953 1.186 3.155c0 1.225-.499 2.542-1.286 3.554c-.546.703-1.27 1.305-2.114 1.605l.543.676c.533.664.152 1.62-.625 1.789q.148.13.332.231c.681.374 1.277.114 2.277-.36c.442-.209 1.003-.474 1.593-.542c.652-.074 1.309.092 1.918.638a.75.75 0 0 1-1 1.117c-.281-.252-.509-.292-.748-.265c-.302.035-.64.18-1.12.408l-.13.062c-.85.406-2.126 1.017-3.512.257a3.06 3.06 0 0 1-1.388-1.52h-.127c-.943 0-1.46-1.1-.86-1.826zm.604 1.23h1.094l-.54-.67z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBalloonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.404 11.173h-.932a.5.5 0 0 1-.386-.819l1.14-1.38c-.95-.196-1.784-.73-2.414-1.415C1.014 6.69.503 5.535.503 4.404c0-2.27 2.043-4.279 4.518-4.279c2.476 0 4.519 2.009 4.519 4.279c0 1.131-.511 2.286-1.31 3.155c-.623.679-1.448 1.21-2.386 1.41l1.116 1.39a.5.5 0 0 1-.39.813h-.93l.006.051c.042.551.188.884.345 1.085a1 1 0 0 0 .582.362c.5.118 1.128-.053 1.506-.296c.85-.546 1.593-.914 2.4-1.117c.805-.203 1.632-.23 2.633-.151a.625.625 0 1 1-.097 1.246c-.927-.073-1.605-.04-2.232.117c-.627.158-1.242.451-2.028.956c-.59.38-1.561.675-2.467.462a2.25 2.25 0 0 1-1.28-.808c-.347-.442-.553-1.031-.609-1.761a.6.6 0 0 1 .006-.146\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBandage: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3.13 7.87l4.74-4.74m-1.74 7.74l4.74-4.74m-3.08 6.39a3.345 3.345 0 0 0 4.73-4.73L6.21 1.48a3.345 3.345 0 0 0-4.73 4.73z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBandageRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.095 0a3.905 3.905 0 0 1 2.761 6.667l-6.189 6.19a3.906 3.906 0 0 1-5.523-5.524l6.189-6.19A3.9 3.9 0 0 1 10.095 0m.283 7.378L6.622 3.622l-3 3l3.756 3.756z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBandageSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.11.045a4.064 4.064 0 0 0-2.874 6.938l.363.364q.035.045.076.085l4.893 4.893q.041.041.086.077l.363.362a4.064 4.064 0 1 0 5.747-5.747l-.363-.364a1 1 0 0 0-.076-.085L7.432 1.675a1 1 0 0 0-.086-.076l-.363-.363A4.06 4.06 0 0 0 4.11.046m-.235 6.769l2.939-2.939l3.31 3.311l-2.938 2.939z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBank: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.91 5.5H1.09c-.56 0-.8-.61-.36-.9L6.64.73a.71.71 0 0 1 .72 0l5.91 3.87c.44.29.2.9-.36.9M13 11H1a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5M2 5.5V11m3.333-5.5V11m3.334-5.5V11M12 5.5V11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBankRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .5a1.15 1.15 0 0 0-.609.175L.936 4.295l-.001.002a.925.925 0 0 0-.368 1.12c.148.379.524.637.978.637h.09v3.952h-.173c-.616 0-1.087.508-1.087 1.1v1.42c0 .592.471 1.099 1.087 1.099h11.077c.615 0 1.086-.507 1.086-1.099v-1.42c0-.592-.471-1.1-1.086-1.1h-.174V6.054h.09c.454 0 .83-.258.978-.636a.925.925 0 0 0-.367-1.121l-.002-.001L7.61.676L7.59.661A1.15 1.15 0 0 0 7 .5m3.616 5.554H9.372v3.952h1.243zm-2.994 0H6.378v3.952h1.244zm-2.994 0H3.385v3.952h1.243zm-3.003 5.202v1.119h10.75v-1.119z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBankSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .066a1.2 1.2 0 0 0-.634.18l-5.91 3.87H.455c-.42.277-.547.754-.385 1.161c.156.392.55.657 1.02.657h11.82c.47 0 .864-.265 1.02-.657c.162-.407.034-.884-.385-1.16l-.001-.001l-5.91-3.87l-.02-.013A1.2 1.2 0 0 0 7 .066M0 11.877c0-.6.572-.889 1-.889h.055l-.003-.054V7.723a.5.5 0 0 1 .5-.5h1.664a.5.5 0 0 1 .5.5v3.211l-.003.054h1.958l-.003-.054V7.723a.5.5 0 0 1 .5-.5h1.664a.5.5 0 0 1 .5.5v3.211l-.003.054h1.958l-.003-.054V7.723a.5.5 0 0 1 .5-.5h1.664a.5.5 0 0 1 .5.5v3.211l-.003.054H13c.429 0 1 .289 1 .89v1.167c0 .6-.571.889-1 .889H1c-.428 0-1-.289-1-.89z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryAlert1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 5.5A.5.5 0 0 0 13 5h-.5V3.5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h.5a.5.5 0 0 0 .5-.5zm-7-1V7\"/><path d=\"M6.5 9.125a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryAlert1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.875A1.625 1.625 0 0 0 0 3.5v7a1.625 1.625 0 0 0 1.625 1.625h8.75A1.625 1.625 0 0 0 12 10.5v-.625h.875A1.125 1.125 0 0 0 14 8.75v-3.5a1.125 1.125 0 0 0-1.125-1.125H12V3.5a1.625 1.625 0 0 0-1.625-1.625zm-.265 1.36c.07-.07.166-.11.265-.11h8.75a.375.375 0 0 1 .375.375v1.25c0 .345.28.625.625.625h1.375v3.25h-1.375a.625.625 0 0 0-.625.625v1.25a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375v-7c0-.1.04-.195.11-.265m5.14 1.39a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0zm-.75 5.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryAlert1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-.5V3.5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h.5a.5.5 0 0 0 .5-.5zm-7-1.625c.345 0 .625.28.625.625V7a.625.625 0 1 1-1.25 0V4.5c0-.345.28-.625.625-.625m.75 5.375a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryCharging: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 5.5A.5.5 0 0 0 13 5h-.5V3.5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h.5a.5.5 0 0 0 .5-.5z\"/><path d=\"m7.177 4.658l-1.658 2.24h2.169l-1.183 2.13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryChargingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.875A1.625 1.625 0 0 0 0 3.5v7a1.625 1.625 0 0 0 1.625 1.625h8.75A1.625 1.625 0 0 0 12 10.5v-.625h.875A1.125 1.125 0 0 0 14 8.75v-3.5a1.125 1.125 0 0 0-1.125-1.125H12V3.5a1.625 1.625 0 0 0-1.625-1.625zm-.265 1.36c.07-.07.166-.11.265-.11h8.75a.375.375 0 0 1 .375.375v1.25c0 .345.28.625.625.625h1.375v3.25h-1.375a.625.625 0 0 0-.625.625v1.25a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375v-7c0-.1.04-.195.11-.265m5.685 2.01a.75.75 0 1 0-1.142-.972l-1.908 2.24a.75.75 0 0 0 .571 1.236h1.438L5.15 8.755a.75.75 0 1 0 1.143.971l1.905-2.242a.75.75 0 0 0-.572-1.235H6.19z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryChargingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.354 5.146a.5.5 0 0 1 .146.354v3a.5.5 0 0 1-.5.5h-.5v1.5a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1V5h.5a.5.5 0 0 1 .354.146m-5.862.009a.625.625 0 1 0-1.005-.744L4.83 6.651a.625.625 0 0 0 .503.997h1.106L5.771 8.85a.625.625 0 1 0 1.093.607l1.182-2.13a.625.625 0 0 0-.546-.93h-.928z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryEmpty1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-.5V3.5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h.5a.5.5 0 0 0 .5-.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryEmpty1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M13.375 5.25a.5.5 0 0 0-.5-.5h-1.5V3.5a1 1 0 0 0-1-1h-8.75a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h8.75a1 1 0 0 0 1-1V9.25h1.5a.5.5 0 0 0 .5-.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryEmpty1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h10a1.5 1.5 0 0 0 1.5-1.5v-1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1v-1A1.5 1.5 0 0 0 11.5 2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryEmpty2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 2.5h9a1 1 0 0 1 1 1V5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5v1.5a1 1 0 0 1-1 1M.5.5l13 13m-13-10v7a1 1 0 0 0 1 1h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryEmpty2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.067.183a.625.625 0 1 0-.884.884l1.875 1.875l8.642 8.642l2.233 2.233a.625.625 0 1 0 .884-.884l-1.905-1.905A1.6 1.6 0 0 0 12 10.5v-.625h.875A1.125 1.125 0 0 0 14 8.75v-3.5a1.125 1.125 0 0 0-1.125-1.125H12V3.5a1.625 1.625 0 0 0-1.625-1.625H2.759zM.625 3.5c.345 0 .625.28.625.625V10.5a.375.375 0 0 0 .375.375H8a.625.625 0 1 1 0 1.25H1.625A1.625 1.625 0 0 1 0 10.5V4.125C0 3.78.28 3.5.625 3.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryEmpty2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.219.219a.75.75 0 0 0 0 1.06l.178.179q.027.021.051.046l12.328 12.328a.75.75 0 0 0 1.005-1.112l-1.543-1.542a1 1 0 0 0 .262-.675v-1.5h.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-.5v-1.5a1 1 0 0 0-1-1H3.564L1.28.22a.75.75 0 0 0-1.061 0M8.68 11.503L.514 3.337a1 1 0 0 0-.014.166v7a1 1 0 0 0 1 1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryFull1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.25 5v4m3-4v4m3-4v4m4.25-3.5A.5.5 0 0 0 13 5h-.5V3.5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h.5a.5.5 0 0 0 .5-.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryFull1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.875A1.625 1.625 0 0 0 0 3.5v7a1.625 1.625 0 0 0 1.625 1.625h8.75A1.625 1.625 0 0 0 12 10.5v-.625h.875A1.125 1.125 0 0 0 14 8.75v-3.5a1.125 1.125 0 0 0-1.125-1.125H12V3.5a1.625 1.625 0 0 0-1.625-1.625zm-.265 1.36c.07-.07.166-.11.265-.11h8.75a.375.375 0 0 1 .375.375v1.25c0 .345.28.625.625.625h1.375v3.25h-1.375a.625.625 0 0 0-.625.625v1.25a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375v-7c0-.1.04-.195.11-.265M4 5a.75.75 0 0 0-1.5 0v4A.75.75 0 0 0 4 9zm2.75 0a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zm2-.75A.75.75 0 0 1 9.5 5v4A.75.75 0 0 1 8 9V5a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryFull1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.44 2.44A1.5 1.5 0 0 1 1.5 2h10A1.5 1.5 0 0 1 13 3.5v1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1v1a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 0 10.5v-7c0-.398.158-.78.44-1.06M3.374 5a.625.625 0 1 0-1.25 0v4a.625.625 0 1 0 1.25 0zm3.5 0a.625.625 0 1 0-1.25 0v4a.625.625 0 1 0 1.25 0zm2.875-.625c.345 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0V5c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryLow1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-.5V3.5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h.5a.5.5 0 0 0 .5-.5zM3.25 5v4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryLow1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.875A1.625 1.625 0 0 0 0 3.5v7a1.625 1.625 0 0 0 1.625 1.625h8.75A1.625 1.625 0 0 0 12 10.5v-.625h.875A1.125 1.125 0 0 0 14 8.75v-3.5a1.125 1.125 0 0 0-1.125-1.125H12V3.5a1.625 1.625 0 0 0-1.625-1.625zm-.265 1.36c.07-.07.166-.11.265-.11h8.75a.375.375 0 0 1 .375.375v1.25c0 .345.28.625.625.625h1.375v3.25h-1.375a.625.625 0 0 0-.625.625v1.25a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375v-7c0-.1.04-.195.11-.265M4 5a.75.75 0 0 0-1.5 0v4A.75.75 0 0 0 4 9z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryLow1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.44 2.44A1.5 1.5 0 0 1 1.5 2h10A1.5 1.5 0 0 1 13 3.5v1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1v1a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 0 10.5v-7c0-.398.158-.78.44-1.06M3.374 5a.625.625 0 1 0-1.25 0v4a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryMedium1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-.5V3.5a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h.5a.5.5 0 0 0 .5-.5zM3.25 5v4m3-4v4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryMedium1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.875A1.625 1.625 0 0 0 0 3.5v7a1.625 1.625 0 0 0 1.625 1.625h8.75A1.625 1.625 0 0 0 12 10.5v-.625h.875A1.125 1.125 0 0 0 14 8.75v-3.5a1.125 1.125 0 0 0-1.125-1.125H12V3.5a1.625 1.625 0 0 0-1.625-1.625zm-.265 1.36c.07-.07.166-.11.265-.11h8.75a.375.375 0 0 1 .375.375v1.25c0 .345.28.625.625.625h1.375v3.25h-1.375a.625.625 0 0 0-.625.625v1.25a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375v-7c0-.1.04-.195.11-.265M3.25 4.25A.75.75 0 0 1 4 5v4a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75m2.75 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 6 4.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBatteryMedium1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.44 2.44A1.5 1.5 0 0 1 1.5 2h10A1.5 1.5 0 0 1 13 3.5v1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1v1a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 0 10.5v-7c0-.398.158-.78.44-1.06m2.31 1.935c.345 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0V5c0-.345.28-.625.625-.625m3.5 0c.345 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0V5c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeach: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 13.48H13a2 2 0 0 1-2-2a2 2 0 0 1-4 0a2 2 0 0 1-4 0a2 2 0 0 1-2 2H.5m9.5-4a5.49 5.49 0 0 0-8.48 0\"/><path d=\"M6.5 7.53c.06-2.26.75-4.32 2.25-5.06M5.76.57a2.58 2.58 0 0 1 3 1.9\"/><path d=\"M12.41 2.84a2.78 2.78 0 0 0-3.66-.37\"/><path d=\"M5.08 3.54a3 3 0 0 1 3.67-1.07a2.55 2.55 0 0 1 1.89 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeachRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.063 3.638a2.13 2.13 0 0 0-1.259.872a.875.875 0 0 1-1.448-.983A3.88 3.88 0 0 1 6.684 1.93a1.7 1.7 0 0 0-.755-.022A.875.875 0 1 1 5.591.19a3.455 3.455 0 0 1 3.597 1.56a3.66 3.66 0 0 1 3.864.975a.875.875 0 0 1-1.284 1.19a1.9 1.9 0 0 0-.881-.54q.081.11.155.226a3.42 3.42 0 0 1 .454 2.528a.875.875 0 0 1-1.712-.359a1.675 1.675 0 0 0-1.208-1.962c-.367.312-.674.762-.913 1.34c-.276.667-.446 1.472-.511 2.345A6.1 6.1 0 0 1 9.815 8.87a.625.625 0 0 1-.829.936A4.87 4.87 0 0 0 6.47 8.633a1 1 0 0 1-.107-.015a4.87 4.87 0 0 0-4.36 1.738a.625.625 0 0 1-.965-.794a6.12 6.12 0 0 1 4.873-2.23c.077-.95.268-1.865.597-2.662a5.5 5.5 0 0 1 .556-1.032m-2.938 7.737a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-1.607 1.017a.625.625 0 0 0-.893.565v.418c0 .345.28.625.625.625h12c.345 0 .625-.28.625-.625v-.418a.625.625 0 0 0-.893-.565a1.125 1.125 0 0 1-1.607-1.017a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-2.25 0a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeachSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.34 3.291a2.24 2.24 0 0 0-1.287.912a.75.75 0 1 1-1.24-.843a3.75 3.75 0 0 1 2.681-1.62a1.83 1.83 0 0 0-1.236-.193a.75.75 0 0 1-.29-1.471a3.33 3.33 0 0 1 3.52 1.588a3.53 3.53 0 0 1 3.825.908a.75.75 0 1 1-1.1 1.02a2.03 2.03 0 0 0-1.285-.641h-.006q.204.22.367.478a3.3 3.3 0 0 1 .438 2.436a.75.75 0 1 1-1.468-.307a1.8 1.8 0 0 0-1.069-2.03c-.427.291-.786.769-1.059 1.43c-.272.658-.44 1.459-.504 2.332a5.6 5.6 0 0 1 1.58.678c.775.48 1.46 1.15 2.024 1.96a1.5 1.5 0 0 0-.908.643q-.13.206-.262.339a1.01 1.01 0 0 1-1.416 0a2 2 0 0 1-.224-.28c-.387-.576-1.056-.701-1.452-.701s-1.065.125-1.452.701q-.113.166-.224.28a1.01 1.01 0 0 1-1.416 0a2 2 0 0 1-.263-.339c-.37-.587-1.033-.71-1.412-.71c-.206 0-.49.036-.769.16c.576-.853 1.284-1.554 2.087-2.053a5.4 5.4 0 0 1 2.615-.831c.075-.979.269-1.926.61-2.752a5.6 5.6 0 0 1 .595-1.094M2.89 11.49a.75.75 0 0 0-1.382.007a1.5 1.5 0 0 1-.951.857a.75.75 0 1 0 .427 1.438a3 3 0 0 0 1.216-.707q.26.254.576.444c1.047.628 2.571.628 3.618 0a3 3 0 0 0 .575-.443q.26.253.575.443c1.047.628 2.571.628 3.618 0q.316-.19.576-.444l.067.063c.33.297.723.517 1.149.644a.75.75 0 0 0 .427-1.438a1.5 1.5 0 0 1-.951-.857a.75.75 0 0 0-1.382-.007a1.63 1.63 0 0 1-.658.753c-.572.343-1.503.343-2.074 0a1.62 1.62 0 0 1-.658-.753a.75.75 0 0 0-1.378 0a1.62 1.62 0 0 1-.658.753c-.572.343-1.503.343-2.075 0a1.62 1.62 0 0 1-.657-.753\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeanie: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 10.5h-11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m-11 0v-3a5.5 5.5 0 1 1 11 0v3M7 2V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeanieRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625 1a.625.625 0 1 0-1.25 0v.91c-2.812.31-5 2.695-5 5.59v2.136A1.5 1.5 0 0 0 .5 11v1A1.5 1.5 0 0 0 2 13.5h10a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-.875-1.364V7.5a5.626 5.626 0 0 0-5-5.59zM7 3.125A4.375 4.375 0 0 0 2.625 7.5v2h8.75v-2A4.375 4.375 0 0 0 7 3.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeanieSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 1a1 1 0 0 0-2 0v.566a6 6 0 0 0-5 5.916v2.02h12v-2.02a6 6 0 0 0-5-5.916zm-6.923 9.751h11.846c.595 0 1.077.482 1.077 1.077v1.077c0 .595-.482 1.077-1.077 1.077H1.077A1.077 1.077 0 0 1 0 12.905v-1.077c0-.595.482-1.077 1.077-1.077\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeerMug: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5.5h8a1 1 0 0 1 1 1v10a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-10a1 1 0 0 1 1-1m9 2.5h2a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1h-2M3.75 4v5.5M7.25 4v5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeerMugRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v9A2.625 2.625 0 0 0 3 13.625h5a2.625 2.625 0 0 0 2.622-2.5H12c.898 0 1.625-.727 1.625-1.625v-5c0-.897-.727-1.625-1.625-1.625h-1.375V2c0-.897-.728-1.625-1.625-1.625zM9.375 3.5V2A.375.375 0 0 0 9 1.625H2A.375.375 0 0 0 1.625 2v9c0 .76.616 1.375 1.375 1.375h5c.76 0 1.375-.616 1.375-1.375zm1.25 6.375v-5.75H12c.207 0 .375.168.375.375v5a.375.375 0 0 1-.375.375zM4 3.375c.345 0 .625.28.625.625v5.5a.625.625 0 1 1-1.25 0V4c0-.345.28-.625.625-.625M7.625 4a.625.625 0 1 0-1.25 0v5.5a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeerMugSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.414.45A1.42 1.42 0 0 1 1.446 0h7.566c.393 0 .764.165 1.032.45c.268.282.414.66.414 1.05v.75h1.777A1.75 1.75 0 0 1 13.986 4v4.5a1.75 1.75 0 0 1-1.75 1.75h-1.777v1.25a2.56 2.56 0 0 1-.69 1.758A2.34 2.34 0 0 1 8.066 14H2.392c-.644 0-1.255-.27-1.701-.742A2.56 2.56 0 0 1 0 11.5v-10C0 1.11.146.732.414.45m10.044 8.3h1.777a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25h-1.777zm-7.28-5.375c.345 0 .624.28.624.625v5.5a.625.625 0 1 1-1.25 0V4c0-.345.28-.625.625-.625M7.905 4a.625.625 0 1 0-1.25 0v5.5a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeerPitch: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 11h2a1 1 0 0 0 1-1V7.5a1 1 0 0 0-1-1h-1.841M2 6.879v4.62a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6.874\"/><path d=\"M2 6.872a2.25 2.25 0 1 1 1.526-4.235a2.5 2.5 0 0 1 4.948 0A2.25 2.25 0 1 1 9.25 7H5v2a1.5 1.5 0 1 1-3 0z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeerPitchRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.152 2.804a1.876 1.876 0 0 1 3.696 0a.625.625 0 0 0 .783.496a1.377 1.377 0 0 1 1.744 1.325C10.375 5.385 9.759 6 9 6H5.5a.625.625 0 0 0-.625.625v2a.875.875 0 1 1-1.75 0V6.562a.625.625 0 0 0-.47-.605A1.376 1.376 0 1 1 3.37 3.3a.625.625 0 0 0 .783-.496M1.875 8.5V6.997a2.625 2.625 0 0 1 1.208-4.996a3.126 3.126 0 0 1 5.834 0L9 2a2.625 2.625 0 0 1 2.236 4h.264c.967 0 1.75.784 1.75 1.75v3a1.75 1.75 0 0 1-1.75 1.75h-1.38c-.064.84-.765 1.5-1.62 1.5h-5a1.625 1.625 0 0 1-1.625-1.625zm8.25-1V11H11.5a.25.25 0 0 0 .25-.25v-3a.25.25 0 0 0-.25-.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBeerPitchSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.429.071a3.19 3.19 0 0 0-2.943 1.96a2.944 2.944 0 0 0-1.71 5.48V11.5a2.5 2.5 0 0 0 2.5 2.5h3.802a2.5 2.5 0 0 0 2.48-2.188h1.598a1.75 1.75 0 0 0 1.75-1.75v-2.39a1.75 1.75 0 0 0-1.527-1.735A2.944 2.944 0 0 0 9.371 2.03A3.19 3.19 0 0 0 6.43.071M4.758 3.013a1.689 1.689 0 0 1 3.341 0A.75.75 0 0 0 9.1 3.61a1.444 1.444 0 1 1 .498 2.8H5.953a.75.75 0 0 0-.75.75v1.701a.963.963 0 1 1-1.926 0V7.036a.75.75 0 0 0-.5-.708a1.445 1.445 0 1 1 .98-2.718a.75.75 0 0 0 1.001-.597m5.82 4.41h1.578a.25.25 0 0 1 .25.25v2.389a.25.25 0 0 1-.25.25h-1.578z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBicycleBike: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 11.25a2.25 2.25 0 1 0 4.5 0a2.25 2.25 0 0 0-4.5 0m8.5 0a2.25 2.25 0 1 0 4.5 0a2.25 2.25 0 0 0-4.5 0m-2-.75l-3-5\"/><path d=\"M4.953 7.089L2.75 11.25L7 10.5l2.85-3.326m1.4 4.076L8.977 4.628h2.64M3 5.5h2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBicycleBikeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.506 2.867A.63.63 0 0 1 9 2.625h2.5a.625.625 0 1 1 0 1.25H9.807l1.065 4.128Q10.935 8 11 8a3 3 0 1 1-1.339.314l-.21-.814l-3.656 2.408a3 3 0 1 1-.688-1.043l.673-.444l-1.864-2.796H3a.625.625 0 1 1 0-1.25h2.75a.625.625 0 1 1 0 1.25h-.332l1.406 2.109L9.12 6.22l-.726-2.815a.63.63 0 0 1 .11-.539m-4.71 6.86a1.5 1.5 0 1 0 .688 1.044l-1.14.75a.625.625 0 1 1-.688-1.043zm6.599 1.43l-.34-1.321a1.5 1.5 0 1 0 1.21-.313l.34 1.32a.625.625 0 0 1-1.21.313\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBicycleBikeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.985 4.146a.63.63 0 0 1 .515-.271H11a.625.625 0 1 1 0 1.25H9.41l1.166 3.031a2.876 2.876 0 1 1-2.2 1.669l-.885 1.062a.62.62 0 0 1-.429.235l-1.2.15A2.875 2.875 0 1 1 3.694 8.21l.547-1.094l-.595-.991H3a.625.625 0 1 1 0-1.25h2.5a.625.625 0 1 1 0 1.25h-.396l.38.635l.009.013l1.59 2.65L8.89 7.257l-.973-2.532a.63.63 0 0 1 .068-.578m2.432 7.078l-.539-1.4a1.625 1.625 0 1 0 1.167-.448l.538 1.4a.625.625 0 0 1-1.166.448M9.404 8.591l.005.014l-.038.026zm-4.4-.204l-.44.88l-.483.968l1.074-.134l.815-.102zm-.438 3.047l-1.488.186a.625.625 0 0 1-.637-.9l.67-1.341A1.623 1.623 0 0 0 1.375 11a1.625 1.625 0 0 0 3.19.434\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1\"/><path d=\"M7 6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-5.5 5h11m-10 2.5h9M2.775 4.75a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m8.45.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v5.25a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375zM2 .375C1.103.375.375 1.103.375 2v5.25c0 .897.728 1.625 1.625 1.625h10c.898 0 1.625-.728 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625zm3.25 4.25a1.75 1.75 0 1 1 3.5 0a1.75 1.75 0 0 1-3.5 0m-2.75 7.75a.625.625 0 1 0 0 1.25h9a.625.625 0 1 0 0-1.25zM10.725 5.5a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m-7.45 0a.875.875 0 1 1 0-1.75a.875.875 0 1 1 0 1.75m-2.4 5.125c0-.345.28-.625.625-.625h11a.625.625 0 1 1 0 1.25h-11a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0C.699 0 0 .62 0 1.445v5.671c0 .824.699 1.445 1.5 1.445h11c.802 0 1.5-.62 1.5-1.445v-5.67C14 .62 13.302 0 12.5 0zM7 2.477a1.803 1.803 0 1 0 0 3.607a1.803 1.803 0 0 0 0-3.607M3.529 4.502a.752.752 0 1 1-1.504 0a.752.752 0 0 1 1.504 0m7.694.752a.752.752 0 1 0 0-1.504a.752.752 0 0 0 0 1.504M1.086 10.56a.75.75 0 0 1 .75-.75h10.329a.75.75 0 1 1 0 1.5H1.835a.75.75 0 0 1-.75-.75m1.689 1.905a.75.75 0 0 0 0 1.5h8.45a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 2.5h-11a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1\"/><path d=\"M7 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4M2.775 7.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m8.45.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3c0-.207.168-.375.375-.375h10.75c.207 0 .375.168.375.375v8a.375.375 0 0 1-.375.375H1.625A.375.375 0 0 1 1.25 11zm.375-1.625C.728 1.375 0 2.103 0 3v8c0 .898.728 1.625 1.625 1.625h10.75c.898 0 1.625-.727 1.625-1.625V3c0-.897-.727-1.625-1.625-1.625zM9 7a2 2 0 1 1-4 0a2 2 0 0 1 4 0M3.025 8a1 1 0 0 1 0-2a1 1 0 1 1 0 2m7.95 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3.675c0-.824.696-1.45 1.5-1.45h11c.804 0 1.5.626 1.5 1.45v6.65c0 .824-.696 1.45-1.5 1.45h-11c-.804 0-1.5-.626-1.5-1.45zM4.9 7a2.1 2.1 0 1 1 4.2 0a2.1 2.1 0 0 1-4.2 0M3.004 7A.752.752 0 1 1 1.5 7a.752.752 0 0 1 1.504 0m8.744.752a.752.752 0 1 0 0-1.504a.752.752 0 0 0 0 1.504\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill4: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 1.75H1.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1\"/><path d=\"M3.5 12.25h9a1 1 0 0 0 1-1v-5M2.525 5.857a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m6.45.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M5.75 7a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill4Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.635 2.25a.36.36 0 0 0-.375.346v6.558c0 .174.15.346.375.346h8.5a.36.36 0 0 0 .375-.346V2.596a.36.36 0 0 0-.375-.346zM.01 2.596C.01 1.698.755 1 1.635 1h8.5c.88 0 1.625.698 1.625 1.596v.654h.615c.88 0 1.625.698 1.625 1.596v6.558c0 .898-.744 1.596-1.625 1.596h-8.5c-.88 0-1.625-.698-1.625-1.596v-.654h-.615c-.88 0-1.625-.698-1.625-1.596zm1.9 3.279A.875.875 0 1 0 2.785 5a.875.875 0 0 0-.875.875m6.2 0A.875.875 0 1 0 8.985 5a.875.875 0 0 0-.875.875m-2.225-1.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBill4Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 2.65c0-.815.709-1.4 1.485-1.4h8.376c.777 0 1.486.585 1.486 1.4v5.396c0 .815-.71 1.4-1.486 1.4H1.485C.71 9.445 0 8.86 0 8.045zm4.144 2.698a1.53 1.53 0 1 1 3.059 0a1.53 1.53 0 0 1-3.06 0M1.346 5.25a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0M9.25 4.5a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5m4.716.848a.75.75 0 0 0-1.5 0v5a.25.25 0 0 1-.25.25h-9a.75.75 0 1 0 0 1.5h9a1.75 1.75 0 0 0 1.75-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBillCashless: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 2.5h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1m-11-8v7a1 1 0 0 0 1 1H9\"/><path d=\"M5.586 5.586a2 2 0 1 1 2.828 2.828M5.022 7.296a2 2 0 0 0 1.745 1.69M13.5 13.5L.5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBillCashlessRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.067.183a.625.625 0 1 0-.884.884l12.75 12.75a.625.625 0 1 0 .884-.884l-.9-.9A1.63 1.63 0 0 0 14 10.5V3.625C14 2.728 13.273 2 12.375 2H2.884zM5.73 4.846L9.154 8.27A2.5 2.5 0 0 0 5.73 4.846M.625 3.375c.345 0 .625.28.625.625v6.375c0 .207.168.375.375.375h6.25a.625.625 0 1 1 0 1.25h-6.25A1.625 1.625 0 0 1 0 10.375V4c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBillCashlessSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.219 1.28A.75.75 0 0 1 1.279.219l2.007 2.006H12.5c.804 0 1.5.626 1.5 1.45v6.65c0 .718-.528 1.285-1.195 1.42l.976.975a.75.75 0 1 1-1.06 1.061zm8.996 6.875a2.5 2.5 0 0 0-3.373-3.373zM.174 2.995a1.4 1.4 0 0 0-.174.68v6.65c0 .824.696 1.45 1.5 1.45h7.453z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBinanceCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 7.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m-3.2.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m6.4.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4.5 5L7 3l2.5 2m-5 4L7 11l2.5-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBinanceCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0m-.387 2.384a.625.625 0 0 1 .774 0L9.762 4.26a.625.625 0 0 1-.774.982L7 3.67L5.012 5.24a.625.625 0 0 1-.774-.982zM4.134 8.863a.625.625 0 0 1 .878-.104L7 10.33l1.988-1.57a.625.625 0 0 1 .774.982l-2.375 1.875a.625.625 0 0 1-.774 0L4.238 9.74a.625.625 0 0 1-.104-.878M7 7.875a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m-3.2 0a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m6.4 0a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBinanceCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M9.89 3.963l-2.5-2a.625.625 0 0 0-.78 0l-2.5 2a.625.625 0 0 0 .78.976L7 3.252l2.11 1.687a.625.625 0 1 0 .78-.976m-5 5.097a.625.625 0 1 0-.78.976l2.5 2a.625.625 0 0 0 .78 0l2.5-2a.625.625 0 1 0-.78-.976L7 10.748zM7.75 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m-3.95.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5M10.95 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBitcoin: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.79 6.45A2.23 2.23 0 0 0 7.83 2H4.39a.81.81 0 0 0-.81.81v8.09a.81.81 0 0 0 .81.81h3.4a2.63 2.63 0 0 0 0-5.26M5.13 2V.5M7.63 2V.5m-2.5 13v-1.79m2.5 1.79v-1.79m.2-5.26H3.58\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBitcoinRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.625.625a.625.625 0 1 0-1.25 0v.88c-.84.064-1.5.765-1.5 1.62v7.75c0 .855.66 1.556 1.5 1.62v.88a.625.625 0 1 0 1.25 0V12.5h1.75v.875a.625.625 0 1 0 1.25 0v-.926A3.064 3.064 0 0 0 9.64 6.812A3.064 3.064 0 0 0 8.625 1.69V.625a.625.625 0 1 0-1.25 0V1.5h-1.75zm1.938 5.75a1.812 1.812 0 1 0 0-3.625H4.5a.375.375 0 0 0-.375.375v3.25zM8 11.25h.063a1.813 1.813 0 0 0 0-3.625H4.124v3.25c0 .207.168.375.375.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBitcoinSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.744 1.029a1 1 0 1 0-2 0v.604a1.74 1.74 0 0 0-.886 1.518v7.432a1.74 1.74 0 0 0 .886 1.518v.87a1 1 0 1 0 2 0v-.644h1.019v.644a1 1 0 1 0 2 0v-.805A3.416 3.416 0 0 0 9.99 6.353a3.05 3.05 0 0 0-1.227-4.725v-.6a1 1 0 1 0-2 0v.379h-1.02zm-.886 6.466v2.832h2.868a1.416 1.416 0 0 0 .02-2.832zm2.832-2H4.858V3.407h2.86a1.049 1.049 0 0 1-.028 2.088\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlankCalendar: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 2a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2M.5 5.5h13m-10-5v3m7-3v3M3.5 2h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlankCalendarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5.25c.345 0 .625.28.625.625V2h5.75V.875a.625.625 0 1 1 1.25 0V2H12a1.625 1.625 0 0 1 1.625 1.625v8.25A1.625 1.625 0 0 1 12 13.5H2a1.625 1.625 0 0 1-1.625-1.625v-8.25A1.625 1.625 0 0 1 2 2h.875V.875c0-.345.28-.625.625-.625M1.625 6v5.875A.375.375 0 0 0 2 12.25h10a.375.375 0 0 0 .375-.375V6z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlankCalendarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1a1 1 0 0 0-2 0v1h-1A1.5 1.5 0 0 0 0 3.5V5h14V3.5A1.5 1.5 0 0 0 12.5 2h-1V1a1 1 0 1 0-2 0v1h-5zM14 6.25H0v6.25A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlankNotepad: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 3.5v-3m3 3v-3m3 3v-3M12.5 2h-11a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlankNotepadRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5.75a.75.75 0 0 0-1.5 0v.875H2c-.897 0-1.625.728-1.625 1.625v9.125C.375 13.273 1.103 14 2 14h10c.898 0 1.625-.727 1.625-1.625V3.25c0-.897-.727-1.625-1.625-1.625h-1V.75a.75.75 0 0 0-1.5 0v.875H7.75V.75a.75.75 0 0 0-1.5 0v.875H4.5zm5 2.125H7.75v.875a.75.75 0 0 1-1.5 0v-.875H4.5v.875a.75.75 0 0 1-1.5 0v-.875H2a.375.375 0 0 0-.375.375v9.125c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375V3.25A.375.375 0 0 0 12 2.875h-1v.875a.75.75 0 0 1-1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlankNotepadSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1a1 1 0 0 0-2 0v1h-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2h-1V1a1 1 0 1 0-2 0v1H8V1a1 1 0 0 0-2 0v1H4.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlockBellNotification: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 13.5h2M4.48 2.3A4 4 0 0 0 2 6v3.5A1.5 1.5 0 0 1 .5 11h11A1.5 1.5 0 0 1 10 9.5\"/><path d=\"M10.25 7a3.25 3.25 0 1 1 0-6.5a3.25 3.25 0 0 1 0 6.5m2.3-.95l-4.6-4.6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlockBellNotificationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.75 3.875A2.625 2.625 0 0 0 8.764 1.63l3.606 3.606c.241-.397.38-.863.38-1.361m.16 2.695a3.875 3.875 0 0 0-5.48-5.48a.6.6 0 0 0-.09.09a3.875 3.875 0 0 0 5.48 5.48a.6.6 0 0 0 .09-.09m-1.424-.45L7.88 2.514a2.625 2.625 0 0 0 3.606 3.606m-7.111 7.13a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m.379-10.334a.625.625 0 1 0-.508-1.142A4.62 4.62 0 0 0 1.5 6v3.25a.875.875 0 0 1-.875.875a.625.625 0 1 0 0 1.25h11a.625.625 0 1 0 0-1.25a.875.875 0 0 1-.863-.73a.625.625 0 1 0-1.232.21q.046.27.159.52H2.56c.124-.272.189-.57.189-.875V6a3.38 3.38 0 0 1 2.004-3.084\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBlockBellNotificationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 3.748c0 1.01-.4 1.928-1.05 2.602a1 1 0 0 1-.097.097a3.748 3.748 0 0 1-5.3-5.3a1 1 0 0 1 .097-.098A3.748 3.748 0 0 1 14 3.748M10.252 1.5a2.248 2.248 0 0 1 2.03 3.217l-3-2.998a2.24 2.24 0 0 1 .97-.219m-2.03 1.28l2.998 2.998A2.248 2.248 0 0 1 8.222 2.78m2.03 5.967q.16 0 .32-.01v.838c0 .234.1.466.289.642c.219.204.391.283.639.283a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1c.248 0 .42-.079.64-.283a.88.88 0 0 0 .288-.642V5.8c0-1.152.49-2.25 1.351-3.052a4.7 4.7 0 0 1 3.005-1.243a4.998 4.998 0 0 0 4.467 7.242ZM4.25 13.25A.75.75 0 0 1 5 12.5h2A.75.75 0 0 1 7 14H5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodBagDonation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 7.838V3.5a3 3 0 0 1 3-3h5a3 3 0 0 1 3 3v4.338a3 3 0 0 1-2.051 2.846L9.5 11v.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V11l-.949-.316A3 3 0 0 1 1.5 7.838\"/><path d=\"M1.5 8.039c.667-.444 2.7-1.066 5.5 0c2.8 1.065 4.833.222 5.5-.333M8.118 4.661c0-.63-1.118-2.19-1.118-2.19S5.88 4.032 5.88 4.662c0 .31.118.606.328.825s.494.341.79.341s.582-.123.792-.341s.327-.515.327-.825M7 12.5v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodBagDonationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.568 1.25c-.739 0-1.337.598-1.337 1.337V7.33c0 .998.638 1.883 1.584 2.199l.93.31a.625.625 0 0 1 .428.593v.49c0 .197.16.356.356.356h2.942c.197 0 .356-.16.356-.356v-.49c0-.27.172-.508.427-.593l.93-.31A2.32 2.32 0 0 0 11.77 7.33V2.587c0-.739-.598-1.337-1.336-1.337zm1.961 11.279h.846v.846a.625.625 0 0 0 1.25 0v-.846h.846c.887 0 1.606-.72 1.606-1.606v-.04l.503-.167a3.57 3.57 0 0 0 2.44-3.385V2.587A2.587 2.587 0 0 0 10.432 0H3.568A2.587 2.587 0 0 0 .98 2.587V7.33c0 1.536.983 2.899 2.44 3.384l.502.168v.04c0 .887.72 1.606 1.606 1.606M7.406 2.365L7 2.656l-.406-.291a.5.5 0 0 1 .812 0M7 2.656l-.406-.291l-.002.003l-.005.006l-.018.025a17 17 0 0 0-.297.432c-.19.284-.445.675-.701 1.104c-.255.428-.516.9-.715 1.346c-.19.426-.356.895-.356 1.29c0 .68.259 1.335.725 1.82A2.46 2.46 0 0 0 7 9.157a2.46 2.46 0 0 0 1.775-.764a2.63 2.63 0 0 0 .725-1.82c0-.396-.166-.865-.356-1.291a13 13 0 0 0-.715-1.346A25 25 0 0 0 7.431 2.4l-.018-.025l-.005-.006l-.001-.002v-.001z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodBagDonationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.433 7.806v-.13c.944-.301 2.546-.447 4.568.323c2.001.762 3.595.509 4.545.11a2.16 2.16 0 0 1-1.458 1.75l-.912.303a.72.72 0 0 0-.493.684v.481a.24.24 0 0 1-.24.24H5.556a.24.24 0 0 1-.24-.24v-.48a.72.72 0 0 0-.493-.685l-.912-.304a2.16 2.16 0 0 1-1.48-2.052m3.846 5.204h-.721a1.683 1.683 0 0 1-1.683-1.644l-.42-.14A3.61 3.61 0 0 1 .99 7.807V3.635A3.606 3.606 0 0 1 4.596.029h4.808a3.606 3.606 0 0 1 3.606 3.606v4.17c0 1.553-.994 2.93-2.466 3.422l-.42.14a1.683 1.683 0 0 1-1.682 1.643h-.72v.24a.721.721 0 1 1-1.443 0zM7 2.833l.407-.291a.5.5 0 0 0-.813 0zm0 0l-.406-.291l-.001.001l-.003.004l-.008.011l-.03.043a11 11 0 0 0-.419.648a6 6 0 0 0-.327.617c-.085.19-.18.443-.18.68c0 .368.14.724.395.99c.256.267.608.421.98.421c.37 0 .722-.154.978-.42c.256-.267.396-.623.396-.991c0-.237-.096-.49-.18-.68a6 6 0 0 0-.328-.617A11 11 0 0 0 7.45 2.6l-.03-.043l-.008-.011l-.002-.004h-.001v-.001z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodDonateDrop: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.021 12.75l-1.914-1.914a2 2 0 0 1-.586-1.414V5.25a1 1 0 0 1 1-1v0a1 1 0 0 1 1 1v3m8.458 4.5l1.914-1.914a2 2 0 0 0 .586-1.414V5.25a1 1 0 0 0-1-1v0a1 1 0 0 0-1 1v3\"/><path d=\"m3.436 10.078l-.707-.707a1 1 0 0 1 1.414-1.414L5.436 9.25a2 2 0 0 1 .585 1.414v2.086m4.543-2.672l.707-.707a1 1 0 0 0-1.414-1.414L8.564 9.25a2 2 0 0 0-.585 1.414v2.086m1.042-7.584c0-1.127-2-3.916-2-3.916s-2 2.79-2 3.916c0 .552.211 1.083.586 1.474c.375.39.884.61 1.414.61s1.04-.22 1.415-.61a2.13 2.13 0 0 0 .585-1.474\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodDonateDropRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7 .5l.406-.291a.5.5 0 0 0-.812 0zm0 0l.406-.291l.002.003l.006.007l.02.03A19 19 0 0 1 7.78.75c.222.33.52.786.817 1.285c.297.497.6 1.046.83 1.561c.22.496.407 1.03.407 1.472c0 .771-.294 1.515-.822 2.066A2.8 2.8 0 0 1 7 8a2.8 2.8 0 0 1-2.01-.866a3 3 0 0 1-.824-2.066c0-.442.187-.976.409-1.472c.23-.515.532-1.064.829-1.56A29 29 0 0 1 6.565.247l.02-.029l.006-.007l.002-.002zm3.298 6.663a2.26 2.26 0 0 1 2.26-2.26c.796 0 1.442.646 1.442 1.443v4.73c0 .695-.277 1.363-.769 1.855l-.885.886a.625.625 0 1 1-.884-.884l.885-.886c.258-.257.403-.607.403-.972V6.346a.19.19 0 0 0-.192-.192a1.01 1.01 0 0 0-1.01 1.01v2.032l.062.059c.65.65.65 1.705 0 2.355l-.735.736a.625.625 0 1 1-.884-.884l.735-.736a.415.415 0 0 0-.093-.657l-.01-.005a.415.415 0 0 0-.484.075L8.71 11.568a.36.36 0 0 0-.104.252v1.555a.625.625 0 1 1-1.25 0V11.82c0-.426.169-.835.47-1.136l1.43-1.429c.29-.29.662-.452 1.042-.482zm-6.596 0a2.26 2.26 0 0 0-2.26-2.26A1.444 1.444 0 0 0 0 6.347v4.73c0 .695.277 1.363.769 1.855l.885.886a.625.625 0 1 0 .884-.884l-.885-.886a1.38 1.38 0 0 1-.403-.972v-4.73c0-.106.086-.192.192-.192c.558 0 1.01.452 1.01 1.01v2.032l-.062.06c-.65.65-.65 1.704 0 2.354l.735.736a.625.625 0 1 0 .884-.884l-.735-.736a.415.415 0 0 1 .587-.587l1.429 1.43a.36.36 0 0 1 .104.25v1.556a.625.625 0 0 0 1.25 0V11.82c0-.426-.169-.835-.47-1.136l-1.43-1.429a1.66 1.66 0 0 0-1.042-.482z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodDonateDropSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7 .464l.377-.27a.464.464 0 0 0-.754 0zm0 0l-.377-.27l-.002.002l-.005.006L6.6.226a16 16 0 0 0-.276.4a24 24 0 0 0-.652 1.027a12 12 0 0 0-.664 1.25c-.176.395-.33.831-.33 1.198c0 .631.24 1.24.673 1.691s1.027.71 1.649.71s1.215-.258 1.649-.71s.673-1.06.673-1.69c0-.368-.154-.804-.33-1.2a12 12 0 0 0-.664-1.25A23 23 0 0 0 7.4.227L7.384.202L7.379.196L7.378.195L7 .465ZM0 5.112v4.726a2 2 0 0 0 .586 1.414l2.191 2.191V14H6.11v-2.874a2.22 2.22 0 0 0-.65-1.57L4.022 8.118l-.004-.004a.8.8 0 0 0-1.076 1.182l.92.92a.5.5 0 1 1-.707.707l-.92-.92a1.8 1.8 0 0 1-.014-2.53V5.111a1.11 1.11 0 1 0-2.222 0Zm14 4.726V5.112a1.11 1.11 0 0 0-2.222 0v2.361a1.8 1.8 0 0 1-.014 2.532l-.92.919a.5.5 0 0 1-.707-.707l.92-.92A.8.8 0 0 0 9.98 8.115l-.004.004L8.54 9.555a2.22 2.22 0 0 0-.65 1.571V14h3.332v-.556l2.191-2.192A2 2 0 0 0 14 9.838\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodDropDonation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.092 8.954C2.092 4.308 7 .6 7 .6s4.908 3.708 4.908 8.354c0 3.002-2.486 4.446-4.908 4.446s-4.908-1.444-4.908-4.446\"/><path d=\"M6.379 6.014a.38.38 0 0 0-.382.382v1.076H4.92a.38.38 0 0 0-.382.382v1.242c0 .212.171.383.382.383h1.076v1.075c0 .211.17.382.382.382H7.62a.38.38 0 0 0 .383-.382V9.479h1.075a.38.38 0 0 0 .382-.383V7.854a.38.38 0 0 0-.382-.382H8.004V6.396a.38.38 0 0 0-.383-.382z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodDropDonationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7 .625l.319-.537a.63.63 0 0 0-.638 0zm-.472 1.076c.184-.136.344-.247.472-.333a15 15 0 0 1 2.25 1.874c1.306 1.335 2.52 3.143 2.52 5.213c0 2.55-2.349 4.295-4.77 4.295c-2.422 0-4.77-1.744-4.77-4.295c0-2.07 1.213-3.878 2.52-5.213A15 15 0 0 1 6.527 1.7M7 .625L6.68.088L6.678.09l-.004.003L6.66.1a6 6 0 0 0-.234.149a16 16 0 0 0-2.57 2.119C2.465 3.79.98 5.898.98 8.455C.98 11.888 4.097 14 7 14s6.02-2.112 6.02-5.545c0-2.557-1.485-4.665-2.876-6.087a16 16 0 0 0-2.57-2.12L7.34.1L7.325.092L7.321.089H7.32V.087zM5.832 5.739c0-.201.163-.364.364-.364h1.608c.201 0 .364.163.364.364v1.343h1.343c.201 0 .364.163.364.364v1.608a.364.364 0 0 1-.364.364H8.168v1.343a.364.364 0 0 1-.364.364H6.196a.364.364 0 0 1-.364-.364V9.418H4.489a.364.364 0 0 1-.364-.364V7.446c0-.201.163-.364.364-.364h1.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBloodDropDonationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.92.592L6.624.2h-.002l-.004.004l-.012.01a6 6 0 0 0-.21.167a17.4 17.4 0 0 0-2.315 2.338C2.826 4.262 1.514 6.462 1.514 8.956c0 1.655.692 2.91 1.733 3.738c1.028.819 2.37 1.206 3.673 1.206c1.304 0 2.646-.387 3.674-1.206c1.04-.829 1.733-2.083 1.733-3.738c0-2.494-1.312-4.694-2.567-6.237A17.4 17.4 0 0 0 7.445.38l-.21-.168l-.012-.01L7.219.2h-.002a.49.49 0 0 0-.593 0l.037.049zM5.906 5.449c0-.214.173-.387.387-.387h1.256c.214 0 .387.173.387.387v1.537h1.537c.214 0 .387.174.387.387V8.63a.387.387 0 0 1-.387.386H7.936v1.538a.387.387 0 0 1-.387.387H6.292a.387.387 0 0 1-.386-.387V9.016H4.368a.387.387 0 0 1-.386-.386V7.373c0-.213.173-.387.386-.387h1.538V5.45Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetooth: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3.25 9.5l7.5-5.5l-4-3.5v13l4-3.5l-7.5-5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothDisabled: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.75 6.75L10.5 4L6.5.5v5.937M.5.5l13 13M3 9.5l1.875-1.375m3.895 3.389L6.5 13.5V9.31\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothDisabledRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.214.055a.63.63 0 0 1 .67.101l3.968 3.5a.625.625 0 0 1-.048.976L7.734 6.85l6.083 6.083a.625.625 0 0 1-.884.884L6.331 7.215l-.302-.302L.183 1.067a.625.625 0 1 1 .884-.884l4.78 4.78V.624c0-.246.143-.469.367-.57m.882 1.955v3.759l2.342-1.693zM5.268 7.86c.202.28.139.67-.14.873l-1.762 1.273a.625.625 0 1 1-.732-1.014l1.76-1.272a.627.627 0 0 1 .874.14M6.47 9.312c.345 0 .625.28.625.625v2.053l.788-.695a.625.625 0 1 1 .827.937l-1.826 1.612a.625.625 0 0 1-1.039-.469V9.937c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothDisabledSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.219.219a.75.75 0 0 0 0 1.06l.178.179q.027.022.051.046l12.328 12.328a.75.75 0 0 0 1.005-1.112L11.05 9.99a.75.75 0 0 0-.292-.754l-1.731-1.27L7.91 6.851l2.847-2.088a.75.75 0 0 0 .05-1.17L7.02.28a.75.75 0 0 0-1.244.564v3.873L1.28.219a.75.75 0 0 0-1.061 0m8.869 11.692l-1.063-1.063l-.749.655v-1.404l-1.5-1.5v4.557a.75.75 0 0 0 1.244.564zM5.67 8.494L4.597 7.42l-1.83 1.341a.75.75 0 1 0 .888 1.21zm1.605-3.038v-2.96l1.84 1.61z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m2.625 9.5l8.75-5.375l-4.75-3.5v12.75l4.75-3.5L2.625 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothSearching: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 9.5L8.5 4L4.5.5v13l4-3.5L1 4.5m11.033-1c1.9 1.9 1.9 5 0 6.9M10.5 5.305c.859.859.859 2.33 0 3.19\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothSearchingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.839.055a.63.63 0 0 1 .67.101l3.968 3.5a.625.625 0 0 1-.048.976L5.152 7l3.277 2.368a.625.625 0 0 1 .048.976l-3.967 3.5a.625.625 0 0 1-1.039-.469v-5.16l-2.48 1.792A.625.625 0 1 1 .26 8.993L3.017 7L.26 5.007a.625.625 0 1 1 .732-1.014l2.48 1.793V.625c0-.246.144-.469.368-.57m.882 8.176l2.342 1.693l-2.342 2.066zm0-2.462v-3.76l2.342 2.067zm7.012 4.299a4.35 4.35 0 0 0 0-6.136a.5.5 0 1 1 .707-.707a5.35 5.35 0 0 1 0 7.55a.5.5 0 0 1-.707-.707m-1.52-4.296c.657.656.657 1.8 0 2.456a.5.5 0 0 0 .708.707c1.046-1.047 1.046-2.823 0-3.87a.5.5 0 1 0-.708.707\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothSearchingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 .132a.75.75 0 0 1 .803.118L8.61 3.58a.75.75 0 0 1-.05 1.17L5.49 7l3.07 2.25a.75.75 0 0 1 .05 1.17l-3.806 3.33a.75.75 0 0 1-1.244-.565V8.417L1.422 9.984a.75.75 0 1 1-.887-1.21L2.955 7L.535 5.226a.75.75 0 0 1 .887-1.21L3.56 5.583V.815A.75.75 0 0 1 4 .132m1.06 8.412l1.858 1.362l-1.859 1.626zm0-3.087v-2.99l1.858 1.627zm6.075 4.248a3.9 3.9 0 0 0 0-5.505a.75.75 0 0 1 1.06-1.06a5.4 5.4 0 0 1 0 7.626a.75.75 0 1 1-1.06-1.06M9.489 5.918c.524.524.524 1.45 0 1.974a.75.75 0 1 0 1.06 1.06c1.11-1.11 1.11-2.985 0-4.095a.75.75 0 0 0-1.06 1.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBluetoothSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.272.142a1 1 0 0 1 1.042.083l4.404 3.213A1 1 0 0 1 11.65 5.1L8.542 7l3.108 1.9a1 1 0 0 1 .068 1.662l-4.404 3.213a1 1 0 0 1-1.59-.808V8.722l-2.33 1.426A1 1 0 0 1 2.35 8.442L4.708 7L2.35 5.558a1 1 0 1 1 1.043-1.706l2.332 1.426V1.033a1 1 0 0 1 .547-.891m1.453 8.703l1.606.982L7.725 11zm0-3.69V3.001L9.33 4.173z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBomb: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 13.5a6 6 0 1 0 0-12a6 6 0 0 0 0 12\"/><path d=\"M13.5.5h-.671a3 3 0 0 0-2.814 1.959L10 2.5m-6.5 5a3 3 0 0 1 3-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBombRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13 7.5a6.48 6.48 0 0 0-2.141-4.822a2.13 2.13 0 0 1 1.756-.928h.51a.875.875 0 0 0 0-1.75h-.51a3.88 3.88 0 0 0-3.2 1.689A6.5 6.5 0 1 0 13 7.5M6.5 2.25a5.25 5.25 0 1 0 0 10.5a5.25 5.25 0 0 0 0-10.5M4.909 5.909A2.25 2.25 0 0 1 6.5 5.25a.75.75 0 0 0 0-1.5A3.75 3.75 0 0 0 2.75 7.5a.75.75 0 0 0 1.5 0c0-.597.237-1.169.659-1.591\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBombSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.543 2.41a6.5 6.5 0 1 1-1.276-.794A3.75 3.75 0 0 1 12.35 0h.899a.75.75 0 0 1 0 1.5h-.9a2.25 2.25 0 0 0-1.807.91M6.5 5.125A2.375 2.375 0 0 0 4.125 7.5a.625.625 0 1 1-1.25 0A3.625 3.625 0 0 1 6.5 3.875a.625.625 0 1 1 0 1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 2.5a2 2 0 1 0-4 0a2 2 0 0 0 .59 1.41L3.91 8.09A2 2 0 0 0 2.5 7.5a2 2 0 1 0 0 4a2 2 0 0 0 4 0a2 2 0 0 0-.59-1.41l4.18-4.18a2 2 0 0 0 1.41.59a2 2 0 0 0 0-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBoneRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M11.414 2.586a1.962 1.962 0 0 0-3.924 0c.003.52.21 1.017.58 1.383l-4.101 4.1a1.96 1.96 0 0 0-1.383-.579a1.962 1.962 0 0 0 0 3.924a1.962 1.962 0 1 0 3.924 0a1.96 1.96 0 0 0-.58-1.383l4.101-4.1c.366.368.864.576 1.383.579a1.962 1.962 0 1 0 0-3.924\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.846 2.154a2.154 2.154 0 0 0-4.308 0c.003.57.231 1.116.636 1.518L3.672 8.174a2.15 2.15 0 0 0-1.518-.636a2.154 2.154 0 1 0 0 4.308a2.154 2.154 0 0 0 4.308 0a2.15 2.15 0 0 0-.636-1.518l4.502-4.502c.402.405.948.633 1.518.636a2.154 2.154 0 0 0 0-4.308\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBookReading: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5V8.25A1.25 1.25 0 0 1 8.25 7v0A1.25 1.25 0 0 1 9.5 8.25V11h2a2 2 0 0 1 2 2v.5M6.257 3.095A8.24 8.24 0 0 0 1.51.51a.886.886 0 0 0-1.01.877v7.13a.886.886 0 0 0 .788.886a8.2 8.2 0 0 1 3.9 1.627m1.07-5.172V3.095m4.968 6.307a.886.886 0 0 0 .789-.886v-7.13a.886.886 0 0 0-1.01-.877a8.24 8.24 0 0 0-4.748 2.586\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBookReadingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m1.626 1.647l-.001.005V6.9l.011.017l.015.013h.001l.012.002a6.66 6.66 0 0 1 2.949 1.16V3.16A5.44 5.44 0 0 0 1.65 1.625l-.014.008zM6.09 9.482c-.185.116-.49.274-.84.278h-.016c-.312 0-.587-.124-.768-.227a2.4 2.4 0 0 1-.42-.306a5.4 5.4 0 0 0-2.544-1.055A1.294 1.294 0 0 1 .375 6.898v-.002L1 6.9H.375V1.652H1H.375c0-.77.693-1.373 1.456-1.265l.015.003a6.7 6.7 0 0 1 3.392 1.638A6.7 6.7 0 0 1 8.63.39l.014-.003A1.283 1.283 0 0 1 10.1 1.652v1.8a.625.625 0 1 1-1.25 0v-1.8l-.001-.005l-.01-.013l-.014-.008l-.003-.001a5.44 5.44 0 0 0-2.959 1.534v5.178a.623.623 0 0 1 .227 1.145m1.327-3.114a1.424 1.424 0 1 1 2.847 0V8.5h.163a3.073 3.073 0 0 1 3.073 3.073V13a.5.5 0 0 1-.5.5H7.222a.5.5 0 0 1-.384-.18l-.547-.657c-.971-1.165-.34-2.934 1.126-3.238z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBookReadingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.998.055A1.4 1.4 0 0 1 1.58.014l.012.001a8.74 8.74 0 0 1 4.04 1.808v9.832c-1.46-1.016-2.781-1.486-4.414-1.758A1.386 1.386 0 0 1 0 8.515v-7.13A1.39 1.39 0 0 1 .998.056M6.883 5.89V1.823a8.74 8.74 0 0 1 4.04-1.808l.012-.001a1.385 1.385 0 0 1 1.58 1.372v7.129a1.39 1.39 0 0 1-.521 1.09a3.3 3.3 0 0 0-.6-.056h-.75v-1.5a2.5 2.5 0 0 0-3.761-2.16m.01 7.409v-5.25a1.25 1.25 0 0 1 2.5 0v2.75h2a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-5.5a.5.5 0 0 1-.5-.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBookmark: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11 13.5l-4-4l-4 4v-12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBookmark1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M2 1.625v11.75l5-3.5l5 3.5V1.625a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBookmarkSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0a1.5 1.5 0 0 0-1.5 1.5v12a.5.5 0 0 0 .854.354L7 10.207l3.646 3.647a.5.5 0 0 0 .854-.354v-12A1.5 1.5 0 0 0 10 0z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBow: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 2.82s5.107-.928 8.357 2.322s2.322 8.357 2.322 8.357m-8.822-1.856L13.5.5m-2.786 0H13.5v2.786M2.357 2.698V13.5m8.944-1.857H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBowRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.49 1.625L8.697 4.42c-1.557-1.317-3.417-1.8-4.9-1.953a12 12 0 0 0-2.668.024l-.219.033l-.014.002H.891l-.002.001l.111.615l-.112-.615a.625.625 0 0 0 .224 1.23l.006-.001l.033-.005l.138-.02a9 9 0 0 1 .8-.067v6.997H1a.625.625 0 0 0 0 1.25h1.09V13a.625.625 0 1 0 1.25 0v-1.09h6.996a10 10 0 0 1-.067.8l-.02.139l-.005.032v.007a.625.625 0 0 0 1.23.223l-.571-.104l.57.104v-.002l.001-.005l.003-.014l.004-.026l.004-.021l.024-.171c.019-.146.042-.355.06-.613a12 12 0 0 0-.036-2.056c-.153-1.482-.635-3.342-1.952-4.9l2.795-2.794V4.5a.625.625 0 1 0 1.25 0V1.009a.623.623 0 0 0-.615-.634H9.5a.625.625 0 1 0 0 1.25zm-1.172 9.036a10 10 0 0 0-.029-.33c-.136-1.313-.55-2.857-1.597-4.14l-4.47 4.47zm-6.979-.884V3.68q.16.012.329.03c1.313.135 2.858.549 4.14 1.596z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBowSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.464.026a.75.75 0 0 0-.53 1.28l.862.863l-1.653 1.653A9.7 9.7 0 0 0 2.827 1.5a9.8 9.8 0 0 0-2.166.242a.75.75 0 0 0 .332 1.462q.41-.093.834-.144v7.556h-1a.75.75 0 0 0-.693.463v.002a.74.74 0 0 0-.056.312a.75.75 0 0 0 .235.52l1.824 1.824a.75.75 0 0 0 1.297-.513v-.974h7.583a8 8 0 0 1-.144.834a.75.75 0 1 0 1.463.332a9.8 9.8 0 0 0 .241-2.166a9.7 9.7 0 0 0-2.37-6.371l1.65-1.65l.863.863a.75.75 0 0 0 1.28-.53V.776a.747.747 0 0 0-.75-.75zM8.08 4.886a8.2 8.2 0 0 0-4.752-1.871v6.623zm1.065 1.057a8.2 8.2 0 0 1 1.918 4.807H4.337z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBowTie: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/><path d=\"m6.5 8.94l-4.75 1.23a1 1 0 0 1-1.25-1V4.79a1 1 0 0 1 1.25-1L6.5 5.06m1 3.88l4.75 1.23a1 1 0 0 0 1.25-1V4.79a1 1 0 0 0-1.25-1L7.5 5.06\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBowTieRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3.978c0-.84.661-1.604 1.573-1.59c.945.014 1.71.17 2.507.533c.765.35 1.54.884 2.51 1.612a2.5 2.5 0 0 1 .82 0c.97-.728 1.745-1.262 2.51-1.612c.797-.363 1.562-.519 2.507-.533c.912-.014 1.573.75 1.573 1.59v6.024c0 .827-.64 1.584-1.539 1.589c-.944.005-1.704-.14-2.502-.503c-.766-.347-1.55-.885-2.548-1.622a2.5 2.5 0 0 1-.822 0c-.999.737-1.782 1.275-2.548 1.622c-.799.362-1.558.508-2.502.503C.64 11.586 0 10.829 0 10.002zm8.685 4.87c.725.518 1.276.869 1.79 1.102c.614.278 1.191.395 1.98.39c.14 0 .295-.126.295-.338V3.978c0-.215-.16-.342-.304-.34c-.797.012-1.389.138-2.007.42c-.512.234-1.056.581-1.759 1.091c.504.457.82 1.117.82 1.851c0 .732-.314 1.39-.815 1.847M3.56 4.057c.513.234 1.057.581 1.76 1.09A2.5 2.5 0 0 0 4.5 7c0 .732.314 1.39.815 1.847c-.725.52-1.276.87-1.79 1.103c-.613.278-1.191.395-1.98.39c-.14 0-.295-.126-.295-.338V3.978c0-.215.16-.342.304-.34c.797.012 1.389.138 2.006.42\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBowTieSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8.95 9.28l3.703.89c.162.039.332.042.496.01c.163-.033.316-.1.447-.197a1 1 0 0 0 .305-.362A.94.94 0 0 0 14 9.17V4.79a.94.94 0 0 0-.099-.45a1 1 0 0 0-.305-.363a1.1 1.1 0 0 0-.447-.197a1.2 1.2 0 0 0-.496.01l-3.713.922A3 3 0 0 1 10 7c0 .912-.407 1.73-1.05 2.28M7 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-5.653 1.19L5.05 9.3A3 3 0 0 1 4 7.02a2.99 2.99 0 0 1 1.06-2.288L1.347 3.81a1.2 1.2 0 0 0-.495-.01c-.164.033-.317.1-.448.197a1 1 0 0 0-.305.362a.94.94 0 0 0-.098.451v4.38a.94.94 0 0 0 .098.45c.07.142.174.266.305.363a1.15 1.15 0 0 0 .942.187\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBoxSign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-9 10h7\"/><path d=\"M5.5 8.5v-5l-2 2m5 3v-5l2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBoxSignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125.5A1.625 1.625 0 0 0 .5 2.125v9.75A1.625 1.625 0 0 0 2.125 13.5h9.75a1.625 1.625 0 0 0 1.625-1.625v-9.75A1.625 1.625 0 0 0 11.875.5zM1.86 1.86c.07-.07.166-.11.265-.11h9.75a.375.375 0 0 1 .375.375v9.75a.375.375 0 0 1-.375.375h-9.75a.375.375 0 0 1-.375-.375v-9.75c0-.1.04-.195.11-.265m1.765 7.89a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5zm2.162-6.818a.75.75 0 0 1 .463.693v4.75a.75.75 0 0 1-1.5 0v-2.94l-.72.72a.75.75 0 0 1-1.06-1.06l2-2a.75.75 0 0 1 .817-.163m3.243.163a.75.75 0 0 0-1.28.53v4.75a.75.75 0 0 0 1.5 0v-2.94l.72.72a.75.75 0 1 0 1.06-1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBoxSignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5zm3.5 8.375a.625.625 0 1 0 0 1.25h7a.625.625 0 1 0 0-1.25zm2.26-6.944a.63.63 0 0 1 .365.569v4.334a.625.625 0 0 1-1.25 0V4.87l-.966.837a.625.625 0 0 1-.818-.945l2-1.733a.63.63 0 0 1 .669-.097m3.15.097a.625.625 0 0 0-1.035.472v4.334a.625.625 0 0 0 1.25 0V4.87l.966.837a.625.625 0 0 0 .818-.945z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBracesCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 4.5c-.39 0-1.083.304-1.133 1.148c-.03.497-.198 1.017-.643 1.24L3.5 7l.224.112c.445.223.613.743.643 1.24c.05.844.743 1.148 1.133 1.148m3-5c.39 0 1.083.304 1.133 1.148c.03.497.198 1.017.643 1.24L10.5 7l-.224.112c-.445.223-.613.743-.643 1.24A1.174 1.174 0 0 1 8.5 9.5\"/><path d=\"M7 13.25A6.25 6.25 0 1 0 7 .75a6.25 6.25 0 0 0 0 12.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBracesCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M3.743 5.61A1.8 1.8 0 0 1 5.5 3.876a.625.625 0 1 1 0 1.25c-.056 0-.19.03-.305.122c-.096.076-.19.201-.204.438c-.024.387-.126.907-.443 1.315c.317.408.42.928.443 1.315c.014.237.108.362.204.438a.56.56 0 0 0 .305.122a.625.625 0 1 1 0 1.25c-.62 0-1.682-.47-1.757-1.736c-.026-.438-.166-.652-.298-.718L3.22 7.56a.625.625 0 0 1 0-1.118l.225-.112c.132-.066.272-.28.298-.718m6.514 0A1.8 1.8 0 0 0 8.5 3.876a.625.625 0 1 0 0 1.25c.056 0 .19.03.305.122c.096.076.19.201.204.438c.024.387.126.907.443 1.315c-.317.408-.42.928-.443 1.315c-.014.237-.108.362-.204.438a.56.56 0 0 1-.305.122a.625.625 0 1 0 0 1.25c.62 0 1.682-.47 1.757-1.736c.026-.438.166-.652.298-.718l.225-.112a.625.625 0 0 0 0-1.118l-.225-.112c-.132-.066-.272-.28-.298-.718\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBracesCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .25a6.75 6.75 0 1 0 0 13.5A6.75 6.75 0 0 0 7 .25M3.743 5.61A1.8 1.8 0 0 1 5.5 3.876a.625.625 0 1 1 0 1.25c-.056 0-.19.03-.305.122c-.096.076-.19.201-.204.438c-.024.387-.126.907-.443 1.315c.317.408.42.928.443 1.315c.014.237.108.362.204.438a.56.56 0 0 0 .305.122a.625.625 0 1 1 0 1.25c-.62 0-1.682-.47-1.757-1.736c-.026-.438-.166-.652-.298-.718L3.22 7.56a.625.625 0 0 1 0-1.118l.225-.112c.132-.066.272-.28.298-.718M8.5 3.876c.62 0 1.682.47 1.757 1.736c.026.438.166.652.298.718l.225.112a.625.625 0 0 1 0 1.118l-.225.112c-.132.066-.272.28-.298.718A1.8 1.8 0 0 1 8.5 10.125a.625.625 0 1 1 0-1.25c.056 0 .19-.03.305-.122c.096-.076.19-.201.204-.438c.024-.387.126-.907.443-1.315c-.317-.408-.42-.928-.443-1.315c-.014-.237-.108-.362-.204-.438a.56.56 0 0 0-.305-.122a.625.625 0 1 1 0-1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBracket: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 10.5L.5 7L4 3.5m6 7L13.5 7L10 3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBracketSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.476 2.893a1 1 0 1 0-1.46 1.367L11.578 7L9.015 9.74a1 1 0 1 0 1.46 1.367l3.204-3.424a1 1 0 0 0 0-1.366zM4.985 4.26a1 1 0 1 0-1.46-1.367L.32 6.317a1 1 0 0 0 0 1.366l3.203 3.424a1 1 0 0 0 1.46-1.367L2.422 7l2.564-2.74Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrailleBlind: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m2.834 13.45l-.394-.664a1.715 1.715 0 0 1 1.157-2.561l1.036-.195V5.322c0-.765.62-1.385 1.385-1.385v0c.765 0 1.385.62 1.385 1.385v3.212h1.489a2.573 2.573 0 0 1 2.573 2.573v2.343M1.717 1.566a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m4.259.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m6.858.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m0 4.337a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m-2.898.75a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75m-8.22.75a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75m0 4.319a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrailleBlindRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.375 1.25a1 1 0 1 0-2 0a1 1 0 0 0 2 0m3.5 1a1 1 0 1 1 0-2a1 1 0 0 1 0 2m6.75 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0 3a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-2.75 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-8.5 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m.153 4.589a1.73 1.73 0 0 0-.095 2.341l1.359 1.6a.625.625 0 0 0 .952-.81l-1.359-1.6a.479.479 0 0 1 .704-.648l1.22 1.22a.625.625 0 0 0 1.066-.442V5.25a.625.625 0 1 1 1.25 0v3.847a.625.625 0 0 0 .637.625l2.342-.043a1.948 1.948 0 0 1 1.974 2.149l-.154 1.482a.625.625 0 0 0 1.243.13l.154-1.483a3.198 3.198 0 0 0-3.24-3.528l-1.706.031V5.25a1.875 1.875 0 1 0-3.75 0v4.741l-.153-.153a1.73 1.73 0 0 0-2.444 0M.375 7.25a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrailleBlindSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.834 4.077c-.709 0-1.284.575-1.284 1.284v4.968h-.625a1.715 1.715 0 0 0-1.583 2.374L2.88 14h8.005v-3.086A2.573 2.573 0 0 0 8.313 8.34H7.119V5.36c0-.709-.575-1.284-1.285-1.284ZM5.794.584a.947.947 0 1 1 0 1.893a.947.947 0 0 1 0-1.893M9.469 3.91a.947.947 0 1 1 0 1.893a.947.947 0 0 1 0-1.893m2.687 0a.947.947 0 1 1 0 1.893a.947.947 0 0 1 0-1.893M1.845 5.803a.947.947 0 1 1 0-1.893a.947.947 0 0 1 0 1.893m0 3.31a.947.947 0 1 1 0-1.893a.947.947 0 0 1 0 1.893m0-8.53a.947.947 0 1 1 0 1.894a.947.947 0 0 1 0-1.893Zm10.31 0a.947.947 0 1 1 0 1.894a.947.947 0 0 1 0-1.893Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrain: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.62 1.438A2.38 2.38 0 0 1 7 3.818v6.47a2.724 2.724 0 1 1-5.439-.228C.994 9.45.636 8.26.636 7.265c0-1.354.665-2.671 1.617-3.189A2.38 2.38 0 0 1 4.62 1.438\"/><path d=\"M3.511 5.694c-.35-.08-1.141-.599-1.26-1.611M4.97 8.365C6.398 8.205 6.963 6.699 7 6.086M2.29 8.632c-.356.28-.64.917-.731 1.427M9.38 1.438A2.38 2.38 0 0 0 7 3.818v6.47a2.724 2.724 0 1 0 5.439-.228c.567-.61.924-1.8.924-2.795c0-1.354-.664-2.67-1.616-3.189q.013-.126.013-.258a2.38 2.38 0 0 0-2.38-2.38\"/><path d=\"M10.489 5.694c.35-.08 1.141-.599 1.26-1.611M9.03 8.365C7.602 8.205 7.037 6.699 7 6.086m4.71 2.546c.356.28.64.917.731 1.427\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrainCognitive: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 13.5V11h2a1 1 0 0 0 1-1V6a5.5 5.5 0 1 0-8 4.9v2.6\"/><path d=\"M5.5 3.312a3.25 3.25 0 0 0-1.436 3.9c.12.335.48.503.824.412c1.737-.46 3.505-1.705 4.58-2.675c.285-.257.343-.687.09-.975A3.25 3.25 0 0 0 5.5 3.312\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrainCognitiveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.942.768a6.02 6.02 0 0 0-6.019 10.425v2.182a.625.625 0 1 0 1.25 0v-2.55a.63.63 0 0 0-.34-.557a4.77 4.77 0 1 1 6.937-4.25v3.924a.356.356 0 0 1-.356.356H9.452a.625.625 0 0 0-.625.625v2.452a.625.625 0 1 0 1.25 0v-1.827h1.337a1.606 1.606 0 0 0 1.606-1.606V6.019A6.02 6.02 0 0 0 9.942.768M5.375 3.095a3.5 3.5 0 0 1 4.37.714c.36.407.26.992-.11 1.325c-1.088.983-2.891 2.257-4.683 2.732c-.456.12-.956-.1-1.123-.57a3.5 3.5 0 0 1 1.546-4.2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrainCognitiveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.883.002A6 6 0 0 1 13 6v4a1.5 1.5 0 0 1-1.5 1.5H10v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2.303A6 6 0 0 1 6.883.002M3.56 7.21a3.768 3.768 0 0 1 6.373-3.757c.294.334.225.832-.105 1.13C8.582 5.71 6.53 7.154 4.515 7.688c-.398.106-.817-.09-.955-.477\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrainRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.665.98a2.96 2.96 0 0 0-2.958 2.85C.691 4.625 0 5.678 0 7.178c0 1.15.418 1.926 1.033 2.654A3.297 3.297 0 0 0 7 11.655a3.297 3.297 0 0 0 5.968-1.823C13.583 9.104 14 8.328 14 7.178c0-1.5-.692-2.553-1.708-3.347A2.96 2.96 0 0 0 7 2.121A2.96 2.96 0 0 0 4.665.98m-1.71 2.96a1.71 1.71 0 1 1 3.42 0v1.922c-.016.19-.125.588-.374.951c-.248.36-.591.63-1.062.683a.625.625 0 1 0 .14 1.243a2.6 2.6 0 0 0 1.296-.52v1.504a2.047 2.047 0 1 1-4.094 0v-.019c.035-.187.107-.405.204-.602c.104-.212.21-.344.282-.4a.625.625 0 0 0-.775-.982a2.2 2.2 0 0 0-.496.586a2.44 2.44 0 0 1-.247-1.128c0-.816.278-1.44.79-1.972a2.6 2.6 0 0 0 .378.5c.317.33.7.552 1.014.623a.625.625 0 1 0 .278-1.218l-.039-.015a1 1 0 0 1-.098-.051a1.32 1.32 0 0 1-.617-.967zm5.967 4.799a2.6 2.6 0 0 1-1.297-.52v1.504a2.047 2.047 0 1 0 4.094 0v-.019a2.5 2.5 0 0 0-.204-.602c-.104-.212-.21-.344-.282-.4a.625.625 0 1 1 .775-.982c.201.16.366.37.496.586c.165-.332.247-.687.247-1.128c0-.816-.278-1.44-.79-1.972a2.6 2.6 0 0 1-.378.5c-.317.33-.7.552-1.014.623a.625.625 0 1 1-.278-1.218l.039-.015a1 1 0 0 0 .098-.051a1.32 1.32 0 0 0 .617-.966v-.14a1.71 1.71 0 0 0-3.42 0v1.923c.016.19.125.588.374.951c.248.36.59.63 1.062.683a.625.625 0 1 1-.14 1.243\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrainSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.382.824c.798 0 1.513.357 1.993.92v4.563c-.017.205-.133.633-.4 1.023c-.265.385-.635.678-1.144.734a.625.625 0 1 0 .139 1.243a2.7 2.7 0 0 0 1.405-.585v3.67a2.997 2.997 0 0 1-5.336-1.389c.114-.351.3-.654.478-.795a.625.625 0 1 0-.775-.98a2 2 0 0 0-.259.244A5.65 5.65 0 0 1 0 7.234c0-.974.312-1.931.822-2.636c.11.213.242.4.384.562c.369.42.83.692 1.189.774a.625.625 0 0 0 .277-1.219c-.057-.013-.298-.119-.527-.38c-.184-.21-.343-.5-.382-.89v-.003A2.62 2.62 0 0 1 4.382.824m5.615 12.732a3 3 0 0 1-2.372-1.164V6.548c.256.186.528.338.792.45a.625.625 0 1 0 .486-1.153c-.553-.233-1.062-.685-1.24-1.1l-.038-.074V1.744a2.618 2.618 0 0 1 4.596 1.982l.002.001c-.063.41-.23.788-.41.965a.625.625 0 1 0 .878.89a2.5 2.5 0 0 0 .557-.883c.468.693.752 1.606.752 2.535c0 1.09-.39 2.394-1.01 3.066l-.023-.001a1.7 1.7 0 0 1-.476-.11c-.363-.136-.801-.42-1.183-.975a.625.625 0 1 0-1.03.71c.53.77 1.178 1.211 1.773 1.435c.265.1.531.16.778.183a3 3 0 0 1-2.832 2.014\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBriefcaseDollar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 3.5h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-2.5 0v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2\"/><path d=\"M8.276 7.167a1 1 0 0 0-.943-.667H6.56a.893.893 0 0 0-.19 1.765l1.178.257a1 1 0 0 1-.214 1.978h-.666a1 1 0 0 1-.943-.667M7 6.5v-1m0 6v-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBriefcaseDollarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.674.55C4.026.197 4.503 0 5 0h4a1.875 1.875 0 0 1 1.875 1.875v.875h1.5c.898 0 1.625.728 1.625 1.625v8c0 .898-.727 1.625-1.625 1.625H1.625A1.625 1.625 0 0 1 0 12.375v-8C0 3.478.728 2.75 1.625 2.75h1.5v-.875c0-.497.198-.974.55-1.326m5.451 1.325v.875h-4.25v-.875A.125.125 0 0 1 5 1.75h4a.125.125 0 0 1 .125.125M1.625 4a.375.375 0 0 0-.375.375v8c0 .207.168.375.375.375h10.75a.375.375 0 0 0 .375-.375v-8A.375.375 0 0 0 12.375 4zm6 1.25v.354a1.71 1.71 0 0 1 1.347 1.118a.625.625 0 1 1-1.178.417a.46.46 0 0 0-.433-.306h-.838a.342.342 0 0 0-.074.676l1.277.28a1.709 1.709 0 0 1-.101 3.357v.354a.625.625 0 1 1-1.25 0v-.354a1.71 1.71 0 0 1-1.347-1.118a.625.625 0 1 1 1.178-.417a.46.46 0 0 0 .433.306h.722a.459.459 0 0 0 .098-.907l-1.277-.28a1.592 1.592 0 0 1 .193-3.14v-.34a.625.625 0 1 1 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBriefcaseDollarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.763.587A1.75 1.75 0 0 1 5 .074h4a1.75 1.75 0 0 1 1.75 1.75V3h1.75A1.5 1.5 0 0 1 14 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8A1.5 1.5 0 0 1 1.5 3h1.75V1.824c0-.464.184-.91.513-1.237M9.25 1.824V3h-4.5V1.824a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25M7.75 4.75a.75.75 0 0 0-1.5 0v.51a1.866 1.866 0 0 0-.2 3.679l1.474.322a.5.5 0 0 1-.107.99h-.834a.5.5 0 0 1-.471-.334a.75.75 0 1 0-1.415.5c.239.674.83 1.184 1.553 1.305v.528a.75.75 0 0 0 1.5 0v-.528a2.001 2.001 0 0 0 .094-3.927l-1.473-.322a.366.366 0 0 1 .078-.723h.968a.5.5 0 0 1 .471.333a.75.75 0 1 0 1.415-.5A2 2 0 0 0 7.75 5.279z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 8.998a1.998 1.998 0 1 0 0-3.996a1.998 1.998 0 0 0 0 3.996M7 .5v1m0 11v1M13.5 7h-1m-11 0h-1m11.1-4.6l-.71.71m-7.78 7.78l-.71.71m9.2 0l-.71-.71M3.11 3.11L2.4 2.4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625v1a.625.625 0 1 1-1.25 0v-1C6.375.28 6.655 0 7 0m0 5.627a1.373 1.373 0 1 0 0 2.746a1.373 1.373 0 0 0 0-2.746M4.377 7a2.623 2.623 0 1 1 5.246 0a2.623 2.623 0 0 1-5.246 0m3.248 5.375a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0zM14 7c0 .345-.28.625-.625.625h-1a.625.625 0 1 1 0-1.25h1c.345 0 .625.28.625.625m-12.375.625a.625.625 0 1 0 0-1.25h-1a.625.625 0 1 0 0 1.25zM2.05 2.05a.625.625 0 0 1 .884 0l.707.707a.625.625 0 0 1-.884.884l-.707-.707a.625.625 0 0 1 0-.884m9.193 8.309a.625.625 0 0 0-.884.884l.707.707a.625.625 0 1 0 .884-.884zm.707-8.309a.625.625 0 0 1 0 .884l-.707.707a.625.625 0 1 1-.884-.884l.707-.707a.625.625 0 0 1 .884 0m-8.31 9.193a.625.625 0 0 0-.884-.884l-.707.707a.625.625 0 0 0 .884.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 7 0m2.25 7a2.25 2.25 0 1 1-4.5 0a2.25 2.25 0 0 1 4.5 0m-1.5 5.25a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zM11.5 7a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 11.5 7M.75 6.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm1.3-4.2a.75.75 0 0 1 1.06 0l.862.86A.75.75 0 0 1 2.91 3.973l-.86-.861a.75.75 0 0 1 0-1.06m9.04 7.978a.75.75 0 1 0-1.062 1.06l.861.862a.75.75 0 0 0 1.06-1.061zm.86-7.978a.75.75 0 0 1 0 1.06l-.86.862a.75.75 0 0 1-1.062-1.061l.861-.86a.75.75 0 0 1 1.06 0M3.972 11.09a.75.75 0 1 0-1.061-1.06l-.86.86a.75.75 0 0 0 1.06 1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 7A3.25 3.25 0 0 0 7 10.25v-6.5A3.25 3.25 0 0 0 3.75 7M7 .5v1m0 11v1M13.5 7h-1m-11 0h-1m11.1-4.6l-.71.71m-7.78 7.78l-.71.71m9.2 0l-.71-.71M3.11 3.11L2.4 2.4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625v1a.625.625 0 1 1-1.25 0v-1C6.375.28 6.655 0 7 0m-.625 4.579a2.501 2.501 0 0 0 0 4.842zM3.25 7A3.75 3.75 0 0 1 7 3.25c.345 0 .625.28.625.625v6.25c0 .345-.28.625-.625.625A3.75 3.75 0 0 1 3.25 7m4.375 5.375a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0zM14 7c0 .345-.28.625-.625.625h-1a.625.625 0 1 1 0-1.25h1c.345 0 .625.28.625.625m-12.375.625a.625.625 0 1 0 0-1.25h-1a.625.625 0 1 0 0 1.25zM2.05 2.05a.625.625 0 0 1 .884 0l.707.707a.625.625 0 0 1-.884.884l-.707-.707a.625.625 0 0 1 0-.884m9.193 8.309a.625.625 0 0 0-.884.884l.707.707a.625.625 0 1 0 .884-.884zm.707-8.309a.625.625 0 0 1 0 .884l-.707.707a.625.625 0 1 1-.884-.884l.707-.707a.625.625 0 0 1 .884 0m-8.31 9.193a.625.625 0 0 0-.884-.884l-.707.707a.625.625 0 0 0 .884.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 7 0m0 11.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 7 11.5m5.25-5.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zM0 7a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 0 7m3.11-4.95a.75.75 0 1 0-1.06 1.06l.86.862A.75.75 0 0 0 3.973 2.91zm6.918 7.978a.75.75 0 0 1 1.061 0l.86.86a.75.75 0 0 1-1.06 1.062l-.86-.861a.75.75 0 0 1 0-1.06m1.922-6.917a.75.75 0 1 0-1.06-1.06l-.862.86a.75.75 0 0 0 1.061 1.06zm-7.978 6.917a.75.75 0 0 1 0 1.06l-.861.862a.75.75 0 1 1-1.06-1.061l.86-.86a.75.75 0 0 1 1.06 0m2.53.184a3.25 3.25 0 0 1 0-6.424c.273-.042.498.186.498.462v5.5c0 .276-.225.504-.498.462\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v1m0 11v1M13.5 7h-1m-11 0h-1m11.1-4.6l-.71.71m-7.78 7.78l-.71.71m9.2 0l-.71-.71M3.11 3.11L2.4 2.4M7 7.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625v1a.625.625 0 1 1-1.25 0v-1C6.375.28 6.655 0 7 0m1.5 7a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-.875 5.375a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0zM14 7c0 .345-.28.625-.625.625h-1a.625.625 0 1 1 0-1.25h1c.345 0 .625.28.625.625m-12.375.625a.625.625 0 1 0 0-1.25h-1a.625.625 0 1 0 0 1.25zM2.05 2.05a.625.625 0 0 1 .884 0l.707.707a.625.625 0 0 1-.884.884l-.707-.707a.625.625 0 0 1 0-.884m9.193 8.309a.625.625 0 0 0-.884.884l.707.707a.625.625 0 1 0 .884-.884zm.707-8.309a.625.625 0 0 1 0 .884l-.707.707a.625.625 0 1 1-.884-.884l.707-.707a.625.625 0 0 1 .884 0m-8.31 9.193a.625.625 0 0 0-.884-.884l-.707.707a.625.625 0 0 0 .884.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrightness3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 7 0m1 7a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-.25 5.25a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zM11.5 7a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 11.5 7M.75 6.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5zm1.3-4.2a.75.75 0 0 1 1.06 0l.862.86A.75.75 0 0 1 2.91 3.973l-.86-.861a.75.75 0 0 1 0-1.06m9.04 7.978a.75.75 0 1 0-1.062 1.06l.861.862a.75.75 0 0 0 1.06-1.061zm.86-7.978a.75.75 0 0 1 0 1.06l-.86.862a.75.75 0 0 1-1.062-1.061l.861-.86a.75.75 0 0 1 1.06 0M3.972 11.09a.75.75 0 1 0-1.061-1.06l-.86.86a.75.75 0 0 0 1.06 1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrokenLink2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13M6 3l1.464-1.464a3.536 3.536 0 0 1 5 5L11 8m-3 3l-1.464 1.465a3.536 3.536 0 0 1-5-5L3 6m6-1L7 7M5 9l.5-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrokenLink2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 1 .884 0L6.735 5.85l1.558-1.558a1 1 0 1 1 1.414 1.414L8.15 7.265l5.669 5.669a.625.625 0 1 1-.884.884L.183 1.066a.625.625 0 0 1 0-.883m6.92 12.598a4.16 4.16 0 1 1-5.884-5.883l1-1a.625.625 0 0 1 .884.883l-1 1a2.91 2.91 0 1 0 4.116 4.117l1-1a.625.625 0 1 1 .884.883zM12.782 1.22a4.16 4.16 0 0 0-5.884 0l-1.25 1.25a.625.625 0 1 0 .883.883l1.25-1.25a2.91 2.91 0 0 1 4.117 4.117l-1.25 1.25a.625.625 0 1 0 .883.883l1.25-1.25a4.16 4.16 0 0 0 0-5.883M4.292 8.293a1 1 0 1 0 1.414 1.414l.741-.74l-1.414-1.415z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrokenLink2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.627 2.735a2.51 2.51 0 0 1 3.549 3.549L9.258 8.2L8.19 7.134l.96-.96a1 1 0 1 0-1.414-1.415l-.96.961l-1.068-1.067l1.918-1.918Zm-3.332.504L6.213 1.32a4.51 4.51 0 1 1 6.377 6.377l-1.918 1.918l3.014 3.014a.744.744 0 0 1-1.053 1.052L.225 1.274A.744.744 0 0 1 1.278.221L4.295 3.24Zm-1.56 2.974a1 1 0 0 1 0 1.414a2.51 2.51 0 0 0 3.549 3.549a1 1 0 0 1 1.414 1.414A4.51 4.51 0 1 1 1.32 6.213a1 1 0 0 1 1.414 0Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-12 3h13m-4 5h-5M7 6v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548zM7.75 5.5a.75.75 0 0 0-1.5 0v1.75H4.5a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0V8.75H9.5a.75.75 0 0 0 0-1.5H7.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 2.815v9.434c0 .113.092.205.205.205h10.498a.204.204 0 0 0 .205-.205V2.815zM1.751.046C.809.046.046.81.046 1.751v10.498c0 .942.763 1.705 1.705 1.705h10.498c.942 0 1.705-.763 1.705-1.705V1.751c0-.942-.763-1.705-1.705-1.705zM3.75 7.75A.75.75 0 0 1 4.5 7h1.75V5.25a.75.75 0 0 1 1.5 0V7H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 1 1-1.5 0V8.5H4.5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserBlock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 3.494h13M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M7 11.5a3 3 0 1 0 0-6a3 3 0 0 0 0 6m2.123-.877L4.877 6.377\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserBlockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548zM7 4.625a3.375 3.375 0 1 0 2.377 5.771l.01-.01l.01-.01A3.375 3.375 0 0 0 7 4.626m1.879 4.37a2.125 2.125 0 0 0-2.873-2.873zm-3.757-1.99a2.125 2.125 0 0 0 2.873 2.873z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserBlockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 3.315v8.934c0 .113.092.205.205.205h10.498a.204.204 0 0 0 .205-.205V3.315zM1.751.046C.809.046.046.81.046 1.751v10.498c0 .942.763 1.705 1.705 1.705h10.498c.942 0 1.705-.763 1.705-1.705V1.751c0-.942-.763-1.705-1.705-1.705zM7 4a3.748 3.748 0 1 1-3.75 3.748c0-.986.399-1.954 1.097-2.652A3.78 3.78 0 0 1 7 4m0 1.5a2.248 2.248 0 0 1 2.03 3.217l-3-2.997A2.24 2.24 0 0 1 7 5.5M4.97 6.78l2.998 2.998A2.248 2.248 0 0 1 4.97 6.78\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserBuild: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7.5v5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h4v7zm-13-4h13m-3.5 4v-7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserBuildRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V8.125H5.5a.625.625 0 0 1-.625-.625V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V7.5A.625.625 0 0 0 13 6.875h-2.375v-2.25h2.125a.875.875 0 0 0 0-1.75h-2.125V1.25a.875.875 0 0 0-1.75 0v1.625h-2.75V1A.625.625 0 0 0 5.5.375zm6.952 4.25h-2.75v2.25h2.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserBuildSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.54 12.255V3.334h3.277v4.144c0 .414.336.75.75.75h4.25a.75.75 0 0 0 .365 0h2.278v4.027a.205.205 0 0 1-.206.205H1.745a.205.205 0 0 1-.205-.206m9.21-5.527h2.46a.75.75 0 0 1 .75.75v4.777a1.705 1.705 0 0 1-1.705 1.705H1.745A1.705 1.705 0 0 1 .04 12.254V1.745A1.705 1.705 0 0 1 1.745.04h3.822a.75.75 0 0 1 .75.75v1.044H9.25V.79a.75.75 0 0 1 1.5 0v1.044h2.46a.75.75 0 0 1 0 1.5h-2.46zm-1.5 0V3.334H6.317v3.394z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-12 3h13\"/><path d=\"m4 9l2 1.5l3.5-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548zm8.32 5.06a.75.75 0 0 1 .071 1.059l-3.5 4A.75.75 0 0 1 5.8 10.6l-2-1.5a.75.75 0 1 1 .9-1.2l1.444 1.083l3.042-3.477a.75.75 0 0 1 1.058-.07\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 12.25V3.314h10.908v8.934a.204.204 0 0 1-.205.205H1.751a.204.204 0 0 1-.205-.205M1.751.045A1.707 1.707 0 0 0 .046 1.751v10.498c0 .942.763 1.705 1.705 1.705h10.498c.942 0 1.705-.763 1.705-1.705V1.751c0-.942-.763-1.705-1.705-1.705zm8.313 6.39a.75.75 0 1 0-1.128-.987L5.894 8.925L4.45 7.843a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.014-.106z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-12 3h13m-4.5 7l-4-4m4 0l-4 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserDeleteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548zM5.53 5.47a.75.75 0 0 0-1.06 1.06L5.94 8L4.47 9.47a.75.75 0 1 0 1.06 1.06L7 9.06l1.47 1.47a.75.75 0 1 0 1.06-1.06L8.06 8l1.47-1.47a.75.75 0 0 0-1.06-1.06L7 6.94z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserDeleteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 12.25V3.314h10.908v8.934a.204.204 0 0 1-.205.205H1.751a.204.204 0 0 1-.205-.205M1.751.045A1.707 1.707 0 0 0 .046 1.751v10.498c0 .942.763 1.705 1.705 1.705h10.498c.942 0 1.705-.763 1.705-1.705V1.751c0-.942-.763-1.705-1.705-1.705zM4.47 5.3a.75.75 0 0 1 1.06 0L7 6.77L8.47 5.3a.75.75 0 0 1 1.06 1.061l-1.47 1.47L9.53 9.3a.75.75 0 1 1-1.06 1.06L7 8.891l-1.47 1.47a.75.75 0 0 1-1.06-1.06l1.47-1.47l-1.47-1.47a.75.75 0 0 1 0-1.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserHash: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 3.494h13M6.546 5.689l-1.817 5.302M9.27 5.689l-1.816 5.302m2.726-3.937H4.274m5.451 2.725H3.821M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserHashRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548zm5.214 5.176a.625.625 0 1 0-1.182-.405l-.323.943H4.275a.625.625 0 1 0 0 1.25h.928l-.505 1.475h-.877a.625.625 0 1 0 0 1.25h.449l-.132.385a.625.625 0 1 0 1.182.405l.271-.79h1.404l-.132.385a.625.625 0 1 0 1.182.405l.271-.79h1.41a.625.625 0 1 0 0-1.25h-.982l.506-1.475h.93a.625.625 0 1 0 0-1.25h-.502l.184-.538a.625.625 0 1 0-1.182-.405l-.323.943H6.953zm.286 3.263l.506-1.475H6.525l-.506 1.475z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserHashSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 12.25V3.314h10.908v8.934a.204.204 0 0 1-.205.205H1.751a.204.204 0 0 1-.205-.205M1.751.045A1.707 1.707 0 0 0 .046 1.751v10.498c0 .942.763 1.705 1.705 1.705h10.498c.942 0 1.705-.763 1.705-1.705V1.751c0-.942-.763-1.705-1.705-1.705zm5.038 4.51c.392.134.6.56.466.952l-.127.372h1.14l.293-.858a.75.75 0 0 1 1.42.486l-.128.372h.326a.75.75 0 0 1 0 1.5h-.84l-.42 1.225h.806a.75.75 0 0 1 0 1.5h-1.32l-.241.705a.75.75 0 0 1-1.42-.486l.076-.22H5.68l-.241.706a.75.75 0 0 1-1.42-.486l.076-.22H3.82a.75.75 0 1 1 0-1.5h.788l.42-1.224h-.754a.75.75 0 0 1 0-1.5h1.267l.294-.858a.75.75 0 0 1 .953-.466m.965 2.824l-.42 1.225h-1.14l.42-1.225z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserLock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\"><path d=\"M4.75 10.5v-2a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3.5a.5.5 0 0 1-.5-.5Z\"/><path stroke-linecap=\"round\" d=\"M5.5 8V7A1.5 1.5 0 0 1 7 5.5v0A1.5 1.5 0 0 1 8.5 7v1m-8-4.506h13\"/><path stroke-linecap=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserLockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548zm4.327 6.25a.75.75 0 0 1 1.5 0v.625h-1.5zM5 7.282v-.657a2 2 0 1 1 4 0v.657a1 1 0 0 1 .75.968v2a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1v-2A1 1 0 0 1 5 7.282\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserLockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 3.315v8.934c0 .113.092.205.205.205h10.498a.204.204 0 0 0 .205-.205V3.315zM1.751.046C.809.046.046.81.046 1.751v10.498c0 .942.763 1.705 1.705 1.705h10.498c.942 0 1.705-.763 1.705-1.705V1.751c0-.942-.763-1.705-1.705-1.705zM7 5.75a.875.875 0 0 0-.875.875v.5h1.75v-.5A.875.875 0 0 0 7 5.75m-2.125.875v.72a1 1 0 0 0-.375.78v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-.375-.78v-.72a2.125 2.125 0 0 0-4.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserMultipleWindow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 5V1.5a1 1 0 0 1 1-1h8.5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H11m-8-7h10.5\"/><path d=\"M7.5 7.5h-6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1M.5 10h8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserMultipleWindowRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.625 3.5V5a.625.625 0 1 1-1.25 0V1.625A1.625 1.625 0 0 1 4 0h8.375A1.625 1.625 0 0 1 14 1.625V9.5a1.625 1.625 0 0 1-1.625 1.625H11a.625.625 0 1 1 0-1.25h1.375a.375.375 0 0 0 .375-.375v-6zM1.25 12.375V10h6.625v2.375a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375M0 8.5c0-.897.728-1.625 1.625-1.625H7.5c.897 0 1.625.728 1.625 1.625v3.875C9.125 13.273 8.397 14 7.5 14H1.625A1.625 1.625 0 0 1 0 12.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserMultipleWindowSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.442 8.224V3.36H4.39v1.194a.75.75 0 1 1-1.5 0v-2.82C2.89.793 3.652.03 4.594.03h7.644c.941 0 1.704.763 1.704 1.704v6.49c0 .94-.763 1.704-1.704 1.704h-.776a.75.75 0 0 1 0-1.5h.776a.204.204 0 0 0 .204-.204M1.605 9.827v2.406c0 .113.091.204.204.204h6.046a.204.204 0 0 0 .205-.204V9.827zm6.25-3.33H1.81c-.941 0-1.704.763-1.704 1.704v4.032c0 .941.763 1.704 1.704 1.704h6.046c.941 0 1.705-.763 1.705-1.704V8.2c0-.941-.764-1.704-1.705-1.704\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserRemove: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-12 3h13m-4 5h-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserRemoveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548zM3.75 8a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5A.75.75 0 0 1 3.75 8\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserRemoveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 12.25V3.314h10.908v8.934a.204.204 0 0 1-.205.205H1.751a.204.204 0 0 1-.205-.205M1.751.045A1.707 1.707 0 0 0 .046 1.751v10.498c0 .942.763 1.705 1.705 1.705h10.498c.942 0 1.705-.763 1.705-1.705V1.751c0-.942-.763-1.705-1.705-1.705zm3.127 7.016a.75.75 0 1 0 0 1.5h4.244a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserWebsite1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 3.494h13M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserWebsite1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.518v8.559c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V3.518zM1.923.375c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548h10.154c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserWebsite1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 12.25V3.314h10.908v8.934a.204.204 0 0 1-.205.205H1.751a.204.204 0 0 1-.205-.205Zm-1.5-10.5C.046.81.81.047 1.751.047h10.498c.942 0 1.705.763 1.705 1.705V12.25c0 .942-.763 1.705-1.705 1.705H1.751A1.704 1.704 0 0 1 .046 12.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserWifi: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 13h11a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1m-1-9h13\"/><path d=\"M3.55 7.425c1.9-1.9 5-1.9 6.9 0M5.355 8.958c.859-.859 2.33-.859 3.19 0M6.95 11.297a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserWifiRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 3.518v8.559c0 .234.19.423.423.423h10.154c.234 0 .423-.19.423-.423V3.518zM1.923.5C1.137.5.5 1.137.5 1.923v10.154c0 .786.637 1.423 1.423 1.423h10.154c.786 0 1.423-.637 1.423-1.423V1.923C13.5 1.137 12.863.5 12.077.5zm8.085 6.867a4.264 4.264 0 0 0-6.016 0a.625.625 0 0 1-.884-.884a5.514 5.514 0 0 1 7.784 0a.625.625 0 1 1-.884.884M5.797 8.9c.614-.615 1.69-.615 2.305 0a.625.625 0 0 0 .884-.884c-1.103-1.103-2.97-1.103-4.073 0a.625.625 0 0 0 .884.884m.278 1.647a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBrowserWifiSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 3.361v8.934c0 .113.092.205.205.205h10.453a.25.25 0 0 0 .25-.25V3.36H1.546ZM1.751.092C.809.092.046.855.046 1.797v10.498C.046 13.238.81 14 1.751 14h10.453a1.75 1.75 0 0 0 1.75-1.75V1.797c0-.942-.763-1.705-1.705-1.705zm2.688 7.02a3.63 3.63 0 0 1 5.122 0a.75.75 0 0 0 1.06-1.062a5.13 5.13 0 0 0-7.243 0A.75.75 0 0 0 4.44 7.111ZM5.906 8.73c.582-.581 1.606-.581 2.188 0a.75.75 0 1 0 1.06-1.06c-1.167-1.168-3.141-1.168-4.309 0a.75.75 0 0 0 1.061 1.06m1.844 1.342a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBug: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 12.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9M2.5 8h-2m0 3.5a3.46 3.46 0 0 0 2.63-1.2\"/><path d=\"M3.13 5.7A3.46 3.46 0 0 0 .5 4.5m11 3.5h2m0 3.5a3.46 3.46 0 0 1-2.63-1.2m0-4.6a3.46 3.46 0 0 1 2.63-1.2m-5.26-.83A2.5 2.5 0 0 0 9.5 1.5m-5 0a2.5 2.5 0 0 0 1.26 2.17M2.61 7h8.78\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugAntivirusDebugging: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.5 10.5l1.3-1.3M4.5 7H3m7.5-3.5L9.2 4.8M9.5 7H11m-4.5-.5h3M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0m11.096 4.596L2.404 2.404\"/><path d=\"M4.804 4.804A2.5 2.5 0 0 1 9.5 6v2a2.5 2.5 0 0 1-.304 1.196M4.5 7v1a2.5 2.5 0 0 0 3.172 2.408\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugAntivirusDebuggingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.73 5.73 0 0 0-3.6 1.266l1.333 1.333l.057-.059a3.125 3.125 0 0 1 4.477.06l.416-.417a.625.625 0 1 1 .884.884l-.626.626c.12.336.184.693.184 1.057v.375H11a.625.625 0 1 1 0 1.25h-.875V8c0 .364-.063.721-.184 1.057l1.544 1.544A5.751 5.751 0 0 0 7 1.25M1.249 7.001c0-1.363.474-2.616 1.267-3.601l8.085 8.085A5.751 5.751 0 0 1 1.25 7.001m-1.25 0a7.001 7.001 0 1 1 14.002 0A7.001 7.001 0 0 1 0 7.001M5.125 7a.625.625 0 0 0-.625-.625H3a.625.625 0 1 0 0 1.25h.875V8c0 .364.064.721.184 1.057l-.626.626a.625.625 0 0 0 .884.884l.416-.416l.057.059a3.13 3.13 0 0 0 2.835.852a.625.625 0 0 0-.25-1.225A1.875 1.875 0 0 1 5.125 8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugAntivirusDebuggingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.594 7a5.38 5.38 0 0 1 1.09-3.256l1.849 1.85v.001L8.736 9.8l.001-.001l1.519 1.518A5.406 5.406 0 0 1 1.594 7m6.003 3.428L3.442 6.273a.75.75 0 0 0 .183 1.477H4.5V8q0 .207.033.407l-.956.956a.75.75 0 0 0 1.06 1.06l.626-.625a2.49 2.49 0 0 0 2.334.63M5.263 4.202L3.744 2.684a5.406 5.406 0 0 1 7.572 7.572l-1.849-1.85Q9.5 8.207 9.5 8v-.25h.875a.75.75 0 0 0 0-1.5H9.5V6q0-.207-.033-.407l.956-.956a.75.75 0 1 0-1.06-1.06l-.626.625C8.287 3.767 7.675 3.5 7 3.5s-1.287.267-1.737.702M13.906 7c0 1.903-.77 3.626-2.014 4.875l-.008.008l-.009.009A6.906 6.906 0 1 1 13.905 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugAntivirusShield: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.36 13.4a1 1 0 0 1-.72 0v0A9.59 9.59 0 0 1 .5 4.46V1.54a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.92a9.59 9.59 0 0 1-6.14 8.94\"/><path d=\"M9 7V5a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0M3.5 6H5m4 0h1.5M5 5.5h4m-.187-1.312L10 3M8.813 7.813L10 9M5.188 7.813L4 9m1.188-4.812L4 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugAntivirusShieldRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.645 1.355a.35.35 0 0 0-.25-.105H1.604a.35.35 0 0 0-.25.105a.36.36 0 0 0-.105.256v2.88a8.87 8.87 0 0 0 1.543 4.995a8.8 8.8 0 0 0 4.08 3.24l-.226.583l.226-.583a.35.35 0 0 0 .254 0l.226.583l-.226-.583a8.8 8.8 0 0 0 4.08-3.24A8.87 8.87 0 0 0 12.75 4.49V1.61a.36.36 0 0 0-.105-.256M1.76 10.19a10.04 10.04 0 0 0 4.66 3.7a1.6 1.6 0 0 0 1.158 0a10.04 10.04 0 0 0 4.66-3.7A10.1 10.1 0 0 0 14 4.49V1.61A1.61 1.61 0 0 0 12.395 0H1.606C1.179 0 .77.17.469.473c-.3.303-.47.712-.47 1.138v2.88a10.1 10.1 0 0 0 1.762 5.7M7 3.625c-.76 0-1.375.616-1.375 1.375h2.75c0-.76-.616-1.375-1.375-1.375M9.625 5a2.6 2.6 0 0 0-.083-.658l.775-.775a.625.625 0 1 0-.884-.884l-.52.52c-.479-.51-1.159-.828-1.913-.828s-1.434.318-1.913.828l-.52-.52a.625.625 0 1 0-.884.884l.775.775A2.6 2.6 0 0 0 4.375 5v.375H3.5a.625.625 0 1 0 0 1.25h.875V7q.001.342.083.658l-.775.775a.625.625 0 1 0 .884.884l.52-.52c.479.51 1.159.828 1.913.828s1.434-.318 1.913-.828l.52.52a.625.625 0 1 0 .884-.884l-.775-.775q.082-.316.083-.658v-.375h.875a.625.625 0 1 0 0-1.25h-.875z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugAntivirusShieldSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.537c0-.821.68-1.5 1.5-1.5h11c.82 0 1.5.679 1.5 1.5v2.92c-.003 4.126-2.61 7.922-6.46 9.406a1.5 1.5 0 0 1-1.08 0C2.61 12.379.003 8.583 0 4.457zm4.828 3.175q-.042.21-.042.43v.054a.6.6 0 0 0-.094.179H4a.625.625 0 1 0 0 1.25h.786v.232q0 .222.042.431l-.841.842a.625.625 0 1 0 .883.883l.578-.577c.4.393.947.635 1.552.635s1.153-.242 1.552-.635l.578.577a.625.625 0 1 0 .883-.883l-.84-.842q.04-.21.041-.43v-.233H10a.625.625 0 0 0 0-1.25h-.692a.6.6 0 0 0-.094-.179v-.053q0-.222-.042-.431l.841-.841a.625.625 0 1 0-.883-.884l-.578.577A2.2 2.2 0 0 0 7 2.929c-.605 0-1.153.242-1.552.635l-.578-.577a.625.625 0 1 0-.883.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5.875a.625.625 0 0 0-.625.625a3.13 3.13 0 0 0 .708 1.98c-.573.307-1.08.72-1.497 1.212a4.1 4.1 0 0 0-2.463-.817a.625.625 0 1 0 .004 1.25a2.84 2.84 0 0 1 1.772.615a5.1 5.1 0 0 0-.486 1.635H.625a.625.625 0 1 0 0 1.25h1.288c.07.58.238 1.13.486 1.635a2.83 2.83 0 0 1-1.772.615a.625.625 0 0 0-.004 1.25a4.1 4.1 0 0 0 2.463-.817A5.11 5.11 0 0 0 7 13.125a5.11 5.11 0 0 0 3.914-1.817a4.1 4.1 0 0 0 2.463.817a.625.625 0 1 0-.004-1.25a2.83 2.83 0 0 1-1.772-.615a5.1 5.1 0 0 0 .486-1.635h1.288a.625.625 0 1 0 0-1.25h-1.288a5.1 5.1 0 0 0-.486-1.635a2.83 2.83 0 0 1 1.772-.615a.625.625 0 1 0 .004-1.25a4.1 4.1 0 0 0-2.463.817A5.2 5.2 0 0 0 9.417 3.48a3.13 3.13 0 0 0 .708-1.98a.625.625 0 0 0-1.25 0a1.88 1.88 0 0 1-.75 1.499a5.14 5.14 0 0 0-2.25 0a1.88 1.88 0 0 1-.75-1.5A.625.625 0 0 0 4.5.876M10.745 7A3.88 3.88 0 0 1 7 11.875A3.875 3.875 0 0 1 3.255 7z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.135 1.71a.75.75 0 0 0-1.5 0a1.63 1.63 0 0 1-.651 1.305a5.1 5.1 0 0 0-1.968 0a1.63 1.63 0 0 1-.65-1.305a.75.75 0 1 0-1.5 0a3.14 3.14 0 0 0 .623 1.875a5.1 5.1 0 0 0-1.27 1.031A4.05 4.05 0 0 0 .8 3.822a.75.75 0 1 0 .003 1.5a2.55 2.55 0 0 1 1.595.554a5 5 0 0 0-.391 1.284H.8a.75.75 0 1 0 0 1.5h1.185c.062.463.187.906.366 1.32a2.55 2.55 0 0 1-1.549.518a.75.75 0 1 0-.004 1.5a4.05 4.05 0 0 0 2.347-.74A5.05 5.05 0 0 0 7 13.04a5.05 5.05 0 0 0 3.855-1.782a4.05 4.05 0 0 0 2.347.74a.75.75 0 0 0-.004-1.5a2.55 2.55 0 0 1-1.549-.518c.179-.414.303-.857.366-1.32H13.2a.75.75 0 0 0 0-1.5h-1.206a5 5 0 0 0-.39-1.284a2.55 2.55 0 0 1 1.594-.554a.75.75 0 0 0 .004-1.5a4.05 4.05 0 0 0-2.421.794a5.1 5.1 0 0 0-1.27-1.03a3.13 3.13 0 0 0 .624-1.875M7 4.42a3.56 3.56 0 0 1 3.222 2.043H3.778A3.56 3.56 0 0 1 7 4.419\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusBrowser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 12.5h-2a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1V4m-13-.5h13M6 6.5l1.3 1.3M6 13.5l1.3-1.3M7 10H5.5M13 6.5l-1.3 1.3m1.3 5.7l-1.3-1.3\"/><path d=\"M7 9a2.5 2.5 0 1 1 5 0v2a2.5 2.5 0 0 1-5 0zm5 1h1.5M7 9.5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusBrowserRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.01 1.625C.01.728.738 0 1.636 0h9.741C12.274 0 13 .728 13 1.625V4a.625.625 0 1 1-1.25 0v-.5H1.26v6.875c0 .208.169.375.375.375H3.38a.625.625 0 1 1 0 1.25H1.635A1.625 1.625 0 0 1 .01 10.375zm8.04 5.924a1.875 1.875 0 0 1 3.2 1.326H7.5c0-.497.198-.974.55-1.326M12.5 9.25v-.375c0-.364-.063-.721-.184-1.057l1.001-1.001a.625.625 0 1 0-.884-.884l-.79.791l-.058-.059a3.125 3.125 0 0 0-4.477.06l-.79-.792a.625.625 0 0 0-.885.884l1.001 1.001c-.12.336-.184.693-.184 1.057v.375h-.875a.625.625 0 0 0 0 1.25h.875v.375c0 .364.064.721.184 1.057l-1 1.001a.625.625 0 0 0 .883.884l.791-.791l.058.059a3.125 3.125 0 0 0 4.476-.06l.791.792a.625.625 0 0 0 .884-.884l-1-1.001c.12-.336.183-.693.183-1.057V10.5h.875a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusBrowserSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 12.25V3.314h10.908v.856a.75.75 0 0 0 1.5 0V1.75c0-.942-.763-1.705-1.705-1.705H1.751A1.707 1.707 0 0 0 .046 1.751v10.498c0 .942.763 1.705 1.705 1.705h2.245a.75.75 0 0 0 0-1.5H1.751a.204.204 0 0 1-.205-.205m4.115-5.462a.75.75 0 0 1 1.06-.05l.781.709a2.83 2.83 0 0 1 3.95 0l.782-.71a.75.75 0 1 1 1.008 1.11l-1.022.93q.086.338.086.695v.032h.898a.75.75 0 0 1 0 1.5h-.898v.032q-.001.356-.086.696l1.022.928a.75.75 0 0 1-1.008 1.11l-.781-.709a2.83 2.83 0 0 1-3.951 0l-.781.71a.75.75 0 1 1-1.009-1.11l1.023-.93a2.8 2.8 0 0 1-.087-.695v-.032h-.897a.75.75 0 0 1 0-1.5h.897v-.032q0-.357.087-.695l-1.023-.93a.75.75 0 0 1-.05-1.059\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusDocument: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 11.5h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h6l3 3V4M6 6.5l1.3 1.3M6 13.5l1.3-1.3M7 10H5.5M13 6.5l-1.3 1.3m1.3 5.7l-1.3-1.3\"/><path d=\"M7 9a2.5 2.5 0 1 1 5 0v2a2.5 2.5 0 0 1-5 0zm5 1h1.5M7 9.5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusDocumentRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.36 1.36c.07-.07.166-.11.265-.11h6.241L11 4.384a.625.625 0 0 0 1.25-.009v-.25a.63.63 0 0 0-.183-.442l-3.5-3.5A.63.63 0 0 0 8.125 0h-6.5A1.625 1.625 0 0 0 0 1.625v10.75A1.625 1.625 0 0 0 1.625 14h1.75a.625.625 0 1 0 0-1.25h-1.75a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265m6.69 6.19a1.875 1.875 0 0 1 3.2 1.325H7.5c0-.497.198-.974.55-1.326m4.45 1.7v-.375c0-.364-.063-.721-.184-1.057l1-1.001a.625.625 0 1 0-.883-.884l-.791.791l-.057-.059a3.125 3.125 0 0 0-4.477.06l-.791-.792a.625.625 0 1 0-.884.884l1.001 1.001c-.12.336-.184.693-.184 1.057v.375h-.875a.625.625 0 1 0 0 1.25h.875v.375c0 .364.063.721.184 1.057l-1 1.001a.625.625 0 0 0 .883.884l.791-.791l.057.059a3.125 3.125 0 0 0 4.477-.06l.791.792a.625.625 0 0 0 .884-.884l-1.001-1.001c.12-.336.184-.693.184-1.057V10.5h.875a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusDocumentSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v9A1.5 1.5 0 0 0 1.5 12h3.164l.048-.06a1.998 1.998 0 0 1 0-3.373a2 2 0 0 1 2.72-2.89A4.33 4.33 0 0 1 11 5.406V3.5a.5.5 0 0 0-.146-.354l-3-3A.5.5 0 0 0 7.5 0zm4.198 6.788a.75.75 0 0 1 1.059-.05l.781.709a2.83 2.83 0 0 1 3.95 0l.782-.71a.75.75 0 0 1 1.008 1.11l-1.022.93q.086.338.086.695v.032h.898a.75.75 0 0 1 0 1.5h-.898v.032q-.001.356-.086.696l1.022.929a.75.75 0 1 1-1.008 1.11l-.781-.71a2.83 2.83 0 0 1-3.95 0l-.782.71a.75.75 0 0 1-1.009-1.11l1.023-.93a2.8 2.8 0 0 1-.087-.695v-.032h-.897a.75.75 0 0 1 0-1.5h.897v-.032q0-.357.087-.695l-1.023-.93a.75.75 0 0 1-.05-1.059\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusFolder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m6 6.5l1.3 1.3M6 13.5l1.3-1.3M7 10H5.5M13 6.5l-1.3 1.3m1.3 5.7l-1.3-1.3M7 9a2.5 2.5 0 1 1 5 0v2a2.5 2.5 0 0 1-5 0zm5 1h1.5M7 9.5h5\"/><path d=\"M3.5 12h-2a1 1 0 0 1-1-1V1.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.28 1.24h6a1 1 0 0 1 1 1V4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusFolderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 1.625c0-.207.168-.375.375-.375h3.094c.172 0 .322.117.364.284l.31 1.243c.07.278.32.473.607.473h6.375c.207 0 .375.168.375.375v.5a.625.625 0 1 0 1.25 0v-.5C14 2.728 13.273 2 12.375 2H6.488l-.192-.77A1.625 1.625 0 0 0 4.719 0H1.625C.728 0 0 .728 0 1.625v8.75C0 11.273.728 12 1.625 12h2a.625.625 0 1 0 0-1.25h-2a.375.375 0 0 1-.375-.375zm6.8 5.924a1.875 1.875 0 0 1 3.2 1.326H7.5c0-.497.198-.974.55-1.326M12.5 9.25v-.375c0-.364-.063-.721-.184-1.057l1-1.001a.625.625 0 1 0-.883-.884l-.791.791l-.057-.059a3.125 3.125 0 0 0-4.477.06l-.791-.792a.625.625 0 1 0-.884.884l1.001 1.001c-.12.336-.184.693-.184 1.057v.375h-.875a.625.625 0 1 0 0 1.25h.875v.375c0 .364.063.721.184 1.057l-1 1.001a.625.625 0 0 0 .883.884l.791-.791l.057.059a3.125 3.125 0 0 0 4.477-.06l.791.792a.625.625 0 0 0 .884-.884l-1.001-1.001c.12-.336.184-.693.184-1.057V10.5h.875a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBugVirusFolderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.198 0A1.5 1.5 0 0 1 6.69 1.14l.003.01l.192.85h5.6a1.5 1.5 0 0 1 1.5 1.5v2.188a2 2 0 0 0-2.378-.016a4.33 4.33 0 0 0-4.164 0a2 2 0 0 0-2.72 2.891a1.998 1.998 0 0 0 0 3.374a2 2 0 0 0-.329.563H1.515a1.5 1.5 0 0 1-1.5-1.5V1.5a1.5 1.5 0 0 1 1.5-1.5zm.51 6.784a.75.75 0 0 1 1.06-.05l.781.709a2.83 2.83 0 0 1 3.95 0l.782-.71a.75.75 0 1 1 1.008 1.11l-1.022.93q.086.338.087.695V9.5h.897a.75.75 0 0 1 0 1.5h-.897v.032q0 .356-.087.696l1.023.929a.75.75 0 1 1-1.009 1.11l-.781-.71a2.83 2.83 0 0 1-3.95 0l-.782.71a.75.75 0 0 1-1.008-1.11l1.022-.93a2.8 2.8 0 0 1-.086-.695V11h-.898a.75.75 0 0 1 0-1.5h.898v-.032q.001-.357.086-.695l-1.022-.93a.75.75 0 0 1-.051-1.059\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBuilding2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5 13.5h-8V4l4-3.5l4 3.5zm0 0h5v-7h-5m-4 7v-2M3 8.5h3m-3-3h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBuilding2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.14.512a.625.625 0 0 0-.78 0l-3.75 3A.63.63 0 0 0 .375 4v9c0 .345.28.625.625.625h12c.345 0 .625-.28.625-.625V6.5A.625.625 0 0 0 13 5.875H9.125V4c0-.19-.086-.37-.235-.488zM7.875 6.5V4.3L4.75 1.8L1.625 4.3v8.075H3.75V11.25a1 1 0 1 1 2 0v1.125h2.125zM2.75 8.25a.75.75 0 0 1 .75-.75H6A.75.75 0 0 1 6 9H3.5a.75.75 0 0 1-.75-.75m.75-3.5a.75.75 0 0 0 0 1.5H6a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBuilding2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.521.138a.5.5 0 0 0-.69 0l-3.676 3.5A.5.5 0 0 0 0 4v9.5a.5.5 0 0 0 .5.5h2.676v-2a1 1 0 1 1 2 0v2h2.677a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.156-.362zM9.77 6.5a.5.5 0 0 1 .5-.5h3.23a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-3.231a.5.5 0 0 1-.5-.5zM2.173 7.763c0-.345.28-.625.625-.625h2.757a.625.625 0 1 1 0 1.25H2.798a.625.625 0 0 1-.625-.625m.625-3.232a.625.625 0 1 0 0 1.25h2.757a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBulletList: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 3a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m3.5-.5h9M1 7.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1M4.5 7h9M1 12a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m3.5-.5h9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBulletListRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.25 1.5a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0m4.125 0c0-.345.28-.625.625-.625h8a.625.625 0 1 1 0 1.25H5a.625.625 0 0 1-.625-.625M1.5 5.75a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5M4.375 7c0-.345.28-.625.625-.625h8a.625.625 0 1 1 0 1.25H5A.625.625 0 0 1 4.375 7M1.5 11.25a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5m3.5.625a.625.625 0 1 0 0 1.25h8a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBulletListSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 2.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0M1 8a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 4.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2M4.75 1.75a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM4 7a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 4 7m.75 3.75a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBurger: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7.5h13M4 .5h6A3.5 3.5 0 0 1 13.5 4a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1A3.5 3.5 0 0 1 4 .5m9 9.5H7l-1.5 1.5l-3-1.5H1a.5.5 0 0 0-.5.5v0a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3a.5.5 0 0 0-.5-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBurger1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 1.25a2.375 2.375 0 0 0-2.375 2.375c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375A2.375 2.375 0 0 0 10 1.25zM.375 3.625A3.625 3.625 0 0 1 4 0h6a3.625 3.625 0 0 1 3.625 3.625c0 .897-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 3.625m1.5 6.875a.25.25 0 0 0-.25.25a2 2 0 0 0 2 2h6.75a2 2 0 0 0 2-2a.25.25 0 0 0-.25-.25h-4.79l-.815 1.222a.625.625 0 0 1-.842.189L3.327 10.5zm-1.5.25a1.5 1.5 0 0 1 1.5-1.5H3.5c.113 0 .224.03.322.09l1.989 1.193l.669-1.005A.63.63 0 0 1 7 9.25h5.125a1.5 1.5 0 0 1 1.5 1.5a3.25 3.25 0 0 1-3.25 3.25h-6.75a3.25 3.25 0 0 1-3.25-3.25M1 6.375a.875.875 0 1 0 0 1.75h12a.875.875 0 1 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBurgerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.184 1.094A4.13 4.13 0 0 1 4 0h6c1.05 0 2.064.39 2.816 1.094A3.67 3.67 0 0 1 14 3.774c0 .391-.167.76-.451 1.026a1.54 1.54 0 0 1-1.049.409h-11A1.54 1.54 0 0 1 .451 4.8A1.4 1.4 0 0 1 0 3.773a3.67 3.67 0 0 1 1.184-2.68M.77 6.75a.75.75 0 0 0 0 1.5h12.46a.75.75 0 0 0 0-1.5zm-.464 3.267c.19-.176.44-.27.694-.27h1.5a.5.5 0 0 1 .21.047l2.696 1.252L6.66 9.881A.5.5 0 0 1 7 9.748h6c.254 0 .504.093.694.27a.95.95 0 0 1 .306.694a3.2 3.2 0 0 1-1.038 2.338A3.62 3.62 0 0 1 10.5 14h-7a3.62 3.62 0 0 1-2.462-.95A3.2 3.2 0 0 1 0 10.712a.95.95 0 0 1 .306-.695\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBurritoFastfood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.865 10.397l2.6 2.601a1 1 0 0 0 1.415 0l5.294-5.293l-4.016-4.016L.865 8.983a1 1 0 0 0 0 1.414\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.6 9.562l5.378 1.409a1 1 0 0 0 1.22-1.221L5.724 4.129\"/><path stroke-linecap=\"round\" d=\"M6.648 4.18c.122-.191.36-.502.547-.651a2.11 2.11 0 0 1 2.97.33c.73.911.583 2.24-.329 2.97l-.297.237\"/><path stroke-linejoin=\"round\" d=\"M6.46 4.003a1.784 1.784 0 0 1 0-2.523a1.79 1.79 0 0 1 2.083-.326l.055-.058a1.78 1.78 0 0 1 2.524 0c.315.316.488.72.518 1.134c.41.032.814.199 1.127.512a1.784 1.784 0 0 1 0 2.523l-.06.058A1.785 1.785 0 0 1 9.86 7.404\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBurritoFastfoodRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.5 0a2.5 2.5 0 0 0-1.471.479A2.268 2.268 0 0 0 5.216 3.9l-.273.273l-.019.019L.442 8.674l-.019.019l-.063.063a1.23 1.23 0 0 0 0 1.738l3.146 3.146a1.23 1.23 0 0 0 1.738 0l2.073-2.073l.5-.5L10.1 8.784a2.268 2.268 0 0 0 3.248-3.1A2.5 2.5 0 0 0 11.8 1.518A2.5 2.5 0 0 0 9.5 0M6.092 4.799l3.113 3.113l-1.557 1.556zm-4.06 4.053l3.07-3.07l1.535 4.605zm2.343 3.89l-2.686-2.687l4.029 1.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBurritoFastfoodSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.323 1.99a2 2 0 0 0-.872-.512A2 2 0 0 0 10.589.02h-.002a2 2 0 0 0-1.273.407a2 2 0 0 0-2.002.5a2 2 0 0 0 0 2.829l2.86 2.859a2 2 0 0 0 2.828 0a2 2 0 0 0 .5-2.002a2 2 0 0 0 .408-1.273a2 2 0 0 0-.585-1.35M10.91 5.94l-.032-.031l-2.86-2.86l-.029-.03a2.06 2.06 0 0 1 1.452-.784a2.05 2.05 0 0 1 1.644.623c.456.438.652 1.036.604 1.634a2.04 2.04 0 0 1-.779 1.448M.903 9.087L4.73 5.261l1.85 5.037a.5.5 0 0 1-.642.642zm-.52 1.934A1 1 0 0 1 .187 9.89l5.406 1.99q.301.107.588.093l-1.715 1.716a1 1 0 0 1-1.415 0zm9.553-2.805l-2.324 2.325a1.5 1.5 0 0 0-.094-.588l-2.01-5.47l.348-.348z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBus: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h-9a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1M3.5 12v1.5m7-1.5v1.5M1.5 7h11\"/><path d=\"M4 9.75a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m6 .5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375c-.897 0-1.625.728-1.625 1.625v2.875h-.75a.625.625 0 1 0 0 1.25h.75V10.5c0 .812.596 1.486 1.375 1.606V13a.75.75 0 0 0 1.5 0v-.875h5.5V13a.75.75 0 0 0 1.5 0v-.894a1.625 1.625 0 0 0 1.375-1.606V6.125h.75a.625.625 0 1 0 0-1.25h-.75V2c0-.897-.727-1.625-1.625-1.625zM11.375 5.5V2A.375.375 0 0 0 11 1.625H3A.375.375 0 0 0 2.625 2v8.5c0 .207.168.375.375.375h8a.375.375 0 0 0 .375-.375zm-7.5 1a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5V3.375a.5.5 0 0 0-.5-.5h-5.25a.5.5 0 0 0-.5.5zM3.625 9a1 1 0 1 0 2 0a1 1 0 0 0-2 0m4.75 0a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.496 1.746c0-.113.092-.205.205-.205H11.3c.113 0 .205.092.205.205V6H2.496zm10.508 9.075c0 .802-.553 1.474-1.299 1.657v.513a1 1 0 0 1-2 0v-.465h-5.41v.465a1 1 0 0 1-2 0v-.513A1.706 1.706 0 0 1 .996 10.82V1.746C.996.804 1.76.041 2.701.041H11.3c.942 0 1.705.763 1.705 1.705zM4 10a1 1 0 1 0 0-2a1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessCard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 2.5h-11a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1\"/><path d=\"M4.5 8.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m4-3H11m-2.5 3H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessCardRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3.5c0-.207.168-.375.375-.375h10.75c.207 0 .375.168.375.375v7a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375zm.375-1.625C.728 1.875 0 2.603 0 3.5v7c0 .898.728 1.625 1.625 1.625h10.75c.898 0 1.625-.727 1.625-1.625v-7c0-.897-.727-1.625-1.625-1.625zm1 5.125a2 2 0 1 1 4 0a2 2 0 0 1-4 0M7.75 5.5c0-.345.28-.625.625-.625h2.5a.625.625 0 1 1 0 1.25h-2.5A.625.625 0 0 1 7.75 5.5m.625 2.375a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessCardSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h11a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 12.5 2zm2.774 2.875a2.125 2.125 0 1 0 0 4.25a2.125 2.125 0 0 0 0-4.25m3.827.625c0-.345.28-.625.625-.625h2.5a.625.625 0 1 1 0 1.25h-2.5A.625.625 0 0 1 8.1 5.5m.625 2.375a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessHandshake: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.548 3.085l2.194 1.18l1.96-.338a2.23 2.23 0 0 1 1.844.515v0m4.736 4.84L8.18 11.486a2 2 0 0 1-2.285.022L.548 7.863\"/><path d=\"m13.402 7.84l-2.195 1.5l-3.406-2.75l-1.253.911a1.17 1.17 0 0 1-1.609-.226v0a1.17 1.17 0 0 1 .169-1.613l1.305-1.097a3 3 0 0 1 2.25-.688l2.033.218l2.706-1.463\"/><path d=\"M7.801 6.597c.82.73 1.982.357 2.414-.239\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessHandshakeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.643 2.138a.625.625 0 1 0-.62-1.085l-2.44 1.397l-2.13.1a3.6 3.6 0 0 0-1.612.465a2.67 2.67 0 0 0-2.233-.619l-1.8.33l-2.06-1.175A.5.5 0 0 0 0 1.985v6.728a.5.5 0 0 0 .23.42l5.42 3.474c.874.56 1.981.519 2.81-.104h.001l2.985-2.22a.5.5 0 0 0 .092-.087l.02-.015l2.06-1.497a.625.625 0 0 0-.735-1.01l-1.624 1.18l-1.616-1.636c.47-.156.887-.455 1.15-.838a.625.625 0 0 0-1.032-.706c-.112.164-.355.336-.652.395a.92.92 0 0 1-.798-.2l-.031-.032a.625.625 0 0 0-.827-.056l-1.2.926a.599.599 0 0 1-.764-.923l.004-.004l1.55-1.382a2.37 2.37 0 0 1 1.469-.6l2.28-.106a.6.6 0 0 0 .282-.082z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessHandshakeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m5.385 5.242l1.404-1.27a3 3 0 0 1 2.406-.747l1.858.246l2.578-1.393a.25.25 0 0 1 .369.22v4.738a1 1 0 0 1-.418.813L11.846 9.09l-1.88-1.576a2.5 2.5 0 0 0 .967-.63a.625.625 0 1 0-.9-.869q-.277.291-.653.366c-.219.043-.498.036-.849-.072l-.446-.375L6.84 6.943a1.12 1.12 0 0 1-1.455-1.701m-.838-.928l1.008-.911a3.1 3.1 0 0 0-1.33-.063l-1.835.318L.376 2.574A.255.255 0 0 0 0 2.799v4.236c0 .338.167.654.446.844l5.455 3.719a2.04 2.04 0 0 0 2.334-.023l2.506-1.779l-2.67-2.24l-.445.358a2.37 2.37 0 0 1-3.079-3.6\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessIdeaMoney: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.276 3.979a1 1 0 0 0-.943-.667H6.56a.893.893 0 0 0-.19 1.765l1.178.257a1 1 0 0 1-.214 1.978h-.666a1 1 0 0 1-.943-.667M7 3.312v-1m0 6v-1\"/><path d=\"M11.5 5.031a4.5 4.5 0 1 0-6.5 4v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1.5a4.48 4.48 0 0 0 2.5-4M5 13.5h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessIdeaMoneyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.898.001a5.243 5.243 0 0 1 5.344 5.277a5.22 5.22 0 0 1-2.565 4.474v.921a1.14 1.14 0 0 1-1.138 1.138H5.46a1.14 1.14 0 0 1-1.138-1.138V9.75A5.243 5.243 0 0 1 6.898.001M8.96 1.764A3.993 3.993 0 1 0 5.225 8.82a.63.63 0 0 1 .347.56v1.181h2.855V9.38c0-.238.135-.455.349-.56a3.97 3.97 0 0 0 2.216-3.547V5.27A3.99 3.99 0 0 0 8.96 1.764M4.41 13.375c0-.345.28-.625.626-.625h3.93a.625.625 0 1 1 0 1.25h-3.93a.625.625 0 0 1-.625-.625M7.626 2.64v.385a1.61 1.61 0 0 1 1.218 1.044a.625.625 0 0 1-1.178.417a.36.36 0 0 0-.338-.239h-.76a.252.252 0 0 0-.054.499l1.158.253a1.608 1.608 0 0 1-.046 3.15v.386a.625.625 0 0 1-1.25 0V8.15a1.61 1.61 0 0 1-1.218-1.044a.625.625 0 1 1 1.178-.417c.05.14.183.238.337.238h.655a.358.358 0 0 0 .077-.707l-1.158-.253a1.502 1.502 0 0 1 .129-2.957v-.37a.625.625 0 1 1 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessIdeaMoneySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.454.644A5 5 0 0 0 4.5 9.33v1.201a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1.2A4.98 4.98 0 0 0 12 5.034A5 5 0 0 0 9.454.644M7 1.726c.345 0 .625.28.625.625v.384A1.61 1.61 0 0 1 8.843 3.78a.625.625 0 1 1-1.178.416a.36.36 0 0 0-.337-.238h-.76a.252.252 0 0 0-.055.498l1.158.253a1.608 1.608 0 0 1-.046 3.15v.386a.625.625 0 1 1-1.25 0V7.86a1.61 1.61 0 0 1-1.218-1.044a.625.625 0 0 1 1.178-.417c.05.14.183.238.338.238h.655a.358.358 0 0 0 .076-.707l-1.158-.253a1.502 1.502 0 0 1 .13-2.957v-.37c0-.345.279-.624.624-.624M5 12.49a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessProfessionHomeOffice: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.272 6.346h3.455s1 0 1 1v2.456s0 1-1 1H5.272s-1 0-1-1V7.346s0-1 1-1m.474 0v-.572a1 1 0 0 1 1-1h.51a1 1 0 0 1 1 1v.572\"/><path d=\"M13.5 6.94a1 1 0 0 0-.32-.74L7 .5L.82 6.2a1 1 0 0 0-.32.74v5.56a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessProfessionHomeOfficeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.422.54a.625.625 0 0 0-.844 0L.902 5.741l.415.453l-.415-.453A1.63 1.63 0 0 0 .375 6.94V12c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V6.94c0-.456-.191-.89-.527-1.198zM1.747 6.662L7 1.848l5.253 4.815a.38.38 0 0 1 .122.277V12a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12V6.94c0-.105.044-.206.122-.277M6.246 5.9a.125.125 0 0 0-.125.125v.572h1.76v-.572a.125.125 0 0 0-.125-.125zm-1.375.125v.627a1.5 1.5 0 0 0-1.099 1.445v1.956a1.5 1.5 0 0 0 1.5 1.5h3.455a1.5 1.5 0 0 0 1.5-1.5V8.096a1.5 1.5 0 0 0-1.096-1.445v-.627c0-.76-.616-1.375-1.375-1.375h-1.51c-.76 0-1.375.616-1.375 1.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessProfessionHomeOfficeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.322.445a1 1 0 0 1 1.356 0l5.842 5.388c.308.286.48.692.48 1.107v5.56a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5V6.94c0-.454.178-.827.48-1.107h.001L6.322.444Zm.243 4.985a.5.5 0 0 0-.5.5v.405h1.87V5.93a.5.5 0 0 0-.5-.5zm-1.5.5v.405H4.88a1 1 0 0 0-1 1v3.095a1 1 0 0 0 1 1h4.238a1 1 0 0 0 1-1V7.335a1 1 0 0 0-1-1h-.182V5.93a1.5 1.5 0 0 0-1.5-1.5h-.87a1.5 1.5 0 0 0-1.5 1.5Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessProgressBar2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 12.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M.5 11H4m3 0h6.5m-2-2l2 2l-2 2m-6-3.5V1m0 0L10 3.5L5.5 6z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessProgressBar2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.805.954a.625.625 0 0 0-.93.546v6.718a2.13 2.13 0 0 0-1.407 1.407H.632a.625.625 0 1 0 0 1.25h2.836a2.126 2.126 0 0 0 4.063 0h2.953V12.5a.625.625 0 0 0 1.067.442l2.25-2.25a.625.625 0 0 0 0-.884l-2.25-2.25A.625.625 0 0 0 10.484 8v1.625H7.53a2.13 2.13 0 0 0-1.406-1.407V6.617l3.93-2.196a.625.625 0 0 0 0-1.092zm.57 9.296a.875.875 0 0 0-1.75-.002v.004a.875.875 0 0 0 1.75-.002m-.25-5.065v-2.62l2.344 1.31z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessProgressBar2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 1.218a.75.75 0 0 1 1.126-.65l4.488 2.494a.75.75 0 0 1 0 1.311L6.25 6.66v2.704c.502.203.902.603 1.105 1.105h3.495v-.815a.75.75 0 0 1 1.28-.53l1.565 1.564a.75.75 0 0 1-.004 1.065l-1.561 1.56a.75.75 0 0 1-1.28-.53v-.814H7.355a2 2 0 0 1-3.71 0H.836a.75.75 0 0 1 0-1.5h2.81A2 2 0 0 1 4.75 9.363z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessUserCurriculum: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M4.098 3.65a1.15 1.15 0 1 0 2.3 0a1.15 1.15 0 0 0-2.3 0\"/><path stroke-linejoin=\"round\" d=\"M3.5 5.94a2.2 2.2 0 0 1 .746-.834c.306-.2.652-.304 1.003-.304s.697.104 1.003.304c.307.199.563.486.746.834\"/><path stroke-linejoin=\"round\" d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4z\"/><path d=\"M3.5 8.5h7m-7 2.5h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessUserCurriculumRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.235 1.36c.07-.07.166-.11.265-.11h5.586c.1 0 .195.04.265.11l3.414 3.414c.07.07.11.166.11.265v7.336a.375.375 0 0 1-.375.375h-9a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265M2.5 0A1.625 1.625 0 0 0 .875 1.625v10.75A1.625 1.625 0 0 0 2.5 14h9a1.625 1.625 0 0 0 1.625-1.625V5.039c0-.43-.171-.844-.476-1.149L9.235.476A1.63 1.63 0 0 0 8.085 0zm4.133 4.761a1.775 1.775 0 1 0-2.77.001a2.75 2.75 0 0 0-.806.945a.5.5 0 0 0 .443.733h3.498a.5.5 0 0 0 .443-.733a2.75 2.75 0 0 0-.808-.946m-1.91-1.11a.525.525 0 1 1 1.05 0a.525.525 0 0 1-1.05 0M2.875 8.5c0-.345.28-.625.625-.625h7a.625.625 0 1 1 0 1.25h-7a.625.625 0 0 1-.625-.625m.625 1.875a.625.625 0 1 0 0 1.25h4a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineBusinessUserCurriculumSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h6a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5v-11c0-.398.158-.78.44-1.06m3.515 3.51a1.024 1.024 0 1 0 0-2.048a1.024 1.024 0 0 0 0 2.048M2.876 8.5c0-.345.279-.625.624-.625h7a.626.626 0 0 1 .002 1.25h-7a.626.626 0 0 1-.626-.625m0 3c0-.345.279-.625.624-.625h4a.626.626 0 0 1 .002 1.25h-4a.626.626 0 0 1-.626-.625m2.08-6.866c-.7 0-1.339.263-1.822.696c-.287.257-.063.67.322.67h2.998c.386 0 .61-.413.323-.67a2.72 2.72 0 0 0-1.822-.696\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonFastForward1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.28a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L1.6 3.1a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.62z\"/><path d=\"M6.997 10.28a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L8.097 3.1a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.6z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonFastForward1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2.478c0-.15.085-.266.23-.323a.38.38 0 0 1 .424.085l4.371 4.416a.34.34 0 0 1 .1.232V6.9a.34.34 0 0 1-.1.232l-4.371 4.416a.38.38 0 0 1-.423.086a.34.34 0 0 1-.231-.324zm5.125 6.33l-3.583 3.62C1.797 13.433 0 12.78 0 11.31V2.478C0 1.008 1.797.356 2.792 1.361l3.583 3.62V2.477c0-1.47 1.797-2.122 2.792-1.117l4.371 4.416a1.584 1.584 0 0 1 0 2.235l-4.371 4.416c-.995 1.005-2.792.352-2.792-1.118zm1.25-1.9v4.402c0 .15.085.267.23.324a.38.38 0 0 0 .424-.086l4.371-4.416a.334.334 0 0 0 0-.476L8.28 2.24a.38.38 0 0 0-.423-.085a.34.34 0 0 0-.231.323z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonFastForward1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.497 5.894L1.27 2.424a.83.83 0 0 0-.92.056a.82.82 0 0 0-.35.648v7.723c0 .638.735 1.05 1.27.724l5.227-3.449v2.724c0 .639.734 1.052 1.27.725l5.867-3.872c.488-.316.488-1.067 0-1.384L7.767 2.424a.83.83 0 0 0-.92.056a.82.82 0 0 0-.35.648z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonFastForward2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.29a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L1.6 3.11a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.62z\"/><path d=\"M6.997 10.29a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18l-5.08-3.32a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.6zM13.5 2.5v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonFastForward2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.128.98c.483 0 .875.392.875.876v10.288a.875.875 0 1 1-1.75 0V9.416l-3.086 3.117c-.995 1.005-2.792.353-2.792-1.117V8.914l-3.583 3.62C1.797 13.537 0 12.885 0 11.415V2.584C0 1.114 1.797.461 2.792 1.466l3.583 3.62V2.584c0-1.47 1.797-2.123 2.792-1.118l3.086 3.118V1.856c0-.484.392-.875.875-.875m-.875 5.38L8.279 2.347a.38.38 0 0 0-.423-.086a.34.34 0 0 0-.231.324v8.832c0 .15.085.266.23.324a.38.38 0 0 0 .424-.086l3.974-4.015zm-5.878.634a.34.34 0 0 0-.1-.232L1.904 2.346a.38.38 0 0 0-.423-.086a.34.34 0 0 0-.231.324v8.832c0 .15.085.266.23.324a.38.38 0 0 0 .424-.086l4.371-4.416a.34.34 0 0 0 .1-.232z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonFastForward2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13 2.234a1 1 0 0 1 1 1v7.532a1 1 0 1 1-2 0V8.782l-4.233 2.793c-.536.327-1.27-.086-1.27-.724V8.126l-5.227 3.45C.735 11.901 0 11.488 0 10.85V3.127a.82.82 0 0 1 .35-.648c.262-.189.624-.237.92-.056l5.227 3.47V3.128a.82.82 0 0 1 .35-.648a.83.83 0 0 1 .92-.056L12 5.234v-2a1 1 0 0 1 1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonNext: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5v13M.52 11.66a1 1 0 0 0 .52.88a1 1 0 0 0 1 0l7.19-4.7a1 1 0 0 0 0-1.68L2.02 1.5a1 1 0 0 0-1 0a1 1 0 0 0-.52.88z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonNextRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.993c0-.29.34-.478.596-.296l7.035 5.007a.36.36 0 0 1 0 .592l-7.035 5.007a.376.376 0 0 1-.596-.296zM2.945.679C1.88-.081.376.668.376 1.993v10.014c0 1.325 1.504 2.074 2.57 1.314l7.036-5.007a1.61 1.61 0 0 0 0-2.628zm10.93.571a.875.875 0 0 0-1.75 0v11.5a.875.875 0 0 0 1.75 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonNextSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.512 6.056L1.693.656C1.297.407.815.474.467.737A1.14 1.14 0 0 0 0 1.632v10.705c0 .884.979 1.456 1.693 1.004l7.82-5.367c.65-.439.65-1.48 0-1.919m4.238-4.314a1 1 0 1 0-2 0v10.516a1 1 0 0 0 2 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPause2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 .5H1.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1H4a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m8.5 0H10a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPause2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h2.5c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12zM2 .375C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h2.5c.897 0 1.625-.727 1.625-1.625V2c0-.897-.728-1.625-1.625-1.625zM9.125 2c0-.207.168-.375.375-.375H12c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375H9.5A.375.375 0 0 1 9.125 12zM9.5.375c-.897 0-1.625.728-1.625 1.625v10c0 .898.728 1.625 1.625 1.625H12c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPause2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0H4a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 4 14H1.5A1.5 1.5 0 0 1 0 12.5zM10 0a1.5 1.5 0 0 0-1.5 1.5v11A1.5 1.5 0 0 0 10 14h2.5a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPlay: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.436 12.33a1.14 1.14 0 0 0 .63 1a1.24 1.24 0 0 0 1.22 0l8.65-5.35a1.11 1.11 0 0 0 0-2L3.286.67a1.24 1.24 0 0 0-1.22 0a1.14 1.14 0 0 0-.63 1z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPlayRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.145.596a1.77 1.77 0 0 1 1.749.02l7.972 4.894a1.651 1.651 0 0 1 .001 2.943l-7.971 4.93l-.022.013a1.77 1.77 0 0 1-1.729.007a1.68 1.68 0 0 1-.913-1.465V2.062A1.68 1.68 0 0 1 2.145.596m.858 1.029a.5.5 0 0 0-.285.082a.43.43 0 0 0-.236.372v9.842a.43.43 0 0 0 .264.387a.52.52 0 0 0 .505.004l7.983-4.938l.058-.031a.402.402 0 0 0 0-.723l-.056-.03l-7.985-4.902a.5.5 0 0 0-.248-.063\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPlaySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.676.02a1.74 1.74 0 0 0-.845.218a1.64 1.64 0 0 0-.895 1.433v10.677a1.64 1.64 0 0 0 .895 1.433a1.74 1.74 0 0 0 1.718-.016l8.63-5.338a1.61 1.61 0 0 0-.001-2.876L3.548.253L3.532.244A1.74 1.74 0 0 0 2.676.02\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPower1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5V6m4-4.124a6.5 6.5 0 1 1-8 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPower1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625.663a.625.625 0 1 0-1.25 0v5.395a.625.625 0 1 0 1.25 0zm-4.012 2.09a.75.75 0 0 0-.918-1.187A6.95 6.95 0 0 0 .289 5.07a6.9 6.9 0 0 0 .093 4.24a6.96 6.96 0 0 0 2.555 3.397a7.035 7.035 0 0 0 8.126 0a6.96 6.96 0 0 0 2.555-3.396a6.9 6.9 0 0 0 .093-4.24a6.95 6.95 0 0 0-2.406-3.504a.75.75 0 1 0-.918 1.186A5.46 5.46 0 0 1 12.274 5.5a5.4 5.4 0 0 1-.073 3.32a5.46 5.46 0 0 1-2.004 2.663a5.535 5.535 0 0 1-6.394 0A5.46 5.46 0 0 1 1.8 8.818a5.4 5.4 0 0 1-.073-3.32a5.45 5.45 0 0 1 1.887-2.746\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPower1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 1a1 1 0 0 0-2 0v5.077a1 1 0 1 0 2 0zM3.923 3.059a1 1 0 0 0-1.23-1.577a7 7 0 1 0 8.615 0a1 1 0 0 0-1.231 1.577a5 5 0 1 1-6.154 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPrevious: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5.5v13m12.98-1.84a1 1 0 0 1-.52.88a1 1 0 0 1-1 0l-7.19-4.7a1 1 0 0 1 0-1.68l7.21-4.66a1 1 0 0 1 1 0a1 1 0 0 1 .52.88z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPreviousRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.625 1.993c0-1.325-1.504-2.074-2.57-1.314L4.018 5.686a1.61 1.61 0 0 0 0 2.628l7.035 5.007c1.067.76 2.57.011 2.57-1.314zm-1.846-.296a.376.376 0 0 1 .596.296v10.014c0 .29-.34.478-.596.296L4.744 7.296a.36.36 0 0 1 0-.592zM1.875 1.25a.875.875 0 1 0-1.75 0v11.5a.875.875 0 0 0 1.75 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonPreviousSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m4.238 6.056l7.819-5.4c.396-.25.878-.183 1.226.08c.269.201.458.519.467.897v10.705c0 .884-.979 1.456-1.693 1.004l-7.82-5.367c-.65-.439-.65-1.48 0-1.919M0 1.742a1 1 0 1 1 2 0v10.516a1 1 0 1 1-2 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRecord3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRecord3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.75 5.75 0 1 0 0 11.5a5.75 5.75 0 0 0 0-11.5M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRecord3Solid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRewind1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.28a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L7.32 7.58a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.62z\"/><path d=\"M7.003 10.28a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L.823 7.58a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.6z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRewind1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625 2.478c0-1.47-1.797-2.122-2.792-1.117L.462 5.777a1.583 1.583 0 0 0 0 2.235l4.371 4.416c.995 1.005 2.792.352 2.792-1.118V8.808l3.583 3.62C12.203 13.433 14 12.78 14 11.31V2.478c0-1.47-1.797-2.122-2.792-1.117L7.625 4.98zm0 4.422v-.012a.34.34 0 0 1 .1-.232l4.372-4.416a.38.38 0 0 1 .422-.085a.34.34 0 0 1 .231.323v8.832c0 .15-.085.267-.23.324a.38.38 0 0 1-.424-.086L7.725 7.132a.34.34 0 0 1-.1-.232m-1.25-.02V2.478a.34.34 0 0 0-.23-.323a.38.38 0 0 0-.423.085L1.35 6.656a.334.334 0 0 0 0 .476l4.372 4.416a.38.38 0 0 0 .422.086a.34.34 0 0 0 .231-.324z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRewind1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.503 5.894l5.227-3.47c.296-.181.658-.133.92.056a.82.82 0 0 1 .35.648v7.723c0 .638-.735 1.05-1.27.724L7.503 8.126v2.724c0 .639-.734 1.052-1.27.725L.366 7.703c-.488-.316-.488-1.067 0-1.384l5.867-3.895a.83.83 0 0 1 .92.056a.82.82 0 0 1 .35.648z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRewind2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.29a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L7.32 7.59a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.62z\"/><path d=\"M7.003 10.29a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L.823 7.59a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.6zM.5 2.5v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRewind2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.833 1.466c.995-1.005 2.792-.352 2.792 1.118v2.502l3.583-3.62C12.203.461 14 1.114 14 2.584v8.832c0 1.47-1.797 2.122-2.792 1.117l-3.583-3.62v2.503c0 1.47-1.797 2.122-2.792 1.117l-3.07-3.102v2.588a.875.875 0 1 1-1.75 0v-4.82a1.6 1.6 0 0 1 0-.397V1.98a.875.875 0 1 1 1.75 0v2.587zm-3.07 6.189v-1.31l3.959-4a.38.38 0 0 1 .423-.085c.145.057.23.174.23.324v8.832c0 .15-.085.266-.23.324a.38.38 0 0 1-.423-.086zm5.862-.661v.012a.34.34 0 0 0 .1.232l4.372 4.416a.38.38 0 0 0 .422.086a.34.34 0 0 0 .231-.324V2.584a.34.34 0 0 0-.23-.324a.38.38 0 0 0-.424.086L7.725 6.762a.34.34 0 0 0-.1.232\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonRewind2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 2.234a1 1 0 0 0-1 1v7.532a1 1 0 1 0 2 0V8.782l4.233 2.793c.536.327 1.27-.086 1.27-.724V8.126l5.227 3.45c.535.326 1.27-.087 1.27-.725V3.128a.82.82 0 0 0-.35-.648c-.262-.189-.623-.237-.92-.056l-5.227 3.47V3.128a.82.82 0 0 0-.35-.648a.83.83 0 0 0-.92-.056L2 5.234v-2a1 1 0 0 0-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonStop: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonStopRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.923 1.625a.3.3 0 0 0-.298.298v10.154c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V1.923a.3.3 0 0 0-.298-.298zm-1.548.298c0-.855.693-1.548 1.548-1.548h10.154c.855 0 1.548.693 1.548 1.548v10.154c0 .855-.693 1.548-1.548 1.548H1.923a1.55 1.55 0 0 1-1.548-1.548z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineButtonStopSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCakeSlice: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 6.5h-11a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1m-9 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-3 3h13m-10-7s0-2 1.5-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCakeSliceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 1.25a.87.87 0 0 0-.714.37a2.626 2.626 0 0 1 1.45 3.88H12c.898 0 1.625.728 1.625 1.625v5c0 .898-.727 1.625-1.625 1.625H2a1.625 1.625 0 0 1-1.625-1.625v-5c0-.82.608-1.499 1.398-1.61a2.626 2.626 0 0 1 1.678-3.958A2.126 2.126 0 0 1 5.5 0a.625.625 0 1 1 0 1.25M1.625 9v3.125c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375V9zM4 5.5a1.375 1.375 0 1 0 0-2.75A1.375 1.375 0 0 0 4 5.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCakeSliceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.47 3.817c0-.937.635-1.726 1.498-1.96a3 3 0 0 1 .152-.624c.09-.24.24-.521.494-.747C3.881.248 4.234.1 4.659.1a.625.625 0 1 1 0 1.25c-.118 0-.175.034-.215.069a.6.6 0 0 0-.153.252a1.4 1.4 0 0 0-.067.248A2.031 2.031 0 1 1 1.47 3.817M0 7.473a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.402H0zm0 2.652V13.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-3.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalculator1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-10 5h11\"/><path d=\"M4.25 8.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M7 8.5A.25.25 0 0 1 7 8m0 .5A.25.25 0 0 0 7 8m2.75.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m-5.5 3a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5M7 11a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m2.75.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5M10 3H9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalculator1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.875 5.5h-9.75v6.875c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375zM2.5 0C1.603 0 .875.728.875 1.625v10.75C.875 13.273 1.603 14 2.5 14h9c.898 0 1.625-.727 1.625-1.625V1.625C13.125.728 12.398 0 11.5 0zm1.75 8.625a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m2.75 0a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m2.75 0a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m-5.5 2.75a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m2.75 0a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m2.75 0a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75M8 2.75A.75.75 0 0 1 8.75 2h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 8 2.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalculator1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.569 1.748c0-.122.095-.204.192-.204h8.478c.097 0 .192.082.192.204v3.416H2.57zM2.76.044c-.944 0-1.692.772-1.692 1.704v10.504c0 .931.748 1.704 1.692 1.704h8.478c.944 0 1.692-.772 1.692-1.704V1.748c0-.932-.748-1.704-1.692-1.704zm1.068 8.675a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5M7 8.72a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m3.92-.75a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m-7.09 3.974a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m3.921-.75a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m2.42.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5M8.465 2.802a.625.625 0 1 0 0 1.25h1.419a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalculator2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2M7 .5v13M.5 7h13m-11-3.25H5m4.25 0h2m-2 5.5h2m-2 2h2M3.75 2.5V5M2.69 9.19l2.12 2.12m0-2.12l-2.12 2.12\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalculator2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 12.5H2.846A1.346 1.346 0 0 1 1.5 11.154V7.5h5zm-6-9.654v8.308A2.346 2.346 0 0 0 2.846 13.5h8.308a2.346 2.346 0 0 0 2.346-2.346V2.846A2.346 2.346 0 0 0 11.154.5H2.846A2.346 2.346 0 0 0 .5 2.846m7 3.654h5V2.846c0-.743-.603-1.346-1.346-1.346H7.5zM9 3.375a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25zM2.125 4c0-.345.28-.625.625-.625h.625V2.75a.625.625 0 1 1 1.25 0v.625h.625a.625.625 0 1 1 0 1.25h-.625v.625a.625.625 0 1 1-1.25 0v-.625H2.75A.625.625 0 0 1 2.125 4m1.257 4.498a.625.625 0 1 0-.884.884l.618.618l-.618.618a.625.625 0 1 0 .884.884L4 10.884l.618.618a.625.625 0 1 0 .884-.884L4.884 10l.618-.618a.625.625 0 1 0-.884-.884L4 9.116zM9 8.25A.625.625 0 1 0 9 9.5h2a.625.625 0 1 0 0-1.25zm-.625 2.875c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25H9a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalculator2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H2.5A2.5 2.5 0 0 0 0 2.5v3.875h6.375zM0 11.5V7.625h6.375V14H2.5A2.5 2.5 0 0 1 0 11.5M7.625 14V7.625H14V11.5a2.5 2.5 0 0 1-2.5 2.5zM14 2.5v3.875H7.625V0H11.5A2.5 2.5 0 0 1 14 2.5m-11.967.225a.625.625 0 0 0 0 1.25h.625V4.6a.625.625 0 1 0 1.25 0v-.625h.625a.625.625 0 0 0 0-1.25h-.625V2.1a.625.625 0 0 0-1.25 0v.625zm6.992.625c0-.346.28-.625.625-.625h2a.625.625 0 0 1 0 1.25h-2a.625.625 0 0 1-.625-.625m.625 5.682a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25zm-.625 2.625c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25h-2a.625.625 0 0 1-.625-.625M1.781 9.215a.625.625 0 0 1 .884 0l.618.618l.618-.618a.625.625 0 1 1 .884.884l-.618.618l.618.618a.625.625 0 0 1-.884.884l-.618-.618l-.618.618a.625.625 0 0 1-.884-.884l.618-.618l-.618-.618a.625.625 0 0 1 0-.884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 2a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2M3.5.5v3m7-3v3M3.5 2h5m1 6h-5M7 5.5v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5.25c.345 0 .625.28.625.625V2h5.75V.875a.625.625 0 1 1 1.25 0V2H12a1.625 1.625 0 0 1 1.625 1.625v8.25A1.625 1.625 0 0 1 12 13.5H2a1.625 1.625 0 0 1-1.625-1.625v-8.25A1.625 1.625 0 0 1 2 2h.875V.875c0-.345.28-.625.625-.625m6.375 3v.625a.625.625 0 1 0 1.25 0V3.25H12a.375.375 0 0 1 .375.375v8.25a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375v-8.25A.375.375 0 0 1 2 3.25h.875v.625a.625.625 0 1 0 1.25 0V3.25zM3.5 8a.75.75 0 0 1 .75-.75h2v-2a.75.75 0 0 1 1.5 0v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2A.75.75 0 0 1 3.5 8\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1-1m.25 8a.75.75 0 0 1 .75-.75h1.75V5.5a.75.75 0 0 1 1.5 0v1.75H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 0 1-1.5 0V8.75H4.5A.75.75 0 0 1 3.75 8\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarEdit: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2M3.5.5v3m7-3v3M3.5 2h5\"/><path d=\"m10 6.864l-4.132 4.132L4 11.25l.263-1.868L8.386 5.25z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarEditRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5.25c.345 0 .625.28.625.625V2h5.75V.875a.625.625 0 1 1 1.25 0V2H12a1.625 1.625 0 0 1 1.625 1.625v8.25A1.625 1.625 0 0 1 12 13.5H2a1.625 1.625 0 0 1-1.625-1.625v-8.25A1.625 1.625 0 0 1 2 2h.875V.875c0-.345.28-.625.625-.625m6.375 3v.625a.625.625 0 1 0 1.25 0V3.25H12a.375.375 0 0 1 .375.375v8.25a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375v-8.25A.375.375 0 0 1 2 3.25h.875v.625a.625.625 0 1 0 1.25 0V3.25zM8.135 5a.5.5 0 0 1 .355.146l1.614 1.614a.5.5 0 0 1 0 .708l-3.632 3.631a.5.5 0 0 1-.286.142l-1.869.254a.5.5 0 0 1-.562-.565l.263-1.868a.5.5 0 0 1 .141-.284l3.623-3.631A.5.5 0 0 1 8.136 5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarEditSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 1 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1-1m5.063 5.073a.25.25 0 0 0-.354 0L4.086 9.205a.25.25 0 0 0-.07.142l-.264 1.868a.25.25 0 0 0 .282.283l1.868-.255a.25.25 0 0 0 .143-.07l4.132-4.132a.25.25 0 0 0 0-.354z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarJumpToDate: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2M3.5.5v3m7-3v3M3.5 2h5M4.419 8.224H9.58\"/><path d=\"m7.642 10.164l1.94-1.94l-1.94-1.94\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarJumpToDateRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5.25c.345 0 .625.28.625.625V2h5.75V.875a.625.625 0 1 1 1.25 0V2H12a1.625 1.625 0 0 1 1.625 1.625v8.25A1.625 1.625 0 0 1 12 13.5H2a1.625 1.625 0 0 1-1.625-1.625v-8.25A1.625 1.625 0 0 1 2 2h.875V.875c0-.345.28-.625.625-.625m6.375 3v.625a.625.625 0 1 0 1.25 0V3.25H12a.375.375 0 0 1 .375.375v8.25a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375v-8.25A.375.375 0 0 1 2 3.25h.875v.625a.625.625 0 1 0 1.25 0V3.25zM7.511 5.423A.625.625 0 0 0 7.125 6v1.375H4.25a.625.625 0 1 0 0 1.25h2.875V10a.625.625 0 0 0 1.067.442l2-2a.625.625 0 0 0 0-.884l-2-2a.625.625 0 0 0-.681-.135\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarJumpToDateSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1-1m-.214 8.181a.75.75 0 0 1 .75-.75H7.43V6.272a.625.625 0 0 1 1.066-.442l1.91 1.91a.625.625 0 0 1 0 .883l-1.91 1.91a.625.625 0 0 1-1.066-.442V8.93H4.036a.75.75 0 0 1-.75-.75Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2M3.5.5v3m7-3v3M3.5 2h5\"/><path d=\"m7.249 4.652l.836 1.683a.26.26 0 0 0 .214.156l1.858.282a.282.282 0 0 1 .156.487L8.941 8.563a.27.27 0 0 0 0 .253l.263 1.848a.282.282 0 0 1-.418.302l-1.654-.876a.33.33 0 0 0-.272 0l-1.654.876a.283.283 0 0 1-.418-.302l.31-1.848a.27.27 0 0 0-.048-.253L3.68 7.25a.282.282 0 0 1 .155-.477l1.858-.272a.26.26 0 0 0 .214-.156l.837-1.683a.282.282 0 0 1 .506-.01\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarStarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5.25c.345 0 .625.28.625.625V2h5.75V.875a.625.625 0 1 1 1.25 0V2H12a1.625 1.625 0 0 1 1.625 1.625v8.25A1.625 1.625 0 0 1 12 13.5H2a1.625 1.625 0 0 1-1.625-1.625v-8.25A1.625 1.625 0 0 1 2 2h.875V.875c0-.345.28-.625.625-.625m6.375 3v.625a.625.625 0 1 0 1.25 0V3.25H12a.375.375 0 0 1 .375.375v8.25a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375v-8.25A.375.375 0 0 1 2 3.25h.875v.625a.625.625 0 1 0 1.25 0V3.25zm-2.89 1.5a.74.74 0 0 1 .67.399l.003.007l.648 1.303l1.435.218a.738.738 0 0 1 .403 1.27l-.998.949l.211 1.484a.738.738 0 0 1-1.088.776l-1.273-.674l-1.273.674a.739.739 0 0 1-1.086-.784l.244-1.445l-1.035-.99l-.01-.01a.739.739 0 0 1 .407-1.248l.007-.002l1.437-.21l.646-1.299a.74.74 0 0 1 .651-.418\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCalendarStarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1a1 1 0 0 0-2 0v1h-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2h-1V1a1 1 0 1 0-2 0v1h-5zm2.489 4.125a.5.5 0 0 1 .454.27l.002.004l.744 1.498h.003l1.65.25a.5.5 0 0 1 .273.862l-1.16 1.103a.3.3 0 0 1 .018.063l.232 1.636a.5.5 0 0 1-.739.529l-1.456-.77a.04.04 0 0 0-.028 0l-1.456.77a.5.5 0 0 1-.738-.533l.276-1.638l.006-.026l-1.195-1.144l-.005-.005a.5.5 0 0 1 .277-.846h.003l1.653-.243l.001-.002l.743-1.493a.5.5 0 0 1 .442-.285\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCallCenterSupportService: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.506 13.065a2.7 2.7 0 0 0 3.37-.36l.38-.38a.91.91 0 0 0 0-1.28l-1.6-1.59a.9.9 0 0 0-1.27 0v0a.91.91 0 0 1-1.28 0l-2.55-2.55a.91.91 0 0 1 0-1.28v0a.9.9 0 0 0 0-1.27l-1.54-1.6a.91.91 0 0 0-1.28 0l-.38.38a2.7 2.7 0 0 0-.41 3.37a24.2 24.2 0 0 0 6.56 6.56m5.959-9.893h-2.748a.215.215 0 0 1-.215-.216v0q.001-.08.053-.142l1.96-2.24a.2.2 0 0 1 .154-.07v0c.112 0 .203.092.203.204v3.353M8.85 4.06H6.48v-.505a.89.89 0 0 1 .533-.814l1.32-.577a.866.866 0 0 0-.348-1.66h-.616a.89.89 0 0 0-.838.593\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCallCenterSupportServiceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.817 1.01A1.51 1.51 0 0 1 7.244 0h.616a1.49 1.49 0 0 1 .598 2.857l-1.32.577a.26.26 0 0 0-.129.122h1.717a.625.625 0 0 1 0 1.25h-2.37a.625.625 0 0 1-.626-.625v-.505c0-.602.356-1.146.907-1.387l1.32-.577a.24.24 0 0 0-.097-.462h-.616a.26.26 0 0 0-.249.176a.625.625 0 1 1-1.178-.417m6.149-.743c.478-.517 1.441-.243 1.441.559v1.84a.625.625 0 0 1 0 1.25v.265a.625.625 0 1 1-1.25 0v-.265h-1.53a.838.838 0 0 1-.649-1.374A215 215 0 0 1 11.966.267m.191 2.4V1.94l-.241.276l-.394.45zM3.545 2.19a1.544 1.544 0 0 0-2.159 0l-.002.002l-.377.377a3.325 3.325 0 0 0-.49 4.164c.915 1.359 2.483 2.96 3.848 4.24c1.362 1.276 2.599 2.3 2.882 2.49a3.325 3.325 0 0 0 4.11-.386q.048-.035.097-.078c.087-.077.204-.197.367-.388c.475-.557.588-1.5-.031-2.125l-.004-.004l-1.6-1.59l-.271-.207l.271.207a1.3 1.3 0 0 0-.27-.207L5.468 5.3a1.53 1.53 0 0 0-.376-1.502L3.556 2.202zM5.47 5.3l4.446 3.385a1.6 1.6 0 0 0-.879-.193c-.334.019-.736.135-1.002.401a.4.4 0 0 1-.09.075a1 1 0 0 1-.108.005a.28.28 0 0 1-.2-.081L5.09 6.345a.285.285 0 0 1 0-.4c.185-.185.311-.408.38-.645M2.975 3.4L5.47 5.3zl-.313-.325A.3.3 0 0 0 2.45 3l-1.064-.81L2.45 3a.28.28 0 0 0-.184.078l-.378.378l-.007.007a2.075 2.075 0 0 0-.32 2.581c.83 1.23 2.303 2.745 3.659 4.015c1.363 1.278 2.535 2.239 2.725 2.367a2.075 2.075 0 0 0 2.58-.284a.6.6 0 0 1 .108-.087c.031-.028.104-.1.237-.256a.4.4 0 0 0 .096-.252a.24.24 0 0 0-.063-.182L9.305 9.779c-.004-.004-.06-.046-.2-.038a.6.6 0 0 0-.199.048a1.5 1.5 0 0 1-.539.355a1.5 1.5 0 0 1-.531.08c-.405 0-.793-.16-1.08-.444l-.002-.003l-2.55-2.55l-.003-.002a1.535 1.535 0 0 1 0-2.16h.002a.284.284 0 0 0 0-.389l-.008-.007zM2.45 3l.525.4zm2.64 2.944l-.444-.44l.443.441M7.941 8.97h.002z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCallCenterSupportServiceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.656 1.195A1.51 1.51 0 0 1 7.084.186H7.7a1.49 1.49 0 0 1 .597 2.857l-1.319.577a.26.26 0 0 0-.13.122h1.718a.625.625 0 1 1 0 1.25h-2.37a.625.625 0 0 1-.626-.625v-.505c0-.602.356-1.146.907-1.387l1.32-.577a.24.24 0 0 0-.097-.462h-.616a.26.26 0 0 0-.249.176a.625.625 0 0 1-1.179-.417M11.76.47a.829.829 0 0 1 1.452.546v1.839a.625.625 0 0 1 0 1.248v.265a.625.625 0 0 1-1.25 0v-.264h-1.53A.84.84 0 0 1 9.8 2.709zm-.425 2.384l.627-.717v.717zM8.915 13.8a2.7 2.7 0 0 1-1.75-.415a24.2 24.2 0 0 1-6.56-6.56a2.7 2.7 0 0 1 .41-3.37l.38-.38a.91.91 0 0 1 1.28 0l1.54 1.6a.9.9 0 0 1 0 1.27a.91.91 0 0 0 0 1.28l2.55 2.55a.91.91 0 0 0 1.28 0a.9.9 0 0 1 1.27 0l1.6 1.59a.91.91 0 0 1 0 1.28l-.38.38a2.7 2.7 0 0 1-1.62.775\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCallHangUp: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.761 8.69a1.06 1.06 0 0 1-1.484 0a1.05 1.05 0 0 0-1.474 0L.926 10.549a1.06 1.06 0 0 0 0 1.484l.442.433a3.135 3.135 0 0 0 3.931.432a28 28 0 0 0 2.647-2.021M.5.5l13 13M9.467 9.467a28.4 28.4 0 0 0 3.46-4.177a3.135 3.135 0 0 0-.433-3.931L12.06.916a1.06 1.06 0 0 0-1.484 0L8.71 2.784a1.05 1.05 0 0 0 0 1.474a1.04 1.04 0 0 1 0 1.484L7.226 7.226\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCallHangUpRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 1 .884 0l6.155 6.155l1.013-1.013l.003-.004a.415.415 0 0 0 0-.565l-.007-.007a1.667 1.667 0 0 1 0-2.322l.004-.004L10.067.592l.004-.005a1.676 1.676 0 0 1 2.33 0l.01.01l.42.43a3.73 3.73 0 0 1 .506 4.635l-.008.012a28.5 28.5 0 0 1-3.03 3.742l3.518 3.517a.625.625 0 1 1-.884.884L8.984 9.868l-.013-.013L6.786 7.67l-.013-.013l-6.59-6.59a.625.625 0 0 1 0-.884m7.923 7.039l1.31 1.31a27 27 0 0 0 2.875-3.554a2.48 2.48 0 0 0-.342-3.066l-.008-.008l-.418-.427a.427.427 0 0 0-.576.002L9.121 3.305a.417.417 0 0 0 0 .566a1.665 1.665 0 0 1-.003 2.339zm-3.34.99a1.667 1.667 0 0 0-2.32 0l-.002.002l-1.841 1.822l-.008.007a1.676 1.676 0 0 0 0 2.33l.01.01l.43.42a3.73 3.73 0 0 0 4.636.506l.01-.007a29 29 0 0 0 2.655-2.027a.625.625 0 0 0-.816-.947a27 27 0 0 1-2.532 1.934a2.48 2.48 0 0 1-3.067-.341l-.008-.008l-.427-.418a.427.427 0 0 1 0-.575l1.836-1.816a.417.417 0 0 1 .57 0v.001a1.666 1.666 0 0 0 2.33 0a.625.625 0 1 0-.874-.894a.416.416 0 0 1-.581 0m0 0l-.438.446z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCallHangUpSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22l6.123 6.122l.953-.953l.003-.003a.54.54 0 0 0 0-.772l-.006-.006a1.55 1.55 0 0 1 0-2.175l1.87-1.87l.004-.004a1.56 1.56 0 0 1 2.184 0l.437.447a3.635 3.635 0 0 1 .498 4.555l-.006.01a29 29 0 0 1-2.995 3.713l3.435 3.436a.75.75 0 1 1-1.06 1.06zm5.242 7.002l2.895 2.895l-.071.066l-.014.012a29 29 0 0 1-2.693 2.057l-.009.005a3.635 3.635 0 0 1-4.555-.498l-.44-.43l-.007-.007a1.56 1.56 0 0 1 0-2.183L2.45 8.335l.001-.001a1.55 1.55 0 0 1 2.175 0v-.001l-.35.357l.35-.356a.56.56 0 0 0 .783 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCamera1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 5a1 1 0 0 0-1-1h-2L9 2H5L3.5 4h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1z\"/><path d=\"M7 9.75a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCamera1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.875.875a.63.63 0 0 0-.536.303L3.021 3.375H1.625A1.625 1.625 0 0 0 0 5v6.5a1.625 1.625 0 0 0 1.625 1.625h10.75A1.625 1.625 0 0 0 14 11.5V5a1.625 1.625 0 0 0-1.625-1.625h-1.396L9.66 1.178a.63.63 0 0 0-.536-.303zm-.964 3.447l1.318-2.197H8.77l1.318 2.197a.63.63 0 0 0 .536.303h1.75A.375.375 0 0 1 12.75 5v6.5a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375V5a.375.375 0 0 1 .375-.375h1.75c.22 0 .423-.115.536-.303M9.5 7.782a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCamera1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.6 1.7a.5.5 0 0 1 .4-.2h4a.5.5 0 0 1 .4.2l1.35 1.8h1.75A1.5 1.5 0 0 1 14 5v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 11V5a1.5 1.5 0 0 1 1.5-1.5h1.75zm4.861 6.011a2.461 2.461 0 1 1-4.922 0a2.461 2.461 0 0 1 4.922 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraDisabled: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8.219m-4.04-6.321a2.25 2.25 0 0 1 3.143 3.143\"/><path d=\"M3.714 3.714L5 2h4l1.5 2h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H12M4.778 7.145a2.25 2.25 0 0 0 2.577 2.577M13.5 13.5L.5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraDisabledRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 1 .884 0l2.23 2.23L4.34.679a.63.63 0 0 1 .536-.303h4.25c.22 0 .423.115.536.303l1.318 2.197h1.396A1.625 1.625 0 0 1 14 4.5V11a1.63 1.63 0 0 1-.748 1.368l.565.565a.625.625 0 1 1-.884.884L.183 1.067a.625.625 0 0 1 0-.884m5.73 4.846L4.21 3.325l1.02-1.7h3.54l1.318 2.197a.63.63 0 0 0 .536.303h1.75a.375.375 0 0 1 .375.375V11a.375.375 0 0 1-.375.375h-.116L9.252 8.368A2.5 2.5 0 0 0 5.913 5.03M4.5 7.281q0-.216.036-.424l2.888 2.888q-.208.036-.424.036a2.5 2.5 0 0 1-2.5-2.5M1.3 4.312a.625.625 0 0 0-1.082-.624A1.6 1.6 0 0 0 0 4.5V11a1.625 1.625 0 0 0 1.625 1.625h7.134a.625.625 0 1 0 0-1.25H1.625A.375.375 0 0 1 1.25 11V4.5q.001-.1.05-.188\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraDisabledSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.219.219a.75.75 0 0 0 0 1.06l.178.179q.027.022.051.046l12.328 12.328a.75.75 0 0 0 1.005-1.112l-.83-.829A1 1 0 0 0 13.5 11V5a1 1 0 0 0-1-1h-2L9 2H5l-.832 1.109L1.28.219a.75.75 0 0 0-1.061 0m8.957 11.78L1.217 4.04A1 1 0 0 0 .5 5v6a1 1 0 0 0 1 1zm.09-4.515q-.002.33-.09.632L6.368 5.307a2.267 2.267 0 0 1 2.898 2.177\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraLoading: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 5a1 1 0 0 0-1-1h-2L9 2H5L3.5 4h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1z\"/><path d=\"M4.292 8a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m2.596.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M9.75 8a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraLoadingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.875.875a.63.63 0 0 0-.536.303L3.021 3.375H1.625A1.625 1.625 0 0 0 0 5v6.5a1.625 1.625 0 0 0 1.625 1.625h10.75A1.625 1.625 0 0 0 14 11.5V5a1.625 1.625 0 0 0-1.625-1.625h-1.396L9.66 1.178a.63.63 0 0 0-.536-.303zm-.964 3.447l1.318-2.197H8.77l1.318 2.197a.63.63 0 0 0 .536.303h1.75A.375.375 0 0 1 12.75 5v6.5a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375V5a.375.375 0 0 1 .375-.375h1.75c.22 0 .423-.115.536-.303m.037 2.46a1 1 0 1 1 0 2a1 1 0 0 1 0-2m4.052 1a1 1 0 1 0-2 0a1 1 0 0 0 2 0m3.052 0a1 1 0 1 0-2 0a1 1 0 0 0 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraLoadingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.6 1.7a.5.5 0 0 1 .4-.2h4a.5.5 0 0 1 .4.2l1.35 1.8h1.75A1.5 1.5 0 0 1 14 5v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 11V5a1.5 1.5 0 0 1 1.5-1.5h1.75zm-.308 6.808a.758.758 0 1 0 0-1.516a.758.758 0 0 0 0 1.516m3.354-.758a.758.758 0 1 1-1.516 0a.758.758 0 0 1 1.516 0m2.104.758a.758.758 0 1 0 0-1.516a.758.758 0 0 0 0 1.516\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M10.5 6a1 1 0 0 0-1-1H9L8 3.5H6L5 5h-.5a1 1 0 0 0-1 1v2.5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1z\"/><path d=\"M7 7.375a.375.375 0 1 1 0-.75m0 .75a.375.375 0 1 0 0-.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.375 12.077a.3.3 0 0 1-.298.298H1.923a.3.3 0 0 1-.298-.298V1.923c0-.165.133-.298.298-.298h10.154c.165 0 .298.133.298.298zm-.298 1.548c.855 0 1.548-.693 1.548-1.548V1.923c0-.855-.693-1.548-1.548-1.548H1.923c-.855 0-1.548.693-1.548 1.548v10.154c0 .855.693 1.548 1.548 1.548zM5.584 3.723A.5.5 0 0 1 6 3.5h2a.5.5 0 0 1 .416.223L9.268 5H9.5A1.5 1.5 0 0 1 11 6.5V9a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 3 9V6.5A1.5 1.5 0 0 1 4.5 5h.232zM5.625 7.5A1.375 1.375 0 1 0 7 6.125c-.76 0-1.375.616-1.375 1.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5zm10.824 4.732a1.093 1.093 0 0 0-1.092-1.093h-.547L8.093 3.5H5.907L4.815 5.139h-.547a1.093 1.093 0 0 0-1.092 1.093v2.731a1.093 1.093 0 0 0 1.093 1.093h5.463a1.093 1.093 0 0 0 1.092-1.093zM5.81 7.469a1.191 1.191 0 1 1 2.382 0a1.191 1.191 0 0 1-2.382 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraVideo: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 6.5a3 3 0 1 0 0-6a3 3 0 0 0 0 6m7 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4M10 9H4.5a1 1 0 0 0-1 1v2.5a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1m3.5 1v2.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraVideoRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.25 3.75a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0M10 2.5A2.25 2.25 0 1 0 10 7a2.25 2.25 0 0 0 0-4.5M4.25 9.125a.375.375 0 0 0-.375.375V12c0 .207.168.375.375.375h5.5a.375.375 0 0 0 .375-.375V9.5a.375.375 0 0 0-.375-.375zM2.625 9.5c0-.897.728-1.625 1.625-1.625h5.5c.898 0 1.625.728 1.625 1.625V12c0 .898-.727 1.625-1.625 1.625h-5.5A1.625 1.625 0 0 1 2.625 12zm11.125.5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCameraVideoSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3.5a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0M10.5 2a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5M1.912 9.609c0-.89.721-1.612 1.612-1.612h6.114c.89 0 1.612.722 1.612 1.612v2.78c0 .89-.722 1.611-1.612 1.611H3.524c-.89 0-1.612-.722-1.612-1.612zm11.966.14a.75.75 0 1 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCampingTent: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 10.5v3m2-13l-8.5 13h13L5 .5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCampingTentRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.03.669a.625.625 0 0 0-1.06.662L6.263 3.4L.47 12.669a.625.625 0 0 0 .53.956h12a.625.625 0 0 0 .53-.956L7.737 3.4L9.03 1.331A.625.625 0 0 0 7.97.67L7 2.22zM2.128 12.375L7 4.579l4.872 7.796H7.875V10a.875.875 0 0 0-1.75 0v2.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCampingTentSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.67.13a.75.75 0 0 1 1.037.218L7 2.325L8.293.348a.75.75 0 1 1 1.255.82L7.896 3.697l5.973 9.135a.75.75 0 0 1-.628 1.16H8v-3.019a1 1 0 1 0-2 0v3.02H.758a.75.75 0 0 1-.627-1.16l5.973-9.136L4.452 1.17A.75.75 0 0 1 4.669.13\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCandyCane: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 0 3 0V5a4.5 4.5 0 1 0-9 0v1a1.5 1.5 0 0 0 3 0zm3 5l3-3M8.42 4.51L9.95 1.6M5.86 4.02L3.03 2.88\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCandyCaneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.353 3.207a4.36 4.36 0 0 0-.728 2.418v.25a1.125 1.125 0 0 0 2.25 0v-.25c0-.362.09-.702.25-1zm5.379 1.186c.247.348.393.773.393 1.232V9.25L11.375 7V5.625c0-1.08-.392-2.07-1.041-2.834zM7 0a5.625 5.625 0 0 0-5.625 5.625v.25a2.375 2.375 0 1 0 4.75 0v-.25a.875.875 0 1 1 1.75 0v6a2.375 2.375 0 1 0 4.75 0v-6A5.625 5.625 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCandyCaneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.98 0C8 0 8.986.32 9.804.907L8.046 3.632a1.615 1.615 0 0 0-2.217.081L2.845 2.511a1 1 0 0 0-.094-.03A4.84 4.84 0 0 1 6.98 0M2.29 3.627a5 5 0 0 0-.156 1.22v1.076a1.615 1.615 0 0 0 3.231 0v-1.05L2.378 3.67a1 1 0 0 1-.088-.043m6.306 1.458l2.134-3.31a4.85 4.85 0 0 1 1.097 3.071v1.27l-3.231 3.23zm0 6.03v1.27a1.616 1.616 0 0 0 3.23 0V7.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCane: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m8.799 9.979l-.057-.641a1.183 1.183 0 0 1 1.075-1.282v0a1.18 1.18 0 0 1 1.211.764l1.411 3.772M3.57 2.822a1.715 1.715 0 1 0 3.43 0a1.715 1.715 0 1 0-3.43 0\"/><path d=\"m2.099 12.592l2.573-8.148c.278.706 1.565 2.557 3.194 2.386\"/><path d=\"m3.57 7.964l2.087 1.502a1 1 0 0 1 .388.577l.615 2.549\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCaneAlt: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.5 3a1 1 0 0 0-1 1v.25a1.25 1.25 0 1 1-2.5 0V4a3.5 3.5 0 1 1 7 0v8.25a1.25 1.25 0 1 1-2.5 0V4a1 1 0 0 0-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCaneAltRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.546 1.183a4.043 4.043 0 0 1 5.717 5.718l-6.56 6.56a1.846 1.846 0 1 1-2.61-2.61l6.56-6.56a.352.352 0 0 0-.497-.498l-.173.173a1.846 1.846 0 1 1-2.61-2.61zm4.833.884a2.793 2.793 0 0 0-3.95 0l-.172.173a.596.596 0 0 0 .842.842l.173-.173a1.602 1.602 0 0 1 2.265 2.265l-6.56 6.56a.596.596 0 0 0 .843.842l6.56-6.56a2.793 2.793 0 0 0 0-3.949\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCaneAltSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.469 2.5a1 1 0 0 0-1 1v.25a1.25 1.25 0 1 1-2.5 0V3.5a3.5 3.5 0 1 1 7 0v9.25a1.25 1.25 0 1 1-2.5 0V3.5a1 1 0 0 0-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCaneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.125 1.25a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25M2.75 2.375a2.375 2.375 0 1 1 2.554 2.368l-.484.693l.536.536c.258.258.608.403.973.403h1.046a.625.625 0 0 1 0 1.25H6.33a2.63 2.63 0 0 1-1.857-.769l-.38-.38l-1.436 2.052l1.4 1.198c.361.308.57.76.57 1.235v2.414a.625.625 0 1 1-1.25 0v-2.414a.38.38 0 0 0-.132-.285L1.07 8.818A1.625 1.625 0 0 1 .795 6.65L3.02 3.473a2.4 2.4 0 0 1-.269-1.098m7.375 6.5a.875.875 0 0 1 1.75 0v4.5a.625.625 0 1 0 1.25 0v-4.5a2.125 2.125 0 0 0-4.25 0a.625.625 0 1 0 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCaneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.512 3.917a1.959 1.959 0 1 0 0-3.917a1.959 1.959 0 0 0 0 3.917M9.62 9.271a.433.433 0 0 1 .836-.19l1.411 3.774a.75.75 0 0 0 1.405-.526L11.86 8.556a1.933 1.933 0 0 0-3.735.847l.056.641a.75.75 0 0 0 1.494-.131L9.62 9.27Zm-5.452-4.72a1 1 0 0 1 .936.252c.684.661 1.443 1.16 2.658 1.032a1 1 0 1 1 .21 1.99c-1.276.133-2.269-.179-3.053-.644l-.166.509l1.52 1.094a2 2 0 0 1 .776 1.154l.584 2.419a1 1 0 1 1-1.944.47l-.584-2.42L4.1 9.685l-1.05 3.217a1 1 0 1 1-1.902-.62l2.31-7.071a1 1 0 0 1 .71-.66\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCapitol: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.262 8.831H.857l6.202-3.544zM.857 13.262h12.405M1.743 8.831v4.43M4.4 8.831v4.43m2.66-4.43v4.43m2.657-4.43v4.43m2.659-4.43v4.43\"/><path d=\"M3.515 7.296V5.73a3.544 3.544 0 1 1 7.088 0v1.566M7.06 2.185V.856\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCapitolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .375c.345 0 .625.28.625.625v.922A4.126 4.126 0 0 1 11.125 6v.999l2.222 1.481A.625.625 0 0 1 13 9.625h-.375v2.75H13a.625.625 0 1 1 0 1.25H1a.625.625 0 1 1 0-1.25h.375v-2.75H1A.625.625 0 0 1 .653 8.48l2.222-1.481V6a4.126 4.126 0 0 1 3.5-4.078V1c0-.345.28-.625.625-.625m2.875 5.79L7.347 4.48a.625.625 0 0 0-.694 0L4.125 6.166V6a2.875 2.875 0 1 1 5.75 0zm-7.25 3.46v2.75h1.25v-2.75zm2.5 0v2.75h1.25v-2.75zm2.5 0v2.75h1.25v-2.75zm2.5 0v2.75h1.25v-2.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCapitolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.06.016a.75.75 0 0 1 .75.75v.702a4.25 4.25 0 0 1 3.5 4.185v.077L7.616 3.62a1.13 1.13 0 0 0-1.116 0L2.809 5.73v-.077c0-2.092 1.51-3.83 3.5-4.185V.766a.75.75 0 0 1 .75-.75ZM.856 9.33h.346v3.148h-.101a.75.75 0 0 0 0 1.5h11.914a.75.75 0 0 0 0-1.5h-.1V9.33h.346a.5.5 0 0 0 .248-.934L7.307 4.853a.5.5 0 0 0-.496 0L.608 8.397a.5.5 0 0 0 .249.934Zm1.846 3.148V9.33h1.053v3.148zm2.553 0V9.33h1.053v3.148H5.256Zm2.553 0V9.33h1.053v3.148H7.81Zm2.553 0V9.33h1.053v3.148z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCarBatteryCharging: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 5v7.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1M2 4V2h3v2m4 0V2h3v2\"/><path d=\"m7.5 6l-2 2.5h3l-2 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCarBatteryChargingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.25 1.5a.5.5 0 0 0-.5.5v1.5h-.125C.728 3.5 0 4.228 0 5.125v7.25C0 13.273.728 14 1.625 14h10.75c.898 0 1.625-.727 1.625-1.625v-7.25c0-.897-.727-1.625-1.625-1.625h-.125V2a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v1.5h-3.5V2a.5.5 0 0 0-.5-.5zm-.625 3.25a.375.375 0 0 0-.375.375v7.25c0 .207.168.375.375.375h10.75a.375.375 0 0 0 .375-.375v-7.25a.375.375 0 0 0-.375-.375zm6.119 2.049a.75.75 0 1 0-1.238-.848L4.881 8.326A.75.75 0 0 0 5.5 9.5h1.578l-.822 1.202a.75.75 0 1 0 1.238.847l1.625-2.375A.75.75 0 0 0 8.5 8H6.922z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCarBatteryChargingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1.5h3V2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1.5A1.5 1.5 0 0 1 14 5v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5V5a1.5 1.5 0 0 1 1.5-1.5zm6.446 4.62a.625.625 0 0 0-.976-.781L5.137 8.13a.625.625 0 0 0 .488 1.016h1.582l-1.185 1.778a.625.625 0 1 0 1.04.694l1.833-2.75a.625.625 0 0 0-.52-.972h-1.45z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCarTaxi1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2 11h-.5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1H3l.77-2.32a1 1 0 0 1 1-.68h4.01a1 1 0 0 1 1 .68L10.5 7h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H12\"/><path d=\"M10.499 12.5a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002m-7 0a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002M8.998 11H5m2-7V2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCarTaxi1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 .875a.625.625 0 0 0-.625.625v1.375H4.159c-.65 0-1.237.387-1.493.985L1.588 6.375C.708 6.395 0 7.115 0 8v2c0 .888.713 1.61 1.598 1.625a2.002 2.002 0 0 0 3.802 0h3.198a2.002 2.002 0 0 0 3.802 0A1.625 1.625 0 0 0 14 10V8c0-.897-.727-1.625-1.625-1.625h-1.963L9.334 3.86a1.63 1.63 0 0 0-1.493-.985H6.625V1.5A.625.625 0 0 0 6 .875m-1.84 3.25h3.68c.15 0 .286.09.345.227l1.24 2.894c.099.23.325.379.575.379h2.375c.207 0 .375.168.375.375v2a.375.375 0 0 1-.35.374a2.002 2.002 0 0 0-3.803.001H5.401a2.002 2.002 0 0 0-3.804-.001A.375.375 0 0 1 1.25 10V8c0-.207.168-.375.375-.375H2c.25 0 .476-.149.574-.379l1.24-2.894a.38.38 0 0 1 .345-.227m.234 3.5a.5.5 0 0 1-.46-.697l.59-1.375a.5.5 0 0 1 .46-.303h2.032c.2 0 .381.12.46.303l.59 1.375a.5.5 0 0 1-.46.697z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCarTaxi1Solid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.499 13.253a1.501 1.501 0 1 1 0-3.003a1.501 1.501 0 0 1 0 3.003m-7 0a1.501 1.501 0 1 1 0-3.003a1.501 1.501 0 0 1 0 3.003\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a.75.75 0 0 0-.75.75v1.5H4.782a1.5 1.5 0 0 0-1.486 1.02v.003L2.638 6.5H1.5A1.5 1.5 0 0 0 0 8v2a1.5 1.5 0 0 0 1.02 1.421a2.502 2.502 0 0 1 4.968.079H8.01a2.501 2.501 0 0 1 4.968-.078A1.5 1.5 0 0 0 14 10V8a1.5 1.5 0 0 0-1.5-1.5h-1.632l-.61-1.968l-.004-.011A1.5 1.5 0 0 0 8.768 3.5H7.75V2A.75.75 0 0 0 7 1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCards: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.546.857a.475.475 0 0 1 .581-.335l6.02 1.612a.475.475 0 0 1 .337.581l-2.31 8.618a.475.475 0 0 1-.582.335l-6.02-1.612a.475.475 0 0 1-.336-.581z\"/><path d=\"M6.108 2.535L.852 3.944a.475.475 0 0 0-.336.581l2.308 8.618a.475.475 0 0 0 .582.335l3.01-.806\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCardsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m1.286 2.785l5.597-1.499L9.066 9.43l-5.597 1.499zM8.05.808a1.09 1.09 0 0 0-1.336-.77L.81 1.617a1.09 1.09 0 0 0-.772 1.337l2.266 8.451a1.09 1.09 0 0 0 1.336.771l.342-.091a.5.5 0 0 0 .126.053l6.288 1.703a.966.966 0 0 0 1.183-.683l2.264-8.452a.966.966 0 0 0-.683-1.182L8.438 2.259z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCardsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.56.33a.48.48 0 0 0-.587.339L4.64 9.377a.48.48 0 0 0 .34.587l6.083 1.63a.48.48 0 0 0 .587-.34l2.335-8.707a.48.48 0 0 0-.34-.588zM3.433 9.053l1.596-5.955L.356 4.349a.48.48 0 0 0-.34.588l2.335 8.707a.48.48 0 0 0 .587.34l6.084-1.63l.023-.007l-4.39-1.176a1.73 1.73 0 0 1-1.223-2.118\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCat1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 7.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4 .5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m-4.5 6.46a4 4 0 0 0 1.5.29h2a4 4 0 0 0 1.5-.29M2 7.5v-7l4.153 3.056M12 7.5v-7L7.86 3.556\"/><path d=\"M4.019 4.5c.732-.614 1.796-1 2.981-1s2.25.386 2.982 1M.5 9.5H4m0 2L1 13m9-3.5h3.5m-3.5 2l3 1.5M7.75 9.5h-1.5L7 10z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCat1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.26.432a.63.63 0 0 0-.668.095L8.608 3.098A5.8 5.8 0 0 0 7 2.875c-.562 0-1.104.078-1.608.223L2.408.527A.625.625 0 0 0 1.375 1v6.25a.625.625 0 0 0 1.21.22c.121-.32.465-.98.986-1.625c.376-.465.814-.887 1.293-1.176q.275-.16.598-.28l.006-.002A4.5 4.5 0 0 1 7 4.125c.824 0 1.564.21 2.138.545c.478.289.916.71 1.29 1.175c.522.645.866 1.304.987 1.626a.625.625 0 0 0 1.21-.221V1a.63.63 0 0 0-.365-.568M9.265 12.38a.625.625 0 0 1 .47 1.159A4.6 4.6 0 0 1 8 13.875H6c-.612 0-1.198-.12-1.735-.336a.625.625 0 0 1 .47-1.16c.39.159.816.246 1.265.246h2c.449 0 .876-.087 1.265-.245M13 8.625a.625.625 0 1 1 0 1.25h-2.75a.625.625 0 1 1 0-1.25zm-3.416 2.187a.625.625 0 0 0 .228.854l2.375 1.375a.625.625 0 1 0 .626-1.082l-2.375-1.375a.625.625 0 0 0-.854.228M3.75 8.625a.625.625 0 1 1 0 1.25H1a.625.625 0 1 1 0-1.25zm.666 2.187a.625.625 0 0 0-.854-.228L1.187 11.96a.625.625 0 0 0 .626 1.082l2.375-1.375a.625.625 0 0 0 .228-.854M7.75 8.875a.625.625 0 0 1 .347 1.145l-.75.5a.625.625 0 0 1-.694 0l-.75-.5a.625.625 0 0 1 .347-1.145zM9.875 7a.875.875 0 1 1-1.75 0a.875.875 0 0 1 1.75 0m-4 0a.875.875 0 1 1-1.75 0a.875.875 0 0 1 1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCat1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.777.053A.5.5 0 0 1 2.3.1l3.917 2.947a6.6 6.6 0 0 1 1.564 0L11.7.1a.5.5 0 0 1 .801.4v8.25h.748a.75.75 0 0 1 0 1.5h-.81a4.5 4.5 0 0 1-.479 1.391l1.376.688a.75.75 0 1 1-.67 1.342l-1.654-.827A4.48 4.48 0 0 1 8 14H6a4.48 4.48 0 0 1-3.011-1.156l-1.654.827a.75.75 0 1 1-.67-1.342l1.376-.688a4.5 4.5 0 0 1-.479-1.391h-.81a.75.75 0 0 1 0-1.5H1.5V.5a.5.5 0 0 1 .277-.447M9.124 7.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m-4.25 0a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m.897 1.605A.5.5 0 0 1 6.25 9h1.5a.5.5 0 0 1 .277.916l-.75.5a.5.5 0 0 1-.554 0l-.75-.5a.5.5 0 0 1-.202-.56\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetwork4g: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.527 4.846c-.773-.547-1.633-.853-2.511-.892c-.877.042-1.734.348-2.505.895M2.098 2.828A7.9 7.9 0 0 1 7.003.953a7.9 7.9 0 0 1 4.9 1.875m-1.689 8.324h1.306v.87c0 .722-.584 1.307-1.306 1.307h-.87a1.306 1.306 0 0 1-1.306-1.306V9.41c0-.72.585-1.306 1.306-1.306h.87c.569 0 1.053.364 1.232.871M6.45 12.023H2.414a.316.316 0 0 1-.316-.317v0c0-.076.027-.15.078-.208l2.879-3.29a.3.3 0 0 1 .225-.103v0a.3.3 0 0 1 .3.3v4.924\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetwork4gRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.612 2.304a.75.75 0 0 0 .97 1.144A7.16 7.16 0 0 1 7.004 1.75a7.15 7.15 0 0 1 4.413 1.697a.75.75 0 0 0 .972-1.143A8.65 8.65 0 0 0 6.983.25a8.66 8.66 0 0 0-5.37 2.054M3.9 5.33a.75.75 0 0 1 .177-1.046c.878-.623 1.872-.983 2.903-1.033h.07c1.033.047 2.03.406 2.91 1.029a.75.75 0 1 1-.867 1.224c-.653-.463-1.364-.714-2.076-.753c-.711.041-1.42.293-2.072.756A.75.75 0 0 1 3.9 5.331M5.47 7.15a.92.92 0 0 0-.696.317l-2.879 3.29a.941.941 0 0 0 .709 1.561h2.54V13a.625.625 0 1 0 1.25 0v-.68h.246a.625.625 0 1 0 0-1.25h-.246V8.075a.924.924 0 0 0-.924-.924m-.326 1.792v2.126h-1.86zm3.709.14a.68.68 0 0 1 .68-.681h.871c.296 0 .549.188.642.454a.625.625 0 0 0 1.179-.417a1.93 1.93 0 0 0-1.82-1.287h-.871a1.93 1.93 0 0 0-1.931 1.93v2.612a1.93 1.93 0 0 0 1.93 1.931h.871a1.93 1.93 0 0 0 1.93-1.93v-.871a.625.625 0 0 0-.624-.625h-1.306a.625.625 0 1 0 0 1.25h.68v.245a.68.68 0 0 1-.68.681h-.87a.68.68 0 0 1-.681-.68z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetwork4gSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.695 2.236a.625.625 0 0 0 .806.956a7.33 7.33 0 0 1 4.503-1.717a7.3 7.3 0 0 1 4.495 1.717a.625.625 0 1 0 .806-.955A8.56 8.56 0 0 0 6.987.226a8.58 8.58 0 0 0-5.291 2.01Zm2.456 1.976a.625.625 0 1 0 .72 1.021c.673-.474 1.406-.733 2.146-.774c.74.039 1.477.297 2.15.771a.625.625 0 0 0 .72-1.022c-.863-.607-1.836-.954-2.843-1h-.058c-1.004.049-1.975.397-2.835 1.004M9.66 8.584c-.38 0-.68.305-.68.673v2.595c0 .368.3.673.68.673h.87c.38 0 .681-.305.681-.673v-.24h-.68a.625.625 0 0 1 0-1.25h1.305c.345 0 .625.28.625.625v.865a1.927 1.927 0 0 1-1.93 1.923H9.66a1.927 1.927 0 0 1-1.93-1.923V9.257c0-1.066.867-1.923 1.93-1.923h.87c.84 0 1.555.533 1.82 1.28a.625.625 0 1 1-1.177.42a.68.68 0 0 0-.642-.45zm-4.314-1.25a.93.93 0 0 0-.694.314l-2.879 3.27a.939.939 0 0 0 .705 1.56H5.02v.672a.625.625 0 1 0 1.25 0v-.673h.245a.625.625 0 1 0 0-1.25H6.27V8.26a.925.925 0 0 0-.925-.925ZM5.021 9.12v2.107H3.166L5.02 9.12Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetwork5g: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.59 4.846c-.773-.547-1.633-.853-2.512-.892c-.877.042-1.734.348-2.504.895M2.16 2.828A7.9 7.9 0 0 1 7.066.953a7.9 7.9 0 0 1 4.899 1.875m-1.821 8.449h1.306v.87c0 .722-.585 1.307-1.306 1.307h-.87a1.306 1.306 0 0 1-1.306-1.306V9.536c0-.72.584-1.306 1.306-1.306h.87c.569 0 1.052.364 1.232.871m-5.4-.867H3.148l-.435 2.61l.32-.16A2.6 2.6 0 0 1 4.2 10.41h.688c.721 0 1.305.584 1.305 1.305v.435c0 .72-.584 1.305-1.305 1.305h-.87a1.305 1.305 0 0 1-1.23-.87\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetwork5gRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.612 2.304a.75.75 0 0 0 .97 1.144A7.16 7.16 0 0 1 7.004 1.75a7.15 7.15 0 0 1 4.413 1.697a.75.75 0 0 0 .972-1.143A8.65 8.65 0 0 0 6.983.25a8.66 8.66 0 0 0-5.37 2.054m2.465 1.981a.75.75 0 0 0 .868 1.223c.652-.463 1.36-.715 2.072-.756c.712.04 1.423.29 2.076.753a.75.75 0 0 0 .867-1.224c-.88-.623-1.877-.982-2.91-1.029h-.07c-1.031.05-2.025.41-2.903 1.033m5.335 4.117a.68.68 0 0 0-.68.68v2.612a.68.68 0 0 0 .68.681h.871a.68.68 0 0 0 .68-.68v-.246h-.68a.625.625 0 0 1 0-1.25h1.306c.345 0 .625.28.625.625v.87a1.93 1.93 0 0 1-1.931 1.931h-.87a1.93 1.93 0 0 1-1.931-1.93V9.082a1.93 1.93 0 0 1 1.93-1.931h.871a1.93 1.93 0 0 1 1.82 1.287a.625.625 0 0 1-1.178.417a.68.68 0 0 0-.642-.454zm-3.74 0H3.376l-.167.999q.34-.075.689-.074h.688a1.93 1.93 0 0 1 1.93 1.93v.435a1.93 1.93 0 0 1-1.93 1.93h-.87a1.93 1.93 0 0 1-1.82-1.287a.625.625 0 1 1 1.179-.416a.68.68 0 0 0 .641.453h.87a.68.68 0 0 0 .68-.68v-.435a.68.68 0 0 0-.68-.68h-.688a2 2 0 0 0-.888.21l-.32.159a.625.625 0 0 1-.895-.662l.435-2.61a.625.625 0 0 1 .616-.522h2.828a.625.625 0 0 1 0 1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetwork5gSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.772 2.219a.625.625 0 1 0 .81.953a7.16 7.16 0 0 1 4.421-1.697a7.15 7.15 0 0 1 4.416 1.697a.625.625 0 0 0 .809-.953A8.4 8.4 0 0 0 6.987.225A8.4 8.4 0 0 0 1.772 2.22M4.19 4.174a.625.625 0 0 0 .723 1.02c.66-.468 1.379-.725 2.103-.765c.726.038 1.448.294 2.109.762a.625.625 0 0 0 .722-1.02c-.85-.602-1.81-.947-2.804-.992h-.058c-.99.047-1.948.394-2.795.995M9.3 8.636a.66.66 0 0 0-.66.66v2.57a.66.66 0 0 0 .66.659h.857a.66.66 0 0 0 .66-.66v-.231h-.66a.625.625 0 1 1 0-1.25h1.285c.345 0 .625.28.625.625v.856a1.91 1.91 0 0 1-1.91 1.91H9.3a1.91 1.91 0 0 1-1.91-1.91v-2.57a1.91 1.91 0 0 1 1.91-1.91h.857a1.91 1.91 0 0 1 1.8 1.274a.625.625 0 1 1-1.178.417a.66.66 0 0 0-.622-.44zm-3.495.003H3.553l-.16.96q.328-.07.664-.07h.678a1.91 1.91 0 0 1 1.91 1.909v.428a1.91 1.91 0 0 1-1.91 1.909H3.88a1.91 1.91 0 0 1-1.8-1.273a.625.625 0 1 1 1.179-.416a.66.66 0 0 0 .621.439h.856a.66.66 0 0 0 .66-.659v-.428a.66.66 0 0 0-.66-.659h-.678c-.301 0-.599.07-.868.205l-.314.157a.625.625 0 0 1-.896-.662l.428-2.568a.625.625 0 0 1 .616-.522h2.782a.625.625 0 1 1 0 1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetworkLte: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.03 8.027v5.223M4.287 8.027H7.77m4.989 0H9.276v5.223h3.483m-3.483-2.83h3.047M1.242 8.027v5.223h3.047m5.238-8.404c-.773-.547-1.632-.853-2.511-.892c-.877.042-1.734.348-2.505.895M2.098 2.828A7.9 7.9 0 0 1 7.003.953a7.9 7.9 0 0 1 4.9 1.875\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetworkLteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.612 2.304a.75.75 0 1 0 .97 1.144A7.16 7.16 0 0 1 7.004 1.75a7.15 7.15 0 0 1 4.413 1.697a.75.75 0 0 0 .972-1.143A8.65 8.65 0 0 0 6.983.25a8.66 8.66 0 0 0-5.37 2.054M3.9 5.33a.75.75 0 0 1 .177-1.046c.878-.623 1.872-.983 2.903-1.033h.07c1.033.047 2.03.406 2.91 1.029a.75.75 0 1 1-.867 1.224c-.653-.463-1.364-.714-2.076-.753c-.711.041-1.42.293-2.072.756A.75.75 0 0 1 3.9 5.331M1 7.15c.345 0 .625.28.625.626v4.598h2.422a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 13V7.777c0-.345.28-.625.625-.625m5.03 0H4.288a.625.625 0 1 0 0 1.25h1.117V13a.625.625 0 1 0 1.25 0V8.402H7.77a.625.625 0 1 0 0-1.25zm3.046.184a.63.63 0 0 1 .442-.183H13a.625.625 0 1 1 0 1.25h-2.857v1.144h2.422a.625.625 0 0 1 0 1.25h-2.422v1.579H13a.625.625 0 1 1 0 1.25H9.518A.625.625 0 0 1 8.893 13V7.777c0-.166.066-.325.183-.442\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCellularNetworkLteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.693 2.25a.625.625 0 0 0 .809.954a7.3 7.3 0 0 1 4.501-1.728a7.28 7.28 0 0 1 4.495 1.727a.625.625 0 1 0 .809-.952A8.53 8.53 0 0 0 6.987.226A8.54 8.54 0 0 0 1.692 2.25m2.31 2.86a.625.625 0 0 1 .147-.872c.86-.61 1.831-.961 2.836-1.01h.058c1.008.046 1.982.396 2.844 1.006a.625.625 0 0 1-.722 1.02c-.674-.476-1.409-.736-2.149-.776c-.739.042-1.472.303-2.143.78a.625.625 0 0 1-.872-.148M1.635 7.926a.625.625 0 1 0-1.25 0v5.223c0 .345.28.625.625.625h3.047a.625.625 0 1 0 0-1.25H1.636zm6.779 0c0 .345-.28.625-.625.625H6.674v4.598a.625.625 0 1 1-1.25 0V8.55H4.308a.625.625 0 1 1 0-1.25H7.79c.345 0 .625.28.625.625m.689-.442a.63.63 0 0 1 .442-.183h3.482a.625.625 0 1 1 0 1.25h-2.857v1.144h2.422a.625.625 0 1 1 0 1.25H10.17v1.579h2.857a.625.625 0 0 1 0 1.25H9.546a.625.625 0 0 1-.625-.625V7.926c0-.166.066-.325.183-.442\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCelsius: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 3.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m10.5 0c-.412-1.165-1.694-2-3-2a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3c1.306 0 2.588-.835 3-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCelsiusRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.975 2.125a.9.9 0 1 1 1.8 0a.9.9 0 0 1-1.8 0m.9-2.1a2.1 2.1 0 1 0 0 4.2a2.1 2.1 0 0 0 0-4.2M9.5 1a3.625 3.625 0 0 0-3.625 3.625v5.75a3.625 3.625 0 1 0 7.25 0a.625.625 0 1 0-1.25 0a2.375 2.375 0 1 1-4.75 0v-5.75a2.375 2.375 0 0 1 4.75 0a.625.625 0 1 0 1.25 0A3.625 3.625 0 0 0 9.5 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCelsiusSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 2.25a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0M2.25 0a2.25 2.25 0 1 0 0 4.5a2.25 2.25 0 0 0 0-4.5M8 4a2 2 0 0 1 2-2c.934 0 1.803.614 2.057 1.333a1 1 0 0 0 1.886-.666C13.373 1.056 11.679 0 10 0a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4c1.679 0 3.373-1.056 3.943-2.667a1 1 0 1 0-1.886-.666C11.803 11.387 10.934 12 10 12a2 2 0 0 1-2-2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChair: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 8h11m-10 0V.5m9 0V8m-9-6.5h9m-9 3h9M2.5 8l8 5.5m1-5.5l-8 5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChairRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0c.345 0 .625.28.625.625V1.5h7.75V.625a.625.625 0 1 1 1.25 0V7.25h.375a.75.75 0 0 1 0 1.5h-.881l-3.474 2.263l2.821 1.838a.625.625 0 0 1-.682 1.048L7 11.759L3.716 13.9a.625.625 0 0 1-.682-1.048l2.821-1.838L2.381 8.75H1.5a.75.75 0 0 1 0-1.5h.375V.625C1.875.28 2.155 0 2.5 0M7 10.267L9.329 8.75H4.67zm3.875-3.017v-2.5h-7.75v2.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChairSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.532.907a.75.75 0 1 0-1.5 0v6.28h-.187a.75.75 0 1 0 0 1.5h.704l3.127 2.15l-2.382 1.637a.75.75 0 0 0 .85 1.236L7 11.747l2.856 1.963a.75.75 0 0 0 .85-1.236l-2.382-1.637l3.127-2.15h.704a.75.75 0 0 0 0-1.5h-.187V.907a.75.75 0 0 0-1.5 0zm5.271 7.78H5.197L7 9.927zM3.532 5.144v2.043h6.936V5.144z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChampagnePartyAlcohol: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.179 6.011L4.114.881l3.653 1.04l-1.062 5.38a2.362 2.362 0 1 1-4.526-1.29m1.563 3.104l-1.074 3.766m-1.484-.424l2.967.846\"/><path d=\"m3.148 3.438l4.086 1.175\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.567 8.963a2.362 2.362 0 0 0 3.255-2.952L9.885.881l-.576.163m.949 8.071l1.074 3.766m1.484-.424l-2.967.846m1.003-9.853l-1.669.48\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChampagnePartyAlcoholRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.026.18a.625.625 0 0 0-.747.386l-1.926 5.19A2.903 2.903 0 0 0 2.736 9.34l-.729 2.722l-.845-.227a.625.625 0 1 0-.324 1.207l1.437.385l.012.004l.013.003l1.436.385a.625.625 0 1 0 .324-1.208l-.845-.226l.729-2.721a2.903 2.903 0 0 0 2.99-2.414l.927-5.457a.625.625 0 0 0-.454-.708zm-.603 3.591l.83-2.236l2.28.61l-.399 2.353zm4.159 4.705c.158-.326.274-.68.338-1.057l.523-3.075l2.135-.573l-.83-2.236l-.185.05A.625.625 0 1 1 9.24.376L9.974.18a.625.625 0 0 1 .748.386l1.925 5.19a2.903 2.903 0 0 1-1.383 3.585l.73 2.722l.844-.227a.625.625 0 0 1 .324 1.207l-1.437.385l-.012.004l-.012.003l-1.437.385a.625.625 0 0 1-.323-1.207l.845-.227l-.73-2.721a2.91 2.91 0 0 1-2.474-1.19\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChampagnePartyAlcoholSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.208.574a.75.75 0 0 1 .907-.456l3.601 1.026a.75.75 0 0 1 .53.867L7.2 7.315a3.08 3.08 0 0 1-3.117 2.482l-.672 2.357l.74.211a.75.75 0 0 1-.411 1.443L2.313 13.4l-.07-.02l-1.429-.407a.75.75 0 1 1 .412-1.443l.742.212l.672-2.357A3.08 3.08 0 0 1 1.3 5.633L3.207.574Zm.481 2.974l2.574.766l.378-1.917l-2.273-.648zm6.313 6.321a3.08 3.08 0 0 1-2.144-.868a4.3 4.3 0 0 0 .567-1.444l.698-3.539l1.479-.353l-.631-1.849l-.462.116A2 2 0 0 0 8.987.517l1.288-.323a.75.75 0 0 1 .893.485l1.746 5.117a3.08 3.08 0 0 1-1.457 3.707l.596 2.377l.745-.187a.75.75 0 0 1 .365 1.455l-1.443.362l-.059.015l-1.449.364a.75.75 0 0 1-.365-1.455l.751-.189z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOval: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.145 12.84a6.5 6.5 0 1 0-2.556-2.238m2.556 2.239L.5 13.5l1.089-2.897m2.556 2.238l.005-.001m-2.561-2.237l.001-.003\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalNotification: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.114.585a6.474 6.474 0 0 0-4.503 9.96L.526 13.474l3.635-.658a6.464 6.464 0 0 0 9.274-5.14\"/><path d=\"M10.984 5.505a2.49 2.49 0 1 0 0-4.98a2.49 2.49 0 0 0 0 4.98\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalNotificationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75 3.125a3.125 3.125 0 1 1 6.25 0a3.125 3.125 0 0 1-6.25 0M6.548 1.266A.625.625 0 0 0 6.452.02A7.002 7.002 0 0 0 .998 10.605l-.959 2.551a.625.625 0 0 0 .696.835l3.379-.611a7 7 0 0 0 9.866-5.832a.625.625 0 1 0-1.246-.096a5.752 5.752 0 0 1-8.203 4.744a.62.62 0 0 0-.438-.083l-.005.001l-2.491.45l.68-1.81l.001-.003a.63.63 0 0 0-.096-.609a5.75 5.75 0 0 1 4.366-8.876\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalNotificationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.998.046c.523 0 1.044.059 1.55.175a3.723 3.723 0 0 0 5.232 5.23l.004.014a6.954 6.954 0 0 1-9.685 7.854l-3.466.627a.5.5 0 0 1-.556-.668l.994-2.646A6.954 6.954 0 0 1 6.998.046m6.952 2.486a2.482 2.482 0 1 1-4.964 0a2.482 2.482 0 0 1 4.964 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.249a5.751 5.751 0 0 0-4.818 8.893a.63.63 0 0 1 .096.61l-.681 1.813l2.49-.45l.006-.001a.62.62 0 0 1 .438.082A5.751 5.751 0 1 0 7 1.249M4.114 13.38c.88.399 1.858.62 2.886.62a7 7 0 1 0-6.002-3.395l-.959 2.551a.625.625 0 0 0 .696.835z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalSmiley1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.998.56a6.44 6.44 0 0 0-5.36 10.007L.558 13.44l3.617-.654A6.44 6.44 0 1 0 6.998.56\"/><path d=\"M3.7 8c.5 1.8 2.5 2.9 4.3 2.4c1.1-.4 2-1.3 2.3-2.4M4.75 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalSmiley1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7a5.751 5.751 0 1 1 3.282 5.196a.62.62 0 0 0-.438-.083l-.005.001l-2.491.45l.68-1.81l.001-.003a.63.63 0 0 0-.096-.609A5.7 5.7 0 0 1 1.25 7M7 14a7 7 0 0 1-2.886-.62l-3.379.61a.625.625 0 0 1-.696-.834l.959-2.55A7.001 7.001 0 1 1 7 14.001M4.75 6.25a1 1 0 1 1 0-2a1 1 0 0 1 0 2M4.423 7.8a.75.75 0 0 0-1.446.4c.614 2.21 3.035 3.53 5.224 2.923l.055-.018c1.301-.473 2.396-1.545 2.768-2.908a.75.75 0 1 0-1.448-.394c-.226.829-.919 1.55-1.805 1.882c-1.403.373-2.965-.504-3.348-1.886M9.25 6.25a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalSmiley1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.998.06a6.94 6.94 0 1 1-2.892 13.246l-3.458.626a.5.5 0 0 1-.557-.668l.991-2.64A6.94 6.94 0 0 1 6.998.06M4.302 7.833a.625.625 0 0 0-1.204.334c.594 2.141 2.945 3.425 5.07 2.835l.046-.015c1.267-.46 2.33-1.504 2.689-2.823a.625.625 0 1 0-1.206-.328c-.238.874-.966 1.625-1.888 1.968c-1.47.394-3.104-.52-3.507-1.971m1.136-2.864a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m3.875.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalSmiley2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.998.56a6.44 6.44 0 0 0-5.36 10.007L.558 13.44l3.617-.654A6.44 6.44 0 1 0 6.998.56\"/><path d=\"M4.75 5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M7 11a3.5 3.5 0 0 0 3.5-3.5h-7A3.5 3.5 0 0 0 7 11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalSmiley2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7a5.751 5.751 0 1 1 3.282 5.196a.62.62 0 0 0-.438-.083l-.005.001l-2.491.45l.68-1.81l.001-.003a.63.63 0 0 0-.096-.609A5.7 5.7 0 0 1 1.25 7M7 14a7 7 0 0 1-2.886-.62l-3.379.61a.625.625 0 0 1-.696-.834l.959-2.55A7.001 7.001 0 1 1 7 14.001M4.75 5.75a1 1 0 1 1 0-2a1 1 0 0 1 0 2m5.715 2.249a3.5 3.5 0 0 1-6.93 0C3.496 7.725 3.724 7.5 4 7.5h6c.276 0 .504.225.465.499M10.25 4.75a1 1 0 1 0-2 0a1 1 0 0 0 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalSmiley2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.998.06a6.94 6.94 0 1 1-2.892 13.246l-3.458.626a.5.5 0 0 1-.557-.668l.991-2.64A6.94 6.94 0 0 1 6.998.06M4.75 5.313a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m5.219-.75a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0M10.5 7.5a3.5 3.5 0 1 1-7 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleOvalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.02.736a6.954 6.954 0 0 0-8.95 9.897l-.993 2.645a.5.5 0 0 0 .556.668l3.466-.627A6.953 6.953 0 0 0 10.02.736\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareBlock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.578 9.751a3.25 3.25 0 1 0 0-6.5a3.25 3.25 0 0 0 0 6.5m2.3-.951l-4.6-4.6\"/><path d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareBlockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h9.75a.375.375 0 0 1 .375.375v9.75a.375.375 0 0 1-.375.375h-7.75a.6.6 0 0 0-.152.019l-2.895.724l.64-1.92a.6.6 0 0 0 .032-.198v-8.75c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v8.649l-.968 2.903a.625.625 0 0 0 .745.804L4.702 13h7.673A1.625 1.625 0 0 0 14 11.375v-9.75A1.625 1.625 0 0 0 12.375 0zm4.953 3.876c-.498 0-.964.139-1.36.38l3.605 3.606a2.625 2.625 0 0 0-2.245-3.986m-2.742-.117l.048-.043a3.875 3.875 0 0 1 5.479 5.48a.6.6 0 0 1-.09.09a3.875 3.875 0 0 1-5.48-5.479zm2.742 5.367c.499 0 .964-.139 1.361-.38L5.333 5.14a2.625 2.625 0 0 0 2.245 3.986\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareBlockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A1.5 1.5 0 0 0 1 1.5v8.919l-.974 2.923a.5.5 0 0 0 .595.643L4.561 13H12.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 12.5 0zm2.833 5.14A2.625 2.625 0 0 0 8.94 8.746zm-.54-1.334a3.875 3.875 0 0 0 5.48 5.48a1 1 0 0 0 .09-.09a3.875 3.875 0 0 0-5.48-5.48a.6.6 0 0 0-.09.09m1.424.45l3.606 3.606a2.625 2.625 0 0 0-3.606-3.606\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareQuestion: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1z\"/><path d=\"M6 5a1.5 1.5 0 1 1 1.5 1.5v1m0 2.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareQuestionRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h9.75a.375.375 0 0 1 .375.375v9.75a.375.375 0 0 1-.375.375h-7.75a.6.6 0 0 0-.152.019l-2.895.724l.64-1.92a.6.6 0 0 0 .032-.198v-8.75c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v8.649l-.968 2.903a.625.625 0 0 0 .745.804L4.702 13h7.673A1.625 1.625 0 0 0 14 11.375v-9.75A1.625 1.625 0 0 0 12.375 0zm4.54 4.192A.875.875 0 1 1 7.5 5.875a.625.625 0 0 0-.625.625v1a.625.625 0 1 0 1.25 0v-.469A2.125 2.125 0 1 0 5.375 5a.625.625 0 1 0 1.25 0a.875.875 0 0 1 .54-.808m.335 6.433a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareQuestionSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h10A1.5 1.5 0 0 1 14 1.5v10a1.5 1.5 0 0 1-1.5 1.5H4.562l-3.94.985a.5.5 0 0 1-.596-.643L1 10.419V1.5c0-.398.158-.78.44-1.06m5.692 3.19a1.007 1.007 0 1 1 .385 1.936a.625.625 0 0 0-.625.625V7.28a.625.625 0 1 0 1.25 0v-.551A2.256 2.256 0 1 0 5.261 4.56a.625.625 0 1 0 1.25 0a1.01 1.01 0 0 1 .621-.93m.385 6.994a.897.897 0 1 1 .002 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareWarning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zm3-9.5v3.5\"/><path d=\"M7.5 9.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareWarningRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h9.75a.375.375 0 0 1 .375.375v9.75a.375.375 0 0 1-.375.375h-7.75a.6.6 0 0 0-.152.019l-2.895.724l.64-1.92a.6.6 0 0 0 .032-.198v-8.75c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v8.649l-.968 2.903a.625.625 0 0 0 .745.804L4.702 13h7.673A1.625 1.625 0 0 0 14 11.375v-9.75A1.625 1.625 0 0 0 12.375 0zM8.25 3.125a.75.75 0 1 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zm-.75 7a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareWarningSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h10A1.5 1.5 0 0 1 14 1.5v10a1.5 1.5 0 0 1-1.5 1.5H4.562l-3.94.985a.5.5 0 0 1-.596-.643L1 10.419V1.5c0-.398.158-.78.44-1.06m6.753 2.355a.625.625 0 1 0-1.25 0v3.659a.625.625 0 1 0 1.25 0zM6.571 9.581a.998.998 0 1 1 1.995 0a.998.998 0 0 1-1.995 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareWrite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.5.5h-5a1 1 0 0 0-1 1v9l-1 3l4-1h8a1 1 0 0 0 1-1v-5\"/><path d=\"m8.363 8.137l-3 .54l.5-3.04l4.73-4.71a1 1 0 0 1 1.42 0l1.06 1.06a1 1 0 0 1 0 1.42z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareWriteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11H7A.625.625 0 1 0 7 0H2.625A1.625 1.625 0 0 0 1 1.625v8.649l-.968 2.903a.625.625 0 0 0 .745.804L4.702 13h7.673A1.625 1.625 0 0 0 14 11.375V7a.625.625 0 1 0-1.25 0v4.375a.375.375 0 0 1-.375.375h-7.75a.6.6 0 0 0-.152.019l-2.895.724l.64-1.92a.6.6 0 0 0 .032-.198v-8.75c0-.1.04-.195.11-.265M10.726.246a1.5 1.5 0 0 1 1.641.328h.001l1.057 1.058h.001a1.5 1.5 0 0 1 0 2.129L8.716 8.49a.5.5 0 0 1-.265.139l-3 .54a.5.5 0 0 1-.582-.573l.5-3.04a.5.5 0 0 1 .14-.274L10.24.573a1.5 1.5 0 0 1 .486-.327\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleSquareWriteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.88 8.388a1.25 1.25 0 0 1-.664.348l-3 .54A1.25 1.25 0 0 1 4.76 7.843l.5-3.04a1.25 1.25 0 0 1 .351-.683L9.75 0H2.5A1.5 1.5 0 0 0 1 1.5v8.919l-.974 2.923a.5.5 0 0 0 .595.643L4.561 13H12.5a1.5 1.5 0 0 0 1.5-1.5V4.25zM12.319.077a1 1 0 0 0-1.095.219l-4.73 4.71l-.5 3.04l3-.54l4.71-4.73a1 1 0 0 0 0-1.42l-1.06-1.06a1 1 0 0 0-.325-.22\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleTextSquare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zm0-7.5h6m-6 3h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleTextSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h9.75a.375.375 0 0 1 .375.375v9.75a.375.375 0 0 1-.375.375h-7.75a.6.6 0 0 0-.152.019l-2.895.724l.64-1.92a.6.6 0 0 0 .032-.198v-8.75c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v8.649l-.968 2.903a.625.625 0 0 0 .745.804L4.702 13h7.673A1.625 1.625 0 0 0 14 11.375v-9.75A1.625 1.625 0 0 0 12.375 0zM3.75 5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 3.75 5m0 3a.75.75 0 0 1 .75-.75h4a.75.75 0 1 1 0 1.5h-4A.75.75 0 0 1 3.75 8\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleTextSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A1.5 1.5 0 0 0 1 1.5v8.919l-.974 2.923a.5.5 0 0 0 .595.643L4.561 13H12.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 12.5 0zm1.375 4.846c0-.346.28-.625.625-.625h6a.625.625 0 1 1 0 1.25h-6a.625.625 0 0 1-.625-.625M4.5 7.529a.625.625 0 1 0 0 1.25h4a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleTypingOval: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.002 7.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m-2.75.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m5.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/><path d=\"M6.998.56a6.44 6.44 0 0 0-5.36 10.007L.558 13.44l3.617-.654A6.44 6.44 0 1 0 6.998.56\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleTypingOvalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7a5.751 5.751 0 1 1 3.282 5.196a.62.62 0 0 0-.438-.083l-.005.001l-2.491.45l.68-1.81l.001-.003a.63.63 0 0 0-.096-.609A5.7 5.7 0 0 1 1.25 7M7 14a7 7 0 0 1-2.886-.62l-3.379.61a.625.625 0 0 1-.696-.834l.959-2.55A7.001 7.001 0 1 1 7 14.001M4.252 8a1 1 0 1 1 0-2a1 1 0 0 1 0 2m3.75-1a1 1 0 1 0-2 0a1 1 0 0 0 2 0m1.75 1a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatBubbleTypingOvalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.998.046A6.954 6.954 0 1 1 4.099 13.32l-3.466.627a.5.5 0 0 1-.556-.668l.994-2.646A6.954 6.954 0 0 1 6.998.046M5 7a1 1 0 1 1-2 0a1 1 0 0 1 2 0m2 1a1 1 0 1 0 0-2a1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatTwoBubblesOval: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.25 5a4.25 4.25 0 0 1 3.54 6.6l.71 1.9l-2.39-.43A4.25 4.25 0 1 1 9.25 5\"/><path d=\"M9.86 2.51A5.24 5.24 0 0 0 .5 5.75a5.2 5.2 0 0 0 .88 2.91L.5 11l2.12-.38\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatTwoBubblesOvalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.428 4.829C10.98 2.096 8.553-.002 5.75 0A5.75 5.75 0 0 0 .825 8.715l-.793 2.11a.5.5 0 0 0 .557.667l2.79-.505c.462.21.947.356 1.445.437a4.88 4.88 0 0 0 6.244 2.17l2.196.396a.625.625 0 0 0 .697-.834l-.603-1.613A4.8 4.8 0 0 0 14 9.123v.002h-.625L14 9.123a4.88 4.88 0 0 0-2.572-4.294M7.55 5.859a3.625 3.625 0 0 1 5.2 3.266l.001.002a3.6 3.6 0 0 1-.604 2a.63.63 0 0 0-.066.567l.325.871l-1.31-.235a.63.63 0 0 0-.384.053A3.625 3.625 0 1 1 7.55 5.86\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChatTwoBubblesOvalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.515 0A5.515 5.515 0 0 0 .921 8.565l-.737 1.972a.3.3 0 0 0 .335.4l2.583-.465q.385.188.792.314a5.75 5.75 0 0 1 6.897-6.89A5.51 5.51 0 0 0 5.515 0m7.167 6.318a4.5 4.5 0 0 0-6.705.379a4.5 4.5 0 0 0 5.493 6.848l2.012.362a.3.3 0 0 0 .334-.4l-.568-1.519a4.5 4.5 0 0 0-.566-5.67\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheck: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 8.55l2.73 3.51a1 1 0 0 0 1.56.03L13.5 1.55\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m.625 9.125l3.096 2.697a1 1 0 0 0 1.432-.122l8.222-10.075\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.637 1.198a1 1 0 0 1 .134 1.408l-8.04 9.73l-.003.002a1.92 1.92 0 0 1-1.5.693a1.92 1.92 0 0 1-1.499-.748l-.001-.002L.21 9.045a1 1 0 1 1 1.578-1.228l2.464 3.167l7.976-9.652a1 1 0 0 1 1.408-.134Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5.5h-7a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3\"/><path d=\"m9.917 4.75l-4 5l-2-1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625h10c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12V2c0-.207.168-.375.375-.375m10-1.25H2C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625m-1.497 4.844A.75.75 0 1 0 9.33 4.28L5.785 8.714L4.367 7.65a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.036-.131z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0A3.5 3.5 0 0 0 0 3.5v7A3.5 3.5 0 0 0 3.5 14h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 10.5 0zm7.003 5.219A.75.75 0 0 0 9.33 4.28L5.786 8.714L4.367 7.65a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.036-.131z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckupMedicalReportClipboard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><path d=\"M8.5.5h-3a1 1 0 0 0-1 1V2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1M6.303 5.21a.43.43 0 0 0-.43.43v1.207H4.666a.43.43 0 0 0-.43.43v1.395c0 .237.193.43.43.43h1.207v1.207c0 .237.193.43.43.43h1.395a.43.43 0 0 0 .43-.43V9.1h1.207a.43.43 0 0 0 .43-.43V7.277a.43.43 0 0 0-.43-.429H8.128V5.639a.43.43 0 0 0-.43-.429z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckupMedicalReportClipboardRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 2.25h1.163c.173.856.93 1.5 1.837 1.5h3c.907 0 1.664-.644 1.838-1.5H11.5c.207 0 .375.168.375.375v9.75a.375.375 0 0 1-.375.375h-9a.375.375 0 0 1-.375-.375v-9.75c0-.207.168-.375.375-.375m9-1.25h-1.341C9.844.405 9.219 0 8.5 0h-3c-.72 0-1.344.405-1.659 1H2.5C1.603 1 .875 1.728.875 2.625v9.75C.875 13.273 1.603 14 2.5 14h9c.898 0 1.625-.727 1.625-1.625v-9.75C13.125 1.728 12.398 1 11.5 1M5.832 5.739c0-.201.163-.364.364-.364h1.608c.201 0 .364.163.364.364v1.343h1.343c.201 0 .364.163.364.364v1.608a.364.364 0 0 1-.364.364H8.168v1.343a.364.364 0 0 1-.364.364H6.196a.364.364 0 0 1-.364-.364V9.418H4.489a.364.364 0 0 1-.364-.364V7.446c0-.201.163-.364.364-.364h1.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheckupMedicalReportClipboardSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zm6.25 0h.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-8.5a1.5 1.5 0 0 1-1.5-1.5v-10A1.5 1.5 0 0 1 2.75 1h.5v.5A2.25 2.25 0 0 0 5.5 3.75h3a2.25 2.25 0 0 0 2.25-2.25zM5.97 5.948c0-.217.176-.392.393-.392h1.275c.216 0 .392.175.392.392v1.56h1.56c.217 0 .392.176.392.393v1.275a.39.39 0 0 1-.392.392H8.03v1.56a.39.39 0 0 1-.392.393H6.362a.39.39 0 0 1-.392-.393v-1.56H4.41a.39.39 0 0 1-.392-.392V7.9c0-.217.175-.393.392-.393h1.56z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheese: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.09.77L9 .75L.75 5.61A.47.47 0 0 0 .5 6v6.71a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-7A5.88 5.88 0 0 0 9.09.77M.59 5.75H13\"/><path d=\"m.5 10.38l.08-.07A2 2 0 0 1 2 9.71a2 2 0 0 1 2 2a2 2 0 0 1-.59 1.41M9 10.75a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheeseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.153.48A.63.63 0 0 1 8.5.375c1.467 0 2.754.733 3.66 1.778c.904 1.043 1.465 2.436 1.465 3.847v6c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12V6a.62.62 0 0 1 .286-.525zM1.625 6.625v2.802a2.25 2.25 0 0 1 2.948 2.948H12a.375.375 0 0 0 .375-.375V6.625zM7.25 9.5a1.75 1.75 0 1 1 3.5 0a1.75 1.75 0 0 1-3.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCheeseSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M14 5.66A6.55 6.55 0 0 0 9 .05a.79.79 0 0 0-.67.06L.62 5A1.32 1.32 0 0 0 0 6v4.4a.74.74 0 0 0 .49.7a.73.73 0 0 0 .82-.21a1.25 1.25 0 1 1 1.76 1.76a.73.73 0 0 0-.21.82a.74.74 0 0 0 .7.49h9.19A1.25 1.25 0 0 0 14 12.75zM8.75 11a1.75 1.75 0 1 1 0-3.5a1.75 1.75 0 0 1 0 3.5m-4.5-6A.24.24 0 0 1 4 4.82a.25.25 0 0 1 .1-.28l4.57-2.86a.52.52 0 0 1 .44-.05a5.2 5.2 0 0 1 3.1 3a.24.24 0 0 1 0 .23A.23.23 0 0 1 12 5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCherries: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.36 13.5a2.6 2.6 0 1 0 0-5.2a2.6 2.6 0 0 0 0 5.2m7.28-1.04a2.6 2.6 0 1 0 0-5.2a2.6 2.6 0 0 0 0 5.2\"/><path d=\"M9.41 7.57A10.36 10.36 0 0 1 6 .5a13.8 13.8 0 0 0-2.6 7.8M3.36.5h5.2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCherriesRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 1.125c0-.483.392-.875.875-.875h5A.875.875 0 1 1 8.5 2H6.992q.067.347.202.809c.3 1.008.882 2.4 2.016 3.97a3.125 3.125 0 1 1-1.33 1.145C6.678 6.289 6 4.797 5.617 3.628c-.4.97-.818 2.316-1.052 4.058A3.126 3.126 0 0 1 3.5 13.75a3.125 3.125 0 0 1-.686-6.175c.29-2.255.868-3.946 1.398-5.103q.116-.253.227-.472H3.5a.875.875 0 0 1-.875-.875M3.5 8.75a1.875 1.875 0 1 0 0 3.75a1.875 1.875 0 0 0 0-3.75m5.125.875a1.875 1.875 0 1 1 3.75 0a1.875 1.875 0 0 1-3.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCherriesSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.642 1.546A14 14 0 0 0 2.785 7.85a3.082 3.082 0 1 0 1.498.074a12.5 12.5 0 0 1 1.322-5.006a10.7 10.7 0 0 0 2.758 4.818a3.081 3.081 0 1 0 1.3-.828a9.2 9.2 0 0 1-2.812-5.363H8.48a.75.75 0 1 0 0-1.5H3.482a.75.75 0 1 0 0 1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessBishop: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.761 7.377c.433-.317.692-.807.692-1.505c0-1.97-2.454-3.095-2.454-3.095S4.546 3.902 4.546 5.872c0 .698.259 1.188.691 1.505c-.45 1.287-1.104 3.19-1.125 3.46h5.774c-.02-.27-.674-2.173-1.125-3.46\"/><path d=\"M5.861 1.639a1.139 1.139 0 1 0 2.277 0a1.139 1.139 0 0 0-2.277 0M7.389 5.47L8.732 4.1m-5.929 7.344a.89.89 0 0 1 .842-.607h6.71c.382 0 .721.244.842.607l.685 2.056H2.118z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessBishopRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a.492.492 0 1 0 0 .983a.492.492 0 0 0 0-.983m-1.742.492a1.742 1.742 0 1 1 3.032 1.17q.155.115.317.25c.652.553 1.424 1.459 1.424 2.685c0 .664-.202 1.218-.576 1.636c.19.538.4 1.137.575 1.658c.11.326.208.626.28.862q.055.179.09.314c.015.055.034.13.045.204h.704c.584 0 1.142.348 1.348.922l.617 1.72a.625.625 0 0 1-.588.837H1.474a.625.625 0 0 1-.589-.836l.618-1.721c.206-.574.764-.922 1.348-.922h.703c.011-.074.03-.149.044-.204q.036-.135.091-.314c.072-.236.17-.536.28-.862c.176-.521.385-1.12.575-1.658c-.374-.418-.576-.972-.576-1.636c0-1.226.772-2.132 1.424-2.684q.161-.137.318-.251a1.74 1.74 0 0 1-.452-1.17m3.857 8.627l.045.152H4.84l.044-.152c.068-.22.161-.507.27-.829c.216-.642.486-1.409.706-2.03a.625.625 0 0 0-.223-.716c-.245-.176-.419-.452-.419-.947c0-.675.431-1.264.982-1.73a5.3 5.3 0 0 1 .8-.554a5.3 5.3 0 0 1 .799.554l.034.029l-.898.916a.625.625 0 0 0 .893.875l.79-.806c.103.225.163.465.163.716c0 .495-.174.77-.42.947a.625.625 0 0 0-.222.717c.22.62.49 1.387.706 2.03c.109.321.202.608.27.828\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessBishopSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.911 1.194A1.09 1.09 0 1 1 7.734 2a6 6 0 0 1 .852.654L7.484 3.79a.625.625 0 0 0 .897.87l.98-1.009c.193.367.321.79.321 1.265c0 .554-.153 1.029-.459 1.402a2 2 0 0 1-.559.47l.01.03c.162.53.403 1.323.606 2.018c.073.248.141.485.199.694H4.521c.058-.209.126-.446.199-.694a170 170 0 0 1 .616-2.049c-.21-.12-.4-.275-.56-.47c-.305-.372-.458-.847-.458-1.401c0-1.093.678-1.908 1.265-2.413c.242-.208.483-.376.684-.503a1.1 1.1 0 0 1-.356-.805M3.905 10.78c-.469.035-.927.304-1.111.77l-.611 1.548a.5.5 0 0 0 .465.683h8.706a.5.5 0 0 0 .465-.683l-.61-1.548c-.185-.466-.643-.735-1.112-.77z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessKing: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3.998 5.81l1.027 2.955l-.768 2.1h5.486l-.768-2.1l1.028-2.955c.142-.408-.176-.83-.625-.83H4.622c-.45 0-.766.422-.624.83M7 3.017V.5m-.755.755h1.51M8.963 4.98a1.963 1.963 0 0 0-3.926 0m-2.189 6.486c.12-.359.455-.6.833-.6h6.638c.378 0 .714.241.833.6l.678 2.034H2.17z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessKingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625.625a.625.625 0 1 0-1.25 0v.36h-.36a.625.625 0 0 0 0 1.25h.36v.801a2.55 2.55 0 0 0-1.85 1.856c-.746.085-1.345.816-1.058 1.62l.015.039l.908 2.101l-.665 1.771a1 1 0 0 0-.028.098H2.85c-.584 0-1.142.348-1.348.922l-.618 1.72a.625.625 0 0 0 .589.837h11.052a.625.625 0 0 0 .588-.836l-.617-1.721c-.206-.574-.764-.922-1.348-.922h-.845a1 1 0 0 0-.028-.098l-.665-1.77l.908-2.102l.015-.038c.287-.805-.313-1.537-1.059-1.62a2.55 2.55 0 0 0-1.85-1.857v-.8h.36a.625.625 0 0 0 0-1.25h-.36zm1.352 9.896H5.023l.626-1.666a.63.63 0 0 0-.012-.467l-.973-2.254h4.673l-.974 2.254a.63.63 0 0 0-.011.467zM6.99 4.209h.021a1.3 1.3 0 0 1 1.13.675H5.86a1.3 1.3 0 0 1 1.13-.675\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessKingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.3.542a.5.5 0 1 0-1 0V.78h-.237a.5.5 0 0 0 0 1h.238v.567c-.78.168-1.433.722-1.637 1.471h-.185c-.361 0-.692.154-.906.411a.99.99 0 0 0-.17 1.001l1.003 2.605a.5.5 0 0 0 .076.134l-.217 1.56h4.97L9.03 8.055a.5.5 0 0 0 .166-.22L10.2 5.23a.99.99 0 0 0-.171-1a1.17 1.17 0 0 0-.906-.412h-.185C8.734 3.07 8.08 2.515 7.3 2.347V1.78h.237a.5.5 0 0 0 0-1H7.3zM9.898 10.78H3.705c-.469.035-.928.304-1.111.77l-.612 1.548a.5.5 0 0 0 .466.683h8.706a.5.5 0 0 0 .465-.683l-.611-1.548c-.184-.466-.643-.735-1.111-.77\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessKnight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.42 11.256a.97.97 0 0 1 .92-.662h7.321c.417 0 .787.267.92.662l.747 2.244H1.672z\"/><path d=\"M3.572 10.594c.158-.83 1.306-1.783 2.117-2.418c1.945-1.522 1.765-2.824 1.447-3.177L5.193 6.11a1.23 1.23 0 0 1-1.437-.154v0a1.23 1.23 0 0 1-.237-1.543L4.983 1.93L4.42.658c.93-.33 3.501-.155 4.518.635c1.27.989 2.894 2.489 1.553 9.3\"/><path d=\"M7.773 3.971a1.9 1.9 0 0 1-.631 1.03\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessKnightRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.58 1.301a7 7 0 0 0-1.22-.04l.234.53a.63.63 0 0 1-.032.566L4.118 4.836a.591.591 0 0 0 .807.81l1.727-.999a.6.6 0 0 1 .087-.088a1.23 1.23 0 0 0 .41-.67a.625.625 0 1 1 1.218.281a2.5 2.5 0 0 1-.493 1.01c.107.35.108.777-.016 1.22c-.2.716-.73 1.52-1.756 2.333c-.395.313-.846.685-1.215 1.07c-.267.279-.447.522-.548.718h5.47c.65-3.338.561-5.286.212-6.486c-.336-1.158-.928-1.675-1.508-2.132c-.357-.28-1.09-.504-1.933-.602M3.984 8.939c-.41.428-.844.981-.96 1.582h-.173c-.584 0-1.142.348-1.348.922l-.618 1.72a.625.625 0 0 0 .589.837h11.052a.625.625 0 0 0 .588-.836l-.617-1.721c-.206-.574-.764-.922-1.348-.922h-.067c.617-3.283.56-5.392.14-6.835c-.443-1.523-1.27-2.24-1.936-2.765C8.645.417 7.618.163 6.723.06c-.897-.103-1.872-.078-2.466.134a.625.625 0 0 0-.361.84l.426.97l-1.284 2.204a1.841 1.841 0 0 0 2.513 2.52l1.094-.632c-.12.395-.46.979-1.319 1.658c-.4.318-.91.734-1.342 1.186\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessKnightSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.088 4.16A1.733 1.733 0 0 0 5.11 6.69c.893-.63 1.795-1.58 2.185-2.864a.5.5 0 0 1 .957.29c-.455 1.5-1.468 2.586-2.443 3.303a7 7 0 0 1-.428.363c-.482.378-1.118.894-1.595 1.444a.5.5 0 0 0 .378.827h6.515a.5.5 0 0 0 .493-.418c.497-3.003.373-4.927-.072-6.244c-.454-1.345-1.226-2.002-1.856-2.492C8.622.415 7.608.162 6.702.059c-.91-.104-1.877-.076-2.45.128a.5.5 0 0 0-.29.674l.46 1.035zM1.72 12.093a1.47 1.47 0 0 1 1.387-.985h7.849c.63 0 1.188.401 1.39.996l.451 1.222a.5.5 0 0 1-.469.673H1.672a.5.5 0 0 1-.46-.694z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessPawn: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.61 11.35a.93.93 0 0 1 .88-.636h7.02c.399 0 .754.256.88.635l.717 2.151H1.893zm2.069-8.529a2.321 2.321 0 1 0 4.642 0a2.321 2.321 0 1 0-4.642 0\"/><path d=\"M3.75 10.714c.996-.995 1.658-4.124 1.857-5.571m4.643 5.571C9.254 9.72 8.592 6.59 8.393 5.143m-4.179 0h5.572\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessPawnRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a1.652 1.652 0 0 0-.018 3.303h.036A1.652 1.652 0 0 0 7 1.25M4.098 2.902c0 .613.19 1.183.516 1.651h-.346a.625.625 0 1 0 0 1.25h.634a21 21 0 0 1-.486 2.1a11 11 0 0 1-.504 1.417c-.19.422-.376.716-.541.88l-.003.004c-.13.133-.245.232-.354.317H2.85c-.584 0-1.142.348-1.348.922l-.618 1.72a.625.625 0 0 0 .589.837h11.052a.625.625 0 0 0 .588-.836l-.617-1.721c-.206-.574-.764-.922-1.348-.922h-.16a4 4 0 0 1-.354-.317l-.003-.003c-.165-.165-.352-.46-.541-.88a11 11 0 0 1-.504-1.418a21 21 0 0 1-.486-2.1h.631a.625.625 0 0 0 0-1.25h-.346a2.902 2.902 0 1 0-5.288-1.652m3.735 2.901H6.17a23 23 0 0 1-.553 2.448c-.16.55-.348 1.1-.565 1.582a6 6 0 0 1-.36.688h4.62a6 6 0 0 1-.361-.688a12 12 0 0 1-.565-1.582a23 23 0 0 1-.553-2.448\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChessPawnSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.356 3.14a2.644 2.644 0 1 1 4.891 1.395h.326a.75.75 0 0 1 0 1.5h-.687c.107.748.265 1.662.47 2.541c.075.328.157.65.245.953H4.399c.087-.304.17-.625.246-.953c.204-.88.362-1.793.469-2.541h-.687a.75.75 0 0 1 0-1.5h.326a2.63 2.63 0 0 1-.397-1.394m-.452 7.64c-.469.034-.927.303-1.111.769l-.611 1.548a.5.5 0 0 0 .465.683h8.706a.5.5 0 0 0 .465-.683l-.61-1.548c-.185-.466-.644-.735-1.112-.77z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChickenGrilledStream: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M2.243 2.246v1.562m4.563-1.562v1.562M4.525 1.083v1.562\"/><path d=\"M11.509 4.602a.955.955 0 1 0 1.91 0a.955.955 0 1 0-1.91 0\"/><path stroke-linejoin=\"round\" d=\"m10.841 8.677l.212.093c1.48.7 1.889 1.606 1.889 2.85v.298a1 1 0 0 1-1 1H1.64c-.327 0-.634-.161-.76-.463c-.277-.669-.599-2.013.238-3.685c1.21-2.416 4.187-2.947 6.094-1.947l.09.046\"/><path d=\"M10.158 10.006c.928-1.018.976-2.485.108-3.275s-2.323-.605-3.25.413c-.843.925-.96 2.219-.325 3.04q.097.127.217.235\"/><path stroke-linejoin=\"round\" d=\"M11.806 5.296L10.32 6.781\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChickenGrilledStreamRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.22 4.46a.75.75 0 0 1-.118-1.053a.8.8 0 0 0 .145-.234a2 2 0 0 0-.152-.213l-.022-.028c-.121-.155-.366-.467-.43-.88c-.08-.499.113-.963.46-1.395a.75.75 0 0 1 1.17.937a.8.8 0 0 0-.145.233c.01.02.045.075.152.213l.022.028c.121.155.367.467.431.88c.079.499-.114.963-.46 1.396a.75.75 0 0 1-1.054.117m.904-2.613l.001-.01zM2.25 3.154l-.001.01zm10.154-.308a.75.75 0 1 0-1.06 1.06l.094.095l-1.11 1.111a2.44 2.44 0 0 0-2.363.08l-.706.424a4.6 4.6 0 0 0-1.471-.24H4.536a4.16 4.16 0 0 0-4.161 4.16v.404a3.186 3.186 0 0 0 3.186 3.186h7.732c.618 0 1.212-.246 1.649-.683l.037-.037l-.442-.442l.442.442a2.205 2.205 0 0 0-.336-3.394l-1.178-.785a2.44 2.44 0 0 0-.076-2.054L12.5 5.06l.095.094a.75.75 0 1 0 1.06-1.06zM10.3 8.95a.62.62 0 0 1-.19-.847l.128-.213A1.186 1.186 0 0 0 8.61 6.263l-.958.574l-.012.007l-.392.236a1.583 1.583 0 0 0 .77 2.94a.625.625 0 0 1-.033 1.25a2.836 2.836 0 0 1-2.102-4.645l-.093-.001H4.536a2.91 2.91 0 0 0-2.911 2.91v.404a1.936 1.936 0 0 0 1.936 1.936h7.732c.287 0 .562-.114.765-.317L12.5 12l-.442-.442l.037-.037a.955.955 0 0 0-.145-1.47zM5.107 3.407a.75.75 0 0 0 1.17.937c.347-.433.54-.897.46-1.396c-.064-.413-.309-.725-.43-.88l-.022-.028a2 2 0 0 1-.152-.213a.8.8 0 0 1 .145-.233a.75.75 0 0 0-1.171-.937c-.346.432-.539.896-.46 1.395c.064.413.31.725.431.88l.022.028c.107.138.141.194.152.213a.8.8 0 0 1-.145.234m1.022-1.56l.001-.01zm-.873 1.306l-.001.01z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChickenGrilledStreamSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.15 1.145a.625.625 0 1 0-1.25 0v1.563a.625.625 0 1 0 1.25 0zm-2.907.538c.346 0 .625.28.625.625v1.563a.625.625 0 0 1-1.25 0V2.308c0-.345.28-.625.625-.625m4.563 0c.345 0 .625.28.625.625v1.563a.625.625 0 0 1-1.25 0V2.308c0-.345.28-.625.625-.625m5.658 1.526a1.455 1.455 0 0 0-1.362 1.97l-1.077.994c-.61-.268-1.348-.225-2.012.103a2.8 2.8 0 0 0-.666.543c-.846.929-.901 2.15-.349 2.866q.085.11.191.207a.5.5 0 1 1-.673.74a2.6 2.6 0 0 1-.309-.336c-.912-1.18-.698-2.944.4-4.15l.028-.03C4.562 5.501 1.862 6.23.67 8.608c-.918 1.834-.57 3.335-.252 4.101c.22.532.743.771 1.22.771h10.303a1.5 1.5 0 0 0 1.5-1.5v-.297c0-.676-.111-1.315-.463-1.89c-.268-.439-.657-.809-1.18-1.127a3.8 3.8 0 0 1-.826 1.456a.5.5 0 1 1-.74-.674c.666-.73.841-1.633.62-2.337l1.115-1.031l.034-.034q.218.073.462.074a1.455 1.455 0 1 0 0-2.91\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianCross1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 3.5H9v-3H5v3H2v4h3v6h4v-6h3z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianCross1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 0a.5.5 0 0 0-.5.5v2.75h-3a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h3v5.25a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V8.25h3a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-3V.5A.5.5 0 0 0 9 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianCross1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 0a.5.5 0 0 0-.5.5V3H2a.5.5 0 0 0-.5.5v4A.5.5 0 0 0 2 8h2.5v5.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V8H12a.5.5 0 0 0 .5-.5v-4A.5.5 0 0 0 12 3H9.5V.5A.5.5 0 0 0 9 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianCross2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13m-4-9h8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianCross2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.75a.75.75 0 0 0-1.5 0v3h-3.5a.75.75 0 0 0 0 1.5h3.5v8a.75.75 0 0 0 1.5 0v-8h3.5a.75.75 0 0 0 0-1.5h-3.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianCross2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 1.124a1 1 0 1 0-2 0V3.74H3.384a1 1 0 1 0 0 2H6v7.188a1 1 0 1 0 2 0V5.74h2.616a1 1 0 1 0 0-2H8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianity: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 4s-3.67 6-8 6a5.6 5.6 0 0 1-5-3a5.6 5.6 0 0 1 5-3c4.33 0 8 6 8 6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianityRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.55 3.904c-.798-.008-1.605.277-2.333.859C2.55 5.296 1.976 6.06 1.562 7c.414.94.988 1.704 1.655 2.237c.728.582 1.535.867 2.334.859h.007c.807 0 1.648-.375 2.494-1.041C8.76 8.498 9.428 7.77 10.027 7c-.6-.771-1.267-1.498-1.975-2.055c-.846-.666-1.687-1.04-2.494-1.04zm5.383 4.366c-.582.712-1.238 1.4-1.953 1.964c-.985.775-2.146 1.36-3.419 1.362c-1.177.01-2.313-.413-3.28-1.187C1.314 9.636.55 8.545.051 7.274a.75.75 0 0 1 0-.548c.5-1.271 1.263-2.362 2.228-3.135c.968-.774 2.104-1.197 3.281-1.187c1.273.001 2.434.587 3.419 1.363c.715.562 1.371 1.25 1.953 1.963a25 25 0 0 0 1.6-2.812l.027-.06l.007-.014l.001-.002a.75.75 0 0 1 1.364.625l-.647-.297l.647.297l-.004.008l-.009.019a10 10 0 0 1-.157.325A26 26 0 0 1 11.885 7a26 26 0 0 1 2.034 3.506l.009.02l.003.006l-.681.314l.682-.313a.75.75 0 0 1-1.364.626l-.001-.003l-.007-.014l-.028-.06l-.113-.232a25 25 0 0 0-1.486-2.58\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChristianitySolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.574 4.968A20 20 0 0 1 12.07 7a20 20 0 0 1 1.504 2.032q.087.134.17.272a1 1 0 0 1-.353 1.37c-.511.302-1.106.081-1.399-.401a15 15 0 0 0-.506-.762a18 18 0 0 0-.804-1.053c-1.308 1.206-3.056 2.353-5.036 2.355a5.94 5.94 0 0 1-3.175-.9A6.2 6.2 0 0 1 .225 7.452a1 1 0 0 1 0-.902a6.2 6.2 0 0 1 2.246-2.463a5.94 5.94 0 0 1 3.175-.899c1.98.002 3.728 1.149 5.036 2.355A18 18 0 0 0 11.89 3.89q.067-.105.132-.211a1 1 0 0 1 1.369-.353c.471.278.63.902.351 1.372q-.081.137-.168.27\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChrome: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.86 7.047a6.187 6.187 0 1 0 12.374 0a6.187 6.187 0 1 0-12.374 0m6.187-2.432h5.691\"/><path d=\"M4.615 7.046a2.431 2.431 0 1 0 4.862 0a2.431 2.431 0 1 0-4.862 0m.318 1.218L2.087 3.335m7.061 4.924l-2.846 4.929\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChromeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.535 3.376A5.74 5.74 0 0 1 7 1.25c1.946 0 3.666.967 4.707 2.446H6.999a3.305 3.305 0 0 0-3.073 2.089zm-.75 1.199a5.753 5.753 0 0 0 4.308 8.106l1.393-2.414a3.3 3.3 0 0 1-3.362-1.641zm5.722 8.155a5.75 5.75 0 0 0 4.866-7.784H9.587a3.3 3.3 0 0 1 .716 2.053c0 .602-.161 1.167-.442 1.653zM7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0m0 5.196a1.804 1.804 0 1 0 0 3.607a1.804 1.804 0 0 0 0-3.607\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineChromeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.75 7a6.75 6.75 0 0 1-6.725 6.75l2.824-4.892a3.4 3.4 0 0 0 .552-1.859c0-.643-.178-1.244-.488-1.757h3.269a.8.8 0 0 0 .32-.065c.162.58.248 1.191.248 1.823m-.914-3.394A6.75 6.75 0 0 0 7 .25c-1.941 0-3.691.82-4.923 2.131a.8.8 0 0 1 .162.195l1.698 2.94a3.4 3.4 0 0 1 3.3-1.91zM.25 7a6.75 6.75 0 0 0 5.199 6.571a.8.8 0 0 1 .09-.246l1.692-2.931A3.4 3.4 0 0 1 4.119 8.81a1 1 0 0 1-.075-.107L1.133 3.66A6.7 6.7 0 0 0 .25 7m8.393.947l.04-.061a1.902 1.902 0 1 0-.108.18z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleClock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M7 4.5V7l2.54 2.96\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleClockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0m6.625-3.5a.875.875 0 1 0-1.75 0V7c0 .483.392.875.875.875h2.5a.875.875 0 1 0 0-1.75H7.875z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleClockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14m.625-9.5a.625.625 0 1 0-1.25 0V7c0 .146.051.288.145.4l2.5 3a.625.625 0 1 0 .96-.8L7.625 6.774z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleFlask: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.494 4.767V.523H5.505v4.244a4.483 4.483 0 1 0 2.99 0M4 .523h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleFlaskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.375 1.5H3.5a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5h-.875v1.899a5.625 5.625 0 1 1-5.25 0zm1.25 0v2.291a.63.63 0 0 1-.375.573a4.376 4.376 0 1 0 3.5 0a.63.63 0 0 1-.375-.573V1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleFlaskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.456.005a.75.75 0 0 0 0 1.5H5v2.907a5 5 0 1 0 4 0V1.505h.544a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M7 13.375A6.375 6.375 0 1 1 7 .625a6.375 6.375 0 0 1 0 12.75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCityHall: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.707 13.438h12.75M3.86 5.687l3.222-2.53l3.222 2.53M4.35 7.813h5.464v5.625H4.35zM3.238 5.688h7.688v2.121H3.238zM1.618 7.81v5.628M12.546 7.81v5.625M.707 7.81h12.75M7.082 3.156V.674m0 0h1.25\"/><path d=\"M6.095 11.203a.93.93 0 0 1 .931-.93v0a.93.93 0 0 1 .931.93v2.235H6.095z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCityHallRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 1c0-.345.28-.625.625-.625h1a.625.625 0 1 1 0 1.25h-.375v1.489L11.28 4.94a.63.63 0 0 1 .345.559v.875H13a.625.625 0 1 1 0 1.25h-.125v4.75H13a.625.625 0 1 1 0 1.25H1a.625.625 0 1 1 0-1.25h.125v-4.75H1a.625.625 0 1 1 0-1.25h1.375V5.5c0-.237.134-.453.345-.559l3.655-1.827zm-4 6.625v4.75h1.5v-4.75zm2.75 0v4.75h1V11a.875.875 0 0 1 1.75 0v1.375h1v-4.75zm5 0v4.75h1.5v-4.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCityHallSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .05a.75.75 0 0 0-.75.75v2.305L2.963 5.27a.5.5 0 0 0-.204.561l.001.002h8.644v-.002a.5.5 0 0 0-.203-.561L7.75 2.997V1.551h.621a.75.75 0 0 0 0-1.5zm6.242 8.51h-.196v3.934h.196a.75.75 0 0 1 0 1.5H.922a.75.75 0 0 1 0-1.5h.196V8.559H.922a.75.75 0 1 1 0-1.5h12.32a.75.75 0 0 1 0 1.5m-2.106 0h-1.25v3.934h1.25zm-7.022 0h-1.25v3.934h1.25zm3.843 3.934v-2.11a.93.93 0 1 0-1.862 0v2.11z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClassLesson: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.35.5h6.302c.469 0 .849.38.849.849v6.778c0 .47-.38.85-.849.85H7.5M3.149 4.001a1.75 1.75 0 1 0 0-3.501a1.75 1.75 0 0 0 0 3.501\"/><path d=\"M9 5.527C9 4.96 8.54 4.5 7.973 4.5H3.149v0A2.65 2.65 0 0 0 .5 7.149V9.5h1.135l.379 4h2.27l.872-6.945h2.817C8.54 6.555 9 6.095 9 5.527\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClassLessonRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.875 1c0-.345.28-.625.625-.625H12c.898 0 1.625.728 1.625 1.625v6c0 .897-.727 1.625-1.625 1.625H8a.625.625 0 1 1 0-1.25h4A.375.375 0 0 0 12.375 8V2A.375.375 0 0 0 12 1.625H7.5A.625.625 0 0 1 6.875 1M4 .5a2 2 0 0 0-.788 3.839A3.5 3.5 0 0 0 .5 7.75v1.5a.5.5 0 0 0 .5.5h1.062l.442 3.316A.5.5 0 0 0 3 13.5h2.5a.5.5 0 0 0 .499-.462L6.463 7h2.162a1.375 1.375 0 0 0 0-2.75H4.969A2 2 0 0 0 4 .5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClassLessonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.402 8.976H7.259a2.278 2.278 0 0 0-.193-4.547h-1.68A3.095 3.095 0 0 0 4.609 0h7.793a1.35 1.35 0 0 1 1.348 1.35v6.279c0 .744-.604 1.348-1.348 1.348ZM2.898 4.431a1.848 1.848 0 1 0 0-3.695a1.848 1.848 0 0 0 0 3.695m5.195 2.276c0-.568-.46-1.028-1.027-1.028H2.899a2.65 2.65 0 0 0-2.65 2.65v1.205c0 .532.432.963.964.963h.172l.282 2.61A1 1 0 0 0 2.66 14h.502a1 1 0 0 0 .99-.862l.753-5.404h2.16c.567 0 1.027-.46 1.027-1.027Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCleanWaterAndSanitation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.942 1.812A1.015 1.015 0 0 1 3.95.671h5.823c.61 0 1.083.535 1.007 1.141l-.761 6.093c-.064.508-.496.89-1.008.89h-4.3c-.512 0-.943-.382-1.007-.89zm3.806 6.977v4.39m-1.463-1.464l1.463 1.463l1.463-1.463\"/><path d=\"M3.307 4.714c3.628.518 3.628-1.555 7.256-1.036\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCleanWaterAndSanitationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.875 1.559a.31.31 0 0 1 .309-.309h7.632a.31.31 0 0 1 .306.352l-.292 2.045c-2.116.085-2.973.407-3.83.728c-.829.31-1.657.622-3.623.719l-.499-3.492zm3.5 7.691H4.117A1.625 1.625 0 0 1 2.51 7.855l-.87-6.076A1.557 1.557 0 0 1 3.184 0h7.632a1.56 1.56 0 0 1 1.543 1.78l-.868 6.075c-.114.8-.8 1.395-1.608 1.395H7.625v1.625H9a.5.5 0 0 1 .354.854l-2 2a.5.5 0 0 1-.708 0l-2-2A.5.5 0 0 1 5 10.875h1.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCleanWaterAndSanitationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.198 2.022A1.765 1.765 0 0 1 3.95.038h5.823c1.062 0 1.883.93 1.752 1.984l-.762 6.092A1.765 1.765 0 0 1 9.01 9.661H7.498v1.304h.713a.75.75 0 0 1 .53 1.28l-1.46 1.461l-.023.022a.75.75 0 0 1-1.044-.023l-1.46-1.46a.75.75 0 0 1 .53-1.28h.714V9.661H4.712c-.89 0-1.642-.663-1.752-1.547zM5.351 5.22c-.342.07-.739.11-1.23.089l-.434-3.473a.265.265 0 0 1 .263-.298h5.823c.16 0 .283.14.263.298l-.289 2.31a6 6 0 0 0-1.54.097c-.607.12-1.091.329-1.53.516l-.013.006c-.437.188-.83.354-1.313.455\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardAdd: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5.5h-3a1 1 0 0 0-1 1V2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1M7 6v5m2.5-2.5h-5\"/><path d=\"M9.75 1.5h1.5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.663 2.25H2.5a.375.375 0 0 0-.375.375v9.75c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375v-9.75a.375.375 0 0 0-.375-.375h-1.162c-.174.856-.93 1.5-1.838 1.5h-3a1.876 1.876 0 0 1-1.837-1.5M3.84 1c.315-.595.94-1 1.659-1h3c.72 0 1.344.405 1.659 1H11.5c.898 0 1.625.728 1.625 1.625v9.75c0 .898-.727 1.625-1.625 1.625h-9a1.625 1.625 0 0 1-1.625-1.625v-9.75C.875 1.728 1.603 1 2.5 1zM7 5a.75.75 0 0 1 .75.75V7.5H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 0 1-1.5 0V9H4.5a.75.75 0 0 1 0-1.5h1.75V5.75A.75.75 0 0 1 7 5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2.75 1h.5v.5A2.25 2.25 0 0 0 5.5 3.75h3a2.25 2.25 0 0 0 2.25-2.25V1h.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-8.5a1.5 1.5 0 0 1-1.5-1.5v-10A1.5 1.5 0 0 1 2.75 1m5 5.001a.75.75 0 1 0-1.5 0v1.75H4.5a.75.75 0 1 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75H9.5a.75.75 0 0 0 0-1.5H7.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5.5h-3a1 1 0 0 0-1 1V2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1\"/><path d=\"M9.75 1.5h1.5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><path d=\"m5 9l1.5 1l3-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.663 2.25H2.5a.375.375 0 0 0-.375.375v9.75c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375v-9.75a.375.375 0 0 0-.375-.375h-1.162c-.174.856-.93 1.5-1.838 1.5h-3a1.876 1.876 0 0 1-1.837-1.5M3.84 1c.315-.595.94-1 1.659-1h3c.72 0 1.344.405 1.659 1H11.5c.898 0 1.625.728 1.625 1.625v9.75c0 .898-.727 1.625-1.625 1.625h-9a1.625 1.625 0 0 1-1.625-1.625v-9.75C.875 1.728 1.603 1 2.5 1zm6.26 5.2a.75.75 0 1 0-1.2-.9L6.326 8.732l-.91-.606a.75.75 0 0 0-.832 1.248l1.5 1A.75.75 0 0 0 7.1 10.2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM3.25 1h-.5a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h8.5a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-1.5-1.5h-.5v.5A2.25 2.25 0 0 1 8.5 3.75h-3A2.25 2.25 0 0 1 3.25 1.5zm6.7 4.9a.75.75 0 0 1 .15 1.05l-3 4a.75.75 0 0 1-1.016.174l-1.5-1a.75.75 0 1 1 .832-1.248l.91.606L8.9 6.05a.75.75 0 0 1 1.05-.15\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardRemove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5.5h-3a1 1 0 0 0-1 1V2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1m1 8h-5\"/><path d=\"M9.75 1.5h1.5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardRemoveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.663 2.25H2.5a.375.375 0 0 0-.375.375v9.75c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375v-9.75a.375.375 0 0 0-.375-.375h-1.162c-.174.856-.93 1.5-1.838 1.5h-3a1.876 1.876 0 0 1-1.837-1.5M3.84 1c.315-.595.94-1 1.659-1h3c.72 0 1.344.405 1.659 1H11.5c.898 0 1.625.728 1.625 1.625v9.75c0 .898-.727 1.625-1.625 1.625h-9a1.625 1.625 0 0 1-1.625-1.625v-9.75C.875 1.728 1.603 1 2.5 1zm.66 6.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClipboardRemoveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM3.25 1h-.5a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h8.5a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-1.5-1.5h-.5v.5A2.25 2.25 0 0 1 8.5 3.75h-3A2.25 2.25 0 0 1 3.25 1.5zm.5 7.5a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloset: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M7 .5v13m2.5-7v1m-5-1v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClosetRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125 1.625c0-.207.168-.375.375-.375h3.875v11.5H2.5a.375.375 0 0 1-.375-.375zm5.5 11.125V1.25H11.5c.207 0 .375.168.375.375v10.75a.375.375 0 0 1-.375.375zM7 14H2.5a1.625 1.625 0 0 1-1.625-1.625V1.625C.875.728 1.603 0 2.5 0h9c.898 0 1.625.728 1.625 1.625v10.75c0 .898-.727 1.625-1.625 1.625zm2.5-8.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75m-4.25.75a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClosetSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H2.5A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h3.875zm1.25 14H11.5a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 11.5 0H7.625zM9.5 5.837c.345 0 .625.28.625.625v1.076a.625.625 0 1 1-1.25 0V6.462c0-.346.28-.625.625-.625m-4.375.625a.625.625 0 1 0-1.25 0v1.076a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloud: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 6.5a2.5 2.5 0 0 0-1.5.5A4.5 4.5 0 1 0 5 11.5h6a2.5 2.5 0 0 0 0-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.392 9.283H4.608M7 6.891v4.784m-3.08-.682a3.193 3.193 0 0 1-.428-6.371a.23.23 0 0 0 .21-.127a3.868 3.868 0 0 1 7.508.91a.25.25 0 0 0 .173.2a2.73 2.73 0 0 1-.61 5.388\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.004.674a4.427 4.427 0 0 1 6.722 3.073a3.309 3.309 0 0 1-.079 6.311a.625.625 0 1 1-.36-1.197a2.058 2.058 0 0 0-.123-3.974l-.035-.01a.87.87 0 0 1-.614-.739a3.177 3.177 0 0 0-6.167-.747a.85.85 0 0 1-.772.546a2.513 2.513 0 0 0-.843 4.799a.625.625 0 0 1-.512 1.14a3.762 3.762 0 0 1 1.05-7.164A4.43 4.43 0 0 1 5.003.674M7 7.5a.75.75 0 0 1 .75.75V10H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 0 1-1.5 0V11.5H4.5a.75.75 0 0 1 0-1.5h1.75V8.25A.75.75 0 0 1 7 7.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.883.06a4.37 4.37 0 0 0-4.582 2.718a3.693 3.693 0 0 0-.743 7.18A2 2 0 0 1 4.5 8.438H5v-.5a2 2 0 1 1 4 0v.5h.5a2 2 0 0 1 1.963 1.617a3.231 3.231 0 0 0 .223-6.246A4.37 4.37 0 0 0 7.883.061M3.75 10.439a.75.75 0 0 1 .75-.75h1.75v-1.75a.75.75 0 1 1 1.5 0v1.75H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 0 1-1.5 0v-1.75H4.5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudBlock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 12.045a2.8 2.8 0 1 1 0-5.6a2.8 2.8 0 0 1 0 5.6m1.982-.819L5.018 7.263\"/><path d=\"M2.819 10.874a3.193 3.193 0 0 1 .673-6.252a.23.23 0 0 0 .21-.127a3.868 3.868 0 0 1 7.508.91a.25.25 0 0 0 .173.2a2.73 2.73 0 0 1-.116 5.34\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudBlockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.004.674a4.427 4.427 0 0 1 6.722 3.073a3.309 3.309 0 0 1 .484 6.084a.625.625 0 0 1-.574-1.111a2.057 2.057 0 0 0 .74-3.015a2.06 2.06 0 0 0-1.247-.828a.87.87 0 0 1-.614-.739a3.177 3.177 0 0 0-6.167-.747a.85.85 0 0 1-.772.546a2.513 2.513 0 0 0-1.14 4.641a.625.625 0 0 1-.659 1.062A3.763 3.763 0 0 1 3.27 2.712A4.43 4.43 0 0 1 5.004.674M4.62 8.232a3.375 3.375 0 1 1 4.76 4.786a3.375 3.375 0 0 1-4.76-4.786m.502 1.398a2.125 2.125 0 0 0 2.873 2.873zm3.756 1.99L6.005 8.747a2.125 2.125 0 0 1 2.873 2.873\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudBlockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.041.748a4.368 4.368 0 0 1 6.645 3.115a3.23 3.23 0 0 1 .208 6.118a4.906 4.906 0 0 0-9.776-.145a3.692 3.692 0 0 1 1.183-7.004A4.37 4.37 0 0 1 5.04.748M7 8.198a2.127 2.127 0 0 1 1.938 3.004L6.123 8.386A2.1 2.1 0 0 1 7 8.198m-2.517-.485a1 1 0 0 0-.095.095a3.627 3.627 0 1 0 .095-.095m3.395 4.55a2.127 2.127 0 0 1-2.816-2.816z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9.803 8.55l-3.206 3.606l-1.603-1.202\"/><path d=\"M10.773 10.993a2.73 2.73 0 0 0 .61-5.388a.25.25 0 0 1-.173-.2a3.868 3.868 0 0 0-7.509-.91a.23.23 0 0 1-.21.127a3.192 3.192 0 0 0-.255 6.343\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.884.032a4.43 4.43 0 0 0-4.614 2.68a3.763 3.763 0 0 0-1.178 7.103a.625.625 0 0 0 .555-1.12a2.512 2.512 0 0 1 .93-4.758a.85.85 0 0 0 .771-.546a3.177 3.177 0 0 1 6.171.78a.87.87 0 0 0 .645.716a2.059 2.059 0 0 1 .428 3.855a.625.625 0 0 0 .547 1.124a3.3 3.3 0 0 0 1.84-2.604a3.31 3.31 0 0 0-2.253-3.515A4.43 4.43 0 0 0 7.884.032M10.36 8.72a.75.75 0 0 0-1.171-.938l-3.546 4.433l-1.419-1.064a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.036-.131z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.883.115a4.37 4.37 0 0 0-4.582 2.717a3.693 3.693 0 0 0-.972 7.097l.071-.1a2 2 0 0 1 2.8-.4l.528.395L8.505 6.7a2 2 0 1 1 2.99 2.658l-.738.83h.019a3.23 3.23 0 0 0 .91-6.324A4.37 4.37 0 0 0 7.883.115m2.678 8.412a.75.75 0 0 0-1.122-.997l-3.541 3.984l-1.448-1.086a.75.75 0 0 0-.9 1.2l2 1.5a.75.75 0 0 0 1.01-.101z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudDataTransfer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.984 8.848l1.968-1.74v5.218m4.065-1.739l-1.969 1.739V7.108\"/><path d=\"M3.92 10.842a3.193 3.193 0 0 1-.428-6.37a.23.23 0 0 0 .21-.128a3.868 3.868 0 0 1 7.508.91a.25.25 0 0 0 .173.2a2.73 2.73 0 0 1 .502 5.144\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudDataTransferRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.004.674a4.427 4.427 0 0 1 6.722 3.073a3.309 3.309 0 0 1-1.014 6.452a.625.625 0 1 1-.007-1.25a2.059 2.059 0 0 0 .424-4.072a.87.87 0 0 1-.614-.739a3.177 3.177 0 0 0-6.167-.747a.85.85 0 0 1-.772.546a2.513 2.513 0 0 0-1.468 4.398a.625.625 0 0 1-.823.941A3.763 3.763 0 0 1 3.27 2.712A4.43 4.43 0 0 1 5.004.674m.948 6.878c.228.1.375.325.375.573v5.25a.625.625 0 1 1-1.25 0v-2.917H3.859a.625.625 0 0 1-.425-1.083l1.843-1.708a.63.63 0 0 1 .675-.115m2.971.573a.625.625 0 1 0-1.25 0v5.25a.625.625 0 0 0 1.05.458l1.843-1.708a.625.625 0 0 0-.425-1.083H8.924z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudDataTransferSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.883.115a4.37 4.37 0 0 0-4.582 2.717a3.693 3.693 0 0 0-1.706 6.7a2 2 0 0 1 .557-1.753l2-2A2 2 0 0 1 7 5.799a2 2 0 0 1 3.434 1.394v2a2 2 0 0 1 1.56.748a3.229 3.229 0 0 0-.308-6.078A4.37 4.37 0 0 0 7.883.115M5.853 6.5a.75.75 0 0 1 .463.693v6a.75.75 0 0 1-1.5 0v-4.19l-.72.72a.75.75 0 1 1-1.06-1.06l2-2a.75.75 0 0 1 .817-.163m3.331.693a.75.75 0 1 0-1.5 0v6a.75.75 0 0 0 1.28.53l2-2a.75.75 0 0 0-1.06-1.06l-.72.72z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudGaming1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.579 6.126v2.786M3.186 7.519h2.786M.5 7a4.643 4.643 0 0 0 4.643 4.643h4.643a3.714 3.714 0 1 0-.856-7.33A4.643 4.643 0 0 0 .5 7\"/><path d=\"M9.131 7.853a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25m2.139.25a.125.125 0 1 1 0-.25m0 .25a.125.125 0 0 0 0-.25m-1.045-.797a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25m0 2.388a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudGaming1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a3.93 3.93 0 0 1 3.929-3.936a3.92 3.92 0 0 1 3.204 1.659a.625.625 0 0 0 .653.246q.335-.079.696-.08a3.02 3.02 0 0 1 3.018 3.023a3.02 3.02 0 0 1-3.018 3.024H5.18A3.93 3.93 0 0 1 1.25 7m3.929-5.186C2.318 1.814 0 4.137 0 7s2.318 5.186 5.179 5.186h4.553A4.27 4.27 0 0 0 14 7.912a4.27 4.27 0 0 0-4.845-4.234a5.17 5.17 0 0 0-3.976-1.864m.196 4.329a.75.75 0 1 0-1.5 0v.616H3.26a.75.75 0 1 0 0 1.5h.616v.616a.75.75 0 1 0 1.5 0v-.616h.616a.75.75 0 0 0 0-1.5h-.616zM8.822 8.46a.748.748 0 1 1 .046-1.495a.748.748 0 0 1-.046 1.495m2.588 0a.748.748 0 1 1 .045-1.495a.748.748 0 0 1-.045 1.495m-1.274-1.272a.748.748 0 1 1 .054-1.494a.748.748 0 0 1-.054 1.494m.055 2.587h-.028a.748.748 0 1 1 .028 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudGaming1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a5.143 5.143 0 0 1 9.14-3.236q.316-.05.646-.05a4.214 4.214 0 1 1 0 8.429H5.143A5.143 5.143 0 0 1 0 7m4.803-.61a.625.625 0 1 0-1.25 0v.84h-.84a.625.625 0 0 0 0 1.25h.84v.841a.625.625 0 0 0 1.25 0v-.84h.84a.625.625 0 1 0 0-1.25h-.84zm4.548 1.434a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m2.084.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m-1.417-1.417a.75.75 0 1 1 0-1.5a.75.75 0 0 1 0 1.5m-.75 2.084a.75.75 0 1 0 1.5 0a.75.75 0 0 0-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudRefresh: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 11.32a3.194 3.194 0 0 1-.21-5.818a3.2 3.2 0 0 1 1.202-.324a.23.23 0 0 0 .21-.127a3.868 3.868 0 0 1 7.508.91a.25.25 0 0 0 .173.2A2.73 2.73 0 0 1 12 11.249\"/><path d=\"M9.45 10.5a2.5 2.5 0 1 0-.832 2.406\"/><path d=\"m10 9l-.55 1.5L8 10.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudRefreshRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.004.674a4.427 4.427 0 0 1 6.722 3.073a3.309 3.309 0 0 1 .579 6.033a.625.625 0 0 1-.61-1.092a2.056 2.056 0 0 0 .68-2.983a2.06 2.06 0 0 0-1.246-.828a.87.87 0 0 1-.614-.739a3.177 3.177 0 0 0-6.167-.747a.85.85 0 0 1-.772.546a2.513 2.513 0 0 0-1.468 4.398q.196.17.423.291a.625.625 0 1 1-.588 1.103a3.5 3.5 0 0 1-.658-.453A3.763 3.763 0 0 1 3.27 2.712A4.43 4.43 0 0 1 5.004.674M6.75 9a1.875 1.875 0 1 0 1.213 3.305a.625.625 0 1 1 .809.953a3.125 3.125 0 1 1 .256-4.521l.457-.286a.5.5 0 0 1 .734.596l-.55 1.5a.5.5 0 0 1-.554.32l-1.45-.25a.5.5 0 0 1-.18-.916l.448-.28A1.87 1.87 0 0 0 6.75 9\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudRefreshSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.883.046a4.37 4.37 0 0 0-4.582 2.717a3.693 3.693 0 0 0-.732 7.184a4.5 4.5 0 0 1 6.726-3.083a2 2 0 0 1 2.583 2.56l-.207.563a3.23 3.23 0 0 0 .015-6.192A4.37 4.37 0 0 0 7.883.046M7 8.986a1.75 1.75 0 1 0 1.132 3.084a.75.75 0 0 1 .971 1.143a3.25 3.25 0 1 1 .102-4.865l.397-.248a.75.75 0 0 1 1.102.894l-.545 1.487a.74.74 0 0 1-.173.279a.74.74 0 0 1-.68.212l-1.433-.247a.75.75 0 0 1-.27-1.375l.238-.15A1.74 1.74 0 0 0 7 8.987\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M10.924 6.51c-.53 0-1.047.172-1.472.49a4.414 4.414 0 1 0-4.414 4.414h5.886a2.452 2.452 0 0 0 0-4.904\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudShare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2 11.062A3.2 3.2 0 0 1 .52 8.577a3.193 3.193 0 0 1 2.972-3.4a.23.23 0 0 0 .21-.126a3.868 3.868 0 0 1 7.508.91a.25.25 0 0 0 .173.2A2.73 2.73 0 0 1 12 11.249M8.108 8.946L5.89 10.055\"/><path d=\"M8 8.5a1 1 0 1 0 2 0a1 1 0 1 0-2 0m-4 2a1 1 0 1 0 2 0a1 1 0 1 0-2 0m4 2a1 1 0 1 0 2 0a1 1 0 1 0-2 0m-2.11-1.555l2.218 1.109\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudShareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.004.674a4.427 4.427 0 0 1 6.722 3.073a3.31 3.31 0 0 1 1.178 5.604a.625.625 0 1 1-.836-.93a2.059 2.059 0 0 0-.94-3.544a.87.87 0 0 1-.613-.739a3.177 3.177 0 0 0-6.167-.747a.85.85 0 0 1-.772.546a2.513 2.513 0 0 0-1.468 4.398a.625.625 0 0 1-.823.941A3.763 3.763 0 0 1 3.27 2.712A4.43 4.43 0 0 1 5.004.674m-.17 7.951A1.667 1.667 0 1 0 5.9 11.572l1.607.598a1.667 1.667 0 1 0 .589-1.115l-1.605-.597a1.7 1.7 0 0 0 0-.333l1.604-.597a1.667 1.667 0 1 0-.589-1.115L5.9 9.012a1.66 1.66 0 0 0-1.068-.387\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudShareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.883.046a4.37 4.37 0 0 0-4.582 2.717a3.693 3.693 0 0 0-.979 7.094a2.75 2.75 0 0 1 3.64-1.948l.4-.2a2.751 2.751 0 1 1 4.877 2.374a3.23 3.23 0 0 0 .447-6.288A4.37 4.37 0 0 0 7.883.046M9 6.986a1.5 1.5 0 0 0-1.5 1.55l-1.56.78a1.5 1.5 0 1 0 0 2.338l1.56.78v.052a1.5 1.5 0 1 0 .56-1.17l-1.56-.78v-.101l1.56-.78A1.5 1.5 0 1 0 9 6.985\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.913 2.38A5 5 0 1 0 5 12h6a3 3 0 0 0 0-6v.5V6a3 3 0 0 0-1.065.196a5 5 0 0 0-3.022-3.815\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudWarning: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 11.549h1.273a2.73 2.73 0 0 0 .61-5.388a.25.25 0 0 1-.173-.2A3.868 3.868 0 0 0 3.7 5.05a.23.23 0 0 1-.21.127a3.193 3.193 0 0 0-1.886 5.589c.637.557 1.395.782 2.315.782h.58M7 7.154v3.5m0 2.596a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudWarningRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.884.032a4.43 4.43 0 0 0-4.614 2.68a3.763 3.763 0 0 0-1.985 6.564c.771.674 1.74.923 2.687.923h.403a.625.625 0 1 0 0-1.25h-.403c-.736 0-1.382-.192-1.864-.614a2.513 2.513 0 0 1 1.468-4.398a.85.85 0 0 0 .772-.546a3.177 3.177 0 0 1 6.171.78a.87.87 0 0 0 .645.716a2.059 2.059 0 0 1-.458 4.062H9.625a.625.625 0 0 0 0 1.25h1.087a3.308 3.308 0 0 0 1.014-6.452A4.43 4.43 0 0 0 7.884.032M7.75 7.5a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0zM6 13a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudWarningSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.883.046a4.37 4.37 0 0 0-4.582 2.717a3.693 3.693 0 0 0 .635 7.356H5V7.14a2 2 0 1 1 4 0v2.98h1.776a3.23 3.23 0 0 0 .91-6.324A4.37 4.37 0 0 0 7.883.046M7 6.39a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 7 6.39m1 6.596a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudWifi: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 1.239a9 9 0 0 0-7 0m5.7 2.099a6.78 6.78 0 0 0-4.36 0m6.03 5.369a.22.22 0 0 1-.153-.177a3.415 3.415 0 0 0-6.63-.804a.2.2 0 0 1-.184.113a2.819 2.819 0 0 0 .377 5.624h6.05a2.41 2.41 0 0 0 .54-4.756\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudWifiRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.463.918a11.67 11.67 0 0 1 9.074 0a.75.75 0 0 1-.583 1.382a10.17 10.17 0 0 0-7.908 0A.75.75 0 1 1 2.463.918m1.651 2.278a8.97 8.97 0 0 1 5.771 0a.75.75 0 1 1-.482 1.42a7.47 7.47 0 0 0-4.806 0a.75.75 0 0 1-.483-1.42M7.74 5.423a3.75 3.75 0 0 0-3.882 2.211a3.203 3.203 0 0 0 .674 6.364h5.518a2.83 2.83 0 0 0 .932-5.496A3.75 3.75 0 0 0 7.74 5.423M5.964 7.026A2.498 2.498 0 0 1 9.78 8.95a.82.82 0 0 0 .615.68a1.58 1.58 0 0 1-.351 3.118H4.513l-.042.002a1.953 1.953 0 0 1-.278-3.897a.81.81 0 0 0 .734-.523a2.5 2.5 0 0 1 1.037-1.304\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCloudWifiSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.98.07c-1.32 0-2.624.31-3.832.907a.75.75 0 1 0 .664 1.344A7.1 7.1 0 0 1 6.98 1.57c1.084 0 2.16.254 3.168.752a.75.75 0 1 0 .664-1.344A8.6 8.6 0 0 0 6.98.069m2.098 2.748a5.26 5.26 0 0 0-4.156 0a.75.75 0 1 0 .587 1.38a3.76 3.76 0 0 1 2.982 0a.75.75 0 1 0 .587-1.38M5.308 5.88a3.757 3.757 0 0 1 5.71 2.63a2.8 2.8 0 0 1-.838 5.466H4.422a3.19 3.19 0 0 1-.593-6.347a3.76 3.76 0 0 1 1.48-1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClubsSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5a2.786 2.786 0 0 0-2.786 2.786c0 .696.256 1.523.678 2.22c-.538-.231-1.106-.363-1.606-.363a2.786 2.786 0 0 0 0 5.571c.73 0 1.604-.28 2.321-.741L4.892 13.5h4.216l-.715-3.527c.717.46 1.59.741 2.321.741a2.786 2.786 0 0 0 0-5.571c-.5 0-1.068.132-1.606.363c.422-.697.678-1.524.678-2.22A2.786 2.786 0 0 0 7 .5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClubsSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a2.107 2.107 0 0 0-2.107 2.107c0 .548.208 1.249.574 1.853a.625.625 0 0 1-.78.899c-.468-.2-.94-.305-1.33-.305a2.107 2.107 0 0 0 0 4.214c.577 0 1.319-.23 1.94-.628a.625.625 0 0 1 .95.65l-.55 2.71h2.606l-.55-2.71a.625.625 0 0 1 .95-.65c.621.398 1.363.628 1.94.628a2.107 2.107 0 0 0 0-4.214c-.39 0-.862.104-1.33.305a.625.625 0 0 1-.78-.899c.366-.604.574-1.305.574-1.853A2.107 2.107 0 0 0 7 1.25M3.643 3.357a3.357 3.357 0 1 1 6.714 0c0 .395-.068.814-.191 1.228q.242-.03.477-.031a3.357 3.357 0 0 1 0 6.714c-.454 0-.942-.09-1.416-.251l.453 2.234a.625.625 0 0 1-.613.749H4.933a.625.625 0 0 1-.613-.75l.453-2.233c-.474.16-.962.25-1.416.25a3.357 3.357 0 0 1 0-6.713q.235 0 .477.03a4.4 4.4 0 0 1-.191-1.227\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineClubsSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .25a3.036 3.036 0 0 0-3.036 3.036c0 .56.152 1.186.412 1.771a4 4 0 0 0-1.09-.164a3.036 3.036 0 0 0 0 6.071c.622 0 1.328-.187 1.967-.504l-.606 2.99a.25.25 0 0 0 .245.3h4.216a.25.25 0 0 0 .245-.3l-.606-2.99c.639.317 1.345.504 1.967.504a3.036 3.036 0 0 0 0-6.071c-.347 0-.72.058-1.09.164c.26-.585.412-1.212.412-1.771A3.036 3.036 0 0 0 7 .25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCocktail: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.679 3h8.642M7 8.5L1.659 1.702a.74.74 0 0 1-.159-.459v0c0-.41.333-.743.743-.743h9.514c.41 0 .743.333.743.743v0a.74.74 0 0 1-.159.46zm0 0v5m-3 0h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCocktailRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.243 0a1.368 1.368 0 0 0-1.076 2.213l5.208 6.628v3.909H4A.625.625 0 1 0 4 14h6a.625.625 0 1 0 0-1.25H7.625V8.841l5.208-6.628A1.368 1.368 0 0 0 11.757 0zm-.118 1.368c0-.065.053-.118.118-.118h9.514a.118.118 0 0 1 .093.19l-1.716 2.185H3.866L2.15 1.441a.12.12 0 0 1-.025-.073\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCocktailSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.536.026a1.447 1.447 0 0 0-1.138 2.342L6.25 8.543v3.946H4a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H7.75V8.543l4.852-6.175A1.447 1.447 0 0 0 11.464.026zM9.805 3.5l1.55-1.974h-8.71L4.195 3.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeAnalysis: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.625 12.5a5.875 5.875 0 1 0 0-11.75a5.875 5.875 0 0 0 0 11.75m6.625.75l-2.467-2.467\"/><path d=\"m5.5 4.5l-2 2l2 2m2-4l2 2l-2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeAnalysisRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1.25a5.25 5.25 0 1 0 0 10.5a5.25 5.25 0 0 0 0-10.5M0 6.5a6.5 6.5 0 1 1 11.749 3.835l1.958 1.958a1 1 0 0 1-1.414 1.414l-1.958-1.958A6.5 6.5 0 0 1 0 6.5m5.78-1.47a.75.75 0 0 0-1.06-1.06l-2 2a.75.75 0 0 0 0 1.06l2 2a.75.75 0 0 0 1.06-1.06L4.31 6.5zm2.5-1.06a.75.75 0 0 0-1.06 1.06L8.69 6.5L7.22 7.97a.75.75 0 0 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeAnalysisSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.516 6.36a4.844 4.844 0 1 1 9.687 0a4.844 4.844 0 0 1-9.687 0M6.359.015a6.344 6.344 0 1 0 3.723 11.48l2.195 2.195a1 1 0 0 0 1.415-1.414l-2.196-2.195A6.344 6.344 0 0 0 6.36.016Zm-.745 4.026a.625.625 0 0 1 0 .884L4.056 6.484l1.558 1.558a.625.625 0 0 1-.884.884l-2-2a.625.625 0 0 1 0-.884l2-2a.625.625 0 0 1 .884 0Zm2.5 0a.625.625 0 0 0-.884.884l1.558 1.558L7.23 8.042a.625.625 0 0 0 .884.884l2-2a.625.625 0 0 0 0-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeMonitor1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 2H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-8A.5.5 0 0 0 13 2m-7 9l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"m4.5 5.25l-1.75 1.5L4.25 8m5.5-2.5l1.5 1.25l-1.75 1.5m-3.25.5l1.5-4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeMonitor1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 9.75v-8h11.5v8zM1.125.5C.504.5 0 1.004 0 1.625v8.25C0 10.496.504 11 1.125 11h4.136l-.55 1.375H4a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25h-.711L8.739 11h4.136C13.496 11 14 10.496 14 9.875v-8.25C14 1.004 13.496.5 12.875.5zm3.782 4.35a.625.625 0 0 0-.814-.95l-1.75 1.5a.625.625 0 0 0 .007.955l1.5 1.25a.625.625 0 0 0 .8-.96l-.932-.777zm4.363-.875a.625.625 0 0 1 .88-.08l1.5 1.25a.625.625 0 0 1 .007.955l-1.75 1.5a.625.625 0 0 1-.814-.95l1.189-1.018l-.932-.777a.625.625 0 0 1-.08-.88m-.927-.277a.625.625 0 0 0-1.186-.396l-1.5 4.5a.625.625 0 0 0 1.186.396z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeMonitor1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.457.5C.652.5 0 1.152 0 1.957v7.586C0 10.348.652 11 1.457 11h4.026l-.535 1.495H4a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-.948L8.517 11h4.026C13.348 11 14 10.348 14 9.543V1.957C14 1.152 13.348.5 12.543.5zm6.53 2.289a.75.75 0 0 1 .475.948l-1.5 4.5a.75.75 0 1 1-1.424-.474l1.5-4.5a.75.75 0 0 1 .95-.474m-2.999 2.28a.75.75 0 1 0-.976-1.138l-1.75 1.5a.75.75 0 0 0 .008 1.145l1.5 1.25a.75.75 0 0 0 .96-1.152l-.818-.682zm5.242-.895a.75.75 0 1 0-.96 1.152l.818.682l-1.076.923a.75.75 0 1 0 .976 1.138l1.75-1.5a.75.75 0 0 0-.008-1.145z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeMonitor2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 2H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-8A.5.5 0 0 0 13 2m-7 9l-1 2.5M8 11l1 2.5m-5 0h6M7.5 2v9M3 5h2M3 8h1\"/><path d=\"m7.5 7l1.21-1a2 2 0 0 1 2.55 0l2.24 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeMonitor2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 1.75v8h5.625v-8zm8.039 10.625H10a.625.625 0 1 1 0 1.25H4a.625.625 0 1 1 0-1.25h.711L5.261 11H1.125A1.125 1.125 0 0 1 0 9.875v-8.25C0 1.004.504.5 1.125.5h11.75C13.496.5 14 1.004 14 1.625v8.25c0 .621-.504 1.125-1.125 1.125H8.739zM12.75 9.75V7.33L11.26 6a2 2 0 0 0-2.55 0l-.585.483V9.75zM3 3.375a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25zM2.375 6.5c0-.345.28-.625.625-.625h1a.625.625 0 1 1 0 1.25H3a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCodeMonitor2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 2.5V9h4.397V2.5zm10 4.913L10.407 6.04a1.37 1.37 0 0 0-1.75 0l-.88.71a.22.22 0 0 0-.12.17V9H12zM0 1.957C0 1.152.652.5 1.457.5h11.086C13.348.5 14 1.152 14 1.957v7.586c0 .805-.652 1.457-1.457 1.457H8.517l.535 1.495H10a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.948L5.483 11H1.457A1.457 1.457 0 0 1 0 9.543zM4.776 3.87h-1.75a.63.63 0 1 0 0 1.26h1.75a.63.63 0 0 0 0-1.26m-1.75 2.5h1a.63.63 0 1 1 0 1.26h-1a.63.63 0 0 1 0-1.26\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeBean: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.536 10.536c-2.539 2.538-6.18 3.013-8.132 1.06C.45 9.643.926 6.003 3.464 3.464s6.18-3.013 8.132-1.06c1.953 1.952 1.478 5.593-1.06 8.131\"/><path d=\"M11.596 2.404s-.353 2.475-1.768 3.889c-1.414 1.414-4.242 0-5.656 1.414c-1.415 1.414-1.768 3.89-1.768 3.89\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeBeanRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.782 2.315c-1.807-1.238-4.8-.827-7.047 1.42c-1.988 1.989-2.539 4.56-1.782 6.379c.592-1.367 1.264-2.27 2.028-2.87c.971-.763 1.995-.948 2.814-1.096l.049-.009c.852-.155 1.486-.282 2.095-.76c.578-.453 1.223-1.304 1.843-3.064m-7.564 9.37c1.807 1.238 4.8.827 7.047-1.42c1.989-1.989 2.54-4.56 1.782-6.379c-.592 1.367-1.264 2.27-2.027 2.87c-.972.763-1.996.948-2.815 1.096l-.049.009c-.852.154-1.486.282-2.095.76c-.578.453-1.223 1.304-1.843 3.064M12.16 1.84C9.775-.544 5.596.107 2.85 2.851C.107 5.596-.544 9.775 1.841 12.16s6.563 1.733 9.308-1.011c2.744-2.745 3.395-6.924 1.01-9.309\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeBeanSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.175 12.356c2.221 1.867 6.048 1.27 8.75-1.431C13.37 8.48 14.09 5.114 12.822 2.85q-.073.26-.17.553c-.328.986-.894 2.252-1.837 3.196c-.54.54-1.2.79-1.859.91c-.635.116-1.315.116-1.928.116H7c-.645 0-1.219.002-1.733.095c-.501.091-.895.262-1.198.565c-.743.743-1.232 1.796-1.536 2.707a11 11 0 0 0-.358 1.364m-.997-1.206C-.09 8.886.63 5.52 3.075 3.075C5.777.373 9.604-.222 11.825 1.644l-.047.23c-.062.286-.162.685-.312 1.134c-.303.91-.792 1.964-1.535 2.707c-.303.303-.697.474-1.198.565c-.514.093-1.088.095-1.733.095h-.028c-.613 0-1.293 0-1.928.115c-.659.12-1.319.371-1.859.911c-.943.944-1.509 2.21-1.837 3.196q-.097.292-.17.553\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeMug: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5.5h5a1 1 0 0 1 1 1v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a1 1 0 0 1 1-1m6 1h.5a2.5 2.5 0 0 1 0 5H9M4 .5v2m3-2v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeMugRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.404 4.086a.75.75 0 0 1-.117-1.054a.8.8 0 0 0 .145-.234a2 2 0 0 0-.152-.213l-.021-.028c-.122-.155-.367-.467-.432-.88c-.078-.499.114-.963.46-1.395a.75.75 0 0 1 1.171.937a.8.8 0 0 0-.145.233c.01.02.045.075.152.213l.022.028c.122.155.367.467.431.88c.079.499-.114.963-.46 1.396a.75.75 0 0 1-1.054.117m.905-2.614l.002-.01q0 .01-.002.01m-.873 1.306v.01zM2.5 5C1.603 5 .875 5.728.875 6.625v4.75A2.625 2.625 0 0 0 3.5 14h4c1.234 0 2.27-.852 2.55-2h.2a3 3 0 1 0 0-6H10c-.244-.587-.824-1-1.5-1zm7.625 2.5v3h.125a1.5 1.5 0 1 0 0-3zm-8-.875c0-.207.168-.375.375-.375h6c.207 0 .375.168.375.375v4.75c0 .76-.616 1.375-1.375 1.375h-4c-.76 0-1.375-.616-1.375-1.375zm4.412-3.593a.75.75 0 0 0 1.171.937c.346-.433.539-.897.46-1.396c-.064-.413-.31-.725-.43-.88l-.023-.028a2 2 0 0 1-.152-.213a.8.8 0 0 1 .145-.233a.75.75 0 0 0-1.17-.937c-.347.432-.54.896-.46 1.395c.064.413.31.725.43.88l.022.028c.107.138.142.194.152.213a.8.8 0 0 1-.145.234m1.022-1.56l.002-.01q0 .01-.002.01m-.873 1.306v.01z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeMugSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 .023a.75.75 0 0 1 .75.75v2a.75.75 0 1 1-1.5 0v-2A.75.75 0 0 1 4 .023M1.94 5.439A1.5 1.5 0 0 1 3 5h5a1.5 1.5 0 0 1 1.429 1.044H9.5a3.25 3.25 0 1 1 0 6.5h-.228A2.5 2.5 0 0 1 7 14H4a2.5 2.5 0 0 1-2.5-2.5v-5c0-.398.158-.78.44-1.06m7.56 5.605a1.75 1.75 0 1 0 0-3.5zM7.75.773a.75.75 0 0 0-1.5 0v2a.75.75 0 1 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeTakeawayCup: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 3h-9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m0 0l-1-2.5h-7L2.5 3m9 4l-1 6.5h-7L2.5 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeTakeawayCupRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.91.42A.625.625 0 0 1 3.5 0h7c.266 0 .503.168.59.42l.927 2.664a1.63 1.63 0 0 1 1.108 1.541v1.25c0 .697-.438 1.291-1.055 1.522l-.953 6.075A.625.625 0 0 1 10.5 14h-7a.625.625 0 0 1-.617-.528L1.93 7.397A1.63 1.63 0 0 1 .875 5.875v-1.25c0-.717.464-1.325 1.108-1.541zm.3 7.08l.824 5.25h5.93l.824-5.25zm6.845-6.25L10.664 3H3.336l.608-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoffeeTakeawayCupSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0a.5.5 0 0 0-.464.314l-.84 2.1h9.608l-.84-2.1A.5.5 0 0 0 10.5 0zm-.494 13.576l-.754-4.898h9.496l-.754 4.898A.5.5 0 0 1 10.5 14h-7a.5.5 0 0 1-.494-.424m-.89-9.913h9.769c.6 0 1.085.422 1.085.942v1.882c0 .52-.486.94-1.085.94h-9.77c-.6 0-1.085-.42-1.085-.94V4.605c0-.52.486-.942 1.085-.942\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCog: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.23 2.25l.43-1.11A1 1 0 0 1 6.59.5h.82a1 1 0 0 1 .93.64l.43 1.11l1.46.84l1.18-.18a1 1 0 0 1 1 .49l.4.7a1 1 0 0 1-.08 1.13l-.73.93v1.68l.75.93a1 1 0 0 1 .08 1.13l-.4.7a1 1 0 0 1-1 .49l-1.18-.18l-1.46.84l-.43 1.11a1 1 0 0 1-.93.64h-.84a1 1 0 0 1-.93-.64l-.43-1.11l-1.46-.84l-1.18.18a1 1 0 0 1-1-.49l-.4-.7a1 1 0 0 1 .08-1.13L2 7.84V6.16l-.75-.93a1 1 0 0 1-.08-1.13l.4-.7a1 1 0 0 1 1-.49l1.18.18zM5 7a2 2 0 1 0 4 0a2 2 0 0 0-4 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCog1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.598-.001h-.002a1.61 1.61 0 0 0-1.493 1.027l-.341.881l-1.07.607l-.943-.144l-.01-.001a1.61 1.61 0 0 0-1.606.787l-.002.003l-.39.683a1.61 1.61 0 0 0 .13 1.811l.002.003l.597.74v1.212l-.581.74a1.61 1.61 0 0 0-.129 1.81l.39.683l.002.003a1.61 1.61 0 0 0 1.606.787l.01-.001l.942-.144l1.05.605l.343.882a1.61 1.61 0 0 0 1.493 1.028h.828a1.605 1.605 0 0 0 1.493-1.027l.342-.883l1.051-.605l.941.144l.01.001a1.61 1.61 0 0 0 1.606-.787l.002-.003l.39-.683a1.61 1.61 0 0 0-.13-1.811l-.002-.003l-.597-.74V6.391l.581-.74a1.61 1.61 0 0 0 .13-1.81l-.391-.683l-.002-.003a1.61 1.61 0 0 0-1.606-.787l-.01.001l-.941.144l-1.052-.605l-.341-.882A1.61 1.61 0 0 0 7.404-.001zm.001 1.25h.802a.36.36 0 0 1 .33.228l.423 1.09a.63.63 0 0 0 .27.315l1.433.824a.62.62 0 0 0 .406.076l1.15-.175a.36.36 0 0 1 .352.174l.392.684l.003.007a.36.36 0 0 1-.028.402l-.003.004l-.716.912a.63.63 0 0 0-.133.386v1.648c0 .143.049.281.138.392l.734.91a.36.36 0 0 1 .028.402l-.004.007l-.39.683l-.001.001a.36.36 0 0 1-.351.174l-1.152-.175a.63.63 0 0 0-.406.076l-1.432.824a.63.63 0 0 0-.27.316l-.423 1.089a.36.36 0 0 1-.33.228h-.822a.36.36 0 0 1-.33-.228l-.422-1.09a.63.63 0 0 0-.271-.315l-1.433-.824a.63.63 0 0 0-.406-.076l-1.15.175a.36.36 0 0 1-.352-.174l-.391-.684l-.004-.007a.36.36 0 0 1 .028-.402l.003-.004l.716-.912a.63.63 0 0 0 .133-.386V6.176a.63.63 0 0 0-.138-.392l-.734-.91a.36.36 0 0 1-.028-.402l.004-.007l.391-.684a.36.36 0 0 1 .352-.174l1.15.175a.63.63 0 0 0 .404-.074l1.451-.824a.63.63 0 0 0 .275-.318l.421-1.088v-.001a.36.36 0 0 1 .331-.228M4.75 7a2.25 2.25 0 1 0 4.5 0a2.25 2.25 0 0 0-4.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCogSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m5.557.69l-.463 1.195l-1.594.904l-1.27-.194a1.08 1.08 0 0 0-1.078.528l-.43.754a1.08 1.08 0 0 0 .086 1.217l.807 1.001v1.81L.83 8.906a1.08 1.08 0 0 0-.086 1.217l.43.754a1.08 1.08 0 0 0 1.078.528l1.27-.194l1.573.904l.463 1.196a1.08 1.08 0 0 0 1 .689h.905a1.08 1.08 0 0 0 1.002-.69l.463-1.195l1.572-.904l1.27.194a1.08 1.08 0 0 0 1.078-.528l.43-.754a1.08 1.08 0 0 0-.086-1.217l-.807-1.001v-1.81l.786-1.001a1.08 1.08 0 0 0 .086-1.217l-.43-.754a1.08 1.08 0 0 0-1.078-.528l-1.27.194l-1.573-.904L8.443.689A1.08 1.08 0 0 0 7.442 0h-.884a1.08 1.08 0 0 0-1.001.69M7 9.25a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoinShare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 8.5a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-3v-2M.5 11l2.444 2.036a2 2 0 0 0 1.28.464h6.443c.46 0 .833-.373.833-.833c0-.92-.746-1.667-1.667-1.667H5.354\"/><path d=\"m3.5 10l.75.75a1.06 1.06 0 0 0 1.5-1.5L4.586 8.086A2 2 0 0 0 3.172 7.5H.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoinShareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 4.25a4.25 4.25 0 1 1 8.5 0a4.25 4.25 0 0 1-8.5 0m5.125-1a.875.875 0 1 0-1.75 0v2a.875.875 0 1 0 1.75 0zM.145 10.474a.625.625 0 0 1 .88-.08l2.444 2.037c.247.206.558.319.88.319h6.443a.21.21 0 0 0 .208-.21c0-.575-.466-1.042-1.042-1.042H5.574a1.69 1.69 0 0 1-1.64-.433l-.75-.75a.625.625 0 0 1 .883-.883l.75.75a.436.436 0 1 0 .616-.617L4.27 8.402A1.38 1.38 0 0 0 3.297 8H.625a.625.625 0 1 1 0-1.25h2.672c.696 0 1.363.276 1.856.768l1.164 1.165c.425.425.576 1.02.452 1.567h3.19a2.29 2.29 0 0 1 2.291 2.291c0 .806-.653 1.458-1.458 1.458H4.349a2.63 2.63 0 0 1-1.68-.608L.225 11.355a.625.625 0 0 1-.08-.88\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoinShareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.75 8.25a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-5.625c.345 0 .625.28.625.625v2a.625.625 0 1 1-1.25 0v-2c0-.345.28-.625.625-.625M2.093 6.75H.25v4l1.828 1.828a4 4 0 0 0 2.829 1.172h5.843a1.5 1.5 0 0 0 0-3H7.973a2.11 2.11 0 0 1-3.515.892l-1.45-1.45a.625.625 0 1 1 .884-.884l1.45 1.45a.86.86 0 0 0 1.307-1.109L4.922 7.922A4 4 0 0 0 2.093 6.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoinsStack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 7.5c2.485 0 4.5-.895 4.5-2s-2.015-2-4.5-2s-4.5.895-4.5 2s2.015 2 4.5 2\"/><path d=\"M4.5 5.5v6c0 1.1 2 2 4.5 2s4.5-.9 4.5-2v-6\"/><path d=\"M13.5 8.5c0 1.1-2 2-4.5 2s-4.5-.9-4.5-2m4.4-6.991a6.77 6.77 0 0 0-3.9-1c-2.49 0-4.5.9-4.5 2c0 .59.58 1.12 1.5 1.5\"/><path d=\"M2 10.009c-.92-.38-1.5-.91-1.5-1.5v-6\"/><path d=\"M2 7.009c-.92-.38-1.5-.91-1.5-1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoinsStackRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.125.01c-1.31 0-2.524.235-3.436.64c-.455.202-.862.459-1.163.776C.22 1.746 0 2.156 0 2.635v6c0 .49.23.907.546 1.23c.313.322.735.581 1.208.784a.625.625 0 0 0 .492-1.148c-.376-.162-.642-.34-.804-.507c-.16-.164-.192-.285-.192-.359V7.399q.24.137.504.25a.625.625 0 0 0 .492-1.148c-.376-.162-.642-.34-.804-.507c-.16-.164-.192-.285-.192-.359V4.398q.21.12.44.222q.39.174.846.303c.11-.676.458-1.223.834-1.62c.45-.471 1.011-.811 1.562-1.056c1.105-.49 2.5-.747 3.943-.747q.48 0 .949.037a2 2 0 0 0-.1-.111C9.423 1.109 9.016.852 8.561.65C7.649.245 6.434.01 5.125.01M14 5.375c0-.48-.221-.89-.526-1.21c-.301-.316-.708-.573-1.163-.775c-.912-.405-2.127-.64-3.436-.64s-2.524.235-3.436.64c-.455.202-.862.459-1.163.776c-.305.32-.526.73-.526 1.209v6c0 .478.22.887.523 1.207c.3.316.706.574 1.16.776c.91.406 2.125.642 3.442.642s2.532-.236 3.442-.642c.454-.202.86-.46 1.16-.777c.303-.32.523-.728.523-1.206zM5 7.138q.21.12.44.222c.91.405 2.126.64 3.435.64s2.524-.235 3.436-.64q.23-.1.439-.222v1.237c0 .072-.03.189-.18.347c-.153.16-.404.335-.762.495c-.715.319-1.75.533-2.933.533s-2.218-.214-2.933-.533c-.358-.16-.609-.334-.762-.495c-.15-.158-.18-.275-.18-.347zm.433 3.22A5 5 0 0 1 5 10.14v1.236c0 .072.03.189.18.347c.153.16.404.335.762.495c.715.319 1.75.533 2.933.533c1.184 0 2.218-.214 2.933-.533c.358-.16.609-.334.762-.495c.15-.158.18-.275.18-.347V10.14q-.207.119-.433.22c-.91.405-2.126.641-3.442.641s-2.532-.236-3.442-.642\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCoinsStackSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.123 5.583v1.703c0 .968 1.55 1.782 3.627 1.962V6.714l.003-.12C2.6 6.512 1.55 6.267.727 5.9a5 5 0 0 1-.604-.317m9-3.583v1.47c-1.236.041-2.397.28-3.313.688c-.502.223-.986.522-1.362.916q-.129.135-.244.293c-1.187-.044-2.223-.277-2.967-.609c-.416-.185-.714-.39-.899-.585a.8.8 0 0 1-.215-.348V2c0-1.105 2.014-2 4.5-2c2.485 0 4.5.895 4.5 2m-4.5.931c1.735 0 3.142-.404 3.142-.903c0-.5-1.407-.904-3.143-.904s-3.142.405-3.142.904s1.407.903 3.142.903ZM5 12v-1.703q.283.174.605.317c1.025.458 2.4.725 3.895.725c1.494 0 2.87-.267 3.895-.725q.322-.142.605-.317V12c0 1.1-2 2-4.5 2S5 13.1 5 12m.216-3.113A.8.8 0 0 1 5 8.54V6.714c0-1.104 2.015-2 4.5-2s4.5.896 4.5 2V8.54a.8.8 0 0 1-.216.348c-.185.195-.482.4-.898.586c-.83.37-2.025.616-3.386.616s-2.555-.246-3.386-.616c-.416-.186-.713-.39-.898-.586Zm7.426-2.145c0 .5-1.407.904-3.142.904c-1.736 0-3.142-.405-3.142-.904s1.406-.904 3.142-.904s3.142.405 3.142.904\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCollaborationsIdea: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.194 8.094a1.86 1.86 0 1 0 0-3.719a1.86 1.86 0 0 0 0 3.719M.523 13.479A3.7 3.7 0 0 1 1 11.705a3.71 3.71 0 0 1 3.195-1.868c1.31.003 2.55.727 3.195 1.868a3.7 3.7 0 0 1 .477 1.773m2.02-12.095v-.82m2.799 1.827l.671-.471m-6.271.471l-.672-.471m5.506 3.139a2.055 2.055 0 0 0-2.077-2.042a2.055 2.055 0 0 0-1.99 2.127a2.07 2.07 0 0 0 1.126 1.73v1a.227.227 0 0 0 .226.22h1.361a.227.227 0 0 0 .227-.22V6.855a2.07 2.07 0 0 0 1.128-1.797\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCollaborationsIdeaRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.724.625a.625.625 0 1 0-1.25 0v.8a.625.625 0 1 0 1.25 0zm3.157 1.711a.625.625 0 1 0-.884-.883l-.565.565a.625.625 0 1 0 .883.884zm-7.52-.883a.625.625 0 0 1 .883 0l.566.565a.625.625 0 1 1-.884.884l-.566-.566a.625.625 0 0 1 0-.883m3.05 4.749a1.39 1.39 0 0 1-.754-1.198A1.38 1.38 0 0 1 9.07 3.642a1.38 1.38 0 0 1 1.388 1.362c-.007.495-.31.977-.754 1.198a.63.63 0 0 0-.346.56v.582h-.602v-.583a.63.63 0 0 0-.346-.56m-2.004-1.19a2.63 2.63 0 0 1 2.651-2.62a2.63 2.63 0 0 1 2.651 2.62v.005a2.65 2.65 0 0 1-1.1 2.095v.658a.85.85 0 0 1-.846.824h-1.41a.85.85 0 0 1-.845-.824v-.658a2.65 2.65 0 0 1-1.1-2.095zm5.544-.003c0-.345.28-.625.625-.625h.8a.625.625 0 1 1 0 1.25h-.8a.625.625 0 0 1-.625-.625m-7.126-.625a.625.625 0 0 0 0 1.25h.8a.625.625 0 0 0 0-1.25zM4.173 9.36h-.002A4.21 4.21 0 0 0 .54 11.48A4.2 4.2 0 0 0 0 13.495A.5.5 0 0 0 .5 14h7.344a.5.5 0 0 0 .5-.505a4.2 4.2 0 0 0-.542-2.014a4.21 4.21 0 0 0-3.629-2.122m1.378-2.613c.36 0 .693-.108.971-.294A2.36 2.36 0 1 1 3.233 4.09a1.75 1.75 0 0 0 1.498 2.655z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCollaborationsIdeaSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.887 0c.345 0 .625.28.625.625v.82a.625.625 0 1 1-1.25 0v-.82c0-.345.28-.625.625-.625m-5.84 8.738a2.429 2.429 0 1 0 0-4.857a2.429 2.429 0 0 0 0 4.857M0 13.595a4.048 4.048 0 0 1 8.095 0A.405.405 0 0 1 7.69 14H.405A.405.405 0 0 1 0 13.595M13.716 2.493a.625.625 0 1 0-.718-1.023l-.671.471a.625.625 0 0 0 .718 1.023zm-7.813-.87a.625.625 0 0 0 .152.87l.672.471a.625.625 0 1 0 .718-1.023l-.672-.471a.625.625 0 0 0-.87.152ZM9.84 2.84a2.25 2.25 0 0 1 2.272 2.234c-.01.82-.5 1.6-1.234 1.966v1.113a.25.25 0 0 1-.248.242H9.142a.25.25 0 0 1-.248-.242V7.059a2.26 2.26 0 0 1-1.231-1.892A2.25 2.25 0 0 1 9.84 2.84\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorPalette: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 13a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/><path d=\"M9.5 13a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/><path d=\"M7 9a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorPaletteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.74a3.3 3.3 0 0 0-3.252 2.743q.39-.07.8-.07c.903 0 1.745.263 2.452.717a4.53 4.53 0 0 1 3.252-.647A3.3 3.3 0 0 0 7 1.74M7 .49a4.55 4.55 0 0 0-4.547 4.433A4.549 4.549 0 1 0 7 12.793a4.549 4.549 0 1 0 4.547-7.87A4.55 4.55 0 0 0 7 .49M1.25 8.962c0-1.104.542-2.081 1.374-2.68a4.56 4.56 0 0 0 2.281 2.794a4.53 4.53 0 0 0 1.096 2.848A3.3 3.3 0 0 1 1.25 8.962M8 11.924a4.53 4.53 0 0 0 1.095-2.848a4.56 4.56 0 0 0 2.281-2.794A3.299 3.299 0 0 1 8 11.924m-1-5.72a3.74 3.74 0 0 0-1.223 2.342a3.75 3.75 0 0 0 2.446 0A3.74 3.74 0 0 0 7 6.205\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorPaletteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.974 4.063a3.251 3.251 0 0 1 6.053 0A4.8 4.8 0 0 0 7 4.566a4.73 4.73 0 0 0-3.026-.503m-1.691.627a4.75 4.75 0 0 1 9.434 0A4.75 4.75 0 0 1 7 12.934A4.75 4.75 0 0 1 2.283 4.69m7.943.959a3.25 3.25 0 0 0-1.893-.018A4.74 4.74 0 0 1 9.336 7.51a3.24 3.24 0 0 0 .89-1.86m-.759 3.66a4.76 4.76 0 0 0 2.12-2.818a3.25 3.25 0 0 1-3.253 5.378a4.73 4.73 0 0 0 1.133-2.56m-1.491-.958A3.24 3.24 0 0 0 7 6.405a3.24 3.24 0 0 0-.976 1.946a3.25 3.25 0 0 0 1.952 0M6.224 9.937a4.8 4.8 0 0 0 1.552 0A3.25 3.25 0 0 1 7 11.095a3.3 3.3 0 0 1-.776-1.158M4.533 9.31a4.73 4.73 0 0 0 1.134 2.559q-.437.13-.917.131a3.25 3.25 0 0 1-2.336-5.51a4.76 4.76 0 0 0 2.119 2.82m.13-1.8a3.24 3.24 0 0 1-.889-1.861a3.25 3.25 0 0 1 1.893-.018A4.74 4.74 0 0 0 4.664 7.51\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorPicker: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.416 1.584a3.493 3.493 0 0 0-4.96 0L2.902 6.137a2.98 2.98 0 0 0-.526 3.502L.84 11.177a.99.99 0 0 0 0 1.399l.585.585a.99.99 0 0 0 1.399 0l1.537-1.537a2.98 2.98 0 0 0 3.503-.526l4.553-4.554a3.494 3.494 0 0 0 0-4.96m-7.897-.04l7.936 7.937\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorPickerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.333.314a4.08 4.08 0 0 1 4.462.89a4.076 4.076 0 0 1 0 5.788l-.002.001l-.81.81l1.034 1.033a.875.875 0 1 1-1.238 1.237L10.746 9.04l-2.451 2.452a3.57 3.57 0 0 1-3.766.824l-1.216 1.216l-.001.001a1.605 1.605 0 0 1-2.264 0l-.001-.001l-.579-.579l-.001-.001a1.606 1.606 0 0 1 0-2.264l.001-.001L1.684 9.47a3.57 3.57 0 0 1 .824-3.766l2.452-2.45L3.927 2.22A.875.875 0 0 1 5.164.983l1.033 1.033l.81-.81c.38-.382.83-.685 1.326-.892m-2.49 3.823L3.393 6.59a2.32 2.32 0 0 0-.41 2.727a.625.625 0 0 1-.11.735L1.354 11.57a.356.356 0 0 0 0 .501l.576.577a.356.356 0 0 0 .501 0l1.52-1.519a.625.625 0 0 1 .734-.11a2.32 2.32 0 0 0 2.726-.41l2.453-2.452z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorPickerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.779 1.221c-1.6-1.61-4.27-1.61-5.869.002l-.813.813L5.03.97a.75.75 0 0 0-1.06 1.06l8 8a.75.75 0 1 0 1.06-1.06l-1.066-1.067l.814-.813c1.61-1.598 1.611-4.27 0-5.869M1.582 10.156L.33 11.409a1.13 1.13 0 0 0 0 1.595l.667.667a1.13 1.13 0 0 0 1.595 0l1.253-1.253a3.425 3.425 0 0 0 3.993-.6l2.095-2.095l-5.655-5.655l-2.095 2.095a3.425 3.425 0 0 0-.6 3.993\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorSwatches: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5.5h3a1 1 0 0 1 1 1V11A2.5 2.5 0 0 1 3 13.5v0A2.5 2.5 0 0 1 .5 11V1.5a1 1 0 0 1 1-1\"/><path d=\"M5.5 5L9 1.48a1 1 0 0 1 1.41 0l2.11 2.12a1 1 0 0 1 0 1.41l-7.75 7.76\"/><path d=\"M9 8.5h3.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3m-2.5-9h5m-5 4h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorSwatchesRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.103 1.103.375 2 .375h3c.897 0 1.625.728 1.625 1.625v.99l1.726-1.725a1.625 1.625 0 0 1 2.298 0l2.086 2.086a1.625 1.625 0 0 1 0 2.298l-1.726 1.726H12c.898 0 1.625.728 1.625 1.625v3c0 .898-.727 1.625-1.625 1.625H3.5A3.125 3.125 0 0 1 .375 10.5zm4.94 8.971c-.062.24-.17.46-.314.653l-.006.008a1.875 1.875 0 0 1-3.37-1.132v-2h3.75v2q0 .244-.06.471m.06-6.484V5h-3.75V2c0-.207.168-.375.375-.375h3c.207 0 .375.168.375.375zm1.25 5.504l5.226-5.226a.375.375 0 0 0 0-.53L9.765 2.149a.375.375 0 0 0-.53 0l-2.61 2.61z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineColorSwatchesSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0h3A1.5 1.5 0 0 1 6 1.5v1.875H0V1.5A1.5 1.5 0 0 1 1.5 0M0 4.625v3.25h6v-3.25zM0 11V9.125h6V11a3 3 0 0 1-6 0m7.25-.007l5.089-5.09a1.5 1.5 0 0 0 0-2.12L10.217 1.66a1.5 1.5 0 0 0-2.12 0l-.847.846zM6.01 14h6.49a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 12.5 8h-.49z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5.5L2.025 7.025a3.5 3.5 0 0 0 4.95 4.95L13.5 5.5\"/><path d=\"M3 9.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0m5-2L11.5 4m-5 2L12 .5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCometRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.815.181a.625.625 0 0 1 .004.884L2.094 7.84l-.002.002a2.875 2.875 0 1 0 4.066 4.066l.002-.002l6.775-6.725a.625.625 0 0 1 .88.888l-6.773 6.723A4.125 4.125 0 0 1 1.206 6.96h.001L7.931.184A.625.625 0 0 1 8.815.18M4.25 7.75a2 2 0 1 0 0 4a2 2 0 0 0 0-4M12.317.183a.625.625 0 0 1 0 .884L6.442 6.942a.625.625 0 1 1-.884-.884L11.433.183a.625.625 0 0 1 .884 0m-1 4.884a.625.625 0 1 0-.884-.884L7.058 7.558a.625.625 0 1 0 .884.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCometSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.778.218a.75.75 0 0 1 .004 1.06L6.106 3.975a.377.377 0 1 0 .496.566v.001L10.926.22a.75.75 0 0 1 1.061 1.06L7.698 5.57a.488.488 0 1 0 .647.716l.002.001l3.335-3.336a.75.75 0 0 1 1.061 1.06L9.407 7.348a.41.41 0 0 0 .294.701a.41.41 0 0 0 .313-.144l2.708-2.686a.75.75 0 0 1 1.056 1.064l-3.26 3.235l-.002.003l-3.26 3.235l-.002.001a4.25 4.25 0 0 1-6.01-6.01v-.001l3.236-3.26L7.718.221a.75.75 0 0 1 1.06-.004M6.364 9.75a2.114 2.114 0 1 1-4.228 0a2.114 2.114 0 0 1 4.228 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCommand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.75 10A1.75 1.75 0 1 1 10 11.75v-9.5A1.75 1.75 0 1 1 11.75 4h-9.5A1.75 1.75 0 1 1 4 2.25v9.5A1.75 1.75 0 1 1 2.25 10z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCommandRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M11.385 9.77a1.615 1.615 0 1 1-1.616 1.615v-8.77a1.615 1.615 0 1 1 1.616 1.616h-8.77a1.615 1.615 0 1 1 1.616-1.616v8.77a1.616 1.616 0 1 1-1.616-1.616z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCommandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.332 2.107a.908.908 0 1 0-.348 1.746h.908v-.907a.91.91 0 0 0-.56-.839m2.56 1.746v-.907a2.908 2.908 0 1 0-2.907 2.907h.907v2.255h-.907a2.908 2.908 0 1 0 2.907 2.907v-.907h2.255v.907a2.908 2.908 0 1 0 2.908-2.907h-.908V5.853h.908a2.908 2.908 0 1 0-2.908-2.907v.907zm0 2v2.255h2.255V5.853zm4.255-2h.907a.908.908 0 1 0-.907-.907zm0 6.255v.908a.908.908 0 1 0 .907-.908zm-6.255 0h-.907a.908.908 0 1 0 .907.908z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompassNavigator: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.04 1.605a1.099 1.099 0 0 1 1.355 1.355l-1.902 6.772a1.1 1.1 0 0 1-.76.761L2.96 12.395a1.099 1.099 0 0 1-1.355-1.355l1.902-6.772c.103-.37.392-.658.76-.761z\"/><path d=\"M5.689 5.689a1.854 1.854 0 1 0 2.622 2.622a1.854 1.854 0 1 0-2.622-2.622\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompassNavigatorRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.588 2.232c.24-1.075-.746-2.06-1.82-1.82l-8.283 1.84a1.63 1.63 0 0 0-1.233 1.234l-1.84 8.282c-.24 1.075.745 2.06 1.82 1.82l8.282-1.84a1.63 1.63 0 0 0 1.234-1.234zm-1.55-.6a.27.27 0 0 1 .249.081c.074.075.1.166.081.248l-1.84 8.282a.38.38 0 0 1-.285.285l-8.282 1.84c-.082.019-.174-.006-.248-.08s-.1-.167-.082-.249l1.84-8.282a.38.38 0 0 1 .286-.285zM4.75 7a2.25 2.25 0 1 1 4.5 0a2.25 2.25 0 0 1-4.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompassNavigatorSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.295 1.065a1.209 1.209 0 0 1 1.49 1.49l-2.092 7.45a1.21 1.21 0 0 1-.837.837l-7.45 2.093a1.209 1.209 0 0 1-1.49-1.49l2.092-7.45c.114-.406.431-.723.837-.837zM8.488 5.512a2.104 2.104 0 1 0-2.976 2.976a2.104 2.104 0 0 0 2.976-2.976\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompositionOval: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 11a10.3 10.3 0 0 0 1-4a10.3 10.3 0 0 0-1-4A13.3 13.3 0 0 0 7 2a13.3 13.3 0 0 0-5.5 1a10.3 10.3 0 0 0-1 4a10.3 10.3 0 0 0 1 4A13.3 13.3 0 0 0 7 12a13.3 13.3 0 0 0 5.5-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompositionOvalRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M12.395 11.31c.587-1.35.92-2.816.981-4.31a12 12 0 0 0-.981-4.31A12 12 0 0 0 7 1.612A12 12 0 0 0 1.605 2.69A12 12 0 0 0 .624 7c.06 1.494.394 2.96.98 4.31A12 12 0 0 0 7 12.388a12 12 0 0 0 5.395-1.078\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompositionOvalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.32 2.391A13.8 13.8 0 0 0 7 1.5a13.8 13.8 0 0 0-5.32.891a1.42 1.42 0 0 0-.798.76A10.8 10.8 0 0 0 0 7.022a10.8 10.8 0 0 0 .882 3.827c.153.353.442.625.797.76A13.8 13.8 0 0 0 7 12.5a13.8 13.8 0 0 0 5.32-.891c.356-.135.645-.407.798-.76A10.8 10.8 0 0 0 14 6.978a10.8 10.8 0 0 0-.882-3.827a1.42 1.42 0 0 0-.797-.76\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompositionVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.19 1.19a.52.52 0 0 0 0-.47a.49.49 0 0 0-.41-.22H3.25a.49.49 0 0 0-.492.449a.5.5 0 0 0 .031.241a14.67 14.67 0 0 1 0 11.62a.52.52 0 0 0 .05.47a.49.49 0 0 0 .41.22h7.48a.49.49 0 0 0 .41-.22a.52.52 0 0 0 0-.47a14.67 14.67 0 0 1 .05-11.62\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompositionVerticalRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M1.677 1.957c-.27-.642.248-1.333.998-1.333h8.65c.75 0 1.267.69.998 1.333l-.638 1.522a9.05 9.05 0 0 0 0 7.042l.638 1.522c.27.643-.248 1.333-.998 1.333h-8.65c-.75 0-1.267-.69-.998-1.333l.638-1.522a9.05 9.05 0 0 0 0-7.042z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompositionVerticalSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.827.051c-.044-.002-.084 0-.108 0h-.02l-.031.002H3.362a1.4 1.4 0 0 0-.342.026a1.004 1.004 0 0 0-.657 1.427l.006.013a13.98 13.98 0 0 1-.014 10.995l-.004.009c-.014.033-.047.108-.066.19c-.135.55.229 1.155.845 1.229c.071.008.149.007.178.007h7.319c.05.001.183.004.302-.02a.955.955 0 0 0 .727-1.207a2 2 0 0 0-.091-.23l-.003-.007A13.97 13.97 0 0 1 11.618 1.5c.001-.002.046-.098.066-.154a.96.96 0 0 0-.857-1.295\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompsitionHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.81 11.2a.52.52 0 0 0 .47 0a.49.49 0 0 0 .22-.41V3.26a.49.49 0 0 0-.449-.491a.5.5 0 0 0-.241.031a14.67 14.67 0 0 1-11.62 0a.52.52 0 0 0-.47.05a.49.49 0 0 0-.22.41v7.48a.49.49 0 0 0 .22.41a.52.52 0 0 0 .47 0a14.67 14.67 0 0 1 11.62.05\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompsitionHorizontalRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M1.957 12.323c-.642.27-1.333-.248-1.333-.998v-8.65c0-.75.69-1.267 1.333-.998l1.522.638c2.266.95 4.776.95 7.042 0l1.522-.638c.643-.27 1.333.248 1.333.998v8.65c0 .75-.69 1.267-1.333.998l-1.522-.638a9.05 9.05 0 0 0-7.042 0z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCompsitionHorizontalSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.949 10.799c.002-.044 0-.083 0-.108v-.02l-.002-.03V3.389a1.4 1.4 0 0 0-.026-.34a1.004 1.004 0 0 0-1.166-.74c-.11.022-.218.07-.26.088l-.014.006a14.07 14.07 0 0 1-10.996-.014l-.008-.003c-.033-.014-.108-.047-.19-.067c-.55-.133-1.155.228-1.229.84c-.008.07-.007.147-.007.176V10.6c-.001.05-.004.182.02.3c.115.57.69.87 1.207.722c.086-.025.202-.078.23-.09l.007-.004a14.07 14.07 0 0 1 10.984.056c.002 0 .098.045.154.066c.588.214 1.265-.176 1.296-.851\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerBatteryEmpty1PhoneMobileChargeDeviceElectricityEmptyPowerBattery: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-1V4a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1H11a1 1 0 0 0 1-1V9h1a.5.5 0 0 0 .5-.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerBatteryFull1PhoneMobileChargeDeviceElectricityPowerBatteryFull: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-1V4a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1H11a1 1 0 0 0 1-1V9h1a.5.5 0 0 0 .5-.5Zm-10.25 0v3m3-3v3m3-3v3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerBatteryLow1PhoneMobileChargeDeviceElectricityPowerBatteryLow: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-1V4a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1H11a1 1 0 0 0 1-1V9h1a.5.5 0 0 0 .5-.5Zm-10.25 0v3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerBatteryMedium1PhoneMobileChargeMediumDeviceElectricityPowerBattery: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 5.5A.5.5 0 0 0 13 5h-1V4a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1H11a1 1 0 0 0 1-1V9h1a.5.5 0 0 0 .5-.5Zm-10.25 0v3m3-3v3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M5 3V.5M9 3V.5M3 9H.5M3 5H.5M9 11v2.5M5 11v2.5M11 5h2.5M11 9h2.5m-5-1.5h-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip1ComputerDeviceChipElectronicsCpuMicroprocessor: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8\" height=\"8\" x=\"3\" y=\"3\" rx=\"1\"/><path d=\"M5 3V.5M9 3V.5M3 9H.5M3 5H.5M9 11v2.5M5 11v2.5M11 5h2.5M11 9h2.5m-5-1.5h-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.875.875a.875.875 0 1 0-1.75 0V2h-.5C2.728 2 2 2.728 2 3.625v.5H.875a.875.875 0 1 0 0 1.75H2v2.25H.875a.875.875 0 1 0 0 1.75H2v.5C2 11.273 2.728 12 3.625 12h.5v1.125a.875.875 0 0 0 1.75 0V12h2.25v1.125a.875.875 0 0 0 1.75 0V12h.5c.898 0 1.625-.727 1.625-1.625v-.5h1.125a.875.875 0 0 0 0-1.75H12v-2.25h1.125a.875.875 0 0 0 0-1.75H12v-.5C12 2.728 11.273 2 10.375 2h-.5V.875a.875.875 0 1 0-1.75 0V2h-2.25zM3.25 3.625c0-.207.168-.375.375-.375h6.75c.207 0 .375.168.375.375v6.75a.375.375 0 0 1-.375.375h-6.75a.375.375 0 0 1-.375-.375zM6.75 7.5a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.86.857a.75.75 0 1 0-1.5 0V2.5H4A1.5 1.5 0 0 0 2.5 4v.36H.857a.75.75 0 0 0 0 1.5H2.5v2.28H.857a.75.75 0 1 0 0 1.5H2.5V10A1.5 1.5 0 0 0 4 11.5h.36v1.643a.75.75 0 0 0 1.5 0V11.5h2.28v1.643a.75.75 0 0 0 1.5 0V11.5H10a1.5 1.5 0 0 0 1.5-1.5v-.36h1.643a.75.75 0 0 0 0-1.5H11.5V5.86h1.643a.75.75 0 0 0 0-1.5H11.5V4A1.5 1.5 0 0 0 10 2.5h-.36V.857a.75.75 0 0 0-1.5 0V2.5H5.86zm1.549 7.518a.625.625 0 1 0 0 1.25h2a.625.625 0 0 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10 .5H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-7 3H.5M3 7H.5M3 10.5H.5m13-7H11M13.5 7H11m2.5 3.5H11m-4.5 0h2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip2CoreMicroprocessorDeviceElectronicsChipComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8\" height=\"13\" x=\"3\" y=\".5\" rx=\"1\"/><path d=\"M3 3.5H.5M3 7H.5M3 10.5H.5m13-7H11M13.5 7H11m2.5 3.5H11m-4.5 0h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.933 1.923c0-.165.133-.298.298-.298h5.538c.165 0 .298.133.298.298v10.154a.3.3 0 0 1-.298.298H4.231a.3.3 0 0 1-.298-.298zM4.23.375c-.855 0-1.548.693-1.548 1.548v.971H1a.875.875 0 1 0 0 1.75h1.683v1.481H1a.875.875 0 1 0 0 1.75h1.683v1.48H1a.875.875 0 0 0 0 1.75h1.683v.972c0 .855.693 1.548 1.548 1.548h5.538c.855 0 1.548-.693 1.548-1.548v-.971H13a.875.875 0 1 0 0-1.75h-1.683V7.875H13a.875.875 0 1 0 0-1.75h-1.683v-1.48H13a.875.875 0 1 0 0-1.75h-1.683v-.972c0-.855-.693-1.548-1.548-1.548zm2.307 9.106a.75.75 0 0 0 0 1.5h1.847a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerChip2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 1.5A1.5 1.5 0 0 1 4 0h6a1.5 1.5 0 0 1 1.5 1.5v.835h1.687a.75.75 0 0 1 0 1.5H11.5V6.25h1.687a.75.75 0 0 1 0 1.5H11.5v2.415h1.687a.75.75 0 0 1 0 1.5H11.5v.835A1.5 1.5 0 0 1 10 14H4a1.5 1.5 0 0 1-1.5-1.5v-.835H.813a.75.75 0 0 1 0-1.5H2.5V7.75H.813a.75.75 0 0 1 0-1.5H2.5V3.835H.813a.75.75 0 0 1 0-1.5H2.5zm4.848 9.683a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerConnectionCableSplitCablesCableSplitDeviceComputerElectronicsCordsCordSplitter: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"6.88\" r=\"1.5\"/><path d=\"M5.5 13.38h3m-3-2.5h3m.249-7.754L11.252.623l2 2l-2.502 2.504zM2.75.63l-2 2m2 2l2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerConnectionNetworkNetworkServerInternetEthernet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 10.5v3m-5 0h10\"/><circle cx=\"7\" cy=\"5.5\" r=\"5\"/><path d=\"M2 5.5h10m-5 5c3-3.42 3-6.76 0-10c-2.94 3.12-3 6.44 0 10Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerConnectionSignalLoadingBracketLoadingInternetAngleSignalServerNetworkConnecting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 9.5L.5 7L3 4.5m8 5L13.5 7L11 4.5\"/><circle cx=\"9\" cy=\"7\" r=\".5\"/><circle cx=\"5\" cy=\"7\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerConnectionUsbCableCablesCableDeviceCordComputerElectronicsCordsUsb: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5V11M4.5 4V1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V4m1 0h-7a.5.5 0 0 0-.5.5v2.59a1 1 0 0 0 .29.7L4.5 9v1a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9l1.21-1.21a1 1 0 0 0 .29-.7V4.5a.5.5 0 0 0-.5-.5Zm-4 2.5h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerConnectionUsbPortCablesCableDeviceComputerPortElectronicsCordsCordUsb: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6.97\" cy=\"11.5\" r=\"2\"/><path d=\"M6.97 9.5v-9M5.47 2L6.97.5L8.47 2M6 9.78a4.14 4.14 0 0 1-2.6-2.29\"/><circle cx=\"3.22\" cy=\"6.25\" r=\"1.25\"/><path d=\"M7 8.6a5.6 5.6 0 0 0 3.49-3.07\"/><circle cx=\"10.78\" cy=\"4.32\" r=\"1.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerConnectionWifiWirelessWifiInternetServerNetwork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"10.94\" r=\"1.31\"/><path d=\"M4.53 8a3.49 3.49 0 0 1 5 0M2.36 6.31a6.55 6.55 0 0 1 9.29 0\"/><path d=\"M.5 4.45a9.19 9.19 0 0 1 13 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerController1RemoteQuadcopterDronesFlyingDroneControlControllerTechnologyFly: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"8\" x=\".5\" y=\"5.5\" rx=\"1\"/><path d=\"M7 5.5v-5\"/><circle cx=\"10\" cy=\"9.5\" r=\"1.5\"/><circle cx=\"4\" cy=\"9.5\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDatabaseRaidStorageCodeDiskProgrammingDatabaseArrayHardDisc: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"7\" cy=\"3\" rx=\"6.5\" ry=\"2.5\"/><path d=\"M.5 3v8c0 1.38 2.91 2.5 6.5 2.5s6.5-1.12 6.5-2.5V3\"/><path d=\"M13.5 7c0 1.38-2.91 2.5-6.5 2.5S.5 8.38.5 7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDatabaseServer1ServerNetworkInternet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"6\" x=\".5\" y=\"1\" rx=\"1\"/><circle cx=\"3.5\" cy=\"4\" r=\".5\"/><path d=\"M7.5 4H11M1.5 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1\"/><circle cx=\"3.5\" cy=\"10\" r=\".5\"/><path d=\"M7.5 10H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDatabaseServer2ServerNetworkInternet: Icon = {
  "body": "<rect width=\"13\" height=\"5\" x=\".5\" y=\".5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" rx=\"1\"/><path fill=\"currentColor\" d=\"M3.25 2.25A.75.75 0 1 0 4 3a.76.76 0 0 0-.75-.75Z\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 3h2M1.5 5.5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1\"/><path fill=\"currentColor\" d=\"M3.25 7.25A.75.75 0 1 0 4 8a.76.76 0 0 0-.75-.75Z\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 8h2m-1 2.5v3m-5 0h10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDatabaseServer3ServerNetworkInternet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"6\" x=\".5\" y=\"3\" rx=\"1\"/><circle cx=\"3.5\" cy=\"6\" r=\".5\"/><path d=\"M6.5 6h2M7 9v4.5m-5 0h10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopAddDesktopDeviceDisplayAddPlusComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2\" rx=\".5\"/><path d=\"m6 11l-1 2.5M8 11l1 2.5m-5 0h6m-.5-7h-5M7 4v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopBlockDesktopDeviceDisplayDisablePermissionComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 2H13a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h1.5M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><circle cx=\"7\" cy=\"5\" r=\"3\"/><path d=\"m4.88 7.12l4.24-4.24\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopCheckSuccessApproveDeviceDisplayDesktopComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2\" rx=\".5\"/><path d=\"m6 11l-1 2.5M8 11l1 2.5m-5 0h6M4.5 7l2 1.5l3.5-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopDeleteDeviceRemoveDisplayComputerDenyDesktopFailFailure: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2\" rx=\".5\"/><path d=\"m6 11l-1 2.5M8 11l1 2.5m-5 0h6m-1-5l-4-4m4 0l-4 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopFavoriteHeartDeviceDisplayComputerFavoriteLikeHeartDesktop: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m6 11l-1 2.5M8 11l1 2.5m-5 0h6M13 2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2\"/><path d=\"M7 4c1.17-2.59 3.5-1.29 3.5.65C10.5 7.2 7 8.5 7 8.5S3.5 7.2 3.5 4.6C3.5 2.66 5.83 1.36 7 4Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopFavoriteStarComputerDesktopDeviceDisplayLikeFavoriteStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 2H13a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h1.5M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"M6.45 2.36a.59.59 0 0 1 1.1 0L8.19 4H9.9a.61.61 0 0 1 .56.39a.59.59 0 0 1-.16.61L8.79 6.34l.64 1.28a.58.58 0 0 1-.12.69a.59.59 0 0 1-.7.1L7 7.53l-1.61.88a.59.59 0 0 1-.7-.1a.58.58 0 0 1-.12-.69l.64-1.28L3.7 5a.59.59 0 0 1-.16-.65A.61.61 0 0 1 4.1 4h1.71Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopHelpDeviceHelpInformationDisplayComputerDesktopQuestionInfo: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 2h1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h1m4 9l-1 2.5M8 11l1 2.5m-5 0h6\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 2.5a2 2 0 1 1 2 2v1\"/><path fill=\"currentColor\" d=\"M7 7.5a.75.75 0 1 0 .75.75A.75.75 0 0 0 7 7.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopLockDeviceSecureDisplayComputerLockDesktopPadlockSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 2H13a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h2.5M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"M5 5.5h4v3H5zm.5 0v-1a1.5 1.5 0 0 1 3 0v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopRemoveDesktopDeviceSubtractDisplayMinusComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2\" rx=\".5\"/><path d=\"m6 11l-1 2.5M8 11l1 2.5m-5 0h6m-.5-7h-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopScreenDeviceDisplayComputerDesktopElectronicsMonitorKeyboard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"8\" x=\"1.5\" y=\".5\" rx=\"1\"/><path d=\"M12.28 11.05a1 1 0 0 0-.9-.55H2.62a1 1 0 0 0-.9.55l-.5 1a1 1 0 0 0 .05 1a1 1 0 0 0 .85.47h9.76a1 1 0 0 0 .85-.47a1 1 0 0 0 0-1ZM1.5 6h11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopSettingSettingsDesktopDisplayDeviceGearCogComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 2h1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h1m4 9l-1 2.5M8 11l1 2.5m-5 0h6M7.03 2v1.5M4 3.75l1.3.75M4 7.25l1.3-.75M7.03 9V7.5m3.03-.25l-1.3-.75m1.3-2.75l-1.3.75\"/><circle cx=\"7.03\" cy=\"5.5\" r=\"2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerDesktopWarningAlertDesktopDisplayDeviceWarningNotificationComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 2H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-8A.5.5 0 0 0 13 2h-2.5M6 11l-1 2.5M8 11l1 2.5m-5 0h6m-3-12V5\"/><circle cx=\"7\" cy=\"8\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerHandHeldTabletKindleDeviceElectronicsIpadComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"13\" x=\"1.5\" y=\".5\" rx=\"1\"/><path d=\"M1.5 10.5h11M4.5 3h5m-5 2.5h5M4.5 8h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardAltWindowsKeyboardKeyAltPc: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 2.5v-1a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v1m0 9v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-.75M10.5 5h3M12 5v4M6.5 5v4h2m-5 0V6.5a1.5 1.5 0 0 0-3 0V9m0-1.5h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardAsterisk2AsteriskStarKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7H.5m10-5.5l-7 11m0-11l7 11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardCommandKeyboardMacCommandApple: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.75 10A1.75 1.75 0 1 1 10 11.75v-9.5A1.75 1.75 0 1 1 11.75 4h-9.5A1.75 1.75 0 1 1 4 2.25v9.5A1.75 1.75 0 1 1 2.25 10Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardComputerKeyboardDeviceElectronicsDvorakQwerty: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"8\" x=\".5\" y=\"5.5\" rx=\"1\"/><path d=\"M3.5 10.75h7m-7-2.5h7m-7-2.75v-1a2 2 0 0 1 2-2h4a2 2 0 0 0 2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardDeleteDeleteBackspaceKeyboard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M10.5 9h-5l-2-2l2-2h5v4z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardEjectEjectKeyboardUnmountDismountRemove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M3.5 10h7m-7-2.5h7L7 3.5l-3.5 4z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardOptionKeyboardOptionMacApple: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M3.5 6h2L8 9h2.5m-2-3h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardPowerOffPowerKeyboardButtonOnOff: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M5.5 3.5h-2v2m0-2L7 7m1.57-3.13a3.5 3.5 0 1 1-4.7 4.7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardPrevious1PreviousKeyboardArrowLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7h-10M7 3.5L3.5 7L7 10.5m-6.5-7v7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardPrevious2PreviousKeyboardArrowLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M8 5L6 7l2 2M6 7h4.5m-7-2.5v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardReturn1KeyboardArrowReturnEnter: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.5h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-4\"/><path d=\"m3.5 7.5l-3 3l3 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardReturn2KeyboardArrowReturnEnter: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 9.5h9a4 4 0 0 0 0-8h-3\"/><path d=\"m3.5 6.5l-3 3l3 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardReturn3EnterReturnKeyboard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"m5.5 10.5l-2-2l2-2\"/><path d=\"M3.5 8.5h5a1 1 0 0 0 1-1v-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardShiftKeyboardKeyShiftUpArrow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M8.5 10.5v-3h2L7 3.5l-3.5 4h2v3h3z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardWirelessRemoteDeviceComputerWirelessElectronicsQwertyKeyboardBluetooth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"8\" x=\".5\" y=\"3\" rx=\"1\"/><path d=\"M3.5 8.25h7m-7-2.5h7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLaptopDeviceLaptopElectronicsComputerNotebook: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 8L.72 10.55a1 1 0 0 0 .05 1a1 1 0 0 0 .85.47h10.76a1 1 0 0 0 .85-.47a1 1 0 0 0 0-1L11.5 8m-8-6a1 1 0 0 0-1 1v5h9V3a1 1 0 0 0-1-1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoAppleOsSystemApple: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.18 7.5a2.49 2.49 0 0 1 1.74-2.37a2.91 2.91 0 0 0-4.22-1a1 1 0 0 1-1 0a3.09 3.09 0 0 0-4.41 1.21a5.13 5.13 0 0 0-.54 3.36a7.25 7.25 0 0 0 1.94 4.21a2.09 2.09 0 0 0 2.7.15h0a1.32 1.32 0 0 1 1.57 0a2.06 2.06 0 0 0 2.66-.06a6.58 6.58 0 0 0 1.7-3a2.48 2.48 0 0 1-2.14-2.5Zm-2-5.5L9.68.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoFacebook1MediaFacebookSocial: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 12.5v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-3V8.76h.71a.61.61 0 0 0 .61-.61v-.77a.61.61 0 0 0-.61-.61h-.67v-.94c0-.84.38-.84.76-.84h.49a.55.55 0 0 0 .43-.18a.58.58 0 0 0 .18-.43v-.74a.62.62 0 0 0-.6-.64H9.65a2.32 2.32 0 0 0-2.39 2.6v1.17h-.64a.61.61 0 0 0-.62.61v.77a.61.61 0 0 0 .62.61h.64v4.74H1.5a1 1 0 0 1-1-1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoFacebook2MediaFacebookSocial: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 4c0-1 .5-1 1-1h.6a.75.75 0 0 0 .76-.76V1.3a.76.76 0 0 0-.77-.76L8.17.52a2.86 2.86 0 0 0-2.95 3.2v1.45h-.79a.76.76 0 0 0-.76.76v.94a.76.76 0 0 0 .76.76h.79V13a.5.5 0 0 0 .5.5h1.81A.5.5 0 0 0 8 13V7.63h.88a.76.76 0 0 0 .76-.76v-.94a.76.76 0 0 0-.76-.76H8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoGoogleMediaGoogleSocial: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.36 5.83H8.87a.51.51 0 0 0-.51.52v1.41a.51.51 0 0 0 .51.51h1.29a2.75 2.75 0 0 1-3 2.79c-2.24 0-3.32-1.9-3.32-4.06S5 2.94 7.16 2.94a4.07 4.07 0 0 1 2.64.86a.49.49 0 0 0 .72-.22l.63-1.44a.51.51 0 0 0-.15-.63a7.07 7.07 0 0 0-3.8-1C3.56.5 1.08 3.33 1.08 7s2.49 6.5 6.08 6.5s5.76-2.56 5.76-6c0-1.1-.44-1.67-1.56-1.67Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoLinkedinNetworkLinkedinProfessional: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.54 1.71a1.33 1.33 0 0 1-1.3 1.34A1.36 1.36 0 0 1 .93 1.71A1.34 1.34 0 0 1 2.24.43a1.33 1.33 0 0 1 1.3 1.28ZM1.07 5.43c0-.77.49-.65 1.17-.65s1.16-.12 1.16.65v7.5c0 .78-.49.62-1.16.62s-1.17.16-1.17-.62Zm4.35 0c0-.43.16-.59.41-.64s1.11 0 1.41 0s.42.49.41.86a2.51 2.51 0 0 1 2.24-1a3 3 0 0 1 3.18 3.13v5.12c0 .78-.48.62-1.16.62s-1.16.16-1.16-.62v-4a1.44 1.44 0 0 0-1.52-1.56a1.45 1.45 0 0 0-1.48 1.59v4c0 .78-.49.62-1.17.62s-1.16.16-1.16-.62Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoPaypalPaymentPaypal: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.62 1.59L3.6.51a.49.49 0 0 0-.6.37L1.64 7.29L.63 12a.49.49 0 0 0 .37.58l1.2.26a.49.49 0 0 0 .58-.38l1-4.68l3.44.74a3.52 3.52 0 0 0 4.26-3.43a3.59 3.59 0 0 0-2.86-3.5ZM7.26 6.25l-3-.65l.55-2.6l3 .65a1.32 1.32 0 0 1-.56 2.58Z\"/><path d=\"m5.16 13.5l.62-2.9l3 .63c2.24.49 4.6-1.86 4.63-4.29a3.62 3.62 0 0 0-.2-1.19\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoSkypeVideoMeetingSkype: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m12.87 8.63l-.09-.07A6.1 6.1 0 0 0 13 7a6 6 0 0 0-6-6a6.1 6.1 0 0 0-1.55.21l-.07-.09a2.78 2.78 0 0 0-3.89.35a2.78 2.78 0 0 0-.35 3.89l.08.06A5.91 5.91 0 0 0 1 7a6 6 0 0 0 6 6a5.91 5.91 0 0 0 1.58-.22l.06.08a2.78 2.78 0 0 0 3.89-.35a2.78 2.78 0 0 0 .34-3.88Z\"/><path fill=\"currentColor\" d=\"M7.15 4.07c.42 0 1.45.15 1.45.74a.51.51 0 0 1-.49.54c-.31 0-.54-.22-1-.22s-.6.17-.6.48C6.52 6.38 9 5.89 9 7.8a1.76 1.76 0 0 1-1.9 1.71c-.57 0-1.79-.13-1.79-.83a.49.49 0 0 1 .49-.52c.35 0 .76.29 1.25.29a.66.66 0 0 0 .75-.64c0-.87-2.47-.35-2.47-2.06a1.71 1.71 0 0 1 1.82-1.68m0-1a2.7 2.7 0 0 0-2.83 2.68A2.09 2.09 0 0 0 5 7.38a1.52 1.52 0 0 0-.7 1.3c0 1.13 1.07 1.83 2.79 1.83A2.75 2.75 0 0 0 10 7.8a2.33 2.33 0 0 0-.83-1.88a1.59 1.59 0 0 0 .43-1.11c0-1.2-1.27-1.74-2.45-1.74Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoWindows1OsSystemMicrosoft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.94 2l12-1.38a.49.49 0 0 1 .56.49v11.82a.5.5 0 0 1-.58.49l-12-1.84a.51.51 0 0 1-.42-.5V2.46A.5.5 0 0 1 .94 2ZM6 1.38v10.98m7.5-5.6H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoWindows2OsSystemMicrosoft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 5.82h6.5v-4.5a.49.49 0 0 0-.56-.49L7 1.54Zm-2 0V1.71l-4.06.5a.5.5 0 0 0-.44.5v3.11Zm0 2H.5v3a.51.51 0 0 0 .42.5L5 12Zm2 0v4.4l5.92.95a.5.5 0 0 0 .58-.49V7.82Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoYoutubeYoutubeClipSocialVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"10\" x=\".5\" y=\"2\" rx=\"2\"/><path d=\"M5.31 9.32v-4.2a.39.39 0 0 1 .6-.34l3.6 2.1a.4.4 0 0 1 0 .69l-3.6 2.1a.4.4 0 0 1-.6-.35Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerMonitorScreenDesktopMonitorDeviceElectronicsDisplayComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 5.5h1.5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9\"/><rect width=\"8\" height=\"6\" x=\".5\" y=\"5.5\" rx=\"1\"/><path d=\"M4.5 11.5v2m-2 0h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerMouseComputerDeviceElectronicsMouse: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"7\" height=\"10.5\" x=\"1\" y=\"3\" rx=\"3.5\"/><path d=\"M1 7h7M4.5 7V2.75A2.25 2.25 0 0 1 6.75.5h0A2.25 2.25 0 0 1 9 2.75V3a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerMouseWirelessRemoteWirelessDeviceElectronicsMouseComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"9\" height=\"13\" x=\"2.5\" y=\".5\" rx=\"4.5\"/><path d=\"M7 3.5V5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerPcDesktop: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 6.5v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1m2.5 7h3m-1.5 0v-2\"/><path d=\"M7.5 3.5V3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H9\"/><path d=\"M11.375 4.875a.125.125 0 1 1 0-.25m0 .25a.125.125 0 1 0 0-.25M10.5 7h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerPcDesktopRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 2a1 1 0 0 0-1 1v.5h.625A2.875 2.875 0 0 1 10.5 6.375H14V3a1 1 0 0 0-1-1zm-.25 11.375q0-.064-.005-.127a2.875 2.875 0 0 0 2.755-2.873v-2.75H14V13a1 1 0 0 1-1 1H8a1 1 0 0 1-.35-.063q.099-.264.1-.562m4.148-8.625h-.023a.75.75 0 1 1 .023 0M1.25 6.375c0-.207.168-.375.375-.375h6c.207 0 .375.168.375.375v4a.375.375 0 0 1-.375.375h-6a.375.375 0 0 1-.375-.375zm4 5.625h2.375c.897 0 1.625-.727 1.625-1.625v-4c0-.897-.728-1.625-1.625-1.625h-6C.728 4.75 0 5.478 0 6.375v4C0 11.273.728 12 1.625 12H4v.75h-.875a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25H5.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerPcDesktopSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 2a1 1 0 0 0-1 1v.469h.5a2.75 2.75 0 0 1 2.75 2.75v.156H14V3a1 1 0 0 0-1-1zm-.109 11.871a2 2 0 0 0 .088-.944a2.75 2.75 0 0 0 2.271-2.708V7.625H14V13a1 1 0 0 1-1 1H8.5a1.5 1.5 0 0 1-.609-.129m4.78-9.683a.766.766 0 1 1-1.53 0a.766.766 0 0 1 1.53 0M0 6.217a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5H5.25v.75H6a.75.75 0 1 1 0 1.5H3a.75.75 0 0 1 0-1.5h.75v-.75H1.5a1.5 1.5 0 0 1-1.5-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerPrinterScanDeviceElectronicsPrinterPrintComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 11h2a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1h2\"/><path d=\"M3.5 9.5V13a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9.5Zm7-5V1a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v3.5M11 7h-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerRobotCyborgArtificialRoboticsRobotIntelligenceMachineTechnologyAndroid: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 9.5c0-3-2.46-5-5.5-5s-5.5 2-5.5 5v4h11ZM7 4.5v-4m-5.5 10h11m-7.5 0v3m4-3v3\"/><circle cx=\"5\" cy=\"8\" r=\".5\"/><circle cx=\"9\" cy=\"8\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerScreen1ScreenDeviceElectronicsMonitorDiplayComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2\" rx=\".5\"/><path d=\"m6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerScreen2ScreenDeviceElectronicsMonitorDiplayComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"1.5\" rx=\".5\"/><path d=\"M3.53 13.5a3.51 3.51 0 0 1 6.94 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerScreenCurveScreenCurvedDeviceElectronicsMonitorDiplayComputer: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.93 11.34a42.07 42.07 0 0 0-11.86 0a.5.5 0 0 1-.57-.49V2.49A.49.49 0 0 1 1.07 2a42.83 42.83 0 0 0 11.86 0a.49.49 0 0 1 .57.48v8.36a.5.5 0 0 1-.57.5ZM7 10.92v2.5m-2.5 0h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerScreenTvMoviesTelevisionCathodeCrtTvRayTubeVintageVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"10.5\" x=\".5\" y=\"3\" rx=\"1\"/><rect width=\"8\" height=\"5.5\" x=\"3\" y=\"5.5\" rx=\"1\"/><path d=\"M5 .5L7 3L9 .5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerSmartWatch1DeviceTimepieceCirleComputerElectronicsFaceBlankWatchSmart: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"3.5\"/><path d=\"M9 4.13V1.5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v2.63m4 5.74v2.63a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9.87\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerSmartWatch2DeviceSquareTimepieceComputerElectronicsFaceBlankWatchSmart: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 3.5v-2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v2m4 7v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2\"/><rect width=\"7\" height=\"7\" x=\"3.5\" y=\"3.5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerStorageFloppyDiskDiskFloppyElectronicsDeviceDiscComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 12.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V4.91a1 1 0 0 1 .29-.7L4.21.79a1 1 0 0 1 .7-.29h7.59a1 1 0 0 1 1 1Z\"/><path d=\"M10.5 13.5V9a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v4.5m7-13V4a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerStorageHardDiskDeviceDiscDriveComputerDiskElectronicsPlatterTurntableRaid: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"13\" x=\"1.5\" y=\".5\" rx=\"1\"/><path d=\"m4.5 10.5l1.75-2.75M4.09 7A2.93 2.93 0 0 1 4 5.16a3 3 0 1 1 4.67 3.27M7.5 11H10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerStorageHardDrive1DiskComputerDeviceElectronicsDiscDriveRaid: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"6\" x=\".5\" y=\"7.5\" rx=\"1\"/><path d=\"m.59 8.08l1.74-6.8A1 1 0 0 1 3.3.5h7.4a1 1 0 0 1 1 .78l1.74 6.8M3.5 10.5h3\"/><circle cx=\"10.5\" cy=\"10.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerStorageHardDrive2DiskComputerDeviceElectronicsDiscDriveRaid: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 13.5a3 3 0 0 0 0-6h-7a3 3 0 0 0 0 6Z\"/><path d=\"M.58 9.79L2.17 2.1a2 2 0 0 1 2-1.6h5.7a2 2 0 0 1 2 1.6l1.59 7.69m-9.96.71h3\"/><circle cx=\"10.5\" cy=\"10.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerVirtualRealityGamingVirtualGearControllerRealityGamesHeadsetTechnologyVrEyewear: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6.5H.5v5a1 1 0 0 0 1 1h3a1 1 0 0 0 .78-.38l1.31-1.63a.5.5 0 0 1 .78 0l1.33 1.63a1 1 0 0 0 .78.38h3a1 1 0 0 0 1-1Zm0 0L10.79 2a1 1 0 0 0-.86-.49H4.07a1 1 0 0 0-.86.49L.5 6.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerVoiceMailMicAudioMikeMusicMicrophone: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 6.5a2.5 2.5 0 0 1-5 0V3a2.5 2.5 0 0 1 5 0Z\"/><path d=\"M12 7h0a4.49 4.49 0 0 1-4.5 4.5h-1A4.49 4.49 0 0 1 2 7h0m5 4.5v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerVoiceMailOffMicAudioMikeMusicMicrophoneMuteOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13m-8 8a2.49 2.49 0 0 1-1-2V3a2.5 2.5 0 0 1 5 0v1.5m-.23 3.04A2.5 2.5 0 0 1 8 8.79m-4.42 1.63A4.46 4.46 0 0 1 2 7h0m10 0h0a4.49 4.49 0 0 1-4.5 4.5h-1a5.25 5.25 0 0 1-.56 0m1.06 0v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerWebcamVideoWorkVideoMeetingCameraCompanyConferenceOffice: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.82 3.75L10 5V3.5a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1H9a1 1 0 0 0 1-1V9l2.82 1.25a.5.5 0 0 0 .68-.47V4.22a.5.5 0 0 0-.68-.47Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerWebcamWebcamCameraFutureTechChatSkypeTechnologyVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"6.52\" r=\"6\"/><path d=\"M10.07 11.68a7.4 7.4 0 0 1 2.48 1.8m-11.1 0a7.4 7.4 0 0 1 2.48-1.8\"/><circle cx=\"7\" cy=\"6.52\" r=\"3\"/><circle cx=\"7\" cy=\"6.52\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineConeShape: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.852 13.38c3.041 0 5.507-1.01 5.507-2.256S9.893 8.868 6.852 8.868s-5.508 1.01-5.508 2.256S3.81 13.38 6.852 13.38\"/><path d=\"M1.418 10.718L6.488.872c.174-.336.555-.336.728 0l5.07 9.85\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineConeShapeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.804 10.621q.015-.098.062-.192L5.933.59l.556.286L5.933.59c.175-.338.507-.59.92-.59c.412 0 .744.253.918.59l5.066 9.843q.046.09.062.186q.08.236.081.502c0 .533-.266.981-.623 1.326c-.354.344-.834.624-1.377.846c-1.088.446-2.548.707-4.128.707s-3.04-.261-4.129-.707c-.542-.222-1.023-.502-1.377-.846c-.357-.345-.623-.793-.623-1.326c0-.176.03-.343.08-.5m9.788-1.819l-3.74-7.266L3.11 8.803c1.036-.357 2.342-.562 3.742-.562s2.704.205 3.74.561\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineConeShapeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.66.643C7.504.339 7.21.12 6.852.12c-.357 0-.651.219-.808.523L1.637 9.199q.357-.21.77-.377c1.168-.48 2.74-.761 4.445-.761c1.704 0 3.276.282 4.445.76q.411.169.767.377zM1.525 11.124c0-.115.054-.284.277-.5c.225-.218.584-.443 1.078-.646c.985-.403 2.389-.667 3.972-.667c1.582 0 2.986.264 3.971.667c.494.203.853.428 1.078.646c.223.216.277.385.277.5s-.054.284-.277.5c-.225.218-.584.443-1.078.646c-.985.403-2.389.667-3.971.667s-2.987-.264-3.972-.667c-.494-.203-.853-.428-1.078-.646c-.223-.216-.277-.385-.277-.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineContactPhonebook2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.422 13.424h-9.33a1.473 1.473 0 1 1 0-2.947h8.348a.98.98 0 0 0 .982-.982V1.638a.98.98 0 0 0-.982-.982H3.092A1.473 1.473 0 0 0 1.62 2.09v9.821m9.82-1.433v2.946\"/><path d=\"M7.524 8.236a1.7 1.7 0 0 0 1.957-.461l.246-.247a.533.533 0 0 0 .096-.732l-.796-.795a.533.533 0 0 0-.732.095a.533.533 0 0 1-.731.095L6.29 4.92a.533.533 0 0 1 .095-.732a.533.533 0 0 0 .096-.732l-.796-.796a.533.533 0 0 0-.732.096L4.708 3a1.71 1.71 0 0 0-.462 1.957a9.55 9.55 0 0 0 3.278 3.278\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineContactPhonebook2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.077 0h8.336a1.606 1.606 0 0 1 1.606 1.606v7.846a1.61 1.61 0 0 1-.98 1.479v1.819h.355a.625.625 0 1 1 0 1.25H3.077A2.096 2.096 0 0 1 .98 11.906V2.04A2.096 2.096 0 0 1 3.078 0M2.23 11.904a.846.846 0 0 0 .847.846h7.711v-1.692H3.077a.855.855 0 0 0-.847.846m0-1.918c.265-.116.552-.178.847-.178h8.336a.366.366 0 0 0 .356-.356V1.606a.366.366 0 0 0-.356-.356H3.077a.847.847 0 0 0-.847.816zm2.334-7.569c.345-.402.97-.476 1.398-.16l.057.049l.796.795l.049.057a1.05 1.05 0 0 1-.185 1.419a.9.9 0 0 0-.24.271l-.012.03c.392.487.633.73 1.158 1.156l.029-.011a.9.9 0 0 0 .271-.24c.34-.424.981-.507 1.419-.185l.057.049l.795.795l.049.057a1.05 1.05 0 0 1-.16 1.398l-.218.218a2.24 2.24 0 0 1-2.518.581l-.063-.031a10.05 10.05 0 0 1-3.449-3.45l-.032-.063a2.25 2.25 0 0 1 .581-2.516z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineContactPhonebook2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.132.063H3.046A2.18 2.18 0 0 0 .869 2.18v9.574a2.177 2.177 0 0 0 2.177 2.175h9.037a.75.75 0 0 0 0-1.5h-.2V10.9a1.7 1.7 0 0 0 .95-1.527v-7.61A1.7 1.7 0 0 0 11.132.062ZM2.567 12.23a.677.677 0 0 1 .479-1.155h7.336v1.354H3.046a.68.68 0 0 1-.48-.199Zm6.01-3.906a1.7 1.7 0 0 1-1.053-.089a9.55 9.55 0 0 1-3.278-3.278A1.71 1.71 0 0 1 4.708 3l.246-.246a.533.533 0 0 1 .732-.096l.796.796a.533.533 0 0 1-.096.732a.533.533 0 0 0-.095.732L7.563 6.19a.533.533 0 0 0 .732-.095A.533.533 0 0 1 9.027 6l.796.795a.533.533 0 0 1-.096.732l-.246.247a1.7 1.7 0 0 1-.903.55Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineContainer: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.75 11.5v-9H1.25v9zm.75-9H.5m13 9H.5M4 5v4m3-4v4m3-4v4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineContainerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 1.5a.625.625 0 1 0 0 1.25H.75v8.5H.625a.625.625 0 1 0 0 1.25h12.75a.625.625 0 1 0 0-1.25h-.125v-8.5h.125a.625.625 0 1 0 0-1.25zM12 2.75v8.5H2v-8.5zM4.75 5a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zM7 4.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 7 4.25m3.75.75a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineContainerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 2a.5.5 0 0 0 0 1h.25v8H.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-.25V3h.25a.5.5 0 0 0 0-1zm4.125 3a.625.625 0 1 0-1.25 0v4a.625.625 0 1 0 1.25 0zM7 4.375c.345 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0V5c0-.345.28-.625.625-.625M10.625 5a.625.625 0 1 0-1.25 0v4a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineController: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.4 7v2.31m1.156-1.154H3.245m-1.989-.963l-.412 3.71a2.283 2.283 0 0 0 4.311 1.272l.36-.718h2.97l.36.718a2.283 2.283 0 0 0 4.31-1.273l-.411-3.71a3 3 0 0 0-2.982-2.668H4.238a3 3 0 0 0-2.982 2.669\"/><path d=\"M7 4.524v-.98a1 1 0 0 1 1-1h1.466a1 1 0 0 0 1-1V.562m0 6.933a.248.248 0 0 1 0-.495m0 .495a.248.248 0 1 0 0-.495M8.733 8.733a.248.248 0 0 1 .495 0m-.495 0a.248.248 0 0 0 .495 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineController1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\"><path stroke-linecap=\"round\" d=\"M4.4 5.02v2.31m1.156-1.155H3.245\"/><path d=\"m1.256 5.212l-.412 3.71a2.283 2.283 0 0 0 4.311 1.273l.36-.72h2.97l.36.72a2.283 2.283 0 0 0 4.31-1.273l-.411-3.71a3 3 0 0 0-2.982-2.669H4.238a3 3 0 0 0-2.982 2.669Z\"/><path stroke-linecap=\"round\" d=\"M10.466 5.514a.248.248 0 0 1 0-.495m0 .495a.248.248 0 1 0 0-.495M8.733 6.752a.248.248 0 0 1 .495 0m-.495 0a.248.248 0 1 0 .495 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineController1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.71 5.045A2.393 2.393 0 0 1 4.1 2.918h5.8c1.235 0 2.262.923 2.39 2.127l.45 4.243a1.633 1.633 0 0 1-1.636 1.794a1.65 1.65 0 0 1-1.506-.968l-.4-.894a.63.63 0 0 0-.57-.37H5.372a.63.63 0 0 0-.57.37l-.401.894a1.65 1.65 0 0 1-1.505.968a1.633 1.633 0 0 1-1.638-1.794zM4.1 1.668C2.236 1.668.663 3.064.467 4.913l-.45 4.243c-.182 1.704 1.166 3.176 2.88 3.176c1.141 0 2.18-.667 2.646-1.707l.235-.524h2.444l.236.524a2.9 2.9 0 0 0 2.646 1.707c1.713 0 3.06-1.473 2.88-3.176l-.45-4.243c-.197-1.85-1.77-3.245-3.634-3.245zm.3 2.601c.346 0 .625.28.625.625v.53h.53a.625.625 0 0 1 0 1.25h-.53v.531a.625.625 0 1 1-1.25 0v-.53h-.53a.625.625 0 1 1 0-1.25h.53v-.53c0-.346.28-.626.626-.626m5.194.873a.873.873 0 1 0 1.745 0a.873.873 0 0 0-1.745 0M8.109 6.898v-.02a.873.873 0 1 1 0 .02\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineController1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.203 5.169L.784 8.94a2.305 2.305 0 0 0 4.353 1.286L5.5 9.5h3l.363.726a2.305 2.305 0 0 0 4.353-1.286l-.42-3.771A3 3 0 0 0 9.816 2.5h-5.63a3 3 0 0 0-2.982 2.669m3.172-.794c.345 0 .625.28.625.625v.542h.542a.625.625 0 1 1 0 1.25H5v.541a.625.625 0 1 1-1.25 0v-.541h-.542a.625.625 0 1 1 0-1.25h.542V5c0-.345.28-.625.625-.625m4.89 3.042a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25m1.876-2.175a.625.625 0 1 1-1.25 0a.625.625 0 0 1 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineControllerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.091.75a.625.625 0 1 0-1.25 0v1.012a.375.375 0 0 1-.375.375H8c-.898 0-1.625.728-1.625 1.625v.637H4.488C2.6 4.399.977 5.756.753 7.604l-.358 2.963c-.2 1.658 1.15 3.058 2.816 3.058c1.067 0 2.057-.581 2.54-1.524l.184-.36h2.13l.184.36c.483.943 1.473 1.524 2.54 1.524c1.666 0 3.017-1.4 2.817-3.058l-.359-2.963C13.024 5.756 11.4 4.4 9.512 4.4H7.625v-.637c0-.207.168-.375.375-.375h1.466c.898 0 1.625-.728 1.625-1.625zM4.488 5.649c-1.298 0-2.351.927-2.494 2.105l-.358 2.963c-.103.854.597 1.658 1.575 1.658c.619 0 1.168-.337 1.428-.844l.358-.7a.63.63 0 0 1 .556-.34h2.894c.235 0 .45.132.556.34l.359.7c.26.507.808.844 1.428.844c.977 0 1.678-.804 1.575-1.658l-.359-2.963C11.864 6.576 10.81 5.65 9.512 5.65zM5.15 7A.625.625 0 1 0 3.9 7v.53h-.53a.625.625 0 1 0 0 1.25h.53v.53a.625.625 0 0 0 1.25 0v-.53h.53a.625.625 0 0 0 0-1.25h-.53zm3.944.248a.873.873 0 1 0 1.745 0a.873.873 0 0 0-1.745 0M7.609 9.004v-.02a.873.873 0 1 1 0 .02\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineControllerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.047.991a.75.75 0 0 0-1.5 0v.884a.25.25 0 0 1-.25.25H8a1.75 1.75 0 0 0-1.75 1.75v.884H4.185a3 3 0 0 0-2.982 2.669l-.419 3.771a2.305 2.305 0 0 0 4.353 1.286l.363-.726h3l.363.726a2.305 2.305 0 0 0 4.353-1.286l-.42-3.771a3 3 0 0 0-2.981-2.67H7.75v-.883a.25.25 0 0 1 .25-.25h1.297a1.75 1.75 0 0 0 1.75-1.75zM4.375 6.634c.345 0 .625.28.625.625V7.8h.542a.625.625 0 1 1 0 1.25H5v.541a.625.625 0 0 1-1.25 0V9.05h-.542a.625.625 0 0 1 0-1.25h.542v-.542c0-.345.28-.625.625-.625m4.89 3.042a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25M11.142 7.5a.625.625 0 1 1-1.25 0a.625.625 0 0 1 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineControllerWireless: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.717 9.666h1.652m-.826-.826v1.652m6.77-3.936H3.78v.005a3.11 3.11 0 1 0 2.344 4.933h1.671a3.11 3.11 0 1 0 2.516-4.938m0 0q0 0 0 0\"/><path d=\"M9.367 10.742a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m1.687-1.25a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5M3.196 1.45C3.672 1.135 5.098.5 7 .5s3.328.634 3.804.95M5.098 3.828C5.415 3.67 6.24 3.353 7 3.353s1.585.317 1.902.475\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineControllerWirelessRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.5c-1.46 0-2.521.492-2.8.678A.75.75 0 1 1 3.368.93C3.893.58 5.243 0 7 0c1.756 0 3.107.58 3.632.93A.75.75 0 0 1 9.8 2.178C9.521 1.992 8.46 1.5 7 1.5m0 2.192c-.48 0-1.057.215-1.273.323a.75.75 0 1 1-.671-1.342c.32-.16 1.137-.481 1.944-.481s1.623.32 1.943.48a.75.75 0 0 1-.67 1.343C8.056 3.907 7.48 3.692 7 3.692M5.15 7.375a.625.625 0 1 0-1.25 0v.53h-.53a.625.625 0 1 0 0 1.25h.53v.53a.625.625 0 1 0 1.25 0v-.53h.53a.625.625 0 0 0 0-1.25h-.53zm-3.156.754c.143-1.178 1.196-2.105 2.494-2.105h5.024c1.298 0 2.352.927 2.494 2.105l.358 2.963c.104.854-.597 1.658-1.574 1.658c-.62 0-1.169-.337-1.428-.844l-.359-.7a.63.63 0 0 0-.556-.34H5.553a.63.63 0 0 0-.556.34l-.358.7c-.26.507-.809.844-1.428.844c-.978 0-1.678-.804-1.575-1.658zm2.494-3.355C2.6 4.774.977 6.131.753 7.979l-.358 2.963C.195 12.6 1.545 14 3.21 14c1.067 0 2.057-.581 2.54-1.524l.184-.36h2.13l.184.36c.483.943 1.473 1.524 2.54 1.524c1.666 0 3.017-1.4 2.817-3.058l-.359-2.963c-.223-1.848-1.848-3.205-3.735-3.205zm4.606 2.849a.873.873 0 1 0 1.745 0a.873.873 0 0 0-1.745 0M7.609 9.379v-.02a.873.873 0 1 1 0 .02\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineControllerWirelessSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.02 1.953c-1.754 0-3.036.59-3.388.824A.75.75 0 0 1 2.8 1.53C3.398 1.13 4.97.453 7.02.453s3.62.677 4.219 1.076a.75.75 0 1 1-.832 1.248c-.353-.235-1.634-.824-3.388-.824m0 2.852c-.598 0-1.302.264-1.567.397a.75.75 0 1 1-.671-1.342c.37-.185 1.313-.555 2.237-.555s1.868.37 2.237.555a.75.75 0 0 1-.67 1.342c-.265-.133-.97-.397-1.567-.397M.026 9.938A3.61 3.61 0 0 1 3.762 6.33l.046-.002h6.555a3.61 3.61 0 1 1-2.205 6.468H5.842A3.61 3.61 0 0 1 .027 9.937m9.56 1.555a.765.765 0 1 0 0-1.53a.765.765 0 0 0 0 1.53m2.525-2.646a.765.765 0 1 1-1.53 0a.765.765 0 0 1 1.53 0M1.74 9.921c0-.345.28-.625.625-.625h.448v-.449a.625.625 0 1 1 1.25 0v.449h.448a.625.625 0 1 1 0 1.25h-.448v.448a.625.625 0 1 1-1.25 0v-.448h-.448a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineConvertPdf2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4z\"/><path d=\"M5.3 3.517C4.006 3.9 9.4 10.4 9.975 8.913s-7.085.43-5.823 1.487S6.593 3.133 5.3 3.517\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineConvertPdf2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h6.116l3.009 3.009v8.116a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v10.75A1.625 1.625 0 0 0 2.625 14h8.75A1.625 1.625 0 0 0 13 12.375V4a.63.63 0 0 0-.183-.442L9.442.183A.63.63 0 0 0 9 0zM3.75 10.88c.168.14.393.247.659.238a1 1 0 0 0 .608-.246c.27-.225.46-.578.603-.91q.055-.13.109-.274c.368-.138.79-.269 1.23-.38c.429-.108.853-.192 1.237-.246q.132.105.26.197c.3.215.647.418.99.48c.18.032.411.035.638-.074a.95.95 0 0 0 .474-.527a.96.96 0 0 0 .021-.677a.95.95 0 0 0-.428-.496c-.296-.171-.68-.214-1.007-.221a6 6 0 0 0-.544.017a14 14 0 0 1-1.186-1.249a15 15 0 0 1-.93-1.21c.005-.274 0-.533-.017-.768c-.027-.374-.089-.759-.228-1.055a1.1 1.1 0 0 0-.389-.464a.87.87 0 0 0-.728-.098a.88.88 0 0 0-.557.478c-.098.214-.1.432-.08.597c.038.328.188.69.364 1.027q.159.304.371.637a15.2 15.2 0 0 1-.502 3.1q-.226.105-.419.214c-.283.163-.601.387-.776.688a.94.94 0 0 0-.122.65a.98.98 0 0 0 .35.571m2.903-2.784a14 14 0 0 0-.52.142a17 17 0 0 0 .19-1.08a18 18 0 0 0 .742.84q-.208.047-.412.098M5.726 3.83v-.004zm-.624.167L5.103 4z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineConvertPdf2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h6a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5v-11c0-.398.158-.78.44-1.06m4.636 2.927c.08.338.11.789.108 1.275c.689 1.1 1.816 2.47 2.757 3.33c.435-.03.857-.02 1.19.07c.196.053.465.16.647.407c.215.292.202.628.099.896a.94.94 0 0 1-.632.584c-.274.074-.537.014-.728-.056c-.317-.116-.656-.34-.985-.605a14.3 14.3 0 0 0-3.188.827c-.13.364-.289.704-.485.948c-.122.152-.316.34-.597.409a.92.92 0 0 1-.819-.207c-.205-.172-.379-.44-.353-.785c.022-.303.19-.53.328-.673c.223-.231.551-.433.905-.607c.331-1.182.568-2.904.606-4.2c-.222-.385-.405-.76-.5-1.088a1.55 1.55 0 0 1-.065-.625a.87.87 0 0 1 .475-.684a.8.8 0 0 1 .513-.072a.8.8 0 0 1 .438.252c.17.186.245.43.286.604m-.018 3.267c.418.542.877 1.082 1.332 1.562a17 17 0 0 0-1.648.43c.133-.631.24-1.32.316-1.992\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCopyPaste: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5 3.5v-1a1 1 0 0 0-1-1h-1m-2.5 9H1.5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h1m10 4h-5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M6.75.5h-4.5l.41 1.62a.49.49 0 0 0 .48.38h2.72a.49.49 0 0 0 .48-.38zm1.75 8h3m-3 2h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCopyPasteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2.125h.511A1.5 1.5 0 0 0 3.5 3h2a1.5 1.5 0 0 0 1.364-.875h.511c.207 0 .375.168.375.375v.875a.625.625 0 1 0 1.25 0V2.5C9 1.603 8.272.875 7.375.875h-.511A1.5 1.5 0 0 0 5.5 0h-2a1.5 1.5 0 0 0-1.364.875h-.511C.728.875 0 1.603 0 2.5v6.875C0 10.273.728 11 1.625 11h2.75a.625.625 0 1 0 0-1.25h-2.75a.375.375 0 0 1-.375-.375V2.5c0-.207.168-.375.375-.375M6 6.5A1.5 1.5 0 0 1 7.5 5h5A1.5 1.5 0 0 1 14 6.5v6a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 6 12.5zm2.5.875a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25zM7.875 11c0-.345.28-.625.625-.625h3a.625.625 0 1 1 0 1.25h-3A.625.625 0 0 1 7.875 11\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCopyPasteSolid: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M1.424.27A.75.75 0 0 1 2 0h5a.75.75 0 0 1 .738.884l-.024.131A1.5 1.5 0 0 1 9 2.5v.75H7.25a3 3 0 0 0-3 3V11H1.5A1.5 1.5 0 0 1 0 9.5v-7a1.5 1.5 0 0 1 1.286-1.485l-.024-.13a.75.75 0 0 1 .162-.616M2.9 1.5l.115.634a.75.75 0 0 0 .738.616h1.496a.75.75 0 0 0 .738-.616l.115-.634z\"/><path d=\"M7.25 4.5A1.75 1.75 0 0 0 5.5 6.25v6c0 .967.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 14 12.25v-6a1.75 1.75 0 0 0-1.75-1.75zM7.875 8c0-.345.28-.625.625-.625H11a.625.625 0 1 1 0 1.25H8.5A.625.625 0 0 1 7.875 8M8.5 9.875a.625.625 0 1 0 0 1.25H11a.625.625 0 1 0 0-1.25z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreativeCommons: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0\"/><path d=\"M6.046 5.6a1.05 1.05 0 0 0-.99-.7h-.7c-.58 0-1.05.47-1.05 1.05v2.1c0 .58.47 1.05 1.05 1.05h.7c.457 0 .846-.292.99-.7m4.648-2.8a1.05 1.05 0 0 0-.99-.7h-.7c-.58 0-1.05.47-1.05 1.05v2.1c0 .58.47 1.05 1.05 1.05h.7c.457 0 .846-.292.99-.7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreativeCommonsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.75 5.75 0 1 0 0 11.5a5.75 5.75 0 0 0 0-11.5M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m4.231-1.475a.425.425 0 0 0-.425.425v2.1c0 .235.19.425.425.425h.7a.425.425 0 0 0 .401-.283a.625.625 0 1 1 1.179.416c-.23.65-.85 1.117-1.58 1.117h-.7c-.925 0-1.675-.75-1.675-1.675v-2.1c0-.925.75-1.675 1.675-1.675h.7c.73 0 1.35.467 1.58 1.117a.625.625 0 1 1-1.179.416a.425.425 0 0 0-.401-.283zm4.473.425c0-.235.19-.425.425-.425h.7c.184 0 .342.117.4.283a.625.625 0 0 0 1.18-.416a1.68 1.68 0 0 0-1.58-1.117h-.7c-.925 0-1.675.75-1.675 1.675v2.1c0 .925.75 1.675 1.675 1.675h.7c.73 0 1.35-.467 1.58-1.117a.625.625 0 0 0-1.18-.416a.425.425 0 0 1-.4.283h-.7a.425.425 0 0 1-.425-.425z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreativeCommonsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M4.244 5.625A.375.375 0 0 0 3.869 6v2c0 .207.168.375.375.375h.667a.375.375 0 0 0 .353-.25a.625.625 0 1 1 1.179.417A1.625 1.625 0 0 1 4.91 9.625h-.667A1.625 1.625 0 0 1 2.619 8V6c0-.897.727-1.625 1.625-1.625h.667c.708 0 1.31.453 1.532 1.083a.625.625 0 1 1-1.179.417a.375.375 0 0 0-.353-.25zM8.77 6c0-.207.168-.375.375-.375h.667c.162 0 .302.103.354.25a.625.625 0 1 0 1.178-.417a1.625 1.625 0 0 0-1.532-1.083h-.667c-.897 0-1.625.728-1.625 1.625v2c0 .897.728 1.625 1.625 1.625h.667c.708 0 1.31-.453 1.532-1.083a.625.625 0 1 0-1.178-.417a.375.375 0 0 1-.354.25h-.667A.375.375 0 0 1 8.771 8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreditCard1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 2.25h-11a1 1 0 0 0-1 1v7.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7.5a1 1 0 0 0-1-1m-12 3.5h13m-4 3.5H11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreditCard1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2.625c-.177 0-.375.16-.375.428V4.25h11.5V3.053c0-.267-.198-.428-.375-.428zm-.375 8.322V6.75h11.5v4.197c0 .267-.198.428-.375.428H1.625c-.177 0-.375-.16-.375-.428M0 3.053c0-.896.698-1.678 1.625-1.678h10.75c.927 0 1.625.782 1.625 1.678v7.894c0 .896-.698 1.678-1.625 1.678H1.625C.698 12.625 0 11.843 0 10.947zM9.5 8.25a.75.75 0 0 0 0 1.5H11a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreditCard1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 1.75A1.5 1.5 0 0 0 0 3.25v.94h14v-.94a1.5 1.5 0 0 0-1.5-1.5zm-1.5 9V5.44h14v5.31a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5m9.5-2.125a.625.625 0 1 0 0 1.25H11a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreditCard2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.75 3h-5.5a.5.5 0 0 0-.5.5v9.375a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5\"/><path d=\"M7 9.438a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5M1.906 4.583h-.834a.5.5 0 0 1-.35-.146a.5.5 0 0 1-.144-.354v-3A.5.5 0 0 1 .723.73a.5.5 0 0 1 .35-.147h11.855a.496.496 0 0 1 .494.5v3c0 .133-.052.26-.145.354a.5.5 0 0 1-.35.146h-.833M7 5.21a.125.125 0 1 1 0-.25m0 .25a.125.125 0 1 0 0-.25m0 6.51a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreditCard2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1.875v7.875c0 .664.565 1.125 1.163 1.125h5.924c.598 0 1.163-.46 1.163-1.125V5H13a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm3.125 12.75V3.625h5.75v9.125zM7 6.438a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5m0-.603a.75.75 0 1 1 0-1.5a.75.75 0 1 1 0 1.5m0 6.26a.75.75 0 0 1 0-1.5a.75.75 0 0 1 0 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCreditCard2Solid: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M.367.378a1 1 0 0 1 .705-.295h11.856a.993.993 0 0 1 .994 1v3a1 1 0 0 1-.29.705a1 1 0 0 1-.704.295H12V3.5a2.25 2.25 0 0 0-2.25-2.25h-5.5A2.25 2.25 0 0 0 2 3.5v1.583h-.928a1 1 0 0 1-.705-.295a1 1 0 0 1-.289-.705v-3a1 1 0 0 1 .29-.705\"/><path d=\"M3.25 3.5a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v9.375a1 1 0 0 1-1 1h-5.5a1 1 0 0 1-1-1zm3 1.333a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m-1 3.354a1.75 1.75 0 1 1 3.5 0a1.75 1.75 0 0 1-3.5 0M7 10.848a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCropSelection: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 3.5h3a1 1 0 0 1 1 1v3\"/><path d=\"M3.5.5v9a1 1 0 0 0 1 1h9m-10-7h-3m10 7v3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCropSelectionRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.25.625a.625.625 0 1 0-1.25 0V3H.625a.625.625 0 1 0 0 1.25H3v5.125A1.625 1.625 0 0 0 4.625 11H9.75v2.375a.625.625 0 1 0 1.25 0V11h2.375a.625.625 0 1 0 0-1.25h-8.75a.375.375 0 0 1-.375-.375zM6.375 3a.625.625 0 1 0 0 1.25h3a.375.375 0 0 1 .375.375v3a.625.625 0 1 0 1.25 0v-3A1.625 1.625 0 0 0 9.375 3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCropSelectionSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1a1 1 0 0 0-2 0v1.5H1a1 1 0 0 0 0 2h1.5V9A2.5 2.5 0 0 0 5 11.5h4.5V13a1 1 0 1 0 2 0v-1.5H13a1 1 0 1 0 0-2H5a.5.5 0 0 1-.5-.5zM6 3.5a1 1 0 0 1 1-1h2A2.5 2.5 0 0 1 11.5 5v2a1 1 0 1 1-2 0V5a.5.5 0 0 0-.5-.5H7a1 1 0 0 1-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCrown: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 4l-3 3L7 2L3.5 7l-3-3v6.5A1.5 1.5 0 0 0 2 12h10a1.5 1.5 0 0 0 1.5-1.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCrownRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M13.376 4.057L10.433 7L7 2.095L3.567 7L.624 4.057v6.376a1.47 1.47 0 0 0 1.471 1.472h9.81a1.47 1.47 0 0 0 1.471-1.472z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCrownSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.41 1.713a.5.5 0 0 0-.82 0L3.432 6.225L.854 3.646A.5.5 0 0 0 0 4v6.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a.5.5 0 0 0-.854-.354l-2.578 2.579z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCrutch: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.147 6.832h3.991m-3.104 0V9.68a1.11 1.11 0 0 0 1.11 1.109v0c.612 0 1.108-.497 1.108-1.11V6.833M4.13 10.792v2.138m-.653.016h1.33M8.553 4.65a1.886 1.886 0 1 0 0-3.771a1.886 1.886 0 0 0 0 3.772\"/><path d=\"M6.667 5.243a3.3 3.3 0 0 1 5.186 2.709v1.414H10.44l-.472 3.772h-2.83l-.393-3.146\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCrutchRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 2.625a1.375 1.375 0 1 1 2.75 0a1.375 1.375 0 0 1-2.75 0m4 0a2.62 2.62 0 0 1-.752 1.84A4 4 0 0 1 8 8v1.375c0 .345-.28.625-.625.625H6.302l-.432 3.453a.625.625 0 0 1-.62.547h-2.5a.625.625 0 0 1-.62-.547L1.698 10H.625A.625.625 0 0 1 0 9.375V8a4 4 0 0 1 2.127-3.535a2.625 2.625 0 1 1 4.498-1.84M8 5.375c0-.345.28-.625.625-.625h4.75a.625.625 0 1 1 0 1.25H13v3a2 2 0 0 1-1.375 1.9v1.85h.25a.625.625 0 1 1 0 1.25h-1.75a.625.625 0 1 1 0-1.25h.25V10.9A2 2 0 0 1 9 9V6h-.375A.625.625 0 0 1 8 5.375m3 4.375a.75.75 0 0 0 .75-.75V6h-1.5v3c0 .414.336.75.75.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCrutchSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.689 2.03a2.03 2.03 0 1 1-4.061 0a2.03 2.03 0 0 1 4.061 0m.482 3.873a3.55 3.55 0 0 1 1.041 2.512V9.44a.5.5 0 0 1-.5.5H10.69l-.453 3.623A.5.5 0 0 1 9.74 14H7.577a.5.5 0 0 1-.496-.438l-.438-3.497V8.777a1.75 1.75 0 0 0-.198-3.142a3.554 3.554 0 0 1 4.726.268M1.175 7.254c0-.345.28-.625.625-.625h3.992a.625.625 0 0 1 0 1.25h-.261v2.223c0 .742-.466 1.376-1.122 1.623v1.019h.052a.625.625 0 1 1 0 1.25h-1.33a.625.625 0 0 1 0-1.25h.028v-1.03a1.735 1.735 0 0 1-1.096-1.612V7.88H1.8a.625.625 0 0 1-.625-.625Zm2.138.625v2.223a.484.484 0 0 0 .968 0V7.88h-.968Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCssThree: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m12 10l-5 3.5L2 10L.5.5h13z\"/><path d=\"M4.5 3.5h5L5.5 6H9v2.5L7 10L5 8.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCssThreeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .375a.625.625 0 0 0-.615.734l1.5 8.5c.026.152.109.29.231.384l4.5 3.5a.625.625 0 0 0 .768 0l4.5-3.5a.63.63 0 0 0 .231-.384l1.5-8.5A.625.625 0 0 0 13 .375zm2.074 8.78l-1.329-7.53h10.51l-1.329 7.53L7 12.207zM4.5 2.5a.75.75 0 0 0 0 1.5h2.385L5.103 5.114A.75.75 0 0 0 5.5 6.5h2.75v1.375L7 8.813L5.45 7.65a.75.75 0 1 0-.9 1.2l2 1.5c.267.2.633.2.9 0l2-1.5a.75.75 0 0 0 .3-.6v-2.5A.75.75 0 0 0 9 5h-.885l1.782-1.114A.75.75 0 0 0 9.5 2.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCssThreeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.12.175A.5.5 0 0 1 .5 0h13a.5.5 0 0 1 .494.578l-1.5 9.5a.5.5 0 0 1-.207.332l-5 3.5a.5.5 0 0 1-.574 0l-5-3.5a.5.5 0 0 1-.207-.332l-1.5-9.5A.5.5 0 0 1 .12.175M4.2 2.463a.625.625 0 1 0 0 1.25h3.42L4.99 5.357a.625.625 0 0 0 .331 1.156h3.295v1.862L7 9.585L5.135 8.188a.625.625 0 0 0-.75 1l2.24 1.68a.625.625 0 0 0 .75 0l2.24-1.68a.63.63 0 0 0 .25-.5v-2.8a.625.625 0 0 0-.625-.624H7.5l2.63-1.645a.625.625 0 0 0-.33-1.155z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCurlyBrackets: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.977 1.125H5.59a1 1 0 0 0-1 1v2.77a2 2 0 0 1-.92 1.684l-.804.515l.803.515a2 2 0 0 1 .921 1.684v2.77a1 1 0 0 0 1 1h.386m2.39-11.938h.386a1 1 0 0 1 1 1v2.77a2 2 0 0 0 .92 1.684l.804.515l-.804.515a2 2 0 0 0-.92 1.684v2.77a1 1 0 0 1-1 1h-.386\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCurlyBracketsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.1 0c-.898 0-1.626.728-1.626 1.625v2.92c0 .559-.338 1.062-.856 1.273l-1.479.603a.625.625 0 0 0 0 1.158l1.48.603c.517.21.855.714.855 1.273v2.92c0 .898.728 1.625 1.625 1.625h.386a.625.625 0 1 0 0-1.25H5.1a.375.375 0 0 1-.375-.375v-2.92a2.625 2.625 0 0 0-1.634-2.43L3.03 7l.06-.024a2.625 2.625 0 0 0 1.634-2.431v-2.92c0-.207.168-.375.375-.375h.386a.625.625 0 0 0 0-1.25zm3.8 0c.898 0 1.626.728 1.626 1.625v2.92c0 .559.338 1.062.856 1.273l1.479.603a.625.625 0 0 1 0 1.158l-1.48.603a1.375 1.375 0 0 0-.855 1.273v2.92c0 .898-.728 1.625-1.625 1.625h-.386a.625.625 0 1 1 0-1.25H8.9a.375.375 0 0 0 .375-.375v-2.92c0-1.067.646-2.028 1.634-2.43L10.97 7l-.06-.024a2.625 2.625 0 0 1-1.634-2.431v-2.92A.375.375 0 0 0 8.9 1.25h-.386a.625.625 0 0 1 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCurlyBracketsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.591.375a1.75 1.75 0 0 0-1.75 1.75v2.77c0 .426-.217.822-.575 1.052l-.804.515a.75.75 0 0 0 0 1.263l.804.515c.358.23.575.627.575 1.053v2.77c0 .966.784 1.75 1.75 1.75h.386a.75.75 0 0 0 0-1.5H5.59a.25.25 0 0 1-.25-.25v-2.77a2.75 2.75 0 0 0-1.099-2.2A2.75 2.75 0 0 0 5.34 4.895v-2.77a.25.25 0 0 1 .25-.25h.386a.75.75 0 1 0 0-1.5zm3.16 0c.967 0 1.75.784 1.75 1.75v2.77c0 .426.218.822.576 1.052l.804.515a.75.75 0 0 1 0 1.263l-.804.515a1.25 1.25 0 0 0-.575 1.053v2.77a1.75 1.75 0 0 1-1.75 1.75h-.386a.75.75 0 0 1 0-1.5h.386a.25.25 0 0 0 .25-.25v-2.77c0-.87.41-1.682 1.098-2.2a2.75 2.75 0 0 1-1.098-2.198v-2.77a.25.25 0 0 0-.25-.25h-.386a.75.75 0 0 1 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCursorClick: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.26 12.535L4.795 5.153a.5.5 0 0 1 .633-.633l7.382 2.463a.5.5 0 0 1-.009.951l-3.245 1.02a.5.5 0 0 0-.328.326L8.21 12.526a.5.5 0 0 1-.952.009m2.105-3.46l3.468 3.467M.852 3.625l1.673.449M1.562 7.65l1.225-1.224M3.788.69l.448 1.672M7.813 1.4L6.588 2.624\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCursorClickRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.908.097A.875.875 0 0 1 4.98.716l.468 1.748a.875.875 0 0 1-1.69.453l-.469-1.748A.875.875 0 0 1 3.908.097m-3.81 3.81A.875.875 0 0 0 .715 4.98l1.748.468a.875.875 0 1 0 .453-1.69l-1.746-.47a.875.875 0 0 0-1.072.62m7.823 8.488L5.68 5.68l6.714 2.24l-2.847.893c-.35.11-.624.384-.734.734zM5.833 4.414a1.122 1.122 0 0 0-1.419 1.419l2.447 7.333c.344 1.032 1.808 1.02 2.134-.019l.78-2.488l3.06 3.06a.625.625 0 1 0 .885-.883l-3.06-3.06l2.487-.781c1.038-.326 1.051-1.79.02-2.134zM2.234 8.897a.875.875 0 1 1-1.099-1.362l1.28-1.033a.875.875 0 1 1 1.099 1.362zm6.663-6.663a.875.875 0 0 0-1.361-1.099l-1.033 1.28a.875.875 0 1 0 1.361 1.099z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCursorClickSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.658.162a.75.75 0 0 1 .918.53l.449 1.673a.75.75 0 1 1-1.45.389L3.129 1.08a.75.75 0 0 1 .53-.919M.072 3.755a.75.75 0 0 0 .53.918l1.673.448a.75.75 0 1 0 .388-1.448L.99 3.224a.75.75 0 0 0-.918.53m4.4 1.965a1 1 0 0 1 1.264-1.265l7.12 2.375c.92.307.908 1.612-.018 1.902l-2.026.637l2.7 2.7a1 1 0 0 1-1.415 1.414l-2.706-2.707l-.642 2.046c-.29.925-1.596.937-1.903.017zM2.066 8.755a.75.75 0 1 1-1.061-1.06L2.231 6.47a.75.75 0 0 1 1.06 1.06zm6.46-6.591a.75.75 0 0 0-1.06-1.061L6.24 2.328a.75.75 0 0 0 1.061 1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCustomerSupport1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 7V4.37A3.93 3.93 0 0 1 7 .5a3.93 3.93 0 0 1 4 3.87V7M1.5 5.5h1A.5.5 0 0 1 3 6v3a.5.5 0 0 1-.5.5h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1m11 4h-1A.5.5 0 0 1 11 9V6a.5.5 0 0 1 .5-.5h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1M9 12.25a2 2 0 0 0 2-2V8m-2 4.25a1.25 1.25 0 0 1-1.25 1.25h-1.5a1.25 1.25 0 0 1 0-2.5h1.5A1.25 1.25 0 0 1 9 12.25\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCustomerSupport1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.125 4.625a2.875 2.875 0 1 1 5.75 0v6c0 .46-.225.866-.572 1.116c-.252-.3-.63-.491-1.053-.491h-2.5a1.375 1.375 0 1 0 0 2.75h2.5c.62 0 1.145-.411 1.316-.976a2.63 2.63 0 0 0 1.559-2.399v-1h1.125c.898 0 1.625-.728 1.625-1.625V6c0-.897-.727-1.625-1.625-1.625h-.632a4.625 4.625 0 0 0-9.236 0H1.75C.853 4.375.125 5.103.125 6v2c0 .897.728 1.625 1.625 1.625H3.5c.345 0 .625-.28.625-.625zM1.375 6c0-.207.168-.375.375-.375h1.125v2.75H1.75A.375.375 0 0 1 1.375 8zm9.75 2.375v-2.75h1.125c.207 0 .375.168.375.375v2a.375.375 0 0 1-.375.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCustomerSupport1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.987 1.5A3.18 3.18 0 0 0 3.75 4.628V9a1 1 0 0 1-1 1H1.5A1.5 1.5 0 0 1 0 8.5v-2A1.5 1.5 0 0 1 1.5 5h.75v-.39A4.68 4.68 0 0 1 7 0a4.68 4.68 0 0 1 4.75 4.61V5h.75A1.5 1.5 0 0 1 14 6.5v2a1.5 1.5 0 0 1-1.5 1.5h-.75v.5a2.75 2.75 0 0 1-2.44 2.733A1.5 1.5 0 0 1 8 14H6.5a1.5 1.5 0 0 1 0-3H8c.542 0 1.017.287 1.28.718a1.25 1.25 0 0 0 .97-1.218V4.627A3.18 3.18 0 0 0 6.987 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCut: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.49 10.5h2m2 0h2M2.19 4.93l5.8 3.33M2.75 5a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5m-.56 4.07L13.5 2.55M2.75 13.5a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCutRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 3.25a1.625 1.625 0 1 1 3.25 0a1.625 1.625 0 0 1-3.25 0M3.25.375a2.875 2.875 0 0 0-.803 5.636l1.7.976L2.444 7.99a2.876 2.876 0 0 0 .806 5.636a2.875 2.875 0 0 0 1.314-5.433l.83-.489l2.785 1.6A.625.625 0 1 0 8.8 8.217L6.633 6.974l6.684-3.935a.625.625 0 0 0-.634-1.078L5.386 6.257l-.802-.46A2.875 2.875 0 0 0 3.25.375m4.49 10a.625.625 0 1 0 0 1.25h1.5a.625.625 0 1 0 0-1.25zm4 0a.625.625 0 0 0 0 1.25h1.5a.625.625 0 1 0 0-1.25zm-10.115.375a1.625 1.625 0 1 1 3.25 0a1.625 1.625 0 0 1-3.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCutSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 0a3 3 0 0 0-1.222 5.74L3.892 7L1.778 8.26a3 3 0 1 0 2.707.133l.873-.52l1.296.771a.75.75 0 1 0 .767-1.288L6.824 7l6.81-4.056a.75.75 0 0 0-.768-1.288L5.358 6.127l-.873-.52A3 3 0 0 0 3 0m-.546 4.398q.257.1.546.102a1.5 1.5 0 1 0-.776-.216q.082.026.16.072zM1.5 11a1.5 1.5 0 0 1 .724-1.284a1 1 0 0 0 .16-.072l.07-.042q.256-.1.546-.102A1.5 1.5 0 1 1 1.5 11m6-1.25a.75.75 0 0 0 0 1.5H9a.75.75 0 0 0 0-1.5zm3.5.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCyborg: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 9.082c0-3-2.46-4.636-5.5-4.636S1.5 6.082 1.5 9.082v3.364a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1zM7 4.446v-1.5m0-.251a1.07 1.07 0 1 0 0-2.14a1.07 1.07 0 0 0 0 2.14\"/><path d=\"M12.5 9.946h-.95a1 1 0 0 0-.834.446l-.3.452a1 1 0 0 1-.833.447H4.416a1 1 0 0 1-.833-.447l-.3-.452a1 1 0 0 0-.833-.446H1.5M4.75 8a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCyborg2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.167 1.854a1.167 1.167 0 1 1-2.334 0a1.167 1.167 0 0 1 2.334 0M7 3.02v2.25m1.75 5.48s-.55.583-1.75.583s-1.75-.583-1.75-.583m-.208-2.208a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m3.916.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/><path d=\"M1.5 11.313v-4a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCyborg2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.333 1.667a1.667 1.667 0 1 1 2.292 1.545v1.121H10.5a2.625 2.625 0 0 1 2.625 2.625v4.417A2.625 2.625 0 0 1 10.5 14h-7a2.625 2.625 0 0 1-2.625-2.625V6.958A2.625 2.625 0 0 1 3.5 4.333h2.875v-1.12a1.67 1.67 0 0 1-1.042-1.546M7 5.583H3.5c-.76 0-1.375.616-1.375 1.375v4.417c0 .76.616 1.375 1.375 1.375h7c.76 0 1.375-.616 1.375-1.375V6.958c0-.76-.616-1.375-1.375-1.375zm-1.216 4.37a.75.75 0 0 0-1.08 1.04l.546-.514l-.545.515l.002.002l.002.003l.006.006l.014.014a2 2 0 0 0 .165.143c.104.081.251.18.442.278c.384.195.937.373 1.664.373s1.28-.178 1.664-.373a2.7 2.7 0 0 0 .567-.383l.04-.038l.014-.014l.006-.006l.002-.003l.002-.001l-.545-.516l.546.515a.75.75 0 0 0-1.08-1.042l-.031.026a1.3 1.3 0 0 1-.2.124c-.19.097-.512.21-.985.21s-.795-.113-.986-.21a1.3 1.3 0 0 1-.23-.15m.258-2.182a1 1 0 1 0-1 1a1 1 0 0 0 1-1m2.916-1a1 1 0 0 1 0 2a1 1 0 1 1 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCyborg2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.333 1.854A1.667 1.667 0 1 1 7.75 3.343v1.47h2.75a2.5 2.5 0 0 1 2.5 2.5v4a2.5 2.5 0 0 1-2.5 2.5h-7a2.5 2.5 0 0 1-2.5-2.5v-4a2.5 2.5 0 0 1 2.5-2.5h2.75v-1.47a1.67 1.67 0 0 1-.917-1.489m3.872 9.325a.625.625 0 0 0-.91-.858c-.225.24-.707.423-1.295.423s-1.07-.184-1.295-.423a.625.625 0 0 0-.91.858c.552.585 1.432.815 2.205.815s1.653-.23 2.205-.815M5.042 9.042a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m4.666-.75a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCyborgRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a1.57 1.57 0 0 0-.625 3.012v.894A6.126 6.126 0 0 0 .875 10v2.375C.875 13.272 1.603 14 2.5 14h9c.898 0 1.625-.728 1.625-1.625V10c0-3.172-2.41-5.78-5.5-6.094v-.894A1.57 1.57 0 0 0 7 0M2.127 9.875a4.875 4.875 0 0 1 9.746 0h-.324a1 1 0 0 0-.832.446l-.3.452a1 1 0 0 1-.834.447H4.416a1 1 0 0 1-.833-.447l-.3-.452a1 1 0 0 0-.833-.446zM4 8.055a1 1 0 1 0 2 0a1 1 0 0 0-2 0m4 0a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineCyborgSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.438 1.608A1.562 1.562 0 1 1 7.75 2.98v1.076c1.304.114 2.498.532 3.42 1.258c1.108.874 1.788 2.17 1.788 3.81v.364H11.52c-.544 0-1.052.273-1.353.726l-.294.441a.38.38 0 0 1-.312.168H4.44a.38.38 0 0 1-.312-.168l-.294-.441a1.63 1.63 0 0 0-1.353-.726H1.042v-.364c0-1.64.68-2.936 1.788-3.81c.922-.726 2.116-1.144 3.42-1.258V2.979a1.56 1.56 0 0 1-.812-1.37Zm-4.396 9.13v1.716a1.5 1.5 0 0 0 1.5 1.5h8.916a1.5 1.5 0 0 0 1.5-1.5v-1.717H11.52a.38.38 0 0 0-.312.168l-.294.441a1.62 1.62 0 0 1-1.353.726H4.44a1.63 1.63 0 0 1-1.353-.726l-.294-.441a.38.38 0 0 0-.312-.168zM4.75 7a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5m3.75.75a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDangerousZoneSign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.89 1.05a1 1 0 0 0-1.78 0l-5.5 11a1 1 0 0 0 .89 1.45h11a1 1 0 0 0 .89-1.45z\"/><path d=\"m6.696 10.969l2.022-2.767H5.281l2.022-2.766\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDangerousZoneSignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.676 2.296a.375.375 0 0 1 .648 0l5.26 9.015a.375.375 0 0 1-.325.564H1.741a.375.375 0 0 1-.324-.564zm1.728-.63a1.625 1.625 0 0 0-2.807 0L.337 10.68a1.625 1.625 0 0 0 1.404 2.444H12.26a1.625 1.625 0 0 0 1.404-2.444zm-.51 4.22a.75.75 0 0 0-1.287-.772l-1.5 2.5A.75.75 0 0 0 5.75 8.75h1.176l-.819 1.364a.75.75 0 0 0 1.286.772l1.5-2.5A.75.75 0 0 0 8.25 7.25H7.075z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDangerousZoneSignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.219.226a1.5 1.5 0 0 1 2.117.596l.002.004l5.5 10.999a1.503 1.503 0 0 1-.606 1.983a1.5 1.5 0 0 1-.73.192H1.5a1.5 1.5 0 0 1-1.335-2.174L5.666.822a1.5 1.5 0 0 1 .553-.596m1.69 5.652a.75.75 0 0 0-1.211-.885L4.676 7.76a.75.75 0 0 0 .605 1.192h1.96l-1.15 1.574a.75.75 0 1 0 1.21.885l2.023-2.766a.75.75 0 0 0-.606-1.193h-1.96z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDarkDislayMode: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M9.46 4.522a2.46 2.46 0 1 0 0 4.919c.25 0 .441.3.258.47a3.996 3.996 0 1 1 0-5.86c.183.17-.008.471-.258.471\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDarkDislayModeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 6.981a2.46 2.46 0 0 1 2.46-2.459c.25 0 .441-.3.258-.47a3.996 3.996 0 1 0 0 5.86c.183-.17-.008-.471-.258-.471A2.46 2.46 0 0 1 7 6.98\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDarkDislayModeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m7-.019a2.46 2.46 0 0 1 2.46-2.459c.25 0 .441-.3.258-.47a3.996 3.996 0 1 0 0 5.86c.183-.17-.008-.471-.258-.471A2.46 2.46 0 0 1 7 6.98\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDashboard3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13 6.5H9a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5m0-6H9a.5.5 0 0 0-.5.5v2.01a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5m-8 0H1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V1A.5.5 0 0 0 5 .5m0 9.99H1a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-2.01a.5.5 0 0 0-.5-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDashboard3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.375 1.375v5.75h3.75v-5.75zM.125 1.25C.125.629.629.125 1.25.125h4c.621 0 1.125.504 1.125 1.125v6c0 .621-.504 1.125-1.125 1.125h-4A1.125 1.125 0 0 1 .125 7.25zM8.75.125c-.621 0-1.125.504-1.125 1.125v2.01c0 .621.504 1.125 1.125 1.125h4c.621 0 1.125-.504 1.125-1.125V1.25c0-.621-.504-1.125-1.125-1.125zm.125 6.75v5.75h3.75v-5.75zm-1.25-.125c0-.621.504-1.125 1.125-1.125h4c.621 0 1.125.504 1.125 1.125v6c0 .621-.504 1.125-1.125 1.125h-4a1.125 1.125 0 0 1-1.125-1.125zM1.25 9.615c-.621 0-1.125.504-1.125 1.125v2.01c0 .621.504 1.125 1.125 1.125h4c.621 0 1.125-.504 1.125-1.125v-2.01c0-.621-.504-1.125-1.125-1.125z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDashboard3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 0a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm7 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2.01a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm0 6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm-8 3.99a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDashboardCircle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.25 6a2.75 2.75 0 1 0 0-5.5a2.75 2.75 0 0 0 0 5.5m7.5 0a2.75 2.75 0 1 0 0-5.5a2.75 2.75 0 0 0 0 5.5m-7.5 7.5a2.75 2.75 0 1 0 0-5.5a2.75 2.75 0 0 0 0 5.5m7.5 0a2.75 2.75 0 1 0 0-5.5a2.75 2.75 0 0 0 0 5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDashboardCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.125 3.25a3.125 3.125 0 1 1 6.25 0a3.125 3.125 0 0 1-6.25 0M10.75.125a3.125 3.125 0 1 0 0 6.25a3.125 3.125 0 0 0 0-6.25M8.875 3.25a1.875 1.875 0 1 1 3.75 0a1.875 1.875 0 0 1-3.75 0m-8.75 7.5a3.125 3.125 0 1 1 6.25 0a3.125 3.125 0 0 1-6.25 0M3.25 8.875a1.875 1.875 0 1 0 0 3.75a1.875 1.875 0 0 0 0-3.75m7.5-1.25a3.125 3.125 0 1 0 0 6.25a3.125 3.125 0 0 0 0-6.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDashboardCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 3a3 3 0 1 1-6 0a3 3 0 0 1 6 0m8 0a3 3 0 1 1-6 0a3 3 0 0 1 6 0M3 14a3 3 0 1 0 0-6a3 3 0 0 0 0 6m11-3a3 3 0 1 1-6 0a3 3 0 0 1 6 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabase: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 5.5c3.59 0 6.5-1.12 6.5-2.5S10.59.5 7 .5S.5 1.62.5 3S3.41 5.5 7 5.5\"/><path d=\"M.5 3v8c0 1.38 2.91 2.5 6.5 2.5s6.5-1.12 6.5-2.5V3\"/><path d=\"M13.5 7c0 1.38-2.91 2.5-6.5 2.5S.5 8.38.5 7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 4.74c3.038 0 5.5-.95 5.5-2.12S9.038.5 6 .5S.5 1.45.5 2.62S2.962 4.74 6 4.74m5.5 2.76V2.62\"/><path d=\"M.5 2.62v6.76c0 1 1.78 1.83 4.19 2.06\"/><path d=\"M11.5 6C11.5 7.17 9 8.12 6 8.12S.5 7.17.5 6m13 3l-4 4.5l-2-1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.125 0c-1.576 0-3.03.245-4.114.663c-.54.208-1.02.47-1.375.795C.281 1.782 0 2.216 0 2.744v6.761c0 .854.705 1.451 1.431 1.824c.774.398 1.822.68 2.995.82a.625.625 0 0 0 .148-1.241c-1.082-.13-1.972-.383-2.572-.69c-.648-.334-.752-.614-.752-.713V7.851c.233.133.49.252.761.356c1.084.418 2.538.663 4.114.663c.886 0 1.73-.077 2.489-.218a.625.625 0 1 0-.228-1.229c-.679.126-1.446.197-2.261.197c-1.462 0-2.757-.23-3.664-.58c-.456-.175-.782-.368-.983-.552c-.2-.183-.228-.306-.228-.363V4.471c.233.133.49.252.761.356c1.084.418 2.538.663 4.114.663s3.03-.245 4.114-.663q.41-.156.761-.356V6a.625.625 0 1 0 1.25 0V2.745c0-.529-.28-.963-.636-1.287S10.779.87 10.239.663C9.155.245 7.7 0 6.125 0m7.594 7.664a.75.75 0 0 1 .117 1.055l-4 5a.75.75 0 0 1-1.036.131l-2-1.5a.75.75 0 1 1 .9-1.2l1.418 1.064l3.546-4.433a.75.75 0 0 1 1.054-.117\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.193 1.969c0-.111.055-.283.294-.507c.24-.224.623-.455 1.148-.662C2.68.388 4.167.12 5.84.12s3.161.269 4.206.681c.525.207.907.438 1.148.662s.294.396.294.507s-.055.283-.294.506c-.241.225-.623.455-1.148.662c-1.045.413-2.532.682-4.206.682c-1.673 0-3.16-.27-4.205-.682C1.11 2.93.728 2.7.487 2.475C.247 2.252.193 2.08.193 1.97Zm11.422 1.76c-.323.22-.7.41-1.11.571c-1.225.484-2.874.769-4.665.769S2.4 4.784 1.176 4.3a5.8 5.8 0 0 1-1.11-.57v2.584c.04.093.118.208.266.343c.248.226.642.458 1.183.666c1.076.414 2.605.683 4.325.683s3.25-.27 4.326-.683c.54-.208.935-.44 1.183-.666a1 1 0 0 0 .266-.343zM.065 9.89V8.006c.3.183.637.343 1 .483c1.253.482 2.942.767 4.775.767s3.522-.285 4.775-.767l.03-.011l-1.733 1.949l-.528-.396a2 2 0 0 0-3.065 2.322C2.374 12.242.066 11.18.066 9.89Zm13.68-.76a.75.75 0 1 0-1.121-.996l-3.542 3.984l-1.448-1.086a.75.75 0 0 0-.9 1.2l2 1.5a.75.75 0 0 0 1.01-.102l4-4.5Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseLock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 4.74c3.038 0 5.5-.95 5.5-2.12S9.038.5 6 .5S.5 1.45.5 2.62S2.962 4.74 6 4.74m5.5-.24V2.62\"/><path d=\"M.5 2.62v6.76c0 1.12 2.24 2 5.08 2.11\"/><path d=\"M6 8.08C3 8.12.5 7.17.5 6M8 9.5h5c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5H8c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5m.5 0v-1c0-1.1.9-2 2-2s2 .9 2 2v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseLockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.614 1.458c.355.324.636.758.636 1.287v2.13a.625.625 0 1 1-1.25 0v-.404c-.233.133-.49.252-.761.356c-1.084.418-2.538.663-4.114.663s-3.03-.245-4.114-.663a5.6 5.6 0 0 1-.761-.356v1.654c0 .057.027.18.228.363c.201.184.527.377.983.553c.907.35 2.202.579 3.664.579q.42 0 .822-.025a.625.625 0 1 1 .075 1.248q-.439.027-.897.027c-1.576 0-3.03-.245-4.114-.663a5.6 5.6 0 0 1-.761-.356v1.654c0 .057.027.18.228.363s.527.377.983.553c.907.35 2.202.579 3.664.579a.625.625 0 1 1 0 1.25c-1.576 0-3.03-.245-4.114-.663c-.54-.208-1.02-.47-1.375-.795C.28 10.468 0 10.034 0 9.505V2.744c0-.528.28-.962.636-1.286S1.471.87 2.011.663C3.095.245 4.55 0 6.125 0s3.03.245 4.114.663c.54.208 1.02.47 1.375.795M8.75 9.53v-.78a2.25 2.25 0 0 1 4.5 0v.782a1 1 0 0 1 .75.968V13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.5a1 1 0 0 1 .75-.968M12 9.5h-2v-.75a1 1 0 1 1 2 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseLockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.127 1.85c0-.111.055-.283.294-.506c.241-.225.623-.456 1.148-.663C2.614.27 4.1 0 5.775 0c1.673 0 3.16.269 4.205.681c.525.207.907.438 1.148.663c.24.223.294.395.294.506s-.055.283-.294.506c-.24.225-.623.456-1.148.663c-1.045.412-2.532.68-4.205.68s-3.161-.268-4.206-.68C1.044 2.812.662 2.58.42 2.356C.18 2.133.126 1.961.126 1.85M11.55 3.61a5.8 5.8 0 0 1-1.11.57c-1.225.484-2.874.769-4.664.769s-3.44-.285-4.665-.769A5.8 5.8 0 0 1 0 3.611v2.585c.04.093.118.207.266.342c.248.226.643.458 1.183.666c1.076.414 2.605.683 4.326.683q.454 0 .889-.024a4 4 0 0 1 4.885-2.724zM5.775 9.137q.22 0 .439-.005A2.24 2.24 0 0 0 5.75 10.5v1.745C2.572 12.239 0 11.132 0 9.77V7.888c.298.182.636.343 1 .482c1.253.482 2.94.767 4.775.767M10.5 7.75c-.69 0-1.25.56-1.25 1.25v.5h2.5V9c0-.69-.56-1.25-1.25-1.25M7.75 9v.532A1 1 0 0 0 7 10.5V13a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2.5a1 1 0 0 0-.75-.968V9a2.75 2.75 0 1 0-5.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseRefresh: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 4.74c3.038 0 5.5-.95 5.5-2.12S9.038.5 6 .5S.5 1.45.5 2.62S2.962 4.74 6 4.74M11.5 6V2.62\"/><path d=\"M.5 2.62v6.76c0 1.043 1.94 1.877 4.5 2.076\"/><path d=\"M6 8.08C3 8.12.5 7.17.5 6m12.9 5.369l-.841.635l-.636-.84\"/><path d=\"M12.512 11.941q.212-.402.272-.879a2.58 2.58 0 0 0-3.52-2.706M7.045 10.17l.84-.635l.637.84\"/><path d=\"M7.932 9.599a2.58 2.58 0 0 0 3.25 3.585\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseRefreshRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.011.663C3.095.245 4.55 0 6.125 0s3.03.245 4.114.663c.54.208 1.02.47 1.375.795c.356.324.636.758.636 1.287v3.63a.625.625 0 1 1-1.25 0V4.471c-.233.133-.49.252-.761.356c-1.084.418-2.538.663-4.114.663s-3.03-.245-4.114-.663a5.6 5.6 0 0 1-.761-.356v1.654c0 .05.02.15.161.298c.143.15.382.32.73.482c.694.325 1.71.576 2.909.673a.625.625 0 1 1-.1 1.246c-1.298-.104-2.47-.38-3.34-.787a5 5 0 0 1-.36-.186v1.654c0 .098.106.38.757.714c.601.31 1.491.563 2.567.691a.625.625 0 0 1-.148 1.242c-1.169-.14-2.216-.422-2.991-.821C.71 10.958 0 10.36 0 9.505V2.744c0-.528.28-.962.636-1.286S1.471.87 2.011.663m7.364 7.712c0-.345.28-.625.625-.625c1.726 0 3.125 1.4 3.125 3.125h.375a.5.5 0 0 1 .354.854l-1 1a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .354-.854h.375C11.875 9.839 11.035 9 10 9a.625.625 0 0 1-.625-.625m-.875 2.5h-.375c0 1.036.84 1.875 1.875 1.875A.625.625 0 1 1 10 14a3.125 3.125 0 0 1-3.125-3.125H6.5a.5.5 0 0 1-.354-.854l1-1a.5.5 0 0 1 .708 0l1 1a.5.5 0 0 1-.354.854\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseRefreshSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.127 1.85c0-.111.055-.283.294-.506c.241-.225.623-.456 1.148-.663C2.614.27 4.1 0 5.775 0c1.673 0 3.16.269 4.205.681c.525.207.907.438 1.148.663c.24.223.294.395.294.506s-.055.283-.294.506c-.24.225-.623.456-1.148.663c-1.045.412-2.532.68-4.205.68s-3.161-.268-4.206-.68C1.044 2.812.662 2.58.42 2.356C.18 2.133.126 1.961.126 1.85M11.55 3.61a5.8 5.8 0 0 1-1.11.57c-1.225.484-2.874.769-4.664.769s-3.44-.285-4.665-.769A5.8 5.8 0 0 1 0 3.611v2.585c.04.093.118.207.266.342c.248.226.643.458 1.183.666c1.076.414 2.605.683 4.326.683q.678 0 1.31-.053a1.87 1.87 0 0 1 .984-.156c.056-.208.152-.41.294-.598a1.9 1.9 0 0 1 .962-.655c.543-.17 1.117-.126 1.413-.09q.323.04.628.122a.9.9 0 0 0 .183-.262zM1 8.371c1.181.454 2.75.733 4.461.764a1.875 1.875 0 0 0 .356 2.48q.06.322.166.628l-.208.002C2.585 12.245 0 11.135 0 9.77V7.888c.298.182.636.343 1 .482m12.403 2.377l.058.008a.625.625 0 0 1 .29 1.117l-.84.636a.625.625 0 0 1-.876-.122l-.635-.84a.625.625 0 0 1 .585-.997l.16.023a1.955 1.955 0 0 0-2.187-1.757a.625.625 0 0 1-.697-.543V8.27c-.03-.252.05-.42.192-.53a.62.62 0 0 1 .352-.165a3.2 3.2 0 0 1 .782 0a3.205 3.205 0 0 1 2.816 3.172M7.484 9.043a.625.625 0 0 1 .876.121l.635.841a.625.625 0 0 1-.584.996l-.161-.022a1.955 1.955 0 0 0 2.187 1.757a.625.625 0 1 1 .153 1.24a3.207 3.207 0 0 1-3.599-3.172l-.057-.008a.625.625 0 0 1-.29-1.118z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .375c-1.714 0-3.293.266-4.467.718c-.585.225-1.101.508-1.482.854s-.676.805-.676 1.36v7.385c0 .556.295 1.014.676 1.36c.38.347.897.63 1.482.855c1.174.452 2.753.718 4.467.718s3.293-.266 4.467-.718c.585-.225 1.101-.508 1.482-.854c.38-.347.676-.805.676-1.36V3.307c0-.556-.295-1.014-.676-1.361c-.38-.346-.897-.63-1.482-.854C10.293.64 8.714.375 7 .375M1.625 10.692V8.78c.273.164.58.309.908.435c1.174.451 2.753.718 4.467.718s3.293-.267 4.467-.718a6 6 0 0 0 .908-.435v1.912c0 .082-.04.23-.267.436c-.226.206-.589.42-1.09.613c-.997.383-2.418.634-4.018.634s-3.02-.25-4.018-.634c-.501-.193-.864-.407-1.09-.613s-.267-.354-.267-.436m10.483-3.256c.226-.206.267-.354.267-.436V5.088a6 6 0 0 1-.908.435c-1.174.451-2.753.717-4.467.717s-3.293-.266-4.467-.717a6 6 0 0 1-.908-.435V7c0 .082.04.23.267.436c.226.205.589.42 1.09.612c.997.384 2.418.635 4.018.635s3.02-.251 4.018-.635c.501-.192.864-.407 1.09-.612\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseRemove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 9L9 13.5M9 9l4.5 4.5M6 4.74c3.038 0 5.5-.95 5.5-2.12S9.038.5 6 .5S.5 1.45.5 2.62S2.962 4.74 6 4.74m5.5 2.76V2.62\"/><path d=\"M.5 2.62v6.76c0 1.17 2.44 2.11 5.5 2.12\"/><path d=\"M6 8.12C3 8.12.5 7.17.5 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseRemoveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.011.663C3.095.245 4.55 0 6.125 0s3.03.245 4.114.663c.54.208 1.02.47 1.375.795c.356.324.636.758.636 1.287v3.63a.625.625 0 1 1-1.25 0V4.471c-.233.133-.49.252-.761.356c-1.084.418-2.538.663-4.114.663s-3.03-.245-4.114-.663a5.6 5.6 0 0 1-.761-.356v1.654c0 .057.027.18.228.363c.201.184.527.377.983.553c.907.35 2.202.579 3.664.579a.625.625 0 1 1 0 1.25c-1.576 0-3.03-.245-4.114-.663a5.6 5.6 0 0 1-.761-.356v1.654c0 .057.027.18.228.363s.527.377.983.553c.907.35 2.202.579 3.664.579a.625.625 0 1 1 0 1.25c-1.576 0-3.03-.245-4.114-.663c-.54-.208-1.02-.47-1.375-.795C.28 10.468 0 10.034 0 9.505V2.744c0-.528.28-.962.636-1.286S1.471.87 2.011.663m11.77 8.867a.75.75 0 0 0-1.061-1.06l-1.596 1.595l-1.594-1.59a.75.75 0 1 0-1.06 1.061l1.594 1.59L8.47 12.72a.75.75 0 1 0 1.06 1.06l1.596-1.595l1.594 1.591a.75.75 0 0 0 1.06-1.062l-1.594-1.59z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseRemoveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.257 1.962c0-.111.055-.283.294-.507c.24-.224.623-.455 1.147-.662C2.744.381 4.231.112 5.904.112s3.16.269 4.206.681c.525.207.907.438 1.147.662s.295.396.295.507s-.055.283-.295.506c-.24.225-.622.455-1.147.662c-1.045.413-2.532.682-4.206.682c-1.673 0-3.16-.27-4.206-.682c-.524-.207-.906-.437-1.147-.662c-.24-.223-.294-.395-.294-.506m11.422 1.76c-.323.22-.7.41-1.11.571c-1.225.483-2.874.769-4.665.769s-3.44-.286-4.664-.769a5.8 5.8 0 0 1-1.11-.57v2.584c.04.093.118.208.266.343c.248.226.642.458 1.183.666c1.076.414 2.605.683 4.325.683q.737 0 1.418-.063q.115-.181.274-.34a2 2 0 0 1 2.535-.243l.1-.037c.54-.208.934-.44 1.182-.666a1 1 0 0 0 .266-.343zM5.904 9.25q.57 0 1.116-.036c.045.442.237.873.576 1.211l.706.706l-.706.706q-.207.207-.34.452a13 13 0 0 1-1.352.068C2.715 12.356.13 11.248.13 9.882V7.999c.298.183.636.343 1 .483c1.252.482 2.94.767 4.774.767m5.22-.954l.025-.012l-.019.019zm2.656.185a.75.75 0 0 1 0 1.06l-1.59 1.59l1.59 1.59a.75.75 0 1 1-1.06 1.06l-1.59-1.59l-1.59 1.59a.75.75 0 0 1-1.06-1.06l1.59-1.59l-1.59-1.59a.75.75 0 0 1 1.06-1.06l1.59 1.59l1.59-1.59a.75.75 0 0 1 1.06 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseServer1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 1h-11a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1\"/><path d=\"M3.5 4.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m4-.5H11M1.5 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1\"/><path d=\"M3.5 10.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m4-.5H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseServer1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v4a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 6zm12 4c0 .377-.128.724-.344 1c.216.276.344.623.344 1v4c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12V8c0-.377.128-.724.344-1a1.62 1.62 0 0 1-.344-1V2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625zM2 7.625h10c.207 0 .375.168.375.375v4a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12V8c0-.207.168-.375.375-.375m1.75-4.75a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25M6.75 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 6.75 4m-3 4.875a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25m3.75.375a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseServer1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5.407a1.5 1.5 0 0 0-1.5 1.5v2.925a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V1.907a1.5 1.5 0 0 0-1.5-1.5zM0 9.168a1.5 1.5 0 0 1 1.5-1.5h11a1.5 1.5 0 0 1 1.5 1.5v2.925a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5zM2.046 3.37a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0m0 7.262a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0M6.875 3.37c0-.345.28-.625.625-.625H11a.625.625 0 1 1 0 1.25H7.5a.625.625 0 0 1-.625-.625m.625 6.637a.625.625 0 1 0 0 1.25H11a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseServer2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1M7.5 3H11M1.5 5.5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1\"/><path d=\"M3.25 8.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m0-4.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M7.5 8H11m-4 2.5v3m-5 0h10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseServer2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v2.75a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375zM.719 5.75a1.62 1.62 0 0 1-.344-1V2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v2.75c0 .377-.128.724-.344 1c.222.284.344.636.344 1V9.5A1.625 1.625 0 0 1 12 11.125H7.75v1.125H12a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h4.25v-1.125H2A1.625 1.625 0 0 1 .375 9.5V6.75c0-.364.122-.716.344-1M12 6.375H2a.375.375 0 0 0-.375.375V9.5A.375.375 0 0 0 2 9.875h10a.375.375 0 0 0 .375-.375V6.75A.375.375 0 0 0 12 6.375m-9.375 1.75a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m0-4.75a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m4.25 0c0-.345.28-.625.625-.625h3.25a.625.625 0 1 1 0 1.25H7.5a.625.625 0 0 1-.625-.625M7.5 7.5a.625.625 0 1 0 0 1.25h3.25a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseServer2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5V3a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 3zm0 6A1.5 1.5 0 0 1 1.5 6h11A1.5 1.5 0 0 1 14 7.5V9a1.5 1.5 0 0 1-1.5 1.5H7.75v1.987H12a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h4.25V10.5H1.5A1.5 1.5 0 0 1 0 9zm3.5-5.25a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m4.33-.625a.625.625 0 1 0 0 1.25H11a.625.625 0 1 0 0-1.25zM3.5 8.25a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m3.706 0c0-.345.28-.625.625-.625H11a.625.625 0 1 1 0 1.25H7.83a.625.625 0 0 1-.624-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseSetting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 4.74c3.038 0 5.5-.95 5.5-2.12S9.038.5 6 .5S.5 1.45.5 2.62S2.962 4.74 6 4.74m5.5.26V2.62\"/><path d=\"M.5 2.62v6.76c0 1.071 2.048 1.923 4.71 2.091\"/><path d=\"M.5 6c0 1.086 2.155 1.983 4.865 2.074M10.47 6.5V8m-3.03.25l1.3.75m-1.3 2.75l1.3-.75m1.73 2.5V12m3.03-.25L12.2 11m1.3-2.75L12.2 9m-1.73 3a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseSettingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.125 0c-1.576 0-3.03.245-4.114.663c-.54.208-1.02.47-1.375.795C.281 1.782 0 2.216 0 2.744v6.761c0 .46.214.852.504 1.157c.286.303.673.552 1.107.755c.869.407 2.04.683 3.34.787a.625.625 0 1 0 .099-1.246c-1.2-.097-2.215-.348-2.91-.673c-.347-.163-.586-.331-.729-.483c-.14-.148-.161-.246-.161-.297V7.851q.174.099.36.186c.87.407 2.042.683 3.34.787a.625.625 0 0 0 .1-1.246c-1.2-.097-2.215-.348-2.91-.673c-.347-.163-.586-.331-.729-.482c-.14-.149-.161-.247-.161-.298V4.471c.233.133.49.252.761.356c1.084.418 2.538.663 4.114.663s3.03-.245 4.114-.663q.41-.156.761-.356V5a.625.625 0 1 0 1.25 0V2.745c0-.529-.28-.963-.636-1.287S10.779.87 10.239.663C9.155.245 7.7 0 6.125 0m4.169 6.465h-.002a1 1 0 0 0-.932.642l-.152.39l-.438.25l-.421-.065H8.34a1 1 0 0 0-1.002.49l-.002.003l-.2.35a1 1 0 0 0 .083 1.13l.001.002l.267.33v.491l-.267.33l-.001.003a1 1 0 0 0-.083 1.13l.2.35l.002.002a1 1 0 0 0 1.002.491l.009-.001l.421-.065l.438.25l.152.39a1 1 0 0 0 .932.642h.416a1 1 0 0 0 .932-.641l.152-.392l.438-.249l.422.065l.008.001a1 1 0 0 0 1.002-.491l.002-.003l.2-.35a1 1 0 0 0-.082-1.13l-.002-.002l-.267-.33v-.491l.267-.33l.002-.003a1 1 0 0 0 .082-1.13l-.2-.35l-.002-.002a1 1 0 0 0-1.002-.49h-.008l-.422.065l-.438-.25l-.152-.39a1 1 0 0 0-.932-.642zM10.5 9a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseSettingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.127 1.85c0-.111.055-.283.294-.506c.241-.225.623-.456 1.148-.663C2.614.27 4.1 0 5.775 0c1.673 0 3.16.269 4.205.681c.525.207.907.438 1.148.663c.24.223.294.395.294.506s-.055.283-.294.506c-.24.225-.623.456-1.148.663c-1.045.412-2.532.68-4.205.68s-3.161-.268-4.206-.68C1.044 2.812.662 2.58.42 2.356C.18 2.133.126 1.961.126 1.85M11.55 3.61a5.8 5.8 0 0 1-1.11.57c-1.225.484-2.874.769-4.664.769s-3.44-.285-4.665-.769A5.8 5.8 0 0 1 0 3.611v2.585c.04.093.118.207.266.342c.248.226.643.458 1.183.666c1.07.412 2.59.68 4.3.683a2.004 2.004 0 0 1 2.727-1.299a2 2 0 0 1 3.073-1.455zM5.775 9.137h.034c.133.348.364.661.68.894a2 2 0 0 0-.72 2.214C2.584 12.243 0 11.135 0 9.77V7.888c.298.182.636.343 1 .482c1.253.482 2.94.767 4.775.767m5.438-2.325a.75.75 0 0 0-1.5 0v.74a2.6 2.6 0 0 0-1.02.59l-.641-.37a.75.75 0 1 0-.75 1.3l.64.369a2.6 2.6 0 0 0 0 1.18l-.64.37a.75.75 0 1 0 .75 1.3l.64-.37c.287.268.635.473 1.021.59v.739a.75.75 0 1 0 1.5 0v-.74c.386-.116.734-.32 1.021-.59l.641.37a.75.75 0 0 0 .75-1.299l-.64-.369a2.6 2.6 0 0 0 0-1.181l.64-.37a.75.75 0 0 0-.75-1.299l-.64.37a2.6 2.6 0 0 0-1.022-.59zm-1.69 2.674l-.022.035a1.09 1.09 0 0 0 .04 1.09c.192.305.532.508.919.51h.007a1.088 1.088 0 1 0-.945-1.635\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.552 2.278c0-.155.077-.368.357-.63s.722-.527 1.319-.762C3.418.416 5.105.112 7 .112s3.582.304 4.772.774c.597.235 1.038.5 1.32.762c.28.262.356.475.356.63s-.077.368-.357.63c-.28.261-.722.526-1.319.762c-1.19.47-2.877.774-4.772.774S3.418 4.14 2.228 3.67c-.597-.236-1.038-.5-1.32-.763c-.28-.261-.356-.474-.356-.63m12.96 1.89a6.3 6.3 0 0 1-1.281.665c-1.37.54-3.22.86-5.231.86s-3.861-.32-5.231-.86a6.3 6.3 0 0 1-1.281-.666v3.178c.056.085.135.178.246.279c.29.263.745.53 1.36.766c1.224.471 2.959.776 4.906.776s3.682-.305 4.907-.776c.614-.237 1.069-.503 1.359-.766q.163-.151.246-.28zM.488 11.208V8.993c.341.213.732.4 1.156.564c1.402.539 3.295.859 5.356.859s3.954-.32 5.356-.86a7 7 0 0 0 1.156-.563v2.216C13.512 12.749 10.597 14 7 14S.488 12.75.488 11.209\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseSubtract1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.125 0c-1.576 0-3.03.245-4.114.663c-.54.208-1.02.47-1.375.795C.281 1.782 0 2.216 0 2.744v6.761c0 .49.24.9.56 1.215c.315.312.742.568 1.221.773c.962.412 2.26.676 3.69.741a.625.625 0 0 0 .057-1.249c-1.329-.06-2.469-.304-3.255-.64c-.394-.17-.668-.35-.835-.514c-.164-.162-.188-.271-.188-.326V7.851c.233.133.49.252.761.356c1.084.418 2.538.663 4.114.663s3.03-.245 4.114-.663q.41-.156.761-.356v1.654c0 .07-.044.24-.37.48a.625.625 0 1 0 .74 1.007c.473-.348.88-.845.88-1.487v-6.76c0-.529-.28-.963-.636-1.287S10.779.87 10.239.663C9.155.245 7.7 0 6.125 0M1.478 6.488c-.2-.183-.228-.306-.228-.363V4.471c.233.133.49.252.761.356c1.084.418 2.538.663 4.114.663s3.03-.245 4.114-.663q.41-.156.761-.356v1.654c0 .057-.027.18-.228.363c-.201.184-.527.377-.983.553c-.907.35-2.202.579-3.664.579s-2.757-.23-3.664-.58c-.456-.175-.782-.368-.983-.552M8.25 12.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseSubtract2RaidStorageCodeDiskProgrammingDatabaseArrayHardDiscMinus: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.25 13.5a3.25 3.25 0 1 0 0-6.5a3.25 3.25 0 0 0 0 6.5M9 10.25h2.5M6 4.74c3.038 0 5.5-.95 5.5-2.12S9.038.5 6 .5S.5 1.45.5 2.62S2.962 4.74 6 4.74m5.5-.24V2.62\"/><path d=\"M.5 2.62v6.76c0 .93 1.54 1.71 3.69 2\"/><path d=\"M4.49 8C2.19 7.78.5 7 .5 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDatabaseSubtract2RaidStorageCodeDiskProgrammingDatabaseArrayHardDiscMinusSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.28 1.962c0-.111.054-.283.294-.507S1.197 1 1.721.793C2.767.381 4.253.112 5.927.112s3.16.269 4.206.681c.525.207.907.438 1.147.662s.295.396.295.507s-.055.283-.295.506c-.24.225-.622.455-1.147.662c-1.045.413-2.532.682-4.206.682s-3.16-.27-4.206-.682c-.524-.207-.906-.437-1.147-.662c-.24-.223-.294-.395-.294-.506m11.422 1.76c-.323.22-.7.41-1.11.571c-1.225.483-2.874.769-4.665.769s-3.44-.286-4.664-.769a5.8 5.8 0 0 1-1.11-.57v2.584c.039.093.118.208.266.343c.248.226.642.458 1.183.666c1.076.414 2.605.683 4.325.683q.407 0 .797-.02a4.66 4.66 0 0 1 4.978-1.919zM5.927 9.25l.195-.001a4.7 4.7 0 0 0-.196 1.34c0 .625.123 1.22.346 1.764q-.172.004-.345.004c-3.19 0-5.774-1.108-5.774-2.474V7.999c.298.183.636.343 1 .483c1.252.482 2.94.767 4.774.767M10.588 14a3.412 3.412 0 1 0 0-6.824a3.412 3.412 0 0 0 0 6.824m-2.116-3.412c0-.345.28-.625.625-.625h2.982a.625.625 0 1 1 0 1.25H9.097a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDecentWorkAndEconomicGrowth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9.008 6.709l3.43-1.516v7.672h-3.43zM4.72 4.814l2.144 3.032l2.144-1.137v6.154H4.72z\"/><path d=\"m1.29 6.33l3.43-1.516v8.05H1.29zm12-5.193L7.851 4.613l-2.5-2.923L.878 3.988\"/><path d=\"m10.586.678l2.703.45l-.45 2.704\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDecentWorkAndEconomicGrowthRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.5.5a.5.5 0 0 0-.353.854l.766.766L8.475 4.2l-3.6-2.7a.63.63 0 0 0-.685-.043l-3.5 2a.625.625 0 0 0 .62 1.086l3.144-1.797L8.125 5.5a.625.625 0 0 0 .78-.024l2.895-2.47l.847.848A.5.5 0 0 0 13.5 3.5V1a.5.5 0 0 0-.5-.5zm3.125 5a.625.625 0 0 0-1.009-.493L8.493 8.214L4.875 5.5a.63.63 0 0 0-.685-.043l-3.5 2A.63.63 0 0 0 .375 8v5c0 .345.28.625.625.625h12c.345 0 .625-.28.625-.625zM8.884 9.493l3.491-2.715v5.597H8.5v-2.75a.62.62 0 0 0 .384-.132M4.5 6.781l-.046-.035l-2.829 1.617v4.012H4.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDecentWorkAndEconomicGrowthSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.326.28a.5.5 0 0 1 .506-.229l2.571.429a.5.5 0 0 1 .411.575l-.428 2.572a.5.5 0 0 1-.9.208l-.694-.97l-3.574 2.284a.75.75 0 0 1-.974-.144l-1.993-2.33L1.524 4.59a.75.75 0 1 1-.686-1.334l4.255-2.187a.75.75 0 0 1 .913.18L7.96 3.534l2.96-1.892l-.577-.807a.5.5 0 0 1-.017-.555M3.78 5.19L.878 6.85A.75.75 0 0 0 .5 7.5v5.75c0 .414.336.75.75.75h2.53zM5.03 14h3.668V7.188l-1.649.824l-1.648-2.884a.75.75 0 0 0-.37-.324zm7.72 0H9.948V6.563l2.467-1.234A.75.75 0 0 1 13.5 6v7.25a.75.75 0 0 1-.75.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDefinitionSearchBook: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10 12.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m3.5 1l-1.73-1.73M7 2A1.5 1.5 0 0 0 5.5.5h-5v10h5M7 2v4.5M7 2A1.5 1.5 0 0 1 8.5.5h5v7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDefinitionSearchBookRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625 3.375v2.75a.625.625 0 1 1-1.25 0v-2.75A2.125 2.125 0 0 0 4.25 1.25h-3v8.5h3.875a.625.625 0 0 1 0 1.25h-4.5A.625.625 0 0 1 0 10.375V.625C0 .28.28 0 .625 0H4.25A3.37 3.37 0 0 1 7 1.418A3.37 3.37 0 0 1 9.75 0h3.625c.345 0 .625.28.625.625V6.5a.625.625 0 1 1-1.25 0V1.25h-3a2.125 2.125 0 0 0-2.125 2.125M9.875 8a1.875 1.875 0 1 0 0 3.75a1.875 1.875 0 0 0 0-3.75M6.75 9.875a3.125 3.125 0 1 1 5.732 1.724l1.335 1.334a.625.625 0 1 1-.884.884l-1.335-1.334A3.125 3.125 0 0 1 6.75 9.876\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDefinitionSearchBookSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5.125a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.756A4.5 4.5 0 0 1 5 9.625c0-1.271.527-2.42 1.375-3.238v-4.96A2 2 0 0 0 4.5.126zm7.125 1.303v4.105a4.5 4.5 0 0 1 6.347 3.584H14V.625a.5.5 0 0 0-.5-.5h-4a2 2 0 0 0-1.875 1.303M9.5 7.875a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5m-3.25 1.75a3.25 3.25 0 1 1 6.017 1.706l1.263 1.263a.75.75 0 0 1-1.06 1.061l-1.264-1.263A3.25 3.25 0 0 1 6.25 9.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDelete1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5.5l-13 13m0-13l13 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDelete1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.655 1.335a.7.7 0 0 0-.99-.99L7 6.01L1.335.345a.7.7 0 0 0-.99.99L6.01 7L.345 12.665a.7.7 0 0 0 .99.99L7 7.99l5.665 5.665a.7.7 0 1 0 .99-.99L7.99 7z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDelete1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.707.293A1 1 0 0 0 .293 1.707L5.586 7L.293 12.293a1 1 0 1 0 1.414 1.414L7 8.414l5.293 5.293a1 1 0 0 0 1.414-1.414L8.414 7l5.293-5.293A1 1 0 0 0 12.293.293L7 5.586z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDeleteKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.813 10.176a2 2 0 0 0 1.523.703h5.556a2 2 0 0 0 2-2V5.12a2 2 0 0 0-2-2H5.336a2 2 0 0 0-1.523.704l-1.6 1.88a2 2 0 0 0 0 2.593zm2.584-4.989l3.584 3.584M9.98 5.187L6.398 8.771\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDeleteKeyboardRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.973 1.875a1.64 1.64 0 0 0-1.187.507l-3.338 3.5a1.62 1.62 0 0 0 0 2.236l3.338 3.5l.39-.371l-.39.371c.31.324.739.507 1.187.507h7.392A1.63 1.63 0 0 0 14 10.5v-7a1.63 1.63 0 0 0-1.635-1.625zm-.282 1.37a.4.4 0 0 1 .282-.12h7.392a.38.38 0 0 1 .385.375v7a.38.38 0 0 1-.385.375H4.973a.4.4 0 0 1-.282-.12l-3.338-3.5a.37.37 0 0 1 0-.51zm6.34 1.475a.75.75 0 0 1 0 1.06L9.81 7l1.22 1.22a.75.75 0 1 1-1.06 1.06L8.75 8.06L7.53 9.28a.75.75 0 0 1-1.06-1.06L7.69 7L6.47 5.78a.75.75 0 0 1 1.06-1.06l1.22 1.22l1.22-1.22a.75.75 0 0 1 1.06 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDeleteKeyboardSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.316 10.463a2 2 0 0 0 1.523.703h6.182a2 2 0 0 0 2-2V4.834a2 2 0 0 0-2-2H4.839a2 2 0 0 0-1.523.703L1.471 5.703a2 2 0 0 0 0 2.594zm2.165-5.718a.625.625 0 0 1 .884 0l1.35 1.35l1.349-1.35a.625.625 0 1 1 .884.884l-1.35 1.35l1.35 1.35a.625.625 0 1 1-.884.884l-1.35-1.35l-1.35 1.35a.625.625 0 0 1-.883-.884l1.35-1.35l-1.35-1.35a.625.625 0 0 1 0-.884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDescendingNumberOrder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.167 8.5v5M9.5 9.75h.417c.69 0 1.25-.56 1.25-1.25v0m1.667 5H9.5m.922-10.156h.656a1.422 1.422 0 0 0 0-2.844h-.656a1.422 1.422 0 0 0 0 2.844\"/><path d=\"M12.5 1.813v2.625c0 .725-.588 1.312-1.312 1.312h-.875a1.31 1.31 0 0 1-1.238-.875M6 11l-2.5 2.5L1 11M3.5.5v13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDescendingNumberOrderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.51.753a.612.612 0 1 0-1.226 0v9.432H1.447a.613.613 0 0 0-.433 1.046l2.45 2.45a.613.613 0 0 0 .866 0l2.45-2.45a.612.612 0 0 0-.433-1.046H4.509zm6.323 2.174h-.643a.781.781 0 0 1 0-1.561h.643a.78.78 0 0 1 .781.767v.026a.78.78 0 0 1-.78.768m0-2.786c1.028 0 1.876.772 1.993 1.769a.6.6 0 0 1 .013.13v2.572a1.9 1.9 0 0 1-1.898 1.899h-.858a1.9 1.9 0 0 1-1.79-1.266a.613.613 0 0 1 1.154-.409c.093.263.344.45.636.45h.858a.674.674 0 0 0 .673-.674v-.617a2 2 0 0 1-.78.157h-.644a2.006 2.006 0 1 1 0-4.011zm.7 8.206a.613.613 0 0 0-1.225 0a.613.613 0 0 1-.613.613h-.408a.613.613 0 0 0 0 1.225h.408q.323-.002.613-.105v2.555H9.287a.612.612 0 1 0 0 1.225h3.266a.612.612 0 1 0 0-1.225h-1.02z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDescendingNumberOrderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.078 2.844h-.656a.672.672 0 0 1 0-1.344h.656c.37 0 .67.298.672.667v.01a.67.67 0 0 1-.672.667m0-2.844c1.11 0 2.027.833 2.157 1.909q.015.074.015.153v2.625c0 1.14-.923 2.063-2.062 2.063h-.875c-.9 0-1.662-.575-1.945-1.375a.75.75 0 1 1 1.414-.5c.078.22.287.375.53.375h.876c.31 0 .562-.252.562-.563v-.45a2.2 2.2 0 0 1-.672.107h-.656a2.172 2.172 0 0 1 0-4.344zm.839 8.25a.75.75 0 0 0-1.5 0a.5.5 0 0 1-.5.5H9.5a.75.75 0 0 0 0 1.5h.417q.259 0 .5-.063V12.5H9.5a.75.75 0 0 0 0 1.5h3.334a.75.75 0 0 0 0-1.5h-.917zM3.75 0a1 1 0 0 1 1 1v9h1.5a.75.75 0 0 1 .53 1.28l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5A.75.75 0 0 1 1.25 10h1.5V1a1 1 0 0 1 1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopChat: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 8v2.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h2m3 9l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"M5.5 5.5h3v2l3-2h2v-5h-8z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopChatRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 2a2 2 0 0 1 2-2H12a2 2 0 0 1 2 2v1.5a2 2 0 0 1-2 2h-.349L8.777 7.416A.5.5 0 0 1 8 7V5.5h-.5a2 2 0 0 1-2-2zM1.25 3h2.125a.625.625 0 1 0 0-1.25h-2.25C.504 1.75 0 2.254 0 2.875v7.5c0 .621.504 1.125 1.125 1.125h4.086l-.5 1.25H4A.625.625 0 1 0 4 14h6a.625.625 0 1 0 0-1.25h-.711l-.5-1.25h4.086c.621 0 1.125-.504 1.125-1.125v-2.75a.625.625 0 1 0-1.25 0v2.625H1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopChatSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.429 4.648a1 1 0 0 0 1 1h2.214v1.208a.5.5 0 0 0 .777.416l2.437-1.624H13a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H6.429a1 1 0 0 0-1 1zM8.515 11H12.5A1.5 1.5 0 0 0 14 9.5V8a1 1 0 1 0-2 0v1H2V3h1a1 1 0 0 0 0-2H1.5A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-.537 1.5H4A.75.75 0 0 0 4 14h6a.75.75 0 0 0 0-1.5h-.948z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.82 2H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.587M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"m8 3.15l2 1.5l3.5-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.836 1.219a.75.75 0 0 0-1.172-.937L9.118 4.714L7.7 3.65a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.036-.131zM12.875 11.5H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75h3.75a.625.625 0 1 1 0 1.25H1.25v7.25h11.5V6.625a.625.625 0 1 1 1.25 0v3.75c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.498.436a.75.75 0 0 1 .063 1.059l-4 4.5a.75.75 0 0 1-1.01.101l-2-1.5a.75.75 0 1 1 .9-1.2l1.447 1.086L12.44.498a.75.75 0 0 1 1.058-.062M8.515 11H12.5A1.5 1.5 0 0 0 14 9.5v-2a1 1 0 1 0-2 0V9H2V3h2.5a1 1 0 1 0 0-2h-3A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-.537 1.5H4A.75.75 0 0 0 4 14h6a.75.75 0 0 0 0-1.5h-.948z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopCode: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.5v-8A.5.5 0 0 0 13 2H1c-.265 0-.5.235-.5.5v8c0 .265.235.5.5.5h12c.265 0 .5-.235.5-.5M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"M5 5L3.5 6.5L5 8m4-3l1.5 1.5L9 8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopCodeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.036.183a.625.625 0 0 1 0 .884L7.228 2.875l1.808 1.808a.625.625 0 1 1-.884.884l-2.25-2.25a.625.625 0 0 1 0-.884l2.25-2.25a.625.625 0 0 1 .884 0m1.647 0a.625.625 0 0 1 .884 0l2.25 2.25a.625.625 0 0 1 0 .884l-2.25 2.25a.625.625 0 1 1-.884-.884l1.808-1.808l-1.808-1.808a.625.625 0 0 1 0-.884M12.875 11.5H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75H4A.625.625 0 1 1 4 3H1.25v7.25h11.5V7A.625.625 0 1 1 14 7v3.375c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopCodeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.832C0 1.027.652.375 1.457.375h11.086c.805 0 1.457.652 1.457 1.457v7.586c0 .805-.652 1.457-1.457 1.457H8.517l.535 1.495H10a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.948l.535-1.495H1.457A1.457 1.457 0 0 1 0 9.418zm5.53 1.76a.75.75 0 0 1 0 1.061l-.97.97l.97.97a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06l1.5-1.5a.75.75 0 0 1 1.06 0m4 0a.75.75 0 0 0-1.06 1.061l.97.97l-.97.97a.75.75 0 0 0 1.06 1.06l1.5-1.5a.75.75 0 0 0 0-1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.343 2H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7M6 11l-1 2.5M8 11l1 2.5m-5 0h6m3.5-8.922l-4-4m4 0l-4 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopDeleteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.78.22a.75.75 0 0 1 0 1.06l-1.594 1.594l1.594 1.59a.75.75 0 1 1-1.06 1.062l-1.594-1.591L9.53 5.53a.75.75 0 0 1-1.06-1.06l1.594-1.594l-1.594-1.59A.75.75 0 0 1 9.53.224l1.594 1.591L12.72.22a.75.75 0 0 1 1.06 0m-.905 11.28H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75h5.5a.625.625 0 1 1 0 1.25H1.25v7.25h11.5V7.375a.625.625 0 1 1 1.25 0v3c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopDeleteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.76 1.338A.75.75 0 1 0 12.7.278l-1.72 1.72L9.26.277a.75.75 0 0 0-1.06 1.06l1.72 1.72l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72l1.72 1.72a.75.75 0 0 0 1.06-1.06l-1.719-1.72l1.72-1.72ZM8.516 11H12.5A1.5 1.5 0 0 0 14 9.5v-1a1 1 0 1 0-2 0V9H2V3h3.5a1 1 0 0 0 0-2h-4A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-.537 1.5H4A.75.75 0 0 0 4 14h6a.75.75 0 0 0 0-1.5h-.948z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopDollar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.76 2H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-1M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"M13.424 2.722a1.33 1.33 0 0 0-1.257-.889h-1.032a1.19 1.19 0 0 0-.255 2.353l1.572.344a1.334 1.334 0 0 1-.285 2.637h-.89c-.58 0-1.074-.371-1.257-.89m1.702-4.444V.5m0 8V7.167\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopDollarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.445.625a.625.625 0 0 0-1.25 0v.545a1.667 1.667 0 0 0-.246 3.291l1.375.301a.542.542 0 0 1-.116 1.072h-.778a.54.54 0 0 1-.51-.361a.625.625 0 0 0-1.18.416c.221.624.778 1.09 1.455 1.18v.556a.625.625 0 1 0 1.25 0v-.557a1.793 1.793 0 0 0 .146-3.527l-1.375-.3a.416.416 0 0 1 .09-.824h.902a.54.54 0 0 1 .511.36a.625.625 0 0 0 1.179-.416a1.79 1.79 0 0 0-1.453-1.179zm.43 10.875H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75h6.75a.625.625 0 1 1 0 1.25H1.25v7.25h11.5v-.625a.625.625 0 1 1 1.25 0v.75c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopDollarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-.537 1.5H4A.75.75 0 0 0 4 14h6a.75.75 0 0 0 0-1.5h-.948L8.515 11H9a1 1 0 1 0 0-2H2V3h5a1 1 0 0 0 0-2zm10.083-1a.75.75 0 0 1 .75.75v.528a2 2 0 0 1 1.553 1.305a.75.75 0 0 1-1.414.5A.5.5 0 0 0 12 2.75h-.967a.366.366 0 0 0-.079.723l1.473.322a2 2 0 0 1-.094 3.927v.528a.75.75 0 0 1-1.5 0v-.528a2 2 0 0 1-1.552-1.305a.75.75 0 0 1 1.414-.5a.5.5 0 0 0 .472.333H12a.5.5 0 0 0 .107-.99l-1.473-.322a1.866 1.866 0 0 1 .2-3.677V.75a.75.75 0 0 1 .75-.75Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopEmoji: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.5v-8A.5.5 0 0 0 13 2H1c-.265 0-.5.235-.5.5v8c0 .265.235.5.5.5h12c.265 0 .5-.235.5-.5M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"M4.557 7.571C5.033 8.056 5.874 8.5 7 8.5s1.967-.444 2.443-.929M5.25 5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m3.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopEmojiRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 9.875v-8.25h11.5v8.25zm-.125-9.5C.504.375 0 .879 0 1.5V10c0 .621.504 1.125 1.125 1.125h4.086l-.5 1.25H4a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25h-.711l-.5-1.25h4.086c.621 0 1.125-.504 1.125-1.125V1.5c0-.621-.504-1.125-1.125-1.125zm3.967 5.92a.75.75 0 1 0-1.07 1.052C4.64 7.976 5.675 8.5 7 8.5s2.36-.524 2.978-1.153a.75.75 0 1 0-1.07-1.051C8.574 6.636 7.926 7 7 7s-1.574-.364-1.908-.704M5.274 5H5.25a1 1 0 1 1 .024 0m3.5 0H8.75a1 1 0 1 1 .024 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopEmojiSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.457.252C.652.252 0 .905 0 1.71v7.587c0 .804.652 1.456 1.457 1.456h4.026l-.535 1.496H4a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-.948l-.535-1.496h4.026c.805 0 1.457-.652 1.457-1.456V1.709c0-.804-.652-1.457-1.457-1.457zm3.545 6.134a.625.625 0 0 0-.89.876C4.705 7.867 5.707 8.377 7 8.377s2.294-.51 2.889-1.115a.625.625 0 1 0-.891-.876c-.359.364-1.04.741-1.998.741c-.959 0-1.64-.377-1.998-.741m1.014-2.383a.766.766 0 1 1-1.531 0a.766.766 0 0 1 1.53 0m2.734.765a.766.766 0 1 0 0-1.531a.766.766 0 0 0 0 1.531\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopFavoriteStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 8.475V10.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h3.541M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/><path d=\"m10.272.653l.836 1.682a.26.26 0 0 0 .214.155l1.857.282a.282.282 0 0 1 .155.486l-1.37 1.303a.27.27 0 0 0 0 .252l.262 1.847a.282.282 0 0 1-.418.301l-1.652-.874a.33.33 0 0 0-.272 0L8.23 6.96a.282.282 0 0 1-.418-.3l.311-1.848a.27.27 0 0 0-.048-.252l-1.37-1.313a.282.282 0 0 1 .155-.476L8.717 2.5a.26.26 0 0 0 .214-.155L9.767.663a.282.282 0 0 1 .505-.01\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopFavoriteStarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.007.001a.78.78 0 0 1 .71.422l.003.008l.786 1.582l1.744.264a.782.782 0 0 1 .427 1.345l-1.214 1.154l.256 1.802a.782.782 0 0 1-1.152.822l-1.547-.82l-1.548.82a.782.782 0 0 1-1.15-.83l.295-1.756L6.36 3.61l-.01-.01a.782.782 0 0 1 .432-1.321l.007-.001l1.745-.256l.784-1.578a.78.78 0 0 1 .69-.443M12.875 11.5H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75h3.25a.625.625 0 1 1 0 1.25H1.25v7.25h11.5V8.875a.625.625 0 1 1 1.25 0v1.5c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopFavoriteStarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m10.818.29l.847 1.713a.3.3 0 0 0 .19.191l1.894.274a.292.292 0 0 1 .16.5L12.557 4.32a.31.31 0 0 0-.082.258l.33 1.837a.292.292 0 0 1-.423.31l-1.693-.888a.28.28 0 0 0-.268 0l-1.692.888a.292.292 0 0 1-.423-.31l.325-1.883a.31.31 0 0 0-.083-.258L7.196 2.922a.292.292 0 0 1 .14-.48l1.893-.274a.3.3 0 0 0 .217-.165L10.292.29a.292.292 0 0 1 .526 0M8.515 11H12.5A1.5 1.5 0 0 0 14 9.5V9a1 1 0 1 0-2 0H2V3h3a1 1 0 1 0 0-2H1.5A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-.537 1.5H4A.75.75 0 0 0 4 14h6a.75.75 0 0 0 0-1.5h-.948z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopGame: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1 2h12c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5H1c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5m5 9l-1 2.5M8 11l1 2.5m-5 0h6m-7-7h3M4.5 5v3\"/><path d=\"M10.8 6.05a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5M9 7.45a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopGameRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.108 2.581A2.9 2.9 0 0 1 7.991 0h2.913a2.9 2.9 0 0 1 2.883 2.581l.202 1.816a1.806 1.806 0 0 1-3.509.77l-.102-.306a.38.38 0 0 0-.359-.259H8.876a.38.38 0 0 0-.359.259l-.102.307a1.806 1.806 0 0 1-3.509-.77zm7.767 8.919H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75h2.25a.625.625 0 1 1 0 1.25H1.25v7.25h11.5V7.875a.625.625 0 1 1 1.25 0v2.5c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopGameSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.957C0 1.152.652.5 1.457.5h11.086C13.348.5 14 1.152 14 1.957v7.586c0 .805-.652 1.457-1.457 1.457H8.517l.535 1.495H10a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.948L5.483 11H1.457A1.457 1.457 0 0 1 0 9.543zM2.064 5.53c0-.345.28-.625.625-.625h.875V4.03a.625.625 0 0 1 1.25 0v.875h.875a.625.625 0 0 1 0 1.25h-.875v.875a.625.625 0 0 1-1.25 0v-.875h-.875a.625.625 0 0 1-.625-.625m8.042-.975a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m-1.941 1.95a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopHelp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 6.576V10.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h6.166M6 11l-1 2.5M8 11l1 2.5m-5 0h6M9.5 2A1.5 1.5 0 1 1 11 3.5v1\"/><path d=\"M11 7a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopHelpRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.844 1.356A1.375 1.375 0 1 1 11.37 4a.625.625 0 0 0-.625.625V5.71a.625.625 0 1 0 1.25 0v-.533a2.626 2.626 0 1 0-3.25-2.55a.625.625 0 1 0 1.25 0a1.375 1.375 0 0 1 .849-1.27m.526 7.228a.875.875 0 1 0 0-1.75a.875.875 0 0 0 0 1.75m1.505 2.916H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75H7A.625.625 0 1 1 7 3H1.25v7.25h11.5v-.875a.625.625 0 1 1 1.25 0v1c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDesktopHelpSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.717 1.576a.853.853 0 0 0-1.02.837a.75.75 0 0 1-1.5 0a2.353 2.353 0 1 1 3.103 2.23v.174a.75.75 0 1 1-1.5 0v-.801a.75.75 0 0 1 .75-.75a.853.853 0 0 0 .167-1.69m-.174 6.27a.825.825 0 0 1 .007-1.65h.007a.825.825 0 0 1-.007 1.65zM8.515 11H13a1 1 0 1 0 0-2H2V3h5a1 1 0 1 0 0-2H1.5A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h3.985l-.537 1.5H4A.75.75 0 0 0 4 14h6a.75.75 0 0 0 0-1.5h-.948z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDeviceDatabaseEncryption1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.646 5.406v3.15M.646.5v3.15m0 6.663v3.15M6.777.5v3.15M8.654.5v3.15M2.62 5.406v3.15m.017-6.882a1.174 1.174 0 1 1 2.349 0v.783a1.174 1.174 0 0 1-2.35 0zM4.415 6.58a1.174 1.174 0 0 1 2.349 0v.783a1.174 1.174 0 1 1-2.349 0zm-1.778 4.925a1.174 1.174 0 0 1 2.349 0v.783a1.174 1.174 0 0 1-2.35 0zM8 9.5h5c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5H8c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5m.5 0v-1c0-1.1.9-2 2-2s2 .9 2 2v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDeviceDatabaseEncryption1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25.625a.625.625 0 1 0-1.25 0v2.9a.625.625 0 0 0 1.25 0zm0 4.925a.625.625 0 1 0-1.25 0v2.9a.625.625 0 1 0 1.25 0zm-.625 4.3c.345 0 .625.28.625.626v2.899a.625.625 0 1 1-1.25 0v-2.9c0-.344.28-.624.625-.624M8.13.626a.625.625 0 1 0-1.25 0v2.9a.625.625 0 0 0 1.25 0zM9.758 0c.345 0 .625.28.625.625v2.9a.625.625 0 1 1-1.25 0v-2.9c0-.345.28-.625.625-.625m-6.16 5.55a.625.625 0 1 0-1.25 0v2.9a.625.625 0 1 0 1.25 0zM2.365 1.8a1.8 1.8 0 1 1 3.6 0v.532a1.8 1.8 0 0 1-3.6 0zm1.8-.55a.55.55 0 0 0-.55.55v.532a.55.55 0 0 0 1.1 0v-.533a.55.55 0 0 0-.55-.549m2.153 3.675a1.8 1.8 0 0 0-1.8 1.8v.532a1.8 1.8 0 0 0 3.6 0v-.532a1.8 1.8 0 0 0-1.8-1.8m-.55 1.8a.55.55 0 0 1 1.1 0v.532a.55.55 0 0 1-1.1 0zm-3.403 4.943a1.8 1.8 0 1 1 3.6 0v.533a1.8 1.8 0 1 1-3.6 0zm1.8-.55a.55.55 0 0 0-.55.55v.533a.55.55 0 1 0 1.1 0v-.533a.55.55 0 0 0-.55-.55M8.75 9.532V8.75a2.25 2.25 0 0 1 4.5 0v.782a1 1 0 0 1 .75.968V13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.5a1 1 0 0 1 .75-.968M12 9.5h-2v-.75a1 1 0 1 1 2 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDeviceDatabaseEncryption1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.56 1.954C2.56.895 3.445.092 4.47.092s1.912.803 1.912 1.862v.462c0 1.059-.887 1.862-1.911 1.862s-1.912-.803-1.912-1.862zm1.91-.362c-.258 0-.41.192-.41.362v.462c0 .17.152.362.41.362c.259 0 .412-.193.412-.362v-.462c0-.17-.153-.362-.411-.362ZM1.595.842a.75.75 0 1 0-1.5 0v2.703a.75.75 0 0 0 1.5 0zm0 4.792a.75.75 0 1 0-1.5 0v2.703a.75.75 0 1 0 1.5 0zm1.715-.75a.75.75 0 0 1 .75.75v2.703a.75.75 0 1 1-1.5 0V5.634a.75.75 0 0 1 .75-.75m-1.715 5.503a.75.75 0 1 0-1.5 0v2.703a.75.75 0 0 0 1.5 0zM8.097.092a.75.75 0 0 1 .75.75v2.703a.75.75 0 1 1-1.5 0V.842a.75.75 0 0 1 .75-.75m3.176.75a.75.75 0 1 0-1.5 0v2.703a.75.75 0 1 0 1.5 0zM4.47 9.654c-1.025 0-1.912.803-1.912 1.862v.462c0 1.059.887 1.862 1.912 1.862s1.911-.803 1.911-1.862v-.462c0-1.059-.887-1.862-1.911-1.862m-.412 1.862c0-.17.153-.362.412-.362c.258 0 .411.193.411.362v.462c0 .17-.153.362-.411.362c-.259 0-.412-.192-.412-.362zm.965-4.772a1.91 1.91 0 0 1 1.911-1.91a.75.75 0 0 1 0 1.5a.41.41 0 0 0-.41.41v.483a.75.75 0 1 1-1.5 0zM10.5 7.75c-.69 0-1.25.56-1.25 1.25v.5h2.5V9c0-.69-.56-1.25-1.25-1.25M7.75 9v.531A1 1 0 0 0 7 10.5V13a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-2.5a1 1 0 0 0-.75-.969V9a2.75 2.75 0 1 0-5.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDhammajak: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 5.594V.625m0 12.75V8.406M8.406 7h4.969M.625 7h4.969m2.4-.994l3.514-3.514m-9.016 9.016l3.514-3.514m1.988 0l3.514 3.514M2.492 2.492l3.514 3.514M.615 7a6.385 6.385 0 1 0 12.77 0A6.385 6.385 0 1 0 .615 7\"/><path d=\"M5.594 7a1.406 1.406 0 1 0 2.812 0a1.406 1.406 0 1 0-2.812 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDhammajakRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.037 0h-.074a6.98 6.98 0 0 0-4.94 2.077A6.98 6.98 0 0 0 0 7.037a6.98 6.98 0 0 0 2.077 4.94A6.98 6.98 0 0 0 7.037 14a6.98 6.98 0 0 0 4.94-2.077A6.98 6.98 0 0 0 14 6.963a6.98 6.98 0 0 0-2.077-4.939A6.98 6.98 0 0 0 7.037 0m-.662 1.535a5.47 5.47 0 0 0-2.797 1.159l2.296 2.297q.236-.133.501-.208zM2.694 3.578a5.47 5.47 0 0 0-1.159 2.797h3.248q.075-.265.208-.5zM1.535 7.625a5.47 5.47 0 0 0 1.159 2.797l2.297-2.296a2.3 2.3 0 0 1-.208-.501zm2.043 3.681a5.47 5.47 0 0 0 2.797 1.159V9.217a2.3 2.3 0 0 1-.5-.208zm4.047 1.159a5.47 5.47 0 0 0 2.797-1.159L8.126 9.009a2.3 2.3 0 0 1-.501.208zm3.681-2.043a5.47 5.47 0 0 0 1.159-2.797H9.217q-.076.265-.208.5zm1.159-4.047a5.47 5.47 0 0 0-1.159-2.797L9.009 5.875q.132.235.208.5zm-2.043-3.681L8.126 4.991a2.3 2.3 0 0 0-.501-.208V1.535a5.47 5.47 0 0 1 2.797 1.159M7 6.197a.803.803 0 1 0 0 1.606a.803.803 0 0 0 0-1.606\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDhammajakSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375.09a6.9 6.9 0 0 0-3.823 1.585L5.706 4.83q.31-.186.669-.279zM1.669 2.56A6.9 6.9 0 0 0 .09 6.383h4.46q.091-.357.274-.667zM.093 7.633a6.9 6.9 0 0 0 1.585 3.813l3.155-3.155a2.5 2.5 0 0 1-.276-.658zm2.47 4.696a6.9 6.9 0 0 0 3.812 1.577V9.442a2.5 2.5 0 0 1-.655-.27zm5.062 1.577a6.9 6.9 0 0 0 3.812-1.577L8.28 9.17q-.304.18-.655.27zm4.697-2.46a6.9 6.9 0 0 0 1.585-3.813H9.442q-.091.353-.276.657zm1.587-5.063a6.9 6.9 0 0 0-1.578-3.822L9.175 5.717c.12.205.214.429.273.666zm-2.46-4.707A6.9 6.9 0 0 0 7.624.089v4.462q.358.093.669.28zm-5.723 5.32c0-.7.567-1.269 1.267-1.273h.014a1.273 1.273 0 1 1-1.28 1.274\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiamond2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.638 1.54H3.362a1.07 1.07 0 0 0-.85.46L.692 4.52a1.05 1.05 0 0 0 .06 1.29L6.21 12.1a1 1 0 0 0 1.58 0l5.457-6.29a1.05 1.05 0 0 0 .06-1.29L11.488 2a1.07 1.07 0 0 0-.85-.46\"/><path d=\"M6.48 1.53L4.04 5.31L7 12.46m.55-10.93l2.43 3.78L7 12.46M.52 5.31h12.96\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiamond2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8.17 2.25l1.517 2.56H4.313L5.83 2.25zM1.514 5.81l5.122 5.776l.057.055L4.252 5.81zm8.253 0L7.31 11.638l.053-.052l5.122-5.776zm2.298-4.099A1.63 1.63 0 0 0 10.72 1H3.279c-.538 0-1.04.266-1.343.711L.36 4.028a2.08 2.08 0 0 0 .164 2.55L5.7 12.416a1.737 1.737 0 0 0 2.598 0l5.177-5.838a2.08 2.08 0 0 0 .164-2.55z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiamond2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.408 1.04H7.62l1.717 3.69H4.684zM3.304 4.73l1.724-3.69H3.346a1.57 1.57 0 0 0-1.244.67L.285 4.228l-.003.004a1.6 1.6 0 0 0-.234.5zM.254 5.98h3.024l1.921 6.161L.365 6.13a2 2 0 0 1-.111-.148m4.333 0h4.847l-2.33 7.503a2 2 0 0 1-.176.002zm6.156 0l-1.896 6.103l4.788-5.954a2 2 0 0 0 .111-.148zm3.208-1.25a1.6 1.6 0 0 0-.233-.499l-.003-.004l-1.817-2.516a1.57 1.57 0 0 0-1.244-.67V1.04H8.999l1.717 3.69z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiamondsSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.092 6.398L6.13.933a1.092 1.092 0 0 1 1.742 0l4.037 5.465c.266.36.266.844 0 1.204L7.87 13.066a1.092 1.092 0 0 1-1.742 0L2.092 7.602a1.01 1.01 0 0 1 0-1.204\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiamondsSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.43 1.44c-.2-.253-.66-.253-.86 0L2.305 6.798c-.1.125-.1.277 0 .402l4.263 5.36c.2.252.661.252.862 0l4.263-5.36c.1-.125.1-.277 0-.402zM5.59.66c.702-.881 2.118-.881 2.82 0l4.262 5.36c.462.58.462 1.377 0 1.958L8.41 13.34c-.701.881-2.117.881-2.818 0L1.328 7.98a1.56 1.56 0 0 1 0-1.958z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiamondsSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.072.785a1.342 1.342 0 0 0-2.144 0L1.89 6.25a1.26 1.26 0 0 0 0 1.5l4.037 5.465a1.342 1.342 0 0 0 2.144 0L12.11 7.75a1.26 1.26 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5.5h9s2 0 2 2v9s0 2-2 2h-9s-2 0-2-2v-9s0-2 2-2\"/><path d=\"M6.5 7a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v8A2.625 2.625 0 0 0 3 13.625h8A2.625 2.625 0 0 0 13.625 11V3A2.625 2.625 0 0 0 11 .375zM1.625 3c0-.76.616-1.375 1.375-1.375h8c.76 0 1.375.616 1.375 1.375v8c0 .76-.616 1.375-1.375 1.375H3c-.76 0-1.375-.616-1.375-1.375zM8.25 7a1.25 1.25 0 1 0-2.5 0a1.25 1.25 0 0 0 2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 2.5A2.5 2.5 0 0 1 2.5 0h9A2.5 2.5 0 0 1 14 2.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 0 11.5zm7 5.7a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5.5h9s2 0 2 2v9s0 2-2 2h-9s-2 0-2-2v-9s0-2 2-2\"/><path d=\"M9 4.5a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-5 5a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v8A2.625 2.625 0 0 0 3 13.625h8A2.625 2.625 0 0 0 13.625 11V3A2.625 2.625 0 0 0 11 .375zM1.625 3c0-.76.616-1.375 1.375-1.375h8c.76 0 1.375.616 1.375 1.375v8c0 .76-.616 1.375-1.375 1.375H3c-.76 0-1.375-.616-1.375-1.375zm9.125 1.5a1.25 1.25 0 1 0-2.5 0a1.25 1.25 0 0 0 2.5 0m-7.5 5a1.25 1.25 0 1 0 2.5 0a1.25 1.25 0 0 0-2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 11.5 0zm2.912 9.788a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m4.376-4.376a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5.5h9s2 0 2 2v9s0 2-2 2h-9s-2 0-2-2v-9s0-2 2-2\"/><path d=\"M9.5 4a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-6 6a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m3-3a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v8A2.625 2.625 0 0 0 3 13.625h8A2.625 2.625 0 0 0 13.625 11V3A2.625 2.625 0 0 0 11 .375zM1.625 3c0-.76.616-1.375 1.375-1.375h8c.76 0 1.375.616 1.375 1.375v8c0 .76-.616 1.375-1.375 1.375H3c-.76 0-1.375-.616-1.375-1.375zm9.625 1a1.25 1.25 0 1 0-2.5 0a1.25 1.25 0 0 0 2.5 0M4 11.25a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m3-3a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 2.5A2.5 2.5 0 0 1 2.5 0h9A2.5 2.5 0 0 1 14 2.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 0 11.5zm4.212 8.488a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4M8.198 7a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m1.59-1.588a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice4: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5.5h9s2 0 2 2v9s0 2-2 2h-9s-2 0-2-2v-9s0-2 2-2\"/><path d=\"M9.5 4a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-6 0a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m6 6a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-6 0a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice4Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v8A2.625 2.625 0 0 0 3 13.625h8A2.625 2.625 0 0 0 13.625 11V3A2.625 2.625 0 0 0 11 .375zM1.625 3c0-.76.616-1.375 1.375-1.375h8c.76 0 1.375.616 1.375 1.375v8c0 .76-.616 1.375-1.375 1.375H3c-.76 0-1.375-.616-1.375-1.375zM4 5.25a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5M11.25 4a1.25 1.25 0 1 0-2.5 0a1.25 1.25 0 0 0 2.5 0M10 11.25a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m-6 0a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice4Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 11.5 0zm8.486 4.212a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m-1.2 6.776a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4M5.414 4.212a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m-1.2 6.776a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice5: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5.5h9s2 0 2 2v9s0 2-2 2h-9s-2 0-2-2v-9s0-2 2-2\"/><path d=\"M9.5 4a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-6 0a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m6 6a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-6 0a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m3-3a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice5Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v8A2.625 2.625 0 0 0 3 13.625h8A2.625 2.625 0 0 0 13.625 11V3A2.625 2.625 0 0 0 11 .375zM1.625 3c0-.76.616-1.375 1.375-1.375h8c.76 0 1.375.616 1.375 1.375v8c0 .76-.616 1.375-1.375 1.375H3c-.76 0-1.375-.616-1.375-1.375zM4 5.25a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5M11.25 4a1.25 1.25 0 1 0-2.5 0a1.25 1.25 0 0 0 2.5 0M10 11.25a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m-6 0a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m3-3a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice5Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 2.5A2.5 2.5 0 0 1 2.5 0h9A2.5 2.5 0 0 1 14 2.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 0 11.5zm9.786 2.912a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4m1.2 4.376a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0M7 8.202a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4m-1.586-3.99a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m-1.2 6.776a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice6: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5.5h9s2 0 2 2v9s0 2-2 2h-9s-2 0-2-2v-9s0-2 2-2\"/><path d=\"M9 3.5a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-5 0a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m5 7a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0M9 7a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-5 3.5a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0M4 7a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice6Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v8A2.625 2.625 0 0 0 3 13.625h8A2.625 2.625 0 0 0 13.625 11V3A2.625 2.625 0 0 0 11 .375zM1.625 3c0-.76.616-1.375 1.375-1.375h8c.76 0 1.375.616 1.375 1.375v8c0 .76-.616 1.375-1.375 1.375H3c-.76 0-1.375-.616-1.375-1.375zM4.5 4.75a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m6.25-1.25a1.25 1.25 0 1 0-2.5 0a1.25 1.25 0 0 0 2.5 0M9.5 11.75a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m0-3.5a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m-5 3.5a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5m0-3.5a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDice6Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 11.5 0zm2.735 3.57a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m-1.2 8.06a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4M5.235 7a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m4.73-2.23a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4m1.2 5.66a1.2 1.2 0 1 1-2.4 0a1.2 1.2 0 0 1 2.4 0m-1.2-2.23a1.2 1.2 0 1 0 0-2.4a1.2 1.2 0 0 0 0 2.4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDicesEntertainmentGamingDices: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.929 3.286V1.5a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v5.429a1 1 0 0 0 1 1h1.786m3.785-1.858H12.5s1 0 1 1V12.5s0 1-1 1H7.071s-1 0-1-1V7.071s0-1 1-1\"/><path d=\"M8.654 11.166a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5M3.221 3.505a.25.25 0 0 1 0-.5\"/><path d=\"M3.22 3.505a.25.25 0 0 0 0-.5m7.699 6.1a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDicesEntertainmentGamingDicesRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.48 0A1.48 1.48 0 0 0 0 1.48v5.395c0 .818.663 1.48 1.48 1.48h3.79v3.914c0 .887.719 1.606 1.606 1.606h5.394c.887 0 1.606-.719 1.606-1.606V6.875c0-.887-.72-1.606-1.606-1.606H8.356V1.481A1.48 1.48 0 0 0 6.875 0zm5.04 6.875c0-.196.16-.356.356-.356h5.394c.197 0 .356.16.356.356v5.394c0 .197-.16.356-.356.356H6.875a.356.356 0 0 1-.356-.356zm4.279.846a.87.87 0 1 0 0 1.74a.87.87 0 0 0 0-1.74m-3.322 2.832a.87.87 0 1 1 1.74 0a.87.87 0 0 1-1.74 0m-4.97-7.028a.87.87 0 0 1 .01-1.74h.01a.87.87 0 0 1-.01 1.74zm0 3.046a.87.87 0 0 1 .01-1.74h.01a.87.87 0 0 1-.01 1.74zM5.85 1.785a.87.87 0 1 1-.02 1.74a.87.87 0 0 1 .02-1.74\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDicesEntertainmentGamingDicesSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.25 1.25a1 1 0 0 1 1-1h6.437a1 1 0 0 1 1 1v2.813H6.313a2.25 2.25 0 0 0-2.25 2.25v2.374H1.25a1 1 0 0 1-1-1zm2.551 2.499h-.036c-.56 0-1.013-.453-1.013-1.013v-.013a1 1 0 0 1 1-1h.014A1.013 1.013 0 0 1 2.8 3.75m3.512 1.564a1 1 0 0 0-1 1v6.437a1 1 0 0 0 1 1h6.437a1 1 0 0 0 1-1V6.313a1 1 0 0 0-1-1zm4.569 3.659a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-1.7 2.12a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDictionaryLanguageBook: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 13.5H3a1.5 1.5 0 1 1 0-3h8.5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H3a1.5 1.5 0 0 0-1.5 1.46v10m10-1.46v3\"/><path d=\"M8.051 5.002h2.315l-2.46 3.473h2.605M3.512 5.986l1.066-3.199a.4.4 0 0 1 .38-.274v0c.173 0 .327.11.382.274l1.066 3.199M3.898 4.828H6.02\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDictionaryLanguageBookRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 0h8.5a1.625 1.625 0 0 1 1.625 1.625v7.75a1.625 1.625 0 0 1-1 1.5v1.875h.375a.625.625 0 1 1 0 1.25H3a2.125 2.125 0 0 1-2.125-2.125V2.068A2.125 2.125 0 0 1 3 0m8.5 9.75a.375.375 0 0 0 .375-.375v-7.75a.375.375 0 0 0-.375-.375H3a.875.875 0 0 0-.875.844V9.94c.272-.124.57-.189.875-.189zM5.813 6.183l-.244-.73H4.348l-.243.73a.625.625 0 0 1-1.186-.395L3.3 4.643l.009-.026l.676-2.027a1.027 1.027 0 0 1 1.947 0l.676 2.026l.01.029l.38 1.143a.625.625 0 1 1-1.185.395m-.854-2.562l.194.582h-.388zm5.408.756a.625.625 0 0 1 .51.986L9.116 7.85h1.396a.625.625 0 1 1 0 1.25H7.907a.625.625 0 0 1-.51-.987l1.761-2.486H8.052a.625.625 0 1 1 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDictionaryLanguageBookSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 11.625V2.25A2.25 2.25 0 0 1 3.5 0h7a2.25 2.25 0 0 1 2.25 2.25V10a.75.75 0 0 1-.75.75h-.25v1.75H12a.75.75 0 0 1 0 1.5H3.625a2.375 2.375 0 0 1-2.375-2.375m9-.875H3.625a.875.875 0 0 0 0 1.75h6.625zm.56-5.978a.5.5 0 0 0-.443-.27H8.05a.5.5 0 0 0 0 1H9.4L7.499 8.186a.5.5 0 0 0 .408.789h2.604a.5.5 0 1 0 0-1H8.874l1.9-2.684a.5.5 0 0 0 .037-.519M5.815 2.63a.902.902 0 0 0-1.71 0l-.677 2.03l-.007.022l-.383 1.146a.5.5 0 1 0 .95.317l.27-.816H5.66l.272.816a.5.5 0 0 0 .949-.317l-.382-1.146l-.008-.022zM4.59 4.328l.368-1.102l.367 1.102z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDisableBellNotification: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 13.499l-13-13m10 9.996H13c-.442 0-.757-.175-1.07-.488a1.67 1.67 0 0 1-.487-1.178V4.942a4.443 4.443 0 0 0-8.42-1.979M6 13.501h2M2.557 5.499v3.33c0 .442-.175.866-.488 1.178c-.312.312-.627.488-1.069.488h6.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDisableBellNotificationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.182a.625.625 0 0 0 0 .884l12.75 12.75a.625.625 0 0 0 .884-.884l-1.536-1.536H13a.625.625 0 1 0 0-1.25c-.23 0-.395-.073-.627-.305a1.04 1.04 0 0 1-.305-.736V5.067A5.068 5.068 0 0 0 2.93 2.046L1.067.182a.625.625 0 0 0-.884 0M6 12.501a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zM3.182 5.875a.625.625 0 1 0-1.25 0v3.23c0 .276-.11.54-.305.736c-.232.232-.397.305-.627.305a.625.625 0 0 0 0 1.25h6.375a.625.625 0 1 0 0-1.25H2.932c.163-.32.25-.676.25-1.041z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDisableBellNotificationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.297 1.358A.75.75 0 0 1 1.358.298l1.721 1.72a4.94 4.94 0 0 1 8.86 3.004V9.43c0 .309.122.605.34.823c.249.248.443.341.716.341a.5.5 0 1 1 0 1h-.34l1.048 1.047a.75.75 0 0 1-1.061 1.061zm1.766 3.529l6.709 6.708H1.005a.5.5 0 0 1 0-1c.273 0 .467-.093.715-.34c.219-.22.341-.515.341-.824V5.02l.002-.134m3.188 8.295a.75.75 0 0 1 .75-.75h1.998a.75.75 0 0 1 0 1.5H6.001a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDisableHeart: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m8.5 10.904l-.571.53a1 1 0 0 1-1.36 0L2.404 7.575c-.977-.954-1.095-2.23-.676-3.28M2.85 2.862c1.121-.78 2.785-.765 4.4 1.063c3.649-4.134 7.557 1.002 4.844 3.65L9.749 9.742M.5.5l13 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDisableHeartRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 0 0 .884l12.75 12.75a.625.625 0 0 0 .884-.884l-3.118-3.118l2.112-1.956l.014-.014c1.787-1.764 1.35-4.331-.058-5.746C12.05 1.378 11.05.917 9.916.998c-.972.07-1.972.532-2.923 1.446C6.042 1.528 5.044 1.062 4.074.99a3.5 3.5 0 0 0-1.835.365L1.067.183a.625.625 0 0 0-.884 0m.715 3.392a.625.625 0 0 1 .447.763c-.23.882-.061 1.854.687 2.612l4.96 4.593l.583-.54a.625.625 0 0 1 .85.917l-1.009.933a.625.625 0 0 1-.849 0L1.172 7.858l-.018-.017C.05 6.73-.193 5.283.135 4.022a.625.625 0 0 1 .763-.447\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDisableHeartSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.28.22A.75.75 0 1 0 .22 1.28l12.5 12.5a.75.75 0 1 0 1.06-1.06l-3.247-3.248l1.652-1.53l.01-.009c1.594-1.557 1.217-3.825-.032-5.08c-.636-.637-1.519-1.043-2.52-.973C8.77 1.941 7.865 2.36 7 3.2c-.865-.84-1.77-1.259-2.643-1.32a3.1 3.1 0 0 0-1.25.166zm.526 7.713C.59 6.747.52 5.148 1.108 3.9l7.434 7.417l-.522.484a1.5 1.5 0 0 1-2.04 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscord: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path d=\"M4.112 6.5a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m4.5 0a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.858 9.864c0-2.401.858-5.574 1.715-6.86c0 0 .858-.43 4.289-.43s4.288.43 4.288.43c.858 1.286 1.715 4.459 1.715 6.86c-.285.43-1.286 1.373-3.001 1.716l-1.51-1.886a6.6 6.6 0 0 1-2.985 0L3.86 11.58c-1.715-.343-2.716-1.287-3.002-1.716\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.86 9.007c.261.261.81.523 1.509.687a6.6 6.6 0 0 0 2.986 0c.699-.164 1.247-.426 1.509-.687\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscordRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.198 1.66a.625.625 0 0 0-.656.508l-.1.53H5.558l-.1-.53a.625.625 0 0 0-.656-.508c-.958.065-1.59.166-1.994.256a4 4 0 0 0-.45.123a2 2 0 0 0-.164.063l-.015.007l-.006.003l-.003.002h-.002l.279.56l-.28-.559a.6.6 0 0 0-.24.213c-.514.77-.99 2.035-1.338 3.39c-.352 1.369-.59 2.902-.59 4.243c0 .123.037.244.105.346c.397.597 1.604 1.692 3.585 2.088c.23.046.465-.04.61-.222l1.364-1.704a7.7 7.7 0 0 0 2.673 0L9.7 12.173a.63.63 0 0 0 .61.222c1.981-.396 3.188-1.491 3.586-2.088A.63.63 0 0 0 14 9.962c0-1.34-.237-2.874-.588-4.243c-.348-1.355-.824-2.62-1.338-3.39a.6.6 0 0 0-.24-.213l-.28.56l.279-.56l-.002-.001l-.003-.002l-.007-.003l-.015-.007a1 1 0 0 0-.163-.063a4 4 0 0 0-.45-.123c-.405-.09-1.037-.191-1.995-.256m-7.4 4.369c.306-1.193.694-2.215 1.061-2.837q.084-.024.222-.056a10 10 0 0 1 1.252-.184l.09.486c.056.295.314.51.615.51h3.924c.3 0 .558-.215.614-.51l.09-.486c.596.057.997.127 1.253.184q.139.031.222.056c.366.622.754 1.644 1.06 2.837c.313 1.222.524 2.56.547 3.723c-.306.354-1.073 1-2.318 1.333l-.788-.985c.405-.167.752-.372.988-.608a.625.625 0 1 0-.884-.884c-.155.155-.602.398-1.303.563a6.4 6.4 0 0 1-2.886 0c-.702-.165-1.148-.408-1.303-.563a.625.625 0 1 0-.884.884c.236.236.583.441.988.608l-.788.985c-1.246-.332-2.012-.979-2.319-1.333c.023-1.163.234-2.501.548-3.723m2.859-.71a1.115 1.115 0 1 0 0 2.231a1.115 1.115 0 0 0 0-2.23m4.414 0a1.115 1.115 0 1 0 0 2.231a1.115 1.115 0 0 0 0-2.23\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscordSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.226 2.768c-.425.697-.868 1.86-1.213 3.204c-.35 1.366-.586 2.869-.604 4.17c.338.417 1.259 1.219 2.78 1.595l1.088-1.36c-.526-.19-.968-.433-1.246-.711a.5.5 0 0 1 .707-.707c.205.204.729.478 1.502.66l.007.002a7.1 7.1 0 0 0 3.23 0h.006c.774-.184 1.298-.458 1.502-.662a.5.5 0 1 1 .707.707c-.277.278-.72.521-1.245.71l1.088 1.36c1.521-.375 2.442-1.177 2.78-1.593c-.019-1.302-.254-2.805-.604-4.171c-.345-1.345-.788-2.507-1.213-3.204l-.03-.009a6 6 0 0 0-.715-.156c-.71-.119-1.924-.242-3.891-.242s-3.18.123-3.892.242c-.355.06-.582.117-.714.156zm-.331-.41a31 31 0 0 1-.223-.448h.002l.003-.002l.008-.004l.02-.009l.059-.024q.071-.029.204-.07c.179-.053.448-.12.838-.185c.78-.13 2.05-.255 4.056-.255s3.277.126 4.056.255c.39.065.66.132.838.186a3 3 0 0 1 .263.093l.02.01l.007.003l.004.001l.001.001h.001l-.223.448M4.407 7.077a1 1 0 1 0 0-2a1 1 0 0 0 0 2m5.91-1a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentBadge: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.83.998a1.895 1.895 0 0 1 2.392 0l.333.27l.423-.067a1.895 1.895 0 0 1 2.072 1.196l.152.4l.401.153A1.895 1.895 0 0 1 12.8 5.022l-.068.423l.27.333a1.895 1.895 0 0 1 0 2.392l-.27.333l.068.423a1.895 1.895 0 0 1-1.196 2.072l-.4.153l-.153.4a1.895 1.895 0 0 1-2.072 1.196l-.423-.068l-.333.271a1.895 1.895 0 0 1-2.392 0l-.333-.27l-.423.067a1.895 1.895 0 0 1-2.072-1.196l-.153-.4l-.4-.153a1.895 1.895 0 0 1-1.196-2.072l.068-.423l-.271-.333a1.895 1.895 0 0 1 0-2.392l.27-.333l-.067-.423A1.895 1.895 0 0 1 2.449 2.95l.4-.152l.153-.401A1.895 1.895 0 0 1 5.074 1.2l.423.068zM4.526 9.474l5-5\"/><path d=\"M5.026 5.474a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m4 4a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentBadgeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.203 1.533a1.26 1.26 0 0 1 1.594 0l.331.27c.138.112.318.16.494.132l.422-.068a1.26 1.26 0 0 1 1.38.797l.152.4a.63.63 0 0 0 .36.36l.4.153c.56.213.892.789.797 1.38l-.068.421a.63.63 0 0 0 .132.494l.27.331c.377.464.377 1.13 0 1.594l-.27.331a.63.63 0 0 0-.132.494l.068.422a1.26 1.26 0 0 1-.797 1.38l-.4.152a.63.63 0 0 0-.36.36l-.153.4c-.213.56-.789.892-1.38.797l-.421-.068a.63.63 0 0 0-.494.132l-.331.27a1.26 1.26 0 0 1-1.594 0l-.331-.27a.63.63 0 0 0-.494-.132l-.422.068a1.26 1.26 0 0 1-1.38-.797l-.152-.4a.63.63 0 0 0-.36-.36l-.4-.153a1.26 1.26 0 0 1-.797-1.38l.068-.421a.63.63 0 0 0-.132-.494l-.27-.331a1.26 1.26 0 0 1 0-1.594l.27-.331a.63.63 0 0 0 .132-.494l-.068-.422a1.26 1.26 0 0 1 .797-1.38l.4-.152a.63.63 0 0 0 .36-.36l.153-.4c.213-.56.789-.892 1.38-.797l.421.068a.63.63 0 0 0 .494-.132zm2.382-.97a2.51 2.51 0 0 0-3.17 0L5.3.656L5.155.633a2.51 2.51 0 0 0-2.746 1.586l-.053.137l-.137.053A2.51 2.51 0 0 0 .633 5.155l.023.145l-.093.115a2.51 2.51 0 0 0 0 3.17l.093.115l-.023.145a2.51 2.51 0 0 0 1.586 2.746l.137.053l.053.138a2.51 2.51 0 0 0 2.746 1.585l.145-.023l.115.093a2.51 2.51 0 0 0 3.17 0l.115-.093l.145.023a2.51 2.51 0 0 0 2.746-1.585l.053-.138l.138-.053a2.51 2.51 0 0 0 1.585-2.746l-.023-.145l.093-.115a2.51 2.51 0 0 0 0-3.17l-.093-.115l.023-.145a2.51 2.51 0 0 0-1.585-2.746l-.138-.053l-.053-.137A2.51 2.51 0 0 0 8.845.633L8.7.656zm1.357 4.379a.625.625 0 0 0-.884-.884l-5 5a.625.625 0 1 0 .884.884zM5 3.875a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25M7.875 9a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentBadgeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.514.61a2.395 2.395 0 0 1 3.023 0l.16.13l.202-.033a2.395 2.395 0 0 1 2.618 1.512l.073.191l.191.073a2.395 2.395 0 0 1 1.512 2.618l-.033.203l.13.159l-.341.277l.34-.277c.717.88.717 2.142 0 3.023l-.129.159l.033.202a2.395 2.395 0 0 1-1.512 2.618l-.191.073l-.073.192a2.395 2.395 0 0 1-2.618 1.511l-.203-.032l-.159.129a2.395 2.395 0 0 1-3.023 0l.316-.388l-.316.388l-.159-.13l-.202.033a2.395 2.395 0 0 1-2.618-1.511l-.073-.192l-.192-.073A2.395 2.395 0 0 1 .76 8.847l.033-.202l-.13-.16a2.395 2.395 0 0 1 0-3.022l.13-.16l-.033-.202a2.395 2.395 0 0 1 1.51-2.618l.192-.073l.073-.191A2.395 2.395 0 0 1 5.153.707l.202.033zm4.454 3.422a.625.625 0 0 0-.884 0l-5 5a.625.625 0 1 0 .884.884l5-5a.625.625 0 0 0 0-.884m-4.942-.058a1 1 0 1 0 0 2a1 1 0 0 0 0-2m4 4a1 1 0 1 0 0 2a1 1 0 0 0 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m-2.5-4l5-5\"/><path d=\"M5 5.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m4 4a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0m2.942 4.058a.625.625 0 0 0-.884 0l-5 5a.625.625 0 1 0 .884.884l5-5a.625.625 0 0 0 0-.884M5 3.875a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25m4 4a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0m-3.812-3.188a.625.625 0 0 0-.884 0L3.812 9.304a.625.625 0 1 0 .884.884l5.492-5.492a.625.625 0 0 0 0-.884M4.803 3.63a1.174 1.174 0 1 0 0 2.349a1.174 1.174 0 0 0 0-2.349m4.394 4.393a1.174 1.174 0 1 0 0 2.349a1.174 1.174 0 0 0 0-2.349\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCoupon: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 11a1 1 0 0 0 .998 1h11.004a1 1 0 0 0 .998-1V8.966a2.037 2.037 0 0 1 0-3.932V3a1 1 0 0 0-.998-1H1.498A1 1 0 0 0 .5 3v2.03a2.037 2.037 0 0 1 0 3.94zm4.02-1.5l5-5\"/><path d=\"M5.02 5.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m4 4a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCouponRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2.5c0-.208.168-.375.373-.375h10.754c.205 0 .373.167.373.375v2.104a2.662 2.662 0 0 0 0 4.793V11.5a.374.374 0 0 1-.373.375H1.623a.374.374 0 0 1-.373-.375V9.404a2.662 2.662 0 0 0 0-4.808zM1.623.875C.726.875 0 1.604 0 2.5v2.53c0 .284.192.532.466.604a1.412 1.412 0 0 1 0 2.732A.625.625 0 0 0 0 8.97v2.53c0 .897.726 1.625 1.623 1.625h10.754c.897 0 1.623-.728 1.623-1.625V8.966a.625.625 0 0 0-.461-.603a1.412 1.412 0 0 1 0-2.726a.625.625 0 0 0 .461-.603V2.5c0-.896-.726-1.625-1.623-1.625zm8.319 3.183a.625.625 0 0 0-.884 0l-5 5a.625.625 0 1 0 .884.884l5-5a.625.625 0 0 0 0-.884M3.875 5a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0M9 7.875a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCouponSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 11c0 .828.67 1.5 1.498 1.5h11.004C13.33 12.5 14 11.828 14 11V8.966a.5.5 0 0 0-.369-.483a1.537 1.537 0 0 1 0-2.966a.5.5 0 0 0 .369-.483V3c0-.828-.67-1.5-1.498-1.5H1.498C.67 1.5 0 2.172 0 3v2.03a.5.5 0 0 0 .373.483a1.537 1.537 0 0 1 0 2.974A.5.5 0 0 0 0 8.97zm4.962-1.058l5-5a.625.625 0 0 0-.883-.884l-5 5a.625.625 0 1 0 .883.884M4.021 5a1 1 0 1 1 2 0a1 1 0 0 1-2 0m4 4a1 1 0 1 1 2 0a1 1 0 0 1-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCutout: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.5 9.5l5-5m-5 .5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m5 5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m3-9.5a1 1 0 0 1 1 1m-13 0a1 1 0 0 1 1-1m0 13a1 1 0 0 1-1-1m13 0a1 1 0 0 1-1 1m-8-13h1m3 0h1m-5 13h1m3 0h1m4-9v1m0 3v1m-13-5v1m0 3v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCutoutRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625A.375.375 0 0 0 1.625 2v.875a.625.625 0 1 1-1.25 0V2A1.625 1.625 0 0 1 2 .375h.875a.625.625 0 1 1 0 1.25zM10.5 1c0-.345.28-.625.625-.625H12A1.625 1.625 0 0 1 13.625 2v.875a.625.625 0 1 1-1.25 0V2A.375.375 0 0 0 12 1.625h-.875A.625.625 0 0 1 10.5 1M5.625.375a.625.625 0 1 0 0 1.25h2.75a.625.625 0 1 0 0-1.25zm3.433 3.683a.625.625 0 1 1 .884.884l-5 5a.625.625 0 0 1-.884-.884zM3.875 5a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0m4 4a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0m5.75 2.125a.625.625 0 1 0-1.25 0V12a.375.375 0 0 1-.375.375h-.875a.625.625 0 1 0 0 1.25H12A1.625 1.625 0 0 0 13.625 12zM13 5c.345 0 .625.28.625.625v2.75a.625.625 0 1 1-1.25 0v-2.75c0-.345.28-.625.625-.625M2.875 13.625a.625.625 0 1 0 0-1.25H2A.375.375 0 0 1 1.625 12v-.875a.625.625 0 1 0-1.25 0V12A1.625 1.625 0 0 0 2 13.625zM9 13c0 .345-.28.625-.625.625h-2.75a.625.625 0 1 1 0-1.25h2.75c.345 0 .625.28.625.625M.375 8.375a.625.625 0 1 0 1.25 0v-2.75a.625.625 0 1 0-1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentCutoutSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.62 1.62a.2.2 0 0 1 .143-.06a.75.75 0 1 0 0-1.5A1.7 1.7 0 0 0 .06 1.763a.75.75 0 0 0 1.5 0c0-.054.022-.105.06-.143m9.867-.81a.75.75 0 0 1 .75-.75a1.7 1.7 0 0 1 1.703 1.703a.75.75 0 0 1-1.5 0a.2.2 0 0 0-.203-.203a.75.75 0 0 1-.75-.75M4.825 3.64a1.185 1.185 0 1 0 0 2.37a1.185 1.185 0 0 0 0-2.37m5.086 1.51L5.15 9.91a.75.75 0 1 1-1.06-1.06l4.76-4.76a.75.75 0 0 1 1.06 1.06m-.736 2.84a1.185 1.185 0 1 0 0 2.37a1.185 1.185 0 0 0 0-2.37M.81 11.487a.75.75 0 0 1 .75.75a.2.2 0 0 0 .203.203a.75.75 0 0 1 0 1.5A1.7 1.7 0 0 1 .06 12.237a.75.75 0 0 1 .75-.75m13.13.75a.75.75 0 0 0-1.5 0a.2.2 0 0 1-.203.203a.75.75 0 0 0 0 1.5a1.7 1.7 0 0 0 1.702-1.703M3.87.81a.75.75 0 0 1 .75-.75h.952a.75.75 0 0 1 0 1.5h-.953a.75.75 0 0 1-.75-.75M8.427.06a.75.75 0 0 0 0 1.5h.953a.75.75 0 1 0 0-1.5zM3.87 13.19a.75.75 0 0 1 .75-.75h.953a.75.75 0 0 1 0 1.5H4.62a.75.75 0 0 1-.75-.75m4.56-.75a.75.75 0 0 0 0 1.5h.952a.75.75 0 0 0 0-1.5zm4.76-8.57a.75.75 0 0 1 .75.75v.952a.75.75 0 0 1-1.5 0v-.953a.75.75 0 0 1 .75-.75m.75 4.558a.75.75 0 0 0-1.5 0v.953a.75.75 0 0 0 1.5 0zM.81 3.87a.75.75 0 0 1 .75.75v.953a.75.75 0 0 1-1.5 0V4.62a.75.75 0 0 1 .75-.75m.75 4.56a.75.75 0 0 0-1.5 0v.952a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentFire: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.247 8.462c0-5.008-4.423-7.326-6.506-7.868c.78 1.95.737 3.393-.27 5.171a.478.478 0 0 1-.777.069l-1.28-1.452c-3.35 3.558-1.422 9.281 3.881 9.015c4.057-.25 4.952-2.952 4.952-4.935m-6.58 2.462L8.951 7.64\"/><path d=\"M6.065 8.118a.25.25 0 1 1 0-.5m0 .5a.25.25 0 0 0 0-.5m2.659 3.329a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentFireRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.858.019a.625.625 0 0 0-.73.845c.379.917.537 1.666.503 2.368c-.032.652-.232 1.31-.651 2.064L3.775 3.974a.625.625 0 0 0-.91-.015C.979 5.899.549 8.469 1.394 10.543c.853 2.095 2.967 3.592 5.94 3.447h.007c2.259-.135 3.705-1.067 4.573-2.23a5.7 5.7 0 0 0 1.105-3.305c0-2.706-1.242-4.687-2.748-6.046C8.78 1.063 7.011.31 5.858.02M6.88 3.292a5.7 5.7 0 0 0-.18-1.67a9.8 9.8 0 0 1 2.734 1.716c1.304 1.175 2.335 2.839 2.335 5.117c0 .655-.203 1.68-.857 2.558c-.635.85-1.733 1.614-3.642 1.729c-2.477.12-4.078-1.099-4.718-2.67c-.582-1.43-.4-3.227.77-4.738l.845.926c.485.532 1.403.508 1.801-.173c.554-.948.866-1.847.912-2.795m2.192 4.79a.625.625 0 1 0-.884-.883l-3.283 3.283a.625.625 0 0 0 .884.884zm-3.328.66a.875.875 0 1 0 0-1.75a.875.875 0 1 0 0 1.75m2.66 2.83a.875.875 0 0 1 0-1.75a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscountPercentFireSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.365.263A.5.5 0 0 1 5.867.11c1.109.289 2.813 1.04 4.249 2.377c1.447 1.349 2.631 3.306 2.631 5.975c0 1.057-.237 2.35-1.058 3.421c-.834 1.09-2.217 1.88-4.363 2.013H7.32c-2.86.144-4.868-1.342-5.675-3.389c-.8-2.029-.399-4.553 1.404-6.468a.5.5 0 0 1 .74.012l1.265 1.436c.463-.826.688-1.546.722-2.267c.035-.733-.127-1.507-.5-2.44a.5.5 0 0 1 .09-.517m-.05 7.605a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m3.99.126a.5.5 0 0 0-.708-.707L5.314 10.57a.5.5 0 1 0 .707.707zm-1.33 2.703a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscussionConverstionReply: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.052 6.906V2.314a.845.845 0 0 1 .845-.845h8.22a.845.845 0 0 1 .845.845v.53M2.052 9.03v.965l-.845 2.535l3.38-.845h6.53a.845.845 0 0 0 .845-.845V4.875\"/><path d=\"M.65 5.612L2.038 7l1.388-1.388m7.148.636l1.388-1.388l1.388 1.388\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscussionConverstionReplyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 0c-.897 0-1.625.728-1.625 1.625V3.5H.5a.5.5 0 0 0-.354.854l1.5 1.5a.5.5 0 0 0 .708 0l1.5-1.5A.5.5 0 0 0 3.5 3.5h-.875V1.625c0-.207.168-.375.375-.375h8c.207 0 .375.168.375.375V4a.625.625 0 1 0 1.25 0V1.625C12.625.728 11.898 0 11 0zm8.375 8.5H10.5a.5.5 0 0 1-.354-.854l1.5-1.5a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1-.354.854h-.875v2.375c0 .898-.727 1.625-1.625 1.625H5.104L.828 13.966a.625.625 0 0 1-.785-.82l1.332-3.39V8a.625.625 0 1 1 1.25 0v1.875a.6.6 0 0 1-.043.229L1.7 12.345l3.096-1.061A.6.6 0 0 1 5 11.25h6a.375.375 0 0 0 .375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDiscussionConverstionReplySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.013 2.375a.07.07 0 0 0-.071.071v2.73l.055-.055a.75.75 0 1 1 1.06 1.06L2.71 7.532a.75.75 0 0 1-1.06 0L.298 6.18a.75.75 0 0 1 1.061-1.06l.082.082V2.446A1.57 1.57 0 0 1 3.013.875H11a1.57 1.57 0 0 1 1.572 1.571v.265a.75.75 0 0 1-1.5 0v-.265A.07.07 0 0 0 11 2.375zm9.558 4.356l.07.069a.75.75 0 1 0 1.06-1.06l-1.349-1.35a.75.75 0 0 0-1.06 0l-1.35 1.35a.75.75 0 1 0 1.062 1.06l.068-.068v4a.07.07 0 0 1-.072.072H4.656a.8.8 0 0 0-.182.022l-1.96.49l.39-1.168a.8.8 0 0 0 .038-.237v-.687a.75.75 0 0 0-1.5 0v.565l-.783 2.349a.75.75 0 0 0 .894.965l3.195-.8H11a1.57 1.57 0 0 0 1.572-1.57z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDivisionCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.25A6.25 6.25 0 1 0 7 .75a6.25 6.25 0 0 0 0 12.5M4.044 7.006h5.977\"/><path d=\"M7 4.386a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m0 6.239a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDivisionCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 5.125a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m-3 1.25a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25zm3 4.25a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDivisionCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.25 7a6.75 6.75 0 1 1 13.5 0A6.75 6.75 0 0 1 .25 7m3.794-.62a.625.625 0 1 0 0 1.25h5.977a.625.625 0 0 0 0-1.25zM7 5.012a.875.875 0 1 1 0-1.75a.875.875 0 1 1 0 1.75m0 5.74A.875.875 0 1 1 7 9a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDna: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.1 3.9a4.65 4.65 0 0 0 3.4.1M4 13.5a4.68 4.68 0 0 0-.1-3.41a4.74 4.74 0 0 1 1-5.16a4.8 4.8 0 0 1 2.46-1.3\"/><path d=\"M6.6 10.37a4.8 4.8 0 0 0 2.47-1.31a4.73 4.73 0 0 0 1-5.16A4.65 4.65 0 0 1 10 .5M.5 10a4.6 4.6 0 0 1 3.4.11m1.04-5.18l4.13 4.13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDnaRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.462.842A.625.625 0 0 0 9.289.409a5.28 5.28 0 0 0 .08 3.857v.001a4.1 4.1 0 0 1-.29 3.742L5.927 4.855a4.2 4.2 0 0 1 1.678-.736a.625.625 0 0 0-.238-1.227a5.43 5.43 0 0 0-2.78 1.469l-.006.005A5.37 5.37 0 0 0 3.113 9.06a5.2 5.2 0 0 0-2.7.227a.625.625 0 1 0 .424 1.176a3.98 3.98 0 0 1 2.713.005c.302.871.3 1.823-.013 2.696a.625.625 0 1 0 1.177.422A5.3 5.3 0 0 0 4.6 9.722a4.12 4.12 0 0 1 .306-3.765L8.069 9.12c-.504.38-1.09.641-1.714.763a.625.625 0 0 0 .24 1.227a5.44 5.44 0 0 0 2.79-1.48l.004-.004A5.36 5.36 0 0 0 10.86 4.94c.906.165 1.847.09 2.727-.226a.625.625 0 0 0-.423-1.176a4.03 4.03 0 0 1-2.738-.005a4.03 4.03 0 0 1 .035-2.69\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDnaSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.563 1.065a.75.75 0 1 0-1.407-.52a5.18 5.18 0 0 0 .078 3.79v.001a3.76 3.76 0 0 1-.318 3.51L6.138 5.068c.409-.264.866-.45 1.348-.543A.75.75 0 1 0 7.2 3.052a5.3 5.3 0 0 0-2.73 1.442l-.006.006a5.27 5.27 0 0 0-1.473 4.396a5.1 5.1 0 0 0-2.441.258a.75.75 0 1 0 .509 1.41a3.63 3.63 0 0 1 2.41-.02a3.7 3.7 0 0 1-.035 2.398a.75.75 0 0 0 1.412.505a5.2 5.2 0 0 0-.11-3.794a3.77 3.77 0 0 1 .334-3.53l2.787 2.786c-.417.276-.887.47-1.383.567a.75.75 0 0 0 .287 1.472a5.33 5.33 0 0 0 2.74-1.453l.004-.004a5.26 5.26 0 0 0 1.476-4.388c.824.114 1.67.03 2.466-.256a.75.75 0 1 0-.507-1.412a3.68 3.68 0 0 1-2.434.02a3.68 3.68 0 0 1 .056-2.39\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDollarCoin: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M8.702 5.222a1.33 1.33 0 0 0-1.258-.889H6.412a1.19 1.19 0 0 0-.254 2.353l1.571.344a1.334 1.334 0 0 1-.285 2.637h-.888a1.33 1.33 0 0 1-1.258-.89M7 4.333V3m0 8V9.666\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDollarCoin1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.806 4.24a1.02 1.02 0 0 0-.961-.68h-.79a.91.91 0 0 0-.194 1.798l1.202.263a1.02 1.02 0 0 1-.218 2.016h-.68a1.02 1.02 0 0 1-.961-.68M8.505 3.56V2.54m0 6.116v-1.02\"/><path d=\"M3.614 5.598a4.891 4.891 0 1 0 9.782 0a4.891 4.891 0 1 0-9.782 0m-2.411.536a4.89 4.89 0 0 0 6.437 6.73\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDollarCoin1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.25 5.5a4.25 4.25 0 1 1 8.5 0a4.25 4.25 0 0 1-8.5 0m4.496 5.495A4.502 4.502 0 0 1 0 9.5a4.5 4.5 0 0 1 3.005-4.246a5.5 5.5 0 1 1 5.74 5.74m.384-8.428a.625.625 0 1 0-1.25 0v.28a1.535 1.535 0 0 0-.152 3.024l1.201.263a.395.395 0 0 1-.084.78h-.68a.395.395 0 0 1-.372-.263a.625.625 0 1 0-1.178.416c.194.552.675.969 1.265 1.072v.294a.625.625 0 0 0 1.25 0v-.294a1.645 1.645 0 0 0 .066-3.227l-1.2-.261a.285.285 0 0 1 .06-.564h.79a.39.39 0 0 1 .372.263a.625.625 0 0 0 1.178-.416A1.65 1.65 0 0 0 9.13 2.86z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDollarCoin1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.79 5.509a5.196 5.196 0 1 1-10.393 0a5.196 5.196 0 0 1 10.393 0M8.594 1.585a.75.75 0 0 1 .75.75v.317a1.77 1.77 0 0 1 1.258 1.131a.75.75 0 0 1-1.415.5a.27.27 0 0 0-.254-.179h-.787a.16.16 0 0 0-.035.316l1.201.262a1.77 1.77 0 0 1 .033 3.45v.317a.75.75 0 0 1-1.5 0v-.317a1.77 1.77 0 0 1-1.258-1.131A.75.75 0 1 1 8 6.5a.27.27 0 0 0 .254.18h.68a.27.27 0 0 0 .057-.533L7.79 5.885a1.66 1.66 0 0 1 .054-3.254v-.296a.75.75 0 0 1 .75-.75m0 10.37q.49 0 .96-.071a5.196 5.196 0 1 1-7.34-7.303a6.446 6.446 0 0 0 6.38 7.374\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDollarCoinRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0m.625 3a.625.625 0 1 0-1.25 0v.709a1.815 1.815 0 0 0-.35 3.588l1.57.344a.709.709 0 0 1-.15 1.4h-.889a.71.71 0 0 1-.669-.471a.625.625 0 1 0-1.178.416a1.96 1.96 0 0 0 1.666 1.297V11a.625.625 0 0 0 1.25 0v-.716a1.96 1.96 0 0 0 .238-3.865l-1.571-.343a.565.565 0 0 1 .12-1.118h1.032a.705.705 0 0 1 .669.473a.625.625 0 1 0 1.178-.417a1.96 1.96 0 0 0-1.666-1.297z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDollarCoinSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M7.75 3.25a.75.75 0 0 0-1.5 0v.51a1.866 1.866 0 0 0-.2 3.678l1.474.323a.5.5 0 0 1-.107.989h-.834a.5.5 0 0 1-.471-.333a.75.75 0 0 0-1.415.5c.239.674.83 1.184 1.553 1.305v.528a.75.75 0 0 0 1.5 0v-.528a2.001 2.001 0 0 0 .094-3.927l-1.473-.322a.366.366 0 0 1 .078-.723h.968a.5.5 0 0 1 .471.333a.75.75 0 1 0 1.415-.5A2 2 0 0 0 7.75 3.778z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDonut: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 7a2 2 0 1 0 4 0a2 2 0 1 0-4 0m6.5-.5l-.5 1M3 9l1 1m4-7.5l1 1\"/><path d=\"M3.5 4.75a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m5 7a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDonutRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.75 5.75 0 1 0 0 11.5a5.75 5.75 0 0 0 0-11.5M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m7-1.375a1.375 1.375 0 1 0 0 2.75a1.375 1.375 0 0 0 0-2.75M4.375 7a2.625 2.625 0 1 1 5.25 0a2.625 2.625 0 0 1-5.25 0m7.48-.22a.625.625 0 0 0-1.118-.56l-.5 1a.625.625 0 1 0 1.118.56zM2.683 8.433a.625.625 0 0 1 .884 0l1 1a.625.625 0 1 1-.884.884l-1-1a.625.625 0 0 1 0-.884m5.759-6.19a.625.625 0 1 0-.884.884l1 1a.625.625 0 1 0 .884-.884zM2.884 4.481a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m4.491 6.427a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDonutSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.5 7a6.5 6.5 0 1 1-13 0a6.5 6.5 0 0 1 13 0M9 7a2 2 0 1 1-4 0a2 2 0 0 1 4 0m3.059-.22a.625.625 0 0 0-1.118-.56l-.5 1a.625.625 0 0 0 1.118.56zm-9.5 1.778a.625.625 0 0 1 .883 0l1 1a.625.625 0 1 1-.884.884l-1-1a.625.625 0 0 1 0-.884m5.883-6.5a.625.625 0 1 0-.884.884l1 1a.625.625 0 1 0 .884-.884zM3.5 5.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m6 5.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadBox1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 13.5h-1a1 1 0 0 1-1-1v-8h13v8a1 1 0 0 1-1 1h-1\"/><path d=\"M4.5 11L7 13.5L9.5 11M7 13.5v-6M11.29 1a1 1 0 0 0-.84-.5h-6.9a1 1 0 0 0-.84.5L.5 4.5h13zM7 .5v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadBox1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.463.205A.63.63 0 0 0 10 0H7.75v4h4.125v5.125a.375.375 0 0 1-.375.375H11a.625.625 0 1 0 0 1.25h.5c.898 0 1.625-.727 1.625-1.625v-5.75a.63.63 0 0 0-.162-.42zm-4.088 7.17a.625.625 0 1 1 1.25 0V11H8.75a.625.625 0 0 1 .442 1.067l-1.75 1.75a.62.62 0 0 1-.884 0l-1.75-1.75A.625.625 0 0 1 5.25 11h1.125zM4 0a.63.63 0 0 0-.462.205l-2.5 2.75a.63.63 0 0 0-.163.42v5.75c0 .898.728 1.625 1.625 1.625H3A.625.625 0 1 0 3 9.5h-.5a.375.375 0 0 1-.375-.375V4H6.25V0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadBox1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H3.383A1.5 1.5 0 0 0 2.07.772L.347 3.875h6.028zM0 12.5V5.125h14V12.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5m13.653-8.625H7.625V0h2.992a1.5 1.5 0 0 1 1.312.772zm-9.3 6.479l2.293 2.293a.5.5 0 0 0 .708 0l2.292-2.293a.5.5 0 0 0-.353-.854H8v-2a1 1 0 1 0-2 0v2H4.707a.5.5 0 0 0-.353.854Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 8L7 10.5L9.5 8M7 10.5v-7\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 2.875c.345 0 .625.28.625.625v4.125H9.25a.625.625 0 0 1 .442 1.067l-2.25 2.25a.62.62 0 0 1-.436.183h-.012a.63.63 0 0 1-.436-.183l-2.25-2.25a.625.625 0 0 1 .442-1.067h1.625V3.5c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14m3.146-5.69l-2.793 2.793a.5.5 0 0 1-.707 0L3.854 8.31a.5.5 0 0 1 .353-.853H6V3.75a1 1 0 0 1 2 0v3.707h1.793a.5.5 0 0 1 .353.853\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v6m-2-2l2 2l2-2\"/><path d=\"M9.5 2H13a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h3.5M6 11l-1 2.5M8 11l1 2.5m-5 0h6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadComputerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625V5H8.75a.625.625 0 0 1 .442 1.067l-1.75 1.75A.62.62 0 0 1 7.006 8h-.012a.62.62 0 0 1-.436-.183l-1.75-1.75A.625.625 0 0 1 5.25 5h1.125V.625C6.375.28 6.655 0 7 0m1.789 11.5H12c.898 0 1.625-.727 1.625-1.625v-6c0-.897-.727-1.625-1.625-1.625H9.5a.625.625 0 1 0 0 1.25H12c.207 0 .375.168.375.375v6a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375v-6c0-.207.168-.375.375-.375h2.5a.625.625 0 1 0 0-1.25H2c-.897 0-1.625.728-1.625 1.625v6c0 .898.728 1.625 1.625 1.625h3.211l-.5 1.25H4A.625.625 0 1 0 4 14h6a.625.625 0 1 0 0-1.25h-.711z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadComputerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.646 5.06L7.353 7.355a.5.5 0 0 1-.707 0L4.354 5.06a.5.5 0 0 1 .353-.854H6V1a1 1 0 0 1 2 0v3.207h1.293a.5.5 0 0 1 .353.854M2.062 2.91h.937a1 1 0 1 0 0-2h-1.48C.713.91.061 1.562.061 2.367v7.309c0 .804.652 1.457 1.456 1.457h3.918l-.488 1.362H4a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-.948l-.488-1.362h3.917c.805 0 1.457-.653 1.457-1.457v-7.31c0-.804-.652-1.456-1.457-1.456H11a1 1 0 1 0 0 2h.94v6.222H2.061z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4z\"/><path d=\"m9 8l-2 2l-2-2m2 2V4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadFileRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h6.116l3.009 3.009v8.116a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v10.75A1.625 1.625 0 0 0 2.625 14h8.75A1.625 1.625 0 0 0 13 12.375V4a.63.63 0 0 0-.183-.442L9.442.183A.63.63 0 0 0 9 0zm3.75 4.5v2.875H5a.625.625 0 0 0-.442 1.067l2 2a.625.625 0 0 0 .884 0l2-2A.625.625 0 0 0 9 7.375H7.625V4.5a.625.625 0 1 0-1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDownloadFileSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h6a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5v-11c0-.398.158-.78.44-1.06m5.747 10.502l.104-.104c.116-.076.216-.176.292-.292l1.854-1.854a.625.625 0 0 0-.442-1.067h-1.25V4a1 1 0 0 0-2 0v3.625h-1.25a.625.625 0 0 0-.442 1.067l1.854 1.854c.076.116.176.216.292.292l.104.104a.625.625 0 0 0 .884 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDressingTable: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 7.5v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5M.5 7.5h13M7 7.5v6M9.5 10v1m-5-1v1M12 7.5v-2a5 5 0 0 0-10 0v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDressingTableRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a5.5 5.5 0 0 0-5.5 5.5v1.375H.625a.625.625 0 1 0 0 1.25h.75v4.25A1.625 1.625 0 0 0 3 14h8a1.625 1.625 0 0 0 1.625-1.625v-4.25h.75a.625.625 0 1 0 0-1.25H12.5V5.5A5.5 5.5 0 0 0 7 0m4 12.75H7.625V8.125h3.75v4.25a.375.375 0 0 1-.375.375m-4.625 0V8.125h-3.75v4.25A.375.375 0 0 0 3 12.75zM10 10.125a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0zm-5.25-.75a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDressingTableSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M13.25 7.5h-.5V5.75a5.75 5.75 0 0 0-11.5 0V7.5h-.5a.75.75 0 0 0 0 1.5H1a.25.25 0 0 1 .25.25v3A1.76 1.76 0 0 0 3 14h3a.25.25 0 0 0 .25-.25v-6A.25.25 0 0 0 6 7.5H3a.25.25 0 0 1-.25-.25v-1.5a4.25 4.25 0 0 1 8.5 0v1.5a.25.25 0 0 1-.25.25H8a.25.25 0 0 0-.25.25v6A.25.25 0 0 0 8 14h3a1.76 1.76 0 0 0 1.75-1.75v-3A.25.25 0 0 1 13 9h.25a.75.75 0 1 0 0-1.5M3.5 10.25a.75.75 0 0 1 1.5 0v1a.75.75 0 1 1-1.5 0zm7 1a.75.75 0 1 1-1.5 0v-1a.75.75 0 0 1 1.5 0z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDrone: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 1h4m5 0h4m-11 0v3m9-3v3m2 0H.5v1a2 2 0 0 0 2 2h1a3 3 0 0 0 3 3h1a3 3 0 0 0 3-3h1a2 2 0 0 0 2-2zm-10 3h7\"/><path d=\"M4 8.65A4.48 4.48 0 0 0 2.5 12v1h1M10 8.65A4.48 4.48 0 0 1 11.5 12v1h-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDroneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 1c0-.345.28-.625.625-.625h4a.625.625 0 1 1 0 1.25H3.625v1.75h6.75v-1.75H9a.625.625 0 1 1 0-1.25h4a.625.625 0 1 1 0 1.25h-1.375v1.75H13c.345 0 .625.28.625.625v1a2.625 2.625 0 0 1-2.554 2.624a3.6 3.6 0 0 1-.29.919a5.1 5.1 0 0 1 1.344 3.456V13c0 .345-.28.625-.625.625h-1.25a.625.625 0 1 1 0-1.25h.625v-.376a3.85 3.85 0 0 0-.84-2.407A3.63 3.63 0 0 1 7.5 10.625h-1a3.63 3.63 0 0 1-2.534-1.033a3.85 3.85 0 0 0-.841 2.407v.376h.625a.625.625 0 1 1 0 1.25H2.5A.625.625 0 0 1 1.875 13v-1.001A5.1 5.1 0 0 1 3.22 8.543a3.6 3.6 0 0 1-.29-.919A2.625 2.625 0 0 1 .374 5V4c0-.345.28-.625.625-.625h1.375v-1.75H1A.625.625 0 0 1 .375 1M3 4.625h9.375V5A1.375 1.375 0 0 1 11 6.375H3A1.375 1.375 0 0 1 1.625 5v-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDroneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.034.79a.75.75 0 0 1 .75-.75H4.61a.75.75 0 0 1 0 1.5H3.447V3.5h7.106V1.54H9.391a.75.75 0 0 1 0-1.5h3.825a.75.75 0 0 1 0 1.5h-1.163V3.5H13.5a.5.5 0 0 1 .5.5v1a2.5 2.5 0 0 1-2.44 2.5l-.06-.004h-9l-.06.003A2.5 2.5 0 0 1 0 5V4a.5.5 0 0 1 .5-.5h1.447V1.54H.784a.75.75 0 0 1-.75-.75m3.197 7.956h7.622c.55.585.794 1.38.9 2.064a7.7 7.7 0 0 1-.013 2.313a.75.75 0 0 1-.74.627h-1a.75.75 0 0 1 0-1.5h.326a6 6 0 0 0-.055-1.21a3.4 3.4 0 0 0-.2-.76q-.047.056-.096.105A3.5 3.5 0 0 1 7.5 11.41h-1a3.5 3.5 0 0 1-2.512-1.063a3.5 3.5 0 0 0-.175.694c-.064.412-.073.84-.054 1.209h.326a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.74-.627a7.7 7.7 0 0 1-.014-2.313c.106-.683.35-1.48.9-2.064\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDropbox: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.976 11.643l2.026 1.388l2.026-1.388M7 8.58l3.213-2.201l3.212 2.201l-3.212 2.201zm0-4.406l3.213-2.201l3.212 2.2l-3.212 2.202zM.575 8.58l3.212-2.2L7 8.58l-3.212 2.201zm0-4.406l3.212-2.201L7 4.173L3.787 6.376z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDropboxRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.839 1.087a.625.625 0 0 1 .699 0l3.187 2.148a.625.625 0 0 1 0 1.036l-2.421 1.631l2.42 1.632a.625.625 0 0 1 0 1.036l-3.186 2.148l-.05.03l-3.137 2.114a.625.625 0 0 1-.698 0l-3.124-2.105l-.067-.04L.275 8.57a.625.625 0 0 1 0-1.036l2.42-1.632l-2.42-1.63a.625.625 0 0 1 0-1.037l3.187-2.148a.625.625 0 0 1 .699 0L7 3zm-4.905 9.11L7 8.805l2.067 1.393l-2.065 1.392zM5.88 8.05L3.811 6.658L1.743 8.052L3.81 9.445zm2.24-4.298l2.07 1.394l2.068-1.394l-2.069-1.394zm2.072 5.69l2.066-1.391l-2.069-1.394L8.123 8.05zm-8.449-5.69l2.07 1.394L5.88 3.753L3.811 2.359z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineDropboxSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.313 3.132L3.656.84l3.343 2.292l-3.343 2.29zM10.344.84L7.001 3.132l3.343 2.29l3.344-2.29zm0 9.169L7 7.718l3.343-2.291h.001l3.344 2.291zM3.659 11.29L7.002 9l3.343 2.291l-3.343 2.291zm-.003-5.864L.313 7.718l3.343 2.291l3.343-2.291z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarHearing: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.54 3.19C.854 2.292 2.09.5 4.517.5c3.035 0 4.777 2.58 4.245 4.995c-.46 2.094-1.767 2.824-2.343 3.323c-.842.73-.842 1.325-1.147 2.288c-.177.557-.79 1.351-1.646 1.45c-.62.07-1.365-.225-2.164-1.24M13.5 9.786A3.714 3.714 0 0 1 9.786 13.5m1.997-3.784a1.997 1.997 0 0 1-1.997 1.997m.336-2.553a.93.93 0 0 1-.928.928\"/><path d=\"M2.346 4.496c.182-.45.83-1.326 1.97-1.24c1.14.085 2.118 1.24 1.715 2.31c-.404 1.072-.937.74-1.422 1.46c-.485.721-.304 2.167-1.383 2.383c-.672.134-1.026-.252-1.026-.252\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarHearingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.715 3.953A3.49 3.49 0 0 1 5.002 1.75c2.55 0 3.964 2.135 3.53 4.109c-.334 1.515-1.145 2.153-1.767 2.643q-.17.133-.318.258A3.64 3.64 0 0 0 5.4 10.33c-.4 1.135-1.15 1.92-2.027 1.92a1.62 1.62 0 0 1-1.622-1.622v-.04a.625.625 0 1 0-1.25 0v.04A2.87 2.87 0 0 0 3.372 13.5c1.697 0 2.75-1.464 3.206-2.755c.142-.406.36-.757.688-1.04q.1-.086.247-.198c.629-.487 1.802-1.396 2.239-3.38C10.354 3.395 8.372.5 5.002.5C2.28.5.895 2.511.535 3.54a.625.625 0 1 0 1.18.413m3.045.48c-.724-.055-1.168.505-1.295.818a.625.625 0 0 1-1.158-.47c.227-.56 1.048-1.708 2.546-1.595c.746.056 1.42.455 1.847 1.004c.431.555.653 1.322.363 2.09a2.4 2.4 0 0 1-.43.754a1.9 1.9 0 0 1-.506.406l-.143.08c-.183.102-.262.146-.373.31c-.06.09-.117.23-.18.45l-.063.238c-.042.161-.09.349-.136.495c-.162.515-.484 1.225-1.366 1.4a1.8 1.8 0 0 1-1.13-.118A1.6 1.6 0 0 1 2.303 10l-.011-.011l-.005-.005l-.002-.002V9.98h-.001l.46-.423l-.46.422a.625.625 0 0 1 .905-.86l.003.002a.4.4 0 0 0 .068.04a.57.57 0 0 0 .361.028c.17-.034.287-.133.418-.55c.042-.133.07-.243.102-.367c.024-.097.051-.202.088-.331c.07-.247.169-.547.345-.808c.292-.433.637-.618.844-.729l.085-.046a.7.7 0 0 0 .189-.146c.051-.058.123-.164.202-.372c.103-.275.045-.591-.18-.88a1.38 1.38 0 0 0-.954-.527m6.748 4.395a.75.75 0 0 0-1.5 0c0 .61-.495 1.105-1.107 1.105a.75.75 0 0 0 0 1.5a2.606 2.606 0 0 0 2.607-2.605m2.242.078a.75.75 0 0 0-1.5 0A3.347 3.347 0 0 1 8.9 12.25a.75.75 0 0 0 0 1.5a4.847 4.847 0 0 0 4.85-4.844\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarHearingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.53 3.03C1.1 1.752 2.36.371 4.455.371c2.966 0 4.635 2.183 4.635 4.36c0 2.093-1.303 3.426-2.237 4.112c-.586.43-.965.769-.965 1.283c0 1.278-1.044 2.17-2.146 2.414c-1.14.252-2.482-.14-3.186-1.527a1.85 1.85 0 0 1-.185-.841v-6.35c0-.254.041-.528.159-.792m2.833 1.384c.181-.547.564-.972 1.11-.972c.845 0 1.342.662 1.342 1.42c0 .47-.11.742-.234.923c-.134.194-.321.34-.58.505l-.133.083c-.22.136-.507.314-.728.53a1.73 1.73 0 0 0-.53 1.287c0 .233-.062.356-.108.416a.27.27 0 0 1-.169.105c-.139.025-.317-.043-.4-.24a.625.625 0 1 0-1.151.488a1.62 1.62 0 0 0 1.777.981c.355-.065.69-.255.934-.571c.243-.316.366-.721.366-1.179c0-.2.06-.298.158-.396c.111-.109.244-.192.446-.318l.21-.132c.293-.187.657-.443.937-.85c.29-.42.455-.948.455-1.632c0-1.274-.894-2.67-2.591-2.67c-1.34 0-2.043 1.06-2.298 1.83a.625.625 0 1 0 1.187.392m9.516 4.284a.75.75 0 0 1 .75.75a4.18 4.18 0 0 1-4.18 4.18a.75.75 0 0 1 0-1.5c1.48 0 2.68-1.2 2.68-2.68a.75.75 0 0 1 .75-.75m-1.694-.141a.75.75 0 0 0-1.5 0c0 .605-.49 1.095-1.095 1.095a.75.75 0 1 0 0 1.5a2.595 2.595 0 0 0 2.595-2.595\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarpods: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5a3 3 0 0 1 2 .76v4.48a3 3 0 0 1-2 .76a3 3 0 0 1-.5 0v5.75a1.25 1.25 0 0 1-2.5 0V3.5a3 3 0 0 1 3-3m-9 0a3 3 0 0 0-2 .76v4.48a3 3 0 0 0 2 .76q.25.022.5 0v5.75a1.25 1.25 0 0 0 2.5 0V3.5a3 3 0 0 0-3-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarpodsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.847.375a3.4 3.4 0 0 0-2.263.86a.63.63 0 0 0-.209.467v4.135c0 .178.076.348.21.467a3.4 3.4 0 0 0 2.098.856v4.686a1.779 1.779 0 0 0 3.557 0V3.77A3.394 3.394 0 0 0 2.847.375m0 0V1zm-1.222 5.16V2.004c.357-.246.782-.38 1.22-.379h.001A2.144 2.144 0 0 1 4.99 3.769v8.077a.529.529 0 0 1-1.057 0V6.538a.625.625 0 0 0-.682-.622q-.174.015-.348 0l-.058-.003a2.14 2.14 0 0 1-1.22-.378m9.53-3.91c.438 0 .863.133 1.22.379v3.53c-.357.247-.782.38-1.22.38q-.03 0-.058.002q-.174.015-.348 0a.625.625 0 0 0-.682.622v5.308a.529.529 0 0 1-1.057 0V3.77a2.144 2.144 0 0 1 2.144-2.144m2.26-.39a3.4 3.4 0 0 0-2.262-.86V1V.375A3.394 3.394 0 0 0 7.76 3.769v8.077a1.779 1.779 0 0 0 3.557 0V7.16a3.4 3.4 0 0 0 2.099-.856a.63.63 0 0 0 .209-.467V1.702a.63.63 0 0 0-.21-.467\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarpodsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.46.707a3.15 3.15 0 0 0-1.742-.523a3.146 3.146 0 0 0-3.145 3.145v9.217a1.31 1.31 0 0 0 2.621 0V6.475q.262.024.524 0c.623 0 1.229-.183 1.743-.524c.237-.157.354-.436.354-.721V1.428c0-.285-.117-.564-.354-.722M.54.707A3.15 3.15 0 0 1 2.281.184a3.146 3.146 0 0 1 3.145 3.145v9.217a1.31 1.31 0 0 1-2.621 0V6.475q-.262.024-.524 0A3.15 3.15 0 0 1 .539 5.95c-.237-.156-.354-.435-.354-.72V1.429c0-.285.117-.564.354-.722\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarth1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M1 9.5h1.75A1.75 1.75 0 0 0 4.5 7.75v-1.5A1.75 1.75 0 0 1 6.25 4.5A1.75 1.75 0 0 0 8 2.75V.57m5.5 6.33a3.56 3.56 0 0 0-1.62-.4H9.75a1.75 1.75 0 1 0 0 3.5A1.25 1.25 0 0 1 11 11.25v.87\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarth1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5 1.448V2.75A2.25 2.25 0 0 1 6.25 5A1.25 1.25 0 0 0 5 6.25v1.5A2.25 2.25 0 0 1 2.75 10h-.656A5.75 5.75 0 0 0 7 12.75c1.317 0 2.53-.443 3.5-1.188v-.312a.75.75 0 0 0-.75-.75a2.25 2.25 0 0 1 0-4.5h2.133q.403.002.794.083A5.76 5.76 0 0 0 8.5 1.448M14 6.923l-.001-.06A7 7 0 0 0 8.157.095A.5.5 0 0 0 7.994.07A7 7 0 1 0 14 6.923\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarth1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.502 7a5.498 5.498 0 0 1 7.702-5.038v.276a1.68 1.68 0 0 1-1.68 1.68a1.68 1.68 0 0 0-1.68 1.736v1.388a1.68 1.68 0 0 1-1.68 1.68H1.777A5.5 5.5 0 0 1 1.502 7m8.212 4.782a5.5 5.5 0 0 0 2.518-3.089l-.136-.1a3.2 3.2 0 0 0-1.417-.354H8.807a1.543 1.543 0 0 0 0 3.074a1.09 1.09 0 0 1 .907.47M7 .002a6.998 6.998 0 1 0 0 13.996A6.998 6.998 0 0 0 7 .002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarthAirplane: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 8.5a5 5 0 1 1-8.25-3.8\"/><path d=\"M5.28 6.65a1.6 1.6 0 0 0-.046 1.287a1.52 1.52 0 0 0 1.416.943a.77.77 0 0 1 .77.77v3.47M.57 9.27h1.85A1.54 1.54 0 0 1 4 10.81v2.45m9.26-11.29l-1-.34a.34.34 0 0 0-.39.13l-.73 1.13l-4-2A2.49 2.49 0 0 0 3.53 2.2a.68.68 0 0 0 .47.9l2.61.84l.26.09l.49 1.68a.36.36 0 0 0 .24.25l1.18.38a.37.37 0 0 0 .48-.41L9 4.68h.17l2.55.83a.67.67 0 0 0 .85-.41l.9-2.77a.34.34 0 0 0-.21-.36\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarthAirplaneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.529 1.438v1.09a1.98 1.98 0 0 0 1.98 1.982a.98.98 0 0 1 .981.98v1.27a1.98 1.98 0 0 0 1.981 1.98h.519a4.9 4.9 0 0 1-.962 1.104a.625.625 0 1 0 .809.952A6.125 6.125 0 1 0 1.83 5.137a.625.625 0 1 0 1.233.2A4.88 4.88 0 0 1 6.53 1.439M1.485 7.096a.59.59 0 0 0-.7.398l-.76 2.81l-.002.01a.92.92 0 0 0 .67 1.097l2.359.638l-.543.575a.61.61 0 0 0 .286 1.028l1.196.329l.008.002a.64.64 0 0 0 .558-.132l.004-.002l1.25-1.081l.103.009l2.625.703a.91.91 0 0 0 1.14-.65l.002-.008A2.73 2.73 0 0 0 7.148 9.52l-4.171-.493V7.946a.59.59 0 0 0-.416-.555l-.008-.003l-1.06-.29z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEarthAirplaneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.7 1.163l1.072.364a.364.364 0 0 1 .225.386l-.965 2.968a.72.72 0 0 1-.91.44l-2.733-.89h-.182l.278 1.34a.397.397 0 0 1-.514.44l-1.265-.408a.39.39 0 0 1-.257-.268l-.525-1.8l-.279-.097l-2.797-.9a.73.73 0 0 1-.503-.965A2.668 2.668 0 0 1 7.213.37L11.5 2.513l.782-1.211a.364.364 0 0 1 .418-.14M.01 8.32a5.66 5.66 0 0 1 2.692-4.819a2 2 0 0 0 .792.436l1.119.36a4.16 4.16 0 0 0-2.878 5.376h1.706a1.32 1.32 0 0 0 1.32-1.32v-1.09a1.32 1.32 0 0 1 1.32-1.364q.085 0 .169-.01a1.64 1.64 0 0 0 1.076 1.105l1.258.405h.002a1.646 1.646 0 0 0 2.118-1.225l.233.076A5.659 5.659 0 1 1 .01 8.32m5.995 4.146a4.16 4.16 0 0 0 3.173-1.911l-.1-.073a2.5 2.5 0 0 0-1.113-.278H6.494a1.213 1.213 0 0 0-.489 2.262\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEcologySciencePlanetSolarSystemRingPlanetSaturnSpaceAstronomy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.63 8.13C.85 10.49.05 12.53.76 13.24c1 1 4.6-1 8-4.44s5.44-7 4.44-8c-.64-.65-2.38 0-4.47 1.41\"/><path d=\"M12.05 4.92A5 5 0 0 1 7.5 12a5.06 5.06 0 0 1-1.95-.39M3.5 10a5 5 0 0 1 7-7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEcologyScienceTestTubeExperimentLabScienceChemistryTestTubeSolution: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5h9M10 .5v10a3 3 0 0 1-6 0V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEditImagePhoto: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m13.5 8.5l-4.71 4.71l-2.13.29l.3-2.13l4.7-4.71zm-9.219 5H1.8a1.3 1.3 0 0 1-1.3-1.3V1.8A1.3 1.3 0 0 1 1.8.5h10.4a1.3 1.3 0 0 1 1.3 1.3v2.95\"/><path d=\"M9.014 4.795a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5M.5 7.164a10.3 10.3 0 0 1 6.5.961\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEditImagePhotoRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.36 1.36c.07-.07.166-.11.265-.11h7.75a.375.375 0 0 1 .375.375V4.75a.625.625 0 1 0 1.25 0V1.625A1.625 1.625 0 0 0 9.375 0h-7.75A1.625 1.625 0 0 0 0 1.625v7.75A1.625 1.625 0 0 0 1.625 11h3.26a.5.5 0 0 0 .461-.307a1.8 1.8 0 0 1 .375-.56l1.523-1.525a.5.5 0 0 0 0-.707L3.458 4.115a.5.5 0 0 0-.707 0L1.25 5.616V1.625c0-.1.04-.195.11-.265m7.265 2.265a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0M11.66 6.16a.5.5 0 0 1 .354.146l1.84 1.84a.5.5 0 0 1 0 .708l-4.71 4.71a.5.5 0 0 1-.287.141l-2.13.29a.5.5 0 0 1-.562-.565l.3-2.13a.5.5 0 0 1 .141-.283l4.7-4.71a.5.5 0 0 1 .354-.147\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEditImagePhotoSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.8 0A1.8 1.8 0 0 0 0 1.8v10.4A1.8 1.8 0 0 0 1.8 14h3.714a1.25 1.25 0 0 1-.092-.674l.112-.795H1.975a.506.506 0 0 1-.506-.506V7.004Q1.618 7 1.766 7c1.875 0 3.645.453 5.205 1.254c.194.141.462.343.758.575l3.046-3.052a1.25 1.25 0 0 1 1.769 0L14 7.231V1.8A1.8 1.8 0 0 0 12.2 0zm8.669 3.59a1.5 1.5 0 1 1-1.5-1.5h.045c.803 0 1.455.651 1.455 1.455zm-3.672 8.94l-.137.969l2.13-.29L13.5 8.5l-1.84-1.84l-4.7 4.71z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEject: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 11.5h11m-1.293-3H2.793c-.873 0-1.327-1.04-.733-1.68l4.207-4.53a1 1 0 0 1 1.466 0l4.207 4.53c.594.64.14 1.68-.733 1.68\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEjectRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.057 1.349a1.57 1.57 0 0 0-2.114 0L.533 6.232C-.534 7.196.091 9.059 1.59 9.059h10.82c1.499 0 2.124-1.863 1.056-2.827zm-1.276.928a.32.32 0 0 1 .438 0l5.41 4.883a.37.37 0 0 1 .098.417c-.054.147-.169.232-.318.232H1.59c-.148 0-.263-.085-.318-.232a.37.37 0 0 1 .099-.417zM.875 11.5a.875.875 0 0 0 0 1.75h12.25a.875.875 0 1 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEjectSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.9 1.503a1.5 1.5 0 0 1 2.2 0l4.96 5.343c.892.96.211 2.52-1.099 2.52H2.04c-1.31 0-1.99-1.56-1.1-2.52zM.5 11.976a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineElectricCord1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.94 10.952H5.06a3 3 0 0 1-3-3V5.036a1 1 0 0 1 1-1h7.88a1 1 0 0 1 1 1v2.916a3 3 0 0 1-3 3M4.53 4.036V.578m4.94 3.458V.578M7 10.952v2.47\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineElectricCord1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.411.875a.875.875 0 1 0-1.75 0v2.543h-.589c-.897 0-1.625.728-1.625 1.625v2.9a3.625 3.625 0 0 0 3.625 3.624h1.053v1.558a.875.875 0 1 0 1.75 0v-1.558h1.053a3.625 3.625 0 0 0 3.625-3.625V5.043c0-.897-.728-1.625-1.625-1.625h-.59V.875a.875.875 0 0 0-1.75 0v2.543H5.412zM2.697 5.043c0-.207.168-.375.375-.375h7.856c.207 0 .375.168.375.375v2.9a2.375 2.375 0 0 1-2.375 2.374H5.072a2.375 2.375 0 0 1-2.375-2.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineElectricCord1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.25.813a.75.75 0 0 0-1.5 0V3.53H3a1 1 0 0 0-1 1v3a3 3 0 0 0 3 3h1.25v2.688a.75.75 0 0 0 1.5 0V10.53H9a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1h-.75V.813a.75.75 0 0 0-1.5 0V3.53h-3.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineElectricCord3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.122 5.698h5.756v1.55a2.878 2.878 0 1 1-5.756 0zm1.316 0V3.354m3.125 2.344V3.354\"/><path d=\"M7 10.125v2.125c0 .552.45 1.008.996.921A6.252 6.252 0 0 0 7 .75a6.25 6.25 0 0 0-3.125 11.664\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineElectricCord3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.751 5.751 0 0 0-2.957 10.685a.625.625 0 0 1-.643 1.072a7.001 7.001 0 1 1 3.6.995a.6.6 0 0 1-.22-.04a.625.625 0 0 1-.405-.585v-2.683a3.504 3.504 0 0 1-2.877-3.447v-1.55c0-.344.28-.624.625-.624h.564V3.604a.75.75 0 0 1 1.5 0v1.469h1.625V3.604a.75.75 0 0 1 1.5 0v1.469h.566c.345 0 .625.28.625.625v1.55a3.504 3.504 0 0 1-2.878 3.446v2.024A5.752 5.752 0 0 0 7 1.25m.002 8.25a2.253 2.253 0 0 0 2.25-2.253v-.924H4.749v.924A2.253 2.253 0 0 0 7 9.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineElectricCord3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 7.033a5.5 5.5 0 1 1 6.377 5.431a.1.1 0 0 1-.032-.001a.1.1 0 0 1-.034-.022a.22.22 0 0 1-.061-.158v-1.452a3.63 3.63 0 0 0 2.878-3.55V5.73a.75.75 0 0 0-.75-.75h-.566V3.77a.75.75 0 0 0-1.5 0v1.21H6.188V3.77a.75.75 0 0 0-1.5 0v1.21h-.564a.75.75 0 0 0-.75.75v1.55a3.63 3.63 0 0 0 2.877 3.55v1.453c0 .927.782 1.834 1.865 1.661A7.002 7.002 0 0 0 7 .033a7 7 0 0 0-3.5 13.064a.75.75 0 1 0 .75-1.299A5.5 5.5 0 0 1 1.5 7.033\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEmergencyCallRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.43.411A.41.41 0 0 1 9.84 0h1.82a.41.41 0 0 1 .41.411V1.93h1.519c.227 0 .411.185.411.412V4.16a.41.41 0 0 1-.411.412H12.07V6.09a.41.41 0 0 1-.412.411H9.841a.41.41 0 0 1-.412-.411V4.57H7.911a.41.41 0 0 1-.411-.412V2.341c0-.227.184-.412.411-.412H9.43zm-5.885 1.78a1.544 1.544 0 0 0-2.159 0l-.002.002l-.377.377a3.325 3.325 0 0 0-.49 4.164C1.432 8.092 3 9.693 4.365 10.973c1.362 1.276 2.599 2.3 2.882 2.49a3.325 3.325 0 0 0 4.11-.386q.048-.035.097-.078c.087-.077.204-.197.367-.388c.475-.557.588-1.5-.031-2.125l-.004-.004l-1.6-1.59l-.271-.207l.271.207a1.3 1.3 0 0 0-.27-.207L5.468 5.3a1.53 1.53 0 0 0-.376-1.502L3.556 2.202zM5.47 5.3l4.446 3.385a1.6 1.6 0 0 0-.879-.193c-.334.019-.736.135-1.002.401a.4.4 0 0 1-.09.075a1 1 0 0 1-.108.005a.28.28 0 0 1-.2-.081L5.09 6.345a.285.285 0 0 1 0-.4c.185-.185.311-.408.38-.645M2.975 3.4L5.47 5.3zl-.313-.325A.3.3 0 0 0 2.45 3l-1.064-.81L2.45 3a.28.28 0 0 0-.184.078l-.378.378l-.007.007a2.075 2.075 0 0 0-.32 2.581c.83 1.23 2.303 2.745 3.659 4.015c1.363 1.278 2.535 2.239 2.725 2.367a2.075 2.075 0 0 0 2.58-.284a.6.6 0 0 1 .108-.087c.031-.028.104-.1.237-.256a.4.4 0 0 0 .096-.252a.24.24 0 0 0-.063-.182L9.305 9.779c-.004-.004-.06-.046-.2-.038a.6.6 0 0 0-.199.048a1.5 1.5 0 0 1-.539.355a1.5 1.5 0 0 1-.531.08c-.405 0-.793-.16-1.08-.444l-.002-.003l-2.55-2.55l-.003-.002a1.535 1.535 0 0 1 0-2.16h.002a.284.284 0 0 0 0-.389l-.008-.007zM2.45 3l.525.4zm2.64 2.944l-.444-.44l.443.441M7.941 8.97h.002z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEmergencyExit: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.214 1.643c0-.493.4-.893.893-.893h6.25c.493 0 .893.4.893.893v10.714c0 .493-.4.893-.893.893H9.232\"/><path d=\"M6.553 5.438a1.563 1.563 0 1 0 3.126 0a1.563 1.563 0 1 0-3.126 0m-4.017.669h1.818a1 1 0 0 1 .707.293L7.6 8.94a1 1 0 0 0 .707.292h1.371\"/><path d=\"M6.107 7.446L3.721 9.832a1 1 0 0 1-.707.293H.75\"/><path d=\"m4.321 9.232l1.493 1.493a1 1 0 0 1 .293.707v1.818\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEmergencyExitRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.625 1.625c0-.207.168-.375.375-.375h6.375c.207 0 .375.168.375.375v10.75a.375.375 0 0 1-.375.375H8.5a.625.625 0 1 0 0 1.25h3.875c.898 0 1.625-.727 1.625-1.625V1.625C14 .728 13.273 0 12.375 0H6c-.897 0-1.625.728-1.625 1.625V2.5a.625.625 0 1 0 1.25 0zm2 3.375a.875.875 0 1 1 1.75 0a.875.875 0 0 1-1.75 0M8.5 2.875a2.125 2.125 0 1 0 0 4.25a2.125 2.125 0 0 0 0-4.25M3.809 8.808L5.116 7.5l-.765-.765a.38.38 0 0 0-.265-.11H2.625a.625.625 0 1 1 0-1.25h1.46c.432 0 .845.171 1.15.476L6.44 7.058h.001l.71.71l.497.497c.07.07.166.11.265.11h1.461a.625.625 0 1 1 0 1.25h-1.46c-.432 0-.845-.171-1.15-.476l-.055-.055l-.866.866l.305.305c.305.305.476.718.476 1.15v1.96a.625.625 0 1 1-1.25 0v-1.96c0-.1-.04-.196-.11-.266l-.747-.747l-.268-.268l-.015.015a1.63 1.63 0 0 1-1.15.476H.626a.625.625 0 1 1 0-1.25h2.46c.1 0 .196-.04.266-.11l.456-.456z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEmergencyExitSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.714 1.485c0-.784.636-1.42 1.42-1.42h6.434a1.42 1.42 0 0 1 1.419 1.42v11.03a1.42 1.42 0 0 1-1.42 1.42h-4.9c.077-.214.12-.445.12-.685v-1.818q0-.124-.01-.247q.262.047.531.047H9.68a2 2 0 0 0 .56-3.92a2.88 2.88 0 1 0-4.714-2.966a3 3 0 0 0-.81-.217zm1.93 3.722a1.63 1.63 0 1 1 3.26 0a1.63 1.63 0 0 1-3.26 0m.083 1.62l.002.003l1.49 1.49a.13.13 0 0 0 .089.037h1.371a.875.875 0 1 1 0 1.75H8.308c-.497 0-.974-.197-1.326-.549l-.874-.874l-.71.71l.714.712c.351.352.549.829.549 1.326V13a.875.875 0 0 1-1.75 0v-1.568a.13.13 0 0 0-.037-.088l-.725-.725A1.88 1.88 0 0 1 3.015 11H1a.875.875 0 0 1 0-1.75h2.015a.13.13 0 0 0 .089-.037L4.87 7.446l-.428-.427a.13.13 0 0 0-.088-.037H2.536a.875.875 0 0 1 0-1.75h1.819c.497 0 .974.198 1.325.55l1.044 1.043z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEmptyClipboard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5.5h-3a1 1 0 0 0-1 1V2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1\"/><path d=\"M9.75 1.5h1.5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEmptyClipboardRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.663 2.25H2.5a.375.375 0 0 0-.375.375v9.75c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375v-9.75a.375.375 0 0 0-.375-.375h-1.162c-.174.856-.93 1.5-1.838 1.5h-3a1.876 1.876 0 0 1-1.837-1.5M10.159 1H11.5c.898 0 1.625.728 1.625 1.625v9.75c0 .898-.727 1.625-1.625 1.625h-9a1.625 1.625 0 0 1-1.625-1.625v-9.75C.875 1.728 1.603 1 2.5 1h1.341c.315-.595.94-1 1.659-1h3c.72 0 1.344.405 1.659 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEmptyClipboardSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2.75 1h.5v.5A2.25 2.25 0 0 0 5.5 3.75h3a2.25 2.25 0 0 0 2.25-2.25V1h.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-8.5a1.5 1.5 0 0 1-1.5-1.5v-10A1.5 1.5 0 0 1 2.75 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentCameraVideoFilmTelevisionTvCameraMoviesVideoRecorder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"3.5\" cy=\"3.5\" r=\"3\"/><circle cx=\"10.5\" cy=\"4.5\" r=\"2\"/><rect width=\"7.5\" height=\"4.5\" x=\"3.5\" y=\"9\" rx=\"1\"/><path d=\"M13.5 10v2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonFastForward1ButtonControlsFastForwardMoviesTelevisionVideoTv: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.29a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L1.6 3.11a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.62Z\"/><path d=\"M7 10.29a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L8.1 3.11a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.6Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonFastForward2ButtonControlsFastForwardMoviesTelevisionVideoTv: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.29a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L1.6 3.11a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.62Z\"/><path d=\"M7 10.29a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L8.1 3.11a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.6Zm6.5-7.79v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonMoveCircleMoveButtonCircleDirectionArrows: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M5.5 4L7 3l1.5 1m-3 6L7 11l1.5-1M10 5.5L11 7l-1 1.5m-6-3L3 7l1 1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonNextButtonTelevisionButtonsMoviesSkipNextVideoControls: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5v13m-13-1.84a1 1 0 0 0 .52.88a1 1 0 0 0 1 0l7.19-4.7a1 1 0 0 0 0-1.68L2 1.5a1 1 0 0 0-1 0a1 1 0 0 0-.52.88Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonNextCircleCircleMultiMultimediaButtonSkipMediaNextControls: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M9.5 5v4m-5-4.5l3 2.5l-3 2.5v-5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPause1ButtonTelevisionButtonsMoviesTvPauseVideoControls: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.75.52v13m4.5-13v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPause2ButtonTelevisionButtonsMoviesTvPauseVideoControls: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"4.5\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><rect width=\"4.5\" height=\"13\" x=\"9\" y=\".5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPauseCircleControlsPauseMultiMediaMultimediaButtonCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M5.5 4.5v5m3-5v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPlayButtonTelevisionButtonsMoviesPlayTvVideoControls: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 12.35a1.14 1.14 0 0 0 .63 1a1.24 1.24 0 0 0 1.22 0L12 8a1.11 1.11 0 0 0 0-2L3.35.69a1.24 1.24 0 0 0-1.22 0a1.14 1.14 0 0 0-.63 1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPlayCircleControlsMediaMultiPlayMultimediaButtonCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"m5.5 4.5l4 2.5l-4 2.5v-5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPlayPauseButtonTelevisionButtonsMoviesPlayPauseVideoControls: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 2.5v9m-3-9v9m-10-1.21a.7.7 0 0 0 .37.62a.71.71 0 0 0 .73 0l5.08-3.3a.7.7 0 0 0 0-1.18L1.6 3.11a.71.71 0 0 0-.73 0a.7.7 0 0 0-.37.62Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPower1PowerButtonOnOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5V6m4-4.12a6.5 6.5 0 1 1-8 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPower2PowerButtonOnOff: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 4.5v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPreviousButtonTelevisionButtonsMoviesSkipPreviousVideoControls: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5.5v13m13-1.84a1 1 0 0 1-.52.88a1 1 0 0 1-1 0l-7.19-4.7a1 1 0 0 1 0-1.68L12 1.5a1 1 0 0 1 1 0a1 1 0 0 1 .52.88Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonPreviousCirclePreviousControlsMultiMediaMultimediaButtonCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M4.5 5v4m5-4.5L6.5 7l3 2.5v-5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonRecord1ButtonMultimediaMultiMediaControlsRecordCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><circle cx=\"7\" cy=\"7\" r=\"2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonRecord3ButtonTelevisionButtonsMoviesRecordTvVideoControls: Icon = {
  "body": "<circle cx=\"7\" cy=\"7\" r=\"6.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonRewind1RewindTelevisionButtonMoviesButtonsTvVideoControls: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.29a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L7.32 7.59a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.62Z\"/><path d=\"M7 10.29a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L.82 7.59a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.6Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonRewind2RewindTelevisionButtonMoviesButtonsTvVideoControls: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.29a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L7.32 7.59a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.62Z\"/><path d=\"M7 10.29a.7.7 0 0 1-.37.62a.71.71 0 0 1-.73 0L.82 7.59a.7.7 0 0 1 0-1.18l5.08-3.3a.71.71 0 0 1 .73 0a.7.7 0 0 1 .37.6ZM.5 2.5v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonStopButtonTelevisionButtonsMoviesStopTvVideoControls: Icon = {
  "body": "<rect width=\"13\" height=\"13\" x=\".5\" y=\".52\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" rx=\"1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentControlButtonStopCircleStopControlsMultiMediaMultimediaButtonCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><rect width=\"5\" height=\"5\" x=\"4.5\" y=\"4.5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentEarpodsAirpodsAudioEarpodsMusicEarbudsTrueWireless: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5a3 3 0 0 0-2 .76v4.48a3 3 0 0 0 2 .76a2.74 2.74 0 0 0 .5 0v5.79a1.25 1.25 0 0 0 2.5 0V3.5a3 3 0 0 0-3-3Zm9 0a3 3 0 0 1 2 .76v4.48a3 3 0 0 1-2 .76a2.74 2.74 0 0 1-.5 0v5.79a1.25 1.25 0 0 1-2.5 0V3.5a3 3 0 0 1 3-3Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentMusicNote1MusicAudioNote: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"4.25\" cy=\"11\" r=\"2.5\"/><path d=\"M6.75 11V.5h0a5.5 5.5 0 0 1 5.5 5.5h0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentMusicNote2MusicAudioNote: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2.5\" cy=\"11.42\" r=\"2\"/><circle cx=\"11.5\" cy=\"8.92\" r=\"2\"/><path d=\"M13.5 8.92V1.08a.5.5 0 0 0-.63-.48l-8 2.22a.5.5 0 0 0-.37.48v8.12m0-5.5l9-2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentNewsPaperNewspaperPeriodicalFoldContent: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 4.5V11a1.25 1.25 0 0 1-1.25 1.25h0A1.25 1.25 0 0 1 11 11h0V2.25a.5.5 0 0 0-.5-.5H1a.5.5 0 0 0-.5.5v9a1 1 0 0 0 1 1h10.75\"/><path d=\"M3.5 4.25H8v2.5H3.5zm0 5.5H8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentPartyPopperHobbyEntertainmentPartyPopperConfettiEvent: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.85 13.2l-6.68-2.49a1.25 1.25 0 0 1-.48-2.05l4.19-4.19a1.26 1.26 0 0 1 2.06.53l2.48 6.68a1.22 1.22 0 0 1-1.57 1.52Zm-9.8-6.07a2.06 2.06 0 0 1 1.46-.21m.82-2.64A2.1 2.1 0 0 1 4 2.83M6.63.72A4.72 4.72 0 0 0 6.76 4\"/><circle cx=\"1\" cy=\"3.28\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentPlayList1ScreenTelevisionDisplayPlayerMoviesMovieTvMediaPlayersVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M5.49 10.56V6.73A.36.36 0 0 1 6 6.42l3.32 1.91a.37.37 0 0 1 0 .63L6 10.88a.37.37 0 0 1-.51-.32ZM.5 4h13M4 4L5.5.5m3 3.5L10 .5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentPlayList2PlayerTelevisionMoviesSliderMediaTvPlayersVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 8.68V5.32c0-.25.23-.4.41-.28l2.45 1.68a.35.35 0 0 1 0 .56L5.91 9c-.18.08-.41-.07-.41-.32Z\"/><rect width=\"8\" height=\"11\" x=\"3\" y=\"1.5\" rx=\"1\"/><path d=\"M.5 3v8m13-8v8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentPlayList3PlayerTelevisionDisplayMoviesSmartphoneMediaTvPlayersScreenVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8.5\" height=\"13\" x=\"2.75\" y=\".5\" rx=\"1\"/><path d=\"M5.27 7.14V3.82a.31.31 0 0 1 .47-.28l2.85 1.67a.31.31 0 0 1 0 .54L5.74 7.41a.31.31 0 0 1-.47-.27ZM2.75 10.5h8.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentPlayList4ScreenTelevisionDisplayPlayerMoviesPlayersTvMediaVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M5.23 9.23V4.91a.41.41 0 0 1 .62-.35l3.7 2.15a.41.41 0 0 1 0 .71l-3.7 2.16a.41.41 0 0 1-.62-.35Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentRadioAntennaAudioMusicRadio: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9.5\" x=\".5\" y=\"4\" rx=\"1\"/><path d=\"M2 4L13.5.5\"/><circle cx=\"4.5\" cy=\"10\" r=\"1.5\"/><path d=\"M9.5 8.75H11m-1.5 2.5H11M.5 6.5h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentRecordingTape1FilmTelevisionTvMoviesReelVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5.5\" cy=\"5.5\" r=\"5\"/><circle cx=\"5.5\" cy=\"5.5\" r=\"1.5\"/><path d=\"M10.5 5.5V12a1.5 1.5 0 0 0 1.5 1.5h0a1.5 1.5 0 0 0 1.5-1.5v-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentRecordingTape2PhoneDeviceMailMobileFaxVoiceMachineAnswering: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"3\" cy=\"7\" r=\"2.5\"/><circle cx=\"11\" cy=\"7\" r=\"2.5\"/><path d=\"M3 9.5h8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentSpeaker1SpeakerMusicAudioSubwoofer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.43 3.43a1.5 1.5 0 1 0-1.86-1.86a6.49 6.49 0 0 0-7.14 0a1.5 1.5 0 1 0-1.86 1.86A6.52 6.52 0 0 0 .5 7a6.43 6.43 0 0 0 .83 3.17A1.49 1.49 0 0 0 2 13a1.51 1.51 0 0 0 1.26-.69a6.47 6.47 0 0 0 7.48 0a1.5 1.5 0 0 0 2.76-.81a1.49 1.49 0 0 0-.83-1.33A6.43 6.43 0 0 0 13.5 7a6.52 6.52 0 0 0-1.07-3.57Z\"/><circle cx=\"7\" cy=\"7\" r=\"3.5\"/><circle cx=\"7\" cy=\"7\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentSpeaker2SpeakersMusicAudio: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"13\" x=\"2\" y=\".5\" rx=\"1\"/><circle cx=\"7\" cy=\"9\" r=\"2.5\"/><circle cx=\"7\" cy=\"3.5\" r=\".5\"/><circle cx=\"7\" cy=\"9\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentTicketHobbyTicketEventEntertainmentStubTheater: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.65 2.24l-.39.09a1.19 1.19 0 0 1-.91 1.43a1.22 1.22 0 0 1-1.44-.92L1.13 3a.81.81 0 0 0-.61 1s.36 1.67.78 3.55m10.85-5.32a1.32 1.32 0 1 1-2.44-1L8.9.85a.89.89 0 0 0-1.16.47L4.38 9.23l-.44 1a.89.89 0 0 0 .47 1.16l4.06 1.73a.89.89 0 0 0 1.16-.47l3.8-8.94A.89.89 0 0 0 13 2.58Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentVolumeDownSpeakerDownVolumeControlAudioMusicDecrease: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5H1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1H3Zm0 4l3.91 2.81a1 1 0 0 0 1 .08A1 1 0 0 0 8.5 11V3a1 1 0 0 0-.5-.89a1 1 0 0 0-1 .08L3 5m7.5 1.5h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentVolumeLevelHighSpeakerHighVolumeControlAudioMusic: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5H1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1H3Zm0 4l3.91 2.81a1 1 0 0 0 1 .08A1 1 0 0 0 8.5 11V3a1 1 0 0 0-.5-.89a1 1 0 0 0-1 .08L3 5m9.5-1a4.38 4.38 0 0 1 1 3a6.92 6.92 0 0 1-1 3.5m-2-5A2.19 2.19 0 0 1 11 7a2.19 2.19 0 0 1-.5 1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentVolumeLevelLowVolumeSpeakerLowerDownControlMusicLowAudio: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5H1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1H3Zm0 4l3.91 2.81a1 1 0 0 0 1 .08A1 1 0 0 0 8.5 11V3a1 1 0 0 0-.5-.89a1 1 0 0 0-1 .08L3 5m7.5.5A2.19 2.19 0 0 1 11 7a2.19 2.19 0 0 1-.5 1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentVolumeLevelOffVolumeSpeakerControlMusicAudio: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5H1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1H3Zm0 4l3.91 2.81a1 1 0 0 0 1 .08A1 1 0 0 0 8.5 11V3a1 1 0 0 0-.5-.89a1 1 0 0 0-1 .08L3 5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentVolumeMuteSpeakerRemoveVolumeControlAudioMusicMuteOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5H1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1H3Zm0 4l3.91 2.81a1 1 0 0 0 1 .08A1 1 0 0 0 8.5 11V3a1 1 0 0 0-.5-.89a1 1 0 0 0-1 .08L3 5m10.5.5l-3 3m0-3l3 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentVolumeOffSpeakerMusicMuteVolumeControlAudioOffMute: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13M4.5 5H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1.5ZM10 4V3a1 1 0 0 0-.55-.89a1 1 0 0 0-1 .08L4.5 5m2.17 5.56l1.74 1.25a1 1 0 0 0 1 .08A1 1 0 0 0 10 11V7M4.5 9l.29.21\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentVolumeUpVolumeSpeakerUpControlMusicPlusAddAudioIncrease: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 5v3m-1.5-1.5h3M3 5H1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1H3Zm0 4l3.91 2.81a1 1 0 0 0 1 .08A1 1 0 0 0 8.5 11V3a1 1 0 0 0-.5-.89a1 1 0 0 0-1 .08L3 5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEntertainmentWalkManPlayerTapesTapeHeadphonesMusicWalkmanHeadsetAudio: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5\" height=\"7\" x=\"4.5\" y=\"6.5\" rx=\"1\"/><path d=\"M2 7.5v3m10-3v3m-10-2H1A.5.5 0 0 1 .5 8V7A6.5 6.5 0 0 1 7 .5h0A6.5 6.5 0 0 1 13.5 7v1a.5.5 0 0 1-.5.5h-1M7 9v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEpicGames1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.223 1.429c0-.513.37-.929.825-.929h9.904c.455 0 .825.416.825.929v8.247c0 .352-.177.673-.456.83L7 13.5l-5.32-2.993c-.28-.158-.457-.48-.457-.83z\"/><path d=\"M8.394 7.202H5.61V2.56h2.785M5.609 4.88h2.785M5.143 9.457l1.858.929l1.857-.929\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEpicGames1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.377 0C1.512 0 .98.79.98 1.536v8.089c0 .53.252 1.068.733 1.352l4.968 2.936c.196.116.44.116.636 0l4.968-2.936c.481-.284.733-.823.733-1.352v-8.09C13.02.79 12.49 0 11.624 0zM2.23 1.536a.37.37 0 0 1 .078-.24c.038-.046.064-.046.068-.046h9.247c.003 0 .029 0 .067.045c.04.047.078.13.078.24v8.09c0 .16-.077.252-.119.276L7 12.65L2.35 9.901c-.042-.024-.119-.116-.119-.276zm3.298.675a.625.625 0 0 0-.625.625V7.25c0 .345.28.625.625.625H8.47a.625.625 0 0 0 0-1.25H6.154v-.957H8.47a.625.625 0 0 0 0-1.25H6.154v-.957H8.47a.625.625 0 0 0 0-1.25zm-.49 6.616a.625.625 0 0 0-.28 1.184l1.962.98a.63.63 0 0 0 .559 0l1.961-.98a.625.625 0 0 0-.28-1.184z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEpicGames1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.048 0C1.263 0 .723.697.723 1.429v8.247c0 .511.256 1.01.711 1.266l5.32 2.994a.5.5 0 0 0 .491 0l5.32-2.994c.455-.255.712-.755.712-1.266V1.43c0-.732-.54-1.429-1.325-1.429zm2.936 2.707c0-.345.28-.625.625-.625h2.785a.625.625 0 0 1 0 1.25h-2.16v1.072h2.16a.625.625 0 0 1 0 1.25h-2.16v1.071h2.16a.625.625 0 0 1 0 1.25H5.61a.625.625 0 0 1-.625-.625zm.462 6.98a.625.625 0 1 0-.605 1.095l1.857 1.027a.63.63 0 0 0 .605 0l1.857-1.027a.625.625 0 1 0-.605-1.094L7 10.548z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEqualSign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.75 4.5h12.5m-12.5 5h12.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEqualSignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 3.875a.625.625 0 1 0 0 1.25h12.75a.625.625 0 1 0 0-1.25zm0 5a.625.625 0 1 0 0 1.25h12.75a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEqualSignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3.5a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2zm0 5a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineErlenmeyerFlask: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 .5v6l3.59 4.57a1.5 1.5 0 0 1-1.18 2.43H2.59a1.5 1.5 0 0 1-1.18-2.43L5 6.5v-6M3.5.5h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineErlenmeyerFlaskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.375 1.5H3.5a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5h-.875v3.693l3.1 4.87A2.561 2.561 0 0 1 10.564 14H3.436a2.561 2.561 0 0 1-2.16-3.936l3.099-4.871zm1.25 0v3.875a.63.63 0 0 1-.098.336L2.33 10.735a1.311 1.311 0 0 0 1.106 2.015h7.128a1.311 1.311 0 0 0 1.106-2.015L8.473 5.71a.63.63 0 0 1-.098-.336V1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineErlenmeyerFlaskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.02.75A.75.75 0 0 1 3.77 0h6.46a.75.75 0 0 1 0 1.5H9.5v4.827l3.486 4.437c1.031 1.313.097 3.236-1.572 3.236H2.586c-1.669 0-2.604-1.923-1.572-3.236L4.5 6.327V1.5h-.73a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEsports: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.32 6.536c.638 1.544 1.197 3.545 1.18 4.643c-.024 1.48-.928 2.32-1.856 2.32c-.843-.395-1.859-2.32-2.786-2.32H5.142c-.927 0-1.943 1.925-2.786 2.32c-.928 0-1.832-.84-1.856-2.32c-.018-1.098.542-3.099 1.18-4.643m1.605-5.107v2.785a.93.93 0 0 0 .929.929h5.571a.93.93 0 0 0 .929-.929V1.43l-1.857.928L7 .5L5.142 2.357z\"/><path d=\"M3.5 8.25a1 1 0 1 0 2 0a1 1 0 1 0-2 0m5 0a1 1 0 1 0 2 0a1 1 0 1 0-2 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEsportsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.441.558a.625.625 0 0 0-.884 0L5.02 2.097L3.565 1.37a.625.625 0 0 0-.905.559v2.285c0 .858.696 1.554 1.554 1.554h5.571c.858 0 1.554-.696 1.554-1.554V1.93a.625.625 0 0 0-.905-.56l-1.454.728zm-5.114 5.4c.32.13.472.496.34.815a18 18 0 0 0-.744 2.23c-.197.756-.304 1.41-.298 1.832c.016 1.003.526 1.44.94 1.524c.079-.06.18-.151.308-.284c.134-.14.266-.29.41-.455l.22-.251c.222-.249.475-.52.742-.73c.257-.202.615-.419 1.04-.419h3.43c.425 0 .783.217 1.04.419c.267.21.52.481.742.73l.22.25c.144.165.276.316.41.456c.128.133.23.224.308.284c.414-.084.924-.52.94-1.524c.006-.423-.101-1.076-.298-1.831a18 18 0 0 0-.745-2.23a.625.625 0 1 1 1.156-.476c.305.743.59 1.592.799 2.39c.204.787.347 1.571.338 2.167c-.026 1.62-1.052 2.77-2.339 2.77a.6.6 0 0 1-.267-.06c-.305-.144-.576-.398-.793-.624c-.155-.162-.32-.35-.474-.526l-.189-.215a5 5 0 0 0-.58-.579a1 1 0 0 0-.202-.13a.2.2 0 0 0-.066-.02h-3.43a.2.2 0 0 0-.066.02q-.075.033-.201.13a5 5 0 0 0-.581.58l-.189.214c-.154.176-.319.364-.474.526c-.217.226-.488.48-.793.624a.6.6 0 0 1-.267.06c-1.287 0-2.313-1.15-2.339-2.77c-.009-.596.134-1.38.338-2.166c.208-.799.494-1.648.799-2.39a.625.625 0 0 1 .815-.341M3 8.25a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m6.5-1.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEsportsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.469 2.256v1.275a.9.9 0 0 0 .154.499c.16.232.426.384.728.384h5.297a.88.88 0 0 0 .728-.384a.9.9 0 0 0 .155-.5V1.288a.3.3 0 0 0-.014-.083a.25.25 0 0 0-.348-.14l-.448.223l-.419.21l-.021.01l-.516.258L7.176.177a.25.25 0 0 0-.353 0L5.234 1.765l-.515-.257l-.022-.011l-.42-.21l-.447-.223a.25.25 0 0 0-.361.223zM2.279 4.04a1.28 1.28 0 0 0-1.065.807C.866 5.753.56 6.973.342 8.115C.126 9.251-.01 10.359.001 11.038c.012.767.13 1.478.51 2.002c.408.562 1.042.812 1.846.812a.5.5 0 0 0 .224-.053c.604-.303 1.118-.884 1.547-1.415q.194-.241.369-.467c.25-.32.477-.61.704-.851h3.59c.205.231.412.51.64.82q.175.236.37.492c.408.533.907 1.125 1.499 1.42a.5.5 0 0 0 .223.054c.803 0 1.455-.248 1.892-.793c.418-.522.572-1.234.584-2.02c.011-.675-.123-1.77-.336-2.897c-.214-1.132-.517-2.344-.86-3.252a1.34 1.34 0 0 0-1.085-.847a2.13 2.13 0 0 1-2.07 1.62H4.35A2.134 2.134 0 0 1 2.28 4.04m3.33 4.573a1.307 1.307 0 1 1-2.614 0a1.307 1.307 0 0 1 2.613 0m4.09 1.307a1.307 1.307 0 1 0 0-2.614a1.307 1.307 0 0 0 0 2.614\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEthereum: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.17.573l4.738 6.432l-4.737 6.432l-4.738-6.432z\"/><path d=\"M11.908 7.005L7.17 8.578L2.433 7.005\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEthereumCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M7 3L4.5 6L7 8l2.5-2zM4.5 9L7 11l2.5-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEthereumCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.751 7.001a5.751 5.751 0 1 0-11.502 0a5.751 5.751 0 0 0 11.502 0M7 0a7.001 7.001 0 1 1 0 14.002A7.001 7.001 0 0 1 7 0m.384 2.68a.5.5 0 0 0-.768 0l-2.5 3a.5.5 0 0 0 .072.71l2.5 2a.5.5 0 0 0 .624 0l2.5-2a.5.5 0 0 0 .072-.71zm-3.25 5.933a.625.625 0 0 1 .878-.104L7 10.08l1.988-1.57a.625.625 0 0 1 .774.982l-2.375 1.875a.625.625 0 0 1-.774 0L4.238 9.49a.625.625 0 0 1-.104-.878\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEthereumCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M7 2.5a.5.5 0 0 1 .384.18l2.5 3a.5.5 0 0 1-.072.71l-2.5 2a.5.5 0 0 1-.624 0l-2.5-2a.5.5 0 0 1-.072-.71l2.5-3A.5.5 0 0 1 7 2.5M4.89 8.512a.625.625 0 1 0-.78.976l2.5 2a.625.625 0 0 0 .78 0l2.5-2a.625.625 0 1 0-.78-.976L7 10.2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEthereumRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.192 0 .373.088.492.24l4.998 6.37a.6.6 0 0 1 .112.22a.63.63 0 0 1-.11.555l-5 6.375a.625.625 0 0 1-.984 0l-5-6.375a.624.624 0 0 1 .002-.775L6.508.24A.63.63 0 0 1 7 0m0 1.638l3.943 5.027L7 7.847L3.057 6.665z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEthereumSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.17.073a.5.5 0 0 1 .403.203L12.04 6.34L7.17 7.956L2.3 6.34L6.769.276A.5.5 0 0 1 7.17.073M2.289 7.652l4.48 6.082a.5.5 0 0 0 .805 0l4.48-6.082l-4.685 1.556a.63.63 0 0 1-.394 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEuro: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 12.59a5 5 0 0 1-2 .41a5.77 5.77 0 0 1-5.5-6A5.77 5.77 0 0 1 10 1a4.9 4.9 0 0 1 1.63.27M2 5.5h6m-6 3h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEuroRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.407 2.737a5.5 5.5 0 0 0-1.765 2.138H8.5a.625.625 0 0 1 0 1.25H5.267a4.5 4.5 0 0 0-.047.864v.054q-.017.42.044.832H8.5a.625.625 0 0 1 0 1.25H5.633a5.6 5.6 0 0 0 1.793 2.195c1.377 1.013 3.166 1.394 4.837.708a.625.625 0 1 1 .474 1.157c-2.144.879-4.39.365-6.052-.858c-1.084-.798-1.952-1.92-2.395-3.202H1.5a.625.625 0 1 1 0-1.25h2.503a5.6 5.6 0 0 1-.033-.859q-.016-.454.035-.891H1.5a.625.625 0 1 1 0-1.25h2.795c.443-1.264 1.3-2.357 2.372-3.145C8.321.516 10.547-.015 12.695.692a.625.625 0 0 1-.39 1.188c-1.714-.565-3.524-.152-4.898.857\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEuroSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.026 2c.434 0 .865.072 1.276.215a1 1 0 0 0 .656-1.89A5.9 5.9 0 0 0 9.954.001a6.77 6.77 0 0 0-5.951 4.19H2a1 1 0 1 0 0 2h1.52q-.035.402-.02.81a7 7 0 0 0 .02.808H2a1 1 0 1 0 0 2h2.003A6.77 6.77 0 0 0 9.996 14a6 6 0 0 0 2.4-.492a1 1 0 0 0-.793-1.836a4 4 0 0 1-1.579.328a4.77 4.77 0 0 1-3.776-2.19H8a1 1 0 1 0 0-2H5.53a5 5 0 0 1-.03-.768V6.96q-.017-.388.03-.768H8a1 1 0 0 0 0-2H6.248A4.77 4.77 0 0 1 10.025 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineExpand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v3m-13-3v3m11 5h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m3 0h3M9 4H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineExpandHorizontal1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.48 3.87L.61 6.74a.36.36 0 0 0 0 .52l2.87 2.87m7.04-6.26l2.87 2.87a.36.36 0 0 1 0 .52l-2.87 2.87M7 13.5V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineExpandHorizontal1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 7 0M3.671 3.408a.5.5 0 0 1 .309.462v6.26a.5.5 0 0 1-.854.354L.26 7.617a.86.86 0 0 1 0-1.233l2.867-2.867a.5.5 0 0 1 .545-.109m6.658 0a.5.5 0 0 1 .545.109l2.867 2.867a.86.86 0 0 1 0 1.233l-2.867 2.867a.5.5 0 0 1-.854-.354V3.87a.5.5 0 0 1 .309-.462\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineExpandRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.735 1.735c.07-.07.166-.11.265-.11h1a.625.625 0 1 0 0-1.25H2A1.625 1.625 0 0 0 .375 2v1a.625.625 0 1 0 1.25 0V2c0-.1.04-.195.11-.265M11 .375a.625.625 0 1 0 0 1.25h1a.375.375 0 0 1 .375.375v1a.625.625 0 1 0 1.25 0V2A1.625 1.625 0 0 0 12 .375zM4.875 1c0-.345.28-.625.625-.625h3a.625.625 0 1 1 0 1.25h-3A.625.625 0 0 1 4.875 1m8.75 4.5a.625.625 0 1 0-1.25 0v3a.625.625 0 1 0 1.25 0zM1 4.875c.345 0 .625.28.625.625v3a.625.625 0 1 1-1.25 0v-3c0-.345.28-.625.625-.625M13.625 11a.625.625 0 1 0-1.25 0v1a.375.375 0 0 1-.375.375h-1a.625.625 0 1 0 0 1.25h1A1.625 1.625 0 0 0 13.625 12zM1 10.375c.345 0 .625.28.625.625v1a.375.375 0 0 0 .375.375h1a.625.625 0 1 1 0 1.25H2A1.625 1.625 0 0 1 .375 12v-1c0-.345.28-.625.625-.625m4.5 2a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25zM5 3.5A1.5 1.5 0 0 0 3.5 5v4A1.5 1.5 0 0 0 5 10.5h4A1.5 1.5 0 0 0 10.5 9V5A1.5 1.5 0 0 0 9 3.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineExpandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 1.75a.25.25 0 0 1 .25-.25h.5a.75.75 0 0 0 0-1.5h-.5A1.75 1.75 0 0 0 0 1.75v.5a.75.75 0 0 0 1.5 0zm9.5-1a.75.75 0 0 1 .75-.75h.5C13.216 0 14 .784 14 1.75v.5a.75.75 0 0 1-1.5 0v-.5a.25.25 0 0 0-.25-.25h-.5A.75.75 0 0 1 11 .75M3.5 5A1.5 1.5 0 0 1 5 3.5h4A1.5 1.5 0 0 1 10.5 5v4A1.5 1.5 0 0 1 9 10.5H5A1.5 1.5 0 0 1 3.5 9zm9.75 6a.75.75 0 0 1 .75.75v.5A1.75 1.75 0 0 1 12.25 14h-.5a.75.75 0 0 1 0-1.5h.5a.25.25 0 0 0 .25-.25v-.5a.75.75 0 0 1 .75-.75m-11.75.75a.75.75 0 0 0-1.5 0v.5C0 13.217.784 14 1.75 14h.5a.75.75 0 0 0 0-1.5h-.5a.25.25 0 0 1-.25-.25zm3.75 1.5A.75.75 0 0 1 6 12.5h2A.75.75 0 0 1 8 14H6a.75.75 0 0 1-.75-.75M6 0a.75.75 0 0 0 0 1.5h2A.75.75 0 0 0 8 0zM.75 5.25A.75.75 0 0 1 1.5 6v2A.75.75 0 0 1 0 8V6a.75.75 0 0 1 .75-.75M14 6a.75.75 0 0 0-1.5 0v2A.75.75 0 0 0 14 8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineExpandWindow2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 8v4.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H6m4 0h3.5V4m0-3.5L7 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineExpandWindow2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 2H2.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7a1 1 0 1 1 2 0v4.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 0 11.5v-9A2.5 2.5 0 0 1 2.5 0H7a1 1 0 0 1 0 2M9.538.309A.5.5 0 0 1 10 0h3.5a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.854.354L12.104 3.31L7.707 7.707a1 1 0 0 1-1.414-1.414l4.396-4.397L9.646.854a.5.5 0 0 1-.108-.545\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEyeOptic: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 3.625c-4.187 0-5.945 3.766-5.945 3.844S2.813 11.312 7 11.312s5.945-3.765 5.945-3.843S11.187 3.625 7 3.625M2.169 5.813L.61 4.252m4.525-.354L4.5 1.843m7.331 3.97l1.559-1.56m-4.525-.355L9.5 1.843\"/><path d=\"M5.306 7.081a1.738 1.738 0 1 0 3.388.776a1.738 1.738 0 1 0-3.388-.776\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEyeOpticRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.317 1.001a.625.625 0 0 1 .784.408l.485 1.533c.44-.104.912-.162 1.416-.162s.975.058 1.415.161l.481-1.531a.625.625 0 1 1 1.193.375l-.493 1.567a7 7 0 0 1 2.037 1.472l1.298-1.3a.625.625 0 0 1 .885.883l-1.375 1.377c.291.4.518.778.686 1.088a8 8 0 0 1 .352.748a2 2 0 0 1 .04.12l.01.044a.6.6 0 0 1 0 .239a1 1 0 0 1-.025.093l-.025.072q-.029.073-.075.181a8 8 0 0 1-.277.566a9.4 9.4 0 0 1-1.134 1.654c-1.027 1.197-2.664 2.439-4.993 2.439s-3.966-1.242-4.994-2.439A9.4 9.4 0 0 1 .875 8.935a8 8 0 0 1-.352-.747a2 2 0 0 1-.04-.12l-.01-.045c-.002-.013-.011-.06-.011-.12s.009-.106.011-.118a1 1 0 0 1 .025-.093q.011-.037.025-.072q.027-.074.074-.181c.063-.144.155-.339.278-.567c.17-.317.404-.704.704-1.112L.19 4.414a.625.625 0 1 1 .87-.898l1.329 1.288a7 7 0 0 1 2.016-1.451l-.496-1.567A.625.625 0 0 1 4.317 1M1.976 8.343a7 7 0 0 1-.218-.44a8.2 8.2 0 0 1 1.198-1.87C3.845 4.999 5.165 4.03 7.002 4.03s3.157.97 4.045 2.003a8.2 8.2 0 0 1 1.198 1.87c-.05.111-.121.262-.217.44a8.2 8.2 0 0 1-.98 1.432c-.889 1.034-2.21 2.003-4.046 2.003s-3.157-.97-4.046-2.003a8.2 8.2 0 0 1-.98-1.432m2.76-.47c.01-1.244 1.036-2.24 2.28-2.24s2.256.996 2.248 2.24c-.009 1.242-1.036 2.238-2.28 2.238s-2.256-.996-2.247-2.239\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEyeOpticSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.353 1.268a.75.75 0 0 1 .938.495l.407 1.318A7 7 0 0 1 7 2.963q.69.002 1.302.118l.407-1.318a.75.75 0 0 1 1.434.443l-.406 1.312c.78.336 1.426.79 1.946 1.26l.985-.985a.75.75 0 0 1 1.061 1.06l-1.032 1.033c.147.195.272.378.375.54c.124.197.218.366.283.494a3 3 0 0 1 .112.246a1 1 0 0 1 .036.124a.77.77 0 0 1-.036.428q-.016.043-.032.078a3 3 0 0 1-.08.169a6 6 0 0 1-.283.493a8 8 0 0 1-1.137 1.41C10.9 10.89 9.279 11.922 7 11.922S3.1 10.89 2.066 9.87A8 8 0 0 1 .929 8.458a6 6 0 0 1-.284-.493a3 3 0 0 1-.112-.247a1 1 0 0 1-.035-.124a.76.76 0 0 1 .035-.428l.032-.078q.031-.073.08-.168a7 7 0 0 1 .659-1.033L.27 4.853a.75.75 0 0 1 1.06-1.061l.986.985a7.1 7.1 0 0 1 1.946-1.26l-.406-1.312a.75.75 0 0 1 .495-.938m2.174 8.238a2.117 2.117 0 1 0 .945-4.128a2.117 2.117 0 0 0-.945 4.128\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFaceScan1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 10.5v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2m6.5-6V8H5.5m-1 2a3.63 3.63 0 0 0 5 0M4 4.75a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m6 .5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFaceScan1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625A.375.375 0 0 0 1.625 2v2a.625.625 0 1 1-1.25 0V2A1.625 1.625 0 0 1 2 .375h2a.625.625 0 1 1 0 1.25zm8-1.25a.625.625 0 1 0 0 1.25h2a.375.375 0 0 1 .375.375v2a.625.625 0 1 0 1.25 0V2A1.625 1.625 0 0 0 12 .375zM13.625 10a.625.625 0 1 0-1.25 0v2a.375.375 0 0 1-.375.375h-2a.625.625 0 1 0 0 1.25h2A1.625 1.625 0 0 0 13.625 12zm-12 0a.625.625 0 1 0-1.25 0v2A1.625 1.625 0 0 0 2 13.625h2a.625.625 0 1 0 0-1.25H2A.375.375 0 0 1 1.625 12zM7 3.5a.75.75 0 0 1 .75.75v3.5A.75.75 0 0 1 7 8.5H5.5a.75.75 0 0 1 0-1.5h.75V4.25A.75.75 0 0 1 7 3.5M5.017 9.206a.75.75 0 1 0-1.034 1.088a4.38 4.38 0 0 0 6.034 0a.75.75 0 1 0-1.034-1.088a2.88 2.88 0 0 1-3.966 0M4 3.25a1 1 0 1 1 0 2a1 1 0 0 1 0-2m5 1a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFaceScan1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.5a.25.25 0 0 0-.25.25v1.5a.75.75 0 0 1-1.5 0v-1.5A1.75 1.75 0 0 1 1.75 0h1.5a.75.75 0 0 1 0 1.5zm6 3a.75.75 0 0 0-1.5 0v2.75H5.5a.75.75 0 0 0 0 1.5H7A.75.75 0 0 0 7.75 8zM14 10.75a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-1.5a.75.75 0 0 0 0 1.5h1.5A1.75 1.75 0 0 0 14 12.25zm-12.5 0a.75.75 0 0 0-1.5 0v1.5A1.75 1.75 0 0 0 1.75 14h1.5a.75.75 0 0 0 0-1.5h-1.5a.25.25 0 0 1-.25-.25zm8.5-10a.75.75 0 0 1 .75-.75h1.5A1.75 1.75 0 0 1 14 1.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.25.25 0 0 0-.25-.25h-1.5A.75.75 0 0 1 10 .75M5.017 9.456a.75.75 0 1 0-1.034 1.088a4.38 4.38 0 0 0 6.034 0a.75.75 0 1 0-1.034-1.088a2.88 2.88 0 0 1-3.966 0M5 4.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m5 1a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFacebook1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 12.5v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-3V8.76h.71a.61.61 0 0 0 .61-.61v-.77a.61.61 0 0 0-.61-.61h-.67v-.94c0-.84.38-.84.76-.84h.49a.55.55 0 0 0 .43-.18a.58.58 0 0 0 .18-.43v-.74a.62.62 0 0 0-.6-.64H9.65a2.32 2.32 0 0 0-2.39 2.6v1.17h-.64a.61.61 0 0 0-.62.61v.77a.61.61 0 0 0 .62.61h.64v4.74H1.5a1 1 0 0 1-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFacebook1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.735 1.735c.07-.07.166-.11.265-.11h10a.375.375 0 0 1 .375.375v10a.375.375 0 0 1-.375.375H9V9.01h.96a.61.61 0 0 0 .61-.61v-.77a.61.61 0 0 0-.61-.61h-.92v-.69c0-.84.38-.84.76-.84h.74a.55.55 0 0 0 .43-.18a.58.58 0 0 0 .18-.43v-.74a.62.62 0 0 0-.6-.64l-.334-.002c-1-.01-2.15-.023-2.861.75c-.63.685-.615 1.521-.6 2.375q.005.198.005.397h-.89a.61.61 0 0 0-.62.61v.77a.61.61 0 0 0 .62.61h.89v3.365H2A.375.375 0 0 1 1.625 12V2c0-.1.04-.195.11-.265M2 .375A1.625 1.625 0 0 0 .375 2v10A1.625 1.625 0 0 0 2 13.625h10A1.625 1.625 0 0 0 13.625 12V2A1.625 1.625 0 0 0 12 .375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFacebook1Solid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 12.923V1.077A1.077 1.077 0 0 1 1.077 0h11.846A1.077 1.077 0 0 1 14 1.077v11.846A1.077 1.077 0 0 1 12.923 14h-3.23V8.895h.764a.657.657 0 0 0 .657-.657V7.41a.655.655 0 0 0-.657-.657h-.722V5.74c0-.905.41-.905.819-.905h.527a.6.6 0 0 0 .464-.193a.63.63 0 0 0 .193-.464v-.796a.67.67 0 0 0-.646-.69H9.854a2.498 2.498 0 0 0-2.574 2.8v1.26h-.69a.657.657 0 0 0-.667.657v.83a.657.657 0 0 0 .668.656h.689V14H1.077A1.077 1.077 0 0 1 0 12.923\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFactorial: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5V10M1 13.5V6a4 4 0 1 1 8 0v7.5M1 2v4m11 7a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFactorialRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .375c.345 0 .625.28.625.625v.838a4.625 4.625 0 0 1 8 3.162v8a.625.625 0 1 1-1.25 0V5a3.375 3.375 0 0 0-6.75 0v8a.625.625 0 1 1-1.25 0V1c0-.345.28-.625.625-.625M13.375 1a.625.625 0 1 0-1.25 0v9a.625.625 0 1 0 1.25 0zm-1.5 11.75a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFactorialSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.078.078a1 1 0 0 1 1 1v7.86a1 1 0 1 1-2 0v-7.86a1 1 0 0 1 1-1M5.153 3.384A2.69 2.69 0 0 0 2.46 6.065v6.904a1 1 0 1 1-2 0V2.384a1 1 0 0 1 1.99-.146a4.7 4.7 0 0 1 2.703-.854a4.69 4.69 0 0 1 4.694 4.681v6.904a1 1 0 1 1-2 0V6.065a2.69 2.69 0 0 0-2.694-2.681m5.463 9.077a1.462 1.462 0 1 1 2.924 0a1.462 1.462 0 0 1-2.924 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFahrenheit: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 3.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m4.5 10v-12h6M7 7h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFahrenheitRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.875 1.225a.9.9 0 1 0 0 1.8a.9.9 0 0 0 0-1.8m-2.1.9a2.1 2.1 0 1 1 4.2 0a2.1 2.1 0 0 1-4.2 0M6 1.625C6 1.28 6.28 1 6.625 1h6a.625.625 0 1 1 0 1.25H7.25v4.125h3.375a.625.625 0 1 1 0 1.25H7.25v5.75a.625.625 0 1 1-1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFahrenheitSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.25 1.5a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5M0 2.25a2.25 2.25 0 1 1 4.5 0a2.25 2.25 0 0 1-4.5 0M6 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8v3.5h4a1 1 0 1 1 0 2H8V13a1 1 0 1 1-2 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFastforwardClock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M7 3.5v4l2.6 1.3\"/><path d=\"M13.326 8.5a6.5 6.5 0 1 1-.558-4.5\"/><path stroke-linejoin=\"round\" d=\"M13.5 2v2.5H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFastforwardClockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.75 5.75 0 1 0 5.596 7.077a.625.625 0 0 1 1.217.288a7 7 0 1 1-1.462-6.129l.582-.582A.625.625 0 0 1 14 2.346v2.202c0 .345-.28.625-.625.625h-2.202a.625.625 0 0 1-.442-1.067l.732-.732A5.74 5.74 0 0 0 7 1.249m.875 2.25a.875.875 0 1 0-1.75 0V7c0 .483.392.875.875.875h2.5a.875.875 0 1 0 0-1.75H7.875z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFastforwardClockSolid: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M7 2.75a.75.75 0 0 1 .75.75v3.575l2.136 1.282a.75.75 0 1 1-.772 1.286l-2.5-1.5A.75.75 0 0 1 6.25 7.5v-4A.75.75 0 0 1 7 2.75\"/><path d=\"M1.5 7a5.5 5.5 0 0 1 9.82-3.405l-.966.965a.5.5 0 0 0 .353.854H13.5a.5.5 0 0 0 .5-.5V2.12a.5.5 0 0 0-.854-.354l-.76.761a7 7 0 1 0 1.427 6.086a.75.75 0 0 0-1.46-.344A5.5 5.5 0 0 1 1.5 7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFigma: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.536 2.759c0-1.11.899-2.009 2.008-2.009H7v4.018H4.544c-1.11 0-2.008-.9-2.008-2.01m8.928.001c0-1.11-.899-2.009-2.008-2.009H7v4.018h2.456c1.11 0 2.008-.9 2.008-2.01\"/><path d=\"M11.464 7A2.232 2.232 0 1 0 7 7a2.232 2.232 0 0 0 4.464 0m-8.928 4.241c0-1.11.899-2.009 2.008-2.009H7v1.786c0 1.233-1 2.232-2.232 2.232h-.224c-1.11 0-2.008-.9-2.008-2.009\"/><path d=\"M2.536 7c0-1.233.999-2.232 2.232-2.232H7v4.464H4.768c-1.233 0-2.232-1-2.232-2.232\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFigmaRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.82 2.673A2.674 2.674 0 0 1 4.494 0h5.011a2.674 2.674 0 0 1 1.644 4.783a2.902 2.902 0 0 1-3.525 4.602v1.714c0 1.603-1.3 2.902-2.902 2.902h-.228A2.674 2.674 0 0 1 2.85 9.217a2.9 2.9 0 0 1-1.03-2.218c0-.889.4-1.685 1.03-2.217a2.67 2.67 0 0 1-1.03-2.109m2.675 1.433v-.008a1.424 1.424 0 0 1 0-2.849h1.88v2.848h-1.88zm4.74 1.242a1.652 1.652 0 1 0 .084 0zm-4.74 4.554a1.424 1.424 0 1 0 0 2.848h.227c.912 0 1.652-.74 1.652-1.652V9.902z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFigmaSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.502 5.06a1.962 1.962 0 0 0 .03 3.925h1.963V5.061zm5.505 0a1.962 1.962 0 1 1-.098 0zM10.23.179a1.691 1.691 0 0 1 0 3.383H7.995V.178zM2.57 1.87c0-.934.758-1.692 1.692-1.692h2.233v3.383H4.262A1.69 1.69 0 0 1 2.57 1.87m1.692 8.616a1.691 1.691 0 0 0 0 3.383h.27a1.963 1.963 0 0 0 1.963-1.963v-1.42z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileAddAlternate: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 5V1.5a1 1 0 0 1 1-1H10L13.5 4v8.5a1 1 0 0 1-1 1h-5m-4-6v6m-3-3h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileAddAlternateRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.375 1.25A.375.375 0 0 0 3 1.625v3.75a.625.625 0 1 1-1.25 0v-3.75A1.625 1.625 0 0 1 3.375 0h6.5c.166 0 .325.066.442.183l3.5 3.5a.63.63 0 0 1 .183.442v8.25A1.625 1.625 0 0 1 12.375 14h-4.75a.625.625 0 1 1 0-1.25h4.75a.375.375 0 0 0 .375-.375V4.384L9.616 1.25zM3.5 7a.75.75 0 0 1 .75.75v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2A.75.75 0 0 1 3.5 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileAddAlternateSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0A1.5 1.5 0 0 0 2 1.5v5.189A2 2 0 0 1 5.25 8.25v.5h.5a2 2 0 1 1 0 4h-.5v.5c0 .265-.052.518-.145.75H12.5a1.5 1.5 0 0 0 1.5-1.5v-8a.5.5 0 0 0-.146-.354l-4-4A.5.5 0 0 0 9.5 0zM4 8.25a.75.75 0 0 0-1.5 0V10H.75a.75.75 0 0 0 0 1.5H2.5v1.75a.75.75 0 0 0 1.5 0V11.5h1.75a.75.75 0 0 0 0-1.5H4z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileCode1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4z\"/><path d=\"m5.5 10.5l-2-2l2-2m3 4l2-2l-2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileCode1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 1.25a.375.375 0 0 0-.375.375v10.75a.375.375 0 0 0 .375.375h9a.375.375 0 0 0 .375-.375V4.384L8.741 1.25zM1.351.476A1.63 1.63 0 0 1 2.5 0H9c.166 0 .325.066.442.183l3.5 3.5a.63.63 0 0 1 .183.442v8.25A1.625 1.625 0 0 1 11.5 14h-9a1.625 1.625 0 0 1-1.625-1.625V1.625c0-.431.171-.844.476-1.149m4.59 5.582a.625.625 0 0 1 0 .884L4.385 8.5l1.558 1.558a.625.625 0 1 1-.884.884l-2-2a.625.625 0 0 1 0-.884l2-2a.625.625 0 0 1 .884 0m3 0a.625.625 0 1 0-.883.884L9.616 8.5l-1.558 1.558a.625.625 0 1 0 .884.884l2-2a.625.625 0 0 0 0-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileCode1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h6a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5v-11c0-.398.158-.78.44-1.06m4.59 5.53a.75.75 0 0 1 0 1.06L4.56 8.5l1.47 1.47a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.06 0m1.94 1.06a.75.75 0 0 1 1.06-1.06l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06L9.44 8.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileDeleteAlternate: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 7V1.5a1 1 0 0 1 1-1H10L13.5 4v8.5a1 1 0 0 1-1 1H8M4.74 9.26L.5 13.5m0-4.24l4.24 4.24\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileDeleteAlternateRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.375 1.25A.375.375 0 0 0 3 1.625v4.75a.625.625 0 1 1-1.25 0v-4.75A1.625 1.625 0 0 1 3.375 0h6.5c.166 0 .325.066.442.183l3.5 3.5a.63.63 0 0 1 .183.442v8.25A1.625 1.625 0 0 1 12.375 14h-4.75a.625.625 0 1 1 0-1.25h4.75a.375.375 0 0 0 .375-.375V4.384L9.616 1.25zM5.53 8.47a.75.75 0 0 1 0 1.06l-1.594 1.595L5.53 12.72a.75.75 0 1 1-1.06 1.06l-1.595-1.594L1.28 13.78a.75.75 0 0 1-1.06-1.06l1.594-1.595L.22 9.53a.75.75 0 0 1 1.06-1.06l1.595 1.594L4.47 8.47a.75.75 0 0 1 1.06 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileDeleteAlternateSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0A1.5 1.5 0 0 0 2 1.5v5.949q.086.068.164.147l.706.706l.706-.706a2 2 0 0 1 2.828 2.828l-.706.706l.706.706A2 2 0 0 1 6.844 14H12.5a1.5 1.5 0 0 0 1.5-1.5v-8a.5.5 0 0 0-.146-.354l-4-4A.5.5 0 0 0 9.5 0zm2.02 8.48a.75.75 0 0 1 0 1.06l-1.59 1.59l1.59 1.59a.75.75 0 1 1-1.06 1.06l-1.59-1.59l-1.59 1.59a.75.75 0 0 1-1.06-1.06l1.59-1.59L.22 9.54a.75.75 0 1 1 1.06-1.06l1.59 1.59l1.59-1.59a.75.75 0 0 1 1.06 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileRemoveAlternate: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 7.5v-6a1 1 0 0 1 1-1H10L13.5 4v8.5a1 1 0 0 1-1 1h-6m-6-3h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileRemoveAlternateRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.11 1.36c.07-.07.166-.11.265-.11h6.241l3.134 3.134v7.991a.375.375 0 0 1-.375.375h-7.75a.625.625 0 1 0 0 1.25h7.75A1.625 1.625 0 0 0 14 12.375v-8.25a.63.63 0 0 0-.183-.442l-3.5-3.5A.63.63 0 0 0 9.875 0h-6.5A1.625 1.625 0 0 0 1.75 1.625v6.25a.625.625 0 1 0 1.25 0v-6.25c0-.1.04-.195.11-.265M.75 9.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFileRemoveAlternateSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0A1.5 1.5 0 0 0 2 1.5v6.75h3.75a2 2 0 1 1 0 4H2v.25A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5v-8a.5.5 0 0 0-.146-.354l-4-4A.5.5 0 0 0 9.5 0zm3 10.25a.75.75 0 0 0-.75-.75h-5a.75.75 0 1 0 0 1.5h5a.75.75 0 0 0 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilmRoll1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.75 6a4.75 4.75 0 1 0 9.5 0a4.75 4.75 0 1 0-9.5 0m9.5.25v5a1.5 1.5 0 0 0 3 0\"/><path d=\"M5.5 3.945a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m0 5.11a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M3.195 6.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.61.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilmRoll1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 5.5a4.25 4.25 0 1 1 8.5 0a4.25 4.25 0 0 1-8.5 0m8.5 3.491v2.884a2.125 2.125 0 0 0 4.25 0v-.316a.625.625 0 1 0-1.25 0v.316a.875.875 0 0 1-1.75 0V5.5a5.5 5.5 0 1 0-1.25 3.491M4.5 3.321a1 1 0 1 0 2 0a1 1 0 0 0-2 0m0 4.359a1 1 0 1 0 2 0a1 1 0 0 0-2 0M2.32 5.5a1 1 0 1 0 2 0a1 1 0 0 0-2 0m4.36 0a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilmRoll1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 6a5.5 5.5 0 1 1 10.997.183L11 6.25v5a.75.75 0 0 0 1.5 0a.75.75 0 0 1 1.5 0a2.25 2.25 0 0 1-4.5 0V9.775A5.5 5.5 0 0 1 0 6m6.375-2.5a.875.875 0 1 1-1.75 0a.875.875 0 0 1 1.75 0m-3.18 3.383a.875.875 0 1 0 0-1.75a.875.875 0 0 0 0 1.75m5.485-.875a.875.875 0 1 1-1.75 0a.875.875 0 0 1 1.75 0M5.5 9.242a.875.875 0 1 0 0-1.75a.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilmSlate: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.365 6.127h11.448v6.232a1 1 0 0 1-1 1H2.364a1 1 0 0 1-1-1zm-.001 0L12.42 3.164l-.48-1.79a1 1 0 0 0-1.225-.708L1.591 3.112a1 1 0 0 0-.707 1.224zm2.626 4.69h1.278m-.871-5.503l.64-3.126m2.972 2.158l.64-3.126\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilmSlateRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8.86 4.886l3.716-.996a.5.5 0 0 0 .354-.612l-.48-1.791a1.5 1.5 0 0 0-1.837-1.06l-.884.236zm-.481-3.861l-2.791.748l-.87 4.222l2.791-.747zM1.487 2.872l2.75-.737l-.87 4.222l-.046.013h9.68c.344 0 .624.28.624.625V12c0 .898-.727 1.625-1.625 1.625H2.5A1.625 1.625 0 0 1 .875 12V6.995c0-.126.038-.244.102-.342a.5.5 0 0 1-.07-.154l-.48-1.79a1.5 1.5 0 0 1 1.06-1.837m.638 4.748V12c0 .207.168.375.375.375H12a.375.375 0 0 0 .375-.375V7.62zm2.052 2.197a.75.75 0 1 0 0 1.5h1.279a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilmSlateSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m1.176 6.08l2.294-.614l.01-.045l.768-3.315l1.368-.367l-.003.014L4.837 5.1l2.873-.77l.003-.012L8.51.964L9.882.597l-.003.01l-.797 3.355L12.97 2.92L12.441.946a1 1 0 0 0-1.225-.707L1.354 2.882a1 1 0 0 0-.707 1.224zm.001 0h12.21v6.715a1 1 0 0 1-1 1H2.178a1 1 0 0 1-1-1zm2.174 5.004c0-.345.28-.625.625-.625h1.365a.625.625 0 0 1 0 1.25H3.976a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilter2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5H.5l5 7v6l3-2v-4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilter2Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M13.375.625H.625L5.5 7.5v5.875l3-2V7.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFilter2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 0a.5.5 0 0 0-.407.79L5 7.66v5.84a.5.5 0 0 0 .777.416l3-2A.5.5 0 0 0 9 11.5V7.66L13.907.79A.5.5 0 0 0 13.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFingerprint1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1 13.5v-7a6 6 0 1 1 12 0v2m-9 5v-2\"/><path d=\"M4 9V7a3 3 0 0 1 6 0v6.5m3-2v2M7 12v1.5m0-4v-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFingerprint1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125 6.125a4.875 4.875 0 1 1 9.75 0v2a.625.625 0 1 0 1.25 0v-2a6.125 6.125 0 0 0-12.25 0v7.25a.625.625 0 1 0 1.25 0zm2.5 0a2.375 2.375 0 1 1 4.75 0v7.25a.625.625 0 1 0 1.25 0v-7.25a3.625 3.625 0 0 0-7.25 0v2.5a.625.625 0 1 0 1.25 0zM4 10.5c.345 0 .625.28.625.625v2.25a.625.625 0 1 1-1.25 0v-2.25c0-.345.28-.625.625-.625m3.625-.375a.625.625 0 1 0-1.25 0v3.25a.625.625 0 1 0 1.25 0zM7 6c.345 0 .625.28.625.625v1.5a.625.625 0 1 1-1.25 0v-1.5C6.375 6.28 6.655 6 7 6m6.125 4.625a.625.625 0 1 0-1.25 0v2.75a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFingerprint1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 6.75a5.25 5.25 0 1 1 10.5 0v2a.75.75 0 0 0 1.5 0v-2a6.75 6.75 0 0 0-13.5 0v6.5a.75.75 0 0 0 1.5 0zm3 5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM7 5a2.25 2.25 0 0 0-2.25 2.25v1.5a.75.75 0 0 1-1.5 0v-1.5a3.75 3.75 0 1 1 7.5 0v6a.75.75 0 0 1-1.5 0v-6A2.25 2.25 0 0 0 7 5m6.75 6.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM7 11.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1A.75.75 0 0 1 7 11.5m.75-3.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFingerprint2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.39a5 5 0 0 0 5-5V5.61a5 5 0 0 0-1.27-3.33M2 6.72v1.67A5 5 0 0 0 5.06 13M9.5 1.28a5 5 0 0 0-6.83 1.83a4.9 4.9 0 0 0-.57 1.52\"/><path d=\"M6.48 3.51A2.51 2.51 0 0 1 9.5 6v1.61m-.64 2.1A2.5 2.5 0 0 1 4.5 8V6a2.5 2.5 0 0 1 .2-1M7 6.11v1.67\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFingerprint2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.265 4.185A6.022 6.022 0 0 1 9.512.547a.625.625 0 0 1-.522 1.135a4.772 4.772 0 0 0-6.534 2.883a.625.625 0 1 1-1.191-.38M11.95 2.593a.625.625 0 0 0-1.028.712c.534.77.847 1.705.847 2.714v1.962A4.77 4.77 0 0 1 7 12.75A.625.625 0 1 0 7 14a6.02 6.02 0 0 0 6.02-6.02V6.019a6 6 0 0 0-1.07-3.426M2.23 6.76a.625.625 0 1 0-1.25 0v1.22a6.02 6.02 0 0 0 3.303 5.374a.625.625 0 1 0 .565-1.115A4.77 4.77 0 0 1 2.23 7.981zm2.584-1.513a.625.625 0 1 0-1.179-.417a3.6 3.6 0 0 0-.203 1.19v1.96a3.568 3.568 0 0 0 5.947 2.66a.625.625 0 0 0-.834-.932A2.318 2.318 0 0 1 4.682 7.98V6.02c0-.272.047-.532.132-.772m1.458-2.721a3.568 3.568 0 0 1 4.296 3.493v1.47a.625.625 0 1 1-1.25 0V6.02a2.318 2.318 0 0 0-2.792-2.27a.625.625 0 1 1-.254-1.223M7.625 6.02a.625.625 0 1 0-1.25 0v1.962a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFingerprint2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.54.192a5.64 5.64 0 0 1 3.767.301a.75.75 0 1 1-.614 1.369A4.14 4.14 0 0 0 3.414 3.57c-.2.345-.347.716-.438 1.102a.75.75 0 0 1-1.46-.344A5.64 5.64 0 0 1 5.54.192m6.073 2.203a.75.75 0 1 0-1.226.863a4.14 4.14 0 0 1 .753 2.383V8.36A4.14 4.14 0 0 1 7 12.5A.75.75 0 0 0 7 14a5.64 5.64 0 0 0 5.64-5.64V5.64a5.64 5.64 0 0 0-1.027-3.245M2.86 6.726a.75.75 0 1 0-1.5 0V8.36a5.64 5.64 0 0 0 2.757 4.849a.75.75 0 0 0 .766-1.29A4.14 4.14 0 0 1 2.86 8.36zm3.988-2.435a1.705 1.705 0 0 1 1.847 1.721V7a.75.75 0 1 0 1.5 0v-.974a3.205 3.205 0 0 0-3.473-3.23a.75.75 0 0 0 .126 1.495m-1.805.062a.75.75 0 0 1 .398.983a1.7 1.7 0 0 0-.136.681V7.99A1.695 1.695 0 0 0 8.26 9.15a.75.75 0 0 1 1.116 1.001a3.195 3.195 0 0 1-5.572-2.179V6.023c-.002-.436.084-.87.255-1.272a.75.75 0 0 1 .983-.398M7.75 6.129a.75.75 0 1 0-1.5 0v1.634a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireAlarm2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.31 3.773c-.226-.097-.431.13-.334.292a5.5 5.5 0 0 1 .67 1.923c.14.956 0 2.003-.616 2.777a.26.26 0 0 1-.195.097a.26.26 0 0 1-.205-.086c-.279-.289-.568-.581-.756-.94c-.054-.108-.249-.281-.53 0c-.678.558-1.09 1.416-1.005 2.29c.036 1.937 1.747 3.35 3.623 3.374c1.914.023 3.601-1.394 3.617-3.374a6.2 6.2 0 0 0-1.081-3.5a7.7 7.7 0 0 0-3.187-2.853M9.453.5a4 4 0 0 1 4 4m-4-1.5a1.5 1.5 0 0 1 1.5 1.5M4.547.5a4 4 0 0 0-4 4m4-1.5a1.5 1.5 0 0 0-1.5 1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireAlarm2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 1.5A3.25 3.25 0 0 0 1.5 4.75a.75.75 0 0 1-1.5 0A4.75 4.75 0 0 1 4.75 0a.75.75 0 0 1 0 1.5m5.847 9.22c.09-2.065-1.345-4.469-3.821-5.623a.86.86 0 0 0-.83.023a.77.77 0 0 0-.35.444a.77.77 0 0 0 .085.61c.316.55.502 1.19.506 1.777q.003.48-.149.856a2.7 2.7 0 0 1-.252-.448a.625.625 0 0 0-.875-.295A2.98 2.98 0 0 0 3.4 10.708l.62-.015l-.62.025c.077 1.891 1.731 3.387 3.619 3.276c1.082-.004 1.969-.346 2.597-.958s.943-1.442.981-2.316l-.517-.023zm-1.249-.055c.053-1.219-.66-2.756-2.054-3.808c.09.358.14.724.143 1.085c.006.83-.242 1.685-.9 2.31a.624.624 0 0 1-.833.027a4 4 0 0 1-.664-.718c-.253.31-.4.71-.39 1.11c.05 1.195 1.115 2.152 2.308 2.074h.04c.825 0 1.385-.253 1.745-.604c.364-.354.578-.863.605-1.476M9.25 0a.75.75 0 0 0 0 1.5a3.25 3.25 0 0 1 3.25 3.25a.75.75 0 0 0 1.5 0A4.75 4.75 0 0 0 9.25 0m-4.5 4a.75.75 0 0 0-.75.75a.75.75 0 0 1-1.5 0A2.25 2.25 0 0 1 4.75 2.5a.75.75 0 0 1 0 1.5m4.5-1.5a.75.75 0 0 0 0 1.5a.75.75 0 0 1 .75.75a.75.75 0 0 0 1.5 0A2.25 2.25 0 0 0 9.25 2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireAlarm2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.51.75A.75.75 0 0 0 4.76 0A4.75 4.75 0 0 0 .014 4.748a.75.75 0 1 0 1.5 0A3.25 3.25 0 0 1 4.76 1.5a.75.75 0 0 0 .75-.75m2.98 0A.75.75 0 0 1 9.24 0a4.75 4.75 0 0 1 4.747 4.748a.75.75 0 0 1-1.5 0A3.25 3.25 0 0 0 9.24 1.5a.75.75 0 0 1-.75-.75m-2 2.57a.76.76 0 0 0-.832.147c-.184.177-.328.521-.132.855c.31.539.515 1.13.607 1.744c.114.771.018 1.557-.354 2.165c-.2-.214-.364-.405-.478-.622a.78.78 0 0 0-.508-.402c-.304-.072-.584.053-.8.26c-.773.646-1.265 1.643-1.169 2.69c.052 2.241 2.024 3.817 4.114 3.843c2.15.026 4.103-1.574 4.12-3.868v-.003c0-1.346-.405-2.66-1.161-3.773A8.2 8.2 0 0 0 6.51 3.33l-.01-.005zm2.75-.821a.75.75 0 1 0 0 1.5a.75.75 0 0 1 .75.75a.75.75 0 1 0 1.5 0a2.25 2.25 0 0 0-2.25-2.25m-6.07.658a.75.75 0 0 1 1.06 1.061a.75.75 0 0 0-.219.53a.75.75 0 1 1-1.5 0c0-.596.237-1.169.659-1.59\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireExtinguisherSign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.5 13.5h-4a1 1 0 0 1-1-1v-5a3 3 0 0 1 6 0v5a1 1 0 0 1-1 1m-2-9v-2\"/><path d=\"M.5 6.5v-2a2 2 0 0 1 2-2h7m0 .61V1.89a.5.5 0 0 1 .379-.485l3-.75a.5.5 0 0 1 .621.485v2.72a.5.5 0 0 1-.621.485l-3-.75A.5.5 0 0 1 9.5 3.11M8.5 8h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireExtinguisherSignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.912.035a1.07 1.07 0 0 1 1.338 1.033v2.114a1.068 1.068 0 0 1-1.338 1.033l-2.446-.638a1.13 1.13 0 0 1-.773-.702H7.125v1.183a3.376 3.376 0 0 1 2.75 3.317v5c0 .898-.728 1.625-1.625 1.625h-3.5a1.625 1.625 0 0 1-1.625-1.625v-5a3.376 3.376 0 0 1 2.75-3.317V2.875h-1a2.75 2.75 0 0 0-2.75 2.75v1.75a.75.75 0 0 1-1.5 0v-1.75a4.25 4.25 0 0 1 4.25-4.25h3.818c.124-.34.408-.607.773-.702zM6.5 5.25a2.125 2.125 0 0 0-2.125 2.125v5c0 .207.168.375.375.375h3.5a.375.375 0 0 0 .375-.375v-5A2.125 2.125 0 0 0 6.5 5.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireExtinguisherSignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.758.17A1 1 0 0 1 14 1.14v2.72a1 1 0 0 1-1.242.97l-3-.75A1 1 0 0 1 9 3.125H6.125v.93A3.5 3.5 0 0 1 9 7.5v5A1.5 1.5 0 0 1 7.5 14h-4A1.5 1.5 0 0 1 2 12.5v-5a3.5 3.5 0 0 1 2.875-3.444v-.931H2.656c-.76 0-1.375.616-1.375 1.375v2a.625.625 0 1 1-1.25 0v-2a2.625 2.625 0 0 1 2.625-2.625H9A1 1 0 0 1 9.757.92zM6 8h2v3H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireworksRocket: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.033 7.92L.852 13.102M7 9.006l-.16.16a2 2 0 0 0-.005 2.815l.332.336m1.188-9.809l3.09 3.09L8.45 9.535a.5.5 0 0 1-.751.051L4.367 6.254a.5.5 0 0 1 .05-.752z\"/><path d=\"M7.936 2.09a.7.7 0 0 1-.17-.263a.54.54 0 0 1-.027-.282a.4.4 0 0 1 .11-.231q.092-.092.232-.111l4.357-.406a.56.56 0 0 1 .263.04a.73.73 0 0 1 .403.403a.56.56 0 0 1 .04.263l-.394 4.37a.4.4 0 0 1-.11.23a.4.4 0 0 1-.232.111a.54.54 0 0 1-.274-.025a.7.7 0 0 1-.259-.16zm2.088 8.488l.451.45m2.35-.45l-.452.45m-2.349 2.074l.451-.451m2.35.451l-.452-.451\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireworksRocketRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.62.005c.193-.019.382.015.55.082a1.34 1.34 0 0 1 .743.743c.067.168.1.356.082.55l-.387 4.281l-.003.026a1 1 0 0 1-.286.587c-.16.16-.362.253-.57.284c-.2.034-.397.01-.574-.052a1.3 1.3 0 0 1-.401-.227L9.266 9.576a1.115 1.115 0 0 1-1.676.114L6.392 8.492l-.361.361a1.5 1.5 0 0 0 .588 1.978a.625.625 0 1 1-.625 1.083a2.74 2.74 0 0 1-1.296-1.728l-3.631 3.63a.625.625 0 1 1-.884-.883L5.05 8.066a1 1 0 0 1 .077-.077l.381-.381L4.322 6.42a1.115 1.115 0 0 1 .113-1.676l3.297-2.508a1.3 1.3 0 0 1-.221-.386a1.16 1.16 0 0 1-.057-.589c.03-.208.124-.41.283-.57a1 1 0 0 1 .611-.289zM8.619 3.133L5.314 5.646l3.05 3.05l2.514-3.304zm.196 7.325a.625.625 0 0 0-.883 0l-.443.442a.625.625 0 1 0 .884.884l.442-.443a.625.625 0 0 0 0-.883m-2.747 3.359a.625.625 0 1 1-.883-.884l.442-.443a.625.625 0 1 1 .884.884zm2.747 0a.625.625 0 0 1-.883 0l-.443-.443a.625.625 0 1 1 .884-.884l.442.443a.625.625 0 0 1 0 .884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFireworksRocketSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.334 1.472a.8.8 0 0 1-.18-.277a.57.57 0 0 1-.029-.298a.42.42 0 0 1 .117-.244a.42.42 0 0 1 .244-.117l4.602-.429a.6.6 0 0 1 .277.043a.77.77 0 0 1 .426.425a.6.6 0 0 1 .042.278l-.416 4.614a.42.42 0 0 1-.117.244a.42.42 0 0 1-.244.117a.56.56 0 0 1-.29-.026a.8.8 0 0 1-.273-.17zM7.279 8.585l-.17.172a1.375 1.375 0 0 0-.004 1.935l.428.434a.625.625 0 1 1-.89.878l-.428-.434a2.62 2.62 0 0 1-.73-2.217l-4.191 4.19a.625.625 0 1 1-.884-.883l5.472-5.472l-1.341-1.34a.5.5 0 0 1 .05-.752l3.18-2.419l3.504 3.504l-2.418 3.18a.5.5 0 0 1-.751.05zm2.303 1.55a.625.625 0 0 1 .884 0l.451.452a.625.625 0 0 1-.884.884l-.45-.451a.625.625 0 0 1 0-.884m2.8 0a.625.625 0 1 1 .885.885l-.452.45a.625.625 0 0 1-.884-.883zm-2.8 3.409c.244.244.64.244.884 0l.451-.452a.625.625 0 0 0-.884-.883l-.45.45a.625.625 0 0 0 0 .885m2.8 0a.625.625 0 1 0 .885-.884l-.452-.451a.625.625 0 1 0-.884.883z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFist: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.901 13.407v-2.464c-1.304-.452-2.18-1.97-2.18-3.754c0-1.063.24-2.174 1.42-2.174h2.993a1.111 1.111 0 0 1 .322 2.174l-1.71.519c.874 0 1.948.83 1.925 1.905m3.144 3.795v-2.465s.587-.293 1.2-.88c1.181-1.131 1.335-2.919 1.016-4.523c-.107-.534-.26-1.076-.477-1.532m-8.886.934V3.056a1.478 1.478 0 0 1 2.957 0v1.886\"/><path d=\"M5.625 4.554V2.072a1.48 1.48 0 1 1 2.959 0v2.482a1.48 1.48 0 0 1-1.365 1.474\"/><path d=\"M8.584 3.057a1.479 1.479 0 1 1 2.957 0v1.27a1.479 1.479 0 1 1-2.957 0z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFistRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.623 5.233c-.285-.474-.79-.8-1.373-.84V2.104a.854.854 0 0 1 1.709 0v2.45a.85.85 0 0 1-.336.679m1.075.695c-.233.27-.534.48-.876.604a1.74 1.74 0 0 1-1.185 1.255l-.135.041c.458.433.81 1.06.794 1.799a.625.625 0 1 1-1.25-.027c.007-.317-.147-.63-.422-.88c-.281-.257-.624-.387-.879-.387a.625.625 0 0 1-.181-1.223l1.71-.519a.49.49 0 0 0 .341-.401a.6.6 0 0 1-.019-.213a.49.49 0 0 0-.462-.337H3.14a.7.7 0 0 0-.382.091a.6.6 0 0 0-.212.254c-.14.275-.2.697-.2 1.204c0 1.618.79 2.828 1.76 3.164c.25.087.42.324.42.59v2.432a.625.625 0 1 1-1.25 0v-2.022c-1.383-.713-2.18-2.389-2.18-4.164c0-.556.058-1.222.334-1.768c.136-.27.333-.525.612-.715v-1.65A2.103 2.103 0 0 1 5.19 1.23a2.105 2.105 0 0 1 3.829 0a2.104 2.104 0 0 1 3.147 1.827v.786a7.5 7.5 0 0 1 .478 1.575c.336 1.687.213 3.747-1.197 5.096a6.5 6.5 0 0 1-1.008.788v2.073a.625.625 0 0 1-1.25 0v-2.418a.63.63 0 0 1 .353-.577l.005-.002l.06-.033a5.3 5.3 0 0 0 .976-.734c.903-.865 1.117-2.273.878-3.713a2.1 2.1 0 0 1-1.399.532c-.52 0-.997-.189-1.364-.502m.51-1.59a.854.854 0 0 0 1.708-.012V3.057a.854.854 0 0 0-1.707-.012zM5 4.39V3.056a.853.853 0 0 0-1.707 0V4.39z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFistSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.88 3.667H2.14V2.37a1.37 1.37 0 0 1 2.74-.003zm3.484 1.172a1.99 1.99 0 0 0-1.816-1.172H5.88V1.37a1.37 1.37 0 0 1 2.74 0v2.671c0 .298-.095.573-.256.798m-1.751.08a.744.744 0 0 1 .15 1.454l-2.107.64a.625.625 0 0 0 .181 1.222c.357 0 .812.178 1.18.514c.362.33.577.754.568 1.195a.625.625 0 1 0 1.25.027c.018-.883-.413-1.633-.975-2.146a3 3 0 0 0-.151-.13l.417-.126a2 2 0 0 0 1.377-1.515a2.4 2.4 0 0 0 .617-.556a2.368 2.368 0 0 0 3.85-.152q.07.346.07.704v1.034a4.03 4.03 0 0 1-2.339 3.742V13.5a.5.5 0 0 1-.5.5H3.795a.5.5 0 0 1-.5-.5v-2.43c-1.4-.486-2.34-2.422-2.339-3.742c0-1.141.257-2.333 1.523-2.333zm4.377-3.853a1.37 1.37 0 0 0-1.37 1.37v1.605a1.37 1.37 0 1 0 2.74 0V2.436a1.37 1.37 0 0 0-1.37-1.37\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFitToHeightSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 13.5h-7a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3m-3.5-3v-7\"/><path d=\"m9 5.5l-2-2l-2 2m0 3l2 2l2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFitToHeightSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 10.5A3.5 3.5 0 0 0 3.5 14h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 10.5 0h-7A3.5 3.5 0 0 0 0 3.5zM6.25 6v2H5a.5.5 0 0 0-.354.854l2 2a.5.5 0 0 0 .708 0l2-2A.5.5 0 0 0 9 8H7.75V6H9a.5.5 0 0 0 .354-.854l-2-2a.5.5 0 0 0-.708 0l-2 2A.5.5 0 0 0 5 6z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.25.5L2 5.81a.5.5 0 0 0 .46.69h2.79l-2 7l8.59-8.14a.5.5 0 0 0-.34-.86H7.75l2-4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m4.066.624l-2.42 5.209a.45.45 0 0 0 .05.458a.5.5 0 0 0 .192.16a.6.6 0 0 0 .252.059h2.756l-2.151 6.866l9.486-7.985a.5.5 0 0 0 .152-.249a.45.45 0 0 0-.025-.284a.5.5 0 0 0-.195-.224a.6.6 0 0 0-.298-.086H9.057L11.208.624z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.272 0a.5.5 0 0 0-.46.305l-2.25 5.31l-.002.005A1 1 0 0 0 2.48 7h2.13l-1.82 6.363a.5.5 0 0 0 .825.5l8.59-8.14l.003-.003A1 1 0 0 0 11.53 4H8.581L10.22.724A.5.5 0 0 0 9.772 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 .5v5h3.5l-5.5 8v-5H2.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash2Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M8 .625V5.5h4.375L6 13.375V8.5H1.625z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5.5a.5.5 0 0 0-.912-.283l-5.5 8A.5.5 0 0 0 2.5 9h3v4.5a.5.5 0 0 0 .912.283l5.5-8A.5.5 0 0 0 11.5 5h-3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.502 5.424L4.58 1.486A1 1 0 0 1 5.544.75h1.647a1 1 0 0 1 .965 1.263l-.594 2.175h1.589a1 1 0 0 1 .943 1.331L8.75 9.344h2.75l-5.125 4.125l-3.187-4.125H5.53l.782-2.656H4.467a1 1 0 0 1-.965-1.264\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash3Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M2.203 5.545L3.63.976a.5.5 0 0 1 .477-.351h4.005a.5.5 0 0 1 .478.647l-.804 2.617h2.494a.5.5 0 0 1 .47.672L9.056 9.16H12l-6.02 4.216L2.033 9.16h2.759l.836-2.965H2.68a.5.5 0 0 1-.477-.65\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlash3Solid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.08 5.28L4.286.875a1 1 0 0 1 .965-.736h1.94A1 1 0 0 1 8.156 1.4L7.49 3.847h1.826a1 1 0 0 1 .943 1.332L8.77 9.41h1.359a.5.5 0 0 1 .322.883l-3.845 3.233a.5.5 0 0 1-.717-.077L3.39 10.217a.5.5 0 0 1 .395-.806h1.511l.843-2.866H4.045A1 1 0 0 1 3.08 5.28\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlashOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13M5.19 5.19L8.5.5V5h3L8.81 8.81m-1.66 2.35L5.5 13.5V9h-3l1.41-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlashOffRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.625.625a.625.625 0 0 0-1.11-.393L4.651 3.768L1.067.183a.625.625 0 1 0-.884.884l12.75 12.75a.625.625 0 1 0 .884-.884l-3.678-3.678l2.722-3.362a.625.625 0 0 0-.486-1.018h-3.75zM3.752 5.873c.268.217.31.61.092.879l-.909 1.123H5.5c.166 0 .325.066.442.183l.5.5A.63.63 0 0 1 6.625 9v2.61l.846-1.046a.625.625 0 1 1 .972.787l-1.957 2.417a.625.625 0 0 1-1.111-.393V9.26l-.134-.134H1.625a.625.625 0 0 1-.486-1.018l1.734-2.142a.625.625 0 0 1 .879-.092\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlashOffSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5.5a.5.5 0 0 0-.912-.283l-2.571 3.74L1.28.22A.75.75 0 1 0 .22 1.28l12.5 12.5a.75.75 0 1 0 1.06-1.06L9.847 8.787l2.065-3.004A.5.5 0 0 0 11.5 5h-3zM2.088 8.217l1.347-1.96l4.83 4.83l-1.853 2.696A.5.5 0 0 1 5.5 13.5V9h-3a.5.5 0 0 1-.412-.783\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalArrow2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11 13.5l-4-4l-4 4zm0-13l-4 4l-4-4zM13.5 7h-1m-2 0h-1m-2 0h-1m-2 0h-1m-2 0h-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalArrow2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.625 7c0 .345-.28.625-.625.625h-1.25a.625.625 0 1 1 0-1.25H13c.345 0 .625.28.625.625m-2.548 6.24a.63.63 0 0 1-.577.385h-7a.625.625 0 0 1-.442-1.067l3.5-3.5a.625.625 0 0 1 .884 0l3.5 3.5a.625.625 0 0 1 .135.681m-.135-11.798A.625.625 0 0 0 10.5.375h-7a.625.625 0 0 0-.442 1.067l3.5 3.5c.244.244.64.244.884 0zM9.416 7.625a.625.625 0 1 0 0-1.25h-1.25a.625.625 0 0 0 0 1.25zM6.458 7c0 .345-.28.625-.625.625h-1.25a.625.625 0 1 1 0-1.25h1.25c.346 0 .625.28.625.625m-4.208.625a.625.625 0 1 0 0-1.25H1a.625.625 0 1 0 0 1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalArrow2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m2.854.854l3.792 3.792a.5.5 0 0 0 .707 0L11.147.854A.5.5 0 0 0 10.793 0H3.207a.5.5 0 0 0-.353.854m0 12.292l3.792-3.793a.5.5 0 0 1 .707 0l3.793 3.793a.5.5 0 0 1-.353.854H3.207a.5.5 0 0 1-.353-.854M1.75 7.75h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 1 1 0 1.5m2.833 0h1a.75.75 0 1 0 0-1.5h-1a.75.75 0 0 0 0 1.5m4.834 0h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 0 1 0 1.5m2.833 0h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalCircle1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7h13a6.5 6.5 0 1 1-13 0M13 4.39a6 6 0 0 0-.76-1.3a6.3 6.3 0 0 0-1-1.09M1.05 4.39c.199-.463.454-.9.76-1.3A6.3 6.3 0 0 1 2.85 2M8.5.67a6.7 6.7 0 0 0-3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalCircle1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.612.182a7.2 7.2 0 0 0-3.223 0a.625.625 0 0 0 .28 1.218a5.95 5.95 0 0 1 2.663 0a.625.625 0 1 0 .28-1.218m-5.2 1.515a.626.626 0 0 1-.085.88a5.6 5.6 0 0 0-.918.962l-.003.005a5.4 5.4 0 0 0-.668 1.142a.625.625 0 1 1-1.149-.493c.215-.5.491-.973.822-1.406a6.8 6.8 0 0 1 1.12-1.174a.625.625 0 0 1 .88.084m8.156-.075a.625.625 0 0 0-.816.947q.496.429.882.961l.01.014q.405.53.668 1.142a.625.625 0 1 0 1.148-.493a6.6 6.6 0 0 0-.818-1.401a7 7 0 0 0-1.074-1.17M0 7c0-.345.28-.625.625-.625h12.752A.625.625 0 0 1 14 7A7.001 7.001 0 0 1 0 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalCircle1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.61.183a7.2 7.2 0 0 0-3.22 0a.75.75 0 1 0 .336 1.461a5.7 5.7 0 0 1 2.548 0A.75.75 0 0 0 8.61.183M3.588 1.715a.75.75 0 0 1-.101 1.056c-.328.27-.622.579-.877.919l-.004.005a5 5 0 0 0-.638 1.091a.75.75 0 0 1-1.378-.592c.215-.5.49-.973.821-1.406a7 7 0 0 1 1.121-1.174a.75.75 0 0 1 1.056.1m7.979-.09a.75.75 0 1 0-.98 1.135c.316.273.6.581.843.92l.012.015c.257.336.471.703.638 1.091a.75.75 0 0 0 1.378-.592a6.6 6.6 0 0 0-.817-1.401a7 7 0 0 0-1.074-1.169M.22 6.47a.75.75 0 0 1 .53-.22h12.5A.75.75 0 0 1 14 7A7 7 0 1 1 0 7a.75.75 0 0 1 .22-.53\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalSquare2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 2.5v-1a1 1 0 0 0-1-1h-1m-3 0h-3m-5 2v-1a1 1 0 0 1 1-1h1m-2 9v3a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-3m-13-4V7h13V5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalSquare2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 3.625c.345 0 .625-.28.625-.625V2c0-.207.168-.375.375-.375h1a.625.625 0 1 0 0-1.25H2C1.103.375.375 1.103.375 2v1c0 .345.28.625.625.625M.375 7V5.5a.625.625 0 1 1 1.25 0V7h10.75V5.5a.625.625 0 1 1 1.25 0V12c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12zM5.5 1.625a.625.625 0 1 1 0-1.25h3a.625.625 0 1 1 0 1.25zm7.5 2c.345 0 .625-.28.625-.625V2c0-.897-.727-1.625-1.625-1.625h-1a.625.625 0 1 0 0 1.25h1c.207 0 .375.168.375.375v1c0 .345.28.625.625.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlipVerticalSquare2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.75 0a.75.75 0 0 0 0 1.5h.5a.25.25 0 0 1 .25.25v.5a.75.75 0 0 0 1.5 0v-.5A1.75 1.75 0 0 0 12.25 0zM14 7V5.5a.75.75 0 0 0-1.5 0v.75h-11V5.5a.75.75 0 0 0-1.5 0v6.75C0 13.216.784 14 1.75 14h10.5A1.75 1.75 0 0 0 14 12.25zM1.75 1.5a.25.25 0 0 0-.25.25v.5a.75.75 0 1 1-1.5 0v-.5C0 .784.784 0 1.75 0h.5a.75.75 0 1 1 0 1.5zM6 0a.75.75 0 0 0 0 1.5h2A.75.75 0 0 0 8 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFloppyDisk: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 12.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V4.91a1 1 0 0 1 .29-.7L4.21.79a1 1 0 0 1 .7-.29h7.59a1 1 0 0 1 1 1z\"/><path d=\"M10.5 13.5V9a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v4.5m7-13V4a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFloppyDiskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.41.375h-.003A1.63 1.63 0 0 0 4.27.846l-.002.002l-3.42 3.42l-.002.002c-.3.303-.47.711-.471 1.137V12A1.625 1.625 0 0 0 2 13.625h10A1.625 1.625 0 0 0 13.625 12V2A1.625 1.625 0 0 0 12 .375zm-.16 1.288a.4.4 0 0 0-.1.07L1.734 5.15a.38.38 0 0 0-.109.262V12a.375.375 0 0 0 .375.375h1.25V9A.75.75 0 0 1 4 8.25h6a.75.75 0 0 1 .75.75v3.375H12a.375.375 0 0 0 .375-.375V2A.375.375 0 0 0 12 1.625h-1.25V4a.75.75 0 0 1-.75.75H6A.75.75 0 0 1 5.25 4z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFloppyDiskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.875 0a1.5 1.5 0 0 0-1.017.435l-.002.001l-3.42 3.42l-.001.002A1.5 1.5 0 0 0 0 4.908V12.5A1.5 1.5 0 0 0 1.5 14h.634V9.5c0-.341.165-.638.404-.836a1.3 1.3 0 0 1 .827-.289h7.27c.292 0 .59.095.827.29c.24.197.404.494.404.835V14h.634a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0h-.634v3.5c0 .328-.15.623-.382.825c-.23.2-.524.3-.817.3H6.074c-.292 0-.587-.1-.816-.3a1.1 1.1 0 0 1-.383-.825zm5.741 0H6.125v3.375h4.491zm0 14H3.384V9.625h7.232z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlower: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 8.75c.828 0 1.5-.667 1.5-1.49S7.828 5.77 7 5.77s-1.5.667-1.5 1.49s.672 1.49 1.5 1.49\"/><path d=\"M13.37 5.34a2.57 2.57 0 0 0-3.24-1.64a2.3 2.3 0 0 0-.65.3a2.58 2.58 0 1 0-4.96 0a2.3 2.3 0 0 0-.65-.31a2.561 2.561 0 1 0-1.59 4.87a3 3 0 0 0 .72.12a3 3 0 0 0-.5.51a2.54 2.54 0 0 0 .57 3.57a2.59 2.59 0 0 0 3.6-.56a2.5 2.5 0 0 0 .33-.64q.123.345.34.64a2.59 2.59 0 0 0 4.283-.17a2.54 2.54 0 0 0-.113-2.84a3 3 0 0 0-.5-.51a3 3 0 0 0 .71-.12a2.55 2.55 0 0 0 1.65-3.22\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlowerAlt: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 13.5h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1\"/><path d=\"M10 6.5a3 3 0 1 1-6 0V4.31a.5.5 0 0 1 .72-.45L7 5l2.28-1.14a.5.5 0 0 1 .72.45zm-3 3v4m0 0L9.5 11M7 13.5L4.5 11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlowerAltRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.375 12.077a.3.3 0 0 1-.298.298H8.509l1.433-1.433a.625.625 0 1 0-.884-.884l-1.433 1.433V9.443C9.245 9.142 10.5 7.697 10.5 6V3.81c0-.342-.18-.668-.47-.849a1.01 1.01 0 0 0-.965-.052l-.009.004L7 3.94L4.944 2.913l-.009-.004a1 1 0 0 0-.965.052c-.29.181-.47.507-.47.849V6c0 1.697 1.255 3.142 2.875 3.443v2.048l-1.433-1.433a.625.625 0 1 0-.884.884l1.433 1.433H1.923a.3.3 0 0 1-.298-.298V1.923c0-.165.133-.298.298-.298h10.154c.164 0 .298.133.298.298zm-5.376 1.548H1.923a1.55 1.55 0 0 1-1.548-1.548V1.923c0-.855.693-1.548 1.548-1.548h10.154c.855 0 1.548.693 1.548 1.548v10.154c0 .855-.693 1.548-1.548 1.548zM7 4.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlowerAltSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 12.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5zM9.121 7.22A3 3 0 0 0 10 5.097v-2.19a.5.5 0 0 0-.72-.45L7 3.598l-2.28-1.14a.5.5 0 0 0-.72.45v2.19a3 3 0 0 0 2.375 2.934v2.052L4.942 8.651a.625.625 0 1 0-.884.884l2.5 2.5a.62.62 0 0 0 .436.183h.012a.62.62 0 0 0 .436-.183l2.5-2.5a.625.625 0 0 0-.884-.884l-1.433 1.433V8.032a3 3 0 0 0 1.496-.813\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlowerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.932 2.905a3.126 3.126 0 0 1 6.136 0q.213-.03.432-.03a3.125 3.125 0 0 1 1.542 5.843A3.125 3.125 0 0 1 7 12.408a3.125 3.125 0 0 1-5.042-3.69a3.125 3.125 0 0 1 1.974-5.814M7 1.625A1.875 1.875 0 0 0 5.132 3.66a.625.625 0 0 1-.876.624A1.875 1.875 0 1 0 3.18 7.848a.625.625 0 0 1 .258 1.125a1.875 1.875 0 1 0 2.944 1.795a.625.625 0 0 1 1.238 0a1.876 1.876 0 1 0 2.944-1.795a.625.625 0 0 1 .257-1.125a1.876 1.876 0 1 0-1.076-3.564a.625.625 0 0 1-.876-.624A1.875 1.875 0 0 0 7 1.625M7 5a2 2 0 1 0 0 4a2 2 0 0 0 0-4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFlowerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.822 1.112a3.08 3.08 0 0 1 5.257 2.08a3.07 3.07 0 0 1 3.766 1.992l-.475.156l.475-.155a3.05 3.05 0 0 1-1.86 3.813a3.04 3.04 0 0 1-.753 4.168a3.09 3.09 0 0 1-4.227-.581a3.09 3.09 0 0 1-5.043-.291A3.04 3.04 0 0 1 2.022 9a3.062 3.062 0 0 1 1.9-5.817a3.08 3.08 0 0 1 .9-2.07M9.205 7.26c0 1.21-.987 2.19-2.205 2.19s-2.205-.98-2.205-2.19S5.782 5.07 7 5.07s2.205.98 2.205 2.19\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFluMask: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 10.25c2.5 0 3.5-1 3.5-1v-5.5h-7v5.5s1 1 3.5 1m-1-4h2m-4.5-2.5H2.268C1.29 3.75.5 4.541.5 5.518v0c0 .469.186.918.518 1.25L3.5 9.25m7-5.5h1.232c.977 0 1.768.791 1.768 1.768v0c0 .469-.186.918-.518 1.25L10.5 9.25\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFluMaskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m11 8.61l1.12-1.12a2.15 2.15 0 0 0 .631-1.522v-.612a.846.846 0 0 0-1.388-.65L11 5.007zm-.231 1.979a.6.6 0 0 0 .106-.086l2.13-2.129A3.4 3.4 0 0 0 14 5.968v-.612a2.097 2.097 0 0 0-3.439-1.611l-.396.33a1.6 1.6 0 0 1-.383-.204c-.253-.178-.495-.424-.763-.708l-.074-.08c-.235-.25-.497-.528-.774-.745c-.312-.245-.7-.46-1.172-.46s-.86.216-1.17.46c-.27.216-.528.492-.76.74l-.08.086c-.43.46-.778.789-1.154.913l-.399-.332A2.096 2.096 0 0 0 0 5.355v.613c0 .902.359 1.768.997 2.406l2.129 2.13a.6.6 0 0 0 .106.085q.045.051.101.111c.155.165.387.377.703.588c.638.425 1.608.833 2.965.833s2.327-.408 2.965-.833a4 4 0 0 0 .804-.7M3 5.008V8.61L1.88 7.49a2.15 2.15 0 0 1-.631-1.523v-.612a.846.846 0 0 1 1.388-.65zM5.375 6.5c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25H6a.625.625 0 0 1-.625-.625M6 8.375a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFluMaskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.03 5.837c0-1.365 1.047-2.56 2.442-2.56h9.056c1.395 0 2.442 1.195 2.442 2.56c0 .553-.17 1.092-.488 1.535a2.4 2.4 0 0 1-.479.479l-1.838 1.438A6.75 6.75 0 0 1 2.86 9.3L1.002 7.854a2.4 2.4 0 0 1-.488-.487a2.64 2.64 0 0 1-.484-1.53m2.442-1.06c-.474 0-.942.427-.942 1.06c0 .245.076.477.207.66a1 1 0 0 0 .186.173l1.344 1.045V4.778zm9.607 1.892l-1.346 1.053V4.778h.795c.474 0 .942.426.942 1.059c0 .246-.076.479-.208.663a1 1 0 0 1-.183.17m-5.77-1.161a.625.625 0 0 0 0 1.25h1.383a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFocusPoints: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 1.5h-1a1 1 0 0 0-1 1v1m13 0v-1a1 1 0 0 0-1-1h-1m0 11h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m4.5-5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m-4 0a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m8 0a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m-4 4a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m0-8a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFocusPointsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.36 2.36c.07-.07.166-.11.265-.11h2a.625.625 0 1 0 0-1.25h-2A1.625 1.625 0 0 0 0 2.625v2a.625.625 0 1 0 1.25 0v-2c0-.1.04-.195.11-.265m8.39-.735c0-.345.28-.625.625-.625h2A1.625 1.625 0 0 1 14 2.625v2a.625.625 0 1 1-1.25 0v-2a.375.375 0 0 0-.375-.375h-2a.625.625 0 0 1-.625-.625M5.75 3a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0M3 5.75a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5m4 0a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5M9.75 7a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0M7 9.75a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5m6.375-1c.345 0 .625.28.625.625v2A1.625 1.625 0 0 1 12.375 13h-2a.625.625 0 1 1 0-1.25h2a.375.375 0 0 0 .375-.375v-2c0-.345.28-.625.625-.625M1.25 9.375a.625.625 0 1 0-1.25 0v2A1.625 1.625 0 0 0 1.625 13h2a.625.625 0 1 0 0-1.25h-2a.375.375 0 0 1-.375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFocusPointsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.542 1.497c.32-.32.753-.5 1.205-.5h.955a.75.75 0 0 1 0 1.5h-.955a.205.205 0 0 0-.205.205v.955a.75.75 0 0 1-1.5 0v-.955c0-.452.18-.886.5-1.205m10.006.25a.75.75 0 0 1 .75-.75h.955a1.705 1.705 0 0 1 1.705 1.705v.955a.75.75 0 0 1-1.5 0v-.955a.205.205 0 0 0-.205-.205h-.955a.75.75 0 0 1-.75-.75m3.41 8.596a.75.75 0 1 0-1.5 0v.955a.205.205 0 0 1-.205.205h-.955a.75.75 0 0 0 0 1.5h.955a1.705 1.705 0 0 0 1.705-1.705zM.792 9.593a.75.75 0 0 1 .75.75v.955a.205.205 0 0 0 .205.205h.955a.75.75 0 0 1 0 1.5h-.955a1.705 1.705 0 0 1-1.705-1.705v-.955a.75.75 0 0 1 .75-.75M6 3a1 1 0 1 1 2 0a1 1 0 0 1-2 0M3 6a1 1 0 1 0 0 2a1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2m3 1a1 1 0 1 1 2 0a1 1 0 0 1-2 0m-3 3a1 1 0 1 0 0 2a1 1 0 0 0 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 5.5v5M4.5 8h5m-9 4.25V1.75a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2c0-.207.168-.375.375-.375h2.72c.171 0 .321.117.363.284l.31 1.243c.07.278.32.473.607.473h6.75c.207 0 .375.168.375.375v8a.375.375 0 0 1-.375.375H1.625A.375.375 0 0 1 1.25 12zM1.625.375C.728.375 0 1.103 0 2v10c0 .898.728 1.625 1.625 1.625h10.75c.898 0 1.625-.727 1.625-1.625V4c0-.897-.727-1.625-1.625-1.625H6.113l-.192-.77A1.625 1.625 0 0 0 4.344.376zM7 4.75a.75.75 0 0 1 .75.75v1.75H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 0 1-1.5 0V8.75H4.5a.75.75 0 0 1 0-1.5h1.75V5.5A.75.75 0 0 1 7 4.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.183.5a1.5 1.5 0 0 1 1.492 1.14l.215.86h5.61A1.5 1.5 0 0 1 14 4v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12V2A1.5 1.5 0 0 1 1.5.5zM7 4.75a.75.75 0 0 1 .75.75v1.75H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 0 1-1.5 0V8.75H4.5a.75.75 0 0 1 0-1.5h1.75V5.5A.75.75 0 0 1 7 4.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 12.25V1.75a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1\"/><path d=\"M4.5 9L6 10l3-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2c0-.207.168-.375.375-.375h2.72c.171 0 .321.117.363.284l.31 1.243c.07.278.32.473.607.473h6.75c.207 0 .375.168.375.375v8a.375.375 0 0 1-.375.375H1.625A.375.375 0 0 1 1.25 12zM1.625.375C.728.375 0 1.103 0 2v10c0 .898.728 1.625 1.625 1.625h10.75c.898 0 1.625-.727 1.625-1.625V4c0-.897-.727-1.625-1.625-1.625H6.113l-.192-.77A1.625 1.625 0 0 0 4.344.376zM9.6 6.45a.75.75 0 1 0-1.2-.9L5.826 8.982l-.91-.606a.75.75 0 0 0-.832 1.248l1.5 1A.75.75 0 0 0 6.6 10.45z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.183.5a1.5 1.5 0 0 1 1.492 1.14l.215.86h5.61A1.5 1.5 0 0 1 14 4v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12V2A1.5 1.5 0 0 1 1.5.5zM9.6 6.45a.75.75 0 1 0-1.2-.9L5.826 8.982l-.91-.606a.75.75 0 0 0-.832 1.248l1.5 1A.75.75 0 0 0 6.6 10.45z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 12.25V1.75a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1M4.5 8h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderDeleteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2c0-.207.168-.375.375-.375h2.72c.171 0 .321.117.363.284l.31 1.243c.07.278.32.473.607.473h6.75c.207 0 .375.168.375.375v8a.375.375 0 0 1-.375.375H1.625A.375.375 0 0 1 1.25 12zM1.625.375C.728.375 0 1.103 0 2v10c0 .898.728 1.625 1.625 1.625h10.75c.898 0 1.625-.727 1.625-1.625V4c0-.897-.727-1.625-1.625-1.625H6.113l-.192-.77A1.625 1.625 0 0 0 4.344.376zM4.5 7.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFolderDeleteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.183.5a1.5 1.5 0 0 1 1.492 1.14l.215.86h5.61A1.5 1.5 0 0 1 14 4v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12V2A1.5 1.5 0 0 1 1.5.5zM4.5 7.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodBaguetteCookBreadGlutenDrinkCookingNutritionBaguetteFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.636 6.93l6.468-5.074a3 3 0 0 1 4.212.509l.975 1.243a1 1 0 0 1-.17 1.404l-9.615 7.542a1 1 0 0 1-1.404-.17l-.975-1.243a3 3 0 0 1 .51-4.212Zm1.234-.97l1.56 2m2.03-4.82l1.57 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodBarbequePotCookGrillBbqDrinkCookingNutritionPotBarbecueGrillingFoodCauldron: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 12a6.51 6.51 0 0 0 6.48-6a.5.5 0 0 0-.48-.5H1a.5.5 0 0 0-.48.5A6.51 6.51 0 0 0 7 12Zm-2.95-.71L3.5 13.5m6.45-2.21l.55 2.21M3.5 3V2m7 1V2M7 3V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodBurgerDrinkBurgerFastCookCookingNutritionFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 .5h6A3.5 3.5 0 0 1 13.5 4v0a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v0A3.5 3.5 0 0 1 4 .5Zm-3.5 7h13M13 10H7l-1.5 1.5l-3-1.5H1a.5.5 0 0 0-.5.5h0a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3h0a.5.5 0 0 0-.5-.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodCakeCandleBirthdayEventSpecialSweetCakeBake: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"8\" x=\".5\" y=\"5.5\" rx=\"1\"/><path d=\"M3 3.5v-2m4 2v-2m4 2v-2m2.5 8.5H13a2 2 0 0 1-2-2a2 2 0 0 1-4 0a2 2 0 0 1-4 0a2 2 0 0 1-2 2H.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodCandyCaneCandySweetCaneChristmas: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 0 3 0V5a4.5 4.5 0 0 0-9 0v1a1.5 1.5 0 0 0 3 0Zm3 5l3-3M8.42 4.51L9.95 1.6M5.86 4.02L3.03 2.88\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodCheese1CookCheeseAnimalProductsCookingNutritionDairyFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.59 5.75H13M9.09.77L9 .75L.75 5.6A.5.5 0 0 0 .5 6v1.75c1 0 2.5 0 2.5 1.75S1.47 11.25.5 11.25v1.5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-7A5.88 5.88 0 0 0 9.09.77Z\"/><circle cx=\"10\" cy=\"8.25\" r=\".5\"/><circle cx=\"6.5\" cy=\"10.25\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodCheese2CookCheeseAnimalProductsCookingNutritionDairyFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.09.77L9 .75L.75 5.61A.47.47 0 0 0 .5 6v6.71a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-7A5.88 5.88 0 0 0 9.09.77ZM.59 5.75H13\"/><path d=\"M.5 10.42h0l.08-.07A2 2 0 0 1 2 9.75a2 2 0 0 1 2 2a2 2 0 0 1-.59 1.41l-.08.09\"/><circle cx=\"9\" cy=\"9.25\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodCherriesCookPlantCherryPlantsDrinkCookingNutritionVegetarianFruitFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"3.36\" cy=\"10.9\" r=\"2.6\"/><circle cx=\"10.64\" cy=\"9.86\" r=\"2.6\"/><path d=\"M9.41 7.57A10.36 10.36 0 0 1 6 .5a13.78 13.78 0 0 0-2.6 7.8M3.36.5h5.2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksBeerMugBeerCookBreweryDrinkMugCookingNutritionBrewBrewingFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5.5h8a1 1 0 0 1 1 1v10a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-10a1 1 0 0 1 1-1Zm9 2.5h2a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1h-2M3.75 4v5.5M7.25 4v5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksCocktail1CookAlcoholFoodCocktailDrinkCookingNutritionAlcoholicBeverageGlass: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 8.5L2.48 1.26A.5.5 0 0 1 2.9.5h8.2a.5.5 0 0 1 .42.76Zm0 0v5m-2.5 0h5M3.56 3h6.88\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksCocktailGlassCookAlcoholFoodCocktailDrinkCookingAlcoholicBeverageGlass: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.71.5a.48.48 0 0 0-.46.31a.49.49 0 0 0 .1.54L7 7l5.65-5.65a.49.49 0 0 0 .1-.54a.48.48 0 0 0-.46-.31ZM7 7v6.5m-3 0h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksCocktailShakerAlcoholDrinkMixShakeCocktail: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5 6l-.89 6.62a1 1 0 0 1-1 .88H4.38a1 1 0 0 1-1-.88L2.5 6m8.23-2.32a1 1 0 0 0-1-.68H4.22a1 1 0 0 0-.95.68L2.5 6h9Z\"/><path d=\"M8.5 3V1.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1V3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksCoffeeMugCoffeeCookCupDrinkMugCookingNutritionCafeCaffeineFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5.5h5a1 1 0 0 1 1 1v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a1 1 0 0 1 1-1Zm6 1h.5a2.5 2.5 0 0 1 0 5H9M4 .5v2m3-2v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksMilkCanisterMilkDairyCanisterDrink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11 7.5l-1.5-2h-5L3 7.5v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1Zm0 0l2.5-2M3 7.5l-2.5-2m4-5h5a1 1 0 0 1 1 1V3h0h-7h0V1.5a1 1 0 0 1 1-1Zm0 2.5v2.5m5-2.5v2.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksTeaCupHerbalCookTeaTisaneCupDrinkCookingNutritionMugFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 4h8a.5.5 0 0 1 .5.5V9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V4.5A.5.5 0 0 1 2 4ZM.5 13.5h13m-3-8.5h1a2 2 0 0 1 2 2h0a2 2 0 0 1-2 2h-1M3 .5v1m5-1v1M5.5.5v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksTeapotTeaPotDrinkHotHerb: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 6a5.51 5.51 0 0 0-4.46 2.28L1.5 7l-1 1l2 3.5v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1A5.5 5.5 0 0 0 8 6Zm0 0V4.5\"/><path d=\"M4 7.73V4.5a4 4 0 0 1 8 0v3.23\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksWaterGlassGlassWaterJuiceDrinkLiquid: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.2 11.73a2 2 0 0 1-2 1.77H4.78a2 2 0 0 1-2-1.77L1.5.5h11ZM1.96 4.5h10.08\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksWineBottleCookBottleWineDrinkCookingNutritionFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.25 4V1a.5.5 0 0 0-.5-.5h-1.5a.5.5 0 0 0-.5.5v3h0a3.36 3.36 0 0 0-1.5 2.8v5.7a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V6.8A3.36 3.36 0 0 0 8.25 4Zm-4 3.5h5.5m0 3.5h-5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrinksWineGlassDrinkCookGlassCookingWineNutritionFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.67.5a1 1 0 0 0-1 .89C2.56 2.45 2.5 4.05 2.5 4.5c0 2.62 2 4 4.5 4s4.5-1.38 4.5-4c0-.45-.06-2-.17-3.11a1 1 0 0 0-1-.89ZM7 8.5v5m-2 0h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodDrumStick1CookAnimalDrumsticksProductsChickenCookingNutritionFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.49 9.6a1.66 1.66 0 0 0-3-.79l-1-1s-.08-.05-.11-.08A5.6 5.6 0 0 0 8 1.87a4.15 4.15 0 0 0-6.13 0A4.16 4.16 0 0 0 1.83 8a5.58 5.58 0 0 0 6 1.34a.56.56 0 0 0 0 .08L9 10.58A1.63 1.63 0 0 0 8.43 12a1.66 1.66 0 0 0 3.31-.34a1.6 1.6 0 0 0-.05-.21H12a1.65 1.65 0 0 0 1.49-1.85Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodFishCookCookingFishSeafoodNutritionFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.23 11.06a5 5 0 0 0 2.63-2.14a2.88 2.88 0 0 0 1.25 1A1 1 0 0 0 13.5 9V6.39a1 1 0 0 0-1.39-.92a2.83 2.83 0 0 0-1.25 1c-1-1.56-3.72-2.77-6.45-2.77a4 4 0 0 0-3.91 4a4 4 0 0 0 4.16 3.75h1.08\"/><circle cx=\"4\" cy=\"6.69\" r=\".5\"/><path d=\"M3.23 3.87C4 2.68 5.81 1.34 9.82 1.8a5.16 5.16 0 0 0 0 3.57M4.64 9.53a3.5 3.5 0 0 0 4 2.76L7.63 9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodIceCream1CookFrozenBitePopsicleCreamIceCookingNutritionFreezerColdFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 10v2.5a1 1 0 0 1-1 1h0a1 1 0 0 1-1-1V10m3.75-7A1.75 1.75 0 0 1 8 1.25a1.74 1.74 0 0 1 .1-.56A3.63 3.63 0 0 0 7 .5A3.5 3.5 0 0 0 3.5 4v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4a3.63 3.63 0 0 0-.19-1.1a1.74 1.74 0 0 1-.56.1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodIceCream2CookFrozenFoodPopsicleFreezerNutritionCreamStickColdIceCooking: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8\" height=\"9\" x=\"3\" y=\".5\" rx=\"1\"/><path d=\"M5.5 3v3.5m3-3.5v3.5m0 3V12a1.5 1.5 0 0 1-3 0V9.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodIceCream3CookFrozenConeCreamIceCookingNutritionFreezerColdFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10.36 6.48l-2.87 6.7a.54.54 0 0 1-1 0l-2.85-6.7\"/><circle cx=\"4.88\" cy=\"4.75\" r=\"2.13\"/><path d=\"M4.88 2.63a2.12 2.12 0 1 1 4.24 0\"/><circle cx=\"9.13\" cy=\"4.75\" r=\"2.13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareBowlChopStickCookSoupBowlChopsticksCookingNutritionAsianFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5A6.5 6.5 0 0 0 13.5 7H.5A6.5 6.5 0 0 0 7 13.5ZM7.5 5l3-4.5M9 5.5l3.5-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareChefToqueHatCookGearChefCookingNutritionToolsClothesHatClothingFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 13.5h9m1.93-10.1a2.49 2.49 0 0 0-4.09-1.26a2.49 2.49 0 0 0-4.68 0A2.49 2.49 0 0 0 .57 3.4A2.51 2.51 0 0 0 2.5 6.45V10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6.45a2.51 2.51 0 0 0 1.93-3.05ZM2.5 8.5h9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareForkSpoonForkSpoonFoodDineCookUtensilsEatRestaurantDining: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"10.6\" cy=\"3.5\" rx=\"2.4\" ry=\"3\"/><path d=\"M10.6 6.5v7M3.5.5v13M6 .5V3a2.5 2.5 0 0 1-2.5 2.5h0A2.5 2.5 0 0 1 1 3V.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareMicrowaveCookFoodAppliancesCookingNutritionApplianceMicrowave: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2.5\" rx=\".5\"/><rect width=\"6.5\" height=\"5\" x=\"2.5\" y=\"4.5\" rx=\".5\"/><path d=\"M11 5h.5M11 6.5h.5M11.25 9h0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareNoFoodAllowedForkSpoonFoodDineCookUtensilsEatRestaurantNotAllowed: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5.5v10M6 .5V3a2.5 2.5 0 0 1-2.5 2.5h0A2.5 2.5 0 0 1 1 3V.5m-.5 13l13-13m-1 5A14.61 14.61 0 0 1 13 10H8.5m0-4.5v-5a7.41 7.41 0 0 1 2.66 2.34M8.5 13.5V9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareRefrigeratorFridgeCookAppliancesCookingNutritionFreezerApplianceFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"9\" height=\"12\" x=\"2.5\" y=\".5\" rx=\"1\"/><path d=\"M2.5 6h9m-7-3v.5m-.5 9v1m6-1v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareServingDomeCookToolDomeKitchenServingPaltterDishToolsFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 3h0a6.5 6.5 0 0 1 6.5 6.5v0a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v0A6.5 6.5 0 0 1 7 3Zm0 0V1.5m-6.5 11h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodKitchenwareSpoonPlateForkPlateFoodDineCookUtensilsEatRestaurantDining: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5.5v2.25a2.5 2.5 0 0 0 5 0V.5M3 .5v13m10.5 0a6.5 6.5 0 0 1 0-13\"/><path d=\"M13.5 10.5a3.5 3.5 0 0 1 0-7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodMeatCookMeatCownSliceOrganicCookingNutritionFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 5.44V4.5a2 2 0 0 1 2-2h6.05a.91.91 0 0 1 .95.84v3.82a.91.91 0 0 1-.95.84H8.8\"/><path d=\"M13.5 9.24v2.88a1.38 1.38 0 0 1-1.38 1.38H6.79a1.38 1.38 0 0 1-1.33-1h0a1.37 1.37 0 0 0-1.32-1h-.56A3.08 3.08 0 0 1 .5 8.42V4.56\"/><path d=\"M11.5.5a2 2 0 0 1 2 2v6.74a1.38 1.38 0 0 1-1.38 1.38H8a1.38 1.38 0 0 1-1.33-1h0a1.37 1.37 0 0 0-1.32-1h-.79a4.06 4.06 0 0 1 0-8.12Z\"/><circle cx=\"5.33\" cy=\"5.14\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodPizzaDrinkCookFastCookingNutritionPizzaFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.75.5L8 6l5.5-1.75A3.75 3.75 0 0 0 9.75.5Z\"/><path d=\"M7.5.52L7 .5A6.5 6.5 0 1 0 13.5 7v-.5\"/><circle cx=\"5.5\" cy=\"9.5\" r=\".5\"/><circle cx=\"4\" cy=\"5\" r=\".5\"/><circle cx=\"10.5\" cy=\"8\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodPopcornCookCornMovieSnackCookingNutritionBake: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.56 6l.83 6.62a1 1 0 0 0 1 .88h5.23a1 1 0 0 0 1-.88L11.44 6\"/><path d=\"M11 3.07a1.49 1.49 0 0 0-.36.05a1.81 1.81 0 0 0 .14-.69A2 2 0 0 0 8.76.5A2 2 0 0 0 7 1.56A2 2 0 0 0 5.24.5a2 2 0 0 0-2 1.93a1.81 1.81 0 0 0 .14.69A1.49 1.49 0 0 0 3 3.07a1.5 1.5 0 1 0 0 3a1.56 1.56 0 0 0 1.2-.56a1.53 1.53 0 0 0 1.44 1A1.55 1.55 0 0 0 7 5.76a1.55 1.55 0 0 0 1.32.74a1.53 1.53 0 0 0 1.44-1a1.56 1.56 0 0 0 1.2.56a1.5 1.5 0 1 0 0-3Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodSteakCookGrillSteakBbqCookingNutritionBarbecueGrillingFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.62 2.5C4.29 2.5.5 3.15.5 6a2.75 2.75 0 0 0 3 2.44a3.55 3.55 0 0 0 1.28-.24a1 1 0 0 1 .8 0a6.41 6.41 0 0 0 3.04.8c2.7 0 4.88-1.46 4.88-3.25S11.32 2.5 8.62 2.5Z\"/><path d=\"M13.5 5.75v2.5c0 1.79-2.18 3.25-4.88 3.25a6.41 6.41 0 0 1-3.06-.73a1 1 0 0 0-.8 0a3.55 3.55 0 0 1-1.28.23a2.75 2.75 0 0 1-3-2.44V6\"/><circle cx=\"4\" cy=\"5.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodToastBreadToastBreakfast: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 3A2.5 2.5 0 0 0 11 .5H3A2.5 2.5 0 0 0 1.5 5v7.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V5a2.49 2.49 0 0 0 1-2Zm-5 .5l-4 4m5-1l-4 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodWaterMelonCookPlantPlantsDrinkCookingNutritionWatermelonFruitVegetarianFood: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.13 1L1 10.65a1.14 1.14 0 0 0 .48 1.55a12.22 12.22 0 0 0 11 0a1.14 1.14 0 0 0 .52-1.55L7.87 1a1 1 0 0 0-1.74 0Z\"/><path d=\"M12.24 9.29a12 12 0 0 1-10.48 0M5.5 7.5V8m3-.5V8M7 4.5V5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFoodWheatCookPlantBreadGlutenGrainCookingNutritionFoodWheat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.53 10.85l.84 2.35M1.98.97l.34.94m3.21 8.94l-1.75-.43m1.75.43L6.6 9.4m-1.92-.9l-1.75-.44m1.75.44l1.08-1.45m-1.92-.91l-1.75-.43m1.75.43L4.91 4.7m-1.92-.91l-1.75-.43m1.75.43l1.08-1.45m5.44 7.91l-.56 2.25M11.85.8l-.22.9m-2.12 8.55L8.38 9.01m1.13 1.24l1.57-.56M10.06 8L8.94 6.76M10.06 8l1.58-.57m-1.02-1.68L9.5 4.51m1.12 1.24l1.58-.57M11.18 3.5l-1.12-1.24m1.12 1.24l1.58-.57\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineForkKnife: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5 13.5V.5c4 2 4.5 7.5 4.5 9.5H8.5M3.5.5v13M6 .5V3a2.5 2.5 0 0 1-2.5 2.5v0A2.5 2.5 0 0 1 1 3V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineForkKnifeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.171.468A.63.63 0 0 1 8.78.441c2.19 1.095 3.4 3.004 4.059 4.849c.657 1.84.786 3.668.786 4.71a.624.624 0 0 1-.625.625H9.625V13a.875.875 0 0 1-1.75 0V1c0-.217.112-.418.296-.532m.954 1.643v7.264h3.234c-.048-.974-.219-2.324-.698-3.665c-.484-1.357-1.271-2.671-2.536-3.6m-5 3.157A1.88 1.88 0 0 0 5.375 3.5V1a.625.625 0 1 1 1.25 0v2.5c0 1.422-.95 2.622-2.25 3V13a.875.875 0 0 1-1.75 0V6.5a3.13 3.13 0 0 1-2.25-3V1a.625.625 0 0 1 1.25 0v2.5c0 .816.522 1.51 1.25 1.768V1a.625.625 0 1 1 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineForkKnifeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.974.15a1 1 0 0 1 .973-.044c2.333 1.166 3.467 3.203 4.015 5.12c.538 1.884.538 3.748.538 4.75V10a1 1 0 0 1-1 1h-3v2a1 1 0 1 1-2 0V1a1 1 0 0 1 .474-.85M1 .25a.75.75 0 0 1 .75.75v2.5a1.75 1.75 0 0 0 1 1.581V1a.75.75 0 0 1 1.5 0v4.081a1.75 1.75 0 0 0 1-1.581V1a.75.75 0 0 1 1.5 0v2.5A3.25 3.25 0 0 1 4.5 6.592V13a1 1 0 1 1-2 0V6.592A3.25 3.25 0 0 1 .25 3.5V1A.75.75 0 0 1 1 .25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineForkSpoon: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.6 6.5c1.326 0 2.4-1.343 2.4-3s-1.074-3-2.4-3s-2.4 1.343-2.4 3s1.075 3 2.4 3m0 0v7M3.5.5v13M6 .5V3a2.5 2.5 0 0 1-2.5 2.5v0A2.5 2.5 0 0 1 1 3V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineForkSpoonRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1a.625.625 0 1 0-1.25 0v2.5c0 1.422.95 2.622 2.25 3V13a.875.875 0 0 0 1.75 0V6.5a3.13 3.13 0 0 0 2.25-3V1a.625.625 0 1 0-1.25 0v2.5c0 .816-.522 1.51-1.25 1.768V1a.625.625 0 1 0-1.25 0v4.268A1.88 1.88 0 0 1 1.625 3.5zm8.875.625c-.934 0-1.875.952-1.875 2.375s.941 2.375 1.875 2.375S12.375 5.423 12.375 4s-.941-2.375-1.875-2.375M7.375 4C7.375 2.11 8.672.375 10.5.375S13.625 2.11 13.625 4c0 1.572-.897 3.036-2.25 3.485V13a.875.875 0 0 1-1.75 0V7.485C8.272 7.036 7.375 5.572 7.375 4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineForkSpoonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.785.024a.75.75 0 0 1 .75.75v2.5a1.75 1.75 0 0 0 1 1.581V.774a.75.75 0 1 1 1.5 0v4.081a1.75 1.75 0 0 0 1-1.581v-2.5a.75.75 0 1 1 1.5 0v2.5a3.25 3.25 0 0 1-2.25 3.092V13a1 1 0 0 1-2 0V6.367a3.25 3.25 0 0 1-2.25-3.093v-2.5a.75.75 0 0 1 .75-.75m10.05 0c-1.772 0-2.941 1.727-2.941 3.489c0 1.404.742 2.786 1.94 3.29V13a1 1 0 1 0 2 0V6.802c1.2-.503 1.942-1.885 1.942-3.29c0-1.761-1.17-3.488-2.941-3.488\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFragile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.67.5a1 1 0 0 0-1 .89C2.56 2.45 2.5 4.05 2.5 4.5c0 2.62 2 4 4.5 4s4.5-1.38 4.5-4c0-.45-.06-2-.17-3.11a1 1 0 0 0-1-.89zM7 8.5v5m-2 0h4\"/><path d=\"m7 .5l-1.5 2l2 1.5l-1 1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFragileRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0C1.603 0 .875.728.875 1.625v2.884c0 1.776.685 3.179 1.83 4.127c.986.816 2.273 1.263 3.67 1.365v2.744h-2a.625.625 0 1 0 0 1.25h5.25a.625.625 0 1 0 0-1.25h-2v-2.744c1.397-.102 2.684-.55 3.67-1.365c1.145-.948 1.83-2.351 1.83-4.127V1.625C13.125.728 12.398 0 11.5 0zm-.375 1.625c0-.207.168-.375.375-.375h3.042l-.932.932a.75.75 0 0 0 .131 1.166l1.814 1.137l-1.141 1.14a.75.75 0 1 0 1.06 1.062L8.282 4.88a.75.75 0 0 0-.132-1.166L6.336 2.577L7.454 1.46a.8.8 0 0 0 .148-.21H11.5c.207 0 .375.168.375.375v2.884c0 1.427-.537 2.468-1.378 3.164c-.855.708-2.078 1.1-3.497 1.1s-2.642-.392-3.497-1.1c-.841-.696-1.378-1.737-1.378-3.164z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFragileSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.048 0H3.254a1.136 1.136 0 0 0-1.125 1.001L1.938 4.5c0 2.588 1.735 4.1 4.062 4.431v3.045H4.165a1 1 0 1 0 0 2h5.67a1 1 0 1 0 0-2H8V8.93c2.327-.33 4.063-1.843 4.063-4.431L11.871 1a1.136 1.136 0 0 0-1.125-1H7.534l-.009.014L6.318 1.89L7.91 3.282c.224.196.28.523.131.781l-1 1.747a.625.625 0 0 1-1.084-.62l.745-1.303l-1.614-1.41a.625.625 0 0 1-.115-.81z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFrontCamera: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.96 6.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.083.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M4.555 8.857c.477.485 1.318.929 2.443.929s1.967-.444 2.444-.929\"/><path d=\"M13.5 4.5a1 1 0 0 0-1-1h-2L9 1.5H5l-1.5 2h-2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFrontCameraRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 .75a.63.63 0 0 0-.5.25L3.188 2.75H1.625C.728 2.75 0 3.478 0 4.375v7.25c0 .898.728 1.625 1.625 1.625h10.75c.898 0 1.625-.727 1.625-1.625v-7.25c0-.897-.727-1.625-1.625-1.625h-1.562L9.5 1A.63.63 0 0 0 9 .75zm-1 3L5.313 2h3.375L10 3.75c.118.157.303.25.5.25h1.875c.207 0 .375.168.375.375v7.25a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375v-7.25c0-.207.168-.375.375-.375H3.5a.63.63 0 0 0 .5-.25m1 1.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2m3 1a1 1 0 1 0 2 0a1 1 0 0 0-2 0M4.03 8.322a.75.75 0 0 1 1.06.01c.335.34.983.704 1.908.704s1.574-.364 1.909-.705a.75.75 0 1 1 1.07 1.052c-.619.629-1.653 1.153-2.979 1.153c-1.325 0-2.36-.524-2.978-1.153a.75.75 0 0 1 .01-1.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineFrontCameraSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.6 1.2A.5.5 0 0 1 5 1h4a.5.5 0 0 1 .4.2L10.75 3h1.75A1.5 1.5 0 0 1 14 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 11.5v-7A1.5 1.5 0 0 1 1.5 3h1.75zM4.75 7a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5M5 8.42a.625.625 0 1 0-.89.876c.594.604 1.596 1.115 2.888 1.115c1.293 0 2.295-.51 2.89-1.115a.625.625 0 1 0-.892-.877c-.358.365-1.039.742-1.998.742c-.958 0-1.639-.377-1.997-.742m5-2.17a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGalaxy1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.013 9c3 0 5.713-2 5.713-5.083M7.013 5c-3 0-5.739 2-5.739 5.083\"/><path d=\"M5 7a2 2 0 1 0 4 0a2 2 0 1 0-4 0\"/><path d=\"M8.739 7.989C10.239 5.39 9.863 2.042 7.193.5M5.274 5.989c-1.5 2.598-1.137 5.97 1.533 7.511\"/><path d=\"M8.726 5.989c-1.5-2.598-4.589-3.947-7.259-2.406m3.794 4.406c1.5 2.598 4.602 3.97 7.272 2.428\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGalaxy1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.648.312a.625.625 0 0 1 .854-.23c2.822 1.63 3.286 5.006 2.01 7.694c1.471-.719 2.48-2.082 2.48-3.8a.625.625 0 0 1 1.25 0c0 3.254-2.685 5.342-5.645 5.587c1.36.908 3.039 1.101 4.518.247a.625.625 0 1 1 .625 1.083c-2.813 1.624-5.966.331-7.66-2.098c-.109 1.632.564 3.185 2.043 4.04a.625.625 0 0 1-.625 1.082c-2.813-1.624-3.27-5-2.013-7.683c-1.468.722-2.476 2.081-2.476 3.79a.625.625 0 1 1-1.25 0c0-3.253 2.704-5.338 5.66-5.586c-1.359-.916-3.044-1.108-4.533-.249a.625.625 0 0 1-.625-1.082c2.821-1.63 5.978-.343 7.668 2.106c.112-1.634-.564-3.188-2.052-4.048a.625.625 0 0 1-.23-.853\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGalaxy1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.558.198a.75.75 0 1 0-.75 1.3c1.249.72 1.888 1.977 1.917 3.346c-1.714-2.18-4.668-3.269-7.337-1.728a.75.75 0 0 0 .75 1.3c1.251-.723 2.661-.647 3.863.015C3.26 4.83.83 6.84.83 9.918a.75.75 0 1 0 1.5 0c0-1.434.769-2.613 1.939-3.324c-1.016 2.57-.489 5.672 2.172 7.208a.75.75 0 1 0 .75-1.3c-1.242-.716-1.878-1.972-1.909-3.34C7 11.326 9.95 12.42 12.611 10.884a.75.75 0 0 0-.75-1.3c-1.24.717-2.644.641-3.844-.014c2.74-.399 5.151-2.412 5.151-5.488a.75.75 0 0 0-1.5 0c0 1.442-.768 2.624-1.94 3.334c1.032-2.575.497-5.677-2.171-7.218M7 8.001A1.001 1.001 0 1 0 7 6a1.001 1.001 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGalaxy2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.987 7a2 2 0 1 0 4 0a2 2 0 1 0-4 0\"/><path d=\"M7 9c3.5 0 6.5-2 6.5-4.5c0-3-6.5-3.5-9-2\"/><path d=\"M7 5C3.5 5 .5 7 .5 9.5c0 3 6.5 3.5 9 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGalaxy2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.695 2.278c.752.516 1.306 1.27 1.306 2.27c0 1.495-.897 2.77-2.173 3.642C10.55 9.066 8.83 9.587 7 9.587h-.013A2.587 2.587 0 0 1 4.59 6.026a6.5 6.5 0 0 0-1.713.815C1.823 7.563 1.25 8.496 1.25 9.452c0 .472.243.883.763 1.24c.533.366 1.308.635 2.206.78c.89.143 1.859.158 2.745.05c.894-.11 1.657-.338 2.168-.644a.625.625 0 1 1 .643 1.072c-.716.43-1.67.692-2.66.813c-1 .121-2.085.105-3.095-.057c-1.002-.162-1.975-.476-2.714-.984C.554 11.206 0 10.452 0 9.452c0-1.495.897-2.77 2.173-3.642c1.273-.871 2.982-1.392 4.8-1.397h.04a2.587 2.587 0 0 1 2.368 3.57a6.5 6.5 0 0 0 1.743-.824c1.054-.722 1.628-1.654 1.628-2.611c0-.472-.243-.883-.763-1.24c-.533-.366-1.308-.635-2.206-.78a10 10 0 0 0-2.745-.05c-.894.11-1.657.338-2.168.644a.625.625 0 0 1-.643-1.072c.716-.43 1.67-.692 2.66-.812c1-.122 2.085-.106 3.095.057c1.002.161 1.975.475 2.714.983\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGalaxy2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.556 2.35c.749.514 1.317 1.278 1.317 2.3c0 1.498-.899 2.76-2.148 3.615c-1.253.858-2.932 1.365-4.712 1.365h-.012a2.63 2.63 0 0 1-2.538-3.323a6 6 0 0 0-1.315.666c-.984.673-1.495 1.525-1.495 2.377c0 .389.195.74.666 1.064c.486.333 1.204.585 2.052.722c.84.135 1.753.15 2.588.047c.846-.103 1.554-.318 2.018-.596a.75.75 0 0 1 .772 1.286c-.71.427-1.647.682-2.608.8a11 11 0 0 1-3.009-.056c-.972-.157-1.929-.463-2.662-.967c-.75-.514-1.317-1.279-1.317-2.3c0-1.498.899-2.76 2.148-3.615c1.247-.854 2.916-1.36 4.686-1.365h.04a2.63 2.63 0 0 1 2.509 3.333c.5-.18.952-.409 1.342-.676c.984-.673 1.495-1.525 1.495-2.377c0-.389-.195-.74-.666-1.064c-.485-.333-1.204-.585-2.052-.722a9.5 9.5 0 0 0-2.588-.047c-.845.103-1.554.317-2.018.596a.75.75 0 0 1-.772-1.286c.71-.427 1.647-.682 2.609-.8a11 11 0 0 1 3.008.056c.973.157 1.929.463 2.662.967M6.993 5.87h.011a1.13 1.13 0 1 1-.011 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGameboy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 10.5a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/><path d=\"M11.938 12.219a1 1 0 0 1-1 1H3.061a1 1 0 0 1-1-1V1.78a1 1 0 0 1 1-1h7.876a1 1 0 0 1 1 1z\"/><path d=\"M10.031 7.54H3.969V2.494h6.062zm-4.897 3.813V9.647m-.853.853h1.706\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGameboyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.25 1.606c0-.197.16-.356.356-.356h8.827c.196 0 .356.16.356.356v10.788c0 .197-.16.356-.356.356H2.606a.356.356 0 0 1-.356-.356zM2.606 0C1.719 0 1 .719 1 1.606v10.788C1 13.281 1.719 14 2.606 14h8.827c.887 0 1.606-.719 1.606-1.606V1.606c0-.887-.72-1.606-1.606-1.606zm.6 2.626c0-.345.28-.625.626-.625h6.375c.345 0 .624.28.624.625V7.53c0 .345-.28.625-.624.625H3.832a.625.625 0 0 1-.625-.625zm6.268 6.566a1.24 1.24 0 0 1-.003 2.481zm-.005 2.481a1.24 1.24 0 0 1 .002-2.48zM4.567 8.702a.75.75 0 0 1 .75.75v.23h.231a.75.75 0 1 1 0 1.5h-.23v.231a.75.75 0 1 1-1.5 0v-.23h-.232a.75.75 0 0 1 0-1.5h.231v-.231a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGameboySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.558 14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H2.442a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1zM9.412 7.608a1 1 0 0 0 1-1V2.926a1 1 0 0 0-1-1H4.59a1 1 0 0 0-1 1v3.682a1 1 0 0 0 1 1zm-5.138 3.936a.625.625 0 1 0 1.25 0v-.334h.335a.625.625 0 1 0 0-1.25h-.335v-.335a.625.625 0 1 0-1.25 0v.335H3.94a.625.625 0 1 0 0 1.25h.334zm5.226-.073a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGasStationFuelPetroleum: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 3.5v9a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-9a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2m0 1h8m-8 3h8m0 4h3a2 2 0 0 0 2-2v0a2 2 0 0 0-2-2v0a1 1 0 0 1-1-1V4l3-3\"/><path d=\"m10.5 5.5l2-.5V2M6 10v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGasStationFuelPetroleumRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.692 1.442a.625.625 0 1 0-.884-.884l-2.75 2.75a.63.63 0 0 0-.183.442v2.875c0 .69.56 1.25 1.25 1.25s1.25.56 1.25 1.25v.125c0 .76-.616 1.375-1.375 1.375H9.125V3.25A2.625 2.625 0 0 0 6.5.625H3A2.625 2.625 0 0 0 .375 3.25v8.5c0 .898.728 1.625 1.625 1.625h5.5c.855 0 1.556-.66 1.62-1.5H11a2.625 2.625 0 0 0 2.625-2.625v-.125a2.5 2.5 0 0 0-2.5-2.5V6H12.5c.345 0 .625-.28.625-.625V2.009zM11.875 4.75h-.75v-.741l.75-.75zm-4-1.5c0-.76-.616-1.375-1.375-1.375H3c-.76 0-1.375.616-1.375 1.375v8.5c0 .207.168.375.375.375h5.5a.375.375 0 0 0 .375-.375zm-5.25 1.5a.5.5 0 0 1 .5-.5h3.25a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3.25a.5.5 0 0 1-.5-.5zM3.75 9.375a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGasStationFuelPetroleumSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.723.859a.625.625 0 0 1 0 .883l-.793.793v2.17a.625.625 0 0 1-.473.606l-1.479.37v.987a.35.35 0 0 0 .351.351a2.577 2.577 0 1 1 0 5.154H8.901v.327a1.5 1.5 0 0 1-1.5 1.5H1.594a1.5 1.5 0 0 1-1.5-1.5V3.788a2.5 2.5 0 0 1 2.5-2.5H6.4a2.5 2.5 0 0 1 2.5 2.5v7.135h2.428a1.327 1.327 0 1 0 0-2.654a1.6 1.6 0 0 1-1.6-1.6V4.227c0-.165.065-.324.182-.442L12.84.86a.625.625 0 0 1 .884 0M1.093 7.144V4.881h6.808v2.263zm4.87 2.316c.345 0 .625.28.625.625v.976a.625.625 0 1 1-1.25 0v-.976c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGenderEquality: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.113.86h2.69v2.69M11.802.86L8.645 4.016M6.424 9.363v4.047M4.63 11.617h3.587M3.299 6.238a3.125 3.125 0 1 0 6.25 0a3.125 3.125 0 1 0-6.25 0m2.011-.835h2.227M5.31 7.073h2.227\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGenderEqualityRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.5 0a.5.5 0 0 0-.354.854l.808.808l-1.013 1.013a4.125 4.125 0 1 0-3.066 7.403v1.172H5a.625.625 0 1 0 0 1.25h.875v.875a.625.625 0 1 0 1.25 0V12.5H8a.625.625 0 1 0 0-1.25h-.875v-1.172a4.126 4.126 0 0 0 2.7-6.52l1.013-1.013l.808.809A.5.5 0 0 0 12.5 3V.5A.5.5 0 0 0 12 0zm-.967 3.967l-.003-.003a2.875 2.875 0 1 0 .007.007zM4.875 5c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25h-2A.625.625 0 0 1 4.875 5M5.5 6.375a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGenderEqualitySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.335.764a.75.75 0 0 1 .75-.75h2.672a.75.75 0 0 1 .75.75v2.673a.75.75 0 1 1-1.5 0v-.863l-1.39 1.39a3.856 3.856 0 0 1-2.454 5.927v.813h1.031a.75.75 0 0 1 0 1.5H7.163v1.032a.75.75 0 1 1-1.5 0v-1.032H4.63a.75.75 0 1 1 0-1.5h1.032V9.89a3.856 3.856 0 1 1 2.892-6.987l1.39-1.39h-.86a.75.75 0 0 1-.75-.75M4.448 4.962c0-.345.28-.625.625-.625h2.68a.625.625 0 1 1 0 1.25h-2.68a.625.625 0 0 1-.625-.625m.625 1.67a.625.625 0 0 0 0 1.25h2.68a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGifFormat: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.438 4.656v4.289s0 2-2 2H2.563s-2 0-2-2V4.656s0-2 2-2h8.875s2 0 2 2M6 5.045h1.756m0 3.51H6m.878-3.51v3.51\"/><path d=\"M3.758 7.093h.878v.585a.88.88 0 0 1-.878.878h-.585a.88.88 0 0 1-.878-.878V5.923c0-.485.393-.878.878-.878h.585a.88.88 0 0 1 .828.585m4.799 2.926v-3.51h2.34m-2.34 1.608h2.047\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGifFormatRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.375 11.375c.76 0 1.375-.616 1.375-1.375V4c0-.76-.616-1.375-1.375-1.375h-8.75c-.76 0-1.375.616-1.375 1.375v6c0 .76.616 1.375 1.375 1.375zM14 4v6a2.625 2.625 0 0 1-2.625 2.625h-8.75A2.625 2.625 0 0 1 0 10V4a2.625 2.625 0 0 1 2.625-2.625h8.75A2.625 2.625 0 0 1 14 4M1.875 6c0-.897.728-1.625 1.625-1.625h1c.602 0 1.127.328 1.407.812a.625.625 0 1 1-1.082.626a.38.38 0 0 0-.325-.188h-1A.375.375 0 0 0 3.125 6v2c0 .207.168.375.375.375h1A.375.375 0 0 0 4.875 8v-.125H4.25a.625.625 0 1 1 0-1.25H5.5c.345 0 .625.28.625.625V8c0 .897-.728 1.625-1.625 1.625h-1A1.625 1.625 0 0 1 1.875 8zm6-1a.625.625 0 1 0-1.25 0v4a.625.625 0 1 0 1.25 0zm.5 0c0-.345.28-.625.625-.625h2.5a.625.625 0 1 1 0 1.25H9.625v.75H11a.625.625 0 1 1 0 1.25H9.625V9a.625.625 0 1 1-1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGifFormatSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.438 2.156a2.5 2.5 0 0 1 2.5 2.5v4.289a2.5 2.5 0 0 1-2.5 2.5H2.563a2.5 2.5 0 0 1-2.5-2.5V4.656a2.5 2.5 0 0 1 2.5-2.5zM7.806 9.153a.5.5 0 0 0 0-1H7.38V5.449h.426a.5.5 0 1 0 0-1H5.954a.5.5 0 1 0 0 1h.426v2.704h-.426a.5.5 0 1 0 0 1zM2.269 5.875c0-.236.19-.426.426-.426h.617c.185 0 .344.117.402.284a.5.5 0 0 0 .943-.334a1.43 1.43 0 0 0-1.345-.95h-.617c-.787 0-1.426.638-1.426 1.426v1.852c0 .787.639 1.426 1.426 1.426h.617c.788 0 1.426-.639 1.426-1.426v-.618a.5.5 0 0 0-.5-.5h-.926a.5.5 0 1 0 0 1h.426v.118c0 .235-.19.426-.426.426h-.617a.426.426 0 0 1-.426-.426zm6.993-.926a.5.5 0 0 1 .5-.5h2.469a.5.5 0 1 1 0 1h-1.97v.697h1.661a.5.5 0 0 1 0 1h-1.66v1.507a.5.5 0 0 1-1 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGift: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 3h-11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1m0 4v5.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V7M7 3v10.5m3-13L7 3L4 .5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGift2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.276 12.235V6.393H1.724v5.842a1 1 0 0 0 1 1h8.552a1 1 0 0 0 1-1M7 13.234V6.391m6.138-1.599v.6a1 1 0 0 1-1 1H1.862a1 1 0 0 1-1-1v-.6a1 1 0 0 1 1-1h10.276a1 1 0 0 1 1 1M7 3.792C7 2.917 5.98.875 4.448.875c-2.491 0-1.584 2.917-.391 2.917m2.943 0C7 2.917 8.02.875 9.552.875c2.491 0 1.584 2.917.391 2.917\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGift2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.047 3.167a3 3 0 0 1-.112-.425c-.105-.569-.042-1.272.464-1.833C2.896.357 3.66.125 4.557.125C5.671.125 6.497.84 7 1.518C7.503.84 8.33.125 9.443.125c.896 0 1.66.232 2.159.784c.505.56.568 1.264.463 1.833a3 3 0 0 1-.112.425H12c.898 0 1.625.727 1.625 1.625v1.1c0 .565-.288 1.062-.724 1.353V12c0 .898-.728 1.625-1.625 1.625H2.724A1.625 1.625 0 0 1 1.1 12V7.245a1.62 1.62 0 0 1-.724-1.353v-1.1c0-.898.728-1.625 1.625-1.625zm2.007 0q-.03-.03-.063-.068a1.5 1.5 0 0 1-.335-.674c-.041-.223.013-.311.042-.344c.038-.042.227-.206.86-.206c.323 0 .704.224 1.06.718c.14.195.249.394.328.574zm4 0h1.892q.03-.03.063-.068a1.5 1.5 0 0 0 .335-.674c.041-.223-.013-.311-.042-.344c-.038-.042-.227-.206-.86-.206c-.323 0-.704.224-1.06.718c-.14.195-.249.394-.328.574M2.349 12V7.517h3.526v4.858h-3.15A.375.375 0 0 1 2.348 12m5.776.375V7.517h3.526V12a.375.375 0 0 1-.375.375zm-6.5-7.583c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v1.1a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGift2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.956 3.391H3.449a1.4 1.4 0 0 1-.277-.712c-.023-.256.04-.434.139-.543c.091-.101.316-.257.861-.257c.497 0 1.008.34 1.442.94c.137.19.25.386.342.572m-4.279-.58q.028.295.115.58h-.594a1 1 0 0 0-1 1v.882a1 1 0 0 0 1 1h11.604a1 1 0 0 0 1-1v-.882a1 1 0 0 0-1-1h-.594q.088-.285.115-.58c.048-.552-.072-1.182-.52-1.68C11.348.628 10.663.38 9.828.38c-1.2 0-2.103.792-2.659 1.564a5 5 0 0 0-.169.25a5 5 0 0 0-.17-.25C6.276 1.17 5.372.379 4.173.379c-.836 0-1.52.248-1.975.753c-.449.497-.568 1.127-.52 1.68Zm6.367.58h2.507a1.4 1.4 0 0 0 .277-.712c.023-.256-.04-.434-.139-.543c-.091-.101-.316-.257-.861-.257c-.497 0-1.008.34-1.442.94c-.137.19-.25.386-.342.572M1.198 7.523h5.177v6.332H2.154a1 1 0 0 1-1-1V7.523zm10.648 6.332H7.625V7.523h5.221v5.332a1 1 0 0 1-1 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGiftRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.56.453a.875.875 0 1 0-1.12 1.344L4.883 3H2C1.103 3 .375 3.728.375 4.625v2c0 .676.413 1.256 1 1.5v4A1.625 1.625 0 0 0 3 13.75h8a1.625 1.625 0 0 0 1.625-1.625v-4c.587-.244 1-.824 1-1.5v-2C13.625 3.728 12.898 3 12 3H9.117l1.443-1.203A.875.875 0 0 0 9.44.453L7 2.486zM2 4.25h3.875V7H2a.375.375 0 0 1-.375-.375v-2c0-.207.168-.375.375-.375m6.125 0V7H12a.375.375 0 0 0 .375-.375v-2A.375.375 0 0 0 12 4.25zm-5.5 4h3.25v4.25H3a.375.375 0 0 1-.375-.375zm5.5 0v4.25H11a.375.375 0 0 0 .375-.375V8.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGiftSolid: Icon = {
  "body": "<g fill=\"none\"><path fill=\"currentColor\" d=\"M4.657.626a.75.75 0 1 0-.804 1.267l.958.607H1.5C.778 2.5 0 2.989 0 3.806v1.416c0 .762.677 1.24 1.354 1.3l-.017.005h5.038V3.884h1.25v2.643h5.038l-.018-.006C13.324 6.461 14 5.984 14 5.222V3.806c0-.817-.778-1.306-1.5-1.306H9.189l.958-.607A.75.75 0 0 0 9.344.626L7 2.112zM13 7.777H7.625V14H11.5a1.5 1.5 0 0 0 1.5-1.5zm-6.625 0H1V12.5A1.5 1.5 0 0 0 2.5 14h3.875z\"/><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M9.197 3.38h-4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGiveGift: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 2.5h-7v5h7zm-3.5 0v5M8.5.5l1.5 2l1.5-2M.5 11l2.444 2.036a2 2 0 0 0 1.28.464h6.443c.46 0 .833-.374.833-.834c0-.92-.746-1.667-1.667-1.667H5.354\"/><path d=\"m3.5 10l.75.75a1.06 1.06 0 0 0 1.5-1.5L4.586 8.085A2 2 0 0 0 3.17 7.5H.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGiveGiftRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.85.175A.875.875 0 0 1 9.075.35l.8 1.067l.8-1.067a.875.875 0 0 1 1.4 1.05l-.825 1.1h2.125c.345 0 .625.28.625.625v5c0 .345-.28.625-.625.625H8.187L5.75 6.333V3.125c0-.345.28-.625.625-.625H8.5l-.825-1.1A.875.875 0 0 1 7.85.175m-7.705 10.3a.625.625 0 0 1 .88-.08L3.47 12.43c.247.206.558.319.88.319h6.443A.21.21 0 0 0 11 12.54c0-.575-.466-1.042-1.042-1.042H5.574a1.69 1.69 0 0 1-1.64-.433l-.75-.75a.625.625 0 0 1 .883-.883l.75.75a.436.436 0 1 0 .616-.617L4.27 8.402A1.38 1.38 0 0 0 3.297 8H.625a.625.625 0 1 1 0-1.25h2.672c.696 0 1.363.276 1.856.768l1.164 1.165c.425.425.576 1.02.452 1.567h3.19a2.29 2.29 0 0 1 2.291 2.291c0 .806-.653 1.458-1.458 1.458H4.349a2.63 2.63 0 0 1-1.68-.608L.225 11.355a.625.625 0 0 1-.08-.88\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGiveGiftSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.03.22a.75.75 0 1 0-1.06 1.06l.72.72H6.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2.875V3.5a.625.625 0 1 1 1.25 0V8H13.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-2.19l.72-.72A.75.75 0 0 0 10.97.22l-.97.97zM1.843 7H0v4l1.828 1.828A4 4 0 0 0 4.657 14H10.5a1.5 1.5 0 0 0 0-3H7.723a2.11 2.11 0 0 1-3.515.892l-1.45-1.45a.625.625 0 1 1 .884-.884l1.45 1.45a.86.86 0 0 0 1.306-1.11L4.672 8.172A4 4 0 0 0 1.843 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGlasses: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 9h-5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1zm8 0h-5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1zm-8 0h3m5 0V3a2 2 0 0 0-2-2h-1M.5 9V3a2 2 0 0 1 2-2h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGlassesRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 3A2.625 2.625 0 0 1 3 .375h.5a.625.625 0 1 1 0 1.25H3c-.76 0-1.375.616-1.375 1.375v5.125h10.75V3c0-.76-.616-1.375-1.375-1.375h-.5a.625.625 0 1 1 0-1.25h.5A2.625 2.625 0 0 1 13.625 3v9c0 .898-.727 1.625-1.625 1.625H9.25A1.625 1.625 0 0 1 7.625 12V9.875h-1.25V12c0 .898-.728 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12zm1.25 9V9.875h3.5V12a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12m10.75-2.125h-3.5V12c0 .207.168.375.375.375H12a.375.375 0 0 0 .375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGlassesSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.615 1a.75.75 0 0 1 .75-.75h.962A2.673 2.673 0 0 1 14 2.923v8.962a1.71 1.71 0 0 1-1.712 1.711H9.404a1.71 1.71 0 0 1-1.712-1.711V9.75H6.308v2.135a1.71 1.71 0 0 1-1.712 1.711H1.712A1.71 1.71 0 0 1 0 11.885V2.923A2.673 2.673 0 0 1 2.673.25h.962a.75.75 0 0 1 0 1.5h-.962A1.173 1.173 0 0 0 1.5 2.923V8.25h11V2.923a1.173 1.173 0 0 0-1.173-1.173h-.962a.75.75 0 0 1-.75-.75M1.5 9.75v2.135a.21.21 0 0 0 .212.211h2.884a.21.21 0 0 0 .212-.211V9.75zm7.692 0v2.135a.21.21 0 0 0 .212.211h2.884a.21.21 0 0 0 .212-.211V9.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGlobalLearning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.366 7.318a5.506 5.506 0 1 0-7.549 3.736M.512 6.006h11.011\"/><path d=\"M4.382 8.547a9.5 9.5 0 0 1-.484-2.541A9.5 9.5 0 0 1 6.016.5a9.5 9.5 0 0 1 2.117 5.506A10 10 0 0 1 8.02 7.06m1.438 1.118l4.03 1.746l-4.03 1.746L5.43 9.924z\"/><path d=\"m7.257 10.72l.004 1.9s.665.88 2.197.88s2.2-.88 2.2-.88v-1.9m-6.229 2.275V9.924\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGlobalLearningRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.29 5.376a4.76 4.76 0 0 1 3.383-3.938a9.1 9.1 0 0 0-1.276 3.938zm7.369 0c-.112-1.391-.62-2.76-1.327-3.937a4.76 4.76 0 0 1 3.38 3.937zm2.06 1.25H8.647l-.016.138a.625.625 0 0 1-1.242-.138H4.647q.063.758.298 1.505a.625.625 0 1 1-1.193.376a8.2 8.2 0 0 1-.36-1.88h-2.1a4.75 4.75 0 0 0 2.278 3.457a.625.625 0 1 1-.641 1.073A6.001 6.001 0 0 1 6.002 0a6 6 0 0 1 5.963 6.675a.625.625 0 0 1-1.246-.049M6.002 1.674c.744 1.106 1.277 2.413 1.402 3.702H4.652c.119-1.3.59-2.57 1.35-3.702M9.276 7.6a.5.5 0 0 1 .397 0L13.7 9.344a.5.5 0 0 1 0 .917l-1.402.608v1.626c0 .137-.044.27-.127.379l-.497-.379l.497.38h-.001l-.002.004l-.005.006l-.013.016a2 2 0 0 1-.174.185a3 3 0 0 1-.5.382c-.447.274-1.109.532-2 .532c-.892 0-1.553-.258-2-.532a3 3 0 0 1-.633-.522l-.04-.046l-.012-.016l-.005-.007l-.002-.002l-.001-.002l.498-.377l-.499.376a.63.63 0 0 1-.126-.375l-.004-1.629l-.452-.196v2.073a.625.625 0 1 1-1.25 0V9.928q0-.034.004-.067a.5.5 0 0 1 .298-.517zm-1.374 3.81l.002.83c.057.048.132.105.227.163c.268.165.705.347 1.343.347c.639 0 1.076-.182 1.346-.347q.142-.09.227-.164v-.829l-1.374.595a.5.5 0 0 1-.397 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGlobalLearningSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 5.368A6.01 6.01 0 0 1 5.58 0a.6.6 0 0 0-.093.093a10.13 10.13 0 0 0-2.209 5.275zM3.652 8.91q0 .066.005.131v2.496A6.01 6.01 0 0 1 0 6.618h3.278c.073.66.21 1.31.41 1.939a2 2 0 0 0-.036.352m.885-2.29h1.75l-1.58.684l-.051.023a9 9 0 0 1-.12-.708m7.41-1.25H8.665A10.13 10.13 0 0 0 6.457.092A.6.6 0 0 0 6.363 0a6.01 6.01 0 0 1 5.584 5.368m-7.41 0h2.87a8.9 8.9 0 0 0-1.435-3.831a8.9 8.9 0 0 0-1.435 3.83M9.65 6.71a.55.55 0 0 0-.434 0L5.242 8.432a.6.6 0 0 0-.116.068a.68.68 0 0 0-.349.596v3.028a.682.682 0 0 0 1.365 0v-2.3l3.074 1.331c.139.06.296.06.434 0l3.974-1.721a.546.546 0 0 0 0-1.002zm-2.933 4.51l2.024.877a1.74 1.74 0 0 0 1.383 0l2.024-.877v1.358c0 .12-.038.236-.11.33l-.435-.33l.434.331l-.001.002l-.002.002l-.004.006l-.013.015l-.037.043q-.045.053-.127.132c-.11.105-.27.238-.483.369c-.431.264-1.072.514-1.937.514c-.866 0-1.506-.25-1.936-.515a3 3 0 0 1-.61-.5l-.037-.044l-.012-.015l-.004-.006l-.002-.002v-.002H6.83l.435-.33l-.435.33a.55.55 0 0 1-.11-.329z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGmail: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.743 12.003h2.65V3.088l-.812-.52C2.406 1.816.86 2.658.86 4.05v7.074c0 .486.396.88.884.88\"/><path d=\"M.86 4.05v1.176l3.533 2.263l2.65 1.698l2.65-1.698l3.534-2.263V4.049c0-1.392-1.547-2.234-2.723-1.48l-.81.52l-2.651 1.697l-2.65-1.698l-.812-.52C2.406 1.816.86 2.658.86 4.05\"/><path d=\"M9.693 12.003h2.65a.88.88 0 0 0 .883-.88V4.049c0-1.392-1.546-2.234-2.722-1.48l-.81.52z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGmailRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m1.25 6.164l2.393 1.533v3.687H1.535a.284.284 0 0 1-.285-.282zm2.518-4.409C2.143.715 0 1.875 0 3.808v7.294c0 .849.69 1.533 1.535 1.533h2.733c.345 0 .625-.28.625-.625V8.498l1.77 1.134a.63.63 0 0 0 .674 0l1.77-1.134v3.511c0 .346.28.625.625.625h2.733c.846 0 1.536-.684 1.536-1.532V3.808c0-1.433-1.178-2.441-2.45-2.443a2.44 2.44 0 0 0-1.32.39l-.836.536l-.012.009L7 3.826L4.605 2.29zm5.34 2.205l-1.77 1.134a.63.63 0 0 1-.675 0L4.893 3.96v3.053L7 8.363l2.107-1.35zm1.25 3.737l2.393-1.533v4.938a.284.284 0 0 1-.286.283h-2.108z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGmailSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.086 6.787v4.349a.92.92 0 0 0 .922.918h2.765v-2.88zm8.977 1.74l-2.02 1.307l-2.02-1.307v-4.94l2.02 1.296l2.02-1.296zm1.25.647v2.88h2.765a.92.92 0 0 0 .922-.918v-4.35zM14 5.33l-3.687 2.387V2.784l.847-.544c1.226-.785 2.84.092 2.84 1.546zM3.773 2.784v4.934L.086 5.33V3.786c0-1.454 1.614-2.331 2.84-1.546z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGold: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.66 9.3a1 1 0 0 0-1-.8H2.32a1 1 0 0 0-1 .8L.5 13.5h6zm7 0a1 1 0 0 0-1-.8H9.32a1 1 0 0 0-1 .8l-.82 4.2h6z\"/><path d=\"m10 8.5l-.84-4.2a1 1 0 0 0-1-.8H5.82a1 1 0 0 0-1 .8L4 8.5m.68 0h4.64\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoldRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.826.875h2.328a1.625 1.625 0 0 1 1.618 1.3l.003.015l.748 4.185h1.006a1.625 1.625 0 0 1 1.618 1.3l.003.015l.84 4.7a.625.625 0 0 1-.615.735h-6A.63.63 0 0 1 7 13a.63.63 0 0 1-.375.125h-6a.625.625 0 0 1-.616-.732l.82-4.7l.004-.018a1.625 1.625 0 0 1 1.618-1.3h1.024l.73-4.183l.003-.017a1.625 1.625 0 0 1 1.618-1.3M6.997 11.03l.582-3.337l.004-.018l.01-.05H6.387l.011.05l.003.015zm2.186-4.655h-4.44l.69-3.957a.375.375 0 0 1 .374-.293h2.366a.375.375 0 0 1 .373.294l.707 3.956zm-.012 1.25a.375.375 0 0 0-.362.293l-.69 3.957h4.51l-.708-3.956a.375.375 0 0 0-.373-.294zm-4.362 0H2.432a.375.375 0 0 0-.373.293l-.69 3.957h4.51L5.17 7.919a.375.375 0 0 0-.362-.294\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoldSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.058 1.248h-2.08A1.39 1.39 0 0 0 4.59 2.362v.004l-.733 3.75a.5.5 0 0 0 .491.596h5.357a.5.5 0 0 0 .49-.598l-.75-3.75v-.002a1.39 1.39 0 0 0-1.387-1.114m-3.795 6.85h-2.08A1.39 1.39 0 0 0 .796 9.214l-.001.004l-.732 3.75a.5.5 0 0 0 .49.596h5.358a.5.5 0 0 0 .49-.598l-.75-3.75v-.002A1.39 1.39 0 0 0 4.263 8.1m5.51 0h2.08a1.39 1.39 0 0 1 1.387 1.115v.002l.75 3.75a.5.5 0 0 1-.49.598H8.143a.5.5 0 0 1-.49-.596l.731-3.75l.001-.004a1.39 1.39 0 0 1 1.387-1.114\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoodHealthAndWellBeing: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10.097 12.468l-2.773-2.52c-1.53-1.522.717-4.423 2.773-2.045c2.104-2.33 4.303.57 2.773 2.045z\"/><path d=\"M.621 6.088h1.367l1.823 3.19l4.101-7.747l1.823 3.646\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoodHealthAndWellBeingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.046.54a.75.75 0 0 0-1.342 0L3.927 6.093L3.064 4.08a.75.75 0 0 0-.689-.455h-1.5a.75.75 0 0 0 0 1.5H1.88L3.186 8.17a.75.75 0 0 0 1.36.04l2.829-5.658l1.33 2.658a.75.75 0 0 0 1.34-.67zM7.6 8.56c-.423.424-.495 1.117-.032 1.575l2.307 2.138l2.307-2.138c.463-.458.391-1.151-.032-1.576a.91.91 0 0 0-.718-.285c-.269.019-.651.169-1.089.664a.625.625 0 0 1-.937 0c-.437-.495-.82-.645-1.088-.664a.91.91 0 0 0-.718.285m.805-1.533c.504.035 1.003.246 1.47.629c.467-.383.966-.594 1.47-.629a2.16 2.16 0 0 1 1.69.65c.813.815 1.08 2.318.015 3.358l-.012.01l-2.738 2.538a.625.625 0 0 1-.85 0l-2.738-2.537l-.012-.011c-1.065-1.04-.798-2.543.014-3.358a2.16 2.16 0 0 1 1.69-.65\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoodHealthAndWellBeingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.51 1.374a.75.75 0 0 0-1.29-.016L4.28 7.79L2.903 5.71a.75.75 0 0 0-.626-.336H.76a.75.75 0 0 0 0 1.5h1.115L3.678 9.6a.75.75 0 0 0 1.265-.022l3.899-6.364l1.394 2.41a.75.75 0 0 0 1.299-.751l-2.026-3.5Zm.818 6.965c-.454-.4-.937-.618-1.422-.657a1.98 1.98 0 0 0-1.559.582c-.76.748-1.012 2.13-.042 3.096l.017.015l2.662 2.42a.5.5 0 0 0 .673 0l2.662-2.42l.01-.01c.978-.941.736-2.317-.016-3.065a2 2 0 0 0-1.552-.593c-.485.033-.972.241-1.433.632\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoogle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.36 5.83H7.87a.51.51 0 0 0-.51.52v1.41a.51.51 0 0 0 .51.51h2.29a2.75 2.75 0 0 1-3 2.79c-2.24 0-3.32-1.9-3.32-4.06S5 2.94 7.16 2.94a4.07 4.07 0 0 1 2.64.86a.49.49 0 0 0 .72-.22l.63-1.44a.51.51 0 0 0-.15-.63a7.07 7.07 0 0 0-3.8-1C3.56.5 1.08 3.33 1.08 7s2.49 6.5 6.08 6.5s5.76-2.56 5.76-6c0-1.1-.44-1.67-1.56-1.67\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoogleDrive: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.997 12.536L.742 8.93L4.8 1.715h4.51l4.057 7.214l-2.254 3.607zM4.798 1.715l4.509 7.214m4.061.003H5.023m-2.026 3.604l4.058-7.214\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoogleDriveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.729.912a.62.62 0 0 0-.576.36L.08 8.515a.63.63 0 0 0 .015.637l2.275 3.642a.63.63 0 0 0 .53.294h8.194a.63.63 0 0 0 .53-.294L13.87 9.2a.62.62 0 0 0 .045-.685L9.818 1.23a.63.63 0 0 0-.545-.319zm4.179 1.25l3.395 6.036H9.619L7.552 4.89a1 1 0 0 0-.054-.086L5.847 2.162zM6.016 8.198h2.13L7.023 6.404zm-1.6.295l-.028.048l-1.516 2.696l-1.52-2.434l3.397-6.04l1.52 2.434zm-.447 3.344l1.343-2.39h6.929l-1.493 2.39z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoogleDriveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.154 1.92L.11 9.11l1.845 2.951l1.678-2.984L3.676 9l2.323-4.13zm3.387 2.588a1 1 0 0 0-.07-.112L5.455 1.173h4.079l4.209 7.482h-3.611zm-.636 1.813L5.59 8.655h2.773zm-2.158 3.835l-1.643 2.922h8.415l1.827-2.922z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoogleRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M11.28 5.848H7.854a.5.5 0 0 0-.5.51v1.384a.5.5 0 0 0 .5.5h2.248a2.7 2.7 0 0 1-2.945 2.74c-2.199 0-3.259-1.866-3.259-3.986s1.139-3.985 3.26-3.985a4 4 0 0 1 2.59.844a.48.48 0 0 0 .707-.216l.618-1.413a.5.5 0 0 0-.147-.618a6.94 6.94 0 0 0-3.73-.982C3.624.616 1.19 3.394 1.19 6.996s2.444 6.38 5.968 6.38s5.654-2.513 5.654-5.89c0-1.079-.432-1.638-1.531-1.638\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGoogleSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.7 5.735H7.55a.55.55 0 0 0-.55.56v1.52a.55.55 0 0 0 .55.55h2.857a2.963 2.963 0 0 1-3.234 3.006c-2.416 0-3.58-2.048-3.58-4.375s1.25-4.375 3.58-4.375a4.4 4.4 0 0 1 2.846.926a.528.528 0 0 0 .776-.237l.68-1.551a.55.55 0 0 0-.162-.68A7.63 7.63 0 0 0 7.216.003C3.29-.008.617 3.041.617 6.996C.617 10.95 3.302 14 7.173 14s6.21-2.759 6.21-6.465c0-1.186-.474-1.8-1.682-1.8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraduationCap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7 1.367l6.5 2.817L7 7L.5 4.184z\"/><path d=\"m3.45 5.469l.006 3.064S4.529 9.953 7 9.953s3.55-1.42 3.55-1.42l-.001-3.064m-8.854 5.132v-5.89m.001 8.282a1.196 1.196 0 1 0 0-2.392a1.196 1.196 0 0 0 0 2.392\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraduationCapRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.248 1.046a.63.63 0 0 0-.496 0L.376 3.808a.625.625 0 0 0 0 1.147l.705.306v4.472a1.696 1.696 0 1 0 1.25 0v-3.93l.807.349l.005 2.734c0 .11.03.217.085.312l.54-.314l-.54.315l.001.002l.003.003l.005.009a1 1 0 0 0 .06.091q.057.083.164.208c.143.165.359.376.66.583c.607.42 1.538.808 2.879.808s2.272-.388 2.881-.807c.301-.207.517-.418.661-.583a3 3 0 0 0 .225-.298l.005-.009l.003-.004v-.001a16 16 0 0 0-.539-.317l.54.315a.6.6 0 0 0 .085-.315V6.152l2.764-1.197a.625.625 0 0 0 0-1.147zm2.363 5.648v1.985l-.01.012a2.3 2.3 0 0 1-.428.375c-.404.278-1.09.586-2.173.586c-1.084 0-1.768-.308-2.17-.586a2.3 2.3 0 0 1-.426-.374l-.011-.013l-.004-1.985l2.363 1.024a.63.63 0 0 0 .496 0zm-5.306 1.87\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraduationCapSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.199.728a.5.5 0 0 0-.398 0l-6.5 2.817a.5.5 0 0 0 0 .917l.893.387v5.591a1.24 1.24 0 1 0 1.003 0V5.283L6.8 7.278a.5.5 0 0 0 .398 0l6.5-2.816a.5.5 0 0 0 0-.917zM2.956 9.353l-.005-2.38l3.353 1.452a1.75 1.75 0 0 0 1.391 0l3.354-1.453v2.38a.5.5 0 0 1-.101.303l-.399-.303l.398.303v.002l-.003.002l-.005.007l-.015.019l-.051.06a3 3 0 0 1-.186.191a4.4 4.4 0 0 1-.724.553c-.65.398-1.627.784-2.963.784s-2.313-.386-2.96-.785a4.3 4.3 0 0 1-.724-.552a3 3 0 0 1-.236-.252l-.015-.02l-.005-.006l-.002-.002v-.001c-.001-.001-.001-.001.398-.303l-.4.302a.5.5 0 0 1-.1-.3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGramophone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.79 10.5C11.5 7 8 5 5.5 5l4-4.5s4 2 4 10m-12 0h12v2a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1M.5 8h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGramophoneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.466.441L9.186 1zl.002.001l.002.001l.005.003l.015.008l.046.025q.055.03.147.089c.12.078.286.194.48.356c.389.323.892.83 1.39 1.575c.998 1.499 1.95 3.93 1.95 7.732l-.003.065v1.78a1.423 1.423 0 0 1-1.423 1.424H1.923A1.423 1.423 0 0 1 .5 12.077v-.923A1.423 1.423 0 0 1 1.923 9.73h8.673c-.244-1.148-.931-2.078-1.814-2.754c-1.03-.79-2.283-1.198-3.288-1.198a.625.625 0 0 1-.467-1.04L8.719.585A.625.625 0 0 1 9.466.44m1.046 2.752c.807 1.21 1.657 3.25 1.735 6.538h-.38c-.263-1.612-1.19-2.876-2.325-3.746a7.3 7.3 0 0 0-2.787-1.31l2.535-2.85l.073.059c.304.253.724.67 1.15 1.309M1 7.298a.625.625 0 0 0 0 1.25h5.538a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGramophoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.724.053a.5.5 0 0 0-.598.115l-4 4.5A.5.5 0 0 0 5.5 5.5c1.13 0 2.526.458 3.67 1.334c.667.511 1.237 1.155 1.62 1.919h3.144c-.243-3.1-1.117-5.179-2.018-6.53a7.8 7.8 0 0 0-1.47-1.67a4 4 0 0 0-.7-.488zM1.5 10h6.928q.029.003.058.003h5.509q.005.245.005.497v2a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-1A1.5 1.5 0 0 1 1.5 10M.986 7.25a.75.75 0 0 0 0 1.5H6.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraph: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5.5v13h13\"/><path d=\"M3.5 6.5L6 9l4-6l3.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphArrowDecrease: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 10.5h4v-4\"/><path d=\"M13.5 10.5L7.85 4.85a.5.5 0 0 0-.7 0l-2.3 2.3a.5.5 0 0 1-.7 0L.5 3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphArrowDecreaseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.137 1.32a.625.625 0 0 0-1.024.717l4.028 5.752a.625.625 0 0 0 .87.153l2.6-1.821l2.845 4.064l-1.652 1.218a.5.5 0 0 0 .206.894l3.74.695a.5.5 0 0 0 .584-.41l.66-3.939a.5.5 0 0 0-.79-.485l-1.741 1.284l-3.187-4.55a.625.625 0 0 0-.871-.154L4.806 6.56z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphArrowDecreaseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.898 3.222A1 1 0 1 0 .483 4.637l3.333 3.332l.007.007a1.457 1.457 0 0 0 2.039 0l.007-.007L7.57 6.268L9.917 8.75l-1.04 1.04a.75.75 0 0 0 .53 1.28h3.653a.75.75 0 0 0 .75-.75V6.67a.75.75 0 0 0-1.28-.53l-1.198 1.197l-2.704-2.86l-.027-.028a1.457 1.457 0 0 0-2.04 0l-.006.007l-1.713 1.712z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphArrowIncrease: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 3.5h4v4\"/><path d=\"M13.5 3.5L7.85 9.15a.5.5 0 0 1-.7 0l-2.3-2.3a.5.5 0 0 0-.7 0L.5 10.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphArrowIncreaseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.762 5.865a.5.5 0 0 0 .231-.508l-.66-3.94a.5.5 0 0 0-.584-.409l-3.74.695a.5.5 0 0 0-.205.894l1.652 1.218L7.61 7.88L5.012 6.058a.625.625 0 0 0-.87.153l-4.03 5.752a.625.625 0 1 0 1.024.717l3.67-5.24l2.598 1.822a.625.625 0 0 0 .87-.154l3.187-4.55l1.741 1.284a.5.5 0 0 0 .559.023\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphArrowIncreaseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.898 10.778A1 1 0 0 1 .483 9.363l3.333-3.332l.007-.007a1.457 1.457 0 0 1 2.039 0l.007.007L7.57 7.732L9.917 5.25l-1.04-1.04a.75.75 0 0 1 .53-1.28h3.653a.75.75 0 0 1 .75.75v3.652a.75.75 0 0 1-1.28.53l-1.198-1.198l-2.704 2.861l-.027.027a1.457 1.457 0 0 1-2.039 0l-.007-.007l-1.713-1.712z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphBarDecrease: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.24.5l11.5 5.23m-2.15.81l2.15-.81l-.8-2.16M1.25 6h1.5a.5.5 0 0 1 .5.5v7H.75v-7a.5.5 0 0 1 .5-.5m5 1.5h1.5a.5.5 0 0 1 .5.5v5.5h-2.5V8a.5.5 0 0 1 .5-.5m5 1.5h1.5a.5.5 0 0 1 .5.5v4h-2.5v-4a.5.5 0 0 1 .5-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphBarDecreaseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.033.424a.625.625 0 0 1 .793-.39L11.33 3.601l.448-1.303a.5.5 0 0 1 .923-.055l1.25 2.588a.5.5 0 0 1-.23.666l-2.575 1.26a.5.5 0 0 1-.692-.61l.469-1.364L.424 1.217a.625.625 0 0 1-.39-.793M0 6c0-.345.28-.625.625-.625h4.25c.345 0 .625.28.625.625v1.625h3.625c.345 0 .625.28.625.625v.875h3.625c.345 0 .625.28.625.625v3.625c0 .345-.28.625-.625.625H.625A.625.625 0 0 1 0 13.375zm1.25.625v6.125h3V6.625zm8.5 6.125v-2.375h3v2.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphBarDecreaseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.315.606a.75.75 0 0 1 .99-.38l8.591 3.828l.361-.795a.75.75 0 0 1 1.386.05l.8 2.16a.75.75 0 0 1-.438.963l-2.15.81a.75.75 0 0 1-.948-1.013l.369-.81l-8.581-3.822a.75.75 0 0 1-.38-.99M1.25 5.5a1 1 0 0 0-1 1v7a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5v-7a1 1 0 0 0-1-1zm4.293 1.793A1 1 0 0 1 6.25 7h1.5a1 1 0 0 1 1 1v5.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5V8a1 1 0 0 1 .293-.707M11.25 8.5a1 1 0 0 0-1 1v4a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5v-4a1 1 0 0 0-1-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphBarIncrease: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.24 6.54l11.5-5.23M10.59.5l2.15.81l-.8 2.15m1.31 10.04h-2.5v-7a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5zm-5 0h-2.5V8a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5zm-5 0H.75v-4a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphBarIncreaseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.826 6.776a.625.625 0 0 1-.402-1.183l10.499-3.567l-.47-1.363a.5.5 0 0 1 .694-.612l2.573 1.26a.5.5 0 0 1 .23.667L12.7 4.565a.5.5 0 0 1-.922-.054l-.448-1.303zM14 6a.625.625 0 0 0-.625-.625h-4.25A.625.625 0 0 0 8.5 6v1.625H4.875a.625.625 0 0 0-.625.625v.875H.625A.625.625 0 0 0 0 9.75v3.625c0 .345.28.625.625.625h12.75c.345 0 .625-.28.625-.625zm-1.25.625v6.125h-3V6.625zm-8.5 3.75v2.375h-3v-2.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphBarIncreaseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.997.22a.75.75 0 0 1 .819-.163l2.127.882a.75.75 0 0 1 .408.977l-.869 2.127a.75.75 0 0 1-1.386.006l-.343-.82L2.115 6.92a.75.75 0 1 1-.59-1.38l8.648-3.695l-.336-.805a.75.75 0 0 1 .16-.82m2.753 5.26a1 1 0 0 1 1 1v7a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5v-7a1 1 0 0 1 1-1zM8.457 7.272a1 1 0 0 0-.707-.292h-1.5a1 1 0 0 0-1 1v5.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5v-5.5a1 1 0 0 0-.293-.708M2.75 8.48a1 1 0 0 1 1 1v4a.5.5 0 0 1-.5.5H.75a.5.5 0 0 1-.5-.5v-4a1 1 0 0 1 1-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphDot: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.643.643v12.714h12.714\"/><path d=\"M4.581 3.854a1.776 1.776 0 1 1 0 3.552a1.776 1.776 0 0 1 0-3.552m7-2.968a1.776 1.776 0 1 1 0 3.551a1.776 1.776 0 0 1 0-3.551m-2.469 6.52a1.776 1.776 0 1 1 0 3.552a1.776 1.776 0 0 1 0-3.552M.643 9.424l2.534-2.706m2.953-.202L7.755 8.03m2.141-.452l1.171-3.219\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphDotRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1a.625.625 0 1 0-1.25 0v12c0 .345.28.625.625.625h12a.625.625 0 1 0 0-1.25H1.625V9.94l1.908-2.037a2.3 2.3 0 0 0 1.184.328c.533 0 1.024-.181 1.414-.485l.727.678a2.301 2.301 0 1 0 3.727-.804l.798-2.192a2.301 2.301 0 1 0-1.431-.453l-.734 2.017a2.3 2.3 0 0 0-1.376.298l-.886-.826q.061-.257.062-.534a2.301 2.301 0 1 0-4.454.813l-.939 1.002zm8.648 2.128a1.051 1.051 0 1 0 2.102 0a1.051 1.051 0 0 0-2.102 0M3.666 5.93a1.051 1.051 0 1 0 2.102 0a1.051 1.051 0 0 0-2.102 0m5.328 4.403a1.051 1.051 0 1 1 0-2.102a1.051 1.051 0 0 1 0 2.102\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphDotSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5.75a.75.75 0 0 0-1.5 0v12.5c0 .414.336.75.75.75h12.5a.75.75 0 0 0 0-1.5H1.5V9.72l2.202-2.352c.291.166.628.26.986.26c.454 0 .872-.15 1.208-.406L7.319 8.55a2.002 2.002 0 1 0 3.387-.71l.002-.005l1.159-3.183a1.999 1.999 0 1 0-1.437-.438l-1.081 2.97a2.03 2.03 0 0 0-1.057.223L6.75 5.967a1 1 0 0 0-.08-.065q.017-.134.017-.272a1.998 1.998 0 1 0-3.92.546l-.03.029L1.5 7.525z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1a.625.625 0 1 0-1.25 0v12c0 .345.28.625.625.625h12a.625.625 0 1 0 0-1.25H1.625zm8.384 1.288a.875.875 0 0 0-1.237.227L5.364 7.627L3.869 6.13A.875.875 0 1 0 2.63 7.37l2.25 2.25a.875.875 0 0 0 1.347-.134l3.499-5.248l2.764 1.975a.875.875 0 0 0 1.018-1.424z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGraphSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.574.898a.75.75 0 0 0-1.5 0v12.204c0 .414.336.75.75.75h12.204a.75.75 0 1 0 0-1.5H1.573zm8.647 1.533a1 1 0 0 0-1.413.26L5.73 7.307L4.246 5.823A1 1 0 1 0 2.83 7.238l2.347 2.346a1 1 0 0 0 1.54-.152l3.181-4.773l2.446 1.747a1 1 0 0 0 1.162-1.628z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGroupMeetingCall: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.48 10.533a1.141 1.141 0 1 0 0-2.283a1.141 1.141 0 0 0 0 2.283m-2.055 2.946a2.06 2.06 0 0 1 .267-.993a2.08 2.08 0 0 1 1.788-1.045a2.08 2.08 0 0 1 1.787 1.045c.172.303.263.645.267.993m4.991-2.946a1.141 1.141 0 1 0 0-2.283a1.141 1.141 0 0 0 0 2.283M8.47 13.479a2.06 2.06 0 0 1 .267-.993a2.08 2.08 0 0 1 1.787-1.045a2.06 2.06 0 0 1 2.055 2.037m-5.58-9.431a1.065 1.065 0 1 0 0-2.13a1.065 1.065 0 0 0 0 2.13M5.008 6.718c.003-.337.092-.668.258-.962A2.01 2.01 0 0 1 7 4.743c.71.001 1.383.394 1.733 1.013c.166.294.255.625.259.962\"/><path d=\"M11.782.545H2.218a.72.72 0 0 0-.718.718V6c0 .397.322.718.718.718h9.564A.72.72 0 0 0 12.5 6V1.263a.72.72 0 0 0-.718-.718\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGroupMeetingCallRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.25 1.343c0-.051.042-.093.093-.093h9.314c.051 0 .093.042.093.093V6.08a.093.093 0 0 1-.093.093H9.542a3 3 0 0 0-2.284-1.395a1.625 1.625 0 1 0-.516 0a3 3 0 0 0-2.284 1.395H2.343a.093.093 0 0 1-.093-.093zM2.343 0C1.601 0 1 .601 1 1.343V6.08c0 .742.601 1.343 1.343 1.343h9.314c.742 0 1.343-.601 1.343-1.343V1.343C13 .601 12.399 0 11.657 0zm1.449 8a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5m0 3.5a3 3 0 0 0-2.75 1.8a.5.5 0 0 0 .458.7h4.584a.5.5 0 0 0 .458-.7a3 3 0 0 0-2.75-1.8m3.666 1.8a3 3 0 0 1 5.5 0a.5.5 0 0 1-.458.7H7.916a.5.5 0 0 1-.458-.7m1-3.55a1.75 1.75 0 1 1 3.5 0a1.75 1.75 0 0 1-3.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineGroupMeetingCallSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.218 0C1.545 0 1 .545 1 1.218v4.57c0 .674.545 1.22 1.218 1.22h9.564c.673 0 1.218-.546 1.218-1.22v-4.57C13 .545 12.455 0 11.782 0zm2.703 9.441a1.441 1.441 0 1 1-2.883 0a1.441 1.441 0 0 1 2.883 0m5.604 1.442a1.441 1.441 0 1 0 0-2.883a1.441 1.441 0 0 0 0 2.883m-7.046.778a2.336 2.336 0 0 0-2.303 1.947c-.035.212.143.388.358.388h3.891c.215 0 .393-.176.358-.388a2.336 2.336 0 0 0-2.304-1.947m4.743 1.947a2.336 2.336 0 0 1 4.607 0c.035.212-.143.388-.358.388H8.58c-.214 0-.392-.176-.357-.388ZM8.123 2.121a1.123 1.123 0 1 1-2.246 0a1.123 1.123 0 0 1 2.246 0M5.025 5.657a2.003 2.003 0 0 1 3.95 0c.03.182-.122.332-.306.332H5.33c-.184 0-.336-.15-.306-.332Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHalfStar1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.018.5a.54.54 0 0 0-.49.32l-1.59 3.36a.52.52 0 0 1-.41.31L.988 5a.58.58 0 0 0-.3 1l2.56 2.63a.58.58 0 0 1 .16.5l-.64 3.7a.56.56 0 0 0 .8.6l3.2-1.74a.6.6 0 0 1 .26-.07z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHalfStar1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.746.307c-.169.108-.304.26-.389.442L7.737 4.02l-.013.024l-.005.002l-.019.002l-3.569.529a1.062 1.062 0 0 0-.63 1.825l2.613 2.52l.006.006a.03.03 0 0 1 .009.028v.004l-.623 3.643a1.073 1.073 0 0 0 1.558 1.131h.001l3.216-1.7a.1.1 0 0 1 .036-.008a.51.51 0 0 0 .511-.51V.651a.51.51 0 0 0-.51-.511a1.06 1.06 0 0 0-.572.167\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHalfStar1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.518.5a.5.5 0 0 0-.503-.5a1.04 1.04 0 0 0-.941.61L4.486 3.966l-.007.016a.02.02 0 0 1-.016.012l-.006.001l-3.54.51l-.009.001a1.08 1.08 0 0 0-.57 1.851L2.89 8.98l.002.002a.08.08 0 0 1 .022.068l-.638 3.693v.002a1.06 1.06 0 0 0 1.53 1.125l3.199-1.739a.1.1 0 0 1 .04-.01a.5.5 0 0 0 .483-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandCursor: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 6.13a2 2 0 0 1 1.59 2.24l-.61 4.27a1 1 0 0 1-1 .86H4a1 1 0 0 1-.93-.63L2 10.21a2 2 0 0 1 1-2.53L4.35 7V2a1.5 1.5 0 0 1 3 0v3.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandCursorRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M10.5 6.005a2 2 0 0 1 1.59 2.24l-.61 4.27a1 1 0 0 1-1 .86H4a1 1 0 0 1-.93-.63L2 10.085a2 2 0 0 1 1-2.53l1.35-.68v-4.75a1.5 1.5 0 1 1 3 0v3.25z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandCursorSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.784 6.063a2.154 2.154 0 0 1 1.712 2.412l-.657 4.599a1.08 1.08 0 0 1-1.077.926H3.784a1.08 1.08 0 0 1-1.002-.678L1.63 10.457a2.154 2.154 0 0 1 1.077-2.725L4.16 7V1.615a1.615 1.615 0 1 1 3.23 0v3.77z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandGrab: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.364 13.5v-1.496l-1.926-1.54a2 2 0 0 1-.71-1.167l-.53-2.647a1.994 1.994 0 0 1 1.216-2.243l.952-.38V2.494A1.995 1.995 0 0 1 5.772.544l5.485 1.154A1.994 1.994 0 0 1 12.84 3.65v3.008c0 1.548-.36 3.075-1.053 4.46l-.443.886V13.5M3.366 4.026V6.52\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandGrabRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.991 2.995c0-.87.8-1.52 1.652-1.34l5.485 1.155a1.37 1.37 0 0 1 1.087 1.34v3.008a9.35 9.35 0 0 1-.986 4.18l-.444.887a.6.6 0 0 0-.066.28V13a.625.625 0 0 0 1.25 0v-.348l.378-.754a10.6 10.6 0 0 0 1.118-4.74V4.15a2.62 2.62 0 0 0-2.08-2.563L5.902.432a2.62 2.62 0 0 0-3.16 2.563v1.108l-.56.224A2.62 2.62 0 0 0 .587 7.273l.53 2.647a2.62 2.62 0 0 0 .931 1.532l1.692 1.352V13a.625.625 0 1 0 1.25 0v-.496c0-.19-.087-.37-.235-.488l-1.926-1.54a1.37 1.37 0 0 1-.487-.801l-.53-2.647a1.37 1.37 0 0 1 .835-1.54l.095-.039v1.07a.625.625 0 0 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandGrabSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.794 2.51A2.5 2.5 0 0 1 6.809.07l.013.003l4.557 1.09a2.5 2.5 0 0 1 1.977 2.445v3.016a10.5 10.5 0 0 1-1.108 4.696l-.392.783v1.382a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1.26L2.113 10.83a2.5 2.5 0 0 1-.89-1.461l-.53-2.655a2.5 2.5 0 0 1 1.522-2.811l.023-.01l.023-.006l.283-.083V6.08a.625.625 0 0 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeld: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-10 10h11M4.5 3h5m-5 2.5h5M4.5 8h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125 1.625c0-.207.168-.375.375-.375h9c.207 0 .375.168.375.375V10.5h-9.75zM2.5 0C1.603 0 .875.728.875 1.625v10.75C.875 13.273 1.603 14 2.5 14h9c.898 0 1.625-.727 1.625-1.625V1.625C13.125.728 12.398 0 11.5 0zm2 2.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5zm-.75 3.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.497 1.747c0-.113.092-.205.205-.205h8.596c.113 0 .204.092.204.205v8.727H2.497zM2.702.042C1.761.042.997.806.997 1.747v10.506c0 .941.764 1.705 1.705 1.705h8.596c.941 0 1.704-.764 1.704-1.706V1.747c0-.941-.763-1.705-1.705-1.705zm1.91 2.594a.75.75 0 1 0 0 1.5h4.776a.75.75 0 0 0 0-1.5zm-.75 3.374a.75.75 0 0 1 .75-.75h4.776a.75.75 0 0 1 0 1.5H4.612a.75.75 0 0 1-.75-.75m.75 1.874a.75.75 0 1 0 0 1.5h2.866a.75.75 0 1 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldTabletDrawing: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-10 10h11\"/><path d=\"M4 4c.585-.827 1.71-1.79 2.5-1c1 1-2.205 3.743-1 4.5C6.816 8.327 8.764 4.176 10 5s-1.5 2.5 0 3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldTabletDrawingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125 1.625c0-.207.168-.375.375-.375h9c.207 0 .375.168.375.375V10.5h-9.75zM2.5 0C1.603 0 .875.728.875 1.625v10.75C.875 13.273 1.603 14 2.5 14h9c.898 0 1.625-.727 1.625-1.625V1.625C13.125.728 12.398 0 11.5 0zm2.905 3.803c-.315.17-.662.52-.918.88a.75.75 0 1 1-1.224-.866c.33-.466.837-1.013 1.428-1.333c.3-.163.667-.291 1.068-.277c.424.015.82.186 1.146.513c.573.572.438 1.321.275 1.793s-.456.978-.7 1.398l-.033.057c-.269.462-.468.817-.558 1.092q.062-.03.152-.09c.309-.207.656-.558 1.075-.991l.05-.052c.374-.385.811-.837 1.243-1.135c.43-.296 1.162-.646 1.882-.166c.261.174.47.409.582.712c.108.295.095.582.047.817c-.077.376-.285.764-.431 1.036v.001l-.05.093c-.182.345-.264.541-.276.675a.2.2 0 0 0 0 .043l.004.01c.001.002.022.045.124.113a.75.75 0 1 1-.832 1.248a1.8 1.8 0 0 1-.636-.694a1.6 1.6 0 0 1-.154-.846c.04-.487.285-.949.444-1.25l.024-.045c.156-.296.252-.477.296-.616a1.4 1.4 0 0 0-.171.103c-.303.21-.646.561-1.068.997l-.015.015c-.384.396-.841.868-1.301 1.177c-.452.304-1.179.625-1.902.17a1.3 1.3 0 0 1-.599-.859c-.063-.32-.006-.63.07-.876c.142-.47.441-.985.687-1.408l.016-.027c.275-.476.5-.865.612-1.19c.052-.15.06-.23.06-.266c-.055-.049-.09-.052-.115-.053c-.05-.002-.15.014-.302.097m.413-.07l.004.016q-.006-.013-.004-.015m3.71 2.16q-.003.003-.022.001q.023-.005.021-.001\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldTabletDrawingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.716 1.563a.2.2 0 0 0-.202.201v8.568h8.972V1.764a.2.2 0 0 0-.202-.202zm-1.702.201c0-.94.762-1.702 1.702-1.702h8.568c.94 0 1.702.762 1.702 1.702v10.472c0 .94-.762 1.701-1.702 1.701H2.716c-.94 0-1.702-.761-1.702-1.701zm3.654 2.828c.231-.328.549-.647.84-.805a.6.6 0 0 1 .296-.093c.037.001.083.01.149.073v.007a.8.8 0 0 1-.055.27c-.103.297-.307.652-.554 1.077l-.013.022c-.221.382-.488.84-.614 1.257a1.6 1.6 0 0 0-.06.763c.06.306.237.565.515.74c.624.392 1.253.118 1.655-.152c.409-.275.816-.696 1.162-1.052L8 6.687c.378-.39.69-.71.967-.901a.8.8 0 0 1 .245-.128l.003.003l-.003.02c-.03.14-.122.316-.283.62l-.025.048c-.144.272-.358.678-.394 1.104c-.02.233.01.486.134.734c.123.246.315.445.554.605a.625.625 0 0 0 .694-1.04c-.098-.066-.123-.11-.128-.121c-.005-.009-.012-.026-.008-.073c.01-.131.09-.316.253-.625l.045-.084c.131-.246.315-.588.382-.918a1.3 1.3 0 0 0-.04-.707a1.26 1.26 0 0 0-.504-.615c-.62-.414-1.254-.115-1.636.148c-.383.265-.773.668-1.11 1.015l-.043.045c-.375.387-.691.707-.973.896a1 1 0 0 1-.237.124l.02-.073c.077-.257.264-.588.512-1.015l.029-.05c.22-.378.481-.828.626-1.248c.144-.42.257-1.067-.236-1.56a1.46 1.46 0 0 0-.996-.446c-.35-.013-.67.099-.935.243c-.522.282-.972.767-1.266 1.182a.625.625 0 1 0 1.02.722m1.17 2.253l.002.002z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldTabletWriting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 .5H1.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V8m-11 2.5h11M3.5 3h2m-2 2.5h1\"/><path d=\"m8.994 7.506l-3 .54l.5-3.04l4.23-4.21a1 1 0 0 1 1.42 0l1.06 1.06a1 1 0 0 1 0 1.42z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldTabletWritingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.013.146a.5.5 0 0 0-.707 0l-4.7 4.71a.5.5 0 0 0-.141.284l-.3 2.13a.5.5 0 0 0 .562.565l2.13-.29a.5.5 0 0 0 .286-.141l4.71-4.71a.5.5 0 0 0 0-.708zM1.276 1.625c0-.207.168-.375.375-.375h6.875a.625.625 0 0 0 0-1.25H1.651C.754 0 .026.728.026 1.625v10.75C.026 13.273.754 14 1.651 14h9c.898 0 1.625-.727 1.625-1.625v-4.75a.625.625 0 0 0-1.25 0v2.883h-9.75zM3.026 3c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25h-2A.625.625 0 0 1 3.026 3m.625 1.875a.625.625 0 1 0 0 1.25h1a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHandHeldTabletWritingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.718 1.594a.197.197 0 0 0-.198.197v8.521h8.919V7.947a.75.75 0 1 1 1.5 0v4.262c0 .937-.76 1.697-1.697 1.697H1.716c-.937 0-1.697-.76-1.697-1.697V1.791A1.7 1.7 0 0 1 1.718.094h6.156a.75.75 0 0 1 0 1.5zm1.894 1.413a.625.625 0 1 0 0 1.25h1.894a.625.625 0 1 0 0-1.25zM2.987 6.5c0-.345.28-.625.625-.625h.947a.625.625 0 1 1 0 1.25h-.947a.625.625 0 0 1-.625-.625m6.332 1.034a.5.5 0 0 0 .266-.14l4.099-4.118a1 1 0 0 0 0-1.42l-1.06-1.06a1 1 0 0 0-1.42 0L7.088 4.892a.5.5 0 0 0-.14.273l-.36 2.182a.5.5 0 0 0 .583.573z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHangUp1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.6 4.736A2.55 2.55 0 0 0 .59 7.244l-.006.502a.86.86 0 0 0 .853.853l2.146-.011a.855.855 0 0 0 .847-.847a.86.86 0 0 1 .853-.853H8.67a.847.847 0 0 1 .853.853a.855.855 0 0 0 .847.847h2.146a.863.863 0 0 0 .852-.853l-.005-.503a2.55 2.55 0 0 0-2.01-2.507a23.1 23.1 0 0 0-8.754.011\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHangUp1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.763 5.892a1.92 1.92 0 0 0-1.507 1.886v.011l-.006.492a.234.234 0 0 0 .229.226l2.132-.001a.23.23 0 0 0 .224-.224A1.47 1.47 0 0 1 5.313 6.81h.002l-.004.625V6.81h.002l3.384-.002a1.484 1.484 0 0 1 1.468 1.468v.002a.225.225 0 0 0 .223.224h-.001l-.003.625l.004-.625l2.132.01h-.003l.007.624l.003-.625h-.007a.236.236 0 0 0 .23-.229v.01l.625-.007l-.625-.007v.004l-.005-.503a1.91 1.91 0 0 0-1.503-1.882l.006.002l.119-.614l-.131.611l.006.001c-2.8-.54-5.677-.542-8.479-.004M2.52 4.666a23.7 23.7 0 0 1 8.966.004l.012.003a3.16 3.16 0 0 1 2.497 3.109l.005.51a1.487 1.487 0 0 1-1.468 1.468h-.01l-2.14-.01h-.003a1.476 1.476 0 0 1-1.464-1.464l.625-.005l-.625.007a.234.234 0 0 0-.229-.231l-3.374.002h-.005a.22.22 0 0 0-.222.222v.01a1.48 1.48 0 0 1-1.464 1.465h-.006l-2.147.001A1.484 1.484 0 0 1 0 8.29v-.014l.006-.496a3.17 3.17 0 0 1 2.5-3.11z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHangUp1Solid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M11.459 4.236a3.05 3.05 0 0 1 2.405 2.995l.006.51a1.363 1.363 0 0 1-1.348 1.347h-2.156a1.355 1.355 0 0 1-1.342-1.343a.347.347 0 0 0-.35-.357H5.287a.36.36 0 0 0-.356.358a1.35 1.35 0 0 1-1.343 1.342l-2.155.01A1.363 1.363 0 0 1 .084 7.753l.006-.51a3.05 3.05 0 0 1 2.405-2.995c2.946-.603 6.014-.576 8.964-.011\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHangUp2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.58 3.486A2.55 2.55 0 0 0 .57 5.994l-.006.502a.86.86 0 0 0 .853.853l2.146-.011a.855.855 0 0 0 .847-.847a.86.86 0 0 1 .852-.853h3.389a.847.847 0 0 1 .852.853a.855.855 0 0 0 .847.847h2.146a.863.863 0 0 0 .853-.853l-.006-.503a2.55 2.55 0 0 0-2.01-2.507a23.1 23.1 0 0 0-8.753.011M7 7.938v4.718m-1.872-1.872L7 12.656l1.872-1.872\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHangUp2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.678 3.307a1.92 1.92 0 0 1 1.085-.674a22.4 22.4 0 0 1 8.479.004a1.91 1.91 0 0 1 1.503 1.882v.011l.005.492a.237.237 0 0 1-.23.23l-2.131-.01l-.005.625l.003-.625h.001a.226.226 0 0 1-.223-.225v-.001a1.483 1.483 0 0 0-1.468-1.468H8.69l-3.377.002H5.31v.625l.004-.625h-.002a1.47 1.47 0 0 0-1.478 1.473a.23.23 0 0 1-.224.224l-2.132.001a.234.234 0 0 1-.229-.226l.006-.492v-.011a1.92 1.92 0 0 1 .422-1.212M12.52 5.25h.007l-.003.625l-.007-.625zm.23-.229v-.004l.625.007l-.625.007zm-1.508-2.385l-.006-.001l.13-.611l-.118.614zm.244-1.226a23.7 23.7 0 0 0-8.966-.004l-.014.003a3.17 3.17 0 0 0-2.5 3.11L0 5.016v.014a1.484 1.484 0 0 0 1.468 1.468h.007l2.14-.001h.006a1.48 1.48 0 0 0 1.464-1.465v-.01a.22.22 0 0 1 .222-.222h.005l3.374-.002a.234.234 0 0 1 .229.231l.625-.007l-.625.005a1.476 1.476 0 0 0 1.464 1.465h.002l2.14.01h.01a1.487 1.487 0 0 0 1.47-1.47V5.02l-.006-.496a3.16 3.16 0 0 0-2.497-3.109zM7.75 7.123a.75.75 0 1 0-1.5 0v2.072H4.426a.625.625 0 0 0-.442 1.067l2.574 2.574c.244.244.64.244.884 0l2.575-2.574a.625.625 0 0 0-.442-1.067H7.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHangUp2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.174 4.068a3.05 3.05 0 0 0-1.736-1.073c-2.95-.565-6.017-.592-8.963.011A3.05 3.05 0 0 0 .07 6.002l-.006.51a1.363 1.363 0 0 0 1.347 1.347l2.156-.011A1.354 1.354 0 0 0 4.91 6.505a.363.363 0 0 1 .356-.358h3.388a.347.347 0 0 1 .35.357a1.355 1.355 0 0 0 1.342 1.343h2.156A1.363 1.363 0 0 0 13.849 6.5l-.006-.51a3.05 3.05 0 0 0-.67-1.922Zm-5.549 3.87a.625.625 0 1 0-1.25 0v2.221H5.128a.625.625 0 0 0-.442 1.067l1.866 1.866a.63.63 0 0 0 .526.184a.62.62 0 0 0 .364-.178l1.872-1.872a.625.625 0 0 0-.442-1.067H7.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHappyFace: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M3.7 8c.5 1.8 2.5 2.9 4.3 2.4c1.1-.4 2-1.3 2.3-2.4M4.75 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHappyFaceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.75 4.25a1 1 0 1 1 0 2a1 1 0 0 1 0-2m3.5 1a1 1 0 1 0 2 0a1 1 0 0 0-2 0M3.431 7.281a.75.75 0 0 1 .933.505a2.752 2.752 0 0 0 5.272 0a.75.75 0 0 1 1.438.428a4.252 4.252 0 0 1-8.148 0a.75.75 0 0 1 .505-.933\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHappyFaceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 0 0 7a7 7 0 0 0 14 0m-3.56-2.048c0 .565-.457 1.023-1.022 1.024h-.002a1.025 1.025 0 0 1-.003-2.049h.003c.565 0 1.024.459 1.024 1.025m-4.831 0c0 .565-.457 1.023-1.022 1.024h-.003a1.025 1.025 0 0 1-.002-2.049h.002c.566 0 1.025.459 1.025 1.025M4.189 7.76a.625.625 0 1 0-1.206.325a4.163 4.163 0 0 0 8.038 0a.625.625 0 1 0-1.207-.325a2.913 2.913 0 0 1-5.624 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHardDisk: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-7 10l1.75-2.75\"/><path d=\"M4.09 7A2.93 2.93 0 0 1 4 5.16a3 3 0 1 1 4.67 3.27M7.5 11H10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHardDiskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125 1.625c0-.207.168-.375.375-.375h9c.207 0 .375.168.375.375v10.75a.375.375 0 0 1-.375.375h-9a.375.375 0 0 1-.375-.375zM2.5 0C1.603 0 .875.728.875 1.625v10.75C.875 13.273 1.603 14 2.5 14h9c.898 0 1.625-.727 1.625-1.625V1.625C13.125.728 12.398 0 11.5 0zm2.588 8.412a2.99 2.99 0 1 1 1.146.527l-1.207 1.896a.625.625 0 1 1-1.054-.67zM6.75 11a.75.75 0 0 1 .75-.75H10a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75m1.131-4.981a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHardDiskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 1.5A1.5 1.5 0 0 1 2.5 0h9A1.5 1.5 0 0 1 13 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5zm5.991 6.692a.625.625 0 0 0-.653-.947a.57.57 0 0 0-.401.276l-1.75 2.75a.625.625 0 1 0 1.054.671zm.258 3.414c0-.345.28-.625.625-.625h2.5a.625.625 0 0 1 0 1.25h-2.5a.625.625 0 0 1-.625-.625M6.99 1.897A3.875 3.875 0 0 0 4 8.237l.882-1.387c.298-.468.76-.768 1.284-.843a1.9 1.9 0 0 1 1.294.285c.347.221.663.578.806 1.051a1.83 1.83 0 0 1-.22 1.52l-.471.74a3.876 3.876 0 0 0-.585-7.706m.082 5.815a.62.62 0 0 1-.08.48a.58.58 0 0 0 .08-.48\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHardDrive1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 7.5h-11a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1\"/><path d=\"m.59 8.08l1.74-6.8A1 1 0 0 1 3.3.5h7.4a1 1 0 0 1 1 .78l1.74 6.8M3.5 10.5h3m4 .5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHardDrive1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.488 7.904L1.717 1.66l.003-.016A1.625 1.625 0 0 1 3.297.375h7.396a1.625 1.625 0 0 1 1.617 1.268l.003.016l1.24 6.3q.01.051.012.102q.06.21.06.439V12c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12V8.5q.002-.317.113-.596m1.137.596c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375V12a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12zm1.875 1a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zm5.625.75a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHardDrive1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.588 6.07q.237-.05.489-.05h11.846q.27 0 .52.058l-1.257-4.916A1.5 1.5 0 0 0 10.694 0H3.297a1.5 1.5 0 0 0-1.453 1.162zm12.335 1.2H1.077C.482 7.27 0 7.75 0 8.345v4.308c0 .595.482 1.077 1.077 1.077h11.846c.595 0 1.077-.482 1.077-1.077V8.346c0-.595-.482-1.077-1.077-1.077M3.5 9.874a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25zm6.003.625a.997.997 0 1 1 1.994 0a.997.997 0 0 1-1.994 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading1ParagraphStylesHeading: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.394 7.655v5.095M9.696 8.719h.425c.703 0 1.273-.57 1.273-1.274m1.699 5.305H9.696M1 12.75V1.25m5.75 0v11.5M1 6.52h5.75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading1ParagraphStylesHeadingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25.625a.625.625 0 1 0-1.25 0v10.75a.625.625 0 1 0 1.25 0v-4.75h4.5v4.75a.625.625 0 1 0 1.25 0V.625a.625.625 0 1 0-1.25 0v4.75h-4.5zM12 7.25a.75.75 0 0 0-1.5 0a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 0 0 1.5h.5q.396-.002.75-.128V12.5H9.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading1ParagraphStylesHeadingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.25a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0V7.27H6v5.48a.75.75 0 0 0 1.5 0V1.25a.75.75 0 0 0-1.5 0v4.52H1.75zm10.395 6.195a.75.75 0 0 0-1.5 0c0 .29-.235.524-.524.524h-.425a.75.75 0 1 0 0 1.5h.425q.271 0 .523-.069V12h-.948a.75.75 0 0 0 0 1.5h3.397a.75.75 0 0 0 0-1.5h-.949V7.655l-.004-.078q.005-.066.005-.132\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading2ParagraphStylesHeading: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.926 12.75H9.61v-.753c0-.528.293-1.004.745-1.216l1.845-.86c.441-.206.726-.67.726-1.184c0-.714-.542-1.292-1.211-1.292h-.861c-.542 0-1.002.37-1.173.884M1 12.75V1.25m5.75 0v11.5M1 6.52h5.75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading2ParagraphStylesHeadingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25.625a.625.625 0 1 0-1.25 0v10.75a.625.625 0 1 0 1.25 0v-4.75h4.5v4.75a.625.625 0 1 0 1.25 0V.625a.625.625 0 1 0-1.25 0v4.75h-4.5zm9.5 5.875A2.25 2.25 0 0 0 8.628 8a.75.75 0 0 0 1.414.5a.75.75 0 0 1 .708-.5h1.039a.711.711 0 0 1 .285 1.363l-2.226.973A2.25 2.25 0 0 0 8.5 12.398v.852c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5H10v-.102a.75.75 0 0 1 .45-.687l2.225-.974A2.211 2.211 0 0 0 11.79 6.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading2ParagraphStylesHeadingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.25a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0V7.27H6v5.48a.75.75 0 0 0 1.5 0V1.25a.75.75 0 0 0-1.5 0v4.52H1.75zm9.104 5.445c-.9 0-1.624.611-1.885 1.398a.75.75 0 0 0 1.424.472c.08-.243.278-.37.46-.37h.862c.21 0 .461.196.461.542a.55.55 0 0 1-.293.504l-1.845.86c-.735.344-1.178 1.098-1.178 1.895v.754c0 .414.336.75.75.75h3.316a.75.75 0 0 0 0-1.5H10.36v-.004c0-.256.142-.455.313-.535l1.844-.861c.723-.337 1.159-1.079 1.159-1.863c0-1.081-.833-2.042-1.961-2.042z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading3ParagraphStylesHeading: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.538 11.866c.182.515.673.884 1.25.884h.884c.733 0 1.327-.594 1.327-1.326v-.221c0-.733-.594-1.326-1.327-1.326h-.442h.332a1.216 1.216 0 0 0 0-2.432h-.663c-.557 0-1.026.374-1.17.884M1 12.75V1.25m5.75 0v11.5M1 6.52h5.75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading3ParagraphStylesHeadingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25.625a.625.625 0 1 0-1.25 0v10.75a.625.625 0 1 0 1.25 0v-4.75h4.5v4.75a.625.625 0 1 0 1.25 0V.625a.625.625 0 1 0-1.25 0v4.75h-4.5zM11.625 6.5h-.75c-.974 0-1.793.654-2.045 1.546a.75.75 0 1 0 1.443.408a.626.626 0 0 1 .602-.454h.75a.625.625 0 1 1 0 1.25h-.375a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 1 .75.75v.25a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.707-.5a.75.75 0 1 0-1.415.5A2.25 2.25 0 0 0 10.75 14h1A2.25 2.25 0 0 0 14 11.75v-.25c0-.628-.257-1.196-.672-1.604A2.125 2.125 0 0 0 11.625 6.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeading3ParagraphStylesHeadingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.25a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0V7.27H6v5.48a.75.75 0 0 0 1.5 0V1.25a.75.75 0 0 0-1.5 0v4.52H1.75zm9.812 5.445h-.663c-.901 0-1.658.605-1.892 1.43a.75.75 0 1 0 1.444.408a.47.47 0 0 1 .448-.338h.663a.466.466 0 0 1 0 .931h-.332a.75.75 0 1 0 0 1.5h.442c.319 0 .577.259.577.577v.22a.576.576 0 0 1-.577.577h-.884a.58.58 0 0 1-.543-.384a.75.75 0 1 0-1.415.5a2.08 2.08 0 0 0 1.958 1.384h.884c1.147 0 2.077-.93 2.077-2.076v-.221a2.07 2.07 0 0 0-.568-1.427a1.966 1.966 0 0 0-1.619-3.081\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHealthCare2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.28 9.34a1.91 1.91 0 0 0 0-2.77a2.07 2.07 0 0 0-2.85 0L7 8L5.57 6.57a2.07 2.07 0 0 0-2.85 0a1.91 1.91 0 0 0 0 2.77L7 13.5zM7 4.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHealthCare2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 2.5a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0m1.055 3.17a2.7 2.7 0 0 0-3.744.033a2.7 2.7 0 0 0 .088 3.943l4.684 4.195a.625.625 0 0 0 .834 0l4.684-4.195a2.7 2.7 0 0 0 .088-3.943a2.7 2.7 0 0 0-3.744-.033L7 7.037zm-2.87.926a1.45 1.45 0 0 1 2.01-.018l1.876 1.773a.625.625 0 0 0 .858 0l1.875-1.773a1.45 1.45 0 0 1 2.01.018c.6.587.578 1.56-.047 2.119l.417.465l-.417-.465L7 12.536L2.733 8.715a1.45 1.45 0 0 1-.047-2.119\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHealthCare2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.685 2.422a2.315 2.315 0 1 1 4.63 0a2.315 2.315 0 0 1-4.63 0M2.446 6.214a2.536 2.536 0 0 1 3.492 0l.01.01L7 7.276l1.053-1.052l.01-.01a2.536 2.536 0 0 1 3.49 0a2.38 2.38 0 0 1 .003 3.448l-4.208 4.09a.5.5 0 0 1-.697 0l-4.207-4.09a2.38 2.38 0 0 1 .002-3.447\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHealthMedicalHeartRateHealthBeautyInformationDataBeatPulseMonitorHeartRateInfo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.58 4.31C1.09 1.85 4.12 0 7 3.27c4.11-4.71 8.5 1.13 5.52 4.14L7 12.5l-3.23-3\"/><path d=\"M.5 7H3l1.5-2l2 3.5l1.5-2h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHealthMedicalRibbon1RibbonMedicalCancerHealthBeautySymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 13.5S10 6.39 10 3.5a2.84 2.84 0 0 0-3-3a2.84 2.84 0 0 0-3 3c0 2.89 6.5 10 6.5 10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHealthMedicalRibbon2RibbonMedicalCancerHealthBeautySymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 3.14v1.5m1.51 2.51a3.62 3.62 0 0 0 1.49-3A3.29 3.29 0 0 0 7 .64a3.28 3.28 0 0 0-3 3.5a3.62 3.62 0 0 0 1.49 3l-3.21 3.68a.51.51 0 0 0 0 .65l1.37 1.7a.47.47 0 0 0 .38.19a.52.52 0 0 0 .39-.17A23 23 0 0 0 7 9.64a23 23 0 0 0 2.6 3.55a.52.52 0 0 0 .39.17a.47.47 0 0 0 .38-.19l1.37-1.7a.5.5 0 0 0 0-.64Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHearingDeaf1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 13.5L.5.5m8.822 8.822c.18-.227.345-.406.464-.504c.807-1.01 2.085-1.85 1.917-4.17c-.168-2.322-2.22-3.802-5.112-3.398c-1.418.198-2.269 1.214-2.74 2.25m4.321 7.84c-.27.915-.795 1.788-2.153 1.917c-.84.08-1.244-.235-1.547-.538\"/><path d=\"M6.296 4.106c.37-.589.743-.793 1.11-.891c1.532-.408 2.704 1.515 1.38 2.943\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHearingDeaf1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.808 2.924A3.74 3.74 0 0 1 6.75 1.5c2.07 0 3.75 1.683 3.75 3.755c0 .758-.301 1.485-.836 2.02l-.752.753zM2.742 1.858A5.24 5.24 0 0 1 6.75 0C9.65 0 12 2.357 12 5.255a4.36 4.36 0 0 1-1.276 3.081l-.751.753l3.841 3.842a.625.625 0 1 1-.884.883L.185 1.07A.625.625 0 1 1 1.07.186zm3.883.517a.75.75 0 0 0 0 1.5a1.5 1.5 0 0 1 1.5 1.5a.75.75 0 0 0 1.5 0a3 3 0 0 0-3-3M2.5 9.75c.345 0 .625.28.625.625a2.375 2.375 0 0 0 4.543.972a.625.625 0 0 1 1.14.512a3.626 3.626 0 0 1-6.933-1.484c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHearingDeaf1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22l2.535 2.535C4.515 1.527 5.81.354 7.83.354c1.569 0 2.767.566 3.563 1.483c.782.9 1.118 2.07 1.118 3.198c0 1.058-.552 2.08-1.12 2.873c-.357.496-.752.945-1.108 1.314l3.498 3.498a.75.75 0 1 1-1.06 1.06zm9.002 6.88c.31-.323.65-.71.949-1.127c.518-.72.839-1.422.839-1.998c0-.847-.254-1.643-.75-2.215c-.482-.554-1.249-.966-2.431-.966c-1.51 0-2.454.989-2.9 2.015l4.293 4.292Zm-1.837 2.93c.11-.194.206-.404.286-.608l1.134 1.134a5 5 0 0 1-.117.217c-.257.452-.646.97-1.214 1.247c-.477.233-.964.404-1.503.416c-.546.012-1.067-.14-1.616-.423a.75.75 0 0 1 .687-1.334c.397.205.67.262.896.257c.234-.005.497-.078.878-.264c.166-.08.367-.287.57-.642Zm.13-6.637a.76.76 0 0 1 .362-.082c.12.005.285.043.502.178a.7.7 0 0 1 .285.306c.052.11.076.24.075.38a.75.75 0 0 0 1.5.017c.007-.652-.236-1.458-1.068-1.976c-.855-.533-1.658-.485-2.303-.177a.75.75 0 1 0 .646 1.354Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHearingDeaf2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\"><path d=\"M11.805 1.077c.449.387.757.907.93 1.512\"/><path stroke-linejoin=\"round\" d=\"m3.262 8.618l.46.46m-2.615.606l1.494 1.493M4.31 6.468L5.804 7.96m-1.696 4.37c.282.281.658.574 1.438.5c1.262-.12 1.75-.931 2-1.781s1.125-2.032 1.5-2.344c.75-.938 1.937-1.719 1.781-3.875s-2.062-3.531-4.75-3.156C4.258 1.927 3.445 3.63 3.174 4.83\"/><path stroke-linejoin=\"round\" d=\"M5.804 4.561c.343-.547.69-.737 1.03-.828c1.424-.379 2.513 1.408 1.282 2.734\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHearingDeaf2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.72.22a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06M3.65 4.952a3.376 3.376 0 0 1 6.724.423v.127A3.38 3.38 0 0 1 9.16 8.094l-1.05.876a2.04 2.04 0 0 0-.736 1.57v.335a1.875 1.875 0 0 1-2.822 1.619a.625.625 0 1 0-.633 1.078a3.125 3.125 0 0 0 4.705-2.697v-.336c0-.235.105-.458.285-.609l1.05-.875a4.63 4.63 0 0 0 1.665-3.553v-.127a4.625 4.625 0 0 0-9.214-.577a.625.625 0 0 0 1.24.154M1.28 9.845a.75.75 0 0 0-1.061 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06zM2.344 8.72a.75.75 0 0 1 1.06 0l.5.5a.75.75 0 1 1-1.06 1.06l-.5-.5a.75.75 0 0 1 0-1.06M4.53 6.595a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06zm1.436-2.126a1.375 1.375 0 0 1 1.94 1.94a.625.625 0 1 0 .938.828a2.625 2.625 0 0 0-3.705-3.705a.625.625 0 0 0 .827.937\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHearingDeaf2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.295.509a.75.75 0 0 0-.98 1.136c.322.278.56.663.699 1.15a.75.75 0 0 0 1.442-.413c-.207-.723-.585-1.376-1.161-1.873M4.143 4.437c.393-1.07 1.322-2.155 2.88-2.155c1.143 0 1.882.399 2.345.932c.478.551.723 1.319.723 2.137c0 .55-.305 1.222-.803 1.918A11.3 11.3 0 0 1 7.82 8.904a3.05 3.05 0 0 0-.825 1.321a5.3 5.3 0 0 1-.425 1.005c-.195.339-.386.532-.54.607c-.567.277-.895.316-1.317.174a.75.75 0 0 0-.477 1.422c.918.308 1.667.136 2.453-.248c.553-.27.93-.772 1.182-1.209c.26-.452.44-.937.554-1.299c.084-.266.228-.5.415-.672a13 13 0 0 0 1.67-1.863c.548-.768 1.082-1.76 1.082-2.79c0-1.1-.327-2.242-1.09-3.121C9.723 1.335 8.552.782 7.023.782c-2.41 0-3.766 1.72-4.288 3.137a.75.75 0 1 0 1.408.518M2.731 8.088a.75.75 0 0 1 1.06 0l.461.46a.75.75 0 0 1-1.06 1.061l-.46-.46a.75.75 0 0 1 0-1.06M1.638 9.153a.75.75 0 0 0-1.061 1.061l1.493 1.493a.75.75 0 0 0 1.061-1.06zM3.78 5.937a.75.75 0 0 1 1.06 0l1.494 1.494a.75.75 0 0 1-1.06 1.06L3.78 6.998a.75.75 0 0 1 0-1.06m2.755-1.04a.7.7 0 0 1 .321-.072c.104.004.252.037.45.161a.63.63 0 0 1 .253.27a.8.8 0 0 1 .066.337a.75.75 0 0 0 1.5.017c.007-.624-.226-1.4-1.026-1.897c-.819-.51-1.59-.465-2.21-.17a.75.75 0 0 0 .646 1.354\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeart: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.004 12.383L1.53 7.424c-2.975-2.975 1.398-8.688 5.474-4.066c4.076-4.622 8.43 1.11 5.475 4.066z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartRatePulseGraph: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.992 12.413L1.573 7.401c-2.953-2.966 1.355-8.71 5.419-4.064c4.064-4.632 8.412 1.111 5.418 4.064z\"/><path d=\"M3.515 6.753h1.53l1.032-1.968L7.64 8.41l1.343-1.657h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartRatePulseGraphRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.004 2.545c-.977-.979-1.998-1.463-2.98-1.536c-1.11-.081-2.09.37-2.798 1.084C-.167 3.495-.599 6.03 1.131 7.784l.018.018l5.517 5.066a.5.5 0 0 0 .676 0l5.517-5.066l.008-.007l.01-.01c1.72-1.745 1.287-4.28-.102-5.684c-.706-.714-1.685-1.168-2.793-1.089c-.98.07-2.001.555-2.978 1.533m-.238 1.943a.75.75 0 0 0-1.353-.051l-.82 1.566H3.515a.75.75 0 1 0 0 1.5h1.531a.75.75 0 0 0 .665-.402l.3-.574l.94 2.18a.75.75 0 0 0 1.272.175L9.34 7.503h1.143a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0-.583.278l-.563.694z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartRatePulseGraphSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.992 2.606c-.965-.961-1.972-1.438-2.94-1.51c-1.094-.08-2.06.364-2.756 1.066C-.072 3.542-.49 6.037 1.22 7.754l.015.014l5.418 5.012a.5.5 0 0 0 .68 0l5.418-5.012l.011-.011c1.734-1.71 1.315-4.205-.06-5.585c-.698-.702-1.667-1.147-2.763-1.068c-.97.07-1.98.543-2.946 1.502Zm-.34 1.982a.625.625 0 0 0-1.128-.043L4.668 6.18H3.515a.625.625 0 0 0 0 1.25h1.531c.233 0 .446-.13.554-.335l.423-.807l1.043 2.42a.625.625 0 0 0 1.06.147L9.282 7.43h1.202a.625.625 0 0 0 0-1.25h-1.5a.63.63 0 0 0-.486.231l-.693.855l-1.154-2.677Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartRateSearch: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 6a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0m9.495 3.995L13 13\"/><path d=\"M2.516 6.156h1.53l1.032-1.968l1.563 3.625l1.343-1.657h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartRateSearchRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1.25a5.25 5.25 0 1 0 0 10.5a5.25 5.25 0 0 0 0-10.5M0 6.5a6.5 6.5 0 1 1 11.673 3.936l2.07 2.07a.875.875 0 0 1-1.237 1.238l-2.07-2.07A6.5 6.5 0 0 1 0 6.5m5.606-2.562a.75.75 0 0 1 .66.453L7.34 6.878l.563-.694a.75.75 0 0 1 .582-.278h1.5a.75.75 0 1 1 0 1.5H8.842L7.723 8.785a.75.75 0 0 1-1.271-.176l-.94-2.18l-.3.575a.75.75 0 0 1-.665.402H3.016a.75.75 0 0 1 0-1.5h1.077l.82-1.567a.75.75 0 0 1 .693-.401\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartRateSearchSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.25 1.5a4.75 4.75 0 1 0 0 9.5a4.75 4.75 0 0 0 0-9.5M0 6.25a6.25 6.25 0 1 1 11.32 3.656l2.387 2.387a1 1 0 1 1-1.414 1.414L9.906 11.32A6.25 6.25 0 0 1 0 6.25m5.962-1.723a.625.625 0 0 0-1.095-.044L4.101 5.75H3.046a.625.625 0 1 0 0 1.25h1.408a.63.63 0 0 0 .535-.302l.36-.596l.93 1.87a.625.625 0 0 0 1.016.15L8.345 7h1.11a.625.625 0 1 0 0-1.25h-1.38a.63.63 0 0 0-.456.197l-.621.663z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M6.992 12.395L1.597 7.4c-2.94-2.957 1.349-8.68 5.395-4.05c4.045-4.617 8.375 1.107 5.394 4.05z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.024 1.085c.98.071 2.002.55 2.98 1.517c.978-.968 1.999-1.445 2.978-1.514c1.106-.079 2.083.368 2.79 1.073c1.39 1.386 1.827 3.895.102 5.62l-.018.017l-5.516 4.997a.5.5 0 0 1-.672 0L1.152 7.798l-.018-.017c-1.734-1.734-1.3-4.243.095-5.628c.709-.704 1.688-1.148 2.795-1.068\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartsSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.266 11.908a1.773 1.773 0 0 1-2.527 0L1.49 7.7c-2.84-2.842.87-9.12 5.511-4.478c4.634-4.633 8.344 1.644 5.511 4.478z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartsSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m2.041 7.254l4.164 4.174a1.1 1.1 0 0 0 1.593 0l4.164-4.173v-.001c1.114-1.128.979-3.014.011-4.155c-.464-.548-1.087-.878-1.807-.863c-.726.014-1.66.382-2.72 1.455a.625.625 0 0 1-.89 0c-1.06-1.075-1.996-1.445-2.723-1.46c-.72-.015-1.344.314-1.807.862c-.967 1.14-1.102 3.028.016 4.16m4.961-4.862c-1.067-.94-2.135-1.39-3.143-1.41c-1.156-.025-2.121.516-2.788 1.302c-1.294 1.527-1.586 4.162.082 5.85l4.168 4.177a2.35 2.35 0 0 0 3.363 0l4.166-4.176l.002-.002c1.664-1.683 1.37-4.317.076-5.842c-.666-.787-1.631-1.328-2.785-1.305c-1.008.02-2.075.468-3.14 1.406\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHeartsSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.788 1.314c.988.02 2.085.49 3.214 1.56c1.127-1.067 2.223-1.536 3.21-1.555c1.04-.02 1.918.46 2.536 1.18c1.218 1.42 1.47 3.85-.058 5.377l-.001.001l-4.247 4.208c-.81.802-2.07.802-2.88 0L1.316 7.877C-.217 6.343.032 3.913 1.25 2.491c.617-.72 1.495-1.2 2.537-1.178Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHelpChat2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.998.552a6.448 6.448 0 0 0-5.367 10.02L.55 13.447l3.62-.655A6.448 6.448 0 1 0 6.999.552\"/><path d=\"M5.51 5.512A1.488 1.488 0 1 1 6.998 7v.992M7 10.472a.248.248 0 0 1 0-.496m0 .496a.248.248 0 1 0 0-.496\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHelpChat2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 3.136 5.124a.63.63 0 0 0-.407-.057l-2.346.47l.683-1.707a.63.63 0 0 0-.065-.585A5.7 5.7 0 0 1 1.25 7M7 0a7 7 0 0 0-5.965 10.666l-.99 2.478a.625.625 0 0 0 .702.845l3.27-.654A7 7 0 1 0 7 0m0 10.875a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75M5.875 5.25A1.125 1.125 0 1 1 7 6.375A.625.625 0 0 0 6.375 7v1a.625.625 0 0 0 1.25 0v-.458a2.376 2.376 0 1 0-3-2.292a.625.625 0 0 0 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHelpChat2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.998.046A6.954 6.954 0 1 1 4.099 13.32l-3.466.627a.5.5 0 0 1-.556-.668l.994-2.646A6.954 6.954 0 0 1 6.998.046m-.379 4.399A.995.995 0 1 1 7 6.36a.625.625 0 0 0-.625.625v1.08a.625.625 0 1 0 1.25 0V7.52a2.245 2.245 0 1 0-2.87-2.157a.625.625 0 0 0 1.25 0a.995.995 0 0 1 .614-.919ZM7 11.39a.895.895 0 0 1 .002-1.79h.002a.895.895 0 0 1-.002 1.79z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHelpQuestion1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M5.25 5.25a1.75 1.75 0 0 1 2.093-1.717A1.752 1.752 0 0 1 8.62 5.92A1.75 1.75 0 0 1 7.002 7v1.167M7 10.459a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHelpQuestion1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 4.125c-.621 0-1.125.504-1.125 1.125a.625.625 0 1 1-1.25 0a2.375 2.375 0 1 1 3 2.292V8a.625.625 0 1 1-1.25 0V7c0-.345.28-.625.625-.625a1.125 1.125 0 0 0 0-2.25m0 5a.875.875 0 1 1 0 1.75a.875.875 0 0 1 0-1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHelpQuestion1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M5.75 5.25A1.25 1.25 0 1 1 7 6.5a.75.75 0 0 0-.75.75v.646a.75.75 0 1 0 1.5 0a2.751 2.751 0 1 0-3.5-2.646a.75.75 0 0 0 1.5 0M8 10.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHexagram: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 3.5h13L7 13.5z\"/><path d=\"M.5 10.5h13L7 .5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHexagramRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.534.298a.626.626 0 0 0-1.068 0L4.692 3.186H1.127a.627.627 0 0 0-.534.955L2.35 7L.593 9.86a.627.627 0 0 0 .534.954h3.565l1.774 2.888a.627.627 0 0 0 1.068 0l1.774-2.889h3.565a.627.627 0 0 0 .534-.954L11.65 7l1.756-2.86a.626.626 0 0 0-.534-.954H9.308zm.304 2.888L7 1.823l-.838 1.363zM5.393 4.44h3.214L10.18 7L8.607 9.56H5.393L3.82 7zm-1.47 0H2.246l.838 1.364zm-.838 3.758L2.247 9.56h1.675zm3.077 2.617L7 12.176l.838-1.363zm3.916-1.253h1.675l-.838-1.364zm.837-3.758l-.837-1.364h1.675z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHexagramSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.857.564a1 1 0 0 0-1.714 0L4.67 3.017H1.655a1 1 0 0 0-.857 1.515L2.279 7L.798 9.468a1 1 0 0 0 .857 1.515H4.67l1.473 2.452a1 1 0 0 0 1.714 0l1.473-2.452h3.015a1 1 0 0 0 .857-1.515L11.721 7l1.481-2.468a1 1 0 0 0-.857-1.515H9.33z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy10: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 9.5v-5m8-.5h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4.5.5h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m0 9h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m4-3.5h-2a3 3 0 0 0-3 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy10Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125 12.75V10h2.75v2.75zM5 8.75h-.753A2.375 2.375 0 0 1 6.5 7.125h1.375V8c0 .621.504 1.125 1.125 1.125h3c.621 0 1.125-.504 1.125-1.125V5c0-.621-.504-1.125-1.125-1.125H9c-.621 0-1.125.504-1.125 1.125v.875H6.5a3.63 3.63 0 0 0-2.375.886V5.25H5c.621 0 1.125-.504 1.125-1.125v-3C6.125.504 5.621 0 5 0H2C1.379 0 .875.504.875 1.125v3c0 .621.504 1.125 1.125 1.125h.875v3.5H2c-.621 0-1.125.504-1.125 1.125v3C.875 13.496 1.379 14 2 14h3c.621 0 1.125-.504 1.125-1.125v-3c0-.621-.504-1.125-1.125-1.125M3.5 4H2.125V1.25h2.75V4z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy10Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 1.25C1.25.56 1.81 0 2.5 0h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-.25V6a3.75 3.75 0 0 1 2.25-.75h2V5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2C9.06 8.25 8.5 7.69 8.5 7v-.25h-2A2.25 2.25 0 0 0 4.25 9v.5h.25c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25h.25v-5H2.5c-.69 0-1.25-.56-1.25-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy13: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.531 7.027L2.885 9.5m8.224-5L10.344 7M6.25 6.257L7.5 7.5m5-3h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1m-2 6.5h-2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1M5.25 7.027h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1M3.5 13.5h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy13Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.375.375C9.754.375 9.25.879 9.25 1.5V4c0 .618.498 1.12 1.115 1.125l-.538 1.75H8.5c-.185 0-.36.045-.514.124L6.625 5.886V3.5c0-.621-.504-1.125-1.125-1.125H3c-.621 0-1.125.504-1.125 1.125V6c0 .577.434 1.052.993 1.117l-.541 1.758H1.125C.504 8.875 0 9.379 0 10v2.5c0 .621.504 1.125 1.125 1.125h2.5c.621 0 1.125-.504 1.125-1.125V10c0-.618-.498-1.12-1.115-1.125l.538-1.75H5.5c.185 0 .36-.045.514-.124l1.361 1.113V10.5c0 .621.504 1.125 1.125 1.125H11c.621 0 1.125-.504 1.125-1.125V8c0-.577-.434-1.052-.993-1.117l.541-1.758h1.202C13.496 5.125 14 4.621 14 4V1.5c0-.621-.504-1.125-1.125-1.125zm-.1 7.75h.6v2.25h-2.25v-2.25zm-7.472 2H1.25v2.25H3.5v-2.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy13Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.5 0H13a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1h-.918l-.899 2.517A1 1 0 0 1 12 8v2.5a1 1 0 0 1-1 1H8.5a1 1 0 0 1-1-1V8.695L5.626 6.992A1 1 0 0 1 5.5 7H4.231l-.54 2.518a1 1 0 0 1 .809.982V13a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-2.5a1 1 0 0 1 1-1h1.162l.545-2.544A1 1 0 0 1 2 6V3.5a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1v2.26l1.507 1.37A1 1 0 0 1 8.5 7h1.096l.893-2.5a1 1 0 0 1-.989-1V1a1 1 0 0 1 1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy14: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 5.5v-4a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4.5a1 1 0 0 1-1-1M7 6.5v4m-5 0v-1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1m-11.5 2v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1m5 0v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1m5 0v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy14Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.625 1.5c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4c0 .621-.504 1.125-1.125 1.125H7.625v.75h3.25c.898 0 1.625.728 1.625 1.625v.375h.375c.621 0 1.125.504 1.125 1.125v2c0 .621-.504 1.125-1.125 1.125h-2A1.125 1.125 0 0 1 9.75 12.5v-2c0-.621.504-1.125 1.125-1.125h.375V9a.375.375 0 0 0-.375-.375h-3.25v.75H8c.621 0 1.125.504 1.125 1.125v2c0 .621-.504 1.125-1.125 1.125H6A1.125 1.125 0 0 1 4.875 12.5v-2c0-.621.504-1.125 1.125-1.125h.375v-.75h-3.25A.375.375 0 0 0 2.75 9v.375h.375c.621 0 1.125.504 1.125 1.125v2c0 .621-.504 1.125-1.125 1.125h-2A1.125 1.125 0 0 1 0 12.5v-2c0-.621.504-1.125 1.125-1.125H1.5V9c0-.897.728-1.625 1.625-1.625h3.25v-.75H4.75A1.125 1.125 0 0 1 3.625 5.5zm8.25 9.125H11v1.75h1.75v-1.75zm-5.75 0h1.75v1.75h-1.75zm-4 0H1.25v1.75H3v-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy14Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.25 1v3.5a1 1 0 0 0 1 1h1v1.25H3A1.75 1.75 0 0 0 1.25 8.5V10H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-.25V8.5A.25.25 0 0 1 3 8.25h3.25V10H6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-.25V8.25H11a.25.25 0 0 1 .25.25V10H11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-.25V8.5A1.75 1.75 0 0 0 11 6.75H7.75V5.5h1a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 10V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2M7 4v6M5.5 2v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1m0 9v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1m-5 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1m10 0v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 .375c-.621 0-1.125.504-1.125 1.125v2c0 .621.504 1.125 1.125 1.125h.375v1.75h-3.25A1.625 1.625 0 0 0 1.5 8v1.375h-.375C.504 9.375 0 9.879 0 10.5v2c0 .621.504 1.125 1.125 1.125h2c.621 0 1.125-.504 1.125-1.125v-2c0-.621-.504-1.125-1.125-1.125H2.75V8a.375.375 0 0 1 .375-.375h3.25v1.75H6c-.621 0-1.125.504-1.125 1.125v2c0 .621.504 1.125 1.125 1.125h2c.621 0 1.125-.504 1.125-1.125v-2c0-.621-.504-1.125-1.125-1.125h-.375v-1.75h3.25A.375.375 0 0 1 11.25 8v1.375h-.375c-.621 0-1.125.504-1.125 1.125v2c0 .621.504 1.125 1.125 1.125h2c.621 0 1.125-.504 1.125-1.125v-2c0-.621-.504-1.125-1.125-1.125H12.5V8a1.625 1.625 0 0 0-1.625-1.625h-3.25v-1.75H8c.621 0 1.125-.504 1.125-1.125v-2C9.125.879 8.621.375 8 .375zm1 10.25h-.875v1.75h1.75v-1.75zm4 0h1.75v1.75H11zm-9.75 0H3v1.75H1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5.5A1.5 1.5 0 0 0 5 2v1a1.5 1.5 0 0 0 1.25 1.48v1.77H3A1.75 1.75 0 0 0 1.25 8v1.52A1.5 1.5 0 0 0 0 11v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 4 12v-1a1.5 1.5 0 0 0-1.25-1.48V8A.25.25 0 0 1 3 7.75h3.25v1.77A1.5 1.5 0 0 0 5 11v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 9 12v-1a1.5 1.5 0 0 0-1.25-1.48V7.75H11a.25.25 0 0 1 .25.25v1.52A1.5 1.5 0 0 0 10 11v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 14 12v-1a1.5 1.5 0 0 0-1.25-1.48V8A1.75 1.75 0 0 0 11 6.25H7.75V4.48A1.5 1.5 0 0 0 9 3V2A1.5 1.5 0 0 0 7.5.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy4: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 .5H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m0 9H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m6-4H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m-7-1v5m4-2H7a3 3 0 0 1-3-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy4Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 0C1.379 0 .875.504.875 1.125v3c0 .621.504 1.125 1.125 1.125h.875v3.5H2c-.621 0-1.125.504-1.125 1.125v3C.875 13.496 1.379 14 2 14h3c.621 0 1.125-.504 1.125-1.125v-3c0-.621-.504-1.125-1.125-1.125h-.875V7.239c.657.57 1.5.886 2.375.886h1.375V9c0 .621.504 1.125 1.125 1.125h3c.621 0 1.125-.504 1.125-1.125V6c0-.621-.504-1.125-1.125-1.125H9c-.621 0-1.125.504-1.125 1.125v.875H6.5A2.375 2.375 0 0 1 4.247 5.25H5c.621 0 1.125-.504 1.125-1.125v-3C6.125.504 5.621 0 5 0zm.125 10h2.75v2.75h-2.75zm7-1.125v-2.75h2.75v2.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy4Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.5A1.5 1.5 0 0 1 3.25 0h1.5a1.5 1.5 0 0 1 1.5 1.5V3a1.5 1.5 0 0 1-1.5 1.5A2.25 2.25 0 0 0 7 6.75h1a1.5 1.5 0 0 1 1.5-1.5H11a1.5 1.5 0 0 1 1.5 1.5v1.5a1.5 1.5 0 0 1-1.5 1.5H9.5A1.5 1.5 0 0 1 8 8.25H7a3.75 3.75 0 0 1-2.25-.75v2a1.5 1.5 0 0 1 1.5 1.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-1.5a1.5 1.5 0 0 1-1.5-1.5V11a1.5 1.5 0 0 1 1.5-1.5v-5A1.5 1.5 0 0 1 1.75 3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy7: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5.5h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m0 9h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m9 0h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m-10 0v-5m9 5v-5a2 2 0 0 0-2-2H7\"/><path d=\"m9 .5l-2 2l2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy7Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.941.226a.5.5 0 0 1 .309.462v1.375h1c.898 0 1.625.727 1.625 1.625v4.875h.875c.621 0 1.125.503 1.125 1.125v3c0 .62-.504 1.124-1.125 1.124h-3a1.125 1.125 0 0 1-1.125-1.124v-3c0-.622.504-1.125 1.125-1.125h.875V3.688a.375.375 0 0 0-.375-.375h-1v1.375a.5.5 0 0 1-.854.353l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .545-.108M2.75 4.563h1.375v-2.75h-2.75v2.75zm0 5.25h1.375v2.75h-2.75v-2.75zm.625-1.25v-2.75h.875c.621 0 1.125-.504 1.125-1.125v-3c0-.622-.504-1.125-1.125-1.125h-3C.629.563.125 1.066.125 1.688v3c0 .62.504 1.125 1.125 1.125h.875v2.75H1.25c-.621 0-1.125.503-1.125 1.125v3c0 .62.504 1.124 1.125 1.124h3c.621 0 1.125-.503 1.125-1.124v-3c0-.622-.504-1.125-1.125-1.125z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHierarchy7Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.691.038A.5.5 0 0 1 9 .5v1.25h.75A2.75 2.75 0 0 1 12.5 4.5v5A1.5 1.5 0 0 1 14 11v1.5a1.5 1.5 0 0 1-1.5 1.5H11a1.5 1.5 0 0 1-1.5-1.5V11A1.5 1.5 0 0 1 11 9.5v-5c0-.69-.56-1.25-1.25-1.25H9V4.5a.5.5 0 0 1-.854.354l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .545-.108M1.5 9.5v-5A1.5 1.5 0 0 1 0 3V1.5A1.5 1.5 0 0 1 1.5 0H3a1.5 1.5 0 0 1 1.5 1.5V3A1.5 1.5 0 0 1 3 4.5v5A1.5 1.5 0 0 1 4.5 11v1.5A1.5 1.5 0 0 1 3 14H1.5A1.5 1.5 0 0 1 0 12.5V11a1.5 1.5 0 0 1 1.5-1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHighSpeedTrainFront: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.564 5.39c0 3.333-2.572 7.378-5.744 7.378S1.076 8.723 1.076 5.389S3.647.694 6.82.694s5.744 1.361 5.744 4.695\"/><path d=\"M10.617 10.673c-1.012 1.243-2.341 2.095-3.797 2.095c-1.454 0-2.782-.85-3.794-2.092c.641-1.745 2.1-2.493 3.796-2.493s3.153.747 3.795 2.49m-8.473 1.593L1.076 13.27m10.78-1.004l1.068 1.003M4.497 3.365h4.648s1.271 0 1.271 1.271v0s0 1.271-1.271 1.271H4.497s-1.271 0-1.271-1.271v0s0-1.271 1.271-1.271\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHighSpeedTrainFrontRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.973 1.038C4.174.26 5.683 0 7 0c1.316 0 2.826.26 4.027 1.038c1.239.801 2.098 2.123 2.098 4.087c0 1.857-.528 3.825-1.542 5.347c-1.02 1.53-2.57 2.653-4.583 2.653c-2.012 0-3.562-1.123-4.583-2.653C1.403 8.95.875 6.982.875 5.125c0-1.964.86-3.286 2.098-4.087m.679 1.05c-.886.573-1.527 1.5-1.527 3.037c0 1.643.472 3.362 1.333 4.653q.137.207.287.397C4.47 9.16 5.658 8.5 7 8.5s2.53.66 3.255 1.675q.15-.19.287-.397c.861-1.29 1.333-3.01 1.333-4.653c0-1.536-.64-2.464-1.527-3.038C9.424 1.49 8.184 1.25 7 1.25s-2.424.24-3.348.837M3.5 5A1.5 1.5 0 0 0 5 6.5h4a1.5 1.5 0 1 0 0-3H5A1.5 1.5 0 0 0 3.5 5m-1.183 6.683a.625.625 0 0 1 0 .884l-1.25 1.25a.625.625 0 1 1-.884-.884l1.25-1.25a.625.625 0 0 1 .884 0m10.25 0a.625.625 0 1 0-.884.884l1.25 1.25a.625.625 0 1 0 .884-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHighSpeedTrainFrontSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.464 1.2C3.619.36 5.173.009 6.82.009s3.2.351 4.356 1.193c1.179.858 1.888 2.188 1.888 4.002c0 1.593-.546 3.317-1.443 4.739c-1.02-1.797-2.828-2.57-4.799-2.57s-3.78.775-4.8 2.574C1.121 8.523.575 6.798.575 5.203c0-1.814.709-3.144 1.888-4.002m.4 9.87c1.045 1.176 2.413 2.011 3.956 2.011s2.913-.837 3.96-2.015c-.7-1.698-2.16-2.444-3.958-2.444c-1.8 0-3.26.747-3.959 2.448m.362-6.824c0-.702.57-1.27 1.272-1.27h4.648a1.271 1.271 0 1 1 0 2.541H4.498a1.27 1.27 0 0 1-1.272-1.27m-.766 7.501a.75.75 0 0 1-.059 1.06l-1.12 1.002a.75.75 0 0 1-1-1.118l1.12-1.003a.75.75 0 0 1 1.06.06m9.08 0a.75.75 0 0 0 .059 1.06l1.12 1.002a.75.75 0 0 0 1-1.118l-1.12-1.003a.75.75 0 0 0-1.06.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHinduism: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.796 9.186a3.825 3.825 0 1 0 3.825-3.825M2.327 1.586A2.909 2.909 0 0 1 6.34 5.743m6.315-2.377a2.447 2.447 0 0 1-3.46 0\"/><path d=\"M11.668 11.546a3.252 3.252 0 0 0-2.253-5.294c-.62-.052-1.468.094-1.878.459m3.388-5.254a.25.25 0 0 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHinduismRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.907 2.092A2.278 2.278 0 0 1 6.293 4.99a4.4 4.4 0 0 0-1.475-.25a.625.625 0 0 0 0 1.25a3.193 3.193 0 1 1-3.193 3.192a.625.625 0 0 0-1.25 0a4.443 4.443 0 1 0 8.286-2.231l.062-.014a2.9 2.9 0 0 1 .829-.06a2.62 2.62 0 0 1 1.816 4.266a.625.625 0 0 0 .969.79A3.87 3.87 0 0 0 9.655 5.63a4.2 4.2 0 0 0-1.203.085a3.3 3.3 0 0 0-.62.201a5 5 0 0 0-.43-.35A3.528 3.528 0 0 0 2.148 1.1a.625.625 0 1 0 .76.993m10.535.832a.625.625 0 0 1 0 .884a3.07 3.07 0 0 1-4.344 0a.625.625 0 1 1 .884-.884a1.82 1.82 0 0 0 2.576 0a.625.625 0 0 1 .884 0M10.395 1.25a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHinduismSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.112 2.541a1 1 0 1 0 0-2a1 1 0 0 0 0 2M4.42 2.057c-.48 0-.92.16-1.273.43a.75.75 0 0 1-.911-1.192a3.599 3.599 0 0 1 5.413 4.45q.141.109.273.226a3.4 3.4 0 0 1 .553-.17a3.934 3.934 0 0 1 3.947 6.32a.75.75 0 0 1-1.163-.95a2.434 2.434 0 0 0-2.34-3.93A4.496 4.496 0 1 1 .443 9.334a.75.75 0 1 1 1.5 0A2.996 2.996 0 1 0 4.94 6.338a.75.75 0 1 1 0-1.5c.48 0 .944.076 1.378.216A2.1 2.1 0 0 0 4.42 2.057m8.917 2.108a.75.75 0 0 0-1.06-1.06a1.646 1.646 0 0 1-2.329 0a.75.75 0 0 0-1.06 1.06a3.146 3.146 0 0 0 4.449 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHome3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6.94a1 1 0 0 0-.32-.74L7 .5L.82 6.2a1 1 0 0 0-.32.74v5.56a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1zM7 13.5v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHome3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.422.54a.625.625 0 0 0-.844 0L.902 5.741A1.63 1.63 0 0 0 .375 6.94V12c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V6.94c0-.456-.191-.89-.527-1.198zM1.747 6.662L7 1.848l5.253 4.815a.38.38 0 0 1 .122.277V12a.375.375 0 0 1-.375.375H8V9a1 1 0 1 0-2 0v3.375H2A.375.375 0 0 1 1.625 12V6.94c0-.105.044-.206.122-.277\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHome3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.318 6.045A1 1 0 0 0 0 6.776V12.5A1.5 1.5 0 0 0 1.5 14H6v-3a1 1 0 1 1 2 0v3h4.5a1.5 1.5 0 0 0 1.5-1.5V6.776a1 1 0 0 0-.318-.731L7.325.12a.5.5 0 0 0-.65 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHome4: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 8L7 1.5L13.5 8\"/><path d=\"M2.5 6v6.5h9V6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHome4Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.619.881a.875.875 0 0 0-1.238 0L.287 6.976a.875.875 0 0 0 1.237 1.237l.437-.437v5.013c0 .345.28.625.625.625h8.827c.345 0 .625-.28.625-.625V7.776l.438.437a.875.875 0 1 0 1.237-1.237zm3.17 5.645L7 2.737L3.211 6.526v5.638h7.577z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHome4Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.707 1.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L2 8.414V13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.414l.293.293a1 1 0 1 0 1.414-1.414z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHorizontalMenuCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4 7.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m3 .5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m3 .5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHorizontalMenuCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0m3.625 0a1.125 1.125 0 1 0-2.25 0a1.125 1.125 0 0 0 2.25 0M7 8.125a1.125 1.125 0 1 1 0-2.25a1.125 1.125 0 0 1 0 2.25m3.25 0a1.125 1.125 0 1 1 0-2.25a1.125 1.125 0 0 1 0 2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHorizontalMenuCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M4 8a1 1 0 1 0 0-2a1 1 0 0 0 0 2m4-1a1 1 0 1 1-2 0a1 1 0 0 1 2 0m2 1a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHospitalSignCircle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 4.5v5m4-5v5M5 7h4m-2 6.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHospitalSignCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M5.875 4.5a.875.875 0 1 0-1.75 0v5a.875.875 0 1 0 1.75 0V7.875h2.25V9.5a.875.875 0 1 0 1.75 0v-5a.875.875 0 1 0-1.75 0v1.625h-2.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHospitalSignCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m5.625-2.5a.625.625 0 1 0-1.25 0v5a.625.625 0 1 0 1.25 0V7.625h2.75V9.5a.625.625 0 1 0 1.25 0v-5a.625.625 0 1 0-1.25 0v1.875h-2.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHospitalSignSquare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M5 4.5v5m4-5v5M5 7h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHospitalSignSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125.5C1.228.5.5 1.228.5 2.125v9.75c0 .898.728 1.625 1.625 1.625h9.75c.898 0 1.625-.727 1.625-1.625v-9.75C13.5 1.228 12.773.5 11.875.5zM1.75 2.125c0-.207.168-.375.375-.375h9.75c.207 0 .375.168.375.375v9.75a.375.375 0 0 1-.375.375h-9.75a.375.375 0 0 1-.375-.375zM5.875 4.5a.875.875 0 1 0-1.75 0v5a.875.875 0 1 0 1.75 0V7.875h2.25V9.5a.875.875 0 1 0 1.75 0v-5a.875.875 0 1 0-1.75 0v1.625h-2.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHospitalSignSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm5.625 3.5a.625.625 0 1 0-1.25 0v5a.625.625 0 1 0 1.25 0V7.625h2.75V9.5a.625.625 0 1 0 1.25 0v-5a.625.625 0 1 0-1.25 0v1.875h-2.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotSpring: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 7a2.8 2.8 0 0 1 1.5 2.24c0 1.93-2.91 3.5-6.5 3.5S.5 11.18.5 9.25A2.8 2.8 0 0 1 2 7\"/><path d=\"M4.08 2.25c-2 2.5 2 3.5 0 6m2.92-7c-2 2.5 2 5.5 0 8m2.92-7c-2 2.5 2 3.5 0 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotSpringRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.156 1.89a.625.625 0 0 0-.976-.78c-1.221 1.526-.605 3.216-.135 4.505l.036.099c.527 1.449.846 2.461.1 3.396a.625.625 0 0 0 .975.78c1.221-1.526.605-3.216.135-4.505l-.035-.099c-.527-1.449-.847-2.461-.1-3.396m-2.75 1a.625.625 0 0 0-.976-.78c-.586.733-.782 1.43-.694 2.11c.078.61.382 1.14.617 1.55l.023.04c.262.46.44.79.485 1.13c.037.287-.017.653-.43 1.17a.625.625 0 0 0 .975.78c.587-.732.782-1.43.695-2.11c-.079-.61-.383-1.14-.617-1.55l-.023-.04c-.263-.46-.442-.79-.485-1.13c-.038-.287.017-.652.43-1.17m5.403-.878c.27.216.313.609.097.878c-.413.518-.468.883-.43 1.17c.043.34.222.67.485 1.13l.023.04c.234.41.538.94.616 1.55c.088.68-.108 1.378-.694 2.11a.625.625 0 0 1-.976-.78c.414-.517.468-.883.43-1.17c-.043-.34-.222-.67-.484-1.13l-.023-.04c-.235-.41-.539-.94-.617-1.55c-.088-.68.108-1.377.694-2.11a.625.625 0 0 1 .879-.098m-7.303 5.82a.875.875 0 1 0-1.07-1.385C.618 7.08-.001 7.96-.001 9.025c0 1.387 1.03 2.444 2.255 3.103C3.513 12.806 5.193 13.2 7 13.2s3.488-.393 4.747-1.07c1.224-.66 2.255-1.717 2.255-3.104c0-1.066-.62-1.945-1.439-2.578a.875.875 0 0 0-1.07 1.386c.566.436.759.856.759 1.192c0 .435-.341 1.027-1.335 1.562c-.958.516-2.341.862-3.917.862s-2.96-.346-3.918-.862c-.993-.535-1.334-1.127-1.334-1.562c0-.336.193-.756.758-1.192\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotSpringSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.311 1.477a.75.75 0 0 1 .092 1.057c-.335.398-.418.793-.374 1.247c.05.501.249 1.038.5 1.695l.017.044c.23.603.504 1.319.575 2.04c.077.787-.083 1.603-.718 2.36a.75.75 0 1 1-1.148-.966c.334-.398.418-.794.373-1.248c-.049-.5-.249-1.037-.5-1.694l-.017-.045c-.23-.603-.504-1.318-.575-2.04c-.077-.787.083-1.603.719-2.359a.75.75 0 0 1 1.056-.09m-2.809 1.98a.75.75 0 1 0-1.148-.966c-.593.705-.81 1.401-.715 2.099c.082.602.395 1.123.619 1.495l.027.045c.26.433.41.703.446.97c.027.197 0 .481-.377.93a.75.75 0 0 0 1.148.966c.593-.705.81-1.4.715-2.098c-.082-.603-.395-1.123-.619-1.495l-.027-.045c-.26-.433-.41-.703-.446-.97c-.027-.197 0-.482.377-.931m8.41 3.43a.75.75 0 0 0-1.026 1.093a1.92 1.92 0 0 1 .593 1.191c-.016.504-.419 1.125-1.428 1.666c-.999.535-2.43.89-4.051.89c-1.622 0-3.053-.353-4.052-.886c-1.01-.539-1.412-1.158-1.427-1.662a1.9 1.9 0 0 1 .594-1.199a.75.75 0 0 0-1.027-1.093a3.42 3.42 0 0 0-1.065 2.2L.02 9.15c0 1.332.997 2.362 2.222 3.016c1.256.67 2.94 1.061 4.758 1.061c1.82 0 3.503-.394 4.76-1.067c1.224-.656 2.22-1.689 2.22-3.02l-.003-.065a3.4 3.4 0 0 0-1.064-2.187m-2.387-3.523a.75.75 0 0 0-1.281-.78c-.429.706-.562 1.357-.5 1.978c.055.566.271 1.063.437 1.445l.016.036c.183.421.305.718.336 1.029c.027.273-.016.603-.29 1.052a.75.75 0 1 0 1.282.779c.429-.705.561-1.356.5-1.977c-.055-.566-.271-1.064-.437-1.445l-.016-.036c-.183-.422-.305-.719-.336-1.03c-.027-.273.016-.602.29-1.051\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelAirConditioner: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1\"/><path d=\"M11 7.5v-2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2m-.5 5h.1A1.4 1.4 0 0 0 4 11.1V10m7.5 2.5h-.1a1.4 1.4 0 0 1-1.4-1.4V10m-3 3.5V10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelAirConditionerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v4.5a.375.375 0 0 1-.375.375h-1V6a1.5 1.5 0 0 0-1.5-1.5h-5A1.5 1.5 0 0 0 3 6v.875H2a.375.375 0 0 1-.375-.375zM2 .375C1.103.375.375 1.103.375 2v4.5c0 .897.728 1.625 1.625 1.625h10c.898 0 1.625-.728 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625zM4.75 9.5a.75.75 0 0 0-1.5 0v1.1a.65.65 0 0 1-.65.65h-.1a.75.75 0 0 0 0 1.5h.1a2.15 2.15 0 0 0 2.15-2.15zM10 8.75a.75.75 0 0 0-.75.75v1.1a2.15 2.15 0 0 0 2.15 2.15h.1a.75.75 0 0 0 0-1.5h-.1a.65.65 0 0 1-.65-.65V9.5a.75.75 0 0 0-.75-.75m-2.25.75a.75.75 0 0 0-1.5 0V13a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelAirConditionerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0C.706 0 0 .607 0 1.43v4.654c0 .824.706 1.43 1.5 1.43h.582V5.5c0-.446.19-.864.513-1.164a1.74 1.74 0 0 1 1.185-.461h6.44c.436 0 .863.161 1.185.46c.322.301.513.72.513 1.165v2.015h.582c.794 0 1.5-.607 1.5-1.43V1.43C14 .607 13.294 0 12.5 0zm9.168 7.515H3.332V5.5c0-.085.036-.176.115-.25a.5.5 0 0 1 .333-.125h6.44a.5.5 0 0 1 .332.125c.08.074.116.165.116.25zM4.75 9.749a.75.75 0 0 0-1.5 0v1.1a.65.65 0 0 1-.65.65h-.1a.75.75 0 0 0 0 1.5h.1a2.15 2.15 0 0 0 2.15-2.15zm5.25-.75a.75.75 0 0 0-.75.75v1.1a2.15 2.15 0 0 0 2.15 2.15h.1a.75.75 0 0 0 0-1.5h-.1a.65.65 0 0 1-.65-.65v-1.1a.75.75 0 0 0-.75-.75m-2.25.75a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelBed2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M7 3.5H3v-3m8 0v3H7v-3M.5 6h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelBed2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v10c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12zM2 1.625A.375.375 0 0 0 1.625 2v3.5h10.75V2A.375.375 0 0 0 12 1.625h-.75v1.75a.5.5 0 0 1-.5.5H8.125a.5.5 0 0 1-.5-.5v-1.75h-1.25v1.75a.5.5 0 0 1-.5.5H3.25a.5.5 0 0 1-.5-.5v-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelBed2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.046 1.54C.046.714.715.045 1.54.045h10.922c.824 0 1.493.669 1.493 1.493v4.313H.046V1.539Zm0 5.562v5.359c0 .824.669 1.493 1.493 1.493h10.922c.824 0 1.493-.669 1.493-1.493V7.1H.046Zm6.268-3.554v-.979a1 1 0 0 0-1-1H2.63a1 1 0 0 0-1 1v.979a1 1 0 0 0 1 1h2.685a1 1 0 0 0 1-1Zm6.057-.979v.979a1 1 0 0 1-1 1H8.686a1 1 0 0 1-1-1v-.979a1 1 0 0 1 1-1h2.685a1 1 0 0 1 1 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelLaundry: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M9.959 9h-.841C8.383 9 7.658 8.829 7 8.5v0A4.7 4.7 0 0 0 4.882 8h-.84M10 8.5a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-8.5-5h11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelLaundryRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0C1.603 0 .875.728.875 1.625v10.75C.875 13.273 1.603 14 2.5 14h9c.898 0 1.625-.727 1.625-1.625V1.625C13.125.728 12.398 0 11.5 0zm-.375 3.5v8.875c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375V3.5zm2.757 4.125h-.204a2.376 2.376 0 0 1 4.644 1h-.204c-.735 0-1.46-.171-2.118-.5a4.7 4.7 0 0 0-2.118-.5M7 4.5a3.625 3.625 0 1 0 0 7.25A3.625 3.625 0 0 0 7 4.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelLaundrySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 1.5A1.5 1.5 0 0 1 2.5 0h9A1.5 1.5 0 0 1 13 1.5v.981H1zm0 2.231V12.5A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5-1.5V3.731zM3.392 8.5a3.6 3.6 0 0 1 .206-1.202A3.609 3.609 0 1 1 3.392 8.5m1.11-.3a.5.5 0 0 1 .493-.417h.354c.765 0 1.213.187 1.616.354l.06.025c.377.157.758.304 1.511.304h.497a.5.5 0 0 1 .493.582A2.548 2.548 0 0 1 4.502 8.2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelOneStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 5.07v4.32M5.56 6.15h.36A1.08 1.08 0 0 0 7 5.07v0m1.44 4.32H5.56\"/><path d=\"M6.039 1.282a1.135 1.135 0 0 1 1.922 0l1.866 2.952l2.432.298a1.115 1.115 0 0 1 .721 1.836l-2.028 2.327l.653 3.22a1.12 1.12 0 0 1-.442 1.126a1.14 1.14 0 0 1-1.211.067L7 11.493l-2.952 1.615a1.14 1.14 0 0 1-1.211-.067a1.13 1.13 0 0 1-.442-1.125l.653-3.221L1.02 6.368a1.115 1.115 0 0 1 .72-1.836l2.433-.298z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelOneStarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.687 1.635a.373.373 0 0 1 .626 0L9.219 4.58a.63.63 0 0 0 .422.277l2.797.466a.373.373 0 0 1 .228.603l-2.16 2.66a.63.63 0 0 0-.114.573l.926 3.085a.373.373 0 0 1-.485.457l-3.62-1.316a.63.63 0 0 0-.445.007L3.49 12.704a.373.373 0 0 1-.504-.42l.636-3.182a.63.63 0 0 0-.128-.517l-2.16-2.659a.373.373 0 0 1 .228-.603l2.797-.466a.63.63 0 0 0 .422-.277zm1.675-.68a1.623 1.623 0 0 0-2.724 0L3.882 3.67l-2.526.421a1.623 1.623 0 0 0-.993 2.624l1.977 2.43l-.58 2.895c-.253 1.264.997 2.304 2.194 1.825l3.057-1.223l3.395 1.235c1.254.456 2.492-.713 2.109-1.991l-.83-2.768l1.951-2.403a1.623 1.623 0 0 0-.992-2.624l-2.526-.42zM7.625 5.07a.625.625 0 0 0-1.25 0a.455.455 0 0 1-.455.455h-.36a.625.625 0 1 0 0 1.25h.36q.237-.001.455-.062v2.051H5.56a.625.625 0 0 0 0 1.25h2.88a.625.625 0 1 0 0-1.25h-.815z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelOneStarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.19.256A1.67 1.67 0 0 1 8.416.83l1.799 2.846l2.274.279a1.651 1.651 0 0 1 1.065 2.72l-.002.001l-1.933 2.217l.626 3.084l.001.003a1.66 1.66 0 0 1-.653 1.662l-.006.004a1.68 1.68 0 0 1-1.78.1L7 12.208l-2.807 1.536a1.68 1.68 0 0 1-1.78-.099l-.006-.004a1.66 1.66 0 0 1-.653-1.662v-.003l.627-3.084L.448 6.676l-.002-.002a1.652 1.652 0 0 1 1.065-2.719l2.274-.279L5.583.831L5.584.83c.15-.24.359-.437.606-.574m1.435 4.603a.625.625 0 1 0-1.25 0c0 .247-.2.447-.447.447H5.57a.625.625 0 1 0 0 1.25h.358q.232 0 .447-.06v2.026H5.57a.625.625 0 1 0 0 1.25h2.86a.625.625 0 1 0 0-1.25h-.805z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelShowerHead: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 6.5a4 4 0 0 1 8 0zm2 3v1m-1.5 2v1m3.5-1v1m3.5-1v1M9 9.5v1m-2-8v-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelShowerHeadRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625v.788a5.126 5.126 0 0 1 4.5 5.087c0 .345-.28.625-.625.625h-9a.625.625 0 0 1-.625-.625a5.126 5.126 0 0 1 4.5-5.087V.625C6.375.28 6.655 0 7 0M3.175 5.875a3.876 3.876 0 0 1 7.65 0zM3.625 12a.625.625 0 1 0-1.25 0v1.375a.625.625 0 1 0 1.25 0zM7 11.375c.345 0 .625.28.625.625v1.375a.625.625 0 1 1-1.25 0V12c0-.345.28-.625.625-.625m4.625.625a.625.625 0 1 0-1.25 0v1.375a.625.625 0 1 0 1.25 0zM5 8c.345 0 .625.28.625.625V10a.625.625 0 1 1-1.25 0V8.625C4.375 8.28 4.655 8 5 8m4.625.625a.625.625 0 1 0-1.25 0V10a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelShowerHeadSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.762a.75.75 0 0 0-1.5 0v1.315A4.5 4.5 0 0 0 2.5 6.514a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5a4.5 4.5 0 0 0-3.75-4.437zM5 8.488a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75m-.75 3.75a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zm2.75-.75a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75m4.25.75a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zM9 8.488a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelTwoStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.44 9.451H5.56v-.614c0-.429.254-.817.647-.99l1.603-.7a1.052 1.052 0 0 0-.422-2.016H6.64c-.47 0-.87.3-1.018.72\"/><path d=\"M6.039 1.282a1.135 1.135 0 0 1 1.922 0l1.866 2.952l2.432.298a1.115 1.115 0 0 1 .721 1.836l-2.028 2.327l.653 3.22a1.13 1.13 0 0 1-.442 1.126a1.14 1.14 0 0 1-1.211.067L7 11.493l-2.952 1.615a1.14 1.14 0 0 1-1.211-.067a1.13 1.13 0 0 1-.442-1.125l.653-3.221L1.02 6.368a1.115 1.115 0 0 1 .72-1.836l2.433-.298z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelTwoStarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.687 1.635a.373.373 0 0 1 .626 0L9.219 4.58a.63.63 0 0 0 .422.277l2.797.466a.373.373 0 0 1 .228.603l-2.16 2.66a.63.63 0 0 0-.114.573l.926 3.085a.373.373 0 0 1-.485.457l-3.62-1.316a.63.63 0 0 0-.445.007L3.49 12.704a.373.373 0 0 1-.504-.42l.636-3.182a.63.63 0 0 0-.128-.517l-2.16-2.659a.373.373 0 0 1 .228-.603l2.797-.466a.63.63 0 0 0 .422-.277zm1.675-.68a1.623 1.623 0 0 0-2.724 0L3.882 3.67l-2.526.421a1.623 1.623 0 0 0-.993 2.624l1.977 2.43l-.58 2.895c-.253 1.264.997 2.304 2.194 1.825l3.057-1.223l3.395 1.235c1.254.456 2.492-.713 2.109-1.991l-.83-2.768l1.951-2.403a1.623 1.623 0 0 0-.992-2.624l-2.526-.42zM6.64 5.006c-.743 0-1.374.476-1.608 1.138a.625.625 0 0 0 1.179.416a.455.455 0 0 1 .43-.303h.747a.427.427 0 0 1 .171.818l-1.602.701a1.7 1.7 0 0 0-1.022 1.562v.614c0 .345.28.625.625.625h2.88a.625.625 0 0 0 0-1.25H6.185a.46.46 0 0 1 .273-.406l1.602-.7a1.677 1.677 0 0 0-.672-3.214z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHotelTwoStarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.19.256A1.67 1.67 0 0 1 8.416.83l1.799 2.846l2.274.279a1.651 1.651 0 0 1 1.065 2.72l-.002.001l-1.933 2.217l.626 3.084l.001.003a1.66 1.66 0 0 1-.653 1.662l-.006.004a1.68 1.68 0 0 1-1.78.1L7 12.208l-2.807 1.536a1.68 1.68 0 0 1-1.78-.099l-.006-.004a1.66 1.66 0 0 1-.653-1.662v-.003l.627-3.084L.448 6.676l-.002-.002a1.652 1.652 0 0 1 1.065-2.719l2.274-.279L5.583.831L5.584.83c.15-.24.359-.437.606-.574m.453 4.37c-.74 0-1.368.472-1.6 1.13a.625.625 0 0 0 1.178.417a.45.45 0 0 1 .422-.298h.742a.42.42 0 0 1 .168.804l-1.59.696c-.618.27-1.018.88-1.018 1.555v.609c0 .345.28.625.625.625h2.86a.625.625 0 1 0 0-1.25H6.196a.45.45 0 0 1 .267-.394l1.591-.696a1.67 1.67 0 0 0-.669-3.199z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHumidityNone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5L.5.5m8.64 12.448a4.48 4.48 0 0 1-6.619-3.98a5.5 5.5 0 0 1 .498-1.932m8.001 3.984A4.5 4.5 0 0 0 11.5 9C11.5 6.51 7 .5 7 .5S5.626 2.335 4.397 4.397\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHumidityNoneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7 .624l.442-.442a.625.625 0 0 0-.884 0zm4.907 10.399a5.5 5.5 0 0 0 .623-2.552c0-.888-.363-1.855-.839-2.758c-.482-.917-1.119-1.838-1.743-2.65A33 33 0 0 0 7.5.243L7.458.197l-.011-.01l-.004-.004L7 .623L6.558.182l-.002.002l-.004.004l-.014.015l-.055.055q-.072.073-.2.208a33 33 0 0 0-2.276 2.656L1.067.184a.625.625 0 1 0-.884.884L3.626 4.51l.016.016l7.032 7.031l.018.02l2.241 2.24a.625.625 0 1 0 .884-.884zM2.98 5.745c.31.151.44.525.29.836c-.357.733-.55 1.379-.55 1.89a4.28 4.28 0 0 0 6.231 3.81a.625.625 0 1 1 .571 1.112A5.53 5.53 0 0 1 1.47 8.471c0-.788.286-1.635.676-2.437c.15-.31.525-.44.835-.289\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHumidityNoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7 .5l.4-.3a.5.5 0 0 0-.8 0zm4.718 10.157A5 5 0 0 0 12 9c0-.74-.324-1.668-.75-2.588c-.433-.94-1.007-1.944-1.575-2.86A52 52 0 0 0 7.453.273L7.414.218l-.01-.014l-.003-.003V.2L7 .5L6.6.2l-.001.002l-.003.003l-.01.014l-.039.052l-.145.198a52 52 0 0 0-1.966 2.906L1.28.22A.75.75 0 1 0 .22 1.28l12.5 12.5a.75.75 0 1 0 1.06-1.06zm-8.69-4.82l7.08 7.08A5 5 0 0 1 2 9c0-.74.324-1.668.75-2.588q.131-.285.277-.575\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIceCream2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10 .5H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1M5.5 3v3.5m3-3.5v3.5m0 3V12a1.5 1.5 0 0 1-3 0V9.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIceCream2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.625 1.625c0-.207.168-.375.375-.375h6c.207 0 .375.168.375.375v6.75A.375.375 0 0 1 10 8.75H4a.375.375 0 0 1-.375-.375zM4 0c-.897 0-1.625.728-1.625 1.625v6.75C2.375 9.272 3.103 10 4 10h1v2a2 2 0 0 0 4 0v-2h1c.898 0 1.625-.728 1.625-1.625v-6.75C11.625.728 10.898 0 10 0zm1.5 2.375c.345 0 .625.28.625.625v3.5a.625.625 0 1 1-1.25 0V3c0-.345.28-.625.625-.625M9.125 3a.625.625 0 1 0-1.25 0v3.5a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIceCream2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.705 1.449C2.705.649 3.354 0 4.154 0h5.692c.8 0 1.449.649 1.449 1.449V8.09c0 .8-.649 1.449-1.449 1.449H4.154A1.45 1.45 0 0 1 2.705 8.09zm5.437 11.41v-2H5.858v2a1.141 1.141 0 1 0 2.284 0M5.346 2.374c.345 0 .625.28.625.625v3.5a.625.625 0 1 1-1.25 0V3c0-.345.28-.625.625-.625M9.279 3a.625.625 0 0 0-1.25 0v3.5a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIceCream3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10.354 6.467l-2.87 6.697a.54.54 0 0 1-.999 0L3.637 6.467\"/><path d=\"M4.876 6.867a2.129 2.129 0 1 0 0-4.258a2.129 2.129 0 0 0 0 4.258\"/><path d=\"M4.876 2.619a2.119 2.119 0 1 1 4.238 0\"/><path d=\"M9.124 6.867a2.129 2.129 0 1 0 0-4.258a2.129 2.129 0 0 0 0 4.258\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIceCream3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 4.5H3.627a3.375 3.375 0 0 1 6.748.125v3a.875.875 0 1 1-1.75 0v-2.5A.625.625 0 0 0 8 4.5M7 0a4.625 4.625 0 0 0-4.625 4.625v.57c0 .372.08.74.233 1.08l3.116 6.9a1.403 1.403 0 0 0 2.552.011l1.607-3.47a2.126 2.126 0 0 0 1.742-2.091v-3A4.625 4.625 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIceCream3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.475 2.405a2.476 2.476 0 0 0-4.95 0A2.476 2.476 0 1 0 7 6.226a2.476 2.476 0 1 0 2.475-3.82M6.029 13.358L3.934 8.43A3.73 3.73 0 0 0 7 7.95a3.73 3.73 0 0 0 3.06.481l-2.11 4.926a1.04 1.04 0 0 1-1.92 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageAccessoriesLensesPhotosCameraShutterPicturePhotographyPicturesPhotoLens: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><circle cx=\"7\" cy=\"7\" r=\"2.5\"/><path d=\"M4.5 7V1M7 4.5h6M9.5 7v6M7 9.5H1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageBlur: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M5.542 2.896a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25m2.917.25a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25m-2.917 8.708a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25M2.771 5.667a.125.125 0 1 1 0-.25m0 .25a.125.125 0 0 0 0-.25m0 3.166a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25m8.458-2.666a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25m0 3.166a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25m-2.77 3.021a.125.125 0 0 1 0-.25m0 .25a.125.125 0 0 0 0-.25M5.5 5.792a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m3.021.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M5.5 8.708a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m3.021.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageBlurRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m5.75 7a5.75 5.75 0 1 0-11.5 0a5.75 5.75 0 0 0 11.5 0M5.665 2.27a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5m2.667 0a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5m-1.916 8.71a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0M3.021 4.917a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5m.75 3.416a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0m7.208-3.416a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5m.75 3.416a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0m-3.396 1.896a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5M5.625 4.625a1 1 0 1 1 0 2a1 1 0 0 1 0-2m3.75 1a1 1 0 1 0-2 0a1 1 0 0 0 2 0m-3.75 1.75a1 1 0 1 1 0 2a1 1 0 0 1 0-2m3.75 1a1 1 0 1 0-2 0a1 1 0 0 0 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageBlurSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M5.396 9.625a1.02 1.02 0 1 0 0-2.042a1.02 1.02 0 0 0 0 2.042m2.187-1.02a1.02 1.02 0 1 0 2.042 0a1.02 1.02 0 0 0-2.042 0m1.021-4.23a1.02 1.02 0 1 0 0 2.042a1.02 1.02 0 0 0 0-2.042m-2.187 1.02a1.02 1.02 0 1 0-2.042 0a1.02 1.02 0 0 0 2.042 0m-.875-1.982a.642.642 0 1 1 0-1.284a.642.642 0 0 1 0 1.284m-.643 7.816a.642.642 0 1 0 1.285 0a.642.642 0 0 0-1.285 0M2.771 6.184a.642.642 0 1 1 0-1.285a.642.642 0 0 1 0 1.285m7.816-.642a.642.642 0 1 0 1.284 0a.642.642 0 0 0-1.284 0M2.771 9.1a.642.642 0 1 1 0-1.285a.642.642 0 0 1 0 1.285m5.045-6.33a.642.642 0 1 0 1.285 0a.642.642 0 0 0-1.285 0M11.23 9.1a.642.642 0 1 1 0-1.285a.642.642 0 0 1 0 1.285m-3.413 2.128a.642.642 0 1 0 1.284 0a.642.642 0 0 0-1.284 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageCamera1PhotosPictureCameraPhotographyPhotoPictures: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 5a1 1 0 0 0-1-1h-2L9 2H5L3.5 4h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1Z\"/><circle cx=\"7\" cy=\"7.5\" r=\"2.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageCamera2PhotosPictureCameraPhotographyPhotoPictures: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"3.75\" rx=\"1\"/><circle cx=\"7\" cy=\"8.25\" r=\"2\"/><path d=\"M9.5 3.75v-1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageCameraSettingPinPhotosCameraMapPhotographyPicturesMapsSettingsPinPhoto: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 3.5a1 1 0 0 0-1-1h-2L9 .5H5l-1.5 2h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3l2.5 4l2.5-4h3a1 1 0 0 0 1-1Z\"/><circle cx=\"7\" cy=\"5.5\" r=\"2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageCameraTripodTripodPhotosPictureCameraPhotographyPhotoPictures: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 8.5v5m0-5l-4.5 5m4.5-5l4.5 5\"/><rect width=\"11\" height=\"8\" x=\"1.5\" y=\".5\" rx=\"1\"/><circle cx=\"7\" cy=\"4.5\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageFlash1FlashPowerConnectChargeElectricityLightning: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.25.5L2 5.81a.5.5 0 0 0 .46.69h2.79l-2 7l8.59-8.14a.5.5 0 0 0-.34-.86H7.75l2-4Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageFlash2FlashPowerConnectChargeElectricityLightning: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 .5v5h3.5l-5.5 8v-5H2.5L8 .5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePhotoCompositionVerticalCameraPortraitFrameVerticalCompositionPhotographyPhoto: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.2 1.19a.52.52 0 0 0 0-.47a.49.49 0 0 0-.46-.22H3.26a.49.49 0 0 0-.41.22a.52.52 0 0 0-.05.47a14.67 14.67 0 0 1 0 11.62a.52.52 0 0 0 .05.47a.49.49 0 0 0 .41.22h7.48a.49.49 0 0 0 .41-.22a.52.52 0 0 0 0-.47a14.67 14.67 0 0 1 .05-11.62Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePhotoCompsitionHorizontalCameraHorizontalPanoramaCompositionPhotographyPhotoPictures: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.81 11.2a.52.52 0 0 0 .47 0a.49.49 0 0 0 .22-.41V3.26a.49.49 0 0 0-.22-.41a.52.52 0 0 0-.47-.05a14.67 14.67 0 0 1-11.62 0a.52.52 0 0 0-.47.05a.49.49 0 0 0-.22.41v7.48a.49.49 0 0 0 .22.41a.52.52 0 0 0 .47 0a14.67 14.67 0 0 1 11.62.05Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePhotoFocusFramePhotosFramePhotoCameraPhotographyPicturesFocus: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2.5\" rx=\"1\"/><path d=\"M11 6.5V9H8.5M3 7.5V5h2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePhotoFourPhotosCameraPicturePhotographyPicturesFourPhoto: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5\" height=\"5\" x=\".5\" y=\".5\" rx=\".5\"/><rect width=\"5\" height=\"5\" x=\"8.5\" y=\".5\" rx=\".5\"/><rect width=\"5\" height=\"5\" x=\".5\" y=\"8.5\" rx=\".5\"/><rect width=\"5\" height=\"5\" x=\"8.5\" y=\"8.5\" rx=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePhotoPolaroidFourPhotosCameraPolaroidPicturePhotographyPicturesFourPhoto: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5.25\" height=\"5.25\" x=\".5\" y=\".5\" rx=\".5\"/><rect width=\"5.25\" height=\"5.25\" x=\"8.25\" y=\".5\" rx=\".5\"/><rect width=\"5.25\" height=\"5.25\" x=\".5\" y=\"8.25\" rx=\".5\"/><rect width=\"5.25\" height=\"5.25\" x=\"8.25\" y=\"8.25\" rx=\".5\"/><path d=\"M.5 3.5h5.25m2.5 0h5.25m-5.25 7.75h5.25m-13 0h5.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePhotoPolaroidPhotosPolaroidPictureCameraPhotographyPhotoPictures: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"9\" height=\"9\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(180 5 5)\"/><path d=\"m12 4.7l.78.25a1 1 0 0 1 .64 1.27l-2.18 6.59a1 1 0 0 1-1.26.64L5.56 12M.5 7h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePictureFlowerPhotosPhotoPictureCameraPhotographyPicturesFlower: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(180 7 7)\"/><path d=\"M10 6.5a3 3 0 0 1-3 3h0a3 3 0 0 1-3-3V4.31a.5.5 0 0 1 .72-.45L7 5l2.28-1.14a.5.5 0 0 1 .72.45Zm-3 3v4m0 0L9.5 11M7 13.5L4.5 11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePictureGalleryPagesFilterPicturePaginationImage: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10.5\" height=\"8.5\" x=\"3\" y=\"4\" rx=\"1\" transform=\"rotate(180 8.25 8.25)\"/><path d=\"M.5 10V2.5a1 1 0 0 1 1-1h9M3.6 12.42l3.93-4.15A1 1 0 0 1 9 8.26l3.95 4.14\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePictureLandscape1PhotosPhotoLandscapePicturePhotographyCameraPictures: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(180 7.005 7)\"/><circle cx=\"9.25\" cy=\"4.75\" r=\"1.75\"/><path d=\"M9.4 13.5a7.36 7.36 0 0 0-7.4-6a7.88 7.88 0 0 0-1.5.14\"/><path d=\"M13.5 9.91A7.8 7.8 0 0 0 11 9.5a7.89 7.89 0 0 0-3.13.64\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePictureLandscape2PhotosPhotoLandscapePicturePhotographyCameraPictures: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(180 7 7)\"/><path d=\"M.5 11h13m-9.66 0l5.21-4.88a.5.5 0 0 1 .64 0l3.81 2.73\"/><circle cx=\"4.5\" cy=\"4.5\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageSaturation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.835 11.473V4C5.84 4.902 3.85 6.615 3.85 9.081c0 1.825 1.99 2.417 2.985 2.392\"/><path d=\"M12 8.996C12 5.498 7 .5 7 .5S2 5.498 2 8.996a4.77 4.77 0 0 0 1.572 3.28C4.509 13.12 6 13.494 7 13.494s2.491-.375 3.428-1.218A4.77 4.77 0 0 0 12 8.996\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageSaturationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .75L6.47.22a.75.75 0 0 1 1.06 0zM7 12.5c-.838 0-2.072-.328-2.796-.98A3.84 3.84 0 0 1 2.94 8.904c.005-.674.251-1.478.676-2.348c.423-.868.996-1.744 1.582-2.534A28 28 0 0 1 7 1.841zM7 .75l.53-.53l.002.001l.003.004l.012.011l.043.045l.16.165a29 29 0 0 1 2.258 2.682c.616.833 1.246 1.79 1.724 2.77c.473.969.828 2.02.828 3.025l-.001.042a5.34 5.34 0 0 1-1.76 3.67C9.722 13.606 8.087 14 7 14c-1.085 0-2.72-.394-3.799-1.364a5.34 5.34 0 0 1-1.76-3.713c0-1.005.354-2.056.828-3.026c.478-.98 1.107-1.936 1.724-2.769A29 29 0 0 1 6.41.281l.043-.045l.012-.011l.003-.004h.001V.22z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageSaturationVerticalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .624L6.558.182a.625.625 0 0 1 .884 0zm0 12.127a4.28 4.28 0 0 1-4.28-4.28c0-.583.25-1.332.695-2.176c.437-.83 1.027-1.688 1.628-2.47A32 32 0 0 1 7 1.527zM7 .624L6.558.182l-.001.001l-.003.004l-.012.011l-.043.044l-.16.166a33 33 0 0 0-2.286 2.655c-.625.812-1.261 1.733-1.744 2.65c-.475.903-.838 1.87-.838 2.758a5.53 5.53 0 1 0 11.059 0c0-.888-.363-1.855-.839-2.758c-.482-.917-1.118-1.838-1.743-2.65A33 33 0 0 0 7.502.243L7.458.197l-.011-.01l-.003-.004h-.001z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxBlock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.25 13.5a3.25 3.25 0 1 0 0-6.5a3.25 3.25 0 0 0 0 6.5m2.3-.95l-4.6-4.6M4.5 9.5h-3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1V5\"/><path d=\"M.5 1.76L6.5 6l6-4.24\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxBlockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3.1v5.4c0 .207.168.375.375.375h3.75a.625.625 0 1 1 0 1.25h-3.75A1.625 1.625 0 0 1 0 8.5V1.625C0 .728.728 0 1.625 0h9.75C12.273 0 13 .728 13 1.625v3.75a.625.625 0 1 1-1.25 0V3.101L6.777 6.416a.5.5 0 0 1-.554 0zm6.995 5.132a3.375 3.375 0 1 1 4.76 4.786a3.375 3.375 0 0 1-4.76-4.786m.502 1.398a2.125 2.125 0 0 0 2.873 2.873zm3.756 1.99L9.63 8.747a2.125 2.125 0 0 1 2.873 2.873\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxBlockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.576 0h9.312c.857 0 1.551.695 1.551 1.552v.077L6.232 4.733L.024 1.629v-.077C.024.695.72 0 1.576 0m4.935 5.99l5.928-2.963v3.202a4.67 4.67 0 0 0-6.507 3.082H1.576A1.55 1.55 0 0 1 .024 7.76V3.027L5.952 5.99a.63.63 0 0 0 .56 0m3.949 2.442a2.028 2.028 0 0 1 1.862 2.83L9.657 8.597c.246-.106.518-.165.803-.165m3.527 2.028a3.52 3.52 0 0 1-1.08 2.54a3.528 3.528 0 1 1 1.08-2.54m-5.39-.803l2.665 2.665a2.028 2.028 0 0 1-2.665-2.665\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxFavorite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.45 7.336a.59.59 0 0 1 1.1 0l.64 1.63h1.71a.61.61 0 0 1 .56.39a.59.59 0 0 1-.16.65l-1.51 1.35l.64 1.28a.58.58 0 0 1-.12.69a.61.61 0 0 1-.7.1l-1.61-.91l-1.61.88a.61.61 0 0 1-.7-.1a.58.58 0 0 1-.12-.69l.64-1.28l-1.51-1.36a.59.59 0 0 1-.16-.65a.61.61 0 0 1 .56-.35h1.71zM4 9.5H1.5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4\"/><path d=\"M.5 1.76L6.5 6l6-4.24\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxFavoriteHeart: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 9.5h-3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1V5\"/><path d=\"M.5 1.76L6.5 6l6-4.24M10 8.991c1.17-2.595 3.5-1.293 3.5.651c0 2.555-3.5 3.858-3.5 3.858s-3.5-1.303-3.5-3.908c0-1.944 2.33-3.246 3.5-.601\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxFavoriteHeartRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3.1v5.4c0 .207.168.375.375.375h2.75a.625.625 0 1 1 0 1.25h-2.75A1.625 1.625 0 0 1 0 8.5V1.625C0 .728.728 0 1.625 0h9.75C12.273 0 13 .728 13 1.625v3.75a.625.625 0 1 1-1.25 0V3.101L6.777 6.416a.5.5 0 0 1-.554 0zm9 5.094c-.474-.412-.977-.632-1.479-.667a2.04 2.04 0 0 0-1.593.613c-.774.777-1.02 2.199-.016 3.18l.01.01l2.738 2.537a.5.5 0 0 0 .68 0l2.738-2.538l.01-.009c1.005-.981.758-2.403-.016-3.18a2.04 2.04 0 0 0-1.593-.613c-.502.035-1.005.255-1.479.667\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxFavoriteHeartSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.58 0h9.311c.857 0 1.552.695 1.552 1.552v.077L6.235 4.733L.028 1.629v-.077C.028.695.723 0 1.58 0m4.935 5.99l5.928-2.963v3.788a2.65 2.65 0 0 0-1.665.316a3 3 0 0 0-.42.282a3 3 0 0 0-.433-.302a2.64 2.64 0 0 0-2.158-.229c-1.073.35-1.84 1.311-2.088 2.43h-4.1a1.55 1.55 0 0 1-1.55-1.554V3.027L5.956 5.99a.63.63 0 0 0 .559 0m7.329 4.152c0-1.944-2.33-3.246-3.5-.651c-1.17-2.645-3.5-1.343-3.5.601c0 2.605 3.5 3.908 3.5 3.908s3.5-1.303 3.5-3.858\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxFavoriteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3.1v5.4c0 .207.168.375.375.375h2.75a.625.625 0 1 1 0 1.25h-2.75A1.625 1.625 0 0 1 0 8.5V1.625C0 .728.728 0 1.625 0h9.75C12.273 0 13 .728 13 1.625v3.75a.625.625 0 1 1-1.25 0V3.101L6.777 6.416a.5.5 0 0 1-.554 0zm8.735 3.214a.79.79 0 0 1 .716.427l.004.007l.813 1.634l1.8.273a.79.79 0 0 1 .432 1.36l-1.254 1.191l.265 1.862a.79.79 0 0 1-1.164.83l-1.6-.846l-1.599.847a.79.79 0 0 1-1.162-.84l.305-1.813L6.241 10l-.01-.01a.79.79 0 0 1 .436-1.334l.008-.001l1.803-.265l.81-1.63a.79.79 0 0 1 .697-.447\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxFavoriteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.56 0h9.31c.858 0 1.553.695 1.553 1.552v.077L6.215 4.733L.008 1.629v-.077C.008.695.702 0 1.56 0m4.935 5.99l5.928-2.963v4.732q0 .07-.006.14l-.201-.512a1.84 1.84 0 0 0-3.428 0l-.328.835h-.852A1.86 1.86 0 0 0 5.91 9.289l-.01.022H1.56A1.55 1.55 0 0 1 .008 7.76V3.027L5.936 5.99a.63.63 0 0 0 .559 0m3.673 1.579a.6.6 0 0 0-.216.273l-.64 1.63h-1.71a.61.61 0 0 0-.56.35a.59.59 0 0 0 .16.65l1.51 1.36l-.64 1.28a.58.58 0 0 0 .12.69a.61.61 0 0 0 .7.1l1.61-.88l1.61.91a.61.61 0 0 0 .876-.425a.58.58 0 0 0-.056-.365l-.64-1.28l1.51-1.35a.59.59 0 0 0-.06-.93a.6.6 0 0 0-.34-.11h-1.71l-.64-1.63a.59.59 0 0 0-.883-.273\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxLock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 9.5h-4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1V5\"/><path d=\"M.5 1.76L6.5 6l6-4.24M8 9.5h5c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5H8c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5m.5 0v-1c0-1.1.9-2 2-2s2 .9 2 2v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxLockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3.1v5.4c0 .207.168.375.375.375h4.75a.625.625 0 1 1 0 1.25h-4.75A1.625 1.625 0 0 1 0 8.5V1.625C0 .728.728 0 1.625 0h9.75C12.273 0 13 .728 13 1.625V4.75a.625.625 0 1 1-1.25 0V3.1L6.777 6.417a.5.5 0 0 1-.554 0zM10 8.626a1 1 0 1 1 2 0V9.5h-2zm3.25 0v.907a1 1 0 0 1 .75.968V13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.5a1 1 0 0 1 .75-.968v-.907a2.25 2.25 0 0 1 4.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxLockSolid: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M10.891 0H1.58C.723 0 .028.695.028 1.552v.077l6.207 3.104l6.208-3.104v-.077C12.443.695 11.748 0 10.891 0m1.552 3.027L6.515 5.99a.63.63 0 0 1-.56 0L.029 3.027v4.732c0 .858.695 1.552 1.552 1.552h4.51a2.3 2.3 0 0 1 .414-.491a4 4 0 0 1 5.939-3.317z\"/><path d=\"M9.25 9a1.25 1.25 0 1 1 2.5 0v.5h-2.5zm-1.5.532V9a2.75 2.75 0 0 1 5.5 0v.532a1 1 0 0 1 .75.968V13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2.5a1 1 0 0 1 .75-.968\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxTray1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 8H10a1 1 0 0 0-1 1a2 2 0 0 1-4 0a1 1 0 0 0-1-1H.5v4.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1zm-9-4L7 6.5L9.5 4M7 .5v6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxTray1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625V3.5H9.5a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 4.5 3.5h1.875V.625C6.375.28 6.655 0 7 0M1 7.375A.625.625 0 0 0 .375 8v4c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V8A.625.625 0 0 0 13 7.375H9A.625.625 0 0 0 8.375 8v.5a1.375 1.375 0 0 1-2.75 0V8A.625.625 0 0 0 5 7.375zM1.625 12V8.625h2.753a2.625 2.625 0 0 0 5.244 0h2.753V12a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxTray1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.76a.75.75 0 0 0-1.5 0v2.75H4.5a.75.75 0 0 0-.53 1.28l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5a.75.75 0 0 0-.53-1.28H7.75zM.5 8.33a.5.5 0 0 0-.5.5v3.67A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5V8.83a.5.5 0 0 0-.5-.5h-2.973a1.5 1.5 0 0 0-1.5 1.5c0 .974-.976 1.732-2.03 1.725c-1.024-.007-1.97-.768-1.97-1.725a1.5 1.5 0 0 0-1.5-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxTray2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 8H10a1 1 0 0 0-1 1a2 2 0 0 1-4 0a1 1 0 0 0-1-1H.5v4.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1zm-9-5L7 .5L9.5 3M7 6.5v-6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxTray2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.354.146a.5.5 0 0 0-.708 0l-2.5 2.5A.5.5 0 0 0 4.5 3.5h1.875v2.875a.625.625 0 1 0 1.25 0V3.5H9.5a.5.5 0 0 0 .354-.854zM1 7.375A.625.625 0 0 0 .375 8v4c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V8A.625.625 0 0 0 13 7.375H9A.625.625 0 0 0 8.375 8v.5a1.375 1.375 0 0 1-2.75 0V8A.625.625 0 0 0 5 7.375zM1.625 12V8.625h2.753a2.625 2.625 0 0 0 5.244 0h2.753V12a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInboxTray2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.193 3.546a.75.75 0 0 1-.693.463H7.75v2.75a.75.75 0 0 1-1.5 0v-2.75H4.5a.75.75 0 0 1-.53-1.28l2.5-2.5a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1 .163.817M.5 8.33a.5.5 0 0 0-.5.5v3.67A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5V8.83a.5.5 0 0 0-.5-.5h-2.973a1.5 1.5 0 0 0-1.5 1.5c0 .974-.976 1.732-2.03 1.725c-1.024-.007-1.97-.768-1.97-1.725a1.5 1.5 0 0 0-1.5-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIncognitoMode: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.499 11.242a2.25 2.25 0 1 0 4.5 0a2.25 2.25 0 1 0-4.5 0m6.502 0a2.25 2.25 0 1 0 4.5 0a2.25 2.25 0 1 0-4.5 0\"/><path d=\"M5.998 11.242s0-1 1-1s1.001 1 1.001 1M.5 6.5h13M2.86 1.336A1 1 0 0 1 3.848.5h6.306a1 1 0 0 1 .986.836L12 6.5H2z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIncognitoModeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.347.5a1.5 1.5 0 0 0-1.479 1.249l-.761 4.126H1a.625.625 0 1 0 0 1.25h12a.625.625 0 1 0 0-1.25h-1.107l-.761-4.126A1.5 1.5 0 0 0 9.652.5zm4.278 10.25a1.626 1.626 0 1 1 3.251 0a1.626 1.626 0 0 1-3.251 0M7 9.124c.29 0 .547.06.77.171a2.876 2.876 0 1 1-.394 1.455h-.002v.009v-.008a.6.6 0 0 0-.059-.222a.26.26 0 0 0-.085-.104c-.027-.018-.09-.051-.231-.051s-.205.033-.232.051a.26.26 0 0 0-.085.104a.6.6 0 0 0-.058.212v.009a2.875 2.875 0 1 1-.395-1.455A1.7 1.7 0 0 1 7 9.124m-1.626 1.625v-.036a1.625 1.625 0 1 0 0 .037\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIncognitoModeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.544 1.218A1.46 1.46 0 0 1 3.982 0h6.036c.712 0 1.32.515 1.438 1.218l.712 4.276h1.054a.75.75 0 0 1 0 1.5H.778a.75.75 0 0 1 0-1.5h1.054zM8.75 10.9a1.5 1.5 0 1 1 3.001 0a1.5 1.5 0 0 1-3.001 0m1.5-3.001a3 3 0 0 0-2.53 1.387A1.9 1.9 0 0 0 7 9.149q-.397 0-.72.136a3 3 0 1 0 .47 1.615v-.003a.5.5 0 0 1 .044-.162a.13.13 0 0 1 .042-.056c.006-.003.045-.03.163-.03c.117 0 .157.027.162.03c.009.006.024.02.042.056a.5.5 0 0 1 .046.175v.002l.001.03a3 3 0 1 0 3-3.043m-6.501 1.5a1.5 1.5 0 0 1 1.5 1.463v.031l-.001.003v.002h.001v.002h-.001v.034a1.5 1.5 0 1 1-1.5-1.535\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIncomingCall: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.53 12.823a2.7 2.7 0 0 1-3.37-.36l-.38-.38a.91.91 0 0 1 0-1.28l1.6-1.59a.9.9 0 0 1 1.27 0v0a.91.91 0 0 0 1.28 0l2.55-2.55a.91.91 0 0 0 0-1.28v0a.9.9 0 0 1 0-1.27l1.54-1.6a.91.91 0 0 1 1.28 0l.38.38a2.7 2.7 0 0 1 .41 3.37a24.2 24.2 0 0 1-6.56 6.56M2 5.5h3.5V2m0 3.5l-5-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIncomingCallRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.654 5.087L2.84 3.9L.345 1.405a.75.75 0 0 1 1.06-1.06L3.902 2.84l1.186-1.186a.625.625 0 0 1 1.067.442V5.53c0 .345-.28.625-.625.625H2.096a.625.625 0 0 1-.442-1.067m8.849-2.69a1.526 1.526 0 0 1 2.134 0l.003.003l.369.37a3.3 3.3 0 0 1 .482 4.099a24.4 24.4 0 0 1-6.603 6.603l-.011.007a3.3 3.3 0 0 1-4.085-.437l-.373-.373l-.003-.002a1.526 1.526 0 0 1 0-2.134l.004-.004l1.569-1.56l.315-.239l-.315.24q.145-.143.315-.24l4.309-3.274a1.52 1.52 0 0 1 .372-1.482l1.507-1.566zm.645 1.132L8.613 5.456zm.417-.317l1.072-.815za.27.27 0 0 1 .192.073l.371.371l.007.007a2.05 2.05 0 0 1 .313 2.517a23.1 23.1 0 0 1-6.253 6.251a2.05 2.05 0 0 1-2.52-.273l-.37-.37a.277.277 0 0 1-.001-.375L4.87 9.856a.267.267 0 0 1 .364 0l.001.001c.587.58 1.548.58 2.134 0l.003-.002l2.5-2.501l.003-.003c.58-.586.58-1.548 0-2.134l-.001-.002a.267.267 0 0 1 0-.363l.007-.008l1.266-1.315zm0 0l-.417.317l.238-.247a.27.27 0 0 1 .179-.07M8.613 5.456L4.304 8.73a1.52 1.52 0 0 1 1.812.24c.1.097.275.097.375 0l2.497-2.5a.277.277 0 0 0 0-.375l.444-.44l-.443.441a1.5 1.5 0 0 1-.376-.64\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIncomingCallSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.4 5.995a.75.75 0 0 1-.69.461H2.442a.75.75 0 0 1-.53-1.28l1.102-1.103L.512 1.571a.75.75 0 1 1 1.06-1.06l2.503 2.502L5.177 1.91a.75.75 0 0 1 1.28.53v3.266q0 .155-.057.29m.337 7.284a2.7 2.7 0 0 1-3.37-.36l-.38-.38a.91.91 0 0 1 0-1.28l1.6-1.59a.9.9 0 0 1 1.27 0a.91.91 0 0 0 1.28 0l2.55-2.55a.91.91 0 0 0 0-1.28a.9.9 0 0 1 0-1.27l1.54-1.6a.91.91 0 0 1 1.28 0l.38.38a2.7 2.7 0 0 1 .41 3.37a24.2 24.2 0 0 1-6.56 6.56\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIndustryInnovationAndInfrastructure: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.65 11.694v-3.62l3.167-1.357l3.167 1.358v3.619L3.817 13.05z\"/><path d=\"m.65 8.067l3.167 1.357l3.167-1.357M3.817 3.122L6.983 4.48l3.167-1.357\"/><path d=\"m6.983 8.067l3.167 1.357l3.167-1.357\"/><path d=\"M3.819 6.715v-3.62l3.166-1.357l3.167 1.357v3.62L6.985 8.072zm3.164 4.979v-3.62l3.167-1.357l3.167 1.358v3.619L10.15 13.05zM3.817 9.426v3.625m6.335-3.625v3.625M6.983 4.48v3.624\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIndustryInnovationAndInfrastructureRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.72.941a.63.63 0 0 1 .56 0l2.994 1.497a.62.62 0 0 1 .351.575v3.1l2.649 1.325a.62.62 0 0 1 .351.575V11.5a.63.63 0 0 1-.345.559l-3 1.5a.63.63 0 0 1-.56 0L7 12.199l-2.72 1.36a.63.63 0 0 1-.56 0l-3-1.5a.63.63 0 0 1-.345-.559V8.013a.62.62 0 0 1 .351-.575l2.65-1.324V3.013a.62.62 0 0 1 .35-.575zm-5.095 8.07l2.096 1.048a.63.63 0 0 0 .559 0l2.095-1.048v2.103L4 12.3l-2.375-1.187zm6 2.103V9.01l2.096 1.048a.63.63 0 0 0 .559 0l2.095-1.048v2.103L10 12.3zm-3-7.103v2.103L7 7.3l2.375-1.187V4.01L7.28 5.06a.63.63 0 0 1-.56 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIndustryInnovationAndInfrastructureSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.207.478a.5.5 0 0 0-.414 0L4.17 1.672L6.998 2.96l2.83-1.289zM3.7 5.61V2.556l2.8 1.275v3.375L3.991 6.065a.5.5 0 0 1-.293-.455m3.8 6.712v-3.34l2.652 1.208v3.375l-2.506-1.141a.5.5 0 0 1-.147-.102m3.652 1.245V10.19l2.803-1.276v3.055a.5.5 0 0 1-.293.455zM6.498 8.982v3.344a.5.5 0 0 1-.143.098l-2.51 1.143V10.19zM2.845 10.19v3.375L.34 12.424a.5.5 0 0 1-.293-.455V8.915zm4.653-2.982V3.83l2.803-1.276V5.61a.5.5 0 0 1-.293.455zm2.948-.37a.5.5 0 0 1 .414 0l2.62 1.192l-2.83 1.289L7.825 8.03zm-7.306 0a.5.5 0 0 1 .414 0l2.62 1.192l-2.829 1.29L.518 8.03z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13M5.5 10h3\"/><path d=\"M7 10V6.5H6m1-2.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 5a1 1 0 1 1 0-2a1 1 0 0 1 0 2M5.25 6.5A.75.75 0 0 1 6 5.75h1a.75.75 0 0 1 .75.75v2.75h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-2H6a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M5.5 9.375a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25h-.875V6.5A.625.625 0 0 0 7 5.875H6a.625.625 0 1 0 0 1.25h.375v2.25zM8 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationDesk: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.901 4.317v1.364M9.9 2.662a.124.124 0 0 1-.124-.125c0-.07.056-.125.124-.125m.002.25a.125.125 0 0 0 .124-.125a.124.124 0 0 0-.124-.125M.857 12.864h12.007M1.989 6.829a1.939 1.939 0 1 0 3.878 0a1.939 1.939 0 1 0-3.878 0\"/><path d=\"M.855 12.865v-1.024a3.072 3.072 0 1 1 6.145 0v1.024m.394-6.149A3.554 3.554 0 1 0 6.33 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationDeskCustomer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.284 3.503a1.621 1.621 0 1 0 3.242 0a1.621 1.621 0 1 0-3.242 0\"/><path d=\"M8.473 8.367v-.81a2.432 2.432 0 0 1 4.865 0v.81M6.6 8.369h6.738M3.604 5.612a1.712 1.712 0 1 0 0-3.425a1.712 1.712 0 0 0 0 3.425\"/><path d=\"M6.6 8.609a2.996 2.996 0 1 0-5.993 0v1.284h1.285l.428 3.424h2.568l.428-3.424H6.6z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationDeskCustomerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 2.625a1.375 1.375 0 1 1 2.75 0a1.375 1.375 0 0 1-2.75 0m4 0a2.62 2.62 0 0 1-.752 1.84A4 4 0 0 1 8 8v1.375c0 .345-.28.625-.625.625H6.302l-.432 3.453a.625.625 0 0 1-.62.547h-2.5a.625.625 0 0 1-.62-.547L1.698 10H.625A.625.625 0 0 1 0 9.375V8a4 4 0 0 1 2.127-3.535a2.625 2.625 0 1 1 4.498-1.84M10.5 1.25a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-2.25 1a2.25 2.25 0 1 1 3.968 1.453c1.063.6 1.78 1.74 1.78 3.047c0 .345-.28.625-.625.625H9.5a.625.625 0 1 1 0-1.25h3.16a2.25 2.25 0 0 0-3.623-1.081a.625.625 0 1 1-.815-.949q.26-.223.56-.392A2.24 2.24 0 0 1 8.25 2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationDeskCustomerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.918 1.623a1.623 1.623 0 1 1-3.246 0a1.623 1.623 0 0 1 3.246 0m1.024 5.037a.75.75 0 0 1-.732.586H7.098a.75.75 0 1 1 0-1.5h1.596A2.706 2.706 0 0 1 14 6.493a.27.27 0 0 1-.058.167M1.359 3.324a1.811 1.811 0 1 0 3.622 0a1.811 1.811 0 0 0-3.622 0M0 9.019a3.17 3.17 0 1 1 6.34 0v.858a.5.5 0 0 1-.5.5h-.86l-.398 3.185a.5.5 0 0 1-.496.438H2.253a.5.5 0 0 1-.496-.438l-.399-3.185H.5a.5.5 0 0 1-.5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationDeskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.625 1.25a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m-.75 2.25c0-.345.28-.625.625-.625h1c.345 0 .625.28.625.625v2.375H13a.625.625 0 1 1 0 1.25h-3a.625.625 0 1 1 0-1.25h.875v-1.75H10.5a.625.625 0 0 1-.625-.625m-6 2.875a1.375 1.375 0 1 1 2.75 0a1.375 1.375 0 0 1-2.75 0M5.25 3.75a2.625 2.625 0 1 0 0 5.25a2.625 2.625 0 0 0 0-5.25m-4.198 8.625a4.501 4.501 0 0 1 8.395 0h3.928a.625.625 0 1 1 0 1.25H.625a.625.625 0 1 1 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInformationDeskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.09 2.735a3.686 3.686 0 0 1 1.316 4.653A4.054 4.054 0 1 0 6.09 2.735m3.791 1.066c.345 0 .625.28.625.625v1.795a.625.625 0 0 1-1.25 0V4.426c0-.345.28-.625.625-.625m-.733-1.58c0 .471.39.678.665.708l.07.004c.273 0 .734-.2.734-.712c0-.472-.39-.679-.665-.709l-.07-.004c-.273 0-.734.2-.734.713M4.065 8.259a2.44 2.44 0 1 0 0-4.879a2.44 2.44 0 0 0 0 4.879M0 13.137a4.065 4.065 0 0 1 8.075-.673h5.157a.75.75 0 0 1 0 1.5H.77a.75.75 0 0 1-.748-.698a.4.4 0 0 1-.021-.129Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInputBox: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.5 5H13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H7.5m-5 0H1a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 1 5h1.5M4 2.5h2m-2 9h2m-1-9v9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInputBoxRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 1c0-.483.392-.875.875-.875h3a.875.875 0 1 1 0 1.75h-.625v10.25H6.5a.875.875 0 0 1 0 1.75h-3a.875.875 0 0 1 0-1.75h.625V1.875H3.5A.875.875 0 0 1 2.625 1M0 5c0-.897.728-1.625 1.625-1.625h.75a.625.625 0 1 1 0 1.25h-.75A.375.375 0 0 0 1.25 5v4c0 .207.168.375.375.375h.75a.625.625 0 1 1 0 1.25h-.75A1.625 1.625 0 0 1 0 9zm7.625-1.625a.625.625 0 1 0 0 1.25h4.75c.207 0 .375.168.375.375v4a.375.375 0 0 1-.375.375h-4.75a.625.625 0 1 0 0 1.25h4.75C13.273 10.625 14 9.897 14 9V5c0-.897-.727-1.625-1.625-1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInputBoxSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 1.75a.75.75 0 0 0 0 1.5h.25v7.5H4a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-.25v-7.5H6a.75.75 0 0 0 0-1.5zM3 4.5H1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2zm4 5h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H7z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertCloudVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m5.344 7.948l3.875 2.422l-3.875 2.422z\"/><path d=\"M3.353 10.365a2.67 2.67 0 1 1 0-5.33q.225-.015.45 0a3.43 3.43 0 0 1 6.71 0q.23-.015.46 0a2.67 2.67 0 0 1 0 5.33\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertCloudVideoRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.004.674a4.427 4.427 0 0 1 6.722 3.073a3.309 3.309 0 0 1 .375 6.137a.625.625 0 1 1-.532-1.131a2.06 2.06 0 0 0 1.169-1.631a2.06 2.06 0 0 0-1.61-2.245a.87.87 0 0 1-.613-.739a3.177 3.177 0 0 0-6.167-.747a.85.85 0 0 1-.772.546a2.513 2.513 0 0 0-1.468 4.398a2.47 2.47 0 0 0 1.165.55a.625.625 0 1 1-.242 1.226a3.7 3.7 0 0 1-1.746-.835A3.763 3.763 0 0 1 3.27 2.712A4.43 4.43 0 0 1 5.004.674m.811 6.902A.5.5 0 0 0 5.05 8v5.5a.5.5 0 0 0 .765.424l4.4-2.75a.5.5 0 0 0 0-.848z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertCloudVideoSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.158 1.818A3.93 3.93 0 0 0 3.422 4.53l-.07.004a3.17 3.17 0 1 0 .016 6.33h.553V8.17c0-1.375 1.512-2.213 2.678-1.484l3.52 2.2c.708.442.959 1.266.751 1.979h.103l.03-.001a3.17 3.17 0 0 0-.108-6.334a3.93 3.93 0 0 0-3.737-2.712M9.68 10.47l.005-.025a.5.5 0 0 0-.23-.5l-3.519-2.2a.5.5 0 0 0-.765.425v4.4a.5.5 0 0 0 .765.423l3.52-2.2a.5.5 0 0 0 .224-.323\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertSide: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H8m5.5 3H8m5.5 3H8m5.5 6H8m5.5-3H8M.5 1.5v4A.5.5 0 0 0 1 6h4a.5.5 0 0 0 .5-.5v-4A.5.5 0 0 0 5 1H1a.5.5 0 0 0-.5.5m0 7v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4A.5.5 0 0 0 5 8H1a.5.5 0 0 0-.5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertSideRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.875.375a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5zm-1.5 8.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM8.5.375a.625.625 0 1 0 0 1.25H13a.625.625 0 1 0 0-1.25zM7.875 4c0-.345.28-.625.625-.625H13a.625.625 0 1 1 0 1.25H8.5A.625.625 0 0 1 7.875 4M8.5 6.375a.625.625 0 1 0 0 1.25H13a.625.625 0 1 0 0-1.25zM7.875 10c0-.345.28-.625.625-.625H13a.625.625 0 1 1 0 1.25H8.5A.625.625 0 0 1 7.875 10m.625 2.375a.625.625 0 1 0 0 1.25H13a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertSideSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.25.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5zM0 1.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm0 7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zM7.5 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5A.75.75 0 0 1 7.5 4m.75 2.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5zM7.5 10a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5A.75.75 0 0 1 7.5 10m.75 2.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertTopLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H9m4.5 3H9m4.5 3H9m4.5 6H.5m13-3H.5M6 1H1a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 1 7h5a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 6 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertTopLeftRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.103 1.103.375 2 .375h4c.897 0 1.625.728 1.625 1.625v4c0 .897-.728 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 6zM9.5.375a.625.625 0 1 0 0 1.25H13a.625.625 0 1 0 0-1.25zM8.875 4c0-.345.28-.625.625-.625H13a.625.625 0 1 1 0 1.25H9.5A.625.625 0 0 1 8.875 4M9.5 6.375a.625.625 0 1 0 0 1.25H13a.625.625 0 1 0 0-1.25zM.375 13c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 13M1 9.375a.625.625 0 1 0 0 1.25h12a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertTopLeftSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.25.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zM1 .5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zM8.5 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 8.5 4m.75 2.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zM0 10a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 10m.75 2.25a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertTopRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 1H5M.5 4H5M.5 7H5M.5 13h13m-13-3h13M8 7h5a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 13 1H8a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 8 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertTopRightRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.625 2c0-.897-.727-1.625-1.625-1.625H8c-.897 0-1.625.728-1.625 1.625v4c0 .897.728 1.625 1.625 1.625h4c.898 0 1.625-.728 1.625-1.625zM4.5.375a.625.625 0 1 1 0 1.25H1a.625.625 0 1 1 0-1.25zM5.125 4a.625.625 0 0 0-.625-.625H1a.625.625 0 1 0 0 1.25h3.5c.345 0 .625-.28.625-.625M4.5 6.375a.625.625 0 1 1 0 1.25H1a.625.625 0 1 1 0-1.25zM13.625 13a.625.625 0 0 0-.625-.625H1a.625.625 0 1 0 0 1.25h12c.345 0 .625-.28.625-.625M13 9.375a.625.625 0 1 1 0 1.25H1a.625.625 0 1 1 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsertTopRightSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.75.25a.75.75 0 1 0 0 1.5h4a.75.75 0 0 0 0-1.5zM8 .5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zM0 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 0 4m.75 2.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zM0 10a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 10m.75 2.25a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInstagram: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.333 3.644a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/><path d=\"M.858 3.431A2.573 2.573 0 0 1 3.431.858h6.862a2.573 2.573 0 0 1 2.573 2.573v6.862a2.573 2.573 0 0 1-2.573 2.573H3.43a2.573 2.573 0 0 1-2.573-2.573z\"/><path d=\"M4.312 6.862a2.55 2.55 0 1 0 5.1 0a2.55 2.55 0 1 0-5.1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInstagramRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 3.571A3.196 3.196 0 0 1 3.571.375h6.858a3.196 3.196 0 0 1 3.196 3.196v6.858a3.196 3.196 0 0 1-3.196 3.196H3.57a3.196 3.196 0 0 1-3.196-3.196zm3.196-1.946a1.946 1.946 0 0 0-1.946 1.946v6.858c0 1.075.871 1.946 1.946 1.946h6.858a1.946 1.946 0 0 0 1.946-1.946V3.57a1.946 1.946 0 0 0-1.946-1.946zm6.889 2.656a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75M7 3.951a3.05 3.05 0 1 0 0 6.099a3.05 3.05 0 0 0 0-6.1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInstagramSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.39.787A2.604 2.604 0 0 0 .786 3.39v6.944a2.604 2.604 0 0 0 2.604 2.604h6.944a2.604 2.604 0 0 0 2.603-2.604V3.39A2.604 2.604 0 0 0 10.334.787zm7.693 2.607a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m-4.22 1.388a2.08 2.08 0 1 0 0 4.16a2.08 2.08 0 0 0 0-4.16m-3.081 2.08a3.08 3.08 0 1 1 6.16 0a3.08 3.08 0 0 1-6.16 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsuranceHand: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.315 1.031a.5.5 0 0 0-.5.5v1.407H6.409a.5.5 0 0 0-.5.5v1.625a.5.5 0 0 0 .5.5h1.406v1.406a.5.5 0 0 0 .5.5H9.94a.5.5 0 0 0 .5-.5V5.563h1.406a.5.5 0 0 0 .5-.5V3.438a.5.5 0 0 0-.5-.5H10.44V1.53a.5.5 0 0 0-.5-.5zm-7.732 9.75l2.444 2.037a2 2 0 0 0 1.28.463h6.443c.46 0 .833-.373.833-.833c0-.92-.746-1.667-1.667-1.667H5.437\"/><path d=\"m3.583 9.781l.75.75a1.06 1.06 0 1 0 1.5-1.5L4.669 7.867a2 2 0 0 0-1.414-.586H.583\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsuranceHand1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.726.475c0-.262.213-.475.475-.475h2.098c.262 0 .475.213.475.475v1.751h1.751c.262 0 .475.213.475.475v2.098a.475.475 0 0 1-.475.475h-1.751v1.751a.475.475 0 0 1-.475.475H9.201a.475.475 0 0 1-.475-.475V5.274H6.975a.475.475 0 0 1-.475-.475V2.701c0-.262.213-.475.475-.475h1.751zM0 7.375c0-.345.28-.625.625-.625h2.672c.696 0 1.363.277 1.856.769l1.164 1.164c.425.425.576 1.021.452 1.567h3.19a2.29 2.29 0 0 1 2.291 2.292c0 .805-.653 1.458-1.458 1.458H4.349a2.63 2.63 0 0 1-1.68-.608L.225 11.355a.625.625 0 1 1 .8-.96L3.47 12.43c.247.206.558.319.88.319h6.443a.21.21 0 0 0 .208-.208c0-.576-.466-1.042-1.042-1.042H5.574a1.69 1.69 0 0 1-1.64-.433l-.75-.75a.625.625 0 1 1 .883-.884l.75.75a.44.44 0 0 0 .45.104l.007-.002a.435.435 0 0 0 .16-.718L4.268 8.403A1.38 1.38 0 0 0 3.297 8H.625A.625.625 0 0 1 0 7.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInsuranceHandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.906 1.531a.5.5 0 0 1 .5-.5h1.625a.5.5 0 0 1 .5.5v1.407h1.406a.5.5 0 0 1 .5.5v1.625a.5.5 0 0 1-.5.5h-1.406v1.406a.5.5 0 0 1-.5.5H8.406a.5.5 0 0 1-.5-.5V5.563H6.5a.5.5 0 0 1-.5-.5V3.438a.5.5 0 0 1 .5-.5h1.406zM1.843 7H0v4l1.828 1.828A4 4 0 0 0 4.657 14H10.5a1.5 1.5 0 0 0 0-3H7.723a2.11 2.11 0 0 1-3.515.892l-1.45-1.45a.625.625 0 1 1 .884-.884l1.45 1.45a.86.86 0 0 0 1.307-1.109L4.672 8.172A4 4 0 0 0 1.843 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAdd1ExpandCrossButtonsButtonMoreRemovePlusAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .54v13M.5 7h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAdd2RemoveBoldCrossButtonsButtonAddPlus: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6.5a1 1 0 0 0-1-1h-4v-4a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v4h-4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4h4a1 1 0 0 0 1-1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAddCircleButtonRemoveCrossAddButtonsPlusCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 4v6M4 7h6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAddSquareSquareRemoveCrossButtonsAddPlusButton: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4v6M4 7h6\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertAlarmBell1NotificationVibrateRingSoundAlarmAlertBellNoise: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 13.25h2m3-7.5a4 4 0 0 0-8 0v3.5a1.5 1.5 0 0 1-1.5 1.5h11a1.5 1.5 0 0 1-1.5-1.5ZM.5 5.62A6 6 0 0 1 3 .75m10.5 4.87A6 6 0 0 0 11 .75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertAlarmBell2AlertBellRingNotificationAlarm: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5a4.29 4.29 0 0 1 4.29 4.29c0 4.77 1.74 5.71 2.21 5.71H.5c.48 0 2.21-.95 2.21-5.71A4.29 4.29 0 0 1 7 .5ZM5.5 12.33a1.55 1.55 0 0 0 3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertAlarmBellOffDisableSilentNotificationOffSilenceAlarmBellAlert: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13M6 13.5h2M8.73.84A4.51 4.51 0 0 0 2.5 5v2.5M3 11h10.5a2 2 0 0 1-2-2V5a4.42 4.42 0 0 0-.5-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertInformationCircleInformationFrameInfoMoreHelpPointCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 7v3.5\"/><circle cx=\"7\" cy=\"4.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertRadioActive1DangerNukeRadiationNuclearWarningAlertRadioactiveCaution: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 4.83L3.75.94A6.49 6.49 0 0 0 .5 6.56H5a2 2 0 0 1 1-1.73Zm3 1.73h4.5A6.49 6.49 0 0 0 10.25.94L8 4.83a2 2 0 0 1 1 1.73Zm-2 2a2 2 0 0 1-1-.26l-2.25 3.89a6.51 6.51 0 0 0 6.5 0L8 8.3a2 2 0 0 1-1 .26Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertRadioActive2WarningRadioactiveRadiationEmergencyDangerSafety: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.92 1.25a3.2 3.2 0 1 1-3.84 0\"/><path d=\"M.5 9.17a3.2 3.2 0 1 1 1.92 3.32\"/><path d=\"M11.58 12.49a3.19 3.19 0 1 1 1.92-3.32\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertRadioActive3WarningRadioactiveRadiationEmergencyDangerSafety: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7.49\" r=\"3.5\"/><path d=\"M9.35 1.31a3.32 3.32 0 1 1-4.7 0\"/><path d=\"M.5 8.5a3.32 3.32 0 1 1 2.35 4.07\"/><path d=\"M11.15 12.57A3.32 3.32 0 1 1 13.5 8.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertWarningCircleWarningAlertFrameExclamationCautionCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 3.5v3\"/><circle cx=\"7\" cy=\"9.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertWarningDiamondDiamondAlertWarningFrameExclamationCaution: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 3.5v3\"/><circle cx=\"7\" cy=\"9.5\" r=\".5\"/><rect width=\"9.82\" height=\"9.82\" x=\"2.09\" y=\"2.09\" rx=\"1.07\" transform=\"rotate(-45 7 7)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlertWarningTriangleFrameAlertWarningTriangleExclamationCaution: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 5v3\"/><circle cx=\"7\" cy=\"11\" r=\".5\"/><path d=\"M7.89 1.05a1 1 0 0 0-1.78 0l-5.5 11a1 1 0 0 0 .89 1.45h11a1 1 0 0 0 .89-1.45Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignBackBackDesignLayerLayersPileStack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10.5\" height=\"10.5\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M13.5 3.5v9a1 1 0 0 1-1 1h-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignFrontDesignFrontLayerLayersPileStack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10.5\" height=\"10.5\" x=\"3\" y=\"3\" rx=\"1\" transform=\"rotate(180 8.25 8.25)\"/><path d=\"M.5 10.5v-9a1 1 0 0 1 1-1h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignHorizontalCenterAlignCenterDesign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"7\" height=\"4\" x=\"3.5\" y=\".5\" rx=\"1\"/><rect width=\"11\" height=\"4\" x=\"1.5\" y=\"9.5\" rx=\"1\"/><path d=\"M7 4.5v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignHorizontalLeftAlignDesignLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5.5v13\"/><rect width=\"6.5\" height=\"4\" x=\"3\" y=\"1.5\" rx=\"1\"/><rect width=\"10.5\" height=\"4\" x=\"3\" y=\"8.5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignHorizontalRightAlignDesignRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5.5v13\"/><rect width=\"6.5\" height=\"4\" x=\"4.5\" y=\"1.5\" rx=\"1\" transform=\"rotate(180 7.75 3.5)\"/><rect width=\"10.5\" height=\"4\" x=\".5\" y=\"8.5\" rx=\"1\" transform=\"rotate(180 5.75 10.5)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignLayers1DesignLayerLayersPileStack: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.47 6.9a1.18 1.18 0 0 1-.94 0L.83 4.26a.56.56 0 0 1 0-1L6.53.6a1.18 1.18 0 0 1 .94 0l5.7 2.64a.56.56 0 0 1 0 1Zm6.03.45l-6.1 2.81a1 1 0 0 1-.83 0L.5 7.35m13 3.25l-6.1 2.81a1 1 0 0 1-.83 0L.5 10.6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignLayers2DesignLayerLayersPileStack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8\" height=\"6\" x=\"5.5\" y=\"1.5\" rx=\"1\"/><path d=\"M11 10H4a1 1 0 0 1-1-1V4\"/><path d=\"M9 12.5H1.5a1 1 0 0 1-1-1V6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignVerticalBottomAlignDesignBottom: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 13.5H.5\"/><rect width=\"6.5\" height=\"4\" x=\"7.25\" y=\"5.75\" rx=\"1\" transform=\"rotate(-90 10.5 7.75)\"/><rect width=\"10.5\" height=\"4\" x=\"-1.75\" y=\"3.75\" rx=\"1\" transform=\"rotate(-90 3.5 5.75)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignVerticalCenterAlignDesignMiddle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8\" height=\"4\" x=\"7.5\" y=\"5.5\" rx=\"1\" transform=\"rotate(90 11.5 7.5)\"/><rect width=\"11\" height=\"4\" x=\"-3\" y=\"5\" rx=\"1\" transform=\"rotate(90 2.5 7)\"/><path d=\"M9.5 7h-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAlignVerticalTopAlignDesignTop: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5.5H.5\"/><rect width=\"6.5\" height=\"4\" x=\"7.25\" y=\"4.25\" rx=\"1\" transform=\"rotate(90 10.5 6.25)\"/><rect width=\"10.5\" height=\"4\" x=\"-1.75\" y=\"6.25\" rx=\"1\" transform=\"rotate(90 3.5 8.25)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendDownLeft1ArrowBendCurveChangeDirectionLeftToDown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.75 11l2.5 2.5l2.5-2.5\"/><path d=\"M11.25.5h-5a1 1 0 0 0-1 1v12\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendDownLeft2ArrowBendCurveChangeDirectionDownToLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.5 11.5l-3-3l3-3\"/><path d=\"M13.5 2.5v2a4 4 0 0 1-4 4h-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendDownRight2ArrowBendCurveChangeDirectionDownToRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10.5 11.5l3-3l-3-3\"/><path d=\"M.5 2.5v2a4 4 0 0 0 4 4h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendLeft1ArrowBendCurveChangeDirectionUpToLeftBack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 2.75L.5 5.25L3 7.75\"/><path d=\"M13.5 11.25v-5a1 1 0 0 0-1-1H.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendRight1ArrowBendCurveChangeDirectionUpToRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11 2.75l2.5 2.5l-2.5 2.5\"/><path d=\"M.5 11.25v-5a1 1 0 0 1 1-1h12\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendUpLeft1ArrowBendCurveChangeDirectionLeftToUp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.75 3L5.25.5L7.75 3\"/><path d=\"M11.25 13.5h-5a1 1 0 0 1-1-1V.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendUpLeft2ArrowBendCurveChangeDirectionLeftToUp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.5 3.5l3-3l3 3\"/><path d=\"M11.5 13.5h-2a4 4 0 0 1-4-4v-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendUpLeft3ArrowBendCurveChangeDirectionUpToLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.5 2.5l-3 3l3 3\"/><path d=\"M13.5 11.5v-2a4 4 0 0 0-4-4h-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendUpRight1ArrowBendCurveChangeDirectionRightToUp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5 3.5l-3-3l-3 3\"/><path d=\"M2.5 13.5h2a4 4 0 0 0 4-4v-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendUpRight2ArrowBendCurveChangeDirectionUpToRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10.5 2.5l3 3l-3 3\"/><path d=\"M.5 11.5v-2a4 4 0 0 1 4-4h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonDownArrowDownKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 3.85L6.65 10a.48.48 0 0 0 .7 0l6.15-6.15\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonDownDoubleArrowArrowsDoubleDown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.5 6.46l6.15 6.14a.48.48 0 0 0 .7 0l6.15-6.14\"/><path d=\"M.5 1.25L6.65 7.4a.5.5 0 0 0 .7 0l6.15-6.15\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonLeftArrowKeyboardLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.15.5L4 6.65a.48.48 0 0 0 0 .7l6.15 6.15\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonLeftDoubleArrowArrowsDoubleLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.54.5L1.4 6.65a.48.48 0 0 0 0 .7l6.14 6.15\"/><path d=\"M12.75.5L6.6 6.65a.5.5 0 0 0 0 .7l6.15 6.15\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonRightArrowRightKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.85.5L10 6.65a.48.48 0 0 1 0 .7L3.85 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonRightDuobleArrowArrowsDoubleRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m6.46.5l6.14 6.15a.48.48 0 0 1 0 .7L6.46 13.5\"/><path d=\"M1.25.5L7.4 6.65a.5.5 0 0 1 0 .7L1.25 13.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonToBottomArrowDownLineToBottom: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 5.71l6.15 6.14a.48.48 0 0 0 .7 0l6.15-6.14M.5 2h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonToLeftArrowLineToLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.29.5L2.15 6.65a.48.48 0 0 0 0 .7l6.14 6.15M12 .5v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonToRightArrowLineToRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.71.5l6.14 6.15a.48.48 0 0 1 0 .7L5.71 13.5M2 .5v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonToTopArrowUpLineToTop: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 8.29l6.15-6.14a.48.48 0 0 1 .7 0l6.15 6.14M.5 12h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonUpArrowUpKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 10.15L6.65 4a.48.48 0 0 1 .7 0l6.15 6.15\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonUpDoubleArrowArrowsDoubleUp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7.54L6.65 1.4a.48.48 0 0 1 .7 0l6.15 6.14\"/><path d=\"M.5 12.75L6.65 6.6a.5.5 0 0 1 .7 0l6.15 6.15\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsButtonZigzagBothDirectionArrowCurvyDiagramZigzagVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 11L3 13.5v-11a2 2 0 0 1 4 0v9a2 2 0 0 0 4 0V.5L13.5 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCornerDownLeftDownKeyboardArrowLeftBottom: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5.5l-13 13m5 0h-5v-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCornerDownRightDownKeyboardArrowRightBottom: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13m-5 0h5v-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCornerUpLeftKeyboardTopArrowLeftUp: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5L.5.5m5 0h-5v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCornerUpRightKeyboardTopArrowRightUp: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13m-5 0h5v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCurvyBothDirection1BothDirectionArrowCurvyDiagramZigzagHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 .5L13.5 3h-12a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H.5L3 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCurvyBothDirection2BothDirectionArrowCurvyDiagramZigzagHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 .5L.5 3h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h12L11 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCurvyLeftSnakeArrowSidewaysDiagramLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5.75h-12a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h11a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H.5\"/><path d=\"m3 8.25l-2.5 2.5l2.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCurvyRightSnakeArrowSidewaysDiagramRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5.75h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-11a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12\"/><path d=\"m11 8.25l2.5 2.5l-2.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDataTransferDiagonalSquareArrowSquareDataDiagonalInternetTransferNetwork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"m4 8l4.5-4.5H5M10 6l-4.5 4.5H9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDataTransferHorizontalArrowSquareDataInternetTransferNetworkHorizontal: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"m6 10.5l-2-2h6m-2-5l2 2H4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDataTransferVerticalArrowSquareDataInternetTransferNetworkVertical: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"m10.5 8l-2 2V4m-5 2l2-2v6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDataTrasnferVerticalArrowServerArrowsDataVerticalInternetTransferNetwork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m2.5 3.5l3-3v13m6-3l-3 3V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDiagonal1ExpandSmallerRetractBiggerBigSmallDiagonal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13m-4 0h4v4m-9 9h-4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDiagonal2ExpandSmallerRetractBiggerBigSmallDiagonal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.5.5h-4v4m0-4l13 13m-4 0h4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDiagonalArrowsArrowServerDataDiagonalInternetTransferNetwork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.5 8.5l8-8m0 3.5V.5h0H6m6.5 5l-8 8m0-3.5v3.5H8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDiagonalScrollPoint1MoveScroll: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><path d=\"M9 .5h4a.5.5 0 0 1 .5.5v4M5 13.5H1a.5.5 0 0 1-.5-.5V9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDiagonalScrollPoint2MoveScroll: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><path d=\"M5 .5H1a.5.5 0 0 0-.5.5v4M9 13.5h4a.5.5 0 0 0 .5-.5V9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDownArrowDownKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13m3.5-3.5L7 13.5L3.5 10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDownCircle1ArrowKeyboardCircleButtonDown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4v6M5.5 8.5L7 10l1.5-1.5\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDownCircle2ArrowKeyboardCircleButtonDown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 6L7 9L4 6\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDownleftCornerArrowCornerDownLeftDownleft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5h-12a1 1 0 0 1-1-1V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDownrightCornerArrowCornerDownRightDownright: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5v12a1 1 0 0 1-1 1H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpand2ExpandSmallerRetractBiggerBigSmallDiagonal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.5 5.5l-5-5m4 0h-4v4m8 4l5 5m-4 0h4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpand3ExpandSmallerRetractBiggerBigSmallDiagonal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m8.5 5.5l5-5m-4 0h4v4m-8 4l-5 5m4 0h-4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpand4ExpandSmallBiggerRetractSmallerBig: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"10\" x=\"3.5\" y=\".5\" rx=\"1\" transform=\"rotate(180 8.5 5.5)\"/><path d=\"M10.5 13.5h-9a1 1 0 0 1-1-1v-9m7 0h3v3m0-3l-4 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpandDiagonal1ExpandResizeBiggerDiagonalSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 5L13.5.5m-4 0h4v4M5 9L.5 13.5m4 0h-4v-4M4 4l6 6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpandDiagonal2ExpandResizeBiggerDiagonalSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 5L.5.5m4 0h-4v4M9 9l4.5 4.5m-4 0h4v-4M10 4l-6 6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpandVerticalDiamondArrowDiamondDataVerticalDataInternetTransferNetwork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"9.82\" height=\"9.82\" x=\"2.09\" y=\"2.09\" rx=\"1.07\" transform=\"rotate(-45 7 7)\"/><path d=\"M5.5 5.5L7 4l1.5 1.5m-3 3L7 10l1.5-1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsHorizonalScrollPointMoveScrollHorizonal: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.48 3.87L.61 6.74a.36.36 0 0 0 0 .52l2.87 2.87m7.04-6.26l2.87 2.87a.36.36 0 0 1 0 .52l-2.87 2.87\"/><circle cx=\"7\" cy=\"7\" r=\"1.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsHorizontalExpandExpandResizeBiggerHorizontalSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 7h-9M5 4.5L2.5 7L5 9.5m4-5L11.5 7L9 9.5M.5.5v13m13-13v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsHorizontalExpandResizeBiggerHorizontalSmallSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7H.5m3-3l-3 3l3 3m7-6l3 3l-3 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsHorizontalUpDownExpandResizeBiggerVerticalSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.13 3.48L7.26.61a.36.36 0 0 0-.52 0L3.87 3.48m6.26 7.04l-2.87 2.87a.36.36 0 0 1-.52 0l-2.87-2.87M.5 7h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsLeftArrowKeyboardLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7H.5M4 3.5L.5 7L4 10.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsLeftCircle1ArrowKeyboardCircleButtonLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 7H4m1.5-1.5L4 7l1.5 1.5\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsLeftCircle2ArrowKeyboardCircleButtonLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 4L5 7l3 3\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsLoopArrowDiagramLoopInfinityRepeat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 10.43a2.37 2.37 0 0 1-1.5.57a2.75 2.75 0 0 1-3-3a2.75 2.75 0 0 1 3-3c2.75 0 4.25 6 7 6a2.75 2.75 0 0 0 3-3a2.75 2.75 0 0 0-3-3h-2l2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveDownMoveDownArrows: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 7.5v6M4.5 11L7 13.5L9.5 11\"/><rect width=\"4.5\" height=\"13\" x=\"4.75\" y=\"-3.75\" rx=\"1\" transform=\"rotate(-90 7 2.75)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveHorizontalCircleTransferDataInternetArrowHorizontalNetworkCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m6 10.5l-2-2h6m-2-5l2 2H4\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveLeftDownExpandResizeBiggerCornerSmallSmallerSizeArrowArrowsBig: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.5.5l-2 2l2 2\"/><path d=\"M11.5 13.5v-10a1 1 0 0 0-1-1H.5\"/><path d=\"m9.5 11.5l2 2l2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveLeftMoveLeftArrows: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 7h-6M3 4.5L.5 7L3 9.5\"/><rect width=\"4.5\" height=\"13\" x=\"9\" y=\".5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveLeftUpExpandResizeBiggerCornerSmallSmallerSizeArrowArrowsBig: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.5 13.5l-2-2l2-2\"/><path d=\"M11.5.5v10a1 1 0 0 1-1 1H.5\"/><path d=\"m9.5 2.5l2-2l2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveRightDownExpandResizeBiggerCornerSmallSmallerSizeArrowArrowsBig: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5.5l2 2l-2 2\"/><path d=\"M2.5 13.5v-10a1 1 0 0 1 1-1h10\"/><path d=\"m4.5 11.5l-2 2l-2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveRightMoveRightArrows: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.5 7h6M11 4.5L13.5 7L11 9.5\"/><rect width=\"4.5\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(-180 2.75 7)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveRightUpExpandResizeBiggerCornerSmallSmallerSizeArrowArrowsBig: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.5 2.5l2-2l2 2\"/><path d=\"M13.5 11.5h-10a1 1 0 0 1-1-1V.5\"/><path d=\"m11.5 9.5l2 2l-2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsMoveUpMoveUpArrows: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 6.5v-6M9.5 3L7 .5L4.5 3\"/><rect width=\"4.5\" height=\"13\" x=\"4.75\" y=\"4.75\" rx=\"1\" transform=\"rotate(90 7 11.25)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsRightArrowRightKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7h13M10 10.5L13.5 7L10 3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsRightCircle1ArrowKeyboardCircleButtonRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 7h6M8.5 5.5L10 7L8.5 8.5\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsRightCircle2ArrowKeyboardCircleButtonRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m6 4l3 3l-3 3\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsShrink4ExpandRetractShrinkBiggerBigSmallSmaller: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"10\" x=\"3.5\" y=\".5\" rx=\"1\" transform=\"rotate(180 8.5 5.5)\"/><path d=\"M10.5 13.5h-9a1 1 0 0 1-1-1v-9m9 4h-3v-3m0 3l4-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsShrinkVerticalMoveVerticalShrink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.25 13.5L6.74 9a.37.37 0 0 1 .52 0l4.49 4.49M2.25.5L6.74 5a.37.37 0 0 0 .52 0L11.75.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsSplitVerticalUpMergeArrowDiagram: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m10 3.5l-3-3l-3 3m7 10a4 4 0 0 1-4-4a4 4 0 0 1-4 4m4-4v-9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsSynchronizeArrowsLoadingLoadSyncSynchronizeArrowReload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11 9l2-.5l.5 2\"/><path d=\"M13 8.5A6.76 6.76 0 0 1 7 13h0a6 6 0 0 1-5.64-3.95M3 5l-2 .5l-.5-2\"/><path d=\"M1 5.5C1.84 3.2 4.42 1 7 1h0a6 6 0 0 1 5.64 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsSynchronizeWarningArrowFailNotificationSyncWarningFailureSynchronizeError: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11 9l2-.5l.5 2\"/><path d=\"M13 8.5A6.6 6.6 0 0 1 7 13h0a6 6 0 0 1-5.64-3.95M3 5l-2 .5l-.5-2\"/><path d=\"M1 5.5A6.79 6.79 0 0 1 7 1h0a6 6 0 0 1 5.64 4M7 3.5v4\"/><circle cx=\"7\" cy=\"10\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsTopMoveUpArrowArrows: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4 7.5l3-3l3 3m-3 6v-9M3.5.5h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsTriangleLoopDiagramTriangleLoopArrowArrows: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.5 13.5L4 11h8.5m1-7l-1 3.5L8 .5m-6 3h3.5l-5 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsTurnBackwardArrowBendCurveChangeDirectionReturnLeftBackBackward: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.5 1.5l-3 3l3 3\"/><path d=\"M.5 4.5h9a4 4 0 0 1 0 8h-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsTurnDownArrowBendCurveChangeDirectionReturnDown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m1.5 10.5l3 3l3-3\"/><path d=\"M4.5 13.5v-9a4 4 0 0 1 8 0v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsTurnForwardArrowBendCurveChangeDirectionReturnRightNextForward: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10.5 1.5l3 3l-3 3\"/><path d=\"M13.5 4.5h-9a4 4 0 0 0 0 8h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsTurnUpArrowBendCurveChangeDirectionReturnUp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m12.5 3.5l-3-3l-3 3\"/><path d=\"M9.5.5v9a4 4 0 0 1-8 0v-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsUpCircle1ArrowUpKeyboardCircleButton: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 10V4M5.5 5.5L7 4l1.5 1.5\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsUpCircle2ArrowKeyboardCircleButtonUp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4 8l3-3l3 3\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsUpleftCornerArrowCornerUpLeftUpleft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5h-12a1 1 0 0 0-1 1v12\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsUprightCornerArrowUpRightUprightCorner: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5.5h12a1 1 0 0 1 1 1v12\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsVerticalExpand1MoveExpandVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.25 5.1L6.74.61a.36.36 0 0 1 .52 0l4.49 4.49m-9.5 3.8l4.49 4.49a.36.36 0 0 0 .52 0l4.49-4.49\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsVerticalExpand2ExpandResizeBiggerVerticalSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 11.5v-9M9.5 5L7 2.5L4.5 5m5 4L7 11.5L4.5 9m9-8.5H.5m13 13H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsVerticalExpandResizeBiggerVerticalSmallSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5V.5m3 3l-3-3l-3 3m6 7l-3 3l-3-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsVerticalScrollPointMoveScrollVertical: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.13 3.48L7.26.61a.36.36 0 0 0-.52 0L3.87 3.48m6.26 7.04l-2.87 2.87a.36.36 0 0 1-.52 0l-2.87-2.87\"/><circle cx=\"7\" cy=\"7\" r=\"1.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAwardCrownRewardSocialRatingMediaQueenVipKingCrown: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 4l-3 3L7 2L3.5 7l-3-3v6.5A1.5 1.5 0 0 0 2 12h10a1.5 1.5 0 0 0 1.5-1.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAwardHalfStarRewardRatingRateSocialStarMediaFavoriteLikeStarsHalf: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.25.5a.54.54 0 0 0-.49.32L8.17 4.18a.52.52 0 0 1-.41.31L4.22 5a.58.58 0 0 0-.3 1l2.56 2.63a.58.58 0 0 1 .16.5L6 12.83a.56.56 0 0 0 .8.6l3.2-1.74a.59.59 0 0 1 .26-.07Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceAwardTrophyRewardRatingTrophySocialAwardMedia: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 8.5v5m-2.5 0h5m-6-8a3 3 0 0 1-3-3v-1H4v4Zm7 0a3 3 0 0 0 3-3v-1H10v4Z\"/><path d=\"M10 5.5a3 3 0 0 1-6 0v-5h6Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceBlockRemoveCircleGarbageTrashDelete: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"m2.4 11.6l9.2-9.2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceBookmarkBookmarksTagsFavorite: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11 13.5l-4-4l-4 4v-12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceBookmarkDoubleBookmarksDoubleTagsFavorite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9 13.5l-3.5-3l-3.5 3v-9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Z\"/><path d=\"M5 .5h6a1 1 0 0 1 1 1v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceBookmarkTagTagsBookmarkFavorite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m13.28 9.39l-3.89 3.89a.75.75 0 0 1-1.06 0L.61 5.56a.36.36 0 0 1-.11-.29l.59-3.83a.37.37 0 0 1 .35-.35L5.27.5a.36.36 0 0 1 .29.11l7.72 7.72a.75.75 0 0 1 0 1.06Z\"/><circle cx=\"4.11\" cy=\"4.11\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarAddAddCalendarDateDayMonth: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5m1 5.5h-5M7 5.5v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarBlankCalendarDateDayMonth: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-10 4h13m-10-6v4m7-4v4m-7-2h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarBlockBlockCalendarDateDayMonth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><circle cx=\"7\" cy=\"8.5\" r=\"3\"/><path d=\"m4.88 10.62l4.24-4.24\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarCheckApproveCalendarCheckDateDayMonthSuccess: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"m4 9l2 1.5l3.5-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarDateMonthThirtyThirtyCalendarDateWeekDayMonth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 6.5h1V11m-1 0h2\"/><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"M3.5 6.5H6l-1.5 2s1.5 0 1.5 1A1.33 1.33 0 0 1 4.5 11h-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarDateOneOneCalendarDateDayMonth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 6.5h1V11m-1.5 0h3\"/><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarDisableCalendarDateDayDeleteDisableMonthRemove: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5m.27 7.27L5.23 6.23m3.54 0L5.23 9.77\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarDownloadArrowCalendarDateDayDownDownloadMonth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"m5 9l2 2l2-2m-2 2V6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarFavoriteCalendarDateDayFavoriteLikeMonthStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"M6.45 5.37a.59.59 0 0 1 1.1 0L8.19 7H9.9a.6.6 0 0 1 .4 1L8.79 9.36l.64 1.28a.58.58 0 0 1-.12.69a.61.61 0 0 1-.7.1L7 10.55l-1.61.88a.61.61 0 0 1-.7-.1a.58.58 0 0 1-.12-.69l.64-1.28L3.7 8a.6.6 0 0 1 .4-1h1.71Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarHeartCalendarDateDayFavoriteHeartLikeMonth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"M7 7.5c1-2 3-1 3 .5c0 2-3 3-3 3s-3-1-3-3c0-1.5 2-2.5 3-.5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarHomeCalendarDateDayHomeHouseMonth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"m10 8.5l-3-3l-3 3\"/><path d=\"M5 7.5V11h4V7.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarLockCalendarDateDayLockMonthPadlockSecureSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"M5 8h4v3H5zm.5 0V7a1.5 1.5 0 0 1 3 0v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarMarkCalendarDateDayMonthMark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><circle cx=\"3.5\" cy=\"7.5\" r=\".5\"/><circle cx=\"7\" cy=\"7.5\" r=\".5\"/><circle cx=\"10.5\" cy=\"7.5\" r=\".5\"/><circle cx=\"3.5\" cy=\"10.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarRemoveCalendarDateDayDeleteMonthRemoveSubtract: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5m1 7.5h-5m-4-3.5h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarSettingCalendarCogDateDayGearLoadLoadingMonthSettingWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5m-1.53 2V6m-3.03.25l1.3.75m-1.3 2.75L5.24 9m1.73 2.5V10M10 9.75L8.7 9M10 6.25L8.7 7\"/><circle cx=\"6.97\" cy=\"8\" r=\"2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarUploadCalendarDateDayMonthPushUpArrowUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5\"/><path d=\"m5 8l2-2l2 2M7 6v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCalendarWarningAlterCalendarCautionDateDayMonthNotificationWarning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2m-7-2v4m7-4v4m-7-2h5M7 5v3\"/><circle cx=\"7\" cy=\"11\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentArchiveBoxContentBankerArchiveFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 5.54h11v7a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-7h0Z\"/><rect width=\"4\" height=\"13\" x=\"5\" y=\"-2.96\" rx=\"1\" transform=\"rotate(90 7 3.54)\"/><path d=\"M5.5 8.54h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentArchiveFolderOutboxContentFolderArchiveFileInbox: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 9.54a1 1 0 0 0-1-1h-3v1h-5v-1h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1Zm-12-4h11m-11-3h11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentArchiveLockerLockerContentArchiveFileCabinet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5.5h11a1 1 0 0 1 1 1v10a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-10a1 1 0 0 1 1-1ZM.5 7h13\"/><circle cx=\"7\" cy=\"3.5\" r=\".5\"/><circle cx=\"7\" cy=\"10\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentBook2LibraryContentBooksBookShelfStack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"3.5\" height=\"13\" x=\".55\" y=\".5\" rx=\".5\"/><rect width=\"3.5\" height=\"11\" x=\"4.05\" y=\"2.5\" rx=\".5\"/><rect width=\"3\" height=\"11\" x=\"9.26\" y=\"2.3\" rx=\".5\" transform=\"rotate(-14.05 10.779 7.795)\"/><path d=\"M.55 10h3.5m0-1h3.5m2.5 2l2.88-.72\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentBookContentBooksBookClose: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 13.54H3a1.5 1.5 0 0 1 0-3h8.5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H3A1.5 1.5 0 0 0 1.5 2v10m10-1.46v3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentBookEditPencilContentWriteNotebookBookEditCompositionCreation: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 13.5H1.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9m1.5 3l1.5-3l1.5 3V12a1.5 1.5 0 0 1-3 0Zm0 6h3m-10-9v13M6 4h2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentBookOpenContentBooksBookOpen: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5a9.26 9.26 0 0 0-5.61-2.95a1 1 0 0 1-.89-1V1.5A1 1 0 0 1 .85.74a1 1 0 0 1 .79-.23A9.3 9.3 0 0 1 7 3.43Zm0 0a9.26 9.26 0 0 1 5.61-2.95a1 1 0 0 0 .89-1V1.5a1 1 0 0 0-.35-.76a1 1 0 0 0-.79-.23A9.3 9.3 0 0 0 7 3.43Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentBookPagePagesContentBooksBookOpen: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 12.5a1 1 0 0 1-1.45.89l-4-2A1 1 0 0 1 2 10.5V.5l5.45 2.72a1 1 0 0 1 .55.9Z\"/><path d=\"M2 .5h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentChartProductDataAnalysisAnalyticsGraphLineBusinessBoardChart: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(180 7 7)\"/><path d=\"M3 3h2M3 5.5h4.5m4 0l-3 5l-3.5-2l-2 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentEyeGlassesVisionSunglassesProtectionSpectaclesCorrectionSunEyeGlasses: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 9h-5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1Zm8 0h-5v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1Zm-8 0h3m5 0V3a2 2 0 0 0-2-2h-1M.5 9V3a2 2 0 0 1 2-2h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentFileEmptyCommonFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5l5 5Z\"/><path d=\"M7.5.5v5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentFireLitFlameTorchTrending: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.15.53a.39.39 0 0 0-.4 0a.26.26 0 0 0-.06.34C6.92 3 7.18 5.9 5.5 7.5a5.52 5.52 0 0 1-1.5-2A3.89 3.89 0 0 0 2 9a4.7 4.7 0 0 0 5 4.5c3.22 0 4.89-2 5-4.5c.13-3-2-6.69-5.85-8.47Z\"/><path d=\"M9.5 9a2 2 0 0 1-2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentNotePadContentNotesBookNotepadNotebook: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 3.5v-3m3 3v-3m3 3v-3\"/><rect width=\"13\" height=\"11.5\" x=\".5\" y=\"2\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentNotePadTextContentNotesBookNotepadNotebook: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 3.5v-3m3 3v-3m3 3v-3\"/><rect width=\"13\" height=\"11.5\" x=\".5\" y=\"2\" rx=\"1\"/><path d=\"M3.5 7h7m-7 3h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceContentSaveDiskFloppyElectronicsDeviceDiscComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 12.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-9l3-3h9a1 1 0 0 1 1 1Z\"/><path d=\"M3.5 8.5h7v5h-7zm1-8h6v4h-6z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCursorArrow1MouseSelectCursor: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 10.5l-4-4l2-2a1 1 0 0 0-.5-1.68L1.74.53A1 1 0 0 0 .53 1.74L2.82 11a1 1 0 0 0 1.68.46l2-2l4 4Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCursorArrow2MouseSelectCursor: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.15 5.45a.5.5 0 0 0 0-1L1.83.56A1 1 0 0 0 .56 1.83L4.5 13.16a.5.5 0 0 0 1 0l2-5.66Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceCursorHandHandSelectCursorFinger: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 6.13a2 2 0 0 1 1.59 2.24l-.61 4.27a1 1 0 0 1-1 .86H4a1 1 0 0 1-.93-.63L2 10.21a2 2 0 0 1 1-2.53L4.35 7V2a1.5 1.5 0 0 1 3 0v3.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDashboardLayout1CornersDashboardFrameLayoutMatOctagonSquareTriangle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(180 7 7)\"/><path d=\"M.5 6.5L6 .5m7.5 6L8 .5m-7.5 7l5.5 6m7.5-6l-5.5 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDashboardLayout2CornersDashboardFrameLayoutCircleSquareCenter: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5.5h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m7 13h2a1 1 0 0 0 1-1v-2m-13 0v2a1 1 0 0 0 1 1h2\"/><circle cx=\"7\" cy=\"7\" r=\"3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDashboardLayout3AppApplicationDashboardHomeLayout: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5\" height=\"7\" x=\"8.5\" y=\"6.5\" rx=\".5\"/><rect width=\"5\" height=\"3.01\" x=\"8.5\" y=\".5\" rx=\".5\"/><rect width=\"5\" height=\"7\" x=\".5\" y=\".5\" rx=\".5\"/><rect width=\"5\" height=\"3.01\" x=\".5\" y=\"10.49\" rx=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDashboardLayoutCircleAppApplicationDashboardHomeLayoutCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"3.25\" cy=\"3.25\" r=\"2.75\"/><circle cx=\"10.75\" cy=\"3.25\" r=\"2.75\"/><circle cx=\"3.25\" cy=\"10.75\" r=\"2.75\"/><circle cx=\"10.75\" cy=\"10.75\" r=\"2.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDashboardLayoutSquareAppApplicationDashboardHomeLayoutSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5\" height=\"5\" x=\".5\" y=\".5\" rx=\"1\"/><rect width=\"5\" height=\"5\" x=\"8.5\" y=\".5\" rx=\"1\"/><rect width=\"5\" height=\"5\" x=\".5\" y=\"8.5\" rx=\"1\"/><rect width=\"5\" height=\"5\" x=\"8.5\" y=\"8.5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDelete2RemoveBoldAddButtonButtonsDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.19 3.05a1.06 1.06 0 0 0 0-1.49l-.75-.75a1.06 1.06 0 0 0-1.44 0L7 4.76L3.05.81a1.06 1.06 0 0 0-1.49 0l-.75.75a1.06 1.06 0 0 0 0 1.49l4 4l-4 3.95a1.06 1.06 0 0 0 0 1.49l.75.75a1.06 1.06 0 0 0 1.49 0l3.95-4l4 3.95a1.06 1.06 0 0 0 1.49 0l.75-.75a1.06 1.06 0 0 0 0-1.49L9.24 7Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDelete3RemoveCircleGarbageTrashDelete: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"m2.4 11.6l9.2-9.2m0 9.2L2.4 2.4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDeleteBin1RemoveDeleteEmptyBinTrashGarbage: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11.5 5.5l-1 8h-7l-1-8M1 3.5h12m-8.54-.29V1.48a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDeleteBin2RemoveDeleteEmptyBinTrashGarbage: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 3.5h12m-10.5 0h9v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-9h0Zm2 0V3a2.5 2.5 0 0 1 5 0v.5m-4 2V11m3-5.5V11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDeleteBin3RemoveDeleteEmptyBinTrashGarbage: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m12 .5l-1.4 12.11a1 1 0 0 1-1 .89H4.39a1 1 0 0 1-1-.89L2 .5m-1 0h12m-6 0v13m-4.54-9h9.08M2.98 9h8.04\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDeleteBin5RemoveDeleteEmptyBinTrashGarbage: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 3.5h12m-10.5 0h9v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-9h0Zm2 0V3a2.5 2.5 0 0 1 5 0v.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDeleteCircleButtonDeleteRemoveAddCircleButtons: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.12 4.88L4.88 9.12m0-4.24l4.24 4.24\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDeleteSquareButtonRemoveButtonsAddSquareDelete: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.12 4.88L4.88 9.12m0-4.24l4.24 4.24\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadBox1ArrowBoxDownDownloadInternetNetworkServerUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 13.5h-1a1 1 0 0 1-1-1v-8h13v8a1 1 0 0 1-1 1h-1\"/><path d=\"M4.5 11L7 13.5L9.5 11M7 13.5v-6M11.29 1a1 1 0 0 0-.84-.5h-6.9a1 1 0 0 0-.84.5L.5 4.5h13ZM7 .5v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadButton1ArrowButtonDownDownloadInternetNetworkServerUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 4.75h1a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-7.5a.5.5 0 0 1 .5-.5h1m3.5-4v8\"/><path d=\"m5 6.75l2 2l2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadButton2ArrowBottomDownDownloadInternetNetworkServerUpload: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 10.5v1a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1M4 6l3 3.5L10 6M7 9.5v-9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadCircleArrowCircleDownDownloadInternetNetworkServerUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4 7l3 3.5L10 7m-3 3.5v-7\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadDesktopActionActionsComputerDesktopDeviceDisplayDownloadMonitorScreen: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 3H13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-7A.5.5 0 0 1 1 3h1.5M7 11v2.5m-2 0h4M7 .5v6\"/><path d=\"m5 4.5l2 2l2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadLaptopArrowComputerDownDownloadInternetLaptopNetworkServerUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m1.91 9.5l-1.3 2.55a1 1 0 0 0 0 1a1 1 0 0 0 .87.47h11a1 1 0 0 0 .87-.47a1 1 0 0 0 0-1L12.09 9.5ZM5 4.5l2 2l2-2m-2 2v-6\"/><path d=\"M2.5 4.63a1 1 0 0 0-.5.87v4h10v-4a1 1 0 0 0-.5-.87\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadSquareArrowDownDownloadInternetNetworkServerSquareUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"m4 7l3 3.5L10 7m-3 3.5v-7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDownloadWebsiteActionActionsComputerWebsiteDeviceDisplayDownloadMonitorScreen: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 7v6.5M4.5 11L7 13.5L9.5 11\"/><path d=\"M2.5 13.5h-1a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-1m-11-10h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditAttachment1AttachmentLinkPaperclipUnlink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13 6.81l-5.95 6a2.48 2.48 0 0 1-3.54 0L1.73 11a2.53 2.53 0 0 1 0-3.55l6.34-6.36a2 2 0 0 1 2.84 0l.71.71a2 2 0 0 1 0 2.84L6 10.28a1 1 0 0 1-1.42 0l-.35-.36a1 1 0 0 1 0-1.42L8 4.76\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditAttachment2AttachmentLinkPaperclipUnlink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.75 11.5V3A2.5 2.5 0 0 0 8.25.5h-2.5A2.5 2.5 0 0 0 3.25 3v8.5a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V4a1 1 0 0 0-1-1h-.5a1 1 0 0 0-1 1v5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditBinocularBinocularBinocularsViewZoom: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"3\" cy=\"11\" r=\"2.5\"/><path d=\"M5.5 3V1.5a1 1 0 0 0-1-1H3.32a1 1 0 0 0-1 .81L.55 10.5m3.95-5h5M5.5 8v3\"/><circle cx=\"11\" cy=\"11\" r=\"2.5\"/><path d=\"M8.5 3V1.5a1 1 0 0 1 1-1h1.18a1 1 0 0 1 1 .81l1.79 9.19M8.5 8v3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditBombDeleteBombRemove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6.5\" cy=\"7.5\" r=\"6\"/><path d=\"m13.5.5l-2.76 2.76M3.5 7.5a3 3 0 0 1 3-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditBrush1BrushColorColorsDesignPaintPainting: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 8.5h-9l-.76 3.8a1 1 0 0 0 .21.83a1 1 0 0 0 .77.37h8.56a1 1 0 0 0 .77-.37a1 1 0 0 0 .21-.83Zm0-3a1 1 0 0 1 1 1v2h-11v-2a1 1 0 0 1 1-1H4a1 1 0 0 0 1-1v-2a2 2 0 0 1 4 0v2a1 1 0 0 0 1 1Zm-3 8V11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditBrush2BrushColorColorsDesignPaintPainting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.13 12.06C4.6 13.6 2 14.11.5 12.57C2.5 10.5.5 9.5 2 8a2.9 2.9 0 1 1 4.09 4.1Z\"/><path d=\"M12.92 1.08A2 2 0 0 0 11.44.5a2 2 0 0 0-1.44.67l-5.38 6A2.85 2.85 0 0 1 6.13 8a3 3 0 0 1 .77 1.31L12.83 4a2 2 0 0 0 .67-1.43a2 2 0 0 0-.58-1.49Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditBrush3BrushColorColorsDesignPaintPaintingRollerRolling: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"4\" x=\"2.5\" y=\".5\" rx=\"1\"/><path d=\"M8 9.5v-1a2 2 0 0 0-2-2H2.5a2 2 0 0 1-2-2v-1a1 1 0 0 1 1-1h1m4 11v-3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditBrush4DesignRubberStampSuppliesTool: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 10.5h11v2a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-2h0Zm9-4a1 1 0 0 1-1-1V3a2.5 2.5 0 0 0-5 0v2.5a1 1 0 0 1-1 1h-1a2 2 0 0 0-2 2v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditClipBinderClipClipperCompanyOfficeSuppliesWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 6h1a1 1 0 0 1 1 1.13l-.73 5.5a1 1 0 0 1-1 .87H2.23a1 1 0 0 1-1-.87l-.72-5.5A1 1 0 0 1 1.5 6h1\"/><path d=\"M10.46 13.5L8.33 4h.42a1.75 1.75 0 0 0 0-3.5h-3.5a1.75 1.75 0 0 0 0 3.5h.41l-2.12 9.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditColorDropPickColorDropPickCompanyOfficeSuppliesWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 9C12 5.5 7 .5 7 .5S2 5.5 2 9a4.77 4.77 0 0 0 5 4.5A4.77 4.77 0 0 0 12 9ZM7 .5v13m2.5-.6V3.44\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditColorPaletteColorPaletteCompanyOfficeSuppliesWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"4.5\" cy=\"9\" r=\"4\"/><circle cx=\"9.5\" cy=\"9\" r=\"4\"/><circle cx=\"7\" cy=\"5\" r=\"4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditColorTriangleColorTriangleCompanyOfficeSuppliesWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M3.5 9h7L7 3.5L3.5 9z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditCopyClipboardCopyCutPaste: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 3.5v-1a1 1 0 0 0-1-1h-1m-2.5 9H1.5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h1\"/><rect width=\"7\" height=\"8\" x=\"6.5\" y=\"5.5\" rx=\"1\"/><path d=\"M6.75.5h-4.5l.41 1.62a.49.49 0 0 0 .48.38h2.72a.49.49 0 0 0 .48-.38Zm1.75 8h3m-3 2h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditCropArtboardCropDesignImagePicture: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4.5h1.5a1 1 0 0 1 1 1V7\"/><path d=\"M4.5.5v8a1 1 0 0 0 1 1h8m-9-5h-4m9 5v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditCutCouponCutDiscountPricePricesScissors: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.49 10.5h2m2 0h2M2.19 4.93l5.8 3.33\"/><circle cx=\"2.75\" cy=\"2.75\" r=\"2.25\"/><path d=\"M2.19 9.07L13.5 2.55\"/><circle cx=\"2.75\" cy=\"11.25\" r=\"2.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditCutterCutterCompanyOfficeSuppliesWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.5 7.5l-2 2v4l4-4\"/><path d=\"M11.67 1.33a2.82 2.82 0 0 0-4 0L2.5 6.5l4 4l5.17-5.17a2.82 2.82 0 0 0 0-4ZM6.5 6.5l3-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditDesignToolSelectionWandSselectionWandObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l9-9m2-2l1-1M9 2V.5M12 5h1.5M11 7l1 1M6 2l1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditDrawingBoardBoardDesignDrawingEaselProcess: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 2.5h8a1 1 0 0 1 1 1V10h0H2h0V3.5a1 1 0 0 1 1-1ZM.5 10h13M7 2.5v-2M5.5 10L3 13.5M8.5 10l2.5 3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditExpandBigBiggerDesignExpandLargerResizeSizeSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v3m-13-3v3m11 5h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m3 0h3\"/><rect width=\"6\" height=\"6\" x=\"4\" y=\"4\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipBottomAlternate1FlipBottomObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7a6.5 6.5 0 0 1-13 0M13 4.39a6.13 6.13 0 0 0-.76-1.3a6.34 6.34 0 0 0-1-1.09M1.05 4.39a6.13 6.13 0 0 1 .76-1.3A6.34 6.34 0 0 1 2.85 2M8.5.67a6.7 6.7 0 0 0-3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipBottomFlipBottomObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7h13a6.5 6.5 0 0 1-13 0ZM13 4.39a6.13 6.13 0 0 0-.76-1.3a6.34 6.34 0 0 0-1-1.09M1.05 4.39a6.13 6.13 0 0 1 .76-1.3A6.34 6.34 0 0 1 2.85 2M8.5.67a6.7 6.7 0 0 0-3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipDownDesignDownFlipReflectVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 11.5v1a1 1 0 0 1-1 1h-1m-3 0h-3m-5-2v1a1 1 0 0 0 1 1h1m-2-9v-3a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v3m-13 4V7h13v1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipHorizontal1ArrowDesignFlipReflect: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 3l4 4l-4 4V3zm13 0l-4 4l4 4V3zM7 .5v1m0 2v1m0 2v1m0 2v1m0 2v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipHorizontal2ArrowDesignFlipReflect: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.5 3.75l2.93 3.07a.27.27 0 0 1 0 .36L1.5 10.25m11-6.5L9.57 6.82a.27.27 0 0 0 0 .36l2.93 3.07M7 .5v1m0 2v1m0 2v1m0 2v1m0 2v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipLeftAlternate1FlipLeftObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5a6.5 6.5 0 0 0 0 13M9.61 1.05a6.13 6.13 0 0 1 1.3.76a6.34 6.34 0 0 1 1.09 1M9.61 13a6.13 6.13 0 0 0 1.3-.76a6.34 6.34 0 0 0 1.09-1m1.33-5.74a6.7 6.7 0 0 1 0 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipLeftDesignFlipReflectLeftHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5h-1a1 1 0 0 0-1 1v1m0 3v3m2 5h-1a1 1 0 0 1-1-1v-1m9 2h3a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-3m-4 13H7V.5H5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipLeftFlipLeftObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5V.5a6.5 6.5 0 0 0 0 13ZM9.61 1.05a6.13 6.13 0 0 1 1.3.76a6.34 6.34 0 0 1 1.09 1M9.61 13a6.13 6.13 0 0 0 1.3-.76a6.34 6.34 0 0 0 1.09-1m1.33-5.74a6.7 6.7 0 0 1 0 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipRightAlternate1FlipRightObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5a6.5 6.5 0 0 1 0 13M4.39 1.05a6.13 6.13 0 0 0-1.3.76A6.34 6.34 0 0 0 2 2.85M4.39 13a6.13 6.13 0 0 1-1.3-.76a6.34 6.34 0 0 1-1.09-1M.67 5.5a6.7 6.7 0 0 0 0 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipRightDesignFlipReflectRightHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m0 3v3m-2 5h1a1 1 0 0 0 1-1v-1m-9 2h-3a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h3m4 13H7V.5h1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipRightFlipRightObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5V.5a6.5 6.5 0 0 1 0 13ZM4.39 1.05a6.13 6.13 0 0 0-1.3.76A6.34 6.34 0 0 0 2 2.85M4.39 13a6.13 6.13 0 0 1-1.3-.76a6.34 6.34 0 0 1-1.09-1M.67 5.5a6.7 6.7 0 0 0 0 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipTopAlternate1FlipTopObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7a6.5 6.5 0 0 1 13 0M1.05 9.61a6.13 6.13 0 0 0 .76 1.3a6.34 6.34 0 0 0 1 1.09M13 9.61a6.13 6.13 0 0 1-.76 1.3a6.34 6.34 0 0 1-1 1.09M5.5 13.33a6.7 6.7 0 0 0 3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipTopFlipTopObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7H.5a6.5 6.5 0 0 1 13 0ZM1.05 9.61a6.13 6.13 0 0 0 .76 1.3a6.34 6.34 0 0 0 1 1.09M13 9.61a6.13 6.13 0 0 1-.76 1.3a6.34 6.34 0 0 1-1 1.09M5.5 13.33a6.7 6.7 0 0 0 3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipVertical1ArrowDesignFlipReflectUpDown: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.25 1.5L7.18 4.43a.27.27 0 0 1-.36 0L3.75 1.5m6.5 11L7.18 9.57a.27.27 0 0 0-.36 0L3.75 12.5M13.5 7h-1m-2 0h-1m-2 0h-1m-2 0h-1m-2 0h-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipVertical2ArrowDesignFlipReflectUpDown: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11 13.5l-4-4l-4 4h8zm0-13l-4 4l-4-4h8zM13.5 7h-1m-2 0h-1m-2 0h-1m-2 0h-1m-2 0h-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditGlueGlueCompanyOfficeSuppliesWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 8v4.5a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V8A2.5 2.5 0 0 1 5 5.5h4A2.5 2.5 0 0 1 11.5 8ZM7.5.5h-1L5 5.5h4L7.5.5zM5 11h4M2.5 8.5h9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditGridGridLayoutLayoutsModule: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M5 .5v13m4-13v13M13.5 5H.5m13 4H.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditGridOffGridLayoutLayoutsModuleOffCloseDenySlash: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13M1.79 1.79a1 1 0 0 1 .71-.29h9a1 1 0 0 1 1 1v9a1 1 0 0 1-.29.71M9 12.5H2.5a1 1 0 0 1-1-1V5m3.75-3.5v3.75m3.5-3.75v7.25m3.75-3.5H5.25m7.25 3.5H8.75m-3.5-.25v4m3.5-.5v.5M5.5 8.75h-4m.5-3.5h-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditLayerAdd1LayerAddDesignPlusLayersSquareBox: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 3.19v4.62M3.19 5.5h4.62\"/><rect width=\"10\" height=\"10\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M3.5 13.5h9a1 1 0 0 0 1-1v-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditLayerAdd2LayerAddDesignPlusLayersSquareBox: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"10\" x=\".5\" y=\"3.5\" rx=\"1\"/><path d=\"M3.5.5h9a1 1 0 0 1 1 1v9M5.5 6v5M8 8.5H3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditMagicWandDesignMagicStarSuppliesToolWand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m12.64 1.87l-.84 2.48a.41.41 0 0 0 0 .37l1.57 2.1a.4.4 0 0 1-.33.64h-2.62a.43.43 0 0 0-.33.17l-1.46 2.1a.4.4 0 0 1-.71-.11l-.78-2.5a.38.38 0 0 0-.26-.26l-2.5-.78a.4.4 0 0 1-.11-.71l2.14-1.51a.43.43 0 0 0 .17-.33V.91a.4.4 0 0 1 .6-.33l2.1 1.57a.41.41 0 0 0 .37.05l2.48-.84a.4.4 0 0 1 .51.51Zm-5.6 5.09L.5 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditMagnetDesignMagnetSnapSuppliesToTool: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.81 12.07a4.86 4.86 0 0 1-6.88-6.88L6.62.5l2.19 2.19L4.51 7A1.77 1.77 0 0 0 7 9.49l4.3-4.3l2.2 2.19Zm.38-4.76l2.19 2.19M4.5 2.62l2.19 2.19\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPaintColorColorsDesignPaintPaintingPalette: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"8.5\" cy=\"4\" r=\"1\"/><circle cx=\"4.5\" cy=\"9.5\" r=\".5\"/><circle cx=\"4.5\" cy=\"5.5\" r=\"1\"/><path d=\"M9.52 12.28a1 1 0 0 0-.65-.88a2 2 0 0 1 .63-3.9h1.87a2 2 0 0 0 1.89-2.67a6.5 6.5 0 1 0-6.13 8.67a6.3 6.3 0 0 0 1.74-.24a.9.9 0 0 0 .65-.98Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPathfinderDividePathfinderDivideWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 8.5a1 1 0 0 0 1 1m0-9a1 1 0 0 0-1 1m9 0a1 1 0 0 0-1-1M4 .5h2M.5 4v2m9-1.5h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-3h4a1 1 0 0 0 1-1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPathfinderIntersectPathfinderIntersectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 8.5a1 1 0 0 0 1 1m0-9a1 1 0 0 0-1 1m9 0a1 1 0 0 0-1-1M4 .5h2M.5 4v2m4 6.5a1 1 0 0 0 1 1m8-8a1 1 0 0 0-1-1m0 9a1 1 0 0 0 1-1m-5.5 1h2M13.5 8v2m-4-1.5v-4h-4a1 1 0 0 0-1 1v4h4a1 1 0 0 0 1-1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPathfinderMergePathfinderMergeWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.5 9.5h1a1 1 0 0 0 1-1v-1m0-3v-3a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h3m0 3a1 1 0 0 0 1 1m8-8a1 1 0 0 0-1-1m0 9a1 1 0 0 0 1-1m-4-8h.5m-2 9h2M13.5 8v2m-9-.5v.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPathfinderOutlinePathfinderOutlineWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 9.5a1 1 0 0 0 1-1m-5 1H6m3.5-5V6m-4-1.5a1 1 0 0 0-1 1\"/><path d=\"M.5 1.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1Zm7.5 3h1.5M4.5 8v1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPen1ContentCreationEditPenWrite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.5 13.5l2-2m2.21.79a1 1 0 0 1-1.42 0l-1.58-1.58a1 1 0 0 1 0-1.42l8.17-8.17a2.12 2.12 0 0 1 3 3Z\"/><path d=\"M11.5 5.5L7.21 1.21a1 1 0 0 0-1.42 0L2.5 4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPen2ContentCreationEditFountainPenWrite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 12.5a2.72 2.72 0 0 0 0-4a2.72 2.72 0 0 0-4 0c-1 1-1 5-1 5s4 0 5-1Z\"/><path d=\"M12.92 1.08a2 2 0 0 0-2.64-.15L4.5 5l-.71 2.64a2.87 2.87 0 0 1 1.71.86a2.87 2.87 0 0 1 .86 1.71L9 9.5l4.07-5.78a2 2 0 0 0-.15-2.64ZM.5 13.5l3.25-3.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPen3ContentCreationEditPenPensWrite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 3a2.5 2.5 0 0 0-5 0v7.5l2.5 3l2.5-3Zm-5 1.5h5m2-2a2 2 0 0 1 4 0v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1Zm2 9v2\"/><path d=\"M7.5 4.5h5a1 1 0 0 1 1 1v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPencilChangeEditModifyPencilWriteWriting: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 12.24L.5 13.5L1.76 9L10 .8a1 1 0 0 1 1.43 0l1.77 1.78a1 1 0 0 1 0 1.42Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPickerColorColorsDesignDropperEyeEyedropEyedropperPaintingPicker: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.46 1.54a3.52 3.52 0 0 0-5 0L2.87 6.13a3 3 0 0 0-.53 3.53L.79 11.21a1 1 0 0 0 0 1.41l.59.59a1 1 0 0 0 1.41 0l1.55-1.55a3 3 0 0 0 3.53-.53l4.59-4.59a3.52 3.52 0 0 0 0-5ZM4.5 1.5l8 8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPin1PinPushThumbtack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"9\" cy=\"5\" r=\"4.5\"/><path d=\"m.5 13.5l5.58-5.07\"/><circle cx=\"8.5\" cy=\"3.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPin2PinPushThumbtack: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.73 7.65L13 5.54A1 1 0 0 0 13.21 4L10 .79A1 1 0 0 0 8.46 1L6.3 4.23l-4.49 1a.6.6 0 0 0-.29 1l6.15 6.16a.61.61 0 0 0 1-.3ZM4.59 9.38L.5 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPin3PinPushThumbtack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"9\" cy=\"5\" r=\"4.5\"/><path d=\"M10.25 3.67a1.5 1.5 0 0 0-2.31-.23M.5 13.5l5.58-5.07\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditPrinterPrinterCompanyOfficeSuppliesWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 8.5h9a1 1 0 0 1 1 1v4h0h-11h0v-4a1 1 0 0 1 1-1Z\"/><path d=\"M1.5 9.5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1M3 .5h8v5H3zM4 11h6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditQuillChangeEditFeatherModifyQuillWriteWriting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.51 10.05a10.21 10.21 0 0 0 3 .45A10 10 0 0 0 13.5 1a10.16 10.16 0 0 0-3-.45a10 10 0 0 0-9.99 9.5Z\"/><path d=\"M1 13.5a9.65 9.65 0 0 1-.49-3.45M8.01 5l2.57 2.57\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditRotateAngleRotateAngleCompanyOfficeSuppliesWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5.5v13h13\"/><path d=\"M7.5 13.5a7 7 0 0 0-7-7m0 7L3 11m2.5-2.5L7 7m2-2l1.5-1.5m2-2l1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditRulerRulerCompanyOfficeSuppliesWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.502 9.496L9.503.495l4.002 4.002l-9.001 9.001zM7.5 2.5L9 4M5 5l1.5 1.5m-4 1L4 9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditScissorsClipboardCopyCutPasteRightScissors: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.19 4.93l11.31 6.52\"/><circle cx=\"2.75\" cy=\"2.75\" r=\"2.25\"/><path d=\"M2.19 9.07L13.5 2.55\"/><circle cx=\"2.75\" cy=\"11.25\" r=\"2.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSelectAreaCircleDashSelectAreaObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5.67a6.7 6.7 0 0 0-3 0m-1.91.8a7 7 0 0 0-1.19.93a7 7 0 0 0-.93 1.19M.67 5.5a6.7 6.7 0 0 0 0 3m.8 1.91a7 7 0 0 0 .93 1.19a7 7 0 0 0 1.19.93m1.91.8a6.7 6.7 0 0 0 3 0m1.91-.8a7 7 0 0 0 1.19-.93a7 7 0 0 0 .93-1.19m.8-1.91a6.7 6.7 0 0 0 0-3m-.8-1.91a7 7 0 0 0-.93-1.19a7 7 0 0 0-1.19-.93\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSelectAreaRectangleDashSelectAreaObjectWork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v3m-13-3v3m11 5h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m3 0h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSelectBackBehindBoxDesignLayerLayersSelectSendToBack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 9.5a1 1 0 0 0 1 1m0-10a1 1 0 0 0-1 1m10 0a1 1 0 0 0-1-1m0 10a1 1 0 0 0 1-1\"/><path d=\"M10.5 13.5h-8a2 2 0 0 1-2-2v-8m7-3h2m-2 10h2m4-6v2m-10-2v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSelectFrameCursorFrameSelect: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5.5h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m7 13h2a1 1 0 0 0 1-1v-2m-13 0v2a1 1 0 0 0 1 1h2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSelectFrontDesignFrontLayerLayersSelectSendToTop: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"10\" x=\"3.5\" y=\".5\" rx=\"1\"/><path d=\"M.5 12.5a1 1 0 0 0 1 1m3 0H6m3 0h1.5M.5 8v1.5m0-6V5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSkull1CrashDeathDeleteDieErrorGarbageRemoveSkullTrash: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 6.5a6 6 0 1 0-9.5 4.87v1.13a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1.13A6 6 0 0 0 13 6.5Z\"/><circle cx=\"4.5\" cy=\"7\" r=\".5\"/><circle cx=\"9.5\" cy=\"7\" r=\".5\"/><path d=\"M6 11.5v2m2-2v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSprayCanColorColorsDesignPaintPaintingSpray: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"6\" height=\"9\" x=\".5\" y=\"4.5\" rx=\"1\"/><path d=\"M3.5 2v2.5m5-3l5-1m-5 3l5 1M2.5 2h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditSwatchColorColorsDesignPaintingPaletteSampleSwatch: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5.5h3a1 1 0 0 1 1 1V11A2.5 2.5 0 0 1 3 13.5h0A2.5 2.5 0 0 1 .5 11V1.5a1 1 0 0 1 1-1Z\"/><path d=\"M5.5 5L9 1.48a1 1 0 0 1 1.41 0l2.11 2.12a1 1 0 0 1 0 1.41l-7.75 7.76\"/><path d=\"M9 8.5h3.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3m-2.5-9h5m-5 4h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditTypewriterTypewriterCompanyOfficeSuppliesWork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 3.5h13v3H.5zM3 .5h8a.5.5 0 0 1 .5.5v2.5h0h-9h0V1A.5.5 0 0 1 3 .5Z\"/><circle cx=\"3\" cy=\"8\" r=\"1.5\"/><circle cx=\"11\" cy=\"8\" r=\"1.5\"/><path d=\"M2.5 9.41v3.09a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V9.41m-9 .09h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditViewEyeEyeballOpenView: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.23 6.33a1 1 0 0 1 0 1.34C12.18 8.8 9.79 11 7 11S1.82 8.8.77 7.67a1 1 0 0 1 0-1.34C1.82 5.2 4.21 3 7 3s5.18 2.2 6.23 3.33Z\"/><circle cx=\"7\" cy=\"7\" r=\"2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditViewOffDisableEyeEyeballHideOffView: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.29 5.4c.38.34.7.67.94.93a1 1 0 0 1 0 1.34C12.18 8.8 9.79 11 7 11h-.4m-2.73-.87a12.4 12.4 0 0 1-3.1-2.46a1 1 0 0 1 0-1.34C1.82 5.2 4.21 3 7 3a6.56 6.56 0 0 1 3.13.87M12.5 1.5l-11 11\"/><path d=\"M5.59 8.41A2 2 0 0 1 5 7a2 2 0 0 1 2-2a2 2 0 0 1 1.41.59M8.74 8a2 2 0 0 1-.74.73\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditWrite1EditEditionFormPenTextWrite: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.5h11m-5-3.5l-3 .54L4 7.5L10.73.79a1 1 0 0 1 1.42 0l1.06 1.06a1 1 0 0 1 0 1.42Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditWrite2ChangeDocumentEditModifyPaperPencilWriteWriting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.5 9l-3 .54L5 6.5L10.73.79a1 1 0 0 1 1.42 0l1.06 1.06a1 1 0 0 1 0 1.42Z\"/><path d=\"M12 9.5v3a1 1 0 0 1-1 1H1.5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditWriteCircleChangeCircleEditModifyPencilWriteWriting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 7A6.5 6.5 0 1 1 7 .5\"/><path d=\"m10.5.5l-5 5l-1 4l4-1l5-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditZoomInEnhanceGlassInMagnifyMagnifyingZoom: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5.92\" cy=\"5.92\" r=\"5.42\"/><path d=\"M13.5 13.5L9.75 9.75M6 3.5v5M3.5 6h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditZoomOutGlassMagnifyingOutReduceZoom: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5.92\" cy=\"5.92\" r=\"5.42\"/><path d=\"M13.5 13.5L9.75 9.75M3.5 6h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFavoriteAwardRibbonRewardLikeSocialRatingMedia: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6.87\" cy=\"5\" r=\"4.5\"/><circle cx=\"6.87\" cy=\"5\" r=\"2\"/><path d=\"m6 9.42l-.88 3.7a.51.51 0 0 1-.26.33a.54.54 0 0 1-.43 0L1.11 12a.51.51 0 0 1-.18-.78L3.5 8M8 9.37l.9 3.75a.5.5 0 0 0 .27.33a.51.51 0 0 0 .42 0l3.3-1.45a.5.5 0 0 0 .28-.35a.48.48 0 0 0-.1-.43l-2.68-3.41\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFavoriteDislike1RewardDownThumbHandSocialMediaDislikeRating: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3.37 8.15l2.54 4.06a1.09 1.09 0 0 0 .94.52h0A1.11 1.11 0 0 0 8 11.63V8.72h4.39a1.15 1.15 0 0 0 1.1-1.32l-.8-5.16a1.14 1.14 0 0 0-1.13-1H5a2 2 0 0 0-.9.21l-.72.36m-.01 6.34V1.84M1 1.84h2.37v6.31h0H1a.5.5 0 0 1-.5-.5V2.34a.5.5 0 0 1 .5-.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFavoriteGiveHeartRewardSocialRatingMediaHeartHand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 8.5h2A2.5 2.5 0 0 1 5 11h0m-3 0h5a2 2 0 0 1 2 2h0a.5.5 0 0 1-.5.5h-8m8.25-5l-4-3.7c-2.18-2.19 1-6.43 4-3c3-3.42 6.21.82 4 3Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFavoriteHeartRewardSocialRatingMediaHeartItLikeFavoriteLove: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m7 12.45l-5.52-5c-3-3 1.41-8.76 5.52-4.1c4.11-4.66 8.5 1.12 5.52 4.1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFavoriteLike1RewardSocialUpRatingMediaLikeThumbHand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3.37 5.85l2.54-4.06a1.09 1.09 0 0 1 .94-.52h0A1.11 1.11 0 0 1 8 2.37v2.91h4.39a1.15 1.15 0 0 1 1.1 1.32l-.8 5.16a1.14 1.14 0 0 1-1.13 1H5a2 2 0 0 1-.9-.21l-.72-.36m-.01-6.34v6.31M1 5.85h2.37v6.31h0H1a.5.5 0 0 1-.5-.5V6.35a.5.5 0 0 1 .5-.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFavoriteStarRewardRatingRateSocialStarMediaFavoriteLikeStars: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.49 1.09L9.08 4.3a.51.51 0 0 0 .41.3l3.51.52a.54.54 0 0 1 .3.93l-2.53 2.51a.53.53 0 0 0-.16.48l.61 3.53a.55.55 0 0 1-.8.58l-3.16-1.67a.59.59 0 0 0-.52 0l-3.16 1.67a.55.55 0 0 1-.8-.58L3.39 9a.53.53 0 0 0-.16-.48L.67 6.05A.54.54 0 0 1 1 5.12l3.51-.52a.51.51 0 0 0 .41-.3l1.59-3.21a.54.54 0 0 1 .98 0Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileAddAlternateFileCommonAdd: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 5.5v-4a1 1 0 0 1 1-1h5l5 5v7a1 1 0 0 1-1 1h-5\"/><path d=\"M8.5.5v5h5m-10 2v6m-3-3h6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileAddFileCommonAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5l5 5Zm-6-6.75v3.5M4.75 7.5h3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileBookmarkTextCommonBookmark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4Z\"/><path d=\"m8 7.5l-2-2l-2 2v-7h4v7z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileCheckFileCommonCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5l5 5Z\"/><path d=\"m4.5 8.5l1.5 1l2.5-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileClipboardAddEditTaskEditionAddClipboardForm: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><rect width=\"5\" height=\"2.5\" x=\"4.5\" y=\".5\" rx=\"1\"/><path d=\"M7 6v4m2-2H5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileClipboardBlockEditTaskEditionBlockClipboardForm: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 13.5h-4a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1H3m5 0h1.5a1 1 0 0 1 1 1v2\"/><rect width=\"5\" height=\"2.5\" x=\"3\" y=\".5\" rx=\"1\"/><circle cx=\"10.25\" cy=\"10.25\" r=\"3.25\"/><path d=\"m7.95 12.55l4.6-4.6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileClipboardCheckCheckmarkEditTaskEditionChecklistCheckSuccessClipboardForm: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><rect width=\"5\" height=\"2.5\" x=\"4.5\" y=\".5\" rx=\"1\"/><path d=\"m4.5 8.5l2 1.5L9 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileClipboardDeleteEditTaskEditionDeleteClipboardForm: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><rect width=\"5\" height=\"2.5\" x=\"4.5\" y=\".5\" rx=\"1\"/><path d=\"m5.5 6.5l3 3m0-3l-3 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileClipboardRemoveEditTaskEditionRemoveDeleteClipboardForm: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><rect width=\"5\" height=\"2.5\" x=\"4.5\" y=\".5\" rx=\"1\"/><path d=\"M9 8H5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileClipboardTextEditionFormTaskChecklistEditClipboard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><rect width=\"5\" height=\"2.5\" x=\"4.5\" y=\".5\" rx=\"1\"/><path d=\"M4.5 5.5h5M4.5 8h5m-5 2.5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileClipboardWorkPlainClipboardTaskListCompanyOffice: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><rect width=\"5\" height=\"2.5\" x=\"4.5\" y=\".5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileDeleteAlternateFileCommonDelete: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 7V1.5a1 1 0 0 1 1-1h5l5 5v7a1 1 0 0 1-1 1H8\"/><path d=\"M8.5.5v5h5M4.74 9.26L.5 13.5m0-4.24l4.24 4.24\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileDeleteFileCommonDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5l5 5ZM8.74 6L4.5 10.24M4.5 6l4.24 4.24\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileDoubleFileCommonDouble: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V1.5a1 1 0 0 1 1-1h4.5l3 3Z\"/><path d=\"M9.5 13.5h-7a1 1 0 0 1-1-1v-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileFolderWorkOfficeCompanyFolderSuppliesFile: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.91 12.56l-.41-7A.5.5 0 0 1 1 5h4.61a.51.51 0 0 1 .49.38L6.5 7H13a.5.5 0 0 1 .5.54l-.39 5a1 1 0 0 1-1 .92H1.91a1 1 0 0 1-1-.9ZM3.5 3V1A.5.5 0 0 1 4 .5h8.5a.5.5 0 0 1 .5.5v4M7.5 3h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileMultipleDoubleCommonFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8\" height=\"11\" x=\"2\" y=\"2.5\" rx=\"1\"/><path d=\"M4 5h4M4 7.5h4M4 10h2M4.5.5H11a1 1 0 0 1 1 1V11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileRemoveAlternateFileCommonRemoveMinusSubtract: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 7.5v-6a1 1 0 0 1 1-1h5l5 5v7a1 1 0 0 1-1 1h-6\"/><path d=\"M8.5.5v5h5m-13 5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileRemoveFileCommonRemoveMinusSubtract: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5l5 5Zm-7.75-5h3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileSettingFileCommonSetting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.39 4V1.5a1 1 0 0 1 1-1h5l5 5v7a1 1 0 0 1-1 1h-3.5\"/><path d=\"M8.39.5v5h5m-9.75 1V8m-3.03.25l1.3.75m-1.3 2.75l1.3-.75m1.73 2.5V12m3.03-.25L5.37 11m1.3-2.75L5.37 9\"/><circle cx=\"3.64\" cy=\"10\" r=\"2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileStickyNoteEmptyCommonFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 13.5h-7a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7Z\"/><path d=\"M8.5 9v4.5l5-5H9a.5.5 0 0 0-.5.5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileTextTextCommonFile: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5l5 5Zm-8-8h2m-2 3h5m-5 3h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFileZipFileCommonZip: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h6l4 4ZM4 3.5h3m-3 3h3m-3 3h3M5.5.5v10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFolderAddAddFolderPlus: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 11.75v-9.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1Zm6.63-5.5v3.5M5.38 8h3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFolderBlockBlockFolderSubtract: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.75 12H1.5a1 1 0 0 1-1-1V1.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.28 1.24h6a1 1 0 0 1 1 1v1.75\"/><circle cx=\"10.25\" cy=\"10.25\" r=\"3.25\"/><path d=\"m7.95 12.55l4.6-4.6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFolderCheckRemoveCheckFolderSubtract: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 11.75v-9.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1Z\"/><path d=\"m5 8.75l1.5 1l2.5-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFolderDeleteRemoveMinusFolderSubtractDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 11.75v-9.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1ZM5 8h3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFolderEmptyFolder: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6A1.5 1.5 0 0 0 12 4.5H7l-1.44-3H2A1.5 1.5 0 0 0 .5 3v8A1.5 1.5 0 0 0 2 12.5h10a1.5 1.5 0 0 0 1.5-1.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFolderRemoveRemoveMinusFolderSubtractDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 11.75v-9.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1Zm8-5l-3 3m0-3l3 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceFolderZipZipFolderCompact: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 6.25h3m-3 3h3m-1.5-6v7m-9 1.5v-9.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceGeometricPentagonPentagonDesignGeometricShapeShapes: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6L7 .5L.5 6l3 7.5h7l3-7.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceGeometricPolygonPolygonOctangleDesignGeometricShapeShapes: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 13.5h-5l-4-4v-5l4-4h5l4 4v5l-4 4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceGeometricSquareSquareGeometricDesignShapeShapes: Icon = {
  "body": "<rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" rx=\"1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceGeometricTriangleGeometricTriangleShapeDesignShapes: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.46 2a.55.55 0 0 0-.92 0l-6 9.5a.5.5 0 0 0 0 .5a.54.54 0 0 0 .46.25h12a.54.54 0 0 0 .46-.25a.5.5 0 0 0 0-.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpCustomerSupport1CustomerHeadsetHelpMicrophonePhoneSupport: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 7V4.37A3.93 3.93 0 0 1 7 .5h0a3.93 3.93 0 0 1 4 3.87V7M1.5 5.5h1A.5.5 0 0 1 3 6v3a.5.5 0 0 1-.5.5h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm11 4h-1A.5.5 0 0 1 11 9V6a.5.5 0 0 1 .5-.5h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1ZM9 12.25a2 2 0 0 0 2-2h0V8m-2 4.25a1.25 1.25 0 0 1-1.25 1.25h-1.5a1.25 1.25 0 0 1 0-2.5h1.5A1.25 1.25 0 0 1 9 12.25Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpCustomerSupport2CustomerHeadphonesHeadsetHelpMicrophonePhonePersonSupport: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 6h1a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-.5.5h-1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm11 3.5h-1A.5.5 0 0 1 11 9V6.5a.5.5 0 0 1 .5-.5h1a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1Zm-3 2.75a2 2 0 0 0 2-2h0V9.5\"/><path d=\"M8.25 11a1.25 1.25 0 0 1 0 2.5h-1.5a1.25 1.25 0 0 1 0-2.5ZM2.5 6V5a4.5 4.5 0 0 1 9 0v1m-6-2v1.5m3-1.5v1.5m-3 2c0 1.33 3 1.33 3 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpCustomerSupport4CustomerHeadsetHelpPhoneSupport: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 7.5h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a6.5 6.5 0 0 1 13 0v5.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpCustomerSupport5CustomerHeadsetHelpPhoneSupport: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"3\" height=\"6\" x=\"2.5\" y=\"7.5\" rx=\"1\"/><rect width=\"3\" height=\"6\" x=\"8.5\" y=\"7.5\" rx=\"1\"/><path d=\"M.5 9.5V7a6.5 6.5 0 0 1 13 0v2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpCustomerSupportHuman1CustomerHeadphonesHelpHeadsetPersonProfileSuuport: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"2.5\"/><path d=\"M7 4.5v-4m2.5 13V12h2a1 1 0 0 0 1-1V7a5.5 5.5 0 0 0-3-4.9m-5 0a5.5 5.5 0 0 0 0 9.8v1.6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpQuestionCircleCircleFaqFrameHelpInfoMarkMoreQueryQuestion: Icon = {
  "body": "<circle cx=\"7\" cy=\"7\" r=\"6.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 5.5A1.5 1.5 0 1 1 7 7v1\"/><path fill=\"currentColor\" d=\"M7 9.5a.75.75 0 1 0 .75.75A.76.76 0 0 0 7 9.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpQuestionMessageBubbleHelpMarkMessageQueryQuestionSpeech: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1h2v2.5L6.62 11h5.88a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1Z\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 4.5A1.5 1.5 0 1 1 7 6v.5\"/><path fill=\"currentColor\" d=\"M7 8a.75.75 0 1 0 .75.75A.76.76 0 0 0 7 8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHelpQuestionSquareFrameHelpMarkQueryQuestionSquare: Icon = {
  "body": "<rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" rx=\"1\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 5.5A1.5 1.5 0 1 1 7 7v1\"/><path fill=\"currentColor\" d=\"M7 9.5a.75.75 0 1 0 .75.75A.76.76 0 0 0 7 9.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHierarchy1NodeOrganizationLinksStructureLinkNodesNetworkHierarchy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2.5\" cy=\"7\" r=\"2\"/><circle cx=\"11.5\" cy=\"2.5\" r=\"2\"/><circle cx=\"11.5\" cy=\"11.5\" r=\"2\"/><path d=\"m3.71 5.41l5.85-2.43M3.71 8.59l5.85 2.43\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHierarchy2NodeOrganizationLinksStructureLinkNodesNetworkHierarchy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"2.5\" r=\"1.5\"/><circle cx=\"2\" cy=\"11.5\" r=\"1.5\"/><circle cx=\"7\" cy=\"11.5\" r=\"1.5\"/><circle cx=\"12\" cy=\"11.5\" r=\"1.5\"/><path d=\"M2 10V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2M7 4v6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHierarchy3NodeOrganizationLinksStructureLinkNodesNetworkHierarchy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"3.5\" height=\"3.5\" x=\".5\" y=\"10\" rx=\".5\"/><rect width=\"3.5\" height=\"3.5\" x=\"10\" y=\"10\" rx=\".5\"/><rect width=\"4\" height=\"4\" x=\"5\" y=\".5\" rx=\".5\"/><path d=\"M4 12h6M5.09 4.29L2.5 10m6.41-5.71L11.5 10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHome1HomeHouseMapRoof: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6.94a1 1 0 0 0-.32-.74L7 .5L.82 6.2a1 1 0 0 0-.32.74v5.56a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHome2DoorEntranceHomeHouseMapRoofRound: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 9L7 2.5L13.5 9\"/><path d=\"M2.5 7v6.5h9V7M7 13.5v-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHome3HomeHouseMapRoof: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7L7 .5L13.5 7m-11 1.5v5h9v-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHome4DoorEntrnaceMap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"9\" height=\"13\" x=\"2.5\" y=\".5\" rx=\"1\"/><path d=\"M8 7.5h1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceHome5DoorEntranceHomeHouseMapRoofRoundWindow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 8.5L7 2l6.5 6.5\"/><path d=\"M2.5 6.5v7h9v-7m-4.5 7v-3\"/><circle cx=\"7\" cy=\"6.75\" r=\"1.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdFaceScan2IdentificationAngleSecureHumanIdPersonFaceSecurityBrackets: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 10.5v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2m3.5-7v2m6-2v2m-3-1V8H5.5m-1 2a3.63 3.63 0 0 0 5 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdFingerPrintIdentificationPasswordTouchIdSecureFingerprintFingerSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 8.75v-1.5C13 3.54 10.3.5 7 .5h0c-3.3 0-6 3-6 6.75v6.25m3-2.25v2.25\"/><path d=\"M10 13.5V8c0-2.06-1.35-3.75-3-3.75h0C5.35 4.25 4 5.94 4 8v.75M7 12v1.5m0-6.25V9.5m6 4v-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdFingerPrintScanTouchIdIdentificationHandFingerCircleFingerprint: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 13.5V8.25A1.25 1.25 0 0 1 6.75 7h0A1.25 1.25 0 0 1 8 8.25V11h2a2 2 0 0 1 2 2v.5\"/><path d=\"M3.39 8.61a4.75 4.75 0 1 1 6.72 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdIrisScanCheckIdentificationRetinaSecurityApprovedSuccessIrisScanEyeLogin: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4.5 7.25l1.55 1.14a.48.48 0 0 0 .4.1a.5.5 0 0 0 .34-.24l3.71-6\"/><path d=\"M11.85 5.25a13.92 13.92 0 0 1 1.65 2s-2.91 4.5-6.5 4.5S.5 7.25.5 7.25s2.91-4.5 6.5-4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdIrisScanIdentificationRetinaSecureSecurityIrisScanEyeBrackets: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.5v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2m11-3.5s-2 3-4.5 3s-4.5-3-4.5-3s2-3 4.5-3s4.5 3 4.5 3Z\"/><circle cx=\"7\" cy=\"7\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdUserIdentificationAngleSecureHumanIdPersonFaceSilhouetteSecurityBrackets: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.5v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2\"/><circle cx=\"7\" cy=\"4.5\" r=\"2\"/><path d=\"M10.16 10.5a3.5 3.5 0 0 0-6.32 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdVoice1IdentificationSecureIdSoundwaveSoundVoiceSecurity: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 1.5v11m5.2-9v7M3.1 5v4m10.4-7.5v11m-2.6-9v7M8.3 5v4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdVoice2IdentificationSecureIdSoundwaveSoundVoiceBracketsSecurity: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 4V1.5a1 1 0 0 1 1-1H4M13.5 4V1.5a1 1 0 0 0-1-1H10M.5 10v2.5a1 1 0 0 0 1 1H4m9.5-3.5v2.5a1 1 0 0 1-1 1H10m-9-6h2.5l1.5-4L7 9l2-4l1.5 2.5H13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdVoiceScanIdentificationSecureIdSoundwaveSoundVoiceBracketsSecurity: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5.18v4.14m4-4.14v4.14M5 6.07v2.36m6-3.25v4.14M9 6.07v2.36M.5 4V1.5a1 1 0 0 1 1-1H4M13.5 4V1.5a1 1 0 0 0-1-1H10M.5 10v2.5a1 1 0 0 0 1 1H4m9.5-3.5v2.5a1 1 0 0 1-1 1H10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout1ColumnLayoutLayoutsLeftSidebar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(180 7 7)\"/><path d=\"M5.5.5v13m0-6.5h8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout10ColumnLayoutLayoutsRightSidebar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M9.5.5v13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout11ColumnLayoutLayoutsLeftSidebar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M4.5.5v13m0-6.5h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout2ColumnHeaderLayoutLayoutsMastheadSidebar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-9 0v10m9-5h-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout3HeaderLayoutLayoutsMastheadTop: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout4ColumnHeaderLayoutLayoutsMastheadSidebar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-9 0v10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout5ColumnHeaderLayoutLayoutsMastheadSidebar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-4 0v10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout6ColumnHeaderLayoutLayoutsMasthead: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-9 0v10m5-10v10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout7ColumnHeaderLayoutLayoutsMasthead: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13M7 3.5v10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout8GridHeaderLayoutLayoutsMasthead: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13M7 3.5v10m-6.5-5h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayout9ColumnLayoutLayoutsLeftSidebar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M4.5.5v13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderBottomBorderBottomCellFormatFormatting: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m-8 13h13m0-8v4m-13-4v4m6.5-4v3M8.5 7h-3m8 0h-2m-9 0h-2M7 .5v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderCenterBorderCellFormatFormattingHorizontalVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v3m-13-3v3M7 .5v13M13.5 7H.5m11 6.5h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m3 0h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderCornerBorderCellFormatFormattingCornerTopUpLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 11.5v1a1 1 0 0 1-1 1h-1m2-9v4m-5 5h-3m-5-1v-11a1 1 0 0 1 1-1h11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderFrameBorderCellFormatFormattingFull: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 5.5v3M8.5 7h-3m8 0h-2m-9 0h-2\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M7 .5v2m0 9v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderFullGridLayoutLayoutsModule: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M7 .5v13M.5 7h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderHorizontalBorderCellCenterFormatFormatting: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v3m-13-3v3m6.5-3v3M13.5 7H.5m11 6.5h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m3 0h3M7 .5v2m0 9v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderLeftBorderCellFormatFormattingLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-9-2h4m5 5v3M.5.5v13m6.5-8v3M8.5 7h-3m8 0h-2m0 6.5h1a1 1 0 0 0 1-1v-1m-9 2h4M7 .5v2m0 9v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderNoneBorderCellFormatFormattingNone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v3m-13-3v3m6.5-3v3M8.5 7h-3m8 0h-2m-9 0h-2m11 6.5h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m3 0h3M7 .5v2m0 9v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderRightBorderCellFormatFormattingRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 13.5h-1a1 1 0 0 1-1-1v-1m9 2h-4m-5-5v-3m13 8V.5M7 8.5v-3M5.5 7h3m-8 0h2m0-6.5h-1a1 1 0 0 0-1 1v1m9-2h-4m1.5 13v-2m0-9v-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderTopBorderCellFormatFormattingTop: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 11.5v1a1 1 0 0 1-1 1h-1m2-9v4m-5 5h-3m8-13H.5m8 6.5h-3M7 8.5v-3m0 8v-2m-6.5 0v1a1 1 0 0 0 1 1h1m-2-9v4m13-1.5h-2m-9 0h-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutBorderVerticalBorderCellCenterFormatFormatting: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v3m-13-3v3m8-1.5h-3m8 0h-2m-9 0h-2m11 6.5h1a1 1 0 0 0 1-1v-1m-13 0v1a1 1 0 0 0 1 1h1m3 0h3M7 .5v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutThreeColumnsColumnsLayoutLayoutsThree: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M4.5.5v13m5-13v13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutTwoColumnsColumsLayoutLayoutsTwo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M7 .5v13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLayoutTwoRowsRowsLayoutLayoutsTwo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 7h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLightingBrightness1BrightAdjustBrightnessAdjustmentSunRaiseControls: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"2.5\"/><path d=\"M7 .5v2m-4.6-.1l1.42 1.42M.5 7h2m-.1 4.6l1.42-1.42M7 13.5v-2m4.6.1l-1.42-1.42M13.5 7h-2m.1-4.6l-1.42 1.42\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLightingBrightness2BrightAdjustBrightnessAdjustmentSunRaiseControlsHalf: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v1m0 11v1M1.5 7h-1m2.61 3.89l-.71.71m.71-8.49L2.4 2.4M7 3.5a3.5 3.5 0 0 0 0 7ZM12.5 7h1m-2.61 3.89l.71.71m-.71-8.49l.71-.71\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLightingBrightness3BrightAdjustBrightnessAdjustmentSunRaiseControlsDotSmall: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\".5\"/><path d=\"M7 12.5v-1m3.89-.61l-.71-.71M12.5 7h-1m-.61-3.89l-.71.71M7 1.5v1m-3.89.61l.71.71M1.5 7h1m.61 3.89l.71-.71\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLightingBrightness4BrightAdjustBrightnessAdjustmentSunRaiseControlsDot: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"3.25\"/><path d=\"M7 .5v1m0 11v1M13.5 7h-1m-11 0h-1m11.1-4.6l-.71.71m-7.78 7.78l-.71.71m9.2 0l-.71-.71M3.11 3.11L2.4 2.4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLightingLightBulbLightingLightIncandescentBulbLights: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 5A4.5 4.5 0 1 0 5 9v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V9a4.48 4.48 0 0 0 2.5-4ZM5 13.5h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLightingLightBulbOnLightingLightShineIncandescentBulbLights: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 8a3.5 3.5 0 1 0-5.06 3.12v1.72a.39.39 0 0 0 .39.38h2.34a.39.39 0 0 0 .39-.38v-1.75A3.5 3.5 0 0 0 10.5 8ZM7 .81v1.5m4-.07L9.94 3.31m3.34 2.03h-1.5M3 2.24l1.06 1.07M.72 5.34h1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLinkBrokenBreakBrokenHyperlinkLinkRemoveUnlink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.14 7.13L1.27 9a2.65 2.65 0 0 0 0 3.74h0a2.65 2.65 0 0 0 3.74 0l1.11-1.11M9 9.5h1.86a2.64 2.64 0 0 0 2.64-2.64h0a2.64 2.64 0 0 0-2.64-2.64H8.22M7 .5l-.5 2m-6 1l2 1m.5-4l1 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLinkCreateHyperlinkLinkMakeUnlink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 6.49L.79 9.67a1 1 0 0 0 0 1.42l2.12 2.12a1 1 0 0 0 1.42 0L7.51 10M10 7.51l3.18-3.18a1 1 0 0 0 0-1.42L11.09.79a1 1 0 0 0-1.42 0L6.49 4M9 5L5 9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLockCircleCircleFrameKeyKeyholeLockLockedSecureSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><circle cx=\"7\" cy=\"6\" r=\"1.5\"/><path d=\"M7 7.5v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLockCombinationComboLockLockedPadlockSecureSecurityShieldKeyhole: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"8\" x=\"2\" y=\"5.5\" rx=\"1\"/><path d=\"M10.5 5.5V4a3.5 3.5 0 0 0-7 0v1.5\"/><circle cx=\"7\" cy=\"9.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLockShieldCombinationComboLockLockedPadlockSecureSecurityShieldKeyhole: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.36 13.4h0a1 1 0 0 1-.72 0h0A9.59 9.59 0 0 1 .5 4.46V1.54a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.92a9.59 9.59 0 0 1-6.14 8.94Z\"/><circle cx=\"7\" cy=\"5.04\" r=\"1.5\"/><path d=\"M7 9.04v-2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLoginArrowEnterFrameLeftLoginPointRectangle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 10v2.5a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1V4m3 3h-8\"/><path d=\"m6.5 5l-2 2l2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLoginCircleArrowEnterLeftLoginPointCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 7h-8m2-2l-2 2l2 2\"/><path d=\"M12.48 10.5a6.5 6.5 0 1 1 0-7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLoginDialPad1DialPadDot: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2\" cy=\"2\" r=\"1.5\"/><circle cx=\"2\" cy=\"7\" r=\"1.5\"/><circle cx=\"7\" cy=\"2\" r=\"1.5\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><circle cx=\"7\" cy=\"12\" r=\"1.5\"/><circle cx=\"12\" cy=\"2\" r=\"1.5\"/><circle cx=\"12\" cy=\"7\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLoginDialPad2DialPadDot: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2\" cy=\"2\" r=\"1.5\"/><circle cx=\"2\" cy=\"7\" r=\"1.5\"/><circle cx=\"7\" cy=\"2\" r=\"1.5\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><circle cx=\"7\" cy=\"12\" r=\"1.5\"/><circle cx=\"12\" cy=\"2\" r=\"1.5\"/><circle cx=\"12\" cy=\"7\" r=\"1.5\"/><circle cx=\"2\" cy=\"12\" r=\"1.5\"/><circle cx=\"12\" cy=\"12\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLoginDialPadFingerPasswordDialPadDotFinger: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5V8.25A1.25 1.25 0 0 1 8.25 7h0A1.25 1.25 0 0 1 9.5 8.25V11h2a2 2 0 0 1 2 2v.5\"/><circle cx=\"1\" cy=\"1\" r=\".5\"/><circle cx=\"5\" cy=\"1\" r=\".5\"/><circle cx=\"9\" cy=\"1\" r=\".5\"/><circle cx=\"1\" cy=\"4.5\" r=\".5\"/><circle cx=\"5\" cy=\"4.5\" r=\".5\"/><circle cx=\"9\" cy=\"4.5\" r=\".5\"/><circle cx=\"1\" cy=\"8\" r=\".5\"/><path d=\"M5 8.5a.5.5 0 0 1 0-1Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLoginKeyEntryKeyLockLoginPassUnlock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.62 7.38L11.5 1.5l2 2m-4.25.25L11 5.5\"/><circle cx=\"3.5\" cy=\"9.5\" r=\"3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLoginPasswordLockLoginPadlockPasswordSecureSecurityTextboxType: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"7\" x=\".5\" y=\"3.5\" rx=\"1\"/><circle cx=\"3.5\" cy=\"7\" r=\".5\"/><circle cx=\"6.5\" cy=\"7\" r=\".5\"/><path d=\"M9.5 8H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLogoutCircleArrowEnterRightLogoutPointCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 7h7m-2-2l2 2l-2 2\"/><path d=\"M11.7 11.49a6.5 6.5 0 1 1 0-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePadLockShieldCombinationComboLockLockedPadlockSecureSecurityShieldSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.36 13.43h0a1 1 0 0 1-.72 0h0a9.67 9.67 0 0 1-6.14-9V1.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.92a9.67 9.67 0 0 1-6.14 9.01Z\"/><rect width=\"5\" height=\"4\" x=\"4.5\" y=\"5.5\" rx=\"1\"/><path d=\"M8.5 5.5v-1a1.5 1.5 0 1 0-3 0v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerButtonLoop1MultimediaMultiButtonRepeatMediaLoopInfinityControls: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 10a2.75 2.75 0 0 0 3-3a2.75 2.75 0 0 0-3-3c-2.75 0-4.25 6-7 6a2.75 2.75 0 0 1-3-3a2.75 2.75 0 0 1 3-3c2.75 0 4.25 6 7 6Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerButtonLoop2MultimediaMultiButtonRepeatMediaLoopInfinityControls: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 9.43a2.37 2.37 0 0 1-1.5.57a2.75 2.75 0 0 1-3-3a2.75 2.75 0 0 1 3-3c2.75 0 4.25 6 7 6a2.75 2.75 0 0 0 3-3a2.75 2.75 0 0 0-3-3a2.37 2.37 0 0 0-1.45.57\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerFitScreenFitScreenAdjustDisplayArtboardFrameCorner: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 .5H1a.5.5 0 0 0-.5.5v4m13 0V1a.5.5 0 0 0-.5-.5H9m0 13h4a.5.5 0 0 0 .5-.5V9M.5 9v4a.5.5 0 0 0 .5.5h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerLoading1ProgressLoadingLoadWaitWaiting: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .88v2.5m-5 0l1.84 1.69M1 8.88l2.42-.9m.97 5.14l1.11-2.24m6.5-7.5l-1.84 1.69M13 8.88l-2.42-.9m-.97 5.14L8.5 10.88\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerLoading2ProgressLoadingLineLoadWaitWaiting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5\" height=\"4\" x=\".5\" y=\"5\" rx=\".5\"/><rect width=\"3\" height=\"4\" x=\"8\" y=\"5\" rx=\".5\"/><path d=\"M13.5 5v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerLoading3ProgressLoadingDotLoadWaitWaiting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><circle cx=\"12.25\" cy=\"7\" r=\"1.25\"/><circle cx=\"1.75\" cy=\"7\" r=\"1.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerLoadingHalfProgressLoadingLoadHalfWaitWaiting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 1 6.21-8.41M13.5 7v.5\"/><path stroke-dasharray=\".889 1.778\" d=\"M13.11 9.23a6.51 6.51 0 0 1-2.79 3.36\"/><path d=\"m9.53 13l-.47.18\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerScrollLeftRighMoveScrollHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m9 2.25l4.39 4.49a.36.36 0 0 1 0 .52L9 11.75m-4-9.5L.61 6.74a.36.36 0 0 0 0 .52L5 11.75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerScrollUpDownMoveScrollVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.25 5L6.74.61a.36.36 0 0 1 .52 0L11.75 5m-9.5 4l4.49 4.39a.36.36 0 0 0 .52 0L11.75 9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePageControllerSettingsPageSettingSquareTriangleCircleLineCombinationVariation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 1h5v5h-5zm12.75 12.5h-5m0-5h5m-5 2.5h5m.25-5H8L10.75.5L13.5 6z\"/><circle cx=\"3\" cy=\"11\" r=\"2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceRemove2DeleteBoxSubtractButtonsButtonRemoveTextboxTextAddBold: Icon = {
  "body": "<rect width=\"13\" height=\"3\" x=\".5\" y=\"5.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" rx=\"1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceRemoveCircleDeleteAddCircleSubtractButtonButtonsRemove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M4 7h6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceRemoveSquareSubtractButtonsRemoveAddButtonSquareDelete: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 7h6\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSearchCircleCircleGlassSearchMagnifying: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><circle cx=\"6.5\" cy=\"6.5\" r=\"2.5\"/><path d=\"M10 10L8.27 8.27\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSearchGlassSearchMagnifying: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5.92\" cy=\"5.92\" r=\"5.42\"/><path d=\"M13.5 13.5L9.75 9.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSearchSquareGlassSearchSquareMagnifying: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6.5\" cy=\"6.5\" r=\"2.5\"/><path d=\"M10 10L8.27 8.27\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSecurityFireWallCodeFirewallProgrammingSecureSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7.5h13v6H.5z\"/><path d=\"M7 .5S8.5 3 6.5 4C5.5 4.5 4 3 4 3a3.18 3.18 0 0 0 3 4.5A3.34 3.34 0 0 0 10.5 4A3.34 3.34 0 0 0 7 .5Zm-6.5 10h13m-8 0v3m3-6v3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSecurityShield1ShieldProtectionSecurityDefendCrimeWarCover: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.36 13.43h0a1 1 0 0 1-.72 0h0A9.57 9.57 0 0 1 .5 4.49v-3a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v3a9.57 9.57 0 0 1-6.14 8.94Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSecurityShield2ShieldProtectionSecurityDefendCrimeWarCover: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m7.92 13.21l-.59.23a.94.94 0 0 1-.66 0l-.59-.23A8 8 0 0 1 1 5.78V3A6.36 6.36 0 0 0 7 .5c1.25 1.82 3.32 2.68 6 2.5v2.78a8 8 0 0 1-5.08 7.43Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSecurityShield3ShieldPayProductSecureMoneyCashCurrencySecurityBusiness: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 6.94a5.64 5.64 0 0 1-3.13 5L7 13.5L4.13 12A5.64 5.64 0 0 1 1 6.94V1.5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z\"/><path d=\"M5.5 8A1.5 1.5 0 0 0 7 9.5A1.4 1.4 0 0 0 8.5 8c0-1.5-3-1.5-3-3A1.4 1.4 0 0 1 7 3.5A1.5 1.5 0 0 1 8.5 5M7 3.5v-1m0 8v-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSecurityShield4ShieldProtectionSecurityDefendCrimeWarCover: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.36 13.43h0a1 1 0 0 1-.72 0h0A9.57 9.57 0 0 1 .5 4.49V1.88a.51.51 0 0 1 .36-.49a21.57 21.57 0 0 1 12.28 0a.51.51 0 0 1 .36.49v2.61a9.57 9.57 0 0 1-6.14 8.94Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSecurityShieldPersonshieldSecureSecurityPerson: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"2.75\" r=\"2.25\"/><path d=\"M6 6.61A4.49 4.49 0 0 0 .5 11v1.5H6m4.67.97h0a.5.5 0 0 1-.34 0h0A4.48 4.48 0 0 1 7.5 9.31V8a.47.47 0 0 1 .5-.5h5a.47.47 0 0 1 .5.5v1.31a4.48 4.48 0 0 1-2.83 4.16Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSecurityShieldProfileshieldSecureSecurityProfilePerson: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.36 13.43h0a1 1 0 0 1-.72 0h0a9.67 9.67 0 0 1-6.14-9V1.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.92a9.67 9.67 0 0 1-6.14 9.01Z\"/><circle cx=\"7\" cy=\"5.5\" r=\"2.5\"/><path d=\"M3.25 11.19a5 5 0 0 1 7.5 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingCogWorkLoadingCogGearSettingsMachine: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.23 2.25l.43-1.11A1 1 0 0 1 6.59.5h.82a1 1 0 0 1 .93.64l.43 1.11l1.46.84l1.18-.18a1 1 0 0 1 1 .49l.4.7a1 1 0 0 1-.08 1.13l-.73.93v1.68l.75.93a1 1 0 0 1 .08 1.13l-.4.7a1 1 0 0 1-1 .49l-1.18-.18l-1.46.84l-.43 1.11a1 1 0 0 1-.93.64h-.84a1 1 0 0 1-.93-.64l-.43-1.11l-1.46-.84l-1.18.18a1 1 0 0 1-1-.49l-.4-.7a1 1 0 0 1 .08-1.13L2 7.84V6.16l-.75-.93a1 1 0 0 1-.08-1.13l.4-.7a1 1 0 0 1 1-.49l1.18.18ZM5 7a2 2 0 1 0 2-2a2 2 0 0 0-2 2Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingGaugeDashboard1BarSpeedTestLoadingDashboardInternetGaugeProgress: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"m10 4.5l-3 5m-6 0h12\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingGaugeDashboard2BarSpeedTestLoadingDashboardInternetGaugeProgress: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m10 6.5l-3 5m6 0a6.5 6.5 0 1 0-12 0Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingHammerConstructionHammerMalletToolToolsSettingEditAdjust: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5.66\" height=\"9.66\" x=\"5.67\" y=\".67\" rx=\"1\" transform=\"rotate(-45 8.498 5.5)\"/><path d=\"M.91 11.09a1.41 1.41 0 0 0 2 2L7.5 8.5l-2-2Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenu1AlternateButtonParallelHorizontalLinesMenuNavigationTwoThick: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"4\" x=\"1.5\" y=\"9.61\" rx=\"1\"/><rect width=\"11\" height=\"4\" x=\"1.5\" y=\".61\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenu1ButtonParallelHorizontalLinesMenuNavigationThreeHamburger: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 2H.5m13 5H.5m13 5H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenu2AlternateButtonParallelHorizontalLinesMenuNavigationStaggeredThick: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"9\" height=\"4\" x=\".5\" y=\"1.5\" rx=\"1\"/><rect width=\"9\" height=\"4\" x=\"4.5\" y=\"8.5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenu2ButtonParallelHorizontalLinesMenuNavigationStaggeredThreeHamburger: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 2H6m5 5H3.5m5 5h-8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenuHorizontalCircleNavigationDotsThreeCircleButtonHorizontalMenu: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><circle cx=\"7\" cy=\"7\" r=\".5\"/><circle cx=\"4\" cy=\"7\" r=\".5\"/><circle cx=\"10\" cy=\"7\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenuHorizontalNavigationDotsThreeCircleButtonHorizontalMenu: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"7\" r=\"1.5\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><circle cx=\"2\" cy=\"7\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenuHorizontalSquareNavigationDotsThreeSquareButtonHorizontalMenu: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><circle cx=\"7\" cy=\"7\" r=\".5\"/><circle cx=\"4\" cy=\"7\" r=\".5\"/><circle cx=\"10\" cy=\"7\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenuParallelHamburgerCircleNavigationParallelHamburgerButtonmenuCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M4.5 4.5h5M4.5 7h5m-5 2.5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenuParallelHamburgerSquareNavigationParallelHamburgerButtonmenuSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M4.5 4.5h5M4.5 7h5m-5 2.5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingMenuVerticalNavigationVerticalThreeCircleButtonMenuDots: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"2\" r=\"1.5\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><circle cx=\"7\" cy=\"12\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingPieChartCogSettingGraphCog: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m5.23 2.25l.43-1.11A1 1 0 0 1 6.59.5h.82a1 1 0 0 1 .93.64l.43 1.11l1.46.84l1.18-.18a1 1 0 0 1 1 .49l.4.7a1 1 0 0 1-.08 1.13l-.73.93v1.68l.75.93a1 1 0 0 1 .08 1.13l-.4.7a1 1 0 0 1-1 .49l-1.18-.18l-1.46.84l-.43 1.11a1 1 0 0 1-.93.64h-.84a1 1 0 0 1-.93-.64l-.43-1.11l-1.46-.84l-1.18.18a1 1 0 0 1-1-.49l-.4-.7a1 1 0 0 1 .08-1.13L2 7.84V6.16l-.75-.93a1 1 0 0 1-.08-1.13l.4-.7a1 1 0 0 1 1-.49l1.18.18Z\"/><circle cx=\"7\" cy=\"7\" r=\"3\"/><path d=\"M7 4v3h3M7 7L4.88 9.12\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingScrewdriverScrewdriverScrewToolSettingsHand: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.85 7.037L6.973 9.16a.49.49 0 0 1 0 .693l-3.125 3.125a2 2 0 0 1-2.829 0h0a2 2 0 0 1 0-2.828l3.126-3.126a.49.49 0 0 1 .707.014ZM5.91 8.09l4.48-4.48m.35.34l-.69-.69V1.88L12.12.5l1.38 1.38l-1.38 2.07h-1.38z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingSlideHorizontalAdjustmentAdjustControlsFaderHorizontalSettingsSlider: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5.5\" cy=\"7\" r=\"2\"/><path d=\"M1.5 7h-1m9 0h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingSliderHorizontalAdjustmentAdjustControlsFaderHorizontalSettingsSlider: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2\" cy=\"2\" r=\"1.5\"/><path d=\"M3.5 2h10\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><path d=\"M.5 7h5m3 0h5\"/><circle cx=\"12\" cy=\"12\" r=\"1.5\"/><path d=\"M10.5 12H.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingSliderHorizontalSquareAdjustControlsFaderHorizontalSettingsSliderSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M3 4.5h5\"/><circle cx=\"9.5\" cy=\"4.5\" r=\"1.5\"/><path d=\"M11 9.5H8m-3 0H3\"/><circle cx=\"6.5\" cy=\"9.5\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingSliderVerticalAdjustmentAdjustControlsFaderVerticalSettingsSlider: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2\" cy=\"4.5\" r=\"1.5\"/><path d=\"M2 6v7.5m0-13V3\"/><circle cx=\"12\" cy=\"4.5\" r=\"1.5\"/><path d=\"M12 3V.5m0 13V6\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><path d=\"M7 .5v5m0 3v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingSliderVerticalAdjustmentAdjustControlsFaderVerticalSettingsSlider1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"5.5\" r=\"2\"/><path d=\"M7 1.5v-1m0 9v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingSliderVerticalAdjustmentAdjustControlsFaderVerticalSettingsSliderSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\" transform=\"rotate(-90 7 7)\"/><path d=\"M4.5 11V6\"/><circle cx=\"4.5\" cy=\"4.5\" r=\"1.5\"/><path d=\"M9.5 3v3m0 3v2\"/><circle cx=\"9.5\" cy=\"7.5\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingToolBoxBoxBriefcaseToolSettings: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"4.5\" rx=\"1\"/><path d=\"M.5 8.5h13M7 7.5v2m3-5a3 3 0 0 0-3-3h0a3 3 0 0 0-3 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingWrenchCrescentToolConstructionToolsWrenchSettingEditAdjust: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.43 3.59a.76.76 0 0 0-.35-.51l-2 2a1 1 0 0 1-1.44 0l-.76-.68a1 1 0 0 1 0-1.4l2-2a.76.76 0 0 0-.48-.43A3.8 3.8 0 0 0 6.26 6L.8 11.41a1 1 0 0 0 0 1.43l.36.36a1 1 0 0 0 1.43 0l5.46-5.45a3.81 3.81 0 0 0 5.38-4.16Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSettingZoomAreaZoomMagnifierSquareArea: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h1a1 1 0 0 1 1 1v1m-13 0v-1a1 1 0 0 1 1-1h1m3 0h3m5 5v2.75M.5 5.5v3m0 3v1a1 1 0 0 0 1 1h1m3 0h2.75\"/><circle cx=\"8\" cy=\"8\" r=\"3.5\"/><path d=\"M10.47 10.47L13 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceShareHandLockGiveHandLockPadlockSecureSecurityTransfer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"6\" height=\"4.5\" x=\"7.5\" y=\"3.5\" rx=\".5\"/><path d=\"M8.5 3.5v-1a2 2 0 0 1 4 0v1m-12 5h3A2.5 2.5 0 0 1 6 11h0m-3 0h5a2 2 0 0 1 2 2h0a.5.5 0 0 1-.5.5h-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceShareMegaPhone1BullhornLoudMegaphoneShareSpeakerTransmit: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.84 12.07L1.17 8a1 1 0 0 1-.67-.91V6a1 1 0 0 1 .67-.94L12.84 1a.5.5 0 0 1 .66.47V11.6a.5.5 0 0 1-.66.47Zm-4.36-1.5A2.75 2.75 0 0 1 3 10.25V8.66\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceShareSatelliteBroadcastSatelliteShareTransmit: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 9A6 6 0 0 1 5 .5ZM9.26 4.74L12 2\"/><path d=\"M3.96 7.57L.5 13.5H7L5.92 9.73\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceShareShareTransmit: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2.75\" cy=\"7\" r=\"2.25\"/><circle cx=\"11.25\" cy=\"11.25\" r=\"2.25\"/><circle cx=\"11.25\" cy=\"2.75\" r=\"2.25\"/><path d=\"m4.76 6l4.48-2.25M4.76 8l4.48 2.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceShareUserHumanPersonShareSignalTransmitUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"6.75\" r=\"2.25\"/><path d=\"M11 13.5a4.5 4.5 0 0 0-8 0\"/><path d=\"M12 10.56a6.25 6.25 0 1 0-9.92 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSignalGraphCircleCircleStatsGraphLineBeatHeart: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7.01h4L6 4.5L7.5 10l2-2.99h4M12.77 4A6.51 6.51 0 0 0 1.23 4m0 6a6.51 6.51 0 0 0 11.54 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSignalSquareHeartLineStatsBeatSquareGraph: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"M2.5 7.02h2L6 4.51l1.5 5.5l2-2.99h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingBoldTextBoldFormattingFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 3.5a3 3 0 0 0-3-3H4a1 1 0 0 0-1 1v5h5a3 3 0 0 0 3-3Zm1 6.5a3.5 3.5 0 0 1-3.5 3.5H4a1 1 0 0 1-1-1v-6h5.5A3.5 3.5 0 0 1 12 10Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingEraserTextRemoveFormatFormattingEraserDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 13.5h10m-1.18-7.29a.94.94 0 0 0 0-1.35L8.25.78a1 1 0 0 0-1.36 0L.78 6.89a1 1 0 0 0 0 1.36l2.44 2.43a.92.92 0 0 0 .67.29h3.28a.92.92 0 0 0 .68-.29Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingFilter1FunnelFilterRoundOil: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5H.5a6.51 6.51 0 0 0 5 6.33v6.67l3-2V6.83a6.51 6.51 0 0 0 5-6.33Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingFontSizeSizeTextFormattingFontFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m6.5 12.5l3.14-7.33a.39.39 0 0 1 .72 0l3.14 7.33M7.91 9.21h4.18M.5 12.5L5.07 1.84a.57.57 0 0 1 1 0L7 3.94M2.55 7.72H5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingImageBottomInsertParagraphBottomImageTextAlignFormatting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 6.5h-9m13-3H.5m13-3H.5\"/><rect width=\"4\" height=\"13\" x=\"5\" y=\"5\" rx=\".5\" transform=\"rotate(-90 7 11.5)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingImageLeftAlignmentWrapFormattingParagraphImageLeftText: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 1H9m4.5 3H9m4.5 3H9m4.5 6H.5m13-3H.5\"/><rect width=\"6\" height=\"6\" x=\".5\" y=\"1\" rx=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingImageRightParagraphImageTextAlignmentWrapRightFormatting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 1H5M.5 4H5M.5 7H5M.5 13h13m-13-3h13\"/><rect width=\"6\" height=\"6\" x=\"7.5\" y=\"1\" rx=\".5\" transform=\"rotate(-180 10.5 4)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingImageTopInsertParagraphImageTextAlignTopFormatting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 13.5h-9m13-3H.5m13-3H.5\"/><rect width=\"4\" height=\"13\" x=\"5\" y=\"-4\" rx=\".5\" transform=\"rotate(-90 7 2.5)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingIndentDecreaseTextAlignmentIndentParagraphAlignFormattingDecrease: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H.5m13 4H6m7.5 4H6m7.5 4H.5m2-8L1 7l1.5 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingIndentIncreaseAlignmentAlignIndentParagraphIncreaseFormattingText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H.5m13 4H6m7.5 4H6m7.5 4H.5M2 5l2 2l-2 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingIndentLeftAlignmentAlignIndentParagraphFormattingLeftText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1.5h-6m4 4h-4m6 4h-6m4 4h-4M.5 5l2 2l-2 2M5 13.5V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingIndentRightAlignmentAlignIndentParagraphFormattingRightText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 1.5h6m-4 4h4m-6 4h6m-4 4h4m7-8.5l-2 2l2 2M9 13.5V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingItalicOffTextOffFormattingItalicFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.24 6.24L4 13.5m-2.5 0h5M5 .5h7.5a1 1 0 0 1 1 1V3M.5.5l13 13M8 .5L7.23 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingItalicTextFormattingItalicFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.5 13.5l5-13m-4 0H13m-12 13h7.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingJustifiedAlignJustifiedAlignAlignmentParagraphFormattingText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H.5m13 3H.5m13 3H.5m13 6H.5m13-3H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingListBulletsPointsBulletUnorderedListListsBullets: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"1\" cy=\"2.5\" r=\".5\"/><path d=\"M4.5 2.5h9\"/><circle cx=\"1\" cy=\"7\" r=\".5\"/><path d=\"M4.5 7h9\"/><circle cx=\"1\" cy=\"11.5\" r=\".5\"/><path d=\"M4.5 11.5h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingParagraphArticleAlignmentFormattingNormalParagraphText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H5m8.5 3H.5m13 3H.5m9 6h-9m13-3H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingParagraphBulletsPointsBulletAlignParagraphFormattingBulletsText: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 1H8m5.5 3H8m5.5 3H8m5.5 6H8m5.5-3H8\"/><rect width=\"5\" height=\"5\" x=\".5\" y=\"1\" rx=\".5\" transform=\"rotate(-90 3 3.5)\"/><rect width=\"5\" height=\"5\" x=\".5\" y=\"8\" rx=\".5\" transform=\"rotate(-90 3 10.5)\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingParagraphColumnTextAlignmentFormattingParagraphColumnsColumnTwo: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 1H2m3.5 3h-5m5 3h-5m5 6h-5m5-3h-5m13-9h-5m5 3h-5m5 3h-5m3.5 6H8.5m5-3h-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingQuotation1QuoteQuotationFormatFormattingOpenCloseMarksText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.07 7a3.82 3.82 0 0 1 0-4m3.01 4a3.82 3.82 0 0 1 0-4m8.85 8a3.82 3.82 0 0 0 0-4m-3.01 4a3.82 3.82 0 0 0 0-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingQuotation2QuoteQuotationFormatFormattingOpenCloseMarksText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.18 5.44a1 1 0 0 1 .42.81a.9.9 0 0 1-1.1 1C.54 7 .09 5.57 1 3.25m4.7 2.19a1 1 0 0 1 .43.81a.9.9 0 0 1-1.1 1c-1-.19-1.41-1.66-.53-4m7.32 5.31a1 1 0 0 1-.42-.81a.9.9 0 0 1 1.1-1c1 .19 1.41 1.66.52 4M8.3 8.56a1 1 0 0 1-.43-.81a.9.9 0 0 1 1.1-1c1 .19 1.41 1.66.53 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingQuotation3QuoteQuotationFormatFormattingOpenCloseMarksText: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.08 7.25a3.82 3.82 0 0 1 0-4\"/><circle cx=\"4.45\" cy=\"6.92\" r=\".5\"/><path d=\"M1.07 7.25a3.82 3.82 0 0 1 0-4\"/><circle cx=\"1.44\" cy=\"6.92\" r=\".5\"/><path d=\"M9.92 6.75a3.82 3.82 0 0 1 0 4\"/><circle cx=\"9.55\" cy=\"7.08\" r=\".5\"/><path d=\"M12.93 6.75a3.82 3.82 0 0 1 0 4\"/><circle cx=\"12.56\" cy=\"7.08\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingSigmaFormulaTextFormatSigmaFormattingSum: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5H1a.5.5 0 0 1-.46-.31a.47.47 0 0 1 .11-.54l5.29-5.3a.5.5 0 0 0 0-.7L.65 1.35A.47.47 0 0 1 .54.81A.5.5 0 0 1 1 .5h12.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingStrikeThroughTextStrikeThroughFormattingFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.08 8.67a2.73 2.73 0 0 1-.42 3.95a5.06 5.06 0 0 1-5.37.21l-.9-.51m6.61-11C8 .33 4.23-.26 3.38 2.54a2.47 2.47 0 0 0 .55 2.38a11.8 11.8 0 0 0 2.6 1.54M.5 6.5h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingSubScriptTextFormattingSubscriptFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1 .5l7 8m0-8l-7 8m9.5 2.5v-.25a1.25 1.25 0 0 1 1.25-1.25h0A1.25 1.25 0 0 1 13 10.75a1.58 1.58 0 0 1-.59 1.25l-1.91 1.5H13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingSuperScriptTextFormattingSuperscriptFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1 5.5l7 8m0-8l-7 8M10.5 2v-.25A1.25 1.25 0 0 1 11.75.5h0A1.25 1.25 0 0 1 13 1.75A1.58 1.58 0 0 1 12.41 3L10.5 4.5H13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTextBarTextBarFormattingFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 13.5H9a2 2 0 0 1-2-2a2 2 0 0 1-2 2H3.5m7-13H9a2 2 0 0 0-2 2a2 2 0 0 0-2-2H3.5m3.5 2v9M4.5 8h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTextSquareTextOptionsFormattingFormatSquareColorBorderFill: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.5 10.78l3.14-7.33a.39.39 0 0 1 .72 0l3.14 7.33M4.69 8h4.62\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTextStrikeThroughTextStrikeThroughFormattingFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5V5m-2.5 8.5h5M1.5 3V1.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1V3m-11 4.5h11M7 7.5v6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTextTextOptionsFormattingFormatColor: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.5h13M2.14 11L6.5.83a.54.54 0 0 1 1 0L11.86 11M4.07 6.5h5.86\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTextToSpeech1SpeechAutomatedTranslateLanguageVoiceTechnology: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.5 13.5l3.14-7.33a.39.39 0 0 1 .72 0l3.14 7.33m-5.59-3.29h4.18M.5 4A3.5 3.5 0 0 1 4 .5\"/><path d=\"M.5 4A3.5 3.5 0 0 1 4 .5M3 4a1 1 0 0 1 1-1\"/><path d=\"M3 4a1 1 0 0 1 1-1m6-2.5A3.5 3.5 0 0 1 13.5 4\"/><path d=\"M10 .5A3.5 3.5 0 0 1 13.5 4M10 3a1 1 0 0 1 1 1\"/><path d=\"M10 3a1 1 0 0 1 1 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTextToSpeech2SpeechAutomatedTranslateLanguageVoiceTechnology: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 7.5h8m-4-2v2m-2.5 0c0 2.32 2.16 4.28 5 6\"/><path d=\"M9.5 7.5c.05 2.32-2.16 4.28-5 6M.5 4A3.5 3.5 0 0 1 4 .5\"/><path d=\"M.5 4A3.5 3.5 0 0 1 4 .5M3 4a1 1 0 0 1 1-1\"/><path d=\"M3 4a1 1 0 0 1 1-1m6-2.5A3.5 3.5 0 0 1 13.5 4\"/><path d=\"M10 .5A3.5 3.5 0 0 1 13.5 4M10 3a1 1 0 0 1 1 1\"/><path d=\"M10 3a1 1 0 0 1 1 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTranslateOptionsTextTranslate: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m6.5 13.5l3.14-7.33a.39.39 0 0 1 .72 0l3.14 7.33m-5.59-3.29h4.18M.5 2.5h9M5 .5v2m3 0l-6 7m0-7l3.94 4.6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingUnderlineTextUnderlineFormattingFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5v6.75a4.25 4.25 0 0 0 4.25 4.25h0A4.25 4.25 0 0 0 11 7.25V.5m-9.5 13h11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeAlarmNotificationAlertBellWakeClockAlarm: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"8\" r=\"5.5\"/><path d=\"M5.5.5h3M7 .5v2M5.5 6L7 8h2.5M12 2l1 1M2 2L1 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeClockCircleClockLoadingMeasureTimeCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 4.5V7l2.54 2.96\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeClockHandHandClockTimeGiveHumanPerson: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.28 5.25a4.5 4.5 0 1 1 7.93 3.38\"/><path d=\"M8.75 3.75v2h1.5m-9.5 2h4a2.5 2.5 0 0 1 2.5 2.5h0m-3 0h5a2 2 0 0 1 2 2h0a.5.5 0 0 1-.5.5h-10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeClockNineToFiveWorkHourTimeClock: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 12v1.5m-3.54-2.96L2.4 11.6M7 .5A6.5 6.5 0 0 0 .5 7H7l4.6 4.6A6.51 6.51 0 0 0 7 .5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeClockSquareClockLoadingFrameMeasureTimeCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"4\"/><path d=\"M7 5.5V7h1.5\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeHourGlassHourglassLoadingMeasureClockTime: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 3.5a3.5 3.5 0 0 1-7 0v-3h7Z\"/><path d=\"M10.5 10.5a3.5 3.5 0 0 0-7 0v3h7Zm-9-10h11m-11 13h11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeMidnightWholeMidnightHourClockTime: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 7H.5m2.96-3.54L2.4 2.4m1.06 8.14L2.4 11.6M12 7h1.5m-2.96 3.54l1.06 1.06M7 12v1.5m3.54-10.04L11.6 2.4M7 2V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeNineThreeQuartersFourtyFiveClockMinutesNineTimeHour: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7A6.5 6.5 0 1 0 7 .5V7Zm2.96-3.54L2.4 2.4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeResetTimeClockResetStopwatchCircleMeasureLoading: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5A6.5 6.5 0 1 1 .5 7a7.23 7.23 0 0 1 2-5\"/><path d=\"m.5 2.5l2-.5l.5 2m4-.5v4l2.6 1.3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeRewindBackReturnClockTimerCountdown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7A6.5 6.5 0 1 0 7 .5a7.23 7.23 0 0 0-5 2\"/><path d=\"m2.5.5l-.5 2L4 3m3 .5v4L4.4 8.8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeSixHourClockTimeMinutesHalfThirtySix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5a6.5 6.5 0 0 0 0-13ZM2 7H.5m2.96-3.54L2.4 2.4m1.06 8.14L2.4 11.6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeSleepNapSleepRestBreakClock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 7A6.5 6.5 0 1 1 7 .5\"/><path d=\"M7 4.5V7L4.46 9.96M10 .5h3.5l-3.5 4h3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeStopWatchAlternateTimerCountdownClock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5A6.5 6.5 0 1 1 13.5 7a7.23 7.23 0 0 1-2 5\"/><path d=\"m13.5 11.5l-2 .5l-.5-2M9 9L7 6.5H4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeStopWatchHalfQuarterSecondsThirtyHourHalfMeasureTimeStopwatch: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.75 2.5a5.5 5.5 0 0 1 0 11Zm-1.5-2h3m-1.5 0v2m5-.5l1 1M2.86 4.11l1.06 1.06M1.25 8h1.5m.11 3.89l1.06-1.06\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeStopWatchQuarterTimeFifteenQuarterStopwatchMinuteMeasureSeconds: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.75 8V2.5a5.5 5.5 0 0 1 5.5 5.5ZM5.25.5h3m-1.5 0v2m5-.5l1 1M2.86 4.11l1.06 1.06M1.25 8h1.5m.11 3.89l1.06-1.06M7 12v1.5m3.54-2.96l1.06 1.06\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeStopWatchSixtySecondMinuteTimeStopwatchMeasureHourWholeClock: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5.5h3M7 .5V4m-3.89.11l1.06 1.06M1.5 8H3m.11 3.89l1.06-1.06M7 13.5V12m3.89-.11l-1.06-1.06M12.5 8H11m-.11-3.89L9.83 5.17\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeStopWatchThirdQuarterQuartersTimeMeasureStopwatchThreeSecondsMinutes: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.75 2.5A5.5 5.5 0 1 1 1.25 8h5.5Zm-1.5-2h3m-1.5 2v-2m5 1.5l1 1M2.86 4.11l1.06 1.06\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeStopWatchTimerCountdownClock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 6.92a7.62 7.62 0 0 1-.74 3.21M7 13.42a6.5 6.5 0 0 1-6.5-6.5m8.5 2l-2-2.5H4\"/><circle cx=\"12\" cy=\"11.42\" r=\"1.5\"/><path d=\"M.92 4.52A6.31 6.31 0 0 1 1.79 3m1.93-1.72a6.3 6.3 0 0 1 1.81-.7m7.55 3.94A6.31 6.31 0 0 0 12.21 3m-1.93-1.72a6.3 6.3 0 0 0-1.81-.7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeThreeClockFifteenThreeQuarterMinutesTimeHour: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7A6.5 6.5 0 0 0 7 .5V7ZM2 7H.5m2.96-3.54L2.4 2.4m1.06 8.14L2.4 11.6M7 12v1.5m3.54-2.96l1.06 1.06\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTimeTimerTimeTockStopwatchMeasureClockTick: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"8\" r=\"5.5\"/><path d=\"M.5 2.5A8.69 8.69 0 0 1 3 .5m10.5 2a8.69 8.69 0 0 0-2.5-2M7 5v3h2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUnlinkBreakBrokenHyperlinkLinkRemoveUnlink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m8.54 9.7l2-2l2.12-2.12a3 3 0 0 0 0-4.24h0a3 3 0 0 0-4.24 0L7 2.76L5.46 4.3M3.5 6.26L1.38 8.38a3 3 0 0 0 0 4.24h0a3 3 0 0 0 4.24 0l1-1M4.17 2.05l5.66 9.9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUnlockCombinationComboKeyKeyholeLockSecureSecuritySquareUnlockUnlocked: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"8\" x=\"2\" y=\"5.5\" rx=\"1\"/><path d=\"M9.47 1.53A3.44 3.44 0 0 0 7 .5A3.5 3.5 0 0 0 3.5 4v1.5\"/><circle cx=\"7\" cy=\"9.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadBox1ArrowBoxDownloadInternetNetworkServerUpUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 13.5h-2a1 1 0 0 1-1-1v-8h13v8a1 1 0 0 1-1 1h-2\"/><path d=\"M4.5 10L7 7.5L9.5 10M7 7.5v6M11.29 1a1 1 0 0 0-.84-.5h-6.9a1 1 0 0 0-.84.5L.5 4.5h13ZM7 .5v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadButton1ArrowButtonDownloadInternetNetworkServerUpUpload: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 5h1a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 2 13V5.5a.5.5 0 0 1 .5-.5h1M7 7.5v-7m-2 2l2-2l2 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadButton2ArrowBottomDownloadInternetNetworkErverUpUpload: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 10.5v1a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1M4 4L7 .5L10 4M7 .5v9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadCircleArrowCircleDownloadInternetNetworkServerUpUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4 7l3-3.5L10 7M7 3.5v7\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadDesktopActionActionsComputerDesktopDeviceDisplayMonitorScreenUpload: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 3h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-7A.5.5 0 0 1 1 3h1m5 8v2.5m-2 0h4m-2-7v-6m-2 2l2-2l2 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadLaptopArrowComputerDownloadInternetLaptopNetworkServerUpUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m1.91 9.5l-1.3 2.55a1 1 0 0 0 0 1a1 1 0 0 0 .87.47h11a1 1 0 0 0 .87-.47a1 1 0 0 0 0-1L12.09 9.5ZM5 2.5l2-2l2 2m-2-2v6\"/><path d=\"M3 4.5a1 1 0 0 0-1 1v4h10v-4a1 1 0 0 0-1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadSquareArrowDownloadInternetNetworkServerSquareUpUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"m4 7l3-3.5L10 7M7 3.5v7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUploadWebsiteActionActionsComputerWebsiteDeviceDisplayUploadMonitorScreen: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 13.5h-2a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-2m-10-10h13M7 13.5V7\"/><path d=\"M4.5 9.5L7 7l2.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserAddActionsAddCloseGeometricHumanPersonPlusSingleUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"2.75\" r=\"2.25\"/><path d=\"M4.5 12.5h-4V11A4.51 4.51 0 0 1 7 7m3.5.5v6m-3-3h6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserBlockActionsBlockCloseDeniedDenyGeometricHumanPersonSingleUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"2.75\" r=\"2.25\"/><circle cx=\"10.25\" cy=\"10.25\" r=\"3.25\"/><path d=\"m7.95 12.55l4.6-4.6M6 6.61A4.49 4.49 0 0 0 .5 11v1.5h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserCheckActionsCloseCheckmarkCheckGeometricHumanPersonSingleSuccessUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m13.5 8l-4.12 5.5l-2.75-2.06\"/><circle cx=\"5\" cy=\"2.75\" r=\"2.25\"/><path d=\"M3 12.5H.5V11a4.5 4.5 0 0 1 7.68-3.18\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserCircleCircleGeometricHumanPersonSingleUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"5.5\" r=\"2.5\"/><path d=\"M2.73 11.9a5 5 0 0 1 8.54 0\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserDeleteActionsCloseDeleteDenyFailGeometricHumanPersonRemoveSingleUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"2.75\" r=\"2.25\"/><path d=\"M5 12.5H.5V11a4.5 4.5 0 0 1 6.73-3.91m6.27 2.17L9.26 13.5m0-4.24l4.24 4.24\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserEditActionsCloseEditGeometricHumanPencilPersonSingleUpUserWrite: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"2.75\" r=\"2.25\"/><path d=\"M3.5 12.5h-3V11A4.51 4.51 0 0 1 7 7m6.5 1.5l-4.71 4.71l-2.13.29l.3-2.13l4.7-4.71L13.5 8.5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserFullBodyGeometricHumanPersonSingleUpUserFullBody: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"2.5\" r=\"2\"/><path d=\"M10.5 8a3.5 3.5 0 0 0-7 0v1.5H5l.5 4h3l.5-4h1.5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserHomeHomeGeometricHumanPersonSingleUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"2.5\"/><path d=\"M2.73 13.4a5 5 0 0 1 8.54 0\"/><path d=\"M13.5 6.94a1 1 0 0 0-.32-.74L7 .5L.82 6.2a1 1 0 0 0-.32.74v5.56a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserHumanGeometricHumanPersonSingleUser: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 13.5V11h2a1 1 0 0 0 1-1V6a5.5 5.5 0 1 0-8 4.9v2.6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserLockActionsLockGeometricHumanPersonSingleUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"2.75\" r=\"2.25\"/><path d=\"M6 6.61A4.49 4.49 0 0 0 .5 11v1.5h4\"/><rect width=\"6\" height=\"4.5\" x=\"7.5\" y=\"9\" rx=\".5\"/><path d=\"M8.5 9V8a2 2 0 0 1 4 0v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserMultipleCloseGeometricHumanMultiplePersonUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"3.75\" r=\"2.25\"/><path d=\"M9.5 13.5h-9v-1a4.5 4.5 0 0 1 9 0ZM9 1.5A2.25 2.25 0 0 1 9 6m1.6 2.19a4.5 4.5 0 0 1 2.9 4.2v1.11H12\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserProfileFocusCloseGeometricHumanPersonProfileFocusUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"5.5\" r=\"2.5\"/><path d=\"M10.31 10.75a5 5 0 0 0-6.62 0m9.81-.25v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserRemoveActionsRemoveCloseGeometricHumanPersonMinusSingleUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"5\" cy=\"3.75\" r=\"2.25\"/><path d=\"M6.5 13.5h-6V12a4.5 4.5 0 0 1 7.39-3.45m.61 2.95h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserSingleCloseGeometricHumanPersonSingleUpUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"3.75\" r=\"3.25\"/><path d=\"M13.18 13.5a6.49 6.49 0 0 0-12.36 0Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceUserSquareAlternateSquareGeometricHumanPersonSingleUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"5.5\" r=\"2.5\"/><path d=\"M2.1 13.5a5 5 0 0 1 9.8 0\"/><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceValidationCheckCheckFormValidationCheckmarkSuccessAddAddition: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 8.55l2.73 3.51a1 1 0 0 0 .78.39a1 1 0 0 0 .78-.36L13.5 1.55\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceValidationCheckCircleCheckmarkAdditionCircleSuccessCheckValidationAddForm: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4 8l2.05 1.64a.48.48 0 0 0 .4.1a.5.5 0 0 0 .34-.24L10 4\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceValidationCheckSquare1CheckFormValidationCheckmarkSuccessAddAdditionBoxSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"m4 8l2.05 1.64a.48.48 0 0 0 .4.1a.5.5 0 0 0 .34-.24L10 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceValidationCheckSquare2CheckFormValidationCheckmarkSuccessAddAdditionBoxSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"m3 7l1.5 1.5L7 5m1 2.5h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherCelsiusDegreesTemperatureCentigradeCelsiusDegreeWeather: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2\" cy=\"2\" r=\"1.5\"/><path d=\"M13.5 1.84a6 6 0 1 0-2 11.66a6 6 0 0 0 2-.34\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherCloud1CloudMeteorologyCloudyOvercastCoverWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.726 5.706a2.34 2.34 0 0 0-.449 0a3.356 3.356 0 0 0-6.554 0a2.34 2.34 0 0 0-.45 0a2.614 2.614 0 1 0 0 5.219h7.453a2.613 2.613 0 1 0 0-5.219Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherCloud2CloudMeteorologyCloudyOvercastCoverWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 6.5a2.51 2.51 0 0 0-1.5.5h0A4.5 4.5 0 1 0 5 11.5h6a2.5 2.5 0 0 0 0-5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherCresentMoon1NightNewMoonCrescentWeatherTimeWaning: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 7a7 7 0 0 1 3.44-6A6.58 6.58 0 0 0 9 .5a6.5 6.5 0 0 0 0 13a6.58 6.58 0 0 0 2.47-.5A7 7 0 0 1 8 7Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherCresentMoon2NightNewMoonCrescentWaxingTimeWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 7a7 7 0 0 0-3.47-6A6.58 6.58 0 0 1 5 .5a6.5 6.5 0 1 1 0 13a6.58 6.58 0 0 1-2.47-.5A7 7 0 0 0 6 7Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherFahrenheitDegreesTemperatureFahrenheitDegreeWeather: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2.5\" cy=\"2\" r=\"1.5\"/><path d=\"M7 13.5v-12h6M7 7h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherFirstQuarterMoonNightMoonFirstHalfQuarterTimeWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75.5a6.5 6.5 0 0 1 0 13Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherGibbousMoon1NightMoonWeatherGibbousTimeWaning: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 7a6.5 6.5 0 0 0 6.5 6.5a6.58 6.58 0 0 0 1.19-.11a10 10 0 0 0 0-12.78A6.58 6.58 0 0 0 8.5.5A6.5 6.5 0 0 0 2 7Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherGibbousMoon2NightWaxingMoonGibbousTimeWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 7a6.5 6.5 0 0 1-6.5 6.5a6.58 6.58 0 0 1-1.19-.11a10 10 0 0 1 0-12.78A6.58 6.58 0 0 1 5.5.5A6.5 6.5 0 0 1 12 7Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherHumidityNoneHumidityDropWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13M4.85 13a4.5 4.5 0 0 0 6.65-4a5.48 5.48 0 0 0-.5-1.94M9.6 4.4C8.37 2.34 7 .5 7 .5S2.5 6.51 2.5 9a4.42 4.42 0 0 0 .5 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherHurricaneTwisterTornadoHurricaneCycloneDisasterNaturalWeather: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"7\" cy=\"3\" rx=\"6\" ry=\"2.5\"/><path d=\"M11.87 6.73c-.87.79-2.73 1.34-4.94 1.34A10.17 10.17 0 0 1 3 7.37m7.86 2.47a6.84 6.84 0 0 1-3.36.73a8.47 8.47 0 0 1-2.5-.35m5.37 3.22c-.95.21-1.83-.16-2-.83\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherLightning1CloudBoltStormWeatherThunderMeteorologyLightning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 7L6 10.5h3l-2 3\"/><path d=\"M11 8a2.5 2.5 0 1 0-.62-4.92a3.5 3.5 0 0 0-6.76 0A2.5 2.5 0 1 0 3 8h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherLightning2CloudBoltStormWeatherThunderMeteorologyLightning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.78 9.38A2.5 2.5 0 1 0 9.5 5h0a4.5 4.5 0 1 0-5.75 4.32\"/><path d=\"m8 8l-2 2.5h3l-2 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherMoonAstronomyMoonScienceSpaceCrescent: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 10.48A6.55 6.55 0 0 1 6.46.5a6.55 6.55 0 0 0 1 13A6.46 6.46 0 0 0 13 10.39a6.79 6.79 0 0 1-1 .09Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherRain1CloudRainRainyMeteorologyPrecipitationWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.25 11.5l.5-1m4 1l.5-1M6 13.5l.5-1m-5 1l.5-1m8.5 1l.5-1M11 8a2.5 2.5 0 1 0-.62-4.92a3.5 3.5 0 0 0-6.76 0A2.5 2.5 0 1 0 3 8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherRain2CloudRainRainyMeteorologyPrecipitationWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4 11.5l.5-1m4 1l.5-1m-3.25 3l.5-1m-5 1l.5-1m8.5 1l.5-1m-.5-4.5a2.5 2.5 0 0 0 0-5a2.54 2.54 0 0 0-1.57.55A3.75 3.75 0 1 0 5 8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherRainDropDropsRainRainyMeteorologyWaterPrecipitationWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 9C11.5 6.51 7 .5 7 .5S2.5 6.51 2.5 9a4.5 4.5 0 0 0 9 0Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherSnow1CloudSnowSnowfallOvercastWeatherPrecipitationMeteorology: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.25 10a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm-2 2.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm6-2.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75ZM5 12.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm5.75-2.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75ZM9 12.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm3.75 0a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Z\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 8a2.5 2.5 0 1 0-.62-4.92a3.5 3.5 0 0 0-6.76 0A2.5 2.5 0 1 0 3 8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherSnow2CloudSnowSnowfallOvercastWeatherPrecipitationMeteorology: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.25 10a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm-2 2.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm6-2.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75ZM5 12.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm5.75-2.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75ZM9 12.5a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Zm3.75 0a.75.75 0 1 0 .75.75a.76.76 0 0 0-.75-.75Z\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 8a2.5 2.5 0 0 0 0-5a2.54 2.54 0 0 0-1.57.55A3.75 3.75 0 1 0 5.25 8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherSun1CloudMeteorologyCloudyPartlySunnyWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 1.93a3 3 0 0 1 4.5 2.57a3.12 3.12 0 0 1-.21 1.11m-2.317 1.56a3.421 3.421 0 0 0-.46 0a3.43 3.43 0 0 0-6.71 0c-.15-.01-.3-.01-.45 0a2.67 2.67 0 1 0 0 5.33h7.62a2.67 2.67 0 0 0 0-5.33v0Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherSun2CloudMeteorologyCloudyPartlySunnyWeather: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 8.5a2.51 2.51 0 0 0-1.5.5h0A4.5 4.5 0 1 0 5 13.5h6a2.5 2.5 0 0 0 0-5Z\"/><circle cx=\"11.25\" cy=\"2.75\" r=\"2.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherSunPhotosLightCameraModeBrightnessSunPhotoFull: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"2.5\"/><path d=\"m13.5 7l-2.34 1.72l.44 2.88l-2.88-.44L7 13.5l-1.72-2.34l-2.88.44l.44-2.88L.5 7l2.34-1.72L2.4 2.4l2.88.44L7 .5l1.72 2.34l2.88-.44l-.44 2.88L13.5 7z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherTemperatureColdTemperatureThermometerMinusMercuryColdWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 9V2A1.5 1.5 0 0 0 10 .5h0A1.5 1.5 0 0 0 8.5 2v7a2.5 2.5 0 1 0 3 0Zm-10-6.5h3.25\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherTemperatureHotTemperatureThermometerHotMercuryPlusWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 9V2A1.5 1.5 0 0 0 10 .5h0A1.5 1.5 0 0 0 8.5 2v7a2.5 2.5 0 1 0 3 0Zm-10-6.5h3.98M3.49.51v3.98\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherTemperatureTemperatureThermometerWeatherLevelMeterMercuryMeasure: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5 9V2A1.5 1.5 0 0 0 7 .5h0A1.5 1.5 0 0 0 5.5 2v7a2.5 2.5 0 1 0 3 0Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherThirdQuarterMoonNightMoonThirdHalfQuarterTimeWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.25 13.5a6.5 6.5 0 0 1 0-13Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherUmbrellaCloseStormRainUmbrellaCloseWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 9.5h-7l3-9h1l3 9zM7 9.5V12a1.5 1.5 0 0 0 3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherUmbrellaStormRainUmbrellaOpenWeather: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 7a5 5 0 0 1 10 0Zm5-5V.5M10 12a1.5 1.5 0 0 1-3 0V7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherWindmillWindmillVelocityWeatherWind: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5h1a2 2 0 0 1 2 2V7h0h-3h0V.5h0ZM4 7h3v6.5h0h-1a2 2 0 0 1-2-2V7h0Zm9.5 0v1a2 2 0 0 1-2 2H7h0V7h6.5ZM7 4v3h0H.5h0V6a2 2 0 0 1 2-2H7Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvestmentSelection: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M6.338 3.7a1 1 0 0 0-.943-.668H4.62a.893.893 0 0 0-.19 1.765l1.178.258a1 1 0 0 1-.214 1.977h-.667a1 1 0 0 1-.943-.666m1.278-3.334v-1m0 6v-1m1.907 6.467v-5.25a1.25 1.25 0 0 1 1.25-1.25v0a1.25 1.25 0 0 1 1.25 1.25v2.75h2a2 2 0 0 1 2 2v.5\"/><path d=\"M5.063 9.564a4.531 4.531 0 1 1 4.489-3.911\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvestmentSelectionRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.778.25a.75.75 0 0 1 .75.75v.606a2.08 2.08 0 0 1 1.659 1.366a.75.75 0 0 1-1.414.5a.58.58 0 0 0-.55-.389H2.19a.44.44 0 0 0-.094.87l1.571.344a2.084 2.084 0 0 1-.14 4.097V9a.75.75 0 0 1-1.5 0v-.606A2.09 2.09 0 0 1 .37 7.028a.75.75 0 1 1 1.414-.5c.08.227.298.389.55.389h.889a.584.584 0 0 0 .125-1.154l-1.571-.344a1.94 1.94 0 0 1 .252-3.829V1a.75.75 0 0 1 .75-.75m4.847 5.5a.625.625 0 0 1 1.25 0V8.5c0 .345.28.625.625.625h.927c1.076 0 1.948.872 1.948 1.948V13a.625.625 0 1 0 1.25 0v-1.927a3.2 3.2 0 0 0-3.198-3.198h-.302V5.75a1.875 1.875 0 0 0-3.75 0v3.27c-1.44.559-1.989 2.42-.94 3.678l.585.702a.625.625 0 1 0 .96-.8l-.585-.702a1.09 1.09 0 0 1 .659-1.773l.049-.009a.625.625 0 0 0 .522-.616z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvestmentSelectionSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.5 13.499v-5.25a1.25 1.25 0 0 1 2.5 0v2.75h2a2 2 0 0 1 2 2v.5\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.031 4.424A4.423 4.423 0 1 1 8.676 5.75A2.5 2.5 0 0 0 6.25 8.249v.219A4.423 4.423 0 0 1 .031 4.424m4.423-3.238c.346 0 .625.28.625.625v.283a1.5 1.5 0 0 1 1.077.96a.625.625 0 1 1-1.179.417a.25.25 0 0 0-.232-.164H4.07a.153.153 0 0 0-.032.302l1.027.224a1.497 1.497 0 0 1 .014 2.921v.284a.625.625 0 0 1-1.25 0v-.283a1.5 1.5 0 0 1-1.076-.96a.625.625 0 0 1 1.179-.417a.25.25 0 0 0 .232.164h.581a.247.247 0 0 0 .052-.487L3.771 4.83a1.403 1.403 0 0 1 .058-2.753v-.266c0-.346.28-.625.625-.625M7.5 8.249v5.75H14v-1a2 2 0 0 0-2-2h-2v-2.75a1.25 1.25 0 0 0-2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvisible1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.63 3.624C4.621 2.98 5.771 2.5 7 2.5c2.79 0 5.18 2.475 6.23 3.746c.166.207.258.476.258.754s-.092.547-.258.754c-.579.7-1.565 1.767-2.8 2.583m-1.93.933c-.482.146-.984.23-1.5.23c-2.79 0-5.18-2.475-6.23-3.746C.604 7.547.512 7.279.512 7s.092-.547.258-.754c.333-.402.8-.926 1.372-1.454\"/><path d=\"M8.414 8.414a2 2 0 0 0-2.828-2.828M13.5 13.5L.5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvisible1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 1 .884 0L3.543 2.66C4.536 1.986 5.713 1.47 7 1.47c1.574 0 2.983.771 4.093 1.66c1.118.894 2 1.961 2.531 2.675l.005.007c.248.342.372.766.372 1.188c0 .423-.124.846-.372 1.188l-.005.007c-.473.635-1.223 1.55-2.17 2.375l2.363 2.363a.625.625 0 1 1-.884.884L.183 1.067a.625.625 0 0 1 0-.884M5.73 4.846L4.446 3.562C5.25 3.052 6.116 2.72 7 2.72c1.168 0 2.304.579 3.312 1.385c.999.8 1.806 1.771 2.307 2.443A.8.8 0 0 1 12.75 7a.8.8 0 0 1-.132.453c-.457.613-1.17 1.477-2.051 2.23L9.154 8.27A2.5 2.5 0 0 0 5.73 4.846m-3.538.702a.625.625 0 1 0-.937-.827c-.351.398-.647.773-.879 1.084l-.005.007A2.04 2.04 0 0 0-.001 7c0 .423.125.846.372 1.188l.005.007c.532.714 1.413 1.782 2.53 2.676c1.11.888 2.52 1.66 4.094 1.66c.512 0 1.006-.082 1.477-.222a.625.625 0 1 0-.356-1.199a4 4 0 0 1-1.12.17c-1.169 0-2.305-.578-3.313-1.385c-.999-.8-1.806-1.77-2.306-2.442c-.078-.11-.133-.27-.133-.453s.055-.343.133-.452c.214-.288.488-.634.81-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvisible1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.264 1.324a.75.75 0 0 1 1.06-1.06l2.629 2.628C4.86 2.393 5.893 2.04 7 2.04c1.532 0 2.92.677 4.035 1.48c1.118.805 2.003 1.769 2.539 2.417l.004.005c.24.298.366.675.366 1.058s-.126.76-.366 1.058l-.004.006a14.5 14.5 0 0 1-2.249 2.2l2.411 2.412a.75.75 0 0 1-1.06 1.06zm8.753 6.633a2.232 2.232 0 0 0-2.974-2.974zm-8.59-2.02c.319-.387.762-.885 1.305-1.395l7.104 7.104A5.7 5.7 0 0 1 7 11.96c-1.532 0-2.92-.676-4.035-1.479C1.847 9.675.962 8.711.426 8.064l-.004-.006C.182 7.76.056 7.383.056 7s.126-.76.366-1.058z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvisible2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.68 4.206C2.652 6.015 4.67 7.258 7 7.258s4.348-1.243 5.322-3.052M2.75 5.596L.5 7.481m4.916-.415L4.333 9.794m6.917-4.198l2.25 1.885m-4.92-.415l1.083 2.728\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvisible2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.265 3.436a.875.875 0 0 1 1.185.356c.815 1.514 2.53 2.59 4.55 2.59c2.022 0 3.736-1.076 4.55-2.59a.875.875 0 0 1 1.542.829a6.4 6.4 0 0 1-.755 1.103l1.453 1.29a.625.625 0 0 1-.83.935l-1.522-1.352A6.9 6.9 0 0 1 9.5 7.69l.744 1.873a.625.625 0 0 1-1.162.461L8.286 8.02a7.3 7.3 0 0 1-2.576 0l-.796 2.005a.625.625 0 1 1-1.162-.461l.744-1.875a6.9 6.9 0 0 1-1.933-1.09L1.04 7.947a.625.625 0 1 1-.83-.934l1.453-1.29Q1.227 5.212.91 4.621a.875.875 0 0 1 .356-1.185\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInvisible2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.615 3.54a1 1 0 0 1 1.354.407a4.1 4.1 0 0 0 .832 1.068c.806.747 1.933 1.223 3.2 1.223c1.262 0 2.386-.473 3.191-1.215q.045-.047.09-.086c.302-.295.555-.628.75-.99a1 1 0 1 1 1.76.948a6 6 0 0 1-.441.7l1.291 1.083a1 1 0 1 1-1.284 1.533l-1.44-1.207q-.535.38-1.147.653l.617 1.553a1 1 0 0 1-1.86.738l-.698-1.76a7 7 0 0 1-1.663 0l-.7 1.76A1 1 0 0 1 3.61 9.21l.617-1.555a6.6 6.6 0 0 1-1.144-.651L1.642 8.21A1 1 0 0 1 .358 6.678L1.65 5.595a6 6 0 0 1-.442-.7a1 1 0 0 1 .407-1.354\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIron: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.59 5.5H8.91a8.78 8.78 0 0 0-8.32 6h11.82a1 1 0 0 0 .964-.73q.06-.212.026-.43zm0 0l-.22-1.33a2 2 0 0 0-2-1.67H4.59\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIronRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.875.75a.875.875 0 1 0 0 1.75h5.25c1.174 0 2.125.951 2.125 2.125V5H8.57A8.63 8.63 0 0 0 .854 9.768L.15 11.175a1.434 1.434 0 0 0 1.283 2.075h11.941c.345 0 .625-.28.625-.625v-8A3.875 3.875 0 0 0 10.125.75zm-2.902 9.577A7.38 7.38 0 0 1 8.569 6.25h4.181V12H1.434a.184.184 0 0 1-.165-.266z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIronSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.035 2.036a2.6 2.6 0 0 0-1.81-.722H4.532a.75.75 0 1 0 0 1.5h5.708a1.08 1.08 0 0 1 .764.313c.23.217.399.536.454.907l.09.623H8.852a9.26 9.26 0 0 0-8.774 6.328a.75.75 0 0 0 .71.987h11.456A1.72 1.72 0 0 0 13.9 10.72c.068-.24.083-.493.044-.74v-.006l-.785-4.683l-.215-1.475a3.06 3.06 0 0 0-.908-1.78\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIslam: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.21 7a5.5 5.5 0 0 1 5.47-5.5a6.5 6.5 0 1 0 0 11A5.5 5.5 0 0 1 5.21 7\"/><path d=\"m10.57 4.04l.91 1.81h1.81l-1.36 1.4l.43 2l-1.79-1l-1.71 1l.36-2l-1.36-1.4h1.81z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIslamRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 7a6.5 6.5 0 0 1 9.705-5.656a.5.5 0 0 1-.299.932a4.75 4.75 0 1 0 0 9.448a.5.5 0 0 1 .299.932A6.5 6.5 0 0 1 .5 7m10.339-2.76a.625.625 0 0 0-1.118.002l-.687 1.38h-1.34a.625.625 0 0 0-.447 1.06L8.32 7.787L8.034 9.38a.625.625 0 0 0 .93.65l1.323-.773l1.396.78a.625.625 0 0 0 .916-.677l-.34-1.581l1.064-1.096a.625.625 0 0 0-.448-1.06h-1.341zM9.98 6.524l.302-.607l.307.61a.63.63 0 0 0 .558.344h.248l-.267.275a.63.63 0 0 0-.163.567l.12.557l-.501-.28a.63.63 0 0 0-.62.006l-.46.269l.102-.573a.63.63 0 0 0-.166-.546l-.268-.275h.249a.63.63 0 0 0 .56-.347\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineIslamSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.325.003a7 7 0 1 0 3.529 12.92a.5.5 0 0 0-.264-.923a5 5 0 0 1 0-10a.5.5 0 0 0 .264-.923A7 7 0 0 0 7.325.003m4.87 4.941a.5.5 0 0 0-.894.002l-.4.806h-.774a.5.5 0 0 0-.359.848l.635.654l-.17.944a.5.5 0 0 0 .745.52l.776-.454l.822.46a.5.5 0 0 0 .733-.542l-.201-.936l.627-.646a.5.5 0 0 0-.358-.848h-.775z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJumpObject: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.451h13M.5.549h13m-4.254 9.675H4.75a1 1 0 0 1-1-1V4.778a1 1 0 0 1 1-1h4.495a1 1 0 0 1 1 1v4.446a1 1 0 0 1-1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJumpObjectRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 1c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 1M5 3.375c-.897 0-1.625.728-1.625 1.625v4c0 .897.728 1.625 1.625 1.625h4c.897 0 1.625-.728 1.625-1.625V5c0-.897-.728-1.625-1.625-1.625zm-4 9a.625.625 0 1 0 0 1.25h12a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJumpObjectSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1A.75.75 0 0 1 .75.25h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 1m3.5 4A1.5 1.5 0 0 1 5 3.5h4A1.5 1.5 0 0 1 10.5 5v4A1.5 1.5 0 0 1 9 10.5H5A1.5 1.5 0 0 1 3.5 9zM.75 12.25a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeHammer: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.29H8m-1 0v-2.5H1.5v2.5M7.787 1.002L4.202 4.587a1 1 0 0 0 0 1.414l1.584 1.584a1 1 0 0 0 1.414 0L10.785 4a1 1 0 0 0 0-1.414L9.2 1.002a1 1 0 0 0-1.414 0M9 5.79l4.5 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeHammerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.096 1.401a.46.46 0 0 0-.651-.002L4.54 5.28a.46.46 0 0 0-.002.65l1.714 1.725a.46.46 0 0 0 .651.002l3.904-3.88a.46.46 0 0 0 .002-.65zM7.563.513a1.71 1.71 0 0 1 2.42.007l1.713 1.725a1.71 1.71 0 0 1-.007 2.418l-1.32 1.312l3.375 3.374a.875.875 0 0 1-1.238 1.238L9.128 7.208L7.785 8.543a1.71 1.71 0 0 1-2.418-.008L3.653 6.811a1.71 1.71 0 0 1 .007-2.42zm-5.938 9.862a.5.5 0 0 0-.5.5v1.875h-.5a.625.625 0 1 0 0 1.25h7.5a.625.625 0 1 0 0-1.25h-.5v-1.875a.5.5 0 0 0-.5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeHammerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.877 6.266a1.5 1.5 0 0 1 0-2.122L7.462.56a1.5 1.5 0 0 1 2.122 0l1.583 1.584a1.5 1.5 0 0 1 0 2.121L9.91 5.521L13.7 9.31a.75.75 0 1 1-1.062 1.06L8.85 6.583L7.582 7.85a1.5 1.5 0 0 1-2.12 0zM1.331 12.38h-.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-.5v-1.75a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeScale1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 9.5L3 4L.5 9.5m5 0a2.5 2.5 0 0 1-5 0m5 0h-5m13 0L11 4L8.5 9.5m5 0a2.5 2.5 0 0 1-5 0m5 0h-5M1.5 4h11M7 4V2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeScale1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 1.5a.625.625 0 1 1 1.25 0v1.375H12.5a.625.625 0 1 1 0 1.25h-.815l2.268 5.481a.6.6 0 0 1 .047.24c0 .867-.34 1.7-.95 2.316a3.24 3.24 0 0 1-2.3.963a3.24 3.24 0 0 1-2.3-.963a3.3 3.3 0 0 1-.95-2.317q0-.124.047-.239l2.268-5.481h-5.63l2.268 5.481a.6.6 0 0 1 .047.24c0 .867-.34 1.7-.95 2.316a3.24 3.24 0 0 1-2.3.963a3.24 3.24 0 0 1-2.3-.963A3.3 3.3 0 0 1 0 9.845q0-.124.047-.239l2.268-5.481H1.5a.625.625 0 1 1 0-1.25h4.875zm2.426 8.345l1.949-4.71l1.949 4.71zm-7.5 0H5.2l-1.95-4.71z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeScale1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75 2.306a.75.75 0 0 0-1.5 0v1.127H1.836a.75.75 0 0 0 0 1.5h.32L.196 10.08a.8.8 0 0 0-.049.267a3.097 3.097 0 1 0 6.195 0a.8.8 0 0 0-.05-.267l-1.96-5.147h5.335l-1.96 5.147a.8.8 0 0 0-.049.267a3.097 3.097 0 1 0 6.195 0a.8.8 0 0 0-.05-.267l-1.96-5.147h.32a.75.75 0 0 0 0-1.5H7.75zM4.657 10L3.244 6.29L1.833 10h2.825Zm6.098-3.71L12.168 10H9.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeScale2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 11L3 4.82L.5 11m5 0a2.5 2.5 0 0 1-5 0m5 0h-5m13-4L11 1.18L8.5 7m5 0a2.5 2.5 0 0 1-5 0m5 0h-5m-7-1.5l11-5M7 3V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeScale2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625.625a.625.625 0 1 0-1.25 0V2.48L1.253 4.684a.625.625 0 1 0 .494 1.148l.372-.16L.05 10.473a.6.6 0 0 0-.05.247c0 .868.34 1.701.95 2.317a3.24 3.24 0 0 0 2.3.963c.864 0 1.692-.347 2.3-.963c.61-.616.95-1.45.95-2.317a.6.6 0 0 0-.051-.247L4.028 4.851l5.564-2.394l-2.04 4.637a.6.6 0 0 0-.052.251c0 .868.34 1.701.95 2.317a3.24 3.24 0 0 0 2.3.963c.864 0 1.692-.347 2.3-.963c.61-.616.95-1.45.95-2.317a.6.6 0 0 0-.053-.251L11.54 1.619l.848-.365a.625.625 0 1 0-.494-1.148L7.625 1.942zm1.183 6.72l1.942-4.417l1.942 4.417zM5.195 10.72L3.25 6.205L1.306 10.72z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineJusticeScale2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.864.567a.75.75 0 0 1-.373.993l-.743.338l2.064 4.806a.8.8 0 0 1 .061.296a3.105 3.105 0 1 1-6.21 0a.8.8 0 0 1 .06-.296l1.59-3.7l-1.988.904l-.03.014L4.196 5.33l2.086 5.157a.8.8 0 0 1 .055.281a3.105 3.105 0 1 1-6.21 0a.8.8 0 0 1 .054-.28l1.68-4.152a.75.75 0 0 1-.353-1.432L6.25 2.75V.877a.75.75 0 0 1 1.5 0v1.19l2.664-1.21a1 1 0 0 1 .09-.041L11.87.194a.75.75 0 0 1 .993.373Zm-.69 6.123l-1.406-3.272L9.362 6.69zm-8.942.256l-1.405 3.472h2.81L3.231 6.946Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKey: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.62 7.38L11.5 1.5l2 2m-4.25.25L11 5.5\"/><path d=\"M3.5 12.5a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.415.98c.165 0 .324.066.442.183l1.961 1.962a.625.625 0 1 1-.883.884l-1.52-1.52l-1.324 1.323l1.275 1.275a.625.625 0 0 1-.884.884L9.207 4.696L6.494 7.41a3.569 3.569 0 1 1-.884-.884l3.144-3.144l.023-.024l2.196-2.195a.63.63 0 0 1 .442-.183M3.567 7.634a1.819 1.819 0 1 0 0 3.637a1.819 1.819 0 0 0 0-3.637\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1-1.414 1.414L11 3.414L9.914 4.5l1.293 1.293a1 1 0 0 1-1.414 1.414L8.5 5.914L7.446 6.968a4 4 0 1 1-1.414-1.414l1.757-1.757l.004-.004l.004-.004zM2 9a2 2 0 1 1 4 0a2 2 0 0 1-4 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 5.5v-1a2 2 0 0 1 2-2h4a2 2 0 0 0 2-2m1 5h-11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-7 5.25h3m-6 0h1m7 0h1m-9-2.5h1m1.667 0h1m1.666 0h1m1.667 0h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.5.375c.345 0 .625.28.625.625A2.625 2.625 0 0 1 9.5 3.625h-4A1.375 1.375 0 0 0 4.125 5v.375H12c.898 0 1.625.728 1.625 1.625v5c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12V7c0-.897.728-1.625 1.625-1.625h.875V5A2.625 2.625 0 0 1 5.5 2.375h4A1.375 1.375 0 0 0 10.875 1c0-.345.28-.625.625-.625M2 6.625h10c.207 0 .375.168.375.375v5a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12V7c0-.207.168-.375.375-.375m3.75 3.5a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25zm-3.375.625c0-.345.28-.625.625-.625h.75a.625.625 0 1 1 0 1.25H3a.625.625 0 0 1-.625-.625m7.875-.625a.625.625 0 1 0 0 1.25H11a.625.625 0 1 0 0-1.25zM2.375 8.25c0-.345.28-.625.625-.625h.625a.625.625 0 1 1 0 1.25H3a.625.625 0 0 1-.625-.625m3.083-.625a.625.625 0 1 0 0 1.25h.625a.625.625 0 1 0 0-1.25zm1.833.625c0-.345.28-.625.625-.625h.625a.625.625 0 1 1 0 1.25h-.625a.625.625 0 0 1-.625-.625m3.084-.625a.625.625 0 1 0 0 1.25H11a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.5.055a.75.75 0 0 1 .75.75a2.57 2.57 0 0 1-.822 1.874a2.82 2.82 0 0 1-1.928.754h-4c-.346 0-.67.13-.9.347c-.23.215-.35.498-.35.781V5h8.25A1.5 1.5 0 0 1 14 6.5v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-6A1.5 1.5 0 0 1 1.5 5h1.25v-.439c0-.713.302-1.386.822-1.875A2.82 2.82 0 0 1 5.5 1.933h4c.346 0 .67-.13.9-.347s.35-.498.35-.781a.75.75 0 0 1 .75-.75M4.866 10.844a.5.5 0 0 1 .5-.5h3.268a.5.5 0 1 1 0 1H5.366a.5.5 0 0 1-.5-.5m-2.768-.5a.5.5 0 1 0 0 1h1.09a.5.5 0 0 0 0-1zm8.715 0a.5.5 0 1 0 0 1h1.09a.5.5 0 0 0 0-1zM1.598 8.156a.5.5 0 0 1 .5-.5h1.09a.5.5 0 0 1 0 1h-1.09a.5.5 0 0 1-.5-.5m3.405-.5a.5.5 0 0 0 0 1h1.09a.5.5 0 0 0 0-1zm2.405.5a.5.5 0 0 1 .5-.5h1.09a.5.5 0 0 1 0 1h-1.09a.5.5 0 0 1-.5-.5m3.405-.5a.5.5 0 1 0 0 1h1.09a.5.5 0 0 0 0-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardVirtual: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-7 5.25h3m-6 0h1m7 0h1m-9-2.5h1m1.667 0h1m1.666 0h1m1.667 0h1M5 11.5l2 2l2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardVirtualRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.25a.375.375 0 0 0-.375.375v6c0 .207.168.375.375.375h10.75a.375.375 0 0 0 .375-.375v-6a.375.375 0 0 0-.375-.375zM0 1.625C0 .728.728 0 1.625 0h10.75C13.273 0 14 .728 14 1.625v6c0 .897-.727 1.625-1.625 1.625H1.625A1.625 1.625 0 0 1 0 7.625zM5 11a.5.5 0 0 0-.354.854l2 2a.5.5 0 0 0 .708 0l2-2A.5.5 0 0 0 9 11zm.625-5.75a.625.625 0 1 0 0 1.25h2.75a.625.625 0 1 0 0-1.25zM2 5.875c0-.345.28-.625.625-.625h.75a.625.625 0 1 1 0 1.25h-.75A.625.625 0 0 1 2 5.875m8.625-.625a.625.625 0 1 0 0 1.25h.75a.625.625 0 1 0 0-1.25zM2 3.375c0-.345.28-.625.625-.625h.75a.625.625 0 1 1 0 1.25h-.75A.625.625 0 0 1 2 3.375m3.292-.625a.625.625 0 1 0 0 1.25h.75a.625.625 0 1 0 0-1.25zm2.041.625c0-.345.28-.625.625-.625h.75a.625.625 0 1 1 0 1.25h-.75a.625.625 0 0 1-.625-.625m3.292-.625a.625.625 0 1 0 0 1.25h.75a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardVirtualSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5.203c-.79 0-1.5.6-1.5 1.422v5.531c0 .823.71 1.422 1.5 1.422h11c.79 0 1.5-.599 1.5-1.422V1.625c0-.823-.71-1.422-1.5-1.422zM5 5.547a.5.5 0 0 1 .5-.5h3a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5m-2.5-.5a.5.5 0 1 0 0 1h1a.5.5 0 0 0 0-1zm8 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-8.5-2a.5.5 0 0 1 .5-.5h1a.5.5 0 1 1 0 1h-1a.5.5 0 0 1-.5-.5m3.167-.5a.5.5 0 1 0 0 1h1a.5.5 0 0 0 0-1zm2.166.5a.5.5 0 0 1 .5-.5h1a.5.5 0 1 1 0 1h-1a.5.5 0 0 1-.5-.5m3.167-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-5.962 8.558A.5.5 0 0 1 5 10.798h4a.5.5 0 0 1 .354.853l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1-.108-.545\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardWireless2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 1.239a9 9 0 0 0-7 0m5.7 2.099a6.78 6.78 0 0 0-4.36 0M12.5 5.5h-11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-7 5.25h3m-6 0h1m7 0h1m-9-2.5h1m1.667 0h1m1.666 0h1m1.667 0h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardWireless2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a9.6 9.6 0 0 0-3.743.758a.625.625 0 0 0 .486 1.151a8.38 8.38 0 0 1 6.514 0a.625.625 0 0 0 .486-1.151A9.6 9.6 0 0 0 7 0m2.401 2.591a7.4 7.4 0 0 0-4.762 0a.625.625 0 1 0 .402 1.184a6.16 6.16 0 0 1 3.958 0a.625.625 0 1 0 .402-1.184M1.625 6a.375.375 0 0 0-.375.375v6c0 .207.168.375.375.375h10.75a.375.375 0 0 0 .375-.375v-6A.375.375 0 0 0 12.375 6zM0 6.375C0 5.478.728 4.75 1.625 4.75h10.75c.898 0 1.625.728 1.625 1.625v6c0 .898-.727 1.625-1.625 1.625H1.625A1.625 1.625 0 0 1 0 12.375zM5.625 10a.625.625 0 1 0 0 1.25h2.75a.625.625 0 1 0 0-1.25zM2 10.625c0-.345.28-.625.625-.625h.75a.625.625 0 1 1 0 1.25h-.75A.625.625 0 0 1 2 10.625M10.625 10a.625.625 0 1 0 0 1.25h.75a.625.625 0 1 0 0-1.25zM2 8.125c0-.345.28-.625.625-.625h.75a.625.625 0 1 1 0 1.25h-.75A.625.625 0 0 1 2 8.125M5.292 7.5a.625.625 0 1 0 0 1.25h.75a.625.625 0 1 0 0-1.25zm2.041.625c0-.345.28-.625.625-.625h.75a.625.625 0 1 1 0 1.25h-.75a.625.625 0 0 1-.625-.625m3.292-.625a.625.625 0 1 0 0 1.25h.75a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyboardWireless2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.208.845a9.75 9.75 0 0 1 7.584 0a.75.75 0 0 1-.584 1.382a8.25 8.25 0 0 0-6.416 0A.75.75 0 0 1 3.208.845m1.39 2.08a7.53 7.53 0 0 1 4.843 0a.75.75 0 0 1-.482 1.42a6.03 6.03 0 0 0-3.878 0a.75.75 0 0 1-.482-1.42ZM0 6.97c0-.823.71-1.422 1.5-1.422h11c.79 0 1.5.6 1.5 1.422v5.532c0 .822-.71 1.421-1.5 1.421h-11c-.79 0-1.5-.599-1.5-1.421zm5.5 3.422a.5.5 0 0 0 0 1h3a.5.5 0 1 0 0-1zm-3.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m-7.5-3a.5.5 0 0 0 0 1h1a.5.5 0 1 0 0-1zm2.167.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m3.166-.5a.5.5 0 0 0 0 1h1a.5.5 0 1 0 0-1zm2.167.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyholeLockCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M7 7.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 0v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyholeLockCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 4a2 2 0 0 0-.875 3.799V9.5a.875.875 0 1 0 1.75 0V7.799A2 2 0 0 0 7 4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineKeyholeLockCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0m-6 .732a2 2 0 1 0-2 0V9.5a1 1 0 1 0 2 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLadder: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5.5v13m7-13v13M3.5 3h7m-7 4h7m-7 4h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLadderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0c.345 0 .625.28.625.625v1h7.75v-1a.625.625 0 1 1 1.25 0v12.75a.625.625 0 1 1-1.25 0v-1h-7.75v1a.625.625 0 1 1-1.25 0V.625C1.875.28 2.155 0 2.5 0m.625 10.625h7.75v-2.75h-7.75zm7.75-7.25v2.75h-7.75v-2.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLadderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0a1 1 0 0 1 1 1v1.216h5V1a1 1 0 0 1 2 0v12a1 1 0 1 1-2 0v-1.216h-5V13a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1m1 9.784h5V8h-5zm5-5.568V6h-5V4.216z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLandscape2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 13.5h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1\"/><path d=\"m1.75 13.5l7.3-6.88a.5.5 0 0 1 .64 0l3.81 2.73M4.5 6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLandscape2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.158 12.364a.3.3 0 0 0 .217-.287V1.923a.3.3 0 0 0-.298-.298H1.923a.3.3 0 0 0-.298.298V8.29L4.5 5.414a.5.5 0 0 1 .707 0zm1.467-.287c0 .855-.693 1.548-1.548 1.548H1.923a1.55 1.55 0 0 1-1.548-1.548V1.923c0-.855.693-1.548 1.548-1.548h10.154c.855 0 1.548.693 1.548 1.548zM11 4.75a1.75 1.75 0 1 0-3.5 0a1.75 1.75 0 0 0 3.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLandscape2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 12.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5zM3.75 2a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5m4.651 4.599L2.5 12.5h10v-4L9.69 6.492A1 1 0 0 0 8.4 6.6\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLandscapeSetting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 12h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1\"/><path d=\"M7 5.714a1.029 1.029 0 1 0 0-2.058a1.029 1.029 0 0 0 0 2.058\"/><path d=\"M8.8 7.514a1.8 1.8 0 1 0-3.6 0v.772h.771l.257 2.058h1.544l.257-2.058H8.8z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLandscapeSettingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.75 2.5a.375.375 0 0 0-.375-.375H1.625a.375.375 0 0 0-.375.375v9a.375.375 0 0 0 .375.375h10.75a.375.375 0 0 0 .375-.375zm.774-1.149c.305.305.476.718.476 1.149v9a1.625 1.625 0 0 1-1.625 1.625H1.625A1.625 1.625 0 0 1 0 11.5v-9A1.625 1.625 0 0 1 1.625.875h10.75c.431 0 .844.171 1.149.476M7 2.946a2.06 2.06 0 1 0 0 4.118a2.06 2.06 0 0 0 0-4.118m0 4.85a4.12 4.12 0 0 0-3.872 2.713a.5.5 0 0 0 .47.67h6.804a.5.5 0 0 0 .47-.67A4.12 4.12 0 0 0 7 7.796\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLandscapeSettingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.5 12.5A1.5 1.5 0 0 0 14 11V3a1.5 1.5 0 0 0-1.5-1.5h-11A1.5 1.5 0 0 0 0 3v8a1.5 1.5 0 0 0 1.5 1.5zM7.005 5.462a1.23 1.23 0 1 0-.01 0a2.154 2.154 0 0 0-2.149 2.153v.923h.923L6.077 11h1.846l.308-2.462h.923v-.923a2.154 2.154 0 0 0-2.149-2.153\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLaptopCamera: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 3a1 1 0 0 0-1-1H12L11 .5H9L8 2h-.5a1 1 0 0 0-1 1v2.5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zM2 9.5L.61 12.05a1 1 0 0 0 .89 1.45h10a1 1 0 0 0 .89-1.45L11 9.5zm2-6H3a1 1 0 0 0-1 1v5\"/><path d=\"M10 4.375a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLaptopCameraRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.584.223A.5.5 0 0 1 9 0h2a.5.5 0 0 1 .416.223l.852 1.277h.232A1.5 1.5 0 0 1 14 3v2.5A1.5 1.5 0 0 1 12.5 7h-5A1.5 1.5 0 0 1 6 5.5V3a1.5 1.5 0 0 1 1.5-1.5h.232zM8.875 4a1.125 1.125 0 1 0 2.25 0a1.125 1.125 0 0 0-2.25 0M2.75 8.75V4.375c0-.207.168-.375.375-.375H4.25a.625.625 0 1 0 0-1.25H3.125c-.897 0-1.625.728-1.625 1.625v4.852L.151 11.925A1.434 1.434 0 0 0 1.434 14h11.132a1.434 1.434 0 0 0 1.283-2.075L12.5 9.227v-.602a.625.625 0 1 0-1.25 0v.125z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLaptopCameraSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.842 2.653a1 1 0 0 0-1-1h-.5l-1-1.5h-2l-1 1.5h-.5a1 1 0 0 0-1 1v2.5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zm-4.5 1a1 1 0 1 1 2 0a1 1 0 0 1-2 0M2.986 4.752a.25.25 0 0 1 .25-.25h1.606a.75.75 0 1 0 0-1.5H3.236a1.75 1.75 0 0 0-1.75 1.75v4.931l-1.163 2.08l-.008.015a1.4 1.4 0 0 0 .06 1.395c.13.208.312.377.527.495c.214.117.455.179.7.18h9.48c.245-.001.486-.063.7-.18c.215-.118.397-.287.528-.495a1.41 1.41 0 0 0 .06-1.395l-.009-.014l-1.164-2.081l.001-.03v-1.5a.75.75 0 0 0-1.5 0v.75H2.986z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLaptopCharging: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11.5.5l-2 3h3l-2 3M2.475 9.4L.675 12c-.2.3-.2.7 0 1s.5.5.8.5h10.8c.6 0 1-.4 1-1c0-.2 0-.3-.1-.5l-1.8-2.6zm8.9 0v-.9m-4.4-5.1h-3.5c-.6 0-1 .4-1 1v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLaptopChargingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.326 1.23a.75.75 0 0 0-1.152-.96l-2.5 3A.75.75 0 0 0 9.25 4.5h2.399l-1.475 1.77a.75.75 0 0 0 1.152.96l2.5-3A.75.75 0 0 0 13.25 3h-2.399zM2.625 4.625c0-.207.168-.375.375-.375h4A.625.625 0 1 0 7 3H3c-.897 0-1.625.728-1.625 1.625v5.096L.152 12.057A1.327 1.327 0 0 0 1.327 14h11.346a1.327 1.327 0 0 0 1.175-1.943l-1.223-2.336V8.625a.625.625 0 1 0-1.25 0v.625h-8.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLaptopChargingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.082 1.166a.75.75 0 1 0-1.248-.832l-1.833 2.75a.75.75 0 0 0 .624 1.166h1.348L9.917 5.834a.75.75 0 1 0 1.249.832l1.833-2.75a.75.75 0 0 0-.624-1.166h-1.349zM6.996 3.042a.75.75 0 1 1 0 1.5H3.7a.25.25 0 0 0-.25.25V8.75h7.095V8.5a.75.75 0 0 1 1.5 0v.894l1.654 2.206c.741.99.036 2.4-1.2 2.4H1.502c-1.235 0-1.941-1.41-1.2-2.4L1.95 9.404V4.792c0-.966.784-1.75 1.75-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLassoTool: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.123 12.709c1.518 0 1.897-1.073 1.897-1.61c0-.535-.38-1.608-1.897-1.608c-1.518 0-1.897 1.073-1.897 1.609s.38 1.609 1.897 1.609\"/><path d=\"M7 9.806C1.8 9.806.5 6.744.5 5.213C.5 3.683 1.8.621 7 .621s6.5 3.062 6.5 4.592c0 1.531-1.3 4.593-6.5 4.593m-1.414.226c1.01 1.147 1.683 1.912 1.68 3.345\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLassoToolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 2.255C2.786 1.173 4.461.375 7 .375s4.213.798 5.25 1.88c1.024 1.065 1.375 2.35 1.375 3.245c0 .894-.351 2.18-1.374 3.245c-.861.898-2.16 1.6-4.028 1.813c.508.556.902 1.346.902 2.442a.625.625 0 0 1-1.25 0c0-1.058-.513-1.645-1.04-1.993a3 3 0 0 0-.248-.148a2.07 2.07 0 0 1-.536 1.011c-.438.457-1.113.755-2.051.755s-1.613-.298-2.05-.755a2.03 2.03 0 0 1-.575-1.37a2.03 2.03 0 0 1 .673-1.467C.793 7.92.375 6.473.375 5.5c0-.894.351-2.18 1.374-3.245m3.552 7.96l-.004-.008a.8.8 0 0 0-.149-.212c-.162-.168-.487-.37-1.149-.37a2.3 2.3 0 0 0-.64.08a1.1 1.1 0 0 0-.51.29a.78.78 0 0 0-.225.505c0 .106.049.32.226.505c.162.168.487.37 1.149.37s.987-.202 1.15-.37a.78.78 0 0 0 .225-.505a.7.7 0 0 0-.073-.284M7 9.375q-.404 0-.767-.029a2 2 0 0 0-.182-.216C5.613 8.673 4.938 8.375 4 8.375q-.37 0-.687.06C2.01 7.555 1.625 6.256 1.625 5.5c0-.606.249-1.57 1.026-2.38C3.413 2.327 4.738 1.625 7 1.625s3.587.702 4.35 1.495c.776.81 1.025 1.774 1.025 2.38s-.249 1.57-1.026 2.38C10.587 8.673 9.262 9.375 7 9.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLassoToolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.475 1.87C2.58.786 4.347 0 7 0s4.42.785 5.525 1.87C13.617 2.943 14 4.244 14 5.167s-.383 2.224-1.475 3.295C11.42 9.546 9.653 10.331 7 10.331h-.063c.626.801 1.081 1.654 1.078 2.916a.75.75 0 1 1-1.5-.004c.001-.564-.118-.988-.369-1.42a2.4 2.4 0 0 1-.433.768c-.442.52-1.135.868-2.09.868s-1.648-.348-2.09-.868A2.36 2.36 0 0 1 .976 11.1c0-.416.14-1 .557-1.491c.183-.215.408-.4.676-.543a5.5 5.5 0 0 1-.734-.605C.383 7.391 0 6.09 0 5.166S.383 2.942 1.475 1.87m1.05 1.071C1.742 3.711 1.5 4.617 1.5 5.166S1.742 6.62 2.525 7.39c.77.754 2.128 1.44 4.475 1.44s3.706-.686 4.475-1.44c.784-.77 1.025-1.676 1.025-2.225s-.241-1.456-1.025-2.225C10.705 2.187 9.347 1.5 7 1.5s-3.706.687-4.475 1.441m.152 7.639a.87.87 0 0 0-.201.52c0 .12.05.341.2.52c.128.15.385.339.947.339c.563 0 .819-.189.946-.34a.87.87 0 0 0 .201-.52c0-.12-.05-.34-.2-.519c-.128-.15-.384-.339-.947-.339s-.819.189-.946.339\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayers1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.47 6.9a1.18 1.18 0 0 1-.94 0L.83 4.26a.56.56 0 0 1 0-1L6.53.6a1.18 1.18 0 0 1 .94 0l5.7 2.64a.56.56 0 0 1 0 1zm6.03.45l-6.1 2.81a1 1 0 0 1-.83 0L.5 7.35m13 3.25l-6.1 2.81a1 1 0 0 1-.83 0L.5 10.6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayers1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .377a1.65 1.65 0 0 0-.7.157l-.016.008l-5.28 2.66l-.018.01c-.192.104-.346.26-.452.445a1.22 1.22 0 0 0 0 1.206a1.16 1.16 0 0 0 .472.456l5.28 2.64l.013.007a1.65 1.65 0 0 0 1.402 0l.016-.008l5.28-2.66l.017-.009a1.16 1.16 0 0 0 .452-.446a1.22 1.22 0 0 0 0-1.206a1.16 1.16 0 0 0-.471-.456L7.715.541L7.701.534A1.65 1.65 0 0 0 7 .377m6.56 6.693a.625.625 0 0 1-.279.839l-5.6 2.81l-.02.01a1.63 1.63 0 0 1-1.371-.01L.72 7.909a.625.625 0 1 1 .563-1.117l5.556 2.803a.38.38 0 0 0 .295 0l5.587-2.804a.625.625 0 0 1 .839.279m-.279 3.589a.625.625 0 1 0-.56-1.118l-5.587 2.804a.37.37 0 0 1-.295 0L1.282 9.542a.625.625 0 1 0-.563 1.116l5.57 2.81l.022.01a1.63 1.63 0 0 0 1.37-.01z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayers1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .002c-.23 0-.458.048-.67.14L.62 2.806l-.014.007a1.06 1.06 0 0 0 0 1.892l.015.008l5.7 2.64l.01.005a1.68 1.68 0 0 0 1.34 0l5.711-2.666l.014-.007a1.06 1.06 0 0 0 0-1.892l-.015-.008l-5.7-2.64l-.01-.005A1.7 1.7 0 0 0 7 .002m6.931 6.894a.75.75 0 0 1-.367.995l-5.866 2.702l-.002.001a1.7 1.7 0 0 1-1.42 0l-.005-.002L.435 7.891a.75.75 0 0 1 .63-1.362L6.9 9.23a.21.21 0 0 0 .174 0l5.863-2.701a.75.75 0 0 1 .995.367m-.367 4.245a.75.75 0 0 0-.628-1.362l-5.863 2.7a.21.21 0 0 1-.174.001l-5.834-2.7a.75.75 0 1 0-.63 1.36l5.836 2.702l.004.002a1.7 1.7 0 0 0 1.42 0h.003z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayers2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 1.5h-6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1\"/><path d=\"M11 10H4a1 1 0 0 1-1-1V4\"/><path d=\"M9 12.5H1.5a1 1 0 0 1-1-1V6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayers2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.51.98c-.887 0-1.606.72-1.606 1.606V6.51c0 .887.719 1.606 1.606 1.606h5.885c.887 0 1.606-.72 1.606-1.606V2.586A1.61 1.61 0 0 0 12.395.98zM3.077 3.923c.345 0 .625.28.625.625v4.414a.356.356 0 0 0 .356.355h6.375a.625.625 0 1 1 0 1.25H4.058a1.606 1.606 0 0 1-1.606-1.605V4.548c0-.346.28-.625.625-.625M1.25 7A.625.625 0 1 0 0 7v4.414a1.606 1.606 0 0 0 1.605 1.606h6.376a.625.625 0 1 0 0-1.25H1.605a.356.356 0 0 1-.355-.356z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayers2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1A1.5 1.5 0 0 0 5 2.5v4A1.5 1.5 0 0 0 6.5 8h6A1.5 1.5 0 0 0 14 6.5v-4A1.5 1.5 0 0 0 12.5 1zM3.25 3a.75.75 0 0 1 .75.75v5c0 .139.112.25.25.25h7a.75.75 0 0 1 0 1.5h-7A1.75 1.75 0 0 1 2.5 8.75v-5A.75.75 0 0 1 3.25 3M.75 5.5a.75.75 0 0 1 .75.75v5c0 .138.112.25.25.25h7a.75.75 0 0 1 0 1.5h-7A1.75 1.75 0 0 1 0 11.25v-5a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 13.5h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1m4-13v13m0-6.5h8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 12.375a.375.375 0 0 0 .375-.375V7.625H5.5v4.75zm-6.5-6v-4.75H12c.207 0 .375.168.375.375v4.375zM13.625 7V2c0-.897-.727-1.625-1.625-1.625H2C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0h3.375v14H1.5A1.5 1.5 0 0 1 0 12.5v-11A1.5 1.5 0 0 1 1.5 0m4.625 7.625V14H12.5a1.5 1.5 0 0 0 1.5-1.5V7.625zM14 6.375H6.125V0H12.5A1.5 1.5 0 0 1 14 1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow11: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.625.507v12.99m0-6.497H.5m0 5.5v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow11Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 12.375A.375.375 0 0 1 1.625 12V7.625H8.5v4.75zm6.5-6v-4.75H2A.375.375 0 0 0 1.625 2v4.375zM.375 7V2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v10c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow11Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.5 0h-2.375v14H12.5a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0M8.875 7.625V14H1.5A1.5 1.5 0 0 1 0 12.5V7.625zM0 6.375h8.875V0H1.5A1.5 1.5 0 0 0 0 1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-12 3h13m-9 0v10m9-5h-9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 4.5V12c0 .207.168.375.375.375h2.375V4.5zm4 4.563v3.312H12a.375.375 0 0 0 .375-.375V9.063zm6.75-1.25h-6.75V4.5h6.75zm1.25.625V2c0-.897-.727-1.625-1.625-1.625H2C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v1.375h14V1.5A1.5 1.5 0 0 0 12.5 0zM0 4.125h3.875V14H1.5A1.5 1.5 0 0 1 0 12.5zm5.125 5V14H12.5a1.5 1.5 0 0 0 1.5-1.5V9.125zM14 7.875H5.125v-3.75H14z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow8: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-12 3h13M7 3.5v10m-6.5-5h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow8Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 9.063V12c0 .207.168.375.375.375h4.375V9.063zm-1.25-.626V12c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625H2C1.103.375.375 1.103.375 2zm1.25-.624h4.75V4.5h-4.75zm6 1.25v3.312H12a.375.375 0 0 0 .375-.375V9.063zm4.75-1.25h-4.75V4.5h4.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLayoutWindow8Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v1.375h14V1.5A1.5 1.5 0 0 0 12.5 0zM0 8.375v-4.25h6.375v4.25zm0 1.25V12.5A1.5 1.5 0 0 0 1.5 14h4.875V9.625zm7.625 0V14H12.5a1.5 1.5 0 0 0 1.5-1.5V9.625zM14 8.375v-4.25H7.625v4.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLeaf: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.51 5.391c2 2.817.47 6.043-.27 7.301a1.42 1.42 0 0 1-1 .66c-1.45.25-5.06.529-7-2.288c-1.91-2.656-1.83-7.33-1.66-9.558A1.048 1.048 0 0 1 3 .568c2.15.619 6.63 2.167 8.51 4.823\"/><path d=\"M4.77 4.463a52 52 0 0 1 6 8.719\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLeafRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.471.01a1.66 1.66 0 0 0-.743.086c-1.073.31-2.726.851-4.354 1.65c-1.623.796-3.296 1.884-4.308 3.314C.964 6.612.843 8.274 1.084 9.681c.238 1.396.836 2.57 1.217 3.22l.007.01a2.02 2.02 0 0 0 1.413.936c.75.13 2.07.268 3.47.004c1.41-.267 2.937-.954 4.008-2.504c1.027-1.433 1.491-3.356 1.689-5.137c.199-1.793.136-3.523.052-4.636A1.654 1.654 0 0 0 11.47.009m-.328 1.265a.406.406 0 0 1 .55.384c.081 1.07.14 2.721-.047 4.413c-.19 1.707-.623 3.377-1.466 4.55l-.007.01c-.833 1.209-2.025 1.765-3.215 1.99c-.93.176-1.837.144-2.51.067c1.548-2.7 3.376-5.222 5.405-7.611A.875.875 0 1 0 8.52 3.944c-2.041 2.403-3.896 4.951-5.483 7.688a8 8 0 0 1-.721-2.161c-.201-1.174-.091-2.476.769-3.687c.832-1.176 2.279-2.15 3.84-2.916c1.547-.759 3.135-1.279 4.17-1.577z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLeafSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.157.092a1.55 1.55 0 0 0-2.075 1.384c-.086 1.13-.15 2.886.052 4.703c.2 1.808.67 3.741 1.698 5.174c1.065 1.543 2.586 2.229 4 2.497c1.404.265 2.732.125 3.488-.004a2 2 0 0 0 .6-.196c-1.129-3.022-3.248-6.346-6.382-9.233a.625.625 0 0 1 .847-.92c3.072 2.83 5.227 6.076 6.473 9.12c.371-.685.835-1.717 1.038-2.906c.241-1.41.12-3.065-.977-4.609c-1.013-1.43-2.693-2.527-4.342-3.336C5.926.956 4.247.406 3.157.092\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLegalJusticeHammerHammerWorkLegalMalletOfficeCompanyGavelJusticeJudgeArbitrationCourt: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 13.29H8m-1 0v-2.5H1.5v2.5\"/><rect width=\"7.07\" height=\"4.24\" x=\"3.96\" y=\"2.17\" rx=\"1\" transform=\"rotate(-45 7.499 4.294)\"/><path d=\"m9 5.79l4.5 4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLegalJusticeScale1OfficeWorkLegalScaleJusticeCompanyArbitrationBalanceCourt: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 9.5L3 4L.5 9.5a2.5 2.5 0 0 0 5 0Zm8 0L11 4L8.5 9.5a2.5 2.5 0 0 0 5 0ZM1.5 4h11M7 4V2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLegalJusticeScale2OfficeWorkLegalScaleJusticeUnequalCompanyArbitrationUnbalanceCourt: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 11L3 4.82L.5 11a2.5 2.5 0 0 0 5 0Zm8-4L11 1.18L8.5 7a2.5 2.5 0 0 0 5 0Zm-12-1.5l11-5M7 3V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLemonFruitSeasoning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path d=\"M10.976 10.975c1.843-1.843 2.064-4.198 1.51-6.036c-.1-.334-.049-.694.115-1.002c.441-.826.453-1.683-.2-2.336c-.654-.654-1.511-.642-2.338-.2a1.33 1.33 0 0 1-1.002.116c-1.837-.553-4.19-.331-6.033 1.511C1.187 4.87.964 7.222 1.516 9.06c.1.334.048.694-.116 1.001c-.442.828-.455 1.685.2 2.339c.653.653 1.509.642 2.335.201a1.33 1.33 0 0 1 1.002-.115c1.838.555 4.194.335 6.038-1.51Z\"/><path stroke-linecap=\"round\" d=\"M8.35 3.408c-1.203-.362-2.745-.217-3.952.99a3.87 3.87 0 0 0-1.12 2.177\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLemonFruitSeasoningRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.402 1.871c.346-.185.659-.258.92-.243c.25.015.49.111.715.337c.225.225.321.465.336.714c.016.261-.057.573-.242.92c-.234.439-.32.975-.164 1.49c.508 1.686.303 3.823-1.376 5.502c-1.68 1.68-3.818 1.884-5.503 1.375a1.97 1.97 0 0 0-1.492.164c-.346.184-.658.257-.919.241a1.07 1.07 0 0 1-.714-.336a1.07 1.07 0 0 1-.336-.715c-.015-.262.058-.574.243-.92c.235-.44.32-.975.165-1.49c-.506-1.686-.3-3.82 1.378-5.497C5.09 1.734 7.226 1.529 8.91 2.036c.516.155 1.052.07 1.49-.165m2.519-.79a2.32 2.32 0 0 0-1.525-.7c-.549-.033-1.09.125-1.583.388a.72.72 0 0 1-.542.07C7.228.224 4.59.469 2.53 2.529S.224 7.226.838 9.269a.72.72 0 0 1-.07.54c-.264.494-.421 1.036-.389 1.584c.033.561.262 1.088.7 1.526s.964.667 1.524.7c.548.033 1.09-.124 1.581-.386a.72.72 0 0 1 .542-.07c2.044.617 4.687.374 6.749-1.688s2.305-4.702 1.689-6.746a.72.72 0 0 1 .07-.542c.262-.492.42-1.034.387-1.582a2.32 2.32 0 0 0-.7-1.524M4.403 6.73A2.75 2.75 0 0 1 7.91 4.49a.75.75 0 1 0 .43-1.44a4.25 4.25 0 0 0-5.42 3.468a.75.75 0 0 0 1.484.212\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLemonFruitSeasoningSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.326.591c.524.03 1.016.245 1.428.656s.625.904.656 1.428c.03.513-.116 1.026-.368 1.498a.83.83 0 0 0-.077.622c.597 1.981.36 4.538-1.636 6.534c-1.997 1.997-4.555 2.233-6.537 1.635a.83.83 0 0 0-.622.077c-.472.252-.984.398-1.497.368a2.17 2.17 0 0 1-1.427-.657a2.17 2.17 0 0 1-.656-1.428c-.03-.515.117-1.027.37-1.5a.83.83 0 0 0 .077-.621C.442 7.223.68 4.669 2.675 2.675C4.67.679 7.225.442 9.205 1.038A.83.83 0 0 0 9.827.96c.472-.252.985-.4 1.499-.369M5.053 4.894c.978-.978 2.218-1.1 3.207-.803a.75.75 0 1 0 .432-1.436c-1.419-.427-3.263-.258-4.7 1.178a4.62 4.62 0 0 0-1.33 2.594a.75.75 0 0 0 1.483.227a3.12 3.12 0 0 1 .908-1.76\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLift: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m8.996 5.698l2.252-2.252L13.5 5.698M8.996 9.302l2.252 2.252L13.5 9.302M3.8 4.65a1.886 1.886 0 1 0 0-3.77a1.886 1.886 0 0 0 0 3.772\"/><path d=\"M7.101 7.952a3.3 3.3 0 0 0-6.601 0v1.414h1.415l.471 3.772h2.83l.47-3.772h1.415z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiftDisability: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m9.5 2.5l2-2l2 2m-4 3l2 2l2-2M6 6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 0v3h2a1 1 0 0 1 1 1v3M3.5 7.5a3 3 0 1 0 2.83 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiftDisabilityRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.854.146a.5.5 0 0 0-.708 0l-2 2A.5.5 0 0 0 9.5 3h4a.5.5 0 0 0 .354-.854zM4.037 7.15a1.187 1.187 0 0 1 2.338.288V9.25h1.34c.65 0 1.238.387 1.494.985l1.24 2.894a.625.625 0 0 1-1.148.492l-1.24-2.894a.38.38 0 0 0-.345-.227H5.28a1.625 1.625 0 0 1-1.577-2.02zm-.958.21a.625.625 0 0 1-.344.813a2.376 2.376 0 1 0 2.887 3.489a.625.625 0 1 1 1.05.678a3.625 3.625 0 1 1-4.407-5.325c.32-.13.685.025.814.345m5.96-2.05A.5.5 0 0 1 9.5 5h4a.5.5 0 0 1 .354.854l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1-.108-.545M4.5 3.25a.875.875 0 1 1 1.75 0a.875.875 0 0 1-1.75 0m.875-2.125a2.125 2.125 0 1 0 0 4.25a2.125 2.125 0 0 0 0-4.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiftDisabilitySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.854.146a.5.5 0 0 0-.707 0l-2 2A.5.5 0 0 0 9.5 3h4a.5.5 0 0 0 .354-.854zM9.5 5a.5.5 0 0 0-.354.854l2 2a.5.5 0 0 0 .708 0l2-2A.5.5 0 0 0 13.5 5zm-5.143-.74a1.741 1.741 0 1 1 3.483 0a1.741 1.741 0 0 1-3.483 0M7.1 7.485a1 1 0 1 0-2 0v2.482a1 1 0 0 0 1 1h1.895v1.978a1 1 0 1 0 2 0v-2.013A1.965 1.965 0 0 0 8.03 8.968H7.1zM4.438 7.36a.75.75 0 0 1-.75.75a2.145 2.145 0 1 0 1.358 3.808a.75.75 0 1 1 .949 1.162a3.645 3.645 0 1 1-2.307-6.47a.75.75 0 0 1 .75.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiftRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 2.625a1.375 1.375 0 1 1 2.75 0a1.375 1.375 0 0 1-2.75 0m4 0a2.62 2.62 0 0 1-.752 1.84A4 4 0 0 1 8 8v1.375c0 .345-.28.625-.625.625H6.302l-.432 3.453a.625.625 0 0 1-.62.547h-2.5a.625.625 0 0 1-.62-.547L1.698 10H.625A.625.625 0 0 1 0 9.375V8a4 4 0 0 1 2.127-3.535a2.625 2.625 0 1 1 4.498-1.84m4.521.521a.5.5 0 0 1 .708 0l2 2A.5.5 0 0 1 13.5 6h-4a.5.5 0 0 1-.354-.854zM9.5 8a.5.5 0 0 0-.354.854l2 2a.5.5 0 0 0 .708 0l2-2A.5.5 0 0 0 13.5 8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiftSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.554 4.061a2.03 2.03 0 1 0 0-4.061a2.03 2.03 0 0 0 0 4.061m8.047-.968a.5.5 0 0 0-.707 0L8.642 5.345a.5.5 0 0 0 .354.853H13.5a.5.5 0 0 0 .354-.853L11.6 3.093ZM8.534 9.11a.5.5 0 0 1 .462-.308H13.5a.5.5 0 0 1 .354.853L11.6 11.907a.5.5 0 0 1-.707 0L8.642 9.655a.5.5 0 0 1-.108-.545M6.067 5.903a3.55 3.55 0 0 1 1.04 2.512V9.44a.5.5 0 0 1-.5.5H5.585l-.452 3.623a.5.5 0 0 1-.497.438H2.472a.5.5 0 0 1-.496-.438L1.523 9.94H.5a.5.5 0 0 1-.5-.5V8.415a3.554 3.554 0 0 1 6.067-2.512\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLightbulb: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 5.031a4.5 4.5 0 1 0-6.5 4v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1.5a4.48 4.48 0 0 0 2.5-4M5 13.5h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLightbulbRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.125 5.125a3.875 3.875 0 1 1 5.597 3.473a.63.63 0 0 0-.347.56v.967h-2.75v-.968a.63.63 0 0 0-.347-.56a3.88 3.88 0 0 1-2.153-3.472M7 0a5.125 5.125 0 0 0-2.625 9.527v.723c0 .621.504 1.125 1.125 1.125h3c.621 0 1.125-.504 1.125-1.125v-.723A5.125 5.125 0 0 0 7 0M5.25 12.25a.875.875 0 0 0 0 1.75h3.5a.875.875 0 0 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLightbulbSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.5 9.331a5 5 0 1 0-5 0V10.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1zm-5 3.919a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLike1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.046 5.814h2.351v6.26h-2.35a.496.496 0 0 1-.497-.496V6.31a.496.496 0 0 1 .496-.496\"/><path d=\"m3.397 5.814l2.52-4.028a1.08 1.08 0 0 1 .933-.516a1.1 1.1 0 0 1 1.14 1.09v2.887h4.356a1.14 1.14 0 0 1 1.091 1.31l-.793 5.119a1.13 1.13 0 0 1-1.121.992H5.014c-.31.001-.615-.07-.892-.208l-.715-.357m-.01-6.289v6.26\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLike1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.066 13.125h6.382a1.756 1.756 0 0 0 1.74-1.53l.792-5.11V6.48a1.765 1.765 0 0 0-1.709-2.027H8.666V2.187A1.726 1.726 0 0 0 6.892.476a1.7 1.7 0 0 0-1.456.812l-.002.002l-2.399 3.855H.996A.996.996 0 0 0 0 6.14v5.268a.996.996 0 0 0 .996.996H3l.178.089l.714.357c.365.182.767.275 1.174.274m-.615-1.393l-.369-.184l.003-5.725l2.413-3.876l.002-.004a.46.46 0 0 1 .422-.218a.476.476 0 0 1 .494.47V5.08c0 .345.28.625.625.625h4.218a.516.516 0 0 1 .486.59v.002l-.794 5.116l-.003.02a.506.506 0 0 1-.5.443H5.061a1.36 1.36 0 0 1-.611-.143\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLike1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.41 12.961a2.5 2.5 0 0 0 1.076.244h5.346a2.5 2.5 0 0 0 2.47-2.114l.626-4.003a2 2 0 0 0-1.976-2.31H8.67V2.422a1.625 1.625 0 0 0-3.044-.794l-2.077 3.71a1.5 1.5 0 0 0-.191.733v5.442a1.5 1.5 0 0 0 .854 1.354zm-3.366-7.44a.996.996 0 0 0-.997.996v5.112a.997.997 0 0 0 .997.997h.496a.5.5 0 0 0 .5-.5V6.02a.5.5 0 0 0-.5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowCrossoverDownRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.442.558a.625.625 0 0 1 0 .884l-4.25 4.25a.625.625 0 1 1-.884-.884l4.25-4.25a.625.625 0 0 1 .884 0m-7.75 7.75a.625.625 0 0 1 0 .884l-3.183 3.183H5a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 13V9a.625.625 0 1 1 1.25 0v2.491l3.183-3.183a.625.625 0 0 1 .884 0M.558.558a.625.625 0 0 1 .884 0l10.933 10.933V9a.625.625 0 1 1 1.25 0v4a.624.624 0 0 1-.625.625H9a.625.625 0 1 1 0-1.25h2.491L.558 1.442a.625.625 0 0 1 0-.884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowCrossoverLeftRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.558.558a.625.625 0 1 1 .884.884L2.509 12.375H5a.625.625 0 1 1 0 1.25H1A.624.624 0 0 1 .375 13V9a.625.625 0 1 1 1.25 0v2.491zM.761.422A.62.62 0 0 0 .375 1v4a.625.625 0 1 0 1.25 0V2.509l3.433 3.433a.625.625 0 1 0 .884-.884L2.509 1.625H5a.625.625 0 1 0 0-1.25H1a.6.6 0 0 0-.24.047m7.297 7.636a.625.625 0 0 1 .884 0l4.5 4.5a.625.625 0 1 1-.884.884l-4.5-4.5a.625.625 0 0 1 0-.884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowCrossoverRightRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.442.558a.62.62 0 0 1 .183.442v4a.625.625 0 1 1-1.25 0V2.509L1.442 13.442a.625.625 0 1 1-.884-.884L11.491 1.625H9a.625.625 0 1 1 0-1.25h4c.16 0 .32.061.442.183m-4.5 7.5a.625.625 0 1 0-.884.884l3.433 3.433H9a.625.625 0 1 0 0 1.25h4c.345 0 .625-.28.625-.625V9a.625.625 0 1 0-1.25 0v2.491zM.558.558a.625.625 0 0 1 .884 0l4.5 4.5a.625.625 0 1 1-.884.884l-4.5-4.5a.625.625 0 0 1 0-.884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowCrossoverUpRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 .375a.625.625 0 1 0 0 1.25h2.491L8.058 5.058a.625.625 0 1 0 .884.884l3.433-3.433V5a.625.625 0 1 0 1.25 0V1A.625.625 0 0 0 13 .375zM5.942 8.058a.625.625 0 0 1 0 .884l-4.5 4.5a.625.625 0 1 1-.884-.884l4.5-4.5a.625.625 0 0 1 .884 0M2.509 1.625H5a.625.625 0 1 0 0-1.25H1C.84.375.68.436.558.558L.557.56A.62.62 0 0 0 .375 1v4a.625.625 0 1 0 1.25 0V2.509l10.933 10.933a.625.625 0 1 0 .884-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowCurveLeftDownRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 1.25a3.375 3.375 0 0 0-3.375 3.375v7.241l1.433-1.433a.625.625 0 1 1 .884.884l-2.5 2.5a.625.625 0 0 1-.884 0l-2.5-2.5a.625.625 0 1 1 .884-.884l1.433 1.433V4.625A4.625 4.625 0 0 1 9 0h2.5a.625.625 0 1 1 0 1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowCurveRightDownRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 1.25a3.375 3.375 0 0 1 3.375 3.375v7.241l-1.433-1.433a.625.625 0 1 0-.884.884l2.5 2.5c.244.244.64.244.884 0l2.5-2.5a.625.625 0 1 0-.884-.884l-1.433 1.433V4.625A4.625 4.625 0 0 0 5 0H2.5a.625.625 0 1 0 0 1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowCurvyUpDown1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.51.048a.625.625 0 0 1 .682.135l2.5 2.5a.625.625 0 1 1-.884.884l-1.433-1.433V11.5a2.5 2.5 0 0 1-5 0v-9a1.25 1.25 0 1 0-2.5 0v10.875a.625.625 0 0 1-1.067.442l-2.5-2.5a.625.625 0 0 1 .884-.884l1.433 1.433V2.5a2.5 2.5 0 0 1 5 0v9a1.25 1.25 0 1 0 2.5 0V.625c0-.253.152-.48.386-.577\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowDownDashedSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h.5a.625.625 0 1 0 0-1.25H2C1.103.375.375 1.103.375 2v.5a.625.625 0 1 0 1.25 0zm6 2a.625.625 0 1 0-1.25 0v4.491l-.933-.933a.625.625 0 1 0-.884.884l2 2a.62.62 0 0 0 .436.183h.012a.62.62 0 0 0 .436-.183l2-2a.625.625 0 1 0-.884-.884l-.933.933zM1 10.875c.345 0 .625.28.625.625v.5c0 .207.168.375.375.375h.5a.625.625 0 1 1 0 1.25H2A1.625 1.625 0 0 1 .375 12v-.5c0-.345.28-.625.625-.625m5 1.5a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25zm7-1.5c.345 0 .625.28.625.625v.5c0 .898-.727 1.625-1.625 1.625h-.5a.625.625 0 1 1 0-1.25h.5a.375.375 0 0 0 .375-.375v-.5c0-.345.28-.625.625-.625M13.625 6a.625.625 0 1 0-1.25 0v2a.625.625 0 1 0 1.25 0zM1 5.375c.345 0 .625.28.625.625v2a.625.625 0 1 1-1.25 0V6c0-.345.28-.625.625-.625M5.375 1c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25H6A.625.625 0 0 1 5.375 1M11.5.375a.625.625 0 1 0 0 1.25h.5c.207 0 .375.168.375.375v.5a.625.625 0 1 0 1.25 0V2c0-.897-.727-1.625-1.625-1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowExpandWindow1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625A.375.375 0 0 0 1.625 2v10c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375V8a.625.625 0 1 1 1.25 0v4c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12V2C.375 1.103 1.103.375 2 .375h4a.625.625 0 1 1 0 1.25zM8.375 1c0-.345.28-.625.625-.625h4c.345 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0V2.509L7.442 7.442a.625.625 0 1 1-.884-.884l4.933-4.933H9A.625.625 0 0 1 8.375 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowFitToHeightSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12zM2 .375C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625zm3.442 7.683a.625.625 0 1 0-.884.884l2 2c.244.244.64.244.884 0l2-2a.625.625 0 1 0-.884-.884l-.933.933V5.01l.933.933a.625.625 0 1 0 .884-.884l-2-2a.623.623 0 0 0-.884 0l-2 2a.625.625 0 1 0 .884.884l.933-.933v3.98z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowInfiniteLoopRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.797 2.482a.61.61 0 0 1 0 .866L9.44 4.705h.924c1.393 0 2.305.572 2.845 1.343c.515.736.651 1.593.651 2.153c0 .561-.136 1.418-.651 2.154c-.54.77-1.452 1.342-2.845 1.342c-.948 0-1.695-.48-2.295-1.08c-.584-.584-1.093-1.347-1.56-2.046l-.019-.03c-.49-.734-.936-1.4-1.425-1.889c-.481-.48-.935-.721-1.429-.721c-1.01 0-1.54.39-1.84.82c-.327.466-.43 1.05-.43 1.45s.103.985.43 1.451c.3.43.83.82 1.84.82c.512 0 .982-.259 1.482-.775a.613.613 0 0 1 .88.852c-.612.632-1.379 1.148-2.362 1.148c-1.393 0-2.305-.571-2.845-1.342C.276 9.619.14 8.762.14 8.2s.137-1.418.651-2.153c.54-.77 1.452-1.343 2.845-1.343c.948 0 1.695.48 2.295 1.08c.584.585 1.093 1.348 1.56 2.047l.019.03c.49.734.936 1.4 1.425 1.889c.481.48.935.721 1.429.721c1.01 0 1.54-.39 1.84-.82c.327-.466.43-1.05.43-1.45s-.103-.986-.43-1.451c-.3-.43-.83-.82-1.84-.82H7.961a.613.613 0 0 1-.433-1.046L9.93 2.482a.61.61 0 0 1 .866 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowMinimizeWindow1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 12.375a.375.375 0 0 0 .375-.375V2A.375.375 0 0 0 12 1.625H2A.375.375 0 0 0 1.625 2v4a.625.625 0 1 1-1.25 0V2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v10c0 .898-.727 1.625-1.625 1.625H8a.625.625 0 1 1 0-1.25zM5.625 13c0 .345-.28.625-.625.625H1A.625.625 0 0 1 .375 13V9a.625.625 0 1 1 1.25 0v2.491l4.933-4.933a.625.625 0 1 1 .884.884l-4.933 4.933H5c.345 0 .625.28.625.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowMoveDown1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625v7.491l1.933-1.933a.625.625 0 1 1 .884.884l-3 3a.625.625 0 0 1-.884 0l-3-3a.625.625 0 1 1 .884-.884l1.933 1.933V.625C6.375.28 6.655 0 7 0M3.5 12.75a.625.625 0 1 0 0 1.25h7a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowMoveHorizontalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .375c.345 0 .625.28.625.625v12a.625.625 0 1 1-1.25 0V1c0-.345.28-.625.625-.625M4.067 3.558a.625.625 0 0 1 0 .884L1.509 7l2.558 2.558a.625.625 0 1 1-.884.884l-3-3a.625.625 0 0 1 0-.884l3-3a.625.625 0 0 1 .884 0m6.75 0a.625.625 0 1 0-.884.884L12.491 7L9.933 9.558a.625.625 0 1 0 .884.884l3-3a.625.625 0 0 0 0-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowMoveLeft2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.625 2c0-.897-.727-1.625-1.625-1.625h-2c-.897 0-1.625.728-1.625 1.625v10c0 .898.728 1.625 1.625 1.625h2c.898 0 1.625-.727 1.625-1.625zM12 1.625c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375h-2A.375.375 0 0 1 9.625 12V2c0-.207.168-.375.375-.375zM7.625 7A.625.625 0 0 0 7 6.375H2.509l1.433-1.433a.625.625 0 1 0-.884-.884l-2.5 2.5a.625.625 0 0 0 0 .884l2.5 2.5a.625.625 0 0 0 .884-.884L2.509 7.625H7c.345 0 .625-.28.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowMoveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.442.558a.625.625 0 0 0-.884 0l-2 2a.625.625 0 1 0 .884.884l.933-.933v3.866H2.509l.933-.933a.625.625 0 1 0-.884-.884l-2 2a.625.625 0 0 0 0 .884l2 2a.625.625 0 1 0 .884-.884l-.933-.933h3.866v3.866l-.933-.933a.625.625 0 1 0-.884.884l2 2c.244.244.64.244.884 0l2-2a.625.625 0 1 0-.884-.884l-.933.933V7.625h3.866l-.933.933a.625.625 0 1 0 .884.884l2-2a.62.62 0 0 0 .183-.436v-.012a.63.63 0 0 0-.183-.436l-2-2a.625.625 0 1 0-.884.884l.933.933H7.625V2.509l.933.933a.625.625 0 1 0 .884-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowMoveRight2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.103 1.103.375 2 .375h2c.897 0 1.625.728 1.625 1.625v10c0 .898-.728 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12zM2 1.625A.375.375 0 0 0 1.625 2v10c0 .207.168.375.375.375h2A.375.375 0 0 0 4.375 12V2A.375.375 0 0 0 4 1.625zM6.375 7c0-.345.28-.625.625-.625h4.491l-1.433-1.433a.625.625 0 1 1 .884-.884l2.5 2.5a.62.62 0 0 1 .183.436v.012a.62.62 0 0 1-.183.436l-2.5 2.5a.625.625 0 1 1-.884-.884l1.433-1.433H7A.625.625 0 0 1 6.375 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowReloadVertical1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.485.066a.625.625 0 1 0 0 1.25h2.397c.207 0 .375.168.375.375v8.168l-1.36-1.36a.625.625 0 1 0-.883.884l2.421 2.422a.62.62 0 0 0 .447.188a.62.62 0 0 0 .447-.188l2.422-2.422a.625.625 0 0 0-.884-.884l-1.36 1.36V1.69c0-.897-.727-1.625-1.625-1.625zM2.673 2.192a.63.63 0 0 1 .444-.185a.62.62 0 0 1 .442.183l2.427 2.427a.625.625 0 0 1-.884.884l-1.36-1.36v8.168c0 .207.168.375.375.375h2.398a.625.625 0 1 1 0 1.25H4.117a1.625 1.625 0 0 1-1.625-1.625V4.14L1.132 5.5a.625.625 0 0 1-.883-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowReloadVertical2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m10.375 5.616l-.933-.933a.625.625 0 1 0-.884.884l2 2a.62.62 0 0 0 .88.004m.004-.004l2-2a.625.625 0 1 0-.884-.884l-.933.933V2.625A2.625 2.625 0 0 0 9 0H5a2.625 2.625 0 0 0-2.625 2.625v1.75a.625.625 0 1 0 1.25 0v-1.75c0-.76.616-1.375 1.375-1.375h4c.76 0 1.375.616 1.375 1.375v2.991m-7.614.681a.6.6 0 0 0-.203.136l-2 2a.625.625 0 1 0 .884.884l.933-.933v2.991A2.625 2.625 0 0 0 5 14h4a2.625 2.625 0 0 0 2.625-2.625v-1.75a.625.625 0 1 0-1.25 0v1.75c0 .76-.616 1.375-1.375 1.375H5c-.76 0-1.375-.616-1.375-1.375V8.384l.933.933a.625.625 0 1 0 .884-.884l-2-2a.62.62 0 0 0-.681-.136\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowRotateLeft1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.279 1.192a.625.625 0 1 0-.884-.884L1.99 2.712a.62.62 0 0 0 0 .884L4.395 6a.625.625 0 1 0 .884-.884L3.942 3.779H7a4.423 4.423 0 1 1-4.423 4.423a.625.625 0 1 0-1.25 0A5.673 5.673 0 1 0 7 2.529H3.942z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowRotateRight1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.722 1.192a.625.625 0 1 1 .884-.884l2.403 2.404a.62.62 0 0 1 0 .884L9.606 6a.625.625 0 0 1-.884-.884l1.337-1.337H7a4.423 4.423 0 1 0 4.423 4.423a.625.625 0 1 1 1.25 0A5.673 5.673 0 1 1 7 2.529h3.059z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowShrinkDiagonal1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.442.558a.625.625 0 0 1 0 .884l-3.433 3.433H12.5a.625.625 0 1 1 0 1.25h-4a.623.623 0 0 1-.625-.625v-4a.625.625 0 1 1 1.25 0v2.491L12.558.558a.625.625 0 0 1 .884 0M6.078 8.261a.6.6 0 0 0-.135-.202h-.001l-.001-.002a.62.62 0 0 0-.441-.182h-4a.625.625 0 1 0 0 1.25h2.491L.558 12.558a.625.625 0 1 0 .884.884l3.433-3.433V12.5a.625.625 0 1 0 1.25 0v-4a.6.6 0 0 0-.047-.24\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowShrinkDiagonal2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.558.558a.625.625 0 0 1 .884 0l3.433 3.433V1.5a.625.625 0 1 1 1.25 0v4a.623.623 0 0 1-.625.625h-4a.625.625 0 1 1 0-1.25h2.491L.558 1.442a.625.625 0 0 1 0-.884m7.703 7.364a.6.6 0 0 0-.202.135v.001l-.002.001a.62.62 0 0 0-.182.441v4a.625.625 0 1 0 1.25 0v-2.491l3.433 3.433a.625.625 0 1 0 .884-.884l-3.433-3.433H12.5a.625.625 0 1 0 0-1.25h-4a.6.6 0 0 0-.24.047\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowShrinkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.442.558a.625.625 0 0 1 0 .884l-3.433 3.433H12.5a.625.625 0 1 1 0 1.25h-4a.623.623 0 0 1-.625-.625v-4a.625.625 0 1 1 1.25 0v2.491L12.558.558a.625.625 0 0 1 .884 0M6.078 8.261a.6.6 0 0 0-.135-.202h-.001l-.001-.002a.62.62 0 0 0-.441-.182h-4a.625.625 0 1 0 0 1.25h2.491L.558 12.558a.625.625 0 1 0 .884.884l3.433-3.433V12.5a.625.625 0 1 0 1.25 0v-4a.6.6 0 0 0-.047-.24m3.93.864H12.5a.625.625 0 1 0 0-1.25h-4a.625.625 0 0 0-.625.625v4a.625.625 0 1 0 1.25 0v-2.491l3.433 3.433a.625.625 0 1 0 .884-.884zM.559.558a.625.625 0 0 1 .884 0l3.433 3.433V1.5a.625.625 0 1 1 1.25 0v4a.623.623 0 0 1-.625.625h-4a.625.625 0 1 1 0-1.25h2.491L.558 1.442a.625.625 0 0 1 0-.884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowSplitVerticalUp2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .125a.62.62 0 0 0-.44.182L.557.308A.62.62 0 0 0 .375.75v3.5a.625.625 0 1 0 1.25 0V2.259l4.75 4.75v6.241a.625.625 0 1 0 1.25 0V7.009l4.75-4.75V4.25a.625.625 0 1 0 1.25 0V.75A.624.624 0 0 0 13 .125H9.5a.625.625 0 1 0 0 1.25h1.991L7 5.866L2.509 1.375H4.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowSynchronizeDisableRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.489 2.605A5.6 5.6 0 0 1 7 1.375a.625.625 0 1 0 0-1.25a6.85 6.85 0 0 0-4.4 1.592L1.193.308a.625.625 0 0 0-.884.884l1.83 1.83l8.84 8.84l1.83 1.83a.625.625 0 1 0 .884-.884l-1.41-1.408A6.85 6.85 0 0 0 13.875 7a6.85 6.85 0 0 0-1.823-4.662h.717a.625.625 0 1 0 0-1.25h-2.403a.625.625 0 0 0-.625.625v2.403a.625.625 0 0 0 1.25 0v-1.08A5.6 5.6 0 0 1 12.625 7c0 1.328-.46 2.548-1.23 3.511zm6.305 10.022a.625.625 0 0 1-.363.806A6.9 6.9 0 0 1 7 13.875a.625.625 0 1 1 0-1.25c.701 0 1.371-.128 1.989-.362a.625.625 0 0 1 .805.364m-5.534-.339V9.885a.625.625 0 0 0-1.25 0v1.08A5.6 5.6 0 0 1 1.375 7c0-.715.133-1.397.375-2.025a.625.625 0 0 0-1.166-.45A6.9 6.9 0 0 0 .125 7c0 1.8.692 3.438 1.824 4.664H1.23a.625.625 0 1 0 0 1.25h2.404c.345 0 .625-.28.625-.626\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowSynchronizeWarningRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.375A5.6 5.6 0 0 0 3.035 3.01h1.08a.625.625 0 1 1 0 1.25H1.711a.625.625 0 0 1-.625-.625V1.23a.625.625 0 0 1 1.25 0v.718A6.875 6.875 0 0 1 13.875 7a.625.625 0 1 1-1.25 0A5.625 5.625 0 0 0 7 1.375M7 3.25c.345 0 .625.28.625.625V7.24a.625.625 0 1 1-1.25 0V3.875c0-.345.28-.625.625-.625m.01 7.26H7a.865.865 0 0 1-.01-1.731H7a.865.865 0 0 1 .01 1.73M1.375 7a.625.625 0 1 0-1.25 0a6.875 6.875 0 0 0 11.539 5.051v.718a.625.625 0 0 0 1.25 0v-2.404a.625.625 0 0 0-.625-.625H9.885a.625.625 0 0 0 0 1.25h1.08A5.625 5.625 0 0 1 1.375 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowUp1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.558.19a.625.625 0 0 1 .884 0l3.918 3.92a.625.625 0 1 1-.884.884L7.625 2.14v11.227a.625.625 0 1 1-1.25 0V2.14L3.523 4.993a.625.625 0 0 1-.883-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLineArrowUpDashedSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h.5a.625.625 0 1 0 0-1.25H2C1.103.375.375 1.103.375 2v.5a.625.625 0 1 0 1.25 0zm5.136 1.422a.6.6 0 0 0-.203.136l-2 2a.625.625 0 1 0 .884.884l.933-.933V10a.625.625 0 1 0 1.25 0V5.509l.933.933a.625.625 0 1 0 .884-.884l-2-2a.62.62 0 0 0-.681-.136M1 10.875c.345 0 .625.28.625.625v.5c0 .207.168.375.375.375h.5a.625.625 0 1 1 0 1.25H2A1.625 1.625 0 0 1 .375 12v-.5c0-.345.28-.625.625-.625m5 1.5a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25zm7-1.5c.345 0 .625.28.625.625v.5c0 .898-.727 1.625-1.625 1.625h-.5a.625.625 0 1 1 0-1.25h.5a.375.375 0 0 0 .375-.375v-.5c0-.345.28-.625.625-.625M13.625 6a.625.625 0 1 0-1.25 0v2a.625.625 0 1 0 1.25 0zM1 5.375c.345 0 .625.28.625.625v2a.625.625 0 1 1-1.25 0V6c0-.345.28-.625.625-.625M5.375 1c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25H6A.625.625 0 0 1 5.375 1M11.5.375a.625.625 0 1 0 0 1.25h.5c.207 0 .375.168.375.375v.5a.625.625 0 1 0 1.25 0V2c0-.897-.727-1.625-1.625-1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLinkChain: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m6 3l1.464-1.464a3.536 3.536 0 0 1 5 5L11 8m-3 3l-1.464 1.465a3.536 3.536 0 0 1-5-5L3 6m6-1L5 9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLinkChainRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.103 12.781a4.16 4.16 0 1 1-5.884-5.883l1.5-1.5a.625.625 0 0 1 .884.883l-1.5 1.5a2.91 2.91 0 1 0 4.116 4.116l1.5-1.5a.625.625 0 1 1 .884.884zm-2.81-3.074a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0m8.488-8.488a4.16 4.16 0 0 0-5.883 0l-1.5 1.5a.625.625 0 1 0 .883.883l1.5-1.5a2.91 2.91 0 1 1 4.117 4.117l-1.5 1.5a.625.625 0 1 0 .883.883l1.5-1.5a4.16 4.16 0 0 0 0-5.883\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLinkChainSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.672 2.743l-.965.964a1 1 0 0 1-1.414-1.414l.964-.965a4.536 4.536 0 0 1 6.415 6.415l-.965.964a1 1 0 1 1-1.414-1.414l.964-.965a2.536 2.536 0 0 0-3.585-3.585m-3.965 2.55a1 1 0 0 1 0 1.414l-.964.965a2.536 2.536 0 0 0 3.585 3.585l.965-.964a1 1 0 0 1 1.414 1.414l-.964.964a4.536 4.536 0 0 1-6.415-6.414l.965-.964a1 1 0 0 1 1.414 0m5.5.914a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLinkedin: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.574 1.767a1.316 1.316 0 0 1-1.287 1.326A1.346 1.346 0 0 1 .99 1.767A1.326 1.326 0 0 1 2.287.5a1.316 1.316 0 0 1 1.287 1.267M1.129 5.449c0-.762.485-.643 1.158-.643s1.148-.119 1.148.643v7.424c0 .772-.485.614-1.148.614s-1.158.158-1.158-.614zm4.306.001c0-.426.158-.585.405-.634s1.1 0 1.396 0c.297 0 .416.485.406.851a2.49 2.49 0 0 1 2.217-.99a2.97 2.97 0 0 1 3.148 3.098v5.068c0 .772-.475.614-1.149.614s-1.148.158-1.148-.614V8.884A1.425 1.425 0 0 0 9.206 7.34A1.435 1.435 0 0 0 7.74 8.914v3.959c0 .772-.485.614-1.158.614s-1.148.158-1.148-.614z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLinkedinRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.183 0H2.16A1.826 1.826 0 0 0 .375 1.774a1.846 1.846 0 0 0 1.808 1.82a1.816 1.816 0 0 0 1.775-1.83v-.016A1.816 1.816 0 0 0 2.183 0m.407 5.44a6 6 0 0 0-.418-.01c-.174 0-.307.001-.42.01a1 1 0 0 0-.113.012v7.264q.043.008.115.013c.114.007.246.008.418.008s.303 0 .416-.008q.066-.005.107-.012V5.451a1 1 0 0 0-.105-.012m1.18-.688c.132.22.175.464.175.697v7.299c0 .233-.046.477-.186.694a1.1 1.1 0 0 1-.545.428c-.185.07-.377.094-.54.105c-.16.012-.333.012-.49.012H2.16c-.157 0-.33 0-.492-.012a2 2 0 0 1-.542-.104a1.1 1.1 0 0 1-.547-.425a1.25 1.25 0 0 1-.19-.698V5.449c0-.235.044-.481.18-.7c.14-.229.342-.366.543-.445c.189-.074.385-.1.55-.112c.163-.011.338-.011.498-.011h.024c.16 0 .334 0 .496.011c.164.012.36.039.549.113c.2.08.4.219.54.447M8.257 6.04c.361-.484.92-.738 1.717-.738c1.375 0 2.522 1.09 2.522 2.473v4.913q-.04.006-.103.01c-.113.009-.246.009-.42.009s-.307 0-.42-.008l-.103-.01V8.883c0-1.174-.88-2.229-2.14-2.17c-1.248-.017-2.08 1.013-2.08 2.2v3.803a1 1 0 0 1-.11.012a7 7 0 0 1-.423.008a7 7 0 0 1-.42-.008l-.103-.01V5.421l.073-.002a10 10 0 0 1 .373.002c.103.002.217.006.327.01l.168.004a1 1 0 0 1 .016.214a.625.625 0 0 0 1.126.39m1.717-1.988c-.7 0-1.356.151-1.91.495a.88.88 0 0 0-.714-.356c-.078 0-.19-.004-.327-.008q-.168-.006-.375-.01a11 11 0 0 0-.425-.003a2.4 2.4 0 0 0-.39.033a1.07 1.07 0 0 0-.683.426c-.176.247-.226.541-.226.82v7.299c0 .23.044.474.183.69c.143.225.345.357.542.431c.186.07.379.095.542.106c.16.012.335.012.494.012h.024c.16 0 .334 0 .496-.012a1.9 1.9 0 0 0 .542-.105c.197-.073.4-.203.546-.427a1.26 1.26 0 0 0 .187-.695V8.914c0-.625.39-.96.825-.95h.052c.434-.026.843.328.843.92v3.834c0 .23.044.474.183.691c.143.225.345.356.542.43c.186.07.379.096.542.107c.16.01.335.01.494.01h.024c.16 0 .333 0 .494-.01c.163-.011.356-.036.541-.106c.198-.075.4-.206.543-.43c.139-.218.183-.461.183-.692V7.775c0-2.11-1.745-3.723-3.772-3.723\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLinkedinSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.913 2.362c.26-.268.403-.626.4-.998A1.417 1.417 0 0 0 1.928 0A1.43 1.43 0 0 0 .532 1.364a1.45 1.45 0 0 0 1.396 1.428a1.42 1.42 0 0 0 .985-.43M1.67 4.63c-.587-.013-.987-.022-.987.696v7.992c0 .703.382.689.932.668q.15-.007.314-.008q.165.001.314.008c.548.02.922.035.922-.668V5.327c0-.718-.392-.71-.976-.696q-.125.003-.26.004q-.135 0-.26-.004m4.084.015c-.266.053-.437.223-.437.681v7.991c0 .704.367.69.918.669q.15-.007.318-.008q.168.001.319.008c.554.02.928.035.928-.668V9.057a1.545 1.545 0 0 1 1.577-1.695a1.534 1.534 0 0 1 1.62 1.663v4.262c0 .703.366.689.917.668q.15-.007.318-.008q.168.001.319.008c.551.02.917.035.917-.668V7.83a3.195 3.195 0 0 0-3.388-3.335a2.67 2.67 0 0 0-2.387 1.066c.011-.394-.117-.916-.436-.916c-.092 0-.233-.005-.393-.01c-.4-.012-.92-.028-1.11.01\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLipstick: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.29 9.71a1 1 0 0 0 0 1.41l2.09 2.09a1 1 0 0 0 1.41 0L8.5 9.5L5 6z\"/><path d=\"M5.54 6.54L11.29.79a1 1 0 0 1 1.09-.21a1 1 0 0 1 .62.92v2.17a1 1 0 0 1-.29.71L8 9m.04-4.96l2.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLipstickRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.783.178c.266-.073.55-.073.815.018c.267.09.492.268.642.509c.149.24.207.52.184.796v.003l-.171 1.981a1.5 1.5 0 0 1-.145.53q-.121.252-.317.452l-.005.004l-1.707 1.685a.625.625 0 0 1-.029.86L8.9 9.134a.5.5 0 0 1-.07.62l-3.662 3.685h-.001a1.484 1.484 0 0 1-2.1 0l-2.064-2.077a1.496 1.496 0 0 1 0-2.104v-.001L4.666 5.57a.5.5 0 0 1 .667-.037L7.451 3.4a.625.625 0 0 1 .857-.028L11.075.595l.001-.002c.197-.195.44-.341.707-.415m-3.888 4.55l-1.59 1.601l1.81 1.822l1.61-1.585z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLipstickSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m11.496 5.656l-.09-.09l1.621-1.589a.98.98 0 0 0 .285-.697V1.151a.98.98 0 0 0-.609-.903a.98.98 0 0 0-1.07.206l-2.669 2.67l-.13-.13a.75.75 0 0 0-1.06 0l-2.059 2.06l-.067-.067a.53.53 0 0 0-.749 0L1.166 8.719l-.001.001a1.64 1.64 0 0 0 0 2.311l2.32 2.32a1.64 1.64 0 0 0 2.311 0h.001l3.734-3.734a.53.53 0 0 0 0-.749l-.093-.093l2.058-2.058a.75.75 0 0 0 0-1.06M8.353 7.691l1.48-1.48l-1.554-1.553l-1.48 1.48z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiveVideo: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.014 8.764V5.236c0-.408.474-.666.86-.468l3.441 1.765a.515.515 0 0 1 0 .934l-3.44 1.765c-.387.198-.861-.06-.861-.468M.61 6.139a6.5 6.5 0 0 0 0 1.593m2.505-5.933a6.5 6.5 0 0 1 1.38-.797M1.068 4.43a6.5 6.5 0 0 1 .796-1.38\"/><path d=\"M7.012.5c3.55 0 6.427 2.91 6.427 6.5s-2.877 6.5-6.427 6.5c-2.446 0-4.573-1.382-5.659-3.416\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiveVideoRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.346.03Q6.67 0 7 0A7 7 0 1 1 .985 10.581a.625.625 0 1 1 1.073-.64a5.75 5.75 0 1 0 4.403-8.666a.625.625 0 0 1-.115-1.244m-.244 4.293c-.66-.338-1.588.067-1.588.913v3.528c0 .846.929 1.25 1.588.912l3.441-1.764c.76-.39.76-1.435 0-1.824zm-2-2.29A.625.625 0 0 0 3.47.956a7 7 0 0 0-1.854 1.571a.625.625 0 1 0 .96.8a5.8 5.8 0 0 1 1.525-1.292M1.439 5.538a.625.625 0 0 0-1.21-.316a7 7 0 0 0-.2 2.423a.625.625 0 1 0 1.245-.114a5.8 5.8 0 0 1 .165-1.993\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLiveVideoSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.09.084a.75.75 0 1 0-.232 1.482A5.502 5.502 0 0 1 7 12.5a5.5 5.5 0 0 1-5.116-3.475a.75.75 0 1 0-1.394.552A7.002 7.002 0 0 0 14 7A7 7 0 0 0 8.09.084M6.164.661a.75.75 0 0 1-.54.914a5.5 5.5 0 0 0-.735.246a.75.75 0 1 1-.576-1.385q.453-.19.938-.314a.75.75 0 0 1 .913.54M3.185 1.894a.75.75 0 0 1-.016 1.06a5.6 5.6 0 0 0-.95 1.225a.75.75 0 1 1-1.302-.744a7 7 0 0 1 1.208-1.557a.75.75 0 0 1 1.06.016M.916 5.28a.75.75 0 0 1 .638.847a6 6 0 0 0-.054.775a.75.75 0 0 1-1.5 0q0-.5.069-.984a.75.75 0 0 1 .847-.638M4.5 8.882V5.118a1 1 0 0 1 1.447-.894l3.764 1.882a1 1 0 0 1 0 1.788L5.947 9.776A1 1 0 0 1 4.5 8.882\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocalStorageFolder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.82 1.953H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7.234M6 10.953l-1 2.5m3-2.5l1 2.5m-5 0h6\"/><path d=\"M13.43 5.112c0 .24-.195.435-.435.435h-4.77a.435.435 0 0 1-.434-.435V.982a.435.435 0 0 1 .435-.435H9.83a.435.435 0 0 1 .435.33l.122.54h2.608a.435.435 0 0 1 .435.434z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocalStorageFolderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.644 0a.935.935 0 0 1 .935.754l.056.366h2.43a.935.935 0 0 1 .935.934v3.261a.935.935 0 0 1-.935.935h-5.27a.935.935 0 0 1-.934-.935V.935A.935.935 0 0 1 7.796 0zm3.231 11.5H8.789l.5 1.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 10.375v-7.5C0 2.254.504 1.75 1.125 1.75H5A.625.625 0 1 1 5 3H1.25v7.25h11.5V8.125a.625.625 0 1 1 1.25 0v2.25c0 .621-.504 1.125-1.125 1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocalStorageFolderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.796 5h4.77c.24 0 .434-.195.434-.435v-3.26a.435.435 0 0 0-.434-.435h-2.61l-.12-.54A.435.435 0 0 0 10.4 0H8.796a.435.435 0 0 0-.435.435v4.13A.435.435 0 0 0 8.796 5M2 3h4.25a1 1 0 0 0 0-2H1.457C.652 1 0 1.652 0 2.457v7.086C0 10.348.652 11 1.457 11h4.028l-.537 1.5H4A.75.75 0 0 0 4 14h6a.75.75 0 1 0 0-1.5h-.948L8.515 11h4.028C13.348 11 14 10.348 14 9.543V7.25a1 1 0 1 0-2 0V9H2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationCompass1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"m7.5 10.5l2-6l-6 2L6 8z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationCompass1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m2.854 4.146a.5.5 0 0 1 .12.512l-2 6a.5.5 0 0 1-.903.1L5.636 8.363L3.243 6.93a.5.5 0 0 1 .099-.903l6-2a.5.5 0 0 1 .512.12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationCompass1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m2.62 4.38a.5.5 0 0 1 .12.512l-1.844 5.532a.5.5 0 0 1-.903.1l-1.318-2.2l-2.198-1.317a.5.5 0 0 1 .099-.903L9.108 4.26a.5.5 0 0 1 .512.12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationPin3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 5c0 3-4.5 6.5-4.5 6.5S2.5 8 2.5 5C2.5 2.549 4.549.5 7 .5s4.5 2.049 4.5 4.5\"/><path d=\"M7 6.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m4.077 3.5H12l1.5 3.5H.5L2 10h.923\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationPin3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a3.875 3.875 0 0 0-3.875 3.875c0 1.29.68 2.449 1.534 3.387a11 11 0 0 0 2.21 1.83c.029.018.07.033.131.033s.102-.014.132-.033a11 11 0 0 0 2.21-1.83c.853-.938 1.533-2.096 1.533-3.387A3.875 3.875 0 0 0 7 1.25M1.875 5.125a5.125 5.125 0 1 1 10.25 0c0 1.736-.909 3.184-1.86 4.228a12.2 12.2 0 0 1-2.472 2.05c-.249.155-.525.222-.793.222s-.544-.067-.793-.222a12.2 12.2 0 0 1-2.473-2.05c-.95-1.044-1.859-2.492-1.859-4.228m.417 4.25c.2.266.406.512.61.735a13.3 13.3 0 0 0 2.71 2.248c.447.278.934.392 1.388.392s.941-.114 1.388-.392a13.3 13.3 0 0 0 2.71-2.248q.308-.335.61-.735h.542c.269 0 .508.172.593.427l1.125 3.375a.624.624 0 0 1-.593.823H.625a.625.625 0 0 1-.593-.823l1.125-3.375a.625.625 0 0 1 .593-.427zM7 6.5A1.75 1.75 0 1 0 7 3a1.75 1.75 0 0 0 0 3.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationPin3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c2.622 0 4.806 2.184 4.806 4.805c0 .856-.294 1.7-.705 2.464c-.413.768-.959 1.484-1.501 2.094a16 16 0 0 1-1.521 1.49a9 9 0 0 1-.546.433a3 3 0 0 1-.195.13a1 1 0 0 1-.174.083a.54.54 0 0 1-.405-.03a1 1 0 0 1-.098-.053a3 3 0 0 1-.196-.133a9 9 0 0 1-.545-.435A16 16 0 0 1 4.4 9.352c-.542-.612-1.088-1.33-1.5-2.095c-.411-.762-.706-1.603-.706-2.452C2.194 2.184 4.378 0 7 0m0 6.24a1.435 1.435 0 1 1 0-2.87a1.435 1.435 0 0 1 0 2.87m3.1 3.916q.276-.31.55-.65h1.343c.2 0 .38.12.46.303l1.497 3.495a.5.5 0 0 1-.46.697H.51a.5.5 0 0 1-.46-.697l1.498-3.495a.5.5 0 0 1 .46-.303h1.355q.266.33.537.636c.662.746 1.33 1.376 1.85 1.821c.26.223.487.402.661.528q.13.095.232.157q.049.03.11.06q.03.014.079.03a.55.55 0 0 0 .414-.03q.06-.029.11-.059q.101-.061.231-.155c.174-.126.4-.304.661-.525c.52-.442 1.19-1.069 1.851-1.813\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationPinDisabled: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.503.502l12.995 12.996M7.45 7.45a2 2 0 1 0-2.4-2.4\"/><path d=\"M2.678 2.678A5.4 5.4 0 0 1 7 .5c3.003 0 5.438 2.482 5.438 5.543c0 1.752-.839 3.302-1.857 4.538M1.776 4.5a5.7 5.7 0 0 0-.214 1.543c0 3.64 3.615 6.405 4.95 7.303c.298.2.678.2.976 0a16 16 0 0 0 1.758-1.376\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationPinDisabledRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m.185 1.07l2.093 2.092l.006.006l7.73 7.73l.007.007l2.91 2.91a.625.625 0 1 0 .883-.885l-2.52-2.52c.932-1.225 1.726-2.744 1.726-4.39A6.02 6.02 0 0 0 2.695 1.81L1.069.186a.625.625 0 1 0-.884.883M9 5.5c0 .71-.37 1.334-.928 1.688l-2.76-2.76A2 2 0 0 1 9 5.5m-6.685-.383a.625.625 0 1 0-1.228-.234Q.981 5.436.98 6.019c0 1.96 1.124 3.74 2.274 5.062a18 18 0 0 0 2.937 2.664c.244.175.529.256.809.256c.282 0 .567-.083.81-.258c.282-.202.814-.6 1.432-1.15a.625.625 0 0 0-.83-.935c-.579.514-1.075.886-1.33 1.07a.14.14 0 0 1-.082.023a.13.13 0 0 1-.08-.022a16.7 16.7 0 0 1-2.723-2.469C3.108 9.01 2.23 7.52 2.23 6.02q0-.465.085-.903\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationPinDisabledSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.28.22A.75.75 0 1 0 .22 1.28l12.5 12.5a.75.75 0 1 0 1.06-1.06l-2.378-2.379c.86-1.192 1.535-2.649 1.535-4.294C12.937 2.72 10.288.004 7 .004c-1.634 0-3.11.67-4.182 1.753zm4.104 4.103L8.18 7.118a2 2 0 1 0-2.795-2.795M1.062 6.047c0-.653.102-1.282.291-1.872l8.198 8.198a16 16 0 0 1-1.784 1.392a1.37 1.37 0 0 1-1.534 0c-.686-.462-1.965-1.407-3.077-2.714c-1.108-1.303-2.094-3.016-2.094-5.004\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationTarget1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M7 7.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m0-5v-2m0 13v-2M11.5 7h2M.5 7h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationTarget1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625v1.288a5.13 5.13 0 0 1 4.462 4.462h1.288a.625.625 0 1 1 0 1.25h-1.288a5.13 5.13 0 0 1-4.462 4.462v1.288a.625.625 0 1 1-1.25 0v-1.288a5.13 5.13 0 0 1-4.462-4.462H.625a.625.625 0 1 1 0-1.25h1.288a5.13 5.13 0 0 1 4.462-4.462V.625C6.375.28 6.655 0 7 0M3.125 7a3.875 3.875 0 1 0 7.75 0a3.875 3.875 0 0 0-7.75 0M5.75 7a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLocationTarget1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.766a.75.75 0 0 0-1.5 0v1.223A5.07 5.07 0 0 0 1.99 6.25H.765a.75.75 0 0 0 0 1.5h1.223a5.07 5.07 0 0 0 4.261 4.26v1.224a.75.75 0 0 0 1.5 0v-1.223a5.07 5.07 0 0 0 4.26-4.261h1.224a.75.75 0 0 0 0-1.5H12.01a5.07 5.07 0 0 0-4.26-4.26zm2.816 6.228a3.566 3.566 0 1 0-3.572 3.572h.012a3.566 3.566 0 0 0 3.56-3.56zM5.77 7a1.23 1.23 0 1 1 2.46 0a1.23 1.23 0 0 1-2.46 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLockRotation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" d=\"M13.326 8.5a6.5 6.5 0 1 1-.558-4.5\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 2v2.5H11\"/><path stroke-linejoin=\"round\" d=\"M4.75 9.25v-2a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3.5a.5.5 0 0 1-.5-.5Z\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 6.75v-1A1.5 1.5 0 0 1 7 4.25v0a1.5 1.5 0 0 1 1.5 1.5v1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLockRotationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.75 5.75 0 1 0 5.596 7.077a.625.625 0 0 1 1.217.288a7 7 0 1 1-1.462-6.129l.582-.582A.625.625 0 0 1 14 2.346v2.202c0 .345-.28.625-.625.625h-2.202a.625.625 0 0 1-.442-1.067l.732-.732A5.74 5.74 0 0 0 7 1.249m0 3.625a.875.875 0 0 0-.875.875v.5h1.75v-.5A.875.875 0 0 0 7 4.875m-2.125.875v.573a1 1 0 0 0-.625.927v2a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-2a1 1 0 0 0-.625-.927V5.75a2.125 2.125 0 0 0-4.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLockRotationSolid: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M1.5 7a5.5 5.5 0 0 1 9.82-3.405l-.966.965a.5.5 0 0 0 .353.854H13.5a.5.5 0 0 0 .5-.5V2.12a.5.5 0 0 0-.854-.354l-.76.761a7 7 0 1 0 1.427 6.086a.75.75 0 0 0-1.46-.344A5.5 5.5 0 0 1 1.5 7\"/><path d=\"M6.125 5.813a.875.875 0 1 1 1.75 0v.5h-1.75zm-1.25.719v-.72a2.125 2.125 0 1 1 4.25 0v.72a1 1 0 0 1 .375.78v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-2c0-.315.146-.597.375-.78\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLog: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 8a2 3.5 0 1 0 4 0a2 3.5 0 1 0-4 0\"/><path d=\"M2.5 4.5h9c1.105 0 2 1.567 2 3.5s-.895 3.5-2 3.5h-9m6-4.5h4.801M4.5 9.5H7m.5-5l-2-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.994 1.006a.875.875 0 0 0-1.238 1.238L5.513 3H2.875a.6.6 0 0 0-.29.072c-.763.205-1.365.831-1.774 1.567C.298 5.563 0 6.797 0 8.125s.298 2.562.81 3.486c.41.735 1.012 1.362 1.774 1.567a.6.6 0 0 0 .291.072h8c1.02 0 1.813-.737 2.314-1.64c.513-.923.811-2.157.811-3.485s-.298-2.562-.81-3.486C12.687 3.737 11.894 3 10.874 3H7.987zm-.555 10.605a5 5 0 0 1-.242.389h5.678c.36 0 .818-.27 1.221-.996c.392-.706.654-1.722.654-2.879q0-.32-.026-.625H8.375a.625.625 0 1 1 0-1.25h4.126a4.7 4.7 0 0 0-.405-1.003c-.403-.727-.86-.997-1.221-.997H5.197q.13.188.242.39c.513.923.811 2.157.811 3.485q0 .578-.073 1.125H7.75a.625.625 0 0 1 0 1.25H5.907a6 6 0 0 1-.468 1.11\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.03 1.97a.75.75 0 0 0-1.06 1.06l.97.97H4.145c.152.208.28.424.384.631c.467.927.72 2.12.72 3.369q0 .444-.042.875H7a.625.625 0 1 1 0 1.25H4.99c-.116.449-.27.868-.46 1.244a4.5 4.5 0 0 1-.384.631H11.5c.81 0 1.444-.57 1.848-1.277C13.761 10 14 9.037 14 8a7 7 0 0 0-.01-.375H8.5a.625.625 0 1 1 0-1.25h5.292a4.7 4.7 0 0 0-.444-1.098C12.944 4.57 12.31 4 11.5 4H8.059l-.029-.03zM2 11.969c1.105 0 2-1.777 2-3.969s-.895-3.969-2-3.969S0 5.808 0 8s.895 3.969 2 3.969\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogin1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 10.5v2a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v2m4 3.5h-8\"/><path d=\"m7.5 5l-2 2l2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogin1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 1.25c-.103 0-.2.04-.27.108a.35.35 0 0 0-.105.247v10.79c0 .09.037.18.106.247a.38.38 0 0 0 .269.108h7c.103 0 .2-.04.27-.108a.35.35 0 0 0 .105-.247v-1.962a.625.625 0 1 1 1.25 0v1.962c0 .43-.174.839-.48 1.14A1.64 1.64 0 0 1 9.5 14h-7c-.427 0-.84-.166-1.145-.466s-.48-.71-.48-1.14V1.606c0-.43.174-.84.48-1.14S2.073 0 2.5 0h7c.427 0 .84.167 1.145.466s.48.71.48 1.14v1.962a.625.625 0 1 1-1.25 0V1.605c0-.09-.037-.18-.106-.247a.4.4 0 0 0-.269-.109zm5.625 5.125V5a.625.625 0 0 0-1.067-.442l-2 2a.623.623 0 0 0 0 .884l2 2A.625.625 0 0 0 8.125 9V7.625H12.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogin1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h7A1.5 1.5 0 0 1 10 1.5v3.25h-.516a2 2 0 0 0-3.398-1.164l-2 2a2 2 0 0 0 0 2.828l2 2A2 2 0 0 0 9.484 9.25H10v3.25A1.5 1.5 0 0 1 8.5 14h-7A1.5 1.5 0 0 1 0 12.5zm7.787 2.807A.75.75 0 0 1 8.25 5v1H13a1 1 0 1 1 0 2H8.25v1a.75.75 0 0 1-1.28.53l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 .817-.163\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogout1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 10.5v2a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v2M6.5 7h7m-2-2l2 2l-2 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogout1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.23 1.358a.4.4 0 0 1 .27-.109h7c.103 0 .2.04.27.109a.35.35 0 0 1 .105.247v.962a.625.625 0 1 0 1.25 0v-.962c0-.43-.174-.84-.48-1.14A1.64 1.64 0 0 0 9.5 0h-7c-.427 0-.84.167-1.145.466s-.48.71-.48 1.14v10.79c0 .43.174.839.48 1.14c.306.299.718.465 1.145.465h7c.427 0 .84-.166 1.145-.466s.48-.71.48-1.14v-.961a.625.625 0 1 0-1.25 0v.962c0 .09-.037.18-.106.247a.4.4 0 0 1-.269.108h-7c-.103 0-.2-.04-.27-.108a.35.35 0 0 1-.105-.247V1.605c0-.09.037-.18.106-.247m8.03 3.065A.63.63 0 0 0 9.876 5v1.375H5.5a.625.625 0 1 0 0 1.25h4.375V9a.625.625 0 0 0 1.067.442l2-2a.625.625 0 0 0 0-.884l-2-2a.625.625 0 0 0-.681-.135\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLogout1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h7A1.5 1.5 0 0 1 10 1.5v1.939a2 2 0 0 0-.734 1.311H5.75a2.25 2.25 0 1 0 0 4.5h3.516A2 2 0 0 0 10 10.561V12.5A1.5 1.5 0 0 1 8.5 14h-7A1.5 1.5 0 0 1 0 12.5zm10.963 2.807A.75.75 0 0 0 10.5 5v1H5.75a1 1 0 0 0 0 2h4.75v1a.75.75 0 0 0 1.28.53l2-2a.75.75 0 0 0 0-1.06l-2-2a.75.75 0 0 0-.817-.163\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLoop1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 10a2.75 2.75 0 0 0 2.85-1.808C13.489 7.811 13.5 7 13.5 7s-.012-.81-.15-1.192A2.75 2.75 0 0 0 10.5 4c-2.75 0-4.25 6-7 6A2.75 2.75 0 0 1 .65 8.192C.511 7.811.5 7 .5 7s.012-.81.15-1.192A2.75 2.75 0 0 1 3.5 4c2.75 0 4.25 6 7 6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLoop1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M.624 7c0-.98.49-2.943 2.943-2.943c2.943 0 3.923 5.886 6.866 5.886c2.453 0 2.943-1.962 2.943-2.943c0-.98-.49-2.943-2.943-2.943c-2.943 0-3.923 5.886-6.866 5.886C1.114 9.943.624 7.98.624 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLoop1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.564 4.884a1.91 1.91 0 0 0-1.523.542a1.9 1.9 0 0 0-.442.691a2.5 2.5 0 0 0-.08.511c-.02.255-.02.49 0 .744c.02.241.052.434.08.51A1.87 1.87 0 0 0 2.74 9.015c.263.094.545.129.824.102l.07-.003c.373 0 .78-.2 1.271-.68c.392-.384.77-.879 1.172-1.433c-.401-.554-.78-1.049-1.172-1.432c-.491-.482-.898-.681-1.27-.681zM7 8.277a11 11 0 0 1-1.045 1.227c-.598.585-1.352 1.096-2.284 1.109a3.41 3.41 0 0 1-2.687-.974a3.4 3.4 0 0 1-.796-1.246c-.104-.287-.144-.664-.163-.9A6 6 0 0 1 0 7q.001-.247.024-.493c.02-.236.06-.613.163-.9a3.37 3.37 0 0 1 2.048-2.034c.46-.164.95-.227 1.435-.186c.932.013 1.686.524 2.284 1.109c.368.36.716.789 1.045 1.227a11 11 0 0 1 1.045-1.227c.598-.585 1.352-1.096 2.284-1.109a3.41 3.41 0 0 1 2.687.974c.354.352.626.777.796 1.246c.104.287.144.664.163.9q.022.246.025.493q-.002.247-.025.493c-.02.236-.06.613-.163.9a3.37 3.37 0 0 1-2.048 2.034c-.46.164-.95.227-1.435.186c-.932-.013-1.686-.524-2.284-1.109a11 11 0 0 1-1.045-1.227m5.48-.905c-.02.241-.051.434-.079.51a1.87 1.87 0 0 1-1.141 1.132a1.9 1.9 0 0 1-.824.102l-.07-.003c-.373 0-.78-.2-1.271-.68c-.392-.384-.77-.879-1.172-1.433c.401-.554.78-1.049 1.172-1.432c.491-.482.898-.681 1.27-.681l.071-.003a1.91 1.91 0 0 1 1.523.542c.197.196.348.432.442.691c.028.077.06.27.08.511c.02.255.02.49 0 .744\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLostAndFound: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 4h-9a2 2 0 0 0-2 2v5.5a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-7 0v-.5a2.5 2.5 0 1 1 5 0V4\"/><path d=\"M5.5 7.5A1.5 1.5 0 1 1 7 9v.5m.002 2a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLostAndFoundRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.625 3.25a1.375 1.375 0 0 1 2.75 0v.125h-2.75zm-1.75.125V3.25a3.125 3.125 0 1 1 6.25 0v.125h1.25A2.625 2.625 0 0 1 14 6v5a2.625 2.625 0 0 1-2.625 2.625h-8.75A2.625 2.625 0 0 1 0 11V6a2.625 2.625 0 0 1 2.625-2.625zm-1.25 1.25c-.76 0-1.375.616-1.375 1.375v5c0 .76.616 1.375 1.375 1.375h8.75c.76 0 1.375-.616 1.375-1.375V6c0-.76-.616-1.375-1.375-1.375zm4.546 1.767a.875.875 0 0 0-1.046.858a.625.625 0 1 1-1.25 0a2.125 2.125 0 1 1 2.75 2.031a.625.625 0 0 1-1.25-.031v-.5c0-.345.28-.625.625-.625a.875.875 0 0 0 .17-1.733M6.127 11a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineLostAndFoundSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.763 2.263A1.75 1.75 0 0 1 8.75 3.5h-3.5c0-.464.184-.91.513-1.237M3.75 3.5a3.25 3.25 0 0 1 6.5 0h1.25A2.5 2.5 0 0 1 14 6v5.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 0 11.5V6a2.5 2.5 0 0 1 2.5-2.5zm2.915 3.067A.875.875 0 1 1 7 8.25a.625.625 0 0 0-.625.625v1a.625.625 0 1 0 1.25 0v-.469a2.125 2.125 0 1 0-2.75-2.031a.625.625 0 1 0 1.25 0a.875.875 0 0 1 .54-.808m.337 6.308a.75.75 0 1 1 0-1.5a.75.75 0 0 1 0 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagicWand2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m12.64 1.87l-.84 2.48a.41.41 0 0 0 0 .37l1.57 2.1a.4.4 0 0 1-.33.64h-2.62a.43.43 0 0 0-.33.17l-1.46 2.1a.4.4 0 0 1-.71-.11l-.78-2.5a.38.38 0 0 0-.26-.26l-2.5-.78a.4.4 0 0 1-.11-.71l2.14-1.51a.43.43 0 0 0 .17-.33V.91a.4.4 0 0 1 .6-.33l2.1 1.57a.41.41 0 0 0 .37.05l2.48-.84a.4.4 0 0 1 .51.51m-5.6 5.09L.5 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagicWand2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.13 1.478l1.7 1.271l.018.013a1.03 1.03 0 0 0 .93.128l2.05-.694l-.684 2.02a1.03 1.03 0 0 0 .023.885a1 1 0 0 0 .057.092l1.302 1.74h-2.181l-.019.001a1.06 1.06 0 0 0-.824.438L8.305 9.094l-.642-2.056a1 1 0 0 0-.677-.677l-2.06-.643l1.77-1.248l.016-.013a1.06 1.06 0 0 0 .418-.81zM4.555 5.98l-.003.002zm2.693 3.925l.011.032c.124.354.439.618.811.676a1.03 1.03 0 0 0 1.01-.445l1.38-1.984h2.499c.386.006.75-.212.927-.555a1.03 1.03 0 0 0-.09-1.085h-.001l-1.459-1.951l.82-2.421a1.03 1.03 0 0 0-.244-1.06a1.03 1.03 0 0 0-1.06-.244l-2.375.804L7.48.178A1.03 1.03 0 0 0 6.41.127a1.03 1.03 0 0 0-.53.882v2.506L3.836 4.957a1.03 1.03 0 0 0-.425.997c.06.383.337.706.708.822l1.424.444l-5.287 5.286a.875.875 0 1 0 1.238 1.238l5.299-5.3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagicWand2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.35 3.824l.84-2.48a.4.4 0 0 0-.51-.51l-2.48.84a.41.41 0 0 1-.37-.05L7.73.054a.4.4 0 0 0-.6.33v2.62a.43.43 0 0 1-.17.33l-2.14 1.51a.4.4 0 0 0 .11.71l2.5.78a.38.38 0 0 1 .26.26l.78 2.5a.4.4 0 0 0 .71.11l1.46-2.1a.43.43 0 0 1 .33-.17h2.62a.4.4 0 0 0 .33-.64l-1.57-2.1a.41.41 0 0 1 0-.37M.293 12.293l5.241-5.241l1.096.342l.33 1.06l-5.253 5.253a1 1 0 0 1-1.414-1.414\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagnifyingGlass: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 11.5a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11m7.5 2L10 10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagnifyingGlassCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M6.5 9a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m3.5 1L8.27 8.27\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagnifyingGlassCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m-.5 4.625a1.875 1.875 0 1 0 0 3.75a1.875 1.875 0 0 0 0-3.75M3.375 6.5a3.125 3.125 0 1 1 5.732 1.723l1.335 1.335a.625.625 0 0 1-.884.884L8.223 9.107A3.125 3.125 0 0 1 3.375 6.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagnifyingGlassCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M6.5 4.625a1.875 1.875 0 1 0 0 3.75a1.875 1.875 0 0 0 0-3.75M3.375 6.5a3.125 3.125 0 1 1 5.732 1.723l1.335 1.335a.625.625 0 1 1-.884.884L8.223 9.107A3.125 3.125 0 0 1 3.375 6.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagnifyingGlassRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 6a4.75 4.75 0 1 1 9.5 0a4.75 4.75 0 0 1-9.5 0M6 0a6 6 0 1 0 3.266 11.034l2.6 2.6a1.25 1.25 0 0 0 1.768-1.768l-2.6-2.6A6 6 0 0 0 6 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMagnifyingGlassSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 6a4 4 0 1 1 8 0a4 4 0 0 1-8 0m4-6a6 6 0 1 0 3.476 10.89l2.817 2.817a1 1 0 0 0 1.414-1.414l-2.816-2.816A6 6 0 0 0 6 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailChatBubbleSquareMessagesMessageBubbleChatSquare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailChatBubbleSquareWarningBubbleSquareMessagesNotificationChatMessageWarningAlert: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1Zm3-9.5v3\"/><circle cx=\"7.5\" cy=\"9\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailChatBubbleTypingOvalMessagesMessageBubbleTypingChat: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"3.5\" cy=\"7\" r=\".5\"/><circle cx=\"6.75\" cy=\"7\" r=\".5\"/><circle cx=\"10\" cy=\"7\" r=\".5\"/><path d=\"M7 .5a6.5 6.5 0 0 0-5.41 10.1L.5 13.5l3.65-.66A6.5 6.5 0 1 0 7 .5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailChatBubbleTypingSquareMessagesMessageBubbleTypingSquareChat: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"4.25\" cy=\"6.5\" r=\".5\"/><circle cx=\"7.5\" cy=\"6.5\" r=\".5\"/><circle cx=\"10.75\" cy=\"6.5\" r=\".5\"/><path d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailInboxEmailOutboxDrawerEmptyOpenInbox: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 8H4a1 1 0 0 1 1 1a2 2 0 0 0 4 0a1 1 0 0 1 1-1h3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailIncoming: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 4L7 6.5L9.5 4M7 .5v6\"/><path d=\"M12 4.5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1\"/><path d=\"M1 5.76L7 10l6-4.24\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailIncomingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625.625a.625.625 0 1 0-1.25 0V3.5H5a.5.5 0 0 0-.354.854l2 2a.5.5 0 0 0 .708 0l2-2A.5.5 0 0 0 9 3.5H7.625zM3.939 5.061L3.882 5H2.625C1.728 5 1 5.728 1 6.625v5.75C1 13.273 1.728 14 2.625 14h8.75c.898 0 1.625-.727 1.625-1.625v-5.75C13 5.728 12.273 5 11.375 5h-1.257l-.057.06l-2 2a1.5 1.5 0 0 1-2.122 0zM11.75 8.07l-4.482 2.852a.5.5 0 0 1-.536 0L2.25 8.07v4.305c0 .207.168.375.375.375h8.75a.375.375 0 0 0 .375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailIncomingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .042a.75.75 0 0 1 .75.75V3.2h1.17a.5.5 0 0 1 .354.854l-1.92 1.92a.5.5 0 0 1-.708 0l-1.92-1.92a.5.5 0 0 1 .353-.854H6.25V.792A.75.75 0 0 1 7 .042m-4.914 4.13h1.308c.08.283.23.548.448.766l1.92 1.92a1.75 1.75 0 0 0 2.475 0l1.921-1.92c.218-.218.369-.483.448-.767h1.308c.905 0 1.639.734 1.639 1.638v.146L7 9.773L.448 5.955v-.146c0-.904.733-1.638 1.638-1.638ZM.448 7.401v4.96c0 .905.733 1.638 1.638 1.638h9.828c.905 0 1.639-.733 1.639-1.638v-4.96l-6.238 3.635a.63.63 0 0 1-.63 0L.448 7.402Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSearch: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 9.5H1.5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4\"/><path d=\"M.5 1.76L6.5 6l6-4.24M10 12.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m3.5 1l-1.73-1.73\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSearchRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 3.1v5.4c0 .207.168.375.375.375H5a.625.625 0 1 1 0 1.25H1.625A1.625 1.625 0 0 1 0 8.5V1.625C0 .728.728 0 1.625 0h9.75C12.273 0 13 .728 13 1.625v4a.625.625 0 1 1-1.25 0V3.101L6.777 6.416a.5.5 0 0 1-.554 0zM9.875 8a1.875 1.875 0 1 0 1.319 3.208l.007-.007l.006-.007A1.875 1.875 0 0 0 9.875 8m0 5a3.1 3.1 0 0 0 1.723-.518l1.335 1.335a.625.625 0 1 0 .884-.884l-1.335-1.335A3.125 3.125 0 1 0 9.875 13\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSearchSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.566 0h9.312c.857 0 1.552.695 1.552 1.552v.077L6.222 4.733L.015 1.629v-.077C.015.695.709 0 1.566 0m4.936 5.99l5.928-2.963V6.22a4.5 4.5 0 0 0-6.89 3.091H1.565A1.55 1.55 0 0 1 .015 7.76V3.027L5.943 5.99a.63.63 0 0 0 .559 0m3.485 2.26a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5M6.737 10a3.25 3.25 0 1 1 6.023 1.696l1.021 1.024a.75.75 0 0 1-1.062 1.06l-1.016-1.02A3.25 3.25 0 0 1 6.737 10\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEmailMessage: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 8L.5 5.5l13-5l-5 13zm0 0l3-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEmailMessageRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.959.848a.625.625 0 0 0-.807-.807L.402 4.916a.625.625 0 0 0-.025 1.158L5.65 8.35l2.276 5.273a.625.625 0 0 0 1.158-.025zm-8.1 6.232L2.284 5.535l10.009-3.827l-3.827 10.009L6.92 8.14l2.485-2.485a.75.75 0 0 0-1.06-1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEmailMessageSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.854.146a.5.5 0 0 1 .113.534l-5 13a.5.5 0 0 1-.922.027l-2.091-4.6L9.03 6.03a.75.75 0 0 0-1.06-1.06L4.893 8.046l-4.6-2.09a.5.5 0 0 1 .028-.923l13-5a.5.5 0 0 1 .533.113\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEmailSendEmailPaperAirplane: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.82 11L8 13.17a1.1 1.1 0 0 0 1.05.3a1.12 1.12 0 0 0 .81-.74L13.44 2A1.12 1.12 0 0 0 12 .56L1.27 4.14A1.12 1.12 0 0 0 .53 5a1.1 1.1 0 0 0 .3 1l2.74 2.74l-.09 3.47ZM13.12.78L3.57 8.74\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEnvelope: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 1.75h-11a1 1 0 0 0-1 1v8.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8.5a1 1 0 0 0-1-1\"/><path d=\"m.5 3l5.86 3.524c.18.106.406.163.64.163s.46-.057.64-.163L13.5 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEnvelopeEnvelopeEmailMessageUnopenedSealedClose: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"10.5\" x=\".5\" y=\"1.75\" rx=\"1\"/><path d=\"m.5 3l5.86 5a1 1 0 0 0 1.28 0l5.86-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEnvelopeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.375 1H1.625C.728 1 0 1.728 0 2.625v8.75C0 12.273.728 13 1.625 13h10.75c.898 0 1.625-.727 1.625-1.625v-8.75C14 1.728 13.273 1 12.375 1m-4.51 7.501l4.885-3.448v6.322a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375V5.053l4.885 3.448a1.5 1.5 0 0 0 1.73 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendEnvelopeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 2.75a1.5 1.5 0 0 1 1.5-1.5h11a1.5 1.5 0 0 1 1.5 1.5v.342L7.383 7.504A.7.7 0 0 1 7 7.607a.7.7 0 0 1-.383-.103L0 3.092zm0 1.844v6.656a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V4.594L8.073 8.546l-.005.004A1.97 1.97 0 0 1 7 8.857c-.375 0-.753-.102-1.068-.307l-.005-.004z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendForwardEmailEmailSendMessageEnvelopeActionsActionForwardArrow: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 12.5C3.42 10 4.14 9 7 9h1.5v3l5-5.5l-5-5v3h-1c-5 0-6 5-7 8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendReplyAll: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.5 2.5l-3 3l3 3\"/><path d=\"M13.5 11.5v-2a4 4 0 0 0-4-4h-5m-1-3l-3 3l3 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendReplyAllRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.125 2.5a.625.625 0 0 0-1.067-.442l-3 3a.625.625 0 0 0 0 .884l3 3A.625.625 0 0 0 8.125 8.5V6.125h1.25A3.375 3.375 0 0 1 12.75 9.5v2a.625.625 0 1 0 1.25 0v-2a4.625 4.625 0 0 0-4.625-4.625h-1.25zm-4.058-.442a.625.625 0 0 1 0 .884L1.509 5.5l2.558 2.558a.625.625 0 1 1-.884.884l-3-3a.625.625 0 0 1 0-.884l3-3a.625.625 0 0 1 .884 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendReplyAllSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.014 2.553a.75.75 0 0 0-1.28-.53L4.006 4.75a.75.75 0 0 0 0 1.06l2.728 2.728a.75.75 0 0 0 1.28-.53V6.03h1.58a2.886 2.886 0 0 1 2.887 2.886v1.818a.75.75 0 0 0 1.5 0V8.917A4.386 4.386 0 0 0 9.595 4.53H8.014zm-3.987.53a.75.75 0 0 0-1.061-1.06L.239 4.75a.75.75 0 0 0 0 1.06l2.727 2.728a.75.75 0 1 0 1.06-1.06L1.83 5.28z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendReplyEmailReplyMessageActionsActionArrow: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 12.5C10.58 10 9.86 9 7 9H5.5v3l-5-5.5l5-5v3h1c5 0 6 5 7 8Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSignAtEmailAtSignReadAddress: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.05 7A3 3 0 1 1 7 4a3 3 0 0 1 3.05 3Z\"/><path d=\"M10.05 7v1.3c0 3.49 5.47.2 2.6-4.54A6.59 6.59 0 0 0 7 .5A6.5 6.5 0 1 0 9.52 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSmileyHappyFaceChatMessageSmileySmileEmojiFaceSatisfied: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13Z\"/><path d=\"M3.7 8c.5 1.8 2.5 2.9 4.3 2.4c1.1-.4 2-1.3 2.3-2.4M4.8 5.45a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.4.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSmileyHappyMaskChatMessageSmileySmileEmojiMask: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 8s.5 1.5 3 1.5S10 8 10 8\"/><path d=\"M13.5 7a6.5 6.5 0 0 1-13 0V.5h13Z\"/><path d=\"M5 5a1 1 0 0 0-2 0m8 0a1 1 0 0 0-2 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSmileySadFaceChatMessageSmileyEmojiSadFaceUnsatisfied: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13Z\"/><path d=\"M3.7 10.5C4.2 8.7 6.1 7.6 8 8.1c1.1.3 2 1.2 2.4 2.4M4.85 5.45a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.4.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSmileySadMaskChatMessageSmileyEmojiSadMaskCry: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 7a6.5 6.5 0 0 1-13 0V.5h13Z\"/><path d=\"M4 9.5S4.5 8 7 8s3 1.5 3 1.5m-5-5a1 1 0 0 1-2 0m8 0a1 1 0 0 1-2 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSmileyStraightFaceChatMessageIndifferentSmileyEmojiFacePoker: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 9.5h7m-3.5 4a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13Z\"/><path d=\"M4.8 5.45a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.4.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMakeUpBrush: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4.956 5.241l3.77 3.77l-3.616 3.617a2.666 2.666 0 0 1-3.77 0v0a2.666 2.666 0 0 1 0-3.77zM3.494 6.703l3.77 3.77\"/><path d=\"m4.956 5.241l3.77 3.77l3.9-1.82a1 1 0 0 0 .285-1.613L8.39 1.056a1 1 0 0 0-1.613.285zm4.458-3.163L8.221 3.963m3.502.424L9.837 5.579\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMakeUpBrushRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.338 1.463a.356.356 0 0 1 .577-.108l.797.797L7.81 3.58a.625.625 0 0 0 1.056.668l.752-1.189l1.16 1.16l-1.189.752a.625.625 0 0 0 .668 1.056l1.427-.902l.961.961a.356.356 0 0 1-.108.577L8.78 8.321L5.68 5.22zm4.89 2.437l1.301 1.301a1.606 1.606 0 0 1-.487 2.605L8.893 9.637a.6.6 0 0 1-.173.048l-3.277 3.277a3.115 3.115 0 0 1-4.406-4.405l3.278-3.278a.6.6 0 0 1 .048-.173L6.194.958A1.606 1.606 0 0 1 8.8.47l1.143 1.143l.017.017l2.24 2.24z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMakeUpBrushSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.127 6.894L9.468 8.602a1 1 0 0 0-.076-.084l-3.77-3.77l-.052-.049l1.706-3.655A1 1 0 0 1 8.89.759l.587.588l-1.342 1.777a.625.625 0 1 0 .998.753l1.236-1.638l1.62 1.62l-1.621 1.024a.625.625 0 1 0 .668 1.057l1.858-1.176l.517.517a1 1 0 0 1-.284 1.613m-4.62 2.508l-3.77-3.77l-3.616 3.616a2.666 2.666 0 1 0 3.77 3.77z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineManSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.75 13.5a4.25 4.25 0 1 0 0-8.5a4.25 4.25 0 0 0 0 8.5M9 .5h4.5V5M7.75 6.25L13.5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineManSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 0a.5.5 0 0 0-.354.854l1.808 1.808l-2.602 2.602a4.875 4.875 0 1 0 .884.884l2.602-2.602l1.808 1.808A.5.5 0 0 0 14 5V.5a.5.5 0 0 0-.5-.5zM7.375 6.5a.6.6 0 0 0 .125.125a3.625 3.625 0 1 1-.126-.126\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineManSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 .75A.75.75 0 0 1 8.75 0h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V2.56L9.026 6.036a5 5 0 1 1-1.06-1.06l3.473-3.475H8.75A.75.75 0 0 1 8 .75m-.594 5.708a3.5 3.5 0 1 0 .135.135a.8.8 0 0 1-.135-.135\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineManualBook: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 4.054a1.5 1.5 0 1 1 1.5 1.5v.5m0 2.062a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/><path d=\"M12.5 13.5H3a1.5 1.5 0 1 1 0-3h8.5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H3a1.5 1.5 0 0 0-1.5 1.46v10m10-1.46v3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineManualBookRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 0h8.5a1.625 1.625 0 0 1 1.625 1.625v7.75a1.625 1.625 0 0 1-1 1.5v1.875h.375a.625.625 0 1 1 0 1.25H3a2.125 2.125 0 0 1-2.125-2.125V2.068A2.125 2.125 0 0 1 3 0m8.5 9.75a.375.375 0 0 0 .375-.375v-7.75a.375.375 0 0 0-.375-.375H3a.875.875 0 0 0-.875.844V9.94c.272-.124.57-.189.875-.189zM6.665 3.37A.875.875 0 1 1 7 5.054a.625.625 0 0 0-.625.625v.5a.625.625 0 0 0 1.25.031a2.125 2.125 0 1 0-2.75-2.031a.625.625 0 1 0 1.25 0a.875.875 0 0 1 .54-.809M7 8.991a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineManualBookSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 10.75h-.25v1.75H12a.75.75 0 0 1 0 1.5H3.625a2.375 2.375 0 0 1-2.375-2.375V2.25A2.25 2.25 0 0 1 3.5 0h7a2.25 2.25 0 0 1 2.25 2.25V10a.75.75 0 0 1-.75.75m-8.375 0h6.625v1.75H3.625a.875.875 0 0 1 0-1.75m3.546-7.921a.875.875 0 0 0-1.046.858a.625.625 0 1 1-1.25 0a2.125 2.125 0 1 1 2.75 2.031a.625.625 0 0 1-1.25-.031v-.5c0-.345.28-.625.625-.625a.875.875 0 0 0 .17-1.733ZM7 8.884a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMapFold: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.83 12.5l-3.105.717A1 1 0 0 1 .5 12.243V2.295a1 1 0 0 1 .775-.974L4.83.5zm0 0l4.34 1v-12L4.83.5zm8.67-.795a1 1 0 0 1-.775.974L9.17 13.5v-12l3.105-.717a1 1 0 0 1 1.225.974z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMapFoldRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.152.394a.6.6 0 0 0-.304 0l-3.242.81A1.625 1.625 0 0 0 .375 2.781v8.938c0 1.057.994 1.833 2.02 1.577L5 12.644l3.848.962q.152.038.304 0l3.242-.81a1.625 1.625 0 0 0 1.231-1.577V2.281a1.625 1.625 0 0 0-2.02-1.577L9 1.356zM1.909 2.417L5 1.644v9.731a.6.6 0 0 0-.152.019l-2.757.689a.375.375 0 0 1-.466-.364V2.781c0-.172.117-.322.284-.364M9 12.356l3.091-.773a.375.375 0 0 0 .284-.364V2.281a.375.375 0 0 0-.466-.364l-2.757.69A.6.6 0 0 1 9 2.624z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMapFoldSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8.875.865l-3.75-.75v13.02l3.75.75zm1.25 12.994l3.496-.874A.5.5 0 0 0 14 12.5V.5a.5.5 0 0 0-.621-.485l-3.254.813zM.379 1.015L3.875.14v13.03l-3.254.814A.5.5 0 0 1 0 13.5v-12a.5.5 0 0 1 .379-.485\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMarkdownCircleProgramming: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0\"/><path d=\"M3.5 9V5.243c0-.134.109-.243.243-.243v0c.096 0 .182.056.221.143l.754 1.675A.31.31 0 0 0 5 7v0a.31.31 0 0 0 .282-.182l.754-1.675A.24.24 0 0 1 6.257 5v0c.134 0 .243.109.243.243V9m3-4v4m-1-1l1 1l1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMarkdownCircleProgrammingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0M4.125 9V7.023l.023.051a.934.934 0 0 0 1.704 0l.023-.051V9a.625.625 0 1 0 1.25 0V5.243a.868.868 0 0 0-1.66-.356L5 5.92l-.465-1.034a.868.868 0 0 0-1.66.356V9a.625.625 0 1 0 1.25 0m6-4a.625.625 0 1 0-1.25 0v2.375H8.5a.625.625 0 0 0-.442 1.067l1 1a.625.625 0 0 0 .884 0l1-1a.625.625 0 0 0-.442-1.067h-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMarkdownCircleProgrammingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M3.743 4.375c.341 0 .651.2.791.512L5 5.92l.466-1.034a.868.868 0 0 1 1.659.356V9a.625.625 0 0 1-1.25 0V7.023l-.023.051a.934.934 0 0 1-1.704 0l-.023-.05V9a.625.625 0 1 1-1.25 0V5.243c0-.48.389-.868.868-.868M10.125 5a.625.625 0 1 0-1.25 0v2.5H8.5a.5.5 0 0 0-.354.854l1 1a.5.5 0 0 0 .708 0l1-1A.5.5 0 0 0 10.5 7.5h-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMarkdownDocumentProgramming: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h6l4 4z\"/><path d=\"M3.5 10.5V6.743c0-.134.109-.243.243-.243v0c.096 0 .182.056.221.143l.754 1.675A.31.31 0 0 0 5 8.5v0a.31.31 0 0 0 .282-.182l.754-1.675a.24.24 0 0 1 .221-.143v0c.134 0 .243.109.243.243V10.5m3-4v4m-1-1l1 1l1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMarkdownDocumentProgrammingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.235 1.36c.07-.07.166-.11.265-.11h6.241l3.134 3.134v7.991a.375.375 0 0 1-.375.375h-9a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265M2.5 0A1.625 1.625 0 0 0 .875 1.625v10.75A1.625 1.625 0 0 0 2.5 14h9a1.625 1.625 0 0 0 1.625-1.625v-8.25a.63.63 0 0 0-.183-.442l-3.5-3.5A.63.63 0 0 0 9 0zm1.625 10.5V8.523l.023.051a.934.934 0 0 0 1.704 0l.023-.051V10.5a.625.625 0 1 0 1.25 0V6.743a.868.868 0 0 0-1.66-.356L5 7.42l-.466-1.034a.868.868 0 0 0-1.659.356V10.5a.625.625 0 1 0 1.25 0M9.5 5.875c.345 0 .625.28.625.625v2.375h.375a.625.625 0 0 1 .442 1.067l-1 1a.624.624 0 0 1-.884 0l-1-1A.625.625 0 0 1 8.5 8.875h.375V6.5c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMarkdownDocumentProgrammingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5-1.5v-7a.5.5 0 0 0-.146-.354l-5-5A.5.5 0 0 0 7.5 0zm1.243 5.875c.341 0 .651.2.791.512L5 7.42l.466-1.034a.868.868 0 0 1 1.659.356V10.5a.625.625 0 1 1-1.25 0V8.523l-.023.051a.934.934 0 0 1-1.704 0l-.023-.05V10.5a.625.625 0 1 1-1.25 0V6.743c0-.48.389-.868.868-.868m6.382.625a.625.625 0 1 0-1.25 0V9H8.5a.5.5 0 0 0-.354.853l1 1a.5.5 0 0 0 .708 0l1-1A.5.5 0 0 0 10.5 9h-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalBag: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 8.5h4m-2-2v4m5.5-7h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-2.5 0v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalBagRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.351.976A1.63 1.63 0 0 1 5.5.5h3a1.625 1.625 0 0 1 1.625 1.625V3h1.75c.897 0 1.625.728 1.625 1.625v7.25c0 .898-.728 1.625-1.625 1.625h-9.75A1.625 1.625 0 0 1 .5 11.875v-7.25C.5 3.728 1.228 3 2.125 3h1.75v-.875c0-.431.171-.844.476-1.149m4.524 1.149V3h-3.75v-.875A.375.375 0 0 1 5.5 1.75h3a.375.375 0 0 1 .375.375M2.125 4.25h9.75c.207 0 .375.168.375.375v7.25a.375.375 0 0 1-.375.375h-9.75a.375.375 0 0 1-.375-.375v-7.25c0-.207.168-.375.375-.375M7 5.5a.75.75 0 0 1 .75.75V7.5H9A.75.75 0 0 1 9 9H7.75v1.25a.75.75 0 0 1-1.5 0V9H5a.75.75 0 0 1 0-1.5h1.25V6.25A.75.75 0 0 1 7 5.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalBagSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.999 0c-.474 0-.96.153-1.343.469c-.389.32-.658.8-.658 1.354v1.543H1.5C.69 3.366 0 4 0 4.826v7.684c0 .825.69 1.46 1.5 1.46h11c.81 0 1.5-.635 1.5-1.46V4.826c0-.825-.69-1.46-1.5-1.46h-1.498V1.823c0-.553-.269-1.034-.658-1.354A2.12 2.12 0 0 0 9.001 0H5Zm4.003 3.366V2H4.998v1.366zM4.375 8.668c0-.345.28-.625.625-.625h1.375V6.668a.625.625 0 1 1 1.25 0v1.375H9a.625.625 0 1 1 0 1.25H7.625v1.375a.625.625 0 1 1-1.25 0V9.293H5a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalCrossSignHealthcare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 .5H5V5H.5v4H5v4.5h4V9h4.5V5H9z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalCrossSignHealthcareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.413.625c0-.345.28-.625.625-.625h3.924c.345 0 .625.28.625.625v3.788h3.788c.345 0 .625.28.625.625v3.924c0 .345-.28.625-.625.625H9.587v3.788c0 .345-.28.625-.625.625H5.038a.625.625 0 0 1-.625-.625V9.587H.625A.625.625 0 0 1 0 8.962V5.038c0-.345.28-.625.625-.625h3.788zm1.25.625v3.788c0 .346-.28.625-.625.625H1.25v2.674h3.788c.346 0 .625.28.625.625v3.788h2.674V8.962c0-.346.28-.625.625-.625h3.788V5.663H8.962a.625.625 0 0 1-.625-.625V1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalCrossSignHealthcareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 0a.5.5 0 0 0-.5.5v4h-4A.5.5 0 0 0 0 5v4a.5.5 0 0 0 .5.5h4v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4h4A.5.5 0 0 0 14 9V5a.5.5 0 0 0-.5-.5h-4v-4A.5.5 0 0 0 9 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalCrossSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 5.51l-1.96-3.392l-2.58 1.49V.628H5.04v2.98l-2.58-1.49L.5 5.51L3.078 7L.5 8.49l1.96 3.392l2.58-1.49v2.98h3.92v-2.98l2.58 1.49L13.5 8.49L10.922 7z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalCrossSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.452.75c0-.345.28-.625.625-.625h3.846c.345 0 .625.28.625.625v1.84l1.591-.92a.625.625 0 0 1 .854.229l1.923 3.327a.625.625 0 0 1-.228.854L12.095 7l1.593.92a.625.625 0 0 1 .228.854l-1.923 3.327a.625.625 0 0 1-.854.229l-1.59-.92v1.84c0 .345-.28.625-.626.625H5.077a.625.625 0 0 1-.625-.625v-1.84l-1.591.92a.625.625 0 0 1-.854-.229L.084 8.774a.625.625 0 0 1 .228-.854L1.905 7L.312 6.08a.625.625 0 0 1-.228-.854l1.923-3.327a.625.625 0 0 1 .854-.229l1.59.92zm1.25.625v2.298a.625.625 0 0 1-.938.541L2.776 3.065L1.48 5.31l1.987 1.15a.625.625 0 0 1 0 1.082L1.479 8.69l1.297 2.245l1.988-1.15a.625.625 0 0 1 .938.542v2.298h2.596v-2.298a.625.625 0 0 1 .938-.541l1.988 1.149L12.52 8.69l-1.987-1.15a.625.625 0 0 1 0-1.082l1.988-1.149l-1.297-2.245l-1.988 1.15a.625.625 0 0 1-.938-.542V1.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalCrossSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.047.757a.5.5 0 0 1 .5-.5h2.906a.5.5 0 0 1 .5.5v2.86l2.478-1.43a.5.5 0 0 1 .682.183l1.453 2.517a.5.5 0 0 1-.183.683L10.905 7l2.478 1.43a.5.5 0 0 1 .183.684l-1.453 2.516a.5.5 0 0 1-.683.183l-2.477-1.43v2.86a.5.5 0 0 1-.5.5H5.547a.5.5 0 0 1-.5-.5v-2.86l-2.477 1.43a.5.5 0 0 1-.683-.183L.434 9.114a.5.5 0 0 1 .183-.683L3.095 7L.617 5.57a.5.5 0 0 1-.183-.683L1.887 2.37a.5.5 0 0 1 .683-.183l2.477 1.43z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalFilesReportHistory: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4z\"/><path d=\"M6.303 4.771a.43.43 0 0 0-.43.43v1.208H4.666a.43.43 0 0 0-.43.429v1.395c0 .238.193.43.43.43h1.207V9.87c0 .238.193.43.43.43h1.395a.43.43 0 0 0 .43-.43V8.663h1.207a.43.43 0 0 0 .43-.43V6.838a.43.43 0 0 0-.43-.43H8.128V5.202a.43.43 0 0 0-.43-.43z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalFilesReportHistoryRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h6.116l3.009 3.009v8.116a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v10.75A1.625 1.625 0 0 0 2.625 14h8.75A1.625 1.625 0 0 0 13 12.375V4a.63.63 0 0 0-.183-.442L9.442.183A.63.63 0 0 0 9 0zm3.207 5.395c0-.2.163-.364.364-.364h1.608c.201 0 .364.163.364.364v1.343h1.343c.201 0 .364.163.364.364v1.609a.364.364 0 0 1-.364.363H8.168v1.343a.364.364 0 0 1-.364.364H6.196a.364.364 0 0 1-.364-.364V9.074H4.489a.364.364 0 0 1-.364-.363V7.102c0-.201.163-.364.364-.364h1.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalFilesReportHistorySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h6a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5v-11c0-.398.158-.78.44-1.06m4.53 4.987c0-.216.176-.392.393-.392h1.275c.216 0 .392.176.392.392v1.56h1.56c.217 0 .392.176.392.393v1.275a.39.39 0 0 1-.392.392H8.03v1.56a.39.39 0 0 1-.392.393H6.362a.39.39 0 0 1-.392-.392v-1.56H4.41a.39.39 0 0 1-.392-.393V7.38c0-.217.175-.392.392-.392h1.56z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalRibbon1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 13.5S10 6.39 10 3.5c.101-1.743-1.332-3-3-3s-3.101 1.257-3 3c0 2.89 6.5 10 6.5 10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalRibbon1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.907 4.058C2.907 1.978 4.714 0 7 0c1.16 0 2.184.535 2.907 1.288c.72.748 1.186 1.755 1.186 2.77c0 1.264-.54 2.514-1.276 3.64c-.554.847-1.24 1.657-1.95 2.392a29 29 0 0 0 3.439 2.708l.059.04l.014.008l.003.002a.626.626 0 0 1-.674 1.053l.31-.484l-.31.484l-.002-.001l-.005-.003l-.018-.012l-.066-.044l-.247-.165a30 30 0 0 1-3.397-2.71a31.6 31.6 0 0 1-3.65 2.914l-.018.012l-.005.004l-.322-.486l.322.486a.626.626 0 0 1-.689-1.043l.004-.002l.014-.01l.06-.04l.23-.16a30 30 0 0 0 3.16-2.551c-.691-.715-1.356-1.504-1.896-2.335c-.738-1.136-1.275-2.402-1.275-3.697m4.065 5.159c.67-.693 1.3-1.439 1.798-2.203c.673-1.03 1.073-2.037 1.073-2.956c0-.641-.304-1.35-.837-1.904c-.529-.55-1.24-.904-2.006-.904c-1.57 0-2.843 1.393-2.843 2.808c0 .957.402 1.983 1.073 3.016c.485.746 1.093 1.47 1.742 2.143\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalRibbon1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.416.362A3.6 3.6 0 0 0 7 .132A3.563 3.563 0 0 0 3.293 3.87c.007 1.138.461 2.317 1.037 3.38c.401.74.888 1.472 1.396 2.156a34 34 0 0 1-2.328 2.502l-.235.224A1 1 0 0 0 4.52 13.6c.327-.304.643-.62.954-.939c.427-.437.962-1.01 1.526-1.665a37 37 0 0 0 1.526 1.665c.55.565 1.505 1.817 2.367.883a1 1 0 0 0-.056-1.413l-.002-.002h-.001a34 34 0 0 1-2.56-2.722A18 18 0 0 0 9.67 7.25c.576-1.063 1.03-2.242 1.037-3.38A3.56 3.56 0 0 0 8.417.362M7 7.755c.337-.482.649-.973.912-1.458c.52-.96.795-1.8.795-2.456c0-1.132-.795-1.71-1.765-1.71s-1.65.784-1.65 1.71c0 .657.277 1.497.796 2.456c.263.485.574.976.912 1.458\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalSearchDiagnosis: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.478 12.207a5.729 5.729 0 1 0 0-11.457a5.729 5.729 0 0 0 0 11.457m6.772 1.043l-2.722-2.723\"/><path d=\"M5.666 3.26a.5.5 0 0 0-.5.5v1.406H3.759a.5.5 0 0 0-.5.5v1.625a.5.5 0 0 0 .5.5h1.407v1.407a.5.5 0 0 0 .5.5H7.29a.5.5 0 0 0 .5-.5V7.79h1.406a.5.5 0 0 0 .5-.5V5.666a.5.5 0 0 0-.5-.5H7.791V3.76a.5.5 0 0 0-.5-.5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalSearchDiagnosisRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1.25a5.25 5.25 0 1 0 0 10.5a5.25 5.25 0 0 0 0-10.5M0 6.5a6.5 6.5 0 1 1 11.673 3.936l2.07 2.07a.875.875 0 0 1-1.237 1.238l-2.07-2.07A6.5 6.5 0 0 1 0 6.5m5.129-2.948c0-.236.19-.427.427-.427h1.888c.236 0 .427.191.427.427V5.13h1.577c.236 0 .427.19.427.427v1.888a.427.427 0 0 1-.427.427H7.87v1.577a.427.427 0 0 1-.427.427H5.556a.427.427 0 0 1-.427-.427V7.87H3.552a.427.427 0 0 1-.427-.427V5.556c0-.236.191-.427.427-.427H5.13z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMedicalSearchDiagnosisSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.25 1.5a4.75 4.75 0 1 0 0 9.5a4.75 4.75 0 0 0 0-9.5M0 6.25a6.25 6.25 0 1 1 11.32 3.656l2.387 2.387a1 1 0 0 1-1.414 1.414L9.906 11.32A6.25 6.25 0 0 1 0 6.25m5.438-3.22a.5.5 0 0 0-.5.5v1.406H3.53a.5.5 0 0 0-.5.5v1.625a.5.5 0 0 0 .5.5h1.406V8.97a.5.5 0 0 0 .5.5h1.625a.5.5 0 0 0 .5-.5V7.562H8.97a.5.5 0 0 0 .5-.5V5.437a.5.5 0 0 0-.5-.5H7.563V3.531a.5.5 0 0 0-.5-.5H5.438Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMegaphone2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4.5 9.06l7.68 2.56a1 1 0 0 0 .9-.14a1 1 0 0 0 .42-.81V2.44a1 1 0 0 0-.854-.983a1 1 0 0 0-.466.043L4.5 4.06zm-4-2.5A2.5 2.5 0 0 0 3 9.06h1.5v-5H3a2.5 2.5 0 0 0-2.5 2.5\"/><path d=\"M3 9.06v1a2.5 2.5 0 0 0 2.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMegaphone2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.458 2.231a.226.226 0 0 1 .293.216v8.106a.226.226 0 0 1-.293.216L5.173 8.493V4.507zm.067-1.26q-.226 0-.44.067L4.453 3.423H3.077a3.077 3.077 0 0 0-.702 6.073V10c0 1.726 1.4 3.125 3.125 3.125a.625.625 0 1 0 0-1.25A1.875 1.875 0 0 1 3.625 10v-.423h.828l7.632 2.385A1.477 1.477 0 0 0 14 10.553V2.447c0-.815-.66-1.476-1.476-1.476\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMegaphone2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.25 3.5L11.956.795A1.5 1.5 0 0 1 14 2.193v8.226a1.5 1.5 0 0 1-1.974 1.423L5.25 9.5zM3 3.5h1v7a1 1 0 0 0 1 1h.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V9.33A3.001 3.001 0 0 1 3 3.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMeta: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.776 4.957c.555-.37 1.145-.594 1.777-.594c1.776 0 2.664 2.665 2.664 4.44c0 1.777-.888 2.665-1.776 2.665c-2.22 0-4.441-7.105-7.993-7.105c-1.777 0-2.665 2.665-2.665 4.44c0 1.777.888 2.665 1.776 2.665c.924 0 1.847-1.229 2.866-2.664\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMetaRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M8.822 3.966c.57-.379 1.174-.61 1.822-.61c1.821 0 2.732 2.733 2.732 4.555s-.91 2.732-1.822 2.732c-2.277 0-4.554-7.286-8.197-7.286C1.535 3.357.625 6.089.625 7.91s.91 2.732 1.821 2.732c.947 0 1.894-1.26 2.94-2.732\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMetaSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.429 2.571c1.43 0 2.334 1.077 2.823 2.053c.505 1.012.748 2.24.748 3.233c0 1.981-1.057 3.572-2.714 3.572c-.542 0-1.007-.217-1.376-.473s-.705-.594-1.008-.945c-.46-.533-.939-1.208-1.403-1.864q-.202-.287-.4-.563c-.614-.855-1.216-1.633-1.845-2.197s-1.176-.816-1.683-.816c-.283 0-.665.21-1.034.948C2.186 6.22 2 7.137 2 7.857c0 1.448.657 1.572.714 1.572c.089 0 .205-.025.632-.464c.203-.209.535-.629.857-1.054a1.02 1.02 0 0 1 1.381-.238a.98.98 0 0 1 .244 1.405c-.368.488-.77.996-1.049 1.282c-.487.5-1.185 1.069-2.065 1.069C1.057 11.429 0 9.839 0 7.857c0-.994.243-2.221.748-3.233c.488-.976 1.392-2.053 2.823-2.053c1.208 0 2.215.606 3.019 1.328c.804.721 1.515 1.657 2.133 2.517l.452.636c.451.637.849 1.199 1.24 1.651c.253.292.463.49.635.61a1 1 0 0 0 .184.102l.04.012l.01.001h.002c.057 0 .714-.123.714-1.57c0-.721-.186-1.637-.537-2.34c-.37-.738-.751-.947-1.034-.947c-.293.02-.55.072-.783.144c-.558.173-1.174-.102-1.277-.676a.95.95 0 0 1 .415-.954c.376-.246.823-.485 1.645-.514\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMicroscopeObservationSciene: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 2.5H6v4c0 .554-.446 1.005-1 1.012l-1.46.017A1.03 1.03 0 0 1 2.5 6.5v0Zm.75 0v-2h2v2M6 5.059h1.523a3.22 3.22 0 0 1 3.22 3.22V11H13.5V8.309a5.8 5.8 0 0 0-5.802-5.802H6M5.5 11v.5c0 .667-.8 2-2 2h10V11h-12m2.281 2.5H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMicroscopeObservationScieneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625.625c0-.345.28-.625.625-.625h2c.345 0 .625.28.625.625V2H6.5l.084.006h1.614A5.8 5.8 0 0 1 14 7.808V13.5a.5.5 0 0 1-.5.5H.625a.625.625 0 1 1 0-1.25H6.5v-1H1.625a.625.625 0 1 1 0-1.25h9.618V8.03a3.22 3.22 0 0 0-3.22-3.221h-.898V7c0 .897-.723 1.626-1.62 1.634l-2.458.023A1.657 1.657 0 0 1 1.375 7V2.625C1.375 2.28 1.655 2 2 2h.625zm2 .625V2h-.75v-.75zm.625 2H2.625V7c0 .226.184.409.41.407l2.46-.023A.384.384 0 0 0 5.874 7V3.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMicroscopeObservationScieneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.974.018h1a.5.5 0 0 1 .5.5v1.75h-2V.518a.5.5 0 0 1 .5-.5m-.75 3.22a.5.5 0 0 0-.5.5v3.5a1.03 1.03 0 0 0 1.042 1.03l1.459-.017c.554-.007 1-.458 1-1.012V5.792h1.522a3.22 3.22 0 0 1 3.221 3.22v.72H1.974a.75.75 0 1 0 0 1.5h3.051c0 .246-.108.58-.305.907c-.23.223-.489.343-.746.343H1.025a.75.75 0 0 0 0 1.5h11.949a.75.75 0 0 0 .75-.75V9.041a5.8 5.8 0 0 0-5.801-5.802H3.224\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMicrowave: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 2.5H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5\"/><path d=\"M8.5 4.5H3a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h5.5A.5.5 0 0 0 9 9V5a.5.5 0 0 0-.5-.5M11 5h.5M11 7h.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMicrowaveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 11.375v-8.75h11.5v8.75zm-.125-10C.504 1.375 0 1.879 0 2.5v9c0 .621.504 1.125 1.125 1.125h11.75c.621 0 1.125-.504 1.125-1.125v-9c0-.621-.504-1.125-1.125-1.125zm2 2.875h5a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4.5a.5.5 0 0 1 .5-.5m6.75.625c0-.345.28-.625.625-.625h.625a.625.625 0 1 1 0 1.25H10.5a.625.625 0 0 1-.625-.625M10.5 6.25a.625.625 0 1 0 0 1.25h.625a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMicrowaveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm2.546 1.088h6.408c.321 0 .582.26.582.582v4.66c0 .322-.26.582-.582.582H2.546a.58.58 0 0 1-.582-.582V4.67c0-.322.26-.582.582-.582m8.146.748c0-.345.28-.625.625-.625h1.046a.625.625 0 1 1 0 1.25h-1.046a.625.625 0 0 1-.625-.625m.625 1.539a.625.625 0 1 0 0 1.25h1.046a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMilkshake: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 6.5V6a3.5 3.5 0 1 1 7 0v.5l-.434 6.071a1 1 0 0 1-.997.929H4.93a1 1 0 0 1-.997-.929zm-1 0h9M8.72 2.951L9.5.5M3.684 9h6.602\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMilkshakeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.442 1.067a.625.625 0 1 0-.884-.884l-1.151 1.151a5.018 5.018 0 0 0-8.423 3.54H1.5a.625.625 0 1 0 0 1.251h.554l.5 6.377A1.625 1.625 0 0 0 4.175 14h5.651c.849 0 1.554-.652 1.62-1.498l.5-6.377h.555a.625.625 0 1 0 0-1.25h-.484a5 5 0 0 0-.801-2.58zm-1.677 3.808a3.768 3.768 0 0 0-7.53 0zm-7.457 1.25l.177 2.25h7.03l.177-2.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMilkshakeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.722.067a.75.75 0 0 1 .487.942l-.51 1.603a4.17 4.17 0 0 1 1.576 3.012H12a.75.75 0 0 1 0 1.5h-.769l-.372 5.22a1.75 1.75 0 0 1-1.746 1.625H5.108a1.75 1.75 0 0 1-1.745-1.626l-.373-5.22h-.77a.75.75 0 1 1 0-1.5h.725A4.173 4.173 0 0 1 8.351 1.9L8.78.554a.75.75 0 0 1 .943-.487M4.45 5.624a2.673 2.673 0 0 1 5.32 0zm5.156 3.194l.12-1.694H4.494l.122 1.694z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMinimizeWindow2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 6V1.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H8m-4 0H.5V10m0 3.5L7 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMinimizeWindow2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 2.5A2.5 2.5 0 0 1 2.5 0h9A2.5 2.5 0 0 1 14 2.5v9a2.5 2.5 0 0 1-2.5 2.5H7a1 1 0 1 1 0-2h4.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V7a1 1 0 0 1-2 0zm4.462 11.191A.5.5 0 0 1 4 14H.5a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .854-.354l1.042 1.043l4.397-4.396a1 1 0 0 1 1.414 1.414l-4.396 4.397l1.043 1.042a.5.5 0 0 1 .108.545\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMissedCall: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.143 12.696a2.76 2.76 0 0 1-3.464-.381l-.39-.381a.935.935 0 0 1 0-1.308L3.944 8.99a.926.926 0 0 1 1.3 0v0a.935.935 0 0 0 1.306 0l2.598-2.597a.92.92 0 0 0 0-1.308v0a.926.926 0 0 1 0-1.299l1.645-1.645a.935.935 0 0 1 1.307 0l.381.39a2.76 2.76 0 0 1 .381 3.463a25.1 25.1 0 0 1-6.718 6.702m.79-11.539L3.67 4.421a1 1 0 0 1-1.415 0l-1.44-1.44\"/><path d=\"M4.62 1.157h2.314v2.314\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMissedCallRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.037 0h2.645a.5.5 0 0 1 .5.5v2.645a.5.5 0 0 1-.853.353l-.705-.704l-2.036 2.033a1.875 1.875 0 0 1-2.65 0L.257 3.147A.875.875 0 0 1 1.494 1.91l1.681 1.68a.125.125 0 0 0 .177 0l2.034-2.033l-.702-.702A.5.5 0 0 1 5.037 0m5.466 2.397a1.526 1.526 0 0 1 2.134 0l.003.003l.369.37a3.3 3.3 0 0 1 .482 4.099a24.4 24.4 0 0 1-6.603 6.603l-.011.007a3.3 3.3 0 0 1-4.085-.437l-.373-.373l-.003-.002a1.526 1.526 0 0 1 0-2.134l.004-.004l1.569-1.56l.315-.239l-.315.24q.145-.143.315-.24l4.309-3.274a1.52 1.52 0 0 1 .372-1.482l1.507-1.566zm.645 1.132L8.613 5.456zm.417-.317l1.072-.815za.27.27 0 0 1 .192.073l.371.371l.007.007a2.05 2.05 0 0 1 .313 2.517a23.1 23.1 0 0 1-6.253 6.251a2.05 2.05 0 0 1-2.52-.273l-.37-.37a.277.277 0 0 1-.001-.375L4.87 9.856a.267.267 0 0 1 .364 0l.001.001c.587.58 1.548.58 2.135 0l.002-.002l2.5-2.501l.003-.003c.58-.586.58-1.548 0-2.134l-.001-.002a.267.267 0 0 1 0-.363l.007-.008l1.266-1.315zm0 0l-.417.317l.238-.247a.27.27 0 0 1 .179-.07M8.613 5.456L4.304 8.73a1.52 1.52 0 0 1 1.812.24c.1.097.275.097.375 0l2.497-2.5a.277.277 0 0 0 0-.375l.444-.44l-.443.441a1.5 1.5 0 0 1-.376-.641\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMissedCallSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.178 1.599A.625.625 0 0 1 4.62.532h2.314c.345 0 .625.28.625.625v2.314a.625.625 0 0 1-1.067.442l-.627-.627L4.2 4.952a1.75 1.75 0 0 1-2.475 0l-1.44-1.44a.75.75 0 0 1 1.061-1.06l1.44 1.439a.25.25 0 0 0 .353 0l1.666-1.666zm7.267-.349c.408 0 .8.16 1.091.445l.387.395a3.39 3.39 0 0 1 .455 4.255a25.8 25.8 0 0 1-6.897 6.876a3.39 3.39 0 0 1-4.243-.463l-.395-.387a1.56 1.56 0 0 1 0-2.182l1.66-1.643l.002-.002a1.55 1.55 0 0 1 2.174 0a.31.31 0 0 0 .431 0l2.595-2.593l.003-.004a.3.3 0 0 0 .065-.095a.31.31 0 0 0-.072-.329a1.55 1.55 0 0 1 0-2.175L10.35 1.7l.005-.004a1.56 1.56 0 0 1 1.09-.445Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMobilePhoneCamera: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 11h1M5 .5H1.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V9\"/><path d=\"M13.5 3a1 1 0 0 0-1-1H12L11 .5H9L8 2h-.5a1 1 0 0 0-1 1v2.5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1z\"/><path d=\"M10 4.375a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMobilePhoneCameraRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.25a.375.375 0 0 0-.375.375v10.75c0 .207.168.375.375.375h6.75a.375.375 0 0 0 .375-.375V9A.625.625 0 1 1 10 9v3.375C10 13.273 9.272 14 8.375 14h-6.75A1.625 1.625 0 0 1 0 12.375V1.625C0 .728.728 0 1.625 0h2.75a.625.625 0 1 1 0 1.25zm2.125 9.5A.75.75 0 0 1 4.5 10h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M8.584.223A.5.5 0 0 1 9 0h2a.5.5 0 0 1 .416.223l.852 1.277h.232A1.5 1.5 0 0 1 14 3v2.5A1.5 1.5 0 0 1 12.5 7h-5A1.5 1.5 0 0 1 6 5.5V3a1.5 1.5 0 0 1 1.5-1.5h.232zM8.875 4a1.125 1.125 0 1 0 2.25 0a1.125 1.125 0 0 0-2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMobilePhoneCameraSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.5a.25.25 0 0 0-.25.25v10.489a.5.5 0 0 0 .123.148a.8.8 0 0 0 .179.113H8.25a.25.25 0 0 0 .25-.25v-4a.75.75 0 0 1 1.5 0v4A1.75 1.75 0 0 1 8.25 14h-6.5a1.4 1.4 0 0 1-.602-.15c-.17-.08-.342-.19-.498-.322c-.289-.246-.65-.686-.65-1.278V1.75C0 .784.784 0 1.75 0H5a.75.75 0 0 1 0 1.5zm11.957.293A1 1 0 0 1 14 2.5V5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V2.5a1 1 0 0 1 1-1h.5l1-1.5h2l1 1.5h.5a1 1 0 0 1 .707.293M10.5 2.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-6 7.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModulePuzzle1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.1 1.211c.36.351.573.824.599 1.325L6.522.723a.67.67 0 0 1 .996 0l1.475 1.535q-.317.153-.568.398a2.052 2.052 0 0 0 2.899 2.9c.162-.167.297-.36.399-.569l1.554 1.535a.67.67 0 0 1 0 .996l-1.813 1.784A2.043 2.043 0 1 1 9.3 11.464l-1.823 1.813a.67.67 0 0 1-.996 0l-1.475-1.534q.317-.154.568-.4a2.057 2.057 0 1 0-3.317-2.33L.723 7.478a.67.67 0 0 1 0-.996l1.813-1.783A2 2 0 0 1 1.211 4.1a2.043 2.043 0 1 1 2.89-2.89\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModulePuzzle1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.98 1.249a.03.03 0 0 1 .023.01l.025.027l1.789 1.779a.625.625 0 0 0 1.065-.412c.017-.334.16-.65.399-.884l-.437-.447l.442.442a1.379 1.379 0 1 1 1.95 1.95l-.005.005a1.33 1.33 0 0 1-.884.4a.625.625 0 0 0-.407 1.069l1.779 1.75l.022.02a.03.03 0 0 1 .01.022a.03.03 0 0 1-.01.023l-.026.024l-.98.98l-.026-.026l-.005-.004a2.643 2.643 0 1 0-3.75 3.724l.007.008l.038.036l-.941.979l-.016.017a.03.03 0 0 1-.045 0l-.025-.027l-1.789-1.779a.625.625 0 0 0-1.064.406a1.378 1.378 0 1 1-1.46-1.46a.625.625 0 0 0 .4-1.069l-1.778-1.75l-.022-.02a.03.03 0 0 1 0-.045l.023-.021l1-.987l.056.056a2.638 2.638 0 0 0 3.7-3.754l-.037-.036l.941-.979l.016-.017a.03.03 0 0 1 .022-.01M9.405.877c-.174.17-.322.364-.44.572L7.92.411a1.28 1.28 0 0 0-1.887.006l-1.44 1.498a.625.625 0 0 0 .179.995q.21.103.38.263a1.388 1.388 0 0 1-1.96 1.96a1.5 1.5 0 0 1-.263-.38a.625.625 0 0 0-1.002-.172L.413 6.077a1.28 1.28 0 0 0 0 1.886l1.029 1.01a2.63 2.63 0 0 0-.558 4.143a2.63 2.63 0 0 0 4.148-.568L6.08 13.59a1.28 1.28 0 0 0 1.887-.006l1.44-1.498a.625.625 0 0 0-.179-.995a1.5 1.5 0 0 1-.39-.273a1.393 1.393 0 1 1 2.253-1.57a.625.625 0 0 0 1.004.17l1.495-1.495a1.28 1.28 0 0 0-.003-1.885L12.561 5.03a2.6 2.6 0 0 0 .562-.434A2.63 2.63 0 0 0 9.405.877\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModulePuzzle1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.02.25a1.14 1.14 0 0 0-.842.37L5.045 1.745a2.4 2.4 0 0 0-.481-.668a2.464 2.464 0 0 0-3.486 3.486c.193.197.416.357.66.477L.62 6.138a1.14 1.14 0 0 0 0 1.684l1.466 1.467a.5.5 0 0 0 .804-.136q.112-.23.29-.413a1.478 1.478 0 0 1 2.098 2.082a1.6 1.6 0 0 1-.412.288a.5.5 0 0 0-.142.797l1.412 1.47a1.143 1.143 0 0 0 1.686.004l1.136-1.13a2.462 2.462 0 0 0 3.958.665a2.463 2.463 0 0 0-.656-3.954l1.119-1.1a1.143 1.143 0 0 0 0-1.685l-1.487-1.468a.5.5 0 0 0-.801.138a1.6 1.6 0 0 1-.28.404a1.473 1.473 0 0 1-2.081-2.08q.181-.173.404-.281a.5.5 0 0 0 .143-.797L7.864.623A1.14 1.14 0 0 0 7.02.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModulePuzzle3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M7 .5v2.132a1.5 1.5 0 1 0 0 2.236v4.264a1.5 1.5 0 1 1 0 2.236V13.5\"/><path d=\"M.5 7h2.132a1.5 1.5 0 1 0 2.236 0h4.264a1.5 1.5 0 1 1 2.236 0H13.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModulePuzzle3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v10c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12zm1.25 10V7h1.343a1.385 1.385 0 1 0 2.064 0H7v1.968a1.385 1.385 0 1 1 0 2.064v1.343H2A.375.375 0 0 1 1.625 12m10.75-5h-1.343a1.385 1.385 0 1 0-2.064 0H7V5.032a1.385 1.385 0 1 1 0-2.064V1.625h5c.207 0 .375.168.375.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModulePuzzle3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0h4.875v1.158a2.125 2.125 0 1 0 0 4.184v1.033H4.368a.625.625 0 0 0-.466 1.042a.875.875 0 1 1-1.305 0a.625.625 0 0 0-.465-1.042H0V1.5A1.5 1.5 0 0 1 1.5 0M0 7.625V12.5A1.5 1.5 0 0 0 1.5 14h4.875v-2.132a.625.625 0 0 1 1.042-.466a.875.875 0 1 0 0-1.305a.625.625 0 0 1-1.042-.465V7.625H5.342q.033.183.033.375a2.125 2.125 0 1 1-4.217-.375zm7.625 0v1.033q.183-.033.375-.033a2.125 2.125 0 1 1-.375 4.217V14H12.5a1.5 1.5 0 0 0 1.5-1.5V7.625h-2.132a.625.625 0 0 1-.466-1.042a.875.875 0 1 0-1.305 0a.625.625 0 0 1-.465 1.042zM14 6.375V1.5A1.5 1.5 0 0 0 12.5 0H7.625v2.132a.625.625 0 0 1-1.042.466a.875.875 0 1 0 0 1.305a.625.625 0 0 1 1.042.465v2.007h1.033a2.125 2.125 0 1 1 4.184 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModuleThree: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.25 8.25H1a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h4.25a.5.5 0 0 0 .5-.5V8.75a.5.5 0 0 0-.5-.5m7.75 0H8.75a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5V8.75a.5.5 0 0 0-.5-.5M9.13.5H4.88a.5.5 0 0 0-.5.5v4.25a.5.5 0 0 0 .5.5h4.25a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModuleThreeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.88 0c-.621 0-1.125.504-1.125 1.125v4.25c0 .621.504 1.125 1.125 1.125h4.25c.621 0 1.125-.504 1.125-1.125v-4.25C10.255.504 9.751 0 9.13 0zM1.25 12.75v-4h4v4zM1.125 7.5C.504 7.5 0 8.004 0 8.625v4.25C0 13.496.504 14 1.125 14h4.25c.621 0 1.125-.504 1.125-1.125v-4.25c0-.621-.504-1.125-1.125-1.125zM8.75 8.75v4h4v-4zM7.5 8.625c0-.621.504-1.125 1.125-1.125h4.25c.621 0 1.125.504 1.125 1.125v4.25c0 .621-.504 1.125-1.125 1.125h-4.25A1.125 1.125 0 0 1 7.5 12.875z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineModuleThreeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.88 0a1 1 0 0 0-1 1v4.25a1 1 0 0 0 1 1h4.25a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM1 7.75a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h4.25a1 1 0 0 0 1-1V8.75a1 1 0 0 0-1-1zm6.75 1a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1H8.75a1 1 0 0 1-1-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyAtmCard1CreditPayPaymentDebitCardFinancePlasticMoney: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9.5\" x=\".5\" y=\"2.25\" rx=\"1\"/><path d=\"M.5 5.75h13m-4 3.5H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyAtmCard2DepositMoneyPaymentFinanceAtmWithdraw: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1 4.5A.5.5 0 0 1 .5 4V1A.5.5 0 0 1 1 .5h12a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5\"/><rect width=\"7\" height=\"8\" x=\"3.5\" y=\"3\" rx=\".5\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><path d=\"M3.5 13.5h7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyAtmCard3DepositMoneyPaymentFinanceAtmWithdraw: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"7\" x=\".5\" y=\"6.5\" rx=\"1\"/><path d=\"M3.5 2v2M7 .5V4m3.5-2v2\"/><circle cx=\"7\" cy=\"10\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyBankInstitutionMoneySavingBankPaymentFinance: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.91 5.5H1.09c-.56 0-.8-.61-.36-.9L6.64.73a.71.71 0 0 1 .72 0l5.91 3.87c.44.29.2.9-.36.9Z\"/><rect width=\"13\" height=\"2.5\" x=\".5\" y=\"11\" rx=\".5\"/><path d=\"M2 5.5V11m2.5-5.5V11M7 5.5V11m2.5-5.5V11M12 5.5V11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashBagBagPaymentCashMoneyFinance: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 3.02L13.5.5M8 3.02l5.5 1.48m-7 9c3.5 0 6-1.24 6-4c0-3-1.5-5-4.5-6.5l1.18-1.53a.65.65 0 0 0-.56-.95H4.38a.65.65 0 0 0-.56 1L5 3C2 4.52.5 6.52.5 9.52c0 2.74 2.5 3.98 6 3.98Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashBagDollarBagPaymentCashMoneyFinance: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 10.02v1.01m0-6.02v.94m0 7.54c3.5 0 6-1.24 6-4c0-3-1.5-5-4.5-6.5l1.18-1.52a.66.66 0 0 0-.56-1H4.88a.66.66 0 0 0-.56 1L5.5 3C2.5 4.51 1 6.51 1 9.51c0 2.74 2.5 3.98 6 3.98Z\"/><path d=\"M6 9.56A1.24 1.24 0 0 0 7 10a1.12 1.12 0 0 0 1.19-1A1.12 1.12 0 0 0 7 8a1.12 1.12 0 0 1-1.19-1A1.11 1.11 0 0 1 7 6a1.26 1.26 0 0 1 1 .4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashBill1BillingBillsPaymentFinanceCashCurrencyMoneyAccounting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"8\" x=\".5\" y=\".5\" rx=\"1\"/><circle cx=\"7\" cy=\"4.5\" r=\"1.5\"/><path d=\"M1.5 11h11m-10 2.5h9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashBill2CurrencyBillingPaymentFinanceCashBillMoneyAccounting: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"2.5\" rx=\"1\"/><circle cx=\"7\" cy=\"7\" r=\"1.5\"/><path d=\"M3 5h.5m7 4h.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashBill3AccountingBillingPaymentFinanceCashCurrencyMoneyBill: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10.5\" height=\"8\" x=\".5\" y=\"1.75\" rx=\"1\"/><circle cx=\"5.75\" cy=\"5.75\" r=\"1.5\"/><path d=\"M3.5 12.25h9a1 1 0 0 0 1-1v-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashCoinsStackAccountingBillingPaymentStackCashCoinsCurrencyMoneyFinance: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"9\" cy=\"5.5\" rx=\"4.5\" ry=\"2\"/><path d=\"M4.5 5.5v6c0 1.1 2 2 4.5 2s4.5-.9 4.5-2v-6\"/><path d=\"M13.5 8.5c0 1.1-2 2-4.5 2s-4.5-.9-4.5-2m4.4-7A6.77 6.77 0 0 0 5 .5C2.51.5.5 1.4.5 2.5c0 .59.58 1.12 1.5 1.5\"/><path d=\"M2 10C1.08 9.62.5 9.09.5 8.5v-6\"/><path d=\"M2 7C1.08 6.62.5 6.09.5 5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashDollarCoinAccountingBillingPaymentCashCoinCurrencyMoneyFinance: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4.5V3M5.5 8.5c0 .75.67 1 1.5 1s1.5 0 1.5-1c0-1.5-3-1.5-3-3c0-1 .67-1 1.5-1s1.5.38 1.5 1M7 9.5V11\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashFileDollarCommonMoneyCurrencyCashFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5.5h-7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7Z\"/><path d=\"M8.5 5V.5l5 5H9a.5.5 0 0 1-.5-.5Zm-4-.5V3M3 8.5c0 .75.67 1 1.5 1s1.5 0 1.5-1C6 7 3 7 3 5.5c0-1 .67-1 1.5-1s1.5.38 1.5 1m-1.5 4V11m4-1.5h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashSearchDollarSearchPayProductCurrencyQueryMagnifyingCashBusinessMoneyGlass: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6.5\" cy=\"6.5\" r=\"6\"/><path d=\"m10.74 10.74l2.76 2.76M6.5 4V2.5M5 8c0 .75.67 1 1.5 1S8 9 8 8c0-1.5-3-1.5-3-3c0-1 .67-1 1.5-1S8 4.38 8 5M6.5 9v1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashierBarCodeCodesTagsUpcBarcode: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5.5v10m3-10v10m3-10v10M11 .5v10m2.5-10v10m-13 3h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashierQrCodeCodesTagsCodeQr: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"4\" height=\"4\" x=\"3\" y=\"3\" rx=\"1\"/><path d=\"M3 .5H1.5a1 1 0 0 0-1 1V3M11 .5h1.5a1 1 0 0 1 1 1V3M3 13.5H1.5a1 1 0 0 1-1-1V11M11 13.5h1.5a1 1 0 0 0 1-1V11M3 9.5V11h1.5M7 11V9.5H5.5m5.5-5H9.5V3M11 8V6.5H9.5m0 3V11H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashierShopShoppingPayPaymentCashierStoreCashRegisterMachine: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 11h1M10 5V3m2-1.25A1.25 1.25 0 0 1 10.75 3h-1.5a1.25 1.25 0 0 1 0-2.5h1.5A1.25 1.25 0 0 1 12 1.75ZM5.5 5V1.5h-3V5\"/><rect width=\"13\" height=\"5\" x=\".5\" y=\"8.5\" rx=\"1\"/><path d=\"M12.5 8.5V6a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCashierTagCodesTagsTagProductLabel: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.25 9.36l-3.89 3.89a.75.75 0 0 1-1.06 0L1.79 6.74a.36.36 0 0 1-.11-.29l.59-3.84a.37.37 0 0 1 .34-.34l3.84-.59a.36.36 0 0 1 .29.11l6.51 6.51a.75.75 0 0 1 0 1.06ZM4.03 4.03L.53.53\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyBitcoinCircle1CryptoCirclePaymentBlockchainFinanceBitcoinCurrencyMoney: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.88 6.66h0a1.37 1.37 0 0 0 1.39-1.37h0A1.37 1.37 0 0 0 7.9 3.92H5.79a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2.09a1.62 1.62 0 1 0 0-3.24Zm.02 0H5.29m.95-2.74V3m1.54.92V3m-1.54 8V9.9M7.78 11V9.9\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyBitcoinCryptoCirclePaymentBlokchainFinanceBitcoinCurrencyMoney: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.79 6.45h0A2.23 2.23 0 0 0 7.83 2H4.39a.81.81 0 0 0-.81.81v8.09a.81.81 0 0 0 .81.81h3.4a2.63 2.63 0 0 0 0-5.26ZM5.13 2V.5M7.63 2V.5m-2.5 13V12m2.5 1.5V12m.2-5.55H3.58\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyDollarDollarExchangePaymentForexFinanceCurrencyMoneyForeign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.5 10.5h3.85a1.65 1.65 0 0 0 .32-3.27l-3.34-.46a1.65 1.65 0 0 1 .32-3.27H9.5M7 13.5V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyEuroCircleExchangePaymentEuroForexFinanceCurrencyMoneyForeign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 9.8a2.59 2.59 0 0 1-1 .2a2.88 2.88 0 0 1-2.75-3A2.88 2.88 0 0 1 7.5 4a2.76 2.76 0 0 1 .82.13M3.5 6h3m-3 2h3\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyEuroExchangePaymentEuroForexFinanceCurrencyMoneyForeign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 12.59a5 5 0 0 1-2 .41a5.77 5.77 0 0 1-5.5-6A5.77 5.77 0 0 1 10 1a4.89 4.89 0 0 1 1.63.27M2 5.5h6m-6 3h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyPoundCirclePoundSterlingExchangePaymentForexFinanceCurrencyMoneyForeign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.06 5.42v-.36A1.56 1.56 0 0 0 7.5 3.5h0a1.56 1.56 0 0 0-1.56 1.56v3L5 9.5h4.06M4.5 6.62h2.88\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyPoundPoundSterlingExchangePaymentForexFinanceCurrencyMoneyForeign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.75 4.75V4A3.26 3.26 0 0 0 8.5.75h0A3.26 3.26 0 0 0 5.25 4v6.25l-2 3h8.5m-9.5-6h5.99\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyYuanCircleExchangePaymentForexFinanceYuanCurrencyMoneyForeign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m5 4l2.08 2.77L9.15 4M7.08 6.77V10m-1.62-.69h3.23M5.46 7.5h3.23\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyGraphBarDecreaseArrowProductPerformanceDownDecreaseGraphBusinessChart: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.24.5l11.5 5.23m-2.15.81l2.15-.81l-.8-2.16M1.25 6h1.5a.5.5 0 0 1 .5.5v7h0h-2.5h0v-7a.5.5 0 0 1 .5-.5Zm5 1.5h1.5a.5.5 0 0 1 .5.5v5.5h0h-2.5h0V8a.5.5 0 0 1 .5-.5Zm5 1.5h1.5a.5.5 0 0 1 .5.5v4h0h-2.5h0v-4a.5.5 0 0 1 .5-.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyGraphBarIncreaseUpProductPerformanceIncreaseArrowGraphBusinessChart: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.24 6.54l11.5-5.23M10.59.5l2.15.81l-.8 2.15m1.31 10.05h-2.5h0v-7a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v7h0Zm-5 0h-2.5h0v-5.5a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v5.5h0Zm-5 0H.75h0v-4a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v4h0Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyGraphBarProductDataBarsAnalysisAnalyticsGraphBusinessChart: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.5h13m-9 0V.5h-4v13m8 0v-7h-4v7m8 0v-10h-4v10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyGraphPieChartProductDataAnalysisAnalyticsPieGraphBusinessChart: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 .5V7l4.6 4.6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneySafeVaultSavingComboPaymentSafeMoneyCombinationFinance: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"11.5\" x=\".5\" y=\".5\" rx=\"1\"/><circle cx=\"8.5\" cy=\"6.25\" r=\"1.75\"/><path d=\"M8.5 3.25V4.5m0 3.5v1.25m3-3h-1.25m-3.5 0H5.5m5.12-2.12l-.88.88M7.26 7.49l-.88.88m4.24 0l-.88-.88M7.26 5.01l-.88-.88M3 4.5V8m-1 4v1.5m9.5-1.5v1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyWalletMoneyPaymentFinanceWallet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 7.5v-2a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1H11a1 1 0 0 0 1-1V10M3.84 2L9.51.52a.49.49 0 0 1 .61.36L10.4 2\"/><rect width=\"3.5\" height=\"2.5\" x=\"10\" y=\"7.5\" rx=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoonCloud: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.67 2.5A3 3 0 0 1 10.673.505a2 2 0 1 0 2.824 2.824q.004.084.004.171a3 3 0 0 1-2 2.83M11 8.5a2.5 2.5 0 0 0-1.5.5A4.5 4.5 0 1 0 5 13.5h6a2.5 2.5 0 0 0 0-5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoonCloudRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.176 1.197a.5.5 0 0 0-.509-.695a3.5 3.5 0 0 0-3.11 4.03a5.4 5.4 0 0 1 2.18 1.66a4.4 4.4 0 0 1 3.233.697a3.5 3.5 0 0 0 1.528-2.556a.5.5 0 0 0-.695-.509a2 2 0 0 1-2.627-2.627M1.625 9.5a2.875 2.875 0 0 1 5.653-.744a.625.625 0 0 0 1.009.315A1.875 1.875 0 1 1 9.5 12.375h-5A2.875 2.875 0 0 1 1.625 9.5M4.5 5.375a4.125 4.125 0 0 0 0 8.25h5a3.125 3.125 0 1 0-1.307-5.964A4.12 4.12 0 0 0 4.5 5.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoonCloudSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.843 1.25a.75.75 0 0 0 .192-.722a.67.67 0 0 0-.674-.51a3.4 3.4 0 0 0-2.287.996c-.663.628-1.035 1.331-1.153 2.038a6.25 6.25 0 0 1 3.911 3.701q.083-.003.166-.003H11q.216 0 .429.022A3.95 3.95 0 0 0 12.9 5.87l.01-.01c.636-.635.97-1.46 1-2.291a.67.67 0 0 0-.509-.675a.75.75 0 0 0-.72.192a1.299 1.299 0 1 1-1.838-1.837M4.025 4.095a5 5 0 0 1 5.91 4.1A3 3 0 0 1 10.999 8H11a3 3 0 1 1 0 6H5a5 5 0 0 1-.975-9.904\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouse: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 6.5a3.5 3.5 0 1 0-7 0V10a3.5 3.5 0 1 0 7 0zM1 7h7\"/><path d=\"M4.5 7V2.75A2.25 2.25 0 0 1 6.75.5v0A2.25 2.25 0 0 1 9 2.75V3a2 2 0 1 0 4 0V1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.657 2.552a1.626 1.626 0 0 1 3.218.323v.75a2.125 2.125 0 0 0 4.25 0v-3a.625.625 0 1 0-1.25 0v3a.875.875 0 0 1-1.75 0v-.75a2.875 2.875 0 0 0-5.731-.33a4.126 4.126 0 0 0-3.519 4.08v3.25a4.125 4.125 0 1 0 8.25 0v-3.25a4.126 4.126 0 0 0-3.468-4.073M5 3.75a2.875 2.875 0 0 0-2.875 2.875v3.25a2.875 2.875 0 0 0 5.75 0v-3.25A2.875 2.875 0 0 0 5 3.75m0 1a.75.75 0 0 1 .75.75v1.625a.75.75 0 0 1-1.5 0V5.5A.75.75 0 0 1 5 4.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.659 1.94A1.5 1.5 0 0 1 8.219 3v.25a2.75 2.75 0 0 0 5.5 0v-1.5a.75.75 0 0 0-1.5 0v1.5a1.25 1.25 0 0 1-2.5 0V3a3 3 0 0 0-5.93-.64a4.8 4.8 0 0 1 1.559.033a1.5 1.5 0 0 1 .31-.454m2.28 5.09A3.47 3.47 0 0 0 1 7.03v3.47a3.47 3.47 0 1 0 6.939 0zM5.094 5.97a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseWireless: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 5a4.5 4.5 0 0 0-9 0v4a4.5 4.5 0 1 0 9 0zM7 3.5V5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseWireless1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 8.5v-1m3.5-6.261a9 9 0 0 0-7 0m5.7 2.099a6.78 6.78 0 0 0-4.36 0M4 10.5v-2a3 3 0 0 1 6 0v2a3 3 0 1 1-6 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseWireless1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.5a6.1 6.1 0 0 0-3.17.88a.75.75 0 0 1-.775-1.284A7.6 7.6 0 0 1 7 0c1.442 0 2.793.4 3.945 1.096a.75.75 0 0 1-.775 1.284A6.1 6.1 0 0 0 7 1.5M5.203 4.4A4.3 4.3 0 0 1 7 4.005a4.3 4.3 0 0 1 1.797.395a.75.75 0 0 0 .63-1.36A5.8 5.8 0 0 0 7 2.504c-.866 0-1.689.191-2.428.534A.75.75 0 0 0 5.203 4.4M7 5a3.375 3.375 0 0 0-3.375 3.375v2.25a3.375 3.375 0 1 0 6.75 0v-2.25A3.375 3.375 0 0 0 7 5M4.875 8.375a2.125 2.125 0 0 1 4.25 0v2.25a2.125 2.125 0 0 1-4.25 0zm2.875-.446a.75.75 0 0 0-1.5 0v.839a.75.75 0 1 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseWireless1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .078a9.6 9.6 0 0 0-3.743.757a.625.625 0 0 0 .486 1.152a8.38 8.38 0 0 1 6.514 0a.625.625 0 1 0 .486-1.152A9.6 9.6 0 0 0 7 .078M3.5 8.422a3.5 3.5 0 0 1 7 0v2a3.5 3.5 0 1 1-7 0zM4.64 2.92a7.4 7.4 0 0 1 4.761 0A.625.625 0 0 1 9 4.102a6.16 6.16 0 0 0-3.958 0A.625.625 0 0 1 4.64 2.92m3.11 4.503a.75.75 0 1 0-1.5 0v1a.75.75 0 1 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseWirelessRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.125 5.125a3.875 3.875 0 0 1 7.75 0v3.75a3.875 3.875 0 0 1-7.75 0zM7 0a5.125 5.125 0 0 0-5.125 5.125v3.75a5.125 5.125 0 1 0 10.25 0v-3.75A5.125 5.125 0 0 0 7 0m.75 3.375a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouseWirelessSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 5a5 5 0 0 1 10 0v4A5 5 0 0 1 2 9zm5.625-1.5a.625.625 0 1 0-1.25 0V5a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoustache: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 8.31a3.5 3.5 0 0 0 6.5-1.81a5.2 5.2 0 0 1-2 .5c-1 0-.58-2.42-2-2.89A2.34 2.34 0 0 0 7 5a2.34 2.34 0 0 0-2.5-.89C3.08 4.58 3.5 7 2.5 7a5.2 5.2 0 0 1-2-.5A3.5 3.5 0 0 0 7 8.31\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoustacheRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.038 4.484c-.738 0-1.336.598-1.336 1.336c0 .448-.098 1.018-.327 1.466c-.114.224-.29.475-.562.637c-.302.18-.657.209-1.006.073a4 4 0 0 1-.338-.15a2.747 2.747 0 0 0 4.975.172a.625.625 0 0 1 1.112 0a2.746 2.746 0 0 0 4.975-.173q-.166.084-.338.15a1.12 1.12 0 0 1-1.006-.072c-.271-.162-.448-.413-.562-.637c-.23-.448-.327-1.018-.327-1.466a1.337 1.337 0 0 0-2.41-.797l-.058.068a3 3 0 0 0-.274.43a.625.625 0 0 1-1.112 0a3 3 0 0 0-.274-.43a1 1 0 0 1-.059-.068a1.33 1.33 0 0 0-1.073-.54M7 4.134A2.587 2.587 0 0 0 2.452 5.82c0 .306-.073.669-.19.897a1 1 0 0 1-.055.092a2.74 2.74 0 0 1-1.078-.797a.625.625 0 0 0-1.106.327A3.996 3.996 0 0 0 7 9.406a3.996 3.996 0 0 0 6.977-3.067a.625.625 0 0 0-1.106-.327a2.74 2.74 0 0 1-1.078.797a1 1 0 0 1-.055-.092c-.117-.228-.19-.591-.19-.897A2.587 2.587 0 0 0 7 4.134\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoustacheSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7 8.39a3.77 3.77 0 0 0 6.919-1.163c.076-.36-.304-.606-.655-.497a5.6 5.6 0 0 1-1.418.25c-1.077 0-.625-2.607-2.154-3.113A2.52 2.52 0 0 0 7 4.826a2.52 2.52 0 0 0-2.692-.959C2.778 4.373 3.23 6.98 2.154 6.98a5.6 5.6 0 0 1-1.418-.25c-.35-.11-.73.137-.655.497A3.77 3.77 0 0 0 7 8.39\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouthLip: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 7.5s1.686 3.486 6 3.486S13 7.5 13 7.5s-1.427-4.875-6-2.312C2.427 2.625 1 7.5 1 7.5m0-.004h12\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouthLipRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.104 3.817c.063-.021.228-.03.527.055c.28.08.595.219.902.379a10 10 0 0 1 1.084.658l.015.01l.003.003a.625.625 0 0 0 .73 0l.003-.003l.015-.01a6 6 0 0 1 .3-.201c.203-.13.481-.3.784-.457c.307-.16.622-.298.902-.379c.3-.085.464-.076.527-.055c.03.01.111.049.248.15q.195.146.444.387c.332.318.695.722 1.038 1.126c.168.198.329.394.476.577H1.898c.147-.183.308-.379.476-.577c.343-.404.706-.808 1.038-1.126q.249-.241.444-.386c.137-.102.218-.141.248-.151M.298 6.442l-.177-.13l.002-.002l.006-.008l.02-.027a23 23 0 0 1 .356-.47c.235-.302.559-.712.915-1.133c.355-.419.75-.86 1.126-1.22a6 6 0 0 1 .563-.486c.177-.132.383-.263.599-.335c.427-.143.895-.067 1.267.04c.393.112.79.292 1.134.47c.348.181.66.372.884.516L7 3.66l.007-.004c.224-.144.536-.334.884-.515a6.3 6.3 0 0 1 1.134-.471c.372-.107.84-.183 1.267-.04c.216.072.422.203.599.335c.185.138.375.306.563.486c.376.36.771.801 1.126 1.22a33 33 0 0 1 1.27 1.603l.021.027l.006.008l.001.002l-.176.13l.177-.13c.141.193.16.45.05.66l-.206-.107l.205.108l-.001.002l-.002.005l-.007.012l-.021.038l-.077.129a6 6 0 0 1-.296.432a7.7 7.7 0 0 1-1.217 1.28c-1.114.933-2.845 1.855-5.307 1.855S2.807 9.803 1.693 8.87A7.7 7.7 0 0 1 .476 7.59a6 6 0 0 1-.394-.6l-.007-.01l-.002-.005v-.001H.071l.205-.11l-.206.109a.63.63 0 0 1 .05-.66zm11.84.865a7 7 0 0 1-.633.606C10.577 8.689 9.122 9.476 7 9.476S3.423 8.69 2.495 7.913a7 7 0 0 1-.632-.606z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMouthLipSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.722 6.865a7 7 0 0 0-.198-.442a6 6 0 0 0-1.168-1.639c-.564-.546-1.33-1.02-2.324-1.143c-.896-.112-1.905.07-3.032.633c-1.127-.563-2.137-.745-3.033-.633c-.993.123-1.76.597-2.324 1.143a6 6 0 0 0-1.167 1.64a7 7 0 0 0-.198.441zM.334 8.115q.09.154.235.364c.257.372.648.865 1.192 1.358C2.854 10.83 4.565 11.82 7 11.82s4.145-.99 5.239-1.982a8 8 0 0 0 1.426-1.722z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoveLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.5 7h-6M3 4.5L.5 7L3 9.5m9.5-9H10a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoveLeftSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 0a1.5 1.5 0 0 0-1.5 1.5v11A1.5 1.5 0 0 0 10 14h2.5a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0zM3.5 4.5a.5.5 0 0 0-.854-.354l-2.5 2.5a.5.5 0 0 0 0 .708l2.5 2.5A.5.5 0 0 0 3.5 9.5V8h3a1 1 0 0 0 0-2h-3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoveRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.5 7h6M11 4.5L13.5 7L11 9.5m-9.5 4H4a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoveRightSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14H4a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 4 0zm6 6a1 1 0 0 0 0 2h3v1.5a.5.5 0 0 0 .854.354l2.5-2.5a.5.5 0 0 0 0-.708l-2.5-2.5a.5.5 0 0 0-.854.354V6z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMultipleFile2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 2.5H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1M4 5h4M4 7.5h4M4 10h2\"/><path d=\"M4.5.5H11a1 1 0 0 1 1 1V11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMultipleFile2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.25 1.625C3.25.728 3.978 0 4.875 0h6.5C12.273 0 13 .728 13 1.625v8.5c0 .898-.727 1.625-1.625 1.625h-.625v.625c0 .898-.727 1.625-1.625 1.625h-6.5A1.625 1.625 0 0 1 1 12.375v-8.5c0-.897.728-1.625 1.625-1.625h.625zm-1 2.25c0-.207.168-.375.375-.375h6.5c.207 0 .375.168.375.375v8.5a.375.375 0 0 1-.375.375h-6.5a.375.375 0 0 1-.375-.375zm1 1.75c0-.345.28-.625.625-.625h4a.625.625 0 1 1 0 1.25h-4a.625.625 0 0 1-.625-.625m.625 2.125a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMultipleFile2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 0a.75.75 0 0 0 0 1.5H11a.25.25 0 0 1 .25.25v9.5a.75.75 0 0 0 1.5 0v-9.5A1.75 1.75 0 0 0 11 0zm-3 4A1.5 1.5 0 0 1 3 2.5h5.5A1.5 1.5 0 0 1 10 4v8.5A1.5 1.5 0 0 1 8.5 14H3a1.5 1.5 0 0 1-1.5-1.5zm1.625 1c0-.345.28-.625.625-.625h4a.625.625 0 1 1 0 1.25h-4A.625.625 0 0 1 3.125 5m.625 1.875a.625.625 0 1 0 0 1.25h4a.625.625 0 1 0 0-1.25zM3.124 10c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25h-2A.625.625 0 0 1 3.124 10\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicEqualizer: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 5.5v3M4 3v8M7 .5v13M10 3v8m3-5.5v3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicEqualizer1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.75a.75.75 0 0 0-1.5 0v12.5a.75.75 0 0 0 1.5 0zM3.813 2.327a.75.75 0 0 1 .75.75v7.846a.75.75 0 0 1-1.5 0V3.077a.75.75 0 0 1 .75-.75M.874 4.779a.75.75 0 0 1 .75.75V8.47a.75.75 0 0 1-1.5 0V5.53a.75.75 0 0 1 .75-.75m9.313-2.452a.75.75 0 0 1 .75.75v7.846a.75.75 0 0 1-1.5 0V3.077a.75.75 0 0 1 .75-.75m3.687 3.202a.75.75 0 0 0-1.5 0V8.47a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicEqualizerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.851a.75.75 0 0 0-1.5 0V13.15a.75.75 0 0 0 1.5 0zM4 2.466a.75.75 0 0 1 .75.75v7.568a.75.75 0 1 1-1.5 0V3.216a.75.75 0 0 1 .75-.75M1 4.831a.75.75 0 0 1 .75.75V8.42a.75.75 0 0 1-1.5 0V5.581a.75.75 0 0 1 .75-.75m9-2.365a.75.75 0 0 1 .75.75v7.568a.75.75 0 1 1-1.5 0V3.216a.75.75 0 0 1 .75-.75m3.75 3.115a.75.75 0 0 0-1.5 0V8.42a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicFolderSong: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.645 11a.88.88 0 1 0 0-1.759a.88.88 0 0 0 0 1.76m3.957-1.1a.88.88 0 1 0 0-1.76a.88.88 0 0 0 0 1.76\"/><path d=\"M5.525 10.12V6.339l3.957-.932v3.616\"/><path d=\"M.5 12.25V1.75a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicFolderSongRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2.625c0-.207.168-.375.375-.375h3.22c.171 0 .321.117.363.284l.31 1.243c.07.278.32.473.607.473h6.25c.207 0 .375.168.375.375v6.75a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375zM1.625 1C.728 1 0 1.728 0 2.625v8.75C0 12.273.728 13 1.625 13h10.75c.898 0 1.625-.727 1.625-1.625v-6.75C14 3.728 13.273 3 12.375 3H6.613l-.192-.77A1.625 1.625 0 0 0 4.844 1zm8.251 4.376a.63.63 0 0 1 .249.499V9a1.25 1.25 0 1 1-1.25-1.25V6.704l-2.25.642V9.75a1.25 1.25 0 1 1-1.25-1.25V6.875c0-.279.185-.524.453-.601l3.5-1a.63.63 0 0 1 .548.102\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicFolderSongSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.183.25a1.5 1.5 0 0 1 1.492 1.14l.215.86h5.61a1.5 1.5 0 0 1 1.5 1.5v8.5a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5V1.75A1.5 1.5 0 0 1 1.5.25zM9.48 4.48a1 1 0 0 0-.438.015l-.005.002l-3.472.963a.97.97 0 0 0-.712.927V8.75a1.535 1.535 0 1 0 1.501 1.535V6.991l2.407-.669v1.303h-.034A1.536 1.536 0 1 0 10.26 9.11l-.001-3.683v-.004a.966.966 0 0 0-.78-.943\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNote1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.25 13.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/><path d=\"M6.75 11V.5a5.5 5.5 0 0 1 5.5 5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNote1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.51 0a.625.625 0 0 0-.625.625v7.887a2.952 2.952 0 1 0 1.25 2.411v-9.64c.482.053.955.166 1.405.337a5.3 5.3 0 0 1 1.708 1.046c.486.445.869.971 1.129 1.546s.392 1.189.392 1.807a.625.625 0 0 0 1.25 0c0-.798-.172-1.587-.503-2.321a6 6 0 0 0-1.423-1.954A6.6 6.6 0 0 0 8.983.451A7 7 0 0 0 6.51 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNote1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.445.126a1 1 0 0 0-1 1v6.59a3.195 3.195 0 1 0 2 2.934V2.23q.38.081.742.221c.55.215 1.047.527 1.462.917s.741.849.962 1.35c.221.5.334 1.034.334 1.572a1 1 0 1 0 2 0c0-.818-.172-1.627-.504-2.38a6.2 6.2 0 0 0-1.423-2A6.5 6.5 0 0 0 8.912.587a6.8 6.8 0 0 0-2.467-.46\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNote2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 13.42a2 2 0 1 0 0-4a2 2 0 0 0 0 4m9-2.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/><path d=\"M13.5 8.92V1.08a.5.5 0 0 0-.63-.48l-8 2.22a.5.5 0 0 0-.37.48v8.12m0-5.5l9-2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNote2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.254.413a1.08 1.08 0 0 1 1.258.57c.074.15.112.314.113.48v7.23q.005.076.005.153a2.346 2.346 0 1 1-1.255-2.077V4.592l-7.058 1.96v4.415q.008.093.008.187a2.346 2.346 0 1 1-1.258-2.079V3.543a1.1 1.1 0 0 1 .8-1.049l7.382-2.08zM5.317 5.255l7.058-1.96V1.677L5.317 3.666z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNote2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.781.23a1.2 1.2 0 0 0-.555.02h-.006L4.587 2.369a1.23 1.23 0 0 0-.905 1.177V9.04a2.477 2.477 0 1 0 1.5 2.277V6.076l7.09-1.97V6.57a2.477 2.477 0 1 0 1.5 2.345V1.403a1.226 1.226 0 0 0-.99-1.172Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNoteOff1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.25 13.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m2.5-6.75V.5a5.5 5.5 0 0 1 5.5 5.5M.5.5l13 13M6.75 11V9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNoteOff1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.067.183a.625.625 0 1 0-.884.884l6.125 6.125l.01.01l6.615 6.615a.625.625 0 1 0 .884-.884L7.38 6.496V1.29a4.77 4.77 0 0 1 4.144 4.728a.625.625 0 1 0 1.25 0A6.02 6.02 0 0 0 6.754 0a.625.625 0 0 0-.624.625v4.62zm3.377 7.788a2.952 2.952 0 1 0 0 5.904a2.952 2.952 0 0 0 0-5.904\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNoteOff1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22L5.4 4.339V1.185a1 1 0 0 1 1-1c.838 0 1.67.155 2.45.457c.778.303 1.49.749 2.091 1.314a6.1 6.1 0 0 1 1.414 1.987c.33.747.5 1.55.5 2.364a1 1 0 1 1-2 0a3.85 3.85 0 0 0-.33-1.557a4.1 4.1 0 0 0-.952-1.336a4.5 4.5 0 0 0-1.448-.908a5 5 0 0 0-.726-.216v4.049l6.381 6.38a.75.75 0 1 1-1.06 1.061zm4.002 6.24q.273 0 .532.045l2.565 2.565q.045.259.045.531A3.142 3.142 0 1 1 4.222 7.52\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNoteOff2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.5.5l13 13m-11-.08a2 2 0 1 0 0-4a2 2 0 0 0 0 4m8.29-2.63a2 2 0 1 0-1.16-1.16M4.5 8v3.42\"/><path d=\"M13.5 8.92V1.08a.5.5 0 0 0-.63-.48l-8 2.22a.5.5 0 0 0-.37.48v1.2m1.11 1.11l7.89-2.19\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNoteOff2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.067.183a.625.625 0 1 0-.884.884l12.75 12.75a.625.625 0 1 0 .884-.884l-1.92-1.92a2.31 2.31 0 0 0 1.607-2.154l.006-.082V1.569a1.09 1.09 0 0 0-.421-.854a1.07 1.07 0 0 0-.94-.187l-.004.002l-7.24 2.04a1.08 1.08 0 0 0-.74.71zm4.295 4.295l.621.622l6.277-1.744v-1.56L5.362 3.739zm1.637 1.637l1.993 1.993A2.312 2.312 0 0 1 12.26 6.76V4.654zM.736 11.074a2.31 2.31 0 0 1 3.376-2.051V7.88a.625.625 0 1 1 1.25 0v3.194a1 1 0 0 1-.007.09a2.31 2.31 0 0 1-4.62-.09\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMusicNoteOff2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22L3.9 2.838c.158-.187.37-.322.607-.387L12.083.35a1.217 1.217 0 0 1 1.534 1.168v7.185q.006.087.006.174c0 .997-.592 1.855-1.443 2.243l1.6 1.6a.75.75 0 1 1-1.06 1.061zm8.697 6.577A2.463 2.463 0 0 1 12.13 6.61V4.153L6.731 5.67zM3.61 9.06V6.243L5.097 7.73v3.42q.006.086.006.174A2.463 2.463 0 1 1 3.609 9.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatrueEcologyRecycle1SignEnvironmentProtectSaveArrows: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 10.08v2a.29.29 0 0 1-.29.28h-2.1a1.45 1.45 0 0 1-.88-.51\"/><path d=\"M2.73 11.86s-1.09-.95 1.44-3.48H5.3L3.61 5.59H.5l.85 1.09s-.57.1-.57.89a10 10 0 0 0 1.95 4.29Zm7.62-5.49l1.48-1a.26.26 0 0 1 .21 0a.26.26 0 0 1 .19.12l1.15 1.72a1 1 0 0 1 0 .89\"/><path d=\"M13.42 8s-.32 1.3-3.63 1v-.87l-1.94 2.54l1.84 2.83l.1-1.33s.37.45 1 0A18.73 18.73 0 0 0 13.42 8ZM4.35 4.28L3 3.66a.3.3 0 0 1-.14-.38L4 1a1 1 0 0 1 .74-.5m0 0s1.23 0 2.79 3l-.81 1h3.36l1.19-3.14l-1.4.43a1.21 1.21 0 0 0-.73-1A5.87 5.87 0 0 0 7 .5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyBonePetDogBoneFoodSnack: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 2.5a2 2 0 0 0-4 0a2 2 0 0 0 .59 1.41L3.91 8.09A2 2 0 0 0 2.5 7.5a2 2 0 0 0 0 4a2 2 0 0 0 4 0a2 2 0 0 0-.59-1.41l4.18-4.18a2 2 0 0 0 1.41.59a2 2 0 0 0 0-4Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyCatHeadCatPetAnimalsFelyne: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.5 10.25h1m-7 3l3.5-2m-3.5-3l4 1m2.98-6.97L12.87.77a.46.46 0 0 1 .46.11a.49.49 0 0 1 .16.45l-1.1 5.61c-.06-.15-.12-.31-.17-.47A5.75 5.75 0 0 0 7 2.25a5.75 5.75 0 0 0-5.22 4.22c-.05.17-.11.32-.17.48L.51 1.33A.49.49 0 0 1 .67.88a.46.46 0 0 1 .46-.11l5.39 1.51m1.98 10.8a6.7 6.7 0 0 1-3 0m8 .17l-3.5-2m3.5-3l-4 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyCloverPlantLeafTreeFlowerLuckLucky: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 7s2-.5 2-2c0-1-.5-1.5-2-1.5c-1 0-2.08 1.83-2.5 2c.17-.42 1.5-2 1.5-3c0-1.5-.5-2-1.5-2c-1.5 0-2 2-2 2s-.5-2-2-2c-1 0-1.5.5-1.5 2c0 1 1.33 2.08 1.5 2.5c-.42-.17-1.5-1.5-2.5-1.5C1 3.5.5 4 .5 5c0 1.5 2 2 2 2s-2 .5-2 2c0 1 .5 1.5 2 1.5a6.36 6.36 0 0 0 4.5-2a6.36 6.36 0 0 0 4.5 2c1.5 0 2-.5 2-1.5c0-1.5-2-2-2-2ZM7 8.5v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyDogHeadDogPetAnimalsCanine: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10 5v2a1 1 0 0 0 1 1h.5a2 2 0 0 0 2-2V3a1 1 0 0 0-1-1H11a2 2 0 0 1-.91-.22A6.88 6.88 0 0 0 7 1a6.88 6.88 0 0 0-3.11.78A2.07 2.07 0 0 1 3 2H1.5a1 1 0 0 0-1 1v3a2 2 0 0 0 2 2H3a1 1 0 0 0 1-1V5m7.5 3l-.31 1.57a4.27 4.27 0 0 1-8.38 0L2.5 8m4 2h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyFlowerPlantTreeFlowerPetalsBloom: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"7\" cy=\"7.26\" rx=\"1.5\" ry=\"1.49\"/><path d=\"M13.37 5.34a2.57 2.57 0 0 0-3.24-1.64a2.3 2.3 0 0 0-.65.3a2.71 2.71 0 0 0 .1-.71a2.58 2.58 0 0 0-5.16 0a2.71 2.71 0 0 0 .1.71a2.3 2.3 0 0 0-.65-.31a2.56 2.56 0 1 0-1.59 4.87a3 3 0 0 0 .72.12a3 3 0 0 0-.5.51a2.54 2.54 0 0 0 .57 3.57a2.59 2.59 0 0 0 3.6-.56a2.47 2.47 0 0 0 .33-.64a2.47 2.47 0 0 0 .34.64a2.59 2.59 0 0 0 3.6.56a2.54 2.54 0 0 0 .57-3.57a3 3 0 0 0-.5-.51a3 3 0 0 0 .71-.12a2.55 2.55 0 0 0 1.65-3.22Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyGreenHouseGlassBuildingPlantsCropsProduceFarm: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6.94a1 1 0 0 0-.32-.74L7 .5L.82 6.2a1 1 0 0 0-.32.74v5.56a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1ZM7 8V.5M.5 8h13m-13 2.75H4m6 0h3.5M4 13.5V3.27m6 10.23V3.27\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyLeafEnvironmentLeafEcologyPlantPlantsEco: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.51 5.38c2 2.82.47 6.05-.27 7.31a1.42 1.42 0 0 1-1 .66c-1.45.25-5.06.53-7-2.29C1.33 8.4 1.41 3.72 1.58 1.49A1.05 1.05 0 0 1 3 .55c2.15.62 6.63 2.17 8.51 4.83Z\"/><path d=\"M4.77 4.45a52.26 52.26 0 0 1 6 8.73\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyLeafProtectEnvironmentLeafEcologyPlantPlantsEco: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.31 4.15c0-1 0-2-.07-2.66A1 1 0 0 0 9.89.55c-2.16.62-6.57 2.17-8.42 4.83c-2 2.82-.46 6.05.27 7.31a1.38 1.38 0 0 0 1 .66a9.36 9.36 0 0 0 2.79.08\"/><path d=\"M5 8.58a51.12 51.12 0 0 0-2.78 4.6m8.45.29h0a.5.5 0 0 1-.34 0h0A4.48 4.48 0 0 1 7.5 9.31V7.46A.47.47 0 0 1 8 7h5a.47.47 0 0 1 .46.46v1.85a4.48 4.48 0 0 1-2.79 4.16Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyPineTreePlantTreeFarmingChristmasNaturePlantsPineEnvironment: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 10.5H2l3.5-5H3l4-5l4 5H8.5l3.5 5zm-5 0v3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyPottedCactusTreePlantSucculentPot: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.1 12.61a1 1 0 0 1-1 .89H4.9a1 1 0 0 1-1-.89L3.5 9h7ZM4.5 9V5a2.5 2.5 0 0 1 5 0v4M7 2.5v-2M4.5 6h-2m1-3.5l1.31 1.31M9.5 6h2m-1-3.5L9.19 3.81\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyPottedFlowerFlowerPlantTreePot: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 13.5H5l-1-4h6l-1 4zm1.31-10.61A1.34 1.34 0 0 0 8.63 2a1.2 1.2 0 0 0-.34.17a1.5 1.5 0 0 0 .05-.37a1.34 1.34 0 0 0-2.68 0a1.5 1.5 0 0 0 0 .37A1.2 1.2 0 0 0 5.37 2a1.34 1.34 0 0 0-1.68.86a1.32 1.32 0 0 0 .86 1.67a1.15 1.15 0 0 0 .37.06A1.34 1.34 0 0 0 5 6.75a1.34 1.34 0 0 0 1.87-.3A1.06 1.06 0 0 0 7 6.12a1.06 1.06 0 0 0 .18.33a1.34 1.34 0 0 0 1.87.3a1.34 1.34 0 0 0 0-2.13a1.15 1.15 0 0 0 .37-.06a1.32 1.32 0 0 0 .89-1.67ZM7 6.12V9.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyPottedPlantTreePlantSucculentPot: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5 7.5l-.86 5.16a1 1 0 0 1-1 .84H4.35a1 1 0 0 1-1-.84L2.5 7.5ZM4 .69a3.84 3.84 0 0 0-1.5 3.06A3.63 3.63 0 0 0 6 7.5a3.24 3.24 0 0 0 .94-.14Zm6 0a3.84 3.84 0 0 1 1.5 3.06A3.63 3.63 0 0 1 8 7.5a3.24 3.24 0 0 1-.94-.14Z\"/><path d=\"M5 3L7 .5L9 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyPottedTree1TreePlantPot: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"4\" r=\"3.5\"/><path d=\"M7 5v4.5m2 4H5l-.5-4h5l-.5 4z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyPottedTree2TreePlantPot: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.25 13.5h-4l-.5-4h5l-.5 4zm2.88-7.43a2 2 0 1 1-2.47-3.14c.86-.68 3.59-.28 3.59-.28S13 5.39 12.13 6.07Z\"/><path d=\"M9.25 5.64a5.5 5.5 0 0 0-2 3.86c0-3-1.5-5-4-6.5\"/><path d=\"M1.67 5a2.56 2.56 0 0 0 3.61-3.61C4.28.4.75.5.75.5S.67 4 1.67 5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyRainbowArchRainColorfulRainbowCurveHalfCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.25a6.5 6.5 0 0 1 13 0\"/><path d=\"M3 10.25a4 4 0 0 1 8 0\"/><path d=\"M5.5 10.25a1.5 1.5 0 0 1 3 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyRiceFieldSunRiseSetFieldCropProduceFarm: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 11.5s2-2 6.5-2s6.5 2 6.5 2M7 9.5v4m-4.5 0L6 9.53m5.5 3.97L8 9.53M3.54 7.5a2.74 2.74 0 0 1 0-.5a3.5 3.5 0 0 1 7 0a2.74 2.74 0 0 1 0 .5M.5 7h1m1-4.5L3 3M7 .5v1m4.5 1L11 3m2.5 4h-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyRoseFlowerRosePlantTree: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4.1a8.62 8.62 0 0 1 5.5-1.6V6a5.5 5.5 0 0 1-11 0V2.5s6.56-.79 9.56 7.21\"/><path d=\"M9.91 2.76a3 3 0 0 0-5.82 0M7 11.5v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyTree1TreePlantPineTrianglePark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.57 7.84a2 2 0 0 1-.26 1.82a2 2 0 0 1-1.63.84H4.32a2 2 0 0 1-1.63-.84a2 2 0 0 1-.26-1.82l1.91-5.45a2.82 2.82 0 0 1 5.32 0Z\"/><path d=\"M5.5 6.5L7 8v5.5M7 8l1.5-1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyTree2TreePlantCircleRoundPark: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 6.5L7 8v5.5M7 8l1.5-1.5\"/><circle cx=\"7\" cy=\"6\" r=\"5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNatureEcologyVolcanoEruptionEruptMountainVolcanoLavaMagmaExplosion: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5s-4-2-4-5h-5c0 3-4 5-4 5m10-8a2 2 0 0 0 0-4a2 2 0 0 0-1.24.43a2.5 2.5 0 0 0-4.52 0A2 2 0 0 0 3.5 1.5a2 2 0 0 0 0 4m2-1v4m3-4v4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNavigationArrowOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.503.502l12.995 12.996m-8.93-8.93l7.296-3.087a.5.5 0 0 1 .655.655L9.433 9.432M8.5 11.636l-.577 1.365a.5.5 0 0 1-.908.029l-1.94-3.88a.5.5 0 0 0-.224-.225L.97 6.985a.5.5 0 0 1 .028-.908L2.364 5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNavigationArrowOffRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.186.186a.625.625 0 0 0 0 .883l3.777 3.777l.02.021L8.9 9.784l.022.022l4.009 4.008a.625.625 0 1 0 .884-.883l-3.733-3.733l2.473-6.4l.002-.004c.33-.866-.542-1.63-1.326-1.363l-.009.003l-6.64 2.264L1.069.186a.625.625 0 0 0-.883 0m2.224 4.83a.625.625 0 0 0-.793-.39l-.945.323a.992.992 0 0 0-.087 1.843L4.977 8.77a.38.38 0 0 1 .2.218l1.524 4.355a.983.983 0 0 0 1.846.03l.496-1.287a.625.625 0 1 0-1.166-.45l-.235.61l-1.285-3.671a1.63 1.63 0 0 0-.867-.945L1.694 5.92l.326-.111a.625.625 0 0 0 .39-.793\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNavigationArrowOffSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22l3.91 3.908l6.981-2.954a.5.5 0 0 1 .656.656L9.872 8.81l3.908 3.909a.75.75 0 1 1-1.06 1.06zm.085 4.914l2.355-.996l6.142 6.142l-.996 2.355a.5.5 0 0 1-.908.029L4.765 9.458a.5.5 0 0 0-.223-.223L.276 7.102a.5.5 0 0 1 .03-.908\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNavigationArrowOn: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.515 12.53a.5.5 0 0 0 .908-.029l4.596-10.865a.5.5 0 0 0-.655-.655L1.5 5.577a.5.5 0 0 0-.029.908l3.88 1.94a.5.5 0 0 1 .225.224z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNavigationArrowOnRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M8.84 12.757L12.974 1.57a.424.424 0 0 0-.398-.57h-.007a.4.4 0 0 0-.134.021L1.262 4.665a.38.38 0 0 0-.065.693l4.51 2.48a1 1 0 0 1 .43.467l2.014 4.475a.372.372 0 0 0 .689-.023\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNavigationArrowOnSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.96.695a.5.5 0 0 0-.655-.655l-13 5.5a.5.5 0 0 0-.029.907l4.851 2.426l2.426 4.85a.5.5 0 0 0 .907-.028z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNecklace: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 10L7 8.5L5 10v2l2 1.5L9 12z\"/><path d=\"M9 10.083a5 5 0 1 0-4 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNecklaceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.25 5.167C2.25 3.1 3.92 1.5 6.042 1.5h1.916c2.122 0 3.792 1.6 3.792 3.667A3.8 3.8 0 0 1 10.3 8.15l-1.25.983l-1.675-1.257a.625.625 0 0 0-.75 0L4.95 9.132L3.7 8.149a3.8 3.8 0 0 1-1.45-2.982m2.125 5.42L2.773 9.33A5.3 5.3 0 0 1 .75 5.167C.75 2.217 3.147 0 6.042 0h1.916c2.895 0 5.292 2.217 5.292 5.167a5.3 5.3 0 0 1-2.023 4.162l-1.602 1.259v1.287a.63.63 0 0 1-.25.5l-2 1.5a.625.625 0 0 1-.75 0l-2-1.5a.63.63 0 0 1-.25-.5zm1.25.976v-1.375L7 9.156l1.375 1.031v1.376L7 12.593z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNecklaceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.248 1.58a5.948 5.948 0 1 1 7.002 9.597v-.427a1.75 1.75 0 0 0-.413-1.13a4.447 4.447 0 1 0-5.674 0a1.75 1.75 0 0 0-.413 1.13v.427a5.948 5.948 0 0 1-.502-9.597M8.8 10.35a.5.5 0 0 1 .2.4v1.5a.5.5 0 0 1-.2.4l-1.5 1.125a.5.5 0 0 1-.6 0L5.2 12.65a.5.5 0 0 1-.2-.4v-1.5a.5.5 0 0 1 .2-.4l1.5-1.125a.5.5 0 0 1 .6 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNecktie: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5 3.5h-3l-.561-1.684A1 1 0 0 1 5.887.5h2.226a1 1 0 0 1 .948 1.316zm0 0l1 7.5L7 13.5L4.5 11l1-7.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNecktieRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.346 2.139A1.625 1.625 0 0 1 5.888 0h2.225a1.625 1.625 0 0 1 1.541 2.139l-.508 1.524l1.466 7.085a.63.63 0 0 1-.212.607l-3 2.5a.625.625 0 0 1-.8 0l-3-2.5a.63.63 0 0 1-.212-.607l1.466-7.085zM6.009 4.25l-1.321 6.385L7 12.56l2.312-1.926l-1.32-6.385z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNecktieSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 3.104h3l.561-1.684A1 1 0 0 0 8.113.104H5.887A1 1 0 0 0 4.94 1.42zm3.967 8.255L8.5 4.104h-3l-.967 7.255a.5.5 0 0 0 .142.42l1.971 1.971a.5.5 0 0 0 .708 0l1.971-1.972a.5.5 0 0 0 .142-.42\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNetflix: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.504.791H2.512l5.236 11.53l3.74.888z\"/><path d=\"M2.512.791v12.418l2.618-.887V6.547m6.359 6.662V.79H8.871v6.982\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNetflixRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.775.289A.63.63 0 0 1 2.3 0h3.133c.238 0 .455.136.56.35l2.964 6.03V.5a.5.5 0 0 1 .5-.5h2.366a.5.5 0 0 1 .5.5v12.875a.625.625 0 0 1-.77.608l-3.915-.928a.63.63 0 0 1-.423-.346L5.042 8.021v4.55a.5.5 0 0 1-.317.466l-2.366.929a.5.5 0 0 1-.683-.466V.625c0-.117.033-.234.099-.336m1.505.961l4.942 10.658l2.33.553L5.045 1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNetflixSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 13.212V2.793l3.4 7.488v1.967a.5.5 0 0 1-.314.464l-2.4.964a.5.5 0 0 1-.686-.464m10.75-12.7v10.825l-3.4-7.055V.512a.5.5 0 0 1 .5-.5h2.4a.5.5 0 0 1 .5.5M2.125.265h3.25l6.5 13.489l-4.063-.964z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNetwork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 10.5v3m-5 0h10m-5-3a5 5 0 1 0 0-10a5 5 0 0 0 0 10m-5-5h10\"/><path d=\"M7 10.5c3-3.42 3-6.76 0-10c-2.94 3.12-3 6.44 0 10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNetworkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.722 5.75a5.722 5.722 0 1 0-6.597 5.656v.844h-4.25a.875.875 0 1 0 0 1.75h10.25a.875.875 0 0 0 0-1.75h-4.25v-.844a5.72 5.72 0 0 0 4.847-5.656M8.518 1.542C9.316 2.7 9.785 3.895 9.894 5.125h1.535a4.48 4.48 0 0 0-2.91-3.583M6.996 1.6C7.98 2.797 8.51 3.972 8.638 5.125h-3.26c.112-1.171.637-2.345 1.618-3.526m1.625 4.776h-3.21c.164 1.1.68 2.258 1.598 3.481c.938-1.206 1.46-2.366 1.612-3.481m-6.05-1.25h1.552c.095-1.242.556-2.435 1.344-3.577a4.48 4.48 0 0 0-2.896 3.577M5.574 9.99c-.796-1.203-1.28-2.41-1.424-3.615H2.571A4.48 4.48 0 0 0 5.574 9.99M9.88 6.375c-.134 1.217-.616 2.418-1.415 3.601a4.48 4.48 0 0 0 2.963-3.601z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNetworkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.805 4.487A5.24 5.24 0 0 1 5.597.07c-.899 1.417-1.405 2.89-1.482 4.417zm0 1.25h2.342c.15 1.476.693 2.962 1.61 4.458a5.24 5.24 0 0 1-3.952-4.458m10.39 0a5.24 5.24 0 0 1-3.921 4.45c.926-1.471 1.472-2.956 1.61-4.45zM7.01 9.838c.944-1.407 1.473-2.773 1.618-4.101H5.405c.156 1.308.678 2.673 1.605 4.101M5.367 4.487H8.65C8.549 3.079 8.01 1.662 6.997.23c-1.01 1.41-1.544 2.825-1.63 4.256Zm6.827 0h-2.29C9.81 2.977 9.298 1.503 8.39.067a5.24 5.24 0 0 1 3.803 4.42ZM6.25 11.55v.896H2a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H7.75v-.896a6.6 6.6 0 0 1-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4z\"/><path d=\"M8.5.5v4h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewFileRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 1.25a.375.375 0 0 0-.375.375v10.75a.375.375 0 0 0 .375.375h8.75a.375.375 0 0 0 .375-.375V5H8.5a.5.5 0 0 1-.5-.5V1.25zM13 12.375V4a.63.63 0 0 0-.183-.442L9.442.183A.63.63 0 0 0 9 0H2.625A1.625 1.625 0 0 0 1 1.625v10.75A1.625 1.625 0 0 0 2.625 14h8.75A1.625 1.625 0 0 0 13 12.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewFileSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.875 0H2.5A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5.125H8.5a.625.625 0 0 1-.625-.625zm4.707 3.875L9.125.418v3.457z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewFolder: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 12.25V1.75a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewFolderRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M.625 12V2a1 1 0 0 1 1-1h2.72a1 1 0 0 1 .97.757L5.624 3h6.75a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1.625a1 1 0 0 1-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewFolderSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.127.805A1.5 1.5 0 0 0 5.183.5H1.5A1.5 1.5 0 0 0 0 2v10a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 12V4a1.5 1.5 0 0 0-1.5-1.5H6.89l-.215-.86a1.5 1.5 0 0 0-.548-.835\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewStickyNote: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 13.5H1.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1V9z\"/><path d=\"M9 9.5v4L13.5 9h-4a.5.5 0 0 0-.5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewStickyNoteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625A.375.375 0 0 0 1.625 2v10a.375.375 0 0 0 .375.375h5.875V9A1.125 1.125 0 0 1 9 7.875h3.375V2A.375.375 0 0 0 12 1.625zm11.451 7.307a.62.62 0 0 0 .174-.432V2A1.625 1.625 0 0 0 12 .375H2A1.625 1.625 0 0 0 .375 2v10A1.625 1.625 0 0 0 2 13.625h6.5a.62.62 0 0 0 .442-.183l4.5-4.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewStickyNoteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.375 14H1.5A1.5 1.5 0 0 1 0 12.5v-11A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v6.875H9A.625.625 0 0 0 8.375 9zm1.25-.625l3.75-3.75h-3.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewsPaper: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 4.5V11a1.25 1.25 0 0 1-2.5 0V2.25a.5.5 0 0 0-.5-.5H1a.5.5 0 0 0-.5.5v9a1 1 0 0 0 1 1h10.75\"/><path d=\"M8 4.25H3.5v2.5H8zm-4.5 5.5H8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewsPaperRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.32 1.222a1.1 1.1 0 0 1 .805-.347h9.25c.308 0 .597.128.806.347c.207.217.319.506.319.802v1.232h1.875c.345 0 .625.28.625.625v7.31c0 .503-.19.992-.539 1.357c-.35.366-.83.577-1.336.577h-10.5c-.44 0-.857-.184-1.16-.5A1.7 1.7 0 0 1 0 11.452V2.024c0-.296.112-.585.32-.802m10.05 10.653H1.625a.35.35 0 0 1-.255-.113a.45.45 0 0 1-.12-.31V2.125h9v9.066c0 .235.042.466.121.684M3 4.25a.5.5 0 0 1 .5-.5H8a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5zm.625 4.875a.625.625 0 1 0 0 1.25h4.25a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNewsPaperSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 1.25a1 1 0 0 0-1 1v9a1.5 1.5 0 0 0 1.5 1.5h10.75A1.75 1.75 0 0 0 14 11V4.5a.5.5 0 0 0-.5-.5h-.981v6.459a.625.625 0 1 1-1.25 0V2.25a1 1 0 0 0-1-1zm1.787 2.787a.5.5 0 0 1 .5-.5h4.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5h-4.5a.5.5 0 0 1-.5-.5zM2.662 9.75c0-.345.28-.625.625-.625h4.5a.625.625 0 1 1 0 1.25h-4.5a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNext: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7h10M7 10.5L10.5 7L7 3.5m6.5 0v7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNextRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.354 2.146A.5.5 0 0 0 5.5 2.5v3.875H.625a.625.625 0 0 0 0 1.25H5.5V11.5a.5.5 0 0 0 .854.354l4.5-4.5a.5.5 0 0 0 0-.708zM14 2.875a.875.875 0 0 0-1.75 0v8.25a.875.875 0 1 0 1.75 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNextSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13 2.5a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1M6 8.25H1.25a1.25 1.25 0 1 1 0-2.5H6V3.707a.5.5 0 0 1 .854-.353l3.292 3.292a.5.5 0 0 1 0 .708l-3.292 3.292A.5.5 0 0 1 6 10.293z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNintendoSwitch: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.04.5H3.584a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3H6.04z\"/><path d=\"M2.289 4.479a1.023 1.023 0 1 0 2.046 0a1.023 1.023 0 1 0-2.046 0M7.96 13.5h2.455a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3H7.96z\"/><path d=\"M11.71 8.565a1.023 1.023 0 1 0-2.046 0a1.023 1.023 0 1 0 2.046 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNintendoSwitchRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.125 4A3.625 3.625 0 0 1 3.75.375h2.04c.345 0 .624.28.624.625v12c0 .345-.28.624-.625.624H3.75A3.625 3.625 0 0 1 .125 10zm1.622.48a1.523 1.523 0 1 1 3.046 0a1.523 1.523 0 0 1-3.046 0M8.21.374A.625.625 0 0 0 7.585 1v12c0 .345.28.625.625.625h2.04A3.625 3.625 0 0 0 13.875 10V4A3.625 3.625 0 0 0 10.25.375zm.625 12V1.625h1.415A2.375 2.375 0 0 1 12.625 4v6a2.375 2.375 0 0 1-2.375 2.375zm.372-2.855a1.523 1.523 0 1 0 3.046 0a1.523 1.523 0 0 0-3.046 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNintendoSwitchSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.415 14a3.5 3.5 0 0 0 3.5-3.5v-7a3.5 3.5 0 0 0-3.5-3.5H8.242a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5zm.272-3.912a1.523 1.523 0 1 0 0-3.047a1.523 1.523 0 0 0 0 3.047M3.528 0a3.5 3.5 0 0 0-3.5 3.5v7a3.5 3.5 0 0 0 3.5 3.5h2.173a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zm-.272 3.147a1.523 1.523 0 1 0 0 3.047a1.523 1.523 0 0 0 0-3.047\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNoPoverty: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.8 2.501a1.8 1.8 0 1 0 3.6 0a1.8 1.8 0 1 0-3.6 0m4.5 6.3v-.9a2.7 2.7 0 0 0-5.063-1.307M1.6 2.501a1.8 1.8 0 1 0 3.6 0a1.8 1.8 0 1 0-3.6 0m-.9 6.3v-.9a2.7 2.7 0 0 1 5.063-1.307\"/><path d=\"M5.201 7.899a1.8 1.8 0 1 0 3.6 0a1.8 1.8 0 1 0-3.6 0m4.5 5.4a2.7 2.7 0 0 0-5.4 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNoPovertyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.5 1.375a.875.875 0 1 1 0 1.75a.875.875 0 0 1 0-1.75m2.125.875a2.125 2.125 0 1 0-4.25 0a2.125 2.125 0 0 0 4.25 0M3.5 1.375a.875.875 0 1 0 0 1.75a.875.875 0 0 0 0-1.75m-2.125.875a2.125 2.125 0 1 1 4.25 0a2.125 2.125 0 0 1-4.25 0m8.75 5c0-.788-.292-1.508-.773-2.057A3.5 3.5 0 0 1 14 8.5a.5.5 0 0 1-.5.5H9.59a3.1 3.1 0 0 0 .535-1.75M4.411 9a3.1 3.1 0 0 1-.536-1.75c0-.788.292-1.508.773-2.057A3.5 3.5 0 0 0 0 8.5a.5.5 0 0 0 .5.5zM7 6.375a.875.875 0 1 1 0 1.75a.875.875 0 0 1 0-1.75m2.125.875a2.125 2.125 0 1 0-4.25 0a2.125 2.125 0 0 0 4.25 0M7 10a3.5 3.5 0 0 1 3.5 3.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5A3.5 3.5 0 0 1 7 10\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNoPovertySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.164 4.462a1.715 1.715 0 1 0 0-3.431a1.715 1.715 0 0 0 0 3.43Zm7.672 0a1.715 1.715 0 1 0 0-3.431a1.715 1.715 0 0 0 0 3.43Zm0 .357a3.06 3.06 0 0 0-1.898.656a2.96 2.96 0 0 1 .95 2.917h3.521a.5.5 0 0 0 .5-.5a3.073 3.073 0 0 0-3.073-3.073m-7.672 0a3.06 3.06 0 0 1 1.898.656a2.96 2.96 0 0 0-.95 2.917H.59a.5.5 0 0 1-.5-.5A3.073 3.073 0 0 1 3.164 4.82ZM7 9.435a1.715 1.715 0 1 0 0-3.43a1.715 1.715 0 0 0 0 3.43m-3.073 3.43a3.073 3.073 0 1 1 6.146 0a.5.5 0 0 1-.5.5H4.427a.5.5 0 0 1-.5-.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotEqualSign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.75 4.5h12.5m-12.5 5h12.5m-9.75 4l7-13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotEqualSignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.927.918A.625.625 0 0 0 9.823.333L7.947 3.875H.625a.625.625 0 1 0 0 1.25h6.66L5.3 8.875H.625a.625.625 0 1 0 0 1.25h4.013l-1.565 2.958a.625.625 0 0 0 1.104.585l1.876-3.543h7.322a.625.625 0 1 0 0-1.25h-6.66L8.7 5.125h4.675a.625.625 0 1 0 0-1.25H9.362z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotEqualSignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.705.12a1 1 0 0 1 .406 1.354L10.021 3.5H13a1 1 0 1 1 0 2H8.943l-1.615 3H13a1 1 0 1 1 0 2H6.251L4.65 13.474a1 1 0 1 1-1.761-.948l1.09-2.026H1a1 1 0 1 1 0-2h4.057l1.615-3H1a1 1 0 0 1 0-2h6.749L9.35.526A1 1 0 0 1 10.705.12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationAlarm2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.75 5.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5M9.933 8v1.534c0 .39.155.766.432 1.042c.276.277.744.432 1.135.432H.5c.391 0 .859-.155 1.135-.432a1.47 1.47 0 0 0 .432-1.042V5.933A3.933 3.933 0 0 1 6 2M5 13.5h2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationAlarm2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.971 3.077a2.952 2.952 0 1 1 5.904 0a2.952 2.952 0 0 1-5.904 0m-5.168-.274a4.55 4.55 0 0 1 3.751-1.3a.625.625 0 1 1-.147 1.241A3.297 3.297 0 0 0 2.721 6.02v3.433c0 .294-.062.582-.178.846h6.953a2.1 2.1 0 0 1-.179-.846V7.578a.625.625 0 1 1 1.25 0v1.874a.847.847 0 0 0 .847.846a.625.625 0 0 1 0 1.25H.625a.625.625 0 1 1 0-1.25a.846.846 0 0 0 .846-.846V6.019c0-1.206.48-2.363 1.332-3.216m1.61 10.572c0-.345.28-.625.626-.625H7A.625.625 0 1 1 7 14H5.04a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationAlarm2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.25 2.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0M7.46.697a4.603 4.603 0 0 0-5.937 4.407v3.373a.695.695 0 0 1-.695.695a.75.75 0 0 0 0 1.5h10.599a.75.75 0 1 0 0-1.5a.695.695 0 0 1-.695-.695V6.25A3.75 3.75 0 0 1 7.46.697M4.378 12.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationApplication1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 2.5H2.5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V8M11 5.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationApplication1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.971 3.077a2.952 2.952 0 1 1 5.904 0a2.952 2.952 0 0 1-5.904 0M2.587 1.962A2.587 2.587 0 0 0 0 4.548v6.866A2.586 2.586 0 0 0 2.587 14h6.865a2.587 2.587 0 0 0 2.586-2.587V7.49a.625.625 0 0 0-1.25 0v3.923a1.337 1.337 0 0 1-1.336 1.337H2.587a1.336 1.336 0 0 1-1.337-1.337V4.548a1.337 1.337 0 0 1 1.337-1.336H6.51a.625.625 0 0 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationApplication1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 2.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m-12 0h5.75a3.75 3.75 0 0 0 3.75 3.75V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4.5a2 2 0 0 1 2-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationApplication2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 2.5h-4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-3m-2-8v3\"/><path d=\"M9.5 6.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationApplication2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.274.625a.625.625 0 1 0-1.25 0v3a.625.625 0 1 0 1.25 0zM12.649 7a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75M3.068 1.962A2.587 2.587 0 0 0 .481 4.548v6.866A2.587 2.587 0 0 0 3.068 14h6.865a2.586 2.586 0 0 0 2.587-2.586V8.73a.625.625 0 1 0-1.25 0v2.682c0 .739-.598 1.337-1.337 1.337H3.068a1.337 1.337 0 0 1-1.337-1.336V4.547c0-.738.599-1.336 1.337-1.336h6.865a.625.625 0 0 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationApplication2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.648.024c.483 0 .875.392.875.875v2.5a.875.875 0 0 1-1.75 0v-2.5c0-.483.392-.875.875-.875m-1 5.875a1 1 0 1 1 2 0a1 1 0 0 1-2 0m-1-2.5V2.5H2a2 2 0 0 0-2 2V12a2 2 0 0 0 2 2h7.5a2 2 0 0 0 2-2V7.784a2.068 2.068 0 0 1-2.456-3.19a2 2 0 0 1-.396-1.195\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationMessageAlert: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 2.5V4m0 2.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/><path d=\"M9.5.5a4 4 0 0 0-4 4a4.2 4.2 0 0 0 .32 1.58L5 8l2.14-.27A4 4 0 1 0 9.5.5\"/><path d=\"M5 .5H1.5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-2m-5 .5h1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationMessageAlertRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 1.606c0-.197.16-.356.356-.356h4.168a.625.625 0 1 0 0-1.25H1.606C.719 0 0 .719 0 1.606v10.788C0 13.281.719 14 1.606 14H8.47c.887 0 1.606-.719 1.606-1.606V9.452a.625.625 0 1 0-1.25 0v2.942c0 .197-.16.356-.356.356H1.606a.356.356 0 0 1-.356-.356zm3.298 8.442a.875.875 0 1 0 0 1.75h.98a.875.875 0 0 0 0-1.75zM9.914.125a3.96 3.96 0 0 0-3.962 3.962v.002c.002.463.083.92.237 1.355L5.56 6.92a.5.5 0 0 0 .523.693l1.662-.21A3.961 3.961 0 1 0 9.914.125v.5zm.653 1.998a.625.625 0 1 0-1.25 0v1.471a.625.625 0 0 0 1.25 0zm-.625 2.812a.87.87 0 0 0 0 1.74a.87.87 0 0 0 0-1.74\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNotificationMessageAlertSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.5a.25.25 0 0 0-.25.25v10.489l.01.021a.5.5 0 0 0 .113.126a.8.8 0 0 0 .179.114H8.25a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 8.25 14h-6.5a1.4 1.4 0 0 1-.602-.15c-.17-.08-.342-.19-.498-.322c-.289-.246-.65-.686-.65-1.278V1.75C0 .784.784 0 1.75 0H5a.75.75 0 0 1 0 1.5zM10 0a4 4 0 0 0-4 4a4.2 4.2 0 0 0 .32 1.58l-.683 1.6a.2.2 0 0 0 .21.276L7.64 7.23A4 4 0 1 0 10 0m0 1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 1 1-1 0V2a.5.5 0 0 1 .5-.5m.75 4a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0M4.5 9.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNurseAssistantEmergency: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.031 5.531a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m4.407 1.5a.5.5 0 0 0-.5.5v1.407H7.53a.5.5 0 0 0-.5.5v1.625a.5.5 0 0 0 .5.5h1.407v1.406a.5.5 0 0 0 .5.5h1.624a.5.5 0 0 0 .5-.5v-1.406h1.407a.5.5 0 0 0 .5-.5V9.438a.5.5 0 0 0-.5-.5h-1.406V7.53a.5.5 0 0 0-.5-.5zm-3.91 5.5H.531v-.542a4.51 4.51 0 0 1 5.116-4.422\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNurseAssistantEmergencyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.998 1.248A1.752 1.752 0 1 0 5 4.753a1.752 1.752 0 0 0 0-3.505M1.997 3.001A3.002 3.002 0 1 1 8 3a3.002 3.002 0 0 1-6.004 0m8.269 5.748v.892c0 .345-.28.625-.625.625h-.892v.965h.892c.345 0 .625.28.625.625v.893h.965v-.893c0-.345.28-.625.625-.625h.893v-.965h-.893a.625.625 0 0 1-.625-.625v-.892zm-1.25-.28a.97.97 0 0 1 .97-.97h1.525a.97.97 0 0 1 .97.97v.547h.547a.97.97 0 0 1 .97.97v1.525a.97.97 0 0 1-.97.97h-.547v.547a.97.97 0 0 1-.97.97H9.986a.97.97 0 0 1-.97-.97v-.547h-.547a.97.97 0 0 1-.97-.97V9.986a.97.97 0 0 1 .97-.97h.547zM4.998 7.002c1.166 0 2.226.423 3.066 1.127h-.137c-.926 0-1.677.75-1.677 1.677v1.888c0 .527.243.997.622 1.304H.625A.625.625 0 0 1 0 12.373c0-2.917 2.19-5.371 4.998-5.371\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNurseAssistantEmergencySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 3a3 3 0 1 1-6 0a3 3 0 0 1 6 0m1.406 3.5a.5.5 0 0 0-.5.5v1.906H7a.5.5 0 0 0-.5.5v1.625a.5.5 0 0 0 .5.5h1.906V13.5a.5.5 0 0 0 .5.5h1.625a.5.5 0 0 0 .5-.5v-1.969H13.5a.5.5 0 0 0 .5-.5V9.406a.5.5 0 0 0-.5-.5h-1.969V7a.5.5 0 0 0-.5-.5zM5 7a5 5 0 0 1 2.478.656H7a1.75 1.75 0 0 0-1.75 1.75v1.625c0 .616.318 1.157.798 1.469H.5A.5.5 0 0 1 0 12a5 5 0 0 1 5-5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNurseHat: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 8.5h3M7 7v3m6.5-4.5a21.7 21.7 0 0 0-13 0l2 7h9z\"/><path d=\"m11.39 5l-1.17-2.8a1 1 0 0 0-1-.7H4.74a1 1 0 0 0-1 .7L2.61 5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNurseHatRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.21 1.001H4.75a1.5 1.5 0 0 0-1.48 1.03L2.19 4.703q-.882.198-1.751.47a.625.625 0 0 0-.413.774l1.962 6.578a.625.625 0 0 0 .599.446h8.827c.276 0 .52-.181.599-.446l1.961-6.578a.625.625 0 0 0-.412-.775a22 22 0 0 0-1.754-.47L10.69 2.028a1.5 1.5 0 0 0-1.48-1.026M4.625 8.523c0-.345.28-.625.625-.625h1.125V6.773a.625.625 0 1 1 1.25 0v1.125H8.75a.625.625 0 0 1 0 1.25H7.625v1.125a.625.625 0 1 1-1.25 0V9.148H5.25a.625.625 0 0 1-.625-.625M1.403 6.191l1.65 5.531h7.895l1.65-5.531a20.75 20.75 0 0 0-11.195 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineNurseHatSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.21 1.367H4.75a1.5 1.5 0 0 0-1.48 1.03l-.733 1.815a27.9 27.9 0 0 1 8.911-.003l-.759-1.816a1.5 1.5 0 0 0-1.48-1.026Zm4.283 4.54a.493.493 0 0 1 .344.633l-1.766 5.405a1 1 0 0 1-.95.689H2.879a1 1 0 0 1-.95-.69L.163 6.54a.49.49 0 0 1 .344-.632a26.6 26.6 0 0 1 12.986 0ZM5.5 8.243a.625.625 0 0 0 0 1.25h.875v.875a.625.625 0 0 0 1.25 0v-.875H8.5a.625.625 0 1 0 0-1.25h-.875v-.875a.625.625 0 0 0-1.25 0v.875z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOctopus: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 9.5c0 2-2.5 2.354-3.854 1c-1.084-1.083-.83-2.267 0-3a4 4 0 1 0-5.292 0c.83.733 1.084 1.917 0 3C3 11.854.5 11.5.5 9.5\"/><path d=\"M6.25 10.5c-.167 1-1.25 3-3.25 3c-1 0-1.5-.5-1.5-.5m6.25-2.5c.167 1 1.25 3 3.25 3c1 0 1.5-.5 1.5-.5M5.25 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m3.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOctopusRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.286 1.375a2.91 2.91 0 0 0-2.911 2.91v.05c0 .74.294 1.45.817 1.973l.379.379c.515.515.804 1.213.804 1.942v.121a2.625 2.625 0 0 1-5.25 0a.625.625 0 1 1 1.25 0a1.375 1.375 0 0 0 2.75 0v-.121c0-.397-.158-.778-.438-1.058l-.379-.38a4.04 4.04 0 0 1-1.183-2.855v-.05A4.16 4.16 0 0 1 6.285.125h1.43a4.16 4.16 0 0 1 4.16 4.16v.05a4.04 4.04 0 0 1-1.183 2.857l-.379.379c-.28.28-.438.66-.438 1.058v.121a1.375 1.375 0 1 0 2.75 0a.625.625 0 1 1 1.25 0a2.625 2.625 0 0 1-5.25 0v-.121c0-.729.29-1.427.804-1.942l.38-.379a2.8 2.8 0 0 0 .816-1.972v-.05a2.91 2.91 0 0 0-2.91-2.911zm-.11 8.252c.345.029.6.33.572.675a3.897 3.897 0 0 1-3.883 3.573h-.283a2.33 2.33 0 0 1-1.649-.683a.625.625 0 1 1 .884-.884c.203.203.478.317.765.317h.283a2.647 2.647 0 0 0 2.637-2.427c.029-.344.33-.6.675-.57m2.322.571a.625.625 0 1 0-1.246.104a3.897 3.897 0 0 0 3.883 3.573h.283c.618 0 1.212-.246 1.649-.683a.625.625 0 1 0-.884-.884a1.08 1.08 0 0 1-.765.317h-.283a2.647 2.647 0 0 1-2.637-2.427M4.375 4.75a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m3.5 0a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOctopusSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a4.5 4.5 0 0 0-2.977 7.875c.337.297.528.66.55 1.024c.021.355-.113.788-.572 1.247c-.558.558-1.35.757-1.978.623a1.32 1.32 0 0 1-.734-.407C1.119 10.168 1 9.89 1 9.5a.5.5 0 0 0-1 0v.828c0 .844.299 1.618.796 2.223a.6.6 0 0 1 .28.156l.003.004l.045.036c.046.034.122.086.23.14c.212.106.55.222 1.021.222c1.505 0 2.525-1.24 2.963-2.34a.625.625 0 0 1 1.161.462c-.34.857-1.048 1.956-2.149 2.597h5.3c-1.101-.641-1.808-1.74-2.15-2.597a.625.625 0 1 1 1.162-.462c.438 1.1 1.458 2.34 2.963 2.34c.47 0 .809-.116 1.021-.223a1.5 1.5 0 0 0 .275-.175l.003-.004a.6.6 0 0 1 .28-.156A3.5 3.5 0 0 0 14 10.328V9.5a.5.5 0 1 0-1 0c0 .39-.12.668-.289.862c-.173.199-.425.34-.734.407c-.629.134-1.42-.065-1.978-.623c-.46-.46-.593-.892-.572-1.247c.022-.365.213-.727.55-1.024A4.5 4.5 0 0 0 7 0m-.964 5.25a.786.786 0 1 1-1.572 0a.786.786 0 0 1 1.572 0m2.714.786a.786.786 0 1 0 0-1.572a.786.786 0 0 0 0 1.572\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOfficeBuilding1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.461 4.75V1.594c0-.56-.454-1.015-1.015-1.015h-4.79c-.562 0-1.016.454-1.016 1.015v11.827m-1.121 0h4.968M1.64 3.187H4.1M1.64 5.75h3.847m4.993 4.282a1.75 1.75 0 1 0 0-3.5a1.75 1.75 0 0 0 0 3.5m-3.001 3.389a3.04 3.04 0 0 1 .39-1.46a3.03 3.03 0 0 1 2.611-1.537a3.03 3.03 0 0 1 2.612 1.538c.25.445.385.947.39 1.459\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOfficeBuilding1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.246 1.653c0-.23.182-.403.39-.403h4.791c.209 0 .39.173.39.403v3.659a3.5 3.5 0 0 1 1.25-.793V1.653A1.645 1.645 0 0 0 7.428 0h-4.79C1.723 0 .997.747.997 1.653V12.75H.624a.625.625 0 0 0 0 1.25h4.698a1.75 1.75 0 0 1 .01-1.034q.036-.11.075-.216H2.246V6.453H5.47a.625.625 0 1 0 0-1.25H2.246V3.891h1.835a.625.625 0 1 0 0-1.25H2.246zm5.698 9.728a3.913 3.913 0 0 1 6.032 1.967a.5.5 0 0 1-.476.652H7a.5.5 0 0 1-.476-.652c.253-.79.75-1.478 1.42-1.967m.1-3.613a2.206 2.206 0 1 1 4.413 0a2.206 2.206 0 0 1-4.413 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOfficeBuilding1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.14 1.519c0-.837.678-1.516 1.515-1.516h4.79c.838 0 1.516.679 1.516 1.516v3.488a3.228 3.228 0 0 0-.711 4.828a4.55 4.55 0 0 0-2.1 3.835q0 .17.034.33H1.64l-.048-.002H.766a.75.75 0 0 1 0-1.5h.374V5.622h4.347a.625.625 0 1 0 0-1.25H1.14v-1.35H4.1a.625.625 0 0 0 0-1.25H1.14zm11.54 6.21a1.98 1.98 0 1 1-3.96 0a1.98 1.98 0 0 1 3.96 0m-1.98 2.64a3.3 3.3 0 0 0-3.3 3.3a.33.33 0 0 0 .33.331h5.94a.33.33 0 0 0 .33-.33a3.3 3.3 0 0 0-3.3-3.3Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOfficeWorker: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.03 4.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/><path d=\"M5.716 10.525L5.344 13.5H2.727l-.5-4H.529V8a3.5 3.5 0 0 1 6.942-.634M7.295 9.97c0-.487.395-.882.882-.882h4.412c.487 0 .882.395.882.883v2.647a.88.88 0 0 1-.882.882H8.177a.88.88 0 0 1-.882-.882zm1.881-.882v-.65a1 1 0 0 1 1-1h.412a1 1 0 0 1 1 1v.65\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOfficeWorkerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 1.25A1.375 1.375 0 1 0 4 4a1.375 1.375 0 0 0 0-2.75M1.375 2.625a2.625 2.625 0 1 1 4.323 2.002a4 4 0 0 1 2 2.096q-.194.332-.294.713a2.63 2.63 0 0 0-1.85 2.515v2.647c0 .347.067.68.19.983A.5.5 0 0 1 5.25 14h-2.5a.5.5 0 0 1-.495-.434l-.442-3.316H.5a.5.5 0 0 1-.5-.5v-1.5a4 4 0 0 1 2.303-3.623a2.62 2.62 0 0 1-.928-2.002m8.76 5.167a.36.36 0 0 0-.357.358v.26h1.12v-.26a.36.36 0 0 0-.357-.358zm-1.607.358v.26H8.17c-.824 0-1.492.669-1.492 1.493v2.602c0 .824.668 1.492 1.492 1.492h4.337c.824 0 1.492-.668 1.492-1.492V9.903c0-.824-.668-1.492-1.492-1.492h-.36v-.26c0-.889-.719-1.609-1.607-1.609h-.405c-.888 0-1.608.72-1.608 1.608M8.17 9.66a.24.24 0 0 0-.242.243v2.602c0 .133.108.242.242.242h4.337a.24.24 0 0 0 .242-.242V9.903a.24.24 0 0 0-.242-.242z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOfficeWorkerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 4a2 2 0 1 0 0-4a2 2 0 0 0 0 4m2.045 6v-.03c0-.99.547-1.852 1.355-2.302A3.5 3.5 0 0 0 0 8.5v1a.5.5 0 0 0 .5.5h1l.445 3.562a.5.5 0 0 0 .496.438H4.56a.5.5 0 0 0 .496-.438L5.5 10zm4.382-2.313a.25.25 0 0 0-.25.25v.651h1.413v-.65a.25.25 0 0 0-.25-.25zm-1.75.25v.651c-.763 0-1.382.62-1.382 1.383v2.647c0 .763.619 1.382 1.382 1.382h4.412c.763 0 1.382-.619 1.382-1.382V9.97c0-.763-.618-1.382-1.381-1.382v-.65a1.75 1.75 0 0 0-1.75-1.75h-.913a1.75 1.75 0 0 0-1.75 1.75Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOkHand: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.956 13.309a3.8 3.8 0 0 0 1.31-.696c.538-.44.928-.999 1.158-1.61a1.27 1.27 0 0 0-1.31-1.712c.184-.042.36-.126.516-.253c.544-.443.586-1.452.143-1.996a3.8 3.8 0 0 0-3.17-1.398l1.32-3.027A1.415 1.415 0 0 0 8.172.745v0a1.35 1.35 0 0 0-1.648.479c-.991 1.482-2.814 4.488-2.927 6.7c-.157 3.05 0 5.385 0 5.385\"/><path d=\"M7.16 8.64a1.27 1.27 0 1 0 1.992 1.435a1.27 1.27 0 0 1 .904-.79a1.27 1.27 0 0 1-1.108-.463a1.27 1.27 0 0 0-1.787-.182\" clip-rule=\"evenodd\"/><path d=\"M7.612 5.646c-.256.03-.864.143-1.25.353m-2.822 3c-.895-2.001-.855-5.288-.76-6.99A1.35 1.35 0 0 1 3.955.76a1.415 1.415 0 0 1 1.6 1.228v.799\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOkHandRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.93 1.322a.72.72 0 0 0-.888.25l-.003.005c-.26.387-.574.878-.899 1.429a.6.6 0 0 1-.104.18c-.253.436-.508.905-.744 1.389C4.707 5.769 4.27 6.98 4.22 7.957v.01a52 52 0 0 0-.005 5.232l.003.052l.001.013v.003a.625.625 0 0 1-1.247.084l.624-.042l-.624.042v-.006l-.001-.015l-.004-.058l-.011-.217a55 55 0 0 1-.033-3.91c-.46-1.084-.669-2.445-.758-3.71a28 28 0 0 1-.01-3.46C2.21 1.013 2.948.269 3.869.14a2.04 2.04 0 0 1 2.007.93l.128-.194l.005-.006C6.544.074 7.555-.188 8.41.169a2.04 2.04 0 0 1 1.085 2.698l-.005.013l-.956 2.191a4.42 4.42 0 0 1 2.722 1.576c.341.419.469.972.438 1.469c-.02.317-.106.656-.283.954c.63.498.895 1.363.597 2.154a4.4 4.4 0 0 1-1.35 1.873a4.4 4.4 0 0 1-1.524.81a.625.625 0 0 1-.36-1.197c.388-.116.76-.309 1.095-.582c.452-.367.777-.835.97-1.344a.645.645 0 0 0-.666-.87l-.053.002a.64.64 0 0 0-.385.38a1.895 1.895 0 1 1-.304-1.868a.64.64 0 0 0 .564.235l.053-.003a.6.6 0 0 0 .186-.107c.1-.08.197-.258.213-.513s-.058-.478-.16-.603A3.18 3.18 0 0 0 7.7 6.265l-.015.002a4 4 0 0 0-.497.094a2.4 2.4 0 0 0-.53.187a.625.625 0 1 1-.595-1.099c.338-.182.772-.298 1.102-.363L8.35 2.367l.004-.01a.79.79 0 0 0-.424-1.035m-3 1.278v-.57a.79.79 0 0 0-.888-.652a.72.72 0 0 0-.638.666c-.047.837-.08 2.055.008 3.304l.031.387c.205-.583.458-1.163.726-1.71c.243-.497.504-.978.761-1.425m2.533 7.433a.645.645 0 0 1 1-.816q.129.159.283.28q-.107.166-.18.358a.645.645 0 0 1-1.104.178\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOkHandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m4.938 2.04l-.116.359c-.35.57-.724 1.215-1.07 1.887c-.464.899-.923 1.928-1.186 2.937c-.524-1.967-.483-4.525-.404-5.959A1.35 1.35 0 0 1 3.338.014a1.415 1.415 0 0 1 1.6 1.228zm5.177 7.942c.183-.042.36-.126.515-.253c.544-.443.586-1.452.143-1.996A3.8 3.8 0 0 0 7.67 6.33a4 4 0 0 0-.427.068a2.8 2.8 0 0 0-.68.222a.625.625 0 1 1-.596-1.1c.265-.143.638-.264 1.015-.345c.381-.08.82-.131 1.228-.102l.977-2.03a1.415 1.415 0 0 0-.752-1.872a1.35 1.35 0 0 0-1.649.479c-.99 1.482-3.078 4.752-3.191 6.965a53 53 0 0 0-.025 4.918a.49.49 0 0 0 .492.466H8.81a.9.9 0 0 0 .286-.045a3.8 3.8 0 0 0 1.17-.651a3.8 3.8 0 0 0 1.16-1.61a1.27 1.27 0 0 0-1.31-1.712m-3.137 1.137a1.27 1.27 0 0 1 1.97-1.605c.279.342.7.501 1.108.462a1.27 1.27 0 0 0-.904.79a1.27 1.27 0 0 1-2.173.352\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerDragHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.478 11.832l-.46-2.757a2.573 2.573 0 0 0-2.961-2.114l-2.171.362l-.683-4.09a1.194 1.194 0 0 0-1.374-.98v0c-.65.108-1.09.723-.98 1.374l.894 5.36l-.363.133a1.715 1.715 0 0 0-.643 2.803l.184.19l.954.988M1.75.5L.5 1.75L1.75 3M.5 1.75h3M10.25.5l1.25 1.25L10.25 3m1.25-1.25h-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerDragHorizontalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.191.038A.5.5 0 0 1 2.5.5v.875H4a.625.625 0 0 1 0 1.25H2.5V3.5a.5.5 0 0 1-.854.354l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5a.5.5 0 0 1 .545-.108m10.163.108A.5.5 0 0 0 11.5.5v.875H10a.625.625 0 0 0 0 1.25h1.5V3.5a.5.5 0 0 0 .854.354l1.5-1.5a.5.5 0 0 0 0-.708zM3.35 10.53a.505.505 0 0 1 .757-.664l1.201 1.201a.625.625 0 0 0 1.067-.442v-6.25a.625.625 0 0 1 1.25 0v3.847a.625.625 0 0 0 .637.625l2.367-.044a1.948 1.948 0 0 1 1.975 2.132l-.226 2.38a.625.625 0 0 0 1.244.12l.227-2.38a3.198 3.198 0 0 0-3.243-3.502l-1.731.032v-3.21a1.875 1.875 0 0 0-3.75 0v4.741l-.134-.134a1.755 1.755 0 0 0-2.632 2.31l1.896 2.464a.625.625 0 1 0 .99-.762z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerDragHorizontalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5.5a.5.5 0 0 0-.854-.354l-1.5 1.5a.5.5 0 0 0 0 .708l1.5 1.5A.5.5 0 0 0 2.5 3.5v-1h1a.5.5 0 0 0 0-1h-1zm2.407 3.299l.947 5.86l-.52.188a1.715 1.715 0 0 0-.658 2.799l1 1.045a1 1 0 0 0 .722.309h6.482a1 1 0 0 0 .994-1.113l-.367-3.236a2.573 2.573 0 0 0-2.951-2.13l-2.432.394l-.73-4.519a1.26 1.26 0 0 0-2.487.403m5.402-3.76a.5.5 0 0 1 .545.107l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5A.5.5 0 0 1 10 3.5v-1H9a.5.5 0 1 1 0-1h1v-1a.5.5 0 0 1 .309-.462Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerDragVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5v-2.927A2.573 2.573 0 0 0 10.927 8H8.5V3.75c0-.69-.56-1.25-1.25-1.25v0C6.56 2.5 6 3.06 6 3.75V9l-.707.202a1.715 1.715 0 0 0-.944 2.62L5.5 13.5M.5 2L2 .5L3.5 2m-3 3.5L2 7l1.5-1.5M2 .5V7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerDragVerticalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.354.146a.5.5 0 0 0-.708 0l-1.5 1.5A.5.5 0 0 0 .5 2.5h.875V5H.5a.5.5 0 0 0-.354.854l1.5 1.5a.5.5 0 0 0 .708 0l1.5-1.5A.5.5 0 0 0 3.5 5h-.875V2.5H3.5a.5.5 0 0 0 .354-.854zM3.475 10.53a.504.504 0 0 1 .757-.664l1.201 1.2a.625.625 0 0 0 1.067-.441v-7.25a.625.625 0 0 1 1.25 0v4.847a.625.625 0 0 0 .637.625l2.367-.044a1.948 1.948 0 0 1 1.975 2.132l-.226 2.38a.625.625 0 0 0 1.244.12l.227-2.381a3.198 3.198 0 0 0-3.243-3.5L9 7.584v-4.21a1.875 1.875 0 1 0-3.75 0v5.741l-.134-.134a1.755 1.755 0 0 0-2.632 2.31l1.896 2.464a.625.625 0 0 0 .99-.762z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerDragVerticalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.354.146a.5.5 0 0 0-.708 0l-1.5 1.5A.5.5 0 0 0 .5 2.5h.75v2H.5a.5.5 0 0 0-.354.854l1.5 1.5a.5.5 0 0 0 .708 0l1.5-1.5A.5.5 0 0 0 3.5 4.5h-.75v-2h.75a.5.5 0 0 0 .354-.854zm3.59 9.55V3.759a1.26 1.26 0 0 1 2.52 0v4.577h2.463A2.573 2.573 0 0 1 13.5 10.91V13a1 1 0 0 1-1 1H5.893a1 1 0 0 1-.824-.433l-.764-1.11A1.715 1.715 0 0 1 5.4 9.797z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerHold: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.224 3.204a2.638 2.638 0 1 0 5.276 0a2.638 2.638 0 1 0-5.276 0m3.201-.558l-.564.557m-.625 10.231v-2.586a2.573 2.573 0 0 0-2.573-2.573H5.648V4.29c0-.633-.513-1.147-1.147-1.147v0c-.633 0-1.147.514-1.147 1.147v5.224l-.264.05a1.715 1.715 0 0 0-1.096 2.658l.086.124l.748 1.088M1.167 5.258a3.446 3.446 0 0 1 4.96-3.834\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerHoldRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 1.5a2.75 2.75 0 0 0-2.686 3.343a.75.75 0 1 1-1.466.321A4.25 4.25 0 0 1 6.571.41a.75.75 0 1 1-.643 1.355A2.7 2.7 0 0 0 4.75 1.5M7.5 3.25a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0m4.692-.558a.625.625 0 1 0-.884-.884l-1 1a.625.625 0 0 0 .884.884zm-10.828 7.95a.494.494 0 0 1 .735-.659l1.209 1.209a.625.625 0 0 0 1.067-.442V4.875a.625.625 0 1 1 1.25 0v3.472a.625.625 0 0 0 .636.625l2.361-.044a1.948 1.948 0 0 1 1.975 2.137l-.22 2.25a.625.625 0 0 0 1.245.12l.22-2.248a3.198 3.198 0 0 0-3.243-3.508l-1.724.031V4.875a1.875 1.875 0 1 0-3.75 0v4.366L2.983 9.1a1.744 1.744 0 0 0-2.595 2.323l1.874 2.342a.625.625 0 1 0 .976-.78z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerHoldSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 4.196a2.696 2.696 0 0 1 3.95-2.387a.75.75 0 1 0 .7-1.327A4.196 4.196 0 0 0 .11 5.15a.75.75 0 1 0 1.46-.34a2.7 2.7 0 0 1-.07-.614M10.5 7a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7m1.442-4.058a.625.625 0 1 0-.884-.884l-1 1a.625.625 0 1 0 .884.884zM3.133 4.259v5.437l-.543.102a1.715 1.715 0 0 0-1.096 2.659l.764 1.11A1 1 0 0 0 3.08 14h6.61a1 1 0 0 0 1-1v-2.09a2.573 2.573 0 0 0-2.573-2.574H5.652V4.259a1.26 1.26 0 1 0-2.519 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerTap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.102 13.5v-2.833a2.573 2.573 0 0 0-2.574-2.573H7.294V3.918c0-.664-.539-1.202-1.202-1.202v0c-.664 0-1.203.538-1.203 1.202v5.474l-.4.075a1.715 1.715 0 0 0-1.096 2.659l.161.234l.784 1.14\"/><path d=\"M2.597 4.932a3.611 3.611 0 1 1 7.034 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerTapRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.25 4.25a2.75 2.75 0 1 1 5.386.786a.75.75 0 1 0 1.438.428A4.252 4.252 0 0 0 6 0a4.25 4.25 0 0 0-4.074 5.464a.75.75 0 0 0 1.438-.428a2.8 2.8 0 0 1-.114-.786m-.886 6.392a.494.494 0 0 1 .735-.659l1.209 1.209a.625.625 0 0 0 1.067-.442V4.875a.625.625 0 1 1 1.25 0v3.472a.625.625 0 0 0 .636.625l2.361-.044a1.948 1.948 0 0 1 1.975 2.137l-.22 2.25a.625.625 0 0 0 1.245.12l.22-2.248a3.198 3.198 0 0 0-3.243-3.508l-1.724.031V4.875a1.875 1.875 0 1 0-3.75 0v4.366L3.983 9.1a1.744 1.744 0 0 0-2.595 2.323l1.874 2.342a.625.625 0 1 0 .976-.78z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneFingerTapSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.254 4.361a2.861 2.861 0 1 1 5.647.651a.75.75 0 0 0 1.461.34a4.361 4.361 0 1 0-8.495 0a.75.75 0 0 0 1.461-.34a3 3 0 0 1-.074-.651m1.63 5.335V4.259a1.26 1.26 0 0 1 2.518 0v4.077h2.464a2.573 2.573 0 0 1 2.573 2.573V13a1 1 0 0 1-1 1H4.83a1 1 0 0 1-.823-.433l-.764-1.11a1.715 1.715 0 0 1 1.097-2.66l.543-.102Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneVesusOne: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m10.852 12.095l.103.307a1.306 1.306 0 0 0 2.537-.557l-.202-1.817a2.4 2.4 0 0 0-2.386-2.136H7.991c-1.223 0-2.25.92-2.386 2.136l-.202 1.816a1.306 1.306 0 0 0 2.538.558l.102-.307c.12-.359.455-.6.833-.6h1.143c.378 0 .714.241.833.6M5.094 5.298a2.297 2.297 0 1 0 0-4.593a2.297 2.297 0 0 0 0 4.593m-2.757 7.461H.5V11.38a4.134 4.134 0 0 1 4.594-4.11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneVesusOneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.086 3.077a1.827 1.827 0 1 1 3.654 0a1.827 1.827 0 0 1-3.654 0M4.913 0a3.077 3.077 0 1 0 0 6.154a3.077 3.077 0 0 0 0-6.154m0 6.99A4.913 4.913 0 0 0 0 11.904v.49a.5.5 0 0 0 .5.5h4.238a2.8 2.8 0 0 1-.052-.937l.17-1.539a3.75 3.75 0 0 1 2.12-2.975a4.9 4.9 0 0 0-2.063-.453m3.67 1.308a2.534 2.534 0 0 0-2.517 2.254l-.171 1.539a1.607 1.607 0 0 0 3.12.685l.087-.26a.24.24 0 0 1 .231-.167h.969a.24.24 0 0 1 .23.167l.088.26a1.606 1.606 0 0 0 3.12-.685l-.17-1.538a2.534 2.534 0 0 0-2.519-2.255z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOneVesusOneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 6a3 3 0 1 0 0-6a3 3 0 0 0 0 6m5.852 6.095l.103.307a1.306 1.306 0 0 0 2.537-.557l-.202-1.817a2.4 2.4 0 0 0-2.386-2.136H7.991c-1.223 0-2.25.92-2.386 2.136l-.202 1.816a1.306 1.306 0 0 0 2.538.558l.102-.307c.12-.359.455-.6.833-.6h1.143c.378 0 .714.241.833.6M4.362 9.89A3.65 3.65 0 0 1 6.16 7.135A5 5 0 0 0 0 12a.5.5 0 0 0 .5.5h3.696a2.6 2.6 0 0 1-.035-.793z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalCallService: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.744.637a.466.466 0 0 0-.466.466v1.31h-1.31a.466.466 0 0 0-.466.466v1.514c0 .258.209.466.466.466h1.31v1.31c0 .258.209.466.466.466h1.514a.466.466 0 0 0 .466-.466V4.86h1.31a.466.466 0 0 0 .466-.466V2.88a.466.466 0 0 0-.466-.466h-1.31v-1.31a.466.466 0 0 0-.466-.466zM7.456 12.934a2.694 2.694 0 0 0 3.362-.36l.38-.379a.91.91 0 0 0 0-1.277L9.6 9.331a.9.9 0 0 0-1.267 0v0a.91.91 0 0 1-1.278 0L4.512 6.787a.91.91 0 0 1 0-1.277v0a.9.9 0 0 0 0-1.267L2.975 2.646a.91.91 0 0 0-1.277 0l-.38.38A2.694 2.694 0 0 0 .91 6.387a24.2 24.2 0 0 0 6.546 6.546\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalCallServiceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.879.593c0-.272.22-.493.492-.493h1.602c.272 0 .493.22.493.493V2.47h1.94c.272 0 .492.221.492.493v1.602c0 .272-.22.492-.492.492h-1.94v1.94a.493.493 0 0 1-.493.493H9.37A.493.493 0 0 1 8.88 7V5.06H7a.493.493 0 0 1-.493-.493V2.964c0-.272.22-.493.493-.493h1.879zm-.185 13.292a2.66 2.66 0 0 1-1.723-.409A23.9 23.9 0 0 1 .506 7.011a2.66 2.66 0 0 1 .404-3.32l.375-.375a.897.897 0 0 1 1.261 0l1.518 1.577a.887.887 0 0 1 0 1.251a.897.897 0 0 0 0 1.262l2.513 2.513a.897.897 0 0 0 1.261 0a.887.887 0 0 1 1.252 0l1.577 1.567a.897.897 0 0 1 0 1.261l-.375.374a2.66 2.66 0 0 1-1.598.764\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalServiceMonitor: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 1.25H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5m-7 9l-1 2.5m3-2.5l1 2.5m-5 0h6\"/><path d=\"M6.302 2.986a.43.43 0 0 0-.43.43v1.207H4.666a.43.43 0 0 0-.43.43v1.395c0 .237.193.43.43.43h1.208v1.207c0 .237.192.43.43.43h1.395a.43.43 0 0 0 .43-.43V6.877h1.207a.43.43 0 0 0 .43-.43V5.053a.43.43 0 0 0-.43-.43H8.127V3.416a.43.43 0 0 0-.43-.43z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalServiceMonitorRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 9.875v-8.25h10.75v8.25zM1.5.375c-.292 0-.584.1-.804.32c-.22.221-.321.513-.321.805V10c0 .292.1.584.32.804c.221.22.513.321.805.321h3.711l-.5 1.25H4a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25h-.711l-.5-1.25H12.5c.292 0 .584-.1.804-.32c.22-.221.321-.513.321-.805V1.5c0-.292-.1-.584-.32-.804A1.13 1.13 0 0 0 12.5.375zm4.332 2.864c0-.201.163-.364.364-.364h1.608c.201 0 .364.163.364.364v1.343h1.343c.201 0 .364.163.364.364v1.608a.364.364 0 0 1-.364.364H8.168v1.343a.364.364 0 0 1-.364.364H6.196a.364.364 0 0 1-.364-.364V6.918H4.489a.364.364 0 0 1-.364-.364V4.946c0-.201.163-.364.364-.364h1.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalServiceMonitorSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.457.252C.652.252 0 .904 0 1.709v7.586c0 .805.652 1.457 1.457 1.457h4.027l-.536 1.496H4a.75.75 0 0 0 0 1.5h6a.75.75 0 1 0 0-1.5h-.947l-.536-1.496h4.026c.805 0 1.457-.652 1.457-1.457V1.71c0-.805-.652-1.457-1.457-1.457zm4.53 2.66c0-.217.176-.392.393-.392h1.275c.217 0 .392.175.392.392v1.56h1.56c.217 0 .393.176.393.392V6.14a.39.39 0 0 1-.392.393h-1.56v1.56a.39.39 0 0 1-.393.392H6.38a.39.39 0 0 1-.392-.392v-1.56h-1.56a.39.39 0 0 1-.393-.393V4.864c0-.216.176-.392.392-.392h1.56z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalWebService: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 3.494h13M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M6.303 5.735a.43.43 0 0 0-.43.43v1.207H4.666a.43.43 0 0 0-.43.43v1.395c0 .237.193.43.43.43h1.207v1.207c0 .237.193.43.43.43h1.395a.43.43 0 0 0 .43-.43V9.627h1.207a.43.43 0 0 0 .43-.43V7.802a.43.43 0 0 0-.43-.43H8.128V6.165a.43.43 0 0 0-.43-.43z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalWebServiceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 12.077V3.518h10.75v8.559a.3.3 0 0 1-.298.298H1.923a.3.3 0 0 1-.298-.298M.375 1.923c0-.855.693-1.548 1.548-1.548h10.154c.855 0 1.548.693 1.548 1.548v10.154c0 .855-.693 1.548-1.548 1.548H1.923a1.55 1.55 0 0 1-1.548-1.548zm5.457 3.69c0-.2.163-.363.364-.363h1.608c.201 0 .364.163.364.364v1.343h1.343c.201 0 .364.163.364.364v1.608a.364.364 0 0 1-.364.364H8.168v1.343a.364.364 0 0 1-.364.364H6.196a.364.364 0 0 1-.364-.364V9.293H4.489a.364.364 0 0 1-.364-.364V7.321c0-.201.163-.364.364-.364h1.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOnlineMedicalWebServiceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.547 12.25V3.314h10.907v8.934a.204.204 0 0 1-.204.205H1.751a.204.204 0 0 1-.204-.205Zm-1.5-10.5C.047.81.81.046 1.75.046h10.5c.94 0 1.704.763 1.704 1.704v10.5c0 .94-.764 1.704-1.705 1.704H1.751a1.705 1.705 0 0 1-1.704-1.705z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M6.364 5.04a.39.39 0 0 0-.393.392v1.56h-1.56a.39.39 0 0 0-.392.392V8.66c0 .217.175.393.392.393h1.56v1.56c0 .217.176.392.392.392h1.275a.39.39 0 0 0 .393-.392v-1.56h1.56a.39.39 0 0 0 .392-.393V7.384a.39.39 0 0 0-.392-.392h-1.56v-1.56a.39.39 0 0 0-.392-.393z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOpenBook: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5a9.26 9.26 0 0 0-5.61-2.95a1 1 0 0 1-.89-1V1.5A1 1 0 0 1 1.64.51A9.3 9.3 0 0 1 7 3.43zm0 0a9.26 9.26 0 0 1 5.61-2.95a1 1 0 0 0 .89-1V1.5a1 1 0 0 0-1.14-.99A9.3 9.3 0 0 0 7 3.43z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOpenBookRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.917 1.684a.22.22 0 0 0-.19.065a.35.35 0 0 0-.102.251v7c0 .189.166.407.454.444a8.06 8.06 0 0 1 4.296 1.962v-7.2a7 7 0 0 0-1.02-1.026a6.8 6.8 0 0 0-3.438-1.496m5.708 2.522v7.2q.11-.098.23-.195a8.06 8.06 0 0 1 4.066-1.767c.288-.037.454-.255.454-.444V2a.35.35 0 0 0-.102-.251a.22.22 0 0 0-.19-.065A6.8 6.8 0 0 0 8.645 3.18a7 7 0 0 0-1.02 1.026m-.11 9.149l.005-.008l.01-.014q.014-.021.048-.065a5 5 0 0 1 .208-.257c.188-.219.475-.518.86-.831a6.8 6.8 0 0 1 3.437-1.496c.807-.105 1.542-.768 1.542-1.684V2c0-.872-.728-1.683-1.704-1.556a8.06 8.06 0 0 0-4.065 1.767c-.354.288-.64.568-.856.803a8 8 0 0 0-.856-.803A8.06 8.06 0 0 0 2.08.444C1.103.317.375 1.128.375 2v7c0 .916.735 1.579 1.542 1.684a6.8 6.8 0 0 1 3.438 1.496c.384.313.67.612.86.831a5 5 0 0 1 .255.322l.01.013l.006.009a.62.62 0 0 0 .695.243l.01-.003a.63.63 0 0 0 .323-.24\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOpenBookSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 1.653C5.386 1.099 3.536.42 1.496.179C.674.082 0 .76 0 1.588v8c0 .829.677 1.489 1.492 1.637c1.84.334 3.371 1.216 4.348 1.914q.248.175.535.266zm1.25 11.752q.287-.09.534-.265c.977-.698 2.508-1.581 4.349-1.915c.815-.148 1.492-.808 1.492-1.637v-8C14 .76 13.326.082 12.504.18c-2.04.242-3.89.92-4.879 1.474v11.752Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOpenUmbrella: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 7a5 5 0 1 1 10 0zm5-5V.5M10 12a1.5 1.5 0 0 1-3 0V7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOpenUmbrellaRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.625.625a.625.625 0 1 0-1.25 0v.532a6.126 6.126 0 0 0-5.5 6.093v.5c0 .345.28.625.625.625h4.75v3.375a2.25 2.25 0 0 0 4.5 0a.75.75 0 0 0-1.5 0a.75.75 0 0 1-1.5 0V8.375h4.75c.345 0 .625-.28.625-.625v-.5c0-3.172-2.41-5.78-5.5-6.093zM7 2.375a4.875 4.875 0 0 0-4.873 4.75h9.746A4.875 4.875 0 0 0 7 2.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOpenUmbrellaSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a.75.75 0 0 1 .75.75v.801A5.5 5.5 0 0 1 12.5 7a.5.5 0 0 1-.5.5H7.75v4.25a.75.75 0 0 0 1.5 0a.75.75 0 0 1 1.5 0a2.25 2.25 0 0 1-4.5 0V7.5H2a.5.5 0 0 1-.5-.5a5.5 5.5 0 0 1 4.75-5.449V.75A.75.75 0 0 1 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOrientationLandscape: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 12h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1\"/><path d=\"M9.502 6.212a1.245 1.245 0 1 0 0-2.49a1.245 1.245 0 0 0 0 2.49M9.083 12a7.1 7.1 0 0 0-7.136-5.786A7.6 7.6 0 0 0 .5 6.349\"/><path d=\"M13.5 8.94a7.72 7.72 0 0 0-5.506.225\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOrientationLandscapeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.75 11.5a.375.375 0 0 1-.375.375h-.577L4.836 4.914a.5.5 0 0 0-.707 0L1.25 7.793V2.5c0-.207.168-.375.375-.375h10.75c.207 0 .375.168.375.375zm-.375 1.625c.898 0 1.625-.727 1.625-1.625v-9c0-.897-.727-1.625-1.625-1.625H1.625C.728.875 0 1.603 0 2.5v9c0 .898.728 1.625 1.625 1.625zM11.5 5A1.75 1.75 0 1 0 8 5a1.75 1.75 0 0 0 3.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOrientationLandscapeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 11V3a1.5 1.5 0 0 1 1.5-1.5h11A1.5 1.5 0 0 1 14 3zm-3.031-6.033a1.467 1.467 0 1 1-2.934 0a1.467 1.467 0 0 1 2.934 0M1.958 6.714A6.6 6.6 0 0 1 8.452 11.5H1.5A.5.5 0 0 1 1 11V6.775q.47-.063.945-.061zM9.486 11.5H12.5a.5.5 0 0 0 .5-.5V9.309a7.2 7.2 0 0 0-4.35.138a7.6 7.6 0 0 1 .836 2.053\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOrientationPortrait: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 12.5v-11a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1\"/><path d=\"M8.547 5.488a1.228 1.228 0 1 0 0-2.457a1.228 1.228 0 0 0 0 2.457M2 7.807q.522-.088 1.053-.087c1.224-.025 2.419.338 3.37 1.025c1.542 1.111 2.124 3.038 2.124 4.755\"/><path d=\"M12 9.37a7.3 7.3 0 0 0-2.102-.306a7.4 7.4 0 0 0-2.632.479\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOrientationPortraitRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.5 1.25c.207 0 .375.168.375.375v10.75l-.002.04L4.71 5.256a.5.5 0 0 0-.707 0L2.125 7.132V1.625c0-.207.168-.375.375-.375zm1.625.375C13.125.728 12.398 0 11.5 0h-9C1.603 0 .875.728.875 1.625v10.75C.875 13.273 1.603 14 2.5 14h9c.898 0 1.625-.727 1.625-1.625zM10.5 4.25a1.75 1.75 0 1 0-3.5 0a1.75 1.75 0 0 0 3.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOrientationPortraitSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 0a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 11 14H3a1.5 1.5 0 0 1-1.5-1.5v-11A1.5 1.5 0 0 1 3 0zm-.681 4.531a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M3.063 8.22c1.121-.023 2.208.31 3.068.93c1.223.882 1.795 2.375 1.898 3.85H3a.5.5 0 0 1-.5-.5V8.245q.274-.026.552-.025zm6.834 1.344a7 7 0 0 0-1.826.242c.605.977.894 2.116.96 3.194H11a.5.5 0 0 0 .5-.5V9.753a6.8 6.8 0 0 0-1.602-.189z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOutgoingCall: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.53 12.823a2.7 2.7 0 0 1-3.37-.36l-.38-.38a.91.91 0 0 1 0-1.28l1.6-1.59a.9.9 0 0 1 1.27 0v0a.91.91 0 0 0 1.28 0l2.55-2.55a.91.91 0 0 0 0-1.28v0a.9.9 0 0 1 0-1.27l1.54-1.6a.91.91 0 0 1 1.28 0l.38.38a2.7 2.7 0 0 1 .41 3.37a24.2 24.2 0 0 1-6.56 6.56M4 .5H.5V4M.5.5l5 5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOutgoingCallRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.058 0A.625.625 0 0 1 4.5 1.067L3.314 2.253l2.745 2.745A.75.75 0 0 1 5 6.06L2.253 3.314L1.067 4.5A.625.625 0 0 1 0 4.058V.625C0 .28.28 0 .625 0zm6.445 2.397a1.526 1.526 0 0 1 2.134 0l.003.003l.369.37a3.3 3.3 0 0 1 .482 4.099a24.4 24.4 0 0 1-6.603 6.603l-.011.007a3.3 3.3 0 0 1-4.085-.437l-.373-.373l-.003-.002a1.526 1.526 0 0 1 0-2.134l.004-.004l1.569-1.56l.315-.239l-.315.24q.145-.143.315-.24l4.309-3.274a1.52 1.52 0 0 1 .372-1.482l1.507-1.566zm.645 1.132L8.613 5.456zm.417-.317l1.072-.815za.27.27 0 0 1 .192.073l.371.371l.007.007a2.05 2.05 0 0 1 .313 2.517a23.1 23.1 0 0 1-6.253 6.251a2.05 2.05 0 0 1-2.52-.273l-.37-.37a.277.277 0 0 1-.001-.375L4.87 9.856a.267.267 0 0 1 .364 0l.001.001c.587.58 1.548.58 2.135 0l.002-.002l2.5-2.501l.003-.003c.58-.586.58-1.548 0-2.134l-.001-.002a.267.267 0 0 1 0-.363l.007-.008l1.266-1.315zm0 0l-.417.317l.238-.247a.27.27 0 0 1 .179-.07M8.613 5.456L4.304 8.73a1.52 1.52 0 0 1 1.812.24c.1.097.275.097.375 0l2.497-2.5a.277.277 0 0 0 0-.375l.444-.44l-.443.441a1.5 1.5 0 0 1-.376-.641\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineOutgoingCallSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 .754A.75.75 0 0 0 4.309.29H1.042a.75.75 0 0 0-.75.75v3.266a.75.75 0 0 0 1.28.53l1.103-1.103l2.502 2.503a.75.75 0 0 0 1.06-1.061l-2.5-2.501L4.838 1.57a.75.75 0 0 0 .163-.817Zm1.737 12.525a2.7 2.7 0 0 1-3.37-.36l-.38-.38a.91.91 0 0 1 0-1.28l1.6-1.59a.9.9 0 0 1 1.27 0a.91.91 0 0 0 1.28 0l2.55-2.55a.91.91 0 0 0 0-1.28a.9.9 0 0 1 0-1.27l1.54-1.6a.91.91 0 0 1 1.28 0l.38.38a2.7 2.7 0 0 1 .41 3.37a24.2 24.2 0 0 1-6.56 6.56\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePacman: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.215 3.786L7 7l5.215 3.214a6.125 6.125 0 1 1 0-6.428\"/><path d=\"M5.5 4a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePacmanRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.472 1.25C4.308 1.25 1.74 3.823 1.74 7s2.568 5.75 5.732 5.75a5.72 5.72 0 0 0 4.524-2.22L7.143 7.533a.625.625 0 0 1 0-1.064l4.853-2.999a5.72 5.72 0 0 0-4.524-2.22M.49 7c0-3.864 3.124-7 6.982-7a6.97 6.97 0 0 1 5.945 3.327c.18.294.09.678-.204.86L8.661 7l4.552 2.813a.625.625 0 0 1 .204.86A6.97 6.97 0 0 1 7.472 14C3.614 14 .49 10.864.49 7m6.022-4.183a1.24 1.24 0 0 1-.003 2.481m-.002 0a1.24 1.24 0 0 1 .002-2.48\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePacmanSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 7a6.625 6.625 0 0 1 12.266-3.477a.5.5 0 0 1-.164.689L7.953 7l4.524 2.788a.5.5 0 0 1 .163.689A6.625 6.625 0 0 1 .375 7M6 5a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePadlockSquare1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 5.5H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1m-.5 0V4a3.5 3.5 0 1 0-7 0v1.5\"/><path d=\"M7 10a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePadlockSquare1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a4.375 4.375 0 0 0-4.375 4.375V5h-.001C1.727 5 .999 5.728.999 6.625v5.752c0 .897.728 1.625 1.625 1.625h8.751c.897 0 1.625-.728 1.625-1.625V6.625C13 5.728 12.272 5 11.375 5v-.625A4.375 4.375 0 0 0 7 0m2.625 5v-.625a2.625 2.625 0 0 0-5.25 0V5zM3.5 6.25h7.875c.207 0 .375.168.375.375v5.752a.375.375 0 0 1-.375.375H2.624a.375.375 0 0 1-.375-.375V6.625c0-.207.168-.375.375-.375zM7 8.375a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePadlockSquare1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 2a2 2 0 0 0-2 2v1h4V4a2 2 0 0 0-2-2M3 4v1a1.5 1.5 0 0 0-1.5 1.5v6A1.5 1.5 0 0 0 3 14h8a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 11 5V4a4 4 0 1 0-8 0m4 6.75a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePageSetting: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 1h-5v5h5zm7.75 12.5h-5m0-5h5m-5 2.5h5m.25-5H8L10.75.5zM3 13.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePageSettingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.375.125c.228 0 .438.124.548.324l2.75 5a.625.625 0 0 1-.548.926h-5.5a.625.625 0 0 1-.548-.926l2.75-5c.11-.2.32-.324.548-.324m1.693 5l-1.693-3.078l-1.693 3.078zM.875.375A.625.625 0 0 0 .25 1v4.5c0 .345.28.625.625.625h4.5c.345 0 .625-.28.625-.625V1a.625.625 0 0 0-.625-.625zM7.5 13c0-.345.28-.625.625-.625h4.5a.625.625 0 1 1 0 1.25h-4.5A.625.625 0 0 1 7.5 13m.625-5.125a.625.625 0 1 0 0 1.25h4.5a.625.625 0 1 0 0-1.25zM7.5 10.75c0-.345.28-.625.625-.625h4.5a.625.625 0 1 1 0 1.25h-4.5a.625.625 0 0 1-.625-.625m-6.25 0a1.875 1.875 0 1 1 3.75 0a1.875 1.875 0 0 1-3.75 0m1.875-3.125a3.125 3.125 0 1 0 0 6.25a3.125 3.125 0 0 0 0-6.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePageSettingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.565 5.626L10.21.334a.604.604 0 0 1 1.08 0l2.646 5.292a.604.604 0 0 1-.54.874H8.105a.604.604 0 0 1-.54-.874M.5.5A.5.5 0 0 0 0 1v5a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 6 6V1a.5.5 0 0 0-.5-.5zM6 11a3 3 0 1 1-6 0a3 3 0 0 1 6 0m2.5 1.5a.75.75 0 0 0 0 1.5H13a.75.75 0 0 0 0-1.5zM7.75 11a.75.75 0 0 1 .75-.75H13a.75.75 0 0 1 0 1.5H8.5a.75.75 0 0 1-.75-.75m.75-3a.75.75 0 0 0 0 1.5H13A.75.75 0 0 0 13 8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintBucket: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 6.9L6.1.5L.7 7.7A1 1 0 0 0 .79 9L4 12.21a1 1 0 0 0 1.29.09zm-1.196 6.167c-.387-.448-.262-1.118-.037-1.666c.162-.395.366-.76.608-1.176A.42.42 0 0 1 12.25 10a.4.4 0 0 1 .367.225c.247.417.454.783.617 1.18c.225.545.35 1.212-.035 1.66q-.03.034-.065.069a1.25 1.25 0 0 1-1.83-.067\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintBucketRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.064 0a.63.63 0 0 1 .486.18l6.27 6.27a.625.625 0 0 1-.068.942L5.69 12.68l-.005.003a1.604 1.604 0 0 1-2.07-.144l-.005-.006L.466 9.39l-.003-.003a1.604 1.604 0 0 1-.144-2.085V7.3L5.61.248A.63.63 0 0 1 6.063 0m.112 1.575L1.321 8.049a.354.354 0 0 0 .03.46h.002l3.137 3.138a.354.354 0 0 0 .453.03l6.482-4.853zm6.552 8.058a.9.9 0 0 0-.479-.133a.92.92 0 0 0-.81.482a10 10 0 0 0-.634 1.229a3.1 3.1 0 0 0-.248 1.042c-.015.377.07.794.369 1.141q.042.048.087.093a1.75 1.75 0 0 0 2.565-.097c.298-.346.381-.761.367-1.138a3.1 3.1 0 0 0-.248-1.038a9.6 9.6 0 0 0-.641-1.23a.9.9 0 0 0-.328-.351\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintBucketSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.85 5.861c.22.22.194.585-.055.771l-6.9 5.17a1.02 1.02 0 0 1-1.318-.092L.295 8.426a1.02 1.02 0 0 1-.092-1.33L5.37.206A.51.51 0 0 1 6.14.15zm.102 4.437c-.465.697-.952 1.596-.952 2.217C11 13.63 11.75 14 12.5 14s1.5-.371 1.5-1.485c0-.621-.487-1.52-.951-2.217a.654.654 0 0 0-1.097 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintPalette: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-4 5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m0-3.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/><path d=\"M9.52 12.28a1 1 0 0 0-.65-.88a2 2 0 0 1 .63-3.9h1.87a2 2 0 0 0 1.89-2.67a6.5 6.5 0 1 0-6.13 8.67a6.3 6.3 0 0 0 1.74-.24a.9.9 0 0 0 .65-.98\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintPaletteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.09.065a7.06 7.06 0 0 0-6.676 2.893a7.06 7.06 0 0 0-.502 7.259a7.06 7.06 0 0 0 6.214 3.784a6.8 6.8 0 0 0 1.878-.259c.775-.218 1.104-.902 1.087-1.514c-.017-.59-.357-1.244-1.039-1.498l-.023-.008a1.356 1.356 0 0 1-.902-1.483A1.356 1.356 0 0 1 9.45 8.115h1.837V7.49l-.002.625a2.61 2.61 0 0 0 2.118-1.092c.481-.68.605-1.576.327-2.36A7.06 7.06 0 0 0 8.09.064m.914 13.677l-.169-.602zM2.434 3.68A5.8 5.8 0 0 1 7.92 1.303a5.8 5.8 0 0 1 4.63 3.777a1.36 1.36 0 0 1-.168 1.22a1.36 1.36 0 0 1-1.095.565H9.452v.625l.002-.625h-.001a2.606 2.606 0 0 0-2.56 2.175a2.606 2.606 0 0 0 1.73 2.865c.113.045.213.178.218.36a.33.33 0 0 1-.044.186c-.021.033-.056.067-.131.088h-.003a5.6 5.6 0 0 1-1.534.212h-.001a5.8 5.8 0 0 1-5.106-3.108a5.8 5.8 0 0 1 .412-5.963M4.5 8.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2M7 4a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0M4.5 4a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintPaletteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.35.577a7 7 0 0 1 9.381 4.085c.27.758.15 1.626-.315 2.282A2.53 2.53 0 0 1 11.37 8H9.5a1.5 1.5 0 0 0-.455 2.931c.55.205.935.702.972 1.286a1.43 1.43 0 0 1-1.01 1.524A6.8 6.8 0 0 1 7.129 14a7 7 0 0 1-3.636-1.021A7.06 7.06 0 0 1 .15 6.517a7.06 7.06 0 0 1 4.2-5.94M4.5 7a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m6-3a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-6 6.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintbrush1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5 8.5h-9l-.76 3.8a1 1 0 0 0 .21.83a1 1 0 0 0 .77.37h8.56a1 1 0 0 0 .77-.37a1 1 0 0 0 .21-.83zm0-3a1 1 0 0 1 1 1v2h-11v-2a1 1 0 0 1 1-1H4a1 1 0 0 0 1-1v-2a2 2 0 1 1 4 0v2a1 1 0 0 0 1 1zm-3 8V11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintbrush1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.232.732A2.5 2.5 0 0 1 9.5 2.5v2a.5.5 0 0 0 .5.5h1.5A1.5 1.5 0 0 1 13 6.5v2a.5.5 0 0 1-.5.5h-.238l.61 3.052l.001.002a1.63 1.63 0 0 1-.34 1.347a1.63 1.63 0 0 1-1.249.599H2.716a1.63 1.63 0 0 1-1.25-.6a1.62 1.62 0 0 1-.34-1.346l.001-.002L1.737 9H1.5a.5.5 0 0 1-.5-.5v-2A1.5 1.5 0 0 1 2.5 5H4a.5.5 0 0 0 .5-.5v-2A2.5 2.5 0 0 1 5.232.732M9.125 12.75v-1.875a.625.625 0 1 0-1.25 0v1.875H2.723a.38.38 0 0 1-.288-.139l-.003-.004a.38.38 0 0 1-.079-.31v-.001L3.013 9h7.975l.659 3.296a.38.38 0 0 1-.079.311l-.003.004a.38.38 0 0 1-.287.139z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintbrush1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.707 5.292A1 1 0 0 0 12 4.999h-2a1 1 0 0 1-1-1v-2a2 2 0 1 0-4 0v2a1 1 0 0 1-1 1H2a1 1 0 0 0-1 1v2a.5.5 0 0 0 .5.5h11A.5.5 0 0 0 13 8V6a1 1 0 0 0-.293-.707M1.01 12.934L1.5 9.5h11l.49 3.434q.01.066.01.132a.934.934 0 0 1-.934.934H9.25v-2a.75.75 0 0 0-1.5 0v2H1.934a.934.934 0 0 1-.925-1.066\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintbrush2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.133 12.056c-1.53 1.54-4.13 2.05-5.63.51c2-2.07 0-3.07 1.5-4.57a2.9 2.9 0 1 1 4.09 4.1z\"/><path d=\"m4.698 7.082l5.305-5.916c.754-.848 2.115-.89 2.92-.09c.8.805.758 2.166-.09 2.92L6.976 9.241\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintbrush2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.279.72C12.27-.284 10.577-.23 9.633.83v.001L4.728 6.314a3.53 3.53 0 0 0-3.057 1.13c-.45.454-.672.91-.749 1.386c-.06.375-.024.75.005 1.039q.008.069.013.132c.03.328.036.6-.049.894c-.083.29-.27.655-.715 1.115a.625.625 0 0 0 .001.87c.914.938 2.148 1.23 3.329 1.084c1.146-.142 2.28-.699 3.134-1.532a3.53 3.53 0 0 0 1.115-3.23l5.413-4.835c1.063-.945 1.115-2.637.113-3.646zM5.127 7.698a2.275 2.275 0 0 0-2.56.617c-.291.291-.38.518-.411.714c-.033.202-.015.396.013.692l.016.167c.033.368.058.828-.092 1.35a3.5 3.5 0 0 1-.578 1.126c.525.33 1.163.442 1.837.359c.876-.109 1.772-.547 2.44-1.21l.02-.02l.001-.002l.056-.05A2.274 2.274 0 0 0 5.127 7.7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaintbrush2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.41.594A2.02 2.02 0 0 0 11.112.19a2 2 0 0 0-.66.495L5.134 6.638A4.15 4.15 0 0 1 7.35 8.987l5.97-5.41A2.04 2.04 0 0 0 14 2.115a2.06 2.06 0 0 0-.59-1.521M5.393 12.599l.018-.018c-1.414 1.405-3.722 1.937-5.243.807c-.217-.16-.212-.472-.044-.684c.734-.926.666-1.63.602-2.284c-.062-.638-.119-1.226.577-1.921a2.9 2.9 0 1 1 4.09 4.1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaperclip1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m12.858 6.787l-5.88 5.929a2.45 2.45 0 0 1-3.498 0l-1.759-1.789a2.5 2.5 0 0 1 0-3.508l6.265-6.285a1.976 1.976 0 0 1 2.807 0l.701.702a1.975 1.975 0 0 1 0 2.806l-5.553 5.574a.986.986 0 0 1-1.403 0l-.346-.356a.99.99 0 0 1 0-1.403L7.917 4.76\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaperclip1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m12.86 6.79l-5.812 5.86a2.42 2.42 0 0 1-3.458 0l-1.739-1.768a2.47 2.47 0 0 1 0-3.467l6.193-6.213a1.954 1.954 0 0 1 2.774 0l.694.694a1.954 1.954 0 0 1 0 2.774l-5.49 5.509a.975.975 0 0 1-1.387 0l-.342-.352a.977.977 0 0 1 0-1.387l3.683-3.653\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaperclip1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.383 1.5a1.17 1.17 0 0 0-.827.345l-.002.001l-6.069 6.088a1.673 1.673 0 0 0 .002 2.345l1.705 1.734a1.63 1.63 0 0 0 1.788.36c.2-.083.38-.206.531-.36l.003-.002l5.697-5.746a.75.75 0 0 1 1.065 1.057l-5.694 5.742l-.002.001a3.124 3.124 0 0 1-4.458 0l-1.704-1.733a3.173 3.173 0 0 1 0-4.452l.003-.003L7.491.788a2.665 2.665 0 0 1 3.783 0h.001l.676.676v.001a2.664 2.664 0 0 1 .001 3.782l-.001.001l-5.377 5.396l-.001.001a1.71 1.71 0 0 1-2.424 0l-.005-.006l-.331-.34a1.71 1.71 0 0 1 .005-2.42l3.61-3.58a.75.75 0 0 1 1.056 1.064l-3.61 3.581a.21.21 0 0 0 0 .295l.01.01l.332.34a.207.207 0 0 0 .293-.001v-.001l5.382-5.4l.003-.004a1.166 1.166 0 0 0 0-1.654l-.002-.002l-.68-.68l-.002-.002a1.17 1.17 0 0 0-.827-.345\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParachuteDrop: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.235 7h-4.5a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m-2.25 4.258h1m4.5-7.243a.5.5 0 0 0 .44-.27a.47.47 0 0 0 0-.51a6.86 6.86 0 0 0-5.94-2.72a6.86 6.86 0 0 0-5.91 2.72a.47.47 0 0 0 0 .51a.5.5 0 0 0 .41.27zm-5.5 2.993v-3m-2.5 3l-2.5-3m7.5 3l2.5-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParachuteDropRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.63 2.902C11.977.955 9.432 0 6.96 0C4.463 0 2.014.952.369 2.903C.115 3.203 0 3.578 0 3.942c0 .94.762 1.703 1.703 1.703h.536L3.38 7.779c-.31.283-.505.69-.505 1.144v3.529c0 .855.693 1.548 1.548 1.548h5.154c.855 0 1.548-.693 1.548-1.548V8.923a1.54 1.54 0 0 0-.526-1.162l1.132-2.116h.566c.94 0 1.703-.763 1.703-1.703a1.6 1.6 0 0 0-.37-1.04M7.61 5.645h2.704l-.926 1.73H7.61zm-3.954 0H6.36v1.73H4.582zm.767 2.98a.3.3 0 0 0-.298.298v3.529c0 .165.133.298.298.298h5.154a.3.3 0 0 0 .298-.298V8.923a.3.3 0 0 0-.298-.298zm2.845 2.351a.625.625 0 0 0 0 1.25h1a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParachuteDropSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.478.66C4.601.145 5.811 0 6.985 0c1.171 0 2.393.135 3.523.653a7.36 7.36 0 0 1 2.837 2.296a.97.97 0 0 1 .013 1.032a1 1 0 0 1-.81.517l-2.212 2.895c.166.237.263.525.263.837v4.312c0 .805-.653 1.458-1.458 1.458H4.829a1.46 1.46 0 0 1-1.458-1.458V8.23c0-.312.097-.6.263-.837L1.42 4.496a1 1 0 0 1-.778-.516a.97.97 0 0 1 .034-1.06A7.36 7.36 0 0 1 3.478.66m5.445 6.111L10.66 4.5H7.735v2.271zm-2.688 0H5.047L3.31 4.5h2.924zm.705 5.156c0-.345.28-.625.625-.625h1a.625.625 0 0 1 0 1.25h-1a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParagraph: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5h-9a4 4 0 0 0 0 8h2m3-8v13m-3-13v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParagraphRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.625 0a4.625 4.625 0 0 0 0 9.25h1.25v4.125a.625.625 0 1 0 1.25 0V1.25h2.5v12.125a.625.625 0 1 0 1.25 0V1.25h2.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParagraphSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.786 0a4.786 4.786 0 1 0 0 9.573h.943v3.677a.75.75 0 0 0 1.5 0V1.5h2.146v11.75a.75.75 0 0 0 1.5 0V1.5h2.375a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParkingSign: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5.5h-7a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3\"/><path d=\"M5.209 10.514V7.586m0 0v-4.1h3.185a1.5 1.5 0 0 1 1.5 1.5v1.1a1.5 1.5 0 0 1-1.5 1.5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParkingSignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625zM1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12zm2.875.75a.75.75 0 0 0-.75.75v7a.75.75 0 0 0 1.5 0V8.25H8A2.25 2.25 0 0 0 10.25 6V5A2.25 2.25 0 0 0 8 2.75zm3.5 4H5.25v-2.5H8a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParkingSignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3.5A3.5 3.5 0 0 1 3.5 0h7A3.5 3.5 0 0 1 14 3.5v7a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 0 10.5zm5.21-.383a.625.625 0 0 0-.626.625v7.028a.625.625 0 0 0 1.25 0V8.466h2.56a2.125 2.125 0 0 0 2.125-2.125V5.242a2.125 2.125 0 0 0-2.125-2.125zm3.184 4.1h-2.56v-2.85h2.56c.483 0 .875.392.875.875v1.1a.875.875 0 0 1-.875.874\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParliament: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.481 8.68h7.038v4.71H3.48zm1.588-2.702h3.81\"/><path d=\"M5.943 11.628c0-.584.473-1.057 1.057-1.057v0c.584 0 1.058.473 1.058 1.057v1.761H5.943zM5.067 8.68V5.968l1.91-2.938l1.91 2.938v2.71M.59 6.71v6.68h2.892V6.71L2.036 4.513zm9.929 0v6.68h2.89V6.71l-1.445-2.198z\"/><path d=\"M6.977 3.031V.55h1.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParliamentRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .375A.625.625 0 0 0 6.375 1v2.241L5.058 4.558A.63.63 0 0 0 4.875 5v2.375h-.75V7c0-.13-.04-.257-.116-.363l-1.25-1.75a.625.625 0 0 0-1.018 0l-1.25 1.75A.63.63 0 0 0 .375 7v6c0 .345.28.625.625.625h12c.345 0 .625-.28.625-.625V7c0-.13-.04-.257-.116-.363l-1.25-1.75a.625.625 0 0 0-1.018 0l-1.25 1.75A.63.63 0 0 0 9.875 7v.375h-.75V5a.63.63 0 0 0-.183-.442L7.625 3.241V1.625H8a.625.625 0 1 0 0-1.25zm2.875 8.25v3.75h-2V11a.875.875 0 0 0-1.75 0v1.375h-2v-3.75zm2.5-1.425v5.175h-1.25V7.2l.625-.875zm-9.5 5.175V7.2l-.625-.875l-.625.875v5.175z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineParliamentSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .05a.75.75 0 0 0-.75.75v2.174l-1.11 2.11a.5.5 0 0 0-.058.234v2.736h3.79V5.318a.5.5 0 0 0-.058-.233L7.75 3.063V1.55h.621a.75.75 0 0 0 0-1.5zm2.667 9.254H4.286v4.585h1.812V12.5a.902.902 0 1 1 1.804 0v1.39h1.765zM11.4 13.89h-.485V6.645a.5.5 0 0 1 .041-.141l.999-2.199a.5.5 0 0 1 .91 0l.999 2.199a.5.5 0 0 1 .045.207v6.678a.5.5 0 0 1-.5.5H11.4m-8.364 0l-.001-.026V6.65a.5.5 0 0 0-.041-.145l-.999-2.199a.5.5 0 0 0-.91 0L.087 6.504a.5.5 0 0 0-.045.207v6.678a.5.5 0 0 0 .5.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePartyPopper: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m11.85 13.2l-6.68-2.49a1.25 1.25 0 0 1-.48-2.05l4.19-4.19a1.26 1.26 0 0 1 2.06.53l2.48 6.68a1.22 1.22 0 0 1-1.57 1.52m-9.8-6.07a2.06 2.06 0 0 1 1.46-.21m.82-2.64A2.1 2.1 0 0 1 4 2.83M6.63.72A4.72 4.72 0 0 0 6.76 4M1 3.78a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePartyPopperRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.13.044a.75.75 0 0 1 .946.48a5.38 5.38 0 0 1-.148 3.738a.75.75 0 1 1-1.385-.577A3.88 3.88 0 0 0 6.65.99a.75.75 0 0 1 .48-.946m3.758 3.116a.75.75 0 0 0-1.486.206a1.3 1.3 0 0 1-.206.904a.75.75 0 0 0 1.25.83a2.8 2.8 0 0 0 .442-1.94m-7.063.684a1.86 1.86 0 0 1 1.751.458l4.11 4.11l.006.006a1.85 1.85 0 0 1-.706 3.034l-6.547 2.44l-.01.004a1.822 1.822 0 0 1-2.334-2.298l2.429-6.54a1.86 1.86 0 0 1 1.301-1.214m.615 1.21a.61.61 0 0 0-.74.428l-2.427 6.535a.571.571 0 0 0 .736.702l6.545-2.44l.01-.004a.602.602 0 0 0 .234-.983L4.7 5.195a.6.6 0 0 0-.26-.14m5.817 1.268a2.77 2.77 0 0 1 1.963.283a.75.75 0 0 1-.73 1.31a1.27 1.27 0 0 0-.901-.13a.75.75 0 1 1-.332-1.463m1.512-3a1.115 1.115 0 1 1 2.23 0a1.115 1.115 0 0 1-2.23 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePartyPopperSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.876.201a.75.75 0 0 1 .463.955a3.46 3.46 0 0 0 .107 2.54a.75.75 0 0 1-1.372.607A4.96 4.96 0 0 1 5.921.665A.75.75 0 0 1 6.876.2M4.523 2.883a.75.75 0 0 0-1.486-.206a2.85 2.85 0 0 0 .448 1.968a.75.75 0 1 0 1.25-.83a1.35 1.35 0 0 1-.212-.932m5.885 1.407a1.68 1.68 0 0 0-1.564.4l-.012.012l-3.911 3.911l-.005.005a1.667 1.667 0 0 0 .636 2.732l6.232 2.323l.007.003a1.639 1.639 0 0 0 2.102-2.064L11.58 5.385a1.68 1.68 0 0 0-1.173-1.095M3.279 7.91a1.3 1.3 0 0 0-.928.133a.75.75 0 1 1-.731-1.31a2.8 2.8 0 0 1 1.991-.286a.75.75 0 0 1-.332 1.463M1.065 3.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePassport: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M7 9a3 3 0 1 0 0-6a3 3 0 0 0 0 6M4 6h6M7 9V3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePassportRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.875 1.625a.375.375 0 0 0-.375-.375h-9a.375.375 0 0 0-.375.375v10.75c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375zM11.5 0c.898 0 1.625.728 1.625 1.625v10.75c0 .898-.727 1.625-1.625 1.625h-9a1.625 1.625 0 0 1-1.625-1.625V1.625C.875.728 1.603 0 2.5 0zM8.917 3.048a3.63 3.63 0 0 1 1.674 2.577H8.917zm0 6.154a3.63 3.63 0 0 0 1.674-2.577H8.917zm-1 .431V6.625H6.083v3.008a3.63 3.63 0 0 0 1.834 0m-2.834-.43V6.624H3.41a3.63 3.63 0 0 0 1.674 2.577m0-3.578H3.41a3.63 3.63 0 0 1 1.674-2.577zm2.834 0H6.083V2.617a3.63 3.63 0 0 1 1.834 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePassportSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 11.5 0zm5 9.364A3.4 3.4 0 0 0 10.364 6.5H7.5zm-1 0A3.4 3.4 0 0 1 3.636 6.5H6.5zm1-3.864h2.864A3.4 3.4 0 0 0 7.5 2.636zm-1-2.864V5.5H3.636A3.4 3.4 0 0 1 6.5 2.636\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderDivide: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 9.5a1 1 0 0 0 1-1v-7c0-.545-.455-1-1-1h-7c-.545 0-1 .455-1 1v7c0 .545.455 1 1 1z\"/><path d=\"M12.5 13.5a1 1 0 0 0 1-1v-7c0-.545-.455-1-1-1h-7c-.545 0-1 .455-1 1v7c0 .545.455 1 1 1z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderDivideSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5 0h-7A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10h1.252V5.37a2.625 2.625 0 0 1 2.625-2.625H10V1.5A1.5 1.5 0 0 0 8.5 0M10 3.995V4h.014v4.632c0 .76-.616 1.375-1.376 1.375H4.002V5.37c0-.76.616-1.375 1.375-1.375zM11.264 4H12.5A1.5 1.5 0 0 1 14 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 4 12.5v-1.243h4.638a2.625 2.625 0 0 0 2.626-2.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderExclude: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 2.5v-1a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1m9-5h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1m4-7H9a.5.5 0 0 1 .5.5v.5\"/><path d=\"M9.5 8.5V9a.5.5 0 0 1-.5.5h-.5m-3 0H5a.5.5 0 0 1-.5-.5v-.5m0-3V5a.5.5 0 0 1 .5-.5h.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderExcludeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0h7A1.5 1.5 0 0 1 10 1.5V4h2.5A1.5 1.5 0 0 1 14 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 4 12.5V10H1.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0M5 9h3.5a.5.5 0 0 0 .5-.5V5H5.5a.5.5 0 0 0-.5.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderIntersect: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 12.5a1 1 0 0 1-1 1m0-9a1 1 0 0 1 1 1m-9 7a1 1 0 0 0 1 1m8-5.5v2M8 13.5h2M.5 1.5a1 1 0 0 1 1-1m7 0a1 1 0 0 1 1 1m-9 7a1 1 0 0 0 1 1M.5 6V4M4 .5h2m-.5 4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderIntersectSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.277 2.277A.76.76 0 0 1 .75 2.5A.76.76 0 0 1 0 1.75A1.76 1.76 0 0 1 1.75 0a.75.75 0 0 1 0 1.5a.25.25 0 0 0-.25.25a.76.76 0 0 1-.223.527M12.25 5a.25.25 0 0 1 .25.25a.75.75 0 1 0 1.5 0a1.76 1.76 0 0 0-1.75-1.75a.75.75 0 1 0 0 1.5m1 6.5a.76.76 0 0 0-.75.75a.25.25 0 0 1-.25.25a.75.75 0 1 0 0 1.5A1.76 1.76 0 0 0 14 12.25a.76.76 0 0 0-.75-.75m-8.177.927a.25.25 0 0 0 .177.073a.75.75 0 1 1 0 1.5a1.76 1.76 0 0 1-1.75-1.75a.75.75 0 1 1 1.5 0c0 .066.026.13.073.177M8 12.5A.75.75 0 1 0 8 14h1.5a.75.75 0 1 0 0-1.5zm4.723-5.027a.76.76 0 0 1 .527-.223A.76.76 0 0 1 14 8v1.5a.75.75 0 1 1-1.5 0V8a.76.76 0 0 1 .223-.527M1.75 9a.25.25 0 0 1-.25-.25a.75.75 0 0 0-1.5 0a1.76 1.76 0 0 0 1.75 1.75a.75.75 0 1 0 0-1.5m7-7.5a.25.25 0 0 1 .25.25a.75.75 0 0 0 1.5 0A1.76 1.76 0 0 0 8.75 0a.75.75 0 0 0 0 1.5M6 1.5H4.5a.75.75 0 0 1 0-1.5H6a.75.75 0 0 1 0 1.5M.75 6.75A.76.76 0 0 0 1.5 6V4.5a.75.75 0 0 0-1.5 0V6a.76.76 0 0 0 .75.75m4.5-2.5a1 1 0 0 0-1 1v4a.5.5 0 0 0 .5.5h4a1 1 0 0 0 1-1v-4a.5.5 0 0 0-.5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderMerge: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 1.5v3h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1m-5 8v-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderMergeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5 0h-7A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10h1.254V6.5a.625.625 0 1 1 1.25 0v4.25L4 10.82v1.68A1.5 1.5 0 0 0 5.5 14h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 12.5 4H10V1.5A1.5 1.5 0 0 0 8.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderMinusFront1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 4.5v-3c0-.545-.455-1-1-1h-7c-.545 0-1 .455-1 1v7c0 .545.455 1 1 1h3m9 3a1 1 0 0 1-1 1\"/><path d=\"M4.5 5.5a1 1 0 0 1 1-1m7 0a1 1 0 0 1 1 1m-9 7a1 1 0 0 0 1 1m8-5.5v2m-9 0V8M8 4.5h2m-2 9h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderMinusFront1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0h7A1.5 1.5 0 0 1 10 1.5V4a1 1 0 0 1-1 1H5.5a.5.5 0 0 0-.5.5V9a1 1 0 0 1-1 1H1.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0m10.927 5.073A.25.25 0 0 0 12.25 5a.75.75 0 1 1 0-1.5A1.76 1.76 0 0 1 14 5.25a.75.75 0 1 1-1.5 0a.25.25 0 0 0-.073-.177m.296 6.65a.76.76 0 0 1 .527-.223a.76.76 0 0 1 .75.75A1.76 1.76 0 0 1 12.25 14a.75.75 0 1 1 0-1.5a.25.25 0 0 0 .25-.25a.76.76 0 0 1 .223-.527M5.25 12.5a.25.25 0 0 1-.25-.25a.75.75 0 1 0-1.5 0A1.76 1.76 0 0 0 5.25 14a.75.75 0 1 0 0-1.5m2.75 0h1.5a.75.75 0 1 1 0 1.5H8a.75.75 0 1 1 0-1.5m5.25-5.25a.76.76 0 0 0-.75.75v1.5a.75.75 0 1 0 1.5 0V8a.76.76 0 0 0-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderSquareDivideRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.11.375.375 1.11.375 2v6.5c0 .89.735 1.625 1.625 1.625h1.875V12c0 .89.735 1.625 1.625 1.625H12c.898 0 1.625-.727 1.625-1.625V5.5c0-.89-.735-1.625-1.625-1.625h-1.875V2c0-.89-.735-1.625-1.625-1.625zm6.875 3.5V2c0-.2-.176-.375-.375-.375H2c-.2 0-.375.176-.375.375v6.5c0 .2.176.375.375.375h1.875V5.5c0-.89.735-1.625 1.625-1.625zm-3.75 5V5.5c0-.2.176-.375.375-.375h3.375V8.5a.375.375 0 0 1-.375.375zm0 1.25H8.5c.897 0 1.625-.728 1.625-1.625V5.125H12c.2 0 .375.176.375.375V12a.375.375 0 0 1-.375.375H5.5A.385.385 0 0 1 5.125 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderSquareExcludeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375A1.625 1.625 0 0 0 .375 2v6.375A1.625 1.625 0 0 0 2 10h.375a.625.625 0 1 0 0-1.25H2a.375.375 0 0 1-.375-.375V2A.375.375 0 0 1 2 1.625h6.375A.375.375 0 0 1 8.75 2v.375a.625.625 0 1 0 1.25 0V2A1.625 1.625 0 0 0 8.375.375zM11.625 4a.625.625 0 1 0 0 1.25H12a.375.375 0 0 1 .375.375V12a.375.375 0 0 1-.375.375H5.625A.375.375 0 0 1 5.25 12v-.375a.625.625 0 1 0-1.25 0V12a1.625 1.625 0 0 0 1.625 1.625H12A1.625 1.625 0 0 0 13.625 12V5.625A1.625 1.625 0 0 0 12 4zm-3.875.625c0-.345.28-.625.625-.625h.5C9.496 4 10 4.504 10 5.125v.5a.625.625 0 1 1-1.25 0V5.25h-.375a.625.625 0 0 1-.625-.625M10 8.375a.625.625 0 1 0-1.25 0v.375h-.375a.625.625 0 1 0 0 1.25h.5C9.496 10 10 9.496 10 8.875zM4.625 7.75c.345 0 .625.28.625.625v.375h.375a.625.625 0 1 1 0 1.25h-.5A1.125 1.125 0 0 1 4 8.875v-.5c0-.345.28-.625.625-.625m1-2.5H5.25v.375a.625.625 0 1 1-1.25 0v-.5C4 4.504 4.504 4 5.125 4h.5a.625.625 0 1 1 0 1.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderSquareIntersectRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625A.375.375 0 0 0 1.625 2a.625.625 0 1 1-1.25 0C.375 1.103 1.103.375 2 .375a.625.625 0 1 1 0 1.25M11.375 4.5c0-.345.28-.625.625-.625c.898 0 1.625.728 1.625 1.625a.625.625 0 1 1-1.25 0A.375.375 0 0 0 12 5.125a.625.625 0 0 1-.625-.625m2.25 7.5a.625.625 0 1 0-1.25 0a.375.375 0 0 1-.375.375a.625.625 0 1 0 0 1.25c.898 0 1.625-.727 1.625-1.625m-8.5 0a.625.625 0 1 0-1.25 0c0 .898.728 1.625 1.625 1.625a.625.625 0 1 0 0-1.25a.375.375 0 0 1-.375-.375M13 7.375c.345 0 .625.28.625.625v1.5a.625.625 0 1 1-1.25 0V8c0-.345.28-.625.625-.625m-5 5a.625.625 0 1 0 0 1.25h1.5a.625.625 0 1 0 0-1.25zm.5-12a.625.625 0 1 0 0 1.25c.207 0 .375.168.375.375a.625.625 0 1 0 1.25 0c0-.897-.728-1.625-1.625-1.625M1 7.875c.345 0 .625.28.625.625c0 .207.168.375.375.375a.625.625 0 1 1 0 1.25A1.625 1.625 0 0 1 .375 8.5c0-.345.28-.625.625-.625M1.625 4.5a.625.625 0 1 0-1.25 0V6a.625.625 0 1 0 1.25 0zM3.875 1c0-.345.28-.625.625-.625H6a.625.625 0 1 1 0 1.25H4.5A.625.625 0 0 1 3.875 1M5.5 3.875c-.897 0-1.625.728-1.625 1.625v3c0 .897.728 1.625 1.625 1.625h3c.897 0 1.625-.728 1.625-1.625v-3c0-.897-.728-1.625-1.625-1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderSquareMergeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375A1.625 1.625 0 0 0 .375 2v6.5A1.625 1.625 0 0 0 2 10.125h1.875V12A1.625 1.625 0 0 0 5.5 13.625H12A1.625 1.625 0 0 0 13.625 12V5.5A1.625 1.625 0 0 0 12 3.875h-1.875V2A1.625 1.625 0 0 0 8.5.375zm-.265 1.36c.07-.07.166-.11.265-.11h6.5A.375.375 0 0 1 8.875 2v2.5c0 .345.28.625.625.625H12a.375.375 0 0 1 .375.375V12a.375.375 0 0 1-.375.375H5.5A.375.375 0 0 1 5.125 12V6.5a.625.625 0 1 0-1.25 0v2.375H2a.375.375 0 0 1-.375-.375V2c0-.1.04-.195.11-.265\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderSquareMinusFront1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.11 1.11.375 2 .375h6.5c.89 0 1.625.735 1.625 1.625v2.375c0 .345-.28.625-.625.625H6a1 1 0 0 0-1 1v3.5c0 .345-.28.625-.625.625H2C1.11 10.125.375 9.39.375 8.5zm13.25 10a.625.625 0 1 0-1.25 0a.375.375 0 0 1-.375.375a.625.625 0 1 0 0 1.25c.898 0 1.625-.727 1.625-1.625m-2.25-7.5c0-.345.28-.625.625-.625c.898 0 1.625.728 1.625 1.625a.625.625 0 1 1-1.25 0A.375.375 0 0 0 12 5.125a.625.625 0 0 1-.625-.625M5.125 12a.625.625 0 1 0-1.25 0c0 .898.728 1.625 1.625 1.625a.625.625 0 1 0 0-1.25a.375.375 0 0 1-.375-.375M13 7.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5m-5 4.875a.625.625 0 1 0 0 1.25h1.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderSquareTrimRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.11 1.11.375 2 .375h6.5c.89 0 1.625.735 1.625 1.625v1.875H12c.89 0 1.625.735 1.625 1.625V12c0 .898-.727 1.625-1.625 1.625H5.5c-.89 0-1.625-.735-1.625-1.625v-1.875H2C1.11 10.125.375 9.39.375 8.5zm8.5 1.875H5.5c-.89 0-1.625.735-1.625 1.625v3.375H2a.385.385 0 0 1-.375-.375V2c0-.2.176-.375.375-.375h6.5c.2 0 .375.176.375.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderSquareUnionRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M9.5 2v2.5H12a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1V9.5H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6.5a1 1 0 0 1 1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderTrim: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 4.5v-3c0-.545-.455-1-1-1h-7c-.545 0-1 .455-1 1v7c0 .545.455 1 1 1h3\"/><path d=\"M12.5 13.5a1 1 0 0 0 1-1v-7c0-.545-.455-1-1-1h-7c-.545 0-1 .455-1 1v7c0 .545.455 1 1 1z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderTrimSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5 0h-7A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10h1.25V5.5A2.75 2.75 0 0 1 5.5 2.75H10V1.5A1.5 1.5 0 0 0 8.5 0m-3 4h7A1.5 1.5 0 0 1 14 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 4 12.5v-7A1.5 1.5 0 0 1 5.5 4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderUnion: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 1.5v3h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePathfinderUnionSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0h7A1.5 1.5 0 0 1 10 1.5V4h2.5A1.5 1.5 0 0 1 14 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 4 12.5V10H1.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePayment10: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 11.5v2m2.5-3v2m-5-2v2M2.75 4.75a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m8.5.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m-3.186-.861a.83.83 0 0 0-.786-.556h-.645a.744.744 0 0 0-.16 1.47l.983.216a.834.834 0 0 1-.178 1.648h-.556a.83.83 0 0 1-.786-.556M7 2.833V2m0 5v-.833\"/><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePayment10Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 7.5c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375V2A.375.375 0 0 0 12 1.625H2A.375.375 0 0 0 1.625 2zM2 9.125A1.625 1.625 0 0 1 .375 7.5V2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v5.5c0 .897-.727 1.625-1.625 1.625zm4.615-6.698a1.355 1.355 0 0 0-.29 2.679l1.03.225a.3.3 0 0 1-.064.592H6.71a.3.3 0 0 1-.283-.2a.575.575 0 0 0-1.084.384a1.45 1.45 0 0 0 1.367.966h.582a1.45 1.45 0 0 0 .31-2.865l-1.03-.225a.205.205 0 0 1 .044-.406h.676a.3.3 0 0 1 .283.2a.575.575 0 0 0 1.084-.384a1.45 1.45 0 0 0-1.367-.966zM4.125 4.75a.875.875 0 1 0-1.75 0a.875.875 0 0 0 1.75 0m6.625.875a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75M7 13.875c.345 0 .625-.28.625-.625v-2a.625.625 0 1 0-1.25 0v2c0 .345.28.625.625.625m3.125-1.5a.625.625 0 1 1-1.25 0v-2a.625.625 0 1 1 1.25 0zM4.5 13c.345 0 .625-.28.625-.625v-2a.625.625 0 1 0-1.25 0v2c0 .345.28.625.625.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePayment10Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v6A1.5 1.5 0 0 0 1.5 9h11A1.5 1.5 0 0 0 14 7.5v-6A1.5 1.5 0 0 0 12.5 0zm6.125 1.454a.625.625 0 1 0-1.25 0v.4a1.532 1.532 0 0 0-.15 3.018l1.197.261a.39.39 0 0 1-.084.773h-.676a.39.39 0 0 1-.369-.26a.625.625 0 0 0-1.178.416c.194.55.673.965 1.26 1.069v.415a.625.625 0 1 0 1.25 0V7.13a1.641 1.641 0 0 0 .064-3.219L6.492 3.65a.281.281 0 0 1 .06-.556h.786a.39.39 0 0 1 .369.26a.625.625 0 1 0 1.178-.416a1.64 1.64 0 0 0-1.26-1.069zM2.75 3.75a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5m8.5 0a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5M4.5 9.875c.345 0 .625.28.625.625v2a.625.625 0 1 1-1.25 0v-2c0-.345.28-.625.625-.625m5.625.625a.625.625 0 1 0-1.25 0v2a.625.625 0 1 0 1.25 0zm-2.5.75a.625.625 0 1 0-1.25 0v2a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaymentCashOut3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 11.5v2m2.5-3v2m-5-2v2m8-12h-11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1\"/><path d=\"M7 6.25a1.75 1.75 0 1 0 0-3.5a1.75 1.75 0 0 0 0 3.5m-4.225-1.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m8.45.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaymentCashOut3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 7.875a.375.375 0 0 1-.375-.375V2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v5.5a.375.375 0 0 1-.375.375zM.375 7.5c0 .897.728 1.625 1.625 1.625h10c.898 0 1.625-.728 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625H2C1.103.375.375 1.103.375 2zM7 6.75a2 2 0 1 1 0-4a2 2 0 0 1 0 4m-4.625-2a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m7.5 0a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m-2.25 8.5a.625.625 0 1 1-1.25 0v-2a.625.625 0 1 1 1.25 0zM9.5 13c.345 0 .625-.28.625-.625v-2a.625.625 0 1 0-1.25 0v2c0 .345.28.625.625.625m-4.375-.625a.625.625 0 1 1-1.25 0v-2a.625.625 0 1 1 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaymentCashOut3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.45C0 .625.696 0 1.5 0h11c.804 0 1.5.625 1.5 1.45v5.6c0 .825-.696 1.45-1.5 1.45h-11C.696 8.5 0 7.875 0 7.05zm9 2.8a2 2 0 1 1-4 0a2 2 0 0 1 4 0m-5.5.25a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0m7.75-.75a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5M5.125 10.5a.625.625 0 1 0-1.25 0v2a.625.625 0 1 0 1.25 0zM9.5 9.875c.345 0 .625.28.625.625v2a.625.625 0 1 1-1.25 0v-2c0-.345.28-.625.625-.625m-2.5.75c.345 0 .625.28.625.625v2a.625.625 0 1 1-1.25 0v-2c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaypal: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.605 1.595L3.587.515a.49.49 0 0 0-.6.37l-1.36 6.408L.619 12a.49.49 0 0 0 .37.58l1.2.26a.49.49 0 0 0 .58-.38l.999-4.679l3.438.74a3.52 3.52 0 0 0 4.259-3.429a3.59 3.59 0 0 0-2.86-3.498m-1.36 4.658l-2.998-.65l.55-2.599l2.998.65a1.32 1.32 0 0 1-.56 2.579z\"/><path d=\"m5.146 13.5l.62-2.899l2.999.63c2.239.49 4.598-1.86 4.628-4.288c0-.405-.067-.807-.2-1.19\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaypalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.764.534a.625.625 0 0 1 .618-.535h4.626a3.95 3.95 0 0 1 3.91 3.408a3.946 3.946 0 0 1-2.592 6.922H7.813l-.458 3.136a.625.625 0 0 1-.618.535h-2.61a.625.625 0 0 1-.618-.715l.095-.649H1.722a.625.625 0 0 1-.619-.715zm5.244.715c.984 0 1.845.527 2.316 1.314a4 4 0 0 0-.998-.127H5.632a.625.625 0 0 0-.619.535l-1.227 8.415H2.444L3.923 1.25zM4.95 12.101l-.016.076l-.084.573h1.346l.458-3.137a.625.625 0 0 1 .618-.534h2.054A2.696 2.696 0 0 0 11.75 5.2a3.95 3.95 0 0 1-3.742 2.69H5.564z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePaypalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.98.015L8 1.095a3.59 3.59 0 0 1 2.86 3.499A3.517 3.517 0 0 1 6.6 8.022l-3.44-.74l-1 4.679a.49.49 0 0 1-.58.38l-1.2-.26a.49.49 0 0 1-.37-.58l1.01-4.708L2.38.385a.49.49 0 0 1 .6-.37m.66 5.088l3 .65l-.01-.02a1.32 1.32 0 0 0 .56-2.579l-3-.65zm.52 4.557l.18-.846l1.998.43a4.772 4.772 0 0 0 5.773-4.646v-.01q0-.14-.01-.278A3.59 3.59 0 0 1 14 7.46a3.52 3.52 0 0 1-4.26 3.43l-3.44-.74l-.826 3.46a.49.49 0 0 1-.58.38l-1.2-.26a.49.49 0 0 1-.37-.58z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePeaceHand: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.21 13.5c1.464-1.429 1.563-3.26 1.743-4.356c.31-1.89-1.743-2.666-4.014-3.106l.291-4.223a1.14 1.14 0 0 0-2.268-.21l-.474 3.984l-1.043-3.788A1.307 1.307 0 0 0 2.893.882A1.21 1.21 0 0 0 2 2.38l1.45 5.44\"/><path d=\"M3.885 13.5C1.91 12.712 1.6 10.71 1.69 9.313c.057-.879.855-1.491 1.736-1.491h3.191a1.043 1.043 0 0 1 .244 2.057l-1.807.434c.57-.094 1.87.48 1.917 1.734\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePeaceHandRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.57 9.245c.097-.596.011-1.14-.243-1.616c-.249-.467-.637-.827-1.076-1.108c-.729-.466-1.682-.768-2.65-.984l.253-3.634a1.765 1.765 0 0 0-3.513-.328v.002l-.103.853l-.191-.672A1.93 1.93 0 0 0 2.749.399a1.833 1.833 0 0 0-1.354 2.266v.003l1.27 4.648c-.84.268-1.534.97-1.598 1.956c-.096 1.48.22 3.74 2.587 4.684a.625.625 0 1 0 .463-1.161c-1.586-.633-1.888-2.127-1.803-3.442c.032-.484.49-.906 1.112-.906h3.192a.418.418 0 0 1 .097.824l-1.807.434a.625.625 0 0 0 .247 1.224c.072-.012.375.028.689.253c.283.204.488.497.503.889a.625.625 0 1 0 1.25-.048a2.32 2.32 0 0 0-.643-1.523l.052-.013a1.668 1.668 0 0 0-.388-3.29h-2.69L2.602 2.343V2.34a.583.583 0 0 1 .435-.725a.683.683 0 0 1 .805.476l.001.005L4.886 5.76a.625.625 0 0 0 1.222-.097l.473-3.94v-.002a.515.515 0 0 1 1.025.094l-.292 4.178a.625.625 0 0 0 .505.657c1.124.218 2.105.505 2.757.923c.319.204.528.42.647.643c.115.215.17.478.112.826l-.06.39c-.163 1.09-.356 2.376-1.502 3.495a.625.625 0 0 0 .873.894c1.466-1.43 1.712-3.135 1.869-4.218q.027-.194.054-.359\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePeaceHandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.558 9.273c.336-2.05-1.89-2.892-4.355-3.37l.316-4.581a1.236 1.236 0 0 0-2.461-.229l-.514 4.324l-1.132-4.11A1.42 1.42 0 0 0 2.728.308a1.31 1.31 0 0 0-.97 1.624l1.24 4.654H6.78a1.723 1.723 0 0 1 .402 3.399l-.112.026c.384.39.681.932.707 1.624a.625.625 0 1 1-1.249.048c-.016-.425-.238-.742-.543-.961c-.335-.24-.662-.287-.75-.272a.625.625 0 0 1-.246-1.225L6.89 8.77a.473.473 0 0 0-.11-.933H3.295c-.942.016-1.812.679-1.873 1.62c-.076 1.18.11 2.556 1.207 3.511c.348.303.671.588.89.781c.184.162.42.251.664.251h6.076c.261 0 .515-.1.688-.295c1.158-1.315 1.382-2.872 1.543-3.987q.033-.238.067-.445\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePeaceSymbol: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m0-13v13\"/><path d=\"M1.93 11.07L7 6l5.07 5.07\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePeaceSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.25 1.55a5.503 5.503 0 0 0-4.011 8.208L6.25 5.746zm-3.08 9.399a5.5 5.5 0 0 0 3.08 1.502V7.868zm4.58 1.502a5.5 5.5 0 0 0 3.08-1.503l-3.08-3.08zm4.011-2.693A5.503 5.503 0 0 0 7.75 1.55v4.196zM7-.002a7.001 7.001 0 1 0 0 14.003A7.001 7.001 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePeaceSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 7a4.98 4.98 0 0 1 3.981-4.88v2.75L2.298 8.7A5 5 0 0 1 2 7m1.39 3.451a4.97 4.97 0 0 0 2.591 1.43V7.756zm4.59-2.695v4.125a4.97 4.97 0 0 0 2.592-1.43zm3.683.945A4.983 4.983 0 0 0 7.98 2.119v2.752zM0 7a6.981 6.981 0 1 1 13.962 0A6.981 6.981 0 0 1 0 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePen3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 3a2.5 2.5 0 1 0-5 0v7.5l2.5 3l2.5-3zm-5 1.5h5m2-2a2 2 0 1 1 4 0v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm2 9v2\"/><path d=\"M7.5 4.5h5a1 1 0 0 1 1 1v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePen3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 10.28V5.126h2.75v5.156L3 11.999zM3 .376A2.625 2.625 0 0 0 .375 3v7.5c0 .142.048.28.137.39l2 2.5a.625.625 0 0 0 .976 0l2-2.5a.63.63 0 0 0 .137-.39V3A2.625 2.625 0 0 0 3 .375m8.625 3.5V2.75a2.375 2.375 0 1 0-4.75 0V10c0 .898.728 1.625 1.625 1.625h.125V13a.625.625 0 1 0 1.25 0v-1.375H10c.898 0 1.625-.727 1.625-1.625V5.125H12c.207 0 .375.168.375.375v4a.625.625 0 1 0 1.25 0v-4c0-.897-.727-1.625-1.625-1.625zm-3.5 1.25h2.25V10a.375.375 0 0 1-.375.375H8.5A.375.375 0 0 1 8.125 10z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePen3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.5 2a2 2 0 1 1 4 0v.349h.75A1.75 1.75 0 0 1 14 4.099v4a.75.75 0 0 1-1.5 0v-4a.25.25 0 0 0-.25-.25h-.75v.026h-4zm0 9V5.125h4V11a1 1 0 0 1-1 1h-.25v1.25a.75.75 0 0 1-1.5 0V12H8.5a1 1 0 0 1-1-1M4.768.732A2.5 2.5 0 0 1 5.5 2.5v1.375h-5V2.5A2.5 2.5 0 0 1 4.768.732M.5 11.1V5.125h5V11.1a.5.5 0 0 1-.116.32l-2 2.4a.5.5 0 0 1-.768 0l-2-2.4A.5.5 0 0 1 .5 11.1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePenDraw: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.64 7.86c.785-1.097 3.164-4.214 5.947-5.967c2.093-1.318 4.07.422 2.537 2.174c-1.499 1.714-3.51 4.073-4.368 5.244c-.89 1.214.633 2.682 2.157 1.285c1.019-.934 2.08-2.008 3.158-2.802c1.456-1.071 2.705-.125 2.07 1.082c-.46.873-.793 1.258-1.176 1.993c-.384.734.022 1.615.603 1.69c.72.094 1.176-.423 1.791-1.228\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePenDrawRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M.624 7.862c.786-1.1 3.17-4.225 5.962-5.982c2.099-1.322 4.08.423 2.543 2.18C7.626 5.778 5.611 8.143 4.75 9.317c-.892 1.217.635 2.69 2.163 1.288c1.02-.936 2.085-2.013 3.166-2.809c1.46-1.074 2.712-.126 2.075 1.085c-.46.875-.795 1.261-1.18 1.998c-.384.736.023 1.619.606 1.695c.722.093 1.179-.424 1.796-1.231\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePenDrawSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.61 2.66c-.227-.198-.817-.365-1.602.129c-2.508 1.58-4.693 4.43-5.432 5.463a.75.75 0 1 1-1.22-.873c.75-1.047 3.078-4.112 5.853-5.86C7.41.763 8.75.795 9.594 1.527c.421.365.685.89.688 1.486c.004.591-.246 1.177-.702 1.698c-1.427 1.632-3.312 3.845-4.104 4.925c-.104.142-.111.25-.102.312c.01.07.047.135.11.183a.4.4 0 0 0 .299.067c.14-.017.36-.094.628-.339c.226-.208.461-.43.703-.657c.745-.701 1.55-1.46 2.356-2.053c.838-.616 1.818-.787 2.561-.333c.371.227.632.59.722 1.024c.09.43.005.878-.212 1.29c-.233.442-.434.76-.615 1.046l-.014.023a11 11 0 0 0-.485.819a.5.5 0 0 0-.024.415c.024.06.047.089.06.101c.092.007.172-.016.299-.114c.178-.139.377-.374.676-.766a.75.75 0 0 1 1.192.911c-.285.373-.594.764-.948 1.04c-.392.304-.867.488-1.444.413c-.633-.082-1.048-.57-1.231-1.037a2 2 0 0 1 .09-1.658c.19-.364.37-.647.541-.916l.022-.034c.176-.279.35-.556.554-.942c.085-.162.077-.255.071-.284a.07.07 0 0 0-.036-.051c-.043-.027-.347-.138-.89.262c-.726.533-1.433 1.2-2.16 1.884q-.382.362-.775.723c-.923.846-2.047.959-2.838.367c-.77-.576-.981-1.68-.32-2.582c.837-1.142 2.767-3.405 4.185-5.026l.513.448l-.513-.448c.271-.31.332-.555.331-.702a.47.47 0 0 0-.171-.362m2.863 8.883l-.003-.002q.003 0 .003.002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePenTool: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.881 4.754L.607 12.82a.5.5 0 0 0 .572.572l8.067-1.274a1 1 0 0 0 .838-.877L10.5 7.5l-4-4l-3.742.416a1 1 0 0 0-.877.838M6.5 3.5l2-3m2 7l3-2M1 13l4-4M4 8l2 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePenToolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.55.002a.5.5 0 0 0-.471.229L6.304 2.893l-3.606.4a1.625 1.625 0 0 0-1.428 1.38L.104 12.62c-.11.745.53 1.385 1.276 1.276l7.947-1.166a1.625 1.625 0 0 0 1.38-1.428l.4-3.606l2.67-1.78a.5.5 0 0 0 .22-.466v-.017l-.009-.075a6 6 0 0 0-.264-1.141A6.25 6.25 0 0 0 12.23 1.77A6.25 6.25 0 0 0 9.783.276A6 6 0 0 0 8.642.012L8.567.004zM4.655 7.095L5.78 8.22l1.125 1.125a.75.75 0 1 1-1.06 1.06l-.595-.594l-2.642 2.641l6.538-.958c.168-.025.3-.16.318-.33l.382-3.434L6.27 4.154l-3.434.382a.375.375 0 0 0-.33.318l-.959 6.538L4.19 8.75l-.594-.595a.75.75 0 0 1 1.06-1.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePenToolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.308.922L6.75 3q.07.053.134.116l4 4q.063.063.116.134l2.078-1.558a1 1 0 0 0 .107-1.507L9.815.815a1 1 0 0 0-1.507.107M1.381 5.254L.166 12.95L3.116 10l-.308-.308a.625.625 0 0 1 .884-.884l1.5 1.5a.625.625 0 0 1-.884.884L4 10.884l-2.95 2.95l7.696-1.215a1 1 0 0 0 .838-.877L10 8L6 4l-3.742.416a1 1 0 0 0-.877.838\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePencil: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 12.24L.5 13.5L1.76 9L10 .8a1 1 0 0 1 1.43 0l1.77 1.78a1 1 0 0 1 0 1.42z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePencilRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m1.606 8.472l-.981 4.905l4.905-.98l7.56-7.561a.98.98 0 0 0 0-1.387L10.553.912a.98.98 0 0 0-1.387 0z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePencilSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M10.715-.001a1.5 1.5 0 0 0-1.07.449L1.407 8.645a.5.5 0 0 0-.128.22l-1.26 4.5a.5.5 0 0 0 .616.616l4.5-1.26a.5.5 0 0 0 .22-.128l8.197-8.238l.002-.001a1.5 1.5 0 0 0 0-2.128l-.002-.001L11.786.449a1.5 1.5 0 0 0-1.071-.45\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePentagon: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.232 6.67a1 1 0 0 0-.282-1.136L7.646 1.047a1 1 0 0 0-1.292 0L1.05 5.534A1 1 0 0 0 .768 6.67l2.48 6.202a1 1 0 0 0 .929.629h5.646a1 1 0 0 0 .928-.629z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePentagonRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m6.337.961l-5.32 4.706a1 1 0 0 0-.272 1.104l2.26 5.959a1 1 0 0 0 .935.645h6.12a1 1 0 0 0 .935-.645l2.26-5.96a1 1 0 0 0-.272-1.103L7.663.961a1 1 0 0 0-1.326 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePentagonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.969.665a1.5 1.5 0 0 0-1.938 0L.727 5.153a1.5 1.5 0 0 0-.424 1.702l2.481 6.202A1.5 1.5 0 0 0 4.177 14h5.646a1.5 1.5 0 0 0 1.393-.943l2.48-6.202a1.5 1.5 0 0 0-.423-1.702z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetPaw: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 9.5c.552 0 1-.672 1-1.5s-.448-1.5-1-1.5s-1 .672-1 1.5s.448 1.5 1 1.5m3-4.5c.552 0 1-.672 1-1.5S5.052 2 4.5 2s-1 .672-1 1.5s.448 1.5 1 1.5m5 0c.552 0 1-.672 1-1.5S10.052 2 9.5 2s-1 .672-1 1.5s.448 1.5 1 1.5m3 4.5c.552 0 1-.672 1-1.5s-.448-1.5-1-1.5s-1 .672-1 1.5s.448 1.5 1 1.5M10 10c0 1.38-1.62 2-3 2s-3-.62-3-2s1-3.5 3-3.5s3 2.12 3 3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetPawRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.627 1.662C3.867 1.302 4.255 1 4.75 1s.883.301 1.123.662c.243.364.377.839.377 1.338s-.134.974-.377 1.338c-.24.36-.628.662-1.123.662s-.883-.301-1.123-.662C3.384 3.974 3.25 3.499 3.25 3s.134-.974.377-1.338M1.5 4.75c-.495 0-.883.301-1.123.662C.134 5.776 0 6.251 0 6.75s.134.974.377 1.338c.24.36.628.662 1.123.662s.883-.301 1.123-.662C2.866 7.724 3 7.249 3 6.75s-.134-.974-.377-1.338c-.24-.36-.628-.662-1.123-.662M9.25 1c-.495 0-.883.301-1.123.662c-.243.364-.377.839-.377 1.338s.134.974.377 1.338c.24.36.628.662 1.123.662s.883-.301 1.123-.662c.243-.364.377-.839.377-1.338s-.134-.974-.377-1.338C10.133 1.302 9.745 1 9.25 1m2.127 4.412c.24-.36.628-.662 1.123-.662s.883.301 1.123.662c.243.364.377.839.377 1.338s-.134.974-.377 1.338c-.24.36-.628.662-1.123.662s-.883-.301-1.123-.662C11.134 7.724 11 7.249 11 6.75s.134-.974.377-1.338m-7.252 5.156c0-.613.245-1.435.747-2.095C5.362 7.83 6.066 7.375 7 7.375s1.638.454 2.128 1.098c.502.66.747 1.482.747 2.095c0 .439-.26.81-.814 1.103c-.561.298-1.33.454-2.061.454s-1.5-.156-2.061-.454c-.555-.294-.814-.664-.814-1.103M7 6.125c-1.4 0-2.446.702-3.122 1.591c-.665.873-1.003 1.96-1.003 2.852c0 1.067.686 1.788 1.478 2.208c.787.417 1.769.599 2.647.599s1.86-.182 2.647-.6c.792-.42 1.478-1.14 1.478-2.207c0-.892-.338-1.979-1.003-2.852C9.446 6.826 8.4 6.125 7 6.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetPawSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1.5c-.495 0-.883.301-1.123.662C3.134 2.526 3 3.001 3 3.5s.134.974.377 1.338c.24.36.628.662 1.123.662s.883-.301 1.123-.662C5.866 4.474 6 3.999 6 3.5s-.134-.974-.377-1.338c-.24-.36-.628-.662-1.123-.662m5 0c-.495 0-.883.301-1.123.662C8.134 2.526 8 3.001 8 3.5s.134.974.377 1.338c.24.36.628.662 1.123.662s.883-.301 1.123-.662c.243-.364.377-.839.377-1.338s-.134-.974-.377-1.338c-.24-.36-.628-.662-1.123-.662M1.5 6c-.495 0-.883.301-1.123.662C.134 7.026 0 7.501 0 8s.134.974.377 1.338c.24.36.628.662 1.123.662s.883-.301 1.123-.662C2.866 8.974 3 8.499 3 8s-.134-.974-.377-1.338C2.383 6.302 1.995 6 1.5 6M7 6c-1.2 0-2.089.644-2.657 1.443C3.782 8.23 3.5 9.207 3.5 10c0 .924.555 1.567 1.236 1.952c.67.38 1.51.548 2.264.548s1.594-.167 2.264-.548c.68-.386 1.236-1.028 1.236-1.952c0-.793-.282-1.77-.843-2.557C9.09 6.643 8.201 6 7 6m5.5 0c-.495 0-.883.301-1.123.662C11.134 7.026 11 7.501 11 8s.134.974.377 1.338c.24.36.628.662 1.123.662s.883-.301 1.123-.662C13.866 8.974 14 8.499 14 8s-.134-.974-.377-1.338C13.383 6.302 12.995 6 12.5 6\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetriDishLabEquipment: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0\"/><path d=\"M2.529 7.664c.286-.139.994-.312 1.535.105s.554 1.146.493 1.458c-.06.312-.047 1.04.494 1.457c.54.417 1.249.244 1.535.105M8.833 6.5A1.667 1.667 0 1 0 7.32 4.137a1.25 1.25 0 1 0 .385 1.922a1.66 1.66 0 0 0 1.13.441M8.25 9a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m-5-3a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m7 5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetriDishLabEquipmentRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M3.22 8.133a1.1 1.1 0 0 0-.42.093a.625.625 0 1 1-.544-1.125a2.4 2.4 0 0 1 .926-.217c.381-.012.848.07 1.263.39s.614.75.7 1.122c.085.365.072.715.026.95a1.1 1.1 0 0 0 .016.43c.04.174.12.316.245.413a.7.7 0 0 0 .463.131a1.1 1.1 0 0 0 .419-.093a.625.625 0 0 1 .544 1.125c-.216.104-.55.206-.925.218a1.95 1.95 0 0 1-1.264-.39a1.95 1.95 0 0 1-.7-1.123a2.4 2.4 0 0 1-.025-.95a1.1 1.1 0 0 0-.017-.429c-.04-.174-.119-.317-.245-.414s-.283-.136-.463-.131m5.613-5.466c-.71 0-1.34.342-1.734.868A1.75 1.75 0 1 0 7.73 6.7a2.167 2.167 0 1 0 1.102-4.032M2.5 5.25a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m5 3.5a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0m2 1a.75.75 0 1 1 1.5 0a.75.75 0 0 1-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetriDishLabEquipmentSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m8.833-.5A1.667 1.667 0 1 0 7.32 4.137a1.25 1.25 0 1 0 .385 1.922a1.66 1.66 0 0 0 1.13.441Zm-5.07 2.196a.5.5 0 0 0-.187.04a.625.625 0 0 1-.545-1.126c.167-.08.416-.155.694-.164a1.5 1.5 0 0 1 .965.3c.321.248.472.58.536.857c.063.27.054.53.018.712a.5.5 0 0 0 .01.19c.018.08.049.124.081.149c.033.025.082.043.165.04a.5.5 0 0 0 .186-.039a.625.625 0 1 1 .545 1.125a1.8 1.8 0 0 1-.693.164a1.5 1.5 0 0 1-.966-.3a1.5 1.5 0 0 1-.536-.856a1.8 1.8 0 0 1-.018-.713a.5.5 0 0 0-.01-.19c-.018-.08-.049-.123-.081-.148c-.033-.025-.082-.044-.165-.041ZM8 7.49a.875.875 0 1 0 0 1.75a.875.875 0 0 0 0-1.75M2.664 5.084a.875.875 0 1 1 1.75 0a.875.875 0 0 1-1.75 0m7.586 3.871a.875.875 0 1 0 0 1.75a.875.875 0 0 0 0-1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetsAllowed: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.75 11.018v-7.59l1.254 1.004c.633.506 1.42.782 2.23.782H7L8.292 2.63a1.79 1.79 0 0 1 1.597-.987h.682v2.232l2.679.893v.893c0 .986-.8 1.785-1.786 1.785H9.68v3.572a1.34 1.34 0 1 1-2.679 0v-.447c0-.493-.4-.892-.893-.892H4.321c-.493 0-.892.4-.892.892v.447a1.34 1.34 0 1 1-2.679 0\"/><path d=\"M7.012 5.097c.175.717 1 2.195 2.895 2.375\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetsAllowedRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.66.875c-.941 0-1.811.505-2.278 1.323L6.137 4.375H3.292a1.37 1.37 0 0 1-.825-.275L1 3a.625.625 0 0 0-1 .5v7.75a1.875 1.875 0 0 0 3.75 0v-1.125h2.625v1.125a1.875 1.875 0 0 0 3.75 0V8.125h1.25A2.625 2.625 0 0 0 14 5.5V5a.625.625 0 0 0-.42-.59l-2.455-.854V1.5A.625.625 0 0 0 10.5.875zM8.468 2.818c.245-.429.7-.693 1.194-.693h.214V4c0 .266.168.503.42.59l2.455.854V5.5c0 .76-.616 1.375-1.375 1.375H9c-.983 0-1.79-.757-1.869-1.72zm-2.53 2.807H3.293A2.62 2.62 0 0 1 1.718 5.1l-.467-.35v6.5a.625.625 0 1 0 1.25 0V9.5c0-.345.28-.625.625-.625H7c.345 0 .625.28.625.625v1.75a.625.625 0 1 0 1.25 0V8.123a3.126 3.126 0 0 1-2.937-2.498\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePetsAllowedSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.171 3.108a2.17 2.17 0 0 1 1.94-1.2h.733a.25.25 0 0 1 .25.25v2.22l2.708.902a.25.25 0 0 1 .17.237v.96a2.17 2.17 0 0 1-2.168 2.168h-1.67v.002C9.11 8.43 8.35 7.853 7.8 7.173a5.7 5.7 0 0 1-.884-1.554zM5.637 5.747H4.035a3.6 3.6 0 0 1-2.242-.787L.446 3.882a.25.25 0 0 0-.406.196v8.155a1.69 1.69 0 1 0 3.378 0v-.48a.71.71 0 0 1 .71-.709h1.919a.71.71 0 0 1 .71.71v.48a1.69 1.69 0 1 0 3.378 0V9.917c-1.49-.239-2.57-1.05-3.307-1.958a6.9 6.9 0 0 1-1.19-2.213\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePharmacy: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.532 8.384l-.221-1.97a1 1 0 0 1 .993-1.112h9.392a1 1 0 0 1 .993 1.112l-.221 1.97a4 4 0 0 1-1.966 3.012c.17.305.288.645.343 1.008a.748.748 0 0 1-.74.858h-6.21a.748.748 0 0 1-.74-.858c.055-.363.173-.703.342-1.008a4 4 0 0 1-1.965-3.012m5.937-3.103l2.373-3.72a1.2 1.2 0 0 1 1.644-.372v0c.569.355.736 1.107.37 1.67L10.281 5.28m-5.03 4.002H8.75M7 7.534v3.497\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePharmacyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.129.28a1.85 1.85 0 0 0-2.52.548L6.405 4.75H2.444c-.933 0-1.66.81-1.56 1.736l.209 2.342l.001.015a4.4 4.4 0 0 0 1.692 2.996a3.5 3.5 0 0 0-.157.634A1.33 1.33 0 0 0 3.945 14h5.86a1.33 1.33 0 0 0 1.316-1.528a3.5 3.5 0 0 0-.157-.633a4.4 4.4 0 0 0 1.692-2.997l.001-.015l.209-2.342a1.57 1.57 0 0 0-1.078-1.66l.933-2A1.85 1.85 0 0 0 12.13.28M5.25 8.657a.625.625 0 1 0 0 1.25h1.124v1.124a.625.625 0 0 0 1.25 0V9.907H8.75a.625.625 0 0 0 0-1.25H7.625V7.534a.625.625 0 0 0-1.25 0v1.123zM2.127 6.354a.32.32 0 0 1 .317-.355h8.862a.32.32 0 0 1 .317.355l-.001.014l-.209 2.34a3.15 3.15 0 0 1-1.547 2.365a.625.625 0 0 0-.232.844c.124.224.211.473.251.74a.08.08 0 0 1-.08.093h-5.86a.08.08 0 0 1-.08-.092c.04-.268.127-.517.251-.741a.625.625 0 0 0-.232-.844A3.15 3.15 0 0 1 2.337 8.71l-.208-2.34z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePharmacySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.103 1.072L8.135 4.156h3.083l1.084-1.668a1.308 1.308 0 1 0-2.2-1.417M1.067 8.847l-.29-2.58a1 1 0 0 1 .994-1.111h10.458a1 1 0 0 1 .994 1.112l-.29 2.58a4 4 0 0 1-2.055 3.062c.156.307.266.643.32 1a.816.816 0 0 1-.808.937H3.61a.816.816 0 0 1-.808-.937a3.3 3.3 0 0 1 .32-1a4 4 0 0 1-2.055-3.063m6.558-1.275a.625.625 0 1 0-1.25 0v1.304H5.071a.625.625 0 1 0 0 1.25h1.304v1.305a.625.625 0 1 0 1.25 0v-1.304h1.304a.625.625 0 0 0 0-1.25H7.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.248 12.982a3.184 3.184 0 0 1-3.992-.44l-.449-.438a1.08 1.08 0 0 1 0-1.507L2.713 8.71a1.07 1.07 0 0 1 1.497 0a1.08 1.08 0 0 0 1.507 0L8.71 5.717a1.06 1.06 0 0 0 0-1.507a1.07 1.07 0 0 1 0-1.497L10.607.817a1.08 1.08 0 0 1 1.507 0l.439.45a3.184 3.184 0 0 1 .439 3.99a28.9 28.9 0 0 1-7.744 7.725\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneContactPhonebookPhonebookPhoneNumberBooksBook: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 13.5H2a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1ZM4 .5v13M7.5 4h2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneMobilePhone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5.5h-7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M6.5 11h1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneMobilePhoneAndroidPhoneMobileDeviceSmartphoneIphone: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"13\" x=\"2\" y=\".5\" rx=\"1\"/><path d=\"M6.25 11h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneMobilePhoneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.211 1.606c0-.197.16-.356.356-.356h6.866c.196 0 .355.16.355.356v10.788a.355.355 0 0 1-.355.356H3.567a.356.356 0 0 1-.356-.356zM3.567 0C2.68 0 1.961.719 1.961 1.606v10.788c0 .887.72 1.606 1.606 1.606h6.866c.886 0 1.605-.719 1.605-1.606V1.606C12.038.719 11.32 0 10.433 0zM6.51 9.798a.875.875 0 1 0 0 1.75h.98a.875.875 0 0 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneMobilePhoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 1.75a.25.25 0 0 1 .25-.25h6.5a.25.25 0 0 1 .25.25v10.5a.25.25 0 0 1-.25.25H3.802l-.017-.008a.8.8 0 0 1-.162-.106a.5.5 0 0 1-.123-.147zM3.75 0A1.75 1.75 0 0 0 2 1.75v10.5c0 .592.361 1.032.65 1.278c.156.133.328.243.498.322c.154.073.37.15.602.15h6.5A1.75 1.75 0 0 0 12 12.25V1.75A1.75 1.75 0 0 0 10.25 0zM6.5 9.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneModeAirplaneServerPlaneAirplaneDisableWirelessModeInternetNetwork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.39 10.61H1.94a1.45 1.45 0 0 1 0-2.89h2.3l1.48-1.48l-4.06-2.5a1.45 1.45 0 0 1-.52-1.91a1.47 1.47 0 0 1 2-.77l5.3 2.45L11 .92A1.45 1.45 0 0 1 13.08 3l-2.59 2.56l2.45 5.35a1.46 1.46 0 0 1-.77 1.95a1.45 1.45 0 0 1-1.91-.52l-2.5-4.06l-1.48 1.48v2.3a1.45 1.45 0 0 1-2.89 0Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneQr: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 4.5V3h1m3 5.5h1v-1M6 8.5V7H4.5M8 3h1.5v2.5m-3-.5l1 .5\"/><path d=\"M10.5.5h-7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M6.5 11h1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneQrRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.567 1.25a.356.356 0 0 0-.356.356v10.788c0 .197.16.356.356.356h6.866c.196 0 .355-.16.355-.356V1.606a.356.356 0 0 0-.355-.356zm-1.606.356C1.961.719 2.681 0 3.567 0h6.866c.886 0 1.605.719 1.605 1.606v10.788c0 .887-.719 1.606-1.605 1.606H3.567a1.606 1.606 0 0 1-1.606-1.606zm1.962 1.47c0-.344.28-.624.625-.624h.98a.625.625 0 0 1 0 1.25h-.355v.846a.625.625 0 1 1-1.25 0zm5.529 3.79c.345 0 .625.28.625.624v.981c0 .345-.28.625-.625.625H8.47a.625.625 0 1 1 0-1.25h.356V7.49c0-.345.28-.625.625-.625m-4.904-.491a.625.625 0 1 0 0 1.25h.846v.846a.625.625 0 1 0 1.25 0V7a.625.625 0 0 0-.625-.625zm2.808-3.298c0-.345.28-.625.625-.625h1.47c.346 0 .626.28.626.625v2.452a.625.625 0 0 1-1.25 0V3.702H7.98a.625.625 0 0 1-.625-.625M6.789 4.48a.625.625 0 1 0-.559 1.118l.98.49a.625.625 0 0 0 .56-1.118zm-.28 5.318a.875.875 0 1 0 0 1.75h.981a.875.875 0 0 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneQrSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 1.5a.25.25 0 0 0-.25.25v10.489l.01.021a.5.5 0 0 0 .113.126a.8.8 0 0 0 .179.114H10.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25zm-1.75.25C2.25.784 3.034 0 4 0h6.5c.967 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 10.5 14H4a1.4 1.4 0 0 1-.602-.15c-.17-.08-.342-.19-.498-.322c-.289-.246-.65-.686-.65-1.278zm2.325 1.606c0-.345.28-.625.625-.625h.82a.625.625 0 1 1 0 1.25h-.195v.605a.625.625 0 0 1-1.25 0zM9.3 6.422c.346 0 .625.28.625.625v.82c0 .345-.28.625-.625.625h-.82a.625.625 0 1 1 0-1.25h.195v-.195c0-.345.28-.625.625-.625m-4.1-.265a.625.625 0 0 0 0 1.25h.46v.46a.625.625 0 1 0 1.25 0V6.782a.625.625 0 0 0-.626-.625zm2.245-2.8c0-.346.28-.626.625-.626H9.3c.346 0 .625.28.625.625v1.76a.625.625 0 1 1-1.25 0V3.981H8.07a.625.625 0 0 1-.625-.625M7.206 4.68a.625.625 0 1 0-.559 1.118l.646.323a.625.625 0 1 0 .56-1.118zM6.75 9.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.452.48a1.68 1.68 0 0 0-2.352 0l-.005.005l-1.863 1.866a1.675 1.675 0 0 0 0 2.346l.007.007a.414.414 0 0 1 0 .59l-.004.004l-2.933 2.938a.43.43 0 0 1-.601-.002l-.437.446l.438-.445a1.67 1.67 0 0 0-2.345 0l-.001.001l-1.877 1.86a1.684 1.684 0 0 0 0 2.354l.01.01l.437.427a3.745 3.745 0 0 0 4.695.514l.01-.007a29 29 0 0 0 7.763-7.755l.008-.012a3.755 3.755 0 0 0-.513-4.7zm-.878.89l.432.442a2.504 2.504 0 0 1 .349 3.132a27.7 27.7 0 0 1-7.418 7.41a2.49 2.49 0 0 1-3.125-.348l-.008-.008l-.434-.425a.435.435 0 0 1 0-.6l1.864-1.847a.423.423 0 0 1 .591 0h.001a1.68 1.68 0 0 0 2.353 0l.005-.004l2.935-2.94A1.664 1.664 0 0 0 9.12 3.82a.425.425 0 0 1 .001-.59l1.854-1.858a.43.43 0 0 1 .598-.002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneRinging1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.51 13.07a2.7 2.7 0 0 1-3.37-.36l-.38-.38a.91.91 0 0 1 0-1.28l1.6-1.59a.9.9 0 0 1 1.27 0v0a.91.91 0 0 0 1.28 0l2.55-2.55a.91.91 0 0 0 0-1.28v0a.9.9 0 0 1 0-1.27L11 2.76a.91.91 0 0 1 1.28 0l.38.38a2.7 2.7 0 0 1 .41 3.37a24.2 24.2 0 0 1-6.56 6.56M7 .5A6.5 6.5 0 0 0 .5 7M7 3a4 4 0 0 0-4 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneRinging1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.896.787a.75.75 0 0 0-.75-.75A7.125 7.125 0 0 0 .021 7.162a.75.75 0 0 0 1.5 0a5.625 5.625 0 0 1 5.625-5.625a.75.75 0 0 0 .75-.75m4.741 1.61a1.526 1.526 0 0 0-2.134 0l-.011.011l-1.507 1.566c-.395.4-.519.973-.372 1.482l2.535-1.927l.238-.247a.27.27 0 0 1 .179-.07zm-1.072.815l1.072-.815l.003.003l.369.37a3.3 3.3 0 0 1 .482 4.099a24.4 24.4 0 0 1-6.603 6.603l-.011.007a3.3 3.3 0 0 1-4.085-.437l-.373-.373l-.003-.002a1.526 1.526 0 0 1 0-2.134l.004-.004l1.569-1.56l.315-.239l-.315.24q.145-.143.315-.24l4.309-3.274l2.535-1.927zm0 0l-.417.317l-1.266 1.315l-.007.008a.267.267 0 0 0 0 .363l.001.002c.58.586.58 1.548 0 2.134l-.002.003l-2.501 2.5l-.003.003c-.586.58-1.547.58-2.134 0l-.001-.001a.267.267 0 0 0-.364 0l-1.567 1.557a.277.277 0 0 0 0 .374l.001.001l.37.37a2.05 2.05 0 0 0 2.52.273a23.1 23.1 0 0 0 6.253-6.251a2.05 2.05 0 0 0-.313-2.517l-.007-.007l-.37-.37a.27.27 0 0 0-.193-.074M8.613 5.456c.067.236.193.457.376.641l.443-.44l-.444.439c.098.1.098.276 0 .375L6.491 8.97a.277.277 0 0 1-.375 0a1.52 1.52 0 0 0-1.812-.239zM7.146 2.489a.75.75 0 1 1 0 1.5a3.173 3.173 0 0 0-3.173 3.173a.75.75 0 0 1-1.5 0A4.673 4.673 0 0 1 7.146 2.49\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneRinging1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.052.86a.75.75 0 0 0-.75-.75a7.25 7.25 0 0 0-7.25 7.25a.75.75 0 1 0 1.5 0a5.75 5.75 0 0 1 5.75-5.75a.75.75 0 0 0 .75-.75m-1.074 12.6a2.7 2.7 0 0 1-3.37-.36l-.38-.38a.91.91 0 0 1 0-1.28l1.6-1.59a.9.9 0 0 1 1.27 0a.91.91 0 0 0 1.28 0l2.55-2.55a.91.91 0 0 0 0-1.28a.9.9 0 0 1 0-1.27l1.54-1.6a.91.91 0 0 1 1.28 0l.38.38a2.7 2.7 0 0 1 .41 3.37a24.2 24.2 0 0 1-6.56 6.56m.638-10.457a.75.75 0 0 1 0 1.5a3.25 3.25 0 0 0-3.25 3.25a.75.75 0 0 1-1.5 0a4.75 4.75 0 0 1 4.75-4.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneRinging2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.632 1.438h-5.99a.856.856 0 0 0-.856.855v9.414c0 .472.383.855.855.855h5.99a.856.856 0 0 0 .856-.855V2.293a.856.856 0 0 0-.855-.855m-3.423 8.985h.855m7.206-6.631c1.556 1.772 1.556 4.645 0 6.416m-1.666-5.25c.778 1.128.778 2.956 0 4.084\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneRinging2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.606 1.625c-.084 0-.231.088-.231.298v10.154c0 .21.147.298.23.298h5.991c.084 0 .23-.088.23-.298v-1.288a.625.625 0 1 1 1.25 0v1.288c0 .81-.618 1.548-1.48 1.548h-5.99c-.862 0-1.481-.739-1.481-1.548V1.923c0-.81.62-1.548 1.48-1.548h5.991c.862 0 1.48.739 1.48 1.548V3.25a.625.625 0 1 1-1.25 0V1.923c0-.21-.146-.298-.23-.298zm1.692 8.548c0-.483.392-.875.875-.875h.856a.875.875 0 0 1 0 1.75h-.856a.875.875 0 0 1-.875-.875m7.972-5.886c1.307 1.488 1.307 3.938 0 5.427a.75.75 0 1 0 1.127.99c1.804-2.056 1.804-5.352 0-7.407a.75.75 0 0 0-1.127.99M9.395 8.455c.468-.824.466-2.076-.003-2.914a.75.75 0 0 1 1.31-.733c.719 1.287.73 3.098-.004 4.388a.75.75 0 1 1-1.303-.741M7.297 6.682a.73.73 0 0 1 .003.632a.75.75 0 1 0 1.304.742c.358-.63.35-1.484.002-2.107a.75.75 0 1 0-1.309.733\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneRinging2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.536 2.582c0-.045.036-.082.081-.082H7.44c.046 0 .082.037.082.082v9.149a.08.08 0 0 1-.082.081H1.617a.08.08 0 0 1-.081-.081zM1.617 1C.744 1 .036 1.708.036 2.582v9.149c0 .873.708 1.581 1.581 1.581H7.44c.874 0 1.582-.708 1.582-1.581V2.58A1.583 1.583 0 0 0 7.44 1zm2.495 8.733a.75.75 0 1 0 0 1.5h.832a.75.75 0 0 0 0-1.5zm7.638-.223c1.134-1.292 1.134-3.416 0-4.707a.625.625 0 0 1 .94-.825c1.547 1.764 1.547 4.593 0 6.356a.625.625 0 1 1-.94-.824M9.864 5.75c.249.362.392.868.392 1.405s-.143 1.044-.392 1.405a.625.625 0 0 0 1.029.71c.42-.61.613-1.378.613-2.115s-.192-1.504-.613-2.115a.625.625 0 0 0-1.03.71\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneSignalFullPhoneMobileDeviceSignalWirelessSmartphoneIphoneBarBarsFullAndroid: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.75 7.5H.5v6h4.25m4.5-9h-4.5v9h4.5m0-13h4.25v13H9.25z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneSignalLowPhoneMobileDeviceSignalWirelessSmartphoneIphoneBarLowBarsAndroid: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7.5h4.25v6H.5zm10.5 6h2.5m-8.75 0H8.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneSignalMediumSmartphonePhoneMobileDeviceIphoneSignalMediumWirelessBarBarsAndroid: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.75 7.5H.5v6h4.25m0-9h4.5v9h-4.5zm4.5 9h4.25\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneSignalNonePhoneMobileDeviceSignalWirelessSmartphoneIphoneBarBarsNoZeroAndroid: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.5H3m8 0h2.5m-8 0h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.17 13.24a3.32 3.32 0 0 1-4.161-.457l-.468-.458a1.123 1.123 0 0 1 0-1.57l1.986-1.966a1.113 1.113 0 0 1 1.56 0a1.123 1.123 0 0 0 1.571 0l3.12-3.12a1.103 1.103 0 0 0 0-1.571a1.113 1.113 0 0 1 0-1.56L10.756.56a1.123 1.123 0 0 1 1.57 0l.458.468a3.32 3.32 0 0 1 .458 4.16A30.1 30.1 0 0 1 5.17 13.24\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePhoneTelephoneAndroidPhoneMobileDeviceSmartphoneIphone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.76 13a3.19 3.19 0 0 0 4-.44l.45-.44a1.08 1.08 0 0 0 0-1.51L11.3 8.72a1.07 1.07 0 0 0-1.5 0h0a1.08 1.08 0 0 1-1.51 0l-3-3a1.06 1.06 0 0 1 0-1.51h0a1.07 1.07 0 0 0 0-1.5L3.39.81a1.08 1.08 0 0 0-1.51 0l-.44.45a3.19 3.19 0 0 0-.44 4A28.94 28.94 0 0 0 8.76 13Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePiSymbolCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.25A6.25 6.25 0 1 0 7 .75a6.25 6.25 0 0 0 0 12.5\"/><path d=\"M4 5.75c.088-.333.43-.872 1.053-1C5.832 4.59 10 4 10 4\"/><path d=\"M6 4.594C6 5.844 5.981 8.737 5 10m3.5-5.781v5.255c0 .175.12.526.6.526s.8-.351.9-.526\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePiSymbolCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m2.962 4.619a.625.625 0 1 0-.175-1.238L9.875 4l-.088-.619h-.003l-.009.002l-.035.005l-.134.019a440 440 0 0 0-2.003.29c-1.13.165-2.39.356-2.801.44c-.924.191-1.403.967-1.531 1.454a.625.625 0 1 0 1.208.318a.8.8 0 0 1 .185-.316a.7.7 0 0 1 .39-.23q.074-.016.19-.037a19 19 0 0 1-.122 1.89c-.126 1.028-.363 1.914-.74 2.4a.625.625 0 1 0 .987.767c.603-.777.866-1.968.994-3.015c.1-.815.127-1.625.134-2.243c.395-.06.828-.124 1.253-.187v4.536c0 .205.065.485.262.725c.218.266.552.426.963.426c.79 0 1.282-.56 1.443-.842a.625.625 0 0 0-1.086-.619l-.01.014l-.028.035a.6.6 0 0 1-.091.082a.4.4 0 0 1-.203.079V4.756l.3-.043l.482-.069l.134-.019l.035-.004l.008-.002zL9.875 4z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePiSymbolCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.25 7a6.75 6.75 0 1 1 13.5 0A6.75 6.75 0 0 1 .25 7m10.369-3.088a.625.625 0 0 0-.707-.53L10 4l-.088-.619h-.003l-.009.002l-.035.005l-.134.019a440 440 0 0 0-2.003.29c-1.13.165-2.39.356-2.801.44c-.924.191-1.403.967-1.531 1.454a.625.625 0 1 0 1.208.318a.8.8 0 0 1 .185-.316a.7.7 0 0 1 .39-.23q.074-.016.19-.037c-.01.556-.04 1.225-.121 1.89c-.127 1.028-.364 1.915-.742 2.4a.625.625 0 1 0 .988.767c.603-.777.866-1.968.994-3.015c.1-.815.127-1.625.135-2.243c.394-.06.827-.124 1.252-.187v4.536c0 .205.065.485.262.725c.218.266.552.426.963.426c.79 0 1.282-.56 1.443-.842a.625.625 0 0 0-1.086-.619l-.01.014l-.028.035a.6.6 0 0 1-.091.082a.4.4 0 0 1-.203.079V4.756l.782-.112l.134-.019l.035-.004l.009-.002h.002L10 4l.087.619a.625.625 0 0 0 .532-.707\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePicturesFolderMemories: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.901 13.25L5.3 8.004a.54.54 0 0 0-.688 0L.516 10.95M9.86 7.88a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3\"/><path d=\"M.5 12.25V1.75a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.31 1.24h6a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePicturesFolderMemoriesRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2.625c0-.207.168-.375.375-.375h3.22c.171 0 .321.117.363.284l.31 1.243c.07.278.32.473.607.473h6.25c.207 0 .375.168.375.375v6.75a.375.375 0 0 1-.375.375H9.216L5.3 8.004a.54.54 0 0 0-.688 0L1.25 10.412zM1.625 1C.728 1 0 1.728 0 2.625v8.75C0 12.273.728 13 1.625 13h10.75c.898 0 1.625-.727 1.625-1.625v-6.75C14 3.728 13.273 3 12.375 3H6.613l-.192-.77A1.625 1.625 0 0 0 4.844 1zm8.234 7.38a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePicturesFolderMemoriesSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.177.813A1.46 1.46 0 0 0 5.26.516H1.734A1.457 1.457 0 0 0 .276 1.974v10.053a1.46 1.46 0 0 0 1.458 1.458h10.532a1.46 1.46 0 0 0 1.458-1.458V3.89a1.46 1.46 0 0 0-1.458-1.458H6.912l-.202-.807a1.46 1.46 0 0 0-.533-.811ZM9.86 7.566a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-4.298-.351l5.466 5.02H1.734a.21.21 0 0 1-.208-.208V9.53L4.81 7.215a.595.595 0 0 1 .752 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePieChart: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M7 .5V7l4.6 4.6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePieChartRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.751 5.751 0 1 0 4.067 9.817L7.293 7.293A1 1 0 0 1 7 6.586zM7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePieChartSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375.028A7 7 0 1 0 11.64 12.24L6.57 7.454A.63.63 0 0 1 6.376 7zm6.124 11.304A7 7 0 0 0 7.625.027v6.704z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePiggyBank: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.896 2.681c.254.68.736 1.195 1.229 1.56m4.625.661H4.896m4.938 1.502a.25.25 0 1 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/><path d=\"M10.604 1.277V3.35c1.563.65 1.844 1.761 1.844 3.213l.875.719v2.219c-.516 1.109-1.469 1.687-2.719 2.13v.984a.5.5 0 0 1-.5.5h-1.75a.5.5 0 0 1-.5-.5v-.984h-3.14v.906a.5.5 0 0 1-.5.5H2.448a.5.5 0 0 1-.5-.5v-1.77c0-.047-.092-.303-.211-.699C1.389 8.91.81 6.954 1.642 5.112c.697-1.543 2.383-2.721 6.025-2.517c.522-1.38 1.906-1.741 2.612-1.71c.201.01.325.19.325.392\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePiggyBankRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.062.876c-.731-.022-2.129.28-2.87 1.48c-2.091-.28-3.523-.065-4.544.468a4 4 0 0 0-.92.66a3.3 3.3 0 0 1-.517-.938a.625.625 0 0 0-1.172.435c.22.591.518 1.1.914 1.512q-.159.278-.282.538C.136 6.136.061 7.496.193 8.782c.133 1.299.485 2.597.878 3.63c.168.441.591.713 1.043.713h1.832c.621 0 1.125-.504 1.125-1.125v-.46h2.03V12c0 .621.503 1.125 1.124 1.125h1.653c.621 0 1.125-.504 1.125-1.125v-.646c1.122-.438 2.131-1.108 2.848-1.95A.63.63 0 0 0 14 9V7.254a.63.63 0 0 0-.3-.533L12.518 6c-.042-.59-.192-1.115-.466-1.573a3.3 3.3 0 0 0-1.05-1.065V1.896c0-.43-.294-1-.94-1.02M8.123 3.274c.306-.753 1.066-1.07 1.63-1.136v1.58c0 .231.127.443.33.552c.423.225.71.487.896.799s.302.723.302 1.29c0 .217.113.42.3.533l1.169.713v1.156c-.63.666-1.534 1.22-2.568 1.56a.625.625 0 0 0-.43.594v.96H8.35v-.96a.625.625 0 0 0-.625-.625H4.446a.625.625 0 0 0-.625.625v.96H2.205a13.5 13.5 0 0 1-.768-3.22c-.122-1.184-.03-2.275.36-3.08c.318-.658.685-1.255 1.429-1.643c.759-.396 2.014-.628 4.22-.276a.625.625 0 0 0 .677-.382m-.622 2.128a.875.875 0 0 1-.875.875H4.77a.875.875 0 1 1 0-1.75h1.855c.483 0 .875.392.875.875m1.208.752a.875.875 0 1 0 .875-.875a.875.875 0 0 0-.875.875\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePiggyBankSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.349 2.08C8.059.705 9.53.352 10.302.387c.553.025.802.516.802.89V3.03c.7.352 1.169.822 1.457 1.407c.283.577.369 1.225.384 1.889l.695.57a.5.5 0 0 1 .183.387v2.219a.5.5 0 0 1-.047.21c-.548 1.179-1.519 1.816-2.672 2.267v.637a1 1 0 0 1-1 1h-1.75a1 1 0 0 1-1-1v-.484h-2.14v.406a1 1 0 0 1-1 1H2.447a1 1 0 0 1-1-1v-1.716l-.038-.121l-.02-.063l-.132-.425l-.005-.015C.91 9.055.273 6.932 1.186 4.907a4 4 0 0 1 .23-.442C.944 4.09.47 3.563.208 2.859a.625.625 0 0 1 1.17-.437c.165.44.476.798.829 1.075a4.7 4.7 0 0 1 1.127-.75c.997-.477 2.31-.724 4.015-.666Zm.026 2.822c0 .345-.28.625-.625.625H4.896a.625.625 0 1 1 0-1.25H6.75c.346 0 .625.28.625.625m2.459 2.017a.766.766 0 1 0 0-1.53a.766.766 0 0 0 0 1.53\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlanet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.73 2.21C10.82.8 12.56.15 13.2.8c1 1-1.04 4.56-4.44 8s-7 5.44-8 4.44c-.657-.657-.02-2.455 1.491-4.592\"/><path d=\"M5.44 11.754A5 5 0 0 0 7 12a5 5 0 0 0 4.736-6.613M3 10a5 5 0 0 1 7-7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlanetRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.918 2.19c.55-.29 1.043-.49 1.459-.598c.715-.185.964-.046 1.02.01c.041.04.14.188.09.616c-.05.418-.232.978-.569 1.652c-.67 1.34-1.876 2.98-3.472 4.575S5.21 11.247 3.87 11.917c-.674.337-1.234.52-1.651.569c-.429.05-.576-.048-.617-.09c-.056-.056-.195-.305-.01-1.02c.108-.416.308-.909.599-1.458q.143.235.309.457a.625.625 0 1 0 1-.75A4.375 4.375 0 0 1 9.625 3.5a.625.625 0 1 0 .75-1q-.222-.165-.457-.31m-1.77-.696C9.164.839 10.145.362 11.002.14c.835-.217 1.807-.25 2.457.401c.505.505.595 1.21.518 1.854c-.078.655-.338 1.39-.716 2.146q-.316.63-.751 1.306a5.63 5.63 0 0 1-2.812 6.09A5.6 5.6 0 0 1 7 12.626V12v.625q-.583 0-1.152-.118q-.677.436-1.307.752c-.757.378-1.49.639-2.146.716c-.644.077-1.349-.013-1.854-.517c-.65-.651-.618-1.622-.401-2.457c.221-.857.699-1.838 1.353-2.852A5.624 5.624 0 0 1 8.15 1.494m-.701 9.859a4.376 4.376 0 0 0 3.909-3.91a25 25 0 0 1-1.85 2.063a25 25 0 0 1-2.06 1.847\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlanetSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.368.011c.401.012.83.13 1.16.465c.507.509.518 1.227.402 1.817c-.121.62-.42 1.322-.83 2.05q-.327.585-.76 1.217a5.5 5.5 0 0 1-2.68 6.246a5.56 5.56 0 0 1-4.012.5a16 16 0 0 1-1.289.807c-.733.407-1.439.702-2.061.82c-.594.113-1.313.097-1.82-.41c-.334-.335-.455-.769-.468-1.177c-.012-.404.077-.837.22-1.27c.271-.81.782-1.753 1.462-2.74A5.5 5.5 0 0 1 8.4 1.652C9.385 1 10.325.494 11.13.227c.42-.14.842-.227 1.238-.216m-2.315 2.377q.135.09.269.19l.003.002l.451.344c-.76 1.285-1.975 2.829-3.49 4.363c-1.49 1.507-3.008 2.708-4.282 3.465l-.371-.46l-.011-.014a6 6 0 0 1-.208-.297c-.358.596-.613 1.128-.76 1.57c-.112.337-.15.585-.144.749c.003.1.02.145.028.16c.023.012.142.063.48 0c.402-.077.949-.29 1.613-.659q.548-.304 1.157-.723c1.088-.773 2.252-1.765 3.386-2.913s2.123-2.317 2.896-3.407q.418-.605.722-1.148c.372-.663.588-1.207.667-1.606c.065-.333.016-.45.004-.47a.4.4 0 0 0-.14-.023c-.154-.005-.392.03-.72.14c-.436.144-.96.393-1.55.737\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList4: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M5.23 9.23V4.91a.41.41 0 0 1 .62-.35l3.7 2.15a.41.41 0 0 1 0 .71l-3.7 2.16a.41.41 0 0 1-.62-.35\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList4Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.923 1.625a.3.3 0 0 0-.298.298v10.154c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V1.923a.3.3 0 0 0-.298-.298zm-1.548.298c0-.855.693-1.548 1.548-1.548h10.154c.855 0 1.548.693 1.548 1.548v10.154c0 .855-.693 1.548-1.548 1.548H1.923a1.55 1.55 0 0 1-1.548-1.548zM5.23 9.23h-.5V4.907a.91.91 0 0 1 1.373-.778L9.8 6.277a.91.91 0 0 1 .001 1.575v.001l-3.697 2.158a.91.91 0 0 1-1.374-.778z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList4Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5zm4.954 3.146v4.848a.46.46 0 0 0 .696.392L9.8 7.463a.46.46 0 0 0 0-.797L5.65 4.254a.46.46 0 0 0-.696.392\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList5: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.35 8.5a1.35 1.35 0 1 0 0-2.7a1.35 1.35 0 0 0 0 2.7\"/><path d=\"M8.49 5a3 3 0 0 0-2.8-2v4.15\"/><path d=\"M10 .5H1.5a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1\"/><path d=\"M13.5 3.5v9a1 1 0 0 1-1 1h-9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList5Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.929 1.625a.304.304 0 0 0-.304.304V9.82c0 .168.136.304.304.304H9.82a.304.304 0 0 0 .304-.304V1.93a.304.304 0 0 0-.304-.304zm-1.554.304c0-.858.696-1.554 1.554-1.554H9.82c.858 0 1.554.696 1.554 1.554v.821h.696c.79 0 1.429.64 1.429 1.429v7.892c0 .79-.64 1.429-1.429 1.429H4.18c-.79 0-1.429-.64-1.429-1.429v-.696H1.93A1.554 1.554 0 0 1 .375 9.821zm5.456.821a.625.625 0 0 0-.631.625v2.11A1.73 1.73 0 0 0 3 7.149a1.727 1.727 0 1 0 3.45-.137V4.103a2.1 2.1 0 0 1 1.33 1.298a.625.625 0 1 0 1.179-.416A3.35 3.35 0 0 0 5.83 2.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList5Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.475C0 .661.66 0 1.475 0h8.29c.815 0 1.476.66 1.476 1.475v8.29c0 .815-.66 1.476-1.476 1.476h-8.29A1.477 1.477 0 0 1 0 9.765zm2.406 6.13a1.756 1.756 0 0 1 2.011-1.737V2.63a.75.75 0 0 1 .75-.75c.95 0 1.875.34 2.567.968c.694.629 1.1 1.499 1.1 2.424a.75.75 0 1 1-1.5 0c0-.477-.207-.95-.607-1.313a2.2 2.2 0 0 0-.81-.462v4.108a1.756 1.756 0 0 1-3.511 0M13.97 3.5a.75.75 0 0 0-1.5 0v8.748a.22.22 0 0 1-.222.222H3.5a.75.75 0 0 0 0 1.5h8.748a1.72 1.72 0 0 0 1.722-1.722z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList8: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 .5H1.5a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1H10a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1\"/><path d=\"M13.5 3.5v9a1 1 0 0 1-1 1h-9m.25-5.86V3.86a.36.36 0 0 1 .55-.31l3.27 1.89a.36.36 0 0 1 0 .62L4.3 8a.36.36 0 0 1-.55-.36\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList8Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.929c0-.168.136-.304.304-.304H9.82c.168 0 .304.136.304.304V9.82a.304.304 0 0 1-.304.304H1.93a.304.304 0 0 1-.304-.304zM1.929.375C1.07.375.375 1.071.375 1.929V9.82c0 .858.696 1.554 1.554 1.554h.821v.696c0 .79.64 1.429 1.429 1.429h7.892c.79 0 1.429-.64 1.429-1.429V4.18c0-.79-.64-1.429-1.429-1.429h-.696V1.93c0-.858-.696-1.554-1.554-1.554zm1.72 7.385l.5.008h-.5v-.003a.852.852 0 0 0 1.288.74l3.235-1.884a.852.852 0 0 0 0-1.48L4.938 3.246a.852.852 0 0 0-1.29.757v3.762zm0-3.757v.015l.5-.024h-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList8Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.49.03C.675.03.015.69.015 1.505v8.29c0 .815.66 1.475 1.475 1.475h8.29c.815 0 1.476-.66 1.476-1.475v-8.29A1.476 1.476 0 0 0 9.78.03zm2.296 7.66V3.61a.387.387 0 0 1 .585-.33l3.494 2.03a.387.387 0 0 1 0 .67L4.371 8.02a.387.387 0 0 1-.585-.33m10.2-4.16a.75.75 0 0 0-1.5 0v8.748a.22.22 0 0 1-.223.222H3.515a.75.75 0 0 0 0 1.5h8.748a1.72 1.72 0 0 0 1.722-1.722V3.53Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList9: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.688 5.656a1 1 0 0 1 1-1h7.75a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-7.75a1 1 0 0 1-1-1z\"/><path d=\"M10.5 2.875v-.281a1 1 0 0 0-1-1H1.75a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h.188M7.5 6.781l3 1.875l-3 1.875z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList9Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.125 2.606a1.5 1.5 0 0 1 1.5-1.5h7.563a1.5 1.5 0 0 1 1.5 1.5v1.317h1.706c.887 0 1.606.719 1.606 1.606v5.885c0 .886-.719 1.605-1.606 1.605h-7.6a1.606 1.606 0 0 1-1.606-1.606V9.952H1.625a1.5 1.5 0 0 1-1.5-1.5zm4.313 2.923c0-.197.159-.356.355-.356h7.601c.197 0 .356.16.356.356v5.885c0 .196-.16.355-.356.355h-7.6a.356.356 0 0 1-.356-.356zm3.379.68a.5.5 0 0 0-.765.423v3.678a.5.5 0 0 0 .765.424l2.942-1.839a.5.5 0 0 0 0-.848z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayList9Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.031 1.924a1 1 0 0 1 1-1h8.71a1 1 0 0 1 1 1v1.114H4.259a2.25 2.25 0 0 0-2.25 2.25v4.424h-.977a1 1 0 0 1-1-1zm3.227 3.364a1 1 0 0 1 1-1h8.71a1 1 0 0 1 1 1v6.788a1 1 0 0 1-1 1h-8.71a1 1 0 0 1-1-1zm3.674 1.593a.5.5 0 0 1 .765-.424l2.882 1.801a.5.5 0 0 1 0 .848l-2.882 1.801a.5.5 0 0 1-.765-.424z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayListFolder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 12h-4a1 1 0 0 1-1-1V1.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.28 1.24h6a1 1 0 0 1 1 1v2m-4.22 8a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\"/><path d=\"M10.5 12.25V7.5a2.83 2.83 0 0 1 3 2.77\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayListFolderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 1.606c0-.197.16-.356.356-.356h3.157c.163 0 .306.111.345.27l.305 1.218c.07.278.32.474.606.474h6.375c.197 0 .356.159.356.355v2.537a.625.625 0 1 0 1.25 0V3.567c0-.887-.719-1.605-1.606-1.605H6.507l-.186-.746A1.606 1.606 0 0 0 4.763 0H1.606C.719 0 0 .719 0 1.606v8.827c0 .887.719 1.606 1.606 1.606h4.413a.625.625 0 0 0 0-1.25H1.606a.356.356 0 0 1-.356-.356zm6.337 10.543a1.726 1.726 0 0 1 2.22-1.654V7.49c0-.33.258-.604.588-.623A3.4 3.4 0 0 1 14 10.195a.625.625 0 1 1-1.25.024a2.15 2.15 0 0 0-1.692-2.06v3.99q0 .1-.03.19a1.726 1.726 0 0 1-3.441-.19\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayListFolderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.183.75a1.5 1.5 0 0 1 1.492 1.14l.215.86h5.61a1.5 1.5 0 0 1 1.5 1.5v2.975a5 5 0 0 0-.253-.248a4.83 4.83 0 0 0-3.24-1.228a2 2 0 0 0-2 2V9.6a2.926 2.926 0 0 0-1.698 3.65H1.5a1.5 1.5 0 0 1-1.5-1.5v-9.5A1.5 1.5 0 0 1 1.5.75zm4.795 6.468a.75.75 0 0 1 .53-.22a3.58 3.58 0 0 1 2.4.906a3.07 3.07 0 0 1 1.031 2.273a.75.75 0 1 1-1.5 0c0-.42-.183-.84-.538-1.161a2 2 0 0 0-.643-.385v3.691a1.675 1.675 0 1 1-1.5-1.666V7.75a.75.75 0 0 1 .22-.53\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayStation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.225 13.254V.746L9.85 1.905c3.04.912 2.96 5.734 0 4.924l-1.676-.541\"/><path d=\"M8.062 13.254L12.31 11.9c2.692-.954.303-3.496-2.093-2.649l-2.155.788M4.426 8.463L1.696 9.7c-2.634 1.008-.452 3.46 2.057 2.649l.673-.274\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayStationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.874.118a.63.63 0 0 1 .563-.086l3.55 1.18c1.811.567 2.65 2.322 2.64 3.767c-.006.728-.226 1.477-.752 1.99c-.557.541-1.35.714-2.25.458l-.029-.01l-1.643-.55A.625.625 0 0 1 8.35 5.68l1.63.547c.542.15.844.02 1.023-.156c.213-.206.37-.59.374-1.103c.008-1.038-.603-2.203-1.768-2.566l-.01-.004l-2.734-.908v11.884a.625.625 0 1 1-1.25 0V.625c0-.2.096-.39.26-.507m8.052 10.722c-.2.612-.756 1.046-1.509 1.313l-.019.007l-4.167 1.327a.625.625 0 1 1-.38-1.19l4.158-1.325c.56-.2.699-.427.729-.52c.026-.08.024-.23-.158-.441c-.377-.436-1.276-.787-2.213-.456l-2.11.77a.625.625 0 1 1-.43-1.173l2.114-.773l.006-.002c1.411-.5 2.857-.02 3.579.817c.368.426.603 1.022.4 1.646M.088 10.133c.208-.588.742-1.022 1.47-1.303l2.66-1.206a.625.625 0 1 1 .516 1.138L2.057 9.976l-.035.014c-.555.213-.715.448-.755.56c-.032.092-.03.234.13.425c.333.401 1.195.76 2.206.441l.637-.26a.625.625 0 0 1 .471 1.158l-.66.269l-.043.016c-1.441.466-2.87.022-3.573-.825c-.361-.435-.562-1.03-.347-1.641\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayStationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.459.09a.75.75 0 0 0-.978.713V5.71q0 .038.003.074l-.003.076v7.355a.75.75 0 0 0 1.5 0V5.86q0-.03-.003-.06V2.854a.625.625 0 0 1 1.25 0v4.268l1.376.432l.027.008c.934.255 1.775.088 2.374-.473c.567-.531.801-1.306.807-2.047c.012-1.472-.876-3.237-2.761-3.806zM4.233 7.845l-2.539 1.15c-.751.292-1.326.75-1.552 1.388c-.235.668-.013 1.312.371 1.775c.743.893 2.23 1.35 3.72.878v-1.615l-.463.189c-.981.307-1.8-.047-2.103-.411c-.141-.17-.126-.272-.11-.316c.024-.068.15-.287.695-.495l.042-.018l1.94-.878zm8.017 4.74l-4.022 1.281v-1.574l3.555-1.132c.548-.197.649-.406.663-.45c.01-.03.03-.142-.136-.334c-.349-.404-1.208-.746-2.112-.428l-1.97.72V9.071l1.46-.533l.007-.003c1.472-.52 2.987-.023 3.75.86c.39.452.65 1.097.428 1.78c-.218.668-.821 1.126-1.6 1.402z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayStore: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.859 11.981V1.741c0-.672.79-1.098 1.434-.771L12.37 6.09c.662.336.662 1.207 0 1.543l-10.077 5.12c-.644.327-1.434-.099-1.434-.772M9.23 9.23l-8.1-8.101m8.1 3.364l-8.1 8.1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayStoreRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2.332v9.335L6.292 7zm7.744 6.33l2.851-1.448c.123-.063.155-.15.155-.214s-.032-.151-.155-.214L9.37 5.337L7.706 7zM2.716.555C1.739.059.375.655.375 1.883v10.234c0 1.227 1.364 1.824 2.34 1.328l10.072-5.117a1.472 1.472 0 0 0 0-2.656z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePlayStoreSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.352 1.305q0-.038.003-.073l5.63 5.629l-5.63 5.63l-.003-.073zM1.61 13.357q.15-.029.298-.102l6.943-3.527l-1.806-1.806zm6.496-6.496l2.152 2.152l2.586-1.314c.719-.365.719-1.31 0-1.675L10.257 4.71zm.745-2.866L1.908.468A1.1 1.1 0 0 0 1.61.366L7.045 5.8z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePodium: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 8.5H2l-1-5h12l-1 5H9m-2-5v-3m-2 6v7m4-7v7m-5 0h6m-7.5-10s0-3 2-3m7 3s0-3-2-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePodiumRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.483 0 .875.392.875.875V3.25h2.375V1.875a.125.125 0 0 0-.125-.125h-.5a.875.875 0 1 1 0-1.75h.5C11.161 0 12 .84 12 1.875V3.25h.5a.625.625 0 0 1 .613.748l-1 5a.625.625 0 0 1-.613.502H9.625v3.25H10A.625.625 0 1 1 10 14H4a.625.625 0 1 1 0-1.25h.375V9.5H2.5a.625.625 0 0 1-.613-.502l-1-5A.625.625 0 0 1 1.5 3.25H2V1.875C2 .839 2.84 0 3.875 0h.5a.875.875 0 0 1 0 1.75h-.5a.125.125 0 0 0-.125.125V3.25h2.375V.875C6.125.392 6.517 0 7 0M5.625 12.75h2.75V6.875a.625.625 0 1 1 1.25 0V8.25h1.363l.75-3.75H2.262l.75 3.75h1.363V6.875a.625.625 0 1 1 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePodiumSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a.75.75 0 0 1 .75.75V3h2.5L9.212 1.443L10.25 3h.42a4 4 0 0 0-.131-.513C10.32 1.835 10.002 1.5 9.5 1.5q-.154 0-.288-.057L8.75.75A.75.75 0 0 1 9.5 0c1.498 0 2.179 1.165 2.462 2.013c.118.354.187.702.227.987H13a.5.5 0 0 1 .49.598l-1 5A.5.5 0 0 1 12 9H9.5v3.5h.5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.5V9H2a.5.5 0 0 1-.49-.402l-1-5A.5.5 0 0 1 1 3h.811c.04-.285.11-.633.227-.987C2.321 1.165 3.002 0 4.5 0a.75.75 0 1 1 0 1.5c-.502 0-.821.335-1.038.987c-.058.172-.1.348-.131.513H6.25V.75A.75.75 0 0 1 7 0m2.212 1.443A.75.75 0 0 1 8.75.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolaroidFour: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.25.5H1a.5.5 0 0 0-.5.5v4.25a.5.5 0 0 0 .5.5h4.25a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5M13 .5H8.75a.5.5 0 0 0-.5.5v4.25a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5M5.25 8.25H1a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h4.25a.5.5 0 0 0 .5-.5V8.75a.5.5 0 0 0-.5-.5m7.75 0H8.75a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5V8.75a.5.5 0 0 0-.5-.5M.5 3.5h5.25m2.5 0h5.25m-5.25 7.75h5.25m-13 0h5.25\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolaroidFourRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.625V4H5.25V1.625zM.375 1.5C.375.879.879.375 1.5.375h3.875C5.996.375 6.5.879 6.5 1.5v3.875c0 .621-.504 1.125-1.125 1.125H1.5A1.125 1.125 0 0 1 .375 5.375zm12 2.5V1.625H8.75V4zM5.25 11.125H1.625V8.75H5.25zm3.5 0h3.625V8.75H8.75zM8.625.375C8.004.375 7.5.879 7.5 1.5v3.875c0 .621.504 1.125 1.125 1.125H12.5c.621 0 1.125-.504 1.125-1.125V1.5c0-.621-.504-1.125-1.125-1.125zM7.5 8.625c0-.621.504-1.125 1.125-1.125H12.5c.621 0 1.125.504 1.125 1.125V12.5c0 .621-.504 1.125-1.125 1.125H8.625A1.125 1.125 0 0 1 7.5 12.5zM1.5 7.5C.879 7.5.375 8.004.375 8.625V12.5c0 .621.504 1.125 1.125 1.125h3.875c.621 0 1.125-.504 1.125-1.125V8.625c0-.621-.504-1.125-1.125-1.125z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolaroidFourSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.36 5.458c0 .574-.464 1.039-1.038 1.039H1.178A1.04 1.04 0 0 1 .14 5.458v-4.42C.14.466.604 0 1.18 0h4.143c.574 0 1.039.465 1.039 1.039zM1.613 1.486h3.276v2.518H1.612zM6.361 12.96c0 .573-.465 1.038-1.039 1.038H1.178A1.04 1.04 0 0 1 .14 12.96V8.54c0-.573.465-1.038 1.04-1.038h4.143c.574 0 1.039.465 1.039 1.038zM1.612 8.987h3.276v2.519H1.612zM12.822 14a1.04 1.04 0 0 0 1.039-1.04V8.54c0-.573-.465-1.038-1.039-1.038H8.678c-.574 0-1.039.465-1.039 1.038v4.42c0 .574.465 1.039 1.039 1.039zm-.434-5.012H9.112v2.519h3.276zm1.473-3.529c0 .574-.465 1.039-1.039 1.039H8.678a1.04 1.04 0 0 1-1.039-1.039v-4.42A1.04 1.04 0 0 1 8.678 0h4.144c.574 0 1.039.465 1.039 1.039zM9.11 1.486h3.277v2.518H9.112z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsCompaign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.484 3.563h11.04M1.39 10.277h11.235M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0m2.948-1.145v1.062m0 0L2.74 7.98m.708-1.063l.709 1.063m-.709-1.063l-1.062-.354m1.062.354l1.063-.354m2.449-.708v1.062m0 0L6.252 7.98m.708-1.063l.71 1.063m-.71-1.063l-1.062-.354m1.062.354l1.063-.354m2.449-.708v1.062m0 0L9.764 7.98m.708-1.063l.709 1.063m-.709-1.063L9.41 6.563m1.062.354l1.063-.354\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsCompaignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7c0-1.04.276-2.015.759-2.857h9.982c.483.842.759 1.817.759 2.857s-.276 2.015-.759 2.857H2.01A5.7 5.7 0 0 1 1.25 7M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m3.948-1.145a.5.5 0 1 0-1 0v.369l-.404-.135a.5.5 0 1 0-.316.948l.441.148l-.345.517a.5.5 0 1 0 .832.555l.292-.438l.293.438a.5.5 0 0 0 .832-.555l-.345-.517l.441-.148a.5.5 0 1 0-.316-.948l-.405.135zm3.012-.5a.5.5 0 0 1 .5.5v.369l.405-.135a.5.5 0 1 1 .316.948l-.441.148l.345.517a.5.5 0 0 1-.832.555L6.96 7.82l-.292.438a.5.5 0 1 1-.832-.555l.345-.517l-.441-.148a.5.5 0 1 1 .316-.948l.404.135v-.37a.5.5 0 0 1 .5-.5m4.012.5a.5.5 0 1 0-1 0v.369l-.404-.135a.5.5 0 1 0-.316.948l.441.148l-.345.517a.5.5 0 0 0 .832.555l.292-.438l.293.438a.5.5 0 0 0 .832-.555l-.345-.517l.441-.148a.5.5 0 1 0-.316-.948l-.405.135z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsCompaignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m11.537 3.957l.04.059a5.43 5.43 0 0 1 .873 3.356a5.43 5.43 0 0 1-.913 2.671H2.463A5.44 5.44 0 0 1 1.538 7c0-1.127.34-2.173.925-3.043zM7 .037c-2.11 0-4 .938-5.276 2.42H1.71l-.204.264A6.93 6.93 0 0 0 .07 7.672a6.9 6.9 0 0 0 1.416 3.58l.225.291h.013A6.95 6.95 0 0 0 7 13.963c2.11 0 4-.938 5.276-2.42h.013l.225-.292l.115-.153A6.93 6.93 0 0 0 13.962 7a6.93 6.93 0 0 0-1.474-4.285l-.2-.258h-.012A6.95 6.95 0 0 0 7 .037M3.949 5.855a.5.5 0 1 0-1 0v.369l-.405-.135a.5.5 0 1 0-.316.948l.441.148l-.345.517a.5.5 0 1 0 .832.555l.293-.438l.292.438a.5.5 0 1 0 .832-.555l-.345-.517l.441-.148a.5.5 0 1 0-.316-.948l-.404.135zm3.012-.5a.5.5 0 0 1 .5.5v.369l.404-.135a.5.5 0 1 1 .316.948l-.441.148l.345.517a.5.5 0 0 1-.832.555L6.96 7.82l-.293.438a.5.5 0 1 1-.832-.555l.345-.517l-.441-.148a.5.5 0 1 1 .316-.948l.405.135v-.37a.5.5 0 0 1 .5-.5m4.012.5a.5.5 0 0 0-1 0v.369l-.405-.135a.5.5 0 1 0-.316.948l.441.148l-.345.517a.5.5 0 0 0 .832.555l.293-.438l.292.438a.5.5 0 0 0 .832-.555l-.345-.517l.441-.148a.5.5 0 0 0-.316-.948l-.404.135z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsSpeech: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 3.77A1.604 1.604 0 1 0 7 .564A1.604 1.604 0 0 0 7 3.77M1.959 6.979H12.04m-9.165 0l.459 6.416m7.791-6.416l-.459 6.416M7 8.59l.59 1.195l1.318.192l-.954.93l.225 1.313L7 11.6l-1.18.62l.226-1.313l-.954-.93l1.318-.192zM10 7a3 3 0 0 0-6 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsSpeechRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a2.25 2.25 0 1 0 0 4.5A2.25 2.25 0 0 0 7 0m3.642 8.086a3.698 3.698 0 0 0-7.283 0H1.624a.625.625 0 0 0 0 1.25h.777l.393 4.099a.625.625 0 0 0 1.245-.12l-.383-3.98h6.688l-.382 3.98a.625.625 0 1 0 1.244.12l.394-4.1h.777a.625.625 0 1 0 0-1.25zM7 10.01a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsSpeechSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 3.36A1.68 1.68 0 1 0 7 0a1.68 1.68 0 0 0 0 3.36M4.359 5.788a2.801 2.801 0 0 1 5.282 0zM1.894 7.035a.75.75 0 0 0 .065 1.497h.891l.36 4.9a.5.5 0 0 0 .498.463h6.584a.5.5 0 0 0 .498-.464l.36-4.899h.891a.75.75 0 0 0 .065-1.497l-.065.003H1.96zM7 8.7a.5.5 0 0 1 .448.279l.262.53l.586.086a.5.5 0 0 1 .277.853l-.424.413l.1.583a.5.5 0 0 1-.725.527L7 11.695l-.524.275a.5.5 0 0 1-.725-.527l.1-.583l-.424-.413a.5.5 0 0 1 .277-.853l.586-.085l.262-.531A.5.5 0 0 1 7 8.699\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsVote2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.406 6.136H2.272a1 1 0 0 0-1 1v3.128h10.907V7.136a1 1 0 0 0-1-1H8.047M1.272 13.3v-3.036h10.907V13.3\"/><path d=\"M9.34 4.843L7.08 7.105a.5.5 0 0 1-.707 0L3.368 4.1a.5.5 0 0 1 0-.707L5.63 1.131a.5.5 0 0 1 .707 0L9.34 4.136a.5.5 0 0 1 0 .707M4.87 8.2h3.71\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsVote2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.922.793a1 1 0 0 1 1.414 0l3.004 3.004a1 1 0 0 1 0 1.414L8.078 7.473a1 1 0 0 1-.12.102H10a.625.625 0 1 1 0 1.25H4a.625.625 0 0 1 0-1.25h2.783a1 1 0 0 1-.119-.102L3.66 4.47a1 1 0 0 1 0-1.414zM.5 7.136V13a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7.136c0-.897-.727-1.625-1.625-1.625h-.692a.625.625 0 1 0 0 1.25h.692c.207 0 .375.168.375.375V9.64H1.75V7.136c0-.207.168-.375.375-.375H3.56a.625.625 0 1 0 0-1.25H2.125C1.228 5.511.5 6.24.5 7.136\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoliticsVote2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.164 6.327l2.262-2.262a.5.5 0 0 0 0-.707L6.422.354a.5.5 0 0 0-.707 0L3.453 2.615a.5.5 0 0 0 0 .708l3.004 3.004a.5.5 0 0 0 .707 0m-4.892-.69h1.727l1.512 1.511h-1.22a.625.625 0 0 0 0 1.25h4.87a.625.625 0 0 0 0-1.25H8.11l1.511-1.512h1.557a1.5 1.5 0 0 1 1.5 1.5v2.617H.772V7.136a1.5 1.5 0 0 1 1.5-1.5m10.407 5.366H.772v2.47a.5.5 0 0 0 .5.5h10.907a.5.5 0 0 0 .5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolkaDotCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M3.8 5.8C3.8 4 5.2 2.5 7 2.5s3.2 1.5 3.2 3.2S8.8 9 7 9c-.8 0-1.6.5-1.9 1.4M5 11l1-5m1.8 5.25a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolkaDotCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.751 7.001a5.751 5.751 0 1 0-11.502 0a5.751 5.751 0 0 0 11.502 0M7 0a7.001 7.001 0 1 1 0 14.002A7.001 7.001 0 0 1 7 0m0 3.411c-1.312 0-2.366 1.097-2.366 2.46a.625.625 0 0 1-1.25 0c0-2.003 1.564-3.71 3.616-3.71c2.04 0 3.616 1.695 3.616 3.616c0 1.896-1.552 3.709-3.616 3.709c-.453 0-.915.262-1.134.755l-.122.612a.625.625 0 1 1-1.226-.245l.082-.41a.6.6 0 0 1 .031-.226l.032-.09l.79-3.947a.625.625 0 1 1 1.225.245l-.435 2.176q.37-.12.757-.12c1.3 0 2.366-1.178 2.366-2.46C9.366 4.52 8.325 3.412 7 3.412m.748 8.178h.007a.859.859 0 0 0-.007-1.717H7.74a.859.859 0 0 0 .007 1.717\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolkaDotCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0M4.284 5.75c0-1.56 1.207-2.82 2.716-2.82c1.521 0 2.716 1.273 2.716 2.715c0 1.467-1.219 2.82-2.716 2.82c-.32 0-.64.059-.942.173l.51-2.557a.625.625 0 1 0-1.225-.245L4.46 10.25l-.036.104a.6.6 0 0 0-.032.235l-.093.466a.625.625 0 1 0 1.226.245l.138-.691c.255-.583.8-.894 1.337-.894c2.26 0 3.966-1.988 3.966-4.07c0-2.107-1.73-3.966-3.966-3.966c-2.25 0-3.966 1.872-3.966 4.07a.625.625 0 1 0 1.25 0m4.409 5.428a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolygon: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.793 13.207a1 1 0 0 1-.707.293H4.914a1 1 0 0 1-.707-.293L.793 9.793A1 1 0 0 1 .5 9.086V4.914a1 1 0 0 1 .293-.707L4.207.793A1 1 0 0 1 4.914.5h4.172a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707v4.172a1 1 0 0 1-.293.707z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolygonRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M9.682 13.08a1 1 0 0 1-.707.293H5.023a1 1 0 0 1-.707-.293L.918 9.683a1 1 0 0 1-.293-.707V5.024a1 1 0 0 1 .293-.707L4.316.92a1 1 0 0 1 .707-.293h3.952a1 1 0 0 1 .707.293l3.398 3.397a1 1 0 0 1 .293.707v3.952a1 1 0 0 1-.293.707z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePolygonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.914 0a1.5 1.5 0 0 0-1.06.44L.439 3.853A1.5 1.5 0 0 0 0 4.914v4.172c0 .398.158.78.44 1.06l3.414 3.415a1.5 1.5 0 0 0 1.06.439h4.172a1.5 1.5 0 0 0 1.06-.44l3.415-3.414A1.5 1.5 0 0 0 14 9.086V4.914a1.5 1.5 0 0 0-.44-1.06L10.147.439A1.5 1.5 0 0 0 9.086 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoolLadder: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5H13a2 2 0 0 1-2-2a2 2 0 0 1-4 0a2 2 0 0 1-4 0a2 2 0 0 1-2 2H.5m2-11a2 2 0 1 1 4 0v7m3-9a2 2 0 0 1 2 2v7m-5-5h5m-5 3h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoolLadderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.375 1c0-.345.28-.625.625-.625c1.174 0 2.125.951 2.125 2.125v.875h3.75V2.5A.875.875 0 0 0 8 1.625a.625.625 0 1 1 0-1.25c1.174 0 2.125.951 2.125 2.125V9a.625.625 0 1 1-1.25 0v-.875h-3.75V9a.625.625 0 1 1-1.25 0V2.5A.875.875 0 0 0 3 1.625A.625.625 0 0 1 2.375 1m6.5 4.125v1.25h-3.75v-1.25zm-4.75 6.25a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-1.607 1.017a.625.625 0 0 0-.893.565v.418c0 .345.28.625.625.625h12c.345 0 .625-.28.625-.625v-.418a.625.625 0 0 0-.893-.565a1.125 1.125 0 0 1-1.607-1.017a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-2.25 0a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePoolLadderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.605 1.524A1.166 1.166 0 0 0 3.44 2.69a.75.75 0 0 1-1.5 0a2.666 2.666 0 1 1 5.331 0v1.165h3.29V2.69a1.166 1.166 0 0 0-1.166-1.166a.75.75 0 0 1 0-1.5A2.666 2.666 0 0 1 12.06 2.69v6.002a.75.75 0 0 1-1.5 0V8.23H7.271v.591a.75.75 0 0 1-1.5 0V2.69a1.166 1.166 0 0 0-1.166-1.166m2.666 5.205h3.29V5.355H7.27zm-5.274 4.102a.5.5 0 0 1 .463.303c.164.384.446.707.805.922c.69.414 1.78.414 2.47 0a2 2 0 0 0 .805-.922a.5.5 0 0 1 .92 0c.164.384.446.707.805.922c.69.414 1.78.414 2.47 0a2 2 0 0 0 .805-.922a.5.5 0 0 1 .922.005a1.85 1.85 0 0 0 1.18 1.063a.5.5 0 0 1 .358.479v.819a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-.82a.5.5 0 0 1 .357-.479a1.85 1.85 0 0 0 1.181-1.062a.5.5 0 0 1 .46-.308\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePopcorn: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m2.56 6l.83 6.62a1 1 0 0 0 1 .88h5.23a1 1 0 0 0 1-.88L11.44 6\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.64 3.12a1.5 1.5 0 0 1 .36-.05l-.04-.01a1.5 1.5 0 0 1 0 3H3a1.5 1.5 0 0 1-1.06-.43a1.5 1.5 0 0 1 1.44-2.51a1.8 1.8 0 0 1-.14-.69A2 2 0 0 1 6.267.787A2 2 0 0 1 7 1.56A2 2 0 0 1 8.76.5a2 2 0 0 1 2.02 1.93a1.8 1.8 0 0 1-.14.69\"/><path d=\"M7 6v7.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePopcornRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.125 2.625a1.375 1.375 0 0 1 2.406-.91a.625.625 0 0 0 .938 0A1.375 1.375 0 0 1 9.827 2.99a.625.625 0 0 0 .716.78q.1-.019.207-.019a1.125 1.125 0 0 1 .936 1.75H2.314A1.125 1.125 0 0 1 3.457 3.77a.625.625 0 0 0 .717-.78a1.4 1.4 0 0 1-.049-.364M1.403 6.368A2.376 2.376 0 0 1 2.877 2.53A2.625 2.625 0 0 1 7 .47a2.625 2.625 0 0 1 4.123 2.059a2.376 2.376 0 0 1 1.474 3.839l-.859 6.229A1.625 1.625 0 0 1 10.128 14H3.873a1.625 1.625 0 0 1-1.61-1.403zm4.847.382v6h1.5v-6z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePopcornSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.402 2.773q-.201.004-.395.054c.1-.236.152-.488.154-.744a2.15 2.15 0 0 0-.676-1.485A2.2 2.2 0 0 0 8.949 0a2.2 2.2 0 0 0-1.124.31c-.34.201-.617.49-.803.834A2.17 2.17 0 0 0 6.219.31a2.21 2.21 0 0 0-2.646.296a2.14 2.14 0 0 0-.668 1.477c.001.256.053.508.153.744a1.65 1.65 0 0 0-1.577.42A1.6 1.6 0 0 0 1 4.393c0 .43.173.841.481 1.145c.308.303.726.463 1.161.463h8.716c.435 0 .853-.17 1.161-.474S13 4.81 13 4.38c0-.429-.173-.84-.481-1.144a1.66 1.66 0 0 0-1.161-.474zm-.044 4.477H7.75V14h1.874a1.5 1.5 0 0 0 1.487-1.302l.732-5.489q-.24.04-.485.041m-8.716 0a3 3 0 0 1-.485-.04l.732 5.488A1.5 1.5 0 0 0 4.376 14H6.25V7.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePorkMeat: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.68 4.883c-.417.51-1.055 1.601-1.055 3.5C.625 11.696 3.686 13 7 13s6.375-1.304 6.375-4.617c0-1.899-.638-2.99-1.055-3.5c-.2-.246-.353-.546-.353-.864V1l-3.15 1.5S7.633 2.22 7 2.22s-1.817.28-1.817.28L2.033 1v3.02c0 .317-.152.617-.353.863\"/><path d=\"M9.938 8.969c0 1.344-1.316 2.156-2.938 2.156s-2.937-.75-2.937-2.156S5.377 6.813 7 6.813s2.938.812 2.938 2.156Z\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.188 5.75a.125.125 0 1 1 0-.25m0 .25a.125.125 0 1 0 0-.25m5.625.25a.125.125 0 1 0 0-.25m0 .25a.125.125 0 1 1 0-.25M6 9.219a.125.125 0 1 1 0-.25m0 .25a.125.125 0 1 0 0-.25m2 .25a.125.125 0 1 0 0-.25m0 .25a.125.125 0 1 1 0-.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePorkMeatRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.28.441a.625.625 0 0 0-.902.497l-.4 4.006A5.7 5.7 0 0 0 .374 7.5c0 3.433 3.018 6.125 6.625 6.125s6.625-2.692 6.625-6.125c0-.913-.216-1.779-.602-2.556l-.4-4.006A.625.625 0 0 0 11.72.44L9.176 1.713c-.683-.22-1.415-.338-2.176-.338s-1.493.119-2.176.338zm-.07 4.744l.322-3.22l1.967.983a.63.63 0 0 0 .494.028A5.8 5.8 0 0 1 7 2.625c.711 0 1.388.125 2.007.351c.161.06.34.05.494-.028l1.967-.983l.322 3.22q.013.12.069.228c.331.634.516 1.34.516 2.087c0 2.642-2.354 4.875-5.375 4.875S1.625 10.142 1.625 7.5c0-.746.185-1.453.516-2.087a.6.6 0 0 0 .069-.228m2.04.565a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m5.75 0A.875.875 0 1 1 10 4a.875.875 0 0 1 0 1.75M7 11c1.657 0 3-1.12 3-2.5S8.657 6 7 6S4 7.12 4 8.5S5.343 11 7 11m-.5-2.875a.625.625 0 1 0-1.25 0v.75a.625.625 0 1 0 1.25 0zM8.125 7.5c.345 0 .625.28.625.625v.75a.625.625 0 1 1-1.25 0v-.75c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePorkMeatSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.248.549A.5.5 0 0 0 1.533 1v3.02c0 .159-.08.35-.24.547C.808 5.16.125 6.362.125 8.383c0 1.842.865 3.15 2.18 3.975C3.591 13.164 5.288 13.5 7 13.5c1.71 0 3.408-.335 4.696-1.142c1.314-.825 2.179-2.133 2.179-3.975c0-2.021-.683-3.223-1.168-3.816c-.16-.197-.24-.388-.24-.548V1a.5.5 0 0 0-.715-.451L8.76 1.974l-.03-.006a17 17 0 0 0-.491-.1c-.375-.07-.87-.148-1.238-.148s-.863.078-1.238.148c-.194.037-.366.073-.49.1l-.03.006zm7.69 8.42c0 1.344-1.316 2.156-2.938 2.156s-2.937-.75-2.937-2.156S5.377 6.813 7 6.813s2.938.812 2.938 2.156M4.188 6.25a.625.625 0 1 1 0-1.25a.625.625 0 0 1 0 1.25m5.625 0a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25M8 9.719a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25m-2.625-.625a.625.625 0 1 1 1.25 0a.625.625 0 0 1-1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePottedFlowerTulip: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 4V.5l3.5 2l3.5-2V4a3.5 3.5 0 1 1-7 0M7 7.5v6m0-1v1h2.5a3 3 0 0 0 3-3V10a.5.5 0 0 0-.5-.5h-2a3 3 0 0 0-3 3M1.5 10v.5a3 3 0 0 0 3 3H7v-1a3 3 0 0 0-3-3H2a.5.5 0 0 0-.5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePottedFlowerTulipRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.81.082a.625.625 0 0 0-.935.543v3.5a4.126 4.126 0 0 0 3.5 4.078v2.337A4 4 0 0 0 3.22 9H1.375a.5.5 0 0 0-.49.595L1.1 10.71a4 4 0 0 0 3.822 3.239l1.94.05A.5.5 0 0 0 7 13.985a.5.5 0 0 0 .138.016l1.94-.051a4 4 0 0 0 3.822-3.24l.216-1.115A.5.5 0 0 0 12.625 9H10.78a4 4 0 0 0-3.155 1.54V8.203a4.126 4.126 0 0 0 3.5-4.078v-3.5a.625.625 0 0 0-.935-.543L7 1.905zm.315 4.043V1.702L6.69 3.168c.192.11.428.11.62 0l2.565-1.466v2.423a2.875 2.875 0 1 1-5.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePottedFlowerTulipSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.249.068a.5.5 0 0 1 .5-.002L7 1.924L10.252.066A.5.5 0 0 1 11 .5V4c0 1.953-1.4 3.579-3.25 3.93v3.086A3 3 0 0 1 10 10h2a.5.5 0 0 1 .5.5v.5a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3v-.5A.5.5 0 0 1 2 10h2c.896 0 1.7.393 2.25 1.016V7.93A4 4 0 0 1 3 4V.5a.5.5 0 0 1 .249-.432\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrayingHand: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v1m3 0l.5-.5M4 1.5L3.5 1m10 12.5h-2.347a4 4 0 0 1-3.984-3.638l-.115-1.266a.94.94 0 0 1 .462-.9v0a.944.944 0 0 1 1.41.66L9.2 10\"/><path d=\"M13.5 9.997h-1.624a1 1 0 0 1-.992-.868l-.628-4.716a1.133 1.133 0 0 0-1.803-.756v0c-.285.214-.453.55-.453.906v2.934M.5 13.5h2.347a4 4 0 0 0 3.984-3.638l.115-1.266a.94.94 0 0 0-.462-.9v0a.944.944 0 0 0-1.41.66L4.8 10\"/><path d=\"M.5 9.996h1.624a1 1 0 0 0 .992-.868l.628-4.715a1.133 1.133 0 0 1 1.803-.757v0c.285.214.453.55.453.906v2.934\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrayingHandRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0c.345 0 .625.28.625.625V1.5a.625.625 0 1 1-1.25 0V.625C6.375.28 6.655 0 7 0m3.942.558a.625.625 0 0 1 0 .884l-.5.5a.625.625 0 1 1-.884-.884l.5-.5a.625.625 0 0 1 .884 0m-7 0a.625.625 0 1 0-.884.884l.5.5a.625.625 0 1 0 .884-.884zm4.367 7.775a.32.32 0 0 0-.632.081l.115 1.267a3.375 3.375 0 0 0 3.36 3.069h2.223a.625.625 0 1 1 0 1.25h-2.222A4.63 4.63 0 0 1 7 11.413A4.63 4.63 0 0 1 2.847 14H.625a.625.625 0 1 1 0-1.25h2.222a3.375 3.375 0 0 0 3.361-3.07l.115-1.266a.32.32 0 0 0-.632-.081l-.274 1.645a.625.625 0 0 1-1.233-.206l.274-1.645c.092-.556.456-.976.917-1.179v-2.51a.508.508 0 0 0-1.011-.068l-.629 4.716a1.625 1.625 0 0 1-1.61 1.41h-1.5a.625.625 0 1 1 0-1.25h1.5a.375.375 0 0 0 .371-.325l.629-4.716a1.758 1.758 0 0 1 3.5.232v2.506A1.6 1.6 0 0 1 7 7.172a1.6 1.6 0 0 1 .375-.229V4.438a1.758 1.758 0 0 1 3.5-.232l.629 4.715a.375.375 0 0 0 .372.326h1.499a.625.625 0 1 1 0 1.25h-1.5a1.625 1.625 0 0 1-1.61-1.41L9.636 4.37a.508.508 0 0 0-1.011.067v2.51c.46.203.825.623.917 1.18l.275 1.644a.625.625 0 0 1-1.233.206z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrayingHandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.75a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zM.5 14h2.32a4 4 0 0 0 3.986-3.667l.11-1.336a.92.92 0 0 0-.789-.988h-.002a1.077 1.077 0 0 0-1.176.917l-.161 1.106a.5.5 0 1 1-.99-.144l.16-1.106A2.08 2.08 0 0 1 6 7.003V5.245a1.344 1.344 0 0 0-2.673-.202L2.629 9.65a1 1 0 0 1-.989.85H.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5m13 0h-2.32a4 4 0 0 1-3.986-3.667l-.11-1.336a.92.92 0 0 1 .794-.989a1.077 1.077 0 0 1 1.173.918l.161 1.105a.5.5 0 1 0 .99-.143l-.16-1.106A2.08 2.08 0 0 0 8 7.002V5.246a1.344 1.344 0 0 1 2.673-.202l.698 4.607a1 1 0 0 0 .989.85h1.14a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5M11.53.72a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 1 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0m-8 0a.75.75 0 0 0-1.06 1.06l1 1a.75.75 0 0 0 1.06-1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrescriptionPillsDrugsHealthcare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5.5v12m0-12h5.75A2.75 2.75 0 0 1 10 3.25v0A2.75 2.75 0 0 1 7.25 6H1.5m3 0l8 7.5m-6.5 0L12.5 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrescriptionPillsDrugsHealthcareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.98.625C.98.28 1.26 0 1.605 0h5.64a3.322 3.322 0 1 1 0 6.644H6.128L9.09 9.421l2.862-2.863a.625.625 0 0 1 .884.884l-2.834 2.834l2.82 2.643a.625.625 0 0 1-.855.912l-2.85-2.67l-2.656 2.656a.625.625 0 1 1-.884-.884l2.628-2.628l-3.904-3.66H2.23v5.75a.625.625 0 1 1-1.25 0zm1.25 4.77h5.015a2.072 2.072 0 1 0 0-4.145H2.23z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrescriptionPillsDrugsHealthcareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.923.25h5.308a3.288 3.288 0 0 1 0 6.577h-.642l2.374 2.226l2.584-2.583a.75.75 0 1 1 1.06 1.06l-2.549 2.55l2.532 2.373a.75.75 0 0 1-1.026 1.094L8.997 11.14l-2.39 2.39a.75.75 0 0 1-1.06-1.06l2.355-2.356l-3.506-3.287H2.673v5.25a.75.75 0 0 1-1.5 0V1a.75.75 0 0 1 .75-.75m5.308 5.077H2.673V1.75h4.558a1.788 1.788 0 1 1 0 3.577\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrinter: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 11h2a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1h2\"/><path d=\"M3.5 9.5V13a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9.5zm7-5V1a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v3.5M11 7h-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrinterRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.205.705c.21-.211.497-.33.795-.33h6A1.125 1.125 0 0 1 11.125 1.5v2.375H12A1.625 1.625 0 0 1 13.625 5.5V10A1.625 1.625 0 0 1 12 11.625h-1.375v.875A1.125 1.125 0 0 1 9.5 13.625h-5A1.125 1.125 0 0 1 3.375 12.5v-.875H2A1.625 1.625 0 0 1 .375 10V5.5A1.625 1.625 0 0 1 2 3.875h.875V1.5c0-.298.119-.585.33-.795m.92 3.17h5.75v-2.25h-5.75zm.5 5.75v2.75h4.75v-2.75zM9.375 6.5c0-.345.28-.625.625-.625h1a.625.625 0 1 1 0 1.25h-1a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePrinterSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.25.5V3h7.5V.5a.5.5 0 0 0-.5-.5h-6.5a.5.5 0 0 0-.5.5m.638 9V13c0 .133.047.26.13.354a.42.42 0 0 0 .314.146h5.336a.42.42 0 0 0 .314-.146a.53.53 0 0 0 .13-.354V9.5zM.45 4.804a1.53 1.53 0 0 1 1.049-.41h11c.388 0 .766.144 1.05.41c.284.267.45.636.45 1.029v4.228c0 .392-.166.761-.45 1.028s-.662.411-1.05.411h-1.138v-2c0-.69-.56-1.25-1.25-1.25H3.888c-.69 0-1.25.56-1.25 1.25v2H1.5c-.388 0-.766-.144-1.05-.41A1.4 1.4 0 0 1 0 10.06V5.833c0-.393.166-.762.45-1.029m8.864 1.444c0-.345.28-.625.625-.625h1.637a.625.625 0 1 1 0 1.25H9.94a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProductionBelt: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.9 8.875h8.2a2.305 2.305 0 0 1 0 4.61H2.9a2.305 2.305 0 0 1 0-4.61m7.545-7.379h-7c-.351 0-.636.254-.636.568v6.243c0 .314.285.568.636.568h7c.351 0 .636-.254.636-.568V2.064c0-.314-.285-.568-.636-.568\"/><path d=\"M8.218 1.496v2.838a.27.27 0 0 1-.093.2a.34.34 0 0 1-.225.084H5.99a.34.34 0 0 1-.224-.083a.27.27 0 0 1-.093-.2v-2.84M3.735 11.43a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m3.265.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m3.265.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProductionBeltRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.434 1.622v6.127l.011.001h7.011V1.621H8.468v2.212a.77.77 0 0 1-.26.574a.84.84 0 0 1-.558.21H6.24c-.199 0-.4-.07-.557-.21a.77.77 0 0 1-.26-.574V1.621H3.434m-1.25 6.185q0 .084.01.163a2.938 2.938 0 0 0 1.119 5.655h7.374A2.938 2.938 0 0 0 11.7 7.929q.006-.06.006-.122V1.564c0-.724-.633-1.193-1.261-1.193h-7c-.627 0-1.261.469-1.261 1.193zM3.312 9h7.376a1.687 1.687 0 1 1 0 3.375H3.311a1.687 1.687 0 1 1 0-3.375m-.327 1.688a.75.75 0 1 0 1.5 0a.75.75 0 0 0-1.5 0m3.265 0a.75.75 0 1 0 1.5 0a.75.75 0 0 0-1.5 0m3.265 0a.75.75 0 1 0 1.5 0a.75.75 0 0 0-1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProductionBeltSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.294 1.125h2.365c.373 0 .675.27.675.602v5.984H2.646l-.097.001V1.727c0-.333.302-.602.676-.602H5.59v3.014c0 .08.036.156.1.213a.36.36 0 0 0 .238.088h2.028a.36.36 0 0 0 .239-.088a.3.3 0 0 0 .099-.213zM2.646 8.96h8.708a2.448 2.448 0 0 1 0 4.895H2.646a2.448 2.448 0 1 1 0-4.895m1.761 2.44a.875.875 0 1 1-1.75 0a.875.875 0 0 1 1.75 0m3.473 0a.875.875 0 1 1-1.75 0a.875.875 0 0 1 1.75 0m2.597.874a.875.875 0 1 0 0-1.75a.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserAddAppCodeAppsAddProgrammingWindowPlus: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-4 5h-5M7 6v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserBuildBuildWebsiteDevelopmentWindowCodeProgrammingWebBackendBrowserDev: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 7.5v5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h4v7Zm-13-4h13m-3.5 4v-7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserCheckCheckmarkPassWindowAppCodeProgrammingSuccessCheckApps: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13M4 9l2 1.5l3.5-4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserCode1CodeBrowserLineShellProgrammingCommandTerminal: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 4h13M4 7l1.5 1.5L4 10m4.5-1.5h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserCode2CodeBrowserTagsAngleProgrammingBracket: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 4h13m-9 3L3 8.5L4.5 10M10 7l1.5 1.5L10 10m-3.5.5L8 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserDashboardAppCodeAppsProgrammingWindowDashboardPerformance: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-6.5 7L10.5 7m0 3.5h1M7 7V6M4.53 8.03l-.71-.71M3.5 10.5h-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserDeleteAppCodeAppsFailDeleteWindowRemove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-4.5 7l-4-4m4 0l-4 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserFavoriteHeartWindowAppCodeFavoriteLikeProgrammingHeartApps: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13M7 7.5c1-2 3-1 3 .5c0 2-3 3-3 3s-3-1-3-3c0-1.5 2-2.5 3-.5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserFavoriteStarWindowStarAppCodeFavoriteLikeProgrammingApps: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 13.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m-12-10h13\"/><path d=\"M6.45 7.37a.59.59 0 0 1 1.1 0L8.19 9H9.9a.6.6 0 0 1 .4 1l-1.51 1.36l.64 1.28a.58.58 0 0 1-.12.69a.61.61 0 0 1-.7.1L7 12.55l-1.61.88a.61.61 0 0 1-.7-.1a.58.58 0 0 1-.12-.69l.64-1.28L3.7 10a.6.6 0 0 1 .4-1h1.71Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserHashWindowHashCodeProgrammingInternetLanguageBrowserWebTag: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 13.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m-12-10h13m-7 3l-2 7m5-7l-2 7m3-5H4m6 3H3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserKeySecurePasswordWindowBrowserKeySecurityLogin: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6.44\" cy=\"11.33\" r=\"2.17\"/><path d=\"m8 9.8l3.86-3.86a.36.36 0 0 1 .51 0l1.13 1.15m-3.05.28l1.02 1.02M2 12.5h-.5a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1V4m-13-.5h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserMultipleWindowAppCodeAppsTwoProgrammingWindowCascade: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 5V1.5a1 1 0 0 1 1-1h8.5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H11m-8-7h10.5\"/><rect width=\"8\" height=\"6\" x=\".5\" y=\"7.5\" rx=\"1\"/><path d=\"M.5 10h8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserRemoveAppCodeAppsSubtractProgrammingWindowMinus: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M.5 3.5h13m-4 5h-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserSearchSearchWindowGlassAppCodeProgrammingQueryFindMagnifyingApps: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 12.5h-4a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v5m-13-3h13\"/><circle cx=\"9.5\" cy=\"9.5\" r=\"2.5\"/><path d=\"m11.27 11.27l2.23 2.23\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserSettingWindowGearAppCodeProgrammingCogSettingsApps: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 13.5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m-12-10h13M7 6.5V8m-3.03.25l1.3.75m-1.3 2.75l1.3-.75M7 13.5V12m3.03-.25L8.73 11m1.3-2.75L8.73 9\"/><circle cx=\"7\" cy=\"10\" r=\"2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBrowserWarningWindowAppCodeProgrammingNotificationWarningAlertApps: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 13.5h-2a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-2m-10-10h13M7 6.5V10\"/><circle cx=\"7\" cy=\"13\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingBugCodeBugSecurityProgrammingSecureComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"8\" r=\"4.5\"/><path d=\"M2.5 8h-2m0 3.5a3.46 3.46 0 0 0 2.63-1.2m0-4.6A3.46 3.46 0 0 0 .5 4.5m11 3.5h2m0 3.5a3.46 3.46 0 0 1-2.63-1.2m0-4.6a3.46 3.46 0 0 1 2.63-1.2m-5.26-.83A2.5 2.5 0 0 0 9.5 1.5m-5 0a2.5 2.5 0 0 0 1.26 2.17M2.61 7h8.78\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudAddCloudNetworkInternetAddServerPlus: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 8.5a3 3 0 1 0-2.15-5.09A4 4 0 1 0 4.5 8.5M10 11H5m2.5-2.5v5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudCloudInternetServerNetwork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 11a3 3 0 1 0-2.15-5.09A4 4 0 1 0 4.5 11Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudDataTransferCloudDataTransferInternetServerNetwork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 8.1a3 3 0 1 0-3.65-4.69A4 4 0 1 0 1.38 7M3.5 9.5l2-2v6\"/><path d=\"m10.5 11.5l-2 2v-6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudDownloadCloudDownInternetNetworkDownloadServerArrow: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 8.5a3 3 0 1 0-2.15-5.09A4 4 0 1 0 4.5 8.5m3 5v-6m-2 4l2 2l2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudOffCloudNetworkInternetDisableServerOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.17 3.17a4.08 4.08 0 0 1 6.18 2.24a3 3 0 1 1 2.24 5.09l-1 .05M.75 5.1A4 4 0 0 0 .5 6.5a4 4 0 0 0 4 4H6m-5.5-9l11 11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudRemoveCloudNetworkInternetSubtractMinusServerRemove: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 8.5a3 3 0 1 0-2.15-5.09A4 4 0 1 0 4.5 8.5Zm-.5 3H5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudUploadCloudServerInternetUploadUpArrowNetwork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 7.5v6m-2-4l2-2l2 2\"/><path d=\"M12 8.1a3 3 0 1 0-3.65-4.69A4 4 0 0 0 .5 4.5A4 4 0 0 0 1.38 7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingCloudWifiCloudWifiInternetServerNetwork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 13.5a3 3 0 1 0-2.15-5.09A4 4 0 1 0 4.5 13.5Zm-.02-12.3a9 9 0 0 0-7 0m5.7 2.16a6.78 6.78 0 0 0-4.36 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingModuleCubeCodeModuleProgrammingPlugin: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.39 3a.47.47 0 0 0-.21-.16l-6-2.27a.45.45 0 0 0-.36 0l-6 2.31A.47.47 0 0 0 .61 3a.48.48 0 0 0-.11.3v7.32a.5.5 0 0 0 .32.46l6 2.31h.36l6-2.31a.5.5 0 0 0 .32-.46V3.34a.48.48 0 0 0-.11-.34Z\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.46V5.5m0 0v7.96M.61 3.04L7 5.5l6.39-2.46\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingModulePuzzle1CodePuzzleModuleProgrammingPluginPiece: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.09 1.19a2 2 0 0 1 .6 1.33L6.52.7a.67.67 0 0 1 1 0L9 2.24a2.18 2.18 0 0 0-.57.4a2.06 2.06 0 0 0 2.91 2.91a2.18 2.18 0 0 0 .4-.57l1.56 1.54a.67.67 0 0 1 0 1l-1.82 1.79a2.05 2.05 0 1 1-2.17 2.17L7.48 13.3a.67.67 0 0 1-1 0L5 11.76a2.18 2.18 0 0 0 .57-.4a2.06 2.06 0 0 0-2.93-2.91a2.18 2.18 0 0 0-.4.57L.7 7.48a.67.67 0 0 1 0-1l1.82-1.79a2 2 0 0 1-1.33-.6a2.05 2.05 0 0 1 2.9-2.9Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingModuleThreeCodeThreeModuleProgrammingPlugin: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"5.25\" height=\"5.25\" x=\".5\" y=\"8.25\" rx=\".5\"/><rect width=\"5.25\" height=\"5.25\" x=\"8.25\" y=\"8.25\" rx=\".5\"/><rect width=\"5.25\" height=\"5.25\" x=\"4.38\" y=\".5\" rx=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingRssSquareWirelessRssFeedSquareTransmitBroadcast: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><circle cx=\"4\" cy=\"10\" r=\".5\"/><path d=\"M4.5 6.5a3 3 0 0 1 3 3m-3-6a6 6 0 0 1 6 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingRssSymbolWirelessFeedRssTransmitBroadcast: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2.13\" cy=\"11.88\" r=\"1.5\"/><path d=\"M13.38 12.12A11.5 11.5 0 0 0 1.88.62m.24 4.76a6.5 6.5 0 0 1 6.5 6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingScript1LanguageProgrammingCode: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 10.5v-8a2 2 0 0 1 2-2h6.25M10 3.5v8a2 2 0 0 1-2 2m-2-2V11a.5.5 0 0 0-.5-.5H1a.5.5 0 0 0-.5.5v.5a2 2 0 0 0 2 2H8a2 2 0 0 1-2-2Z\"/><path d=\"M11.75.5h0a1.75 1.75 0 0 1 1.75 1.75V3a.5.5 0 0 1-.5.5h-3h0V2.25A1.75 1.75 0 0 1 11.75.5ZM6 4h1.5M6 7h1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingScript2LanguageProgrammingCode: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 3.5v8a2 2 0 0 1-2 2H.5a2 2 0 0 0 2-2v-9a2 2 0 0 1 2-2h7.25\"/><path d=\"M11.75.5h0a1.75 1.75 0 0 1 1.75 1.75V3a.5.5 0 0 1-.5.5h-3h0V2.25A1.75 1.75 0 0 1 11.75.5ZM6 4h1.5M5 7h2.5M5 10h2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingScriptFileCode1CodeFilesAngleProgrammingFileBracket: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.5 13.5l-2-2l2-2m3 4l2-2l-2-2\"/><path d=\"M2.5 7.5v-6a1 1 0 0 1 1-1h5l5 5v7a1 1 0 0 1-1 1h-3\"/><path d=\"M8.5.5v5h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingScriptFileCode2CodeProgrammingTerminalShellFileLineCommandFiles: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.5 13.5l2-2l-2-2m2-2v-6a1 1 0 0 1 1-1h5l5 5v7a1 1 0 0 1-1 1H10\"/><path d=\"M8.5.5v5h5m-9 8h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingScriptHtmlFiveLanguageFiveCodeProgrammingHtml: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m12 10l-5 3.5L2 10L.5.5h13L12 10z\"/><path d=\"M9.5 3.5h-5L5 6h4v2.5L7 10L5 8.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingWebServerWorldInternetEarthWwwGlobeWorldwideWebNetwork: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M.5 7h13m-4 0A11.22 11.22 0 0 1 7 13.5A11.22 11.22 0 0 1 4.5 7A11.22 11.22 0 0 1 7 .5A11.22 11.22 0 0 1 9.5 7Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProjectorBoard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5.5h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-12 3h13m-6.5 7v3m-1.5-3l-3 3m6-3l3 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProjectorBoardRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 9V3.5h10.75V9a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 9M.375 2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v7c0 .897-.727 1.625-1.625 1.625h-1.638l1.757 1.756a.875.875 0 1 1-1.238 1.238l-2.993-2.994h-.013V13a.875.875 0 0 1-1.75 0v-2.375h-.013L3.12 13.619a.875.875 0 0 1-1.24-1.239l1.757-1.756H2A1.625 1.625 0 0 1 .375 9z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProjectorBoardSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v1.375H0zm0 2.625h14V9.5a1.5 1.5 0 0 1-1.5 1.5h-2.19l1.72 1.72a.75.75 0 1 1-1.06 1.06L8.19 11h-.44v2.25a.75.75 0 0 1-1.5 0V11h-.44l-2.78 2.78a.75.75 0 0 1-1.06-1.06L3.69 11H1.5A1.5 1.5 0 0 1 0 9.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePyramidShape: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m12.99 10.444l-5.593 2.528a1 1 0 0 1-.824 0L.979 10.441a.5.5 0 0 1-.21-.734l5.8-8.678a.5.5 0 0 1 .831 0l5.8 8.681a.5.5 0 0 1-.21.733M6.984.938v12.125\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePyramidShapeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.4c.123 0 .246.06.32.177l5.054 8.166a.375.375 0 0 1-.162.538l-5.055 2.333A.4.4 0 0 1 7 12.65zM8.382.92a1.625 1.625 0 0 0-2.763 0L.564 9.085a1.625 1.625 0 0 0 .7 2.331l5.055 2.333c.432.2.93.2 1.362 0l5.055-2.333a1.625 1.625 0 0 0 .7-2.33z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlinePyramidShapeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.36.525a1 1 0 0 0-.207.226L.353 9.43a1 1 0 0 0 .42 1.466l5.586 2.528zm1.25 12.9l5.585-2.525a1 1 0 0 0 .42-1.467L7.816.75A1 1 0 0 0 7.61.524z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQrCode: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 3H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M3 .5H1.5a1 1 0 0 0-1 1V3M11 .5h1.5a1 1 0 0 1 1 1V3M3 13.5H1.5a1 1 0 0 1-1-1V11M11 13.5h1.5a1 1 0 0 0 1-1V11M3 9.5V11h1.5M7 11V9.5H5.5m5.5-5H9.5V3M11 8V6.5H9.5m0 3V11H11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQrCodeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.735 1.735c.07-.07.166-.11.265-.11h2a.625.625 0 1 0 0-1.25H2A1.625 1.625 0 0 0 .375 2v2a.625.625 0 1 0 1.25 0V2c0-.1.04-.195.11-.265M9.375 1c0-.345.28-.625.625-.625h2A1.625 1.625 0 0 1 13.625 2v2a.625.625 0 1 1-1.25 0V2A.375.375 0 0 0 12 1.625h-2A.625.625 0 0 1 9.375 1M2.5 4A1.5 1.5 0 0 1 4 2.5h2A1.5 1.5 0 0 1 7.5 4v2A1.5 1.5 0 0 1 6 7.5H4A1.5 1.5 0 0 1 2.5 6zm1.25 5.375a.625.625 0 1 0-1.25 0v1.5c0 .345.28.625.625.625h1.5a.625.625 0 1 0 0-1.25H3.75zM5 9.25c0-.345.28-.625.625-.625h1.5c.345 0 .625.28.625.625v1.5a.625.625 0 1 1-1.25 0v-.875h-.875A.625.625 0 0 1 5 9.25m5-6.125a.625.625 0 1 0-1.25 0v1.5c0 .345.28.625.625.625h1.5a.625.625 0 1 0 0-1.25H10zm-1.25 3.5c0-.345.28-.625.625-.625h1.5c.345 0 .625.28.625.625v1.5a.625.625 0 1 1-1.25 0V7.25h-.875a.625.625 0 0 1-.625-.625M10 9.375a.625.625 0 1 0-1.25 0v1.5c0 .345.28.625.625.625h1.5a.625.625 0 1 0 0-1.25H10zm3 0c.345 0 .625.28.625.625v2A1.625 1.625 0 0 1 12 13.625h-2a.625.625 0 1 1 0-1.25h2a.375.375 0 0 0 .375-.375v-2c0-.345.28-.625.625-.625M1.625 10a.625.625 0 1 0-1.25 0v2A1.625 1.625 0 0 0 2 13.625h2a.625.625 0 1 0 0-1.25H2A.375.375 0 0 1 1.625 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQrCodeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.776.076a1.7 1.7 0 0 0-1.7 1.7v1.425a.75.75 0 1 0 1.5 0V1.776a.2.2 0 0 1 .2-.2h1.425a.75.75 0 1 0 0-1.5zm2.22 2.67c-.69 0-1.25.56-1.25 1.25v2.073c0 .69.56 1.25 1.25 1.25h2.073c.69 0 1.25-.56 1.25-1.25V3.996c0-.69-.56-1.25-1.25-1.25zm.25 3.073V4.246h1.573v1.573zM10.049.826a.75.75 0 0 1 .75-.75h1.425a1.7 1.7 0 0 1 1.7 1.7v1.425a.75.75 0 0 1-1.5 0V1.776a.2.2 0 0 0-.2-.2h-1.425a.75.75 0 0 1-.75-.75M1.576 10.8a.75.75 0 0 0-1.5 0v1.425a1.7 1.7 0 0 0 1.7 1.7h1.425a.75.75 0 0 0 0-1.5H1.776a.2.2 0 0 1-.2-.2zm11.598-.75a.75.75 0 0 1 .75.75v1.425a1.7 1.7 0 0 1-1.7 1.7h-1.425a.75.75 0 0 1 0-1.5h1.425a.2.2 0 0 0 .2-.2V10.8a.75.75 0 0 1 .75-.75m-8.928-.86a.75.75 0 0 0-1.5 0v1.314c0 .414.336.75.75.75H4.81a.75.75 0 0 0 0-1.5h-.564zm1.46 0a.75.75 0 0 1 .75-.75H7a.75.75 0 0 1 .75.75v1.314a.75.75 0 0 1-1.5 0v-.593a.75.75 0 0 1-.544-.72M9.94 3.496a.75.75 0 1 0-1.5 0V4.81c0 .414.336.75.75.75h1.314a.75.75 0 1 0 0-1.5H9.94zM8.44 7a.75.75 0 0 1 .75-.75h1.314a.75.75 0 0 1 .75.75v.639a.75.75 0 0 1-1.492.111H9.19A.75.75 0 0 1 8.44 7m1.5 2.19a.75.75 0 0 0-1.5 0v1.314c0 .414.336.75.75.75h1.314a.75.75 0 1 0 0-1.5H9.94z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQualityEducation: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 6.546c-.748-.553-1.869-1.52-5.083-1.52v6.924c3.214 0 4.335.967 5.083 1.52zm0 0c.748-.553 1.869-1.52 5.083-1.52v6.924c-3.214 0-4.335.967-5.083 1.52zM10.763.521H4.086a1 1 0 0 0-.528.15L1.801 1.765l1.757 1.092a1 1 0 0 0 .528.15h6.677a1.243 1.243 0 1 0 0-2.485M8.986.575v2.432\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQualityEducationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 0a.5.5 0 0 0-.265.076l-2 1.25a.5.5 0 0 0 0 .848l2 1.25A.5.5 0 0 0 4 3.5h6.75a1.75 1.75 0 1 0 0-3.5zM1.5 4.375A.625.625 0 0 0 .875 5v6.375c0 .345.28.625.625.625c1.672 0 2.916.319 3.741.694c.415.188.714.386.91.558c.177.155.23.253.24.273l.002.002v.001A.62.62 0 0 0 7 14a.62.62 0 0 0 .606-.472l.002-.003c.01-.02.064-.118.241-.273c.196-.172.495-.37.91-.558c.825-.375 2.069-.694 3.741-.694c.345 0 .625-.28.625-.625V5a.625.625 0 0 0-.625-.625c-1.828 0-3.251.348-4.259.806a5 5 0 0 0-1.215.755L7 5.959l-.026-.023A5 5 0 0 0 5.76 5.18c-1.01-.457-2.432-.805-4.26-.805m6.741 7.181q-.336.153-.616.323V7.12c.027-.043.09-.128.224-.244c.196-.172.495-.37.91-.558c.719-.327 1.755-.61 3.116-.679v5.124c-1.53.069-2.744.388-3.634.792m-1.866.323V7.12a1.2 1.2 0 0 0-.224-.244a3.8 3.8 0 0 0-.91-.558c-.719-.327-1.755-.61-3.116-.679v5.124c1.53.069 2.744.388 3.634.792q.337.153.616.323\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQualityEducationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m3.096.577l5.91-.003v2.303l-5.91.003a1.25 1.25 0 0 1-.742-.243l-.958-.707a.25.25 0 0 1 0-.402L2.355.82a1.25 1.25 0 0 1 .74-.244Zm8.343 2.298l-1.183.001V.573h1.187c.634.01 1.119.573 1.119 1.15c0 .578-.485 1.142-1.119 1.152zm-5.931 2.31c.335.134.62.281.867.427V14a5.5 5.5 0 0 0-1.24-.7c-.735-.294-1.795-.537-3.412-.537a.5.5 0 0 1-.5-.5V5.075a.5.5 0 0 1 .5-.5c1.72 0 2.91.259 3.785.61M8.864 13.3c-.54.217-.919.466-1.24.699V5.611c.247-.146.533-.293.868-.427c.875-.351 2.065-.61 3.785-.61a.5.5 0 0 1 .5.5v7.188a.5.5 0 0 1-.5.5c-1.617 0-2.677.243-3.413.538\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQuotation2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 4L1 7m2-3l.5 3m7.75 0l-.5 3m2.75-3l-.5 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQuotation2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.242 3.397a.625.625 0 1 0-1.233.206l.5 3a.625.625 0 0 0 1.233-.206zm2.75 0a.625.625 0 1 0-1.233.206l.5 3a.625.625 0 0 0 1.233-.206zm6.986 3.487c.34.056.57.378.514.719l-.5 3a.625.625 0 0 1-1.233-.206l.5-3a.625.625 0 0 1 .719-.513m3.014.719a.625.625 0 0 0-1.233-.206l-.5 3a.625.625 0 0 0 1.233.206z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineQuotation2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.49 3.877a.75.75 0 1 0-1.48.246l.5 3a.75.75 0 0 0 1.48-.246zm2.5 0a.75.75 0 1 0-1.48.246l.5 3a.75.75 0 0 0 1.48-.246zm7.133 2.383a.75.75 0 0 1 .617.863l-.5 3a.75.75 0 1 1-1.48-.246l.5-3a.75.75 0 0 1 .863-.617m2.867.863a.75.75 0 1 0-1.48-.246l-.5 3a.75.75 0 1 0 1.48.246z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRadio: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 4h-11a1 1 0 0 0-1 1v7.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M1.37 4L13.5.5\"/><path d=\"M4.5 11.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m5-2.75H11m-1.5 2.5H11M.5 6.5h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRadioRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.191 1.595a.625.625 0 1 0-.382-1.19L2.02 3.875H2c-.897 0-1.625.728-1.625 1.625V12c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V5.5c0-.897-.727-1.625-1.625-1.625H6.103zM1.625 12V6.66h10.75V12a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12M4.5 7.875a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5m4.125 1c0-.345.28-.625.625-.625h1.5a.625.625 0 1 1 0 1.25h-1.5a.625.625 0 0 1-.625-.625m.625 1.375a.625.625 0 0 0 0 1.25h1.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRadioSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.362 1.498A.75.75 0 1 0 12.935.06L1.316 3.511A1.5 1.5 0 0 0 0 5v.875h14V5a1.5 1.5 0 0 0-1.5-1.5H6.622zM14 7.125H0V12.5A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5zm-9.662 5.206a1.83 1.83 0 1 0 0-3.662a1.83 1.83 0 0 0 0 3.662M9.5 8.807a.625.625 0 0 0 0 1.25H11a.625.625 0 0 0 0-1.25zm-.625 3.125c0-.345.28-.625.625-.625H11a.625.625 0 1 1 0 1.25H9.5a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRadioactive2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 10.99a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\"/><path d=\"M9.35 1.31a3.32 3.32 0 1 1-4.7 0\"/><path d=\"M.5 8.5a3.32 3.32 0 1 1 2.35 4.07\"/><path d=\"M11.15 12.57A3.32 3.32 0 1 1 13.5 8.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRadioactive2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.137 1.86a.625.625 0 1 0-.884-.883a3.88 3.88 0 0 0-.809 4.299a4 4 0 0 0-.107.184l-.073.009a3.88 3.88 0 0 0-3.243 2.84a.625.625 0 1 0 1.207.325a2.63 2.63 0 0 1 1.637-1.788q-.048.31-.048.635a4.18 4.18 0 0 0 2.612 3.878a2.63 2.63 0 0 1-2.339.5a.625.625 0 0 0-.322 1.208a3.88 3.88 0 0 0 4.082-1.389l.013-.016a5 5 0 0 0 .274 0l.013.016a3.88 3.88 0 0 0 4.082 1.39a.625.625 0 1 0-.323-1.208a2.63 2.63 0 0 1-2.338-.501a4.184 4.184 0 0 0 2.564-4.513a2.63 2.63 0 0 1 1.637 1.788a.625.625 0 1 0 1.207-.325a3.88 3.88 0 0 0-3.315-2.85a4 4 0 0 0-.108-.183l.03-.07A3.88 3.88 0 0 0 9.748.977a.625.625 0 1 0-.885.883a2.63 2.63 0 0 1 .725 2.334A4.17 4.17 0 0 0 7 3.298c-.977 0-1.876.335-2.588.896a2.63 2.63 0 0 1 .725-2.334m3.505 3.916q.124-.1.235-.212A2.67 2.67 0 0 0 7 4.798c-.73 0-1.393.292-1.877.765q.111.114.236.213a4 4 0 0 1 .681.393a2.63 2.63 0 0 0 1.92 0a4 4 0 0 1 .682-.393M6.37 8.917a2.63 2.63 0 0 0-.96-1.657a4 4 0 0 1-.68-.393a3 3 0 0 0-.317-.101a2.686 2.686 0 0 0 1.878 3.303q.05-.173.079-.352a4 4 0 0 1 0-.8m2.902-2.05q.155-.06.315-.101a2.686 2.686 0 0 1-1.878 3.303a3 3 0 0 1-.08-.352a4 4 0 0 0 0-.8a2.63 2.63 0 0 1 .96-1.656a4 4 0 0 0 .683-.394\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRadioactive2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.271 2.062a.75.75 0 0 0-1.061-1.06a3.94 3.94 0 0 0-.826 4.357l-.064.008A3.94 3.94 0 0 0 .026 8.25a.75.75 0 0 0 1.448.39A2.44 2.44 0 0 1 2.91 7.014a4.12 4.12 0 0 0 2.393 4.211a2.44 2.44 0 0 1-2.1.41a.75.75 0 0 0-.387 1.45A3.94 3.94 0 0 0 7 11.622l.038.05a3.94 3.94 0 0 0 4.146 1.411a.75.75 0 1 0-.387-1.449a2.44 2.44 0 0 1-2.1-.41a4.12 4.12 0 0 0 2.393-4.211a2.44 2.44 0 0 1 1.436 1.627a.75.75 0 0 0 1.448-.39a3.94 3.94 0 0 0-3.358-2.892l.025-.061a3.94 3.94 0 0 0-.85-4.296a.75.75 0 0 0-1.062 1.06a2.44 2.44 0 0 1 .687 2.081A4.1 4.1 0 0 0 7 3.359c-.903 0-1.738.291-2.416.784a2.44 2.44 0 0 1 .687-2.081m3.264 3.625q.102-.082.194-.175A2.6 2.6 0 0 0 7 4.86c-.663 0-1.268.247-1.729.653q.092.093.194.175a4 4 0 0 1 .658.38a2.44 2.44 0 0 0 1.754 0a4 4 0 0 1 .658-.38m-2.29 3.2a2.44 2.44 0 0 0-.877-1.511a4 4 0 0 1-.659-.38a2 2 0 0 0-.263-.085q-.06.273-.061.564c0 1.157.751 2.139 1.793 2.483q.042-.145.066-.295a4 4 0 0 1 0-.776M9.29 6.996a2 2 0 0 1 .264-.085q.06.273.06.564a2.62 2.62 0 0 1-1.793 2.483a2 2 0 0 1-.066-.295a4 4 0 0 0 0-.776a2.44 2.44 0 0 1 .876-1.511a4 4 0 0 0 .659-.38\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRainCloud: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4 11.5l.5-1m4 1l.5-1m-3.25 3l.5-1m-5 1l.5-1m8.5 1l.5-1m-.5-4.5a2.5 2.5 0 0 0 0-5a2.54 2.54 0 0 0-1.57.55A3.75 3.75 0 1 0 5 8z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRainCloudRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125 4.125a2.875 2.875 0 0 1 5.653-.744a.625.625 0 0 0 1.009.315A1.875 1.875 0 1 1 10 7H5a2.875 2.875 0 0 1-2.876-2.875M5 0a4.125 4.125 0 0 0 0 8.25h5a3.125 3.125 0 1 0-1.307-5.964A4.12 4.12 0 0 0 5 0m.296 10.21a.75.75 0 1 0-1.342-.67l-.5 1a.75.75 0 1 0 1.342.67zm4.415-1.006a.75.75 0 0 1 .335 1.006l-.5 1a.75.75 0 1 1-1.342-.67l.5-1a.75.75 0 0 1 1.007-.336M7.17 12.46a.75.75 0 1 0-1.342-.67l-.5 1a.75.75 0 1 0 1.342.67zm-5.085-1.006a.75.75 0 0 1 .335 1.006l-.5 1a.75.75 0 1 1-1.342-.67l.5-1a.75.75 0 0 1 1.007-.336m9.835 1.006a.75.75 0 1 0-1.342-.67l-.5 1a.75.75 0 0 0 1.342.67z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRainCloudSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.683.208a4.25 4.25 0 0 1 5.3 2.572a3 3 0 0 1 1.265-.28h.002a3 3 0 0 1 0 6H5A4.25 4.25 0 0 1 3.683.208M5.22 10.585a.75.75 0 1 0-1.342-.67l-.5 1a.75.75 0 1 0 1.342.67zM9.785 9.58a.75.75 0 0 1 .336 1.006l-.5 1a.75.75 0 1 1-1.342-.67l.5-1a.75.75 0 0 1 1.006-.336m-2.614 3.006a.75.75 0 1 0-1.342-.67l-.5 1a.75.75 0 1 0 1.342.67zM1.936 11.58a.75.75 0 0 1 .335 1.006l-.5 1a.75.75 0 1 1-1.342-.67l.5-1a.75.75 0 0 1 1.007-.336m10.135 1.006a.75.75 0 1 0-1.342-.67l-.5 1a.75.75 0 1 0 1.342.67z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRainbow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.25a6.5 6.5 0 1 1 13 0\"/><path d=\"M3 10.25a4 4 0 0 1 8 0\"/><path d=\"M5.5 10.25a1.5 1.5 0 0 1 3 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRainbowRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 8.5a5.75 5.75 0 1 1 11.5 0V12A.625.625 0 1 0 14 12V8.5a7 7 0 1 0-14 0V12a.625.625 0 1 0 1.25 0zM3 8.5a4 4 0 0 1 8 0v3.625a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5V8.5a1.5 1.5 0 0 0-3 0v3.625a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRainbowSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 4.632a5.486 5.486 0 0 0-5.486 5.486a.75.75 0 0 1-1.5 0a6.986 6.986 0 0 1 13.972 0a.75.75 0 0 1-1.5 0A5.486 5.486 0 0 0 7 4.632M7 7.09a3.03 3.03 0 0 0-3.028 3.028a.75.75 0 0 1-1.5 0a4.528 4.528 0 1 1 9.056 0a.75.75 0 0 1-1.5 0A3.03 3.03 0 0 0 7 7.09m-.403 2.625a.57.57 0 0 1 .973.403a.75.75 0 0 0 1.5 0a2.07 2.07 0 1 0-4.14 0a.75.75 0 0 0 1.5 0a.57.57 0 0 1 .167-.403\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceipt: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.202 4.722a1.33 1.33 0 0 0-1.258-.889H4.912a1.19 1.19 0 0 0-.254 2.353l1.571.344a1.334 1.334 0 0 1-.285 2.637h-.888a1.33 1.33 0 0 1-1.258-.89M5.5 3.833V2.5m0 8V9.167\"/><path d=\"M12 .5H2.5a2 2 0 0 0-2 2v11L3 12l2.5 1.5L8 12l2.5 1.5V2a1.5 1.5 0 1 1 3 0v3.5h-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 6.5H3M5.5 4v5M12 .5H2.5a2 2 0 0 0-2 2v11L3 12l2.5 1.5L8 12l2.5 1.5V2a1.5 1.5 0 1 1 3 0v3.5h-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v10a.625.625 0 0 0 .972.52l1.903-1.269l1.903 1.269c.21.14.484.14.694 0l1.903-1.269l1.903 1.269a.625.625 0 0 0 .972-.52V5.625H13c.345 0 .625-.28.625-.625V2.5A2.125 2.125 0 0 0 11.5.375zM9.375 2.5c0-.305.065-.603.189-.875H3A1.375 1.375 0 0 0 1.625 3v8.832l1.278-.852c.21-.14.484-.14.694 0L5.5 12.249l1.903-1.269c.21-.14.484-.14.694 0l1.278.852zM6.25 4.25a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A2.5 2.5 0 0 0 0 2.5v11a.5.5 0 0 0 .757.429L3 12.583l2.243 1.346a.5.5 0 0 0 .514 0L8 12.583l2.243 1.346A.5.5 0 0 0 11 13.5V6h.005V2.5a.625.625 0 1 1 1.25 0V6H13.5a.5.5 0 0 0 .5-.5V2a2 2 0 0 0-2-2zm3 3.25a.75.75 0 0 1 .75.75v1.75H8a.75.75 0 0 1 0 1.5H6.25V9a.75.75 0 0 1-1.5 0V7.25H3a.75.75 0 0 1 0-1.5h1.75V4a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.75 7l2 1.5l3.5-4\"/><path d=\"M12 .5H2.5a2 2 0 0 0-2 2v11L3 12l2.5 1.5L8 12l2.5 1.5V2a1.5 1.5 0 1 1 3 0v3.5h-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v10a.625.625 0 0 0 .972.52l1.903-1.269l1.903 1.269c.21.14.484.14.694 0l1.903-1.269l1.903 1.269a.625.625 0 0 0 .972-.52V5.625H13c.345 0 .625-.28.625-.625V2.5A2.125 2.125 0 0 0 11.5.375zM9.375 2.5c0-.305.065-.603.189-.875H3A1.375 1.375 0 0 0 1.625 3v8.832l1.278-.852c.21-.14.484-.14.694 0L5.5 12.249l1.903-1.269c.21-.14.484-.14.694 0l1.278.852zM8.244 4.507a.75.75 0 0 1 .07 1.058l-3 3.429A.75.75 0 0 1 4.3 9.1L2.8 7.975a.75.75 0 1 1 .9-1.2l.944.708l2.542-2.905a.75.75 0 0 1 1.058-.071\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A2.5 2.5 0 0 0 0 2.5v11a.5.5 0 0 0 .757.429L3 12.583l2.243 1.346a.5.5 0 0 0 .514 0L8 12.583l2.243 1.346A.5.5 0 0 0 11 13.5V6h.005V2.5a.625.625 0 1 1 1.25 0V6H13.5a.5.5 0 0 0 .5-.5V2a2 2 0 0 0-2-2zm6.314 4.994a.75.75 0 1 0-1.128-.988L4.644 7.483L3.2 6.4a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.014-.106z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.144 1.144A2.63 2.63 0 0 1 3 .375h8.5A2.125 2.125 0 0 1 13.625 2.5V5c0 .345-.28.625-.625.625h-2.375V13a.625.625 0 0 1-.972.52L7.75 12.251L5.847 13.52a.625.625 0 0 1-.694 0L3.25 12.251L1.347 13.52A.625.625 0 0 1 .375 13V3c0-.696.277-1.364.769-1.856m8.42.481c-.124.272-.189.57-.189.875v9.332l-1.278-.852a.625.625 0 0 0-.694 0L5.5 12.249L3.597 10.98a.625.625 0 0 0-.694 0l-1.278.852V3A1.375 1.375 0 0 1 3 1.625zM6.18 3.313v.478A1.71 1.71 0 0 1 7.528 4.91a.625.625 0 0 1-1.179.416a.46.46 0 0 0-.432-.305h-.839a.342.342 0 0 0-.073.676l1.277.28a1.709 1.709 0 0 1-.101 3.357v.479a.625.625 0 1 1-1.25 0v-.48a1.71 1.71 0 0 1-1.348-1.118a.625.625 0 1 1 1.179-.416a.46.46 0 0 0 .432.305h.723a.459.459 0 0 0 .098-.907l-1.277-.279a1.592 1.592 0 0 1 .193-3.14v-.465a.625.625 0 0 1 1.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.732.732A2.5 2.5 0 0 1 2.5 0H12a2 2 0 0 1 2 2v3.5a.5.5 0 0 1-.5.5h-1.245V2.5a.625.625 0 1 0-1.25 0V6H11v7.5a.5.5 0 0 1-.757.429L8 12.583L5.757 13.93a.5.5 0 0 1-.514 0L3 12.583L.757 13.93A.5.5 0 0 1 0 13.5v-11A2.5 2.5 0 0 1 .732.732M5.5 2a.75.75 0 0 1 .75.75v.528a2 2 0 0 1 1.553 1.305a.75.75 0 0 1-1.415.5a.5.5 0 0 0-.471-.333h-.968a.366.366 0 0 0-.078.723l1.473.322a2 2 0 0 1-.094 3.927v.528a.75.75 0 0 1-1.5 0v-.528a2 2 0 0 1-1.553-1.305a.75.75 0 0 1 1.415-.5a.5.5 0 0 0 .471.333h.834a.5.5 0 0 0 .107-.99L4.55 6.939a1.866 1.866 0 0 1 .2-3.677V2.75A.75.75 0 0 1 5.5 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptSubtract: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 6.5H3m9-6H2.5a2 2 0 0 0-2 2v11L3 12l2.5 1.5L8 12l2.5 1.5V2a1.5 1.5 0 1 1 3 0v3.5h-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptSubtractRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375A2.625 2.625 0 0 0 .375 3v10a.625.625 0 0 0 .972.52l1.903-1.269l1.903 1.269c.21.14.484.14.694 0l1.903-1.269l1.903 1.269a.625.625 0 0 0 .972-.52V5.625H13c.345 0 .625-.28.625-.625V2.5A2.125 2.125 0 0 0 11.5.375zM9.375 2.5c0-.305.065-.603.189-.875H3A1.375 1.375 0 0 0 1.625 3v8.832l1.278-.852c.21-.14.484-.14.694 0L5.5 12.249l1.903-1.269c.21-.14.484-.14.694 0l1.278.852zm-6.625 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReceiptSubtractSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 0A2.5 2.5 0 0 0 0 2.5v11a.5.5 0 0 0 .757.429L3 12.583l2.243 1.346a.5.5 0 0 0 .514 0L8 12.583l2.243 1.346A.5.5 0 0 0 11 13.5V6h.005V2.5a.625.625 0 1 1 1.25 0V6H13.5a.5.5 0 0 0 .5-.5V2a2 2 0 0 0-2-2zM3 5.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecordingTapeBubbleCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 8.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m-5 0a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 0h5\"/><path d=\"M4.145 12.84a6.5 6.5 0 1 0-2.556-2.238m2.556 2.239L.5 13.5l1.089-2.897m2.556 2.238l.005-.001m-2.561-2.237l.001-.003\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecordingTapeBubbleCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 3.281 5.195a.62.62 0 0 0-.437-.082h-.006l-2.49.451l.68-1.81l.001-.003a.63.63 0 0 0-.096-.61A5.7 5.7 0 0 1 1.25 7M7 14a7 7 0 0 1-2.886-.62l-3.378.61a.625.625 0 0 1-.696-.835l.958-2.55A7 7 0 1 1 7 14M4.548 5.029a1.971 1.971 0 0 0-.141 3.937q.067.016.141.016h4.904a.6.6 0 0 0 .141-.016a1.971 1.971 0 1 0-1.972-1.234H6.38a1.97 1.97 0 0 0-1.83-2.703\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecordingTapeBubbleCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.998.046A6.953 6.953 0 1 1 4.1 13.32l-3.466.626a.5.5 0 0 1-.557-.667l.994-2.646A6.954 6.954 0 0 1 6.998.046M8.781 7.05a1.037 1.037 0 1 1 2.074 0a1.037 1.037 0 0 1-2.074 0m1.037-2.287a2.287 2.287 0 0 0-2.039 3.324H6.317a2.287 2.287 0 1 0-2.039 1.25h5.548a2.287 2.287 0 0 0-.008-4.574m-5.54 1.25a1.037 1.037 0 1 0 0 2.074a1.037 1.037 0 0 0 0-2.074\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecordingTapeBubbleSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4.5 12.5l-4 1l1-3v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1z\"/><path d=\"M10 8a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3M5 8a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 0h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecordingTapeBubbleSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.335 1.354a.36.36 0 0 1 .252-.104h9.807a.356.356 0 0 1 .356.356v9.808a.356.356 0 0 1-.356.355H4.548a.6.6 0 0 0-.151.019l-2.819.705l.62-1.863a.6.6 0 0 0 .033-.197V1.606c0-.095.037-.185.104-.252M2.587 0A1.606 1.606 0 0 0 .98 1.606v8.725l-.949 2.846a.625.625 0 0 0 .745.804l3.848-.962h7.77A1.606 1.606 0 0 0 14 11.413V1.606A1.606 1.606 0 0 0 12.394 0zm2.326 4.408a1.971 1.971 0 0 0-.14 3.937q.068.015.14.016h4.904a.6.6 0 0 0 .142-.016a1.971 1.971 0 1 0-1.972-1.234H6.744a1.97 1.97 0 0 0-1.83-2.703\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecordingTapeBubbleSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h10A1.5 1.5 0 0 1 14 1.5v10a1.5 1.5 0 0 1-1.5 1.5H4.562l-3.94.985a.5.5 0 0 1-.596-.643L1 10.419V1.5c0-.398.158-.78.44-1.06m7.888 5.83a1.037 1.037 0 1 1 2.073 0a1.037 1.037 0 0 1-2.073 0m1.037-2.287a2.287 2.287 0 0 0-2.039 3.324H6.864a2.287 2.287 0 1 0-2.039 1.25h5.548a2.287 2.287 0 0 0-.008-4.574m-5.54 1.25a1.037 1.037 0 1 0 0 2.074a1.037 1.037 0 0 0 0-2.074\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecycle1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.008 10.082v1.999a.29.29 0 0 1-.29.28H3.62a1.45 1.45 0 0 1-.88-.51\"/><path d=\"M2.74 11.86s-1.09-.949 1.44-3.477h1.129l-1.69-2.789H.512l.85 1.09s-.57.1-.57.89a10 10 0 0 0 1.95 4.287m7.614-5.487l1.479-1a.26.26 0 0 1 .21 0a.26.26 0 0 1 .19.12l1.15 1.72a1 1 0 0 1 0 .89\"/><path d=\"M13.424 8.003s-.32 1.3-3.628 1v-.87l-1.939 2.539l1.84 2.828l.1-1.33s.369.45.999 0a18.7 18.7 0 0 0 2.628-4.167M4.36 4.285l-1.35-.62a.3.3 0 0 1-.14-.38l1.14-2.278a1 1 0 0 1 .74-.5\"/><path d=\"M4.749.507s1.23 0 2.788 2.999l-.81 1h3.359l1.19-3.14l-1.4.43a1.21 1.21 0 0 0-.73-.999a5.9 5.9 0 0 0-2.138-.29z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecycle1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.561 0h3.91c.21 0 .404.104.52.278l.534.8l.497-.434a.625.625 0 0 1 1.03.56l-.49 3.432a.625.625 0 0 1-.62.537H6.51a.625.625 0 0 1-.412-1.095l.335-.294l-1.747-2.038l-.771 1.542l.422.21a.625.625 0 1 1-.56 1.119l-.98-.49a.625.625 0 0 1-.28-.84L3.987.35A.62.62 0 0 1 4.56 0m7.524 5.435a.625.625 0 0 0-.866-.178l-.916.605a.625.625 0 0 0 .69 1.043l.393-.26l.95 1.438l-2.64.494l-.086-.437a.625.625 0 0 0-1.154-.191l-1.717 2.973a.625.625 0 0 0 .155.804l2.728 2.142a.625.625 0 0 0 1-.613l-.128-.647l.96-.062a.63.63 0 0 0 .501-.311l1.955-3.386a.63.63 0 0 0-.019-.678zm-7.414.893a.625.625 0 0 0-.679-.459L.55 6.284a.625.625 0 0 0-.273 1.14l.548.367l-.635.723a.63.63 0 0 0-.135.574l1.012 3.776a.63.63 0 0 0 .482.465l3.224.66a.625.625 0 0 0 .737-.488l.22-1.074a.625.625 0 1 0-1.225-.25l-.094.461l-1.689-.345l1.517-2.216l.37.248a.625.625 0 0 0 .952-.68z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecycle1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.626 1.31c.98-1.646 3.337-1.72 4.42-.14l.593.866l.82-.405a.625.625 0 0 1 .859.789l-1.151 2.936a.625.625 0 0 1-.747.375l-3.085-.844a.625.625 0 0 1-.112-1.163l.686-.339l-.561-.88a.375.375 0 0 0-.597-.048L5.628 3.724a.625.625 0 0 1-1.004-.735zm-1.85 3.358a.625.625 0 0 1 .697.459l.812 3.093a.625.625 0 0 1-.951.679l-.637-.425l-.482.927a.375.375 0 0 0 .257.54l1.659.34a.625.625 0 0 1-.134 1.237l-1.956-.028C1.126 11.463-.117 9.46.711 7.732l.453-.948l-.76-.507A.625.625 0 0 1 .656 5.14zm3.386 6.552a.625.625 0 0 1 .05-.834l2.272-2.25a.625.625 0 0 1 1.064.485l-.05.763l1.044-.045a.375.375 0 0 0 .34-.493l-.537-1.606a.625.625 0 0 1 1.139-.503l.954 1.708c.934 1.672-.18 3.75-2.09 3.897l-1.047.081l-.059.912a.625.625 0 0 1-1.112.35z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecycleBin2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 3.5h12m-10.5 0h9v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1zm2 0V3a2.5 2.5 0 1 1 5 0v.5m-4 3.001v4.002m3-4.002v4.002\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecycleBin2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.851 2.226A1.625 1.625 0 0 1 8.58 3H5.42c.069-.29.217-.56.432-.774M3.646 3a3.375 3.375 0 0 1 6.708 0H13a.875.875 0 0 1 0 1.75h-.875v7.625A1.625 1.625 0 0 1 10.5 14h-7a1.625 1.625 0 0 1-1.625-1.625V4.75H1A.875.875 0 1 1 1 3zm7.229 9.375V4.75h-7.75v7.625a.375.375 0 0 0 .375.375h7a.375.375 0 0 0 .375-.375M5.5 6.001c.345 0 .625.28.625.625v4.002a.625.625 0 0 1-1.25 0V6.626c0-.345.28-.625.625-.625m3.625.625a.625.625 0 0 0-1.25 0v4.002a.625.625 0 0 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRecycleBin2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.763 2.013a1.75 1.75 0 0 1 2.914.737H5.323a1.75 1.75 0 0 1 .44-.737m-1.974.737a3.25 3.25 0 0 1 6.422 0H13a.75.75 0 0 1 0 1.5h-1v8.25a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 2 12.5V4.25H1a.75.75 0 1 1 0-1.5zM5 5.876c.345 0 .625.28.625.625v4.002a.625.625 0 0 1-1.25 0V6.501c0-.345.28-.625.625-.625m4.625.625a.625.625 0 0 0-1.25 0v4.002a.625.625 0 0 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReducedInequalities: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.733 6.91l2.45-2.45v4.9zm12.477 0l-2.45-2.45v4.9zM5.112 5.516h3.72m-3.72 2.79h3.72m-1.86 4.844l-2.45-2.45h4.9zm0-12.479l-2.45 2.45h4.9z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReducedInequalitiesRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.465.207a.625.625 0 0 0-.93 0l-2.25 2.5A.625.625 0 0 0 4.75 3.75h4.5a.625.625 0 0 0 .465-1.043zM7 1.559l.847.941H6.153zM4.75 10.25a.625.625 0 0 0-.465 1.043l2.25 2.5a.625.625 0 0 0 .93 0l2.25-2.5a.625.625 0 0 0-.465-1.043zM7 12.44l-.847-.94h1.694zm3.62-8.26a.63.63 0 0 1 .673.105l2.5 2.25a.625.625 0 0 1 0 .93l-2.5 2.25a.625.625 0 0 1-1.043-.465v-4.5c0-.247.145-.47.37-.57m-6.87.57a.625.625 0 0 0-1.043-.465l-2.5 2.25a.625.625 0 0 0 0 .93l2.5 2.25A.625.625 0 0 0 3.75 9.25zm.875 1c0-.345.28-.625.625-.625h3.5a.625.625 0 1 1 0 1.25h-3.5a.625.625 0 0 1-.625-.625m.625 1.875a.625.625 0 1 0 0 1.25h3.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReducedInequalitiesSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.423 2.95a.5.5 0 0 0 .462.308h4.173a.5.5 0 0 0 .354-.853L7.325.318a.5.5 0 0 0-.707 0L4.532 2.405a.5.5 0 0 0-.109.544M5.63 4.764a.75.75 0 1 0 0 1.5h2.684a.75.75 0 1 0 0-1.5zm0 2.79a.75.75 0 1 0 0 1.5h2.684a.75.75 0 1 0 0-1.5zm3.89 3.317a.5.5 0 0 0-.462-.309H4.885a.5.5 0 0 0-.353.854l2.086 2.086a.5.5 0 0 0 .707 0l2.087-2.086a.5.5 0 0 0 .108-.545m1.413-6.51a.5.5 0 0 0-.309.462v4.173a.5.5 0 0 0 .854.354l2.087-2.087a.5.5 0 0 0 0-.707L11.478 4.47a.5.5 0 0 0-.545-.108M3.011 9.46a.5.5 0 0 0 .308-.462V4.824a.5.5 0 0 0-.853-.354L.379 6.557a.5.5 0 0 0 0 .707l2.087 2.087a.5.5 0 0 0 .545.108\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRefrigerator: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5.5h-7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1M2.5 6h9m-7-3v.5m-.5 9v1m6-1v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRefrigeratorRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 11.375V6h8.75v5.375a.375.375 0 0 1-.375.375H3a.375.375 0 0 1-.375-.375m10 0c0 .855-.66 1.556-1.5 1.62v.38a.625.625 0 1 1-1.25 0V13h-5.75v.375a.625.625 0 1 1-1.25 0v-.38a1.625 1.625 0 0 1-1.5-1.62v-9.75C1.375.728 2.103 0 3 0h8c.898 0 1.625.728 1.625 1.625zm-8-8.625a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0zm0 5a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRefrigeratorSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0C2.682 0 2 .652 2 1.479v3.897l.029-.001H12V1.48A1.49 1.49 0 0 0 10.5 0zM2 11.265v-4.64h10v4.64c0 .74-.547 1.341-1.25 1.458v.52a.75.75 0 0 1-1.5 0v-.5h-4.5v.5a.75.75 0 0 1-1.5 0v-.52A1.485 1.485 0 0 1 2 11.265m3.041-8.656a.625.625 0 0 0-1.25 0v.5a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionCross1ReligionCrossCultureBold: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 3.5H9v-3H5v3H2v4h3v6h4v-6h3v-4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionHexagramStarJewJewishJudaismHexagramCultureReligionDavid: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 3.5h13L7 13.5L.5 3.5z\"/><path d=\"M.5 10.5h13L7 .5l-6.5 10z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionIslamReligionIslamMoonCrescentMuslimCultureStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.21 7a5.5 5.5 0 0 1 5.47-5.5a6.5 6.5 0 1 0 0 11A5.5 5.5 0 0 1 5.21 7Z\"/><path d=\"m10.57 4.04l.91 1.81h1.81l-1.36 1.4l.43 2l-1.79-1l-1.71 1l.36-2l-1.36-1.4h1.81l.9-1.81z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionShintoReligionGateCultureShintoJapanJapaneseShrine: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 4a.5.5 0 0 1-.5.5H1A.5.5 0 0 1 .5 4V.5a11.55 11.55 0 0 0 13 0ZM3 4.5v9m8-9v9M.5 8h13M7 4.5V8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionSymbolPeaceReligionPeaceWarCulture: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 .5v13m-5.07-2.43L7 6l5.07 5.07\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionSymbolYinYangReligionTaoYinYangTaoismCulture: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 .5S2.93 4.09 7 7c3.5 2.5 0 6.5 0 6.5\"/><circle cx=\"9\" cy=\"4.5\" r=\"1\"/><circle cx=\"5\" cy=\"9.5\" r=\"1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReturn2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 9.5h9a4 4 0 1 0 0-8h-3\"/><path d=\"m3.5 6.5l-3 3l3 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReturn2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.875 1.5c0-.345.28-.625.625-.625h3.25a4.25 4.25 0 0 1 0 8.5h-5V12.5a.5.5 0 0 1-.854.354l-3.75-3.75a.5.5 0 0 1 0-.708l3.75-3.75A.5.5 0 0 1 4.75 5v3.125h5a3 3 0 1 0 0-6H6.5a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReturn2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.545.998a1 1 0 0 0 0 2h2.728a2.638 2.638 0 0 1 0 5.275H4.817V6.545a1 1 0 0 0-1.707-.707L.384 8.564a1 1 0 0 0-.22 1.09q.073.18.218.327l2.728 2.728a1 1 0 0 0 1.707-.707v-1.729h4.456a4.638 4.638 0 1 0 0-9.275z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRingingBellNotification: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 13.25h2m3-7.5a4 4 0 1 0-8 0v3.5a1.5 1.5 0 0 1-1.5 1.5h11a1.5 1.5 0 0 1-1.5-1.5zM.5 5.62A6 6 0 0 1 3 .75m10.5 4.87A6 6 0 0 0 11 .75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRingingBellNotificationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.633.26a.627.627 0 0 1-.143.873a5.38 5.38 0 0 0-2.24 4.362a.625.625 0 0 1-1.25 0A6.63 6.63 0 0 1 2.76.117a.625.625 0 0 1 .873.143M7 1.5a4.625 4.625 0 0 0-4.625 4.625v3.25a.875.875 0 0 1-.875.875a.625.625 0 0 0 0 1.25h11a.625.625 0 1 0 0-1.25a.875.875 0 0 1-.875-.875v-3.25A4.625 4.625 0 0 0 7 1.5m3.375 7.875c0 .305.065.603.189.875H3.435c.124-.272.189-.57.189-.875v-3.25a3.375 3.375 0 0 1 6.75 0zM6 12.5A.75.75 0 0 0 6 14h2a.75.75 0 1 0 0-1.5zM11.24.117a.625.625 0 1 0-.73 1.016a5.38 5.38 0 0 1 2.24 4.362a.625.625 0 0 0 1.25 0A6.63 6.63 0 0 0 11.24.117\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRingingBellNotificationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.763.313a.75.75 0 0 1-.172 1.046A5.02 5.02 0 0 0 1.5 5.433a.75.75 0 1 1-1.5 0A6.52 6.52 0 0 1 2.716.14a.75.75 0 0 1 1.047.172m.055 2.255A4.5 4.5 0 0 1 11.5 5.75v3.5a1 1 0 0 0 1 1a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1a1 1 0 0 0 1-1v-3.5a4.5 4.5 0 0 1 1.318-3.182M5.25 13.25A.75.75 0 0 1 6 12.5h2A.75.75 0 0 1 8 14H6a.75.75 0 0 1-.75-.75M11.284.14a.75.75 0 1 0-.875 1.22A5.02 5.02 0 0 1 12.5 5.432a.75.75 0 1 0 1.5 0A6.52 6.52 0 0 0 11.284.14\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRockAndRollHand: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.763 13.5c-1.883-.75-2.071-2.435-1.916-3.833c.107-.97.911-1.584 1.865-1.584c.895 0 2.708.004 2.708.004c.684.053 1.18.676 1.115 1.349c-.1 1.036-1.324 1.148-2.147 1.356c.631.29 1.87 1.095 1.776 1.98\"/><path d=\"m10.263 13.5l.453-.453a4 4 0 0 0 1.172-2.829V4.021c0-.748-.606-1.354-1.354-1.354v0c-.748 0-1.355.606-1.355 1.354V7c-1.616-.726-2.014-.798-3.791-.542V1.854C5.388 1.106 4.782.5 4.034.5v0c-.748 0-1.355.606-1.355 1.354v6.478\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRockAndRollHandRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.034 0a1.98 1.98 0 0 0-1.98 1.98v6.058c-.444.368-.755.9-.828 1.56c-.082.74-.085 1.6.234 2.398c.33.826.98 1.525 2.071 1.96a.625.625 0 1 0 .463-1.161c-.791-.316-1.177-.773-1.373-1.263c-.207-.519-.226-1.138-.153-1.796c.068-.608.561-1.028 1.244-1.028l1.689.002l.72.002h.27a.61.61 0 0 1 .522.664c-.02.206-.122.342-.43.476c-.248.108-.512.166-.815.233q-.204.044-.433.1a.625.625 0 0 0-.109 1.174c.273.126.68.366.998.66c.345.318.433.555.419.687a.625.625 0 1 0 1.243.132c.08-.753-.405-1.36-.814-1.738l-.074-.067l.084-.035c.535-.233 1.095-.671 1.175-1.502c.097-1.004-.64-1.951-1.689-2.032l-.053-.002h-.291l-.721-.002l-1.69-.001q-.208 0-.409.03v-5.51a.73.73 0 1 1 1.459 0v4.23a.625.625 0 0 0 .714.618c.887-.128 1.351-.16 1.776-.098c.428.063.859.227 1.67.591a.625.625 0 0 0 .881-.57V4.146a.73.73 0 1 1 1.459 0v5.947c0 .895-.356 1.754-.989 2.387l-.453.453a.625.625 0 1 0 .884.884l.453-.453a4.63 4.63 0 0 0 1.355-3.27V4.145a1.98 1.98 0 0 0-3.959 0v1.66a5 5 0 0 0-1.12-.313c-.441-.065-.884-.054-1.421.004V1.98A1.98 1.98 0 0 0 4.033 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRockAndRollHandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.695 9.755c-.185 1.482-.04 3.306 1.873 4.17a.9.9 0 0 0 .369.075h6.393a1 1 0 0 0 .708-.293l.09-.09a4.67 4.67 0 0 0 1.367-3.3V3.792a1.458 1.458 0 1 0-2.917 0v2.25c-1.74-.782-2.17-.86-4.083-.584v-4a1.458 1.458 0 0 0-2.917 0v5.754H6.15a1.748 1.748 0 0 1 .809 3.299c.256.335.43.772.45 1.303a.625.625 0 1 1-1.248.047c-.015-.375-.171-.604-.34-.74c-.195-.156-.385-.175-.435-.167a.625.625 0 0 1-.254-1.223l1.14-.288a.498.498 0 0 0-.122-.98H2.553a1.77 1.77 0 0 0-.858 1.292\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRockSlide: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l2 2L3 6l5.5 5l.5 2.5H.5m9.5-7a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m3 5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m-7-10a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRockSlideRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.76.423a.625.625 0 0 1 .682.135l2 2c.096.096.158.22.177.354l.465 3.255l4.806 3.845a.63.63 0 0 1 .223.365l.5 2.5a.625.625 0 0 1-.613.748H1A.625.625 0 0 1 .375 13V1c0-.253.152-.48.386-.577M9.126 5a.875.875 0 1 1 1.75 0a.875.875 0 0 1-1.75 0M10 2.875a2.125 2.125 0 1 0 0 4.25a2.125 2.125 0 0 0 0-4.25M11.5 11a1 1 0 1 1 2 0a1 1 0 0 1-2 0M6 .5a1 1 0 1 0 0 2a1 1 0 0 0 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRockSlideSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.854.146A.5.5 0 0 0 0 .5v13a.5.5 0 0 0 .5.5H9a.5.5 0 0 0 .49-.598l-.5-2.5a.5.5 0 0 0-.154-.272L3.47 5.751L2.995 2.43a.5.5 0 0 0-.141-.283zM8 5a2 2 0 1 1 4 0a2 2 0 0 1-4 0m4 6a1 1 0 1 1 2 0a1 1 0 0 1-2 0M5 1a1 1 0 1 1 2 0a1 1 0 0 1-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRose: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4.108a8.6 8.6 0 0 1 5.496-1.599v3.497a5.495 5.495 0 0 1-10.991 0V2.51s6.554-.79 9.552 7.204\"/><path d=\"M9.908 2.769a2.998 2.998 0 0 0-5.816 0M7 11.502V13.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRoseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25c-.924 0-1.726.528-2.118 1.3c.746.25 1.456.581 2.118.983a10.6 10.6 0 0 1 2.118-.983A2.38 2.38 0 0 0 7 1.25M1.5 2a.625.625 0 0 0-.625.625v3.25a6.126 6.126 0 0 0 5.25 6.063v1.187a.875.875 0 1 0 1.75 0v-1.187a6.1 6.1 0 0 0 3.651-1.936l.034-.037a6.1 6.1 0 0 0 1.565-4.09v-3.25A.625.625 0 0 0 12.5 2a10.7 10.7 0 0 0-2.158.22a3.625 3.625 0 0 0-6.684 0A10.7 10.7 0 0 0 1.5 2M7 10.75c1.283 0 2.45-.495 3.322-1.307a9.4 9.4 0 0 0-3.676-4.656a9.3 9.3 0 0 0-4.521-1.516v2.604A4.875 4.875 0 0 0 7 10.75m4.875-4.875a4.85 4.85 0 0 1-.658 2.447a10.66 10.66 0 0 0-3.082-3.996a9.3 9.3 0 0 1 3.74-1.056z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRoseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.993 3.353a9.9 9.9 0 0 1 2.955-1.296a3.14 3.14 0 0 0-5.898.007a10.2 10.2 0 0 1 2.943 1.29m-5.185-.292a.3.3 0 0 0-.08.217v2.865A5.27 5.27 0 0 0 6.25 11.36v1.813a.75.75 0 0 0 1.5 0V11.36a5.27 5.27 0 0 0 2.874-1.39c-1.205-3-2.888-4.7-4.476-5.67A8.9 8.9 0 0 0 1.961 3a.19.19 0 0 0-.153.06m9.705 5.805a5.27 5.27 0 0 0 .758-2.723V3.337c0-.218-.16-.332-.291-.326a8.6 8.6 0 0 0-3.9 1.142c1.263 1.062 2.474 2.573 3.433 4.713\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRotateAngle45: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 4L.5 13.5h13\"/><path d=\"M7.5 13.5a7 7 0 0 0-2.05-4.95\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRotateAngle45Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.442 1.442a.625.625 0 0 0-.884-.884l-12 12A.625.625 0 0 0 1 13.625h12a.625.625 0 1 0 0-1.25H8.85a7.88 7.88 0 0 0-1.857-4.484zM5.75 9.134l-3.24 3.241h4.584A6.13 6.13 0 0 0 5.75 9.134\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRotateAngle45Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.78 4.28a.75.75 0 0 0-1.06-1.06L5.18 7.758l-.023.023L.22 12.72A.75.75 0 0 0 .75 14h12.5a.75.75 0 0 0 0-1.5H8.464a7.75 7.75 0 0 0-1.729-4.174zM5.668 9.393L2.561 12.5h4.394a6.25 6.25 0 0 0-1.287-3.107\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRoundCap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.988 7H13.5m0-4.794H5.294a4.794 4.794 0 0 0 0 9.588H13.5\"/><path d=\"M4.392 6.999a1.798 1.798 0 1 0 3.596 0a1.798 1.798 0 1 0-3.596 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRoundCapRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.625 1.375a5.625 5.625 0 0 0 0 11.25h7.75a.625.625 0 1 0 0-1.25h-7.75a4.375 4.375 0 1 1 0-8.75h7.75a.625.625 0 1 0 0-1.25zM2.875 7a2.625 2.625 0 0 1 5.175-.625h5.325a.625.625 0 1 1 0 1.25H8.05A2.626 2.626 0 0 1 2.875 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRoundCapSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a5 5 0 0 0 5 5h9V7.75H6.855a2 2 0 1 1 0-1.5H14V2H5a5 5 0 0 0-5 5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRssSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M4 10.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m.5-4a3 3 0 0 1 3 3m-3-6a6 6 0 0 1 6 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRssSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.923 1.625a.3.3 0 0 0-.298.298v10.154c0 .165.133.298.298.298h10.154a.3.3 0 0 0 .298-.298V1.923a.3.3 0 0 0-.298-.298zm-1.548.298c0-.855.693-1.548 1.548-1.548h10.154c.855 0 1.548.693 1.548 1.548v10.154c0 .855-.693 1.548-1.548 1.548H1.923a1.55 1.55 0 0 1-1.548-1.548zM2.75 10a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0m1-3.5a.75.75 0 0 1 .75-.75A3.75 3.75 0 0 1 8.25 9.5a.75.75 0 0 1-1.5 0A2.25 2.25 0 0 0 4.5 7.25a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5A5.25 5.25 0 0 1 9.75 9.5a.75.75 0 0 0 1.5 0A6.75 6.75 0 0 0 4.5 2.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRssSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0zm1.457 9.96a1.084 1.084 0 1 1 2.167 0a1.084 1.084 0 0 1-2.167 0m.459-3.502c0-.346.28-.625.625-.625a4.127 4.127 0 0 1 4.126 4.126a.625.625 0 1 1-1.25 0a2.877 2.877 0 0 0-2.876-2.876a.625.625 0 0 1-.625-.625m.625-3.626a.625.625 0 0 0 0 1.25A5.877 5.877 0 0 1 9.918 9.96a.625.625 0 1 0 1.25 0A7.127 7.127 0 0 0 4.04 2.832\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRssSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.13 13.38a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m11.25-1.26A11.5 11.5 0 0 0 1.88.62m.24 4.76a6.5 6.5 0 0 1 6.5 6.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRssSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.556 1c0-.345.28-.625.625-.625a11.45 11.45 0 0 1 10.573 7.062c.575 1.388.871 2.875.871 4.378a.625.625 0 0 1-1.25 0A10.19 10.19 0 0 0 6.082 2.4a10.2 10.2 0 0 0-3.901-.776A.625.625 0 0 1 1.556 1m.86 8.554a2.036 2.036 0 1 0 0 4.072a2.036 2.036 0 0 0 0-4.072m-.01-4.702a.625.625 0 0 0 0 1.25a5.49 5.49 0 0 1 5.49 5.487a.625.625 0 1 0 1.25 0a6.735 6.735 0 0 0-6.74-6.737\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineRssSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.857 1.052a1 1 0 0 1 1-1A12.09 12.09 0 0 1 13.95 12.143a1 1 0 0 1-2 0A10.09 10.09 0 0 0 1.857 2.052a1 1 0 0 1-1-1m1.245 8.883a1.972 1.972 0 1 0 0 3.945a1.972 1.972 0 0 0 0-3.945m-.245-5.173a1 1 0 1 0 0 2a5.38 5.38 0 0 1 5.38 5.381a1 1 0 0 0 2 0a7.38 7.38 0 0 0-7.38-7.38\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSadFace: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.75 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4 10c.448-1.428 2.15-2.3 3.85-1.904A3.07 3.07 0 0 1 10 10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSadFaceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a5.75 5.75 0 1 0 0 11.5a5.75 5.75 0 0 0 0-11.5M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m4.75-2.75a1 1 0 1 1 0 2a1 1 0 0 1 0-2m3.5 1a1 1 0 1 0 2 0a1 1 0 0 0-2 0M7 7.25a4.24 4.24 0 0 0-3.317 1.592a.75.75 0 0 0 1.17.939A2.74 2.74 0 0 1 7 8.75c.868 0 1.641.401 2.146 1.03a.75.75 0 1 0 1.17-.938A4.24 4.24 0 0 0 7 7.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSadFaceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m4.19 3.7a.625.625 0 1 1-1.207-.324a4.163 4.163 0 0 1 8.038 0a.625.625 0 0 1-1.207.325a2.913 2.913 0 0 0-5.624 0m.392-4.724a1.024 1.024 0 0 1 .002-2.049h.003a1.024 1.024 0 0 1-.003 2.049zm4.831 0a1.024 1.024 0 0 1 .003-2.049h.002a1.024 1.024 0 0 1-.002 2.049z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSafeVault: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1\"/><path d=\"M8.5 8a1.75 1.75 0 1 0 0-3.5a1.75 1.75 0 0 0 0 3.5m0-4.75V4.5m0 3.5v1.25m3-3h-1.25m-3.5 0H5.5m5.12-2.12l-.88.88M7.26 7.49l-.88.88m4.24 0l-.88-.88M7.26 5.01l-.88-.88M3 4.5V8m-1 4v1.5m9.5-1.5v1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSafeVaultRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v8.5a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375zM11.75 12.125H12c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625H2C1.103.375.375 1.103.375 2v8.5c0 .812.596 1.486 1.375 1.606V13A.625.625 0 1 0 3 13v-.875h7.5V13a.625.625 0 1 0 1.25 0zM9.125 4.35V3.5a.625.625 0 1 0-1.25 0v.85a2 2 0 0 0-.708.409l-.736-.425a.625.625 0 0 0-.625 1.082l.736.425a2 2 0 0 0 0 .818l-.736.425a.625.625 0 0 0 .625 1.082l.736-.425c.203.182.443.322.708.41V9a.625.625 0 1 0 1.25 0v-.85c.265-.087.505-.227.708-.409l.736.425a.625.625 0 0 0 .625-1.082l-.736-.425a2 2 0 0 0 0-.818l.736-.425a.625.625 0 1 0-.625-1.082l-.736.425a2 2 0 0 0-.708-.41m-5 .15a.75.75 0 0 0-1.5 0V8a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSafeVaultSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5V11a1.5 1.5 0 0 0 1.5 1.5v.702a.75.75 0 0 0 1.5 0V12.5h8v.702a.75.75 0 0 0 1.5 0V12.5A1.5 1.5 0 0 0 14 11V1.5A1.5 1.5 0 0 0 12.5 0zm7.25 4.943c-.721 0-1.306.584-1.307 1.304v.006a1.307 1.307 0 1 0 1.307-1.31M8.124 3.77a2.5 2.5 0 0 0-.687.284l-.587-.587a.625.625 0 0 0-.884.884l.587.587a2.5 2.5 0 0 0-.284.687h-.832a.625.625 0 0 0 0 1.25h.832q.093.369.284.687l-.587.587a.625.625 0 0 0 .884.884l.587-.587q.318.19.687.284v.832a.625.625 0 1 0 1.25 0V8.73q.369-.093.687-.284l.587.587a.625.625 0 0 0 .884-.884l-.587-.587q.19-.318.284-.687h.832a.625.625 0 0 0 0-1.25h-.832a2.5 2.5 0 0 0-.284-.687l.587-.587a.625.625 0 1 0-.884-.884l-.587.587a2.5 2.5 0 0 0-.687-.284v-.832a.625.625 0 1 0-1.25 0zm-5.007.364a.625.625 0 0 0-1.25 0v4.232a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSailShip: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 9.5H.5l1 2.7a2 2 0 0 0 1.88 1.3h7.22a2 2 0 0 0 1.88-1.3zm-7 0v-9m0 0l-5 6h5m2-4l3.5 4H8.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSailShipRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.97.588a.624.624 0 0 0-.953.016L1.02 6.6a.625.625 0 0 0 .48 1.025h4.375v1.25H1a.625.625 0 0 0-.6.797l.585 2.05a2.625 2.625 0 0 0 2.524 1.903h6.982a2.625 2.625 0 0 0 2.524-1.904l.586-2.05A.625.625 0 0 0 13 8.876H7.125V1A.62.62 0 0 0 6.97.588M2.834 6.375l3.041-3.649v3.649zm6.41-4.259a.625.625 0 0 0-.987.768l2.715 3.491H8.75a.625.625 0 1 0 0 1.25h3.5a.625.625 0 0 0 .493-1.009z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSailShipSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.75 7H1.327a.5.5 0 0 1-.384-.82l5-6A.5.5 0 0 1 6.41.007a.75.75 0 0 1 .84.745L7.249 9h6.25a.5.5 0 0 1 .468.676l-1.013 2.702A2.5 2.5 0 0 1 10.614 14H3.386a2.5 2.5 0 0 1-2.34-1.622L.031 9.676A.5.5 0 0 1 .5 9h5.25zm3.631-4.804a.5.5 0 0 0-.896.304v4a.5.5 0 0 0 .5.5h3.07a.5.5 0 0 0 .396-.804z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSatelliteDish: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 9A6.01 6.01 0 1 1 5 .5zM9.26 4.74L12 2\"/><path d=\"M3.96 7.57L.5 13.5H7L5.92 9.73\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSatelliteDishRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.522.183a.625.625 0 0 0-.884 0l-.243.243a5.78 5.78 0 0 0-.755 7.245l-2.594 5.62A.5.5 0 0 0 1.5 14h7a.5.5 0 0 0 .49-.599l-.622-3.11A5.76 5.76 0 0 0 12.57 8.6l.243-.243a.625.625 0 0 0 0-.884l-3.2-3.2l1.83-1.831a.625.625 0 1 0-.884-.884l-1.83 1.83zm-.243 7.533a4.53 4.53 0 0 1-.193-6.201l6.394 6.394a4.53 4.53 0 0 1-6.201-.193\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSatelliteDishSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.354.146a.5.5 0 0 0-.708 0a6.51 6.51 0 1 0 9.208 9.208a.5.5 0 0 0 0-.708L10.31 5.104l1.396-1.397a1 1 0 0 0-1.414-1.414L8.896 3.689zM2.764 9.01a7.76 7.76 0 0 0 4.184 3.151l.359 1.195a.5.5 0 0 1-.479.644H.39a.39.39 0 0 1-.332-.594z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScanner: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.75 13.5H1.429a.93.93 0 0 1-.929-.928V10.25m13 0v2.322a.93.93 0 0 1-.929.928H10.25m0-13h2.321a.93.93 0 0 1 .929.929V3.75m-13 0V1.429A.93.93 0 0 1 1.429.5H3.75M.5 7h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScanner3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.702 5.138a1.33 1.33 0 0 0-1.258-.889H6.412a1.19 1.19 0 0 0-.254 2.353l1.571.344a1.334 1.334 0 0 1-.285 2.637h-.888a1.33 1.33 0 0 1-1.258-.89M7 4.25V2.915m0 8.001V9.583M5.069.656H1.165a.49.49 0 0 0-.488.488v3.904m12.687 0V1.144a.49.49 0 0 0-.488-.488H8.972m0 12.688h3.904a.49.49 0 0 0 .488-.488V8.952m-12.687 0v3.904a.49.49 0 0 0 .488.488h3.904\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScanner3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.735 1.735c.07-.07.166-.11.265-.11h2a.625.625 0 1 0 0-1.25H2A1.625 1.625 0 0 0 .375 2v2a.625.625 0 1 0 1.25 0V2c0-.1.04-.195.11-.265M9.375 1c0-.345.28-.625.625-.625h2A1.625 1.625 0 0 1 13.625 2v2a.625.625 0 1 1-1.25 0V2A.375.375 0 0 0 12 1.625h-2A.625.625 0 0 1 9.375 1M7 2.166a.75.75 0 0 1 .75.75v.606a2.08 2.08 0 0 1 1.659 1.366a.75.75 0 1 1-1.414.5a.58.58 0 0 0-.55-.389H6.411a.44.44 0 0 0-.094.87l1.572.344a2.084 2.084 0 0 1-.14 4.097v.606a.75.75 0 0 1-1.5 0v-.606a2.09 2.09 0 0 1-1.66-1.366a.75.75 0 1 1 1.415-.5c.08.227.298.389.55.389h.889a.584.584 0 0 0 .125-1.155l-1.571-.343a1.94 1.94 0 0 1 .252-3.83v-.59a.75.75 0 0 1 .75-.75m6 7.209c.345 0 .625.28.625.625v2A1.625 1.625 0 0 1 12 13.625h-2a.625.625 0 1 1 0-1.25h2a.375.375 0 0 0 .375-.375v-2c0-.345.28-.625.625-.625M1.625 10a.625.625 0 1 0-1.25 0v2A1.625 1.625 0 0 0 2 13.625h2a.625.625 0 1 0 0-1.25H2A.375.375 0 0 1 1.625 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScanner3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 2.418a.75.75 0 0 1 .75.75v.528a2 2 0 0 1 1.553 1.306a.75.75 0 0 1-1.414.5a.5.5 0 0 0-.472-.334H6.45a.366.366 0 0 0-.079.723l1.474.323a2 2 0 0 1-.095 3.927v.527a.75.75 0 0 1-1.5 0v-.527a2 2 0 0 1-1.552-1.306a.75.75 0 1 1 1.414-.5a.5.5 0 0 0 .472.333h.833a.5.5 0 0 0 .107-.989l-1.473-.322a1.866 1.866 0 0 1 .2-3.678v-.51a.75.75 0 0 1 .75-.75ZM1.338.094A1.224 1.224 0 0 0 .114 1.317v3.789a.75.75 0 0 0 1.5 0V1.594h3.512a.75.75 0 0 0 0-1.5zm7.577 0a.75.75 0 0 0 0 1.5h3.512v3.512a.75.75 0 0 0 1.5 0V1.317A1.224 1.224 0 0 0 12.704.094zm4.262 8.05a.75.75 0 0 1 .75.75v3.789a1.224 1.224 0 0 1-1.223 1.223H8.915a.75.75 0 1 1 0-1.5h3.512V8.894a.75.75 0 0 1 .75-.75m-11.563.75a.75.75 0 1 0-1.5 0v3.789a1.224 1.224 0 0 0 1.224 1.223h3.788a.75.75 0 1 0 0-1.5H1.614z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScannerBarCode: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.11.656H1.208a.49.49 0 0 0-.488.488v3.904m12.686 0V1.144a.49.49 0 0 0-.488-.488H9.014m0 12.688h3.904a.49.49 0 0 0 .488-.488V8.952m-12.687 0v3.904a.49.49 0 0 0 .488.488H5.11m5.696-9.552v6.416M3.194 3.792v6.416m5.709-6.416v4.666m0 1.75v-.291M7 3.792v4.666m0 1.75v-.291M5.097 3.792v4.666m0 1.75v-.291\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScannerBarCodeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.735 1.735c.07-.07.166-.11.265-.11h2a.625.625 0 1 0 0-1.25H2A1.625 1.625 0 0 0 .375 2v2a.625.625 0 1 0 1.25 0V2c0-.1.04-.195.11-.265M10 .375a.625.625 0 1 0 0 1.25h2a.375.375 0 0 1 .375.375v2a.625.625 0 1 0 1.25 0V2A1.625 1.625 0 0 0 12 .375zm3 9c.345 0 .625.28.625.625v2A1.625 1.625 0 0 1 12 13.625h-2a.625.625 0 1 1 0-1.25h2a.375.375 0 0 0 .375-.375v-2c0-.345.28-.625.625-.625M1.625 10a.625.625 0 1 0-1.25 0v2A1.625 1.625 0 0 0 2 13.625h2a.625.625 0 1 0 0-1.25H2A.375.375 0 0 1 1.625 12zm9.18-6.958a.75.75 0 0 1 .75.75v6.416a.75.75 0 0 1-1.5 0V3.792a.75.75 0 0 1 .75-.75m-8.36.75a.75.75 0 1 1 1.5 0v6.416a.75.75 0 0 1-1.5 0zm5.824-.75a.75.75 0 0 1 .75.75v3.791a.75.75 0 1 1-1.5 0V3.792a.75.75 0 0 1 .75-.75m-.75 7.166a.75.75 0 0 0 1.5 0v-.541a.75.75 0 1 0-1.5 0zM5.73 3.042a.75.75 0 0 1 .75.75v3.791a.75.75 0 1 1-1.5 0V3.792a.75.75 0 0 1 .75-.75m-.75 7.166a.75.75 0 0 0 1.5 0v-.541a.75.75 0 1 0-1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScannerBarCodeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.419.136a1.22 1.22 0 0 0-1.22 1.22V5.12a.75.75 0 0 0 1.5 0V1.636H5.18a.75.75 0 1 0 0-1.5zm7.525 0a.75.75 0 0 0 0 1.5h3.483v3.483a.75.75 0 0 0 1.5 0V1.356a1.22 1.22 0 0 0-1.22-1.22zm4.233 7.995a.75.75 0 0 1 .75.75v3.763a1.22 1.22 0 0 1-1.22 1.22H8.943a.75.75 0 0 1 0-1.5h3.483V8.881a.75.75 0 0 1 .75-.75m-11.479.75a.75.75 0 1 0-1.5 0v3.763a1.22 1.22 0 0 0 1.22 1.22H5.18a.75.75 0 0 0 0-1.5H1.698zm8.972-5.598c.346 0 .625.28.625.625v6.184a.625.625 0 0 1-1.25 0V3.908c0-.345.28-.625.625-.625m-7.961.625a.625.625 0 0 1 1.25 0v6.184a.625.625 0 0 1-1.25 0zm5.72-.625c.346 0 .626.28.626.625v3.608a.625.625 0 1 1-1.25 0V3.908c0-.345.28-.625.625-.625m-.624 6.81a.625.625 0 0 0 1.25 0V9.81a.625.625 0 1 0-1.25 0zm-1.98-6.81c.344 0 .624.28.624.625v3.608a.625.625 0 1 1-1.25 0V3.908c0-.345.28-.625.625-.625m-.626 6.81a.625.625 0 0 0 1.25 0V9.81a.625.625 0 1 0-1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScannerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.375 0a.625.625 0 1 0 0 1.25h2.071c.168 0 .304.136.304.304v2.071a.625.625 0 1 0 1.25 0V1.554C14 .696 13.304 0 12.446 0zM.625 9.75c.345 0 .625.28.625.625v2.071c0 .168.136.304.304.304h2.071a.625.625 0 1 1 0 1.25H1.554A1.554 1.554 0 0 1 0 12.446v-2.071c0-.345.28-.625.625-.625m12.75 0c.345 0 .625.28.625.625v2.071c0 .858-.696 1.554-1.554 1.554h-2.071a.625.625 0 1 1 0-1.25h2.071a.304.304 0 0 0 .304-.304v-2.071c0-.345.28-.625.625-.625M1.554 1.25a.304.304 0 0 0-.304.304v2.071a.625.625 0 1 1-1.25 0V1.554C0 .696.696 0 1.554 0h2.071a.625.625 0 1 1 0 1.25zM.875 6.125a.875.875 0 1 0 0 1.75h12.25a.875.875 0 0 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScannerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.75.75A.75.75 0 0 1 10.5 0h1.75C13.216 0 14 .784 14 1.75V3.5a.75.75 0 0 1-1.5 0V1.75a.25.25 0 0 0-.25-.25H10.5a.75.75 0 0 1-.75-.75M0 7a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 7m1.5-5.25a.25.25 0 0 1 .25-.25H3.5a.75.75 0 0 0 0-1.5H1.75A1.75 1.75 0 0 0 0 1.75V3.5a.75.75 0 0 0 1.5 0zm11.75 8a.75.75 0 0 1 .75.75v1.75A1.75 1.75 0 0 1 12.25 14H10.5a.75.75 0 0 1 0-1.5h1.75a.25.25 0 0 0 .25-.25V10.5a.75.75 0 0 1 .75-.75M1.5 10.5a.75.75 0 0 0-1.5 0v1.75C0 13.216.784 14 1.75 14H3.5a.75.75 0 0 0 0-1.5H1.75a.25.25 0 0 1-.25-.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSchoolBusSide: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.625 11.492h.802a1 1 0 0 0 1-1V7.957a1 1 0 0 0-1-1h-.552V3.375a1 1 0 0 0-1-1h-9.19a1 1 0 0 0-1 1v7.26c0 .473.384.857.857.857H2m9.875-7.283H.685m11.19 2.748H.685m3.779-2.748v2.744m3.567-2.744v2.744\"/><path d=\"M1.994 11.478a1.396 1.396 0 1 0 2.792 0a1.396 1.396 0 1 0-2.792 0m6.84 0a1.396 1.396 0 1 0 2.792 0a1.396 1.396 0 1 0-2.792 0m-4.048 0h4.048\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSchoolBusSideRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.25 3c0-.897.728-1.625 1.625-1.625h8.5C11.273 1.375 12 2.103 12 3v3.375h.125c.898 0 1.625.728 1.625 1.625v2.5c0 .898-.727 1.625-1.625 1.625h-.35a2.002 2.002 0 0 1-3.802 0H5.275a2.002 2.002 0 0 1-3.82-.055A1.626 1.626 0 0 1 .25 10.5zm7.722 7.875H5.276a2.002 2.002 0 0 0-3.73-.193a.4.4 0 0 1-.046-.182V3c0-.207.168-.375.375-.375h8.5c.207 0 .375.168.375.375v4c0 .345.28.625.625.625h.75c.207 0 .375.168.375.375v2.5a.375.375 0 0 1-.375.375h-.35a2.002 2.002 0 0 0-3.803 0M9.25 7h-2.5V4h2.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5M3 4h2.5v3H3a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 3 4\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSchoolBusSideSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.145 3.526c0-.967.784-1.75 1.75-1.75h8.82c.967 0 1.75.783 1.75 1.75v2.68h.252c.69 0 1.25.56 1.25 1.25v3.385c0 .64-.48 1.167-1.1 1.241a2.511 2.511 0 1 0-5.003.009H5.757a2.511 2.511 0 1 0-5.009-.353a1.6 1.6 0 0 1-.603-1.255zm1.75.724a.25.25 0 0 0-.25.25v1.75h2.013v-2zm3.263 0v2h2.233v-2zm5.808 2H8.89v-2h1.825a.25.25 0 0 1 .25.25zm-6.45 5.62a1.261 1.261 0 1 1-2.521 0a1.261 1.261 0 0 1 2.521 0m7.11 0a1.261 1.261 0 1 1-2.522 0a1.261 1.261 0 0 1 2.522 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreen1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13 2H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-8A.5.5 0 0 0 13 2m-7 9l-1 2.5M8 11l1 2.5m-5 0h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreen1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2.125v7.25h11.5v-7.25zM0 2C0 1.379.504.875 1.125.875h11.75C13.496.875 14 1.379 14 2v7.5c0 .621-.504 1.125-1.125 1.125H8.789l.5 1.25H10a.625.625 0 1 1 0 1.25H4a.625.625 0 1 1 0-1.25h.711l.5-1.25H1.125A1.125 1.125 0 0 1 0 9.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreen1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 9V2.5h10V9zM1.457.5C.652.5 0 1.152 0 1.957v7.586C0 10.348.652 11 1.457 11h4.026l-.535 1.495H4a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-.948L8.517 11h4.026C13.348 11 14 10.348 14 9.543V1.957C14 1.152 13.348.5 12.543.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreen2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13 1.5H1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5\"/><path d=\"M3.53 13.5a3.51 3.51 0 0 1 6.94 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreen2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 9.375v-7.25h11.5v7.25zm8.575 1.25h3.05c.621 0 1.125-.504 1.125-1.125V2c0-.621-.504-1.125-1.125-1.125H1.125C.504.875 0 1.379 0 2v7.5c0 .621.504 1.125 1.125 1.125h3.05a3.8 3.8 0 0 0-.95 1.993a.875.875 0 1 0 1.73.264a2.068 2.068 0 0 1 4.09 0a.875.875 0 1 0 1.73-.264a3.8 3.8 0 0 0-.95-1.993\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreen2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 9V2.5H2V9zm.543-8.5C13.348.5 14 1.152 14 1.957v7.586c0 .805-.652 1.457-1.457 1.457h-2.486a4.1 4.1 0 0 1 1 2.121a.75.75 0 0 1-1.482.226a2.604 2.604 0 0 0-5.15 0a.75.75 0 1 1-1.483-.226c.121-.793.47-1.53 1.001-2.121H1.457A1.457 1.457 0 0 1 0 9.543V1.957C0 1.152.652.5 1.457.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreenBroadcast: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 8a4 4 0 0 1 4 4m-4-1.5A1.5 1.5 0 0 1 2 12m5 0h5.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v2.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreenBroadcastRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1A1.625 1.625 0 0 0 0 2.625v3.25a.625.625 0 1 0 1.25 0v-3.25a.375.375 0 0 1 .375-.375h10.75a.375.375 0 0 1 .375.375v8.75a.375.375 0 0 1-.375.375h-5.25a.625.625 0 1 0 0 1.25h5.25A1.625 1.625 0 0 0 14 11.375v-8.75A1.625 1.625 0 0 0 12.375 1zM0 8.25a.75.75 0 0 1 .75-.75a4.75 4.75 0 0 1 4.75 4.75a.75.75 0 0 1-1.5 0A3.25 3.25 0 0 0 .75 9A.75.75 0 0 1 0 8.25m0 2.5A.75.75 0 0 1 .75 10A2.25 2.25 0 0 1 3 12.25a.75.75 0 0 1-1.5 0a.75.75 0 0 0-.75-.75a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreenBroadcastSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.939 1.399a1.92 1.92 0 0 0-1.92 1.92v1.475a1 1 0 0 0 2 0V3.399h9.963V10.6h-4.27a1 1 0 1 0 0 2h4.35a1.92 1.92 0 0 0 1.92-1.92V3.319a1.92 1.92 0 0 0-1.92-1.92zm-1.92 6.08a.75.75 0 0 1 .75-.75a5.033 5.033 0 0 1 5.034 5.033a.75.75 0 1 1-1.5 0A3.533 3.533 0 0 0 .769 8.23a.75.75 0 0 1-.75-.75m0 2.677a.75.75 0 0 1 .75-.75a2.356 2.356 0 0 1 2.357 2.356a.75.75 0 0 1-1.5 0a.856.856 0 0 0-.857-.856a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreenCurve: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.93 11.34a42 42 0 0 0-11.86 0a.5.5 0 0 1-.57-.49V2.49A.49.49 0 0 1 1.07 2c3.934.55 7.926.55 11.86 0a.49.49 0 0 1 .57.48v8.36a.5.5 0 0 1-.57.5M7 10.92v2.5m-2.5 0h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreenCurveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.288.638c3.872.541 7.552.541 11.424 0c.317-.05.645.042.891.249s.392.515.397.837v8.374a1.13 1.13 0 0 1-.383.849a1.13 1.13 0 0 1-.9.268h-.002a41 41 0 0 0-4.84-.404v1.064H9.5a.875.875 0 0 1 0 1.75h-5a.875.875 0 1 1 0-1.75h1.625v-1.064a41 41 0 0 0-4.842.404h-.002a1.13 1.13 0 0 1-.89-.26a1.13 1.13 0 0 1-.39-.842V1.75A1.12 1.12 0 0 1 .387.895a1.12 1.12 0 0 1 .9-.256M1.25 1.895v8.062a41 41 0 0 1 11.5 0V1.895a41.6 41.6 0 0 1-11.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreenCurveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 2.495C14 1.32 12.904.542 11.853.73C10.62.952 8.737 1.145 7 1.145S3.381.952 2.147.73C1.097.542 0 1.32 0 2.495v7.01c0 1.175 1.096 1.954 2.147 1.765c1.058-.19 2.592-.36 4.103-.404v1.433H4.639a.75.75 0 0 0 0 1.5H9.36a.75.75 0 0 0 0-1.5H7.75v-1.433c1.51.045 3.045.214 4.103.404c1.05.189 2.147-.59 2.147-1.765zm-7 .65c1.766 0 3.66-.184 5-.41v6.53a32 32 0 0 0-5-.41c-1.766 0-3.66.184-5 .41v-6.53c1.34.226 3.234.41 5 .41\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreensaverMonitorWallpaper: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1 1.25h12c.3 0 .5.2.5.5v8c0 .3-.2.5-.5.5H1c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5\"/><path d=\"M4.64 5.75a1.39 1.39 0 1 0 0-2.781a1.39 1.39 0 0 0 0 2.781M6 10.25l-1 2.5m3-2.5l1 2.5m-5 0h6m-5.91-2.5l5.075-4.88a.48.48 0 0 1 .624 0L13.5 8.11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreensaverMonitorWallpaperRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7.122V1.625h11.5v8.25h-2.646l-4.926-4.62l-.022-.02a1 1 0 0 0-1.263-.013zm-.125 4.003h4.086l-.5 1.25H4a.625.625 0 1 0 0 1.25h6a.625.625 0 1 0 0-1.25h-.711l-.5-1.25h4.086c.621 0 1.125-.504 1.125-1.125V1.5c0-.621-.504-1.125-1.125-1.125H1.125C.504.375 0 .879 0 1.5V10c0 .621.504 1.125 1.125 1.125m7.35-6.89a1.39 1.39 0 1 0 2.78.001a1.39 1.39 0 0 0-2.78-.002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScreensaverMonitorWallpaperSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 2.25v6.5h2.178l3.998-3.745l.022-.02a1 1 0 0 1 1.264-.012L12 6.798V2.25zm-2-.543C0 .902.652.25 1.457.25h11.086C13.348.25 14 .902 14 1.707v7.586c0 .805-.652 1.457-1.457 1.457H8.515l.537 1.5H10a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.948l.537-1.5H1.457A1.457 1.457 0 0 1 0 9.293zM5.969 4.39a1.36 1.36 0 1 1-2.719 0a1.36 1.36 0 0 1 2.719 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScript2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 3.5v8a2 2 0 0 1-2 2H.5a2 2 0 0 0 2-2v-9a2 2 0 0 1 2-2h7.25\"/><path d=\"M11.75.5a1.75 1.75 0 0 1 1.75 1.75V3a.5.5 0 0 1-.5.5h-3V2.25A1.75 1.75 0 0 1 11.75.5M6 4h1.5M5 7h2.5M5 10h2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScript2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.625 1.25A1.375 1.375 0 0 0 3.25 2.625v8.75c0 .49-.137.965-.389 1.375h5.014a1.375 1.375 0 0 0 1.375-1.375v-9c0-.396.099-.782.283-1.125zM10.5 11.375V4.25h2.375A1.125 1.125 0 0 0 14 3.125v-.75A2.375 2.375 0 0 0 11.625 0h-7A2.625 2.625 0 0 0 2 2.625v8.75A1.375 1.375 0 0 1 .625 12.75a.625.625 0 1 0 0 1.25h7.25a2.625 2.625 0 0 0 2.625-2.625m-4.5-8a.625.625 0 1 0 0 1.25h1.5a.625.625 0 1 0 0-1.25zM4.375 7c0-.345.28-.625.625-.625h2.5a.625.625 0 1 1 0 1.25H5A.625.625 0 0 1 4.375 7M5 9.375a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineScript2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.5 11.5V2.707c0-.533.14-1.079.371-1.424a.625.625 0 1 1 1.04.693a1 1 0 0 0-.102.263c-.036.137-.059.3-.059.468V4H13a1 1 0 0 0 1-1v-.75A2.25 2.25 0 0 0 11.75 0H4.5A2.5 2.5 0 0 0 2 2.5v9A1.5 1.5 0 0 1 .5 13a.5.5 0 0 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5m-5.323-8c0-.345.28-.625.625-.625H7.74a.625.625 0 1 1 0 1.25H5.802a.625.625 0 0 1-.625-.625m-.666 2.375a.625.625 0 1 0 0 1.25H7.74a.625.625 0 1 0 0-1.25zM3.885 9.5c0-.345.28-.625.626-.625H7.74a.625.625 0 1 1 0 1.25H4.51a.625.625 0 0 1-.624-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSearchDollar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 12.5a6 6 0 1 0 0-12a6 6 0 0 0 0 12m4.24-1.76l2.76 2.76\"/><path d=\"M3.5 5.849c0-.489.396-.885.885-.885h4.23c.489 0 .885.396.885.885v2.516a.884.884 0 0 1-.885.885h-4.23a.884.884 0 0 1-.885-.885zM5.214 4.76v-.51a1 1 0 0 1 1-1h.572a1 1 0 0 1 1 1v.51\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSearchDollarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1.25a5.25 5.25 0 1 0 0 10.5a5.25 5.25 0 0 0 0-10.5M0 6.5a6.5 6.5 0 1 1 11.673 3.936l2.07 2.07a.875.875 0 0 1-1.237 1.238l-2.07-2.07A6.5 6.5 0 0 1 0 6.5m5.84-2.296c0-.207.167-.375.374-.375h.572c.207 0 .375.168.375.375v.26H5.839zm-1.25.26v-.26c0-.897.727-1.625 1.624-1.625h.572c.897 0 1.625.728 1.625 1.625v.26h.204c.765 0 1.385.62 1.385 1.385v2.516c0 .765-.62 1.385-1.385 1.385h-4.23C3.62 9.75 3 9.13 3 8.365V5.85c0-.765.62-1.385 1.385-1.385z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSearchDollarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 1.5a5 5 0 1 0 0 10a5 5 0 0 0 0-10M0 6.5a6.5 6.5 0 1 1 11.749 3.835l1.958 1.958a1 1 0 1 1-1.414 1.414l-1.958-1.958A6.5 6.5 0 0 1 0 6.5m5.837-1.88c0-.175.141-.317.316-.317h.693c.175 0 .317.142.317.316v.498H5.837zm2.38 0v.497h.46a.95.95 0 0 1 .95.948v2.241a.95.95 0 0 1-.95.948H4.323a.95.95 0 0 1-.95-.948V6.065a.95.95 0 0 1 .95-.948h.459v-.498A1.37 1.37 0 0 1 6.153 3.25h.693a1.37 1.37 0 0 1 1.372 1.37\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSearchVisual: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 10.5v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2\"/><path d=\"M3.25 6.25a3 3 0 1 0 6 0a3 3 0 1 0-6 0\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m8.5 8.5l2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSearchVisualRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625A.375.375 0 0 0 1.625 2v2a.625.625 0 1 1-1.25 0V2A1.625 1.625 0 0 1 2 .375h2a.625.625 0 1 1 0 1.25zm8-1.25a.625.625 0 1 0 0 1.25h2a.375.375 0 0 1 .375.375v2a.625.625 0 1 0 1.25 0V2A1.625 1.625 0 0 0 12 .375zM13.625 10a.625.625 0 1 0-1.25 0v2a.375.375 0 0 1-.375.375h-2a.625.625 0 1 0 0 1.25h2A1.625 1.625 0 0 0 13.625 12zm-12 0a.625.625 0 1 0-1.25 0v2A1.625 1.625 0 0 0 2 13.625h2a.625.625 0 1 0 0-1.25H2A.375.375 0 0 1 1.625 12zM6.25 3.875a2.375 2.375 0 1 0 0 4.75a2.375 2.375 0 0 0 0-4.75M2.625 6.25a3.625 3.625 0 1 1 6.732 1.87l1.512 1.511A.875.875 0 0 1 9.63 10.87L8.12 9.357A3.625 3.625 0 0 1 2.625 6.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSearchVisualSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75 1.5a.25.25 0 0 0-.25.25v1.5a.75.75 0 0 1-1.5 0v-1.5A1.75 1.75 0 0 1 1.75 0h1.5a.75.75 0 0 1 0 1.5zm11.5 8.5a.75.75 0 0 1 .75.75v1.5A1.75 1.75 0 0 1 12.25 14h-1.5a.75.75 0 0 1 0-1.5h1.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 .75-.75m-11.75.75a.75.75 0 0 0-1.5 0v1.5A1.75 1.75 0 0 0 1.75 14h1.5a.75.75 0 0 0 0-1.5h-1.5a.25.25 0 0 1-.25-.25zm8.5-10a.75.75 0 0 1 .75-.75h1.5A1.75 1.75 0 0 1 14 1.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.25.25 0 0 0-.25-.25h-1.5A.75.75 0 0 1 10 .75M6.25 4a2.25 2.25 0 1 0 0 4.5a2.25 2.25 0 0 0 0-4.5M2.5 6.25a3.75 3.75 0 1 1 6.879 2.068L11.03 9.97a.75.75 0 1 1-1.06 1.06L8.318 9.38A3.75 3.75 0 0 1 2.5 6.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSelectCircleArea1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5.67a6.7 6.7 0 0 0-3 0m-1.91.8a7 7 0 0 0-1.19.93a7 7 0 0 0-.93 1.19M.67 5.5a6.7 6.7 0 0 0 0 3m.8 1.91a7 7 0 0 0 .93 1.19q.544.53 1.19.93m1.91.8a6.7 6.7 0 0 0 3 0m1.91-.8q.646-.4 1.19-.93q.53-.545.93-1.19m.8-1.91a6.7 6.7 0 0 0 0-3m-.8-1.91a7 7 0 0 0-.93-1.19a7 7 0 0 0-1.19-.93\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSelectCircleArea1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.611.182a7.2 7.2 0 0 0-3.222 0a.625.625 0 1 0 .28 1.218a5.95 5.95 0 0 1 2.662 0a.625.625 0 1 0 .28-1.218M3.984 2.107a.625.625 0 1 0-.659-1.062a7.4 7.4 0 0 0-1.273.995l-.012.012q-.566.584-.996 1.274a.625.625 0 1 0 1.063.659q.354-.572.823-1.055a6.2 6.2 0 0 1 1.054-.823M.931 4.92a.625.625 0 0 1 .47.749a5.9 5.9 0 0 0 0 2.662a.625.625 0 0 1-1.219.28a7.2 7.2 0 0 1 0-3.222a.625.625 0 0 1 .75-.47m1.176 5.095a.625.625 0 1 0-1.063.66q.429.69.996 1.273l.012.012q.583.566 1.273.996a.625.625 0 1 0 .66-1.063a6.3 6.3 0 0 1-1.055-.823a6.2 6.2 0 0 1-.823-1.054m2.812 3.054a.625.625 0 0 1 .75-.469a5.95 5.95 0 0 0 2.662 0a.625.625 0 1 1 .28 1.218a7.2 7.2 0 0 1-3.222 0a.625.625 0 0 1-.47-.749m8.036-2.395a.625.625 0 1 0-1.062-.659a6.2 6.2 0 0 1-.823 1.055a6.3 6.3 0 0 1-1.055.823a.625.625 0 0 0 .66 1.063a7.5 7.5 0 0 0 1.273-.996l.012-.012q.567-.582.995-1.274m.114-5.754a.625.625 0 0 1 .75.469a7.2 7.2 0 0 1 0 3.223a.625.625 0 0 1-1.22-.28a5.9 5.9 0 0 0 0-2.663a.625.625 0 0 1 .47-.75m-2.395-3.875a.625.625 0 0 0-.659 1.062q.572.355 1.055.823q.468.483.823 1.055a.625.625 0 0 0 1.062-.66a7.5 7.5 0 0 0-.995-1.273l-.012-.012a7.5 7.5 0 0 0-1.274-.995\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSelectCircleArea1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.738.114a7 7 0 0 1 2.524 0a.75.75 0 0 1-.27 1.475a5.5 5.5 0 0 0-1.985 0A.75.75 0 1 1 5.738.114M4.066 1.429a.75.75 0 0 1-.19 1.044a5.5 5.5 0 0 0-1.403 1.403a.75.75 0 1 1-1.234-.853a7 7 0 0 1 1.784-1.784a.75.75 0 0 1 1.043.19m5.868 0a.75.75 0 0 1 1.043-.19a7 7 0 0 1 1.784 1.784a.75.75 0 0 1-1.234.853a5.5 5.5 0 0 0-1.403-1.403a.75.75 0 0 1-.19-1.044M.986 5.135a.75.75 0 0 1 .603.872a5.5 5.5 0 0 0 0 1.986a.75.75 0 1 1-1.475.269a7 7 0 0 1 0-2.524a.75.75 0 0 1 .872-.603m12.028 0a.75.75 0 0 1 .873.603a7 7 0 0 1 0 2.524a.75.75 0 0 1-1.476-.27a5.5 5.5 0 0 0 0-1.985a.75.75 0 0 1 .603-.872M1.43 9.934a.75.75 0 0 1 1.044.19a5.5 5.5 0 0 0 1.403 1.403a.75.75 0 1 1-.853 1.234a7 7 0 0 1-1.784-1.784a.75.75 0 0 1 .19-1.043m11.142 0a.75.75 0 0 1 .19 1.043a7 7 0 0 1-1.784 1.784a.75.75 0 0 1-.853-1.234a5.5 5.5 0 0 0 1.403-1.403a.75.75 0 0 1 1.044-.19m-7.436 3.08a.75.75 0 0 1 .872-.603a5.5 5.5 0 0 0 1.986 0a.75.75 0 1 1 .269 1.475a7 7 0 0 1-2.524 0a.75.75 0 0 1-.603-.872\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSendEmail: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5.812 11l2.178 2.17a1.1 1.1 0 0 0 1.05.3a1.12 1.12 0 0 0 .809-.74l3.576-10.72A1.118 1.118 0 0 0 11.987.57L1.267 4.147a1.12 1.12 0 0 0-.74.859a1.1 1.1 0 0 0 .3 1l2.737 2.737l-.09 3.466zM13.106.79L3.564 8.742\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSendEmailRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.688.103a1.724 1.724 0 0 1 2.208 2.208L10.39 12.816a1.72 1.72 0 0 1-1.242 1.137a1.7 1.7 0 0 1-1.619-.462L5.716 11.69l-1.89.976a.625.625 0 0 1-.911-.571l.08-3.132L.5 6.467a1.7 1.7 0 0 1-.466-1.542A1.72 1.72 0 0 1 1.17 3.61l.005-.002zm.69 1.157a.47.47 0 0 0-.286.026L1.572 4.793a.47.47 0 0 0-.31.363l-.003.014a.45.45 0 0 0 .123.412l1.95 1.948l6.33-4.177a.5.5 0 0 1 .616.783L4.225 9.8l-.033 1.27l1.355-.7a.625.625 0 0 1 .728.111l2.138 2.127l.006.006a.45.45 0 0 0 .433.124l.008-.002a.47.47 0 0 0 .342-.312v-.002l3.511-10.516l.007-.02a.47.47 0 0 0-.342-.626\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSendEmailSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.821.098a1.62 1.62 0 0 1 2.077 2.076l-3.574 10.712a1.62 1.62 0 0 1-1.168 1.069a1.6 1.6 0 0 1-1.52-.434l-1.918-1.909l-2.014 1.042a.5.5 0 0 1-.73-.457l.083-3.184l7.045-5.117a.625.625 0 1 0-.735-1.012L2.203 8.088l-1.73-1.73a1.6 1.6 0 0 1-.437-1.447a1.62 1.62 0 0 1 1.068-1.238h.004z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineServingDome: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 3a6.5 6.5 0 0 1 6.5 6.5v0a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1A6.5 6.5 0 0 1 7 3m0 0V1.5m-6.5 11h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineServingDomeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .461c.345 0 .625.28.625.625v.875c3.58.321 6.376 3.376 6.376 7.026c0 .846-.685 1.553-1.545 1.553H1.544c-.86 0-1.545-.707-1.545-1.553c0-3.65 2.797-6.705 6.376-7.026v-.875c0-.345.28-.625.625-.625m0 2.722c-3.17 0-5.751 2.621-5.751 5.804c0 .17.139.303.295.303h10.912a.3.3 0 0 0 .295-.303c0-3.183-2.582-5.804-5.751-5.804M.875 11.625a.875.875 0 0 0 0 1.75h12.25a.875.875 0 0 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineServingDomeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .103a.75.75 0 0 1 .75.75v1.04A7 7 0 0 1 14 8.854a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5a7 7 0 0 1 6.25-6.96V.854A.75.75 0 0 1 7 .103M.78 11.75a.75.75 0 0 0 0 1.5h12.44a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShareLink: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.75 9.25a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5m8.5 4.25a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5m0-8.5a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5M4.76 6l4.48-2.25M4.76 8l4.48 2.25\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShareLinkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10 10.5a1.375 1.375 0 1 0 2.75 0a1.375 1.375 0 0 0-2.75 0m1.375 2.625a2.625 2.625 0 0 1-2.622-2.755l-4.17-1.62a2.625 2.625 0 1 1 0-3.497l4.17-1.622l-.003-.13a2.625 2.625 0 1 1 .667 1.749l-4.17 1.62a3 3 0 0 1 0 .258l4.17 1.622a2.625 2.625 0 1 1 1.958 4.374m0-8.25a1.375 1.375 0 1 1 0-2.75a1.375 1.375 0 0 1 0 2.75m-8.75 3.5a1.375 1.375 0 1 1 0-2.75a1.375 1.375 0 0 1 0 2.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShareLinkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.25 5.5a2.75 2.75 0 1 0-2.747-2.62l-4 2a2.75 2.75 0 1 0 0 4.239l4 2a2.75 2.75 0 1 0 .816-1.828L5.475 7.37a2.8 2.8 0 0 0 0-.74L9.32 4.708c.497.49 1.179.792 1.931.792Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShelf: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.5.5h-9a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M1.5 4h11m-11 3.5h11M7 7.5v6M9.5 10v1m-5-1v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShelfRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 1.25a.375.375 0 0 0-.375.375v2.5h9.75v-2.5a.375.375 0 0 0-.375-.375zm-.375 11.125v-4.75h4.25v5.125H2.5a.375.375 0 0 1-.375-.375m5.5.375V7.625h4.25v4.75a.375.375 0 0 1-.375.375zM7 14h4.5c.898 0 1.625-.727 1.625-1.625V1.625C13.125.728 12.398 0 11.5 0h-9C1.603 0 .875.728.875 1.625v10.75C.875 13.273 1.603 14 2.5 14zm2.25-4.875a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75m-3.75.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShelfSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 1.5A1.5 1.5 0 0 1 2.5 0h9A1.5 1.5 0 0 1 13 1.5v1.502H1zm0 2.752v2.623h12V4.252zm5.375 3.873H1V12.5A1.5 1.5 0 0 0 2.5 14h3.875zM7.625 14V8.125H13V12.5a1.5 1.5 0 0 1-1.5 1.5zM9.5 9.881c.345 0 .625.28.625.625v1a.625.625 0 1 1-1.25 0v-1c0-.345.28-.625.625-.625m-4.375.625a.625.625 0 1 0-1.25 0v1a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShell: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.497 11.5v1a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1m.278-7.649a2.5 2.5 0 0 0-3.572 3.147q-.187.241-.345.47c-.572.829-.202 1.898.678 2.388l2.96 1.644h5.047l2.924-1.642c.875-.49 1.242-1.557.672-2.383a10 10 0 0 0-.35-.477a2.5 2.5 0 0 0-3.572-3.147a2.5 2.5 0 0 0-4.442 0M8.497 7l.724-3.154m3.625 3.014L9.996 9M5.497 7l-.725-3.154M1.147 6.86L3.997 9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShellRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.996 1.16c-.986 0-1.864.459-2.433 1.174A3.11 3.11 0 0 0 .537 6.149q-.08.11-.154.217c-.823 1.192-.24 2.65.884 3.274l2.62 1.456v.62c0 .897.728 1.624 1.626 1.624H8.48c.897 0 1.625-.727 1.625-1.625v-.595l2.633-1.478c1.118-.628 1.695-2.081.876-3.269l-.16-.225A3.11 3.11 0 0 0 9.43 2.333A3.1 3.1 0 0 0 6.997 1.16m-.88 4.957l-.663-2.885a1.857 1.857 0 0 1 3.087 0l-.662 2.885a.625.625 0 0 0 1.218.28L9.75 3.55a1.86 1.86 0 0 1 2.528 2.166L9.763 7.344a.625.625 0 1 0 .68 1.05l2.106-1.364l.037.053c.313.454.161 1.12-.46 1.469l-2.762 1.55h-4.69l-2.8-1.555c-.624-.346-.777-1.015-.463-1.47l.033-.048l2.107 1.364a.625.625 0 1 0 .68-1.049L1.714 5.716a1.86 1.86 0 0 1 2.53-2.166l.653 2.846a.625.625 0 0 0 1.218-.28\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShellSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.16 3.588a2.503 2.503 0 0 0-3.08 3.05l3.043 2.284a.625.625 0 0 1-.75 1L.64 7.869c-.278.737.064 1.572.777 2.017L3.999 11.5v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1l2.582-1.614c.712-.445 1.054-1.279.778-2.015l-2.73 2.05a.625.625 0 1 1-.752-.999l3.04-2.282a2.502 2.502 0 0 0-3.075-3.053l-.008.04L9.11 6.78a.625.625 0 0 1-1.218-.28l.724-3.154a.6.6 0 0 1 .076-.187a2.5 2.5 0 0 0-1.693-.66c-.652 0-1.245.25-1.69.658q.053.086.077.189L6.11 6.5a.625.625 0 0 1-1.218.28l-.724-3.155z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShield1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.354 13.384a1 1 0 0 1-.714 0v0A9.49 9.49 0 0 1 .55 4.517V1.542A.99.99 0 0 1 1.542.55h10.91a.99.99 0 0 1 .991.992v2.975a9.49 9.49 0 0 1-6.09 8.867\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShield1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M12 1H2a1 1 0 0 0-1 1v2.675A8.775 8.775 0 0 0 7 13a8.775 8.775 0 0 0 6-8.325V2a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShield1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 4.927a9.4 9.4 0 0 1-6.635 8.984a1.24 1.24 0 0 1-.73 0A9.4 9.4 0 0 1 0 4.927V1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShield2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m7.92 13.21l-.59.23a.94.94 0 0 1-.66 0l-.59-.23A8 8 0 0 1 1 5.78V3A6.36 6.36 0 0 0 7 .5c1.25 1.82 3.32 2.68 6 2.5v2.78a8 8 0 0 1-5.08 7.43\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShield2Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M13 5.565V3.75a1 1 0 0 0-1-1h-1.097a4 4 0 0 1-2.499-.877L7 .75L5.596 1.873a4 4 0 0 1-2.5.877H2a1 1 0 0 0-1 1v1.815a7.92 7.92 0 0 0 6 7.685c3.526-.882 6-4.05 6-7.685\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShield2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.412.217A.5.5 0 0 0 6.6.202a5.86 5.86 0 0 1-5.53 2.303A.5.5 0 0 0 .5 3v2.781a8.5 8.5 0 0 0 5.398 7.895l.59.23l.006.002a1.44 1.44 0 0 0 1.012 0l.006-.002l.59-.23l-.182-.466l.183.466A8.5 8.5 0 0 0 13.5 5.78V3a.5.5 0 0 0-.534-.499c-2.549.171-4.427-.644-5.554-2.284\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShieldCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.354 13.384a1 1 0 0 1-.714 0v0A9.49 9.49 0 0 1 .55 4.517V1.542A.99.99 0 0 1 1.542.55h10.91a.99.99 0 0 1 .991.992v2.975a9.49 9.49 0 0 1-6.09 8.867\"/><path d=\"M10 4L6 8.5L4 7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShieldCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v2.675a9.4 9.4 0 0 0 6.427 8.918a.62.62 0 0 0 .396 0a9.4 9.4 0 0 0 6.427-8.918V2c0-.897-.727-1.625-1.625-1.625zM1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v2.675A8.15 8.15 0 0 1 7 12.338a8.15 8.15 0 0 1-5.375-7.663zm8.936 2.498a.75.75 0 0 0-1.122-.996L5.898 7.486L4.45 6.4a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.01-.102z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShieldCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5C0 .677.68 0 1.5 0h11c.82 0 1.5.678 1.5 1.5v2.853c0 4.136-2.51 8.006-6.411 9.528a1.6 1.6 0 0 1-.596.12a1.6 1.6 0 0 1-.582-.12C2.51 12.359 0 8.489 0 4.353zm10.56 3.008a.75.75 0 1 0-1.12-.996L5.898 7.496L4.45 6.41a.75.75 0 1 0-.9 1.2l2 1.5a.75.75 0 0 0 1.01-.102z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShieldCross: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.36 13.433a1 1 0 0 1-.72 0A9.565 9.565 0 0 1 .504 4.498V1.499A1 1 0 0 1 1.503.5h10.994a1 1 0 0 1 1 1v2.998a9.565 9.565 0 0 1-6.137 8.935\"/><path d=\"M8 3.008H6v2H4.001v1.998h2v2h1.998v-2h2V5.007h-2z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShieldCrossRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v2.675a9.4 9.4 0 0 0 6.427 8.918a.62.62 0 0 0 .396 0a9.4 9.4 0 0 0 6.427-8.918V2c0-.897-.727-1.625-1.625-1.625zM1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v2.675A8.15 8.15 0 0 1 7 12.338a8.15 8.15 0 0 1-5.375-7.663zM5.5 3.25a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H8.5v1.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-1.5H4a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShieldCrossSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 4.927a9.4 9.4 0 0 1-6.635 8.984a1.24 1.24 0 0 1-.73 0A9.4 9.4 0 0 1 0 4.927V1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5zM5.6 2.908a.5.5 0 0 1 .5-.5h1.8a.5.5 0 0 1 .5.5v1.7h1.698a.5.5 0 0 1 .5.5v1.798a.5.5 0 0 1-.5.5H8.4v1.699a.5.5 0 0 1-.5.5H6.1a.5.5 0 0 1-.5-.5V7.406H3.901a.5.5 0 0 1-.5-.5V5.107a.5.5 0 0 1 .5-.5h1.7V2.908Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShift: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.646.854L1.354 6.146A.5.5 0 0 0 1.707 7H3.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V7h1.793a.5.5 0 0 0 .353-.854L7.354.854a.5.5 0 0 0-.708 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShiftRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m6.623.789l-4.986 5.36a.509.509 0 0 0 .377.855h2.42v5.862c0 .281.23.509.513.509h4.105a.51.51 0 0 0 .514-.51v-5.86h2.42a.51.51 0 0 0 .377-.856L7.377.79a.516.516 0 0 0-.754 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShiftSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6.646.854L1.354 6.146A.5.5 0 0 0 1.707 7H3.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V7h1.793a.5.5 0 0 0 .353-.854L7.354.854a.5.5 0 0 0-.708 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentAdd: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v4m-6.5 0h13v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z\"/><path d=\"M.5 4.5L2 1.61A2 2 0 0 1 3.74.5h6.52a2 2 0 0 1 1.79 1.11L13.5 4.5M9.5 9h-5M7 6.5v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375.5H3.383a1.5 1.5 0 0 0-1.356.858L.548 4.478a.5.5 0 0 0-.046.259l-.002.05v7.165A1.55 1.55 0 0 0 2.048 13.5h9.904a1.55 1.55 0 0 0 1.548-1.548V4.787l-.002-.05a.5.5 0 0 0-.046-.259l-1.48-3.12A1.5 1.5 0 0 0 10.618.5H7.625v4.692h4.625v6.76a.3.3 0 0 1-.298.298H2.048a.3.3 0 0 1-.298-.298v-6.76h4.625zM7 6.221c.345 0 .625.28.625.625v1.375H9a.625.625 0 1 1 0 1.25H7.625v1.375a.625.625 0 1 1-1.25 0V9.471H5a.625.625 0 1 1 0-1.25h1.375V6.846c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H3.489a2.19 2.19 0 0 0-1.874 1.195L0 4.308v.016h6.375zM0 12.923V5.574h14v7.35A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923m14-8.615v.016H7.625V0h2.886a2.19 2.19 0 0 1 1.928 1.195zM7 6.5a.75.75 0 0 1 .75.75V9H9.5a.75.75 0 0 1 0 1.5H7.75v1.75a.75.75 0 0 1-1.5 0V10.5H4.5a.75.75 0 0 1 0-1.5h1.75V7.25A.75.75 0 0 1 7 6.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v4m-6.5 0h13v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z\"/><path d=\"M.5 4.5L2 1.61A2 2 0 0 1 3.74.5h6.52a2 2 0 0 1 1.79 1.11L13.5 4.5M9.498 7l-2.996 4l-2-1.498\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375.308H3.383a1.5 1.5 0 0 0-1.356.858L.548 4.286a.5.5 0 0 0-.046.259l-.002.05v7.165a1.55 1.55 0 0 0 1.548 1.548h9.904A1.55 1.55 0 0 0 13.5 11.76V4.595l-.002-.05a.5.5 0 0 0-.046-.259l-1.48-3.12a1.5 1.5 0 0 0-1.355-.858H7.625V5h4.625v6.76a.3.3 0 0 1-.298.298H2.048a.3.3 0 0 1-.298-.298V5h4.625zM9.75 7.375a.625.625 0 0 0-1-.75L6.426 9.728l-1.301-.975a.625.625 0 1 0-.75 1l1.802 1.35a.625.625 0 0 0 .875-.126z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H3.489a2.19 2.19 0 0 0-1.874 1.195L0 4.308v.016h6.375zM0 12.923V5.574h14v7.35A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923m14-8.615v.016H7.625V0h2.886a2.19 2.19 0 0 1 1.928 1.195zM9.437 8.636a.625.625 0 1 0-1-.75L6.488 10.49l-1.05-.79a.625.625 0 1 0-.75 1l1.55 1.163a.625.625 0 0 0 .876-.126z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentDownload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v4m-6.5 0h13v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z\"/><path d=\"M.5 4.5L2 1.61A2 2 0 0 1 3.74.5h6.52a2 2 0 0 1 1.79 1.11L13.5 4.5M7 6.705v4.612m1.75-1.721L7 11.346l-1.75-1.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentDownloadRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375.308H3.383a1.5 1.5 0 0 0-1.356.858L.548 4.286a.5.5 0 0 0-.046.259l-.002.05v7.165a1.55 1.55 0 0 0 1.548 1.548h9.904A1.55 1.55 0 0 0 13.5 11.76V4.595l-.002-.05a.5.5 0 0 0-.046-.259l-1.48-3.12a1.5 1.5 0 0 0-1.355-.858H7.625V5h4.625v6.76a.3.3 0 0 1-.298.298H2.048a.3.3 0 0 1-.298-.298V5h4.625zM7 6.096c.345 0 .625.28.625.625v1.75H8.75a.625.625 0 0 1 .442 1.067l-1.75 1.75a.62.62 0 0 1-.442.183a.62.62 0 0 1-.452-.193l-1.74-1.74A.625.625 0 0 1 5.25 8.47h1.125V6.72c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentDownloadSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H3.489a2.19 2.19 0 0 0-1.874 1.195L0 4.308v.016h6.375zM0 12.923V5.574h14v7.35A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923m14-8.615v.016H7.625V0h2.886a2.19 2.19 0 0 1 1.928 1.195zM6.375 7.705a.625.625 0 0 1 1.25 0v2.003h.848a.526.526 0 0 1 .372.898L7.372 12.08a.526.526 0 0 1-.744 0l-1.473-1.474a.526.526 0 0 1 .372-.898h.848z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentRemove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v4m-6.5 0h13v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z\"/><path d=\"M.5 4.5L2 1.61A2 2 0 0 1 3.74.5h6.52a2 2 0 0 1 1.79 1.11L13.5 4.5M9.5 9h-5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentRemoveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375.5H3.383a1.5 1.5 0 0 0-1.356.858L.548 4.478a.5.5 0 0 0-.046.259l-.002.05v7.165A1.55 1.55 0 0 0 2.048 13.5h9.904a1.55 1.55 0 0 0 1.548-1.548V4.787l-.002-.05a.5.5 0 0 0-.046-.259l-1.48-3.12A1.5 1.5 0 0 0 10.618.5H7.625v4.692h4.625v6.76a.3.3 0 0 1-.298.298H2.048a.3.3 0 0 1-.298-.298v-6.76h4.625zM5 8.221a.625.625 0 1 0 0 1.25h4a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentRemoveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H3.489a2.19 2.19 0 0 0-1.874 1.195L0 4.308v.016h6.375zM0 12.923V5.574h14v7.35A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923m14-8.615v.016H7.625V0h2.886a2.19 2.19 0 0 1 1.928 1.195zM4.5 9a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentUpload: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v4m-6.5 0h13v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z\"/><path d=\"M.5 4.5L2 1.61A2 2 0 0 1 3.74.5h6.52a2 2 0 0 1 1.79 1.11L13.5 4.5M7 11.346V6.734m1.75 1.721L7 6.705l-1.75 1.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentUploadRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375.5H3.383a1.5 1.5 0 0 0-1.356.858L.548 4.478a.5.5 0 0 0-.046.259l-.002.05v7.165A1.55 1.55 0 0 0 2.048 13.5h9.904a1.55 1.55 0 0 0 1.548-1.548V4.787l-.002-.05a.5.5 0 0 0-.046-.259l-1.48-3.12A1.5 1.5 0 0 0 10.618.5H7.625v4.692h4.625v6.76a.3.3 0 0 1-.298.298H2.048a.3.3 0 0 1-.298-.298v-6.76h4.625zm2.953 8.21a.625.625 0 0 1-.578.386H7.625v1.75a.625.625 0 1 1-1.25 0v-1.75H5.25a.625.625 0 0 1-.442-1.067l1.75-1.75a.623.623 0 0 1 .893.01l1.741 1.74a.625.625 0 0 1 .136.682\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShipmentUploadSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H3.489a2.19 2.19 0 0 0-1.874 1.195L0 4.308v.016h6.375zM0 12.923V5.574h14v7.35A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923m14-8.615v.016H7.625V0h2.886a2.19 2.19 0 0 1 1.928 1.195zm-7.625 7.538a.625.625 0 1 0 1.25 0V9.843h.849a.526.526 0 0 0 .372-.898L7.372 7.47a.526.526 0 0 0-.744 0L5.154 8.945a.526.526 0 0 0 .372.898h.849z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingBox1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M9 .5v5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-5M8.5 11H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingBox1BoxPackageLabelDeliveryShipmentShipping: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M9 .5v5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-5M8.5 11H11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingBox1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375A1.625 1.625 0 0 0 .375 2v10A1.625 1.625 0 0 0 2 13.625h10A1.625 1.625 0 0 0 13.625 12V2A1.625 1.625 0 0 0 12 .375zm-.265 1.36c.07-.07.166-.11.265-.11h2.5V6a.5.5 0 0 0 .8.4L7 5.125L8.7 6.4a.5.5 0 0 0 .8-.4V1.625H12a.375.375 0 0 1 .375.375v10a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12V2c0-.1.04-.195.11-.265\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingBox1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5 0h-3v4.508c0 .13.055.255.154.348A.54.54 0 0 0 6.026 5h1.948c.14 0 .273-.052.372-.144a.48.48 0 0 0 .154-.348zM4.25 0H1.5A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0H9.75v4.508c0 .49-.208.94-.55 1.26c-.338.317-.78.482-1.226.482H6.026c-.446 0-.888-.165-1.226-.482a1.73 1.73 0 0 1-.55-1.26zm4.51 11.1c0-.346.28-.626.624-.626h2.014a.625.625 0 0 1 0 1.25H9.384a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingBox2BoxPackageLabelDeliveryShipmentShipping3d: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .5v4M8.5 11H11M.5 4.5h13v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-8h0Z\"/><path d=\"M.5 4.5L2 1.61A2 2 0 0 1 3.74.5h6.52a2 2 0 0 1 1.79 1.11L13.5 4.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingBoxFragileFragileShippingGlassDeliveryWineCrackShipmentSignSticker: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.67.5a1 1 0 0 0-1 .89C2.56 2.45 2.5 4.05 2.5 4.5c0 2.62 2 4 4.5 4s4.5-1.38 4.5-4c0-.45-.06-2-.17-3.11a1 1 0 0 0-1-.89ZM7 8.5v5m-2 0h4\"/><path d=\"m7 .5l-1.5 2l2 1.5l-1 1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingTransferCartPackageBoxFulfillmentCartWarehouseShippingDelivery: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"6.5\" height=\"6.5\" x=\"5.5\" y=\"3\" rx=\"1\"/><path d=\"M4 12h7.61a1 1 0 0 1 .7.29l1.19 1.21M.5.5h1a1 1 0 0 1 1 1V10M4 11.75A2.11 2.11 0 0 1 4 12a1.74 1.74 0 1 1 0-.25ZM8.5 7h1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingTransferTruckTimeTruckShippingDeliveryTimeWaitingDelay: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6\" cy=\"12.49\" r=\"1\"/><circle cx=\"10.5\" cy=\"12.49\" r=\"1\"/><path d=\"M8.38 3.53A4 4 0 1 0 2 7.62m2.5-3.11L6 3.01m.5 6.49v-1H5a2 2 0 0 0-2 2v2\"/><path d=\"M13.5 12.49v-5a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingTransferTruckTruckShippingDelivery: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 5.5h-3a2 2 0 0 0-2 2v4H2m10.5 0h1v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5.68M6 11.5h2.5\"/><circle cx=\"4\" cy=\"11.5\" r=\"2\"/><circle cx=\"10.5\" cy=\"11.5\" r=\"2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingTruck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 5.5h3a2 2 0 0 1 2 2v4H12m-10.5 0h-1v-7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7m-.5 0H5.5\"/><path d=\"M10.25 13.5a1.75 1.75 0 1 1 0-3.5a1.75 1.75 0 0 1 0 3.5m-6.75 0a1.75 1.75 0 1 1 0-3.5a1.75 1.75 0 0 1 0 3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingTruckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.247 5.226H11.5a2.5 2.5 0 0 1 2.5 2.5v4a.5.5 0 0 1-.5.5h-1.444a1.81 1.81 0 0 1-3.62 0H5a1.81 1.81 0 0 1-3.62 0H.5a.5.5 0 0 1-.5-.5v-7a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.497 1.406v3.783a.625.625 0 0 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShippingWarehouseDeliveryWarehouseShippingFulfillment: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 4.5h13V13a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V4.5h0Zm0 0h0a4 4 0 0 1 4-4h5a4 4 0 0 1 4 4h0\"/><path d=\"M11 13.5V8a.5.5 0 0 0-.5-.5h-7A.5.5 0 0 0 3 8v5.5m0-4h8m-8 2h8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBagHandBag1ShoppingBagPurseGoodsItemProducts: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.27 13.5H2.73a2 2 0 0 1-2-2.22l.67-5.89a1 1 0 0 1 1-.89h9.2a1 1 0 0 1 1 .89l.65 5.89a2 2 0 0 1-1.98 2.22Z\"/><path d=\"M3 4.5a4 4 0 0 1 8 0m-6.5 3h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBagHandBag2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.88 12.39a1 1 0 0 1-1 1.11H2.12a1 1 0 0 1-1-1.11L2 4.5h10zM4.5 4.5V3a2.5 2.5 0 1 1 5 0v1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBagHandBag2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.75a1.625 1.625 0 0 1 1.625 1.625V4h-3.25v-.625A1.625 1.625 0 0 1 7 1.75m0 3.5h4.48L12.74 12q.01.057.01.116c0 .35-.284.634-.634.634H1.884A.634.634 0 0 1 1.26 12l1.258-6.75zM7 14h5.116a1.884 1.884 0 0 0 1.852-2.229l-1.354-7.26A.625.625 0 0 0 12 4h-1.625v-.625a3.375 3.375 0 0 0-6.75 0V4H2a.625.625 0 0 0-.614.51L.032 11.771A1.883 1.883 0 0 0 1.884 14z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBagHandBag2ShoppingBagPurseGoodsItemProducts: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.88 12.39a1 1 0 0 1-.25.78a1 1 0 0 1-.75.33H2.12a1 1 0 0 1-.75-.33a1 1 0 0 1-.25-.78L2 4.5h10ZM4.5 4.5V3a2.5 2.5 0 0 1 5 0v1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBagHandBag2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.146 2.013A1.75 1.75 0 0 1 9.134 3.25v.663h-3.5V3.25c0-.464.184-.91.512-1.237m-2.012 1.9V3.25a3.25 3.25 0 0 1 6.5 0v.663h1.75a.5.5 0 0 1 .497.444l.847 7.596l.009.07c.02.163.056.431.002.69a1.52 1.52 0 0 1-1.073 1.146c-.245.068-.523.06-.692.056l-.09-.002h-9l-.09.002c-.17.004-.448.012-.692-.056c-.542-.15-.959-.6-1.073-1.146c-.054-.259-.02-.527.002-.69l.009-.07l.847-7.596a.5.5 0 0 1 .497-.444z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBagSuitcase1ProductBusinessBriefcase: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"10\" x=\".5\" y=\"3.5\" rx=\"1\"/><path d=\"M5 .5h4a1 1 0 0 1 1 1v2h0h-6h0v-2a1 1 0 0 1 1-1ZM3.5 7h7m-7 3h7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBasket1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.36 6H1.64a1 1 0 0 0-1 1.13l.73 5.5a1 1 0 0 0 1 .87h9.24a1 1 0 0 0 1-.87l.73-5.5A1 1 0 0 0 12.36 6M4.5 8.5V11M7 8.5V11m2.5-2.5V11\"/><path d=\"M9.48 1.54A2.79 2.79 0 0 1 11.78 4L12 6M2 6l.22-2a2.79 2.79 0 0 1 2.3-2.44\"/><path d=\"M9.5 1.75A1.25 1.25 0 0 1 8.25 3h-2.5a1.25 1.25 0 0 1 0-2.5h2.5A1.25 1.25 0 0 1 9.5 1.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBasket1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.25.5h-2.5c-.683 0-1.287.41-1.573.994A3.415 3.415 0 0 0 1.599 4.43l-.055.495C.757 5.137.295 5.958.388 6.708l.688 5.499c.096.768.762 1.42 1.564 1.418h8.717c.805.005 1.47-.649 1.566-1.418l.69-5.5c.092-.75-.37-1.57-1.157-1.78l-.055-.494a3.415 3.415 0 0 0-2.589-2.962A1.77 1.77 0 0 0 8.25.5m1.651 2.318C9.658 3.5 8.996 4 8.25 4h-2.5c-.749 0-1.4-.492-1.646-1.164A2.17 2.17 0 0 0 2.84 4.569l-.033.306h8.385l-.034-.307v-.003A2.17 2.17 0 0 0 9.9 2.818M2.12 6.125h-.175c-.08 0-.16.035-.227.118a.43.43 0 0 0-.09.31l.688 5.5c.024.198.203.323.318.322h8.73c.115.001.293-.125.318-.323l.689-5.5a.43.43 0 0 0-.091-.31a.28.28 0 0 0-.22-.117zM4.25 7.5a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m3.5.75a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0zm2-.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBasket1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.142 1.167A1.74 1.74 0 0 1 5.768.047H8.25a1.74 1.74 0 0 1 1.619 1.1a3.39 3.39 0 0 1 2.4 2.89l.162 1.474c.84.064 1.479.836 1.368 1.682v.001l-.693 5.22l-.007.057c-.015.13-.04.347-.122.544a1.54 1.54 0 0 1-.984.88c-.208.06-.42.058-.55.057H2.605a2 2 0 0 1-.6-.057a1.54 1.54 0 0 1-.983-.88c-.094-.226-.122-.494-.138-.656l-.01-.087l-.661-4.979A1.8 1.8 0 0 1 .2 6.811A1.51 1.51 0 0 1 1.587 5.51l.162-1.474a3.39 3.39 0 0 1 2.393-2.868m.152 1.545A1.89 1.89 0 0 0 3.24 4.2l-.144 1.306h7.826L10.778 4.2v-.004a1.89 1.89 0 0 0-1.044-1.497a1.74 1.74 0 0 1-1.484.83H5.768a1.74 1.74 0 0 1-1.474-.816m.077 5.776a.625.625 0 0 0-1.25 0v2.482a.625.625 0 1 0 1.25 0zm2.638-.625c.345 0 .625.28.625.625v2.482a.625.625 0 1 1-1.25 0V8.488c0-.345.28-.625.625-.625m3.889.625a.625.625 0 1 0-1.25 0v2.482a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBasket2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.28 6H1.72a1 1 0 0 0-1 1.2l1.1 5.5a1 1 0 0 0 1 .8h8.36a1 1 0 0 0 1-.8l1.1-5.5a1 1 0 0 0-1-1.2M9 2.5L11 6M3 6l2-3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBasket2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.49 1.934a.875.875 0 0 1 1.52-.868l1.89 3.309h.498c.239-.004.475.048.69.151c.217.104.407.257.556.445s.254.406.31.639s.06.474.016.708v.001l-1.048 5.498v.002c-.071.366-.263.7-.55.94a1.55 1.55 0 0 1-1.022.366h-8.7a1.55 1.55 0 0 1-1.022-.365a1.63 1.63 0 0 1-.55-.941v-.002L.03 6.319v-.001A1.67 1.67 0 0 1 .355 4.97c.15-.188.339-.34.556-.445c.215-.103.451-.155.69-.151H2.1l1.891-3.31a.875.875 0 0 1 1.52.869l-1.395 2.44h5.77zm3.927 3.69q.066 0 .13.03q.066.03.118.094q.052.065.073.153q.021.09.004.18v.002l-1.047 5.498a.4.4 0 0 1-.127.221a.3.3 0 0 1-.199.073H2.631a.3.3 0 0 1-.199-.073a.4.4 0 0 1-.127-.22v-.001L1.258 6.083v-.002a.42.42 0 0 1 .077-.333a.3.3 0 0 1 .117-.094a.3.3 0 0 1 .131-.03l.014.001z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBasket2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.777 1.587a.75.75 0 0 1 1.024.28L11.877 5.5h.399a1.5 1.5 0 0 1 1.494 1.799V7.3l-1.1 5.498v.002a1.5 1.5 0 0 1-1.495 1.2h-8.35a1.5 1.5 0 0 1-1.495-1.2v-.002L.23 7.3v-.001a1.5 1.5 0 0 1 1.495-1.8h.398l2.076-3.633a.75.75 0 0 1 1.303.744L3.85 5.5h6.298L8.5 2.61a.75.75 0 0 1 .278-1.023\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingBuildingRealHomeTowerBuildingHouseEstate: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5 13.5h-8V4l4-3.5l4 3.5v9.5zm0 0h5v-7h-5m-4 7v-2M3 8.5h3m-3-3h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.508.5H2.95l.87 8.65a1 1 0 0 0 1 .85h6.3a1 1 0 0 0 1-.68l1.33-4a1 1 0 0 0-.14-.9a1 1 0 0 0-.86-.42H3.3m7.65 9.5a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m-6.5 0a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 0a.625.625 0 1 0 0 1.25h1.818l.205 1.94l.644 6.105a1.626 1.626 0 0 0 1.619 1.455h6.208c.746 0 1.397-.506 1.579-1.23l1.253-5a1.626 1.626 0 0 0-1.579-2.02h-8.54L3.627.56A.625.625 0 0 0 3.006 0zm3.91 9.164L3.964 3.75h8.408c.247 0 .425.23.366.466l-1.253 5a.38.38 0 0 1-.366.284H4.911a.376.376 0 0 1-.376-.336m-.089 2.586a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25m6.5 0a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart1ShoppingCartCheckout: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5.5H11l-.87 8.65a1 1 0 0 1-1 .85h-6.3a1 1 0 0 1-1-.68l-1.33-4a1 1 0 0 1 .14-.9A1 1 0 0 1 1.5 4h9.15\"/><circle cx=\"3\" cy=\"13\" r=\".5\"/><circle cx=\"9.5\" cy=\"13\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.844.753a.75.75 0 0 0-.747-.675H.77a.75.75 0 0 0 0 1.5h1.649l.252 2.506l.002.052l.482 4.795l.004.025a1.43 1.43 0 0 0 1.427 1.216h5.852a1.43 1.43 0 0 0 1.416-.973v-.002l1.24-3.724v-.001a1.43 1.43 0 0 0-.2-1.286a1.43 1.43 0 0 0-1.216-.6h-7.55zm7.58 12.07a1.178 1.178 0 1 0-2.355 0a1.178 1.178 0 0 0 2.356 0m-6.323-1.179a1.178 1.178 0 1 1 0 2.356a1.178 1.178 0 0 1 0-2.356\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.182 7.5h-8.18l-1-5h10a.5.5 0 0 1 .49.59l-.82 4a.49.49 0 0 1-.49.41m-9.18-5L2.582.9a.5.5 0 0 0-.49-.4H.502m3.5 7l.42 2.1a.5.5 0 0 0 .49.4h6.09m-.5 3.5a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m-5 0a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.81 9.617L1.995 1.25H.627a.625.625 0 1 1 0-1.25h1.465c.514 0 .99.365 1.101.884l.231 1.063h9.453c.64.003 1.247.568 1.104 1.317l-.82 3.897c-.144.68-.798.886-1.107.905h-7.3L5.01 9.25h5.992a.625.625 0 0 1 0 1.25h-6.09c-.514 0-.991-.365-1.101-.883m.672-2.801h7.474l.753-3.619H3.696zm6.02 4.934a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25m-3.875 1.125a1.125 1.125 0 1 0-2.25 0a1.125 1.125 0 0 0 2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart2ShoppingCartCheckout: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.82 7.5H10l1-5H1a.5.5 0 0 0-.49.59l.82 4a.49.49 0 0 0 .49.41Zm9.18-5l.42-1.6a.5.5 0 0 1 .49-.4h1.59m-3.5 7l-.42 2.1a.5.5 0 0 1-.49.4H3\"/><circle cx=\"3.5\" cy=\"13\" r=\".5\"/><circle cx=\"8.5\" cy=\"13\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.75 1.5h1.396l.379 1.44l.01.034l.968 4.845l.012.078l.42 2.1V10a1.25 1.25 0 0 0 1.225 1h6.09a.75.75 0 0 0 0-1.5H5.365l-.25-1.25h6.996c.035 0 .135.003.227-.012a1.01 1.01 0 0 0 .756-.589c.054-.124.081-.281.09-.333l.003-.014l.791-3.862l.002-.01A1 1 0 0 0 13 2.25H3.893L3.56.975A1.25 1.25 0 0 0 2.34 0H.75a.75.75 0 1 0 0 1.5m10.88 11.3a1.149 1.149 0 1 0-2.298 0a1.149 1.149 0 0 0 2.297 0Zm-6.15-1.148a1.149 1.149 0 1 1 0 2.297a1.149 1.149 0 0 1 0-2.297\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.508.5H2.95l.87 8.65a1 1 0 0 0 1 .85h6.3a1 1 0 0 0 1-.68l1.33-4a1 1 0 0 0-.14-.9a1 1 0 0 0-.86-.42H3.3m7.65 9.5a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m-6.5 0a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1M6.688 6v2m3-2v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 0a.625.625 0 1 0 0 1.25h1.818l.205 1.94l.644 6.105a1.626 1.626 0 0 0 1.619 1.455h6.208c.746 0 1.397-.506 1.579-1.23l1.253-5a1.626 1.626 0 0 0-1.579-2.02h-8.54L3.627.56A.625.625 0 0 0 3.006 0zm3.91 9.164L3.964 3.75h8.408c.247 0 .425.23.366.466l-1.253 5a.38.38 0 0 1-.366.284H4.911a.376.376 0 0 1-.376-.336m2.153-4.289a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m3 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m2.383 8a1.125 1.125 0 1 0-2.25 0a1.125 1.125 0 0 0 2.25 0M4.446 11.75a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart3ShoppingCartCheckout: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.75 4.5l.25 1m3.25-1L7 5.5m-5.18 2H10l1-5H1a.5.5 0 0 0-.49.59l.82 4a.49.49 0 0 0 .49.41Zm9.18-5l.42-1.6a.5.5 0 0 1 .49-.4h1.59m-3.5 7l-.42 2.1a.5.5 0 0 1-.49.4H3\"/><circle cx=\"3.5\" cy=\"13\" r=\".5\"/><circle cx=\"8.5\" cy=\"13\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCart3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.844.753a.75.75 0 0 0-.746-.675H.77a.75.75 0 1 0 0 1.5h1.65l.25 2.506q0 .026.003.052l.482 4.795l.004.025a1.43 1.43 0 0 0 1.428 1.216h5.85a1.43 1.43 0 0 0 1.418-.973v-.002l1.238-3.724v-.001a1.43 1.43 0 0 0-.198-1.286a1.43 1.43 0 0 0-1.217-.6h-7.55zm7.581 12.07a1.178 1.178 0 1 0-2.356 0a1.178 1.178 0 0 0 2.356 0m-6.324-1.179a1.178 1.178 0 1 1 0 2.356a1.178 1.178 0 0 1 0-2.356m1.087-6.269c.345 0 .625.28.625.625v2a.625.625 0 1 1-1.25 0V6c0-.345.28-.625.625-.625M10.313 6a.625.625 0 1 0-1.25 0v2a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.946 13.5a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m-6.5 0a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m5.158-7h-3m1.5-1.5v3M.5.5H3L3.263 3m0 0l.643 6.105A1 1 0 0 0 4.9 10h6.32a1 1 0 0 0 .97-.757l1.25-5A1 1 0 0 0 12.47 3z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartAddRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 0a.625.625 0 1 0 0 1.25h1.818l.205 1.94l.644 6.105a1.626 1.626 0 0 0 1.619 1.455h6.208c.746 0 1.397-.506 1.579-1.23l1.253-5a1.626 1.626 0 0 0-1.579-2.02h-8.54L3.627.56A.625.625 0 0 0 3.006 0zm3.91 9.164L3.964 3.75h8.408c.247 0 .425.23.366.466l-1.253 5a.38.38 0 0 1-.366.284H4.911a.376.376 0 0 1-.376-.336m3.57-4.789a.75.75 0 0 1 .75.75v.75h.75a.75.75 0 0 1 0 1.5h-.75v.75a.75.75 0 1 1-1.5 0v-.75h-.75a.75.75 0 0 1 0-1.5h.75v-.75a.75.75 0 0 1 .75-.75m3.966 8.5a1.125 1.125 0 1 0-2.25 0a1.125 1.125 0 0 0 2.25 0M4.446 11.75a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartAddSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.505.078a.75.75 0 0 1 .746.675l.285 2.833h7.549a1.43 1.43 0 0 1 1.217.6a1.43 1.43 0 0 1 .199 1.286l-1.239 3.725V9.2a1.43 1.43 0 0 1-1.417.973H4.994a1.43 1.43 0 0 1-1.431-1.24L3.08 4.135l-.002-.052l-.252-2.506H1.177a.75.75 0 0 1 0-1.5zm7.15 11.566a1.178 1.178 0 1 1 0 2.356a1.178 1.178 0 0 1 0-2.356m-3.969 1.178a1.178 1.178 0 1 0-2.355 0a1.178 1.178 0 0 0 2.355 0m1.626-7.759a.625.625 0 0 0-.625.625v.687H7a.625.625 0 1 0 0 1.25h.687v.687a.625.625 0 0 0 1.25 0v-.687h.687a.625.625 0 1 0 0-1.25h-.687v-.687a.625.625 0 0 0-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartBasket1ShoppingBasket: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.36 6H1.64a1 1 0 0 0-1 1.13l.73 5.5a1 1 0 0 0 1 .87h9.24a1 1 0 0 0 1-.87l.73-5.5A1 1 0 0 0 12.36 6ZM4.5 8.5V11M7 8.5V11m2.5-2.5V11\"/><path d=\"M9.48 1.54A2.79 2.79 0 0 1 11.78 4L12 6M2 6l.22-2a2.79 2.79 0 0 1 2.3-2.44\"/><path d=\"M9.5 1.75A1.25 1.25 0 0 1 8.25 3h-2.5a1.25 1.25 0 0 1 0-2.5h2.5A1.25 1.25 0 0 1 9.5 1.75Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartBasket3ShoppingBasket: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.36 6.62a1 1 0 0 0-.24-.78a1 1 0 0 0-.75-.34H1.63a1 1 0 0 0-.75.34a1 1 0 0 0-.24.78l.75 6a1 1 0 0 0 1 .88h9.24a1 1 0 0 0 1-.88ZM2.5 5.5V5a4.5 4.5 0 0 1 9 0v.5M5 8.5v2m4-2v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartCheck: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.946 13.5a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m-6.5 0a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1M.5.5H3L3.263 3m0 0l.643 6.105A1 1 0 0 0 4.9 10h6.32a1 1 0 0 0 .97-.757l1.25-5A1 1 0 0 0 12.47 3z\"/><path d=\"m6.42 6.75l1.333 1l2.188-2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartCheckRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 0a.625.625 0 1 0 0 1.25h1.818l.205 1.94l.644 6.105a1.626 1.626 0 0 0 1.619 1.455h6.208c.746 0 1.397-.506 1.579-1.23l1.253-5a1.626 1.626 0 0 0-1.579-2.02h-8.54L3.627.56A.625.625 0 0 0 3.006 0zm3.91 9.164L3.964 3.75h8.408c.247 0 .425.23.366.466l-1.253 5a.38.38 0 0 1-.366.284H4.911a.376.376 0 0 1-.376-.336m5.72-3.134a.75.75 0 0 0-1.129-.988l-1.48 1.69l-.526-.395a.75.75 0 1 0-.9 1.2l1.083.813a.75.75 0 0 0 1.015-.106zm1.816 6.845a1.125 1.125 0 1 0-2.25 0a1.125 1.125 0 0 0 2.25 0M4.446 11.75a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartCheckSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.505.078a.75.75 0 0 1 .746.675l.285 2.833h7.549a1.43 1.43 0 0 1 1.217.6a1.43 1.43 0 0 1 .199 1.286l-1.239 3.725V9.2a1.43 1.43 0 0 1-1.417.973H4.994a1.43 1.43 0 0 1-1.431-1.24L3.08 4.135l-.002-.052l-.252-2.506H1.177a.75.75 0 0 1 0-1.5zm7.15 11.566a1.178 1.178 0 1 1 0 2.356a1.178 1.178 0 0 1 0-2.356m-3.969 1.178a1.178 1.178 0 1 0-2.355 0a1.178 1.178 0 0 0 2.355 0m3.305-6.668a.625.625 0 0 0-1-.75L7.702 7.126l-.61-.457a.625.625 0 1 0-.75 1l1.111.832a.625.625 0 0 0 .875-.125z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartSubtract: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.946 13.5a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m-6.5 0a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1M.5.5H3L3.263 3m0 0l.643 6.105A1 1 0 0 0 4.9 10h6.32a1 1 0 0 0 .97-.757l1.25-5A1 1 0 0 0 12.47 3zm6.341 3.5h-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartSubtractRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 0a.625.625 0 1 0 0 1.25h1.818l.205 1.94l.644 6.105a1.626 1.626 0 0 0 1.619 1.455h6.208c.746 0 1.397-.506 1.579-1.23l1.253-5a1.626 1.626 0 0 0-1.579-2.02h-8.54L3.627.56A.625.625 0 0 0 3.006 0zm3.91 9.164L3.964 3.75h8.408c.247 0 .425.23.366.466l-1.253 5a.38.38 0 0 1-.366.284H4.911a.376.376 0 0 1-.376-.336m2.07-3.289a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zm5.466 7a1.125 1.125 0 1 0-2.25 0a1.125 1.125 0 0 0 2.25 0M4.446 11.75a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartSubtractSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.505.078a.75.75 0 0 1 .746.675l.285 2.833h7.549a1.43 1.43 0 0 1 1.217.6a1.43 1.43 0 0 1 .199 1.286l-1.239 3.725V9.2a1.43 1.43 0 0 1-1.417.973H4.994a1.43 1.43 0 0 1-1.431-1.24L3.08 4.135l-.002-.052l-.252-2.506H1.177a.75.75 0 0 1 0-1.5zm7.15 11.566a1.178 1.178 0 1 1 0 2.356a1.178 1.178 0 0 1 0-2.356m-3.969 1.178a1.178 1.178 0 1 0-2.355 0a1.178 1.178 0 0 0 2.355 0m2.938-6.447a.625.625 0 0 1 0 1.25H7a.625.625 0 0 1 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesBabyBotlleBottleMilkFamilyChildrenFormulaCareChildKidBaby: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5 6.5v6a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6m0 0v-2a1 1 0 0 0-1-1a1 1 0 0 1-1-1V2a1.5 1.5 0 0 0-3 0v.5a1 1 0 0 1-1 1a1 1 0 0 0-1 1v2m-1 0h9m-4 3h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesBallSportsBallSportBasketball: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M7 .5v13m-4.9-2.23A5 5 0 0 0 4.5 7a5 5 0 0 0-2.4-4.27m9.8 0a5 5 0 0 0 0 8.54\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesChairDesignLoungeFurnitureChairInteriorDecorateArmchairDecoration: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 7.5h1a1 1 0 0 1 1 1v5h0h-3h0v-5a1 1 0 0 1 1-1Zm10 0h1a1 1 0 0 1 1 1v5h0h-3h0v-5a1 1 0 0 1 1-1Zm-8 6h7m-8-6v-2a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v2m-8 2h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesDressClothingDressSkirtWomen: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 3.5L11 5l2-2L10.5.5h-7L1 3l2 2l1.5-1.5V7c0 1.35-1.62 2.3-1.94 5.4a1 1 0 0 0 .25.77a1 1 0 0 0 .74.33h6.9a1 1 0 0 0 .74-.33a1 1 0 0 0 .25-.77C11.12 9.3 9.5 8.35 9.5 7Z\"/><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.5 6.25a6.47 6.47 0 0 0 5 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesPhoneAndroidPhoneMobileDeviceSmartphoneIphone: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"10\" height=\"13\" x=\"2\" y=\".5\" rx=\"1\"/><path d=\"M4.5 3h5v5h-5z\"/><circle cx=\"7\" cy=\"10.75\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesRingMoneyDiamondPaymentWealthFinanceRingAccessories: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"9\" r=\"4.5\"/><path d=\"m8.5.5l1 1l-2.5 3l-2.5-3l1-1h3z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesShirtClothingTShirtMenTop: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m10.5 1.5l3 3l-2 2l-1-1v6a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-6l-1 1l-2-2l3-3Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCatergoriesSofaDecorationFurnitureInteriorDesignCouchSofaDecorate: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"8\" height=\"7\" x=\"3\" y=\"1.5\" rx=\"1\"/><path d=\"M3 4.5H1.5a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1H11M4 11l-.5 2.5M10 11l.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingGiftRewardBoxSocialPresentGiftMediaRatingBow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"5\" x=\".5\" y=\"3\" rx=\"1\"/><path d=\"M12.5 8v4.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V8M7 3v10.5m3-13L7 3L4 .5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingJewelryDiamond1DiamondMoneyPaymentFinanceWealth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m13.5 5.5l-6.5 7l-6.5-7l3-4h7l3 4zm-13 0h13\"/><path d=\"m3.5 1.5l3.5 4l3.5-4M7 5.5v7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingJewelryDiamond2DiamondMoneyPaymentFinanceWealth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.64 1.54H3.36a1.07 1.07 0 0 0-.85.46L.69 4.52a1.05 1.05 0 0 0 .06 1.29l5.46 6.29a1 1 0 0 0 1.58 0l5.46-6.29a1.05 1.05 0 0 0 .06-1.29L11.49 2a1.07 1.07 0 0 0-.85-.46Z\"/><path d=\"M6.48 1.53L4.04 5.31L7 12.46m.55-10.93l2.43 3.78L7 12.46M.52 5.31h12.96\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingJewelryGoldGoldMoneyPaymentBarsFinanceWealthBullion: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.66 9.3a1 1 0 0 0-1-.8H2.32a1 1 0 0 0-1 .8L.5 13.5h6Zm7 0a1 1 0 0 0-1-.8H9.32a1 1 0 0 0-1 .8l-.82 4.2h6Z\"/><path d=\"m10 8.5l-.84-4.2a1 1 0 0 0-1-.8H5.82a1 1 0 0 0-1 .8L4 8.5\"/></g><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.68 8.5h4.64\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingStore1StoreShopShopsStores: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M8 8.5v5M1.5 10H8M.5 4L2 .5h10L13.5 4H.5zm4.25 0v1a2 2 0 0 1-2 2h-.28a2 2 0 0 1-2-2V4m8.78 0v1a2 2 0 0 1-2 2h-.5a2 2 0 0 1-2-2V4m8.75 0v1a2 2 0 0 1-2 2h-.25a2 2 0 0 1-2-2V4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingStoreSignage1SignStoreShopShopsSignageStores: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"8\" x=\".5\" y=\"5.5\" rx=\"2\"/><path d=\"m4 5.5l3-5l3 5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingStoreSignage2SignStoreShopShopsSignageStoresPole: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"7\" x=\".5\" y=\".5\" rx=\"2\"/><path d=\"M7 13.5v-6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingStoreSignage3StreetSandwichShopsShopStoresBoardSignStore: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 2.5h-7l-3 11h7l3-11zm3 11l-3-11m-2.18 8h4.36\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShovelRake: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.849 7.5H3.15a2 2 0 0 1-1.923-2.55l.86-3.008a1.989 1.989 0 0 1 3.824 0l.86 3.009A2 2 0 0 1 4.849 7.5M4 5.5v8m-1.5 0h3m5.5 0V.5M9.5.5h3m1 13V11A2.5 2.5 0 0 0 11 8.5v0A2.5 2.5 0 0 0 8.5 11v2.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShovelRakeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.875.375A3.065 3.065 0 0 0 .87 2.839L.289 5.745a1.99 1.99 0 0 0 1.95 2.38H3.25v3.75h-.875a.875.875 0 0 0 0 1.75h3a.875.875 0 0 0 0-1.75H4.5v-3.75h1.01a1.99 1.99 0 0 0 1.951-2.38l-.58-2.906A3.065 3.065 0 0 0 3.874.375m.625 6.5h1.01a.74.74 0 0 0 .726-.885l.612-.123l-.612.123l-.582-2.906a1.815 1.815 0 0 0-3.558 0L1.514 5.99a.74.74 0 0 0 .726.885h1.01V5.5a.625.625 0 1 1 1.25 0zm7.625-4.75h-.875v5.313c1.426.29 2.5 1.55 2.5 3.062V13a.625.625 0 1 1-1.25 0v-2.5c0-.816-.522-1.51-1.25-1.768V13A.625.625 0 1 1 10 13V8.732A1.88 1.88 0 0 0 8.75 10.5V13a.625.625 0 1 1-1.25 0v-2.5A3.126 3.126 0 0 1 10 7.438V2.125h-.875a.875.875 0 1 1 0-1.75h3a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShovelRakeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.866 1.563h-.671V7.73a3.12 3.12 0 0 1 2.368 3.027v2.368a.75.75 0 0 1-1.5 0v-2.368c0-.623-.352-1.163-.868-1.434v3.802a.75.75 0 0 1-1.5 0V9.323c-.516.27-.868.811-.868 1.434v2.368a.75.75 0 0 1-1.5 0v-2.368A3.12 3.12 0 0 1 9.695 7.73V1.563h-.67a.75.75 0 0 1 0-1.5h2.84a.75.75 0 0 1 0 1.5M1.523 2.04a2.383 2.383 0 0 1 4.584 0l.775 2.715A2.5 2.5 0 0 1 4.565 7.94v4.434h.67a.75.75 0 0 1 0 1.5h-2.84a.75.75 0 0 1 0-1.5h.67V7.941A2.5 2.5 0 0 1 .749 4.756z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShredder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 10.5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1m1.5-2h8m-5.25 0v5\"/><path d=\"M3.5 8.5V11A1.5 1.5 0 0 1 2 12.5m6.25-4v5m2.25-5V11a1.5 1.5 0 0 0 1.5 1.5m-1.5-7v-3l-2-2h-5v5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShredderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5.375A.625.625 0 0 0 2.875 1v3.875H2A1.625 1.625 0 0 0 .375 6.5v3A1.625 1.625 0 0 0 2 11.125h.5c.345 0 .625-.28.625-.625V9.375C3.125 8.615 3.741 8 4.5 8h5c.76 0 1.375.616 1.375 1.375V10.5c0 .345.28.625.625.625h.5A1.625 1.625 0 0 0 13.625 9.5v-3A1.625 1.625 0 0 0 12 4.875h-.875V3a.63.63 0 0 0-.183-.442l-2-2A.63.63 0 0 0 8.5.375zm6.375 4.5V3.259L8.241 1.625H4.125v3.25zm-4.5 4.75a.625.625 0 1 0-1.25 0v1.625a.875.875 0 0 1-.875.875a.625.625 0 1 0 0 1.25a2.125 2.125 0 0 0 2.125-2.125zM7 9c.345 0 .625.28.625.625v3.625a.625.625 0 1 1-1.25 0V9.625C6.375 9.28 6.655 9 7 9m2.875.625a.625.625 0 1 0-1.25 0v1.625a2.125 2.125 0 0 0 2.125 2.125a.625.625 0 1 0 0-1.25a.875.875 0 0 1-.875-.875z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShredderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.076 3.538v-.795a1 1 0 0 0-.293-.707L9.04.293A1 1 0 0 0 8.333 0h-4.91a.5.5 0 0 0-.5.5v3.038zM.47 5.133a1.6 1.6 0 0 1 1.03-.366h11a1.6 1.6 0 0 1 1.03.366c.287.242.47.592.47.978V9.91c0 .386-.183.736-.47.979a1.6 1.6 0 0 1-1.03.365h-.7a.7.7 0 0 0 .014-.14v-3.13a.68.68 0 0 0-.216-.493a.77.77 0 0 0-.524-.203H2.926a.77.77 0 0 0-.523.203a.68.68 0 0 0-.217.492v3.132q0 .071.015.139H1.5a1.6 1.6 0 0 1-1.03-.365a1.28 1.28 0 0 1-.47-.98V6.111c0-.386.183-.736.47-.978M7.75 9a.75.75 0 0 0-1.5 0v4.197a.75.75 0 0 0 1.5 0zm-3.461-.75a.75.75 0 0 1 .75.75v2.662a2.02 2.02 0 0 1-2.018 2.018a.75.75 0 0 1 0-1.5a.52.52 0 0 0 .518-.518V9a.75.75 0 0 1 .75-.75m6.172.75a.75.75 0 0 0-1.5 0v2.662a2.02 2.02 0 0 0 2.018 2.018a.75.75 0 0 0 0-1.5a.52.52 0 0 1-.518-.518z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShrimp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 13.5a5 5 0 0 0 0-10H3v1a4 4 0 0 0 4 4h1.5a2 2 0 1 1 0 4\"/><path d=\"M8.5 3.5s1 .5 1 2.5s-1 2.5-1 2.5m-2.667 5H8.5v-.75A1.75 1.75 0 0 0 6.75 11h-.083C5.747 11 5 11.746 5 12.667c0 .46.373.833.833.833M3 3.5H2A1.5 1.5 0 0 1 .5 2v0A1.5 1.5 0 0 1 2 .5h4.5M6.25 6a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M10.5 10C12 9.5 13 8.5 13 6.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShrimpRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.25a.75.75 0 0 0 0 1.5h6.389a5.62 5.62 0 0 1 4.65 2.48q.04.048.07.107A5.625 5.625 0 0 1 8.375 14H5.709a1.46 1.46 0 0 1-1.458-1.458a2.29 2.29 0 0 1 2.292-2.292h.083c.976 0 1.815.59 2.18 1.431A1.376 1.376 0 0 0 8.386 9H6.875A4.625 4.625 0 0 1 2.25 4.375V4H2a2 2 0 1 1 0-4h4.5a.625.625 0 1 1 0 1.25zm9.95 4.602a4.4 4.4 0 0 0-2.212-1.635c.157.432.262.977.262 1.658c0 .962-.21 1.653-.478 2.138c.362.176.678.433.923.748c.453-.273.825-.614 1.086-1.022c.308-.484.484-1.1.419-1.887m-.991 4.056c.642-.362 1.216-.854 1.626-1.498q.085-.132.159-.272q.006.117.006.237c0 1.844-1.14 3.42-2.754 4.065a2.62 2.62 0 0 0 .963-2.532M3.5 4h4.671c.05.047.115.119.184.222c.174.26.395.762.395 1.653s-.22 1.392-.395 1.653a1.3 1.3 0 0 1-.184.222H6.875A3.375 3.375 0 0 1 3.5 4.375zm2.625 2.5a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShrimpSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.347 1.781a.754.754 0 1 0 0 1.508H3.35v-.002h5.24q.062.09.162.147l.016.017q.04.042.107.146a3.3 3.3 0 0 1 .283.582C9.348 4.673 9.5 5.32 9.5 6s-.152 1.327-.342 1.82a3.4 3.4 0 0 1-.283.583a1 1 0 0 1-.123.163a.5.5 0 0 0-.21.233H7.35a4 4 0 0 1-4-4v-.01H2.347a2.254 2.254 0 1 1 0-4.508h4.511a.75.75 0 0 1 0 1.5zm7.745 2.04a5 5 0 0 0-.186-.426a5.02 5.02 0 0 1 3.54 2.872c-.425 2.075-1.887 3.21-2.793 3.633a2 2 0 0 0-.96-.921l.026-.039c.13-.205.26-.465.373-.76A6.2 6.2 0 0 0 10.5 6a6.2 6.2 0 0 0-.408-2.18m.774 7.076c.865-.35 2.196-1.247 3.004-2.83q.006.115.006.232c0 2.426-1.724 4.833-4.013 5.391v-.63q0-.253-.044-.493a2 2 0 0 0 1.047-1.67m-2.02 1.918q.018.12.017.246v.752H6.19a.835.835 0 0 1-.835-.836c0-.923.748-1.67 1.67-1.67h.084c.885 0 1.616.654 1.737 1.505zM7.36 5.542a.752.752 0 1 1-1.504 0a.752.752 0 0 1 1.504 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShrinkHorizontal1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 4.5L8.5 7L11 9.5m-8-5L5.5 7L3 9.5M.5.5v13m13-13v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShrinkHorizontal1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5.75a.75.75 0 0 0-1.5 0v12.5a.75.75 0 0 0 1.5 0zm12.5 0a.75.75 0 0 0-1.5 0v12.5a.75.75 0 0 0 1.5 0zm-2.809 3.288a.5.5 0 0 1 .309.462v5a.5.5 0 0 1-.854.354l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .545-.108m-8.382 0a.5.5 0 0 1 .545.108l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5A.5.5 0 0 1 2.5 9.5v-5a.5.5 0 0 1 .309-.462\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShuffle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5 2l2 2l-2 2m-3-2h5m-2 4l2 2l-2 2\"/><path d=\"M.5 4H4l4 6h5.5m-13 0H4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShuffleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.309 1.038a.5.5 0 0 1 .545.108l2 2a.5.5 0 0 1 0 .708l-2 2A.5.5 0 0 1 11 5.5V4.25H8.5a.75.75 0 1 1 0-1.5H11V1.5a.5.5 0 0 1 .309-.462m.545 7.108A.5.5 0 0 0 11 8.5v1.25H8.435L4.651 3.128A.75.75 0 0 0 4 2.75H.75a.75.75 0 0 0 0 1.5h2.815l3.784 6.622A.75.75 0 0 0 8 11.25h3v1.25a.5.5 0 0 0 .854.354l2-2a.5.5 0 0 0 0-.707zM.75 9.75a.75.75 0 1 0 0 1.5H4a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShuffleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.854 1.646A.5.5 0 0 0 11 2v1H8.5a1 1 0 1 0 0 2H11v1a.5.5 0 0 0 .854.354l2-2a.5.5 0 0 0 0-.708zM0 4a1 1 0 0 1 1-1h3.25a1 1 0 0 1 .832.445L8.785 9H11V8a.5.5 0 0 1 .854-.354l2 2a.5.5 0 0 1 0 .708l-2 2A.5.5 0 0 1 11 12v-1H8.25a1 1 0 0 1-.832-.445L3.715 5H1a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSigma: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.45 13.448H1.048a.5.5 0 0 1-.456-.307a.47.47 0 0 1 .109-.536l5.248-5.259a.496.496 0 0 0 0-.694L.701 1.393A.47.47 0 0 1 .59.858A.5.5 0 0 1 1.049.55H13.45\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSigmaRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M13 1H1.707a.707.707 0 0 0-.5 1.207L6 7l-4.793 4.793a.707.707 0 0 0 .5 1.207H13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSigmaSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.418 2.268C-.366 1.48.184.126 1.305.126h11.9a.744.744 0 1 1 0 1.489H1.87l4.843 4.86c.29.29.29.76 0 1.05l-4.843 4.86h11.337a.744.744 0 1 1 0 1.49h-11.9c-1.122 0-1.672-1.355-.888-2.142L5.134 7z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignAt: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.05 7a3 3 0 1 1-5.999 0a3 3 0 0 1 5.999 0\"/><path d=\"M10.05 7v1.3c0 3.49 5.47.2 2.6-4.54A6.59 6.59 0 0 0 7 .5A6.5 6.5 0 1 0 9.52 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignAtRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7a5.751 5.751 0 1 1 11.502 0v1.226a1.092 1.092 0 1 1-2.183 0V7a3.568 3.568 0 1 0-.932 2.405A2.34 2.34 0 0 0 14 8.226V7a7 7 0 1 0-4.303 6.462a.625.625 0 1 0-.482-1.153A5.75 5.75 0 0 1 1.249 7m8.069-.005v.015a2.318 2.318 0 1 1 0-.015\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignAtSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.004.03h-.006A6.97 6.97 0 1 0 9.7 13.434a.75.75 0 0 0-.577-1.385A5.47 5.47 0 1 1 7 1.53a5.56 5.56 0 0 1 4.76 2.75l.006.009c1.199 1.98.61 3.514-.095 4.199c-.39.379-.71.417-.807.394c-.025-.005-.05-.015-.085-.07c-.044-.072-.11-.24-.11-.567V6.993A3.62 3.62 0 1 0 9.528 9.64c.24.368.59.61.998.704c.798.184 1.615-.222 2.19-.78c1.224-1.188 1.88-3.493.336-6.047A7.06 7.06 0 0 0 7.004.03m.009 4.85a2.12 2.12 0 1 1 .07 4.24a2.12 2.12 0 0 1-.07-4.24\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignCrossSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.688 1.594a1 1 0 0 1 1-1H12.28a1 1 0 0 1 1 1v10.594a1 1 0 0 1-1 1H1.688a1 1 0 0 1-1-1z\"/><path d=\"M6.188 3.563a.5.5 0 0 0-.5.5v1.406H4.28a.5.5 0 0 0-.5.5v1.625a.5.5 0 0 0 .5.5h1.407V9.5a.5.5 0 0 0 .5.5h1.625a.5.5 0 0 0 .5-.5V8.094h1.406a.5.5 0 0 0 .5-.5V5.969a.5.5 0 0 0-.5-.5H8.313V4.062a.5.5 0 0 0-.5-.5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignCrossSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.125.5C1.228.5.5 1.228.5 2.125v9.75c0 .898.728 1.625 1.625 1.625h9.75c.898 0 1.625-.727 1.625-1.625v-9.75C13.5 1.228 12.773.5 11.875.5zM1.75 2.125c0-.207.168-.375.375-.375h9.75c.207 0 .375.168.375.375v9.75a.375.375 0 0 1-.375.375h-9.75a.375.375 0 0 1-.375-.375zm3.879 1.927c0-.236.19-.427.427-.427h1.888c.236 0 .427.191.427.427V5.63h1.577c.236 0 .427.19.427.427v1.888a.427.427 0 0 1-.427.427H8.37v1.577a.427.427 0 0 1-.427.427H6.056a.427.427 0 0 1-.427-.427V8.37H4.052a.427.427 0 0 1-.427-.427V6.056c0-.236.191-.427.427-.427H5.63z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignCrossSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.188 1.594a1.5 1.5 0 0 1 1.5-1.5H12.28a1.5 1.5 0 0 1 1.5 1.5v10.594a1.5 1.5 0 0 1-1.5 1.5H1.688a1.5 1.5 0 0 1-1.5-1.5zm5.5 2.468a.5.5 0 0 1 .5-.5h1.625a.5.5 0 0 1 .5.5V5.47h1.406a.5.5 0 0 1 .5.5v1.625a.5.5 0 0 1-.5.5H8.313V9.5a.5.5 0 0 1-.5.5H6.188a.5.5 0 0 1-.5-.5V8.094H4.28a.5.5 0 0 1-.5-.5V5.969a.5.5 0 0 1 .5-.5h1.407z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignHashtag: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 4.25h13m-13 5.5h13M11.25.5l-2.5 13m-3-13l-2.5 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignHashtagRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.603.384c.34.056.57.378.514.719l-.504 3.022H13a.625.625 0 1 1 0 1.25h-2.595l-.542 3.25H12.5a.625.625 0 1 1 0 1.25H9.654l-.537 3.228a.625.625 0 0 1-1.234-.206l.504-3.022H4.654l-.537 3.228a.625.625 0 0 1-1.233-.206l.503-3.022H1a.625.625 0 0 1 0-1.25h2.596l.541-3.25H1.5a.625.625 0 0 1 0-1.25h2.846L4.883.897a.625.625 0 0 1 1.233.206l-.503 3.022h3.733L9.883.897a.625.625 0 0 1 .72-.513M5.404 5.375l-.541 3.25h3.733l.541-3.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignHashtagSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.178.09a.75.75 0 0 1 .594.879l-.513 2.67h1.914a.75.75 0 1 1 0 1.5H10.97l-.716 3.722h2.918a.75.75 0 1 1 0 1.5H9.966l-.568 2.953a.75.75 0 1 1-1.473-.283l.514-2.67H4.743l-.568 2.953a.75.75 0 1 1-1.473-.283l.514-2.67H.827a.75.75 0 0 1 0-1.5h2.677l.716-3.723H.827a.75.75 0 1 1 0-1.5H4.51L5.076.686A.75.75 0 1 1 6.55.969l-.513 2.67h3.696L10.3.686a.75.75 0 0 1 .879-.595m-5.43 5.048l-.716 3.723h3.695l.716-3.723z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignage3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 2.5h-7l-3 11h7zm3 11l-3-11m-2.18 8h4.36\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignage3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.214.375a.875.875 0 0 1 .868.67l2.769 11.5a.875.875 0 1 1-1.701.41l-.567-2.353H8.656l-.585 2.539a.625.625 0 0 1-.61.484H1a.625.625 0 0 1-.609-.765l2.77-12a.625.625 0 0 1 .608-.485zm-.125 4.02L9.06 8.853h2.102zm-5.823-2.77l-2.48 10.75h5.178l2.481-10.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignage3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8.202 13.407l2.121-8.34l1.348 5.298h-.888a.75.75 0 0 0 0 1.5h1.27l.391 1.542a.75.75 0 1 0 1.454-.37L11.051 1.844l-.006-.022l-.006-.02a.746.746 0 0 0-.732-.527h-6.63a.75.75 0 0 0-.727.566L.102 13.037a.75.75 0 0 0 .727.935h6.646a.75.75 0 0 0 .727-.565\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignage4: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.854 9.419v3.852m6.292-3.852v3.852M7 .729v1.458m.583.001H6.417M10.583.729v1.458m.584.001H10M3.5.729v1.458m-.583.001h1.166m7.001 4.437H8.75M1.375.729h11.25s.5 0 .5.5v7.69s0 .5-.5.5H1.375s-.5 0-.5-.5v-7.69s0-.5.5-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignage4Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5.375C.879.375.375.879.375 1.5v7.512c0 .622.504 1.125 1.125 1.125h1.479V13a.875.875 0 1 0 1.75 0v-2.863h4.542V13a.875.875 0 1 0 1.75 0v-2.863H12.5c.621 0 1.125-.503 1.125-1.125V1.5c0-.621-.504-1.125-1.125-1.125zm.125 8.512V1.625h1.334v.585a.625.625 0 0 0 .04 1.248h1.168a.625.625 0 0 0 .042-1.248v-.585h2.125v.585a.625.625 0 0 0 .041 1.248h1.167a.625.625 0 0 0 .042-1.248v-.585h2.208v.585a.625.625 0 0 0 .041 1.248H11a.625.625 0 0 0 .041-1.248v-.585h1.334v7.262zM7.75 6.875a.75.75 0 0 1 .75-.75h2.083a.75.75 0 0 1 0 1.5H8.5a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignage4Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.615.406v.786h-.002a.625.625 0 1 0 0 1.25h1.253a.625.625 0 0 0 0-1.25h-.001V.406h2.51v.786h-.002a.625.625 0 1 0 0 1.25h1.254a.625.625 0 1 0 0-1.25h-.002V.406h2.51v.786h-.001a.625.625 0 0 0 0 1.25h1.253a.625.625 0 1 0 0-1.25h-.002V.406h1.695a.5.5 0 0 1 .5.5v8.336a.5.5 0 0 1-.5.5h-2.184v3.5a.75.75 0 0 1-1.5 0v-3.5H4.604v3.5a.75.75 0 0 1-1.5 0v-3.5H.92a.5.5 0 0 1-.5-.5V.906a.5.5 0 0 1 .5-.5zm6.265 5.71a.625.625 0 0 0 0 1.25h2.507a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalFull: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.75 7.5H.5v6h4.25m4.5-9h-4.5v9h4.5M13.5.5H9.25v13h4.25z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalFullRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 .375A.625.625 0 0 0 8.375 1v2.875H5a.625.625 0 0 0-.625.625v2.375H1a.625.625 0 0 0-.625.625V13c0 .345.28.625.625.625h12c.345 0 .625-.28.625-.625V1A.625.625 0 0 0 13 .375zm-.625 12v-7.25h-2.75v7.25zm1.25 0h2.75V1.625h-2.75zm-5.25-4.25v4.25h-2.75v-4.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalFullSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13 1h-2.662a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h2.663a.5.5 0 0 0 .5-.5v-12A.5.5 0 0 0 13 1M3.163 8H.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2.662a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5M5.42 5h2.663a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H5.419a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalLoading: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 9.5L.5 7L3 4.5m8 5L13.5 7L11 4.5M7 7.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m2.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m-5 .5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalLoadingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.067 4.442a.625.625 0 1 0-.884-.884l-3 3a.625.625 0 0 0 0 .884l3 3a.625.625 0 1 0 .884-.884L1.509 7zm6.75-.884a.625.625 0 1 0-.884.884L12.491 7L9.933 9.558a.625.625 0 1 0 .884.884l3-3a.625.625 0 0 0 0-.884zM6 7a1 1 0 1 0 2 0a1 1 0 0 0-2 0m2.75 0a1 1 0 1 0 2 0a1 1 0 0 0-2 0m-5.5 0a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalLoadingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.7 3.958a.75.75 0 0 1 .024 1.06L1.832 7l1.892 1.982a.75.75 0 0 1-1.085 1.036l-2.387-2.5a.75.75 0 0 1 0-1.036l2.387-2.5a.75.75 0 0 1 1.06-.024m6.6 0a.75.75 0 0 1 1.061.024l2.387 2.5a.75.75 0 0 1 0 1.036l-2.387 2.5a.75.75 0 0 1-1.085-1.036L12.17 7l-1.893-1.982a.75.75 0 0 1 .025-1.06M4.5 6.25a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5M7.75 7a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0m2.5 0a.75.75 0 1 0-1.5 0a.75.75 0 0 0 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalLow: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.75 7.5H.5v6h4.25zm6.25 6h2.5m-6.75 0h2.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalLowRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 6.875A.625.625 0 0 0 0 7.5V13c0 .345.28.625.625.625h3.75c.345 0 .625-.28.625-.625V7.5a.625.625 0 0 0-.625-.625zm.625 5.5v-4.25h2.5v4.25zM5.961 13c0-.345.28-.625.625-.625h2.25a.625.625 0 1 1 0 1.25h-2.25A.625.625 0 0 1 5.961 13m4.539 0c0-.345.28-.625.625-.625h2.25a.625.625 0 1 1 0 1.25h-2.25A.625.625 0 0 1 10.5 13\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalLowSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.162 8H.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2.662a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m6.954 5.25a.75.75 0 0 1 .75-.75h2.375a.75.75 0 0 1 0 1.5h-2.375a.75.75 0 0 1-.75-.75m-4.303-.75a.75.75 0 0 0 0 1.5h2.374a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalMedium: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.75 7.5H.5v6h4.25m4.5-9h-4.5v9h4.5zm1.75 9h2.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalMediumRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 3.875a.625.625 0 0 0-.625.625v2.375H.75a.625.625 0 0 0-.625.625V13c0 .345.28.625.625.625h8c.345 0 .625-.28.625-.625V4.5a.625.625 0 0 0-.625-.625zm-.625 8.5v-4.25h-2.75v4.25zm1.25 0h2.75v-7.25h-2.75zm4.75.625c0-.345.28-.625.625-.625h2.5a.625.625 0 1 1 0 1.25h-2.5a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalMediumSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.331 5H5.67a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.66a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5M3.162 8H.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2.662a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m7.704 4.5a.75.75 0 0 0 0 1.5h2.375a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalNone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 13.5h2.5m-7.75 0h2.5m-7.75 0H3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalNoneRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.336 12.375a.625.625 0 1 0 0 1.25h2.25a.625.625 0 1 0 0-1.25zM5.25 13c0-.345.28-.625.625-.625h2.25a.625.625 0 1 1 0 1.25h-2.25A.625.625 0 0 1 5.25 13m4.539 0c0-.345.28-.625.625-.625h2.25a.625.625 0 1 1 0 1.25h-2.25A.625.625 0 0 1 9.789 13\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSignalNoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 13.25a.75.75 0 0 1 .75-.75h2.375a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75m10.116 0a.75.75 0 0 1 .75-.75h2.375a.75.75 0 0 1 0 1.5h-2.375a.75.75 0 0 1-.75-.75m-4.303-.75a.75.75 0 0 0 0 1.5h2.374a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSkull1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.884 6.511a5.885 5.885 0 1 0-9.316 4.776v1.108a.98.98 0 0 0 .98.98h4.904a.98.98 0 0 0 .98-.98v-1.108a5.88 5.88 0 0 0 2.452-4.776M6.02 11.415v1.96m1.96-1.96v1.96\"/><path d=\"M3.567 7.246a1.226 1.226 0 1 0 2.452 0a1.226 1.226 0 1 0-2.452 0m4.414 0a1.226 1.226 0 1 0 2.452 0a1.226 1.226 0 1 0-2.452 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSkull1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.875 6.375a5.125 5.125 0 1 1 8.244 4.067a.63.63 0 0 0-.244.495v1.438a.375.375 0 0 1-.375.375h-.625V11.5a.625.625 0 1 0-1.25 0v1.25h-1.25V11.5a.625.625 0 1 0-1.25 0v1.25H4.5a.375.375 0 0 1-.375-.375v-1.438a.63.63 0 0 0-.244-.495a5.12 5.12 0 0 1-2.006-4.067M7 0a6.375 6.375 0 0 0-4.125 11.236v1.139c0 .898.728 1.625 1.625 1.625h5c.898 0 1.625-.727 1.625-1.625v-1.14A6.375 6.375 0 0 0 7 0M6 7a1.25 1.25 0 1 1-2.5 0A1.25 1.25 0 0 1 6 7m4.5 0A1.25 1.25 0 1 1 8 7a1.25 1.25 0 0 1 2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSkull1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.25 10.235a6 6 0 1 0-8.5 0V13a1 1 0 1 0 2 0v-.916H6V13a1 1 0 1 0 2 0v-.916h1.25V13a1 1 0 1 0 2 0zm-6.5-1.651a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5m5.75-1.25a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSlack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path d=\"M5.5 2a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m6 4a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-4 6a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0m-6-4a.5.5 0 1 0 1 0a.5.5 0 1 0-1 0\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.793 1.219v4.937m-3.59 1.692v4.937M1.215 5.207h4.937m1.692 3.59h4.937\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSlackRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.393 2.5A2.108 2.108 0 0 1 7 1.02a2.108 2.108 0 0 1 3.608 1.48v1.09A2.108 2.108 0 0 1 12.98 7a2.108 2.108 0 0 1-1.48 3.608h-1.09A2.108 2.108 0 0 1 7 12.98a2.108 2.108 0 0 1-3.607-1.48v-1.091A2.108 2.108 0 0 1 1.02 7A2.108 2.108 0 0 1 2.5 3.393h1.09a2.1 2.1 0 0 1-.197-.893M2.5 6.392h3a.893.893 0 0 0 0-1.785h-3a.892.892 0 1 0 0 1.785M4.608 8.5v3a.893.893 0 0 0 1.785 0v-3a.892.892 0 0 0-1.785 0m7.785.001c0 .493-.4.892-.893.892h-3a.892.892 0 1 1 0-1.785h3c.493 0 .893.4.893.893m-3-6a.892.892 0 1 0-1.785 0v3a.892.892 0 1 0 1.785 0zM7.02 7L7 7.02L6.98 7L7 6.98z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSlackSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.855.25c.428 0 .775.347.775.775v5.1a.775.775 0 0 1-1.55 0v-5.1c0-.428.347-.775.775-.775M5.145 7.1c.429 0 .776.346.776.774v5.101a.775.775 0 1 1-1.55 0v-5.1c0-.429.347-.776.775-.776m-4.12-2.73a.775.775 0 0 0 0 1.55h5.1a.775.775 0 1 0 0-1.55zM7.1 8.854c0-.428.347-.775.775-.775h5.101a.775.775 0 1 1 0 1.55h-5.1a.775.775 0 0 1-.776-.775M5 2a1 1 0 1 1 2 0a1 1 0 0 1-2 0m6 4a1 1 0 1 1 2 0a1 1 0 0 1-2 0m-3 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2M1 8a1 1 0 1 1 2 0a1 1 0 0 1-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSleep: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.588 4.403H5.24L2.422 8.38h2.983M7.825.94h2.483L7.67 4.664h2.793M8.402 7.712h3.612l-3.838 5.419h4.064\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSleepRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .625C7 .28 7.28 0 7.625 0h3a.625.625 0 0 1 .5 1l-2.25 3h1.75a.625.625 0 1 1 0 1.25h-3a.625.625 0 0 1-.5-1l2.25-3h-1.75A.625.625 0 0 1 7 .625M.875 5c0-.345.28-.625.625-.625H5a.625.625 0 0 1 .493 1.009L2.778 8.875H5a.625.625 0 1 1 0 1.25H1.5a.625.625 0 0 1-.493-1.009l2.715-3.491H1.5A.625.625 0 0 1 .875 5m8 2.25a.875.875 0 0 0 0 1.75h2.18l-2.863 3.578A.875.875 0 0 0 8.875 14h4a.875.875 0 1 0 0-1.75h-2.18l2.863-3.578a.875.875 0 0 0-.683-1.422z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSleepSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.974.595a.75.75 0 0 0-.666-.405H7.825a.75.75 0 0 0 0 1.5h1.033l-1.8 2.54a.75.75 0 0 0 .612 1.184h2.793a.75.75 0 0 0 0-1.5H9.12l1.8-2.54a.75.75 0 0 0 .054-.779M5.906 4.058a.75.75 0 0 0-.667-.405H2.588a.75.75 0 1 0 0 1.5h1.201L1.81 7.947a.75.75 0 0 0 .613 1.183h2.983a.75.75 0 1 0 0-1.5H3.872l1.98-2.794a.75.75 0 0 0 .054-.778m6.108 2.904a.75.75 0 0 1 .612 1.184l-3 4.235h2.614a.75.75 0 0 1 0 1.5H8.176a.75.75 0 0 1-.612-1.184l3-4.235H8.402a.75.75 0 1 1 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyAngry: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 11c.828 0 1.5-.783 1.5-1.75S7.828 7.5 7 7.5s-1.5.784-1.5 1.75S6.172 11 7 11\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4.25 6a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m5.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M5.345 3.484c.31.254.993.417 1.655.417s1.344-.163 1.654-.417\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyAngryRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m-.778 2.934c-.248-.061-.371-.131-.401-.156a.75.75 0 0 0-.95 1.16c.28.23.653.369.99.452a4.8 4.8 0 0 0 2.28 0c.336-.083.708-.222.989-.451a.75.75 0 0 0-.95-1.16c-.03.024-.154.094-.402.155a3.3 3.3 0 0 1-1.556 0M3.25 5.875a1 1 0 1 0 2 0a1 1 0 0 0-2 0M7 7C5.826 7 5 8.082 5 9.25s.826 2.25 2 2.25s2-1.082 2-2.25S8.174 7 7 7m1.75-1.125a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyAngrySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 0 0 7a7 7 0 0 0 14 0M8.26 2.4c-.051.04-.195.117-.45.18a3.45 3.45 0 0 1-1.617 0c-.255-.063-.4-.14-.45-.18a.625.625 0 0 0-.792.966c.26.213.611.345.94.427a4.7 4.7 0 0 0 2.22 0c.33-.082.681-.214.94-.427a.625.625 0 1 0-.791-.967m.756 6.877c0-1.143-.865-2.14-2.013-2.14c-1.15 0-2.014.997-2.014 2.14s.865 2.14 2.014 2.14s2.013-.997 2.013-2.14m.403-2.91a1.024 1.024 0 0 0-.002-2.05h-.003a1.025 1.025 0 0 0 .003 2.05zm-4.83 0a1.025 1.025 0 0 0-.003-2.05h-.003a1.025 1.025 0 0 0 .003 2.05z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCool: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.232 10.617c.349.048.88-.157 1.3-.478c.224-.172.425-.383.57-.596\"/><path d=\"M13.366 5.678q.133.642.134 1.322A6.5 6.5 0 1 1 .634 5.678M12.768 4A6.5 6.5 0 0 0 7 .5A6.5 6.5 0 0 0 1.232 4\"/><path d=\"M.5 4.75V4H7v.75a3.25 3.25 0 1 1-6.5 0m6.5 0V4h6.5v.75a3.25 3.25 0 0 1-6.5 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCoolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.75 8.5a3.74 3.74 0 0 1-2.472-.93a5.75 5.75 0 0 0 11.444 0A3.75 3.75 0 0 1 7 6.622A3.75 3.75 0 0 1 3.75 8.5m7.812-5H2.438A5.74 5.74 0 0 1 7 1.25a5.74 5.74 0 0 1 4.562 2.25m1.502 0a7 7 0 0 0-12.128 0H.5A.5.5 0 0 0 0 4v.75q.002.493.12.948Q.003 6.332 0 7a7 7 0 1 0 13.88-1.302q.118-.455.12-.948V4a.5.5 0 0 0-.5-.5zM9.72 10.34a.75.75 0 1 0-1.24-.844a1.93 1.93 0 0 1-.889.693a1 1 0 0 1-.191.054c-.043.007-.064.006-.068.006a.75.75 0 1 0-.203 1.486c.347.047.7-.034.987-.14a3.43 3.43 0 0 0 1.604-1.254\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCoolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 3.17H1.14A7 7 0 0 1 7 0a7 7 0 0 1 5.86 3.17zm0 3.161a5 5 0 0 1-.229.412C6.11 7.815 4.975 8.735 3.196 8.735c-1.388 0-2.398-.562-3.092-1.34L.006 7.28a7 7 0 0 0 13.988.001l-.097.113c-.694.779-1.705 1.341-3.092 1.341c-1.78 0-2.914-.92-3.576-1.992A5 5 0 0 1 7 6.331m2.487 3.463a.5.5 0 0 0-.706.054a1.9 1.9 0 0 1-.758.527q-.142.037-.286.047a.5.5 0 0 0 .07.998a2.5 2.5 0 0 0 .54-.098A2.9 2.9 0 0 0 9.54 10.5a.5.5 0 0 0-.053-.706M.159 4.512a.14.14 0 0 0-.039.14c.14.641.427 1.362.917 1.91c.473.53 1.15.923 2.159.923c1.265 0 2.032-.62 2.512-1.398a4.8 4.8 0 0 0 .61-1.667H.39a.32.32 0 0 0-.232.092m8.134 1.575a4.8 4.8 0 0 1-.61-1.667h5.926c.108 0 .19.044.233.092a.14.14 0 0 1 .039.14c-.14.641-.427 1.362-.917 1.91c-.473.53-1.151.923-2.16.923c-1.264 0-2.031-.62-2.511-1.398\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCrying1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4 9.5c.448-1.428 2.15-2.3 3.85-1.904A3.07 3.07 0 0 1 10 9.5M3.797 5.377c.092-.179.38-.497.713-.69s.753-.282.954-.272m3.072-.002c.201-.01.62.08.954.273c.333.192.621.51.713.69\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCrying1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m1.575 5.162c.015.002.084.007.197.037c.122.032.245.08.343.136a1.5 1.5 0 0 1 .42.381l.001.002a.75.75 0 0 0 1.334-.685a2.3 2.3 0 0 0-.4-.526a3 3 0 0 0-.605-.47a3 3 0 0 0-.71-.288a2.3 2.3 0 0 0-.656-.085a.75.75 0 0 0 .074 1.498zM5.501 3.665a2.3 2.3 0 0 0-.656.085a3 3 0 0 0-.71.288a3 3 0 0 0-.604.47a2.3 2.3 0 0 0-.401.526a.75.75 0 0 0 1.334.686l.001-.002a1.5 1.5 0 0 1 .42-.38a1.5 1.5 0 0 1 .54-.174h.002a.75.75 0 0 0 .074-1.499M3.358 8.81A4.25 4.25 0 0 1 7 6.75c1.547 0 2.9.827 3.642 2.06a.75.75 0 1 1-1.284.773A2.75 2.75 0 0 0 7 8.25c-1 0-1.875.533-2.358 1.333a.75.75 0 1 1-1.284-.774\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCrying1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 0 0 7a7 7 0 0 0 14 0M4.994 3.826a2.1 2.1 0 0 0-.617.081a2.8 2.8 0 0 0-.68.275c-.224.13-.422.295-.578.451c-.148.15-.292.326-.378.495a.625.625 0 1 0 1.112.57a1.4 1.4 0 0 1 .153-.185c.095-.095.207-.185.316-.248a1.6 1.6 0 0 1 .54-.184q.069-.007.071-.006a.625.625 0 1 0 .061-1.249M4.67 9.694a.625.625 0 1 1-1.21-.324a3.665 3.665 0 0 1 7.078 0a.625.625 0 0 1-1.208.325a2.415 2.415 0 0 0-4.662 0Zm4.468-4.613q-.067-.007-.07-.006a.625.625 0 0 1-.062-1.249c.19-.009.414.027.618.081c.213.056.455.146.68.275c.224.13.422.295.577.451c.15.15.292.326.38.495a.625.625 0 1 1-1.113.57a1.5 1.5 0 0 0-.153-.185a1.6 1.6 0 0 0-.317-.248a1.6 1.6 0 0 0-.54-.184\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCute: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M8.367 5.69c.157-.255.5-.418.834-.418s.678.163.835.417m-4.403.001c-.157-.255-.5-.418-.834-.418s-.678.163-.835.417m.216 2.945a1.41 1.41 0 1 0 2.819 0a1.41 1.41 0 0 0 2.82 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCuteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m-.974 6.328a.75.75 0 0 1-1.028-.24a.2.2 0 0 0-.047-.03a.4.4 0 0 0-.152-.036a.4.4 0 0 0-.153.036a.2.2 0 0 0-.047.03a.75.75 0 0 1-1.273-.792c.322-.524.941-.774 1.473-.774c.531 0 1.15.25 1.473.774a.75.75 0 0 1-.246 1.032m1.948 0a.75.75 0 0 0 1.028-.24a.2.2 0 0 1 .047-.03a.4.4 0 0 1 .152-.036a.4.4 0 0 1 .153.036c.03.015.044.028.047.03a.75.75 0 0 0 1.273-.792c-.322-.524-.941-.774-1.473-.774c-.531 0-1.15.25-1.473.774a.75.75 0 0 0 .246 1.032M4.18 7.884a.75.75 0 0 1 .75.75a.66.66 0 1 0 1.32 0a.75.75 0 1 1 1.5 0a.66.66 0 0 0 1.32 0a.75.75 0 1 1 1.5 0A2.16 2.16 0 0 1 7 10.271a2.16 2.16 0 0 1-3.57-1.636a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyCuteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M-.001 7a7 7 0 1 1 14 0a7 7 0 0 1-14 0m4.805 1.634a.625.625 0 1 0-1.25 0A2.035 2.035 0 0 0 7 10.102a2.035 2.035 0 0 0 3.445-1.467a.625.625 0 1 0-1.25 0a.785.785 0 1 1-1.57 0a.625.625 0 1 0-1.25 0a.785.785 0 1 1-1.57 0ZM9.52 5.168c.265 0 .48.138.543.24a.625.625 0 1 0 1.065-.655c-.34-.553-1.013-.835-1.608-.835s-1.268.282-1.608.835a.625.625 0 0 0 1.065.655c.063-.102.278-.24.543-.24m-5.583.24c.063-.102.278-.24.543-.24s.48.138.543.24a.625.625 0 0 0 1.065-.655c-.34-.553-1.013-.835-1.608-.835s-1.267.282-1.608.835a.625.625 0 1 0 1.065.655\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyDrool: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 9.95v1.8a1.25 1.25 0 0 1-2.5 0V11c.481-.481 1.538-1.05 2.5-1.05\"/><path d=\"M3.5 7.5A3.5 3.5 0 0 0 7 11v.75a1.25 1.25 0 1 0 2.5 0v-1.8c.619-.632 1-1.496 1-2.45z\"/><path d=\"M12.124 11A6.5 6.5 0 1 0 5 13.186\"/><path d=\"M3.797 5.377c.092-.179.38-.497.713-.69s.753-.282.954-.272m3.072-.002c.201-.01.62.08.954.273c.333.192.621.51.713.69\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyDroolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 10.228 3.608a.625.625 0 1 0 .973.784a7 7 0 1 0-7.647 2.256a.625.625 0 0 0 .392-1.187A5.75 5.75 0 0 1 1.25 7m7.522-1.801a1 1 0 0 0-.197-.037h-.002a.75.75 0 1 1-.074-1.498c.208-.01.446.029.656.085c.222.058.474.151.71.287c.236.137.443.309.604.471c.154.155.307.341.401.526a.75.75 0 1 1-1.334.685l-.001-.002a1.5 1.5 0 0 0-.42-.38a1.5 1.5 0 0 0-.343-.137M5.5 3.665a2.3 2.3 0 0 0-.656.085a3 3 0 0 0-.71.288a3 3 0 0 0-.604.47a2.3 2.3 0 0 0-.401.526a.75.75 0 0 0 1.334.686l.001-.002a1.5 1.5 0 0 1 .42-.38a1.5 1.5 0 0 1 .54-.174h.002A.75.75 0 0 0 5.5 3.665M7 11a3.5 3.5 0 0 1-3.465-3.001C3.496 7.725 3.724 7.5 4 7.5h6c.276 0 .504.225.465.498A3.5 3.5 0 0 1 9.5 9.95V12A1.25 1.25 0 1 1 7 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyDroolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.637 10.862a5.2 5.2 0 0 1 1.846-.707a5 5 0 0 1 .297-.04v1.354a1.231 1.231 0 0 1-2.462 0v-.38a3 3 0 0 1 .319-.227m2.587-1.643a1 1 0 0 0-.543-.099c-1.234.123-2.361.681-2.992 1.19a1 1 0 0 0-.369.712a3.5 3.5 0 0 1-2.097-1.115c-.573-.638-.85-1.42-.85-2a.5.5 0 0 1 .5-.5h6.218a.5.5 0 0 1 .5.5c0 .38-.12.851-.367 1.312M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m8.89-2.266a2.2 2.2 0 0 1 .558-1.165c.223.059.475.152.708.287c.234.134.44.306.603.47c.155.156.304.339.393.513a.625.625 0 1 1-1.112.57l-.011-.017a1.5 1.5 0 0 0-.157-.185a1.7 1.7 0 0 0-.34-.269a1.7 1.7 0 0 0-.642-.204m-4.919.658a2.2 2.2 0 0 1-.73-1.066a3 3 0 0 1 .603-.47c.233-.135.485-.228.708-.287a2.2 2.2 0 0 1 .64-.084a.625.625 0 1 1-.06 1.248l-.022.001a1.5 1.5 0 0 0-.239.043c-.14.037-.284.093-.402.161a1.7 1.7 0 0 0-.498.454\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyEmojiKissNervous: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"m7.231 7.001l.447.097a.858.858 0 0 1 .36 1.503l-.37.3l.37.3a.858.858 0 0 1-.36 1.504l-.447.097M10.5 4l-2 1.5l2 1M3.5 4l2 1.5l-2 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyEmojiKissNervousRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M2.9 3.55a.75.75 0 0 1 1.05-.15l2 1.5a.75.75 0 0 1-.115 1.27l-2 1a.75.75 0 0 1-.67-1.34l.914-.458L3.05 4.6a.75.75 0 0 1-.15-1.05m8.05 1.05a.75.75 0 1 0-.9-1.2l-2 1.5a.75.75 0 0 0 .115 1.27l2 1a.75.75 0 1 0 .67-1.34l-.914-.458zM7.14 6.518a.75.75 0 1 0-.318 1.466l.446.097a.1.1 0 0 1 .054.027q.02.018.028.053c.008.035.004.045 0 .06a.1.1 0 0 1-.037.049l-.368.3a.75.75 0 0 0 0 1.163l.368.3a.1.1 0 0 1 .036.049a.1.1 0 0 1 .001.06a.1.1 0 0 1-.028.053a.1.1 0 0 1-.054.027l-.446.097a.75.75 0 1 0 .318 1.466l.447-.097c1.183-.257 1.628-1.641.947-2.536c.68-.896.236-2.28-.947-2.537z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyEmojiKissNervousSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m7.445-.297a.625.625 0 0 0-.265 1.221l.446.097c.19.042.25.285.098.408l-.369.3a.625.625 0 0 0 0 .97l.369.3a.233.233 0 0 1-.098.408l-.446.097a.625.625 0 0 0 .265 1.221l.447-.097c1.125-.244 1.526-1.593.812-2.414c.714-.82.313-2.17-.812-2.414zM11 3.625a.625.625 0 0 1-.125.875l-1.191.893l1.096.548a.625.625 0 0 1-.56 1.118l-2-1A.625.625 0 0 1 8.125 5l2-1.5a.625.625 0 0 1 .875.125M3.875 3.5a.625.625 0 1 0-.75 1l1.191.893l-1.096.548a.625.625 0 0 0 .56 1.118l2-1A.625.625 0 0 0 5.875 5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyEmojiTerrified: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"m10.5 4l-2 1.5l2 1M3.5 4l2 1.5l-2 1m1 3.5S6 7.5 7 7.5S9.5 10 9.5 10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyEmojiTerrifiedRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M3.95 3.4a.75.75 0 1 0-.9 1.2l1.03.772l-.915.457a.75.75 0 0 0 .67 1.342l2-1A.75.75 0 0 0 5.95 4.9zm7 1.2a.75.75 0 1 0-.9-1.2l-2 1.5a.75.75 0 0 0 .115 1.27l2 1a.75.75 0 1 0 .67-1.34l-.914-.458zm-5.825 6.314l.003-.005l.013-.018a10 10 0 0 1 .24-.344c.162-.225.384-.523.63-.818c.248-.298.503-.574.73-.769q.164-.138.259-.189q.095.05.259.19c.227.194.482.47.73.768a15 15 0 0 1 .87 1.162l.013.018l.002.005a.75.75 0 0 0 1.251-.828L9.5 10.5l.625-.414v-.001l-.002-.002l-.004-.007l-.016-.023a12 12 0 0 0-.266-.381c-.175-.244-.42-.571-.694-.901a8 8 0 0 0-.909-.95a3 3 0 0 0-.527-.373A1.5 1.5 0 0 0 7 7.25c-.28 0-.527.1-.707.198a3 3 0 0 0-.527.373a8 8 0 0 0-.91.95a17 17 0 0 0-.96 1.282l-.015.023l-.004.007l-.002.002l.625.415l-.625-.414a.75.75 0 0 0 1.25.828\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyEmojiTerrifiedSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m10.875-2.5a.625.625 0 0 0-.75-1l-2 1.5a.625.625 0 0 0 .095 1.059l2 1a.625.625 0 0 0 .56-1.118l-1.096-.548zM3 3.625a.625.625 0 0 1 .875-.125l2 1.5a.625.625 0 0 1-.095 1.059l-2 1a.625.625 0 1 1-.56-1.118l1.096-.548L3.125 4.5A.625.625 0 0 1 3 3.625m2.037 6.695a.625.625 0 0 1-1.074-.64L4.5 10l-.537-.32l.002-.003l.004-.006l.014-.024a9 9 0 0 1 .246-.386c.162-.246.392-.577.656-.91c.262-.33.573-.682.9-.958c.302-.253.73-.54 1.215-.54c.484 0 .913.287 1.215.54c.327.276.638.627.9.958a13 13 0 0 1 .902 1.296l.014.024l.004.006l.001.002v.001h.001L9.5 10l.537-.32a.625.625 0 0 1-1.074.64v-.001l-.003-.004l-.011-.019a10 10 0 0 0-.22-.346c-.15-.227-.358-.526-.594-.823c-.238-.3-.49-.579-.725-.777a1.6 1.6 0 0 0-.297-.206A.4.4 0 0 0 7 8.103a.4.4 0 0 0-.113.041q-.12.06-.297.206a5.5 5.5 0 0 0-.725.777a12 12 0 0 0-.814 1.17l-.011.018l-.002.004\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyGrumpy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4 9.5c.448-1.428 2.15-2.3 3.85-1.904A3.07 3.07 0 0 1 10 9.5m-6-5h1.5V5m3-.5H10V5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyGrumpyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4 3.75a.75.75 0 0 0 0 1.5h.793A.75.75 0 0 0 6.25 5v-.5a.75.75 0 0 0-.75-.75zm4.5 0a.75.75 0 0 0 0 1.5h.793A.75.75 0 0 0 10.75 5v-.5a.75.75 0 0 0-.75-.75zM3.358 8.81A4.25 4.25 0 0 1 7 6.75c1.547 0 2.9.827 3.642 2.06a.75.75 0 1 1-1.284.773A2.75 2.75 0 0 0 7 8.25c-1 0-1.875.533-2.358 1.333a.75.75 0 1 1-1.284-.774\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyGrumpySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m9.331 2.582a.625.625 0 0 0 1.208-.325a3.665 3.665 0 0 0-7.077 0a.625.625 0 1 0 1.207.325a2.415 2.415 0 0 1 4.662 0m-6.39-5.174c0-.345.28-.625.625-.625h1.303c.346 0 .625.28.625.625v.595a.625.625 0 0 1-1.249.03h-.68a.625.625 0 0 1-.624-.625m6.19-.625a.625.625 0 0 0 0 1.25h.679a.625.625 0 0 0 1.25-.03v-.595a.625.625 0 0 0-.626-.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyHappy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4.75 5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M7 11a3.5 3.5 0 0 0 3.5-3.5h-7A3.5 3.5 0 0 0 7 11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyHappyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.75 5.75a1 1 0 1 1 0-2a1 1 0 0 1 0 2m5.715 2.249a3.5 3.5 0 0 1-6.93 0C3.496 7.725 3.724 7.5 4 7.5h6c.276 0 .504.225.465.499M10.25 4.75a1 1 0 1 0-2 0a1 1 0 0 0 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyHappySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M3.343 8.223a.25.25 0 0 1 .25-.25h6.782a.25.25 0 0 1 .25.25c0 .552-.27 1.337-.852 1.983c-.59.656-1.504 1.173-2.79 1.173c-1.284 0-2.198-.517-2.789-1.173c-.581-.646-.85-1.43-.85-1.983Zm1.239-2.247a1.024 1.024 0 0 1 .002-2.049h.003a1.024 1.024 0 0 1-.003 2.049zm4.831 0a1.024 1.024 0 0 1 .003-2.049h.002a1.024 1.024 0 0 1-.002 2.049z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyInLove: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 7a6.5 6.5 0 1 1-13 0m5-6.326a6.5 6.5 0 0 1 3 0M3.544 3.085c-.992-1.217-2.04-.352-2.053.58c0 1.388 1.66 2.528 2.053 2.528s2.054-1.14 2.054-2.528c-.014-.932-1.062-1.797-2.054-.58m6.911 0c.992-1.217 2.04-.352 2.053.58c0 1.388-1.66 2.528-2.053 2.528s-2.053-1.14-2.053-2.528c.013-.932 1.06-1.797 2.053-.58\"/><path d=\"M3.7 8c.5 1.8 2.5 2.9 4.3 2.4c1.1-.4 2-1.3 2.3-2.4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyInLoveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.804 1.539C8.237 1.35 7.631 1.25 7 1.25s-1.237.101-1.804.289A.625.625 0 0 1 4.804.352A7 7 0 0 1 7 0c.766 0 1.504.123 2.196.352a.625.625 0 0 1-.392 1.187M12.75 7A.625.625 0 1 1 14 7A7 7 0 1 1 0 7a.625.625 0 1 1 1.25 0a5.75 5.75 0 0 0 11.5 0m-1.625-4.467a1.8 1.8 0 0 1 .732-.472a1.22 1.22 0 0 1 .9.054c.524.244.86.831.868 1.424v.003c0 .858-.51 1.611-1.038 2.133a4.5 4.5 0 0 1-.799.631a2.5 2.5 0 0 1-.348.18a.9.9 0 0 1-.315.076a.9.9 0 0 1-.315-.075a2.5 2.5 0 0 1-.348-.18a4.5 4.5 0 0 1-.799-.632C9.134 5.153 8.625 4.4 8.625 3.542V3.54c.009-.593.344-1.18.867-1.424a1.22 1.22 0 0 1 .9-.054c.25.08.497.235.733.472M9.636 7.786a.75.75 0 0 1 1.438.428a4.252 4.252 0 0 1-8.148 0a.75.75 0 1 1 1.438-.428a2.752 2.752 0 0 0 5.272 0M2.143 2.061q.377.118.732.472a1.8 1.8 0 0 1 .732-.472a1.22 1.22 0 0 1 .9.054c.524.244.86.831.868 1.424v.003c0 .858-.51 1.611-1.038 2.133a4.5 4.5 0 0 1-.799.631a2.5 2.5 0 0 1-.348.18a.9.9 0 0 1-.315.076a.9.9 0 0 1-.315-.075a2.5 2.5 0 0 1-.348-.18a4.5 4.5 0 0 1-.799-.632C.884 5.153.375 4.4.375 3.542V3.54c.009-.593.344-1.18.867-1.424a1.22 1.22 0 0 1 .9-.054\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyInLoveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 0 0 7a7 7 0 0 0 14 0M9.509 8.837a.625.625 0 1 1 1.207.325a3.85 3.85 0 0 1-7.431 0a.625.625 0 0 1 1.207-.325a2.6 2.6 0 0 0 5.017 0m.544-4.945c.993-1.217 2.04-.352 2.054.58c0 1.389-1.66 2.528-2.053 2.528S8 5.86 8 4.473c.014-.933 1.061-1.798 2.053-.58Zm-8.16.58c.014-.932 1.061-1.797 2.053-.58c.993-1.217 2.04-.352 2.054.58C6 5.862 4.34 7 3.946 7c-.392 0-2.053-1.14-2.053-2.527Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyKiss: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"m7.231 7.001l.447.097a.858.858 0 0 1 .36 1.503l-.37.3l.37.3a.858.858 0 0 1-.36 1.504l-.447.097M4.75 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyKissRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.75 6.25a1 1 0 1 1 0-2a1 1 0 0 1 0 2m2.64.018a.75.75 0 1 0-.318 1.466l.446.097a.1.1 0 0 1 .054.027q.02.018.028.053c.008.035.004.045 0 .06a.1.1 0 0 1-.036.049l-.37.3a.75.75 0 0 0 0 1.163l.37.3a.1.1 0 0 1 .035.049q.009.023.001.06c-.008.037-.016.042-.028.053a.1.1 0 0 1-.054.027l-.446.097a.75.75 0 1 0 .318 1.466l.447-.097c1.183-.257 1.628-1.641.947-2.536c.68-.896.236-2.28-.947-2.537zm1.86-.018a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyKissSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m3.56-2.324c0 .565.457 1.024 1.022 1.025h.002a1.025 1.025 0 0 0 .003-2.049h-.003c-.565 0-1.024.459-1.024 1.024m4.831 0c0 .565.457 1.024 1.022 1.025h.003a1.024 1.024 0 0 0 .002-2.049h-.002c-.566 0-1.025.459-1.025 1.024M7.364 6.39a.625.625 0 1 0-.266 1.222l.447.097c.19.041.249.285.098.408l-.37.3a.625.625 0 0 0 0 .97l.37.3a.233.233 0 0 1-.098.407l-.447.097a.625.625 0 0 0 .266 1.222l.446-.097c1.125-.245 1.526-1.594.813-2.414c.713-.821.312-2.17-.813-2.415z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyLaughing3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M9 10.464a3.5 3.5 0 0 0 1.281-4.78l-6.062 3.5A3.5 3.5 0 0 0 9 10.463m-.902-7.561L7.55 4.95l1.732-1m-6.38 1.952l2.049.549l-1.732 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyLaughing3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m1.823 3.096a.75.75 0 1 0-1.45-.388l-.548 2.049a.75.75 0 0 0 1.099.843l1.732-1a.75.75 0 0 0-.75-1.299l-.164.095zM10.5 6.132a3.5 3.5 0 0 1-6.001 3.465c-.17-.217-.086-.526.153-.664l5.196-3c.24-.138.549-.057.652.2m-8.323-.424a.75.75 0 0 1 .919-.53l2.05.548a.75.75 0 0 1 .18 1.374l-1.732 1a.75.75 0 1 1-.75-1.299l.164-.094l-.3-.08a.75.75 0 0 1-.53-.92\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyLaughing3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.526.982a6.949 6.949 0 1 0 6.948 12.036A6.949 6.949 0 0 0 3.526.982M2.23 5.66a.625.625 0 0 1 .792-.392l1.928.65a.625.625 0 0 1 .113 1.134l-1.441.832A.625.625 0 1 1 2.998 6.8l.243-.14l-.617-.209a.625.625 0 0 1-.393-.792m6.483-2.724a.625.625 0 1 0-1.226-.246l-.4 1.995a.625.625 0 0 0 .925.664l1.441-.832a.625.625 0 1 0-.625-1.082l-.244.14zm-4.506 6.96a.5.5 0 0 1 .183-.683l5.83-3.366a.5.5 0 0 1 .683.183c.309.534.472 1.407.281 2.306c-.196.923-.767 1.883-1.936 2.558c-1.17.676-2.286.69-3.184.398c-.874-.284-1.548-.862-1.857-1.396\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyMask: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M3.797 5.377c.092-.179.38-.497.713-.69s.753-.282.954-.272m3.072-.002c.201-.01.62.08.954.273c.333.192.621.51.713.69M.5 7c.667.5 3 1.5 6.5 1.5s5.833-1 6.5-1.5\"/><path d=\"M7 13.5a6.5 6.5 0 0 0 3-.732V8.239c-.868.157-1.874.261-3 .261s-2.132-.104-3-.26v4.528a6.5 6.5 0 0 0 3 .732\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyMaskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.256 6.73a5.75 5.75 0 0 1 11.488 0c-.35.18-.887.404-1.602.606c-1.05.297-2.451.539-4.142.539c-1.69 0-3.092-.242-4.142-.539a9 9 0 0 1-1.602-.607m.109 1.42A5.76 5.76 0 0 0 4 11.905V8.874c-.544-.094-1.04-.21-1.483-.335a12 12 0 0 1-1.152-.39M10 11.905a5.76 5.76 0 0 0 2.635-3.757a12 12 0 0 1-1.152.39c-.443.125-.939.24-1.483.335zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m1.772 5.199a1 1 0 0 0-.197-.037h-.002a.75.75 0 1 1-.074-1.498c.208-.01.446.029.656.085c.222.058.474.151.71.287c.236.137.443.309.604.471c.154.155.307.341.401.526a.75.75 0 1 1-1.334.685l-.001-.002a1.5 1.5 0 0 0-.42-.38a1.5 1.5 0 0 0-.343-.137M4.845 3.75a2.3 2.3 0 0 1 .656-.085a.75.75 0 0 1-.074 1.499h-.002a1.5 1.5 0 0 0-.54.173a1.5 1.5 0 0 0-.42.381l-.001.002a.75.75 0 1 1-1.334-.686c.094-.184.247-.37.4-.525a3 3 0 0 1 .605-.471c.236-.136.488-.23.71-.288\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyMaskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.055 6.116a7.001 7.001 0 0 1 13.89 0c-.39.229-1.214.618-2.325.977c-1.312.424-2.954.782-4.62.782s-3.308-.358-4.62-.782C1.269 6.734.444 6.345.055 6.116m-.037 1.39a7 7 0 0 0 13.964 0c-.521.25-1.202.526-1.977.776c-.464.15-.97.293-1.505.418v2.543A5.48 5.48 0 0 1 7 12.5c-1.33 0-2.55-.472-3.5-1.257V8.7a19 19 0 0 1-1.505-.418a16 16 0 0 1-1.977-.776m9.12-2.962q-.068-.009-.071-.007a.625.625 0 0 1-.061-1.248c.189-.01.413.026.617.08c.213.057.455.146.68.276c.224.13.422.294.578.45c.148.15.292.326.378.495a.625.625 0 1 1-1.112.571a1.4 1.4 0 0 0-.153-.185a1.6 1.6 0 0 0-.316-.249a1.6 1.6 0 0 0-.54-.183M4.376 3.37c.204-.054.428-.09.618-.08a.625.625 0 1 1-.062 1.248q-.003-.002-.07.006a1.6 1.6 0 0 0-.54.184a1.6 1.6 0 0 0-.47.433a.625.625 0 0 1-1.112-.57c.086-.17.23-.345.378-.495a2.8 2.8 0 0 1 .579-.45c.224-.13.466-.22.679-.276\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyNauseas: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.75 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4.899 9.194c.235-.325.987-.975 2.114-.975c1.128 0 1.88.65 2.115.975\"/><path d=\"M4.08 8.185c.773.336 1.01 1.242.702 2.084M9.92 8.185c-.773.336-1.01 1.242-.702 2.084\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyNauseasRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.75 4.25a1 1 0 1 1 0 2a1 1 0 0 1 0-2m3.5 1a1 1 0 1 0 2 0a1 1 0 0 0-2 0M5.11 8.017a2.1 2.1 0 0 0-.731-.52a.75.75 0 1 0-.598 1.376c.289.125.518.532.296 1.139a.75.75 0 1 0 1.409.515a2.9 2.9 0 0 0 .172-1.054a2.06 2.06 0 0 1 1.355-.504c.624 0 1.084.272 1.33.481c-.014.367.047.738.171 1.077a.75.75 0 0 0 1.409-.515a1.24 1.24 0 0 1-.081-.588a1 1 0 0 0 .031-.143a.64.64 0 0 1 .346-.408a.75.75 0 0 0-.598-1.376a2.1 2.1 0 0 0-.72.51a3.55 3.55 0 0 0-1.888-.538c-.782 0-1.426.247-1.903.548\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyNauseasSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m4.083.612c.346.15.61.37.803.631a3.63 3.63 0 0 1 2.127-.683c.896 0 1.613.316 2.11.67c.192-.256.454-.47.794-.618a.625.625 0 1 1 .498 1.146c-.37.16-.6.65-.364 1.297a.625.625 0 1 1-1.174.429a2.7 2.7 0 0 1-.166-.964c-.226-.251-.824-.71-1.698-.71c-.91 0-1.522.499-1.724.741c0 .317-.058.637-.166.933a.625.625 0 0 1-1.174-.43c.236-.646.006-1.135-.364-1.296a.625.625 0 1 1 .498-1.146m.499-1.61a1.024 1.024 0 0 1 .002-2.05h.003a1.025 1.025 0 0 1-.003 2.05zm4.831 0a1.025 1.025 0 0 1 .003-2.05h.002a1.024 1.024 0 0 1-.002 2.05z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySmirk: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.25 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m-4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M7.732 10.117c.349.048.88-.157 1.3-.478s.755-.78.8-1.13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySmirkRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M3.75 5.25a1 1 0 1 0 2 0a1 1 0 0 0-2 0m5.5-1a1 1 0 1 1 0 2a1 1 0 0 1 0-2m.679 3.516c.41.053.7.429.648.84c-.045.346-.216.666-.395.915a3.43 3.43 0 0 1-1.565 1.198c-.287.107-.64.188-.987.14a.75.75 0 1 1 .204-1.485q.003.002.067-.006q.076-.013.192-.054a1.93 1.93 0 0 0 .87-.666q.071-.102.102-.172c.02-.042.024-.063.024-.063a.75.75 0 0 1 .84-.647\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySmirkSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m3.56-2.324c0 .565.457 1.024 1.022 1.025h.002a1.025 1.025 0 0 0 .003-2.049h-.003c-.565 0-1.024.459-1.024 1.024m4.831 0c0 .565.457 1.024 1.022 1.025h.003a1.024 1.024 0 0 0 .002-2.049h-.002c-.566 0-1.025.459-1.025 1.024m-.34 5.156a.8.8 0 0 0 .32-.067a2.06 2.06 0 0 0 .928-.71c.112-.156.144-.26.148-.291a.625.625 0 0 1 1.24.16c-.041.318-.2.618-.372.859a3.3 3.3 0 0 1-1.507 1.153c-.278.104-.609.178-.927.134a.625.625 0 1 1 .17-1.238\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySparks: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m-2.25-10V6M3.5 4.75H6M9.25 3.5V6M8 4.75h2.5\"/><path d=\"M3.535 8a3.5 3.5 0 0 0 6.93 0z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySparksRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M5.5 3.5a.75.75 0 0 0-1.5 0V4h-.5a.75.75 0 0 0 0 1.5H4V6a.75.75 0 0 0 1.5 0v-.5H6A.75.75 0 0 0 6 4h-.5zM3.664 8.687c-.092-.29.144-.562.448-.562h5.776c.304 0 .54.272.448.562a3.501 3.501 0 0 1-6.672 0M10 3.5a.75.75 0 0 0-1.5 0V4H8a.75.75 0 0 0 0 1.5h.5V6A.75.75 0 0 0 10 6v-.5h.5a.75.75 0 0 0 0-1.5H10z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySparksSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m3.89 8.268a.5.5 0 0 0-.5-.5H3.61a.5.5 0 0 0-.5.5c0 .62.296 1.463.915 2.15c.635.707 1.616 1.256 2.975 1.256c1.36 0 2.34-.55 2.975-1.255c.619-.688.916-1.53.916-2.151Zm-1.405-5.19a.625.625 0 0 0-.625.626v.491h-.49a.625.625 0 0 0 0 1.25h.49v.49a.625.625 0 0 0 1.25 0v-.49h.492a.625.625 0 1 0 0-1.25h-.492v-.491a.625.625 0 0 0-.625-.625Zm-4.97 0c.345 0 .625.28.625.625v.492h.49a.625.625 0 0 1 0 1.25h-.49v.49a.625.625 0 0 1-1.25 0v-.49h-.492a.625.625 0 1 1 0-1.25h.492v-.492c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySurprised: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 10.5c.828 0 1.5-.783 1.5-1.75S7.828 7 7 7s-1.5.784-1.5 1.75s.672 1.75 1.5 1.75\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4.75 5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySurprisedRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.75 5.75a1 1 0 1 1 0-2a1 1 0 0 1 0 2m.25 3c0-1.168.826-2.25 2-2.25s2 1.082 2 2.25S8.174 11 7 11S5 9.918 5 8.75m4.25-3a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileySurprisedSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.999 0a7 7 0 1 0 0 14a7 7 0 0 0 0-14M4.986 9.023c0-1.185.823-2.3 2.013-2.3s2.013 1.115 2.013 2.3s-.824 2.3-2.013 2.3s-2.013-1.115-2.013-2.3M4.58 5.976a1.024 1.024 0 0 1 .002-2.049h.003a1.024 1.024 0 0 1-.003 2.049zm4.831 0a1.024 1.024 0 0 1 .003-2.049h.002a1.024 1.024 0 0 1-.002 2.049z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyThrowUp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.232 10a6.5 6.5 0 1 1 11.536 0\"/><path d=\"M3.949 10.193C3.724 7.897 5.972 7.5 7 7.5s3.276.397 3.051 2.693a.4.4 0 0 1-.405.352h-.741C8.91 11.933 11 11.645 11 12.458c0 0-.172 1.043-4 1.043s-4-1.043-4-1.043c0-.811 2.09-.525 2.095-1.912h-.74a.4.4 0 0 1-.406-.352M9.5 4l-1 1.5h2M4.5 4l1 1.5h-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyThrowUpRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 10.26 3.567a.625.625 0 1 0 .98.776a7 7 0 1 0-10.98 0a.625.625 0 1 0 .98-.776A5.72 5.72 0 0 1 1.25 7m2.834-3.624a.75.75 0 0 1 1.04.208l1 1.5A.75.75 0 0 1 5.5 6.25h-2a.75.75 0 0 1 0-1.5h.599l-.223-.334a.75.75 0 0 1 .208-1.04m6.04 1.04a.75.75 0 1 0-1.248-.832l-1 1.5A.75.75 0 0 0 8.5 6.25h2a.75.75 0 0 0 0-1.5h-.599zM7 7.5c-1.028 0-3.276.397-3.051 2.693a.4.4 0 0 0 .405.352h.741c-.003.786-.675 1.195-1.257 1.55c-.445.27-.838.51-.838.861c0 0 .172 1.044 4 1.044s4-1.043 4-1.043c0-.352-.393-.591-.838-.863c-.582-.354-1.254-.763-1.257-1.548h.74a.4.4 0 0 0 .406-.353C10.276 7.897 8.028 7.5 7 7.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyThrowUpSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 0 1 4.62 12.26a3 3 0 0 0-.278-.254a5 5 0 0 0-.406-.288c.145-.21.242-.465.27-.756c.07-.737-.076-1.406-.425-1.972A3.23 3.23 0 0 0 9.5 7.833c-.894-.464-1.91-.56-2.5-.56c-.587 0-1.597.095-2.487.554c-.46.237-.938.598-1.28 1.141c-.352.558-.505 1.222-.443 1.955c.027.311.13.575.281.79a6 6 0 0 0-.413.294c-.069.055-.17.139-.277.252A7 7 0 0 1 7 0m3.473 3.362a.625.625 0 0 0-.867.173L8.498 5.197a.625.625 0 0 0 .52.972h2.216a.625.625 0 1 0 0-1.25h-1.048l.46-.69a.625.625 0 0 0-.173-.867m-6.079.173a.625.625 0 0 0-1.04.694l.46.69H2.766a.625.625 0 1 0 0 1.25h2.216a.625.625 0 0 0 .52-.972zM7 8.524c.99 0 3.15.343 2.962 2.32a.393.393 0 0 1-.401.344h-.714c.003.687.654 1.1 1.218 1.457c.432.273.813.514.813.822c0 0-.167.533-3.878.533c-3.71 0-3.878-.533-3.878-.533c0-.308.381-.549.813-.822c.564-.358 1.215-.77 1.218-1.457H4.49c-.23 0-.435-.155-.453-.371C3.87 8.863 6.014 8.524 7 8.524\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyVeryShocked: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 8.5v2m-6 3c.245-.388.661-1.473.367-2.714s-.122-1.81 0-1.94c.245-.387.955-.775 1.836.776s.857 3.232.735 3.878m9.062 0c-.245-.388-.661-1.473-.367-2.714s.122-1.81 0-1.94c-.245-.387-.955-.775-1.836.776s-.857 3.232-.735 3.878M2 4.5a2 2.5 0 1 0 4 0a2 2.5 0 1 0-4 0m6 0a2 2.5 0 1 0 4 0a2 2.5 0 1 0-4 0\"/><path d=\"M1.762 8.53C1.272 7.865 1 7.204 1 6C1 2.253 3.693.5 7 .5s6 1.753 6 5.5c0 1.205-.272 1.866-.762 2.53m-8.437 2.596C4.461 12.096 5.208 13 7 13s2.539-.905 3.199-1.874\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyVeryShockedRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.375 6.125c0-.93-.18-1.705-.492-2.345c.076.264.117.549.117.845c0 1.38-.895 2.5-2 2.5s-2-1.12-2-2.5s.895-2.5 2-2.5q.275 0 .528.088C9.609 1.579 8.388 1.25 7 1.25s-2.61.33-3.528.963A1.6 1.6 0 0 1 4 2.125c1.104 0 2 1.12 2 2.5s-.896 2.5-2 2.5s-2-1.12-2-2.5q.002-.446.117-.845c-.313.64-.492 1.416-.492 2.345c0 .737.108 1.217.308 1.624q.1 0 .208.016c.612.093 1.14.603 1.606 1.424a6.7 6.7 0 0 1 .722 1.928c.27.378.534.69.867.923c.377.266.883.46 1.664.46s1.286-.194 1.664-.46c.333-.234.597-.545.867-.923a6.7 6.7 0 0 1 .722-1.928c.467-.821.994-1.331 1.606-1.424a1.3 1.3 0 0 1 .208-.016c.2-.407.308-.887.308-1.624M3.29 11.613l-.007-.01l.005-.003a5.5 5.5 0 0 0-.63-1.794c-.414-.73-.682-.802-.707-.806H1.95l-.004.002a.2.2 0 0 0-.051.053l-.026.038c-.01.034-.027.106-.035.224c-.016.236.004.624.14 1.2c.34 1.436-.131 2.692-.447 3.192a.625.625 0 1 1-1.057-.668c.175-.276.536-1.19.288-2.236c-.156-.665-.197-1.182-.17-1.573q.02-.294.09-.515a1.2 1.2 0 0 1 .169-.345C.539 7.775.375 7.092.375 6.125c0-2.037.74-3.596 1.984-4.635C3.588.465 5.244 0 7 0s3.413.465 4.642 1.49c1.244 1.039 1.984 2.598 1.984 4.635c0 .967-.164 1.65-.472 2.247c.083.112.135.236.169.345q.07.222.09.515c.027.39-.014.908-.171 1.573c-.248 1.045.113 1.96.287 2.236a.625.625 0 1 1-1.057.668c-.315-.5-.787-1.756-.447-3.192c.137-.576.157-.964.141-1.2a1 1 0 0 0-.035-.224l-.026-.038a.2.2 0 0 0-.051-.053L12.05 9h-.003c-.024.004-.292.076-.707.806a5.5 5.5 0 0 0-.63 1.794l.005.003l-.006.01c-.124.729-.09 1.344-.033 1.646a.625.625 0 0 1-1.228.232a4 4 0 0 1-.055-.435l-.01.006c-.608.43-1.371.688-2.383.688s-1.775-.259-2.384-.688l-.009-.006a4 4 0 0 1-.055.435a.625.625 0 1 1-1.228-.232c.057-.302.09-.917-.033-1.646M7 7.75a.875.875 0 0 0-.875.875v1.75a.875.875 0 0 0 1.75 0v-1.75A.875.875 0 0 0 7 7.75M1.878 9.073l-.003.005z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmileyVeryShockedSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .048c-1.855 0-3.578.483-4.85 1.474C.862 2.524.074 4.02.074 5.945c0 .578.05 1.055.147 1.46c.324-.217.75-.36 1.262-.286c.843.122 1.545.785 2.141 1.778c.974 1.624 1.17 3.345 1.12 4.468c.568.344 1.292.534 2.255.534s1.687-.19 2.256-.534c-.052-1.124.145-2.844 1.119-4.468c.596-.993 1.298-1.656 2.14-1.778c.514-.074.94.069 1.263.285c.097-.404.147-.88.147-1.459c0-1.925-.788-3.421-2.075-4.423C10.578.53 8.854.048 7 .048M6 4.5C6 5.88 5.105 7 4 7S2 5.88 2 4.5S2.895 2 4 2s2 1.12 2 2.5M10 7C8.895 7 8 5.88 8 4.5S8.895 2 10 2s2 1.12 2 2.5S11.105 7 10 7m-3 .343a.75.75 0 0 1 .75.75v1.751a.75.75 0 0 1-1.5 0V8.093a.75.75 0 0 1 .75-.75M.502 10.771c.363 1.454-.152 2.726-.454 3.18h3.634c.152-.757.182-2.726-.908-4.543S.804 8.045.502 8.5c-.152.152-.364.818 0 2.272m12.996 0c-.363 1.454.151 2.726.454 3.18h-3.635c-.15-.757-.181-2.725.91-4.543c1.09-1.817 1.968-1.363 2.271-.909c.151.152.364.818 0 2.272\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmokeDetector: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.58 7.5c-2 2.5 2 3.5 0 6M7 7.5c-2 2.5 2 3.5 0 6m3.42-6c-2 2.5 2 3.5 0 6M2.5.5h9m-8 0V1a3.5 3.5 0 1 0 7 0V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmokeDetectorRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 0a.625.625 0 1 0 0 1.25h.375v.375A3.625 3.625 0 0 0 6 5.25h2a3.625 3.625 0 0 0 3.625-3.625V1.25H12A.625.625 0 1 0 12 0zm8.375 1.25h-6.75v.375A2.375 2.375 0 0 0 6 4h2a2.375 2.375 0 0 0 2.375-2.375zM3.921 6.664a.75.75 0 0 1 .117 1.055c-.396.495-.436.828-.404 1.076c.04.31.204.619.47 1.083l.025.045c.233.406.548.957.63 1.59c.093.721-.117 1.451-.721 2.206a.75.75 0 1 1-1.171-.937c.396-.496.436-.829.404-1.077c-.04-.31-.204-.619-.47-1.083l-.026-.045c-.232-.406-.547-.957-.629-1.59c-.093-.721.117-1.451.72-2.206a.75.75 0 0 1 1.055-.117M7.586 7.72a.75.75 0 0 0-1.172-.938c-.603.755-.813 1.485-.72 2.206c.081.633.396 1.184.63 1.59l.025.045c.265.464.43.772.47 1.083c.032.248-.008.581-.405 1.077a.75.75 0 0 0 1.172.937c.603-.755.813-1.485.72-2.206c-.081-.633-.396-1.183-.63-1.59l-.025-.045c-.265-.464-.43-.772-.47-1.083c-.032-.248.008-.581.405-1.076m3.43-1.055a.75.75 0 0 1 .117 1.055c-.396.495-.436.828-.404 1.076c.04.31.205.619.47 1.083l.026.045c.232.406.547.957.629 1.59c.093.721-.117 1.451-.72 2.205a.75.75 0 0 1-1.172-.937c.397-.495.436-.828.404-1.076c-.04-.31-.204-.619-.47-1.083l-.025-.045c-.233-.407-.548-.957-.63-1.59c-.093-.721.117-1.451.721-2.206a.75.75 0 0 1 1.054-.117\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmokeDetectorSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5.005a.75.75 0 0 0 0 1.5h.508a4 4 0 0 0 7.984 0h.508a.75.75 0 0 0 0-1.5zm1.666 7.7a.75.75 0 0 0-1.172-.937c-.603.754-.813 1.484-.72 2.205c.081.634.396 1.184.63 1.59l.025.045c.265.465.43.772.47 1.084c.032.248-.008.58-.405 1.076a.75.75 0 0 0 1.172.937c.603-.755.813-1.484.72-2.205c-.081-.634-.396-1.184-.63-1.59l-.025-.046c-.265-.464-.43-.772-.47-1.083c-.032-.248.008-.58.405-1.076m3.42 0a.75.75 0 1 0-1.172-.937c-.603.754-.813 1.484-.72 2.205c.081.634.396 1.184.63 1.59l.025.045c.265.465.43.772.47 1.084c.032.248-.008.58-.405 1.076a.75.75 0 1 0 1.172.937c.603-.755.813-1.484.72-2.205c-.081-.634-.396-1.184-.63-1.59l-.025-.046c-.265-.464-.43-.772-.47-1.083c-.032-.248.008-.58.405-1.076m3.303-1.054a.75.75 0 0 1 .117 1.054c-.397.495-.437.828-.405 1.076c.04.311.205.619.47 1.083l.026.045c.233.407.548.957.63 1.59c.092.721-.118 1.451-.721 2.206a.75.75 0 0 1-1.172-.937c.397-.496.437-.828.405-1.076c-.04-.312-.205-.62-.47-1.084l-.026-.045c-.233-.406-.548-.956-.63-1.59c-.092-.72.118-1.45.721-2.205a.75.75 0 0 1 1.055-.117\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmokingArea: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 12.5v-2a1 1 0 0 1 1-1h12v4h-12a1 1 0 0 1-1-1m10.5-3v4m1.923-13c2 2.5-2 3.5 0 6m-2.42-6c2 2.5-2 3.5 0 6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmokingAreaRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.954.414a.75.75 0 0 0-.117 1.055c.41.513.43.81.406.987c-.035.24-.175.474-.445.878l-.029.044c-.23.345-.565.845-.652 1.453c-.1.699.13 1.4.72 2.138a.75.75 0 0 0 1.171-.937c-.41-.514-.43-.812-.405-.988c.034-.24.174-.474.444-.878l.029-.044c.23-.345.565-.845.652-1.453c.1-.699-.13-1.4-.72-2.137a.75.75 0 0 0-1.054-.118M13 8.875c.345 0 .625.28.625.625V13c0 .345-.28.625-.625.625H2A1.625 1.625 0 0 1 .375 12v-1.5c0-.897.727-1.625 1.625-1.625zm-3 3.5H2A.375.375 0 0 1 1.625 12v-1.5c0-.207.168-.375.375-.375h8zM8.917 1.469a.75.75 0 0 1 1.171-.937c.59.736.82 1.438.72 2.137c-.087.608-.421 1.108-.652 1.453l-.03.044c-.269.404-.41.638-.443.878c-.026.176-.005.474.405.988a.75.75 0 1 1-1.171.937c-.59-.737-.82-1.44-.72-2.138c.088-.608.422-1.108.652-1.453l.03-.044c.269-.404.41-.638.444-.878c.025-.176.005-.474-.406-.987\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSmokingAreaSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.314.168a.625.625 0 0 0-.098.879c.414.517.468.882.43 1.17c-.043.34-.222.67-.485 1.13l-.023.04c-.234.409-.538.94-.617 1.549c-.087.681.108 1.378.695 2.11a.625.625 0 1 0 .976-.78c-.414-.517-.468-.883-.43-1.17c.043-.34.222-.67.485-1.13l.022-.04c.235-.41.539-.94.617-1.55c.088-.68-.108-1.377-.694-2.11a.625.625 0 0 0-.879-.098m-2.67 0a.625.625 0 0 0-.098.879c.414.517.468.882.43 1.17c-.043.34-.222.67-.485 1.13l-.023.04c-.234.41-.538.94-.616 1.549c-.088.681.108 1.378.694 2.11a.625.625 0 1 0 .976-.78c-.414-.517-.468-.883-.43-1.17c.043-.34.222-.67.485-1.13l.023-.04c.234-.41.538-.94.616-1.55c.088-.68-.108-1.377-.694-2.11a.625.625 0 0 0-.878-.098M13.5 8.875h-1.875v5H13.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5m-12 5h8.875v-5H1.5a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSnorkle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 10.5a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3V.5\"/><path d=\"M10.5 5.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1l1.17-1.75a1 1 0 0 1 1.66 0L7.5 9.5h1a2 2 0 0 0 2-2z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSnorkleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 .875a.875.875 0 0 0-1.75 0v9.25a2.125 2.125 0 0 1-2.125 2.125h-2A1.625 1.625 0 0 1 6.5 10.625a.875.875 0 0 0-1.75 0A3.375 3.375 0 0 0 8.125 14h2A3.875 3.875 0 0 0 14 10.125zM1.25 5c0-.76.616-1.375 1.375-1.375h6C9.385 3.625 10 4.241 10 5v2c0 .76-.616 1.375-1.375 1.375h-.5a.38.38 0 0 1-.3-.15l-.9-1.2a1.625 1.625 0 0 0-2.6 0l-.9 1.2a.38.38 0 0 1-.3.15h-.5c-.76 0-1.375-.616-1.375-1.375zm1.375-2.625A2.625 2.625 0 0 0 0 5v2a2.625 2.625 0 0 0 2.625 2.625h.5c.511 0 .993-.24 1.3-.65l.9-1.2a.375.375 0 0 1 .6 0l.9 1.2c.307.41.789.65 1.3.65h.5A2.625 2.625 0 0 0 11.25 7V5a2.625 2.625 0 0 0-2.625-2.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSnorkleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.188.062a.75.75 0 0 1 .75.75v9.52a3.606 3.606 0 0 1-3.606 3.606H8.428a3.606 3.606 0 0 1-3.606-3.606a.75.75 0 1 1 1.5 0a2.106 2.106 0 0 0 2.106 2.106h1.904a2.106 2.106 0 0 0 2.106-2.106V.812a.75.75 0 0 1 .75-.75M1.016 2.838a2.4 2.4 0 0 1 1.7-.704h5.712a2.404 2.404 0 0 1 2.404 2.404v1.904a2.404 2.404 0 0 1-2.404 2.404h-.952a.5.5 0 0 1-.416-.222L5.947 6.958a.452.452 0 0 0-.75 0L4.084 8.625a.5.5 0 0 1-.416.222h-.952A2.404 2.404 0 0 1 .312 6.442V4.538c0-.638.253-1.25.704-1.7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSnowFlake: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5 .5l2 2l2-2M.5 9l2-2l-2-2M9 13.5l-2-2l-2 2M13.5 5l-2 2l2 2m-10-5.5L5 5m0 4l-1.5 1.5m7-7L9 5m0 4l1.5 1.5M7 2.5v9M2.5 7h9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSnowFlakeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.442.558a.625.625 0 1 0-.884.884l1.817 1.817v3.116H3.259L1.442 4.558a.625.625 0 1 0-.884.884L2.116 7L.558 8.558a.625.625 0 1 0 .884.884l1.817-1.817h3.116v3.116l-1.817 1.817a.625.625 0 1 0 .884.884L7 11.884l1.558 1.558a.625.625 0 1 0 .884-.884l-1.817-1.817V7.625h3.116l1.817 1.817a.625.625 0 1 0 .884-.884L11.884 7l1.558-1.558a.625.625 0 1 0-.884-.884l-1.817 1.817H7.625V3.259l1.817-1.817a.625.625 0 1 0-.884-.884L7 2.116zm-2.384 2.5a.625.625 0 0 1 .884 0l1.5 1.5a.625.625 0 1 1-.884.884l-1.5-1.5a.625.625 0 0 1 0-.884m2.384 6.384a.625.625 0 1 0-.884-.884l-1.5 1.5a.625.625 0 1 0 .884.884zm5.5-6.384a.625.625 0 0 1 0 .884l-1.5 1.5a.625.625 0 1 1-.884-.884l1.5-1.5a.625.625 0 0 1 .884 0m-1.5 5.5a.625.625 0 1 0-.884.884l1.5 1.5a.625.625 0 1 0 .884-.884z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSnowFlakeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.53.22a.75.75 0 1 0-1.06 1.06l1.78 1.78v3.19H3.06L1.28 4.47A.75.75 0 0 0 .22 5.53L1.69 7L.22 8.47a.75.75 0 1 0 1.06 1.06l1.78-1.78h3.19v3.19l-1.78 1.78a.75.75 0 1 0 1.06 1.06L7 12.31l1.47 1.47a.75.75 0 0 0 1.06-1.06l-1.78-1.78V7.75h3.19l1.78 1.78a.75.75 0 1 0 1.06-1.06L12.31 7l1.47-1.47a.75.75 0 0 0-1.06-1.06l-1.78 1.78H7.75V3.06l1.78-1.78A.75.75 0 0 0 8.47.22L7 1.69zM2.97 2.97a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m2.06 7.06a.75.75 0 1 0-1.06-1.06l-1 1a.75.75 0 1 0 1.06 1.06zm6-7.06a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 1 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0m-1 6a.75.75 0 1 0-1.06 1.06l1 1a.75.75 0 1 0 1.06-1.06z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSongRecommendation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.638 13.428a1.497 1.497 0 1 0 0-2.995a1.497 1.497 0 0 0 0 2.995m6.739-1.872a1.497 1.497 0 1 0 0-2.994a1.497 1.497 0 0 0 0 2.994\"/><path d=\"M12.874 10.059v-5.87a.374.374 0 0 0-.472-.359l-2.995.831m3.467 1.28L7.42 7.456M4.762 2.597c.445-.601.719-1.83.719-1.83s.274 1.229.718 1.83c.449.606 1.878 1.136 1.878 1.136s-1.43.53-1.878 1.137c-.444.6-.718 1.829-.718 1.829s-.274-1.228-.719-1.83c-.448-.605-1.877-1.136-1.877-1.136s1.429-.53 1.877-1.136m1.374 9.333V8.892M2.007 6.623v2.268M.873 7.757h2.268\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSongRecommendationRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.471.726C4.25-.246 2.863-.24 2.651.734c-.213.97-.938 1.713-1.89 1.879c-1.015.176-1.015 1.635 0 1.811c.952.166 1.677.909 1.89 1.88c.212.973 1.599.98 1.82.007c.223-.977.944-1.719 1.9-1.885c1.018-.177 1.018-1.638 0-1.815c-.956-.166-1.677-.908-1.9-1.885m-2.51 2.793a3.6 3.6 0 0 0 1.603-1.64a3.63 3.63 0 0 0 1.61 1.64a3.63 3.63 0 0 0-1.61 1.639a3.6 3.6 0 0 0-1.603-1.64m.401 3.78a.625.625 0 1 0-1.25 0v.487H.625a.625.625 0 1 0 0 1.25h.487v.488a.625.625 0 0 0 1.25 0v-.488h.488a.625.625 0 0 0 0-1.25h-.488zm2.22 2.457a2.122 2.122 0 1 0 2.119 1.993V7.763l6.049-1.68v1.83A2.122 2.122 0 1 0 14 9.723v-6.36a1.04 1.04 0 0 0-.402-.816a1.03 1.03 0 0 0-.899-.179l-.004.001l-3.851 1.085l-.718.205c-.055.805-.584 1.578-1.587 1.752c-.508.088-.938.48-1.088 1.09v3.44a2.1 2.1 0 0 0-.869-.185\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSongRecommendationSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.293.19a.59.59 0 0 0-.475.254a1 1 0 0 0-.125.25c-.043.12-.08.275-.113.412l-.013.049c-.084.346-.166.627-.283.786a.9.9 0 0 1-.261.205a4 4 0 0 1-.473.231l-.126.054a7 7 0 0 0-.355.159c-.068.033-.155.08-.23.14a.6.6 0 0 0-.242.47c0 .274.194.43.241.468c.076.06.163.107.23.141c.101.05.232.106.356.159l.126.054c.172.074.334.149.473.23a.9.9 0 0 1 .26.206c.118.159.2.44.284.786l.012.05c.034.135.071.29.114.41a1 1 0 0 0 .125.25c.06.084.213.254.475.254c.263 0 .416-.17.476-.253a1 1 0 0 0 .125-.25c.043-.121.08-.276.113-.412l.012-.05c.085-.345.167-.626.284-.785a.9.9 0 0 1 .261-.205a4 4 0 0 1 .472-.231l.127-.054c.124-.053.255-.109.355-.159c.068-.034.155-.08.23-.14a.6.6 0 0 0 .242-.47a.6.6 0 0 0-.241-.468a1.3 1.3 0 0 0-.231-.141c-.1-.05-.231-.106-.355-.159l-.127-.054a4 4 0 0 1-.472-.23a.9.9 0 0 1-.26-.206c-.118-.159-.2-.44-.285-.786l-.012-.05a5 5 0 0 0-.113-.41a1 1 0 0 0-.125-.251a.59.59 0 0 0-.476-.253m.418 7.218a1.75 1.75 0 0 0 1.29-1.319v.001l.005-.019a5 5 0 0 1 .115-.406a4 4 0 0 1 .163-.417l.014-.01c.081-.055.194-.12.327-.187a6 6 0 0 1 .452-.202l.022-.01a1.75 1.75 0 0 0 .942-.83l3.417-.948l.006-.001a1.12 1.12 0 0 1 1.41 1.057v.02l.001.003v5.804a2.09 2.09 0 1 1-1.5-2.058v-1.45L7.21 7.87v3.937a2.09 2.09 0 1 1-1.5-2.005zm-3.748-1.51a.75.75 0 0 1 .75.75v.384h.384a.75.75 0 1 1 0 1.5h-.384v.384a.75.75 0 0 1-1.5 0v-.384H.829a.75.75 0 1 1 0-1.5h.384V6.65a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSortDescending: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.929.5H.5m7.429 2.786H2.82m5.109 2.785H5.143M13.5 11L11 13.5L8.5 11M11 .5v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSortDescendingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.625 0a.625.625 0 1 0 0 1.25h7.25a.625.625 0 1 0 0-1.25zm10.25 0c.345 0 .625.28.625.625v9.625h1.875a.625.625 0 0 1 .442 1.067l-2.5 2.5a.625.625 0 0 1-.884 0l-2.5-2.5a.625.625 0 0 1 .442-1.067h1.875V.625c0-.345.28-.625.625-.625m-5.75 5.5a.625.625 0 1 0 0 1.25h2.75a.625.625 0 1 0 0-1.25zM2.5 3.375c0-.345.28-.625.625-.625h4.75a.625.625 0 1 1 0 1.25h-4.75a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSortDescendingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 .75A.75.75 0 0 1 .75 0h6.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 .75M3.25 3a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zm2 3a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zm5.5-6a1 1 0 0 1 1 1v9h1.5a.75.75 0 0 1 .53 1.28l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5A.75.75 0 0 1 8.25 10h1.5V1a1 1 0 0 1 1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSosHelpEmergencySign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.494 5.47a1.15 1.15 0 0 0-1.082-.764h-.888a1.024 1.024 0 0 0-.219 2.024l1.352.296a1.147 1.147 0 0 1-.245 2.268h-.765c-.5 0-.924-.319-1.082-.764m12.87-3.06a1.15 1.15 0 0 0-1.082-.764h-.888a1.024 1.024 0 0 0-.219 2.024l1.352.296a1.147 1.147 0 0 1-.245 2.268h-.765c-.499 0-.924-.319-1.081-.764M5.47 5.853v2.294c0 .634.514 1.147 1.148 1.147h.764c.634 0 1.148-.513 1.148-1.147V5.853c0-.633-.514-1.147-1.148-1.147h-.764c-.634 0-1.147.514-1.147 1.147\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSosHelpEmergencySignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 5.495C0 4.37.972 3.514 2.035 3.514c.847 0 1.707.53 2 1.356a.625.625 0 1 1-1.18.417c-.094-.27-.439-.523-.82-.523c-.436 0-.785.358-.785.731c0 .297.202.556.49.628l.797.199A2.024 2.024 0 0 1 4.07 8.286v.082a2.035 2.035 0 0 1-2.035 2.035c-.847 0-1.707-.53-2-1.357a.625.625 0 1 1 1.18-.416c.094.269.439.523.82.523a.785.785 0 0 0 .785-.785v-.082a.774.774 0 0 0-.586-.751l-.797-.2A1.9 1.9 0 0 1 0 5.495m9.93 0c0-1.125.972-1.981 2.035-1.981c.847 0 1.707.53 2 1.356a.625.625 0 1 1-1.179.417c-.095-.27-.44-.523-.82-.523c-.436 0-.785.358-.785.731c0 .297.202.556.49.628l.796.199A2.024 2.024 0 0 1 14 8.286v.082a2.035 2.035 0 0 1-2.035 2.035c-.846 0-1.707-.53-1.999-1.357a.625.625 0 0 1 1.179-.416c.095.269.44.523.82.523a.785.785 0 0 0 .785-.785v-.082a.774.774 0 0 0-.586-.751l-.797-.2a1.9 1.9 0 0 1-1.436-1.84m-3.715.137a.785.785 0 1 1 1.57 0v2.82a.785.785 0 1 1-1.57 0zM7 3.597a2.035 2.035 0 0 0-2.035 2.035v2.82a2.035 2.035 0 1 0 4.07 0v-2.82A2.035 2.035 0 0 0 7 3.597\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSosHelpEmergencySignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 5.778c0-.957.777-1.734 1.735-1.734h.853a1.85 1.85 0 0 1 1.748 1.235a.75.75 0 0 1-1.415.5a.35.35 0 0 0-.333-.235h-.853a.235.235 0 0 0-.05.464l1.3.284a1.853 1.853 0 0 1-.397 3.664h-.735A1.85 1.85 0 0 1 .106 8.72a.75.75 0 1 1 1.414-.5c.049.139.18.236.333.236h.735a.353.353 0 0 0 .076-.699l-1.3-.284A1.735 1.735 0 0 1 0 5.778m9.559 0c0-.957.776-1.734 1.734-1.734h.854a1.85 1.85 0 0 1 1.747 1.235a.75.75 0 1 1-1.414.5a.35.35 0 0 0-.333-.235h-.854a.235.235 0 0 0-.05.464l1.3.284a1.853 1.853 0 0 1-.396 3.664h-.735A1.85 1.85 0 0 1 9.664 8.72a.75.75 0 1 1 1.415-.5c.048.139.18.236.332.236h.736a.353.353 0 0 0 .075-.699l-1.3-.284A1.735 1.735 0 0 1 9.56 5.778m-3.28.119c0-.195.158-.353.353-.353h.736c.194 0 .352.158.352.353v2.206a.353.353 0 0 1-.352.353h-.736a.353.353 0 0 1-.353-.353zm.353-1.853c-1.023 0-1.853.83-1.853 1.853v2.206c0 1.023.83 1.853 1.853 1.853h.736c1.023 0 1.852-.83 1.852-1.853V5.897c0-1.023-.83-1.853-1.852-1.853z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpadesSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.491 4.95L5.74.997a1.855 1.855 0 0 1 2.527 0l4.247 3.953c2.532 2.379-.162 7.342-4.072 5.262l.667 3.288H4.892l.666-3.284C1.644 12.297-1.047 7.335 1.49 4.95\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpadesSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.743 1.916a1.087 1.087 0 0 0-1.482 0L2.343 5.563v.001c-.904.85-.912 2.193-.263 3.176c.318.48.774.838 1.315.987c.532.146 1.2.105 1.98-.31a.625.625 0 0 1 .906.676l-.462 2.282H8.18l-.463-2.285a.625.625 0 0 1 .906-.676c.779.414 1.447.455 1.979.308c.54-.148.997-.506 1.315-.987c.65-.983.643-2.325-.256-3.17v-.002zM5.41 1.001a2.337 2.337 0 0 1 3.184 0l3.923 3.651c1.437 1.35 1.355 3.396.444 4.773c-.463.699-1.158 1.263-2.026 1.502a3.56 3.56 0 0 1-1.767.022l.39 1.927a.625.625 0 0 1-.612.749H5.054a.625.625 0 0 1-.612-.75l.39-1.922a3.6 3.6 0 0 1-1.769-.021c-.868-.239-1.564-.804-2.026-1.503c-.91-1.378-.99-3.425.45-4.777l.002-.002z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpadesSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.436.814a2.105 2.105 0 0 0-2.868 0L1.321 4.767C-.057 6.062-.002 8.039.895 9.397c.452.683 1.123 1.224 1.952 1.452c.706.194 1.51.156 2.366-.194l-.567 2.796a.25.25 0 0 0 .245.3h4.216a.25.25 0 0 0 .245-.3l-.568-2.8c.855.35 1.658.387 2.364.193c.829-.228 1.5-.77 1.952-1.452c.898-1.357.957-3.333-.417-4.623v-.001z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpeaker1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.422 3.438a1.498 1.498 0 1 0-1.858-1.859a6.48 6.48 0 0 0-7.129 0a1.499 1.499 0 0 0-2.882.024a1.5 1.5 0 0 0 1.025 1.835A6.5 6.5 0 0 0 .51 7.005a6.4 6.4 0 0 0 .829 3.167A1.488 1.488 0 0 0 2.008 13a1.5 1.5 0 0 0 1.258-.69a6.46 6.46 0 0 0 7.468 0a1.497 1.497 0 0 0 2.756-.809a1.49 1.49 0 0 0-.829-1.329c.545-.966.83-2.058.829-3.167a6.5 6.5 0 0 0-1.068-3.567\"/><path d=\"M7 10.5a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\"/><path d=\"M7 7.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpeaker1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 1.625a.875.875 0 0 0-.36 1.673a.625.625 0 0 1 .275.896c-.501.816-.79 1.776-.79 2.806s.289 1.99.79 2.806a.625.625 0 0 1-.275.896a.875.875 0 1 0 1.158 1.158a.625.625 0 0 1 .896-.275c.816.501 1.776.79 2.806.79s1.99-.289 2.806-.79a.625.625 0 0 1 .896.275a.875.875 0 1 0 1.158-1.158a.625.625 0 0 1-.275-.896c.501-.816.79-1.776.79-2.806s-.289-1.99-.79-2.806a.625.625 0 0 1 .275-.896a.875.875 0 1 0-1.158-1.158a.625.625 0 0 1-.896.275A5.35 5.35 0 0 0 7 1.625c-1.03 0-1.99.289-2.806.79a.625.625 0 0 1-.896-.275a.88.88 0 0 0-.798-.515M.375 2.5a2.125 2.125 0 0 1 3.688-1.44C4.948.622 5.946.375 7 .375s2.052.247 2.937.685a2.125 2.125 0 1 1 3.003 3.003c.439.885.685 1.883.685 2.937s-.246 2.052-.685 2.937a2.125 2.125 0 1 1-3.003 3.003c-.885.439-1.883.685-2.937.685s-2.052-.246-2.937-.685A2.125 2.125 0 1 1 1.06 9.937C.622 9.052.375 8.054.375 7s.247-2.052.685-2.937A2.12 2.12 0 0 1 .375 2.5M7 3a4 4 0 1 0 0 8a4 4 0 0 0 0-8m0 3a1 1 0 1 0 0 2a1 1 0 0 0 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpeaker1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.526.113A1.987 1.987 0 0 0 .908 3.675a6.96 6.96 0 0 0-.85 3.175a6.9 6.9 0 0 0 .671 3.133c-.799.699-.902 1.958-.209 2.776c.734.866 2.06.888 2.862.168a6.92 6.92 0 0 0 7.235.001c.833.756 2.215.68 2.93-.273c.629-.838.47-2.01-.278-2.67a6.88 6.88 0 0 0 .562-4.224a7 7 0 0 0-.739-2.086A1.986 1.986 0 1 0 10.33.912a6.94 6.94 0 0 0-6.66 0a2 2 0 0 0-1.144-.8M7 11.043a4.038 4.038 0 1 0 0-8.076a4.038 4.038 0 0 0 0 8.076M5.45 7.005a1.55 1.55 0 1 1 3.1 0a1.55 1.55 0 0 1-3.1 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpeaker2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 .5H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M7 11.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/><path d=\"M7 9.25a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m0-4.875a.375.375 0 1 1 0-.75m0 .75a.375.375 0 1 0 0-.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpeaker2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.586 1.25a.356.356 0 0 0-.356.356v10.788c0 .197.16.356.356.356h8.827c.197 0 .356-.16.356-.356V1.606a.356.356 0 0 0-.356-.356zM.98 1.606C.98.719 1.7 0 2.586 0h8.827c.887 0 1.606.719 1.606 1.606v10.788c0 .887-.719 1.606-1.606 1.606H2.586A1.606 1.606 0 0 1 .98 12.394zM7 5.029a3.442 3.442 0 1 0 0 6.884A3.442 3.442 0 0 0 7 5.03m.018-1.056H7a.87.87 0 0 1-.019-1.74H7a.87.87 0 0 1 .018 1.74m0 5.243H7a.745.745 0 1 1 .018 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpeaker2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 0a1.5 1.5 0 0 0-1.5 1.5v11A1.5 1.5 0 0 0 3 14h8a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 11 0zm2.831 3.056a1.169 1.169 0 1 1 2.338 0a1.169 1.169 0 0 1-2.338 0M10.291 9a3.29 3.29 0 1 1-6.582 0a3.29 3.29 0 0 1 6.582 0M5.84 9a1.158 1.158 0 1 1 2.317 0a1.158 1.158 0 0 1-2.316 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpiralShape: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6.071v.465a6.5 6.5 0 0 1-6.5 6.5h-.464A6.036 6.036 0 0 1 .5 7v-.66A5.376 5.376 0 0 1 5.876.964a4.84 4.84 0 0 1 4.838 4.839v.447a4 4 0 0 1-4 4h-.178A3.25 3.25 0 0 1 3.286 7v-.464A2.786 2.786 0 0 1 6.07 3.75c1.026 0 1.858.831 1.858 1.857v.265c0 .88-.713 1.592-1.592 1.592H6.07\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpiralShapeRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M13.376 6.09v.455A6.376 6.376 0 0 1 7 12.92h-.455A5.92 5.92 0 0 1 .624 7v-.648A5.273 5.273 0 0 1 5.897 1.08a4.746 4.746 0 0 1 4.746 4.746v.438a3.924 3.924 0 0 1-3.923 3.924h-.175A3.19 3.19 0 0 1 3.357 7v-.455a2.733 2.733 0 0 1 2.732-2.733c1.006 0 1.822.816 1.822 1.822v.26c0 .862-.7 1.562-1.562 1.562h-.26\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpiralShapeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.92 1.946a4.42 4.42 0 0 0-4.42 4.42V7a5.054 5.054 0 0 0 5.054 5.054H7a5.5 5.5 0 0 0 5.5-5.5v-.447a.75.75 0 0 1 1.5 0v.447a7 7 0 0 1-7 7h-.446A6.554 6.554 0 0 1 0 7v-.634A5.92 5.92 0 0 1 5.92.446a5.4 5.4 0 0 1 5.4 5.404v.43a4.596 4.596 0 0 1-4.596 4.596h-.171A3.875 3.875 0 0 1 2.679 7v-.446a3.43 3.43 0 0 1 3.428-3.429c1.4 0 2.536 1.135 2.536 2.536v.255a2.28 2.28 0 0 1-2.28 2.28h-.256a.75.75 0 0 1 0-1.5h.255a.78.78 0 0 0 .78-.78V5.66c0-.572-.463-1.036-1.035-1.036a1.93 1.93 0 0 0-1.927 1.93V7a2.375 2.375 0 0 0 2.375 2.375h.171a3.096 3.096 0 0 0 3.096-3.096v-.43A3.9 3.9 0 0 0 5.92 1.946\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSplitVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.675 4.13L.785.61L4.305.5M.783.608L7 6.697M7 6.7v6.8m6.325-9.37l-.11-3.52L9.695.5m3.522.108L7 6.697\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSplitVerticalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 .5v4a.5.5 0 0 0 .854.354L2.146 3.56L6 7.414v5.581a1 1 0 1 0 2 0v-5.58l3.854-3.854l1.292 1.293A.5.5 0 0 0 14 4.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.354.854l1.293 1.292L7 5.586l-3.44-3.44L4.855.854A.5.5 0 0 0 4.5 0h-4a.5.5 0 0 0-.5.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpotify: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1 7a6 6 0 1 0 12 0A6 6 0 1 0 1 7\"/><path d=\"M4.055 4.837c2.382-.455 4.248-.202 6.51 1.002M4.98 8.875c1.152-.142 1.935.012 3.005.5M4.54 6.8c1.784-.355 3.031 0 4.914.909\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpotifyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0M3.824 5.577c2.488-.475 4.392-.22 6.76 1.041a.75.75 0 1 0 .705-1.324c-2.673-1.423-4.926-1.73-7.747-1.19a.75.75 0 0 0 .282 1.473m3.927 5.002c-1.084-.495-1.817-.635-2.945-.496a.75.75 0 0 1-.183-1.489c1.439-.177 2.45.026 3.751.62a.75.75 0 0 1-.623 1.365M4.369 7.762c1.76-.35 2.973-.028 5.003.953a.75.75 0 0 0 .653-1.35C7.86 6.318 6.294 5.85 4.077 6.29a.75.75 0 1 0 .292 1.471\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSpotifySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 7a6.5 6.5 0 1 1 13 0a6.5 6.5 0 0 1-13 0m4.659 2.594a4.4 4.4 0 0 1 2.87.302a.625.625 0 1 0 .535-1.13a5.64 5.64 0 0 0-3.69-.39a.625.625 0 1 0 .285 1.218M6.16 7.479q-.761.002-1.468.17a.625.625 0 1 1-.287-1.217a7.64 7.64 0 0 1 5.2.618a.625.625 0 0 1-.565 1.115a6.35 6.35 0 0 0-2.88-.686M4.22 5.705a8.4 8.4 0 0 1 1.94-.226c1.416 0 2.748.35 3.916.97a.625.625 0 0 0 .585-1.105a9.6 9.6 0 0 0-4.5-1.115a9.7 9.7 0 0 0-2.23.26a.625.625 0 1 0 .289 1.216\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSprayPaint: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.5 4.5h-4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1M3.5 2v2.5m5-3l5-1m-5 3l5 1M2.5 2h2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSprayPaintRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.152 1.231A.625.625 0 1 0 12.848.02l-4 1a.625.625 0 1 0 .304 1.212zM6 4H4.875V2.875h.25a.875.875 0 0 0 0-1.75h-2.25a.875.875 0 1 0 0 1.75h.25V4H2C1.103 4 .375 4.728.375 5.625v6.75C.375 13.273 1.103 14 2 14h4c.897 0 1.625-.727 1.625-1.625v-6.75C7.625 4.728 6.897 4 6 4M2 5.25a.375.375 0 0 0-.375.375v6.75c0 .207.168.375.375.375h4a.375.375 0 0 0 .375-.375v-6.75A.375.375 0 0 0 6 5.25zm6.394-1.652a.625.625 0 0 1 .758-.454l4 1a.625.625 0 1 1-.304 1.212l-4-1a.625.625 0 0 1-.454-.758\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSprayPaintSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.985.603a.75.75 0 0 1-.588.882l-5 1a.75.75 0 0 1-.294-1.47l5-1a.75.75 0 0 1 .882.588M4.25 3.25h.25a.75.75 0 0 0 0-1.5h-2a.75.75 0 1 0 0 1.5h.25V4.5H1.5A1.5 1.5 0 0 0 0 6v6.5A1.5 1.5 0 0 0 1.5 14h4A1.5 1.5 0 0 0 7 12.5V6a1.5 1.5 0 0 0-1.5-1.5H4.25zm4.147-.235a.75.75 0 0 0-.294 1.47l5 1a.75.75 0 1 0 .294-1.47z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSprout: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.889 5.393c-.844.734-2.17.61-2.862-.27a2.003 2.003 0 0 1 .411-2.845C10.292 1.603 13 2 13 2s-.248 2.718-1.111 3.393m-8.916 1.68a1.755 1.755 0 0 0 2.507-.236c.605-.77.43-1.932-.36-2.492C4.371 3.754 2 4.102 2 4.102s.217 2.38.973 2.971M.5 12s2-2 6.5-2s6.5 2 6.5 2\"/><path d=\"m9.119 5.236l-.133.124c-1 1-1.89 3.304-1.986 4.64c0-1.583-.305-2.286-1.42-3.18l-.049-.047\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSproutRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.71 2.814a1.92 1.92 0 0 0-.27 2.022l1.047-1.048a.625.625 0 1 1 .884.884l-1.07 1.07a1.915 1.915 0 0 0 2.108-.232c.128-.138.268-.41.387-.83c.118-.417.197-.905.247-1.382c.045-.436.066-.849.075-1.169a16 16 0 0 0-1.184.069a8.6 8.6 0 0 0-1.393.238c-.422.116-.694.253-.83.378M7.592 5.861a3.165 3.165 0 0 1 .223-3.92c.364-.36.897-.573 1.394-.71a10 10 0 0 1 1.603-.277a17 17 0 0 1 1.909-.077h.042l.002.001h.001l-.018.625l.625-.014v.013l.001.032a12 12 0 0 1-.004.542c-.008.352-.03.835-.084 1.352a9.7 9.7 0 0 1-.288 1.594c-.14.495-.357 1.024-.72 1.387l-.035.032a3.165 3.165 0 0 1-3.71.3c-.467.87-.801 1.807-.887 2.776c3.377.184 5.526 1.773 6.244 2.67a.5.5 0 0 1-.39.813H.5a.5.5 0 0 1-.39-.812c.713-.892 2.84-2.467 6.18-2.667a4.7 4.7 0 0 0-.404-.925a6 6 0 0 0-.645-.935a2.61 2.61 0 0 1-3.278-.1c-.339-.271-.563-.685-.717-1.058a7.7 7.7 0 0 1-.374-1.238a14 14 0 0 1-.24-1.486l-.003-.026l-.001-.007v-.003l.622-.057l-.09-.619h.003l.007-.001l.026-.004a9 9 0 0 1 .428-.05c.279-.027.662-.057 1.075-.065a8 8 0 0 1 1.291.07c.399.062.854.182 1.196.446a2.61 2.61 0 0 1 .848 3.21c.266.285.52.623.742.976a10 10 0 0 1 .816-1.788m5.157-4.358l.017-.625c.333.01.6.278.607.61zM1.159 3.067l.091.619l-.622.057a.625.625 0 0 1 .531-.676m3.588 3.336a1.36 1.36 0 0 0-.323-1.95c-.083-.065-.28-.147-.624-.2a6.5 6.5 0 0 0-1.077-.056c-.28.005-.548.022-.772.04c.034.222.08.484.141.757c.08.363.183.728.309 1.031c.133.321.26.494.345.561l.025.021a1.36 1.36 0 0 0 1.961-.185l.012-.015zM1.34 4.304\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSproutSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.758 5.61c.81.433 1.856.357 2.585-.278c.753-.588 1.099-2.528 1.222-3.43a.46.46 0 0 0-.414-.525c-.907-.093-2.88-.214-3.624.375c-.891.632-1.183 1.822-.763 2.785a.8.8 0 0 0-.156.12c-.64.64-1.194 1.633-1.596 2.605a5.3 5.3 0 0 0-.975-1.009c.251-.878-.058-1.881-.832-2.43c-.715-.565-2.605-.453-3.49-.364a.46.46 0 0 0-.414.525c.121.88.456 2.738 1.18 3.303c.755.658 1.86.696 2.663.174c.46.388.707.7.856 1.037c.06.135.11.284.147.457a17 17 0 0 1 1.854.008c.104-.361.238-.744.396-1.126c.372-.897.835-1.682 1.272-2.12a1 1 0 0 0 .089-.106M14 12.339s-1.93-1.931-6.25-2.136a16 16 0 0 0-1.5 0C1.931 10.407 0 12.337 0 12.337v1.582h14z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareBracketsCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.25A6.25 6.25 0 1 0 7 .75a6.25 6.25 0 0 0 0 12.5\"/><path d=\"M5.5 9.5H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h.5m3 5H9a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareBracketsCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.625 5.125H5.5a.625.625 0 1 0 0-1.25h-1c-.621 0-1.125.504-1.125 1.125v4c0 .621.504 1.125 1.125 1.125h1a.625.625 0 1 0 0-1.25h-.875zm4.75 0H8.5a.625.625 0 1 1 0-1.25h1c.621 0 1.125.504 1.125 1.125v4c0 .621-.504 1.125-1.125 1.125h-1a.625.625 0 1 1 0-1.25h.875z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareBracketsCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .25a6.75 6.75 0 1 0 0 13.5A6.75 6.75 0 0 0 7 .25M5 5.125a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h.5a.625.625 0 1 1 0 1.25H5A1.625 1.625 0 0 1 3.375 8.5v-3c0-.897.728-1.625 1.625-1.625h.5a.625.625 0 1 1 0 1.25zm4.375.375A.375.375 0 0 0 9 5.125h-.5a.625.625 0 1 1 0-1.25H9c.897 0 1.625.728 1.625 1.625v3c0 .897-.728 1.625-1.625 1.625h-.5a.625.625 0 1 1 0-1.25H9a.375.375 0 0 0 .375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareCap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.988 7H13.5m0-4.794H1.046a.546.546 0 0 0-.546.547v8.494c0 .302.245.547.546.547H13.5\"/><path d=\"M7.988 7a1.798 1.798 0 1 1-3.596 0a1.798 1.798 0 0 1 3.596 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareCapRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 1.375C.728 1.375 0 2.103 0 3v8c0 .898.728 1.625 1.625 1.625h11.75a.625.625 0 1 0 0-1.25H1.625A.375.375 0 0 1 1.25 11V3c0-.207.168-.375.375-.375h11.75a.625.625 0 1 0 0-1.25zM2.875 7a2.625 2.625 0 0 1 5.175-.625h5.325a.625.625 0 1 1 0 1.25H8.05A2.626 2.626 0 0 1 2.875 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareCapSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3a1 1 0 0 1 1-1h13v4.25H6.855a2 2 0 1 0 0 1.5H14V12H1a1 1 0 0 1-1-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareClock: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 11a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/><path d=\"M7 5.5V7h1.5\"/><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareClockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625zM1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12zM7 11a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0-6.125c.345 0 .625.28.625.625v.875H8.5a.625.625 0 1 1 0 1.25H7A.625.625 0 0 1 6.375 7V5.5c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareClockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5zM11.5 7a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0M7.625 5a.625.625 0 1 0-1.25 0v2c0 .345.28.625.625.625h2a.625.625 0 1 0 0-1.25H7.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareRootXCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m3.563 8.039l1.153 1.615l.923-5.308h3.923\"/><path d=\"M7 13.25A6.25 6.25 0 1 0 7 .75a6.25 6.25 0 0 0 0 12.5m.264-6.284l2.361 2.688m-.139-2.688L7.125 9.654\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareRootXCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M5.875 3.875a.625.625 0 0 0-.613.502l-.77 3.855l-.675-.674a.625.625 0 1 0-.884.884l1.5 1.5a.625.625 0 0 0 1.055-.32l.9-4.497H10a.625.625 0 1 0 0-1.25zM7.988 6.61a.625.625 0 1 0-.976.78l.688.86l-.688.86a.625.625 0 1 0 .976.78l.512-.64l.512.64a.625.625 0 1 0 .976-.78L9.3 8.25l.688-.86a.625.625 0 1 0-.976-.78l-.512.64z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSquareRootXCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 6.75a6.75 6.75 0 1 1 13.5 0a6.75 6.75 0 0 1-13.5 0m7.483-.446a.625.625 0 1 0-.939.825l.75.852l-.889 1.01a.625.625 0 1 0 .94.825l.78-.888l.78.888a.625.625 0 1 0 .94-.825l-.888-1.01l.749-.852a.625.625 0 1 0-.94-.825l-.641.73zM5.39 3.47a.625.625 0 0 0-.615.518l-.667 3.836l-.286-.4a.625.625 0 1 0-1.017.727l1.154 1.615a.625.625 0 0 0 1.124-.256l.833-4.79h3.398a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStar1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.49 1.09L9.08 4.3a.51.51 0 0 0 .41.3l3.51.52a.54.54 0 0 1 .3.93l-2.53 2.51a.53.53 0 0 0-.16.48l.61 3.53a.55.55 0 0 1-.8.58l-3.16-1.67a.59.59 0 0 0-.52 0l-3.16 1.67a.55.55 0 0 1-.8-.58L3.39 9a.53.53 0 0 0-.16-.48L.67 6.05A.54.54 0 0 1 1 5.12l3.51-.52a.51.51 0 0 0 .41-.3l1.59-3.21a.54.54 0 0 1 .98 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStar1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M6.745 11.274a.58.58 0 0 1 .51 0l3.1 1.638a.54.54 0 0 0 .784-.569l-.598-3.501a.52.52 0 0 1 .157-.471l2.51-2.422a.53.53 0 0 0-.323-.913l-3.443-.51a.5.5 0 0 1-.402-.294L7.48 1.084a.53.53 0 0 0-.96 0L4.96 4.232a.5.5 0 0 1-.402.294l-3.442.51a.53.53 0 0 0-.324.913l2.51 2.422a.52.52 0 0 1 .158.47l-.599 3.502a.54.54 0 0 0 .785.569z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStar1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .277a1.04 1.04 0 0 0-.94.596L4.472 4.078l-.012.023l-.005.002l-.018.002l-3.496.518a1.04 1.04 0 0 0-.617 1.788L2.883 8.88l.006.005a.03.03 0 0 1 .009.027v.004l-.61 3.568v.001a1.05 1.05 0 0 0 1.526 1.107l3.15-1.665a.1.1 0 0 1 .072 0l3.15 1.664a1.049 1.049 0 0 0 1.527-1.106l-.61-3.57v-.003q-.002-.007 0-.014l.008-.013l.006-.005l2.559-2.47a1.04 1.04 0 0 0-.617-1.787l-3.496-.518l-.023-.004l-.003-.004l-.009-.019L7.94.873A1.04 1.04 0 0 0 7 .277\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStar2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.827 6.533L5.011 5.01L6.533.827a.497.497 0 0 1 .934 0L8.99 5.011l4.184 1.522a.497.497 0 0 1 0 .934L8.989 8.99l-1.522 4.184a.497.497 0 0 1-.934 0L5.01 8.989L.827 7.467a.497.497 0 0 1 0-.934\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStar2Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m.945 6.542l4.104-1.493L6.542.945a.488.488 0 0 1 .916 0l1.493 4.104l4.104 1.493a.488.488 0 0 1 0 .916L8.951 8.951l-1.493 4.104a.488.488 0 0 1-.916 0L5.049 8.951L.945 7.458a.488.488 0 0 1 0-.916\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStar2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.935.655c-.318-.873-1.552-.873-1.87 0L4.622 4.622L.655 6.065c-.873.318-.873 1.552 0 1.87l3.967 1.443l1.443 3.967c.318.873 1.552.873 1.87 0l1.443-3.967l3.967-1.443c.873-.318.873-1.552 0-1.87L9.378 4.622z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStarBadge: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.953 5.482a4.956 4.956 0 1 1-9.912 0a4.956 4.956 0 0 1 9.912 0\"/><path d=\"m7.2 2.791l.683 1.374a.21.21 0 0 0 .174.127l1.517.23a.23.23 0 0 1 .127.397L8.58 5.983a.22.22 0 0 0 0 .206l.215 1.508a.23.23 0 0 1-.342.246l-1.35-.714a.27.27 0 0 0-.222 0l-1.35.714a.23.23 0 0 1-.34-.246l.254-1.508a.22.22 0 0 0-.04-.206L4.286 4.91a.23.23 0 0 1 .128-.39L5.93 4.3a.21.21 0 0 0 .174-.127l.683-1.374a.23.23 0 0 1 .413-.008M2.704 7.913L.5 11.731l2.381-.638l.639 2.381l1.912-3.312m5.864-2.249l2.204 3.818l-2.382-.638l-.638 2.381l-1.912-3.312\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStarBadgeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a4.25 4.25 0 1 0 0 8.5a4.25 4.25 0 0 0 0-8.5M1.5 5.5a5.5 5.5 0 1 1 10.37 2.56l2.059 3.433a.5.5 0 0 1-.484.754l-1.904-.211l-.844 1.688a.5.5 0 0 1-.881.024l-1.642-2.873a5.5 5.5 0 0 1-2.348 0l-1.642 2.873a.5.5 0 0 1-.881-.024l-.844-1.688l-1.904.211a.5.5 0 0 1-.484-.754l2.06-3.433A5.5 5.5 0 0 1 1.5 5.5m5.486-3.083a.48.48 0 0 1 .436.26l.002.003l.679 1.366l1.506.228a.48.48 0 0 1 .263.827L8.816 6.104a.3.3 0 0 1 .013.05l.213 1.501a.48.48 0 0 1-.708.507l-1.335-.706h-.002l-.003-.001h-.005l-1.335.707a.48.48 0 0 1-.708-.51l.253-1.505l.003-.014l-1.088-1.041l-.005-.005a.48.48 0 0 1 .265-.812h.003l1.507-.221l.678-1.364a.48.48 0 0 1 .424-.273\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStarBadgeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.997.009a5.125 5.125 0 1 0 0 10.249a5.125 5.125 0 0 0 0-10.25ZM7.2 2.432l.683 1.374a.21.21 0 0 0 .174.127l1.516.23a.23.23 0 0 1 .127.397L8.582 5.624a.22.22 0 0 0 0 .206l.214 1.508a.23.23 0 0 1-.34.246l-1.35-.714a.27.27 0 0 0-.223 0l-1.35.714a.23.23 0 0 1-.34-.246l.253-1.508a.22.22 0 0 0-.04-.206L4.287 4.552a.23.23 0 0 1 .127-.39l1.517-.221a.21.21 0 0 0 .174-.127l.683-1.374a.23.23 0 0 1 .413-.008Zm5.1 6.238a6.4 6.4 0 0 1-3.665 2.625l1.412 2.446a.5.5 0 0 0 .916-.12l.51-1.899l1.898.509a.5.5 0 0 0 .562-.733zm-6.936 2.626a6.38 6.38 0 0 1-3.667-2.621l-1.63 2.823a.5.5 0 0 0 .562.733l1.899-.509l.509 1.899a.5.5 0 0 0 .916.12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStartup: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.71 4.31C3.79 3 2 4 .5 5.54l3.32 2m5.87.75C11 10.21 10 12 8.46 13.5l-2-3.32\"/><path d=\"m3.82 7.53l2.65 2.65C8.59 8.91 11 7.68 12.1 6.54c2.38-2.38 1-5.64 1-5.64s-3.26-1.38-5.64 1C6.32 3 5.08 5.42 3.82 7.53m1.46-2.51l3.7 3.7\"/><path d=\"M10.5 4a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m-6.82 8.44C3.1 13 .5 13.5.5 13.5s.5-2.6 1.06-3.18a1.501 1.501 0 0 1 2.597 1.049a1.5 1.5 0 0 1-.477 1.07\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStartupRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m13.19.476l-.242.576c.575-.244.575-.243.576-.243v.002l.002.004l.004.01a3 3 0 0 1 .06.16a6.9 6.9 0 0 1 .364 1.917c.051 1.197-.218 2.76-1.534 4.079c-.485.5-1.179.998-1.944 1.483c.438.905.461 1.807.19 2.661c-.318.995-1.02 1.882-1.8 2.64a.625.625 0 0 1-.97-.124l-1.923-3.192L3.55 8.027L.36 6.104a.625.625 0 0 1-.126-.971c.759-.78 1.646-1.482 2.64-1.799a3.5 3.5 0 0 1 2.661.19c.486-.766.984-1.46 1.484-1.944C8.337.264 9.901-.006 11.098.046a6.9 6.9 0 0 1 1.917.364l.16.06l.01.004zm-.242.576l.575-.244a.63.63 0 0 0-.332-.331zM9.276 7.73a.6.6 0 0 1 .107-.059c.932-.569 1.685-1.089 2.142-1.562l.007-.008c.999-.998 1.215-2.178 1.173-3.146a5.6 5.6 0 0 0-.247-1.413a5.6 5.6 0 0 0-1.414-.247c-.967-.042-2.147.174-3.145 1.173l-.008.007C7.42 2.93 6.9 3.681 6.331 4.61a.6.6 0 0 1-.1.165l-.112.188L9.036 7.88l.196-.117zm-.038 1.483l.028-.017l.135-.079c.247.574.238 1.111.073 1.629c-.164.514-.49 1.032-.932 1.546l-1.195-1.984q.475-.278.957-.555l.078-.044q.432-.249.856-.496M7.92 8.532L5.467 6.079l-.156.271q-.298.521-.612 1.057l1.893 1.894c.361-.212.726-.422 1.086-.63l.08-.046zM3.254 4.525a2.24 2.24 0 0 1 1.627.074c-.219.372-.445.765-.671 1.157c-.175.303-.348.605-.518.897L1.708 5.458c.514-.442 1.031-.769 1.546-.933M.01 13.405l.49.095za.5.5 0 0 0 .585.585L.5 13.5l.095.49h.008l.023-.005l.087-.018a22 22 0 0 0 1.29-.304c.37-.1.767-.22 1.116-.355c.325-.125.68-.29.905-.505a2.001 2.001 0 0 0-2.18-3.287a2 2 0 0 0-.647.46c-.215.225-.38.58-.505.905a12 12 0 0 0-.355 1.116a22 22 0 0 0-.322 1.376l-.004.024l-.002.006zM10.5 2.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStartupSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m6.547 10.263l-2.81-2.81c.309-.517.617-1.052.922-1.584c1.016-1.766 2.008-3.49 2.938-4.387c2.524-2.524 5.981-1.06 5.981-1.06s1.464 3.457-1.06 5.981c-.89.922-2.587 1.9-4.34 2.908c-.546.315-1.097.632-1.631.952m2.14-6.532a1.582 1.582 0 1 1 3.164 0a1.582 1.582 0 0 1-3.163 0m-4.09-.232C3.18 3.122 1.849 3.82.668 4.903a.48.48 0 0 0 .089.765l1.905 1.148l.002-.004c.275-.46.582-.993.894-1.533c.355-.617.716-1.243 1.04-1.78m2.587 7.84l1.148 1.905a.48.48 0 0 0 .765.088c1.083-1.18 1.782-2.512 1.404-3.93c-.522.314-1.07.63-1.613.943l-.083.048c-.548.316-1.091.628-1.616.943zM2.622 9.343a2 2 0 0 1 1.402 3.46c-.222.212-.569.379-.89.506a11 11 0 0 1-1.1.358c-.367.1-.717.18-.982.233a6 6 0 0 1-.336.059q-.066.009-.133.013a.5.5 0 0 1-.198-.022a.5.5 0 0 1-.241-.156a.5.5 0 0 1-.11-.22a.6.6 0 0 1-.012-.176c.003-.04.009-.086.015-.128c.013-.088.033-.203.06-.334c.053-.264.135-.612.235-.977c.1-.364.222-.754.359-1.095c.128-.321.294-.667.506-.888a2 2 0 0 1 1.425-.633\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSteeringWheel: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0\"/><path d=\"M2.5 7a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0-9 0m.11-1h8.78\"/><path d=\"M7 9L4.5 6h5zm0 0v2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSteeringWheelRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.114 5.25A3.37 3.37 0 0 1 7 3.625A3.37 3.37 0 0 1 9.886 5.25zm-.48 1.5q-.009.124-.009.25a3.376 3.376 0 0 0 2.625 3.291V9q0-.056.008-.11L4.474 6.75zm5.892 0L7.742 8.89A1 1 0 0 1 7.75 9v1.291a3.376 3.376 0 0 0 2.616-3.541zM7 2.375a4.625 4.625 0 1 0 0 9.25a4.625 4.625 0 0 0 0-9.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSteeringWheelSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.315 5.25a5.002 5.002 0 0 1 9.37 0zm-.309 1.5a5 5 0 0 0 4.244 5.194V9.143L4.156 6.75zm5.744 5.194a5 5 0 0 0 4.244-5.194h-2.15L7.75 9.143zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStepsNumber: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10.967h13m-2.5 2.5l2.5-2.5l-2.5-2.5m-8.8-2.69V1.511c0 .589-.478 1.066-1.067 1.066H.778m2.844 3.201H.778m7.644-.001H5.578v-.606c0-.423.25-.807.639-.977L7.8 3.502a1.04 1.04 0 0 0-.417-1.991h-.739c-.464 0-.86.296-1.006.71m6.545 1.245c.59 0 1.067.478 1.067 1.067v.178c0 .589-.478 1.067-1.067 1.067h-.71c-.465 0-.86-.297-1.007-.712\"/><path d=\"M10.62 2.222a.98.98 0 0 1 .941-.711h.533a.978.978 0 1 1 0 1.955h-.088\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStepsNumberRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.22 0h-.534c-.735 0-1.352.494-1.542 1.166a.625.625 0 1 0 1.202.34a.35.35 0 0 1 .34-.256h.533a.353.353 0 1 1 0 .706h-.088a.625.625 0 0 0 0 1.25h.178c.243 0 .441.197.441.441v.178a.44.44 0 0 1-.442.442h-.71a.44.44 0 0 1-.418-.294a.625.625 0 1 0-1.178.416a1.69 1.69 0 0 0 1.595 1.128h.711c.935 0 1.692-.757 1.692-1.692v-.178c0-.443-.171-.847-.45-1.15A1.603 1.603 0 0 0 12.22 0M5.05 1.128A1.69 1.69 0 0 1 6.643 0h.74a1.664 1.664 0 0 1 .666 3.189l-1.583.692a.44.44 0 0 0-.264.386h2.22a.625.625 0 0 1 0 1.25H5.577a.625.625 0 0 1-.625-.625v-.606c0-.672.398-1.28 1.013-1.55l1.583-.693a.414.414 0 0 0-.166-.793h-.739a.44.44 0 0 0-.416.294a.625.625 0 1 1-1.179-.416M2.074 0C2.42 0 2.7.28 2.7.625v3.642h.797a.625.625 0 1 1 0 1.25H.653a.625.625 0 1 1 0-1.25h.797V2.258q-.211.058-.442.059H.653a.625.625 0 1 1 0-1.25h.355A.44.44 0 0 0 1.45.625C1.45.28 1.73 0 2.075 0m8.484 7.538a.5.5 0 0 1 .545.108l2.75 2.75a.5.5 0 0 1 0 .708l-2.75 2.75a.5.5 0 0 1-.854-.354v-2.125H.625a.625.625 0 1 1 0-1.25h9.625V8a.5.5 0 0 1 .309-.462\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStepsNumberSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.561.76h.533a1.728 1.728 0 0 1 1.486 2.611c.262.315.42.72.42 1.162v.178a1.817 1.817 0 0 1-1.817 1.816h-.71a1.82 1.82 0 0 1-1.714-1.21a.75.75 0 1 1 1.414-.5a.32.32 0 0 0 .3.21h.71a.317.317 0 0 0 .317-.316v-.178a.317.317 0 0 0-.317-.317h-.177a.75.75 0 0 1 0-1.5h.088a.228.228 0 0 0 0-.456h-.533a.23.23 0 0 0-.22.166a.75.75 0 1 1-1.443-.408A1.73 1.73 0 0 1 11.561.76m-8.67.46a.75.75 0 0 0-1.441.29a.317.317 0 0 1-.317.317H.778a.75.75 0 0 0 0 1.5h.355q.162 0 .317-.027v1.727H.778a.75.75 0 0 0 0 1.5h2.844a.75.75 0 1 0 0-1.5H2.95V1.511a.8.8 0 0 0-.058-.29M6.645.76c-.792 0-1.464.507-1.713 1.212a.75.75 0 0 0 1.415.5a.32.32 0 0 1 .298-.211h.74a.29.29 0 0 1 .115.553l-1.583.693A1.82 1.82 0 0 0 4.828 5.17v.606c0 .415.335.75.75.75h2.844a.75.75 0 0 0 0-1.5h-2.06a.32.32 0 0 1 .155-.146L8.1 4.19A1.79 1.79 0 0 0 7.383.76zm4.134 7.41a.75.75 0 0 1 .817.163l2.185 2.185a.75.75 0 0 1 0 1.06l-2.185 2.186a.75.75 0 0 1-1.28-.53v-1.186H1a1 1 0 1 1 0-2h9.315V8.863a.75.75 0 0 1 .463-.693\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStethoscope: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.625 4.27a1.738 1.738 0 1 0 3.388.776a1.738 1.738 0 1 0-3.388-.776M1.74 1.656H.645V5.25a3.22 3.22 0 0 0 3.218 3.219v0a3.22 3.22 0 0 0 3.22-3.219V1.656H5.989\"/><path d=\"M3.927 8.5v1.208a3.7 3.7 0 0 0 3.698 3.698v0a3.7 3.7 0 0 0 3.699-3.698V6.594\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStethoscopeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 1.25A.75.75 0 0 1 1.25.5h.969a.75.75 0 0 1 0 1.5H2v2.719a2.219 2.219 0 0 0 4.438 0V2h-.22a.75.75 0 0 1 0-1.5h.97a.75.75 0 0 1 .75.75v3.469a3.72 3.72 0 0 1-3.224 3.686v.892a2.953 2.953 0 0 0 5.907 0V6.994a2.25 2.25 0 1 1 1.25.003v2.3a4.203 4.203 0 1 1-8.407 0V8.36A3.72 3.72 0 0 1 .5 4.719z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStethoscopeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.052 1.406a.75.75 0 0 1 .75-.75h1.094a.75.75 0 0 1 0 1.5h-.344V5a2.469 2.469 0 1 0 4.937 0V2.156h-.343a.75.75 0 1 1 0-1.5h1.093a.75.75 0 0 1 .75.75V5a3.97 3.97 0 0 1-3.156 3.886v.572a2.948 2.948 0 1 0 5.897 0V6.782a2.488 2.488 0 1 1 1.5-.003v2.679a4.448 4.448 0 0 1-8.897 0v-.549A3.97 3.97 0 0 1 .052 5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStock: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.25 1.81V.5M11 5.31c0 .66.53.88 1.25.88s1.25 0 1.25-.88C13.5 4 11 4 11 2.69c0-.88.53-.88 1.25-.88s1.25.33 1.25.88m-1.25 3.5V7.5m-9.75-4h-1a1 1 0 0 0-1 1V9a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4.5a1 1 0 0 0-1-1M2 10v1.5m0-8v-3m6 7H7a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8.5a1 1 0 0 0-1-1M7.5 11v2.5m0-6V4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStockRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.877.125c.345 0 .625.28.625.625v.479a1.71 1.71 0 0 1 1.347 1.118a.625.625 0 1 1-1.179.417a.46.46 0 0 0-.432-.306h-.839a.342.342 0 0 0-.073.676l1.277.28a1.709 1.709 0 0 1-.101 3.357v.479a.625.625 0 1 1-1.25 0v-.48a1.71 1.71 0 0 1-1.347-1.118a.625.625 0 0 1 1.178-.417a.46.46 0 0 0 .432.306h.723a.459.459 0 0 0 .098-.907l-1.277-.28a1.592 1.592 0 0 1 .193-3.14V.75c0-.345.28-.625.625-.625m-9.02.769a.75.75 0 0 0-1.5 0v2.14A1.59 1.59 0 0 0 .041 4.598v4.325c0 .784.569 1.435 1.316 1.563v.84a.75.75 0 0 0 1.5 0v-.84a1.59 1.59 0 0 0 1.317-1.564V4.599c0-.785-.57-1.436-1.317-1.564zM1.627 4.26a.336.336 0 0 0-.336.337v4.325c0 .185.15.336.336.336h.96c.186 0 .337-.15.337-.337V4.599a.336.336 0 0 0-.336-.337zm5.286 3.845a.336.336 0 0 0-.336.336v1.442c0 .185.15.336.336.336h.96c.186 0 .337-.15.337-.336V8.442a.336.336 0 0 0-.336-.336zm-1.586.336c0-.784.569-1.435 1.316-1.563V4.117a.75.75 0 1 1 1.5 0V6.88A1.586 1.586 0 0 1 9.46 8.443v1.442c0 .784-.57 1.435-1.317 1.563v1.676a.75.75 0 1 1-1.5 0v-1.676a1.59 1.59 0 0 1-1.316-1.563z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStockSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.798.126a.75.75 0 0 1 .75.75v.78c.233.063.455.158.653.293c.425.288.718.75.718 1.329a.75.75 0 1 1-1.5 0c0-.026-.005-.034-.007-.038a.2.2 0 0 0-.054-.05c-.086-.059-.268-.127-.56-.127c-.207 0-.355 0-.48.012a1 1 0 0 0-.127.018a1 1 0 0 0-.014.185c0 .077.02.156.171.288c.178.155.434.294.798.484l.035.018c.317.167.728.382 1.053.665c.363.318.685.777.685 1.418c0 .31-.046.616-.18.89a1.36 1.36 0 0 1-.627.627c-.191.095-.388.14-.564.165v.72a.75.75 0 0 1-1.5 0v-.762a2 2 0 0 1-.626-.248c-.48-.296-.745-.788-.745-1.392a.75.75 0 1 1 1.5 0q.001.06.007.082l.006.02l.02.014c.068.042.242.099.581.1h.014c.202 0 .348-.001.472-.012q.084-.009.127-.019a1 1 0 0 0 .015-.185c0-.077-.021-.156-.172-.288c-.177-.155-.434-.294-.798-.484l-.034-.018c-.318-.167-.728-.382-1.053-.665c-.364-.317-.685-.777-.685-1.418c0-.31.045-.615.18-.89a1.36 1.36 0 0 1 .627-.627c.19-.094.388-.14.564-.165v-.72a.75.75 0 0 1 .75-.75M4.08 4.463a1.5 1.5 0 0 0-1.25-1.48V.877a.75.75 0 0 0-1.5 0v2.108a1.5 1.5 0 0 0-1.25 1.48v4.5a1.5 1.5 0 0 0 1.25 1.478v1.021a.75.75 0 0 0 1.5 0v-1.02a1.5 1.5 0 0 0 1.25-1.48zm2.25 2.52a1.5 1.5 0 0 0-1.25 1.48v1.5a1.5 1.5 0 0 0 1.25 1.48v1.681a.75.75 0 0 0 1.5 0v-1.682a1.5 1.5 0 0 0 1.25-1.479v-1.5a1.5 1.5 0 0 0-1.25-1.48v-3.02a.75.75 0 0 0-1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStore1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M8 8.5v5M1.5 10H8M.5 4L2 .5h10L13.5 4zm4.28 0v1a2 2 0 0 1-2 2H2.5a2 2 0 0 1-2-2V4\"/><path d=\"M9.25 4v1a2 2 0 0 1-2 2h-.5a2 2 0 0 1-2-2V4m8.75 0v1a2 2 0 0 1-2 2h-.25a2 2 0 0 1-2-2V4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStore1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 4v1A2.5 2.5 0 0 0 5 6.5c.456.607 1.182 1 2 1s1.544-.393 2-1A2.5 2.5 0 0 0 13.5 5V4a.5.5 0 0 0-.046-.21l-1.117-2.419A1.5 1.5 0 0 0 10.976.5H3.024a1.5 1.5 0 0 0-1.361.871L.546 3.791A.5.5 0 0 0 .5 4m1 4.375c.345 0 .625.28.625.625v3.375H5v-1.344a2 2 0 0 1 4 0v1.344h2.875V9a.625.625 0 1 1 1.25 0v3.5A1.125 1.125 0 0 1 12 13.625H2A1.125 1.125 0 0 1 .875 12.5V9c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStore1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 0a.5.5 0 0 0-.453.288l-1.5 3.209a.5.5 0 0 0-.045.253H0v.945c0 .524.226 1.026.63 1.396c.402.37.949.578 1.519.578h.3a2.25 2.25 0 0 0 1.52-.578q.246-.227.4-.508c.127-.17.333-.17.452-.014q.155.29.407.522c.403.37.95.578 1.52.578h.537a2.25 2.25 0 0 0 1.52-.578q.235-.217.386-.484c.131-.205.36-.2.48-.01q.153.273.392.494c.403.37.95.578 1.52.578h.268c.57 0 1.117-.207 1.52-.578S14 5.22 14 4.695V3.75h-.002a.5.5 0 0 0-.045-.253l-1.5-3.209A.5.5 0 0 0 12 0zM1 13V7.729c1.188.392 2.605.217 3.578-.536c1.298 1.004 3.549 1.004 4.846 0c.978.756 2.392.928 3.576.526V13a1 1 0 0 1-1 1h-1.256v-3.79a.2.2 0 0 0-.07-.155a.25.25 0 0 0-.169-.064H8.513a.25.25 0 0 0-.17.064a.2.2 0 0 0-.07.155V14H2a1 1 0 0 1-1-1m1.502-2.24V9.5a.5.5 0 0 1 .5-.5h3.014a.5.5 0 0 1 .5.5v1.26a.5.5 0 0 1-.5.5H3.002a.5.5 0 0 1-.5-.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStore2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M13 6H1a.5.5 0 0 1-.5-.5v-2l1.22-2.45a1 1 0 0 1 .9-.55h8.76a1 1 0 0 1 .9.55L13.5 3.5v2a.5.5 0 0 1-.5.5M8 8.5v5M1.5 10H8M.5 3.5h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStore2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.024.5a1.5 1.5 0 0 0-1.361.871L.546 3.791A.5.5 0 0 0 .5 4v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V4a.5.5 0 0 0-.046-.21l-1.116-2.419A1.5 1.5 0 0 0 10.976.5zm5.601 8a.625.625 0 1 0-1.25 0v.875h-5.25V8.5a.625.625 0 1 0-1.25 0v4A1.125 1.125 0 0 0 2 13.625h10a1.125 1.125 0 0 0 1.125-1.125v-4a.625.625 0 1 0-1.25 0v3.875h-3.25zm-1.25 3.875v-1.75h-5.25v1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStore2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.265.902c.24-.528.767-.906 1.357-.902h8.756h-.002l.004.5V0h-.002c.59-.004 1.117.374 1.357.902l.001.002l.907 2.015H.357L1.264.904zM0 4.169h14v1.365c0 .264-.094.526-.275.726a.98.98 0 0 1-.725.327H1a.98.98 0 0 1-.725-.327A1.1 1.1 0 0 1 0 5.534zm1 4.177a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V13a1 1 0 0 1-1 1h-1.255v-3.79a.2.2 0 0 0-.07-.155a.25.25 0 0 0-.17-.064H8.513a.25.25 0 0 0-.17.064a.2.2 0 0 0-.07.155V14H2a1 1 0 0 1-1-1zM2.502 10v1.26a.5.5 0 0 0 .5.5h3.014a.5.5 0 0 0 .5-.5V10a.5.5 0 0 0-.5-.5H3.002a.5.5 0 0 0-.5.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStoreComputer: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.338 8v1.969a1 1 0 0 1-1 1H2.662a1 1 0 0 1-1-1V8M6 11l-1 2.5M8 11l1 2.5m-5 0h6M.969 3.52L2.36.624h9.278l1.392 2.894zm3.961 0v.826c0 .439-.194.86-.541 1.17A1.97 1.97 0 0 1 3.079 6H2.82a1.97 1.97 0 0 1-1.309-.484a1.57 1.57 0 0 1-.542-1.17V3.52m8.128 0v.826c0 .439-.195.86-.543 1.17A1.97 1.97 0 0 1 7.245 6h-.463a1.97 1.97 0 0 1-1.309-.484a1.57 1.57 0 0 1-.542-1.17V3.52m8.1 0v.826c0 .439-.195.86-.542 1.17a1.97 1.97 0 0 1-1.31.484h-.23a1.97 1.97 0 0 1-1.31-.484a1.57 1.57 0 0 1-.542-1.17V3.52\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStoreComputerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.047.871A1.5 1.5 0 0 1 3.41 0h7.182a1.5 1.5 0 0 1 1.362.871l.998 2.164a.5.5 0 0 1 .049.224v.658A2.333 2.333 0 0 1 8.833 5.36A2.33 2.33 0 0 1 7 6.25a2.33 2.33 0 0 1-1.833-.89A2.333 2.333 0 0 1 1 3.917V3.24zM1 3.241a.5.5 0 0 1 .05-.21l-.004.01a.5.5 0 0 0-.046.2M1.911 7c.346 0 .625.28.625.625v2.344c0 .207.168.375.375.375h8.177a.375.375 0 0 0 .375-.375V7.625a.625.625 0 0 1 1.25 0v2.344c0 .897-.727 1.625-1.625 1.625H8.776l.462 1.156H10A.625.625 0 0 1 10 14H4a.625.625 0 1 1 0-1.25h.761l.463-1.156H2.91a1.625 1.625 0 0 1-1.625-1.625V7.625c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStoreComputerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.183.367a.44.44 0 0 1 .4-.255h8.828c.171 0 .327.1.4.255l1.324 2.832a.44.44 0 0 1 .04.224h.002v.834c0 .462-.2.906-.556 1.233c-.356.326-.838.51-1.341.51h-.237a2 2 0 0 1-1.342-.51a1.8 1.8 0 0 1-.346-.437c-.105-.168-.308-.172-.424.009q-.133.235-.341.428A2 2 0 0 1 7.248 6h-.474c-.503 0-.985-.184-1.341-.51a1.8 1.8 0 0 1-.36-.461c-.105-.137-.286-.138-.398.011q-.137.249-.354.45c-.355.326-.838.51-1.341.51h-.266c-.503 0-.985-.184-1.341-.51a1.67 1.67 0 0 1-.556-1.233v-.834H.82a.44.44 0 0 1 .04-.224zM1.662 10.5V7.078a3.3 3.3 0 0 0 1.052.172H3V10h8V7.25h.28a3.3 3.3 0 0 0 1.058-.174V10.5a1 1 0 0 1-1 1H8.577l.6 1.5H10a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h.823l.6-1.5H2.662a1 1 0 0 1-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStraightCap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.137 7A1.818 1.818 0 1 1 .5 7a1.818 1.818 0 0 1 3.637 0m-.004 0H13.5\"/><path d=\"M13.5 2.152H2.871a.553.553 0 0 0-.552.553v2.48M13.5 11.848H2.871a.553.553 0 0 1-.552-.553v-2.48\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStraightCapRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.25 3c0-.207.168-.375.375-.375h9.75a.625.625 0 1 0 0-1.25h-9.75C2.728 1.375 2 2.103 2 3v1.45a2.626 2.626 0 0 0 0 5.1V11c0 .898.728 1.625 1.625 1.625h9.75a.625.625 0 1 0 0-1.25h-9.75A.375.375 0 0 1 3.25 11V9.55a2.63 2.63 0 0 0 1.925-1.925h8.2a.625.625 0 1 0 0-1.25h-8.2A2.63 2.63 0 0 0 3.25 4.45z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStraightCapSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 2a1.5 1.5 0 0 0-1.5 1.5v.541a3 3 0 0 0 0 5.918v.541A1.5 1.5 0 0 0 4 12h10V7.75H4.3a1.5 1.5 0 1 1 0-1.5H14V2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStraightFace: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 9.5h5m-2.5 4a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M4.75 5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m4.5.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStraightFaceRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4.75 6.25a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-.25 2.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5zm4.75-2.5a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStraightFaceSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7A7 7 0 1 0 0 7a7 7 0 0 0 14 0m-3.56-2.048c0 .565-.457 1.023-1.022 1.024h-.002a1.025 1.025 0 0 1-.003-2.049h.003c.565 0 1.024.459 1.024 1.025m-4.831 0c0 .565-.457 1.023-1.022 1.024h-.003a1.025 1.025 0 0 1-.002-2.049h.002c.566 0 1.025.459 1.025 1.025M9.452 8.7a.625.625 0 0 1 0 1.25H4.548a.625.625 0 0 1 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStrategyTasks: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5\"/><path d=\"M8.5.5h-3a1 1 0 0 0-1 1V2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1M4.046 6.203a1.25 1.25 0 1 0 2.5 0a1.25 1.25 0 0 0-2.5 0m3.406 2.63l2.5 2.5m.002-2.5l-2.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStrategyTasksRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.663 2.25H2.5a.375.375 0 0 0-.375.375v9.75c0 .207.168.375.375.375h9a.375.375 0 0 0 .375-.375v-9.75a.375.375 0 0 0-.375-.375h-1.162c-.174.856-.93 1.5-1.838 1.5h-3a1.876 1.876 0 0 1-1.837-1.5M3.84 1c.315-.595.94-1 1.659-1h3c.72 0 1.344.405 1.659 1H11.5c.898 0 1.625.728 1.625 1.625v9.75c0 .898-.727 1.625-1.625 1.625h-9a1.625 1.625 0 0 1-1.625-1.625v-9.75C.875 1.728 1.603 1 2.5 1zm.705 5.703a.5.5 0 1 1 1 0a.5.5 0 0 1-1 0m.5-2a2 2 0 1 0 0 4a2 2 0 0 0 0-4m3.187 3.6a.75.75 0 0 0-1.06 1.06l.47.47l-.47.47a.75.75 0 0 0 1.061 1.06l.47-.469l.468.47a.75.75 0 1 0 1.06-1.062l-.468-.469l.47-.47a.75.75 0 1 0-1.06-1.06l-.47.47z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStrategyTasksSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0a1 1 0 0 0-1 1v.506a1 1 0 0 0 1 .994h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-2 1H3a1.5 1.5 0 0 0-1.5 1.5v10A1.5 1.5 0 0 0 3 14h8a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 11 1h-.5v.5a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm1.037 5.569a.76.76 0 1 1 1.518 0a.76.76 0 0 1-1.518 0m.759-2.01a2.01 2.01 0 1 0 0 4.02a2.01 2.01 0 0 0 0-4.02m5.1 4.332a.625.625 0 0 1 0 .884l-.81.809l.808.807a.625.625 0 1 1-.884.884l-.807-.807l-.807.807a.625.625 0 1 1-.884-.884l.807-.807l-.809-.81a.625.625 0 1 1 .884-.883l.809.809l.809-.81a.625.625 0 0 1 .884 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStrawberry: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 .5C5.833.5 7 1.8 7 3C7 1.8 8.167.5 9 .5M2.5 7c0-2.8 2-4 4.5-4s4.5 1.2 4.5 4c0 3.5-2.5 6.5-4.5 6.5s-4.5-3-4.5-6.5\"/><path d=\"M4.75 7a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m1 3.558a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5m2.5.5a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5M7 7a.25.25 0 0 1 0-.5M7 7a.25.25 0 0 0 0-.5m2.25.5a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStrawberryRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.875.625C3.875.28 4.155 0 4.5 0h.25A2.87 2.87 0 0 1 7 1.085A2.87 2.87 0 0 1 9.25 0h.25a.625.625 0 1 1 0 1.25h-.25c-.687 0-1.275.427-1.512 1.03c1.51.124 2.688.637 3.516 1.466c.957.956 1.371 2.256 1.371 3.629c0 1.667-.694 3.305-1.713 4.526C9.9 13.11 8.49 14 7 14s-2.9-.888-3.912-2.1C2.07 10.68 1.375 9.043 1.375 7.376c0-1.597.4-2.922 1.389-3.834c.84-.777 2.021-1.173 3.496-1.268A1.63 1.63 0 0 0 4.75 1.25H4.5a.625.625 0 0 1-.625-.625M7 3.5c-1.677 0-2.741.362-3.389.96c-.636.587-.986 1.512-.986 2.915c0 1.333.563 2.695 1.423 3.724C4.915 12.14 6.005 12.75 7 12.75s2.085-.612 2.952-1.65c.86-1.03 1.423-2.392 1.423-3.725c0-1.127-.336-2.077-1.004-2.746C9.705 3.963 8.63 3.5 7 3.5M3.625 6.625a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m1.25 3a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m2.5 0a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m-1.25-3a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0m2.5 0a.875.875 0 1 0 1.75 0a.875.875 0 0 0-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStrawberrySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 .045a.75.75 0 0 0 0 1.5c.12 0 .435.12.767.47c.164.174.287.358.368.533c-.994.113-1.911.433-2.635 1.012C2.554 4.317 2 5.469 2 7c0 1.866.665 3.593 1.597 4.86C4.513 13.101 5.768 14 7 14s2.487-.898 3.402-2.14A8.3 8.3 0 0 0 12 7c0-1.531-.554-2.683-1.5-3.44c-.724-.58-1.64-.899-2.635-1.012c.08-.175.204-.359.368-.532c.332-.351.648-.47.767-.47a.75.75 0 0 0 0-1.5c-.714 0-1.398.453-1.858.94a4 4 0 0 0-.142.16a4 4 0 0 0-.142-.16C6.398.499 5.714.046 5 .046Zm.5 6.705a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m1 3.058a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m1.75.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m-.5-3.808a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m1.5.75a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStream: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.16 8.66a2.57 2.57 0 0 1 1.658-.587l1.636-3.566a3.062 3.062 0 1 1 3.444 2.34L8.227 9.761q.13.352.155.748a2.585 2.585 0 0 1-5.148.448\"/><path d=\"M9.147 3.795a1.319 1.319 0 1 0 2.634-.152a1.319 1.319 0 1 0-2.634.152M1.011 6.93L5.6 9.483c.467.26.68.818.507 1.324v0c-.202.588-.85.892-1.432.674L.56 9.936\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreamRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.563.007a4.195 4.195 0 0 1 .64 8.365l-1.29 1.475q.086.325.108.672a3.291 3.291 0 0 1-6.535.716l-2.078-.769a.625.625 0 0 1 .434-1.172l2.428.898l.032.012l1.634.605h.003a.458.458 0 0 0 .383-.827l-4.5-2.504a.625.625 0 0 1 .608-1.092L4.082 7.86a3.3 3.3 0 0 1 1.364-.431l.628-1.312a4.196 4.196 0 0 1 3.49-6.11m-3.71 12.74a2.04 2.04 0 0 1-1.845-.949l.491.182h.002A1.708 1.708 0 0 0 5.93 8.89l-.384-.214a2 2 0 0 1 .273-.007c.25.01.481-.13.589-.355l.935-1.95a.63.63 0 0 0-.035-.604a2.946 2.946 0 1 1 2.578 1.38a.63.63 0 0 0-.453.213l-1.697 1.94a.63.63 0 0 0-.11.647q.126.304.147.651a2.04 2.04 0 0 1-1.92 2.156m4.026-7.26a1.294 1.294 0 1 0-.15-2.583a1.294 1.294 0 0 0 .15 2.583\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreamSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.248.512a3.312 3.312 0 0 1 .776 6.567L8.51 9.822q.1.322.12.673a2.835 2.835 0 0 1-5.358 1.448l1.424.473a1.789 1.789 0 0 0 1.38-3.29l-1.745-.893a2.8 2.8 0 0 1 1.307-.405l.016-.001l1.537-3.349A3.312 3.312 0 0 1 10.248.512m.292 4.525a1.32 1.32 0 1 0-.152-2.635a1.32 1.32 0 0 0 .152 2.635M0 7.422l.01 2.275l5.176 1.721a.6.6 0 0 0 .463-1.104z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreetRoad: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l3-13M7 .5v2M7 6v2m0 3.5v2m6.5 0l-3-13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreetRoadRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.62.012c.34.066.56.395.493.733l-2.5 12.75a.625.625 0 0 1-1.226-.24l2.5-12.75A.625.625 0 0 1 3.62.012M7 0c.483 0 .875.392.875.875V2.5a.875.875 0 1 1-1.75 0V.875C6.125.392 6.517 0 7 0m.875 11.5a.875.875 0 1 0-1.75 0v1.625a.875.875 0 0 0 1.75 0zM7 5.313c.483 0 .875.391.875.875v1.625a.875.875 0 0 1-1.75 0V6.188c0-.484.392-.875.875-.875M11.113.505a.625.625 0 1 0-1.226.24l2.5 12.75a.625.625 0 1 0 1.226-.24z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreetRoadSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.25 0H3.5a.5.5 0 0 0-.487.388l-3 13A.5.5 0 0 0 .5 14h5.75v-2.154a.75.75 0 0 1 1.5 0V14h5.75a.5.5 0 0 0 .487-.612l-3-13A.5.5 0 0 0 10.5 0H7.75v2.154a.75.75 0 0 1-1.5 0zM7 5.173a.75.75 0 0 1 .75.75v2.154a.75.75 0 0 1-1.5 0V5.923a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreetSign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 4.5H2.707a.5.5 0 0 1-.353-.146l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5A.5.5 0 0 1 2.707.5H7m0 7h4.293a.5.5 0 0 0 .353-.146l1.5-1.5a.5.5 0 0 0 0-.708l-1.5-1.5a.5.5 0 0 0-.353-.146H7m0 7H2.707a.5.5 0 0 1-.353-.146l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5a.5.5 0 0 1 .353-.146H7m0-6v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreetSignRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 .375a.63.63 0 0 0-.442.183l-2 2a.625.625 0 0 0 0 .884l2 2A.63.63 0 0 0 3 5.625h3.375V13a.625.625 0 1 0 1.25 0V9.625H11a.63.63 0 0 0 .442-.183l2-2a.625.625 0 0 0 0-.884l-2-2A.63.63 0 0 0 11 4.375H7.625V1A.625.625 0 0 0 7 .375zm4.625 5.25v2.75h3.116L12.116 7l-1.375-1.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineStreetSignSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.75.795a.75.75 0 0 0-.885-.738H2.538a.25.25 0 0 0-.176.073L.379 2.113a.25.25 0 0 0 0 .353L2.362 4.45a.25.25 0 0 0 .176.074H6.25V6.5H2.538a.25.25 0 0 0-.176.074L.379 8.558a.25.25 0 0 0 0 .353l1.983 1.983a.25.25 0 0 0 .176.073H6.25v2.238a.75.75 0 1 0 1.5 0V7.807h3.712a.25.25 0 0 0 .177-.074l1.983-1.983a.25.25 0 0 0 0-.353l-1.983-1.983a.25.25 0 0 0-.177-.073H7.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubscriptionCashflow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.351 5.307a1.17 1.17 0 0 0-1.1-.778h-.903a1.041 1.041 0 0 0-.223 2.059l1.375.3a1.167 1.167 0 0 1-.25 2.307h-.777c-.508 0-.94-.324-1.1-.777m1.489-3.889V3.362m0 7V9.196m-4.864 4.303v-2.5h2.5\"/><path d=\"M13.388 5.804a6.5 6.5 0 0 1-11.39 5.35M.612 8.196a6.5 6.5 0 0 1 11.39-5.35\"/><path d=\"M12.002.502v2.5h-2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubscriptionCashflowRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 0 1 10.412-3.37l-.515.515A.5.5 0 0 0 11.5 5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.854-.354l-.592.593A7.001 7.001 0 0 0 0 7a.625.625 0 1 0 1.25 0M7 2.875c.345 0 .625.28.625.625v.557a1.79 1.79 0 0 1 1.453 1.18a.625.625 0 1 1-1.178.416a.54.54 0 0 0-.511-.361h-.903a.416.416 0 0 0-.09.823l1.376.3a1.792 1.792 0 0 1-.147 3.528v.557a.625.625 0 1 1-1.25 0v-.557a1.79 1.79 0 0 1-1.453-1.18a.625.625 0 1 1 1.178-.416a.54.54 0 0 0 .511.361h.778a.542.542 0 0 0 .116-1.071L6.13 7.336a1.666 1.666 0 0 1 .245-3.29V3.5c0-.345.28-.625.625-.625M.309 11.962A.5.5 0 0 1 0 11.5v-2A.5.5 0 0 1 .5 9h2a.5.5 0 0 1 .354.854l-.515.514a5.751 5.751 0 0 0 10.412-3.37a.625.625 0 1 1 1.25.001a7.001 7.001 0 0 1-12.555 4.262l-.592.593a.5.5 0 0 1-.545.108\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubscriptionCashflowSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.213 2.538A5.499 5.499 0 0 0 1.595 8.01a.75.75 0 0 1-1.474.277a6.999 6.999 0 0 1 11.163-6.821l.612-.612a.5.5 0 0 1 .854.353V3.5a.5.5 0 0 1-.5.5H9.957a.5.5 0 0 1-.353-.853zm2.791 2.577a.75.75 0 0 1 .876.598a6.999 6.999 0 0 1-11.164 6.821l-.612.613a.5.5 0 0 1-.854-.354V10.5a.5.5 0 0 1 .5-.5h2.293a.5.5 0 0 1 .354.854l-.61.609a5.499 5.499 0 0 0 8.618-5.472a.75.75 0 0 1 .6-.876ZM7.627 3.657a.75.75 0 0 0-1.5 0V4a1.704 1.704 0 0 0-.085 3.346l1.26.275a.32.32 0 0 1-.068.63H6.52a.32.32 0 0 1-.3-.212a.75.75 0 0 0-1.415.5a1.82 1.82 0 0 0 1.321 1.17v.362a.75.75 0 0 0 1.5 0v-.362a1.82 1.82 0 0 0-.005-3.553l-1.26-.276a.204.204 0 0 1 .044-.403h.828a.32.32 0 0 1 .3.212a.75.75 0 0 0 1.415-.5a1.82 1.82 0 0 0-1.322-1.17v-.36Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtract1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtract1Remix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M.625 7h12.75\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtract1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtractCircle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13M4 7h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtractCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M4 6.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtractCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M4 6.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtractSquare: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 7h6m.5-6.5h-7a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtractSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625h10c.207 0 .375.168.375.375v10a.375.375 0 0 1-.375.375H2A.375.375 0 0 1 1.625 12V2c0-.207.168-.375.375-.375m10-1.25H2C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625M4 6.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSubtractSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0A3.5 3.5 0 0 0 0 3.5v7A3.5 3.5 0 0 0 3.5 14h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 10.5 0zM4 6.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSunCloud: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 8.5a2.5 2.5 0 0 0-1.5.5A4.5 4.5 0 1 0 5 13.5h6a2.5 2.5 0 0 0 0-5m.25-3.5a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSunCloudRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.5 3a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0M1.625 9.5a2.875 2.875 0 0 1 5.653-.744a.625.625 0 0 0 1.009.315A1.875 1.875 0 1 1 9.5 12.375h-5A2.875 2.875 0 0 1 1.625 9.5M4.5 5.375a4.125 4.125 0 0 0 0 8.25h5a3.125 3.125 0 1 0-1.307-5.964A4.12 4.12 0 0 0 4.5 5.375\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSunCloudSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 5.999A3 3 0 1 0 11 0a3 3 0 0 0 0 5.999m-9.682.32A4.5 4.5 0 0 1 4.5 5a4.45 4.45 0 0 1 4.46 4.11a.25.25 0 0 0 .14.19a.24.24 0 0 0 .23 0A2.45 2.45 0 0 1 10.5 9a2.5 2.5 0 0 1 0 5h-6a4.5 4.5 0 0 1-3.182-7.682\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSynchronizeDisable: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m5 11l.5 2l-2 .5\"/><path d=\"M5.5 13A6.76 6.76 0 0 1 1 7a6 6 0 0 1 .66-2.736M4.95 1.36a6 6 0 0 0-2.19 1.394M9 3l-.5-2l2-.5\"/><path d=\"M8.5 1c2.3.84 4.5 3.42 4.5 6a6 6 0 0 1-1.731 4.2M9 12.64q.33-.117.642-.27M.5.5l13 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSynchronizeDisableSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m10.929.757l-.322.537A6.75 6.75 0 0 1 13.75 7a6.72 6.72 0 0 1-1.476 4.213l1.506 1.507a.75.75 0 0 1-1.06 1.06L.22 1.28A.75.75 0 0 1 1.28.22l1.507 1.506a6.8 6.8 0 0 1 1.4-.864a.75.75 0 1 1 .626 1.364q-.51.235-.957.57l7.349 7.348A5.23 5.23 0 0 0 12.25 7a5.25 5.25 0 0 0-2.415-4.42l-.406.677a.5.5 0 0 1-.914-.136l-.5-2a.5.5 0 0 1 .364-.606l2-.5a.5.5 0 0 1 .55.742M9.04 11.863l1.108 1.109a7 7 0 0 1-.336.166a.75.75 0 0 1-.772-1.275M2.154 4.976L1.028 3.85A6.7 6.7 0 0 0 .25 7a6.75 6.75 0 0 0 3.143 5.706l-.322.537a.5.5 0 0 0 .55.742l2-.5a.5.5 0 0 0 .364-.606l-.5-2a.5.5 0 0 0-.914-.136l-.406.677A5.25 5.25 0 0 1 1.75 7c0-.717.144-1.4.404-2.024\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSynchronizeWarning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11 9l2-.5l.5 2\"/><path d=\"M13 8.5A6.6 6.6 0 0 1 7 13a6 6 0 0 1-5.64-3.95M3 5l-2 .5l-.5-2\"/><path d=\"M1 5.5A6.79 6.79 0 0 1 7 1a6 6 0 0 1 5.64 4M7 3.5v4m0 2.75a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSynchronizeWarningSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.75a5.25 5.25 0 0 0-4.42 2.415l.677.406a.5.5 0 0 1-.136.914l-2 .5a.5.5 0 0 1-.606-.364l-.5-2a.5.5 0 0 1 .742-.55l.537.322a6.751 6.751 0 0 1 11.844.794a.75.75 0 1 1-1.364.626A5.25 5.25 0 0 0 7 1.75m.75 1.75a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0zM7 11a1 1 0 1 0 0-2a1 1 0 0 0 0 2m4.42-1.165l-.677-.406a.5.5 0 0 1 .136-.914l2-.5a.5.5 0 0 1 .606.364l.5 2a.5.5 0 0 1-.742.55l-.537-.322A6.751 6.751 0 0 1 .862 9.813a.75.75 0 1 1 1.364-.626a5.25 5.25 0 0 0 9.194.648\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSyringe: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 3L2.42 7.49a2 2 0 0 0 0 2.83l1.26 1.26a2 2 0 0 0 2.83 0L11 7M10.5.5l3 3M9 5l3-3m-8.95 8.95L.5 13.5m5-12l7 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSyringeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.939.183a.625.625 0 0 1 .883 0l2.951 2.951a.625.625 0 1 1-.884.884l-.945-.945L9.878 5.14l2.912 2.913a.625.625 0 1 1-.884.883l-1.03-1.029l-3.974 4.055l-.004.004a2.593 2.593 0 0 1-3.47.179l-2.51 1.764a.5.5 0 0 1-.64-.056l-.088-.087a.5.5 0 0 1-.055-.64l1.758-2.502a2.59 2.59 0 0 1 .098-3.565l.004-.004L6.05 3.08L5.02 2.051a.625.625 0 1 1 .884-.884L8.817 4.08l2.067-2.067l-.945-.946a.625.625 0 0 1 0-.884m-3.005 3.78L2.873 7.946A1.34 1.34 0 0 0 2.485 9h5.57l1.938-1.977z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineSyringeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.47.393a1 1 0 0 1 1.414 0l2.723 2.723a1 1 0 1 1-1.414 1.414l-.655-.654l-1.308 1.309l2.47 2.47a1 1 0 0 1-1.415 1.414l-1.001-1.001l-3.372 3.439l-.003.003a2.315 2.315 0 0 1-3.135.13l-1.967 1.967a1 1 0 1 1-1.414-1.415l1.967-1.966a2.316 2.316 0 0 1 .13-3.135l.003-.003l3.44-3.372l-1.002-1A1 1 0 0 1 6.346 1.3l2.47 2.47l1.308-1.31l-.654-.654a1 1 0 0 1 0-1.414\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTableLamp1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 3V1.5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1V3a4 4 0 0 0-2 3.5h8a4 4 0 0 0-2-3.5\"/><path d=\"M6.5 1.5H8a4 4 0 0 1 4 4v8m1.5 0h-6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTableLamp1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.625.375A1.625 1.625 0 0 0 2 2v1.156a4.63 4.63 0 0 0-2 3.85a.625.625 0 0 0 .625.619h8a.625.625 0 0 0 .625-.62A4.63 4.63 0 0 0 7.381 3.25h.37A3.25 3.25 0 0 1 11 6.5v5.75H8a.75.75 0 0 0 0 1.5h5.25a.75.75 0 0 0 0-1.5h-.75V6.5a4.75 4.75 0 0 0-4.75-4.75h-.52A1.625 1.625 0 0 0 5.625.375zm-.265 1.36c.07-.07.166-.11.265-.11h2A.375.375 0 0 1 6 2v1.5c0 .223.12.43.313.541a3.38 3.38 0 0 1 1.635 2.334H1.302a3.38 3.38 0 0 1 1.636-2.334a.63.63 0 0 0 .312-.541V2c0-.1.04-.195.11-.265\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTableLamp1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.44.44A1.5 1.5 0 0 1 3.5 0h2a1.5 1.5 0 0 1 1.3.75H8a4.75 4.75 0 0 1 4.75 4.75v7h.5a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5h4v-7A3.25 3.25 0 0 0 8 2.25H7v.472a4.5 4.5 0 0 1 2 3.782a.5.5 0 0 1-.5.496h-8a.5.5 0 0 1-.5-.496a4.5 4.5 0 0 1 2-3.782V1.5c0-.398.158-.78.44-1.06\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTabletCapsule: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.59 1.69a4.045 4.045 0 1 1 5.72 5.72l-4.9 4.9a4.045 4.045 0 1 1-5.72-5.72zm-2.2 2.2l5.72 5.72\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTabletCapsuleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.526 4.745L2.23 7.04a3.344 3.344 0 1 0 4.73 4.729l2.294-2.295zM9.404.002a4.6 4.6 0 0 0-3.248 1.346L1.347 6.156a4.594 4.594 0 1 0 6.497 6.496l4.808-4.808A4.594 4.594 0 0 0 9.404.002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTabletCapsuleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.016 5.219L2.9 7.336A2.662 2.662 0 0 0 6.664 11.1l2.117-2.117zm4.202-5.1a4.66 4.66 0 0 0-3.296 1.366L1.485 5.922a4.662 4.662 0 1 0 6.593 6.593l4.437-4.437A4.662 4.662 0 0 0 9.218.12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTag: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m.719 9.391l3.89 3.89a.75.75 0 0 0 1.06 0l7.72-7.72a.36.36 0 0 0 .11-.29l-.59-3.83a.37.37 0 0 0-.35-.35l-3.83-.59a.36.36 0 0 0-.29.11l-7.72 7.72a.75.75 0 0 0 0 1.06\"/><path d=\"M9.889 4.611a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTagAlt: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9.5 9.45l2.71-2.71a.36.36 0 0 0 .11-.29l-.59-3.84a.37.37 0 0 0-.34-.34l-3.84-.59a.36.36 0 0 0-.29.11L4.55 4.5M3.191 5.859L.75 8.3a.75.75 0 0 0 0 1.06l3.89 3.89a.75.75 0 0 0 1.06 0l2.441-2.441M11.75 2.25L13.47.53\"/><path d=\"M9.243 4.93a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5M13.5 13.5L.5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTagAltRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m4.084 4.968l4.948 4.948h.001l.001.002l3.9 3.899a.625.625 0 1 0 .883-.884l-3.458-3.458l3.344-3.344a1 1 0 0 0 .296-.755V.626A.625.625 0 0 0 13.374 0h-4.75a1 1 0 0 0-.755.296L4.525 3.641L1.067.183a.625.625 0 1 0-.884.884l3.899 3.899h.001zm6.305-2.482a1.125 1.125 0 1 1 0 2.25a1.125 1.125 0 0 1 0-2.25m-7.055 3.23a.625.625 0 0 0-.884 0L.402 7.764a1.375 1.375 0 0 0 0 1.943l3.89 3.89a1.375 1.375 0 0 0 1.944 0l2.025-2.024a.625.625 0 0 0-.884-.884l-2.025 2.024a.125.125 0 0 1-.176 0l-3.89-3.889a.125.125 0 0 1 0-.177L3.334 6.6a.625.625 0 0 0 0-.884\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTagAltSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22L4.7 3.639l2.244-2.244a.86.86 0 0 1 .723-.254l3.577.55L12.64.295a.75.75 0 0 1 1.06 1.061l-1.395 1.395l.55 3.578l.004.035a.86.86 0 0 1-.258.688l-2.244 2.244l3.423 3.424a.75.75 0 1 1-1.06 1.06zm8.17 9.983L2.733 5.606L.437 7.902a1.27 1.27 0 0 0 0 1.766l3.89 3.89a1.25 1.25 0 0 0 1.767 0zm1.103-5.97a.864.864 0 1 1 0-1.727a.864.864 0 0 1 0 1.727\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTagRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.14.476A1.63 1.63 0 0 1 8.29 0h4.085C13.273 0 14 .728 14 1.625v4.086c0 .43-.171.844-.476 1.149l-6.625 6.625a1.625 1.625 0 0 1-2.298 0L.515 9.399a1.625 1.625 0 0 1 0-2.298zm1.15.774c-.1 0-.196.04-.266.11L1.4 7.985a.375.375 0 0 0 0 .53l4.086 4.086a.375.375 0 0 0 .53 0l6.625-6.625c.07-.07.11-.166.11-.265V1.625a.375.375 0 0 0-.375-.375zm3.085 2.5a1.125 1.125 0 1 0-2.25 0a1.125 1.125 0 0 0 2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTagSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.77.003a.86.86 0 0 0-.688.258L.365 7.978a1.25 1.25 0 0 0 0 1.767l3.89 3.89a1.25 1.25 0 0 0 1.768 0l7.716-7.717a.86.86 0 0 0 .254-.723l-.587-3.81a.87.87 0 0 0-.79-.791L8.806.007zM10 5a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTaillessLineArrowShrinkHorizontal2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .375c.345 0 .625.28.625.625v12a.625.625 0 1 1-1.25 0V1c0-.345.28-.625.625-.625m2.692 3.683a.625.625 0 1 0-.884.884L4.866 7L2.808 9.058a.625.625 0 1 0 .884.884l2.5-2.5a.625.625 0 0 0 0-.884zm7.5.884a.625.625 0 1 0-.884-.884l-2.5 2.5a.625.625 0 0 0 0 .884l2.5 2.5a.625.625 0 1 0 .884-.884L9.134 7zM13.625 1a.625.625 0 1 0-1.25 0v12a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTakeOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.81 3.78l1.37-.44a.46.46 0 0 1 .51.17L3.63 5l5.16-2.57a3.24 3.24 0 0 1 4.67 1.65a.88.88 0 0 1-.58 1.1l-3.39 1.1l-.34.11l-.64 2.19a.45.45 0 0 1-.31.32l-1.54.5A.48.48 0 0 1 6 8.86l.32-1.56l-.22.07l-3.31 1.07a.86.86 0 0 1-1.11-.52L.52 4.32a.44.44 0 0 1 .29-.54M13.5 13.5H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTakeOffRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.94 2.636a2.37 2.37 0 0 1 2.43 1.496a.187.187 0 0 1-.127.221l-.008.003l-3.444 1.117a.62.62 0 0 0-.41.43l-.56 1.918l-1.07.348l.23-1.126a.62.62 0 0 0-.032-.373a.624.624 0 0 0-.774-.356L2.92 7.366l-.026.008a.17.17 0 0 1-.216-.097l-.996-3.091l.905-.29l.772 1.222c.17.27.52.369.807.226L8.93 2.97l.038-.02c.297-.174.629-.281.972-.314M5.544 7.832l-2.23.72a1.42 1.42 0 0 1-1.817-.864l-.005-.016L.42 4.348l-.01-.032a1.03 1.03 0 0 1 .683-1.254l.008-.003l1.255-.403l.005-.001a1.05 1.05 0 0 1 1.186.42l.566.898l4.24-2.112a3.617 3.617 0 0 1 5.207 1.89a1.437 1.437 0 0 1-.943 1.795L9.49 6.56l-.496 1.698a1.04 1.04 0 0 1-.702.724L6.9 9.434a1.068 1.068 0 0 1-1.436-1.213zM1 12.25A.875.875 0 0 0 1 14h12a.875.875 0 0 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTakeOffSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.59 1.934a3.49 3.49 0 0 0-2.921.276l-4.95 2.465l-.82-1.298l-.009-.013a.71.71 0 0 0-.787-.263l-.002.001l-1.369.44a.69.69 0 0 0-.455.847l.003.008l1.16 3.6l.002.006a1.11 1.11 0 0 0 1.427.673L5.987 7.67l-.234 1.14a.73.73 0 0 0 .992.826l1.527-.496a.7.7 0 0 0 .477-.492l.602-2.06l.214-.07l3.388-1.099a1.13 1.13 0 0 0 .739-1.426a3.49 3.49 0 0 0-2.103-2.058m1.4 10.054a1 1 0 1 1 0 2H1.006a1 1 0 1 1 0-2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTallHat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.5h13m-9.5 0L2.629 1.615A1 1 0 0 1 3.622.5h6.756a1 1 0 0 1 .993 1.115L10 13.5m-6.46-4h6.92\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTallHatRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.587 1.625a.375.375 0 0 0-.374.406l.57 6.844h6.434l.57-6.844a.375.375 0 0 0-.374-.406zm-1.62.51l.844 10.115H1a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-1.81l.843-10.115a1.625 1.625 0 0 0-1.62-1.76H3.587c-.95 0-1.698.813-1.62 1.76\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTallHatSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.127.167A.5.5 0 0 1 2.5 0h9a.5.5 0 0 1 .497.557l-.96 8.317H2.963L2.003.557a.5.5 0 0 1 .124-.39m.98 9.958l.275 2.375H.774a.75.75 0 0 0 0 1.5h12.452a.75.75 0 0 0 0-1.5h-2.608l.275-2.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTapeCassetteRecord: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 3a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1z\"/><path d=\"M4.5 9.5h5l1 2.5h-7zm-2-3.75c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v0c0 .69-.56 1.25-1.25 1.25h-6.5C3.06 7 2.5 6.44 2.5 5.75\"/><path d=\"M4.833 4.5a1.5 1.5 0 0 1 0 2.5m4.334-2.5a1.5 1.5 0 0 0 0 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTapeCassetteRecordRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625.875C.728.875 0 1.603 0 2.5v8.789c0 .897.728 1.625 1.625 1.625h10.75c.898 0 1.625-.728 1.625-1.625V2.5c0-.897-.727-1.625-1.625-1.625zM1.25 2.5c0-.207.168-.375.375-.375h10.75c.207 0 .375.168.375.375v8.789a.375.375 0 0 1-.375.375h-1.779L9.791 9.65a.5.5 0 0 0-.464-.315H4.423a.5.5 0 0 0-.464.315l-.805 2.013H1.625a.375.375 0 0 1-.375-.375zm2.688 1.563a1.851 1.851 0 1 0 0 3.701h5.875a1.851 1.851 0 1 0 0-3.702zm0 1.25h.593a.844.844 0 0 1 0 1.201h-.593a.601.601 0 0 1 0-1.201m5.03.6c0 .235.096.447.25.601h.595a.601.601 0 0 0 0-1.201h-.594a.84.84 0 0 0-.25.6\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTapeCassetteRecordSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3a1.5 1.5 0 0 1 1.5-1.5h11A1.5 1.5 0 0 1 14 3v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 11zm9.5 6.5h-5L3.9 11h6.2zM2 5.75C2 4.784 2.784 4 3.75 4h6.5a1.75 1.75 0 1 1 0 3.5h-6.5A1.75 1.75 0 0 1 2 5.75M3.75 5a.75.75 0 0 0 0 1.5h.915a.998.998 0 0 0 0-1.5zm4.393 1.5H5.857a2 2 0 0 0 0-1.5h2.286a2 2 0 0 0 0 1.5m1.192 0h.915a.75.75 0 0 0 0-1.5h-.915a.998.998 0 0 0 0 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTarget: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.48 7.516a6.5 6.5 0 1 1-6.93-7\"/><path d=\"M9.79 8.09A3 3 0 1 1 5.9 4.21M7 7l2.5-2.5m2 .5l-2-.5l-.5-2l2-2l.5 2l2 .5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTarget3: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.875 7a6.125 6.125 0 1 1 12.25 0A6.125 6.125 0 0 1 .875 7M7 .875v1.633M13.125 7h-1.633M7 13.125v-1.633M.875 7h1.633m2.888 0h3.208M7 5.396v3.208\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTarget3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.698 6.375H11.66a.625.625 0 1 0 0 1.25h1.037a5.73 5.73 0 0 1-5.073 5.073V11.66a.625.625 0 1 0-1.25 0v1.037a5.73 5.73 0 0 1-5.072-5.073h1.036a.625.625 0 1 0 0-1.25H1.303a5.73 5.73 0 0 1 5.072-5.072v1.036a.625.625 0 0 0 1.25 0V1.303a5.73 5.73 0 0 1 5.073 5.072M13.98 7A6.981 6.981 0 1 1 .02 7a6.981 6.981 0 0 1 13.962 0M4.294 7a.75.75 0 0 1 .75-.75H6.25V5.044a.75.75 0 0 1 1.5 0V6.25h1.206a.75.75 0 1 1 0 1.5H7.75v1.206a.75.75 0 1 1-1.5 0V7.75H5.044a.75.75 0 0 1-.75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTarget3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.323 6.25h-.831a.75.75 0 0 0 0 1.5h.831a5.38 5.38 0 0 1-4.573 4.573v-.831a.75.75 0 0 0-1.5 0v.831A5.38 5.38 0 0 1 1.677 7.75h.831a.75.75 0 1 0 0-1.5h-.831A5.38 5.38 0 0 1 6.25 1.677v.831a.75.75 0 1 0 1.5 0v-.831a5.38 5.38 0 0 1 4.573 4.573M.125 7a6.875 6.875 0 1 1 13.75 0A6.875 6.875 0 0 1 .125 7m4.521 0c0 .414.336.75.75.75h.854v.854a.75.75 0 1 0 1.5 0V7.75h.854a.75.75 0 1 0 0-1.5H7.75v-.854a.75.75 0 0 0-1.5 0v.854h-.854a.75.75 0 0 0-.75.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTargetRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.133.018a.5.5 0 0 1 .352.36l.427 1.71l1.71.427a.5.5 0 0 1 .231.839l-2 2a.5.5 0 0 1-.474.131L9.795 5.09L7.442 7.442a.625.625 0 1 1-.884-.884L8.91 4.205l-.396-1.584a.5.5 0 0 1 .131-.475l2-2a.5.5 0 0 1 .487-.128m-4.53 1.26A.625.625 0 1 0 6.518.03a6.97 6.97 0 1 0 7.432 7.507a.625.625 0 0 0-1.246-.1a5.721 5.721 0 1 1-6.1-6.16m-.095 2.77a.625.625 0 0 1-.354.81a2.304 2.304 0 1 0 2.987 2.98a.625.625 0 0 1 1.165.452a3.555 3.555 0 1 1-4.608-4.596a.625.625 0 0 1 .81.354\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTargetSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.485.379a.5.5 0 0 0-.839-.233l-2 2a.5.5 0 0 0-.131.475l.36 1.444l-.014.014L6.47 6.47a.75.75 0 0 0 1.06 1.06l2.393-2.39l.014-.015l1.443.361a.5.5 0 0 0 .475-.131l2-2a.5.5 0 0 0-.233-.84l-1.709-.426zm-4.168.38a.75.75 0 0 1-.696.8a5.47 5.47 0 1 0 5.831 5.89a.75.75 0 1 1 1.496.119A6.97 6.97 0 1 1 6.517.062a.75.75 0 0 1 .8.696m-.672 3.299a.75.75 0 0 1-.425.972a2.12 2.12 0 1 0 2.75 2.742a.75.75 0 1 1 1.398.544a3.62 3.62 0 1 1-4.694-4.683a.75.75 0 0 1 .971.425\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTaskList: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.719 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707zM6.777 6.375h2.5m-2.5 3.469h2.5\"/><path d=\"m2.91 9.787l.838.838L5.145 8.67M2.91 6.256l.838.838l1.397-1.955\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTaskListRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 1.25c-.103 0-.2.04-.27.108a.35.35 0 0 0-.105.248v10.788c0 .09.037.18.106.247a.38.38 0 0 0 .269.109h9c.103 0 .2-.04.27-.109a.35.35 0 0 0 .105-.247V4.968c0-.1-.04-.197-.112-.268L8.354 1.357a.38.38 0 0 0-.263-.107zM1.355.466C1.661.166 2.073 0 2.5 0h5.591c.426 0 .835.167 1.138.465l3.409 3.343c.311.305.487.724.487 1.16v7.426c0 .43-.174.84-.48 1.14S11.927 14 11.5 14h-9c-.427 0-.84-.166-1.145-.466s-.48-.71-.48-1.14V1.606c0-.43.174-.84.48-1.14m5.829 5.921c0-.345.28-.625.625-.625h2.25a.625.625 0 1 1 0 1.25h-2.25a.625.625 0 0 1-.625-.625m.625 3.022a.625.625 0 0 0 0 1.25h2.25a.625.625 0 1 0 0-1.25zM6.367 8.277a.75.75 0 0 1 .165 1.048l-1.396 1.917a.75.75 0 0 1-1.132.094l-.838-.822a.75.75 0 1 1 1.05-1.07l.218.213l.886-1.215a.75.75 0 0 1 1.047-.165m.165-2.661a.75.75 0 1 0-1.212-.883l-.886 1.215l-.217-.213a.75.75 0 1 0-1.05 1.07l.837.822a.75.75 0 0 0 1.132-.094z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTaskListSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.658.44A1.5 1.5 0 0 1 1.718 0h5.587a1.5 1.5 0 0 1 1.06.44l3.414 3.414a1.5 1.5 0 0 1 .44 1.06V12.5a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-11c0-.398.158-.78.44-1.06ZM5.33 4.527a.75.75 0 0 1 .175 1.047L4.108 7.53a.75.75 0 0 1-1.14.094l-.838-.838a.75.75 0 0 1 1.06-1.06l.212.211l.882-1.234a.75.75 0 0 1 1.046-.175Zm.95 1.847a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m0 3.969a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75m-.775-.738a.75.75 0 1 0-1.22-.872l-.883 1.235l-.212-.212a.75.75 0 0 0-1.06 1.06l.838.838a.75.75 0 0 0 1.14-.094z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTeaCup: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 4h8.5v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V4.5A.5.5 0 0 1 2 4M.5 13.5h13m-3-9.5h1a2 2 0 0 1 0 4h-1M3 .5v1m5-1v1M5.5.5v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTeaCupRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.11 3.863a.625.625 0 0 1-.098-.878a1 1 0 0 0 .165-.267a.2.2 0 0 0 .01-.044V2.66c-.004-.029-.025-.077-.18-.278l-.022-.026c-.122-.156-.348-.445-.407-.824c-.071-.452.1-.882.434-1.298a.625.625 0 0 1 .976.78a1 1 0 0 0-.165.267a.2.2 0 0 0-.01.044v.013c.004.029.025.077.18.278l.022.026c.122.156.348.445.407.824c.071.452-.1.882-.434 1.298a.625.625 0 0 1-.878.098M2.625 6v3c0 .76.616 1.375 1.375 1.375h4c.76 0 1.375-.616 1.375-1.375V6zm-1.25-.125c0-.621.504-1.125 1.125-1.125H11A2.625 2.625 0 0 1 11 10h-.572A2.63 2.63 0 0 1 8 11.625H4A2.625 2.625 0 0 1 1.375 9zm9.25 2.875H11A1.375 1.375 0 1 0 11 6h-.375zM.25 13.25A.75.75 0 0 1 1 12.5h11a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1-.75-.75M7.012 2.985a.625.625 0 0 0 .976.78c.333-.416.505-.846.434-1.298c-.06-.379-.285-.668-.407-.824l-.021-.026c-.156-.2-.177-.25-.181-.278v-.013q-.001-.008.01-.044a1 1 0 0 1 .165-.267a.625.625 0 0 0-.976-.78c-.333.416-.505.846-.434 1.298c.06.379.285.668.407.824l.021.026c.156.2.177.25.181.278v.013q.001.008-.01.044a1 1 0 0 1-.165.267\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTeaCupSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.262.77a.75.75 0 1 0-1.5 0v.73a.75.75 0 1 0 1.5 0zm7.461 6.46v-2.5h.5a1.25 1.25 0 0 1 0 2.5zm0 1.5h.5a2.75 2.75 0 1 0 0-5.5h-9.5a1 1 0 0 0-1 1v4.5a2.5 2.5 0 0 0 2.5 2.5h5a2.5 2.5 0 0 0 2.5-2.5M.777 12.48a.75.75 0 0 0 0 1.5h12.446a.75.75 0 0 0 0-1.5zM8.487.02a.75.75 0 0 1 .75.75v.73a.75.75 0 1 1-1.5 0V.77a.75.75 0 0 1 .75-.75M6.25.77a.75.75 0 0 0-1.5 0v.73a.75.75 0 1 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTelegram: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.75 7a6.25 6.25 0 1 0 12.5 0A6.25 6.25 0 1 0 .75 7\"/><path d=\"m9.742 3.811l-.525 6.822l-2.882-2.958L2.92 6.96z\"/><path d=\"m5.063 7.406l.513 2.962l1.877-1.555M6.332 7.66l1.094-.875\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTelegramRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0m3.24 3.85a.5.5 0 0 0-.707-.493L2.71 6.506a.5.5 0 0 0 .107.943l2.827.592l1.29-1.642a.625.625 0 1 1 .983.772L6.68 8.746l2.18 2.236a.5.5 0 0 0 .856-.31z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTelegramSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.25 7a6.75 6.75 0 1 1 13.5 0A6.75 6.75 0 0 1 .25 7m9.002 4.064l1.045-7.932l-8.165 3.935l2.417.876l2.686-2.076a.5.5 0 1 1 .611.792L5.618 8.38v2.726l1.685-1.604z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTelescope: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.34 4.814L.72 6.134m.88 2.412l3.619-1.319M4.12 4.211l1.318 3.62L13.5 5.575L11.741.75zm1.377 9.039l2.5-6.135l2.5 6.135M.5 5.53l1.319 3.62\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTelescopeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.205.838a.625.625 0 0 0-.803-.43L3.804 2.96a.625.625 0 0 0-.405.754l.13.483l-1.69.453l-.13-.483A.625.625 0 1 0 .5 4.492l1.036 3.864a.625.625 0 0 0 1.207-.324l-.13-.483l1.691-.453l.13.483a.625.625 0 0 0 .727.45l1.675-.338l-2.032 5.028a.75.75 0 0 0 1.39.562L8 8.817l1.805 4.464a.75.75 0 0 0 1.39-.562L8.987 7.257l4.032-.815a.625.625 0 0 0 .48-.774zM5.49 6.688l-.731-2.73l6.41-2.154l.95 3.545z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTelescopeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.169.605a.5.5 0 0 0-.677-.284L3.87 3.782a.5.5 0 0 0-.263.626l.115.315a.6.6 0 0 1 .07.137l.994 2.727q.027.075.034.15l.106.29a.5.5 0 0 0 .605.311l1.271-.355l-1.918 4.708a.75.75 0 0 0 1.389.566l1.682-4.129l1.682 4.129a.75.75 0 0 0 1.39-.566L8.871 7.404l4.72-1.32a.5.5 0 0 0 .336-.653zM3.644 8.089l-.033-.074l-.908-2.493l-1.18.43l-.026-.071a.75.75 0 1 0-1.41.514l.995 2.727a.75.75 0 1 0 1.409-.514l-.032-.087z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTestTube: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5h9M4 3.5h2m-2 3h2m-2 3h2m4-9v10a3 3 0 0 1-6 0V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTestTubeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.75.75A.75.75 0 0 1 2.5 0h9a.75.75 0 0 1 0 1.5h-.875v8.875a3.625 3.625 0 0 1-7.25 0V1.5H2.5a.75.75 0 0 1-.75-.75m2.875 3.375H6a.625.625 0 1 0 0-1.25H4.625V1.5h4.75v8.875a2.375 2.375 0 1 1-4.75 0v-.25H6a.625.625 0 1 0 0-1.25H4.625v-1.75H6a.625.625 0 1 0 0-1.25H4.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTestTubeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.767-.001a.75.75 0 1 0 0 1.5H3.5v1.174H6a.625.625 0 1 1 0 1.25H3.5v1.952H6a.625.625 0 0 1 0 1.25H3.5v1.952H6a.625.625 0 1 1 0 1.25H3.5v.173a3.5 3.5 0 1 0 7 0V1.499h.733a.75.75 0 1 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextFlowRows: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.948.5H4.14v3.192H.948zm0 9.344H4.14v3.192H.948zM9.857.5h3.192v3.192H9.857zm1.136 8.88l2.06 2.06l-2.06 2.06m2.059-2.062H4.14m5.717-9.344h-5.72M10.27 3.71L4.138 9.84\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextFlowRowsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.12 3.625h3.76q.009.115.033.225L3.85 8.913a1.6 1.6 0 0 0-.35-.038H2c-.897 0-1.625.728-1.625 1.625V12c0 .898.728 1.625 1.625 1.625h1.5c.855 0 1.556-.66 1.62-1.5h5.255v1.125a.625.625 0 0 0 1.067.442l2-2a.625.625 0 0 0 0-.884l-2-2a.625.625 0 0 0-1.067.442v1.125H5.12a2 2 0 0 0-.033-.225l5.063-5.063q.17.038.35.038H12c.898 0 1.625-.728 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625h-1.5c-.855 0-1.556.66-1.62 1.5H5.12A1.625 1.625 0 0 0 3.5.375H2C1.103.375.375 1.103.375 2v1.5c0 .897.728 1.625 1.625 1.625h1.5c.855 0 1.556-.66 1.62-1.5m5.38-2a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375H12a.375.375 0 0 0 .375-.375V2A.375.375 0 0 0 12 1.625zm-8.5 8.5a.375.375 0 0 0-.375.375V12c0 .207.168.375.375.375h1.5A.375.375 0 0 0 3.875 12v-1.5a.375.375 0 0 0-.375-.375zM1.625 2c0-.207.168-.375.375-.375h1.5c.207 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextFlowRowsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 0a.5.5 0 0 0-.5.5v3A.5.5 0 0 0 1 4h3a.5.5 0 0 0 .5-.5v-.75h5v.69L3.44 9.5H1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-.75h6v1.25a.5.5 0 0 0 .854.354l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 0 0-.854.354v1.25h-6v-.19L11.06 4H13a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 13 0h-3a.5.5 0 0 0-.5.5v.75h-5V.5A.5.5 0 0 0 4 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5.5h-11a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1\"/><path d=\"M3.846 10.78L6.17 3.808A.875.875 0 0 1 7 3.21v0c.377 0 .711.241.83.598l2.324 6.972M4.687 8.257h4.626\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.375 2C.375 1.103 1.103.375 2 .375h10c.898 0 1.625.728 1.625 1.625v10c0 .898-.727 1.625-1.625 1.625H2A1.625 1.625 0 0 1 .375 12zM2 1.625A.375.375 0 0 0 1.625 2v10c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375V2A.375.375 0 0 0 12 1.625zM8.293 8.75l.495 1.487a.75.75 0 0 0 1.423-.474L9.55 7.778l-.01-.03l-1.17-3.51a1.444 1.444 0 0 0-2.74 0L4.461 7.744l-.012.036l-.66 1.982a.75.75 0 0 0 1.423.474l.495-1.487zm-.5-1.5L7 4.872L6.207 7.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0zm5.27 4.04a.242.242 0 0 1 .46 0l1.195 3.585h-2.85zm1.646-.395a1.492 1.492 0 0 0-2.832 0L4.12 8.04l-.01.027l-.828 2.486a.625.625 0 1 0 1.186.396l.69-2.073h3.683l.691 2.073a.625.625 0 1 0 1.186-.396l-.829-2.486l-.009-.028z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextStyle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13m-2.5 0h5M1.5 3V1.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1V3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextStyleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2c0-.207.168-.375.375-.375h4.375v10.75H4.5a.625.625 0 1 0 0 1.25h5a.625.625 0 1 0 0-1.25H7.625V1.625H12c.207 0 .375.168.375.375v1.5a.625.625 0 1 0 1.25 0V2c0-.897-.727-1.625-1.625-1.625H2C1.103.375.375 1.103.375 2v1.5a.625.625 0 1 0 1.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTextStyleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 1.5c-.11 0-.25.102-.25.292v1.042a.75.75 0 0 1-1.5 0V1.792C.75.832 1.505 0 2.5 0h9c.995 0 1.75.832 1.75 1.792v1.042a.75.75 0 0 1-1.5 0V1.792c0-.19-.14-.292-.25-.292H7.75v11H9.5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5h1.75v-11z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThermometer: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5 9V2A1.5 1.5 0 0 0 7 .5v0A1.5 1.5 0 0 0 5.5 2v7a2.5 2.5 0 1 0 3 0\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThermometerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a.875.875 0 0 0-.875.875v5.651c0 .223-.119.43-.312.541a2.375 2.375 0 1 0 2.374 0a.63.63 0 0 1-.312-.54V2.124A.875.875 0 0 0 7 1.25m-2.125.875a2.125 2.125 0 0 1 4.25 0v5.313a3.625 3.625 0 1 1-4.25 0zm1 8.25a1.125 1.125 0 1 1 2.25 0a1.125 1.125 0 0 1-2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThermometerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75 2.25a2.25 2.25 0 0 1 4.5 0v5.569a3.5 3.5 0 1 1-4.5 0zM7 1.5a.75.75 0 0 0-.75.75v5.945a.75.75 0 0 1-.34.628a2 2 0 1 0 2.18 0a.75.75 0 0 1-.34-.628V2.25A.75.75 0 0 0 7 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatBrowser1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 12.5H1.5a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v6m-13-4h13\"/><path d=\"M13.42 12.61a.62.62 0 0 1-.203.81a.55.55 0 0 1-.287.08H7.06a.55.55 0 0 1-.49-.3a.62.62 0 0 1 0-.59l2.95-5.32a.54.54 0 0 1 1 0zM10 10.5v-1\"/><path d=\"M9.995 12.125a.125.125 0 0 1 0-.25m0 .25a.125.125 0 1 0 0-.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatBrowser1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.01 1.625C.01.728.738 0 1.636 0h9.991c.898 0 1.624.728 1.624 1.625v4.75a.625.625 0 1 1-1.25 0v-2.75H1.26v7c0 .208.169.375.375.375H4.38a.625.625 0 1 1 0 1.25H1.635A1.625 1.625 0 0 1 .01 10.625zm6.128 10.743l2.938-5.299a1.06 1.06 0 0 1 .95-.615c.402 0 .787.25.95.617l2.89 5.301c.176.326.177.734.002 1.06a1.07 1.07 0 0 1-.932.568h-5.87c-.386 0-.756-.225-.933-.567a1.14 1.14 0 0 1 .003-1.06zm3.868-3.852c.345 0 .625.28.625.625v1.25a.625.625 0 0 1-1.25 0v-1.25c0-.345.28-.625.625-.625M10 13.126l.027-.001a.75.75 0 1 0-.027 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatBrowser1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.546 3.315v8.934c0 .113.092.205.205.205h2.245a.75.75 0 0 1 0 1.5H1.751a1.704 1.704 0 0 1-1.705-1.705V1.751C.046.809.81.046 1.751.046h10.498c.942 0 1.705.763 1.705 1.705v4.73a.75.75 0 0 1-1.5 0V3.315zm7.368 3.697a1 1 0 0 1 1.736 0l3.139 5.492A1 1 0 0 1 12.92 14H6.643a1 1 0 0 1-.868-1.496zm.868 6.113a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25m0-4.25c.345 0 .625.28.625.625v1a.625.625 0 0 1-1.25 0v-1c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatDocument: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 11.5H1.5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h6l3 3v1m2.92 8.11a.62.62 0 0 1-.203.81a.55.55 0 0 1-.287.08H7.06a.55.55 0 0 1-.49-.3a.62.62 0 0 1 0-.59l2.95-5.32a.54.54 0 0 1 1 0zM10 10.5v-1\"/><path d=\"M9.995 12.125a.125.125 0 0 1 0-.25m0 .25a.125.125 0 1 0 0-.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatDocumentRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.36 1.36c.07-.07.166-.11.265-.11h6.241L11 4.384v.741a.625.625 0 1 0 1.25 0v-1a.63.63 0 0 0-.183-.442l-3.5-3.5A.63.63 0 0 0 8.125 0h-6.5A1.625 1.625 0 0 0 0 1.625v10.75A1.625 1.625 0 0 0 1.625 14h2.75a.625.625 0 1 0 0-1.25h-2.75a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265m4.778 11.007L9.076 7.07a1.06 1.06 0 0 1 .95-.615c.402 0 .786.25.95.617l2.89 5.301c.175.326.176.734.002 1.06a1.07 1.07 0 0 1-.933.568h-5.87c-.385 0-.755-.225-.932-.567a1.14 1.14 0 0 1 .003-1.06zm3.867-3.85c.345 0 .625.28.625.624v1.25a.625.625 0 0 1-1.25 0v-1.25c0-.345.28-.625.625-.625M10 13.124h.028a.75.75 0 1 0-.027 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatDocumentSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v9A1.5 1.5 0 0 0 1.5 12h3.411l3.134-5.484c.63-1.1 2.042-1.3 2.955-.598V3.5a.5.5 0 0 0-.146-.354l-3-3A.5.5 0 0 0 7.5 0zm7.414 7.012a1 1 0 0 1 1.736 0l3.139 5.492A1 1 0 0 1 12.92 14H6.643a1 1 0 0 1-.868-1.496zm.868 6.113a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25m0-4.25c.345 0 .625.28.625.625v1a.625.625 0 0 1-1.25 0v-1c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatFolder: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 12H1.5a1 1 0 0 1-1-1V1.5a1 1 0 0 1 1-1h3.69a1 1 0 0 1 1 .76l.28 1.24h6a1 1 0 0 1 1 1v4\"/><path d=\"M13.42 12.61a.62.62 0 0 1-.203.81a.55.55 0 0 1-.287.08H7.06a.55.55 0 0 1-.49-.3a.62.62 0 0 1 0-.59l2.95-5.32a.54.54 0 0 1 1 0zM10 10.5v-1\"/><path d=\"M9.995 12.125a.125.125 0 0 1 0-.25m0 .25a.125.125 0 1 0 0-.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatFolderRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 1.625c0-.207.168-.375.375-.375h3.094c.172 0 .322.117.364.284l.31 1.243c.07.278.32.473.607.473h6.375c.207 0 .375.168.375.375v3.75a.625.625 0 1 0 1.25 0v-3.75C14 2.728 13.273 2 12.375 2H6.488l-.192-.77A1.625 1.625 0 0 0 4.719 0H1.625C.728 0 0 .728 0 1.625v8.75C0 11.273.728 12 1.625 12h2.75a.625.625 0 1 0 0-1.25h-2.75a.375.375 0 0 1-.375-.375zm4.888 10.743l2.938-5.299a1.06 1.06 0 0 1 .95-.615c.402 0 .786.25.95.617l2.89 5.301c.175.326.176.734.002 1.06a1.07 1.07 0 0 1-.933.568h-5.87c-.385 0-.755-.225-.932-.567a1.14 1.14 0 0 1 .003-1.06zm3.867-3.852c.345 0 .625.28.625.625v1.25a.625.625 0 0 1-1.25 0v-1.25c0-.345.28-.625.625-.625M10 13.126l.028-.001a.75.75 0 1 0-.027 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineThreatFolderSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.127.305A1.5 1.5 0 0 0 5.183 0H1.5A1.5 1.5 0 0 0 0 1.5V11a1.5 1.5 0 0 0 1.5 1.5h3.205a2 2 0 0 1 .202-.492l3.138-5.493c.768-1.343 2.706-1.343 3.473 0l2.452 4.29V3.5a1.5 1.5 0 0 0-1.5-1.5h-5.6l-.192-.85l-.003-.01a1.5 1.5 0 0 0-.548-.835m2.787 6.707a1 1 0 0 1 1.736 0l3.139 5.492A1 1 0 0 1 12.92 14H6.643a1 1 0 0 1-.868-1.496zm.868 6.113a.625.625 0 1 0 0-1.25a.625.625 0 0 0 0 1.25m0-4.25c.345 0 .625.28.625.625v1a.625.625 0 0 1-1.25 0v-1c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTicket1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.906 10.68a1 1 0 0 0 1 1h10.188a1 1 0 0 0 1-1V8.84a1.907 1.907 0 0 1 0-3.68V3.32a1 1 0 0 0-1-1H1.906a1 1 0 0 0-1 1v1.836a1.907 1.907 0 0 1 0 3.688zM9.11 2.328v1.64m0 2.212v1.64m0 2.22v1.64\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTicket1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.096 1.25c-.048-.002-.073.013-.087.027L1.277 8.009c-.014.014-.03.039-.027.087c.003.05.025.114.082.17l.81.81c.746-.198 1.58.036 2.162.62c.584.583.818 1.416.62 2.163l.81.81a.26.26 0 0 0 .17.08c.048.003.073-.012.087-.026l6.732-6.732c.014-.014.03-.039.027-.087a.27.27 0 0 0-.082-.17l-.815-.815c-.742.192-1.57-.043-2.149-.623c-.58-.58-.815-1.407-.623-2.15l-.815-.814a.26.26 0 0 0-.17-.082m-.97-.857c.583-.584 1.491-.478 2.024.055l1.1 1.1c.196.196.24.496.109.74c-.164.303-.122.773.229 1.124c.35.351.82.393 1.125.23a.625.625 0 0 1 .739.107l1.1 1.1c.533.534.639 1.442.055 2.025l-6.733 6.733c-.583.584-1.491.478-2.024-.055l-1.098-1.098a.625.625 0 0 1-.105-.744c.167-.304.127-.777-.226-1.13c-.354-.354-.827-.394-1.131-.227a.625.625 0 0 1-.744-.105L.448 9.15c-.533-.533-.639-1.44-.055-2.024z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTicket1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.605 1.55h-7.05a1.5 1.5 0 0 0-1.5 1.5v2a.5.5 0 0 0 .374.483a1.517 1.517 0 0 1 0 2.933a.5.5 0 0 0-.373.484v1.999a1.5 1.5 0 0 0 1.5 1.5h7.05v-1.715a.625.625 0 1 1 1.25 0v1.715h2.588a1.5 1.5 0 0 0 1.5-1.5V8.946a.5.5 0 0 0-.369-.483a1.517 1.517 0 0 1 0-2.926a.5.5 0 0 0 .37-.483V3.051a1.5 1.5 0 0 0-1.5-1.5h-2.59v1.723a.625.625 0 0 1-1.25 0zm.625 3.816c.346 0 .625.28.625.625v2.016a.625.625 0 0 1-1.25 0V5.991c0-.345.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTicket2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 2.675c0-.362.253-.55.442-.55h6.543v1.266a.875.875 0 1 0 1.75 0V2.125h2.323c.189 0 .442.188.442.55V4.42c-.908.472-1.5 1.47-1.5 2.58s.592 2.108 1.5 2.58v1.745c0 .362-.253.55-.442.55H9.985v-1.266a.875.875 0 1 0-1.75 0v1.266H1.692c-.189 0-.442-.188-.442-.55V9.589C2.167 9.12 2.767 8.116 2.767 7s-.6-2.12-1.517-2.59zm7.86 10.45H1.692c-.99 0-1.692-.864-1.692-1.8V9.167c0-.278.184-.523.452-.6C1.03 8.4 1.517 7.79 1.517 7S1.03 5.6.452 5.433a.625.625 0 0 1-.452-.6V2.675c0-.936.702-1.8 1.692-1.8h10.616c.99 0 1.692.864 1.692 1.8v2.162c0 .277-.181.52-.446.6c-.574.17-1.054.777-1.054 1.563s.48 1.392 1.054 1.564a.624.624 0 0 1 .446.599v2.162c0 .936-.702 1.8-1.692 1.8zm.875-7.07a.875.875 0 1 0-1.75 0v1.89a.875.875 0 1 0 1.75 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTickets: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.656 2.255l-.39.09a1.19 1.19 0 0 1-.91 1.43a1.22 1.22 0 0 1-1.44-.92l-.78.16a.81.81 0 0 0-.61 1s.36 1.67.78 3.55m10.85-5.32a1.32 1.32 0 1 1-2.44-1l-.81-.38a.89.89 0 0 0-1.16.47l-3.36 7.91l-.44 1a.89.89 0 0 0 .47 1.16l4.06 1.73a.89.89 0 0 0 1.16-.47l3.8-8.94a.89.89 0 0 0-.43-1.13z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTicketsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.947 1.743c.264-.109.561.035.748.251a1.4 1.4 0 0 0 .489.363a1.406 1.406 0 0 0 1.975-1.4c-.022-.274.075-.574.325-.691l.41-.193a.95.95 0 0 1 1.237.5l.483 1.118l-.052.113l-.001.002l-3.19 7.367l-.346.787L.069 3.12a.95.95 0 0 1 .458-1.204zm11.322 2.004c.185-.218.483-.361.747-.253l.443.183a.973.973 0 0 1 .47 1.235l-3.672 8.5a.973.973 0 0 1-1.269.513L4.55 12.034a.973.973 0 0 1-.514-1.268l.481-1.093L7.71 2.3a.973.973 0 0 1 1.268-.514l.434.203c.25.117.347.417.322.692a1.45 1.45 0 0 0 .409 1.143a1.444 1.444 0 0 0 2.127-.077\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTidalWave: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.505 13.341a2.35 2.35 0 0 0 1.498-1.35a2.49 2.49 0 0 0 2.499 1.5A2.49 2.49 0 0 0 7 11.99a2.49 2.49 0 0 0 2.498 1.5a2.49 2.49 0 0 0 2.499-1.5a2.35 2.35 0 0 0 1.499 1.35M.505 9.344a2.38 2.38 0 0 0 1.498-1.35c.418.976 1.5 1.5 2.499 1.5c1.998 0 3.497-1.5 3.497-2.998C8 4.497 7 2.499 4.502 3.498C4.668 2.498 5.7.5 8.499.5s4.497 1.999 4.996 2.998\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTidalWaveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.282 2.655c-.23.372-.4.793-.405 1.2a.62.62 0 0 0 .284.542a.62.62 0 0 0 .584.052c1.12-.445 1.842-.308 2.267-.005c.44.314.737.932.737 1.802c0 .63-.245 1.108-.65 1.44c-.418.343-1.048.564-1.849.564a1.125 1.125 0 0 1-1.125-1.125a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-1.848.862a.625.625 0 0 0-.804.957c.413.347.946.556 1.527.556c.693 0 1.316-.296 1.75-.77c.434.474 1.057.77 1.75.77c1.02 0 1.952-.282 2.642-.847c.701-.576 1.107-1.413 1.107-2.407c0-1.128-.39-2.197-1.261-2.819c-.581-.415-1.303-.58-2.118-.488A4.18 4.18 0 0 1 8.75 1.5c1.549 0 2.549.655 3.172 1.306a4.6 4.6 0 0 1 .826 1.198l.032.074l.006.015v.001a.625.625 0 0 0 1.171-.44l-.586.219l.586-.22l-.001-.002l-.002-.004l-.004-.011l-.014-.035l-.051-.117a5 5 0 0 0-.2-.388a6 6 0 0 0-.86-1.154C12.012 1.094 10.701.25 8.749.25c-1.42 0-2.62.568-3.462 1.27a4.8 4.8 0 0 0-1.005 1.135m-.157 8.095a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-1.848.862a.625.625 0 0 0-1.027.479v1.284c0 .345.28.625.625.625h12.75c.345 0 .625-.28.625-.625v-1.284a.625.625 0 0 0-1.027-.479a1.125 1.125 0 0 1-1.848-.862a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-2.25 0a.625.625 0 1 0-1.25 0a1.125 1.125 0 0 1-2.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTidalWaveSolid: Icon = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M2.224 10.982a.75.75 0 0 1 .694.454c.134.315.365.578.658.754c.546.328 1.53.328 2.077 0a1.63 1.63 0 0 0 .658-.754a.75.75 0 0 1 1.378 0c.135.315.365.578.658.754c.546.328 1.531.328 2.077 0c.293-.176.524-.44.658-.754a.75.75 0 0 1 1.382.008a1.5 1.5 0 0 0 .953.857a.75.75 0 1 1-.428 1.438a3 3 0 0 1-1.217-.707a3.13 3.13 0 0 1-2.386.883A3.13 3.13 0 0 1 7 13.032a3.13 3.13 0 0 1-2.386.883a3.13 3.13 0 0 1-2.386-.883a3 3 0 0 1-1.217.707a.75.75 0 1 1-.428-1.438a1.5 1.5 0 0 0 .953-.857a.75.75 0 0 1 .688-.462\"/><path d=\"M8.5 0C5.39 0 4.202 2.248 4.007 3.418a.5.5 0 0 0 .679.546c.562-.225.998-.264 1.33-.206c.325.057.586.214.8.451c.445.495.684 1.35.684 2.291c0 1.176-1.225 2.5-3 2.5c-.857 0-1.721-.453-2.04-1.197a.5.5 0 0 0-.922.005c-.21.506-.655.907-1.18 1.063A.5.5 0 0 0 0 9.35v1.836q.11-.048.227-.083a.24.24 0 0 0 .155-.14a2 2 0 0 1 3.685-.02a.4.4 0 0 0 .152.175c.002.001.037.02.115.038a1.3 1.3 0 0 0 .56 0a.5.5 0 0 0 .115-.038a.4.4 0 0 0 .153-.174a2 2 0 0 1 3.676 0a.4.4 0 0 0 .153.174c.002.001.037.02.115.038a1.3 1.3 0 0 0 .56 0c.078-.018.113-.037.115-.038a.4.4 0 0 0 .152-.174a2 2 0 0 1 3.685.02a.24.24 0 0 0 .155.14q.117.034.227.082V3.5a.5.5 0 0 0-.053-.224C13.395 2.173 11.553 0 8.5 0m5.365 13.373a.75.75 0 0 0-.448-1.071a1.5 1.5 0 0 1-.953-.858a.75.75 0 0 0-1.382-.008a1.63 1.63 0 0 1-.658.754c-.546.328-1.53.328-2.077 0a1.63 1.63 0 0 1-.658-.754a.75.75 0 0 0-1.378 0a1.63 1.63 0 0 1-.658.754c-.546.328-1.531.328-2.077 0a1.63 1.63 0 0 1-.658-.754a.75.75 0 0 0-1.382.008a1.5 1.5 0 0 1-.953.857a.75.75 0 1 0 .428 1.438a3 3 0 0 0 1.217-.707a3 3 0 0 0 .671.5a3.13 3.13 0 0 0 1.715.384a3.13 3.13 0 0 0 1.715-.385l.095-.055A3 3 0 0 0 7 13.032a3 3 0 0 0 .67.5h.001a3.13 3.13 0 0 0 1.715.384a3.13 3.13 0 0 0 1.714-.385a3 3 0 0 0 .671-.5l.07.064a3 3 0 0 0 1.214.66a.75.75 0 0 0 .81-.383Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTiktok: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.422 9.717V1.141m0 8.58a2.893 2.893 0 1 1-2.893-2.893M8.422 1.14a4.29 4.29 0 0 0 4.288 4.29\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTiktokRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M7.748 10.473V.625m0 9.851a2.896 2.896 0 0 1-2.893 2.899a2.896 2.896 0 0 1-2.892-2.899c0-1.6 1.295-2.898 2.892-2.898m7.181-1.901a4.29 4.29 0 0 1-4.288-4.288\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTiktokSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.422 1.14a1 1 0 0 0-2 0v8.58a1.893 1.893 0 1 1-1.893-1.892a1 1 0 1 0 0-2a3.893 3.893 0 1 0 3.893 3.893V5.283a5.27 5.27 0 0 0 3.288 1.146a1 1 0 1 0 0-2a3.29 3.29 0 0 1-3.288-3.288\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTinder: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.252 7.876c0 3.5-2.625 5.25-5.25 5.25s-5.25-1.75-5.25-5.25c0-2.625 1.312-3.937 2.187-4.375c0 1.313.438 2.188.875 2.625c2.625-.875 3.063-3.5 3.063-5.25c1.75 1.313 4.375 3.5 4.375 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTinderRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M12.395 7.911c0 3.643-2.698 5.465-5.395 5.465c-2.698 0-5.395-1.822-5.395-5.465c0-2.732 1.349-4.099 2.248-4.554c0 1.366.45 2.277.899 2.732C7.449 5.18 7.899 2.446 7.899.624c1.798 1.367 4.496 3.644 4.496 7.287\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTinderSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8.177.476a.5.5 0 0 0-.8.4c0 1.645-.396 3.797-2.406 4.657c-.272-.395-.532-1.063-.532-2.032a.5.5 0 0 0-.723-.447c-1.046.523-2.464 2.01-2.464 4.822c0 1.886.712 3.337 1.808 4.311c1.088.967 2.523 1.44 3.942 1.44s2.854-.473 3.942-1.44c1.096-.974 1.808-2.425 1.808-4.31c0-3.771-2.831-6.093-4.575-7.4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToast: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 4A2.5 2.5 0 0 0 8 1.5H3A2.5 2.5 0 0 0 1.5 6v5.5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6a2.49 2.49 0 0 0 1-2\"/><path d=\"M5 1.5h6A2.5 2.5 0 0 1 12.5 6v5.5a1 1 0 0 1-1 1h-7m8-6.5h-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToastRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.298 1.465a3.13 3.13 0 0 1 1.827-.59h7.75A3.125 3.125 0 0 1 13 6.292V11.5a1.625 1.625 0 0 1-1.625 1.625h-8.75A1.625 1.625 0 0 1 1 11.5V6.291a3.125 3.125 0 0 1 .298-4.826m3.327 10.41h4A.375.375 0 0 0 9 11.5V6c0-.197.093-.383.251-.5A1.87 1.87 0 0 0 10 4a1.875 1.875 0 0 0-1.875-1.875h-5A1.875 1.875 0 0 0 2 5.5c.157.118.25.303.25.5v5.5a.375.375 0 0 0 .375.375zM13.375 4L14 3.999V4z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToastSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M9.5 4.5A2.5 2.5 0 0 0 7 2H2.5A2.5 2.5 0 0 0 1 6.5v5a1 1 0 0 0 1 1h5.5a1 1 0 0 0 1-1v-5a2.49 2.49 0 0 0 1-2\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.696 2.97A4 4 0 0 1 11 4.497a4 4 0 0 1-.531 1.997h2.539A2.49 2.49 0 0 0 14 4.5A2.5 2.5 0 0 0 11.5 2h-1.377c.235.294.428.62.573.97M13 7.743h-3V11.5a2.5 2.5 0 0 1-.209 1H12a1 1 0 0 0 1-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletMan: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4.65A1.886 1.886 0 1 0 7 .88a1.886 1.886 0 0 0 0 3.77\"/><path d=\"M10.3 7.952a3.3 3.3 0 0 0-6.6 0v1.414h1.414l.471 3.772h2.83l.471-3.772h1.415z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletManRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25A1.375 1.375 0 1 0 7 4a1.375 1.375 0 0 0 0-2.75m2.625 1.375a2.62 2.62 0 0 1-.752 1.84A4 4 0 0 1 11 8v1.375c0 .345-.28.625-.625.625H9.302l-.432 3.453a.625.625 0 0 1-.62.547h-2.5a.625.625 0 0 1-.62-.547L4.698 10H3.625A.625.625 0 0 1 3 9.375V8a4 4 0 0 1 2.127-3.535a2.625 2.625 0 1 1 4.498-1.84\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletManSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.03 2.03a2.03 2.03 0 1 1-4.06 0a2.03 2.03 0 0 1 4.06 0m.483 3.873a3.55 3.55 0 0 1 1.04 2.512V9.44a.5.5 0 0 1-.5.5H9.032l-.453 3.623a.5.5 0 0 1-.496.438H5.918a.5.5 0 0 1-.496-.438L4.97 9.939H3.946a.5.5 0 0 1-.5-.5V8.415a3.554 3.554 0 0 1 6.067-2.512\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletManWoman1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 2.25A.875.875 0 1 0 3 4a.875.875 0 0 0 0-1.75m2.125.875c0 .517-.184.99-.491 1.359A3 3 0 0 1 6 7v1.875c0 .345-.28.625-.625.625h-.561l-.317 3.064a.625.625 0 0 1-.622.561h-1.75a.625.625 0 0 1-.622-.56L1.186 9.5H.625A.625.625 0 0 1 0 8.875V7c0-1.054.544-1.981 1.366-2.516a2.125 2.125 0 1 1 3.759-1.359M10.5 4a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75M8.153 5.781c.137-.488.416-.906.785-1.215a2.125 2.125 0 1 1 3.123 0c.37.309.65.727.786 1.215l1.13 4.051a.625.625 0 0 1-.602.793h-1.212l-.295 1.968a.625.625 0 0 1-.618.532h-1.5a.625.625 0 0 1-.618-.532l-.295-1.968H7.625a.625.625 0 0 1-.602-.793zM10.5 5.25c-.532 0-1 .355-1.143.867l-.909 3.258h.927c.31 0 .572.226.618.532l.295 1.968h.424l.295-1.968a.625.625 0 0 1 .618-.532h.927l-.91-3.258A1.186 1.186 0 0 0 10.5 5.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletSignManWoman2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 4.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 2c-2.5 0-2.5 7-2.5 7h5s0-7-2.5-7m-8-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 9c-2.5 0-2.5-7-2.5-7h5s0 7-2.5 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletSignManWoman2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 2.5a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0M11 0a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5M9.114 7.358C9.497 6.642 10.098 6 11 6s1.503.642 1.886 1.358c.389.725.634 1.661.794 2.554c.16.901.24 1.797.28 2.464a24 24 0 0 1 .04 1.04v.083l-.5.001h.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5h.5H8v-.085l.005-.228a24 24 0 0 1 .315-3.275c.16-.893.405-1.829.794-2.554M0 6.5A.5.5 0 0 1 .5 6h5a.5.5 0 0 1 .5.5h-.5h.5v.085l-.005.229a24 24 0 0 1-.035.81c-.04.667-.12 1.563-.28 2.464c-.16.893-.405 1.829-.794 2.554C4.503 13.358 3.902 14 3 14s-1.503-.642-1.886-1.358C.725 11.917.48 10.981.32 10.088C.16 9.187.08 8.29.04 7.623A24 24 0 0 1 0 6.585zh.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletWomen: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.02 4.652a1.886 1.886 0 1 0 0-3.773a1.886 1.886 0 0 0 0 3.773\"/><path d=\"m8.743 10.75l-.43 2.14H5.726l-.431-2.14H3.906a.44.44 0 0 1-.428-.412a.3.3 0 0 1 .007-.09c.485-2.278.626-5.596 3.534-5.596s3.05 3.318 3.534 5.596a.3.3 0 0 1 .008.09a.44.44 0 0 1-.429.412z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletWomenRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.625 2.625a1.375 1.375 0 1 1 2.75 0a1.375 1.375 0 0 1-2.75 0M7 0a2.625 2.625 0 0 0-1.806 4.53c-.672.452-1.138 1.143-1.452 1.868c-.535 1.238-.694 2.705-.732 3.705a1.11 1.11 0 0 0 1.115 1.147h.728l.407 2.237a.625.625 0 0 0 .615.513h2.25c.302 0 .56-.216.615-.513l.407-2.237h.728c.613 0 1.14-.5 1.115-1.147c-.038-1-.197-2.467-.732-3.705c-.314-.725-.78-1.416-1.452-1.868A2.625 2.625 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToiletWomenSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.066 2.066a2.066 2.066 0 1 1-4.132 0a2.066 2.066 0 0 1 4.132 0M8.498 13.6l.39-1.944h1.522c.246 0 .448-.2.47-.456a.3.3 0 0 0-.007-.09a36 36 0 0 1-.206-1.076C10.242 7.686 9.75 4.975 7 4.975s-3.242 2.711-3.667 5.058c-.067.372-.133.735-.206 1.076a.3.3 0 0 0-.007.09a.484.484 0 0 0 .47.456h1.521l.391 1.944a.5.5 0 0 0 .49.401h2.016a.5.5 0 0 0 .49-.401Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTooth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.49 5.132c.324-2.947 2.917-3.231 4.682-2.208c.555.322 1.1.322 1.656 0c1.765-1.023 4.358-.739 4.682 2.208c.325 2.956-1.34 6.084-2.232 7.282c-.203.273-.53.403-.87.403a1.32 1.32 0 0 1-1.242-.873l-.315-.874a.905.905 0 0 0-1.702 0l-.315.874a1.32 1.32 0 0 1-1.242.873c-.34 0-.668-.13-.87-.403c-.892-1.198-2.557-4.326-2.232-7.282\"/><path d=\"M8.291 5.28c-1.06.386-1.63.378-2.582 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToothRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.452 1.198C5.396.548 4.043.278 2.86.71C1.627 1.16.738 2.31.547 4.153c-.185 1.79.197 3.6.73 5.117c.534 1.518 1.236 2.787 1.741 3.51c.351.502.906.72 1.433.72c.877 0 1.628-.584 1.907-1.408l.346-1.02a.313.313 0 0 1 .592 0l.346 1.02c.279.824 1.03 1.408 1.907 1.408c.527 0 1.082-.218 1.433-.72c.505-.723 1.207-1.992 1.74-3.51c.534-1.517.916-3.327.73-5.117c-.19-1.845-1.079-2.994-2.312-3.444C9.957.278 8.604.547 7.548 1.2c-.214.131-.393.178-.548.178s-.334-.047-.548-.179M1.791 4.282c.152-1.475.806-2.146 1.497-2.398c.742-.27 1.695-.123 2.508.378c.373.23.777.365 1.204.365s.83-.135 1.204-.365c.813-.501 1.766-.649 2.508-.378c.691.252 1.345.923 1.497 2.398c.16 1.541-.168 3.158-.666 4.573c-.497 1.414-1.147 2.581-1.586 3.208c-.078.112-.216.187-.408.187c-.301 0-.603-.203-.723-.559l-.346-1.02a1.563 1.563 0 0 0-2.96 0l-.346 1.02c-.12.356-.422.559-.723.559c-.192 0-.33-.075-.408-.187c-.439-.627-1.09-1.794-1.586-3.208c-.498-1.415-.826-3.032-.666-4.573m6.425-.428a.75.75 0 0 1 .514 1.41c-.642.234-1.202.374-1.778.373c-.58-.002-1.114-.147-1.703-.381a.75.75 0 1 1 .555-1.394c.498.198.833.274 1.152.275c.323 0 .693-.076 1.26-.283\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineToothSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.081 2.411c-1.959-1.135-4.835-.82-5.194 2.45c-.36 3.28 1.486 6.751 2.475 8.08c.225.302.589.447.966.447c.617 0 1.169-.387 1.378-.969l.35-.971a1.003 1.003 0 0 1 1.887 0l.35.971c.21.582.762.969 1.38.969c.376 0 .74-.145.964-.447c.99-1.329 2.837-4.8 2.476-8.08c-.359-3.27-3.235-3.585-5.195-2.45c-.615.357-1.22.357-1.837 0m2.37 1.699a.625.625 0 1 1 .429 1.174c-.715.26-1.32.41-1.934.408c-.618-.001-1.19-.155-1.843-.414a.625.625 0 1 1 .462-1.162c.577.23.985.325 1.384.326c.403.001.85-.094 1.503-.332\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrafficCone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 13.5h13M5.3 1.24L2 13.5h10L8.7 1.24A1 1 0 0 0 7.733.5H6.266a1 1 0 0 0-.965.74M4.423 4.5h5.154m-6.5 5h7.846\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrafficConeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.262 1.25a.375.375 0 0 0-.361.276L4.947 5h4.106l-.954-3.474a.375.375 0 0 0-.361-.276zM2.82 12.75l.892-3.25h6.576l.892 3.25zm-1.297 0L4.695 1.195A1.625 1.625 0 0 1 6.262 0h1.476c.731 0 1.373.49 1.567 1.195l3.172 11.555h.898a.625.625 0 1 1 0 1.25H.625a.625.625 0 1 1 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrafficConeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m4.715 3.714l.658-2.443a1 1 0 0 1 .965-.74h1.323a1 1 0 0 1 .966.74l.658 2.443zm-.336 1.25l-.945 3.51h7.132l-.945-3.51zm-1.937 7.192l.655-2.432h7.806l.655 2.432h1.63a.75.75 0 0 1 0 1.5H.812a.75.75 0 1 1 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTransferMotorcycle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M10.499 13.5a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002m-7 0a1.501 1.501 0 1 1 0-3.002a1.501 1.501 0 0 1 0 3.002\"/><path stroke-linejoin=\"round\" d=\"M2 12H.5v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v.5A1.5 1.5 0 0 0 8 12h1m3 0h.5c.552 0 1.012-.452.908-.994C13.077 9.278 11.866 8 10 8h-.5\"/><path stroke-linejoin=\"round\" d=\"M8 3.5h1.5v7.379\"/><path stroke-linejoin=\"round\" d=\"M11.5 4.5h-1a1 1 0 0 0 0 2h1z\"/><path d=\"M1.5 8H4a1 1 0 0 0 1-1V4.5a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1V7a1 1 0 0 0 1 1Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTransferMotorcycleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 .875a.625.625 0 1 0 0 1.25h.875v8.25H8a.875.875 0 0 1-.875-.875V9c0-1.15-.74-2.127-1.77-2.482a1.5 1.5 0 0 0 .145-.643V3.5A1.5 1.5 0 0 0 4 2H1.5A1.5 1.5 0 0 0 0 3.5v2.375A1.5 1.5 0 0 0 .743 7.17A2.62 2.62 0 0 0 0 9v2c0 .345.28.625.625.625h1.163a1.752 1.752 0 0 0 3.422 0h3.578a1.752 1.752 0 0 0 3.422 0h.224c.85 0 1.74-.713 1.54-1.74c-.372-1.896-1.733-3.398-3.849-3.504v-.678q.18.046.375.047h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-1q-.195 0-.375.047V1.5A.625.625 0 0 0 9.5.875zm2.125 6.758v1.905a1.76 1.76 0 0 1 1.892.837h.417a.37.37 0 0 0 .264-.103c.047-.048.059-.095.049-.147c-.276-1.41-1.205-2.392-2.622-2.492m-4.062 2.742a2.1 2.1 0 0 1-.188-.875V9c0-.76-.616-1.375-1.375-1.375H2.625c-.76 0-1.375.616-1.375 1.375v1.375h.731a1.75 1.75 0 0 1 3.036 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTransferMotorcycleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 6.5H1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1m4-4.25a.75.75 0 0 0 0 1.5h.75v6.961a2.501 2.501 0 0 1 4.244 1.958C13.621 12.449 14 11.806 14 11c0-1.927-1.58-3.621-3.75-3.743v-.958c.22.128.477.201.75.201h1a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5h-1c-.273 0-.53.073-.75.2V3a.75.75 0 0 0-.75-.75zm.01 10.5a2.5 2.5 0 0 1 .321-1.5H8.25a.75.75 0 0 1-.75-.75V10a2.75 2.75 0 0 0-2.75-2.75h-2A2.75 2.75 0 0 0 0 10v2c0 .414.336.75.75.75h.26a2.501 2.501 0 1 1 4.977 0zm-6.012-.251a1.501 1.501 0 1 0 3.002 0a1.501 1.501 0 0 0-3.002 0m7 0a1.501 1.501 0 1 0 3.002 0a1.501 1.501 0 0 0-3.002 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTransferTruckTimeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 4a4 4 0 1 1 5.7 3.622A3.9 3.9 0 0 0 9.312 6.41A2.895 2.895 0 0 0 6.5 4.125h-.498zm5.442-1.442a.625.625 0 0 1 0 .884l-1 1a.625.625 0 0 1-.884-.884l1-1a.625.625 0 0 1 .884 0M6.5 5.375A1.625 1.625 0 0 1 8.125 7v.635h.75A2.625 2.625 0 0 1 11.5 10.26v1.25c0 .898-.727 1.625-1.625 1.625h-.496A1.5 1.5 0 0 1 6.605 13H4.883a1.5 1.5 0 0 1-2.778.125h-.48A1.625 1.625 0 0 1 0 11.5V7a1.625 1.625 0 0 1 1.625-1.625zM4.883 12h1.722a1.5 1.5 0 0 1 2.783-.115h.487a.375.375 0 0 0 .375-.375v-1.25a1.375 1.375 0 0 0-1.375-1.375h-.75v.365a.625.625 0 1 1-1.25 0V7a.375.375 0 0 0-.375-.375H1.625A.375.375 0 0 0 1.25 7v4.5c0 .207.168.375.375.375h.48A1.5 1.5 0 0 1 4.883 12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTransferVan: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.159 10.89V4.104a1 1 0 0 0-1-1H1.702a1 1 0 0 0-1 1v6.626a1 1 0 0 0 1 1h.75m10.846-3.893H9.16m2.792 3.706h.345a1 1 0 0 0 1-1v-3L11.904 4.69a1 1 0 0 0-.898-.56H9.339\"/><path d=\"M2.502 11.76a1.396 1.396 0 1 0 2.792 0a1.396 1.396 0 1 0-2.792 0m6.337 0a1.396 1.396 0 1 0 2.792 0a1.396 1.396 0 1 0-2.792 0m-.262-.03H5.64\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTransferVanRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.625 2.25a.375.375 0 0 0-.375.375v7.25c0 .207.168.375.375.375H2q.03 0 .059.003a1.751 1.751 0 0 1 3.024.247h3.333A1.76 1.76 0 0 1 9 9.81V2.626a.375.375 0 0 0-.375-.375zM10 7.625v1.873a1.75 1.75 0 0 1 1.437.752h.938a.375.375 0 0 0 .375-.375v-2.25zM3.499 13c.882 0 1.611-.652 1.733-1.5h3.034a1.752 1.752 0 0 0 3.466 0h.643c.898 0 1.625-.727 1.625-1.625v-2.9a.62.62 0 0 0-.135-.363l-1.141-2.283a1.5 1.5 0 0 0-1.342-.829H10.25v-.875C10.25 1.728 9.522 1 8.625 1h-7C.728 1 0 1.728 0 2.625v7.25c0 .898.728 1.625 1.625 1.625h.14c.123.848.852 1.5 1.734 1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTransferVanSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m13.691 7.212l-1.338-2.74a1.5 1.5 0 0 0-1.348-.842h-.438v3.582zm-4.374-4.06a1.5 1.5 0 0 0-1.158-.548H1.702a1.5 1.5 0 0 0-1.5 1.5v6.626a1.5 1.5 0 0 0 1.5 1.5h.304a1.896 1.896 0 0 0 3.784 0h2.553a1.896 1.896 0 0 0 3.787-.187h.166a1.5 1.5 0 0 0 1.5-1.5V8.462H9.942a.625.625 0 0 1-.625-.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelAirportArrivalTimePlaneAirplaneTripLandTravelTimeAdventureTimerClock: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.18 6.08A4 4 0 1 0 2.52 8M4.5 4.5L6 3m6.3 4.09l-1.06.29a.34.34 0 0 0-.24.32V9l-4.4.52a2.48 2.48 0 0 0-2.31 3a.66.66 0 0 0 .83.47l2.65-.71l.23-.02l1.33 1.15a.39.39 0 0 0 .34.08l1.2-.33a.36.36 0 0 0 .17-.61l-.83-.88l.17-.05l2.59-.7a.67.67 0 0 0 .49-.8l-.76-2.81a.34.34 0 0 0-.4-.22Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelAirportBaggageCheckBaggageTravelAdventureLuggageBagChecked: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9.5\" x=\".5\" y=\"4\" rx=\"2\"/><path d=\"M4 13.5V4m6 9.5V4M4.5 4a2.5 2.5 0 0 1 5 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelAirportDepartureTimeTravelPlaneTripAirplaneTimeOffAdventureTimerTakeClock: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.82 6.08A4 4 0 1 1 13.5 4.5a4 4 0 0 1-1.17 2.83M9.5 4.5L11 3m-.74 6.16l-1-.34a.34.34 0 0 0-.44.18l-.73 1.13l-4-2A2.49 2.49 0 0 0 .53 9.39a.68.68 0 0 0 .45.85l2.61.84l.26.08l.49 1.69a.36.36 0 0 0 .24.25l1.18.38a.37.37 0 0 0 .48-.42L6 11.87l.17.05l2.55.83a.67.67 0 0 0 .85-.41l.9-2.77a.34.34 0 0 0-.21-.41Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelAirportEarthAirplaneTravelPlaneTripAirplaneInternationalAdventureGlobeWorld: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5 8.5a5 5 0 1 1-8.25-3.8\"/><path d=\"M5.28 6.65a1.6 1.6 0 0 0-.16.7a1.52 1.52 0 0 0 1.53 1.53a.77.77 0 0 1 .77.77v3.47M.57 9.27h1.85A1.54 1.54 0 0 1 4 10.81v2.45m9.26-11.39l-1-.34a.34.34 0 0 0-.39.13l-.73 1.13l-4-2A2.49 2.49 0 0 0 3.53 2.1A.68.68 0 0 0 4 3l2.61.84l.26.09l.49 1.68a.36.36 0 0 0 .24.25l1.18.38a.37.37 0 0 0 .48-.41L9 4.58h.17l2.55.83a.67.67 0 0 0 .85-.41l.9-2.77a.34.34 0 0 0-.21-.36Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelAirportLandingLandPlaneTravelAdventureAirplane: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3 1.93l1.38.54a.46.46 0 0 1 .3.47l-.18 1.8l5.84 1.35A3.37 3.37 0 0 1 13 10.5a.91.91 0 0 1-1.19.5L8.36 9.65L8 9.52l-2 1.34a.52.52 0 0 1-.47.05L4 10.3a.5.5 0 0 1-.14-.85l1.28-1.06l-.23-.09L1.54 7A.9.9 0 0 1 1 5.83l1.44-3.66A.44.44 0 0 1 3 1.93ZM.5 13.5h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelAirportPassportTravelBookIdAdventureVisa: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"13\" x=\"1.5\" y=\".5\" rx=\"1\"/><circle cx=\"7\" cy=\"6\" r=\"3\"/><path d=\"M4 6h6M7 9V3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelAirportTakeOffTravelPlaneAdventureAirplaneTakeOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.19 3.78l-1.37-.44a.46.46 0 0 0-.51.17L10.37 5L5.21 2.43A3.24 3.24 0 0 0 .54 4.08a.88.88 0 0 0 .58 1.1l3.39 1.1l.34.11l.64 2.19a.45.45 0 0 0 .31.32l1.54.5A.48.48 0 0 0 8 8.86L7.68 7.3l.22.07l3.31 1.07a.86.86 0 0 0 1.11-.52l1.16-3.6a.44.44 0 0 0-.29-.54ZM.5 13.5h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelAirConditionerHeatingAcAirHvacCoolCoolingColdHotConditioning: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"7\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M11 7.5v-2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2m0 3l-.5 3m4.5-3v3m4-3l.5 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelBathTubBatheBathBathroomTowelWaterTub: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.5 4.5h-5a1 1 0 0 0-1 1v1a4 4 0 0 0 4 4h5a4 4 0 0 0 4-4v-1a1 1 0 0 0-1-1h-2\"/><path d=\"M6.5 3.5h4v4h-4z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelBed1BedSingleBedroomsBedroomHotel: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"13\" x=\"1.5\" y=\".5\" rx=\"1\"/><path d=\"M9.5.5v3h-5v-3M1.5 6h11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelBed2BedDoubleBedroomBedroomsQueenKingFullHotel: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><path d=\"M7 3.5H3v-3m8 0v3H7v-3M.5 6h13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelBellServiceConciergePorterCallRingBellhopBellReception: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 10.25a6.5 6.5 0 0 1 13 0Zm0 2.5h13m-6.5-9v-2.5m-1.5 0h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelDumbellSportsWeightsDumbbellSportFitness: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"4\" height=\"6\" x=\".5\" y=\"4\" rx=\"1\"/><rect width=\"4\" height=\"6\" x=\"9.5\" y=\"4\" rx=\"1\"/><path d=\"M4.5 7h5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelHangerHangerLockerCheckCoatRoomCloak: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 3a2 2 0 1 0-2 2v1m0 0l-6 4.6a1.32 1.32 0 0 0-.5 1.06A1.34 1.34 0 0 0 1.84 13h10.32a1.34 1.34 0 0 0 1.34-1.34a1.32 1.32 0 0 0-.5-1.06Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelIronLaundryIronHeat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.59 5.5H8.91a8.78 8.78 0 0 0-8.32 6h11.82a1 1 0 0 0 .76-.35a1 1 0 0 0 .23-.81Zm0 0l-.22-1.33a2 2 0 0 0-2-1.67H4.59\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelLaundryBasketBathroomLaundryBinBasket: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 1v9a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V1M.5 1h13m-12 3h3m-3 3h3m-3 3h3m5-6h3m-3 3h3m-3 3h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelLaundryLaundryMachine: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"1\"/><circle cx=\"7\" cy=\"8\" r=\"3.5\"/><path d=\"M.5 3.5h3m7 0h3M7 7.97v3.5M4 6.2l3 1.77m3-1.77L7 7.97\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelOneStarOneStarReviewsReviewRatingHotelStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 1.05a1.18 1.18 0 0 1 2 0l1.94 3.07l2.53.31a1.16 1.16 0 0 1 .75 1.91l-2.11 2.42l.68 3.35a1.17 1.17 0 0 1-.46 1.17a1.19 1.19 0 0 1-1.26.07L7 11.67l-3.07 1.68a1.19 1.19 0 0 1-1.26-.07a1.17 1.17 0 0 1-.46-1.17l.68-3.35L.78 6.34a1.16 1.16 0 0 1 .75-1.91l2.53-.31Z\"/><path d=\"M7 9.52v-4H6m-.5 4h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelParkingSignDiscountCouponParkingPricePrices: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"13\" x=\".5\" y=\".5\" rx=\"3\"/><path d=\"M5.5 3.5v7m0-3h2a2 2 0 0 0 0-4h-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelPetPawPawFootAnimalsPetsFootprintTrack: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"1.5\" cy=\"8\" rx=\"1\" ry=\"1.5\"/><ellipse cx=\"4.5\" cy=\"3.5\" rx=\"1\" ry=\"1.5\"/><ellipse cx=\"9.5\" cy=\"3.5\" rx=\"1\" ry=\"1.5\"/><ellipse cx=\"12.5\" cy=\"8\" rx=\"1\" ry=\"1.5\"/><path d=\"M10 10c0 1.38-1.62 2-3 2s-3-.62-3-2s1-3.5 3-3.5s3 2.12 3 3.5Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelPoolLadder2PoolStairsSwimSwimmingWaterLadder: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5H13a2 2 0 0 1-2-2a2 2 0 0 1-4 0a2 2 0 0 1-4 0a2 2 0 0 1-2 2H.5m2-11a2 2 0 0 1 4 0v7m3-9a2 2 0 0 1 2 2v7m-5-5h5m-5 3h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelServingDomeCookToolDomeKitchenDrinkServingPlatterDishToolsFoodCooking: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 9.75v-.5a5.5 5.5 0 0 0-11 0v.5m12 0H.5l.32 1.07a2 2 0 0 0 1.92 1.43h8.52a2 2 0 0 0 1.92-1.43Zm-6.5-6v-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelServingDomeHandPorterServiceRoomPlateHandBellhopPlatterGiveFood: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 5.5a5 5 0 0 1 10 0m-11 0h12m-13 3H4A2.5 2.5 0 0 1 6.5 11h0m-3 0h5a2 2 0 0 1 2 2h0a.5.5 0 0 1-.5.5H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelShowerHeadBatheBathBathroomShowerWaterHead: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 6.5a4 4 0 0 1 8 0Zm2 3v1m-1.5 2v1m3.5-1v1m3.5-1v1M9 9.5v1m-2-8v-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelSpaSpaFlowerLotusLily: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 10.5c0 1.66-2.91 3-6.5 3s-6.5-1.34-6.5-3m9-5C9.5 6.88 7.5 9 7 9S4.5 6.88 4.5 5.5c0-2 2.5-5 2.5-5s2.5 3 2.5 5Z\"/><path d=\"M4.88 3.89A15.7 15.7 0 0 0 1 3s.35 3.89 1.77 5.3c1 1 3.89 1.06 4.24.71\"/><path d=\"M9.12 3.89A15.7 15.7 0 0 1 13 3s-.35 3.89-1.77 5.3c-1 1-3.89 1.06-4.24.71\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelThreeStarThreeStarsReviewsReviewRatingHotelStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 1.05a1.18 1.18 0 0 1 2 0l1.94 3.07l2.53.31a1.16 1.16 0 0 1 .75 1.91l-2.11 2.42l.68 3.35a1.17 1.17 0 0 1-.46 1.17a1.19 1.19 0 0 1-1.26.07L7 11.67l-3.07 1.68a1.19 1.19 0 0 1-1.26-.07a1.17 1.17 0 0 1-.46-1.17l.68-3.35L.78 6.34a1.16 1.16 0 0 1 .75-1.91l2.53-.31Z\"/><path d=\"M5.5 5.52h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2m3-2h-3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelTowelTowelSpaWetWaterHot: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 10a3 3 0 0 0-3-3h-9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h9a3 3 0 0 0 3-3Zm-13 0h9m-6-3a3 3 0 0 1 0-6h9a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1.86m2.86-3h-9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelHotelTwoStarTwoStarsReviewsReviewRatingHotelStar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 1.05a1.18 1.18 0 0 1 2 0l1.94 3.07l2.53.31a1.16 1.16 0 0 1 .75 1.91l-2.11 2.42l.68 3.35a1.17 1.17 0 0 1-.46 1.17a1.19 1.19 0 0 1-1.26.07L7 11.67l-3.07 1.68a1.19 1.19 0 0 1-1.26-.07a1.17 1.17 0 0 1-.46-1.17l.68-3.35L.78 6.34a1.16 1.16 0 0 1 .75-1.91l2.53-.31Z\"/><path d=\"M5.5 5.52h2a1 1 0 0 1 0 2h-1a1 1 0 0 0-1 1v1h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapEarth1PlanetEarthGlobeWorld: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M1 9.5h1.75A1.75 1.75 0 0 0 4.5 7.75v-1.5A1.75 1.75 0 0 1 6.25 4.5A1.75 1.75 0 0 0 8 2.75V.57m5.5 6.33a3.56 3.56 0 0 0-1.62-.4H9.75a1.75 1.75 0 0 0 0 3.5A1.25 1.25 0 0 1 11 11.25v.87\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapEarth2PlanetEarthGlobeWorld: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"M12.48 3.5h-4a2 2 0 0 0 0 4a1 1 0 0 1 1 1V13M.58 8H3a2 2 0 0 1 2 2v3.19\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapFlagNavigationMapMapsFlagGpsLocationDestinationGoal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5v13m9-6h-9v-7h9L8.5 4l3 3.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapGlobeModelPlanetEarthGlobeWorld: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6.16\" cy=\"5.75\" r=\"3\"/><path d=\"M6.16 11v2.5m-1.5 0h3M6.16.5a5.25 5.25 0 1 1-3.57 9.1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapLocationCompass1ArrowCompassLocationGpsMapMapsPoint: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><path d=\"m7.5 10.5l2-6l-6 2L6 8l1.5 2.5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapLocationPinNavigationMapMapsPinGpsLocation: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 5c0 2.49-4.5 8.5-4.5 8.5S2.5 7.49 2.5 5a4.5 4.5 0 0 1 9 0Z\"/><circle cx=\"7\" cy=\"5\" r=\"1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapLocationTarget1NavigationLocationMapServicesMapsGpsTarget: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"4.5\"/><circle cx=\"7\" cy=\"7\" r=\".5\"/><path d=\"M7 2.5v-2m0 13v-2M11.5 7h2M.5 7h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapLocationTarget2NavigationLocationMapServicesMapsGpsTarget: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"7\" r=\"4.5\"/><path d=\"M7 2.5v-2m0 13v-2M11.5 7h2M.5 7h2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapLocationTargetOffTargetLocationMapOffServicesNavigationMapsGps: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 2.4V.5m0 13v-2M11.6 7h1.9m-12-5.5l11 11M.5 7h2m1.3-3.2c1.7-1.8 4.6-1.9 6.4-.2s1.9 4.5.2 6.4c-.1.1-.1.2-.2.2M8 11.4c-2.4.5-4.8-1-5.4-3.4c-.1-.3-.1-.7-.1-1c0-.5.1-1 .2-1.4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapNavigationArrowCompassArrowMapBearingNavigationMapsHeadingGps: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m8.5 13.5l5-13l-13 5l6 2l2 6z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapNavigationArrowOffCompassArrowMapBearingNavigationMapsHeadingGpsOffDisable: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.28 3.28L.5 5.5l6 2l2 6l2.22-5.78m1.08-2.8L13.5.5L8.91 2.27M3.5.5l10 10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapNavigationMapMapsGps: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4.83 12.5l-4.33 1v-12l4.33-1v12zm0 0l4.34 1v-12L4.83.5v12zm8.67 0l-4.33 1v-12l4.33-1v12z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapRectangleFlagNavigationMapMapsFlagGpsLocationDestinationGoal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5v13m0-13h9v7h-9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesAnchorAnchorMarinaHarborPort: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 8H1.5a5.5 5.5 0 0 0 11 0H11\"/><circle cx=\"7\" cy=\"2\" r=\"1.5\"/><path d=\"M7 3.5v10m-1.5-7h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesCartCartTravelLocalBuckboardRetro: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.59 10H4V3a1 1 0 0 1 1-1h4.5a4 4 0 0 1 4 4v3a1 1 0 0 1-1 1h-2.09M4 10H.5V8\"/><circle cx=\"9\" cy=\"10.5\" r=\"1.5\"/><path d=\"M7.5 5h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesColumn1PillarBuildingHistoricalColumn: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 13.25v-7.5m2.5 7.5v-5.5m3 5.5v-5.5m2.5 5.5v-7.5m0-5H3a2.5 2.5 0 1 0 2.29 3.5h3.42A2.5 2.5 0 1 0 11 .75Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesColumn2PillarBuildingHistoricalColumn: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2.75\" cy=\"2.75\" r=\"2.25\"/><circle cx=\"11.25\" cy=\"2.75\" r=\"2.25\"/><path d=\"M3 .5h8m-6.84 4h5.68M3 13.5V4.99m2.5 8.51v-6m3 6v-6m2.5 6V4.99\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesDiamondDiamondMoneyPaymentFinanceWealth: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.89.93a1 1 0 0 0-.82-.43H3.93a1 1 0 0 0-.82.43l-1.6 2.31a1 1 0 0 0 .15 1.28l4.67 4.72a1 1 0 0 0 1.34 0l4.67-4.72a1 1 0 0 0 .15-1.28Z\"/><path d=\"M7 .5L4.68 3.94l2.18 5.55M7 .5l2.32 3.44l-2.18 5.55M1.35 3.94h11.3M13 13.5h0a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2h0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesMountainSunLandmarkMountainPlace: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m13.5 9.26l-3.79-5a1 1 0 0 0-1.42 0L.5 13.5h13\"/><path d=\"m4.69 8.5l1.47 1a1 1 0 0 0 1.16 0l.89-.67a1 1 0 0 1 1.2 0l.89.67a1 1 0 0 0 1.15 0l1.48-1\"/><circle cx=\"3\" cy=\"3\" r=\"2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesPaintingPaintingEntertainmentDisplayMuseumEventHobbyExhibit: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"13\" height=\"9\" x=\".5\" y=\"4.24\" rx=\".5\"/><circle cx=\"4.25\" cy=\"7.99\" r=\"1.25\"/><path d=\"m3.75 13.24l4.7-4a1.32 1.32 0 0 1 1.87.15l3.07 3.68M3.5 4.24L6.25 1.1a1 1 0 0 1 1.5 0l2.75 3.14\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesSnorkleDivingScubaOutdoorRecreationOceanMaskWaterSeaSnorkle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 10.5a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3V.5\"/><path d=\"M10.5 5.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1l1.17-1.75a1 1 0 0 1 1.66 0L7.5 9.5h1a2 2 0 0 0 2-2Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesStreetSignCrossroadStreetSignMetaphorDirections: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 4.5H2.5l-2-2l2-2H7m0 7h4.5l2-2l-2-2H7m0 7H2.5l-2-2l2-2H7m0-6v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesTheaterMaskHobbyTheaterMasksDramaEventShowEntertainment: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.77 8.5A5.91 5.91 0 0 1 .5 4.84V1.58a9.65 9.65 0 0 1 8.87 0\"/><path d=\"M7.79 13.44h0a2.27 2.27 0 0 1-2-.51h0a6.66 6.66 0 0 1-2.11-6.67l.73-2.92a9.88 9.88 0 0 1 9.09 2.28l-.73 2.91a6.67 6.67 0 0 1-4.98 4.91Z\"/><path d=\"M5.61 6.51a1 1 0 0 1 1-.27a1 1 0 0 1 .73.69m2.23.57a1 1 0 0 1 1.7.43\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesTrafficSignStreetSignTrafficTravel: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"4\" r=\"3.5\"/><path d=\"M7 7.5v6m-1.5 0h3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelTransportationAirplaneTravelPlaneAdventureAirplane: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.75 2.75h-1.61a.49.49 0 0 0-.48.38l-.51 2l-5-1a3.69 3.69 0 0 0-4.4 3.59a1 1 0 0 0 1 1h4.4l1 1.58a2 2 0 0 0 1.68.92h1.1a.5.5 0 0 0 .44-.73l-.88-1.74h2.76a1 1 0 0 0 1-1v-4.5a.5.5 0 0 0-.5-.5Z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelTransportationBusTransportationTravelBusTransitTransportMotorcoachPublic: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"11\" height=\"11.5\" x=\"1.5\" y=\".5\" rx=\"1\"/><path d=\"M3.5 12v1.5m7-1.5v1.5M1.5 7h11\"/><circle cx=\"4\" cy=\"9.5\" r=\".5\"/><circle cx=\"10\" cy=\"9.5\" r=\".5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelTransportationCarTransportationTravelTaxiTransportCab: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 10.5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H11l-.77-2.32a1 1 0 0 0-1-.68H5.22a1 1 0 0 0-1 .68L3.5 6.5h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1\"/><circle cx=\"3.5\" cy=\"10.5\" r=\"2\"/><circle cx=\"10.5\" cy=\"10.5\" r=\"2\"/><path d=\"M5.5 10.5h3M7 3.5v-2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelTransportationSailShipTravelBoatTransportationTransportOceanShipSeaWater: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 9.5H.5l1 2.7a2 2 0 0 0 1.88 1.3h7.22a2 2 0 0 0 1.88-1.3Zm-7 0v-9m0 0l-5 6h5m2-4l3.5 4H8.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWafinderSinkWashCleanToiletBathroomWater: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 8.5h13v2a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3v-2h0Zm7-6a2 2 0 0 0-4 0v6m4-4v1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderDisabilityPersonAccessWheelchairAccomodationHumanDisabilityDisabledUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"8\" cy=\"2.5\" r=\"2\"/><path d=\"M8 4.5v4h3a1 1 0 0 1 1 1v4m-6.5-7a3.5 3.5 0 1 0 3.22 4.88\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderFireExitSignArrowPointDirectionSignal: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 2.53a.34.34 0 0 0-.34 0a.22.22 0 0 0 0 .29c1 1.74 1.26 4.21-.17 5.56A4.69 4.69 0 0 1 2.2 6.73a3.3 3.3 0 0 0-1.7 3a4 4 0 0 0 4.25 3.77A3.88 3.88 0 0 0 9 9.69C9.11 7.16 7.33 4 4 2.53Z\"/><path d=\"M6.87 9.69a1.69 1.69 0 0 1-1.7 1.69M11.5.5l2 2l-2 2m2-2H9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderLifebuoyWaterLifeRingWheelyLifebeltKisbee: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 1.5L9.09 4.91M1.5 1.5l3.41 3.41M1.5 12.5l3.41-3.41m7.59 3.41L9.09 9.09\"/><circle cx=\"7\" cy=\"7\" r=\"6.5\"/><circle cx=\"7\" cy=\"7\" r=\"2.95\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderLiftArrowUpHumanDownPersonUserLiftElevator: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"2.5\" cy=\"2.5\" r=\"2\"/><path d=\"M1.5 6.5h2a1 1 0 0 1 1 1v3h0h-4h0v-3a1 1 0 0 1 1-1Zm-1 4v3m4-3v3m4-8L11 3l2.5 2.5m-5 4L11 12l2.5-2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderManArmRaises1ManRaiseArmScaningDetectPostureSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"2.5\" r=\"2\"/><path d=\"M2.5 6.5h9m-3 0v4h-3v-4m0 4v3m3-3v3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderManArmRaises2ManRaiseArmScaningDetectPostureSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"2.5\" r=\"2\"/><path d=\"M2.5 5a7.5 7.5 0 0 0 9 0\"/><path d=\"M8.5 6.33v4.17h-3V6.33m0 4.17v3m3-3v3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderManSymbolGeometricGenderBoyPersonMaleHumanUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"4.5\" cy=\"9.5\" r=\"4\"/><path d=\"M9 .5h4.5V5M7.33 6.67L13.5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderStairs1StairsStaircaseRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5H9V5H5v4H.5v4.5h13V.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderStairs2StairsStaircaseLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5.5H5V5h4v4h4.5v4.5H.5V.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderToiletSignManToiletSignRestroomBathroomUserHumanPersonManMale: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"2.5\" r=\"2\"/><path d=\"M7 13.5c-3 0-3-7-3-7h6s0 7-3 7Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderToiletSignManWomanToiletSignRestroomBathroomUserHumanPerson: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"11\" cy=\"2.5\" r=\"2\"/><path d=\"M11 6.5c-2.5 0-2.5 7-2.5 7h5s0-7-2.5-7Z\"/><circle cx=\"3\" cy=\"2.5\" r=\"2\"/><path d=\"M3 13.5c-2.5 0-2.5-7-2.5-7h5s0 7-2.5 7Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderToiltetSignWomanToiletSignRestroomBathroomUserHumanPersonWomanFemale: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"2.5\" r=\"2\"/><path d=\"M7 6.5c-3 0-3 7-3 7h6s0-7-3-7Z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderWomanSymbolGeometricGenderFemalePersonHumanUser: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"7\" cy=\"4\" r=\"3.5\"/><path d=\"M7 7.5v6M5 11h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTree2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.5 6.5L7 8v5.5M7 8l1.5-1.5\"/><path d=\"M7 11.5a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTree2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.625 5.625a4.375 4.375 0 1 1 8.75 0a4.375 4.375 0 0 1-8.75 0M7 0a5.625 5.625 0 0 0-.875 11.182v1.943a.875.875 0 0 0 1.75 0v-1.943A5.626 5.626 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTree2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.501 5.499A5.499 5.499 0 1 1 8 10.907V13a1 1 0 1 1-2 0v-2.094a5.5 5.5 0 0 1-4.499-5.408\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTree3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.24 1.359a3.5 3.5 0 0 1 1.18 2.127h.08a3 3 0 0 1 0 6h-7a3 3 0 1 1 0-6A3.5 3.5 0 0 1 9.24 1.36\"/><path d=\"m5.42 6.486l1.5 1.5v5.5m0-5.5l1.5-1.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTree3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.138 3.85a2.875 2.875 0 0 1 5.724 0a.63.63 0 0 0 .417.53A2.376 2.376 0 0 1 9.5 9h-5a2.375 2.375 0 0 1-.78-4.62a.63.63 0 0 0 .418-.53M7 0a4.126 4.126 0 0 0-4.052 3.348A3.625 3.625 0 0 0 4.5 10.25h1.625v2.875a.875.875 0 1 0 1.75 0V10.25H9.5a3.625 3.625 0 0 0 1.552-6.902A4.126 4.126 0 0 0 7 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTree3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.96.02a4 4 0 0 0-3.872 2.996a3.5 3.5 0 0 0 .41 6.976H5.92v2.988a1 1 0 1 0 2 0V9.992h2.583a3.5 3.5 0 0 0 .327-6.984A4 4 0 0 0 6.96.02\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrendingContent: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.15.555a.39.39 0 0 0-.399 0a.26.26 0 0 0-.06.34c1.227 2.123 1.486 5.016-.19 6.611a5.5 5.5 0 0 1-1.495-1.994a3.88 3.88 0 0 0-1.995 3.49a4.69 4.69 0 0 0 4.987 4.488c3.211 0 4.877-1.994 4.986-4.488C12.114 6.01 9.99 2.33 6.15.555\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrendingContentRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.454.141a1.01 1.01 0 0 1 .998-.02c3.95 1.838 6.2 5.656 6.062 8.87v.005c-.061 1.352-.547 2.611-1.493 3.534c-.949.924-2.305 1.458-4.005 1.461A5.223 5.223 0 0 1 1.482 8.99v-.01a4.43 4.43 0 0 1 2.277-3.986a.625.625 0 0 1 .876.294c.21.479.498.918.85 1.302c.399-.585.587-1.322.58-2.137c-.007-1.044-.335-2.167-.887-3.125A.88.88 0 0 1 5.454.141M6.738 1.68c3.027 1.76 4.63 4.82 4.527 7.253v.005c-.048 1.091-.434 2.032-1.117 2.698c-.384.374-.88.679-1.5.873a2 2 0 1 0-3.292.009a3.97 3.97 0 0 1-2.625-3.574a3.18 3.18 0 0 1 1.104-2.486c.34.57.775 1.081 1.285 1.511a.62.62 0 0 0 .845-.022c.976-.933 1.36-2.217 1.35-3.503a7.5 7.5 0 0 0-.577-2.764\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrendingContentSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.495.126A.89.89 0 0 1 6.379.11c3.987 1.852 6.244 5.698 6.105 8.914c-.06 1.351-.543 2.602-1.48 3.515c-.938.914-2.285 1.448-3.99 1.451a5.186 5.186 0 0 1-5.502-4.967v-.008a4.38 4.38 0 0 1 2.251-3.94a.5.5 0 0 1 .7.235A5 5 0 0 0 5.47 6.796c.494-.645.722-1.478.715-2.394c-.008-1.09-.35-2.259-.924-3.254A.76.76 0 0 1 5.495.126\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowCurvyUpDown2Remix: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.22 2.72A.75.75 0 0 0 .75 4H2.5v7.375a2.625 2.625 0 1 0 5.25 0v-8.75a1.125 1.125 0 0 1 2.25 0V13.25a.75.75 0 0 0 1.28.53l2.5-2.5a.75.75 0 0 0-.53-1.28H11.5V2.625a2.625 2.625 0 1 0-5.25 0v8.75a1.125 1.125 0 0 1-2.25 0V.75A.75.75 0 0 0 2.72.22z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowExpandRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .5h4a.5.5 0 0 1 .354.854l-1.47 1.47L6.03 4.97a.75.75 0 0 1-1.06 1.06L2.823 3.884l-1.47 1.47A.5.5 0 0 1 .5 5V1A.5.5 0 0 1 1 .5m10.177 3.384L9.03 6.03a.75.75 0 0 1-1.06-1.06l2.146-2.147l-1.47-1.47A.5.5 0 0 1 9 .5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.854.354zM6.03 9.03a.75.75 0 0 0-1.06-1.06l-2.147 2.146l-1.47-1.47A.5.5 0 0 0 .5 9v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .354-.854l-1.47-1.47zm3-1.06a.75.75 0 0 0-1.06 1.06l2.146 2.147l-1.47 1.47A.5.5 0 0 0 9 13.5h4a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.854-.354l-1.47 1.47z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowReloadHorizontal1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m9.354 5.854l2.5-2.5a.5.5 0 0 0 0-.708l-2.5-2.5A.5.5 0 0 0 8.5.5v1.75H1.75A1.75 1.75 0 0 0 0 4v2.5a.75.75 0 0 0 1.5 0V4a.25.25 0 0 1 .25-.25H8.5V5.5a.5.5 0 0 0 .854.354M5.19 8.038a.5.5 0 0 1 .31.462v1.75h6.75a.25.25 0 0 0 .25-.25V7.5a.75.75 0 0 1 1.5 0V10a1.75 1.75 0 0 1-1.75 1.75H5.5v1.75a.5.5 0 0 1-.854.354l-2.5-2.5a.5.5 0 0 1 0-.707l2.5-2.5a.5.5 0 0 1 .545-.109\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowReloadHorizontal2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m5.604 5.354l2-2a.5.5 0 0 0 0-.708l-2-2A.5.5 0 0 0 4.75 1v1.25h-2A2.75 2.75 0 0 0 0 5v4a2.75 2.75 0 0 0 2.75 2.75h1a.75.75 0 0 0 0-1.5h-1c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h2V5a.5.5 0 0 0 .854.354M9.25 13v-1.25h2A2.75 2.75 0 0 0 14 9V5a2.75 2.75 0 0 0-2.75-2.75h-1a.75.75 0 0 0 0 1.5h1c.69 0 1.25.56 1.25 1.25v4c0 .69-.56 1.25-1.25 1.25h-2V9a.5.5 0 0 0-.854-.354l-2 2a.5.5 0 0 0 0 .708l2 2A.5.5 0 0 0 9.25 13\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowRoadmapRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.337 2.274a.713.713 0 0 1 1.425-.005v.01a.713.713 0 0 1-1.425-.005m2.795.75a2.214 2.214 0 0 1-4.165 0H1.15a.75.75 0 1 1 0-1.5h1.818a2.214 2.214 0 0 1 4.165 0h3.402a3.066 3.066 0 1 1 0 6.132h-.477a2.213 2.213 0 0 1-4.164 0H3.465a1.566 1.566 0 0 0-.47 3.06a2.213 2.213 0 0 1 4.137.071H10.5V9.5a.5.5 0 0 1 .853-.354l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.853-.354v-1.213H7.132a2.214 2.214 0 0 1-4.18-.042a3.067 3.067 0 0 1 .513-6.09h2.428a2.213 2.213 0 0 1 4.164 0h.477a1.566 1.566 0 1 0 0-3.13zm.13 3.886v-.008a.713.713 0 1 1 0 .008M5.05 10.825c.392 0 .71.316.712.707v.01a.713.713 0 1 1-.712-.717\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowTransferDiagonal1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.538.809A.5.5 0 0 1 5 .5h5.5a.5.5 0 0 1 .354.854l-2.75 2.75a.5.5 0 0 1-.074.06l-6.726 6.727A.75.75 0 1 1 .244 9.83l6.439-6.44l-2.037-2.036a.5.5 0 0 1-.108-.545M13.78 4.14l-6.466 6.466l2.04 2.04A.5.5 0 0 1 9 13.5H3.5a.5.5 0 0 1-.354-.854l2.75-2.75l.055-.047l.019-.02l6.75-6.75a.75.75 0 1 1 1.06 1.062\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowTransferDiagonal2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.485.809A.5.5 0 0 0 9.024.5h-5.5a.5.5 0 0 0-.354.854l2.75 2.75a.5.5 0 0 0 .073.06l6.727 6.727a.75.75 0 1 0 1.06-1.061L7.34 3.39l2.037-2.036a.5.5 0 0 0 .108-.545M.243 4.14l6.467 6.466l-2.04 2.04a.5.5 0 0 0 .354.853h5.5a.5.5 0 0 0 .353-.854l-2.75-2.75l-.055-.047l-.018-.02l-6.75-6.75A.75.75 0 0 0 .244 4.14\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleArrowTransferDiagonal3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 0a.5.5 0 0 0-.354.854l1.47 1.47L.47 7.97a.75.75 0 0 0 1.06 1.06l5.647-5.646l1.47 1.47A.5.5 0 0 0 9.5 4.5v-4A.5.5 0 0 0 9 0zm-.191 9.038a.5.5 0 0 1 .545.108l1.47 1.47L12.47 4.97a.75.75 0 1 1 1.06 1.06l-5.646 5.647l1.47 1.47A.5.5 0 0 1 9 14H5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .309-.462\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleFlag: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5v13m0-13l9 4.5l-9 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleFlagRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.875 9.917v3.208a.875.875 0 0 1-1.75 0V.875A.875.875 0 0 1 2.528.177l9.729 4.378a.625.625 0 0 1 0 1.14zm0-1.371l7.602-3.421l-7.602-3.42z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTriangleFlagSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.666.044c.208 0 .396.085.532.222l8.61 4.305a.5.5 0 0 1 0 .894L3.416 9.661v3.544a.75.75 0 0 1-1.5 0V.795a.75.75 0 0 1 .75-.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrophy: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 9.5v4m-3.5 0h7m-7-13h-3v3a3 3 0 0 0 3 3zm7 0h3v3a3 3 0 0 1-3 3z\"/><path d=\"M3.5.5V6a3.5 3.5 0 1 0 7 0V.5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrophyRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .375A.625.625 0 0 0 .375 1v3c0 1.625 1.24 2.96 2.826 3.11a4.13 4.13 0 0 0 2.924 2.422v2.593H4.5a.875.875 0 0 0 0 1.75h5a.875.875 0 0 0 0-1.75H7.875V9.532a4.13 4.13 0 0 0 2.924-2.421A3.125 3.125 0 0 0 13.625 4V1A.625.625 0 0 0 13 .375zm3.125 1.25V5.5a2.875 2.875 0 1 0 5.75 0V1.625zm-1.25 0h-1.25V4c0 .816.522 1.51 1.25 1.768zm8.25 0v4.143A1.88 1.88 0 0 0 12.375 4V1.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTrophySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 .75A.75.75 0 0 1 .75 0h2.885l.055.002h6.621L10.365 0h2.885a.75.75 0 0 1 .75.75v2.885a3.635 3.635 0 0 1-3.197 3.609A4 4 0 0 1 7.75 9.93v2.57h2.615a.75.75 0 0 1 0 1.5H3.634a.75.75 0 0 1 0-1.5H6.25V9.93a4 4 0 0 1-3.053-2.686A3.635 3.635 0 0 1 0 3.635zm2.885 4.884V1.5H1.5v2.135c0 .915.576 1.696 1.385 2m8.23-4.134v4.134a2.135 2.135 0 0 0 1.385-2V1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwitter: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 9.4a6.8 6.8 0 0 1-2.41 1.21a.5.5 0 0 0 0 .94C8.51 14.39 12.91 10 12.24 5.13l1.12-2.32h-1.3C10.44.82 6.14.92 6.85 5.16c0 0-2.3.41-5.24-2.48A.5.5 0 0 0 .76 3A5.52 5.52 0 0 0 4 9.4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwitterRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M4.019 9.376a6.8 6.8 0 0 1-2.409 1.2a.5.5 0 0 0-.33.465a.49.49 0 0 0 .33.465c6.917 2.814 11.315-1.535 10.646-6.36l1.12-2.299h-1.3C10.456.876 6.158.975 6.868 5.176c0 0-2.3.406-5.238-2.457a.501.501 0 0 0-.85.317a5.43 5.43 0 0 0 .439 3.762a5.5 5.5 0 0 0 2.8 2.578\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwitterSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.475 1.163c1.302-.335 2.873.127 3.83 1.146h1.073a.5.5 0 0 1 .45.717l-1.055 2.186c.3 2.548-.697 4.984-2.702 6.424c-2.05 1.473-5.067 1.844-8.645.378a1 1 0 0 1 .051-1.888a6.3 6.3 0 0 0 1.564-.662a6.02 6.02 0 0 1-2.757-6.55a1 1 0 0 1 1.695-.592C3.392 3.711 4.627 4.285 5.483 4.52c.332.091.61.132.822.149c-.066-.88.084-1.614.416-2.194c.404-.707 1.047-1.13 1.754-1.312\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwoFingerDragHotizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.95 7.574L5.993 3.29a1.196 1.196 0 0 1 .757-1.384v0a1.196 1.196 0 0 1 1.577.863l.888 3.976l.267-.097a2.144 2.144 0 0 1 2.75 1.278l.926 2.537M6.95 7.581l-1.57-2.74a1.22 1.22 0 0 0-1.474-.538v0a1.218 1.218 0 0 0-.662 1.706L5.13 9.633l-.36.215a1.715 1.715 0 0 0-.118 2.873l.242.171l.565.403M1.75.5L.5 1.75L1.75 3M.5 1.75h3M12.25.5l1.25 1.25L12.25 3m1.25-1.25h-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwoFingerDragHotizontalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5.5a.5.5 0 0 0-.854-.354l-1.5 1.5a.5.5 0 0 0 0 .708l1.5 1.5A.5.5 0 0 0 2.5 3.5v-.875H4a.625.625 0 1 0 0-1.25H2.5zm9.309-.462a.5.5 0 0 1 .545.108l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5A.5.5 0 0 1 11.5 3.5v-.875H10a.625.625 0 1 1 0-1.25h1.5V.5a.5.5 0 0 1 .309-.462M1.482 12.842a2.34 2.34 0 0 1 1.402-3.637l.366-.081V5.883A1.875 1.875 0 0 1 5.767 4.12a1.875 1.875 0 0 1 3.733.255v3.878a2.625 2.625 0 0 1 2.5 2.622v2.5a.625.625 0 1 1-1.25 0v-2.5c0-.76-.616-1.375-1.375-1.375h-.5a.625.625 0 0 1-.625-.625v-4.5a.625.625 0 0 0-1.25 0v4.5a.625.625 0 1 1-1.25 0V5.883a.625.625 0 0 0-1.25 0v3.742a.625.625 0 0 1-.49.61l-.855.19a1.09 1.09 0 0 0-.653 1.695l.633.894a.625.625 0 1 1-1.02.722z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwoFingerDragHotizontalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.691.038A.5.5 0 0 1 3 .5v1h1a.5.5 0 0 1 0 1H3v1a.5.5 0 0 1-.854.354l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5a.5.5 0 0 1 .545-.108m9.662.108A.5.5 0 0 0 11.5.5v1h-1a.5.5 0 1 0 0 1h1v1a.5.5 0 0 0 .853.354l1.5-1.5a.5.5 0 0 0 0-.708zM5.42 10.062L3.524 6.11a1.307 1.307 0 0 1 2.332-1.177l1.587 2.992v-.008l-.876-4.625a1.283 1.283 0 0 1 2.52-.478l.815 4.295l.447-.148a2.134 2.134 0 0 1 2.545 1.014c.119.221.17.471.211.719l.698 4.14A1 1 0 0 1 12.817 14H5.983a1 1 0 0 1-.605-.204l-.74-.564a1.707 1.707 0 0 1 .208-2.853z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwoFingerTap: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.263 5.982a3.498 3.498 0 0 1 4.085-4.229a3.498 3.498 0 0 1 6.09 3.041\"/><path d=\"m7.312 8.258l.616-4.69a1.29 1.29 0 0 1 1.278-1.122v0c.778 0 1.38.685 1.278 1.457l-.572 4.355h.473c1.185 0 2.145.96 2.145 2.144v3.08M7.31 8.266L6.733 4.91A1.31 1.31 0 0 0 5.44 3.82v0c-.793 0-1.405.697-1.302 1.483l.57 4.368l-.648.121a1.715 1.715 0 0 0-1.095 2.659l.298.432l.424.617\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwoFingerTapRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.102 1.61c-.96 0-1.815.46-2.352 1.176a.74.74 0 0 1-.588.294a2.205 2.205 0 0 0-2.174 2.573a.735.735 0 1 1-1.45.244A3.675 3.675 0 0 1 4.8 1.628a4.41 4.41 0 0 1 7.663 3.586a.735.735 0 1 1-1.453-.22q.033-.217.033-.444a2.94 2.94 0 0 0-2.94-2.94M3.815 9.424a2.294 2.294 0 0 0-1.436 3.494l.433.664a.613.613 0 0 0 1.026-.67l-.433-.663a1.068 1.068 0 0 1 .72-1.638l.403-.067a.61.61 0 0 0 .512-.604V6.395a.613.613 0 0 1 1.225 0v2.933a.613.613 0 0 0 1.225 0v-4.41a.612.612 0 1 1 1.225 0v4.41a.61.61 0 0 0 .612.612h.49c.745 0 1.348.603 1.348 1.347v1.96a.612.612 0 1 0 1.225 0v-1.96a2.573 2.573 0 0 0-2.45-2.57v-3.8a1.838 1.838 0 0 0-3.658-.249a1.838 1.838 0 0 0-2.467 1.727z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTwoFingerTapSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.923 2.485a2.748 2.748 0 0 1 4.785 2.39a.75.75 0 0 0 1.461.34a4.248 4.248 0 0 0-7.103-4.009a4.25 4.25 0 0 0-4.534 5.196a.75.75 0 0 0 1.462-.34a2.748 2.748 0 0 1 3.21-3.323a.75.75 0 0 0 .72-.254Zm-2.175 7.704l-.566-4.347a1.307 1.307 0 0 1 2.583-.39l.573 3.34l.003-.009l.612-4.667a1.283 1.283 0 1 1 2.544.334l-.569 4.333h.471c1.179 0 2.134.956 2.134 2.134v2.067a1 1 0 0 1-.998 1l-7.275.015a1 1 0 0 1-.826-.433l-.42-.61a1.707 1.707 0 0 1 1.09-2.646l.644-.12Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUnderlineText1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 13.5h11M4 .5v8a3 3 0 0 0 3 3v0a3 3 0 0 0 3-3v-8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUnderlineText1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.125.625a.625.625 0 1 0-1.25 0v6.25a4.125 4.125 0 0 0 8.25 0V.625a.625.625 0 1 0-1.25 0v6.25a2.875 2.875 0 1 1-5.75 0zM1 12.25A.875.875 0 0 0 1 14h12a.875.875 0 0 0 0-1.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUnderlineText1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.75.75a.75.75 0 0 0-1.5 0V7.5a3.75 3.75 0 1 0 7.5 0V.75a.75.75 0 0 0-1.5 0V7.5a2.25 2.25 0 0 1-4.5 0zm-4 11.75a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadBox1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.5 13.5h-2a1 1 0 0 1-1-1v-8h13v8a1 1 0 0 1-1 1h-2\"/><path d=\"M4.5 10L7 7.5L9.5 10M7 7.5v6M11.29 1a1 1 0 0 0-.84-.5h-6.9a1 1 0 0 0-.84.5L.5 4.5h13zM7 .5v4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadBox1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.463.205A.63.63 0 0 0 10 0H7.75v4h4.125v5.125a.375.375 0 0 1-.375.375H11a.625.625 0 1 0 0 1.25h.5c.898 0 1.625-.727 1.625-1.625v-5.75a.63.63 0 0 0-.162-.42zm-2.838 13.17a.625.625 0 1 1-1.25 0V9.75H5.25a.625.625 0 0 1-.442-1.067l1.75-1.75a.623.623 0 0 1 .884 0l1.75 1.75A.625.625 0 0 1 8.75 9.75H7.625zM4 0a.63.63 0 0 0-.462.205l-2.5 2.75a.63.63 0 0 0-.163.42v5.75c0 .898.728 1.625 1.625 1.625H3A.625.625 0 1 0 3 9.5h-.5a.375.375 0 0 1-.375-.375V4H6.25V0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadBox1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.375 0H3.383A1.5 1.5 0 0 0 2.07.772L.347 3.875h6.028zM0 12.5V5.125h14V12.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5m13.653-8.625H7.625V0h2.992a1.5 1.5 0 0 1 1.312.772zm-9.3 5.064l2.293-2.292a.5.5 0 0 1 .708 0l2.292 2.292a.5.5 0 0 1-.353.854H8v2a1 1 0 1 1-2 0v-2H4.707a.5.5 0 0 1-.353-.854Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m4 7l3-3.5L10 7M7 3.5v7\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14m5.75-7a5.75 5.75 0 1 1-11.5 0a5.75 5.75 0 0 1 11.5 0M7 11.125a.625.625 0 0 1-.625-.625V6.375H4.75a.625.625 0 0 1-.442-1.067l2.25-2.25a.62.62 0 0 1 .437-.183h.011a.62.62 0 0 1 .436.183l2.25 2.25a.625.625 0 0 1-.442 1.067H7.625V10.5c0 .345-.28.625-.625.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14m3.146-8.31L7.353 2.895a.5.5 0 0 0-.707 0L3.854 5.69a.5.5 0 0 0 .353.854H6v3.707a1 1 0 0 0 2 0V6.544h1.793a.5.5 0 0 0 .353-.854\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadComputer: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 2h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 1 2h2m3 9l-1 2.5M8 11l1 2.5m-5 0h6m-3-7v-6\"/><path d=\"m5 2.5l2-2l2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadComputerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 8a.625.625 0 0 1-.625-.625V3H5.25a.625.625 0 0 1-.442-1.067l1.75-1.75A.62.62 0 0 1 6.994 0h.012a.62.62 0 0 1 .436.183l1.75 1.75A.625.625 0 0 1 8.75 3H7.625v4.375C7.625 7.72 7.345 8 7 8m1.789 3.5H12c.898 0 1.625-.727 1.625-1.625v-6c0-.897-.727-1.625-1.625-1.625h-.5a.625.625 0 1 0 0 1.25h.5c.207 0 .375.168.375.375v6a.375.375 0 0 1-.375.375H2a.375.375 0 0 1-.375-.375v-6c0-.207.168-.375.375-.375h.5a.625.625 0 1 0 0-1.25H2c-.897 0-1.625.728-1.625 1.625v6c0 .898.728 1.625 1.625 1.625h3.211l-.5 1.25H4A.625.625 0 1 0 4 14h6a.625.625 0 1 0 0-1.25h-.711z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadComputerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 4a.75.75 0 0 1-.586-1.219l2-2.5a.75.75 0 0 1 1.172 0l2 2.5A.75.75 0 0 1 9 4H8v2.5a1 1 0 0 1-2 0V4zM2.062 2.91H2.3a1 1 0 0 0 0-2h-.782C.714.91.062 1.562.062 2.367v7.309c0 .804.652 1.457 1.456 1.457h3.918l-.488 1.362H4a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 0-1.5h-.948l-.488-1.362h3.918c.804 0 1.456-.653 1.456-1.457v-7.31c0-.804-.652-1.456-1.457-1.456H11.7a1 1 0 1 0 0 2h.238v6.222H2.062z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadFile: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.5 12.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H9L12.5 4z\"/><path d=\"m9 6.5l-2-2l-2 2m2-2V10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadFileRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.36 1.36c.07-.07.166-.11.265-.11h6.116l3.009 3.009v8.116a.375.375 0 0 1-.375.375h-8.75a.375.375 0 0 1-.375-.375V1.625c0-.1.04-.195.11-.265M2.625 0A1.625 1.625 0 0 0 1 1.625v10.75A1.625 1.625 0 0 0 2.625 14h8.75A1.625 1.625 0 0 0 13 12.375V4a.63.63 0 0 0-.183-.442L9.442.183A.63.63 0 0 0 9 0zM7 3.875c.166 0 .325.066.442.183l2 2A.625.625 0 0 1 9 7.125H7.625V10a.625.625 0 1 1-1.25 0V7.125H5a.625.625 0 0 1-.442-1.067l2-2A.63.63 0 0 1 7 3.875\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUploadFileSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.44.44A1.5 1.5 0 0 1 2.5 0h6a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 13 4.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5v-11c0-.398.158-.78.44-1.06m5.747 2.993l.104.104c.116.076.216.176.292.292l1.854 1.854a.625.625 0 0 1-.442 1.067h-1.25v3.625a1 1 0 1 1-2 0V6.75h-1.25a.625.625 0 0 1-.442-1.067L5.907 3.83c.076-.116.176-.216.292-.292l.104-.104a.625.625 0 0 1 .884 0Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUsbDrive: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5 9V5.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1V9a4.5 4.5 0 1 1-9 0M4 .5v4h6v-4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUsbDriveRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.125 0A.625.625 0 0 0 3.5.625v3.25c-.897 0-1.625.728-1.625 1.625v3.375a5.125 5.125 0 1 0 10.25 0V5.5c0-.897-.727-1.625-1.625-1.625V.625A.625.625 0 0 0 9.875 0zM9.25 3.875V1.25h-4.5v2.625z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUsbDriveSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 0a.5.5 0 0 0-.5.5v3.25h7V.5A.5.5 0 0 0 10 0zM2.5 6v3.5a4.5 4.5 0 1 0 9 0V6a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserAddPlus: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 5.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m1.5 7h-6v-.542a4.51 4.51 0 0 1 6.5-4m3.5-.458v6m-3-3h6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserAddPlusRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.247 3A1.752 1.752 0 1 1 6.75 3a1.752 1.752 0 0 1-3.504 0M4.998-.001A3.002 3.002 0 1 0 5 6.003A3.002 3.002 0 0 0 5-.002m6.25 7.752a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2zm-2.562 1H7.75a1.75 1.75 0 1 0 0 3.5h1v.748H.625A.625.625 0 0 1 0 12.373c0-2.917 2.19-5.371 4.998-5.371c1.478 0 2.784.68 3.69 1.748\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserAddPlusSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 3a3 3 0 1 1-6 0a3 3 0 0 1 6 0m2.75 4.5a.75.75 0 0 1 .75.75V10h1.75a.75.75 0 0 1 0 1.5H11.5v1.75a.75.75 0 0 1-1.5 0V11.5H8.25a.75.75 0 0 1 0-1.5H10V8.25a.75.75 0 0 1 .75-.75M5 7c1.493 0 2.834.655 3.75 1.693v.057h-.5a2 2 0 0 0-.97 3.75H.5A.5.5 0 0 1 0 12a5 5 0 0 1 5-5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserCheckValidate: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 5.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m0 7H.5v-.542A4.51 4.51 0 0 1 5.204 7.5A4.5 4.5 0 0 1 8.354 9m5.146-.5l-4 5l-2-1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserCheckValidateRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.998 1.248A1.752 1.752 0 1 0 5 4.753a1.752 1.752 0 0 0 0-3.505M1.997 3.001A3.002 3.002 0 1 1 8 3a3.002 3.002 0 0 1-6.004 0m6.547 7.42A1.75 1.75 0 0 0 6.2 12.998H.625A.625.625 0 0 1 0 12.373c0-2.917 2.19-5.371 4.998-5.371c2.087 0 3.833 1.356 4.592 3.25l-.478.592zm5.293-1.452a.75.75 0 0 0-1.167-.942L9.287 12.22l-1.34-.996a.75.75 0 0 0-.895 1.203l1.918 1.427a.75.75 0 0 0 1.031-.131z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserCheckValidateSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 3a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-1.95 9.5H.5A.5.5 0 0 1 0 12a5 5 0 0 1 9.725-1.64l-.076.11l-.601-.404A2 2 0 0 0 6.05 12.5m7.8-3.3a.75.75 0 0 0-1.2-.9l-2.67 3.9l-1.65-1.11a.75.75 0 1 0-.9 1.2l2.25 1.56a.75.75 0 0 0 1.05-.15z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserCircleSingle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 8a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m-4.27 3.9a5 5 0 0 1 8.54 0\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserCircleSingleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.25 7a5.75 5.75 0 1 1 9.581 4.288A4.99 4.99 0 0 0 7 9.5a4.99 4.99 0 0 0-3.831 1.787A5.74 5.74 0 0 1 1.25 7M7 3.625a1.875 1.875 0 1 0 0 3.75a1.875 1.875 0 0 0 0-3.75M3.875 5.5a3.125 3.125 0 1 1 6.25 0a3.125 3.125 0 0 1-6.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserCircleSingleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7a6.98 6.98 0 0 1-1.941 4.838A6.98 6.98 0 0 1 7.02 14h-.04a6.98 6.98 0 0 1-5.039-2.162A7 7 0 1 1 14 7m-2.757 3.5A5.49 5.49 0 0 0 7 8.5a5.49 5.49 0 0 0-4.243 2A5.49 5.49 0 0 0 7 12.5a5.49 5.49 0 0 0 4.243-2M7 7.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserIdentifierCard: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.358 2.266h11.284s.858 0 .858.858v7.752s0 .858-.858.858H1.358s-.858 0-.858-.858V3.124s0-.858.858-.858M9.36 5.88h1.986M9.36 7.849h1.986\"/><path d=\"M3.507 6.208a1.64 1.64 0 1 0 3.282 0a1.64 1.64 0 0 0-3.282 0\"/><path d=\"M2.654 9.473a3.2 3.2 0 0 1 1.064-1.19a2.6 2.6 0 0 1 1.43-.434c.502 0 .994.15 1.431.434a3.2 3.2 0 0 1 1.064 1.19\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserIdentifierCardRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .998c.345 0 .625.28.625.625v.875h4.893c.82 0 1.483.663 1.483 1.482v7.538c0 .818-.664 1.482-1.483 1.482H1.482a1.483 1.483 0 0 1-1.483-1.482V3.98c0-.819.664-1.482 1.483-1.482h4.893v-.875c0-.346.28-.625.625-.625m-.625 2.75H1.482a.233.233 0 0 0-.233.232v7.538c0 .096.059.179.142.214a3.001 3.001 0 0 1 5.807.018h5.32a.233.233 0 0 0 .233-.232V3.98a.233.233 0 0 0-.233-.232H7.625v.875a.625.625 0 1 1-1.25 0zM4.292 6.375a.625.625 0 1 0 0 1.25a.625.625 0 0 0 0-1.25M2.417 7a1.875 1.875 0 1 1 3.75 0a1.875 1.875 0 0 1-3.75 0m6.208-.75c0-.345.28-.625.625-.625h2a.625.625 0 1 1 0 1.25h-2a.625.625 0 0 1-.625-.625m.625 1.625a.625.625 0 1 0 0 1.25h2a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserIdentifierCardSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm6 2.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M1.547 9.302A4 4 0 0 1 4.5 8a4 4 0 0 1 2.953 1.302c.26.284.03.698-.355.698H1.902c-.385 0-.615-.414-.355-.698M8.875 5.5c0-.345.28-.625.625-.625h2a.625.625 0 0 1 0 1.25h-2a.625.625 0 0 1-.625-.625M9.5 7.875a.625.625 0 1 0 0 1.25h2a.625.625 0 0 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserMultipleCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.438 8a1.61 1.61 0 1 1 0-3.22a1.61 1.61 0 0 1 0 3.22m-2.339 2.485a3.22 3.22 0 0 1 4.494-.18M5.229 7.483a1.995 1.995 0 1 1 0-3.99a1.995 1.995 0 0 1 0 3.99\"/><path d=\"M8.967 13.181c-.1-1.192-.397-1.975-.56-2.251a3.95 3.95 0 0 0-1.414-1.414A3.8 3.8 0 0 0 5.09 9a3.8 3.8 0 0 0-1.903.516c-.463.27-.867.634-1.188 1.07l-.203.305\"/><path d=\"M7 13.5a6.5 6.5 0 1 1 0-13a6.5 6.5 0 0 1 0 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserMultipleCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m2 12.393c.426-.158.83-.366 1.201-.615a5.2 5.2 0 0 0-1.058-2.505A3.5 3.5 0 0 1 10.5 9c.62 0 1.202.161 1.706.444a5.75 5.75 0 1 0-10.202.405a4 4 0 0 1 6.994 2.544M5 4.465a1.035 1.035 0 1 0 0 2.07a1.035 1.035 0 0 0 0-2.07M2.715 5.5a2.285 2.285 0 1 1 4.57 0a2.285 2.285 0 0 1-4.57 0m7.1 1a.685.685 0 1 1 1.37 0a.685.685 0 0 1-1.37 0m.685-1.935a1.935 1.935 0 1 0 0 3.87a1.935 1.935 0 0 0 0-3.87\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserMultipleCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7a7 7 0 1 0-12.95 3.688q.051.085.107.168A7 7 0 0 0 14 7m-7 5.5a5.5 5.5 0 0 0 1.582-.23c-.433-1.965-1.758-3.582-4.011-3.582c-.946 0-1.762.325-2.447.86A5.5 5.5 0 0 0 7 12.5m2.594-.649A5.5 5.5 0 0 0 11.93 9.44l-.142-.084a3.74 3.74 0 0 0-3.523-.077q.071.08.139.16c.583.699.97 1.538 1.189 2.413M4.729 3.243a2.245 2.245 0 1 1 0 4.49a2.245 2.245 0 0 1 0-4.49m7.069 2.897a1.86 1.86 0 1 0-3.72 0a1.86 1.86 0 0 0 3.72 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserMultipleGroup: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 6.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m-4.5 7h9v-.542A4.51 4.51 0 0 0 4.796 8.5A4.51 4.51 0 0 0 .5 12.958zm8.5-7a2.5 2.5 0 0 0 0-5m2.5 12h2v-.542A4.51 4.51 0 0 0 10 8.61\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserMultipleGroupRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.826 2.136q.086-.01.174-.011a1.375 1.375 0 1 1-.174 2.74a.625.625 0 0 0-.157 1.24q.164.02.331.02a2.625 2.625 0 1 0-.33-5.23a.625.625 0 1 0 .156 1.24m1.65 5.079a.625.625 0 0 0-.362 1.197c1.49.45 2.57 1.774 2.636 3.341h-1a.625.625 0 0 0 0 1.25h1.628c.345 0 .625-.28.625-.625v-.475c0-2.215-1.494-4.074-3.528-4.688M5 6.998c-2.749 0-5 2.183-5 4.905v.475c0 .345.28.625.625.625h8.753c.345 0 .625-.28.625-.625v-.475c0-2.722-2.253-4.905-5.002-4.905M3.625 3.5a1.375 1.375 0 1 1 2.75 0a1.375 1.375 0 0 1-2.75 0M5 .875a2.625 2.625 0 1 0 0 5.25a2.625 2.625 0 0 0 0-5.25\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserMultipleGroupSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 4.5a3 3 0 1 1-6 0a3 3 0 0 1 6 0m-3 4a5 5 0 0 0-5 5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5a5 5 0 0 0-5-5m8.5 5.5h-2.322q.071-.238.072-.5a6.24 6.24 0 0 0-2.492-4.994Q8.878 8.5 9 8.5a5 5 0 0 1 5 5a.5.5 0 0 1-.5.5M9 7.5a3 3 0 0 1-.868-.127C8.826 6.616 9.25 5.608 9.25 4.5s-.424-2.116-1.118-2.873A3 3 0 1 1 9 7.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserProfileFocus: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 10.5v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2m6.5-4a2 2 0 1 0 0-4a2 2 0 0 0 0 4m3.803 4.5a3.994 3.994 0 0 0-7.606 0z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserProfileFocusRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.38 1.38a.44.44 0 0 1 .31-.127h2.124a.625.625 0 0 0 0-1.25H1.69A1.687 1.687 0 0 0 .002 1.69v2.124a.625.625 0 1 0 1.25 0V1.69c0-.116.047-.227.128-.31M9.562.629c0-.345.28-.625.625-.625h2.124A1.687 1.687 0 0 1 14 1.69v2.124a.625.625 0 1 1-1.25 0V1.69a.437.437 0 0 0-.438-.437h-2.124a.625.625 0 0 1-.625-.625m3.812 8.935c.345 0 .624.28.624.624v2.125a1.687 1.687 0 0 1-1.687 1.687h-2.124a.625.625 0 1 1 0-1.25h2.124a.437.437 0 0 0 .438-.437v-2.125c0-.345.28-.625.624-.625m-12.747 0c.346 0 .625.28.625.624v2.125a.437.437 0 0 0 .438.437h2.124a.625.625 0 0 1 0 1.25H1.69a1.687 1.687 0 0 1-1.688-1.687v-2.124c0-.346.28-.625.625-.625M7 2.875a1.375 1.375 0 1 0 0 2.75a1.375 1.375 0 0 0 0-2.75M4.375 4.25a2.625 2.625 0 1 1 5.25 0a2.625 2.625 0 0 1-5.25 0M7 7.75a4.5 4.5 0 0 0-4.358 3.375a.5.5 0 0 0 .484.625h7.748a.5.5 0 0 0 .484-.625A4.5 4.5 0 0 0 7 7.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserProfileFocusSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.573 1.573A.25.25 0 0 1 1.75 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5A1.75 1.75 0 0 0 0 1.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.25.25 0 0 1 .073-.177M14 10.75a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-1.5a.75.75 0 0 0 0 1.5h1.5A1.75 1.75 0 0 0 14 12.25zM.75 10a.75.75 0 0 1 .75.75v1.5a.25.25 0 0 0 .25.25h1.5a.75.75 0 0 1 0 1.5h-1.5A1.75 1.75 0 0 1 0 12.25v-1.5A.75.75 0 0 1 .75 10m10-10a.75.75 0 0 0 0 1.5h1.5a.25.25 0 0 1 .25.25v1.5a.75.75 0 0 0 1.5 0v-1.5A1.75 1.75 0 0 0 12.25 0zM7 7.776a4.42 4.42 0 0 0-4.145 2.879c-.112.299.127.595.446.595h7.397c.319 0 .557-.296.445-.595A4.42 4.42 0 0 0 7 7.776m2.208-3.315a2.21 2.21 0 1 1-4.421 0a2.21 2.21 0 0 1 4.421 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserProtection2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.36 13.43a1 1 0 0 1-.72 0v0a9.67 9.67 0 0 1-6.14-9V1.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.92a9.67 9.67 0 0 1-6.14 9.01\"/><path d=\"M2.837 10.73A5 5 0 0 1 7 8.5c1.737 0 3.267.886 4.164 2.23M7 7a2.25 2.25 0 1 0 0-4.5A2.25 2.25 0 0 0 7 7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserProtection2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.75C0 .784.784 0 1.75 0h10.5C13.216 0 14 .784 14 1.75v3.257a9.31 9.31 0 0 1-6.57 8.895a1.45 1.45 0 0 1-.86 0A9.31 9.31 0 0 1 0 5.007zM7 6.5A2.25 2.25 0 1 0 7 2a2.25 2.25 0 0 0 0 4.5m4.152 2.893A5.5 5.5 0 0 0 7 7.5a5.5 5.5 0 0 0-4.152 1.893A7.8 7.8 0 0 0 7 12.465a7.8 7.8 0 0 0 4.152-3.072\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserProtection2shieldSecureSecurityProfilePersonRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v2.675a9.4 9.4 0 0 0 6.427 8.918a.62.62 0 0 0 .396 0a9.4 9.4 0 0 0 6.427-8.918V2c0-.897-.727-1.625-1.625-1.625zM1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v2.675a8.14 8.14 0 0 1-1.59 4.835A5.48 5.48 0 0 0 7 8c-1.467 0-2.8.575-3.786 1.51a8.14 8.14 0 0 1-1.589-4.835zM7 3.5a1.375 1.375 0 1 0 0 2.75A1.375 1.375 0 0 0 7 3.5M4.375 4.875a2.625 2.625 0 1 1 5.25 0a2.625 2.625 0 0 1-5.25 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserRemoveSubtract: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 5.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m1.5 7h-6v-.542A4.51 4.51 0 0 1 5.204 7.5A4.5 4.5 0 0 1 8.354 9m.146 2.5h5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserRemoveSubtractRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.998 1.248A1.752 1.752 0 1 0 5 4.753a1.752 1.752 0 0 0 0-3.505M1.997 3.001A3.002 3.002 0 1 1 8 3a3.002 3.002 0 0 1-6.004 0M0 12.373c0-2.917 2.19-5.371 4.998-5.371c2.523 0 4.547 1.98 4.932 4.498H8.236c-.88 0-1.61.65-1.732 1.498H.625A.625.625 0 0 1 0 12.373m7.53.625a.75.75 0 0 1 .706-.498h4.79a.75.75 0 0 1 0 1.5h-4.79a.75.75 0 0 1-.706-1.002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserRemoveSubtractSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 3a3 3 0 1 1-6 0a3 3 0 0 1 6 0m5.25 7a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5zM5 7a5 5 0 0 0-5 5a.5.5 0 0 0 .5.5h6.78a2 2 0 0 1 .97-3.75h.55A4.99 4.99 0 0 0 5 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserSingleNeutralMale: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.18 13.5a6.49 6.49 0 0 0-12.36 0z\"/><path d=\"M7 9A4.232 4.232 0 1 0 7 .536A4.232 4.232 0 0 0 7 9\"/><path d=\"M8.382 6.405s-.351.691-1.382.691s-1.382-.69-1.382-.69m5.537-2.444h-.028a4.12 4.12 0 0 1-3.09-1.392a4.12 4.12 0 0 1-3.091 1.392a4.1 4.1 0 0 1-1.973-.5a4.234 4.234 0 0 1 8.182.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserSingleNeutralMaleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.625 4V2.298a3 3 0 0 1 .405-.239c.423-.212 1.078-.434 1.97-.434s1.547.222 1.97.434c.173.086.308.171.405.24V4a2.375 2.375 0 1 1-4.75 0m5.817-2.442L10 2zl-.001-.002l-.002-.002l-.006-.006l-.016-.015l-.051-.046a3 3 0 0 0-.178-.143A4.3 4.3 0 0 0 9.53.94C8.953.653 8.108.375 7 .375S5.047.653 4.47.941c-.287.144-.506.29-.657.403a3 3 0 0 0-.229.189l-.016.015l-.006.006l-.002.002l-.001.001L4 2l-.442-.442A.63.63 0 0 0 3.375 2v2a3.625 3.625 0 0 0 7.25 0V2a.63.63 0 0 0-.183-.442M.422 12.76a7.127 7.127 0 0 1 13.157 0a.625.625 0 0 1-.577.866H.998a.625.625 0 0 1-.577-.866\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserSingleNeutralMaleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 8a4 4 0 0 0 4-4v-.042a4.6 4.6 0 0 1-2.964-1.182a4.6 4.6 0 0 1-3.09 1.184a4.6 4.6 0 0 1-1.92-.416A4 4 0 0 0 7 8m1.41-6.263a3.62 3.62 0 0 0 2.45 1.213a4.002 4.002 0 0 0-7.59-.399c.501.261 1.07.409 1.675.409a3.62 3.62 0 0 0 2.717-1.223a.5.5 0 0 1 .748 0M.512 13.367a7.002 7.002 0 0 1 12.976 0c.126.31-.114.633-.448.633H.96c-.334 0-.574-.323-.448-.633\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserSyncOnlineInPerson: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.04 13.448v-2.48h2.48\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.339 5.815a6.449 6.449 0 0 1-11.3 5.308M.661 8.185a6.449 6.449 0 0 1 11.3-5.308\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.96.552v2.48H9.48\"/><path d=\"M5.75 5.25a1.25 1.25 0 1 0 2.5 0a1.25 1.25 0 1 0-2.5 0\"/><path stroke-linecap=\"round\" d=\"M4.708 9.5a2.5 2.5 0 0 1 4.584 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserSyncOnlineInPersonRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25A5.75 5.75 0 0 0 1.249 7a.625.625 0 1 1-1.25 0a7 7 0 0 1 12.352-4.514l.582-.582A.625.625 0 0 1 14 2.345v2.203c0 .345-.28.625-.625.625h-2.202a.625.625 0 0 1-.442-1.067l.732-.732A5.74 5.74 0 0 0 7 1.249m6.375 5.125c.345 0 .625.28.625.625a7 7 0 0 1-12.352 4.514l-.582.582a.625.625 0 0 1-1.067-.442V9.452c0-.345.28-.625.625-.625h2.203a.625.625 0 0 1 .441 1.067l-.732.732A5.75 5.75 0 0 0 12.75 7c0-.345.28-.625.625-.625M6.125 5a.875.875 0 1 1 1.75 0a.875.875 0 0 1-1.75 0M7 2.875a2.125 2.125 0 1 0 0 4.25a2.125 2.125 0 0 0 0-4.25M7 8a3 3 0 0 0-2.75 1.8a.5.5 0 0 0 .458.7h4.584a.5.5 0 0 0 .458-.7A3 3 0 0 0 7 8\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineUserSyncOnlineInPersonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.213 2.538A5.499 5.499 0 0 0 1.595 8.01a.75.75 0 0 1-1.474.277a6.999 6.999 0 0 1 11.163-6.821l.612-.612a.5.5 0 0 1 .854.353V3.5a.5.5 0 0 1-.5.5H9.957a.5.5 0 0 1-.353-.853zm2.791 2.577a.75.75 0 0 1 .876.598a6.999 6.999 0 0 1-11.164 6.821l-.612.613a.5.5 0 0 1-.854-.354V10.5a.5.5 0 0 1 .5-.5h2.293a.5.5 0 0 1 .354.854l-.61.609a5.499 5.499 0 0 0 8.618-5.472a.75.75 0 0 1 .6-.876M8.5 5.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M7 7.525a3 3 0 0 0-2.517 1.367c-.188.29.05.633.395.633h4.244c.345 0 .583-.343.395-.633A3 3 0 0 0 7 7.525\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVerticalSliderSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 1.5v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1m4 9.5V6\"/><path d=\"M4.5 6a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m5-3v3m0 3v2m0-2a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVerticalSliderSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.875 12.5a.375.375 0 0 1-.375-.375V1.875c0-.207.168-.375.375-.375h10.25c.207 0 .375.168.375.375v10.25a.375.375 0 0 1-.375.375zM.25 12.125c0 .898.728 1.625 1.625 1.625h10.25c.898 0 1.625-.727 1.625-1.625V1.875c0-.897-.727-1.625-1.625-1.625H1.875C.978.25.25.978.25 1.875zM4 6.48a2 2 0 1 1 1.5 0V11A.75.75 0 0 1 4 11zM10 3v2.895a2 2 0 0 1 0 3.71V11a.75.75 0 0 1-1.5 0V9.605a2 2 0 0 1 0-3.71V3A.75.75 0 0 1 10 3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVerticalSliderSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 0zm2.375 5.885V11a.625.625 0 1 0 1.25 0V5.885a1.75 1.75 0 1 0-1.25 0M11.25 7.75a1.75 1.75 0 0 1-1.125 1.635V11a.625.625 0 1 1-1.25 0V9.385a1.75 1.75 0 0 1 0-3.27V3a.625.625 0 1 1 1.25 0v3.115A1.75 1.75 0 0 1 11.25 7.75\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVideoSwapCamera: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10.15 8.063l-.841.636l-.636-.841\"/><path d=\"M9.262 8.636a2.58 2.58 0 0 0-3.25-3.585M3.795 6.865l.84-.635l.636.84\"/><path d=\"M4.682 6.293a2.58 2.58 0 0 0 3.25 3.585\"/><path d=\"M13.5 4.5a1 1 0 0 0-1-1h-2L9 1.5H5l-1.5 2h-2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVideoSwapCameraRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1A.63.63 0 0 1 5 .75h4c.197 0 .382.093.5.25l1.313 1.75h1.562c.898 0 1.625.728 1.625 1.625v7.25c0 .898-.727 1.625-1.625 1.625H1.625A1.625 1.625 0 0 1 0 11.625v-7.25C0 3.478.728 2.75 1.625 2.75h1.563zm.813 1L4 3.75a.63.63 0 0 1-.5.25H1.625a.375.375 0 0 0-.375.375v7.25c0 .207.168.375.375.375h10.75a.375.375 0 0 0 .375-.375v-7.25A.375.375 0 0 0 12.375 4H10.5a.63.63 0 0 1-.5-.25L8.688 2zM3.5 8h.415a3.126 3.126 0 0 0 4.335 2.365a.625.625 0 1 0-.5-1.146A1.876 1.876 0 0 1 5.193 8H5.5a.5.5 0 0 0 .354-.853l-1-1a.5.5 0 0 0-.708 0l-1 1A.5.5 0 0 0 3.5 8m2.75-2.22A1.876 1.876 0 0 1 8.807 7H8.5a.5.5 0 0 0-.354.854l1 1a.5.5 0 0 0 .708 0l1-1A.5.5 0 0 0 10.5 7h-.415A3.126 3.126 0 0 0 5.75 4.635a.625.625 0 1 0 .5 1.146\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVideoSwapCameraSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.6 1.2A.5.5 0 0 1 5 1h4a.5.5 0 0 1 .4.2L10.75 3h1.75A1.5 1.5 0 0 1 14 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 11.5v-7A1.5 1.5 0 0 1 1.5 3h1.75zm5.636 6.244l-.058-.008A3.205 3.205 0 0 0 5.78 4.47a.625.625 0 0 0 .466 1.16A1.955 1.955 0 0 1 8.92 7.262l-.16-.023a.625.625 0 0 0-.584.996l.635.841c.209.275.6.33.876.122l.84-.636a.625.625 0 0 0-.29-1.118M5.134 5.853a.625.625 0 0 0-.875-.122l-.841.635a.625.625 0 0 0 .29 1.118l.058.008a3.205 3.205 0 0 0 4.399 2.965a.625.625 0 1 0-.467-1.16a1.955 1.955 0 0 1-2.673-1.63l.16.022a.625.625 0 0 0 .585-.995z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVirtualReality: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 6.5H.5v5a1 1 0 0 0 1 1h3a1 1 0 0 0 .78-.38l1.31-1.63a.5.5 0 0 1 .78 0l1.33 1.63a1 1 0 0 0 .78.38h3a1 1 0 0 0 1-1zm0 0L10.79 2a1 1 0 0 0-.86-.49H4.07a1 1 0 0 0-.86.49L.5 6.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVirtualRealityRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.195.875a1.62 1.62 0 0 0-1.398.797v.002L.094 6.164a.625.625 0 0 0 .53.956h12.75a.625.625 0 0 0 .533-.953l-2.705-4.495A1.63 1.63 0 0 0 9.805.875zM9.19 11.732a.625.625 0 0 0-.981.775a1.62 1.62 0 0 0 1.267.618a.625.625 0 1 0 .006-1.25a.38.38 0 0 1-.292-.143\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVirtualRealitySolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.79 1.087A1.5 1.5 0 0 1 4.074.36h5.852a1.5 1.5 0 0 1 1.284.726l2.586 4.29H.211zM0 7a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v5a1.5 1.5 0 0 1-1.5 1.5H9.48a1.5 1.5 0 0 1-1.17-.563l-.92-1.149a.5.5 0 0 0-.78 0l-.92 1.149a1.5 1.5 0 0 1-1.17.563H1.5A1.5 1.5 0 0 1 0 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVirusAntivirus: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.625 7a6.344 6.344 0 1 0 12.688 0A6.344 6.344 0 1 0 .625 7m6.344-3.875v1.38\"/><path d=\"M4.479 7a2.489 2.489 0 1 0 4.978 0a2.489 2.489 0 1 0-4.978 0m2.49 3.875v-1.38M10.844 7h-1.38m-6.37 0h1.38m5.235-2.74l-.976.975M4.229 9.74l.975-.975M2.547 2.578l8.86 8.86\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVirusAntivirusRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25c-1.37 0-2.63.48-3.617 1.28l1.973 1.973c.339-.224.727-.38 1.144-.45v-.928a.5.5 0 0 1 1 0v.927c.453.077.871.255 1.23.51l.656-.656a.5.5 0 1 1 .708.708l-.657.656c.256.359.434.777.51 1.23h.928a.5.5 0 0 1 0 1h-.928c-.07.417-.227.805-.45 1.144l1.973 1.973A5.75 5.75 0 0 0 7 1.25M1.25 7c0-1.355.468-2.6 1.252-3.583l8.08 8.08A5.75 5.75 0 0 1 1.25 7M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m5.01 0a.5.5 0 0 0-.5-.5H3.125a.5.5 0 0 0 0 1h.927c.076.453.254.871.51 1.23l-.656.656a.5.5 0 1 0 .707.708l.656-.656c.36.255.778.433 1.231.51v.927a.5.5 0 0 0 1 0v-1.38A.51.51 0 0 0 7 8.99A1.99 1.99 0 0 1 5.01 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVirusAntivirusSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.48c-1.254 0-2.41.418-3.337 1.122l1.45 1.45A3.5 3.5 0 0 1 6.25 3.58v-.86a.75.75 0 0 1 1.5 0v.861c.41.09.794.252 1.137.472l.61-.61a.75.75 0 0 1 1.06 1.061l-.61.61c.22.343.382.726.472 1.137h.862a.75.75 0 1 1 0 1.5h-.862c-.09.41-.251.794-.471 1.137l1.45 1.45A5.52 5.52 0 0 0 7 1.48M4.051 5.112l-.003.005L8.882 9.95l.005-.003l1.45 1.45a5.52 5.52 0 0 1-7.734-7.734zM0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m2.719-.75h.695l4.336 4.336v.695a.75.75 0 1 1-1.5 0v-.861a3.5 3.5 0 0 1-1.138-.472l-.609.61a.75.75 0 1 1-1.06-1.061l.608-.609A3.5 3.5 0 0 1 3.58 7.75h-.861a.75.75 0 0 1 0-1.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVisible: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.23 6.246c.166.207.258.476.258.754s-.092.547-.258.754C12.18 9.025 9.79 11.5 7 11.5S1.82 9.025.77 7.754C.604 7.547.512 7.279.512 7s.092-.547.258-.754C1.82 4.975 4.21 2.5 7 2.5s5.18 2.475 6.23 3.746\"/><path d=\"M7 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVisibleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.382 6.548A.8.8 0 0 0 1.249 7a.8.8 0 0 0 .133.453c.5.671 1.307 1.643 2.306 2.442C4.696 10.702 5.832 11.28 7 11.28s2.304-.578 3.312-1.385c.999-.8 1.806-1.771 2.307-2.442A.8.8 0 0 0 12.75 7a.8.8 0 0 0-.132-.452c-.5-.672-1.308-1.643-2.307-2.443C9.304 3.3 8.168 2.72 7 2.72s-2.304.58-3.312 1.385c-.999.8-1.806 1.771-2.306 2.443M2.907 3.13C4.017 2.24 5.426 1.47 7 1.47c1.575 0 2.984.771 4.094 1.66c1.117.894 1.999 1.961 2.53 2.675l.006.007c.247.342.371.766.371 1.188c0 .423-.124.846-.371 1.188l-.005.007c-.532.714-1.414 1.782-2.531 2.676c-1.11.888-2.52 1.659-4.094 1.659s-2.983-.77-4.093-1.66c-1.118-.893-2-1.96-2.531-2.675l-.005-.007A2.04 2.04 0 0 1-.001 7c0-.422.125-.846.372-1.188l.005-.007c.532-.714 1.413-1.781 2.53-2.675M7 4.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVisibleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.933 3.491C4.056 2.681 5.456 2 7 2s2.944.682 4.067 1.491c1.128.812 2.02 1.784 2.56 2.437l.005.005c.241.3.368.681.368 1.067s-.127.766-.368 1.067l-.005.005c-.54.653-1.432 1.625-2.56 2.437C9.944 11.32 8.544 12 7 12s-2.944-.682-4.067-1.49C1.805 9.696.913 8.724.373 8.071l-.005-.005C.127 7.767 0 7.387 0 7s.127-.766.368-1.067l.005-.005c.54-.653 1.432-1.625 2.56-2.437M7 9.25a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceMail: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 6.5a2.5 2.5 0 1 1-5 0V3a2.5 2.5 0 1 1 5 0z\"/><path d=\"M12 7a4.49 4.49 0 0 1-4.5 4.5h-1A4.49 4.49 0 0 1 2 7m5 4.5v2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceMailOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5L.5.5m8 8a2.49 2.49 0 0 0 1-2V3a2.5 2.5 0 1 0-5 0v1.5m.23 3.04A2.5 2.5 0 0 0 6 8.79m4.42 1.63A4.46 4.46 0 0 0 12 7M2 7a4.49 4.49 0 0 0 4.5 4.5h1q.28.015.56 0M7 11.5v2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceMailOffRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 1 .884 0L3.513 2.63a3.627 3.627 0 0 1 7.112.996v2.25a3.62 3.62 0 0 1-1.185 2.68l.796.797a4.74 4.74 0 0 0 1.514-3.477a.75.75 0 0 1 1.5 0c0 1.788-.751 3.4-1.953 4.538l2.52 2.52a.625.625 0 1 1-.884.884L8.045 8.929l-.004-.004l-4.483-4.483l-.004-.004l-3.37-3.371a.625.625 0 0 1 0-.884M4 6.5a.625.625 0 0 1 .822.323a2.38 2.38 0 0 0 1.387 1.293a.625.625 0 0 1-.416 1.179A3.63 3.63 0 0 1 3.675 7.32A.625.625 0 0 1 4 6.5m4.302 5.49a6 6 0 0 1-.551.091v1.17a.75.75 0 0 1-1.5 0v-1.17a6.25 6.25 0 0 1-5.5-6.205a.75.75 0 0 1 1.5 0a4.75 4.75 0 0 0 5.74 4.647a.75.75 0 1 1 .311 1.467\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceMailOffSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.917.863a2.946 2.946 0 0 1 5.03 2.083v3.425a2.94 2.94 0 0 1-.66 1.856l1.022 1.021a3.73 3.73 0 0 0 .941-2.485a.75.75 0 0 1 1.5 0a5.23 5.23 0 0 1-1.38 3.547l2.41 2.41a.75.75 0 1 1-1.06 1.06L8.06 9.12h-.003L4.054 5.119v-.004L.22 1.28A.75.75 0 0 1 1.28.22l2.774 2.773v-.047c0-.781.31-1.53.863-2.083m2.833 10.4a.75.75 0 0 0-.75-.75h-.5a3.75 3.75 0 0 1-3.75-3.75a.75.75 0 1 0-1.5 0a5.25 5.25 0 0 0 5 5.244v1.213a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceMailRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25a2.375 2.375 0 0 0-2.375 2.375v2.25a2.375 2.375 0 0 0 4.75 0v-2.25A2.375 2.375 0 0 0 7 1.25M3.375 3.625a3.625 3.625 0 1 1 7.25 0v2.25a3.625 3.625 0 1 1-7.25 0zm4.375 8.456a6.25 6.25 0 0 0 5.5-6.206a.75.75 0 0 0-1.5 0a4.75 4.75 0 1 1-9.5 0a.75.75 0 0 0-1.5 0a6.25 6.25 0 0 0 5.5 6.206v1.169a.75.75 0 0 0 1.5 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceMailSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.75 0a2.946 2.946 0 0 0-2.946 2.946v3.425a2.946 2.946 0 1 0 5.892 0V2.946A2.946 2.946 0 0 0 6.75 0M6 12.008v1.212a.75.75 0 0 0 1.5 0v-1.213a5.25 5.25 0 0 0 5-5.244a.75.75 0 0 0-1.5 0a3.75 3.75 0 0 1-3.75 3.75h-1a3.75 3.75 0 0 1-3.75-3.75a.75.75 0 1 0-1.5 0a5.25 5.25 0 0 0 5 5.245\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceScan2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5.18v4.14m4-4.14v4.14M5 6.07v2.36m6-3.25v4.14M9 6.07v2.36m4.5 2.07v2a1 1 0 0 1-1 1h-2m0-13h2a1 1 0 0 1 1 1v2m-13 0v-2a1 1 0 0 1 1-1h2m0 13h-2a1 1 0 0 1-1-1v-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceScan2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625A.375.375 0 0 0 1.625 2v2a.625.625 0 1 1-1.25 0V2A1.625 1.625 0 0 1 2 .375h2a.625.625 0 1 1 0 1.25zm8-1.25a.625.625 0 1 0 0 1.25h2a.375.375 0 0 1 .375.375v2a.625.625 0 1 0 1.25 0V2A1.625 1.625 0 0 0 12 .375zM7 3.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 7 3.5m-2.75 1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75m6.25.75a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zM13 9.375c.345 0 .625.28.625.625v2A1.625 1.625 0 0 1 12 13.625h-2a.625.625 0 1 1 0-1.25h2a.375.375 0 0 0 .375-.375v-2c0-.345.28-.625.625-.625M1.625 10a.625.625 0 1 0-1.25 0v2A1.625 1.625 0 0 0 2 13.625h2a.625.625 0 1 0 0-1.25H2A.375.375 0 0 1 1.625 12z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVoiceScan2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.573 1.573A.25.25 0 0 1 1.75 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5A1.75 1.75 0 0 0 0 1.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.25.25 0 0 1 .073-.177M2.5 4.375c.345 0 .625.28.625.625v4.5a.625.625 0 1 1-1.25 0V5c0-.345.28-.625.625-.625m2.25 1c.345 0 .625.28.625.625v2.5a.625.625 0 1 1-1.25 0V6c0-.345.28-.625.625-.625M7.625 5a.625.625 0 1 0-1.25 0v4.5a.625.625 0 1 0 1.25 0zm1.625.375c.345 0 .625.28.625.625v2.5a.625.625 0 1 1-1.25 0V6c0-.345.28-.625.625-.625M12.125 5a.625.625 0 1 0-1.25 0v4.5a.625.625 0 1 0 1.25 0zm1.125 5a.75.75 0 0 1 .75.75v1.5A1.75 1.75 0 0 1 12.25 14h-1.5a.75.75 0 0 1 0-1.5h1.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 .75-.75M.75 10a.75.75 0 0 1 .75.75v1.5a.25.25 0 0 0 .25.25h1.5a.75.75 0 0 1 0 1.5h-1.5A1.75 1.75 0 0 1 0 12.25v-1.5A.75.75 0 0 1 .75 10m10-10a.75.75 0 0 0 0 1.5h1.5a.25.25 0 0 1 .25.25v1.5a.75.75 0 0 0 1.5 0v-1.5A1.75 1.75 0 0 0 12.25 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolcano: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.45 13.45s-3.97-1.984-3.97-4.96H4.52c0 2.977-3.97 4.961-3.97 4.961m9.923-7.939a1.984 1.984 0 1 0-1.23-3.542a2.48 2.48 0 0 0-4.485 0a1.984 1.984 0 1 0-1.23 3.542m1.984-.992v3.969M8.488 4.52v3.969\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolcanoRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.625c-.748 0-1.394.437-1.695 1.073a.625.625 0 0 1-.953.223A1.375 1.375 0 1 0 3.5 5.375a.625.625 0 1 1 0 1.25a2.625 2.625 0 1 1 1.03-5.04a3.123 3.123 0 0 1 4.94 0a2.625 2.625 0 1 1 1.03 5.04a.625.625 0 0 1 0-1.25a1.375 1.375 0 1 0-.852-2.454a.625.625 0 0 1-.952-.223A1.88 1.88 0 0 0 7 1.625M4 8.5a.5.5 0 0 1 .5-.5h.375V5a.625.625 0 1 1 1.25 0v3h1.75V5a.625.625 0 1 1 1.25 0v3H9.5a.5.5 0 0 1 .5.5c0 1.278.75 2.277 1.576 2.987a7.5 7.5 0 0 0 1.595 1.041l.024.011l.005.002a.5.5 0 0 1-.2.959H1a.5.5 0 0 1-.2-.958l.005-.003l.024-.01l.1-.048a7.5 7.5 0 0 0 1.496-.994C3.249 10.777 4 9.778 4 8.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolcanoSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.998.046a2.83 2.83 0 0 0-2.28 1.152a2.364 2.364 0 1 0-.986 4.513h.988V4.519a.625.625 0 1 1 1.25 0v2.843h2.056V4.519a.625.625 0 0 1 1.25 0V5.71h.988a2.364 2.364 0 1 0-.986-4.513A2.83 2.83 0 0 0 6.998.046m-2.807 8.94a.5.5 0 0 1 .5-.5h4.618a.5.5 0 0 1 .5.5c0 .917.612 1.786 1.473 2.528a9.8 9.8 0 0 0 2.368 1.48a.5.5 0 0 1-.195.96H.545a.5.5 0 0 1-.195-.96a9.8 9.8 0 0 0 2.368-1.48c.86-.742 1.473-1.611 1.473-2.528\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeDown: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5H1.5c-.545 0-1 .455-1 1v2c0 .545.455 1 1 1H3l3.91 2.81c.645.447 1.573-.024 1.59-.81V3A.954.954 0 0 0 7 2.19zm7.5 2h3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeDownRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.153 1.263C7.21.53 8.63 1.304 8.606 2.58v8.861c-.028 1.27-1.498 2.02-2.541 1.296a1 1 0 0 1-.08-.065l-3.162-3.08H1.606A1.615 1.615 0 0 1 0 7.985V6.017c0-.88.725-1.61 1.606-1.61h1.222l3.251-3.084a1 1 0 0 1 .074-.06M7.356 2.56a.31.31 0 0 0-.46-.288L3.507 5.486a.63.63 0 0 1-.43.172H1.606a.367.367 0 0 0-.356.359v1.967c0 .192.169.359.356.359h1.47c.164 0 .32.063.437.177l3.298 3.21a.36.36 0 0 0 .337-.006a.36.36 0 0 0 .208-.306zM9.82 6.25a.75.75 0 1 0 0 1.5h3.433a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeDownSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 3.005A1.454 1.454 0 0 0 6.716 1.78l-.003.002L2.842 4.5H1.5C.68 4.5 0 5.18 0 6v2c0 .82.68 1.5 1.5 1.5h1.339l3.78 2.716l.007.005c.97.672 2.348-.024 2.374-1.21zm1.813 3.245a.75.75 0 0 0 0 1.5h2.376a.75.75 0 0 0 0-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelHigh: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.495 10.5a6.9 6.9 0 0 0 1-3.5a6.9 6.9 0 0 0-1-3.5m-1.995 2c.348.42.526.955.5 1.5a2.2 2.2 0 0 1-.5 1.5M3 5H1.5c-.545 0-1 .455-1 1v2c0 .545.455 1 1 1H3l3.91 2.81c.645.447 1.573-.024 1.59-.81V3A.954.954 0 0 0 7 2.19z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelHighRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.155 1.261c1.057-.733 2.478.041 2.454 1.317v8.865c-.029 1.27-1.498 2.02-2.542 1.297a1 1 0 0 1-.08-.066l-3.163-3.08H1.606C.725 9.594 0 8.864 0 7.984V6.016c0-.88.725-1.609 1.606-1.609H2.83l3.253-3.086a1 1 0 0 1 .073-.06M7.36 2.557a.31.31 0 0 0-.46-.288L3.507 5.486a.63.63 0 0 1-.43.171H1.606a.37.37 0 0 0-.356.36v1.967c0 .193.169.36.356.36h1.472c.163 0 .32.063.436.177l3.299 3.212a.36.36 0 0 0 .338-.007a.36.36 0 0 0 .208-.306V2.557m4.52.367a.75.75 0 0 1 1.03.253A7.54 7.54 0 0 1 14 6.991v.018a7.54 7.54 0 0 1-1.09 3.813a.75.75 0 1 1-1.283-.777A6.04 6.04 0 0 0 12.5 7a6.04 6.04 0 0 0-.873-3.046a.75.75 0 0 1 .253-1.03M9.832 4.95a.75.75 0 0 1 1.056.1c.453.547.689 1.241.664 1.95a2.9 2.9 0 0 1-.664 1.95a.75.75 0 1 1-1.156-.956c.222-.269.336-.61.32-.958v-.072a1.4 1.4 0 0 0-.32-.958a.75.75 0 0 1 .1-1.056\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelHighSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 3.005A1.454 1.454 0 0 0 6.716 1.78l-.003.002L2.842 4.5H1.5C.68 4.5 0 5.18 0 6v2c0 .82.68 1.5 1.5 1.5h1.339l3.78 2.716l.007.005c.97.672 2.348-.024 2.374-1.21zm2.741.408a.75.75 0 0 1 1.056.1c.83 1.003 1.175 2.207 1.175 3.487s-.346 2.484-1.175 3.487a.75.75 0 0 1-1.156-.956c.566-.684.831-1.53.831-2.531s-.265-1.847-.83-2.53a.75.75 0 0 1 .1-1.057Zm-1.54 1.875a.75.75 0 0 1 .996.362c.197.419.292.881.276 1.35a2.94 2.94 0 0 1-.276 1.35a.75.75 0 0 1-1.358-.635a1.44 1.44 0 0 0 .134-.68v-.07a1.44 1.44 0 0 0-.134-.68a.75.75 0 0 1 .361-.997Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelLow: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10.5 5.5c.348.42.526.955.5 1.5a2.2 2.2 0 0 1-.5 1.5M3 5H1.5c-.545 0-1 .455-1 1v2c0 .545.455 1 1 1H3l3.91 2.81c.645.447 1.573-.024 1.59-.81V3A.954.954 0 0 0 7 2.19z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelLowRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.293 1.16C7.362.42 8.8 1.203 8.774 2.494v9.035c-.028 1.285-1.515 2.044-2.57 1.312a1 1 0 0 1-.08-.066l-3.23-3.144H1.65A1.636 1.636 0 0 1 .024 8.003V5.997c0-.89.734-1.628 1.625-1.628H2.9l3.32-3.148a1 1 0 0 1 .073-.06m1.232 1.312a.328.328 0 0 0-.489-.303L3.58 5.448a.63.63 0 0 1-.43.171h-1.5a.387.387 0 0 0-.376.378v2.006c0 .203.178.378.375.378h1.5c.163 0 .32.064.436.178l3.364 3.274a.38.38 0 0 0 .357-.006a.38.38 0 0 0 .218-.322V2.472m3.702 2.55a.75.75 0 1 0-1.155.956c.228.276.345.628.328.986v.072c.017.358-.1.71-.329.986a.75.75 0 0 0 1.156.956A2.94 2.94 0 0 0 11.9 7a2.94 2.94 0 0 0-.673-1.978\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelLowSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 3.005A1.454 1.454 0 0 0 6.716 1.78l-.003.002L2.842 4.5H1.5C.68 4.5 0 5.18 0 6v2c0 .82.68 1.5 1.5 1.5h1.339l3.78 2.716l.007.005c.97.672 2.348-.024 2.374-1.21zm2.414 2.017a.75.75 0 1 0-1.156.956c.228.276.346.628.329.986v.072c.017.358-.1.71-.33.986a.75.75 0 1 0 1.157.956A2.94 2.94 0 0 0 12.086 7a2.94 2.94 0 0 0-.672-1.978\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 5H1.5c-.545 0-1 .455-1 1v2c0 .545.455 1 1 1H3l3.91 2.81c.645.447 1.573-.024 1.59-.81V3A.954.954 0 0 0 7 2.19z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelOffRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.769 2.493C8.793 1.203 7.356.42 6.287 1.161a1 1 0 0 0-.074.06L2.894 4.369h-1.25c-.892 0-1.625.739-1.625 1.628v2.006c0 .89.733 1.628 1.625 1.628H2.89l3.228 3.143a1 1 0 0 0 .08.066c1.055.733 2.542-.027 2.57-1.312zM7.03 2.17a.328.328 0 0 1 .489.303v9.033a.38.38 0 0 1-.219.322a.38.38 0 0 1-.357.006L3.58 8.56a.63.63 0 0 0-.436-.178h-1.5a.387.387 0 0 1-.375-.378V5.997c0-.203.177-.378.375-.378h1.5c.16 0 .314-.061.43-.171z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeLevelOffSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.716 1.779A1.454 1.454 0 0 1 9 3.005v8.006c-.026 1.186-1.403 1.882-2.374 1.21l-.008-.005L2.84 9.5H1.5C.68 9.5 0 8.82 0 8V6c0-.82.68-1.5 1.5-1.5h1.342l3.87-2.72z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeMute: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 5.5l-3 3m0-3l3 3M3 5H1.5c-.545 0-1 .455-1 1v2c0 .545.455 1 1 1H3l3.91 2.81c.645.447 1.573-.024 1.59-.81V3A.954.954 0 0 0 7 2.19z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeMuteRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.153 1.263C7.21.53 8.63 1.304 8.606 2.58v8.861c-.028 1.27-1.498 2.02-2.541 1.296a1 1 0 0 1-.08-.065l-3.162-3.08H1.606A1.615 1.615 0 0 1 0 7.985V6.017c0-.88.725-1.61 1.606-1.61h1.222l3.251-3.084a1 1 0 0 1 .074-.06M7.356 2.56a.31.31 0 0 0-.46-.288L3.507 5.486a.63.63 0 0 1-.43.172H1.606a.367.367 0 0 0-.356.359v1.967c0 .192.169.359.356.359h1.47c.164 0 .32.063.437.177l3.298 3.21a.36.36 0 0 0 .337-.006a.36.36 0 0 0 .208-.306zM13.779 5a.75.75 0 0 1 0 1.06l-.941.94l.94.94a.75.75 0 1 1-1.06 1.061l-.94-.94l-.942.94a.75.75 0 0 1-1.06-1.06l.94-.941l-.94-.94a.75.75 0 1 1 1.06-1.062l.941.941l.941-.94a.75.75 0 0 1 1.06 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeMuteSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 3.005A1.454 1.454 0 0 0 6.716 1.78l-.003.002L2.842 4.5H1.5C.68 4.5 0 5.18 0 6v2c0 .82.68 1.5 1.5 1.5h1.339l3.78 2.716l.007.005c.97.672 2.348-.024 2.374-1.21zm4.78 2.09a.75.75 0 0 1 0 1.06L12.936 7l.844.845a.75.75 0 0 1-1.06 1.06l-.845-.844l-.845.844a.75.75 0 1 1-1.06-1.06L10.814 7l-.844-.845a.75.75 0 0 1 1.06-1.06l.845.844l.845-.844a.75.75 0 0 1 1.06 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5L.5.5m9.018 11.482a.97.97 0 0 1-.608-.172L5 9H3.5c-.545 0-1-.455-1-1V6c0-.256.1-.492.264-.67M5 5l4-2.81a.954.954 0 0 1 1.5.81v7.492\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeOffRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.067.183a.625.625 0 1 0-.884.884L4.56 5.444l.06.06l8.313 8.313a.625.625 0 1 0 .884-.884l-2.514-2.514V2.58C11.327 1.304 9.907.53 8.85 1.263a1 1 0 0 0-.073.06L5.525 4.408h-.233zm2.255 5.209c.345 0 .625.28.625.625v1.967c0 .193.169.359.356.359h1.47c.164 0 .32.063.437.177l3.298 3.211q.06.031.121.037a.625.625 0 0 1-.117 1.244a1.57 1.57 0 0 1-.75-.275a1 1 0 0 1-.08-.065L5.52 9.592H4.303a1.617 1.617 0 0 1-1.606-1.608V6.017c0-.346.28-.625.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVolumeOffSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22l3.866 3.866L8.713 1.58l.002-.002A1.454 1.454 0 0 1 11 2.805v7.134l2.78 2.78a.75.75 0 1 1-1.06 1.061l-2.06-2.06l-.005.006L3.25 4.321l.01-.002zm1.986 3.766l7.238 7.237a1.46 1.46 0 0 1-.818-.263l-.008-.005L4.84 9.3H3.5C2.68 9.3 2 8.62 2 7.8v-2c0-.273.075-.531.206-.753\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVpnConnection: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.283 5.076c.465-.31 1.857-.929 3.715-.929s3.25.619 3.714.929M4.63 7.063c.395-.198 1.42-.592 2.368-.592c.946 0 1.972.394 2.367.592M6.222 9.08c.13-.066.466-.195.776-.195s.646.13.775.194\"/><path stroke-miterlimit=\"10\" d=\"M7.377 13.43c-.189.094-.471.094-.754 0C2.95 12.013.5 8.426.5 4.463V1.538C.5.972.971.5 1.536.5h10.928c.565 0 1.036.472 1.036 1.038v2.926c0 4.058-2.45 7.55-6.123 8.965\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVpnConnectionRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .375C1.103.375.375 1.103.375 2v2.874a9.125 9.125 0 0 0 6.24 8.656l.187.063a.62.62 0 0 0 .396 0l.188-.063a9.125 9.125 0 0 0 6.239-8.656V2c0-.897-.727-1.625-1.625-1.625zM1.625 2c0-.207.168-.375.375-.375h10c.207 0 .375.168.375.375v2.874A7.875 7.875 0 0 1 7 12.34a7.875 7.875 0 0 1-5.375-7.467zm2.074 3.575c.342-.228 1.59-.803 3.298-.803s2.957.575 3.299.803a.75.75 0 1 0 .832-1.248c-.588-.392-2.125-1.055-4.13-1.055s-3.544.663-4.13 1.055a.75.75 0 1 0 .831 1.248M6.997 7.22c-.783 0-1.689.341-2.031.513a.75.75 0 0 1-.671-1.342c.447-.223 1.592-.671 2.702-.671s2.256.448 2.703.67a.75.75 0 0 1-.671 1.343c-.342-.172-1.248-.513-2.032-.513m-.44 2.654a1.3 1.3 0 0 1 .44-.115a1.3 1.3 0 0 1 .44.115a.75.75 0 1 0 .671-1.342c-.181-.09-.637-.273-1.11-.273s-.93.182-1.111.273a.75.75 0 1 0 .67 1.342\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVpnConnectionSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.538C0 .697.694 0 1.536 0h10.928C13.306 0 14 .697 14 1.538v2.926c0 4.258-2.569 7.93-6.424 9.424c-.345.162-.764.132-1.111.016l-.012-.005l-.01-.003C2.575 12.406 0 8.632 0 4.464zm3.655 3.593c.361-.268 1.625-.91 3.343-.91s2.98.642 3.342.91a.625.625 0 1 0 .744-1.004c-.568-.421-2.09-1.156-4.086-1.156s-3.52.735-4.087 1.156a.625.625 0 1 0 .744 1.004m3.343 1.674c-.796 0-1.713.384-2.064.579a.625.625 0 0 1-.607-1.093c.438-.243 1.573-.736 2.67-.736c1.099 0 2.233.493 2.671.736a.625.625 0 1 1-.607 1.093c-.351-.195-1.268-.58-2.063-.58m-.472 2.82a1.4 1.4 0 0 1 .208-.086a1 1 0 0 1 .264-.05a1.3 1.3 0 0 1 .471.136a.625.625 0 0 0 .607-1.092c-.172-.096-.617-.294-1.078-.294s-.906.198-1.08.294a.625.625 0 1 0 .608 1.092\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVrHeadset1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.286 13.5v-2.602a5.571 5.571 0 1 1 7.612-7.612M8.857 13.5v-2.32h1.857a.93.93 0 0 0 .929-.929V7.93M5.606 5.607H.518\"/><path d=\"M5.607 5.607A2.32 2.32 0 0 1 7.93 3.286h4.57a1 1 0 0 1 1 1v2.643a1 1 0 0 1-1 1H7.929a2.32 2.32 0 0 1-2.322-2.322m3.714-2.321v4.643\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVrHeadset1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.866 4.857c.623-1.88 2.385-3.232 4.456-3.232a4.64 4.64 0 0 1 2.892 1.036H7.928a2.95 2.95 0 0 0-2.85 2.196zM6.322.375c1.883 0 3.564.928 4.648 2.286H12c.898 0 1.625.727 1.625 1.625v2.643c0 .806-.587 1.475-1.357 1.603v1.86c0 .836-.677 1.512-1.512 1.512h-1.15V13a.625.625 0 1 1-1.25 0v-1.72c0-.346.28-.626.626-.626h1.774a.26.26 0 0 0 .262-.261v-1.84h-3.09a2.95 2.95 0 0 1-2.85-2.196H1.625c0 1.753.945 3.282 2.35 4.1c.193.112.31.318.31.54V13a.625.625 0 1 1-1.25 0v-1.656a5.99 5.99 0 0 1-2.66-4.987c0-3.3 2.658-5.982 5.947-5.982m2.374 3.536v3.392h-.768a1.696 1.696 0 1 1 0-3.392z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVrHeadset1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.071 0A6.07 6.07 0 0 0 .097 4.982h4.709a3.46 3.46 0 0 1 3.4-2.83h2.502A6.06 6.06 0 0 0 6.07 0M2.786 11.178A6.07 6.07 0 0 1 .002 6.232h4.804a3.46 3.46 0 0 0 3.4 2.831h3.937v1.187a1.43 1.43 0 0 1-1.429 1.429H9.357V13.5a.5.5 0 0 1-.5.5H3.286a.5.5 0 0 1-.5-.5zm9.345-3.365h.369q.053 0 .102-.005a1 1 0 0 0 .898-.995V4.401a1 1 0 0 0-1-1H9.946v4.412zm-3.435 0V3.401h-.49a2.206 2.206 0 0 0 0 4.412z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVrHeadset2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 6.992c0-1.02.831-1.849 1.857-1.849h9.286c1.026 0 1.857.828 1.857 1.85v3.663c0 1.203-1.138 2.096-2.327 1.884c-1.257-.223-2.824-.44-4.173-.44s-2.916.217-4.173.44C1.637 12.753.5 11.86.5 10.657zm4.179-1.849l.464-3.714h3.714l.464 3.714M4.214 7.929h5.572\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVrHeadset2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.559 1.527a.625.625 0 0 1 .62-.546H8.82c.315 0 .58.234.62.546l.386 3.026h1.727C12.896 4.553 14 5.63 14 6.975v3.559c0 1.591-1.502 2.712-3.016 2.445c-1.221-.215-2.716-.418-3.984-.418s-2.763.203-3.984.418C1.502 13.246 0 12.126 0 10.534v-3.56c0-1.345 1.104-2.42 2.446-2.42h1.727zm4.73 4.276H2.446c-.669 0-1.196.533-1.196 1.172v3.559c0 .745.73 1.359 1.549 1.214c1.244-.219 2.823-.437 4.201-.437s2.957.218 4.201.437c.82.145 1.549-.47 1.549-1.214v-3.56c0-.638-.527-1.17-1.196-1.17zm-5.02 1.483a.625.625 0 0 0 0 1.25h5.463a.625.625 0 0 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineVrHeadset2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.143.929a.5.5 0 0 0-.496.438l-.254 2.027h5.214l-.254-2.027a.5.5 0 0 0-.496-.438zm4.686 3.714l-.043.001H4.214l-.043-.001H2.357C1.057 4.643 0 5.693 0 6.993v3.663c0 1.537 1.441 2.639 2.915 2.377C4.163 12.81 5.695 12.6 7 12.6s2.837.21 4.085.433c1.474.262 2.915-.84 2.915-2.377V6.992c0-1.3-1.057-2.35-2.357-2.35zm-6.24 3.286c0-.345.28-.625.625-.625h5.572a.625.625 0 0 1 0 1.25H4.214a.625.625 0 0 1-.625-.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaitingAppointmentsCalendar: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M1.5 2a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-2M3.5.5v3m7-3v3M3.5 2h5\"/><path d=\"M6.188 4.562a.5.5 0 0 0-.5.5v1.406H4.28a.5.5 0 0 0-.5.5v1.625a.5.5 0 0 0 .5.5h1.407v1.406a.5.5 0 0 0 .5.5h1.625a.5.5 0 0 0 .5-.5V9.093h1.406a.5.5 0 0 0 .5-.5V6.968a.5.5 0 0 0-.5-.5H8.313V5.062a.5.5 0 0 0-.5-.5z\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaitingAppointmentsCalendarRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.125.875a.625.625 0 1 0-1.25 0V2H2A1.625 1.625 0 0 0 .375 3.625v8.25A1.625 1.625 0 0 0 2 13.5h10a1.625 1.625 0 0 0 1.625-1.625v-8.25A1.625 1.625 0 0 0 12 2h-.875V.875a.625.625 0 1 0-1.25 0V2h-5.75zm5.75 3V3.25h-5.75v.625a.625.625 0 1 1-1.25 0V3.25H2a.375.375 0 0 0-.375.375v8.25A.375.375 0 0 0 2 12.25h10a.375.375 0 0 0 .375-.375v-8.25A.375.375 0 0 0 12 3.25h-.875v.625a.625.625 0 1 1-1.25 0M5.832 5.614c0-.201.163-.364.364-.364h1.608c.201 0 .364.163.364.364v1.343h1.343c.201 0 .364.163.364.364v1.608a.364.364 0 0 1-.364.364H8.168v1.343a.364.364 0 0 1-.364.364H6.196a.364.364 0 0 1-.364-.364V9.293H4.489a.364.364 0 0 1-.364-.364V7.321c0-.201.163-.364.364-.364h1.343z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaitingAppointmentsCalendarSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 1a1 1 0 0 0-2 0v1h-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2h-1V1a1 1 0 1 0-2 0v1h-5zm1.47 4.428c0-.217.176-.392.393-.392h1.275c.216 0 .392.175.392.392v1.56h1.56c.217 0 .392.176.392.392v1.275a.39.39 0 0 1-.392.393H8.03v1.56a.39.39 0 0 1-.392.392H6.362a.39.39 0 0 1-.392-.392v-1.56H4.41a.39.39 0 0 1-.392-.393V7.38c0-.216.175-.392.392-.392h1.56z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWallet: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 10.5v2a1 1 0 0 1-1 1H1.5a1 1 0 0 1-1-1V5a3 3 0 0 1 3-3H10v2.5\"/><path d=\"M13 7.5H9.5A.5.5 0 0 0 9 8v2a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5m-1 0v-2a1 1 0 0 0-1-1H3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWalletPurse: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 12a6.5 6.5 0 1 0-13 0A1.5 1.5 0 0 0 2 13.5h10a1.5 1.5 0 0 0 1.5-1.5M9 1a2 2 0 1 1-4 0\"/><path d=\"M.64 5.64a9 9 0 0 1 12.72 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWalletPurseRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.08.188c.483 0 .875.391.875.875a1.045 1.045 0 0 0 2.09 0a.875.875 0 1 1 1.75 0c0 .487-.127.961-.364 1.378a9.33 9.33 0 0 1 4.193 2.462a.875.875 0 1 1-1.248 1.228A7.54 7.54 0 0 0 7 3.865a7.54 7.54 0 0 0-5.376 2.266a.875.875 0 0 1-1.248-1.228A9.33 9.33 0 0 1 4.57 2.441a2.8 2.8 0 0 1-.364-1.378c0-.484.392-.875.875-.875M2.314 7.09C3.556 5.843 5.242 5.141 7 5.141s3.444.702 4.686 1.95a6.67 6.67 0 0 1 1.939 4.705a2.02 2.02 0 0 1-.587 1.425a2 2 0 0 1-1.423.591h-9.23a2 2 0 0 1-1.423-.591a2.02 2.02 0 0 1-.587-1.425a6.67 6.67 0 0 1 1.94-4.705M7 6.391a5.36 5.36 0 0 0-3.8 1.582a5.42 5.42 0 0 0-1.575 3.823c0 .204.08.4.224.543a.76.76 0 0 0 .536.223h9.23c.2 0 .394-.08.536-.223a.77.77 0 0 0 .224-.543A5.42 5.42 0 0 0 10.8 7.973A5.36 5.36 0 0 0 7 6.39\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWalletPurseSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 .25a.75.75 0 0 1 .75.75a1.25 1.25 0 0 0 2.5 0a.75.75 0 0 1 1.5 0a2.75 2.75 0 0 1-.479 1.55a9.6 9.6 0 0 1 4.497 2.528a.75.75 0 0 1-1.06 1.062a8.077 8.077 0 0 0-11.416 0a.75.75 0 0 1-1.06-1.062A9.6 9.6 0 0 1 4.73 2.551A2.75 2.75 0 0 1 4.25 1A.75.75 0 0 1 5 .25M7 5a7 7 0 0 0-7 7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2a7 7 0 0 0-7-7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWalletRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 4.5a2.375 2.375 0 0 1 2.375-2.375h5.75v1.25h-5.75a.625.625 0 1 0 0 1.25H11a.375.375 0 0 1 .375.375v1.25H9.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1.875v1.25a.375.375 0 0 1-.375.375H1.625a.375.375 0 0 1-.375-.375zm11.375 1.75H13a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.375v1.25A1.625 1.625 0 0 1 11 13.125H1.625A1.625 1.625 0 0 1 0 11.5v-7A3.625 3.625 0 0 1 3.625.875H10c.345 0 .625.28.625.625v1.875H11A1.625 1.625 0 0 1 12.625 5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWalletSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 4.355a3.5 3.5 0 0 1 3.5-3.5H10a.5.5 0 0 1 .5.5v1.398H3.355a.625.625 0 1 0 0 1.25h7.585q.03 0 .058-.003h.214a1.5 1.5 0 0 1 1.5 1.5v.916h-2.95c-.824 0-1.75.625-1.75 1.695v1.778c0 1.07.926 1.695 1.75 1.695h2.95v.916a1.5 1.5 0 0 1-1.5 1.5H1.5A1.5 1.5 0 0 1 0 12.5zm9.763 3.311h3.5c.276 0 .5.2.5.445v1.778c0 .246-.224.445-.5.445h-3.5c-.276 0-.5-.2-.5-.445V8.111c0-.246.224-.445.5-.445\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaningCresentMoon: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 7a7 7 0 0 1 3.44-6A6.6 6.6 0 0 0 9 .5a6.5 6.5 0 1 0 0 13a6.6 6.6 0 0 0 2.47-.5A7 7 0 0 1 8 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaningCresentMoonRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M7.98 7a6.87 6.87 0 0 1 3.375-5.886A6.5 6.5 0 0 0 8.96.624a6.376 6.376 0 0 0 0 12.752a6.5 6.5 0 0 0 2.423-.49A6.87 6.87 0 0 1 7.981 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaningCresentMoonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 0a7 7 0 0 0 0 14h.004a7.1 7.1 0 0 0 2.657-.538a.5.5 0 0 0 .061-.894A6.5 6.5 0 0 1 8.5 7a6.5 6.5 0 0 1 3.194-5.568a.5.5 0 0 0-.063-.893A7.1 7.1 0 0 0 9.006 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarehouse1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 6.94a1 1 0 0 0-.32-.74L7 .5L.82 6.2a1 1 0 0 0-.32.74v5.56a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1z\"/><path d=\"M7.25 10.001h2.999s.25 0 .25.25v2.999s0 .25-.25.25H7.25s-.25 0-.25-.25v-2.999s0-.25.25-.25m-1.75-3.5h2.999s.25 0 .25.25V9.75s0 .25-.25.25H5.5s-.25 0-.25-.25V6.751s0-.25.25-.25m-1.749 3.5H6.75s.25 0 .25.25v2.999s0 .25-.25.25H3.751s-.25 0-.25-.25v-2.999s0-.25.25-.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarehouse1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.422.54a.625.625 0 0 0-.844 0L.902 5.741l.415.453l-.415-.453A1.63 1.63 0 0 0 .375 6.94V12c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V6.94c0-.456-.191-.89-.527-1.198zM1.747 6.662L7 1.848l5.253 4.815a.38.38 0 0 1 .122.277V12a.375.375 0 0 1-.375.375h-1V9.751a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25v2.624h-1V9.751a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25v2.624H2A.375.375 0 0 1 1.625 12V6.94c0-.105.044-.206.122-.277M5.25 5.626a.25.25 0 0 1 .25-.25h3a.25.25 0 0 1 .25.25v3a.25.25 0 0 1-.25.25h-3a.25.25 0 0 1-.25-.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarehouse1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 6.776a1 1 0 0 1 .318-.731L6.675.12a.5.5 0 0 1 .65 0l6.357 5.925a1 1 0 0 1 .318.731V12.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5zM6.77 8.75H5.503v-3h3v3H6.771Zm-2.024 4H6.5v-3h-3v3zm4.022 0H7.5v-3h3v3z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarningOctagon: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.793 13.207a1 1 0 0 1-.707.293H4.914a1 1 0 0 1-.707-.293L.793 9.793A1 1 0 0 1 .5 9.086V4.914a1 1 0 0 1 .293-.707L4.207.793A1 1 0 0 1 4.914.5h4.172a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707v4.172a1 1 0 0 1-.293.707zM7 4v3.25\"/><path d=\"M7 10a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarningOctagonRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.899 1.735c.07-.07.166-.11.265-.11h3.672c.1 0 .195.04.265.11l3.164 3.164c.07.07.11.166.11.265v3.672c0 .1-.04.195-.11.265l-3.164 3.164a.38.38 0 0 1-.265.11H5.164c-.1 0-.195-.04-.265-.11L1.735 9.101a.38.38 0 0 1-.11-.265V5.164c0-.1.04-.195.11-.265zm.265-1.36c-.43 0-.844.171-1.149.476L.851 4.015a1.63 1.63 0 0 0-.476 1.15v3.67c0 .432.171.845.476 1.15l3.164 3.164c.305.305.718.476 1.15.476h3.67c.432 0 .845-.171 1.15-.476l3.164-3.164c.305-.305.476-.718.476-1.15v-3.67c0-.432-.171-.845-.476-1.15L9.985.851a1.63 1.63 0 0 0-1.15-.476zm2.586 3.5a.75.75 0 0 0-1.5 0v3.25a.75.75 0 0 0 1.5 0zm-1.75 6a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarningOctagonSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.854.44A1.5 1.5 0 0 1 4.914 0h4.172a1.5 1.5 0 0 1 1.06.44l3.415 3.414A1.5 1.5 0 0 1 14 4.914v4.172a1.5 1.5 0 0 1-.44 1.06l-3.414 3.415a1.5 1.5 0 0 1-1.06.439H4.914a1.5 1.5 0 0 1-1.06-.44L.439 10.147A1.5 1.5 0 0 1 0 9.086V4.914c0-.398.158-.78.44-1.06zM7 3.124a.75.75 0 0 1 .75.75v3.25a.75.75 0 0 1-1.5 0v-3.25a.75.75 0 0 1 .75-.75m1 6.75a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarningTriangle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.89 1.05a1 1 0 0 0-1.78 0l-5.5 11a1 1 0 0 0 .89 1.45h11a1 1 0 0 0 .89-1.45zM7 5v3.25\"/><path d=\"M7 11a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarningTriangleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.676 2.188a.375.375 0 0 1 .648 0l5.374 9.214a.375.375 0 0 1-.324.564H1.626a.375.375 0 0 1-.324-.564zm1.727-.63a1.625 1.625 0 0 0-2.807 0L.222 10.773a1.625 1.625 0 0 0 1.404 2.444h10.748a1.625 1.625 0 0 0 1.404-2.444zM7.75 4.376a.75.75 0 1 0-1.5 0v3.25a.75.75 0 1 0 1.5 0zm-1.75 6a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWarningTriangleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.218.226a1.5 1.5 0 0 1 2.117.596l.002.004l5.5 10.999A1.5 1.5 0 0 1 12.5 14h-11a1.5 1.5 0 0 1-1.336-2.174v-.001L5.664.826l.002-.004a1.5 1.5 0 0 1 .553-.596M7 4.125a.75.75 0 0 1 .75.75v3.25a.75.75 0 0 1-1.5 0v-3.25a.75.75 0 0 1 .75-.75m1 6.75a1 1 0 1 1-2 0a1 1 0 0 1 2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatch1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M9.5 3.25V1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.75m5 7.484V12.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.766\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatch1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v1.344A5.12 5.12 0 0 1 12.125 7A5.12 5.12 0 0 1 10 11.156V12.5A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-1.344A5.12 5.12 0 0 1 1.875 7A5.12 5.12 0 0 1 4 2.844V1.5c0-.398.158-.78.44-1.06M3.124 7a3.875 3.875 0 1 1 7.75 0a3.875 3.875 0 0 1-7.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatch1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v1.191A5.24 5.24 0 0 1 12.25 7c0 1.784-.89 3.36-2.25 4.309V12.5A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-1.191A5.24 5.24 0 0 1 1.75 7c0-1.784.89-3.36 2.25-4.309V1.5c0-.398.158-.78.44-1.06M7 3.25a3.75 3.75 0 1 0 0 7.5a3.75 3.75 0 0 0 0-7.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatch2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 2.5v-1a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1m5 9v1a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1m6-9h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatch2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0A1.5 1.5 0 0 0 4 1.5v.375h-.5c-.897 0-1.625.728-1.625 1.625v7c0 .898.728 1.625 1.625 1.625H4v.375A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5-1.5v-.375h.5c.898 0 1.625-.727 1.625-1.625v-7c0-.897-.727-1.625-1.625-1.625H10V1.5A1.5 1.5 0 0 0 8.5 0zM3.125 3.5c0-.207.168-.375.375-.375h7c.207 0 .375.168.375.375v7a.375.375 0 0 1-.375.375h-7a.375.375 0 0 1-.375-.375z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatch2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v.25h.5c.966 0 1.75.784 1.75 1.75v7a1.75 1.75 0 0 1-1.75 1.75H10v.25A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-.25h-.5a1.75 1.75 0 0 1-1.75-1.75v-7c0-.966.784-1.75 1.75-1.75H4V1.5c0-.398.158-.78.44-1.06M3.25 3.5a.25.25 0 0 1 .25-.25h7a.25.25 0 0 1 .25.25v7a.25.25 0 0 1-.25.25h-7a.25.25 0 0 1-.25-.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleCharging: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.49 4.815l-1.658 2.24H8l-1.183 2.13\"/><path d=\"M7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M9.5 3.25V1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.75m5 7.484V12.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.766\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleChargingRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v1.344A5.12 5.12 0 0 1 12.125 7A5.12 5.12 0 0 1 10 11.156V12.5A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-1.344A5.12 5.12 0 0 1 1.875 7A5.12 5.12 0 0 1 4 2.844V1.5c0-.398.158-.78.44-1.06m3.414 4.724a.625.625 0 1 0-.951-.81l-1.908 2.24a.625.625 0 0 0 .476 1.03h1.708l-1.03 1.212a.625.625 0 1 0 .952.81l1.905-2.243a.625.625 0 0 0-.476-1.03H6.824zM3.125 7a3.875 3.875 0 1 1 7.75 0a3.875 3.875 0 0 1-7.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleChargingSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0A1.5 1.5 0 0 0 4 1.5v1.191A5.24 5.24 0 0 0 1.75 7c0 1.784.89 3.36 2.25 4.309V12.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5-1.5v-1.191A5.24 5.24 0 0 0 12.25 7c0-1.784-.89-3.36-2.25-4.309V1.5A1.5 1.5 0 0 0 8.5 0zM3.25 7a3.75 3.75 0 1 1 7.5 0a3.75 3.75 0 0 1-7.5 0m4.742-1.813a.625.625 0 1 0-1.005-.744L5.33 6.683a.625.625 0 0 0 .503.997h1.106l-.667 1.202a.625.625 0 1 0 1.093.606l1.182-2.13A.625.625 0 0 0 8 6.43h-.928z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleHeartbeatMonitor1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7.487 8.926a.695.695 0 0 1-.972 0L4.88 7.349C3.787 6.285 5.215 3.932 7 5.672c1.782-1.737 3.21.616 2.12 1.677z\"/><path d=\"M7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M9.5 3.25V1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.75m5 7.484V12.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.766\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleHeartbeatMonitor1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v1.344A5.12 5.12 0 0 1 12.125 7A5.12 5.12 0 0 1 10 11.156V12.5A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-1.344A5.12 5.12 0 0 1 1.875 7A5.12 5.12 0 0 1 4 2.844V1.5c0-.398.158-.78.44-1.06M7 5.14c-.402-.3-.817-.456-1.227-.465a1.66 1.66 0 0 0-1.287.579c-.58.66-.73 1.822.046 2.578l.002.002L6.168 9.41a1.195 1.195 0 0 0 1.666 0l1.634-1.577l.001-.002c.776-.755.624-1.917.044-2.576a1.66 1.66 0 0 0-1.285-.579c-.41.008-.825.163-1.227.462M3.126 7a3.875 3.875 0 1 1 7.75 0a3.875 3.875 0 0 1-7.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleHeartbeatMonitor1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0A1.5 1.5 0 0 0 4 1.5v1.191A5.24 5.24 0 0 0 1.75 7c0 1.784.89 3.36 2.25 4.309V12.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5-1.5v-1.191A5.24 5.24 0 0 0 12.25 7c0-1.784-.89-3.36-2.25-4.309V1.5A1.5 1.5 0 0 0 8.5 0zM3.25 7a3.75 3.75 0 1 1 7.5 0a3.75 3.75 0 0 1-7.5 0m1.631.35l1.634 1.576a.695.695 0 0 0 .972 0L9.12 7.349C10.21 6.288 8.783 3.935 7 5.672c-1.784-1.74-3.212.613-2.119 1.677Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleHeartbeatMonitor2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.21 7h1.033l1.02-1.667L7.576 8.75L8.562 7H9.79\"/><path d=\"M7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M9.5 3.25V1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.75m5 7.484V12.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.766\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleHeartbeatMonitor2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v1.344A5.12 5.12 0 0 1 12.125 7A5.12 5.12 0 0 1 10 11.156V12.5A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-1.344A5.12 5.12 0 0 1 1.875 7A5.12 5.12 0 0 1 4 2.844V1.5c0-.398.158-.78.44-1.06m2.407 4.628a.625.625 0 0 0-1.117-.103l-.838 1.368H4.46a.625.625 0 0 0 0 1.25h.784a.62.62 0 0 0 .532-.298l.36-.586l.857 2.233a.625.625 0 0 0 1.128.083l.807-1.432h.614a.625.625 0 0 0 0-1.25h-.98a.63.63 0 0 0-.544.319l-.334.593zM3.125 7a3.875 3.875 0 1 1 7.75 0a3.875 3.875 0 0 1-7.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleHeartbeatMonitor2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0A1.5 1.5 0 0 0 4 1.5v1.191A5.24 5.24 0 0 0 1.75 7c0 1.784.89 3.36 2.25 4.309V12.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5-1.5v-1.191A5.24 5.24 0 0 0 12.25 7c0-1.784-.89-3.36-2.25-4.309V1.5A1.5 1.5 0 0 0 8.5 0zM3.25 7a3.75 3.75 0 1 1 7.5 0a3.75 3.75 0 0 1-7.5 0m3.819-1.568a.625.625 0 0 0-1.117-.102l-.645 1.053H4.82a.625.625 0 1 0 0 1.25h.838c.218 0 .42-.113.533-.299l.166-.27l.61 1.587a.625.625 0 0 0 1.128.083l.62-1.101h.632a.625.625 0 0 0 0-1.25H8.35a.63.63 0 0 0-.544.318l-.148.262z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleMenu: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 5.75H7.102M9 8.25H7.102M7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M9.5 3.25V1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.75m5 7.484V12.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.766M5.258 6a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5m0 3a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleMenuRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v1.344A5.12 5.12 0 0 1 12.125 7A5.12 5.12 0 0 1 10 11.156V12.5A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-1.344A5.12 5.12 0 0 1 1.875 7A5.12 5.12 0 0 1 4 2.844V1.5c0-.398.158-.78.44-1.06m.81 6.185a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75m1.375-.875c0-.345.28-.625.625-.625h1.648a.625.625 0 0 1 0 1.25H7.25a.625.625 0 0 1-.625-.625m0 2.5c0-.345.28-.625.625-.625h1.648a.625.625 0 0 1 0 1.25H7.25a.625.625 0 0 1-.625-.625m-1.375.875a.875.875 0 1 1 0-1.75a.875.875 0 0 1 0 1.75M3.125 7a3.875 3.875 0 1 1 7.75 0a3.875 3.875 0 0 1-7.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleMenuSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0A1.5 1.5 0 0 0 4 1.5v1.191A5.24 5.24 0 0 0 1.75 7c0 1.784.89 3.36 2.25 4.309V12.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5-1.5v-1.191A5.24 5.24 0 0 0 12.25 7c0-1.784-.89-3.36-2.25-4.309V1.5A1.5 1.5 0 0 0 8.5 0zM3.25 7a3.75 3.75 0 1 1 7.5 0a3.75 3.75 0 0 1-7.5 0m1.867-.385a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m1.498-.75c0-.346.28-.625.625-.625h1.75a.625.625 0 1 1 0 1.25H7.24a.625.625 0 0 1-.625-.625m0 2.27c0-.345.28-.625.625-.625h1.75a.625.625 0 1 1 0 1.25H7.24a.625.625 0 0 1-.625-.625m-.748 0a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleTime: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 4.875V7l1.25 1.25\"/><path d=\"M7 11.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M9.5 3.25V1.5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.75m5 7.484V12.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.766\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleTimeRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.44.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5v1.344A5.12 5.12 0 0 1 12.125 7A5.12 5.12 0 0 1 10 11.156V12.5A1.5 1.5 0 0 1 8.5 14h-3A1.5 1.5 0 0 1 4 12.5v-1.344A5.12 5.12 0 0 1 1.875 7A5.12 5.12 0 0 1 4 2.844V1.5c0-.398.158-.78.44-1.06M7 4.25c.345 0 .625.28.625.625v1.866l1.067 1.067a.625.625 0 1 1-.884.884l-1.25-1.25A.63.63 0 0 1 6.375 7V4.875c0-.345.28-.625.625-.625M3.125 7a3.875 3.875 0 1 1 7.75 0a3.875 3.875 0 0 1-7.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWatchCircleTimeSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.5 0A1.5 1.5 0 0 0 4 1.5v1.191A5.24 5.24 0 0 0 1.75 7c0 1.784.89 3.36 2.25 4.309V12.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5-1.5v-1.191A5.24 5.24 0 0 0 12.25 7c0-1.784-.89-3.36-2.25-4.309V1.5A1.5 1.5 0 0 0 8.5 0zM3.25 7a3.75 3.75 0 1 1 7.5 0a3.75 3.75 0 0 1-7.5 0m4.438-1.956a.625.625 0 1 0-1.25 0v1.912c0 .166.065.325.183.442l1.125 1.125a.625.625 0 1 0 .883-.884l-.941-.942z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaterGlass: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.2 11.73a2 2 0 0 1-2 1.77H4.78a2 2 0 0 1-2-1.77L1.5.5h11zM1.96 4.5h10.08\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaterGlassRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 0a.625.625 0 0 0-.62.698l1.395 11.867c.097.818.79 1.435 1.614 1.435h6.222c.824 0 1.517-.617 1.614-1.435L13.12.698A.624.624 0 0 0 12.5 0zm1.07 4.375L2.203 1.25h9.594l-.368 3.125z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaterGlassSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.175.277a.75.75 0 0 1 .56-.25h10.53a.75.75 0 0 1 .746.836l-.545 4.71v.003l-.7 6.039a2.665 2.665 0 0 1-2.662 2.358H4.877a2.665 2.665 0 0 1-2.662-2.358v-.002l-.689-6.038L.99.862a.75.75 0 0 1 .186-.585m10.249 1.25l-.372 3.213H2.941l-.366-3.213z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaveSignal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7.08h2.19a.52.52 0 0 0 .45-.27l1.8-3.6a.49.49 0 0 1 .49-.27a.48.48 0 0 1 .43.35l2.23 7.42a.5.5 0 0 0 .46.36a.5.5 0 0 0 .45-.32l1.37-3.35a.51.51 0 0 1 .47-.32h2.66\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaveSignalRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M.625 7h1.757a1 1 0 0 0 .894-.553l1.619-3.236a.381.381 0 0 1 .698.036l2.82 7.519a.36.36 0 0 0 .675 0l1.169-3.117A1 1 0 0 1 11.193 7h2.182\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaveSignalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m5.267 4.792l1.864 6.203a1.5 1.5 0 0 0 1.452 1.074a1.5 1.5 0 0 0 1.345-.948l1.244-3.041H13a1 1 0 1 0 0-2h-2.166a1.51 1.51 0 0 0-1.39.944L8.627 9.02L6.82 3.01a1.48 1.48 0 0 0-1.304-1.065a1.49 1.49 0 0 0-1.471.82L2.387 6.08H1a1 1 0 0 0 0 2h1.702a1.52 1.52 0 0 0 1.332-.823z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaveSignalSquare: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.5.5h-7a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3\"/><path d=\"M.5 7.02h4L6 4.51l1.5 5.5l2-2.99h4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaveSignalSquareRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 1.625h10c.207 0 .375.168.375.375v4.26H10.5a.75.75 0 0 0-.575.269L8.189 8.604L6.183 4.19a.75.75 0 0 0-1.27-.157L3.14 6.26H1.625V2c0-.207.168-.375.375-.375M1.625 7.76V12c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375V7.76h-1.524l-2.276 2.721a.75.75 0 0 1-1.258-.17L5.324 5.924L4.087 7.477a.75.75 0 0 1-.587.283zM12 .375H2C1.103.375.375 1.103.375 2v10c0 .898.728 1.625 1.625 1.625h10c.898 0 1.625-.727 1.625-1.625V2c0-.897-.727-1.625-1.625-1.625\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWaveSignalSquareSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0A3.5 3.5 0 0 0 0 3.5v2.895h4.145l1.319-2.206a.625.625 0 0 1 1.139.156l1.14 4.178l1.237-1.85a.63.63 0 0 1 .52-.278H14V3.5A3.5 3.5 0 0 0 10.5 0zM14 7.645H9.834L8.02 10.357a.625.625 0 0 1-1.123-.183L5.783 6.091l-.746 1.25a.63.63 0 0 1-.537.304H0V10.5A3.5 3.5 0 0 0 3.5 14h7a3.5 3.5 0 0 0 3.5-3.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWavingHand: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.044 3.938a2.86 2.86 0 0 0-.546-1.508m-9.081-.866A2.86 2.86 0 0 1 4.644.531m-1.476 11.48l-.345-.393A6 6 0 0 1 1.71 9.762l-.688-1.835A1.11 1.11 0 0 1 1.38 6.66v0a1.113 1.113 0 0 1 1.706.429l.58 1.325c.436.116 1.433.57 1.943 1.452\"/><path d=\"M3.666 8.416L5.123 2.98c.161-.6.778-.957 1.38-.796v0c.6.16.956.778.795 1.379l-.874 3.262l1.224-4.567c.16-.6.778-.957 1.379-.796v0c.6.16.957.778.796 1.378l-1.34 5.003l.757-2.828c.161-.6.778-.957 1.379-.796v0c.6.161.957.779.796 1.38l-1.709 6.376a2 2 0 0 1-.932 1.215l-.385.222\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWavingHandRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.771 1.197A.625.625 0 1 0 4.266.053a3.5 3.5 0 0 0-1.494 1.258a.625.625 0 0 0 1.04.694c.247-.37.582-.642.96-.808m8.563.739a.625.625 0 0 0-1.01.738c.244.332.399.736.427 1.18A.625.625 0 0 0 14 3.771a3.5 3.5 0 0 0-.665-1.836M2.685 7.304a.488.488 0 0 0-.904.367l.687 1.835c.229.61.566 1.173.996 1.663l.346.393a.625.625 0 1 1-.939.825l-.345-.393a6.6 6.6 0 0 1-1.228-2.05L.61 8.11a1.738 1.738 0 0 1 3.075-1.574l1.006-3.755a1.75 1.75 0 0 1 2.635-1.022a1.751 1.751 0 0 1 3.272 1.206l-.149.554a1.75 1.75 0 0 1 1.741 2.204L10.482 12.1a2.63 2.63 0 0 1-1.223 1.594l-.385.222a.625.625 0 1 1-.625-1.082l.385-.223c.316-.182.547-.483.64-.835l1.71-6.377a.5.5 0 0 0-.968-.26l-.758 2.828a.625.625 0 0 1-1.207-.323l.758-2.828l.582-2.175a.5.5 0 0 0-.967-.259l-.35 1.305L7.2 6.949a.625.625 0 0 1-1.207-.323l.874-3.263a.5.5 0 0 0-.968-.259L4.59 7.997c.567.267 1.289.753 1.732 1.522a.625.625 0 1 1-1.082.624c-.383-.66-1.163-1.043-1.53-1.15l-.033-.008a.62.62 0 0 1-.419-.372z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWavingHandSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.741.064a.75.75 0 1 1 .606 1.372a2.1 2.1 0 0 0-.906.763a.75.75 0 1 1-1.248-.832A3.6 3.6 0 0 1 3.741.064M2.543 12.469l-.447-.508a5.8 5.8 0 0 1-1.07-1.786l-.775-2.07a1.19 1.19 0 0 1 2.203-.894l.62 1.415l-.016.06c.347.093 1.157.474 1.547 1.15a.625.625 0 1 0 1.082-.625c-.62-1.075-1.789-1.594-2.305-1.733l1.355-5.06a.894.894 0 1 1 1.727.463l-.925 3.452a.447.447 0 0 0 .863.232l1.272-4.747A.894.894 0 0 1 9.4 2.28L8.128 7.027a.447.447 0 1 0 .863.232l.682-2.546a.928.928 0 0 1 1.793.48l-1.962 7.32a1.93 1.93 0 0 1-.896 1.169a1.94 1.94 0 0 1-1.28.183l-3.64-.728a2.04 2.04 0 0 1-1.145-.668m9.613-10.645a.75.75 0 0 1 1.048.163a3.6 3.6 0 0 1 .689 1.902a.75.75 0 1 1-1.497.097a2.1 2.1 0 0 0-.403-1.114a.75.75 0 0 1 .163-1.048\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWeb: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13M.5 7h13\"/><path d=\"M9.5 7A11.22 11.22 0 0 1 7 13.5A11.22 11.22 0 0 1 4.5 7A11.22 11.22 0 0 1 7 .5A11.22 11.22 0 0 1 9.5 7\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.677 1.403a5.76 5.76 0 0 0-4.394 4.973h2.686c.183-1.77.769-3.47 1.708-4.973m2.646 0a11.6 11.6 0 0 1 1.708 4.973h2.686a5.76 5.76 0 0 0-4.394-4.973m.45 4.973A10.4 10.4 0 0 0 7 1.666a10.4 10.4 0 0 0-1.773 4.71zm-3.546 1.25h3.546A10.4 10.4 0 0 1 7 12.336a10.4 10.4 0 0 1-1.773-4.71m-1.258 0H1.283a5.76 5.76 0 0 0 4.394 4.973a11.6 11.6 0 0 1-1.708-4.973m4.354 4.973a11.6 11.6 0 0 0 1.708-4.973h2.686a5.76 5.76 0 0 1-4.394 4.973M7 14.002A7.001 7.001 0 1 0 7 0a7.001 7.001 0 0 0 0 14.002\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.049.276A7.01 7.01 0 0 0 .028 6.375h3.2a15.8 15.8 0 0 1 1.82-6.1m-1.82 7.35h-3.2a7.01 7.01 0 0 0 5.02 6.1a15.8 15.8 0 0 1-1.82-6.1m3.424 6.367a14.5 14.5 0 0 1-2.17-6.367h5.035a14.5 14.5 0 0 1-2.17 6.367a7 7 0 0 1-.695 0m2.3-.268a7.01 7.01 0 0 0 5.02-6.099h-3.2a15.8 15.8 0 0 1-1.82 6.1m1.82-7.349h3.2a7.01 7.01 0 0 0-5.02-6.1a15.8 15.8 0 0 1 1.82 6.1M6.652.008a7 7 0 0 1 .696 0a14.5 14.5 0 0 1 2.169 6.367H4.483c.217-2.277.963-4.46 2.17-6.367\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcam: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 12.52a6 6 0 1 0 0-12a6 6 0 0 0 0 12\"/><path d=\"M10.07 11.68a7.4 7.4 0 0 1 2.48 1.8m-11.1 0a7.4 7.4 0 0 1 2.48-1.8M7 9.52a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/><path d=\"M7 7.02a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.375 6.625a5.375 5.375 0 1 0-10.75 0a5.375 5.375 0 0 0 10.75 0M7 0a6.625 6.625 0 0 1 4.743 11.25a8.3 8.3 0 0 1 1.46 1.292a.875.875 0 0 1-1.306 1.166a6.5 6.5 0 0 0-1.627-1.32A6.6 6.6 0 0 1 7 13.25a6.6 6.6 0 0 1-3.27-.862a6.5 6.5 0 0 0-1.627 1.32a.875.875 0 0 1-1.306-1.166a8.3 8.3 0 0 1 1.46-1.291A6.625 6.625 0 0 1 7 0m3.5 6.625a3.5 3.5 0 1 0-7 0a3.5 3.5 0 0 0 7 0M7 5.375a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.5 6.52a6.5 6.5 0 1 1 10.954 4.734a8.2 8.2 0 0 1 1.653 1.401a.75.75 0 1 1-1.114 1.005a6.7 6.7 0 0 0-1.864-1.441c-.928.51-1.995.801-3.129.801s-2.2-.29-3.129-.801a6.7 6.7 0 0 0-1.864 1.441a.75.75 0 0 1-1.114-1.005a8.2 8.2 0 0 1 1.653-1.4A6.48 6.48 0 0 1 .5 6.52M7 3.27a3.25 3.25 0 1 0 0 6.5a3.25 3.25 0 0 0 0-6.5m0 2.25a1 1 0 1 0 0 2a1 1 0 0 0 0-2\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideo: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.82 3.75L10 5V3.5a1 1 0 0 0-1-1H1.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1H9a1 1 0 0 0 1-1V9l2.82 1.25a.5.5 0 0 0 .68-.47V4.22a.5.5 0 0 0-.68-.47\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"m10.135 5.25l-1.52.673v-.808a.54.54 0 0 0-.538-.539h-4.04a.54.54 0 0 0-.538.539v3.77a.54.54 0 0 0 .539.539h4.04a.54.54 0 0 0 .538-.539v-.808l1.519.673a.27.27 0 0 0 .366-.253V5.503a.27.27 0 0 0-.366-.254\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0M3.481 4.423a.8.8 0 0 1 .558-.23h4.038a.79.79 0 0 1 .789.788v.558l1.165-.517c.37-.166.72.142.72.481v2.994c0 .343-.36.62-.707.486l-.011-.004l-1.167-.518v.558a.79.79 0 0 1-.789.789H4.039a.79.79 0 0 1-.789-.789V4.981c0-.21.083-.41.231-.558\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7m8.616-1.077l1.519-.673a.27.27 0 0 1 .366.253v2.994a.27.27 0 0 1-.366.254l-1.52-.674v.808a.54.54 0 0 1-.538.539h-4.04a.54.54 0 0 1-.538-.539v-3.77a.54.54 0 0 1 .539-.539h4.04a.54.54 0 0 1 .538.539z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoOff: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5L.5.5m2 2H9a1 1 0 0 1 1 1V5l2.82-1.25a.5.5 0 0 1 .68.47v5.56a.5.5 0 0 1-.68.47L10 9v1M.5 3.5v7a1 1 0 0 0 1 1h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoOffRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.183.183a.625.625 0 0 1 .884 0L2.634 1.75h6.241A1.625 1.625 0 0 1 10.5 3.375v.79l1.97-.873c.345-.133.74-.086 1.045.124c.303.21.487.562.485.93v5.307c.002.369-.182.721-.485.931c-.304.21-.7.257-1.045.124l-1.576-.698l2.923 2.923a.625.625 0 1 1-.884.884L.183 1.067a.625.625 0 0 1 0-.884M.625 3.5c.345 0 .625.28.625.625v6.5a.375.375 0 0 0 .375.375h6.5a.625.625 0 1 1 0 1.25h-6.5A1.625 1.625 0 0 1 0 10.625v-6.5C0 3.78.28 3.5.625 3.5\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoOffSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.22 1.28A.75.75 0 0 1 1.28.22L3.06 2H9a1.5 1.5 0 0 1 1.5 1.5v.742l2.106-.903A1 1 0 0 1 14 4.26v5.483a1 1 0 0 1-1.394.919l-1.548-.664l2.722 2.723a.75.75 0 1 1-1.06 1.06zM0 3.5q.002-.302.11-.563l9.054 9.054A2 2 0 0 1 9 12H1.5A1.5 1.5 0 0 1 0 10.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"m12.695 3.875l-2.82 1.25v-1.75a1 1 0 0 0-1-1h-7.25a1 1 0 0 0-1 1v7.25a1 1 0 0 0 1 1h7.25a1 1 0 0 0 1-1v-1.75l2.82 1.25a.5.5 0 0 0 .68-.47v-5.31a.5.5 0 0 0-.68-.47\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWebcamVideoSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12H9a1.5 1.5 0 0 0 1.5-1.5v-.742l2.106.903A1 1 0 0 0 14 9.74V4.259a1 1 0 0 0-1.394-.919l-2.106.903V3.5A1.5 1.5 0 0 0 9 2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWhatsapp: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 .88C3.665.88.88 3.67.88 7.002a6.14 6.14 0 0 0 1.025 3.39L.877 13.127l3.439-.622A6.1 6.1 0 0 0 7 13.121c3.338.002 6.127-2.784 6.127-6.118c0-3.33-2.79-6.126-6.127-6.124\"/><path d=\"M7.337 9.7c.829.531 1.692.144 2.294-.305c.415-.31.401-.907.047-1.285l-.7-.745c-.265.265-.783.397-1.142.287c-.773-.235-1.097-.637-1.36-1.047c-.301-.47.04-1.172.305-1.437l-.78-.712c-.329-.3-.828-.35-1.115-.01c-.568.673-.92 1.696-.503 2.347c.75 1.169 1.785 2.156 2.954 2.906\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWhatsappRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7c0-3.812-3.183-7.002-7.002-7S0 3.186.002 7a7 7 0 0 0 .997 3.602l-.96 2.554a.625.625 0 0 0 .697.835l3.382-.612c.91.41 1.896.616 2.88.617C10.817 13.998 14 10.817 14 7M6.998 1.25C10.126 1.248 12.75 3.877 12.75 7c0 3.126-2.622 5.748-5.752 5.746a5.75 5.75 0 0 1-2.52-.58a.63.63 0 0 0-.386-.053l-2.495.452l.681-1.814a.63.63 0 0 0-.064-.566A5.77 5.77 0 0 1 1.25 7c0-3.124 2.621-5.75 5.747-5.75M4.406 3.923c.535-.616 1.37-.45 1.834-.027l.863.787a.5.5 0 0 1 .016.723c-.078.078-.198.26-.262.472c-.065.216-.042.355.006.43c.13.202.255.37.424.516c.166.144.395.281.744.387a.74.74 0 0 0 .375-.01a.76.76 0 0 0 .338-.17a.5.5 0 0 1 .718.011l.781.832c.512.545.593 1.495-.103 2.029c-.67.512-1.865 1.143-3.054.38c-1.294-.83-2.447-1.927-3.286-3.235c-.33-.513-.323-1.127-.183-1.657c.141-.536.434-1.06.79-1.468\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWhatsappSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .38c3.614-.003 6.627 3.016 6.627 6.623c0 3.61-3.013 6.62-6.627 6.618a6.6 6.6 0 0 1-2.753-.596l-3.28.593a.5.5 0 0 1-.558-.668l.94-2.498a6.64 6.64 0 0 1-.97-3.45C.38 3.395 3.39.382 7 .38m3.325 9.436c-.737.596-1.878 1.198-2.969.498c-1.43-.919-2.696-2.126-3.614-3.557c-.539-.838-.032-2.18.726-2.998c.302-.327.8-.275 1.129.025l.692.632c.21.192.218.526.087.78c-.207.398-.329.933-.073 1.332c.322.5.718.993 1.664 1.28c.286.088.653.05.965-.076c.261-.106.592-.105.785.101l.644.685c.355.378.367.972-.036 1.298\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWheelchair: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 13.5a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\"/><path d=\"M4.2 6.51L3 .5H.5\"/><path d=\"M7.46 10.5h4.5l.267.977L10.78 6.17a2 2 0 0 0-2-1.67h-5m7.3 3.5H6.87m5.63 5.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWheelchair1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 4.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0 0v4h3a1 1 0 0 1 1 1v4m-6.5-7a3.5 3.5 0 1 0 3.22 4.88\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWheelchair1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.25 1.25a1.125 1.125 0 1 0 0 2.25a1.125 1.125 0 0 0 0-2.25M5.875 2.375a2.375 2.375 0 1 1 4.75 0a2.375 2.375 0 0 1-4.75 0M9 8.75V6.577a1.327 1.327 0 0 0-2.614-.322L5.92 8.117A1.515 1.515 0 0 0 7.39 10h.516l.054-.001L8 10h2.286c.16 0 .303.102.355.253l1.143 3.325a.625.625 0 0 0 1.182-.406l-1.143-3.325a1.625 1.625 0 0 0-1.537-1.097zM4.61 7.046a.625.625 0 1 0-.22-1.23A4.126 4.126 0 1 0 8.66 12a.625.625 0 0 0-1.07-.645a2.875 2.875 0 1 1-2.979-4.31\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWheelchair1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.98 0a2 2 0 1 0 0 4a2 2 0 0 0 0-4m0 5a1 1 0 0 1 1 1v2h1.54a1.98 1.98 0 0 1 1.98 1.98V13a1 1 0 0 1-2 0v-3H7.98a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M5.53 7.133a.75.75 0 1 0-.002-1.5a4.182 4.182 0 1 0 3.23 6.844a.75.75 0 0 0-1.157-.954a2.684 2.684 0 0 1-3.233.708A2.682 2.682 0 0 1 5.53 7.133\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWheelchairRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 .375a.625.625 0 1 0 0 1.25h1.795l.62 3.105a.6.6 0 0 0 .034.168l.235 1.18a3.73 3.73 0 1 0 4.27 3.47h2.791l.18.658a1.75 1.75 0 1 0 1.253-.153l-.35-1.288l-.004-.013l-.724-2.654a2.47 2.47 0 0 0-2.46-2.03H4.556L3.921.877a.625.625 0 0 0-.613-.503zm6.659 7.923h2.745l-.518-1.9l-.013-.061a1.22 1.22 0 0 0-1.221-1.02H4.807l.159.794a3.74 3.74 0 0 1 2.693 2.187M2.25 9.768a1.98 1.98 0 1 1 3.96 0a1.98 1.98 0 0 1-3.96 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWheelchairSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.832.082a.75.75 0 0 0 0 1.5H2.59l.936 4.688a3.834 3.834 0 1 0 4.097 4.801h2.753a1.898 1.898 0 1 0 2.068-.902l-.012-.045l-.005-.015l-1.107-4.06a2.65 2.65 0 0 0-2.635-2.171H4.577L3.94.685a.75.75 0 0 0-.736-.603zm9.893 9.49H7.716a3.8 3.8 0 0 0-.224-.873h2.995zm-.647-2.373H6.441a3.8 3.8 0 0 0-1.355-.767l-.007-.044l-.202-1.01h3.822a1.15 1.15 0 0 1 1.148.958l.016.074z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWidget: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 9.5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1.5a1 1 0 0 1 1-1zM7 1a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1H1.932a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm5.469 0a.5.5 0 0 1 .5.5v1.25a.5.5 0 0 1-.5.5H10.5a.5.5 0 0 1-.5-.5V1.5a.5.5 0 0 1 .5-.5zm0 4.25a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5H10.5A.5.5 0 0 1 10 7V5.75a.5.5 0 0 1 .5-.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWidgetRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.568 1.875v4.75c0 .897-.727 1.625-1.625 1.625H1.875A1.625 1.625 0 0 1 .25 6.625v-4.75C.25.978.978.25 1.875.25h5.068c.898 0 1.625.728 1.625 1.625m3.807 10.25v-1.25A.375.375 0 0 0 12 10.5H2a.375.375 0 0 0-.375.375v1.25c0 .207.168.375.375.375h10a.375.375 0 0 0 .375-.375m1.25-1.25v1.25c0 .898-.727 1.625-1.625 1.625H2a1.625 1.625 0 0 1-1.625-1.625v-1.25c0-.897.728-1.625 1.625-1.625h10c.898 0 1.625.728 1.625 1.625M12.5 1.5h-1.719v1.125H12.5zm1.25-.125V2.75c0 .621-.504 1.125-1.125 1.125h-1.969A1.125 1.125 0 0 1 9.531 2.75V1.375c0-.621.504-1.125 1.125-1.125h1.969c.621 0 1.125.504 1.125 1.125m-2.969 4.5H12.5V7h-1.719zm2.969 1.25V5.75c0-.621-.504-1.125-1.125-1.125h-1.969c-.621 0-1.125.504-1.125 1.125v1.375c0 .621.504 1.125 1.125 1.125h1.969c.621 0 1.125-.504 1.125-1.125\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWidgetSolid: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M12.5 9.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM7 .5a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1H1.432a1 1 0 0 1-1-1V1.5a1 1 0 0 1 1-1zm6 4.25a.5.5 0 0 1 .5.5V7.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V5.25a.5.5 0 0 1 .5-.5zM13 .5a.5.5 0 0 1 .5.5v2.25a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 .5-.5z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifi: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 12.25a1.31 1.31 0 1 0 0-2.62a1.31 1.31 0 0 0 0 2.62M4.53 8a3.49 3.49 0 0 1 5 0M2.36 6.31a6.55 6.55 0 0 1 9.29 0\"/><path d=\"M.5 4.45a9.19 9.19 0 0 1 13 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiAntenna: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.18 9.137a4.52 4.52 0 0 1-1.93-3.53a4.52 4.52 0 0 1 1.93-3.56m-1.98 8.53a6.3 6.3 0 0 1-2.7-5A6.31 6.31 0 0 1 3.19.637m5.63 8.5a4.52 4.52 0 0 0 1.93-3.55a4.52 4.52 0 0 0-1.93-3.54m1.98 8.53a6.3 6.3 0 0 0 2.7-5a6.31 6.31 0 0 0-2.69-5M7 7.137a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 0v6.359\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiAntennaRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.626 1.105a.625.625 0 1 1 .8-.96A7.13 7.13 0 0 1 14 5.636a7.13 7.13 0 0 1-2.575 5.492a.625.625 0 0 1-.8-.961a5.88 5.88 0 0 0 2.125-4.53a5.88 5.88 0 0 0-2.124-4.532M8.677 2.781a.625.625 0 0 1 .634-1.077a4.56 4.56 0 0 1 2.25 3.933A4.56 4.56 0 0 1 9.31 9.57a.625.625 0 1 1-.634-1.077a3.31 3.31 0 0 0 1.634-2.856A3.31 3.31 0 0 0 8.677 2.78M9 5.637a2 2 0 1 0-2.625 1.9v5.838a.625.625 0 1 0 1.25 0V7.537A2 2 0 0 0 9 5.637M5.544 1.926a.625.625 0 0 0-.856-.222A4.56 4.56 0 0 0 2.44 5.637A4.56 4.56 0 0 0 4.69 9.57a.625.625 0 1 0 .635-1.077A3.31 3.31 0 0 1 3.69 5.637c0-1.216.655-2.279 1.633-2.856a.625.625 0 0 0 .222-.855m-2.17-.82a.625.625 0 1 0-.8-.961A7.13 7.13 0 0 0 0 5.636a7.13 7.13 0 0 0 2.575 5.492a.625.625 0 0 0 .8-.961a5.88 5.88 0 0 1-2.125-4.53c0-1.823.826-3.451 2.124-4.532\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiAntennaSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.63.247a.75.75 0 1 0-.963 1.15c.53.443.976 1.039 1.294 1.746a6 6 0 0 1 .513 2.297a6 6 0 0 1-.515 2.298a4.86 4.86 0 0 1-1.298 1.744a.75.75 0 0 0 .96 1.153c.72-.6 1.3-1.383 1.705-2.28a7.5 7.5 0 0 0 .648-2.932a7.5 7.5 0 0 0-.645-2.895A6.4 6.4 0 0 0 11.63.247M5.35 8.664a.75.75 0 0 1-1.055.101A4.14 4.14 0 0 1 3.18 7.3a4.8 4.8 0 0 1-.43-1.892a4.8 4.8 0 0 1 .428-1.851a4.14 4.14 0 0 1 1.116-1.47a.75.75 0 1 1 .955 1.156a2.64 2.64 0 0 0-.708.94a3.3 3.3 0 0 0-.291 1.246c.016.44.118.865.292 1.243c.177.384.422.702.706.937a.75.75 0 0 1 .102 1.056Zm3.274-6.448a.75.75 0 0 1 1.055-.101c.472.389.85.893 1.114 1.466a4.8 4.8 0 0 1 .43 1.892a4.8 4.8 0 0 1-.428 1.851A4.14 4.14 0 0 1 9.68 8.796a.75.75 0 1 1-.954-1.157c.285-.235.53-.555.708-.94c.174-.379.275-.806.29-1.246a3.3 3.3 0 0 0-.292-1.243a2.65 2.65 0 0 0-.706-.937a.75.75 0 0 1-.101-1.056ZM3.4 10.54a.75.75 0 0 1-1.057.093A6.4 6.4 0 0 1 .645 8.352A7.5 7.5 0 0 1 0 5.423a7.5 7.5 0 0 1 .648-2.898A6.35 6.35 0 0 1 2.354.245a.75.75 0 1 1 .96 1.153a4.86 4.86 0 0 0-1.298 1.744A6 6 0 0 0 1.5 5.44a6 6 0 0 0 .514 2.297a4.9 4.9 0 0 0 1.293 1.746a.75.75 0 0 1 .094 1.057ZM7 3.876a1.624 1.624 0 0 0-.748 3.065L6.25 7v6.149a.75.75 0 0 0 1.5 0V7q0-.03-.002-.059A1.623 1.623 0 0 0 7 3.876\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiDisabled: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13M7 13.25a1.31 1.31 0 1 0 0-2.62a1.31 1.31 0 0 0 0 2.62M4.53 9a3.5 3.5 0 0 1 1.143-.78M2.36 7.31c.609-.612 1.257-.986 1.257-.986m1.933-.781s.592-.165 1.455-.165A6.55 6.55 0 0 1 11.65 7.31M3.482 3.457A9.19 9.19 0 0 1 13.5 5.45m-13 0c.36-.36.732-.657 1.176-.99\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiDisabledRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.067.183a.625.625 0 1 0-.884.884l12.75 12.75a.625.625 0 1 0 .884-.884L6.888 6.004h.117a5.93 5.93 0 0 1 4.202 1.747a.625.625 0 0 0 .886-.882a7.18 7.18 0 0 0-6.347-2.007l-1.14-1.14a8.57 8.57 0 0 1 8.335 2.055a.625.625 0 0 0 .868-.9A9.82 9.82 0 0 0 3.617 2.733zm2.761 6.745a.625.625 0 0 0-.672-1.054a7.6 7.6 0 0 0-1.24.995a.625.625 0 1 0 .887.882a6.3 6.3 0 0 1 1.025-.823M6.114 8.01a.625.625 0 0 1-.3.831a2.9 2.9 0 0 0-.837.595a.625.625 0 1 1-.895-.872a4.1 4.1 0 0 1 1.2-.855a.625.625 0 0 1 .832.3M7 10.13a1.81 1.81 0 1 0 0 3.62a1.81 1.81 0 0 0 0-3.62M2.05 4.176a.625.625 0 0 1-.12.876c-.333.252-.61.477-.874.728a.625.625 0 1 1-.863-.904c.312-.298.631-.555.98-.82a.625.625 0 0 1 .876.12\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiDisabledSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.219.219a.75.75 0 0 0 0 1.06l.178.179q.027.022.051.046l12.328 12.328a.75.75 0 0 0 1.005-1.112L7.289 6.228a5.42 5.42 0 0 1 3.56 1.592a.75.75 0 0 0 1.065-1.057a6.92 6.92 0 0 0-6.02-1.955l-.021.004l-.819-.818a7.91 7.91 0 0 1 7.54 2.075a.75.75 0 0 0 1.061-1.06a9.41 9.41 0 0 0-9.802-2.217L1.28.22a.75.75 0 0 0-1.061 0m4.695 7.518l1.11 1.11a2.5 2.5 0 0 0-.814.56a.75.75 0 1 1-1.075-1.046q.353-.362.78-.624m-1.81-1.81l1.084 1.084v.001h-.002l-.014.01l-.063.038a5.6 5.6 0 0 0-.95.76a.75.75 0 0 1-1.063-1.057a7 7 0 0 1 1.008-.836m-1.77-1.77l1.07 1.07a9 9 0 0 0-.999.842a.75.75 0 1 1-1.06-1.06c.317-.319.64-.585.989-.852m6.976 7.782a1.31 1.31 0 1 1-2.62 0a1.31 1.31 0 0 1 2.62 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiHorizontal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.43 10.57A4.54 4.54 0 0 1 3.5 7a4.56 4.56 0 0 1 1.93-3.58M3.2 12A6.35 6.35 0 0 1 .5 7a6.37 6.37 0 0 1 2.69-5m5.38 8.57A4.54 4.54 0 0 0 10.5 7a4.56 4.56 0 0 0-1.93-3.58M10.8 12a6.35 6.35 0 0 0 2.7-5a6.37 6.37 0 0 0-2.69-5M7 7.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiHorizontalRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.812 1.166a.625.625 0 0 0 .195.862a5.87 5.87 0 0 1 2.743 4.97a5.87 5.87 0 0 1-2.747 4.973a.625.625 0 0 0 .666 1.058c2-1.26 3.331-3.49 3.331-6.03A7.12 7.12 0 0 0 10.675.97a.625.625 0 0 0-.863.195M7 5.75a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5m1.17-1.407a.625.625 0 1 1 .55-1.123a4.205 4.205 0 0 1 .003 7.558a.625.625 0 1 1-.55-1.123a2.955 2.955 0 0 0-.002-5.312M4.189 1.166a.625.625 0 0 1-.195.862a5.87 5.87 0 0 0-2.743 4.97a5.87 5.87 0 0 0 2.747 4.973a.625.625 0 0 1-.666 1.058A7.12 7.12 0 0 1 0 6.999A7.12 7.12 0 0 1 3.326.97a.625.625 0 0 1 .862.195m1.641 3.177a.625.625 0 1 0-.548-1.123a4.205 4.205 0 0 0-.004 7.558a.625.625 0 1 0 .55-1.123a2.955 2.955 0 0 1 .002-5.312\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiHorizontalSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.813 2.232a.75.75 0 1 0-.93-1.177A7.4 7.4 0 0 0 .82 3.657a8.2 8.2 0 0 0-.8 3.364a8.2 8.2 0 0 0 .803 3.325a7.4 7.4 0 0 0 2.072 2.601a.75.75 0 0 0 .926-1.18a5.9 5.9 0 0 1-1.648-2.073A6.7 6.7 0 0 1 1.52 7c.03-.945.254-1.866.651-2.692a5.9 5.9 0 0 1 1.642-2.076m2.094 2.054a.75.75 0 1 0-.845-1.24a5.05 5.05 0 0 0-1.57 1.712a4.9 4.9 0 0 0-.62 2.272a4.9 4.9 0 0 0 .62 2.218c.381.681.92 1.265 1.572 1.707a.75.75 0 0 0 .841-1.242a3.54 3.54 0 0 1-1.104-1.198a3.4 3.4 0 0 1-.429-1.51a3.4 3.4 0 0 1 .43-1.516a3.55 3.55 0 0 1 1.105-1.203m1.989-1.042a.75.75 0 0 1 1.042-.198a5.05 5.05 0 0 1 1.57 1.712a4.9 4.9 0 0 1 .62 2.272a4.9 4.9 0 0 1-.62 2.218a5 5 0 0 1-1.572 1.707a.75.75 0 0 1-.841-1.242a3.54 3.54 0 0 0 1.104-1.198a3.4 3.4 0 0 0 .429-1.51a3.4 3.4 0 0 0-.43-1.516a3.55 3.55 0 0 0-1.105-1.203a.75.75 0 0 1-.197-1.042m3.22-2.19a.75.75 0 1 0-.93 1.178a5.9 5.9 0 0 1 1.643 2.076A6.7 6.7 0 0 1 12.479 7a6.7 6.7 0 0 1-.652 2.694a5.9 5.9 0 0 1-1.648 2.073a.75.75 0 0 0 .926 1.18a7.4 7.4 0 0 0 2.072-2.6a8.2 8.2 0 0 0 .803-3.368a8.2 8.2 0 0 0-.8-3.322a7.4 7.4 0 0 0-2.063-2.602ZM5.75 7a1.25 1.25 0 1 1 2.5 0a1.25 1.25 0 0 1-2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiRouter: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 11.5v-2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1m2.5 1v1m0-3h.5m2 0H6M1 3l1.5 5.5M13 3l-1.5 5.5M3.55 2c1.9-1.9 5-1.9 6.9 0M5.355 3.533c.859-.859 2.33-.859 3.19 0M11 12.5v1M6.95 5.872a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiRouterRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.08 2.83a4.14 4.14 0 0 1 5.84 0a.75.75 0 0 0 1.06-1.06a5.64 5.64 0 0 0-7.96 0a.75.75 0 0 0 1.06 1.06m-2.48.24a.625.625 0 0 0-1.197.36L1.67 7.659A1.626 1.626 0 0 0 .375 9.25v2c0 .898.728 1.625 1.625 1.625h.375v.375a.625.625 0 1 0 1.25 0v-.375h6.75v.375a.625.625 0 1 0 1.25 0v-.375H12c.898 0 1.625-.727 1.625-1.625v-2c0-.784-.556-1.439-1.295-1.591l1.269-4.23a.625.625 0 1 0-1.197-.359l-1.367 4.555h-8.07zm9.4 8.555h1a.375.375 0 0 0 .375-.375v-2A.375.375 0 0 0 12 8.875H2a.375.375 0 0 0-.375.375v2c0 .207.168.375.375.375zm-8-2a.625.625 0 0 0 0 1.25h.5a.625.625 0 1 0 0-1.25zm1.875.625c0-.345.28-.625.625-.625H6a.625.625 0 1 1 0 1.25h-.5a.625.625 0 0 1-.625-.625m3.139-5.887c-.566-.566-1.563-.566-2.129 0a.75.75 0 1 1-1.06-1.06c1.151-1.152 3.098-1.152 4.25 0a.75.75 0 0 1-1.061 1.06M5.95 5.923a1 1 0 1 0 2 0a1 1 0 0 0-2 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiRouterSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.233 2.753a3.92 3.92 0 0 1 5.534 0a.75.75 0 0 0 1.06-1.06a5.42 5.42 0 0 0-7.655 0a.75.75 0 1 0 1.061 1.06M6.95 6.266a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5m.995-2.048c-.527-.527-1.46-.527-1.987 0a.75.75 0 1 1-1.06-1.06c1.113-1.114 2.995-1.114 4.108 0a.75.75 0 0 1-1.06 1.06M1.99 2.981a.75.75 0 1 0-1.447.395L1.599 7.25h1.554zm11.469.395L12.4 7.25h-1.554l1.164-4.269a.75.75 0 0 1 1.447.395m-11.03 9.838V12.5H1.5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.927v.714a.75.75 0 0 1-1.5 0V12.5H3.927v.714a.75.75 0 0 1-1.5 0m.25-2.867a.5.5 0 0 1 .5-.5h.478a.5.5 0 1 1 0 1h-.478a.5.5 0 0 1-.5-.5m2.89-.5a.5.5 0 1 0 0 1h.477a.5.5 0 1 0 0-1z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiSignalFullRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.056 4.5A8.6 8.6 0 0 1 7 2.125c2.141 0 4.28.792 5.944 2.375a.625.625 0 0 0 .862-.905A9.85 9.85 0 0 0 7 .875c-2.45 0-4.901.907-6.806 2.72a.625.625 0 0 0 .862.905m1.613 1.991a6.125 6.125 0 0 1 8.662 0a.625.625 0 0 0 .884-.884a7.375 7.375 0 0 0-10.43 0a.625.625 0 0 0 .884.884m6.894 1.84a3.625 3.625 0 0 0-5.126 0a.625.625 0 0 1-.884-.884a4.875 4.875 0 0 1 6.894 0a.625.625 0 1 1-.884.884M9 11a2 2 0 1 0-4 0a2 2 0 0 0 4 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWifiSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.916 3.381a8.06 8.06 0 0 1 8.782 1.747a.75.75 0 1 0 1.06-1.06a9.556 9.556 0 0 0-13.517 0a.75.75 0 1 0 1.061 1.06a8.1 8.1 0 0 1 2.614-1.747M7 5.61a5.53 5.53 0 0 0-3.919 1.63a.75.75 0 0 1-1.064-1.058a7.027 7.027 0 0 1 9.966 0a.75.75 0 1 1-1.064 1.058A5.53 5.53 0 0 0 7 5.61m-.98 2.939a2.59 2.59 0 0 1 2.867.58a.75.75 0 1 0 1.075-1.047a4.094 4.094 0 0 0-5.866 0A.75.75 0 1 0 5.17 9.13c.242-.248.531-.446.85-.58Zm-.612 3.164a1.592 1.592 0 1 1 3.184 0a1.592 1.592 0 0 1-3.184 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindFlow1: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.5.5a1.75 1.75 0 0 1 0 3.5h-7m11.25 6.5a1.75 1.75 0 0 0 0-3.5H2m5.25 6.5a1.75 1.75 0 0 0 0-3.5H1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindFlow1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.75.875c0-.345.28-.625.625-.625h.25a2.375 2.375 0 1 1 0 4.75h-7a.625.625 0 1 1 0-1.25h7a1.125 1.125 0 0 0 0-2.25h-.25A.625.625 0 0 1 6.75.875M1 9.625C1 9.28 1.28 9 1.625 9h5.5a2.375 2.375 0 1 1 0 4.75h-.25a.625.625 0 1 1 0-1.25h.25a1.125 1.125 0 0 0 0-2.25h-5.5A.625.625 0 0 1 1 9.625m1.125-3.25a.625.625 0 1 0 0 1.25h9.5a1.125 1.125 0 0 1 0 2.25h-.25a.625.625 0 1 0 0 1.25h.25a2.375 2.375 0 1 0 0-4.75z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindFlow1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.75.75A.75.75 0 0 1 7.5 0a2.5 2.5 0 1 1 0 5H.75a.75.75 0 0 1 0-1.5H7.5a1 1 0 0 0 0-2a.75.75 0 0 1-.75-.75M2 7a.75.75 0 0 1 .75-.75h8.75a2.5 2.5 0 0 1 0 5a.75.75 0 0 1 0-1.5a1 1 0 1 0 0-2H2.75A.75.75 0 0 1 2 7m-.25 2a.75.75 0 0 0 0 1.5h5.5a1 1 0 0 1 0 2a.75.75 0 0 0 0 1.5a2.5 2.5 0 0 0 0-5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindFlow2: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 3.5a10.3 10.3 0 0 1 4-1c2 0 3 1.5 5 1.5a10.3 10.3 0 0 0 4-1l-2-1M.5 7.5a10.3 10.3 0 0 1 4-1c2 0 3 1.5 5 1.5a10.3 10.3 0 0 0 4-1l-2-1m-11 5.5a10.3 10.3 0 0 1 4-1c2 0 3 1.5 5 1.5a10.3 10.3 0 0 0 4-1l-2-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindFlow2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.816 1.72a.625.625 0 0 1 .839-.279l2 1a.625.625 0 0 1-.01 1.123c-1.325.633-2.767.995-4.114 1.06l-.03.001c-1.149 0-2.012-.432-2.748-.8l-.032-.016c-.754-.377-1.38-.68-2.207-.684c-1.288.059-2.438.374-3.62.939a.625.625 0 1 1-.538-1.128c1.32-.63 2.636-.995 4.116-1.06l.028-.001c1.148 0 2.012.432 2.747.8l.033.016c.753.376 1.378.68 2.205.684a9.4 9.4 0 0 0 2.362-.44l-.751-.376a.625.625 0 0 1-.28-.839m0 4a.625.625 0 0 1 .839-.279l2 1a.625.625 0 0 1-.01 1.123c-1.32.63-2.637.995-4.117 1.06l-.028.001c-1.148 0-2.011-.432-2.747-.8l-.032-.016c-.754-.377-1.38-.68-2.207-.684c-1.288.059-2.438.374-3.62.939a.625.625 0 1 1-.538-1.128c1.32-.63 2.636-.995 4.116-1.06l.028-.001c1.148 0 2.012.432 2.747.8l.033.016c.753.377 1.378.68 2.207.684a8.8 8.8 0 0 0 2.372-.434l-.763-.382a.625.625 0 0 1-.28-.839m.839 3.721a.625.625 0 0 0-.56 1.118l.764.382a8.8 8.8 0 0 1-2.372.434c-.829-.003-1.454-.307-2.207-.684l-.033-.016c-.735-.368-1.599-.8-2.747-.8h-.028c-1.48.066-2.797.43-4.116 1.061a.625.625 0 1 0 .539 1.128c1.181-.565 2.33-.88 3.619-.939c.828.003 1.453.307 2.207.684l.032.016c.736.368 1.599.8 2.747.8h.028c1.48-.066 2.797-.43 4.117-1.061a.625.625 0 0 0 .01-1.123z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindFlow2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.673.834a.75.75 0 0 0-1.085.796l.168.946q-.676.14-1.369.173c-.747-.004-1.315-.287-2.041-.665l-.04-.02c-.703-.366-1.564-.814-2.71-.814h-.034A10.4 10.4 0 0 0 .416 2.328a.75.75 0 1 0 .668 1.343a8.9 8.9 0 0 1 3.529-.921c.747.004 1.315.287 2.041.665l.04.02c.703.366 1.564.815 2.71.815l.034-.001a10.3 10.3 0 0 0 4.146-1.078a.75.75 0 0 0 .338-1.005a.75.75 0 0 0-.334-.336zM4.562 5.751l.034-.001c1.146 0 2.007.448 2.71.814l.04.02c.726.378 1.294.662 2.041.666q.707-.034 1.398-.18l-.192-.916a.75.75 0 0 1 1.08-.82l1.915.996a.747.747 0 0 1 .36.943a.75.75 0 0 1-.364.399a10.5 10.5 0 0 1-1.705.668a10.3 10.3 0 0 1-2.475.41c-1.146 0-2.007-.448-2.71-.814l-.04-.02c-.726-.378-1.294-.662-2.041-.666a8.9 8.9 0 0 0-3.53.922a.75.75 0 1 1-.667-1.344a10.4 10.4 0 0 1 4.146-1.077m0 4.5h.034c1.146 0 2.007.448 2.71.814l.04.02c.726.378 1.294.661 2.041.665a9 9 0 0 0 1.402-.18l-.195-.912a.75.75 0 0 1 1.079-.823l1.915.996a.747.747 0 0 1 .36.942a.75.75 0 0 1-.364.4a10.4 10.4 0 0 1-4.18 1.078c-1.146 0-2.007-.449-2.71-.815l-.04-.02c-.726-.378-1.294-.661-2.041-.665a8.9 8.9 0 0 0-3.53.921a.75.75 0 1 1-.667-1.343a10.4 10.4 0 0 1 4.146-1.078\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindmill: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.5 7.936c-.5 1.688-1 3.814-1 5.564h7c0-1.73-.488-3.825-.982-5.503M7 5.5v-5h.5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2z\"/><path d=\"M4.5 8.5v-1a2 2 0 0 1 2-2H7v5h-.5a2 2 0 0 1-2-2m7.5-3H7V6a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2zM7 5v.5H2V5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindmillRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.882.03a.5.5 0 0 0-.642.3L7.237 3.088a2 2 0 0 0-.474 0L5.76.329A.5.5 0 0 0 5.12.03a5.52 5.52 0 0 0-3.29 3.288a.5.5 0 0 0 .3.641l2.758 1.004a2 2 0 0 0 0 .473L2.13 6.44a.5.5 0 0 0-.299.641c.322.883.863 1.66 1.557 2.266c-.278 1.247-.512 2.613-.512 4.028c0 .345.28.625.625.625h7c.345 0 .625-.28.625-.625c0-1.415-.234-2.781-.512-4.028a5.5 5.5 0 0 0 1.557-2.266a.5.5 0 0 0-.3-.64L9.113 5.435a2 2 0 0 0 0-.473l2.759-1.004a.5.5 0 0 0 .299-.64A5.51 5.51 0 0 0 8.882.03M7.237 7.312a2 2 0 0 1-.474 0L5.76 10.07a.5.5 0 0 1-.64.3a6 6 0 0 1-.615-.268a17.6 17.6 0 0 0-.363 2.648H9.86c-.046-.9-.185-1.787-.363-2.648q-.297.15-.614.267a.5.5 0 0 1-.641-.298zM6.125 5.2a.875.875 0 1 1 1.75 0a.875.875 0 0 1-1.75 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindmillSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 4.531a1.5 1.5 0 0 0-1.5-1.5H3.063a1.5 1.5 0 0 0-1.5 1.5V5H6.5zM3.537 9.605C3.232 10.895 3 12.277 3 13.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5c0-1.426-.316-3.07-.694-4.531H9a2.5 2.5 0 0 1-1.5-.5v2.969a.5.5 0 0 1-.5.5h-.969a2.5 2.5 0 0 1-2.494-2.333M9.469 3.5a1.5 1.5 0 0 1-1.5 1.5H7.5V.063h.469a1.5 1.5 0 0 1 1.5 1.5zM6.5 6h-.469a1.5 1.5 0 0 0-1.5 1.5v1.938a1.5 1.5 0 0 0 1.5 1.5H6.5zM9 7.969a1.5 1.5 0 0 1-1.5-1.5V6h4.938v.469a1.5 1.5 0 0 1-1.5 1.5z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindows: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.94 2l12-1.38a.49.49 0 0 1 .56.49v11.82a.5.5 0 0 1-.58.49l-12-1.84a.51.51 0 0 1-.42-.5V2.46A.5.5 0 0 1 .94 2M6 1.38v10.98m7.5-5.6H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindowsRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.375 1.647l-5.673.662V6.13h5.673zm0 5.734H6.702v4.084l5.673.883zM5.452 6.13V2.454l-3.827.447v3.23zM1.625 7.38h3.827v3.89l-3.827-.596zm-1.25-.625v4.049a1.106 1.106 0 0 0 .901 1.081l.016.002l4.653.724l.07.011l6.351.988c.673.109 1.255-.427 1.259-1.072V1.466c.004-.635-.557-1.172-1.222-1.081l-6.346.74a1 1 0 0 0-.106.013l-4.617.539h-.002c-.253.03-.486.149-.66.333a1.1 1.1 0 0 0-.297.718z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWindowsSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.883 1.503L5.375.987v5.148H0V2.46a1 1 0 0 1 .881-.957zM0 7.385v3.697a1.01 1.01 0 0 0 .832.99l4.543.697V7.385zm6.625 0v5.576l6.217.953a1 1 0 0 0 1.158-.98V7.385zM14 6.135V1.112a.99.99 0 0 0-1.123-.988L6.625.843v5.292z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWine: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.67.5a1 1 0 0 0-1 .89C2.56 2.45 2.5 4.05 2.5 4.5c0 2.62 2 4 4.5 4s4.5-1.38 4.5-4c0-.45-.06-2-.17-3.11a1 1 0 0 0-1-.89zm-1.141 3h8.942M7 8.5v5m-2 0h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWineRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.5 0a.63.63 0 0 0-.347.105l.347.52l-.347-.52l-.001.001l-.002.001l-.003.003l-.01.006a1 1 0 0 0-.095.072a3 3 0 0 0-.218.198a4 4 0 0 0-.61.792c-.435.725-.839 1.837-.839 3.447c0 3.04 2.073 5.18 4.75 5.563v2.062h-1.25a.875.875 0 0 0 0 1.75h4.25a.875.875 0 0 0 0-1.75h-1.25v-2.062c2.677-.384 4.75-2.522 4.75-5.563c0-1.61-.404-2.722-.84-3.447a4 4 0 0 0-.609-.792a3 3 0 0 0-.314-.27L10.853.11L10.85.107l-.002-.001c-.001 0-.001-.001-.348.519l.347-.52A.63.63 0 0 0 10.5 0zm7.875 4.625c0-1.39-.346-2.278-.66-2.803a3 3 0 0 0-.423-.552l-.02-.02H3.728l-.02.02a3 3 0 0 0-.422.552c-.315.525-.661 1.413-.661 2.803z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWineSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.897 1.528a.18.18 0 0 0-.18.158a38 38 0 0 0-.126 1.883h6.818a38 38 0 0 0-.125-1.883a.18.18 0 0 0-.18-.158zm.006-1.5a1.68 1.68 0 0 0-1.678 1.496v.008A40 40 0 0 0 2.062 4.5c0 1.428.554 2.576 1.493 3.353c.74.613 1.681.964 2.694 1.078v3.475H5a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H7.75V8.931c1.013-.114 1.953-.464 2.694-1.078c.94-.777 1.493-1.925 1.493-3.353c0-.443-.056-1.91-.161-2.968l-.001-.008A1.68 1.68 0 0 0 10.097.028h.002v.75l-.005-.75h.003z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWomanSymbol: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 9A4.25 4.25 0 1 0 7 .5A4.25 4.25 0 0 0 7 9m0 0v4.5m-2-2h4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWomanSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25A3.625 3.625 0 1 0 7 8.5a3.625 3.625 0 0 0 0-7.25m4.875 3.625a4.876 4.876 0 0 1-4.25 4.835V11H9a.625.625 0 1 1 0 1.25H7.625v1.125a.625.625 0 1 1-1.25 0V12.25H5A.625.625 0 1 1 5 11h1.375V9.71a4.876 4.876 0 1 1 5.5-4.835\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWomanSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.5A3.25 3.25 0 1 0 7 8a3.25 3.25 0 0 0 0-6.5m4.75 3.25a4.75 4.75 0 0 1-4 4.691v1.309h.75a.75.75 0 0 1 0 1.5h-.75v1a.75.75 0 0 1-1.5 0v-1H5.5a.75.75 0 0 1 0-1.5h.75V9.441a4.751 4.751 0 1 1 5.5-4.691\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWorkspaceDesk: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.906 13.5V9.134c0-.612-.496-1.109-1.109-1.109H2.202c-.612 0-1.108.497-1.108 1.109V13.5m8.942-13H3.963a.784.784 0 0 0-.784.784v3.599c0 .433.351.784.784.784h6.073a.784.784 0 0 0 .784-.784V1.284A.784.784 0 0 0 10.036.5M7 5.667v2.358m-5.906 2.187h11.813\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWorkspaceDeskRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.93 1.409c0-.088.07-.159.158-.159h5.823c.088 0 .159.071.159.159v3.474a.16.16 0 0 1-.159.159H4.088a.16.16 0 0 1-.159-.16zM4.087 0C3.31 0 2.68.63 2.68 1.409v3.474a1.41 1.41 0 0 0 1.41 1.409h2.286L6.374 7.4H2.657C1.701 7.4 1 8.22 1 9.134v4.241a.625.625 0 1 0 1.25 0v-2.663h9.5v2.663a.625.625 0 1 0 1.25 0V9.134c0-.915-.7-1.734-1.657-1.734H7.624V6.292h2.287a1.41 1.41 0 0 0 1.409-1.41V1.41C11.32.631 10.69 0 9.911 0z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWorkspaceDeskSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.784 1.505h6.432c.019 0 .034.015.034.034V5.47a.034.034 0 0 1-.034.034H3.784a.034.034 0 0 1-.034-.034V1.539c0-.02.015-.034.034-.034m6.432-1.5H3.784C2.937.005 2.25.69 2.25 1.539V5.47c0 .847.687 1.534 1.534 1.534H6.25V8.02H2.202A1.86 1.86 0 0 0 .344 9.879v3.366a.75.75 0 0 0 1.5 0v-2.517h10.312v2.518a.75.75 0 0 0 1.5 0V9.878a1.86 1.86 0 0 0-1.858-1.858h-4.05V7.005h2.468c.847 0 1.534-.687 1.534-1.534V1.539c0-.848-.687-1.534-1.534-1.534\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWrench: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.41 3.596a.76.76 0 0 0-.35-.51l-2 2a1 1 0 0 1-1.44 0l-.76-.68a1 1 0 0 1 0-1.4l2-2a.76.76 0 0 0-.48-.43a3.8 3.8 0 0 0-4.2 5.309L.815 11.252a1 1 0 0 0 .014 1.428l.561.538a1 1 0 0 0 1.396-.01l5.428-5.37a3.81 3.81 0 0 0 5.196-4.242\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWrenchRemix: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M13.284 3.721a.76.76 0 0 0-.35-.51l-2 2a1 1 0 0 1-1.44 0l-.76-.68a1 1 0 0 1 0-1.4l2-2a.76.76 0 0 0-.48-.43A3.8 3.8 0 0 0 6.056 6.01L.94 11.126a1 1 0 0 0 .015 1.429l.56.538a1 1 0 0 0 1.397-.01l5.178-5.12a3.81 3.81 0 0 0 5.195-4.242\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineWrenchSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.477.086a4.3 4.3 0 0 0-4.884 5.68L.461 10.898a1.5 1.5 0 0 0 .022 2.143l.56.538a1.5 1.5 0 0 0 2.094-.016L8.34 8.417a4.31 4.31 0 0 0 5.56-4.913a1.26 1.26 0 0 0-.579-.844a.5.5 0 0 0-.615.073l-2 2l-.006.006a.5.5 0 0 1-.72 0l-.027-.025l-.746-.668a.5.5 0 0 1 .008-.688l1.998-1.998a.5.5 0 0 0 .107-.55a1.26 1.26 0 0 0-.843-.724\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineXbox: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 7a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0\"/><path d=\"M2.285 2.526c3.785.296 8.776 5.102 8.95 9.405\"/><path d=\"M11.716 2.526c-3.786.296-8.776 5.102-8.95 9.405\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineXboxRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1.25c-1.192 0-2.3.363-3.218.984c1.09.306 2.197.892 3.218 1.65c1.021-.758 2.128-1.344 3.218-1.65A5.7 5.7 0 0 0 7 1.25m4.569 2.258l-.039.004c-1.018.08-2.2.575-3.343 1.366q.207.194.405.396c1.421 1.449 2.593 3.285 3.012 5.171A5.72 5.72 0 0 0 12.75 7c0-1.313-.44-2.524-1.181-3.492m-5.756 1.37C4.671 4.087 3.49 3.592 2.47 3.512l-.039-.004A5.73 5.73 0 0 0 1.25 7c0 1.292.426 2.485 1.146 3.446c.42-1.887 1.591-3.723 3.013-5.172q.198-.202.404-.396m-2.08 6.855l.001-.02C3.807 9.929 4.9 7.937 6.48 6.325q.255-.26.52-.5q.266.24.52.5c1.582 1.612 2.674 3.604 2.746 5.39l.001.018A5.7 5.7 0 0 1 7 12.75a5.7 5.7 0 0 1-3.267-1.017M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineXboxSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14 7a6.97 6.97 0 0 1-1.55 4.393c-.532-2.202-1.949-4.358-3.682-6.078q-.37-.368-.763-.71c1.504-1.072 3.1-1.773 4.507-1.92A6.97 6.97 0 0 1 14 7m-2.547-5.401A6.97 6.97 0 0 0 7 0a6.97 6.97 0 0 0-4.453 1.599C4.04 1.945 5.587 2.736 7 3.79c1.414-1.054 2.96-1.844 4.453-2.19M5.995 4.604c-1.504-1.071-3.1-1.772-4.507-1.92A6.97 6.97 0 0 0 0 7a6.97 6.97 0 0 0 1.55 4.393c.532-2.202 1.949-4.358 3.683-6.078q.369-.368.762-.71M7 5.387q-.455.387-.887.815c-1.865 1.85-3.222 4.128-3.491 6.26A6.97 6.97 0 0 0 7 14a6.97 6.97 0 0 0 4.378-1.538c-.268-2.133-1.626-4.41-3.49-6.26A16 16 0 0 0 7 5.387\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineXrpCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"m4.5 4l1.79 1.79a1 1 0 0 0 1.42 0L9.5 4m-5 6l1.79-1.79a1 1 0 0 1 1.42 0L9.5 10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineXrpCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0M4.058 3.433a.625.625 0 0 1 .884 0l1.79 1.79l.002.002a.375.375 0 0 0 .532 0l.002-.002l1.79-1.79a.625.625 0 1 1 .884.884L8.154 6.105l-.001.001a1.625 1.625 0 0 1-2.306 0l-1.789-1.79a.625.625 0 0 1 0-.883M7 8.664a.38.38 0 0 0-.266.111l-.002.002l-1.79 1.79a.625.625 0 1 1-.884-.884l1.79-1.79a1.625 1.625 0 0 1 2.305 0v.002l1.789 1.788a.625.625 0 0 1-.884.884l-1.79-1.79l-.002-.002A.38.38 0 0 0 7 8.665\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineXrpCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M3.702 3.131a.625.625 0 0 1 .884 0l2.045 2.045l.002.002a.517.517 0 0 0 .734 0l.002-.002L9.414 3.13a.625.625 0 1 1 .883.884L8.256 6.058l-.001.001a1.767 1.767 0 0 1-2.508 0L3.702 4.015a.625.625 0 0 1 0-.884m3.1 5.578a.52.52 0 0 1 .565.113l.002.002l2.045 2.045a.625.625 0 1 0 .883-.884L8.256 7.942l-.001-.001a1.767 1.767 0 0 0-2.508 0L3.702 9.985a.625.625 0 0 0 .884.884l2.045-2.045l.002-.002A.5.5 0 0 1 6.8 8.71\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYinYangSymbol: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/><path d=\"M7 .5S2.93 4.09 7 7c3.5 2.5 0 6.5 0 6.5m2-8a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/><path d=\"M5 10.5a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYinYangSymbolRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 7a5.75 5.75 0 0 1 8.43-5.088A3.25 3.25 0 0 1 7 7a3.25 3.25 0 0 0-2.68 5.088A5.75 5.75 0 0 1 1.25 7M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M5.5 3.75a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m1.5 5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYinYangSymbolSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.698 2.17a4.997 4.997 0 0 0 2.326 9.717c.66-1.39 1.052-3.405-1.027-4.89C4.69 5.347 4.998 3.479 5.698 2.17M6.997 0a6.997 6.997 0 1 0 0 13.993A6.997 6.997 0 0 0 6.997 0m1.595 5.25a1.236 1.236 0 1 0 0-2.473a1.236 1.236 0 0 0 0 2.473M6.997 9.49a1.236 1.236 0 1 1-2.473 0a1.236 1.236 0 0 1 2.473 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYuan: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m2.5.5l4.5 6l4.5-6M7 6.5v7m-3.5-3h7m-7-2h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYuanCircle: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m5 4l2.08 2.77L9.15 4M7.08 6.77V10m-1.62-.69h3.23M5.46 7.5h3.23\"/><path d=\"M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYuanCircleSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M9.87 2.999a.625.625 0 0 1 .127.875L7.706 6.939v.02h1.253a.625.625 0 0 1 0 1.25H7.706v.861h1.253a.625.625 0 0 1 0 1.25H7.706v.459a.625.625 0 1 1-1.25 0v-.459H5.19a.625.625 0 0 1 0-1.25h1.265v-.862H5.19a.625.625 0 0 1 0-1.25h1.265V6.94L4.154 3.875a.625.625 0 1 1 1-.75L7.08 5.688l1.915-2.563a.625.625 0 0 1 .875-.127Z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYuanSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.8.4a1 1 0 1 0-1.6 1.2l3.917 5.222v.021H3.915a1 1 0 1 0 0 2h2.202v1.246H3.915a1 1 0 1 0 0 2h2.202v.804a1 1 0 1 0 2 0v-.805h2.202a1 1 0 1 0 0-2H8.117V8.843h2.202a1 1 0 1 0 0-2H8.117v-.02L12.033 1.6a1 1 0 1 0-1.6-1.2L7.117 4.822z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYuanYenCircleRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.249 7.001a5.751 5.751 0 1 1 11.502 0a5.751 5.751 0 0 1-11.502 0M7 0a7.001 7.001 0 1 0 0 14.002A7.001 7.001 0 0 0 7 0m2.524 3.5a.625.625 0 0 1 .127.874L7.78 6.875h.909a.625.625 0 1 1 0 1.25h-.985v.56h.985a.625.625 0 1 1 0 1.25h-.985v.315a.625.625 0 1 1-1.25 0v-.315H5.46a.625.625 0 1 1 0-1.25h.995v-.56H5.46a.625.625 0 1 1 0-1.25h.917L4.5 4.375a.625.625 0 1 1 1-.75l1.579 2.103l1.57-2.102a.625.625 0 0 1 .875-.127\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineYuanYenRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.984.604a.625.625 0 1 0-.968.792l4.359 5.327v1.152H3.5a.625.625 0 1 0 0 1.25h2.875v1.25H3.5a.625.625 0 1 0 0 1.25h2.875V13a.625.625 0 1 0 1.25 0v-1.375H10.5a.625.625 0 1 0 0-1.25H7.625v-1.25H10.5a.625.625 0 1 0 0-1.25H7.625V6.723l4.359-5.327a.625.625 0 0 0-.968-.792L7 5.513z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZeroHunger: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.858 6.612h12.007a6 6 0 0 1-3.43 5.426v1.078H4.288v-1.078a6 6 0 0 1-3.43-5.426M10.499.858c-.858 1.231 1.286 2.462.429 3.693M6.633.858C5.775 2.09 7.919 3.32 7.06 4.551M2.78.858c-.858 1.231 1.286 2.462.429 3.693\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZeroHungerRemix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.287 3.281a.75.75 0 0 0 1.171.938c.346-.433.539-.897.46-1.396c-.064-.413-.31-.725-.43-.88l-.023-.028a2 2 0 0 1-.152-.213a.8.8 0 0 1 .145-.233a.75.75 0 0 0-1.17-.938c-.347.433-.54.897-.46 1.396c.064.413.31.725.43.88l.022.028c.107.138.142.194.152.213a.8.8 0 0 1-.145.233M4.31 1.722l.002-.01q0 .01-.002.01m-.873 1.306v.01zm2.976.253a.75.75 0 0 0 1.171.938c.346-.433.539-.897.46-1.396c-.064-.413-.31-.725-.43-.88l-.023-.028a2 2 0 0 1-.152-.213a.8.8 0 0 1 .145-.233a.75.75 0 0 0-1.17-.938c-.347.433-.54.897-.46 1.396c.064.413.31.725.43.88l.022.028c.107.138.142.194.152.213a.8.8 0 0 1-.145.233m1.022-1.559l.002-.01q0 .01-.002.01m-.873 1.306v.01zm3.093 1.308a.75.75 0 0 1-.117-1.055a.8.8 0 0 0 .145-.233a2 2 0 0 0-.152-.213l-.021-.028c-.122-.155-.367-.467-.432-.88C9 1.428 9.191.964 9.537.53a.75.75 0 1 1 1.171.938a.8.8 0 0 0-.145.233c.01.02.045.075.152.213l.022.028c.122.155.367.467.431.88c.079.499-.114.963-.46 1.396a.75.75 0 0 1-1.054.117m.905-2.614l.001-.01zm-.873 1.306v.01zM1 6.375A.625.625 0 0 0 .375 7c0 2.1.978 3.972 2.5 5.184V13c0 .345.28.625.625.625h7c.345 0 .625-.28.625-.625v-.816A6.61 6.61 0 0 0 13.625 7A.625.625 0 0 0 13 6.375zm2.865 4.992a5.37 5.37 0 0 1-2.204-3.742h10.678a5.37 5.37 0 0 1-2.204 3.742a.63.63 0 0 0-.26.507v.501h-5.75v-.501a.63.63 0 0 0-.26-.507\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZeroHungerSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.253 1.287A.75.75 0 0 0 10.022.43a1.86 1.86 0 0 0-.292 1.51c.09.408.29.793.439 1.076l.018.035c.172.33.279.545.32.735c.032.143.018.229-.056.335a.75.75 0 1 0 1.23.858c.355-.51.395-1.04.292-1.512c-.089-.408-.29-.793-.438-1.076l-.019-.035c-.172-.33-.279-.545-.32-.735c-.031-.143-.017-.229.057-.335M.496 7.54a.5.5 0 0 1 .5-.5h12.008a.5.5 0 0 1 .5.5c0 2.295-1.406 4.263-3.431 5.26v.663a.5.5 0 0 1-.5.5v-.5v.5H4.427a.5.5 0 0 1-.5-.5V12.8C1.902 11.803.497 9.835.497 7.54M7.2.243a.75.75 0 0 1 .186 1.044c-.074.106-.087.192-.056.335c.041.19.148.405.32.735l.018.035c.148.283.35.668.439 1.076a1.86 1.86 0 0 1-.292 1.512a.75.75 0 0 1-1.23-.858c.074-.106.087-.192.056-.335c-.041-.19-.148-.405-.32-.735l-.018-.035c-.148-.283-.35-.668-.439-1.076A1.86 1.86 0 0 1 6.156.43A.75.75 0 0 1 7.2.243M3.534 1.287A.75.75 0 1 0 2.303.43a1.86 1.86 0 0 0-.292 1.511c.09.408.29.793.439 1.076l.018.035c.172.33.279.545.32.735c.032.143.018.229-.056.335a.75.75 0 1 0 1.23.858c.355-.51.395-1.04.292-1.512c-.089-.408-.29-.793-.438-1.076l-.019-.035c-.172-.33-.279-.545-.32-.735c-.031-.143-.017-.229.057-.335\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac1: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 10V4a2 2 0 1 1 4 0a2 2 0 1 1 4 0v6a2 2 0 0 0 4 0V8\"/><path d=\"m11.5 9l1-1l1 1m-9-5v6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac1Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.586 2.353c-.353 0-.693.141-.944.393a1.35 1.35 0 0 0-.392.955v5.796a.625.625 0 0 1-1.25 0V3.701c0-.688.271-1.348.756-1.836a2.58 2.58 0 0 1 3.792.142a2.6 2.6 0 0 1 1.962-.904c.687 0 1.345.274 1.83.762s.756 1.148.756 1.836v6.855a1.092 1.092 0 0 0 2.183 0v-1.78l-.404.405a.625.625 0 1 1-.884-.883l1.471-1.472a.625.625 0 0 1 .884 0l1.471 1.472a.625.625 0 1 1-.884.883l-.404-.404v1.779a2.342 2.342 0 0 1-4.683 0V3.7c0-.359-.141-.702-.392-.955a1.33 1.33 0 0 0-1.888 0a1.35 1.35 0 0 0-.393.955v5.751a.625.625 0 1 1-1.25 0v-5.76a1.35 1.35 0 0 0-.393-.946a1.33 1.33 0 0 0-.944-.393\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac1Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.846 3.385A.846.846 0 0 0 2 4.23v5.538a1 1 0 0 1-2 0V4.231a2.846 2.846 0 0 1 4.692-2.166A2.846 2.846 0 0 1 9.385 4.23v5.538a.846.846 0 0 0 1.689.074a1 1 0 0 1-.627-1.704l.918-.918a1 1 0 0 1 .712-.298a1 1 0 0 1 .707.293l.923.923a1 1 0 0 1-.631 1.704a2.847 2.847 0 0 1-5.691-.074V4.231a.846.846 0 0 0-1.693-.004V9.77a1 1 0 0 1-2 0V4.231a.846.846 0 0 0-.846-.846\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac10: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 13.5a7.9 7.9 0 0 0 3-6.5a7.9 7.9 0 0 0-3-6.5m11 13a7.9 7.9 0 0 1-3-6.5a7.9 7.9 0 0 1 3-6.5M.5 7h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac10Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.48.653A.625.625 0 0 1 2.347.48c1.09.727 2.799 2.815 3.007 5.895h3.292c.208-3.08 1.917-5.168 3.007-5.895a.625.625 0 1 1 .694 1.04c-.777.518-2.241 2.23-2.448 4.855H13a.625.625 0 1 1 0 1.25H9.9c.205 2.625 1.67 4.337 2.447 4.855a.625.625 0 1 1-.694 1.04c-1.09-.727-2.799-2.815-3.007-5.895H5.354c-.208 3.08-1.917 5.168-3.007 5.895a.625.625 0 0 1-.694-1.04c.777-.518 2.242-2.23 2.448-4.855H1a.625.625 0 1 1 0-1.25h3.1C3.896 3.75 2.43 2.038 1.654 1.52A.625.625 0 0 1 1.48.653\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac10Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.138.38A1 1 0 0 1 2.543.215A8.3 8.3 0 0 1 5.666 6h2.668A8.3 8.3 0 0 1 11.458.215a1 1 0 1 1 1.239 1.57A6.3 6.3 0 0 0 10.344 6H13a1 1 0 1 1 0 2h-2.656a6.3 6.3 0 0 0 2.353 4.215a1 1 0 1 1-1.24 1.57A8.3 8.3 0 0 1 8.334 8H5.666a8.3 8.3 0 0 1-3.123 5.785a1 1 0 1 1-1.24-1.57A6.3 6.3 0 0 0 3.657 8H1a1 1 0 0 1 0-2h2.656a6.3 6.3 0 0 0-2.352-4.215A1 1 0 0 1 1.138.38\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac11: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8.5.5h5v5m0-5l-13 13m1-6l5 5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac11Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.817.183A.62.62 0 0 1 14 .625v5a.625.625 0 1 1-1.25 0V2.134L4.884 10l2.058 2.058a.625.625 0 1 1-.884.884L4 10.884l-2.933 2.933a.625.625 0 1 1-.884-.884L3.116 10L1.058 7.942a.625.625 0 1 1 .884-.884L4 9.116l7.866-7.866H8.375a.625.625 0 1 1 0-1.25h5c.16 0 .32.061.442.183\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac11Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.743.331A1 1 0 0 0 13 0H8.385a1 1 0 0 0 0 2h2.2L4.232 8.355l-1.6-1.6a1 1 0 0 0-1.415 1.414l1.6 1.6l-2.523 2.524a1 1 0 1 0 1.414 1.414l2.524-2.524l1.6 1.601a1 1 0 1 0 1.415-1.414l-1.601-1.6L12 3.413v2.201a1 1 0 1 0 2 0V1a1 1 0 0 0-.257-.669\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac12: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 6.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m8 6a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5m-8-11h10.5m-13 11H11\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac12Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.25 4A1.875 1.875 0 1 1 5 4a1.875 1.875 0 0 1-3.75 0M0 4A3.125 3.125 0 0 1 2.9.883A1 1 0 0 1 3 .875h10.375a.625.625 0 1 1 0 1.25h-7.75A3.125 3.125 0 1 1 0 4m9 6a1.875 1.875 0 1 1 3.75 0A1.875 1.875 0 0 1 9 10m2.1 3.117a3.125 3.125 0 1 0-2.725-1.242H.625a.625.625 0 1 0 0 1.25H11a1 1 0 0 0 .1-.008\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac12Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.308 2.53a1.308 1.308 0 1 0 0 2.616a1.308 1.308 0 0 0 0-2.615M0 3.84A3.31 3.31 0 0 1 3.308.53H13a1 1 0 1 1 0 2H6.347A3.308 3.308 0 1 1 0 3.839m10.692 5.015a1.308 1.308 0 0 0-.008 2.615h.014a1.308 1.308 0 0 0-.006-2.615m-3.307 1.308c0 .464.095.906.268 1.307H1a1 1 0 0 0 0 2h9.692a3.308 3.308 0 1 0-3.307-3.307\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac2: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 3.25V10M.5 10V3.25a2.25 2.25 0 0 1 4.5 0a2.25 2.25 0 1 1 4.5 0V11a2 2 0 0 0 4 0v-1\"/><path d=\"M9.5 4h1.88a2 2 0 0 1 1.46 3.37L7.5 13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac2Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.831 2.23A1.58 1.58 0 0 0 1.25 3.812v6.13a.625.625 0 1 1-1.25 0v-6.13a2.832 2.832 0 0 1 5.04-1.775a2.834 2.834 0 0 1 4.209-.228c.32.32.556.71.692 1.133h1.471A2.63 2.63 0 0 1 13.789 4.5c.404.932.207 2.06-.489 2.8l-.002.003l-3.198 3.371a1.336 1.336 0 0 0 2.652-.24v-.982a.625.625 0 1 1 1.25 0v.981a2.587 2.587 0 0 1-4.854 1.245L8.06 12.825a.625.625 0 0 1-.907-.86l1.675-1.766V3.812a1.582 1.582 0 0 0-3.164-.017v6.148a.625.625 0 1 1-1.25 0V3.812A1.58 1.58 0 0 0 2.831 2.23m7.246 6.65l2.311-2.436h.001c.353-.377.457-.973.252-1.447a1.38 1.38 0 0 0-1.23-.805h-1.334z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac2Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.077 2A1.077 1.077 0 0 0 2 3.077v6.23a1 1 0 1 1-2 0v-6.23A3.077 3.077 0 0 1 5.154.807a3.077 3.077 0 0 1 5.106 1.731h.308c2.896 0 4.346 3.501 2.298 5.549l-2.486 2.486A.846.846 0 0 0 12 10.23v-.423a1 1 0 1 1 2 0v.423a2.847 2.847 0 0 1-5.063 1.785l-.73.73a1 1 0 0 1-1.414-1.415l1.515-1.514v-6.74a1.077 1.077 0 0 0-2.154-.006v6.236a1 1 0 1 1-2 0v-6.23A1.077 1.077 0 0 0 3.077 2m7.23 5.817l1.145-1.145c.787-.787.23-2.134-.884-2.134h-.26z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac3: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.5 13.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/><path d=\"M13.5 12a1.5 1.5 0 1 1-3 0V3.5a3 3 0 0 0-6 0v8\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac3Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.02 4.406a2.609 2.609 0 1 1 5.12-.101l-1.303 7.493a1 1 0 0 0-.01.107a2.097 2.097 0 0 0 4.193 0a.625.625 0 1 0-1.25 0a.846.846 0 0 1-1.691.046L11.37 4.52a3.859 3.859 0 1 0-7.574.15l.608 2.826A2.587 2.587 0 1 0 6.141 9.7a.6.6 0 0 0-.014-.137l-.008-.038a3 3 0 0 0-.055-.254zm-.168 5.168l.038.175q.014.095.014.194a1.337 1.337 0 1 1-.052-.37\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac3Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.461 0a3.77 3.77 0 0 0-3.769 3.77v4.666a2.846 2.846 0 1 0 2 2.702v-7.37a1.77 1.77 0 1 1 3.539 0v7.846a2.385 2.385 0 0 0 4.769 0a1 1 0 0 0-2 0a.385.385 0 0 1-.77 0V3.77A3.77 3.77 0 0 0 7.462 0m-3.77 11.145v.016a.846.846 0 1 1 0-.016\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac4: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 3l2.3 2.68a1 1 0 0 0 1.46.06l2-2a1 1 0 0 1 1.42 0l2 2a1 1 0 0 0 1.46-.06L13.5 3M.5 8l2.3 2.68a1 1 0 0 0 1.46.06l2-2a1 1 0 0 1 1.42 0l2 2a1 1 0 0 0 1.46-.06L13.5 8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac4Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.261 2.546a1.61 1.61 0 0 0-1.793.447L.155 5.62a.625.625 0 0 0 .938.826l2.315-2.63l.005-.005a.356.356 0 0 1 .518-.022L5.89 5.747l.001.001a1.606 1.606 0 0 0 2.279 0v-.001l1.959-1.958a.356.356 0 0 1 .518.022l2.256 2.629a.625.625 0 0 0 .948-.814l-2.256-2.63A1.605 1.605 0 0 0 9.249 2.9l-.003.003l-1.962 1.962l-.002.002a.356.356 0 0 1-.505 0l-.002-.002l-1.962-1.962L4.81 2.9a1.6 1.6 0 0 0-.549-.354m0 4.904a1.61 1.61 0 0 0-1.793.448L.155 10.524a.625.625 0 0 0 .938.826l2.315-2.629l.005-.005a.356.356 0 0 1 .518-.022l1.958 1.958h.001a1.607 1.607 0 0 0 2.279 0l1.959-1.958a.356.356 0 0 1 .518.022l2.256 2.628a.625.625 0 1 0 .948-.814l-2.256-2.629a1.605 1.605 0 0 0-2.345-.097l-.003.004l-1.962 1.961l-.002.002a.356.356 0 0 1-.505 0l-.002-.002l-1.962-1.961l-.003-.004a1.6 1.6 0 0 0-.549-.354\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac4Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.759 2.357A1 1 0 1 0 .24 3.659l2.123 2.474l.001.001a1.923 1.923 0 0 0 2.808.116l.005-.005L6.972 4.45l1.795 1.795l.005.005a1.923 1.923 0 0 0 2.803-.11l2.176-2.47a1 1 0 1 0-1.501-1.323l-2.132 2.42l-1.78-1.78l-.002-.002a1.923 1.923 0 0 0-2.727 0L3.827 4.767zm0 5.189A1 1 0 1 0 .24 8.848l2.123 2.474h.001a1.92 1.92 0 0 0 2.808.116l.005-.005L6.972 9.64l1.795 1.794l.005.005a1.92 1.92 0 0 0 2.803-.11l2.176-2.47a1 1 0 1 0-1.501-1.322l-2.132 2.42l-1.78-1.78l-.002-.002a1.923 1.923 0 0 0-2.727 0L3.827 9.956z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac5: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.5a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9\"/><path d=\"M2.53.5a4.5 4.5 0 0 0 8.94 0\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac5Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.234.555a.625.625 0 0 0-1.242.138a5.04 5.04 0 0 0 2.575 3.855a5.04 5.04 0 1 0 4.865 0A5.04 5.04 0 0 0 12.009.693a.625.625 0 1 0-1.242-.138a3.79 3.79 0 0 1-7.532 0m-.023 8.407a3.79 3.79 0 1 1 7.578 0a3.79 3.79 0 0 1-7.578 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac5Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.02 1.107a1 1 0 0 0-1.987.23A5 5 0 0 0 4.011 4.77a5 5 0 1 0 5.978 0q.174-.129.336-.274a5 5 0 0 0 1.642-3.157a1 1 0 0 0-1.987-.231a3 3 0 0 1-5.96 0M4 8.777a3 3 0 1 1 6 0a3 3 0 0 1-6 0\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac6: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11.5 13.5a2 2 0 1 0 0-4a2 2 0 0 0 0 4m0-4H.5\"/><path d=\"M9.5 11.5V.5S5 1.5 5 5.5C5 1.5.5.5.5.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac6Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.136.39a.625.625 0 0 0-.272 1.22l.004.001l.026.006l.113.03a6.3 6.3 0 0 1 1.723.795c.932.623 1.799 1.606 1.799 3.173a.625.625 0 0 0 1.25 0c0-1.567.867-2.55 1.799-3.172a6.3 6.3 0 0 1 1.105-.58v6.82H1a.625.625 0 0 0 0 1.25h7.683v1.221a2.471 2.471 0 1 0 2.473-2.471H9.933V1a.625.625 0 0 0-.76-.61l.135.61l-.136-.61h-.003l-.004.002l-.013.003a3 3 0 0 0-.194.05a7.6 7.6 0 0 0-2.073.957c-.628.419-1.274 1.005-1.731 1.799c-.457-.794-1.103-1.38-1.73-1.798A7.6 7.6 0 0 0 1.156.395L1.143.392L1.139.39zL1 1zm8.797 10.772v-.022a1.221 1.221 0 1 1 0 .022M.863 1.61\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac6Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.217.024a1 1 0 0 0-.435 1.952H.78h.002l.02.005l.102.027a6 6 0 0 1 1.618.747c.868.579 1.632 1.46 1.632 2.86a1 1 0 1 0 2 0c0-1.4.763-2.281 1.631-2.86a6 6 0 0 1 .523-.307v5.86H1a1 1 0 1 0 0 2h7.308v.846a2.846 2.846 0 1 0 2.85-2.846h-.85V1A1 1 0 0 0 9.09.024L9.308 1L9.09.024h-.003L9.08.027L9.066.03a4 4 0 0 0-.211.055a8 8 0 0 0-2.178 1.006a6.1 6.1 0 0 0-1.523 1.427A6.1 6.1 0 0 0 3.632 1.09A8 8 0 0 0 1.242.03L1.226.026L1.221.025h-.002zL1 1zm9.09 11.136v-.014a.846.846 0 1 1 0 .014\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac7: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5.5s6.5 3 6.5 13c0-10 6.5-13 6.5-13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac7Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.433.738a.625.625 0 0 1 .83-.305L1 1l.263-.567l.003.001l.006.003l.019.01l.062.03q.078.04.215.117c.181.104.434.26.734.475c.6.431 1.393 1.103 2.183 2.075C5.45 4.332 6.402 5.957 7 8.118c.598-2.161 1.55-3.786 2.515-4.974a11.4 11.4 0 0 1 2.183-2.075a8.5 8.5 0 0 1 .95-.592l.062-.03l.018-.01l.006-.003h.003V.432L13 1l-.262-.567a.625.625 0 0 1 .526 1.134h-.001l-.007.003l-.038.02a7 7 0 0 0-.79.495a10.2 10.2 0 0 0-1.943 1.848C9.073 5.67 7.625 8.533 7.625 13a.625.625 0 1 1-1.25 0c0-4.467-1.447-7.329-2.86-9.067a10.2 10.2 0 0 0-1.942-1.848a7 7 0 0 0-.79-.495l-.039-.02l-.006-.003A.625.625 0 0 1 .433.738m.304.829\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac7Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.106.553A1 1 0 0 1 1.447.106C3.065.914 5.605 3.164 7 7.019C8.395 3.164 10.935.914 12.553.106a1 1 0 1 1 .894 1.788C11.771 2.733 8 6.195 8 13a1 1 0 1 1-2 0C6 6.195 2.23 2.733.553 1.894A1 1 0 0 1 .106.553\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac8: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 12h13m0-4h-3c.344-.61.516-1.3.5-2a4 4 0 1 0-8 0a3.9 3.9 0 0 0 .54 2H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac8Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .875a4.625 4.625 0 0 0-4.418 6H.625a.625.625 0 1 0 0 1.25H3.54a.625.625 0 0 0 .538-.943a3.27 3.27 0 0 1-.453-1.678V5.5a3.375 3.375 0 0 1 6.75 0v.015a3.27 3.27 0 0 1-.42 1.678a.625.625 0 0 0 .545.932h2.875a.625.625 0 1 0 0-1.25h-1.936c.133-.446.196-.913.186-1.382A4.625 4.625 0 0 0 7 .875m-6.375 11a.625.625 0 1 0 0 1.25h12.75a.625.625 0 1 0 0-1.25z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac8Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 .886a4.692 4.692 0 0 0-4.618 5.538H1a1 1 0 1 0 0 2h2.806a1 1 0 0 0 .861-1.508a2.6 2.6 0 0 1-.36-1.332v-.006a2.692 2.692 0 1 1 5.385 0v.023a2.6 2.6 0 0 1-.332 1.333a1 1 0 0 0 .87 1.49H13a1 1 0 1 0 0-2h-1.37q.07-.424.062-.857A4.69 4.69 0 0 0 7 .886m-6 9.72a1 1 0 1 0 0 2h12a1 1 0 0 0 0-2z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac9: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5.5a7.9 7.9 0 0 0 6.5 3a7.9 7.9 0 0 0 6.5-3m-13 13a7.9 7.9 0 0 1 6.5-3a7.9 7.9 0 0 1 6.5 3m-9-10.34v7.68m5-7.68v7.68\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac9Remix: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.653.48a.625.625 0 0 1 .867.173c.397.595 1.493 1.593 3.163 2.12l.01.004c.678.212 1.45.348 2.307.348s1.63-.136 2.307-.348l.01-.004c1.67-.527 2.766-1.525 3.163-2.12a.625.625 0 0 1 1.04.694c-.508.762-1.682 1.827-3.395 2.47v6.366c1.713.643 2.887 1.708 3.395 2.47a.625.625 0 1 1-1.04.694c-.396-.595-1.491-1.591-3.159-2.119l-.018-.006A7.7 7.7 0 0 0 7 10.875a7.7 7.7 0 0 0-2.321.353c-1.668.528-2.763 1.524-3.159 2.119a.625.625 0 0 1-1.04-.694c.508-.762 1.682-1.827 3.395-2.47V3.816C2.162 3.174.988 2.11.48 1.346A.625.625 0 0 1 .653.48m4.472 9.34A9 9 0 0 1 7 9.624c.668 0 1.294.071 1.875.194V4.181A9 9 0 0 1 7 4.375a9 9 0 0 1-1.875-.194z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineZodiac9Solid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.746.334A1 1 0 1 0 .254 1.666A8.2 8.2 0 0 0 3.29 3.787q.2.081.402.153v6.12q-.203.072-.402.153a8.2 8.2 0 0 0-3.036 2.121a1 1 0 0 0 1.492 1.332a6.2 6.2 0 0 1 2.3-1.602a7.1 7.1 0 0 1 2.92-.515h.067a7.1 7.1 0 0 1 2.92.515c.91.372 1.696.924 2.3 1.602a1 1 0 1 0 1.493-1.332a8.2 8.2 0 0 0-3.036-2.121a9 9 0 0 0-.402-.153V3.94q.203-.072.402-.153a8.2 8.2 0 0 0 3.036-2.121A1 1 0 0 0 12.254.334a6.2 6.2 0 0 1-2.3 1.602c-.91.371-1.911.55-2.92.515h-.067a7.1 7.1 0 0 1-2.92-.515a6.2 6.2 0 0 1-2.3-1.602m6.562 4.064A9 9 0 0 1 7 4.45a9 9 0 0 1-1.308-.053v5.204Q6.342 9.53 7 9.55a9 9 0 0 1 1.308.053z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineAnnoncementMegaphoneSolid: Icon = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.933.767a.75.75 0 0 0-1.5 0v.754a.75.75 0 0 0 1.5 0zM6.595 2.928a.75.75 0 0 1 1.024.275l3.858 6.681a.75.75 0 0 1-1.299.75l-.055-.096l-3.092.718a2.171 2.171 0 0 1-3.97 1.664l-.002-.003l-.376-.651l-1.454.337a.5.5 0 0 1-.546-.237l-.609-1.055a.5.5 0 0 1 .068-.591l6.235-6.67l-.057-.097a.75.75 0 0 1 .275-1.025M4.21 11.911l1.357-.315a.671.671 0 0 1-1.21.57zm9.78-5.088a.75.75 0 0 1-.75.75h-.754a.75.75 0 0 1 0-1.5h.753a.75.75 0 0 1 .75.75Zm-12.108.75a.75.75 0 1 0 0-1.5h-.754a.75.75 0 1 0 0 1.5zm2.182-3.868a.75.75 0 0 1-1.06 0l-.634-.634a.75.75 0 1 1 1.06-1.06l.635.633a.75.75 0 0 1 0 1.061Zm7.932-.634a.75.75 0 0 0-1.06-1.06l-.642.64a.75.75 0 1 0 1.061 1.061z\" clip-rule=\"evenodd\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerConnectionBluetoothBluetoothInternetServerNetworkWireless: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m3.25 9.5l7.5-5.5l-4-3.5v13l4-3.5l-7.5-5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardAsterisk1AsteriskStarKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13m-5.5-10l11 7m-11 0l11-7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerKeyboardNextKeyboardNextArrowRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7h10M7 10.5L10.5 7L7 3.5m6.5 0v7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoAndroidAndroidCodeAppsBugdroidProgramming: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 13.5v-8a4 4 0 0 1 8 0v8M3 11h8\"/><path d=\"M.5 10V8a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v2M11 .5L9.28 2.22M3 .5l1.72 1.72\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineComputerLogoTwitterMediaTwitterSocial: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 9.4a6.8 6.8 0 0 1-2.41 1.21a.5.5 0 0 0 0 .94C8.51 14.39 12.91 10 12.24 5.13l1.12-2.32h-1.3C10.44.82 6.14.92 6.85 5.16c0 0-2.3.41-5.24-2.48A.5.5 0 0 0 .76 3A5.52 5.52 0 0 0 4 9.4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEcologyScienceAlienExtraterristerialLifeFormSpaceUniverseHead: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 5.5c0 3.59-2.95 8-6.5 8S.5 9.09.5 5.5S3.41.5 7 .5s6.5 1.41 6.5 5\"/><path d=\"M2.75 4.75a3.12 3.12 0 0 0 .49 2.44a3.12 3.12 0 0 0 2.44.49a3.12 3.12 0 0 0-.49-2.44a3.12 3.12 0 0 0-2.44-.49m8.5 0a3.12 3.12 0 0 1-.49 2.44a3.12 3.12 0 0 1-2.44.49a3.12 3.12 0 0 1 .49-2.44a3.12 3.12 0 0 1 2.44-.49\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEcologyScienceDnaBiologyExperimentLabScience: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10.1 3.9a4.65 4.65 0 0 0 3.4.1M4 13.5a4.68 4.68 0 0 0-.1-3.41a4.74 4.74 0 0 1 1-5.16a4.8 4.8 0 0 1 2.46-1.3\"/><path d=\"M6.6 10.37a4.8 4.8 0 0 0 2.47-1.31a4.73 4.73 0 0 0 1-5.16A4.65 4.65 0 0 1 10 .5M.5 10a4.6 4.6 0 0 1 3.4.11m1.04-5.18l4.13 4.13\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineEcologyScienceErlenmeyerFlaskExperimentLabFlaskScienceChemistrySolution: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 .5v6l3.59 4.57a1.5 1.5 0 0 1-1.18 2.43H2.59a1.5 1.5 0 0 1-1.18-2.43L5 6.5v-6M3.5.5h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineHealthMedicalSyringeInstrumentMedicalSyringeHealthBeautyNeedle: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 3L2.42 7.49a2 2 0 0 0 0 2.83l1.26 1.26a2 2 0 0 0 2.83 0L11 7M10.5.5l3 3M9 5l3-3m-8.95 8.95L.5 13.5m5-12l7 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImageFlashOffFlashPowerConnectChargeOffElectricityLightning: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13M5.19 5.19L8.5.5V5h3L8.81 8.81m-1.66 2.35L5.5 13.5V9h-3l1.41-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineImagePhotoCompositionOvalCameraFrameCompositionPhotographyPicturesLandscapePhotoOval: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.5 11a10.3 10.3 0 0 0 1-4a10.3 10.3 0 0 0-1-4A13.3 13.3 0 0 0 7 2a13.3 13.3 0 0 0-5.5 1a10.3 10.3 0 0 0-1 4a10.3 10.3 0 0 0 1 4A13.3 13.3 0 0 0 7 12a13.3 13.3 0 0 0 5.5-1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsAllDirectionMoveButtonArrowsDirection: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5 2.5l2-2l2 2m-4 9l2 2l2-2M7 .5v13M11.5 5l2 2l-2 2m-9-4l-2 2l2 2m11-2H.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendDownLeft3ArrowBendCurveChangeDirectionLeftToDown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2.5 10.5l3 3l3-3\"/><path d=\"M11.5.5h-2a4 4 0 0 0-4 4v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBendDownRight1ArrowBendCurveChangeDirectionRightToDown: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5 10.5l-3 3l-3-3\"/><path d=\"M2.5.5h2a4 4 0 0 1 4 4v9\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsBottomDownMoveArrowArrows: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m4 6.5l3 3l3-3m-3-6v9m-3.5 4h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCrossOverCrossMoveOverArrowArrowsIght: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l13-13m-4 0h4v4M9 9l4.5 4.5m-4 0h4v-4M5 5L.5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCrossoverDownCrossMoveOverArrowArrowsDown: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5.5l13 13m0-4v4h-4M5 9L.5 13.5m0-4v4h4M9 5L13.5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCrossoverLeftCrossMoveOverArrowArrowsLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5.5l-13 13m4 0h-4v-4M5 5L.5.5m4 0h-4v4M9 9l4.5 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsCrossoverUpCrossMoveOverArrowArrowsRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 13.5L.5.5m0 4v-4h4M9 5L13.5.5m0 4v-4h-4M5 9L.5 13.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsDataTransferDiagonalArrowsArrowServerDataDiagonalInternetTransferNetwork: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 10.5l10-10H6m7.5 3l-10 10H8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpand1ExpandSmallBiggerRetractSmallerBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m8.5 5.5l5-5m-4 0h4v4m-8 1l-5-5m4 0h-4v4m8 4l5 5m-4 0h4v-4m-8-1l-5 5m4 0h-4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsExpand5ExpandSmallBiggerRetractSmallerBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 8v4.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1H6m4 0h3.5V4m0-3.5L7 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsHorizontalShrinkResizeShrinkBiggerHorizontalSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 4.5L8.5 7L11 9.5m-8-5L5.5 7L3 9.5M.5.5v13m13-13v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsReload1ArrowsLoadArrowSyncSquareLoadingReloadSynchronize: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5 5L3 2.5L5.5 5\"/><path d=\"M6 13.5H4a1 1 0 0 1-1-1v-10M13.5 9L11 11.5L8.5 9\"/><path d=\"M8 .5h2a1 1 0 0 1 1 1v10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsReload2ArrowsLoadArrowSyncSquareLoadingReloadSynchronize: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 .5L11.5 3L9 5.5\"/><path d=\"M.5 6V4a1 1 0 0 1 1-1h10M5 13.5L2.5 11L5 8.5\"/><path d=\"M13.5 8v2a1 1 0 0 1-1 1h-10\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsRoundLeftDiagramRoundArrowLeft: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4.75.5L2.25 3l2.5 2.5\"/><path d=\"M1.75 8.25A5.25 5.25 0 1 0 7 3H2.25\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsRoundRightDiagramRoundArrowRight: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9.25.5l2.5 2.5l-2.5 2.5\"/><path d=\"M12.25 8.25A5.25 5.25 0 1 1 7 3h4.75\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsShrink1ExpandRetractShrinkBiggerBigSmallSmaller: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l4-4M1 9.5h3.5V13m9 .5l-4-4m3.5 0H9.5V13M.5.5l4 4M1 4.5h3.5V1m9-.5l-4 4m3.5 0H9.5V1\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsShrink2ExpandRetractShrinkBiggerBigSmallSmaller: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5 13.5l-5-5m4 0h-4v4M.5.5l5 5m-4 0h4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsShrink3ExpandRetractShrinkBiggerBigSmallSmaller: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 13.5l5-5m-4 0h4v4m8-12l-5 5m4 0h-4v-4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsShrink5ExpandRetractShrinkBiggerBigSmallSmaller: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 6V1.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H8m-4 0H.5V10m0 3.5L7 7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsShuffleMultimediaShuffleMultiButtonControlsMedia: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m11.5 2l2 2l-2 2m-3-2h5m-2 4l2 2l-2 2\"/><path d=\"M.5 4H4l4 6h5.5m-13 0H4\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsUpArrowUpKeyboard: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 13.5V.5M10.5 4L7 .5L3.5 4\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceArrowsVerticalLeftRightExpandResizeBiggerHorizontalSmallerSizeArrowArrowsBig: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.48 3.87L.61 6.74a.36.36 0 0 0 0 .52l2.87 2.87m7.04-6.26l2.87 2.87a.36.36 0 0 1 0 .52l-2.87 2.87M7 13.5V.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceDelete1RemoveAddButtonButtonsDelete: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m13.5.5l-13 13m0-13l13 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceEditFlipUpDesignUpFlipReflectVertical: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 2.5v-1a1 1 0 0 0-1-1h-1m-3 0h-3m-5 2v-1a1 1 0 0 1 1-1h1m-2 9v3a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-3m-13-4V7h13V5.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceGeometricCircleGeometricCircleRoundDesignShapeShapes: Icon = {
  "body": "<circle cx=\"7\" cy=\"7\" r=\"6.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceIdThumbMarkIdentificationPasswordTouchIdSecureFingerprintFingerSecurity: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 13.39a5 5 0 0 0 5-5V5.61a5 5 0 0 0-1.27-3.33M2 6.72v1.67A5 5 0 0 0 5.06 13M9.5 1.28a5 5 0 0 0-6.83 1.83a4.9 4.9 0 0 0-.57 1.52\"/><path d=\"M6.48 3.51A2.51 2.51 0 0 1 9.5 6v1.61m-.64 2.1A2.5 2.5 0 0 1 4.5 8V6a2.5 2.5 0 0 1 .2-1M7 6.11v1.67\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceLogoutArrowExitFrameLeaveLogoutRectangleRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9.5 10.5v2a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v2M6.5 7h7m-2-2l2 2l-2 2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfacePresentationPodiumWorkDeskNotesCompanyPresentationOfficePodiumMicrophone: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 8.5H2l-1-5h12l-1 5H9m-2-5v-3m-2 6v7m4-7v7m-5 0h6m-7.5-10s0-3 2-3m7 3s0-3-2-3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceRemove1ButtonDeleteButtonsSubtractHorizontalRemoveLineAdd: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceSignalGraphHeartLineBeatSquareGraphStats: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 7.08h2.19a.52.52 0 0 0 .45-.27l1.8-3.6a.49.49 0 0 1 .49-.27a.48.48 0 0 1 .43.35l2.23 7.42a.5.5 0 0 0 .46.36a.5.5 0 0 0 .45-.32l1.37-3.35a.51.51 0 0 1 .47-.32h2.66\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingCenterAlignTextAlignmentAlignParagraphCenteredFormattingCenter: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 1h13M2 4h10M3.5 7h7m-10 6h13M2 10h10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingLeftAlignParagraphTextAlignmentAlignLeftFormattingRight: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 1h13M.5 4h10M.5 7h7m-7 6h13m-13-3h10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingParagraphAlignmentParagraphFormattingText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5.5h-9a4 4 0 0 0 0 8h2m3-8v13m-3-13v13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingQuotation4QuoteQuotationFormatFormattingOpenCloseMarksText: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 4L1 7m2-3l.5 3m7.75 0l-.5 3m2.75-3l-.5 3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingRightAlignRagParagraphTextAlignmentAlignRightFormattingLeft: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 1H.5m13 3h-10m10 3h-7m7 6H.5m13-3h-10\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTextStyleTextStyleFormattingFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13m-2.5 0h5M1.5 3V1.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1V3\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceTextFormattingTypeCursorCursorTextFormattingTypeFormat: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.5 5H13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H7.5m-5 0H1a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 1 5h1.5M4 2.5h2m-2 9h2m-1-9v9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherFullMoonNightFullMoonTimeWeather: Icon = {
  "body": "<circle cx=\"7\" cy=\"7\" r=\"6.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherSnowFlakeWinterFreezeSnowFreezingIceColdWeatherSnowflake: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m5 .5l2 2l2-2M.5 9l2-2l-2-2M9 13.5l-2-2l-2 2M13.5 5l-2 2l2 2m-10-5.5L5 5m0 4l-1.5 1.5m7-7L9 5m0 4l1.5 1.5M7 2.5v9M2.5 7h9\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineInterfaceWeatherWindWindHighOvercastGustWeatherMeteorologyGale: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.5.5a1.75 1.75 0 0 1 0 3.5h-7m11.25 6.5a1.75 1.75 0 0 0 0-3.5H2m5.25 6.5a1.75 1.75 0 0 0 0-3.5H1.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSendReplyAllEmailMessageReplyAllActionsActionArrow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7.5 2.5l-3 3l3 3\"/><path d=\"M13.5 11.5v-2a4 4 0 0 0-4-4h-5m-1-3l-3 3l3 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMailSignHashtagSharpSignHashtagTag: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M.5 4.25h13m-13 5.5h13M11.25.5l-2.5 13m-3-13l-2.5 13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyCurrencyYuanExchangePaymentForexFinanceYuanCurrencyMoneyForeign: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m2.5.5l4.5 6l4.5-6M7 6.5v7m-3.5-3h7m-7-2h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyGraphAnalyticsBusinessProductGraphDataChartAnalysis: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M.5.5v13h13\"/><path d=\"M3.5 6.5L6 9l4-6l3.5 2.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyGraphArrowDecreaseDownStatsGraphDescendRightArrow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 10.5h4v-4\"/><path d=\"M13.5 10.5L7.85 4.85a.5.5 0 0 0-.7 0l-2.3 2.3a.5.5 0 0 1-.7 0L.5 3.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineMoneyGraphArrowIncreaseAscendGrowthUpArrowStatsGraphRightGrow: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.5 3.5h4v4\"/><path d=\"M13.5 3.5L7.85 9.15a.5.5 0 0 1-.7 0l-2.3-2.3a.5.5 0 0 0-.7 0L.5 10.5\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineProgrammingScriptCodeCodeAngleProgrammingFileBracket: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4 10.5L.5 7L4 3.5m6 7L13.5 7L10 3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionChristianityReligionJesusChristianityChristFishCulture: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 4s-3.67 6-8 6a5.6 5.6 0 0 1-5-3a5.6 5.6 0 0 1 5-3c4.33 0 8 6 8 6\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineReligionCross2ReligionCrossCultureThinLine: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 .5v13m-4-9h8\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingCartBasket2ShoppingBasket: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12.28 6H1.72a1 1 0 0 0-1 1.2l1.1 5.5a1 1 0 0 0 1 .8h8.36a1 1 0 0 0 1-.8l1.1-5.5a1 1 0 0 0-1-1.2M9 2.5L11 6M3 6l2-3.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineShoppingStore2StoreShopShopsStores: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M13 6H1a.5.5 0 0 1-.5-.5v-2l1.22-2.45a1 1 0 0 1 .9-.55h8.76a1 1 0 0 1 .9.55L13.5 3.5v2a.5.5 0 0 1-.5.5M8 8.5v5M1.5 10H8M.5 3.5h13\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelMapTriangleFlagNavigationMapMapsFlagGpsLocationDestinationGoal: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.5.5v13m0-13l9 4.5l-9 4.5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesBeachIslandWavesOutdoorRecreationTreeBeachPalmWaveWater: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.5 13.48H13a2 2 0 0 1-2-2a2 2 0 0 1-4 0a2 2 0 0 1-4 0a2 2 0 0 1-2 2H.5m9.5-4a5.49 5.49 0 0 0-8.48 0\"/><path d=\"M6.5 7.53c.06-2.26.75-4.32 2.25-5.06M5.76.57a2.58 2.58 0 0 1 3 1.9\"/><path d=\"M12.41 2.84a2.78 2.78 0 0 0-3.66-.37\"/><path d=\"M5.08 3.54a3 3 0 0 1 3.67-1.07a2.55 2.55 0 0 1 1.89 3\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesCampingTentOutdoorRecreationCampingTentTeepeeTipi: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7 10.5v3m2-13l-8.5 13h13L5 .5\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelPlacesHotSpringRelaxLocationOutdoorRecreationSpa: Icon = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 7a2.8 2.8 0 0 1 1.5 2.24c0 1.93-2.91 3.5-6.5 3.5S.5 11.18.5 9.25A2.8 2.8 0 0 1 2 7\"/><path d=\"M4.08 2.25c-2 2.5 2 3.5 0 6m2.92-7c-2 2.5 2 5.5 0 8m2.92-7c-2 2.5 2 3.5 0 6\"/></g>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export const streamlineTravelWayfinderLadderBusinessProductMetaphorLadder: Icon = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.5.5v13m7-13v13M3.5 3h7m-7 4h7m-7 4h7\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}